export const kadArray = [
  {
    label: '10000',
    value: 'ΕΛΛΕΙΨΗ ΔΡΑΣΤΗΡΙΟΤΗΤΑΣ, ΛΟΓΩ ΜΗ ΔΡΑΣΤΗΡΙΟΠΟΙΗΣΗΣ ΜΕΧΡΙ ΣΗΜΕΡΑ',
  },
  {
    label: '20000',
    value: 'ΕΛΛΕΙΨΗ ΔΡΑΣΤΗΡΙΟΤΗΤΑΣ, ΛΟΓΩ ΑΔΡΑΝΟΠΟΙΗΣΗΣ',
  },
  {
    label: '30000',
    value: 'ΕΛΛΕΙΨΗ ΔΡΑΣΤΗΡΙΟΤΗΤΑΣ, ΛΟΓΩ ΔΡΑΣΤΗΡΙΟΠΟΙΗΣΗΣ ΜΟΝΟ ΕΚΤΟΣ ΕΛΛΑΔΑΣ',
  },
  {
    label: '1000000',
    value: 'ΑΓΡΟΤΗΣ ΕΙΔΙΚΟΥ ΚΑΘΕΣΤΩΤΟΣ',
  },
  {
    label: '1110000',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΔΗΜΗΤΡΙΑΚΩΝ (ΕΚΤΟΣ ΡΥΖΙΟΥ), ΟΣΠΡΙΩΝ ΚΑΙ ΕΛΑΙΟΥΧΩΝ ΣΠΟΡΩΝ',
  },
  {
    label: '1111000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΙΤΑΡΙΟΥ',
  },
  {
    label: '1111100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΚΛΗΡΟΥ ΣΙΤΑΡΙΟΥ',
  },
  {
    label: '1111200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΙΤΑΡΙΟΥ, ΕΚΤΟΣ ΑΠΟ ΤΟ ΣΚΛΗΡΟ ΣΙΤΑΡΙ',
  },
  {
    label: '1111201',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΑΛΑΚΟΥ ΣΙΤΑΡΙΟΥ',
  },
  {
    label: '1112000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΡΑΒΟΣΙΤΟΥ',
  },
  {
    label: '1112001',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΧΛΩΡΟΥ ΑΡΑΒΟΣΙΤΟΥ',
  },
  {
    label: '1113000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΡΙΘΑΡΙΟΥ, ΣΙΚΑΛΗΣ ΚΑΙ ΒΡΩΜΗΣ',
  },
  {
    label: '1113100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΡΙΘΑΡΙΟΥ',
  },
  {
    label: '1113200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΙΚΑΛΗΣ',
  },
  {
    label: '1113300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΒΡΩΜΗΣ',
  },
  {
    label: '1114000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΟΡΓΟΥ, ΚΕΧΡΙΟΥ ΚΑΙ ΑΛΛΩΝ ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '1114100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΟΡΓΟΥ',
  },
  {
    label: '1114200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΕΧΡΙΟΥ',
  },
  {
    label: '1114900',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '1115000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΧΥΡΟΥ ΚΑΙ ΦΛΟΙΩΝ ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '1116000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΟΣΠΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ',
  },
  {
    label: '1116100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΑΣΟΛΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ',
  },
  {
    label: '1116101',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΑΣΟΛΙΩΝ ΜΕΣΟΣΠΕΡΜΩΝ',
  },
  {
    label: '1116200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΠΙΖΕΛΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ',
  },
  {
    label: '1116900',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΟΣΠΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ',
  },
  {
    label: '1117000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΟΣΠΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΠΟΞΗΡΑΜΕΝΑ',
  },
  {
    label: '1117100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΑΣΟΛΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΠΟΞΗΡΑΜΕΝΑ',
  },
  {
    label: '1117200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΟΥΚΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΠΟΞΗΡΑΜΕΝΑ',
  },
  {
    label: '1117300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΡΕΒΙΘΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΠΟΞΗΡΑΜΕΝΑ',
  },
  {
    label: '1117400',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΑΚΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΠΟΞΗΡΑΜΕΝΑ',
  },
  {
    label: '1117500',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΠΙΖΕΛΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΠΟΞΗΡΑΜΕΝΑ',
  },
  {
    label: '1117900',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΟΣΠΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΠΟΞΗΡΑΜΕΝΑ',
  },
  {
    label: '1118000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΣΟΓΙΑΣ, ΑΡΑΠΙΚΩΝ ΦΙΣΤΙΚΙΩΝ ΚΑΙ ΒΑΜΒΑΚΟΣΠΟΡΩΝ',
  },
  {
    label: '1118100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΣΟΓΙΑΣ',
  },
  {
    label: '1118200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΡΑΠΙΚΩΝ ΦΙΣΤΙΚΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΜΕ ΚΕΛΥΦΟΣ',
  },
  {
    label: '1118300',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΑΡΑΠΙΚΩΝ ΦΙΣΤΙΚΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΠΟΦΛΟΙΩΜΕΝΑ (ΧΩΡΙΣ ΚΕΛΥΦΟΣ)',
  },
  {
    label: '1118400',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΒΑΜΒΑΚΟΣΠΟΡΩΝ',
  },
  {
    label: '1119000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΕΛΑΙΟΥΧΩΝ ΣΠΟΡΩΝ',
  },
  {
    label: '1119100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΛΙΝΑΡΟΣΠΟΡΟΥ',
  },
  {
    label: '1119200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΣΙΝΑΠΙΟΥ',
  },
  {
    label: '1119300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΚΡΑΜΒΗΣ Η ΕΛΑΙΟΚΡΑΜΒΗΣ',
  },
  {
    label: '1119400',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΣΟΥΣΑΜΙΟΥ',
  },
  {
    label: '1119500',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΗΛΙΟΤΡΟΠΙΟΥ',
  },
  {
    label: '1119900',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΕΛΑΙΟΥΧΩΝ ΣΠΟΡΩΝ ΠΟΥ ΔΕΝ ΚΑΤΟΝΟΜΑΖΟΝΤΑΙ ΑΛΛΟΥ (Π.Δ.Κ.Α.)',
  },
  {
    label: '1120000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΡΥΖΙΟΥ',
  },
  {
    label: '1121000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΡΥΖΙΟΥ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΜΗ ΑΠΟΦΛΟΙΩΜΕΝΟ',
  },
  {
    label: '1121001',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΑΚΡΟΣΠΕΡΜΟΥ ΡΥΖΙΟΥ',
  },
  {
    label: '1130000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΛΑΧΑΝΙΚΩΝ ΚΑΙ ΠΕΠΟΝΟΕΙΔΩΝ, ΡΙΖΩΝ ΚΑΙ ΚΟΝΔΥΛΩΝ',
  },
  {
    label: '1131000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΛΑΧΑΝΙΚΩΝ ΜΕ ΦΥΛΛΑ Η ΜΙΣΧΟΥΣ',
  },
  {
    label: '1131100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΑΡΑΓΓΙΩΝ',
  },
  {
    label: '1131200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΛΑΧΑΝΩΝ',
  },
  {
    label: '1131300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΟΥΝΟΥΠΙΔΙΩΝ ΚΑΙ ΜΠΡΟΚΟΛΩΝ',
  },
  {
    label: '1131301',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΟΥΝΟΥΠΙΔΙΩΝ',
  },
  {
    label: '1131400',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΑΡΟΥΛΙΩΝ',
  },
  {
    label: '1131500',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΙΚΡΑΛΙΔΩΝ (ΠΙΚΡΟΜΑΡΟΥΛΩΝ;ΧΙΚΟΡΙ)',
  },
  {
    label: '1131600',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΑΝΑΚΙΟΥ',
  },
  {
    label: '1131700',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΓΚΙΝΑΡΩΝ',
  },
  {
    label: '1131900',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΛΑΧΑΝΙΚΩΝ ΜΕ ΦΥΛΛΑ Η ΜΙΣΧΟΥΣ',
  },
  {
    label: '1132000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΕΠΟΝΟΕΙΔΩΝ',
  },
  {
    label: '1132100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΡΠΟΥΖΙΩΝ',
  },
  {
    label: '1132900',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΠΕΠΟΝΟΕΙΔΩΝ',
  },
  {
    label: '1132901',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΕΠΟΝΙΩΝ ΘΕΡΜΟΚΗΠΙΟΥ',
  },
  {
    label: '1132902',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΕΠΟΝΙΩΝ ΥΠΑΙΘΡΟΥ',
  },
  {
    label: '1133000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΛΑΧΑΝΙΚΩΝ ΠΟΥ ΦΕΡΟΥΝ ΚΑΡΠΟΥΣ (ΟΠΩΡΟΦΟΡΩΝ)',
  },
  {
    label: '1133100',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΥΤΕΡΩΝ ΠΙΠΕΡΙΩΝ (ΤΣΙΛΙ) ΚΑΙ ΠΙΠΕΡΙΩΝ, ΠΡΑΣΙΝΩΝ (ΜΟΝΟ ΤΟΥ ΓΕΝΟΥΣ CAPSICUM)',
  },
  {
    label: '1133101',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΙΠΕΡΙΩΝ ΘΕΡΜΟΚΗΠΙΟΥ',
  },
  {
    label: '1133102',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΙΠΕΡΙΩΝ ΥΠΑΙΘΡΟΥ',
  },
  {
    label: '1133200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΓΓΟΥΡΙΩΝ ΚΑΙ ΜΙΚΡΩΝ ΑΓΓΟΥΡΑΚΙΩΝ',
  },
  {
    label: '1133201',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΓΓΟΥΡΙΩΝ ΘΕΡΜΟΚΗΠΙΟΥ',
  },
  {
    label: '1133202',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΓΓΟΥΡΙΩΝ ΥΠΑΙΘΡΟΥ',
  },
  {
    label: '1133300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΕΛΙΤΖΑΝΩΝ',
  },
  {
    label: '1133301',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΕΛΙΤΖΑΝΩΝ ΘΕΡΜΟΚΗΠΙΟΥ',
  },
  {
    label: '1133302',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΕΛΙΤΖΑΝΩΝ ΥΠΑΙΘΡΟΥ',
  },
  {
    label: '1133400',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΝΤΟΜΑΤΩΝ',
  },
  {
    label: '1133401',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΝΤΟΜΑΤΟΠΙΠΕΡΙΩΝ (ΔΙΠΛΟΚΑΛΛΙΕΡΓΕΙΑ)',
  },
  {
    label: '1133402',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΝΤΟΜΑΤΩΝ ~ ΑΓΓΟΥΡΙΩΝ (ΔΙΠΛΟΚΑΛΛΙΕΡΓΕΙΑ)',
  },
  {
    label: '1133403',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΝΤΟΜΑΤΩΝ ~ ΠΕΠΟΝΙΩΝ (ΔΙΠΛΟΚΑΛΛΙΕΡΓΕΙΑ)',
  },
  {
    label: '1133404',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΝΤΟΜΑΤΩΝ ΒΙΟΜΗΧΑΝΙΚΩΝ',
  },
  {
    label: '1133405',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΝΤΟΜΑΤΩΝ ΕΠΙΤΡΑΠΕΖΙΩΝ ΥΠΑΙΘΡΟΥ',
  },
  {
    label: '1133406',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΝΤΟΜΑΤΩΝ ΘΕΡΜΟΚΗΠΙΟΥ',
  },
  {
    label: '1133900',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΛΑΧΑΝΙΚΩΝ ΠΟΥ ΦΕΡΟΥΝ ΚΑΡΠΟΥΣ Π.Δ.Κ.Α.',
  },
  {
    label: '1133901',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΡΑΚΑ ΒΙΟΜΗΧΑΝΙΚΟΥ',
  },
  {
    label: '1133902',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΗΠΕΥΤΙΚΩΝ ΘΕΡΜΟΚΗΠΙΟΥ',
  },
  {
    label: '1133903',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΗΠΕΥΤΙΚΩΝ ΥΠΑΙΘΡΟΥ',
  },
  {
    label: '1133904',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΟΛΟΚΥΘΙΩΝ ΘΕΡΜΟΚΗΠΙΟΥ',
  },
  {
    label: '1133905',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΟΛΟΚΥΘΙΩΝ ΥΠΑΙΘΡΟΥ',
  },
  {
    label: '1133906',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΠΑΜΙΑΣ',
  },
  {
    label: '1133907',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΑΣΟΛΑΚΙΩΝ ΘΕΡΜΟΚΗΠΙΟΥ',
  },
  {
    label: '1133908',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΑΣΟΛΑΚΙΩΝ ΥΠΑΙΘΡΟΥ',
  },
  {
    label: '1134000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΡΙΖΩΔΩΝ, ΒΟΛΒΩΔΩΝ Η ΚΟΝΔΥΛΩΔΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '1134100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΡΟΤΩΝ ΚΑΙ ΓΟΓΓΥΛΙΩΝ',
  },
  {
    label: '1134200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΚΟΡΔΩΝ',
  },
  {
    label: '1134201',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΚΟΡΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΞΕΡΑ',
  },
  {
    label: '1134300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΡΕΜΜΥΔΙΩΝ',
  },
  {
    label: '1134301',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΡΕΜΜΥΔΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΞΕΡΑ',
  },
  {
    label: '1134400',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΡΑΣΩΝ ΚΑΙ ΑΛΛΩΝ ΠΑΡΟΜΟΙΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '1134900',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΡΙΖΩΔΩΝ, ΒΟΛΒΩΔΩΝ Η ΚΟΝΔΥΛΩΔΩΝ ΛΑΧΑΝΙΚΩΝ (ΧΩΡΙΣ ΥΨΗΛΟ ΠΕΡΙΕΧΟΜΕΝΟ ΣΕ ΑΜΥΛΟ Η ΙΝΟΥΛΙΝΗ)',
  },
  {
    label: '1135000',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΒΡΩΣΙΜΩΝ ΡΙΖΩΝ ΚΑΙ ΚΟΝΔΥΛΩΝ ΜΕ ΥΨΗΛΟ ΠΕΡΙΕΧΟΜΕΝΟ ΣΕ ΑΜΥΛΟ Η ΙΝΟΥΛΙΝΗ',
  },
  {
    label: '1135100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΑΤΑΤΩΝ',
  },
  {
    label: '1135200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΓΛΥΚΟΠΑΤΑΤΩΝ',
  },
  {
    label: '1135300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΤΑΠΙΟΚΑΣ (CASSAVA)',
  },
  {
    label: '1135900',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΒΡΩΣΙΜΩΝ ΡΙΖΩΝ ΚΑΙ ΚΟΝΔΥΛΩΝ ΜΕ ΥΨΗΛΟ ΠΕΡΙΕΧΟΜΕΝΟ ΣΕ ΑΜΥΛΟ Η ΙΝΟΥΛΙΝΗ',
  },
  {
    label: '1136000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΛΑΧΑΝΙΚΩΝ, ΠΛΗΝ ΤΩΝ ΣΠΟΡΩΝ ΤΕΥΤΛΩΝ',
  },
  {
    label: '1136001',
    value: 'ΠΑΡΑΓΩΓΗ ΚΟΛΟΚΥΘΟΣΠΟΡΟΥ',
  },
  {
    label: '1137000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΖΑΧΑΡΟΤΕΥΤΛΩΝ ΚΑΙ ΣΠΟΡΩΝ ΖΑΧΑΡΟΤΕΥΤΛΩΝ',
  },
  {
    label: '1137100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΖΑΧΑΡΟΤΕΥΤΛΩΝ',
  },
  {
    label: '1137200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΖΑΧΑΡΟΤΕΥΤΛΩΝ',
  },
  {
    label: '1138000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΑΝΙΤΑΡΙΩΝ ΚΑΙ ΤΡΟΥΦΩΝ',
  },
  {
    label: '1138001',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΑΝΙΤΑΡΙΩΝ (ΣΤΟ ΕΔΑΦΟΣ)',
  },
  {
    label: '1138002',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΑΝΙΤΑΡΙΩΝ PLEUROTUS',
  },
  {
    label: '1138003',
    value: 'ΠΑΡΑΓΩΓΗ ΜΕ ΒΙΟΜΗΧΑΝΙΚΟ ΤΡΟΠΟ (ΟΧΙ ΚΑΛΛΙΕΡΓΕΙΑ ΣΤΗ ΓΗ) ΜΑΝΙΤΑΡΙΩΝ',
  },
  {
    label: '1139000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΛΑΧΑΝΙΚΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ, Π.Δ.Κ.Α.',
  },
  {
    label: '1140000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΖΑΧΑΡΟΚΑΛΑΜΩΝ',
  },
  {
    label: '1150000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΠΝΟΥ',
  },
  {
    label: '1151001',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΠΝΟΥ ΑΝΑΤΟΛΙΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '1151002',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΠΝΟΥ ΤΥΠΟΥ \\\\VIRGINIA\\\\',
  },
  {
    label: '1151003',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΠΝΟΥ ΤΥΠΟΥ \\ΚΑΜΠΑ; ΚΟΥΛΑΚ\\',
  },
  {
    label: '1151004',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΠΝΟΥ ΤΥΠΟΥ \\ΜΠΑΣΜΑ\\',
  },
  {
    label: '1151005',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΠΝΟΥ ΤΥΠΟΥ \\ΜΠΕΡΛΕΫ\\',
  },
  {
    label: '1151006',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΠΝΟΥ ΤΥΠΩΝ \\ΜΑΥΡΑ\\ ΚΑΙ \\ΤΣΕΜΠΕΛΙΑ\\',
  },
  {
    label: '1160000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΙΝΩΔΩΝ ΦΥΤΩΝ',
  },
  {
    label: '1161100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΒΑΜΒΑΚΙΟΥ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΕΚΚΟΚΚΙΣΜΕΝΟ Η ΜΗ',
  },
  {
    label: '1161200',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΓΙΟΥΤΑΣ, ΚΕΝΑΦ ΚΑΙ ΑΛΛΩΝ ΙΝΩΔΩΝ ΦΥΤΩΝ ΡΑΦΙΑΣ (ΔΗΛΑΔΗ ΥΦΑΝΤΙΚΩΝ ΙΝΩΝ ΠΟΥ ΠΡΟΕΡΧΟΝΤΑΙ ΑΠΟ ΣΤΕΛΕΧΗ ΦΥΤΩΝ), (ΕΚΤΟΣ ΑΠΟ ΛΙΝΑΡΙ, ΚΑΝΝΑΒΗ ΚΑΙ ΡΑΜΙ)',
  },
  {
    label: '1161900',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΛΙΝΑΡΙΟΥ, ΚΑΝΝΑΒΗΣ ΚΑΙ ΑΚΑΤΕΡΓΑΣΤΩΝ ΙΝΩΔΩΝ ΦΥΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '1190000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΜΗ ΠΟΛΥΕΤΩΝ ΦΥΤΩΝ',
  },
  {
    label: '1191000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΤΗΝΟΤΡΟΦΙΚΩΝ ΦΥΤΩΝ',
  },
  {
    label: '1191001',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΚΤΗΝΟΤΡΟΦΙΚΩΝ ΦΥΤΩΝ, ΓΙΑ ΖΩΟΤΡΟΦΗ',
  },
  {
    label: '1191002',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΒΙΚΟΥ',
  },
  {
    label: '1191003',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΒΙΟΛΟΓΙΚΩΝ ΚΤΗΝΟΤΡΟΦΙΚΩΝ ΦΥΤΩΝ',
  },
  {
    label: '1191004',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΗΔΙΚΗΣ (ΤΡΙΦΥΛΛΙΟΥ)',
  },
  {
    label: '1191005',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΜΗΔΙΚΗΣ',
  },
  {
    label: '1192000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΝΘΕΩΝ ΚΑΙ ΜΠΟΥΜΠΟΥΚΙΩΝ ΑΝΘΕΩΝ· ΣΠΟΡΩΝ ΑΝΘΕΩΝ',
  },
  {
    label: '1192100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΝΘΕΩΝ ΚΑΙ ΜΠΟΥΜΠΟΥΚΙΩΝ ΑΝΘΕΩΝ',
  },
  {
    label: '1192101',
    value: 'ΠΑΡΑΓΩΓΗ ΑΠΟΞΗΡΑΜΕΝΩΝ ΦΥΤΩΝ',
  },
  {
    label: '1192200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΑΝΘΕΩΝ',
  },
  {
    label: '1193000',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΤΕΥΤΛΩΝ, ΣΠΟΡΩΝ ΚΤΗΝΟΤΡΟΦΙΚΩΝ ΦΥΤΩΝ· ΑΛΛΩΝ ΦΥΤΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ',
  },
  {
    label: '1193100',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΤΕΥΤΛΩΝ (ΠΛΗΝ ΤΩΝ ΣΠΟΡΩΝ ΖΑΧΑΡΟΤΕΥΤΛΩΝ) ΚΑΙ ΣΠΟΡΩΝ ΚΤΗΝΟΤΡΟΦΙΚΩΝ ΦΥΤΩΝ',
  },
  {
    label: '1193900',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '1210000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΤΑΦΥΛΙΩΝ',
  },
  {
    label: '1211100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΤΑΦΥΛΙΩΝ',
  },
  {
    label: '1211200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΣΤΑΦΥΛΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ',
  },
  {
    label: '1211203',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΤΑΦΙΔΑΣ ΚΟΡΙΝΘΙΑΚΗΣ ΞΗΡΙΚΗΣ',
  },
  {
    label: '1211204',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΤΑΦΙΔΑΣ ΣΟΥΛΤΑΝΙΝΑΣ',
  },
  {
    label: '1211205',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΤΑΦΥΛΙΩΝ VQPRD',
  },
  {
    label: '1211206',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΤΑΦΥΛΙΩΝ ΕΠΙΤΡΑΠΕΖΙΩΝ',
  },
  {
    label: '1211207',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΤΑΦΥΛΙΩΝ ΟΙΝΟΠΟΙΙΑΣ ΚΟΙΝΩΝ',
  },
  {
    label: '1220000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΤΡΟΠΙΚΩΝ ΚΑΙ ΥΠΟΤΡΟΠΙΚΩΝ ΦΡΟΥΤΩΝ',
  },
  {
    label: '1221100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΒΟΚΑΝΤΟ',
  },
  {
    label: '1221200',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΜΠΑΝΑΝΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΕΙΔΟΥΣ ΤΩΝ ΑΝΤΙΛΛΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΦΡΟΥΤΩΝ',
  },
  {
    label: '1221201',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΠΑΝΑΝΩΝ',
  },
  {
    label: '1221202',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΠΑΝΑΝΩΝ ΘΕΡΜΟΚΗΠΙΟΥ',
  },
  {
    label: '1221300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΧΟΥΡΜΑΔΩΝ',
  },
  {
    label: '1221400',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΥΚΩΝ',
  },
  {
    label: '1221401',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΥΚΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ',
  },
  {
    label: '1221402',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΥΚΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΞΕΡΑ',
  },
  {
    label: '1221900',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΤΡΟΠΙΚΩΝ ΚΑΙ ΥΠΟΤΡΟΠΙΚΩΝ ΦΡΟΥΤΩΝ',
  },
  {
    label: '1230000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΕΣΠΕΡΙΔΟΕΙΔΩΝ',
  },
  {
    label: '1231100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΡΑΠΩΝ ΚΑΙ ΓΚΡΕΙΠΦΡΟΥΤ',
  },
  {
    label: '1231101',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΓΚΡΕΙΠΦΡΟΥΤ, ΚΙΤΡΩΝ, ΚΟΥΜ;ΚΟΥΑΤ ΚΛΠ',
  },
  {
    label: '1231200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΛΕΜΟΝΙΩΝ ΚΑΙ ΓΛΥΚΟΛΕΜΟΝΩΝ',
  },
  {
    label: '1231201',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΛΕΜΟΝΙΩΝ',
  },
  {
    label: '1231300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΟΡΤΟΚΑΛΙΩΝ',
  },
  {
    label: '1231301',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΟΡΤΟΚΑΛΙΩΝ \\ΒΑΛΕΝΤΣΙΑ\\',
  },
  {
    label: '1231302',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΟΡΤΟΚΑΛΙΩΝ ΚΟΙΝΩΝ',
  },
  {
    label: '1231303',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΟΡΤΟΚΑΛΙΩΝ ΟΜΦΑΛΟΦΟΡΩΝ',
  },
  {
    label: '1231400',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΑΝΤΑΡΙΝΑΤΩΝ (TANGERINES), ΜΑΝΤΑΡΙΝΙΩΝ, ΚΛΗΜΕΝΤΙΝΩΝ',
  },
  {
    label: '1231401',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΑΝΤΑΡΙΝΙΩΝ',
  },
  {
    label: '1231900',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΕΣΠΕΡΙΔΟΕΙΔΩΝ',
  },
  {
    label: '1240000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΗΛΟΕΙΔΩΝ ΚΑΙ ΠΥΡΗΝΟΚΑΡΠΩΝ',
  },
  {
    label: '1241000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΗΛΩΝ',
  },
  {
    label: '1242000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΜΗΛΟΕΙΔΩΝ ΚΑΙ ΠΥΡΗΝΟΚΑΡΠΩΝ',
  },
  {
    label: '1242100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΧΛΑΔΙΩΝ',
  },
  {
    label: '1242101',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΧΛΑΔΙΩΝ ΤΥΠΟΥ \\ΚΟΝΤΟΥΛΕΣ\\',
  },
  {
    label: '1242200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΥΔΩΝΙΩΝ',
  },
  {
    label: '1242300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΒΕΡΙΚΟΚΩΝ',
  },
  {
    label: '1242400',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΕΡΑΣΙΩΝ',
  },
  {
    label: '1242500',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΡΟΔΑΚΙΝΩΝ',
  },
  {
    label: '1242501',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΒΙΟΜΗΧΑΝΙΚΩΝ ΡΟΔΑΚΙΝΩΝ',
  },
  {
    label: '1242600',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΝΕΚΤΑΡΙΝΙΩΝ',
  },
  {
    label: '1242700',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΔΑΜΑΣΚΗΝΩΝ',
  },
  {
    label: '1242701',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΔΑΜΑΣΚΗΝΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΠΟΞΗΡΑΜΕΝΑ ΜΕ ΦΥΣΙΚΑ ΜΕΣΑ',
  },
  {
    label: '1242702',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΔΑΜΑΣΚΗΝΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ',
  },
  {
    label: '1242800',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΟΡΟΜΗΛΩΝ (ΑΓΡΙΟΔΑΜΑΣΚΗΝΩΝ)',
  },
  {
    label: '1242900',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΜΗΛΟΕΙΔΩΝ ΚΑΙ ΠΥΡΗΝΟΚΑΡΠΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '1242901',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΒΥΣΣΙΝΩΝ',
  },
  {
    label: '1242902',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΟΡΟΜΗΛΩΝ ~ ΤΖΑΝΕΡΩΝ',
  },
  {
    label: '1242903',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΛΩΤΩΝ',
  },
  {
    label: '1242904',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΕΣΠΙΛΩΝ (ΜΟΥΣΜΟΥΛΩΝ)',
  },
  {
    label: '1250000',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΔΕΝΔΡΩΔΩΝ ΚΑΙ ΘΑΜΝΩΔΩΝ ΚΑΛΛΙΕΡΓΕΙΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ',
  },
  {
    label: '1251000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΟΥΡΩΝ ΚΑΙ ΚΑΡΠΩΝ ΤΟΥ ΓΕΝΟΥΣ VACCINIUM',
  },
  {
    label: '1251100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΚΤΙΝΙΔΙΩΝ',
  },
  {
    label: '1251200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΜΕΟΥΡΩΝ',
  },
  {
    label: '1251201',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΒΑΤΟΜΟΥΡΩΝ',
  },
  {
    label: '1251300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΡΑΟΥΛΩΝ',
  },
  {
    label: '1251301',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΡΑΟΥΛΩΝ ΧΑΜΗΛΗΣ ΚΑΛΥΨΗΣ',
  },
  {
    label: '1251900',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΜΟΥΡΩΝ, ΤΩΝ ΚΑΡΠΩΝ ΤΟΥ ΓΕΝΟΥΣ VACCINIUM Π.Δ.Κ.Α.',
  },
  {
    label: '1252000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '1253000',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ (ΕΚΤΟΣ ΑΠΟ ΑΓΡΙΟΥΣ ΒΡΩΣΙΜΟΥΣ ΚΑΡΠΟΥΣ ΜΕ ΚΕΛΥΦΟΣ, ΑΡΑΠΙΚΑ ΦΙΣΤΙΚΙΑ ΚΑΙ ΙΝΔΙΚΕΣ ΚΑΡΥΔΕΣ)',
  },
  {
    label: '1253100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΜΥΓΔΑΛΩΝ',
  },
  {
    label: '1253200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΣΤΑΝΩΝ',
  },
  {
    label: '1253300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΟΥΝΤΟΥΚΙΩΝ',
  },
  {
    label: '1253400',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΙΣΤΙΚΙΩΝ',
  },
  {
    label: '1253401',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΕΛΥΦΩΤΩΝ ΦΙΣΤΙΚΙΩΝ ΦΘΙΩΤΙΔΑΣ',
  },
  {
    label: '1253402',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΙΣΤΙΚΙΩΝ ΑΙΓΙΝΗΣ',
  },
  {
    label: '1253500',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΡΥΔΙΩΝ ΚΟΙΝΩΝ',
  },
  {
    label: '1253900',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ (ΕΚΤΟΣ ΑΠΟ ΑΓΡΙΟΥΣ ΒΡΩΣΙΜΟΥΣ ΚΑΡΠΟΥΣ ΜΕ ΚΕΛΥΦΟΣ, ΑΡΑΠΙΚΑ ΦΙΣΤΙΚΙΑ ΚΑΙ ΙΝΔΙΚΕΣ ΚΑΡΥΔΕΣ)',
  },
  {
    label: '1259000',
    value: 'ΑΛΛΕΣ ΔΕΝΔΡΩΔΕΙΣ ΚΑΙ ΘΑΜΝΩΔΕΙΣ ΚΑΛΛΙΕΡΓΕΙΕΣ ΚΑΡΠΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '1259001',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΡΟΔΙΩΝ',
  },
  {
    label: '1260000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΕΛΑΙΩΔΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '1261000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΕΛΙΩΝ',
  },
  {
    label: '1261100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΕΠΙΤΡΑΠΕΖΙΩΝ ΕΛΙΩΝ',
  },
  {
    label: '1261200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΕΛΙΩΝ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΕΛΑΙΟΛΑΔΟΥ',
  },
  {
    label: '1262000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΙΝΔΙΚΗΣ ΚΑΡΥΔΑΣ',
  },
  {
    label: '1269000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΕΛΑΙΟΥΧΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '1270000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΝ ΓΙΑ ΑΦΕΨΗΜΑΤΑ',
  },
  {
    label: '1271100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΟΚΚΩΝ ΚΑΦΕ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΜΗ ΚΑΒΟΥΡΔΙΣΜΕΝΟΙ',
  },
  {
    label: '1271200',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΛΛΩΝ ΤΣΑΓΙΟΥ',
  },
  {
    label: '1271300',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΛΛΩΝ ΜΑΤΕ',
  },
  {
    label: '1271400',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΣΠΟΡΩΝ ΚΑΚΑΟΥ',
  },
  {
    label: '1280000',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΡΥΚΕΥΤΙΚΩΝ, ΑΡΩΜΑΤΙΚΩΝ, ΘΕΡΑΠΕΥΤΙΚΩΝ ΚΑΙ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΦΥΤΩΝ',
  },
  {
    label: '1281000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΡΥΚΕΥΜΑΤΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΜΗ ΚΑΤΕΡΓΑΣΜΕΝΑ',
  },
  {
    label: '1281100',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΙΠΕΡΙΟΥ (PIPER SPP), ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΚΑΤΕΡΓΑΣΤΟ',
  },
  {
    label: '1281200',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΥΤΕΡΩΝ ΠΙΠΕΡΙΩΝ (ΤΣΙΛΙ) ΚΑΙ ΠΙΠΕΡΙΩΝ (ΤΟΥ ΓΕΝΟΥΣ CAPSICUM SPP), ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΠΟΞΗΡΑΜΕΝΕΣ, ΑΚΑΤΕΡΓΑΣΤΕΣ',
  },
  {
    label: '1281300',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΜΟΣΧΟΚΑΡΥΔΟΥ, ΦΛΟΥΔΑΣ ΜΟΣΧΟΚΑΡΥΔΟΥ ΚΑΙ ΚΑΡΔΑΜΟΥ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΑ',
  },
  {
    label: '1281400',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΓΛΥΚΑΝΙΣΟΥ ΤΟΥ ΚΟΙΝΟΥ, ΓΛΥΚΑΝΙΣΟΥ ΤΟΥ ΑΣΤΕΡΟΕΙΔΟΥΣ, ΚΟΡΙΑΝΔΡΟΥ, ΚΥΜΙΝΟΥ, ΑΓΡΙΟΚΥΜΙΝΟΥ, ΜΑΡΑΘΟΥ ΚΑΙ ΚΑΡΠΩΝ ΚΕΔΡΟΥ (ΑΡΚΕΥΘΟΥ), ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΑ',
  },
  {
    label: '1281401',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΓΛΥΚΑΝΙΣΟΥ',
  },
  {
    label: '1281500',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΝΕΛΛΑΣ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΚΑΤΕΡΓΑΣΤΗ',
  },
  {
    label: '1281600',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΓΑΡΥΦΑΛΛΩΝ (ΤΟΥ ΣΤΕΛΕΧΟΥΣ), ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΑ',
  },
  {
    label: '1281700',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΠΙΠΕΡΟΡΙΖΑΣ (ΤΖΙΝΤΖΕΡ), ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΠΟΞΗΡΑΜΕΝΗ, ΑΚΑΤΕΡΓΑΣΤΗ',
  },
  {
    label: '1281800',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΒΑΝΙΛΙΑΣ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΚΑΤΕΡΓΑΣΤΗ',
  },
  {
    label: '1281900',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΚΑΡΥΚΕΥΜΑΤΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΜΗ ΚΑΤΕΡΓΑΣΜΕΝΑ',
  },
  {
    label: '1281901',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΡΟΚΟΥ',
  },
  {
    label: '1282000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΔΙΣΚΙΩΝ ΛΥΚΙΣΚΟΥ',
  },
  {
    label: '1283000',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΚΥΡΙΩΣ ΣΤΗΝ ΑΡΩΜΑΤΟΠΟΙΙΑ, ΤΗ ΦΑΡΜΑΚΕΥΤΙΚΗ, Η ΓΙΑ ΕΝΤΟΜΟΚΤΟΝΑ, ΜΥΚΗΤΟΚΤΟΝΑ Η ΠΑΡΟΜΟΙΟΥΣ ΣΚΟΠΟΥΣ',
  },
  {
    label: '1283001',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΡΩΜΑΤΙΚΩΝ ΦΥΤΩΝ',
  },
  {
    label: '1290000',
    value: 'ΑΛΛΕΣ ΠΟΛΥΕΤΕΙΣ ΚΑΛΛΙΕΡΓΕΙΕΣ',
  },
  {
    label: '1291000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΣΙΚΟΥ ΕΛΑΣΤΙΚΟΥ (ΚΑΟΥΤΣΟΥΚ)',
  },
  {
    label: '1292000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΧΡΙΣΤΟΥΓΕΝΝΙΑΤΙΚΩΝ ΔΕΝΔΡΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΟΜΜΕΝΑ',
  },
  {
    label: '1293000',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΙΚΩΝ ΥΛΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΓΙΑ ΣΠΑΡΤΟΠΛΕΚΤΙΚΗ, ΠΑΡΑΓΕΜΙΣΜΑ, ΒΑΤΕΣ, ΒΑΦΗ Η ΔΕΨΗ',
  },
  {
    label: '1300000',
    value: 'ΠΟΛΛΑΠΛΑΣΙΑΣΜΟΣ ΤΩΝ ΦΥΤΩΝ',
  },
  {
    label: '1301000',
    value:
      'ΠΑΡΑΓΩΓΗ ΥΛΙΚΩΝ ΦΥΤΕΥΣΗΣ: ΖΩΝΤΩΝ ΦΥΤΩΝ, ΚΟΝΔΥΛΩΝ, ΒΟΛΒΩΝ ΚΑΙ ΡΙΖΩΝ· ΜΟΣΧΕΥΜΑΤΩΝ ΚΑΙ ΠΑΡΑΦΥΑΔΩΝ (ΞΕΜΑΣΚΑΛΙΔΙΩΝ)· ΜΥΚΗΛΙΩΝ ΜΑΝΙΤΑΡΙΩΝ',
  },
  {
    label: '1301001',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΛΕΞΑΝΔΡΙΝΟΥ ΘΕΡΜΟΚΗΠΙΟΥ ΣΕ ΓΛΑΣΤΡΑ',
  },
  {
    label: '1301002',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΝΕΜΩΝΩΝ ΘΕΡΜΟΚΗΠΙΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1301003',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΝΕΜΩΝΩΝ ΥΠΑΙΘΡΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1301004',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΝΘΕΩΝ ΘΕΡΜΟΚΗΠΙΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1301005',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΝΘΕΩΝ ΥΠΑΙΘΡΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1301006',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΑΡΑΛΙΑΣ ΘΕΡΜΟΚΗΠΙΟΥ ΣΕ ΓΛΑΣΤΡΑ',
  },
  {
    label: '1301007',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΓΑΡΥΦΑΛΛΩΝ ΘΕΡΜΟΚΗΠΙΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1301008',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΓΑΡΥΦΑΛΛΩΝ ΥΠΑΙΘΡΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1301009',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΓΛΑΔΙΟΛΩΝ ΘΕΡΜΟΚΗΠΙΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1301010',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΓΛΑΔΙΟΛΩΝ ΥΠΑΙΘΡΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1301011',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΓΛΑΣΤΡΙΚΩΝ ΘΕΡΜΟΚΗΠΙΟΥ, ΦΥΛΛΩΔΩΝ ~ ΑΝΘΩΔΩΝ, ΕΣΩΤΕΡΙΚΟΥ ΧΩΡΟΥ',
  },
  {
    label: '1301012',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΔΕΝΔΡΥΛΛΙΩΝ ΕΣΠΕΡΙΔΟΕΙΔΩΝ ΘΕΡΜΟΚΗΠΙΟΥ',
  },
  {
    label: '1301013',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΖΕΡΜΠΕΡΑΣ ΘΕΡΜΟΚΗΠΙΟΥ,[ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΩΣ ΦΥΤΟ ΖΩΝΤΑΝΟ            ]',
  },
  {
    label: '1301014',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΚΤΩΝ ΜΙΚΡΩΝ ΣΕ ΓΛΑΣΤΡΑ',
  },
  {
    label: '1301015',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΑΛΛΩΠΙΣΤΙΚΩΝ ΦΥΤΩΝ',
  },
  {
    label: '1301016',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΚΡΟΤΩΝΑ ΘΕΡΜΟΚΗΠΙΟΥ ΣΕ ΓΛΑΣΤΡΑ',
  },
  {
    label: '1301017',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΛΟΙΠΩΝ ΦΥΤΩΡΙΩΝ',
  },
  {
    label: '1301018',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΝΤΙΦΕΜΠΑΧΙΑΣ ΘΕΡΜΟΚΗΠΙΟΥ ΣΕ ΓΛΑΣΤΡΑ',
  },
  {
    label: '1301019',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΤΡΙΑΝΤΑΦΥΛΛΩΝ ΘΕΡΜΟΚΗΠΙΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1301020',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΤΡΙΑΝΤΑΦΥΛΛΩΝ ΥΠΑΙΘΡΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1301021',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΙΚΩΝ ΔΙΑΦΟΡΩΝ ΘΕΡΜΟΚΗΠΙΟΥ ΣΕ ΓΛΑΣΤΡΑ',
  },
  {
    label: '1301022',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΡΕΖΩΝ ΘΕΡΜΟΚΗΠΙΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1301023',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΝ ΚΗΠΟΤΕΧΝΙΑΣ ΕΞΩΤΕΡΙΚΟΥ ΧΩΡΟΥ',
  },
  {
    label: '1301024',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΡΙΩΝ ΑΛΛΩΝ ΑΝΘΕΩΝ',
  },
  {
    label: '1301025',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΡΙΩΝ ΑΛΛΩΝ ΔΕΝΔΡΥΛΛΙΩΝ',
  },
  {
    label: '1301026',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΡΙΩΝ ΑΜΠΕΛΟΥ',
  },
  {
    label: '1301027',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΡΙΩΝ ΕΛΙΑΣ',
  },
  {
    label: '1301028',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΡΙΩΝ ΦΥΤΩΝ ΕΣΩΤΕΡΙΚΟΥ ΧΩΡΟΥ',
  },
  {
    label: '1301029',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΡΙΩΝ ΚΑΡΠΟΦΟΡΩΝ ΔΕΝΔΡΩΝ ΚΑΙ ΘΑΜΝΩΝ',
  },
  {
    label: '1301030',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΡΙΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '1301031',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΡΙΩΝ ΛΙΓΟΥΣΤΡΟΥ',
  },
  {
    label: '1301032',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΧΡΥΣΑΝΘΕΜΩΝ ΘΕΡΜΟΚΗΠΙΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1301033',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΧΡΥΣΑΝΘΕΜΩΝ ΟΛΛΑΝΔΙΚΟΥ ΤΥΠΟΥ, (ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΩΣ ΦΥΤΑ ΖΩΝΤΑ)',
  },
  {
    label: '1410000',
    value: 'ΕΚΤΡΟΦΗ ΒΟΟΕΙΔΩΝ ΓΑΛΑΚΤΟΠΑΡΑΓΩΓΗΣ',
  },
  {
    label: '1411000',
    value: 'ΕΚΤΡΟΦΗ ΒΟΟΕΙΔΩΝ ΓΑΛΑΚΤΟΠΑΡΑΓΩΓΗΣ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1411001',
    value: 'ΕΚΤΡΟΦΗ ΑΓΕΛΑΔΩΝ ΓΑΛΑΚΤΟΠΑΡΑΓΩΓΗΣ',
  },
  {
    label: '1411002',
    value: 'ΕΚΤΡΟΦΗ ΑΓΕΛΑΔΩΝ ΕΛΕΥΘΕΡΗΣ ΒΟΣΚΗΣ ΚΡΕΑΤΟΠΑΡΑΓΩΓΗΣ',
  },
  {
    label: '1411003',
    value: 'ΕΚΤΡΟΦΗ ΑΓΕΛΑΔΩΝ ΜΕΙΚΤΗΣ ΚΑΤΕΥΘΥΝΣΗΣ',
  },
  {
    label: '1412000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΟΥ ΓΑΛΑΚΤΟΣ ΑΠΟ ΒΟΟΕΙΔΗ ΓΑΛΑΚΤΟΠΑΡΑΓΩΓΗΣ',
  },
  {
    label: '1420000',
    value: 'ΕΚΤΡΟΦΗ ΑΛΛΩΝ ΒΟΟΕΙΔΩΝ ΚΑΙ ΒΟΥΒΑΛΙΩΝ',
  },
  {
    label: '1421000',
    value: 'ΕΚΤΡΟΦΗ ΑΛΛΩΝ ΒΟΟΕΙΔΩΝ ΚΑΙ ΒΟΥΒΑΛΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1421100',
    value:
      'ΕΚΤΡΟΦΗ ΑΛΛΩΝ ΒΟΟΕΙΔΩΝ ΚΑΙ ΒΟΥΒΑΛΙΩΝ, ΕΚΤΟΣ ΤΩΝ ΜΟΣΧΑΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1421200',
    value: 'ΕΚΤΡΟΦΗ ΜΟΣΧΑΡΙΩΝ ΒΟΟΕΙΔΩΝ ΚΑΙ ΒΟΥΒΑΛΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1421201',
    value: 'ΕΚΤΡΟΦΗ ΜΟΣΧΑΡΙΩΝ ΠΑΧΥΝΣΗΣ',
  },
  {
    label: '1422000',
    value: 'ΔΙΑΘΕΣΗ ΣΠΕΡΜΑΤΟΣ ΒΟΟΕΙΔΩΝ ΚΑΙ ΒΟΥΒΑΛΙΩΝ',
  },
  {
    label: '1430000',
    value: 'ΕΚΤΡΟΦΗ ΑΛΟΓΩΝ ΚΑΙ ΑΛΛΩΝ ΙΠΠΟΕΙΔΩΝ',
  },
  {
    label: '1431000',
    value: 'ΕΚΤΡΟΦΗ ΑΛΟΓΩΝ ΚΑΙ ΑΛΛΩΝ ΙΠΠΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1440000',
    value: 'ΕΚΤΡΟΦΗ ΚΑΜΗΛΩΝ ΚΑΙ ΚΑΜΗΛΙΔΩΝ',
  },
  {
    label: '1441000',
    value: 'ΕΚΤΡΟΦΗ ΚΑΜΗΛΩΝ ΚΑΙ ΚΑΜΗΛΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑΝΕΣ',
  },
  {
    label: '1450000',
    value: 'ΕΚΤΡΟΦΗ ΑΙΓΟΠΡΟΒΑΤΩΝ',
  },
  {
    label: '1451000',
    value: 'ΕΚΤΡΟΦΗ ΑΙΓΟΠΡΟΒΑΤΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1451100',
    value: 'ΕΚΤΡΟΦΗ ΠΡΟΒΑΤΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1451101',
    value: 'ΕΚΤΡΟΦΗ ΠΡΟΒΑΤΩΝ ΠΑΧΥΝΣΗΣ',
  },
  {
    label: '1451200',
    value: 'ΕΚΤΡΟΦΗ ΑΙΓΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1451201',
    value: 'ΕΚΤΡΟΦΗ ΑΙΓΩΝ ΠΑΧΥΝΣΗΣ',
  },
  {
    label: '1452000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΟΥ ΓΑΛΑΚΤΟΣ ΑΠΟ ΑΙΓΟΠΡΟΒΑΤΑ',
  },
  {
    label: '1452100',
    value: 'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΟΥ ΠΡΟΒΕΙΟΥ ΓΑΛΑΚΤΟΣ',
  },
  {
    label: '1452200',
    value: 'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΟΥ ΚΑΤΣΙΚΙΣΙΟΥ ΓΑΛΑΚΤΟΣ',
  },
  {
    label: '1453000',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΑΛΛΙΟΥ ΑΠΟ ΚΟΥΡΕΜΑ ΑΙΓΟΠΡΟΒΑΤΩΝ, ΜΗ ΚΑΘΑΡΙΣΜΕΝΟΥ ΑΠΟ ΤΙΣ ΛΙΠΑΡΕΣ ΟΥΣΙΕΣ, ΣΤΟ ΟΠΟΙΟ ΠΕΡΙΛΑΜΒΑΝΕΤΑΙ ΚΑΙ ΤΟ ΚΟΥΡΕΜΕΝΟ ΜΑΛΛΙ ΠΟΥ ΠΛΥΘΗΚΕ ΣΤΗΝ ΠΡΟΒΙΑ',
  },
  {
    label: '1460000',
    value: 'ΕΚΤΡΟΦΗ ΧΟΙΡΩΝ',
  },
  {
    label: '1461000',
    value: 'ΕΚΤΡΟΦΗ ΧΟΙΡΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1461001',
    value: 'ΕΚΤΡΟΦΗ ΧΟΙΡΟΜΗΤΕΡΩΝ',
  },
  {
    label: '1470000',
    value: 'ΕΚΤΡΟΦΗ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '1471000',
    value: 'ΕΚΤΡΟΦΗ ΠΟΥΛΕΡΙΚΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1471100',
    value: 'ΕΚΤΡΟΦΗ ΚΟΤΟΠΟΥΛΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1471101',
    value: 'ΕΚΤΡΟΦΗ ΚΟΤΟΠΟΥΛΩΝ ΑΒΓΟΠΑΡΑΓΩΓΗΣ',
  },
  {
    label: '1471102',
    value: 'ΕΚΤΡΟΦΗ ΠΟΥΛΕΡΙΚΩΝ ΚΛΠ ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ',
  },
  {
    label: '1471103',
    value: 'ΕΚΤΡΟΦΗ ΚΟΤΟΠΟΥΛΩΝ ΚΡΕΑΤΟΠΑΡΑΓΩΓΗΣ',
  },
  {
    label: '1471200',
    value: 'ΕΚΤΡΟΦΗ ΓΑΛΟΠΟΥΛΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑΝΕΣ',
  },
  {
    label: '1471300',
    value: 'ΕΚΤΡΟΦΗ ΧΗΝΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑΝΕΣ',
  },
  {
    label: '1471400',
    value: 'ΕΚΤΡΟΦΗ ΠΑΠΙΩΝ ΚΑΙ ΦΡΑΓΚΟΚΟΤΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑΝΕΣ',
  },
  {
    label: '1472000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΒΓΩΝ ΜΕ ΤΟ ΚΕΛΥΦΟΣ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ',
  },
  {
    label: '1472100',
    value: 'ΠΑΡΑΓΩΓΗ ΑΒΓΩΝ ΚΟΤΑΣ ΜΕ ΤΟ ΚΕΛΥΦΟΣ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ',
  },
  {
    label: '1472200',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΒΓΩΝ ΑΛΛΩΝ ΠΟΥΛΕΡΙΚΩΝ ΜΕ ΤΟ ΚΕΛΥΦΟΣ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ',
  },
  {
    label: '1472300',
    value: 'ΠΑΡΑΓΩΓΗ ΑΒΓΩΝ ΕΠΩΑΣΗΣ',
  },
  {
    label: '1472301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΚΟΛΑΨΗΣ ΠΤΗΝΩΝ',
  },
  {
    label: '1490000',
    value: 'ΕΚΤΡΟΦΗ ΑΛΛΩΝ ΖΩΩΝ',
  },
  {
    label: '1491000',
    value:
      'ΕΚΤΡΟΦΗ ΑΛΛΩΝ ΖΩΩΝ, ΠΟΥ ΕΚΤΡΕΦΟΝΤΑΙ ΣΕ ΑΓΡΟΚΤΗΜΑΤΑ ΚΑΙ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1491100',
    value: 'ΕΚΤΡΟΦΗ ΚΟΥΝΕΛΙΩΝ ΚΑΤΟΙΚΙΔΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1491200',
    value:
      'ΕΚΤΡΟΦΗ ΠΤΗΝΩΝ Π.Δ.Κ.Α. ΠΟΥ ΕΚΤΡΕΦΟΝΤΑΙ ΣΕ ΑΓΡΟΚΤΗΜΑΤΑ ΚΑΙ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1491201',
    value: 'ΕΚΤΡΟΦΗ ΟΡΤΥΚΙΩΝ',
  },
  {
    label: '1491202',
    value: 'ΕΚΤΡΟΦΗ ΠΕΡΔΙΚΩΝ',
  },
  {
    label: '1491203',
    value: 'ΕΚΤΡΟΦΗ ΣΤΡΟΥΘΟΚΑΜΗΛΩΝ',
  },
  {
    label: '1491204',
    value: 'ΕΚΤΡΟΦΗ ΩΔΙΚΩΝ ΠΤΗΝΩΝ',
  },
  {
    label: '1491300',
    value:
      'ΕΚΤΡΟΦΗ ΕΡΠΕΤΩΝ ΠΟΥ ΕΚΤΡΕΦΟΝΤΑΙ ΣΕ ΑΓΡΟΚΤΗΜΑΤΑ (ΣΤΑ ΟΠΟΙΑ ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΦΙΔΙΑ ΚΑΙ ΟΙ ΘΑΛΑΣΣΙΕΣ ΧΕΛΩΝΕΣ) ΚΑΙ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1491900',
    value:
      'ΕΚΤΡΟΦΗ ΑΛΛΩΝ ΖΩΩΝ Π.Δ.Κ.Α. ΠΟΥ ΕΚΤΡΕΦΟΝΤΑΙ ΣΕ ΑΓΡΟΚΤΗΜΑΤΑ ΚΑΙ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '1491901',
    value: 'ΕΚΤΡΟΦΗ ΒΑΤΡΑΧΩΝ',
  },
  {
    label: '1491902',
    value:
      'ΕΚΤΡΟΦΗ ΓΟΥΝΟΦΟΡΩΝ ΖΩΩΝ (ΑΛΕΠΟΥΣ, ΜΙΝΚ, ΜΥΟΚΑΣΤΟΡΑ, ΤΣΙΝΤΣΙΛΑ ΚΑΙ ΑΛΛΩΝ)',
  },
  {
    label: '1491903',
    value: 'ΕΚΤΡΟΦΗ ΣΚΥΛΙΩΝ, ΓΑΤΩΝ ΚΛΠ ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '1491904',
    value: 'ΠΑΡΑΓΩΓΗ ΜΕΛΙΣΣΟΣΜΗΝΩΝ ΣΕ ΚΥΨΕΛΕΣ',
  },
  {
    label: '1492000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΖΩΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΠΟΥ ΠΑΡΑΓΟΝΤΑΙ ΣΕ ΑΓΡΟΚΤΗΜΑΤΑ',
  },
  {
    label: '1492100',
    value: 'ΠΑΡΑΓΩΓΗ ΜΕΛΙΟΥ ΦΥΣΙΚΟΥ',
  },
  {
    label: '1492200',
    value: 'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΟΥ ΓΑΛΑΚΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '1492300',
    value:
      'ΕΚΤΡΟΦΗ ΣΑΛΙΓΚΑΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ, ΑΠΛΗΣ ΨΥΞΗΣ, ΚΑΤΕΨΥΓΜΕΝΑ, ΑΠΟΞΗΡΑΜΕΝΑ, ΠΑΣΤΑ Η ΣΕ ΑΛΜΗ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΘΑΛΑΣΣΙΝΑ ΣΑΛΙΓΚΑΡΙΑ',
  },
  {
    label: '1492400',
    value:
      'ΠΑΡΑΓΩΓΗ ΒΡΩΣΙΜΩΝ ΠΡΟΪΟΝΤΩΝ ΠΡΟΕΡΧΟΜΕΝΩΝ ΑΠΟ ΖΩΑ ΑΓΡΟΚΤΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '1492500',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΟΥΚΟΥΛΙΩΝ ΜΕΤΑΞΟΣΚΩΛΗΚΑ, ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΑΝΑΠΗΝΙΣΗ (ΞΕΤΥΛΙΓΑΔΙΑΣΜΑ)',
  },
  {
    label: '1492600',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΕΡΙΩΝ ΕΝΤΟΜΩΝ ΚΑΙ ΣΠΑΡΜΑΤΣΕΤΩΝ, ΕΙΤΕ ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ Η ΧΡΩΜΑΤΙΣΜΕΝΩΝ, ΕΙΤΕ ΟΧΙ',
  },
  {
    label: '1492700',
    value: 'ΠΑΡΑΓΩΓΗ ΕΜΒΡΥΩΝ ΖΩΩΝ ΓΙΑ ΑΝΑΠΑΡΑΓΩΓΗ',
  },
  {
    label: '1492800',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΗ ΒΡΩΣΙΜΩΝ ΠΡΟΪΟΝΤΩΝ ΠΡΟΕΡΧΟΜΕΝΩΝ ΑΠΟ ΖΩΑ ΑΓΡΟΚΤΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '1493000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΩΝ ΓΟΥΝΟΔΕΡΜΑΤΩΝ ΚΑΙ ΔΙΑΦΟΡΩΝ ΑΚΑΤΕΡΓΑΣΤΩΝ ΠΡΟΒΙΩΝ ΚΑΙ ΔΕΡΜΑΤΩΝ',
  },
  {
    label: '1493100',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΩΝ ΓΟΥΝΟΔΕΡΜΑΤΩΝ, ΕΚΤΟΣ ΑΠΟ ΔΕΡΜΑΤΑ ΓΟΥΝΟΦΟΡΩΝ ΑΡΝΙΩΝ',
  },
  {
    label: '1493200',
    value: 'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΩΝ ΓΟΥΝΟΔΕΡΜΑΤΩΝ ΑΠΟ ΔΕΡΜΑΤΑ ΓΟΥΝΟΦΟΡΩΝ ΑΡΝΙΩΝ',
  },
  {
    label: '1493900',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΩΝ ΔΕΡΜΑΤΩΝ ΖΩΩΝ Π.Δ.Κ.Α. (ΝΩΠΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ, ΠΟΥ ΔΕΝ ΕΧΟΥΝ ΟΜΩΣ ΥΠΟΣΤΕΙ ΠΕΡΑΙΤΕΡΩ ΚΑΤΕΡΓΑΣΙΑ)',
  },
  {
    label: '1500000',
    value: 'ΜΙΚΤΕΣ ΓΕΩΡΓΟΚΤΗΝΟΤΡΟΦΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '1610000',
    value: 'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΓΙΑ ΤΗ ΦΥΤΙΚΗ ΠΑΡΑΓΩΓΗ',
  },
  {
    label: '1611000',
    value: 'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗ ΦΥΤΙΚΗ ΠΑΡΑΓΩΓΗ',
  },
  {
    label: '1611001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΓΡΟΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΠΟΧΙΑΚΗΣ ΧΡΗΣΗΣ (ΘΕΡΙΖΟΑΛΩΝΙΣΤΙΚΩΝ, ΒΑΜΒΑΚΟΣΥΛΛΕΚΤΙΚΩΝ ΚΛΠ)',
  },
  {
    label: '1611002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΡΑΙΩΣΗΣ ΖΑΧΑΡΟΤΕΥΤΛΩΝ',
  },
  {
    label: '1611003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΑΕΡΙΟΥ ΨΕΚΑΣΜΟΥ ΤΩΝ ΚΑΛΛΙΕΡΓΕΙΩΝ',
  },
  {
    label: '1611004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΡΙΣΜΟΥ ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '1611005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΧΩΡΑΦΙΩΝ ΑΠΟ ΑΧΡΗΣΤΑ ΥΛΙΚΑ',
  },
  {
    label: '1611006',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΠΟΛΕΜΗΣΗΣ ΖΙΖΑΝΙΩΝ ΚΑΙ ΕΠΙΒΛΑΒΩΝ ΓΙΑ ΤΗ ΓΕΩΡΓΙΑ ΕΝΤΟΜΩΝ Η ΖΩΩΝ',
  },
  {
    label: '1611007',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΛΑΔΕΜΑΤΟΣ ΔΕΝΔΡΩΝ ΚΑΙ ΑΛΛΩΝ ΦΥΤΩΝ',
  },
  {
    label: '1611008',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΣΥΣΤΗΜΑΤΩΝ ΑΡΔΕΥΣΗΣ',
  },
  {
    label: '1611009',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΕΡΙΣΥΛΛΟΓΗΣ ΚΑΙ ΣΥΓΚΟΜΙΔΗΣ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '1611010',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΕΤΟΙΜΑΣΙΑΣ ΑΓΡΩΝ',
  },
  {
    label: '1611011',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΗΨΙΛΥΣΗΣ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '1611012',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΠΟΡΑΣ ΚΑΙ ΦΥΤΕΥΣΗΣ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '1611013',
    value: 'ΥΠΗΡΕΣΙΕΣ ΨΕΚΑΣΜΟΥ ΦΥΤΩΝ ΚΑΙ ΑΓΡΩΝ',
  },
  {
    label: '1620000',
    value: 'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΓΙΑ ΤΗ ΖΩΙΚΗ ΠΑΡΑΓΩΓΗ',
  },
  {
    label: '1621000',
    value: 'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗ ΖΩΙΚΗ ΠΑΡΑΓΩΓΗ',
  },
  {
    label: '1621001',
    value: 'ΑΓΡΟΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΕ ΕΡΓΑΣΙΕΣ ΦΥΛΑΞΗΣ ΖΩΩΝ ΚΤΗΝΟΤΡΟΦΙΑΣ',
  },
  {
    label: '1621002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΛΟΓΗΣ ΑΒΓΩΝ',
  },
  {
    label: '1621004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΥΝΟΥΧΙΣΜΟΥ ΖΩΩΝ',
  },
  {
    label: '1621005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΟΡΝΙΘΩΝΩΝ',
  },
  {
    label: '1621006',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΥΡΑΣ ΖΩΩΝ',
  },
  {
    label: '1621007',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΚΑΤΑΛΥΜΑΤΟΣ ΣΕ ΟΙΚΙΑΚΑ ΖΩΑ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '1621008',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΗΤΗΣ ΓΟΝΙΜΟΠΟΙΗΣΗΣ',
  },
  {
    label: '1621009',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΡΟΝΤΙΔΑΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΚΟΠΑΔΙΩΝ',
  },
  {
    label: '1621010',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΥΛΑΞΗΣ ΚΑΙ ΠΑΧΥΝΣΗΣ ΖΩΩΝ',
  },
  {
    label: '1630000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΜΕΤΑ ΤΗ ΣΥΓΚΟΜΙΔΗ',
  },
  {
    label: '1631001',
    value:
      'ΚΑΛΛΙΕΡΓΗΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΜΕΤΑ ΤΗ ΣΥΓΚΟΜΙΔΗ, ΠΟΥ ΑΦΟΡΟΥΝ ΤΟΝ ΚΑΠΝΟ',
  },
  {
    label: '1631002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΛΩΝΙΣΜΟΥ ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '1631003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΛΥΜΑΝΣΗΣ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '1631004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΞΗΡΑΝΣΗΣ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '1631005',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΠΟΞΗΡΑΝΣΗΣ ΚΑΙ ΑΠΟΦΛΟΙΩΣΗΣ ΟΣΠΡΙΩΝ ΚΑΙ ΑΛΛΩΝ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '1631006',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΞΗΡΑΝΣΗΣ ΣΤΑΦΙΔΑΣ',
  },
  {
    label: '1631007',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΞΗΡΑΝΣΗΣ ΣΥΚΩΝ',
  },
  {
    label: '1631008',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΦΛΟΙΩΣΗΣ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '1631009',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΑΦΗΣ ΚΑΙ ΚΑΘΑΡΙΣΜΟΥ ΣΤΑΦΙΔΑΣ',
  },
  {
    label: '1631010',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΕΜΑΤΟΠΟΙΗΣΗΣ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '1631011',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΛΟΓΗΣ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '1631012',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΚΟΚΚΙΣΜΟΥ ΒΑΜΒΑΚΙΟΥ (ΕΚ ΤΩΝ ΥΣΤΕΡΩΝ ΠΩΛΗΣΗ ΓΙΑ ΙΔΙΟ ΛΟΓΑΡΙΑΣΜΟ)',
  },
  {
    label: '1631013',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΚΟΚΚΙΣΜΟΥ ΒΑΜΒΑΚΙΟΥ (ΕΚ ΤΩΝ ΥΣΤΕΡΩΝ ΠΩΛΗΣΗ ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ)',
  },
  {
    label: '1631014',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΚΟΚΚΙΣΜΟΥ ΚΑΛΑΜΠΟΚΙΟΥ',
  },
  {
    label: '1631015',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '1631016',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΕΡΩΣΗΣ ΚΑΡΠΩΝ',
  },
  {
    label: '1631017',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΣΚΕΥΑΣΙΑΣ ΚΑΙ ΑΠΟΘΗΚΕΥΣΗΣ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '1640000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΣΠΟΡΩΝ ΠΟΛΛΑΠΛΑΣΙΑΣΜΟΥ',
  },
  {
    label: '1641000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΣΠΟΡΩΝ ΠΟΛΛΑΠΛΑΣΙΑΣΜΟΥ',
  },
  {
    label: '1700000',
    value: 'ΘΗΡΑ, ΤΟΠΟΘΕΤΗΣΗ ΠΑΓΙΔΩΝ ΚΑΙ ΣΥΝΑΦΕΙΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '1701000',
    value: 'ΘΗΡΑ, ΤΟΠΟΘΕΤΗΣΗ ΠΑΓΙΔΩΝ ΚΑΙ ΣΥΝΑΦΕΙΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '1701001',
    value:
      'ΒΟΗΘΗΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΗΝ ΠΡΟΩΘΗΣΗ ΤΗΣ ΘΗΡΑΣ ΚΑΙ ΤΗΣ ΤΟΠΟΘΕΤΗΣΗΣ ΠΑΓΙΔΩΝ, ΓΙΑ ΚΕΡΔΟΣΚΟΠΙΚΟΥΣ ΣΚΟΠΟΥΣ',
  },
  {
    label: '1701002',
    value: 'ΘΗΡΑ ΑΓΡΙΩΝ ΓΟΥΝΟΦΟΡΩΝ ΖΩΩΝ, ΘΗΡΑ ΕΡΠΕΤΩΝ',
  },
  {
    label: '1701003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΠΑΡΑΓΩΓΗΣ ΘΗΡΑΜΑΤΩΝ',
  },
  {
    label: '2100000',
    value: 'ΔΑΣΟΚΟΜΙΑ ΚΑΙ ΑΛΛΕΣ ΔΑΣΟΚΟΜΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '2101000',
    value:
      'ΔΑΣΟΚΟΜΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΕ ΖΩΝΤΑ ΔΑΣΙΚΑ ΦΥΤΑ· ΣΥΛΛΟΓΗ ΣΠΟΡΩΝ ΔΑΣΙΚΩΝ ΦΥΤΩΝ',
  },
  {
    label: '2101100',
    value: 'ΔΑΣΟΚΟΜΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΕ ΖΩΝΤΑ ΔΑΣΙΚΑ ΦΥΤΑ',
  },
  {
    label: '2101200',
    value: 'ΣΥΛΛΟΓΗ ΣΠΟΡΩΝ ΔΑΣΙΚΩΝ ΦΥΤΩΝ',
  },
  {
    label: '2102000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΥΤΩΡΙΩΝ ΔΑΣΙΚΩΝ ΔΕΝΤΡΩΝ',
  },
  {
    label: '2103000',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΔΑΣΙΚΩΝ ΔΕΝΔΡΩΝ',
  },
  {
    label: '2103001',
    value:
      'ΚΑΛΛΙΕΡΓΕΙΑ ΔΑΣΥΛΛΙΩΝ ΓΙΑ ΠΕΡΙΟΔΙΚΗ ΞΥΛΕΙΑ ΠΡΟΣ ΠΑΡΑΣΚΕΥΗ ΧΑΡΤΟΠΟΛΤΟΥ',
  },
  {
    label: '2103002',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΡΙΩΝ ΕΛΑΤΩΝ',
  },
  {
    label: '2103003',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΦΥΤΩΡΙΩΝ ΠΕΥΚΗΣ',
  },
  {
    label: '2200000',
    value: 'ΥΛΟΤΟΜΙΑ',
  },
  {
    label: '2201000',
    value: 'ΥΛΟΤΟΜΙΑ ΑΚΑΤΕΡΓΑΣΤΗΣ ΞΥΛΕΙΑΣ',
  },
  {
    label: '2201100',
    value: 'ΥΛΟΤΟΜΙΑ ΚΟΡΜΩΝ ΞΥΛΕΙΑΣ ΚΩΝΟΦΟΡΩΝ',
  },
  {
    label: '2201200',
    value:
      'ΥΛΟΤΟΜΙΑ ΚΟΡΜΩΝ ΞΥΛΕΙΑΣ ΜΗ ΚΩΝΟΦΟΡΩΝ, ΕΚΤΟΣ ΞΥΛΕΙΑΣ ΤΡΟΠΙΚΩΝ ΔΕΝΔΡΩΝ',
  },
  {
    label: '2201300',
    value: 'ΥΛΟΤΟΜΙΑ ΚΟΡΜΩΝ ΞΥΛΕΙΑΣ ΤΡΟΠΙΚΩΝ ΔΕΝΔΡΩΝ',
  },
  {
    label: '2201400',
    value: 'ΥΛΟΤΟΜΙΑ ΚΑΥΣΟΞΥΛΩΝ',
  },
  {
    label: '2300000',
    value: 'ΣΥΛΛΟΓΗ ΠΡΟΪΟΝΤΩΝ ΑΥΤΟΦΥΩΝ ΦΥΤΩΝ ΜΗ ΞΥΛΩΔΟΥΣ ΜΟΡΦΗΣ',
  },
  {
    label: '2301000',
    value: 'ΣΥΛΛΟΓΗ ΦΥΣΙΚΩΝ ΚΟΜΜΕΩΝ',
  },
  {
    label: '2301100',
    value:
      'ΣΥΛΛΟΓΗ ΒΑΛΑΤΑΣ, ΓΟΥΤΑΠΕΡΚΑΣ, ΓΟΥΑΓΙΟΥΛΗΣ, ΤΣΙΚΛΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΦΥΣΙΚΩΝ ΚΟΜΜΕΩΝ',
  },
  {
    label: '2301200',
    value: 'ΣΥΛΛΟΓΗ ΛΑΚΑΣ, ΒΑΛΣΑΜΩΝ ΚΑΙ ΑΛΛΩΝ ΦΥΣΙΚΩΝ ΚΟΜΜΕΩΝ ΚΑΙ ΡΗΤΙΝΩΝ',
  },
  {
    label: '2301201',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΑΣΤΙΧΑΣ',
  },
  {
    label: '2301202',
    value: 'ΣΥΛΛΟΓΗ ΡΗΤΙΝΩΝ',
  },
  {
    label: '2302000',
    value:
      'ΣΥΛΛΟΓΗ ΦΥΣΙΚΟΥ ΦΕΛΛΟΥ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΚΑΤΕΡΓΑΣΤΟΣ Η ΜΕ ΑΠΛΗ ΚΑΤΕΡΓΑΣΙΑ',
  },
  {
    label: '2303000',
    value:
      'ΣΥΛΛΟΓΗ ΜΕΡΩΝ ΦΥΤΩΝ, ΧΟΡΤΑΡΙΩΝ, ΒΡΥΩΝ ΚΑΙ ΛΕΙΧΗΝΩΝ, ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΔΙΑΚΟΣΜΗΤΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '2304000',
    value: 'ΣΥΛΛΟΓΗ ΒΡΩΣΙΜΩΝ ΠΡΟΪΟΝΤΩΝ ΑΥΤΟΦΥΩΝ ΦΥΤΩΝ',
  },
  {
    label: '2400000',
    value: 'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΠΡΟΣ ΤΗ ΔΑΣΟΚΟΜΙΑ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '2401001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΦΛΟΙΩΣΗΣ ΔΕΝΤΡΩΝ',
  },
  {
    label: '2401002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΑΣΟΚΟΜΙΚΩΝ ΑΠΟΓΡΑΦΩΝ, ΑΠΟΤΙΜΗΣΗΣ ΔΑΣΙΚΗΣ ΞΥΛΕΙΑΣ',
  },
  {
    label: '2401003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΑΣΟΛΟΓΟΥ',
  },
  {
    label: '2401004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΠΗΣ ΔΕΝΤΡΩΝ',
  },
  {
    label: '2401005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΠΗΣ ΚΑΥΣΟΞΥΛΩΝ',
  },
  {
    label: '2401006',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΚΟΡΜΩΝ ΔΕΝΤΡΩΝ',
  },
  {
    label: '2401007',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΥΡΟΠΡΟΣΤΑΣΙΑΣ ΔΑΣΟΥΣ',
  },
  {
    label: '3110000',
    value: 'ΘΑΛΑΣΣΙΑ ΑΛΙΕΙΑ',
  },
  {
    label: '3111000',
    value: 'ΑΛΙΕΙΑ ΨΑΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '3111100',
    value: 'ΑΛΙΕΙΑ ΚΑΛΛΩΠΙΣΤΙΚΩΝ ΨΑΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '3111200',
    value: 'ΑΛΙΕΙΑ ΨΑΡΙΩΝ ΘΑΛΑΣΣΑΣ, ΜΗ ΕΚΤΡΕΦΟΜΕΝΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '3112000',
    value: 'ΑΛΙΕΙΑ ΨΑΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '3112100',
    value:
      'ΑΛΙΕΙΑ ΨΑΡΙΩΝ ΘΑΛΑΣΣΑΣ, ΜΗ ΕΚΤΡΕΦΟΜΕΝΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '3112101',
    value:
      'ΥΠΕΡΠΟΝΤΙΑ ΑΛΙΕΙΑ ΨΑΡΙΩΝ,            [ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ            ]',
  },
  {
    label: '3113000',
    value: 'ΑΛΙΕΙΑ ΚΑΡΚΙΝΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΜΗ ΚΑΤΕΨΥΓΜΕΝΑ',
  },
  {
    label: '3113100',
    value:
      'ΑΛΙΕΙΑ ΚΑΡΚΙΝΟΕΙΔΩΝ, ΜΗ ΚΑΛΛΙΕΡΓΟΥΜΕΝΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΜΗ ΚΑΤΕΨΥΓΜΕΝΑ',
  },
  {
    label: '3114000',
    value:
      'ΑΛΙΕΙΑ ΜΑΛΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ, ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '3114100',
    value:
      'ΑΛΙΕΙΑ ΣΤΡΕΙΔΙΩΝ, ΜΗ ΚΑΛΛΙΕΡΓΟΥΜΕΝΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ, ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '3114200',
    value:
      'ΑΛΙΕΙΑ ΑΛΛΩΝ ΜΑΛΑΚΙΩΝ ΚΑΙ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΜΗ ΚΑΛΛΙΕΡΓΟΥΜΕΝΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ, ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '3115000',
    value: 'ΑΛΙΕΙΑ ΦΥΣΙΚΩΝ ΜΑΡΓΑΡΙΤΑΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΑ',
  },
  {
    label: '3116000',
    value: 'ΑΛΙΕΙΑ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΦΥΤΩΝ, ΖΩΩΝ ΚΑΙ ΤΩΝ ΠΡΟΪΟΝΤΩΝ ΤΟΥΣ',
  },
  {
    label: '3116100',
    value:
      'ΑΛΙΕΙΑ ΚΟΡΑΛΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ, ΟΣΤΡΑΚΩΝ ΜΑΛΑΚΙΩΝ, ΚΑΡΚΙΝΟΕΙΔΩΝ Η ΕΧΙΝΟΔΕΡΜΩΝ ΚΑΙ ΟΣΤΩΝ ΣΟΥΠΙΩΝ',
  },
  {
    label: '3116200',
    value: 'ΑΛΙΕΙΑ ΦΥΣΙΚΩΝ ΣΦΟΥΓΓΑΡΙΩΝ ΖΩΙΚΗΣ ΠΡΟΕΛΕΥΣΗΣ',
  },
  {
    label: '3116300',
    value: 'ΑΛΙΕΙΑ ΦΥΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΑΛΓΩΝ, ΜΗ ΚΑΛΛΙΕΡΓΟΥΜΕΝΩΝ',
  },
  {
    label: '3116900',
    value: 'ΑΛΙΕΙΑ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΦΥΤΩΝ, ΖΩΩΝ ΚΑΙ ΤΩΝ ΠΡΟΪΟΝΤΩΝ ΤΟΥΣ Π.Δ.Κ.Α.',
  },
  {
    label: '3117000',
    value: 'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗΝ ΑΛΙΕΙΑ',
  },
  {
    label: '3117101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΥΚΑΝΣΗΣ ΦΥΣΙΚΩΝ ΣΦΟΥΓΓΑΡΙΩΝ',
  },
  {
    label: '3120000',
    value: 'ΑΛΙΕΙΑ ΓΛΥΚΩΝ ΥΔΑΤΩΝ',
  },
  {
    label: '3121000',
    value:
      'ΑΛΙΕΙΑ ΨΑΡΙΩΝ ΓΛΥΚΩΝ ΥΔΑΤΩΝ, ΜΗ ΕΚΤΡΕΦΟΜΕΝΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '3122000',
    value:
      'ΑΛΙΕΙΑ ΨΑΡΙΩΝ ΓΛΥΚΩΝ ΥΔΑΤΩΝ, ΜΗ ΕΚΤΡΕΦΟΜΕΝΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '3210000',
    value: 'ΘΑΛΑΣΣΙΑ ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ',
  },
  {
    label: '3211000',
    value:
      'ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ ΕΚΤΡΕΦΟΜΕΝΩΝ ΨΑΡΙΩΝ ΘΑΛΑΣΣΗΣ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '3212000',
    value:
      'ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ ΕΚΤΡΕΦΟΜΕΝΩΝ ΨΑΡΙΩΝ ΘΑΛΑΣΣΗΣ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '3212301',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΛΑΒΡΑΚΙΟΥ',
  },
  {
    label: '3212302',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΠΕΣΤΡΟΦΑΣ',
  },
  {
    label: '3213000',
    value:
      'ΘΑΛΑΣΣΙΑ ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ ΚΑΛΛΙΕΡΓΟΥΜΕΝΩΝ ΚΑΡΚΙΝΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΜΗ ΚΑΤΕΨΥΓΜΕΝΑ',
  },
  {
    label: '3214000',
    value:
      'ΘΑΛΑΣΣΙΑ ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ ΜΑΛΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ, ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '3214300',
    value:
      'ΘΑΛΑΣΣΙΑ ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ ΣΤΡΕΙΔΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ, ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '3214400',
    value:
      'ΘΑΛΑΣΣΙΑ ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΜΑΛΑΚΙΩΝ ΚΑΙ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ, ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '3214401',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΑΛΑΚΙΩΝ ΚΑΙ ΜΑΛΑΚΟΣΤΡΑΚΩΝ',
  },
  {
    label: '3214402',
    value: 'ΚΑΛΛΙΕΡΓΕΙΑ ΜΥΔΙΩΝ',
  },
  {
    label: '3214403',
    value: 'ΟΣΤΡΑΚΟΚΑΛΛΙΕΡΓΕΙΑ',
  },
  {
    label: '3215000',
    value:
      'ΘΑΛΑΣΣΙΑ ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ ΜΑΡΓΑΡΙΤΑΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΑ',
  },
  {
    label: '3216000',
    value:
      'ΘΑΛΑΣΣΙΑ ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΦΥΤΩΝ, ΖΩΩΝ ΚΑΙ ΤΩΝ ΠΡΟΪΟΝΤΩΝ ΤΟΥΣ',
  },
  {
    label: '3216400',
    value: 'ΘΑΛΑΣΣΙΑ ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ ΦΥΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΑΛΓΩΝ',
  },
  {
    label: '3217000',
    value: 'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗΝ ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ',
  },
  {
    label: '3220000',
    value: 'ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ ΓΛΥΚΩΝ ΥΔΑΤΩΝ',
  },
  {
    label: '3221000',
    value:
      'ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ ΕΚΤΡΕΦΟΜΕΝΩΝ ΨΑΡΙΩΝ, ΓΛΥΚΩΝ ΥΔΑΤΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΖΩΝΤΑ',
  },
  {
    label: '3221501',
    value: 'ΕΚΤΡΟΦΗ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΨΑΡΙΩΝ',
  },
  {
    label: '3222000',
    value:
      'ΥΔΑΤΟΚΑΛΛΙΕΡΓΕΙΑ ΕΚΤΡΕΦΟΜΕΝΩΝ ΨΑΡΙΩΝ, ΓΛΥΚΩΝ ΥΔΑΤΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '5100000',
    value: 'ΕΞΟΡΥΞΗ ΛΙΘΑΝΘΡΑΚΑ',
  },
  {
    label: '5200000',
    value: 'ΕΞΟΡΥΞΗ ΛΙΓΝΙΤΗ',
  },
  {
    label: '6100000',
    value: 'ΑΝΤΛΗΣΗ ΑΡΓΟΥ ΠΕΤΡΕΛΑΙΟΥ',
  },
  {
    label: '6101000',
    value:
      'ΑΝΤΛΗΣΗ ΠΕΤΡΕΛΑΪΚΩΝ ΕΛΑΙΩΝ ΚΑΙ ΕΛΑΙΩΝ ΠΟΥ ΛΑΜΒΑΝΟΝΤΑΙ ΑΠΟ ΑΣΦΑΛΤΟΥΧΑ ΟΡΥΚΤΑ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΑ',
  },
  {
    label: '6102000',
    value:
      'ΑΝΤΛΗΣΗ ΑΣΦΑΛΤΟΥΧΟΥ Η ΠΕΤΡΕΛΑΙΟΥΧΟΥ ΣΧΙΣΤΟΛΙΘΟΥ ΚΑΙ ΠΙΣΣΟΥΧΩΝ ΑΜΜΩΝ',
  },
  {
    label: '6200000',
    value: 'ΑΝΤΛΗΣΗ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '6201000',
    value:
      'ΑΝΤΛΗΣΗ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΥΓΡΟΠΟΙΗΜΕΝΟ Η ΣΕ ΑΕΡΙΩΔΗ ΚΑΤΑΣΤΑΣΗ',
  },
  {
    label: '7100000',
    value: 'ΕΞΟΡΥΞΗ ΣΙΔΗΡΟΜΕΤΑΛΛΕΥΜΑΤΟΣ',
  },
  {
    label: '7101000',
    value: 'ΕΞΟΡΥΞΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΕΥΜΑΤΩΝ',
  },
  {
    label: '7210000',
    value: 'ΕΞΟΡΥΞΗ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΟΥΡΑΝΙΟΥ ΚΑΙ ΘΟΡΙΟΥ',
  },
  {
    label: '7290000',
    value: 'ΕΞΟΡΥΞΗ ΛΟΙΠΩΝ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΕΥΜΑΤΩΝ',
  },
  {
    label: '7291000',
    value: 'ΕΞΟΡΥΞΗ ΑΛΛΩΝ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ',
  },
  {
    label: '7291100',
    value: 'ΕΞΟΡΥΞΗ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΧΑΛΚΟΥ',
  },
  {
    label: '7291200',
    value: 'ΕΞΟΡΥΞΗ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΝΙΚΕΛΙΟΥ',
  },
  {
    label: '7291300',
    value: 'ΕΞΟΡΥΞΗ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΑΡΓΙΛΙΟΥ',
  },
  {
    label: '7291400',
    value: 'ΕΞΟΡΥΞΗ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΠΟΛΥΤΙΜΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '7291500',
    value:
      'ΕΞΟΡΥΞΗ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΜΟΛΥΒΔΟΥ, ΨΕΥΔΑΡΓΥΡΟΥ ΚΑΙ ΚΑΣΣΙΤΕΡΟΥ',
  },
  {
    label: '7291900',
    value:
      'ΕΞΟΡΥΞΗ ΑΛΛΩΝ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '8110000',
    value:
      'ΕΞΟΡΥΞΗ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΚΑΙ ΟΙΚΟΔΟΜΙΚΩΝ ΛΙΘΩΝ, ΑΣΒΕΣΤΟΛΙΘΟΥ, ΓΥΨΟΥ, ΚΙΜΩΛΙΑΣ ΚΑΙ ΣΧΙΣΤΟΛΙΘΟΥ',
  },
  {
    label: '8111000',
    value: 'ΕΞΟΡΥΞΗ ΛΙΘΩΝ ΓΙΑ ΜΝΗΜΕΙΑ Η ΚΤΙΡΙΑ (ΟΙΚΟΔΟΜΙΚΩΝ ΛΙΘΩΝ)',
  },
  {
    label: '8111100',
    value:
      'ΕΞΟΡΥΞΗ ΜΑΡΜΑΡΩΝ ΚΑΙ ΑΛΛΩΝ ΑΣΒΕΣΤΟΛΙΘΙΚΩΝ ΛΙΘΩΝ, ΓΙΑ ΜΝΗΜΕΙΑ Η ΚΤΙΡΙΑ',
  },
  {
    label: '8111200',
    value:
      'ΕΞΟΡΥΞΗ ΓΡΑΝΙΤΗ, ΨΑΜΜΙΤΗ ΚΑΙ ΑΛΛΩΝ ΛΙΘΩΝ ΓΙΑ ΜΝΗΜΕΙΑ Η ΚΤΙΡΙΑ (ΟΙΚΟΔΟΜΙΚΩΝ ΛΙΘΩΝ)',
  },
  {
    label: '8112000',
    value: 'ΕΞΟΡΥΞΗ ΑΣΒΕΣΤΟΛΙΘΟΥ ΚΑΙ ΓΥΨΟΥ',
  },
  {
    label: '8113000',
    value: 'ΕΞΟΡΥΞΗ ΚΙΜΩΛΙΑΣ ΚΑΙ ΜΗ ΦΡΥΓΜΕΝΟΥ ΔΟΛΟΜΙΤΗ',
  },
  {
    label: '8114000',
    value: 'ΕΞΟΡΥΞΗ ΣΧΙΣΤΟΛΙΘΟΥ',
  },
  {
    label: '8120000',
    value:
      'ΛΕΙΤΟΥΡΓΙΑ ΦΡΕΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΑΜΜΟΧΑΛΙΚΟΥ ΚΑΙ ΑΜΜΟΥ· ΕΞΟΡΥΞΗ ΑΡΓΙΛΟΥ ΚΑΙ ΚΑΟΛΙΝΗΣ',
  },
  {
    label: '8121000',
    value: 'ΕΞΟΡΥΞΗ ΑΜΜΟΧΑΛΙΚΟΥ ΚΑΙ ΑΜΜΟΥ',
  },
  {
    label: '8121100',
    value: 'ΕΞΟΡΥΞΗ ΦΥΣΙΚΗΣ ΑΜΜΟΥ',
  },
  {
    label: '8121200',
    value:
      'ΕΞΟΡΥΞΗ ΛΙΘΟΚΟΚΚΩΝ, ΨΙΛΟΥ ΧΑΛΙΚΙΟΥ ΚΑΙ ΛΙΘΟΣΚΟΝΗΣ· ΚΡΟΚΑΛΩΝ, ΑΜΜΟΧΑΛΙΚΟΥ',
  },
  {
    label: '8121300',
    value:
      'ΕΞΟΡΥΞΗ ΜΕΙΓΜΑΤΩΝ ΣΚΩΡΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΒΙΟΜΗΧΑΝΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, ΑΚΟΜΗ ΚΑΙ ΕΑΝ ΠΕΡΙΕΧΟΥΝ ΚΡΟΚΑΛΕΣ, ΑΜΜΟΧΑΛΙΚΟ, ΤΑΒΑΝΟΣΑΝΙΔΑ ΚΑΙ ΠΥΡΙΤΗ ΛΙΘΟ ΚΑΙ ΔΙΑΘΕΤΟΝΤΑΙ ΓΙΑ ΚΑΤΑΣΚΕΥΑΣΤΙΚΟΥΣ ΣΚΟΠΟΥΣ',
  },
  {
    label: '8122000',
    value: 'ΕΞΟΡΥΞΗ ΑΡΓΙΛΩΝ ΚΑΙ ΚΑΟΛΙΝΗ',
  },
  {
    label: '8122100',
    value: 'ΕΞΟΡΥΞΗ ΚΑΟΛΙΝΗ ΚΑΙ ΑΛΛΩΝ ΚΑΟΛΙΝΙΚΩΝ ΑΡΓΙΛΩΝ',
  },
  {
    label: '8122101',
    value: 'ΠΑΡΑΓΩΓΗ ΜΑΖΩΝ ΚΕΡΑΜΙΚΗΣ ΑΠΟ ΚΑΟΛΙΝΗ ΚΑΙ ΚΑΟΛΙΝΙΚΕΣ ΑΡΓΙΛΟΥΣ',
  },
  {
    label: '8122200',
    value:
      'ΕΞΟΡΥΞΗ ΑΛΛΩΝ ΑΡΓΙΛΩΝ, ΑΝΔΑΛΟΥΣΙΤΗ, ΚΥΑΝΙΤΗ ΚΑΙ ΣΙΛΙΜΑΝΙΤΗ· ΜΟΥΛΛΙΤΗ· ΠΥΡΙΜΑΧΩΝ ΓΑΙΩΝ Η ΓΑΙΩΝ ΑΠΟ ΜΕΙΓΜΑ ΑΛΕΣΜΕΝΟΥ ΧΑΛΑΖΙΤΗ ΚΑΙ ΑΡΓΙΛΟΥ',
  },
  {
    label: '8122201',
    value: 'ΠΑΡΑΓΩΓΗ ΜΑΖΩΝ ΚΕΡΑΜΙΚΗΣ ΑΠΟ ΑΛΛΕΣ ΥΛΕΣ',
  },
  {
    label: '8910000',
    value:
      'ΕΞΟΡΥΞΗ ΟΡΥΚΤΩΝ ΓΙΑ ΤΗ ΧΗΜΙΚΗ ΒΙΟΜΗΧΑΝΙΑ ΚΑΙ ΤΗ ΒΙΟΜΗΧΑΝΙΑ ΛΙΠΑΣΜΑΤΩΝ',
  },
  {
    label: '8911000',
    value: 'ΕΞΟΡΥΞΗ ΧΗΜΙΚΩΝ ΟΡΥΚΤΩΝ ΚΑΙ ΟΡΥΚΤΩΝ ΓΙΑ ΤΗ ΒΙΟΜΗΧΑΝΙΑ ΛΙΠΑΣΜΑΤΩΝ',
  },
  {
    label: '8911100',
    value: 'ΕΞΟΡΥΞΗ ΦΥΣΙΚΩΝ ΦΩΣΦΟΡΙΚΩΝ ΑΛΑΤΩΝ ΑΣΒΕΣΤΙΟΥ Η ΑΡΓΙΛΙΟΥ',
  },
  {
    label: '8911200',
    value:
      'ΕΞΟΡΥΞΗ ΑΦΡΥΚΤΟΥ ΣΙΔΗΡΟΠΥΡΙΤΗ· ΑΚΑΤΕΡΓΑΣΤΟΥ Η ΜΗ ΕΞΕΥΓΕΝΙΣΜΕΝΟΥ ΘΕΙΟΥ',
  },
  {
    label: '8911900',
    value: 'ΕΞΟΡΥΞΗ ΑΛΛΩΝ ΧΗΜΙΚΩΝ ΟΡΥΚΤΩΝ ΚΑΙ ΛΙΠΑΣΜΑΤΩΝ',
  },
  {
    label: '8911901',
    value: 'ΕΞΟΡΥΞΗ ΦΥΣΙΚΟΥ ΘΕΙΙΚΟΥ ΒΑΡΙΟΥ (ΒΑΡΙΤΙΝΗΣ)',
  },
  {
    label: '8911902',
    value: 'ΕΞΟΡΥΞΗ ΦΥΣΙΚΟΥ ΚΡΥΟΛΙΘΟΥ',
  },
  {
    label: '8920000',
    value: 'ΕΞΟΡΥΞΗ ΤΥΡΦΗΣ',
  },
  {
    label: '8930000',
    value: 'ΕΞΟΡΥΞΗ ΑΛΑΤΙΟΥ',
  },
  {
    label: '8931000',
    value:
      'ΕΞΟΡΥΞΗ ΑΛΑΤΙΟΥ ΚΑΙ ΚΑΘΑΡΟΥ ΧΛΩΡΙΟΥΧΟΥ ΝΑΤΡΙΟΥ, ΑΝΤΛΗΣΗ ΘΑΛΑΣΣΙΝΟΥ ΝΕΡΟΥ',
  },
  {
    label: '8990000',
    value: 'ΑΛΛΕΣ ΕΞΟΡΥΚΤΙΚΕΣ ΚΑΙ ΛΑΤΟΜΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '8991000',
    value:
      'ΕΞΟΡΥΞΗ ΒΙΤΟΥΜΙΟΥ ΚΑΙ ΑΣΦΑΛΤΩΝ ΕΝ ΓΕΝΕΙ ΦΥΣΙΚΩΝ· ΑΣΦΑΛΤΙΤΩΝ ΚΑΙ ΑΣΦΑΛΤΙΚΩΝ ΠΕΤΡΩΜΑΤΩΝ',
  },
  {
    label: '8992000',
    value:
      'ΕΞΟΡΥΞΗ ΠΟΛΥΤΙΜΩΝ ΚΑΙ ΗΜΙΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ· ΠΑΡΑΓΩΓΗ ΒΙΟΜΗΧΑΝΙΚΩΝ ΔΙΑΜΑΝΤΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΑ Η ΑΠΛΩΣ ΚΟΜΜΕΝΑ, ΣΧΙΣΜΕΝΑ Η ΠΡΟΕΤΟΙΜΑΣΜΕΝΑ ΓΙΑ ΣΤΙΛΒΩΣΗ· ΕΞΟΡΥΞΗ ΚΙΣΗΡΟΛΙΘΩΝ (ΕΛΑΦΡΟΠΕΤΡΩΝ)· ΣΜΥΡΙΔΑΣ· ΦΥΣΙΚΟΥ ΚΟΡΟΥΝΔΙΟΥ, ΦΥΣΙΚΟΥ ΓΡΑΝΑΤ',
  },
  {
    label: '8992100',
    value:
      'ΕΞΟΡΥΞΗ ΠΟΛΥΤΙΜΩΝ ΚΑΙ ΗΜΙΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ (ΕΚΤΟΣ ΤΩΝ ΒΙΟΜΗΧΑΝΙΚΩΝ ΔΙΑΜΑΝΤΙΩΝ), ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΟΙ Η ΑΠΛΩΣ ΚΟΜΜΕΝΟΙ Η ΧΟΝΔΡΙΚΑ ΔΙΑΜΟΡΦΩΜΕΝΟΙ',
  },
  {
    label: '8992200',
    value:
      'ΕΞΟΡΥΞΗ ΚΑΙ ΠΑΡΑΓΩΓΗ ΒΙΟΜΗΧΑΝΙΚΩΝ ΔΙΑΜΑΝΤΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΑ Η ΑΠΛΩΣ ΚΟΜΜΕΝΑ, ΣΧΙΣΜΕΝΑ Η ΠΡΟΕΤΟΙΜΑΣΜΕΝΑ ΓΙΑ ΣΤΙΛΒΩΣΗ· ΕΞΟΡΥΞΗ ΚΙΣΗΡΟΛΙΘΩΝ (ΕΛΑΦΡΟΠΕΤΡΩΝ)·ΣΜΥΡΙΔΑΣ· ΦΥΣΙΚΟΥ ΚΟΡΟΥΝΔΙΟΥ, ΦΥΣΙΚΟΥ ΓΡΑΝΑΤΗ ΚΑΙ ΑΛΛΩΝ ΦΥΣΙΚΩΝ ΛΕΙΑΝΤΙΚΩΝ',
  },
  {
    label: '8992201',
    value: 'ΕΞΟΡΥΞΗ ΚΙΣΗΡΟΛΙΘΩΝ (ΕΛΑΦΡΟΠΕΤΡΩΝ)',
  },
  {
    label: '8992202',
    value: 'ΕΞΟΡΥΞΗ ΣΜΥΡΙΔΑΣ',
  },
  {
    label: '8992900',
    value: 'ΕΞΟΡΥΞΗ ΑΛΛΩΝ ΟΡΥΚΤΩΝ',
  },
  {
    label: '9100000',
    value:
      'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΓΙΑ ΤΗΝ ΑΝΤΛΗΣΗ ΠΕΤΡΕΛΑΙΟΥ ΚΑΙ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '9101000',
    value:
      'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗΝ ΑΝΤΛΗΣΗ ΠΕΤΡΕΛΑΙΟΥ ΚΑΙ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '9101100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΕΩΤΡΗΣΗΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΗΝ ΑΝΤΛΗΣΗ ΠΕΤΡΕΛΑΙΟΥ ΚΑΙ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '9101200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΕΓΕΡΣΗΣ, ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΑΠΟΣΥΝΑΡΜΟΛΟΓΗΣΗΣ ΠΥΡΓΩΝ ΓΕΩΤΡΗΣΗΣ ΚΑΙ ΣΥΝΑΦΕΙΣ ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΗΝ ΑΝΤΛΗΣΗ ΠΕΤΡΕΛΑΙΟΥ ΚΑΙ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '9101300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΥΓΡΟΠΟΙΗΣΗΣ ΚΑΙ ΕΠΑΝΑΕΡΙΟΠΟΙΗΣΗΣ ΤΟΥ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ ΓΙΑ ΜΕΤΑΦΟΡΑ ΠΟΥ ΓΙΝΕΤΑΙ ΣΤΟ ΧΩΡΟ ΤΟΥ ΟΡΥΧΕΙΟΥ',
  },
  {
    label: '9900000',
    value:
      'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΓΙΑ ΑΛΛΕΣ ΕΞΟΡΥΚΤΙΚΕΣ ΚΑΙ ΛΑΤΟΜΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '9901000',
    value:
      'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΛΟΙΠΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΟΡΥΧΕΙΩΝ ΚΑΙ ΛΑΤΟΜΕΙΩΝ',
  },
  {
    label: '9901100',
    value: 'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗΝ ΕΞΑΓΩΓΗ ΛΙΘΑΝΘΡΑΚΑ',
  },
  {
    label: '9901900',
    value:
      'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΛΟΙΠΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΟΡΥΧΕΙΩΝ ΚΑΙ ΛΑΤΟΜΕΙΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '10110000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ',
  },
  {
    label: '10111000',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΒΟΟΕΙΔΩΝ, ΧΟΙΡΟΕΙΔΩΝ, ΑΙΓΟΠΡΟΒΑΤΟΕΙΔΩΝ, ΑΛΟΓΩΝ ΚΑΙ ΑΛΛΩΝ ΙΠΠΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΝΩΠΟ Η ΔΙΑΤΗΡΗΜΕΝΟ ΜΕ ΑΠΛΗ ΨΥΞΗ',
  },
  {
    label: '10111100',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΒΟΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΝΩΠΟ Η ΔΙΑΤΗΡΗΜΕΝΟ ΜΕ ΑΠΛΗ ΨΥΞΗ',
  },
  {
    label: '10111200',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΧΟΙΡΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΝΩΠΟ Η ΔΙΑΤΗΡΗΜΕΝΟ ΜΕ ΑΠΛΗ ΨΥΞΗ',
  },
  {
    label: '10111300',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΠΡΟΒΑΤΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΝΩΠΟ Η ΔΙΑΤΗΡΗΜΕΝΟ ΜΕ ΑΠΛΗ ΨΥΞΗ',
  },
  {
    label: '10111400',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΑΙΓΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΝΩΠΟ Η ΔΙΑΤΗΡΗΜΕΝΟ ΜΕ ΑΠΛΗ ΨΥΞΗ',
  },
  {
    label: '10111500',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΑΛΟΓΩΝ ΚΑΙ ΑΛΛΩΝ ΙΠΠΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΝΩΠΟ Η ΔΙΑΤΗΡΗΜΕΝΟ ΜΕ ΑΠΛΗ ΨΥΞΗ',
  },
  {
    label: '10112000',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ ΒΟΟΕΙΔΩΝ, ΧΟΙΡΟΕΙΔΩΝ, ΑΙΓΟΠΡΟΒΑΤΟΕΙΔΩΝ, ΑΛΟΓΩΝ ΚΑΙ ΑΛΛΩΝ ΙΠΠΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ Η ΔΙΑΤΗΡΗΜΕΝΑ ΜΕ ΑΠΛΗ ΨΥΞΗ',
  },
  {
    label: '10112001',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΖΩΙΚΩΝ ΕΝΤΕΡΩΝ ΑΛΛΑΝΤΟΠΟΙΙΑΣ',
  },
  {
    label: '10113000',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΑΤΕΨΥΓΜΕΝΩΝ ΚΡΕΑΤΩΝ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ· ΑΛΛΩΝ ΚΡΕΑΤΩΝ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ',
  },
  {
    label: '10113100',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΒΟΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΚΑΤΕΨΥΓΜΕΝΟ',
  },
  {
    label: '10113200',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΧΟΙΡΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΚΑΤΕΨΥΓΜΕΝΟ',
  },
  {
    label: '10113300',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΠΡΟΒΑΤΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΚΑΤΕΨΥΓΜΕΝΟ',
  },
  {
    label: '10113400',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΑΙΓΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΚΑΤΕΨΥΓΜΕΝΟ',
  },
  {
    label: '10113500',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΑΛΟΓΩΝ ΚΑΙ ΑΛΛΩΝ ΙΠΠΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΚΑΤΕΨΥΓΜΕΝΟ',
  },
  {
    label: '10113900',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΑΛΛΩΝ ΚΡΕΑΤΩΝ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ, ΔΙΑΤΗΡΗΜΕΝΑ ΜΕ ΑΠΛΗ ΨΥΞΗ Η ΚΑΤΕΨΥΓΜΕΝΑ',
  },
  {
    label: '10114000',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΜΑΛΛΙΟΥ, ΠΟΥ ΕΧΕΙ ΑΦΑΙΡΕΘΕΙ ΑΠΟ ΤΗΝ ΠΡΟΒΙΑ ΝΕΚΡΩΝ ΖΩΩΝ ΚΑΙ ΑΚΑΤΕΡΓΑΣΤΩΝ ΔΕΡΜΑΤΩΝ ΚΑΙ ΠΡΟΒΙΩΝ ΒΟΟΕΙΔΩΝ, ΙΠΠΟΕΙΔΩΝ, ΑΙΓΟΕΙΔΩΝ ΚΑΙ ΠΡΟΒΑΤΟΕΙΔΩΝ',
  },
  {
    label: '10114100',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΜΑΛΛΙΟΥ, ΠΟΥ ΕΧΕΙ ΑΦΑΙΡΕΘΕΙ ΑΠΟ ΤΗΝ ΠΡΟΒΙΑ ΝΕΚΡΩΝ ΖΩΩΝ, ΜΗ ΚΑΘΑΡΙΣΜΕΝΟΥ ΑΠΟ ΤΙΣ ΛΙΠΑΡΕΣ ΟΥΣΙΕΣ, ΚΑΘΩΣ ΚΑΙ ΜΑΛΛΙΟΥ ΠΟΥ ΕΧΕΙ ΠΛΥΘΕΙ ΠΑΝΩ ΣΤΗΝ ΠΡΟΒΙΑ',
  },
  {
    label: '10114200',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΑΚΑΤΕΡΓΑΣΤΩΝ ΔΕΡΜΑΤΩΝ ΚΑΙ ΠΡΟΒΙΩΝ ΒΟΟΕΙΔΩΝ Η ΙΠΠΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΟΛΟΚΛΗΡΑ',
  },
  {
    label: '10114300',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΑΛΛΩΝ ΑΚΑΤΕΡΓΑΣΤΩΝ ΔΕΡΜΑΤΩΝ ΚΑΙ ΠΡΟΒΙΩΝ ΒΟΟΕΙΔΩΝ Η ΙΠΠΟΕΙΔΩΝ',
  },
  {
    label: '10114400',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΑΚΑΤΕΡΓΑΣΤΩΝ ΔΕΡΜΑΤΩΝ ΚΑΙ ΠΡΟΒΙΩΝ ΠΡΟΒΑΤΩΝ Η ΑΡΝΙΩΝ',
  },
  {
    label: '10114500',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΑΚΑΤΕΡΓΑΣΤΩΝ ΔΕΡΜΑΤΩΝ ΚΑΙ ΠΡΟΒΙΩΝ ΑΙΓΩΝ Η ΚΑΤΣΙΚΙΩΝ',
  },
  {
    label: '10115000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΛΙΠΩΝ ΒΟΟΕΙΔΩΝ, ΠΡΟΒΑΤΩΝ, ΑΙΓΩΝ Η ΧΟΙΡΩΝ',
  },
  {
    label: '10116000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΩΜΩΝ ΕΝΤΟΣΘΙΩΝ, ΜΗ ΒΡΩΣΙΜΩΝ',
  },
  {
    label: '10119000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΠΕΞΕΡΓΑΣΜΕΝΟΥ ΚΑΙ ΔΙΑΤΗΡΗΜΕΝΟΥ ΚΡΕΑΤΟΣ',
  },
  {
    label: '10119901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΦΑΓΗΣ ΖΩΩΝ, ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ',
  },
  {
    label: '10120000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '10121000',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΠΟΥΛΕΡΙΚΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΝΩΠΟ Η ΔΙΑΤΗΡΗΜΕΝΟ ΜΕ ΑΠΛΗ ΨΥΞΗ',
  },
  {
    label: '10122000',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΡΕΑΤΟΣ ΠΟΥΛΕΡΙΚΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΚΑΤΕΨΥΓΜΕΝΟ',
  },
  {
    label: '10123000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΛΙΠΩΝ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '10124000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '10125000',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΦΤΕΡΩΝ ΚΑΙ ΠΟΥΠΟΥΛΩΝ ΚΑΙ ΔΕΡΜΑΤΩΝ ΠΟΥΛΙΩΝ ΜΕ ΦΤΕΡΑ ΚΑΙ ΠΟΥΠΟΥΛΑ',
  },
  {
    label: '10129000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΠΕΞΕΡΓΑΣΜΕΝΟΥ ΚΑΙ ΔΙΑΤΗΡΗΜΕΝΟΥ ΚΡΕΑΤΟΣ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '10130000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ ΚΑΙ ΚΡΕΑΤΟΣ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '10131000',
    value:
      'ΠΑΡΑΓΩΓΗ ΔΙΑΤΗΡΗΜΕΝΩΝ ΤΡΟΦΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΡΕΑΤΟΣ, ΕΝΤΟΣΘΙΩΝ Η ΑΙΜΑΤΟΣ',
  },
  {
    label: '10131100',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΟΙΡΙΝΟΥ ΚΡΕΑΤΟΣ, ΣΕ ΤΕΜΑΧΙΑ, ΑΛΑΤΙΣΜΕΝΑ, ΑΠΟΞΗΡΑΜΕΝΑ Η ΚΑΠΝΙΣΤΑ (ΜΠΕΙΚΟΝ ΚΑΙ ΖΑΜΠΟΝ)',
  },
  {
    label: '10131200',
    value:
      'ΠΑΡΑΓΩΓΗ ΒΟΔΙΝΟΥ ΚΡΕΑΤΟΣ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΛΑΤΙΣΜΕΝΟ, ΑΠΟΞΗΡΑΜΕΝΟ Η ΚΑΠΝΙΣΤΟ',
  },
  {
    label: '10131300',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΚΡΕΑΤΩΝ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΛΑΤΙΣΜΕΝΑ, ΣΕ ΑΛΜΗ, ΑΠΟΞΗΡΑΜΕΝΑ Η ΚΑΠΝΙΣΤΑ (ΕΚΤΟΣ ΑΠΟ ΤΟ ΧΟΙΡΙΝΟ ΚΑΙ ΤΟ ΒΟΔΙΝΟ ΚΡΕΑΣ)· ΠΑΡΑΓΩΓΗ ΒΡΩΣΙΜΩΝ ΑΛΕΥΡΙΩΝ ΚΑΙ ΣΚΟΝΩΝ ΓΕΥΜΑΤΩΝ ΚΡΕΑΤΟΣ Η ΕΝΤΟΣΘΙΩΝ',
  },
  {
    label: '10131400',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΟΥΚΑΝΙΚΩΝ, ΣΑΛΑΜΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ, ΑΠΟ ΚΡΕΑΣ, ΕΝΤΟΣΘΙΑ Η ΑΙΜΑ',
  },
  {
    label: '10131401',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΑΝΤΙΚΩΝ',
  },
  {
    label: '10131402',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΚΟΝΣΕΡΒΩΝ ΑΠΟ ΚΡΕΑΣ ΑΛΛΩΝ ΖΩΩΝ',
  },
  {
    label: '10131403',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΚΟΝΣΕΡΒΩΝ ΑΠΟ ΚΡΕΑΣ ΒΟΟΕΙΔΩΝ',
  },
  {
    label: '10131404',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΚΟΝΣΕΡΒΩΝ ΑΠΟ ΚΡΕΑΣ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '10131405',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΚΟΝΣΕΡΒΩΝ ΑΠΟ ΚΡΕΑΣ ΧΟΙΡΟΕΙΔΩΝ',
  },
  {
    label: '10131500',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΕΙΔΩΝ ΠΡΟΠΑΡΑΣΚΕΥΑΣΜΕΝΟΥ ΚΑΙ ΔΙΑΤΗΡΗΜΕΝΟΥ ΚΡΕΑΤΟΣ, ΕΝΤΟΣΘΙΩΝ Η ΑΙΜΑΤΟΣ ΕΚΤΟΣ ΑΠΟ ΕΤΟΙΜΑ ΓΕΥΜΑΤΑ ΜΕ ΚΡΕΑΣ ΚΑΙ ΕΝΤΟΣΘΙΑ',
  },
  {
    label: '10131600',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΕΥΡΙΩΝ, ΧΟΝΔΡΑΛΕΥΡΩΝ ΚΑΙ ΣΒΟΛΩΝ ΚΡΕΑΤΟΣ, ΑΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΑΝΘΡΩΠΙΝΗ ΚΑΤΑΝΑΛΩΣΗ· ΙΝΩΔΩΝ ΚΑΤΑΛΟΙΠΩΝ ΞΙΓΚΙΩΝ',
  },
  {
    label: '10139000',
    value:
      'ΜΑΓΕΙΡΕΜΑ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΣΚΕΥΗΣ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '10139100',
    value:
      'ΜΑΓΕΙΡΕΜΑ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΣΚΕΥΗΣ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ',
  },
  {
    label: '10139101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΤΗΡΗΣΗΣ ΚΡΕΑΤΟΣ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ',
  },
  {
    label: '10139102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΨΥΞΗΣ ΚΡΕΑΤΟΣ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ',
  },
  {
    label: '10139900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ ΚΑΙ ΚΡΕΑΤΟΣ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '10200000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΨΑΡΙΩΝ, ΚΑΡΚΙΝΟΕΙΔΩΝ ΚΑΙ ΜΑΛΑΚΙΩΝ',
  },
  {
    label: '10201000',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΨΑΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ, ΔΙΑΤΗΡΗΜΕΝΑ ΜΕ ΑΠΛΗ ΨΥΞΗ Η ΚΑΤΕΨΥΓΜΕΝΑ',
  },
  {
    label: '10201100',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΦΙΛΕΤΩΝ ΚΑΙ ΑΛΛΟΥ ΚΡΕΑΤΟΣ ΨΑΡΙΩΝ (ΤΕΜΑΧΙΣΜΕΝΩΝ Η ΜΗ), ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ Η ΔΙΑΤΗΡΗΜΕΝΑ ΜΕ ΑΠΛΗ ΨΥΞΗ',
  },
  {
    label: '10201200',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΣΥΚΩΤΙΩΝ ΨΑΡΙΩΝ ΚΑΙ ΑΒΓΟΤΑΡΑΧΟΥ ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ, ΝΩΠΑ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '10201300',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΨΑΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΑΤΕΨΥΓΜΕΝΑ',
  },
  {
    label: '10201400',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΦΙΛΕΤΩΝ ΨΑΡΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΑΤΕΨΥΓΜΕΝΑ',
  },
  {
    label: '10201500',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΣΑΡΚΑΣ ΨΑΡΙΟΥ, (ΕΣΤΩ ΚΑΙ ΤΕΜΑΧΙΣΜΕΝΗΣ), ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ',
  },
  {
    label: '10201600',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΣΥΚΩΤΙΩΝ ΨΑΡΙΩΝ ΚΑΙ ΑΒΓΟΤΑΡΑΧΟΥ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΑΤΕΨΥΓΜΕΝΑ',
  },
  {
    label: '10202000',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΨΑΡΙΩΝ ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ· ΠΑΡΑΓΩΓΗ ΧΑΒΙΑΡΙΟΥ ΚΑΙ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΑΥΤΟΥ',
  },
  {
    label: '10202100',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΦΙΛΕΤΩΝ ΨΑΡΙΩΝ ΑΠΟΞΗΡΑΜΕΝΩΝ, ΑΛΑΤΙΣΜΕΝΩΝ Η ΣΕ ΑΛΜΗ ΑΛΛΑ ΟΧΙ ΚΑΠΝΙΣΤΩΝ',
  },
  {
    label: '10202200',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΣΥΚΩΤΙΩΝ ΨΑΡΙΩΝ ΚΑΙ ΑΒΓΟΤΑΡΑΧΟΥ, ΑΠΟΞΗΡΑΜΕΝΩΝ, ΚΑΠΝΙΣΤΩΝ, ΑΛΑΤΙΣΜΕΝΩΝ Η ΣΕ ΑΛΜΗ, ΠΑΡΑΓΩΓΗ ΑΛΕΥΡΙΩΝ, ΣΚΟΝΩΝ ΚΑΙ ΣΥΣΣΩΜΑΤΩΜΑΤΩΝ ΜΕ ΜΟΡΦΗ ΣΒΟΛΩΝ (ΠΕΛΕΤΩΝ) ΨΑΡΙΩΝ, ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΑΝΘΡΩΠΙΝΗ ΚΑΤΑΝΑΛΩΣΗ',
  },
  {
    label: '10202300',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΨΑΡΙΩΝ, ΑΠΟΞΗΡΑΜΕΝΩΝ, ΑΛΑΤΙΣΜΕΝΩΝ Η ΜΗ, Η ΣΕ ΑΛΜΗ',
  },
  {
    label: '10202301',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΨΑΡΙΩΝ ΑΛΙΠΑΣΤΩΝ',
  },
  {
    label: '10202400',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΨΑΡΙΩΝ ΚΑΙ ΦΙΛΕΤΩΝ ΨΑΡΙΩΝ, ΚΑΠΝΙΣΤΩΝ',
  },
  {
    label: '10202500',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΨΑΡΙΩΝ, ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΕΤΟΙΜΑ ΓΕΥΜΑΤΑ ΜΕ ΒΑΣΗ ΤΟ ΨΑΡΙ',
  },
  {
    label: '10202501',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΚΟΝΣΕΡΒΩΝ ΨΑΡΙΩΝ',
  },
  {
    label: '10202600',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΧΑΒΙΑΡΙΟΥ ΚΑΙ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΑΥΤΟΥ',
  },
  {
    label: '10203000',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΑΡΚΙΝΟΕΙΔΩΝ, ΜΑΛΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΑΤΕΨΥΓΜΕΝΑ, ΠΑΡΑΣΚΕΥΑΣΜΕΝΑ Η ΔΙΑΤΗΡΗΜΕΝΑ',
  },
  {
    label: '10203100',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΑΡΚΙΝΟΕΙΔΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΑΤΕΨΥΓΜΕΝΑ',
  },
  {
    label: '10203200',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΜΑΛΑΚΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΑΤΕΨΥΓΜΕΝΑ, ΑΠΟΞΗΡΑΜΕΝΑ, ΚΑΠΝΙΣΤΑ, ΑΛΑΤΙΣΜΕΝΑ Η ΣΕ ΑΛΜΗ, ΚΑΠΝΙΣΤΑ',
  },
  {
    label: '10203300',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΑΤΕΨΥΓΜΕΝΑ, ΑΠΟΞΗΡΑΜΕΝΑ, ΑΛΑΤΙΣΜΕΝΑ Η ΣΕ ΑΛΜΗ, ΚΑΠΝΙΣΤΑ',
  },
  {
    label: '10203400',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΚΑΡΚΙΝΟΕΙΔΩΝ ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ· ΜΑΛΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ',
  },
  {
    label: '10204000',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΑΛΕΥΡΙΩΝ, ΣΚΟΝΩΝ ΚΑΙ ΣΒΟΛΩΝ (ΠΕΛΕΤΩΝ), ΚΑΙ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α. ΑΠΟ ΨΑΡΙΑ Η ΚΑΡΚΙΝΟΕΙΔΗ, ΜΑΛΑΚΙΑ Η ΑΛΛΑ ΑΣΠΟΝΔΥΛΑ ΥΔΡΟΒΙΑ, ΑΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΑΝΘΡΩΠΙΝΗ ΚΑΤΑΝΑΛΩΣΗ',
  },
  {
    label: '10204100',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΕΥΡΙΩΝ, ΣΚΟΝΩΝ ΚΑΙ ΣΒΟΛΩΝ (ΠΕΛΕΤΩΝ), ΑΠΟ ΨΑΡΙΑ Η ΚΑΡΚΙΝΟΕΙΔΗ, ΜΑΛΑΚΙΑ Η ΑΛΛΑ ΑΣΠΟΝΔΥΛΑ ΥΔΡΟΒΙΑ, ΑΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΑΝΘΡΩΠΙΝΗ ΚΑΤΑΝΑΛΩΣΗ',
  },
  {
    label: '10204200',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΑΛΛΩΝ ΜΗ ΒΡΩΣΙΜΩΝ ΠΡΟΪΟΝΤΩΝ ΨΑΡΙΩΝ, ΚΑΡΚΙΝΟΕΙΔΩΝ, ΜΑΛΑΚΙΩΝ Η ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ',
  },
  {
    label: '10209000',
    value:
      'ΚΑΠΝΙΣΜΑ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΤΗΡΗΣΗΣ ΚΑΙ ΠΑΡΑΣΚΕΥΗΣ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΠΡΟΪΟΝΤΩΝ ΨΑΡΙΩΝ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΔΙΑΤΗΡΗΜΕΝΩΝ ΨΑΡΙΩΝ, ΚΑΡΚΙΝΟΕΙΔΩΝ ΚΑΙ ΜΑΛΑΚΙΩΝ',
  },
  {
    label: '10209100',
    value:
      'ΚΑΠΝΙΣΜΑ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΤΗΡΗΣΗΣ ΚΑΙ ΠΑΡΑΣΚΕΥΗΣ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΠΡΟΪΟΝΤΩΝ ΨΑΡΙΩΝ',
  },
  {
    label: '10209900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΔΙΑΤΗΡΗΜΕΝΩΝ ΨΑΡΙΩΝ, ΚΑΡΚΙΝΟΕΙΔΩΝ ΚΑΙ ΜΑΛΑΚΙΩΝ',
  },
  {
    label: '10310000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΠΑΤΑΤΩΝ',
  },
  {
    label: '10311000',
    value: 'ΠΑΡΑΓΩΓΗ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΣΥΝΤΗΡΗΜΕΝΩΝ ΠΑΤΑΤΩΝ',
  },
  {
    label: '10311100',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΣΥΝΤΗΡΗΜΕΝΩΝ ΠΑΤΑΤΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΑΤΕΨΥΓΜΕΝΕΣ',
  },
  {
    label: '10311200',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΠΟΞΗΡΑΜΕΝΩΝ ΠΑΤΑΤΩΝ, ΚΟΜΜΕΝΩΝ Η ΜΗ, ΣΕ ΤΕΜΑΧΙΑ Η ΦΕΤΕΣ, ΑΛΛΑ ΟΧΙ ΠΕΡΑΙΤΕΡΩ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ',
  },
  {
    label: '10311201',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΠΟΦΛΟΙΩΜΕΝΩΝ ΚΑΙ ΤΕΜΑΧΙΣΜΕΝΩΝ ΠΑΤΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '10311202',
    value:
      'ΠΑΡΑΓΩΓΗ ΤΗΓΑΝΗΤΩΝ ΠΑΤΑΤΩΝ ΣΕ ΛΕΠΤΕΣ ΦΕΤΕΣ (ΤΣΙΠΣ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '10311203',
    value: 'ΠΑΡΑΓΩΓΗ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΤΡΟΦΩΝ ΑΠΟ ΠΑΤΑΤΕΣ',
  },
  {
    label: '10311300',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΠΟΞΗΡΑΜΕΝΩΝ ΠΑΤΑΤΩΝ, ΜΕ ΤΗ ΜΟΡΦΗ ΑΛΕΥΡΙΩΝ, ΧΟΝΔΡΑΛΕΥΡΩΝ, ΝΙΦΑΔΩΝ, ΚΟΚΚΩΝ ΚΑΙ ΣΒΟΛΩΝ',
  },
  {
    label: '10311400',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΤΑΤΩΝ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ',
  },
  {
    label: '10319000',
    value:
      'ΜΑΓΕΙΡΕΜΑ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΣΚΕΥΗΣ ΓΙΑ ΠΑΤΑΤΕΣ ΚΑΙ ΠΡΟΪΟΝΤΑ ΠΑΤΑΤΑΣ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΚΑΙ ΔΙΑΤΗΡΗΜΕΝΩΝ ΠΑΤΑΤΩΝ',
  },
  {
    label: '10319100',
    value:
      'ΜΑΓΕΙΡΕΜΑ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΣΚΕΥΗΣ ΓΙΑ ΠΑΤΑΤΕΣ ΚΑΙ ΠΡΟΪΟΝΤΑ ΠΑΤΑΤΑΣ',
  },
  {
    label: '10319900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΔΙΑΤΗΡΗΜΕΝΩΝ ΠΑΤΑΤΩΝ',
  },
  {
    label: '10320000',
    value: 'ΠΑΡΑΓΩΓΗ ΧΥΜΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '10321100',
    value: 'ΠΑΡΑΓΩΓΗ ΧΥΜΟΥ ΝΤΟΜΑΤΑΣ',
  },
  {
    label: '10321200',
    value: 'ΠΑΡΑΓΩΓΗ ΧΥΜΟΥ ΠΟΡΤΟΚΑΛΙΟΥ',
  },
  {
    label: '10321300',
    value: 'ΠΑΡΑΓΩΓΗ ΧΥΜΟΥ ΓΚΡΕΙΠΦΡΟΥΤ',
  },
  {
    label: '10321400',
    value: 'ΠΑΡΑΓΩΓΗ ΧΥΜΟΥ ΑΝΑΝΑ',
  },
  {
    label: '10321500',
    value: 'ΠΑΡΑΓΩΓΗ ΧΥΜΟΥ ΣΤΑΦΥΛΙΩΝ',
  },
  {
    label: '10321600',
    value: 'ΠΑΡΑΓΩΓΗ ΧΥΜΟΥ ΜΗΛΩΝ',
  },
  {
    label: '10321700',
    value: 'ΠΑΡΑΓΩΓΗ ΜΕΙΓΜΑΤΩΝ ΧΥΜΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '10321900',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΧΥΜΩΝ ΛΑΧΑΝΙΚΩΝ ΚΑΙ ΦΡΟΥΤΩΝ',
  },
  {
    label: '10329000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΧΥΜΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '10390000',
    value: 'ΑΛΛΗ ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '10391000',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΣΥΝΤΗΡΗΜΕΝΩΝ ΛΑΧΑΝΙΚΩΝ, ΕΚΤΟΣ ΑΠΟ ΠΑΤΑΤΕΣ',
  },
  {
    label: '10391100',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΣΥΝΤΗΡΗΜΕΝΩΝ ΛΑΧΑΝΙΚΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΑΤΕΨΥΓΜΕΝΑ',
  },
  {
    label: '10391200',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΟΣΩΡΙΝΑ ΣΥΝΤΗΡΗΜΕΝΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '10391300',
    value: 'ΠΑΡΑΓΩΓΗ ΑΠΟΞΗΡΑΜΕΝΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '10391400',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΣΥΝΤΗΡΗΜΕΝΩΝ ΛΑΧΑΝΙΚΩΝ ΚΑΙ ΦΡΟΥΤΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΟΜΜΕΝΑ ΚΑΙ ΣΥΣΚΕΥΑΣΜΕΝΑ',
  },
  {
    label: '10391500',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΦΑΣΟΛΙΩΝ, ΣΥΝΤΗΡΗΜΕΝΩΝ ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΕΚΤΟΣ ΑΠΟ ΞΙΔΙ Η ΟΞΙΚΟ ΟΞΥ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΑ ΕΤΟΙΜΑ ΦΑΓΗΤΑ ΜΕ ΛΑΧΑΝΙΚΑ',
  },
  {
    label: '10391600',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΜΠΙΖΕΛΙΩΝ, ΣΥΝΤΗΡΗΜΕΝΩΝ ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΕΚΤΟΣ ΑΠΟ ΞΙΔΙ Η ΟΞΙΚΟ ΟΞΥ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΑ ΕΤΟΙΜΑ ΦΑΓΗΤΑ ΜΕ ΛΑΧΑΝΙΚΑ',
  },
  {
    label: '10391700',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΑΛΛΩΝ ΛΑΧΑΝΙΚΩΝ (ΕΚΤΟΣ ΑΠΟ ΠΑΤΑΤΕΣ), ΣΥΝΤΗΡΗΜΕΝΩΝ ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΕΚΤΟΣ ΑΠΟ ΞΙΔΙ Η ΟΞΙΚΟ ΟΞΥ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΑ ΕΤΟΙΜΑ ΦΑΓΗΤΑ ΜΕ ΛΑΧΑΝΙΚΑ',
  },
  {
    label: '10391701',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΤΟΜΑΤΟΠΟΛΤΟΥ ΚΑΙ ΠΟΥΡΕ ΑΠΟ ΝΤΟΜΑΤΕΣ',
  },
  {
    label: '10391702',
    value: 'ΠΑΡΑΓΩΓΗ ΚΟΝΣΕΡΒΩΝ ΜΕ ΛΑΧΑΝΙΚΑ',
  },
  {
    label: '10391703',
    value: 'ΠΑΣΤΕΡΙΩΣΗ ΚΑΙ ΤΥΠΟΠΟΙΗΣΗ ΑΜΠΕΛΟΦΥΛΛΩΝ',
  },
  {
    label: '10391800',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΛΑΧΑΝΙΚΩΝ, (ΕΚΤΟΣ ΑΠΟ ΠΑΤΑΤΕΣ), ΦΡΟΥΤΩΝ, ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ ΚΑΙ ΑΛΛΩΝ ΒΡΩΣΙΜΩΝ ΜΕΡΩΝ ΦΥΤΩΝ, ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ Η ΣΥΝΤΗΡΗΜΕΝΩΝ ΣΕ ΞΙΔΙ Η ΟΞΙΚΟ ΟΞΥ',
  },
  {
    label: '10392000',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΣΥΝΤΗΡΗΜΕΝΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ',
  },
  {
    label: '10392100',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΣΥΝΤΗΡΗΜΕΝΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ, ΨΗΜΕΝΩΝ Η ΑΨΗΤΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΑΤΕΨΥΓΜΕΝΑ',
  },
  {
    label: '10392200',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΑΡΜΕΛΑΔΩΝ, ΖΕΛΕΔΩΝ ΚΑΙ ΠΟΥΡΕ ΚΑΙ ΠΟΛΤΩΝ ΦΡΟΥΤΩΝ Η ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ',
  },
  {
    label: '10392201',
    value: 'ΠΑΡΑΓΩΓΗ ΚΟΜΠΟΣΤΑΣ ΦΡΟΥΤΩΝ',
  },
  {
    label: '10392202',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΑΡΜΕΛΑΔΑΣ, ΚΟΜΠΟΣΤΑΣ, ΓΛΥΚΩΝ ΚΟΥΤΑΛΙΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΦΡΟΥΤΑ ΚΑΙ ΑΛΛΟΥΣ ΚΑΡΠΟΥΣ',
  },
  {
    label: '10392300',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΣΥΝΤΗΡΗΜΕΝΩΝ ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ, ΑΡΑΠΙΚΩΝ ΦΙΣΤΙΚΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΑΒΟΥΡΔΙΣΜΕΝΑ, ΑΛΑΤΙΣΜΕΝΑ Η ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΑ',
  },
  {
    label: '10392301',
    value: 'ΠΑΡΑΓΩΓΗ ΣΤΡΑΓΑΛΙΩΝ ΚΑΙ ΕΠΕΞΕΡΓΑΣΙΑ ΑΛΛΩΝ ΞΗΡΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '10392302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΡΑΥΣΗΣ Η ΞΕΦΛΟΥΔΙΣΜΑΤΟΣ ΞΗΡΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '10392400',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΡΟΣΩΡΙΝΑ ΣΥΝΤΗΡΗΜΕΝΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ, ΟΧΙ ΓΙΑ ΑΜΕΣΗ ΚΑΤΑΝΑΛΩΣΗ',
  },
  {
    label: '10392401',
    value: 'ΠΑΡΑΓΩΓΗ ΑΠΟΞΗΡΑΜΕΝΗΣ ΣΤΑΦΙΔΑΣ',
  },
  {
    label: '10392402',
    value: 'ΠΑΡΑΓΩΓΗ ΑΠΟΞΗΡΑΜΕΝΩΝ ΔΑΜΑΣΚΗΝΩΝ',
  },
  {
    label: '10392403',
    value: 'ΠΑΡΑΓΩΓΗ ΑΠΟΞΗΡΑΜΕΝΩΝ ΣΥΚΩΝ',
  },
  {
    label: '10392500',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ Η ΣΥΝΤΗΡΗΜΕΝΩΝ ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ',
  },
  {
    label: '10393000',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΥΤΙΚΩΝ ΥΛΩΝ ΚΑΙ ΦΥΤΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, ΦΥΤΙΚΩΝ ΥΠΟΛΕΙΜΜΑΤΩΝ ΚΑΙ ΥΠΟΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '10399000',
    value:
      'ΜΑΓΕΙΡΕΜΑ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΣΚΕΥΗΣ ΓΙΑ ΤΗ ΔΙΑΤΗΡΗΣΗ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΚΑΙ ΣΥΝΤΗΡΗΜΕΝΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '10399100',
    value:
      'ΜΑΓΕΙΡΕΜΑ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΣΚΕΥΗΣ ΓΙΑ ΤΗ ΔΙΑΤΗΡΗΣΗ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '10399101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΜΠΥΚΝΩΣΗΣ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '10399900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΚΑΙ ΣΥΝΤΗΡΗΜΕΝΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '10410000',
    value: 'ΠΑΡΑΓΩΓΗ ΕΛΑΙΩΝ ΚΑΙ ΛΙΠΩΝ',
  },
  {
    label: '10411000',
    value:
      'ΠΑΡΑΓΩΓΗ ΖΩΙΚΩΝ ΕΛΑΙΩΝ ΚΑΙ ΛΙΠΩΝ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥΣ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΑ',
  },
  {
    label: '10411100',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΤΕΑΤΙΝΗΣ, ΛΑΔΙΟΥ ΜΕ ΤΗΝ ΟΝΟΜΑΣΙΑ \\AINDOUX\\ (ΑΠΟ ΧΟΙΡΙΝΟ ΛΙΠΟΣ), ΕΛΑΙΟΣΤΕΑΤΙΝΗΣ, ΕΛΑΙΟΜΑΡΓΑΡΙΝΗΣ ΚΑΙ ΣΤΕΑΤΕΛΑΙΟΥ, ΠΟΥ ΔΕΝ ΕΧΟΥΝ ΓΑΛΑΚΤΩΜΑΤΟΠΟΙΗΘΕΙ ΟΥΤΕ ΑΝΑΜΕΙΧΘΕΙ ΟΥΤΕ ΠΑΡΑΣΚΕΥΑΣΘΕΙ ΑΛΛΙΩΣ',
  },
  {
    label: '10411200',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΙΠΩΝ ΚΑΙ ΕΛΑΙΩΝ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤOΥΣ, ΨΑΡΙΩΝ ΚΑΙ ΘΑΛΑΣΣΙΩΝ ΘΗΛΑΣΤΙΚΩΝ',
  },
  {
    label: '10411900',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΖΩΙΚΩΝ ΛΙΠΩΝ ΚΑΙ ΕΛΑΙΩΝ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤOΥΣ, ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ Η ΜΗ, ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑ ΜΕΤΑΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '10412000',
    value: 'ΠΑΡΑΓΩΓΗ ΦΥΤΙΚΩΝ ΕΛΑΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΑ',
  },
  {
    label: '10412100',
    value: 'ΠΑΡΑΓΩΓΗ ΣΟΓΙΕΛΑΙΟΥ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΚΑΤΕΡΓΑΣΤΟ',
  },
  {
    label: '10412101',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΩΝ ΦΥΤΙΚΩΝ ΕΛΑΙΩΝ, ΠΟΥ ΔΕΝ ΚΑΤΟΝΟΜΑΖΟΝΤΑΙ ΕΙΔΙΚΑ',
  },
  {
    label: '10412200',
    value: 'ΠΑΡΑΓΩΓΗ ΑΡΑΧΙΔΕΛΑΙΟΥ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΚΑΤΕΡΓΑΣΤΟ',
  },
  {
    label: '10412300',
    value: 'ΠΑΡΑΓΩΓΗ ΕΛΑΙΟΛΑΔΟΥ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΚΑΤΕΡΓΑΣΤΟ',
  },
  {
    label: '10412301',
    value: 'ΠΑΡΑΓΩΓΗ ΠΥΡΗΝΕΛΑΙΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ',
  },
  {
    label: '10412302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΘΛΙΨΗΣ ΕΛΑΙΟΚΑΡΠΟΥ ΚΑΙ ΑΛΛΩΝ ΕΛΑΙΟΥΧΩΝ ΣΠΟΡΩΝ',
  },
  {
    label: '10412400',
    value: 'ΠΑΡΑΓΩΓΗ ΗΛΙΕΛΑΙΟΥ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΚΑΤΕΡΓΑΣΤΟ',
  },
  {
    label: '10412500',
    value: 'ΠΑΡΑΓΩΓΗ ΒΑΜΒΑΚΕΛΑΙΟΥ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΚΑΤΕΡΓΑΣΤΟ',
  },
  {
    label: '10412600',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΡΑΜΒΕΛΑΙΟΥ, ΡΑΦΑΝΕΛΑΙΟΥ ΚΑΙ ΣΙΝΑΠΕΛΑΙΟΥ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΑ',
  },
  {
    label: '10412700',
    value: 'ΠΑΡΑΓΩΓΗ ΦΟΙΝΙΚΕΛΑΙΟΥ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΚΑΤΕΡΓΑΣΤΟ',
  },
  {
    label: '10412800',
    value: 'ΠΑΡΑΓΩΓΗ ΕΛΑΙΟΥ ΙΝΔΙΚΗΣ ΚΑΡΥΔΑΣ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΚΑΤΕΡΓΑΣΤΟ',
  },
  {
    label: '10412900',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΦΥΤΙΚΩΝ ΕΛΑΙΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΚΑΤΕΡΓΑΣΤΑ',
  },
  {
    label: '10413000',
    value: 'ΠΑΡΑΓΩΓΗ ΧΟΝΔΡΑΔΙΩΝ ΒΑΜΒΑΚΙΟΥ (LINTER)',
  },
  {
    label: '10414000',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΛΑΙΟΠΙΤΩΝ ΚΑΙ ΑΛΛΩΝ ΣΤΕΡΕΩΝ ΚΑΤΑΛΟΙΠΩΝ ΦΥΤΙΚΩΝ ΛΙΠΩΝ Η ΕΛΑΙΩΝ· ΑΛΕΥΡΙΩΝ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΩΝ ΑΠΟ ΕΛΑΙΟΥΧΟΥΣ ΣΠΟΡΟΥΣ Η ΚΑΡΠΟΥΣ',
  },
  {
    label: '10414100',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΛΑΙΟΠΙΤΩΝ ΚΑΙ ΑΛΛΩΝ ΣΤΕΡΕΩΝ ΚΑΤΑΛΟΙΠΩΝ ΦΥΤΙΚΩΝ ΛΙΠΩΝ Η ΕΛΑΙΩΝ',
  },
  {
    label: '10414101',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΙ ΚΑΤΕΡΓΑΣΙΑ ΕΛΑΙΟΠΥΡΗΝΑ',
  },
  {
    label: '10414200',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΕΥΡΙΩΝ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΩΝ ΑΠΟ ΕΛΑΙΟΥΧΟΥΣ ΣΠΟΡΟΥΣ Η ΚΑΡΠΟΥΣ, ΕΚΤΟΣ ΤΟΥ ΣΙΝΑΠΙΟΥ',
  },
  {
    label: '10415000',
    value: 'ΠΑΡΑΓΩΓΗ ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ ΕΛΑΙΩΝ, ΕΚΤΟΣ ΤΩΝ ΚΑΤΑΛΟΙΠΩΝ',
  },
  {
    label: '10415100',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΟΓΙΕΛΑΙΟΥ, ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥ, ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑ ΜΕΤΑΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '10415101',
    value: 'ΕΞΕΥΓΕΝΙΣΜΟΣ ΚΑΙ ΥΔΡΟΓΟΝΩΣΗ ΦΥΤΙΚΩΝ ΕΛΑΙΩΝ',
  },
  {
    label: '10415200',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΡΑΧΙΔΕΛΑΙΟΥ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥ, ΕΣΤΩ ΚΑΙ ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑ ΜΕΤΑΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '10415300',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΛΑΙΟΛΑΔΟΥ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥ, ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑ ΜΕΤΑΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '10415301',
    value: 'ΠΑΡΑΓΩΓΗ ΠΥΡΗΝΕΛΑΙΟΥ, ΕΞΕΥΓΕΝΙΣΜΕΝΟΥ',
  },
  {
    label: '10415400',
    value:
      'ΠΑΡΑΓΩΓΗ ΗΛΙΕΛΑΙΟΥ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥ, ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑ ΜΕΤΑΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '10415500',
    value:
      'ΠΑΡΑΓΩΓΗ ΒΑΜΒΑΚΕΛΑΙΟΥ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥ, ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑ ΜΕΤΑΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '10415600',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΡΑΜΒΕΛΑΙΟΥ, ΡΑΦΑΝΕΛΑΙΟΥ ΚΑΙ ΣΙΝΑΠΕΛΑΙΟΥ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥΣ, ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑ ΜΕΤΑΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '10415700',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΟΙΝΙΚΕΛΑΙΟΥ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥ, ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑ ΜΕΤΑΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '10415800',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΛΑΙΟΥ ΙΝΔΙΚΗΣ ΚΑΡΥΔΑΣ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥ, ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑΜΕΤΑΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '10415900',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΕΛΑΙΩΝ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥΣ, ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑ ΜΕΤΑΠΟΙΗΜΕΝΩΝ· ΣΤΑΘΕΡΟΠΟΙΗΜΕΝΩΝ ΦΥΤΙΚΩΝ ΛΙΠΩΝ ΚΑΙ ΑΛΛΩΝ ΦΥΤΙΚΩΝ ΕΛΑΙΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΟ ΚΑΛΑΜΠΟΚΕΛΑΙΟ) ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥΣ Π.Δ.Κ.Α., ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑ',
  },
  {
    label: '10415901',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ ΦΥΤΙΚΩΝ ΕΛΑΙΩΝ, ΠΟΥ ΔΕΝ ΚΑΤΟΝΟΜΑΖΟΝΤΑΙ ΕΙΔΙΚΑ',
  },
  {
    label: '10416000',
    value:
      'ΠΑΡΑΓΩΓΗ ΖΩΙΚΩΝ Η ΦΥΤΙΚΩΝ ΛΙΠΩΝ ΚΑΙ ΕΛΑΙΩΝ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥΣ, ΥΔΡΟΓΟΝΩΜΕΝΩΝ, ΕΣΤΕΡΟΠΟΙΗΜΕΝΩΝ, ΑΛΛΑ ΧΩΡΙΣ ΝΑ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΠΕΡΑΙΤΕΡΩ ΠΑΡΑΣΚΕΥΗ',
  },
  {
    label: '10417000',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΥΤΙΚΩΝ ΚΗΡΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΑ ΤΡΙΓΛΥΚΕΡΙΔΙΑ) ~ ΓΑΛΑΚΤΩΜΑΤΩΝ ΔΕΡΜΑΤΟΣ (ΔΕΡΜΑΤΕΛΑΙΩΝ)· ΚΑΤΑΛΟΙΠΩΝ ΤΗΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΛΙΠΑΡΩΝ ΟΥΣΙΩΝ Η ΖΩΙΚΩΝ Η ΦΥΤΙΚΩΝ ΚΗΡΩΝ',
  },
  {
    label: '10417100',
    value: 'ΠΑΡΑΓΩΓΗ ΦΥΤΙΚΩΝ ΚΗΡΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΑ ΤΡΙΓΛΥΚΕΡΙΔΙΑ)',
  },
  {
    label: '10417200',
    value:
      'ΠΑΡΑΓΩΓΗ ΓΑΛΑΚΤΩΜΑΤΩΝ ΔΕΡΜΑΤΟΣ (ΔΕΡΜΑΤΕΛΑΙΩΝ)· ΚΑΤΑΛΟΙΠΩΝ ΤΗΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΛΙΠΑΡΩΝ ΟΥΣΙΩΝ Η ΖΩΙΚΩΝ Η ΦΥΤΙΚΩΝ ΚΗΡΩΝ',
  },
  {
    label: '10419000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΛΑΙΩΝ ΚΑΙ ΛΙΠΩΝ',
  },
  {
    label: '10419901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΕΥΓΕΝΙΣΜΟΥ ΚΑΙ ΥΔΡΟΓΟΝΩΣΗΣ ΖΩΙΚΩΝ ΕΛΑΙΩΝ',
  },
  {
    label: '10419902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΑΙ ΤΥΠΟΠΟΙΗΣΗΣ ΕΛΑΙΟΛΑΔΟΥ',
  },
  {
    label: '10420000',
    value: 'ΠΑΡΑΓΩΓΗ ΜΑΡΓΑΡΙΝΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΒΡΩΣΙΜΩΝ ΛΙΠΩΝ',
  },
  {
    label: '10429000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΜΑΡΓΑΡΙΝΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΒΡΩΣΙΜΩΝ ΛΙΠΩΝ',
  },
  {
    label: '10510000',
    value: 'ΛΕΙΤΟΥΡΓΙΑ ΓΑΛΑΚΤΟΚΟΜΕΙΩΝ ΚΑΙ ΤΥΡΟΚΟΜΙΑ',
  },
  {
    label: '10511000',
    value: 'ΠΑΡΑΓΩΓΗ ΕΠΕΞΕΡΓΑΣΜΕΝΟΥ ΡΕΥΣΤΟΥ ΓΑΛΑΚΤΟΣ ΚΑΙ ΚΡΕΜΑΣ ΓΑΛΑΚΤΟΣ',
  },
  {
    label: '10511100',
    value: 'ΠΑΡΑΓΩΓΗ ΕΠΕΞΕΡΓΑΣΜΕΝΟΥ ΡΕΥΣΤΟΥ ΓΑΛΑΚΤΟΣ',
  },
  {
    label: '10511200',
    value:
      'ΠΑΡΑΓΩΓΗ ΓΑΛΑΚΤΟΣ ΚΑΙ ΚΡΕΜΑΣ ΓΑΛΑΚΤΟΣ ΜΕ ΠΕΡΙΣΣΟΤΕΡΟ ΑΠΟ 6 ;% ΛΙΠΟΣ, ΜΗ ΣΥΜΠΥΚΝΩΜΕΝΩΝ Η ΖΑΧΑΡΟΥΧΩΝ',
  },
  {
    label: '10512000',
    value: 'ΠΑΡΑΓΩΓΗ ΓΑΛΑΚΤΟΣ ΣΕ ΣΤΕΡΕΗ ΜΟΡΦΗ',
  },
  {
    label: '10512100',
    value: 'ΠΑΡΑΓΩΓΗ ΑΠΟΒΟΥΤΥΡΩΜΕΝΟΥ ΓΑΛΑΚΤΟΣ, ΣΕ ΣΚΟΝΗ',
  },
  {
    label: '10512200',
    value: 'ΠΑΡΑΓΩΓΗ ΠΛΗΡΟΥΣ ΓΑΛΑΚΤΟΣ ΣΕ ΣΚΟΝΗ',
  },
  {
    label: '10513000',
    value: 'ΠΑΡΑΓΩΓΗ ΒΟΥΤΥΡΟΥ ΚΑΙ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΓΙΑ ΕΠΑΛΕΙΨΗ',
  },
  {
    label: '10514000',
    value: 'ΠΑΡΑΓΩΓΗ ΤΥΡΙΟΥ ΚΑΙ ΤΥΡΟΠΗΓΜΑΤΟΣ (ΠΗΓΜΕΝΟΥ ΓΑΛΑΚΤΟΣ ΓΙΑ ΤΥΡΙ)',
  },
  {
    label: '10514001',
    value: 'ΠΑΡΑΓΩΓΗ ΤΥΡΙΟΥ ΑΠΟ ΣΚΟΝΗ ΓΑΛΑΚΤΟΣ',
  },
  {
    label: '10515000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '10515100',
    value:
      'ΠΑΡΑΓΩΓΗ ΓΑΛΑΚΤΟΣ ΚΑΙ ΚΡΕΜΑΣ ΓΑΛΑΚΤΟΣ, ΣΥΜΠΥΚΝΩΜΕΝΩΝ Η ΜΕ ΠΡΟΣΘΕΤΗ ΖΑΧΑΡΗ Η ΑΛΛΕΣ ΓΛΥΚΑΝΤΙΚΕΣ ΥΛΕΣ, ΣΕ ΑΛΛΕΣ ΜΟΡΦΕΣ ΕΚΤΟΣ ΤΗΣ ΣΤΕΡΕΑΣ',
  },
  {
    label: '10515200',
    value:
      'ΠΑΡΑΓΩΓΗ ΓΙΑΟΥΡΤΙΟΥ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΓΑΛΑΚΤΟΣ Η ΚΡΕΜΑΣ ΓΑΛΑΚΤΟΣ ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΖΥΜΩΣΗ Η ΟΞΙΝΙΣΗ',
  },
  {
    label: '10515300',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΖΕΪΝΗΣ',
  },
  {
    label: '10515400',
    value: 'ΠΑΡΑΓΩΓΗ ΓΑΛΑΚΤΟΖΗΣ ΚΑΙ ΣΙΡΟΠΙΟΥ ΓΑΛΑΚΤΟΖΗΣ',
  },
  {
    label: '10515500',
    value: 'ΠΑΡΑΓΩΓΗ ΤΥΡΟΓΑΛΟΥ',
  },
  {
    label: '10515600',
    value: 'ΠΑΡΑΓΩΓΗ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '10515601',
    value: 'ΠΑΡΑΓΩΓΗ ΡΥΖΟΓΑΛΟΥ',
  },
  {
    label: '10519000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΚΑΙ ΤΥΡΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '10520000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΓΩΤΩΝ',
  },
  {
    label: '10521000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΓΩΤΟΥ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΒΡΩΣΙΜΟΥ ΠΑΓΟΥ',
  },
  {
    label: '10529000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΠΑΓΩΤΩΝ',
  },
  {
    label: '10529900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΑΓΩΤΩΝ',
  },
  {
    label: '10610000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΟΪΟΝΤΩΝ ΑΛΕΥΡΟΜΥΛΩΝ',
  },
  {
    label: '10611000',
    value:
      'ΠΑΡΑΓΩΓΗ ΡΥΖΙΟΥ, ΠΛΗΡΟΥΣ Η ΜΕΡΙΚΗΣ ΑΛΕΣΕΩΣ Η ΑΠΟΦΛΟΙΩΜΕΝΟΥ Η ΣΕ ΘΡΑΥΣΜΑΤΑ',
  },
  {
    label: '10611100',
    value: 'ΠΑΡΑΓΩΓΗ ΑΠΟΦΛΟΙΩΜΕΝΟΥ ΡΥΖΙΟΥ',
  },
  {
    label: '10611200',
    value: 'ΠΑΡΑΓΩΓΗ ΡΥΖΙΟΥ, ΠΛΗΡΟΥΣ Η ΜΕΡΙΚΗΣ ΑΛΕΣΕΩΣ Η ΣΕ ΘΡΑΥΣΜΑΤΑ',
  },
  {
    label: '10612000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΕΥΡΙΩΝ ΣΙΤΗΡΩΝ ΚΑΙ ΦΥΤΙΚΩΝ ΑΛΕΥΡΙΩΝ· ΜΕΙΓΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '10612100',
    value: 'ΠΑΡΑΓΩΓΗ ΣΙΤΑΛΕΥΡΟΥ Η ΑΛΕΥΡΙΟΥ ΣΜΙΓΑΔΙΟΥ',
  },
  {
    label: '10612200',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΑΛΕΥΡΙΩΝ ΣΙΤΗΡΩΝ',
  },
  {
    label: '10612300',
    value: 'ΠΑΡΑΓΩΓΗ ΦΥΤΙΚΩΝ ΑΛΕΥΡΙΩΝ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΩΝ',
  },
  {
    label: '10612400',
    value: 'ΠΑΡΑΓΩΓΗ ΜΕΙΓΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΑΡΑΣΚΕΥΗ ΥΛΙΚΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '10612401',
    value: 'ΠΑΡΑΓΩΓΗ ΖΥΜΗΣ ΣΦΟΛΙΑΤΑΣ',
  },
  {
    label: '10613000',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΟΝΔΡΩΝ (ΜΠΛΙΓΟΥΡΙΟΥ), ΧΟΝΔΡΑΛΕΥΡΩΝ ΚΑΙ ΣΒΟΛΩΝ ΚΑΙ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '10613100',
    value: 'ΠΑΡΑΓΩΓΗ ΧΟΝΔΡΩΝ (ΜΠΛΙΓΟΥΡΙΟΥ) ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΩΝ ΣΙΤΑΡΙΟΥ',
  },
  {
    label: '10613200',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΟΝΔΡΩΝ (ΜΠΛΙΓΟΥΡΙΟΥ), ΧΟΝΔΡΑΛΕΥΡΩΝ ΚΑΙ ΣΒΟΛΩΝ ΣΙΤΗΡΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '10613300',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΙΤΗΡΩΝ ΓΙΑ ΠΡΟΓΕΥΜΑ ΚΑΙ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΚΟΚΚΟΥΣ ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '10613301',
    value: 'ΠΑΡΑΓΩΓΗ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΤΡΟΦΩΝ ΑΠΟ ΚΑΛΑΜΠΟΚΙ',
  },
  {
    label: '10614000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΙΤΟΥΡΟΥ, ΠΙΤΟΥΡΑΛΕΥΡΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΤΑΛΟΙΠΩΝ ΑΠΟ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΣΙΤΗΡΩΝ',
  },
  {
    label: '10619000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΡΟΪΟΝΤΩΝ ΑΛΕΥΡΟΜΥΛΩΝ',
  },
  {
    label: '10620000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΜΥΛΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΑΜΥΛΟΥ',
  },
  {
    label: '10621000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΜΥΛΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΑΜΥΛΟΥ· ΣΑΚΧΑΡΩΝ ΚΑΙ ΣΙΡΟΠΙΩΝ ΖΑΧΑΡΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '10621100',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΜΥΛΩΝ ΚΑΘΕ ΕΙΔΟΥΣ· ΙΝΟΥΛΙΝΗΣ· ΓΛΟΥΤΕΝΗΣ ΣΙΤΑΡΙΟΥ· ΔΕΞΤΡΙΝΩΝ ΚΑΙ ΑΛΛΩΝ ΤΡΟΠΟΠΟΙΗΜΕΝΩΝ ΑΜΥΛΩΝ',
  },
  {
    label: '10621200',
    value:
      'ΠΑΡΑΓΩΓΗ ΤΑΠΙΟΚΑΣ ΚΑΙ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΑΠΟ ΑΜΥΛΟ ΣΕ ΜΟΡΦΗ ΝΙΦΑΔΩΝ, ΚΟΚΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ',
  },
  {
    label: '10621300',
    value:
      'ΠΑΡΑΓΩΓΗ ΓΛΥΚΟΖΗΣ ΚΑΙ ΣΙΡΟΠΙΟΥ ΓΛΥΚΟΖΗΣ· ΦΡΟΥΚΤΟΖΗΣ ΚΑΙ ΣΙΡΟΠΙΟΥ ΦΡΟΥΚΤΟΖΗΣ·ΙΜΒΕΡΤΟΣΑΚΧΑΡΟΥ· ΣΑΚΧΑΡΩΝ ΚΑΙ ΣΙΡΟΠΙΩΝ ΖΑΧΑΡΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '10621400',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΛΑΜΠΟΚΕΛΑΙΟΥ',
  },
  {
    label: '10622000',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΤΑΛΟΙΠΩΝ ΑΜΥΛΟΠΟΙΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΚΑΤΑΛΟΙΠΩΝ',
  },
  {
    label: '10629000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΜΥΛΩΝ ΚΑΙ ΑΜΥΛΩΔΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '10710000',
    value: 'ΑΡΤΟΠΟΙΙΑ· ΠΑΡΑΓΩΓΗ ΝΩΠΩΝ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ',
  },
  {
    label: '10711000',
    value: 'ΠΑΡΑΓΩΓΗ ΨΩΜΙΟΥ, ΝΩΠΩΝ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ ΚΑΙ ΓΛΥΚΙΣΜΑΤΩΝ',
  },
  {
    label: '10711100',
    value: 'ΠΑΡΑΓΩΓΗ ΦΡΕΣΚΟΥ ΨΩΜΙΟΥ',
  },
  {
    label: '10711101',
    value: 'ΠΑΡΑΓΩΓΗ ΤΥΡΟΠΙΤΩΝ, ΣΑΝΤΟΥΙΤΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '10711102',
    value: 'ΠΑΡΑΓΩΓΗ ΦΡΕΣΚΟΥ ΨΩΜΙΟΥ ΜΕ ΜΗΧΑΝΙΚΟ ΖΥΜΩΤΗΡΙΟ',
  },
  {
    label: '10711103',
    value: 'ΠΑΡΑΓΩΓΗ ΦΡΕΣΚΟΥ ΨΩΜΙΟΥ ΧΩΡΙΣ ΜΗΧΑΝΙΚΑ ΜΕΣΑ',
  },
  {
    label: '10711200',
    value: 'ΠΑΡΑΓΩΓΗ ΝΩΠΩΝ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ ΚΑΙ ΓΛΥΚΙΣΜΑΤΩΝ',
  },
  {
    label: '10719000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΝΩΠΟΥ Η ΚΑΤΕΨΥΓΜΕΝΟΥ ΨΩΜΙΟΥ, ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ ΚΑΙ ΓΛΥΚΙΣΜΑΤΩΝ',
  },
  {
    label: '10720000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΑΞΙΜΑΔΙΩΝ ΚΑΙ ΜΠΙΣΚΟΤΩΝ· ΠΑΡΑΓΩΓΗ ΔΙΑΤΗΡΟΥΜΕΝΩΝ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ',
  },
  {
    label: '10721100',
    value:
      'ΠΑΡΑΓΩΓΗ ΤΡΑΓΑΝΟΥ ΨΩΜΙΟΥ, ΠΑΞΙΜΑΔΙΩΝ, ΦΡΥΓΑΝΙΣΜΕΝΟΥ ΨΩΜΙΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΦΡΥΓΑΝΙΣΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '10721200',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΕΛΟΨΩΜΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ· ΓΛΥΚΩΝ ΜΠΙΣΚΟΤΩΝ· ΒΑΦΛΩΝ (ΓΚΟΦΡΩΝ) ΚΑΙ ΓΚΟΦΡΕΤΩΝ',
  },
  {
    label: '10721201',
    value: 'ΠΑΡΑΓΩΓΗ ΛΟΥΚΟΥΜΑΔΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '10721202',
    value: 'ΠΑΡΑΓΩΓΗ ΜΠΙΣΚΟΤΩΝ',
  },
  {
    label: '10721900',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΞΗΡΩΝ Η ΔΙΑΤΗΡΟΥΜΕΝΩΝ ΕΙΔΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '10721901',
    value: 'ΠΑΡΑΓΩΓΗ ΚΟΥΛΟΥΡΙΩΝ ΚΑΙ ΠΙΤΩΝ',
  },
  {
    label: '10721902',
    value: 'ΠΑΡΑΓΩΓΗ ΦΥΛΛΩΝ ΚΡΟΥΣΤΑΣ Η ΚΑΝΤΑΪΦΙΟΥ',
  },
  {
    label: '10729000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΣΚΕΥΗΣ ΠΑΞΙΜΑΔΙΩΝ ΚΑΙ ΜΠΙΣΚΟΤΩΝ· ΔΙΑΤΗΡΟΥΜΕΝΩΝ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ ΚΑΙ ΓΛΥΚΙΣΜΑΤΩΝ',
  },
  {
    label: '10730000',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΑΚΑΡΟΝΙΩΝ, ΛΑΖΑΝΙΩΝ, ΚΟΥΣΚΟΥΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΑΛΕΥΡΩΔΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '10731000',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΑΚΑΡΟΝΙΩΝ, ΡΥΖΟΜΑΚΑΡΟΝΩΝ (NOODLES), ΚΟΥΣΚΟΥΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΑΛΕΥΡΩΔΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '10731100',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΑΚΑΡΟΝΙΩΝ, ΡΥΖΟΜΑΚΑΡΟΝΩΝ (NOODLES) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΑΛΕΥΡΩΔΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '10731200',
    value: 'ΠΑΡΑΓΩΓΗ ΚΟΥΣΚΟΥΣ',
  },
  {
    label: '10739000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΜΑΚΑΡΟΝΙΩΝ, ΡΥΖΟΜΑΚΑΡΟΝΩΝ (NOODLES), ΚΟΥΣΚΟΥΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΑΛΕΥΡΩΔΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '10739901',
    value: 'ΠΑΡΑΓΩΓΗ ΖΥΜΑΡΙΚΩΝ ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ, ΧΩΡΙΣ ΥΛΙΚΑ',
  },
  {
    label: '10810000',
    value: 'ΠΑΡΑΓΩΓΗ ΖΑΧΑΡΗΣ',
  },
  {
    label: '10811000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΗΣ Η ΚΑΤΕΡΓΑΣΜΕΝΗΣ ΖΑΧΑΡΗΣ ΑΠΟ ΖΑΧΑΡΟΚΑΛΑΜΟ Η ΖΑΧΑΡΟΤΕΥΤΛΑ·',
  },
  {
    label: '10811100',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΗΣ ΖΑΧΑΡΗΣ ΑΠΟ ΖΑΧΑΡΟΚΑΛΑΜΟ Η ΖΑΧΑΡΟΤΕΥΤΛΑ, ΣΕ ΣΤΕΡΕΑ ΜΟΡΦΗ',
  },
  {
    label: '10811200',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΑΤΕΡΓΑΣΜΕΝΗΣ ΖΑΧΑΡΗΣ ΑΠΟ ΖΑΧΑΡΟΚΑΛΑΜΟ Η ΖΑΧΑΡΟΤΕΥΤΛΑ ΚΑΙ ΧΗΜΙΚΑ ΚΑΘΑΡΗΣ ΣΑΚΧΑΡΟΖΗΣ ΣΕ ΣΤΕΡΕΑ ΜΟΡΦΗ, ΠΟΥ ΔΕΝ ΠΕΡΙΕΧΕΙ ΠΡΟΣΘΕΤΕΣ ΑΡΩΜΑΤΙΚΕΣ Η ΧΡΩΣΤΙΚΕΣ ΟΥΣΙΕΣ',
  },
  {
    label: '10811300',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΑΤΕΡΓΑΣΜΕΝΗΣ ΖΑΧΑΡΗΣ ΑΠΟ ΖΑΧΑΡΟΚΑΛΑΜΟ Η ΖΑΧΑΡΟΤΕΥΤΛΑ, ΠΟΥ ΠΕΡΙΕΧΕΙ ΠΡΟΣΘΕΤΕΣ ΑΡΩΜΑΤΙΚΕΣ Η ΧΡΩΣΤΙΚΕΣ ΟΥΣΙΕΣ· ΖΑΧΑΡΗΣ ΚΑΙ ΣΙΡΟΠΙΟΥ ΣΦΕΝΔΑΜΟΥ',
  },
  {
    label: '10811400',
    value: 'ΠΑΡΑΓΩΓΗ ΜΕΛΑΣΩΝ',
  },
  {
    label: '10812000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΟΛΤΟΥ ΤΕΥΤΛΩΝ, ΥΠΟΛΕΙΜΜΑΤΩΝ ΕΚΧΥΛΙΣΗΣ ΣΑΚΧΑΡΟΥ (ΒΑΓΑΣΣΗΣ) ΚΑΙ ΑΛΛΩΝ ΥΠΟΛΕΙΜΜΑΤΩΝ ΑΠΟ ΤΗΝ ΠΑΡΑΓΩΓΗ ΖΑΧΑΡΗΣ',
  },
  {
    label: '10819000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΖΑΧΑΡΗΣ',
  },
  {
    label: '10819901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΙΚΗΣ ΚΡΥΣΤΑΛΛΩΣΗΣ ΖΑΧΑΡΗΣ',
  },
  {
    label: '10820000',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΚΑΟΥ, ΣΟΚΟΛΑΤΑΣ ΚΑΙ ΖΑΧΑΡΩΤΩΝ',
  },
  {
    label: '10821000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΑΣΤΑΣ ΚΑΚΑΟΥ (ΚΑΚΑΟΜΑΖΑΣ), ΑΠΟΒΟΥΤΥΡΩΜΕΝΗΣ Η ΜΗ, ΒΟΥΤΥΡΟΥ, ΛΙΠΟΥΣ ΚΑΙ ΛΑΔΙΟΥ ΚΑΚΑΟΥ ΚΑΙ ΚΑΚΑΟΥ ΣΕ ΣΚΟΝΗ',
  },
  {
    label: '10821100',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΣΤΑΣ ΚΑΚΑΟΥ, ΑΠΟΒΟΥΤΥΡΩΜΕΝΗΣ Η ΜΗ',
  },
  {
    label: '10821200',
    value: 'ΠΑΡΑΓΩΓΗ ΒΟΥΤΥΡΟΥ, ΛΙΠΟΥΣ ΚΑΙ ΛΑΔΙΟΥ ΚΑΚΑΟΥ',
  },
  {
    label: '10821300',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΑΚΑΟΥ ΣΕ ΣΚΟΝΗ, ΠΟΥ ΔΕΝ ΠΕΡΙΕΧΕΙ ΠΡΟΣΘΕΤΑ ΖΑΧΑΡΗΣ Η ΑΛΛΗΣ ΓΛΥΚΑΝΤΙΚΗΣ ΥΛΗΣ',
  },
  {
    label: '10821400',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΑΚΑΟΥ ΣΕ ΣΚΟΝΗ, ΠΟΥ ΠΕΡΙΕΧΕΙ ΠΡΟΣΘΕΤΑ ΖΑΧΑΡΗΣ Η ΑΛΛΗΣ ΓΛΥΚΑΝΤΙΚΗΣ ΥΛΗΣ',
  },
  {
    label: '10822000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΟΪΟΝΤΩΝ ΣΟΚΟΛΑΤΟΠΟΙΙΑΣ ΚΑΙ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ',
  },
  {
    label: '10822100',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΟΚΟΛΑΤΑΣ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΔΙΑΤΡΟΦΗΣ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΚΑΚΑΟ (ΕΚΤΟΣ ΑΠΟ ΖΑΧΑΡΟΥΧΑ ΣΚΟΝΗ ΚΑΚΑΟΥ), ΧΥΔΗΝ',
  },
  {
    label: '10822200',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΟΚΟΛΑΤΑΣ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΔΙΑΤΡΟΦΗΣ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΚΑΚΑΟ (ΕΚΤΟΣ ΑΠΟ ΖΑΧΑΡΟΥΧΑ ΣΚΟΝΗ ΚΑΚΑΟΥ), ΣΕ ΑΛΛΕΣ ΜΟΡΦΕΣ ΕΚΤΟΣ ΧΥΔΗΝ',
  },
  {
    label: '10822300',
    value:
      'ΠΑΡΑΓΩΓΗ ΖΑΧΑΡΩΔΩΝ ΠΡΟΪΟΝΤΩΝ ΧΩΡΙΣ ΚΑΚΑΟ (ΣΤΑ ΟΠΟΙΑ ΠΕΡΙΛΑΜΒΑΝΕΤΑΙ ΚΑΙ Η ΛΕΥΚΗ ΣΟΚΟΛΑΤΑ)',
  },
  {
    label: '10822301',
    value: 'ΠΑΡΑΓΩΓΗ ΚΟΛΛΥΒΩΝ ΓΙΑ ΔΙΣΚΟΥΣ ΜΝΗΜΟΣΥΝΩΝ',
  },
  {
    label: '10822302',
    value: 'ΠΑΡΑΓΩΓΗ ΧΑΛΒΑΔΩΝ, ΚΟΥΦΕΤΩΝ ΚΑΙ ΛΟΥΚΟΥΜΙΩΝ',
  },
  {
    label: '10822400',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΡΟΥΤΩΝ, ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ, ΦΛΟΥΔΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΑΛΛΩΝ ΜΕΡΩΝ ΦΥΤΩΝ ΔΙΑΤΗΡΗΜΕΝΩΝ ΜΕ ΖΑΧΑΡΗ',
  },
  {
    label: '10823000',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΕΛΥΦΩΝ, ΜΕΜΒΡΑΝΩΝ (ΦΛΟΥΔΩΝ) ΚΑΙ ΑΛΛΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΚΑΟΥ',
  },
  {
    label: '10829000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΚΑΚΑΟΥ, ΣΟΚΟΛΑΤΑΣ ΚΑΙ ΖΑΧΑΡΩΤΩΝ',
  },
  {
    label: '10830000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΤΣΑΓΙΟΥ ΚΑΙ ΚΑΦΕ',
  },
  {
    label: '10831100',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΦΕ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΑΠΟΚΑΦΕΪΝΩΜΕΝΟΣ Η ΚΑΒΟΥΡΔΙΣΜΕΝΟΣ',
  },
  {
    label: '10831200',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΤΟΥ ΚΑΦΕ· ΕΚΧΥΛΙΣΜΑΤΩΝ, ΑΠΟΣΤΑΓΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΤΟΥ ΚΑΦΕ Η ΤΩΝ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΤΟΥ ΚΑΦΕ· ΛΟΒΟΥ ΚΑΙ ΦΛΟΙΟΥ ΚΑΦΕ',
  },
  {
    label: '10831300',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΠΡΑΣΙΝΟΥ ΤΣΑΓΙΟΥ (ΠΟΥ ΔΕΝ ΕΧΕΙ ΥΠΟΣΤΕΙ ΖΥΜΩΣΗ), ΜΑΥΡΟΥ ΤΣΑΓΙΟΥ (ΠΟΥ ΕΧΕΙ ΥΠΟΣΤΕΙ ΖΥΜΩΣΗ) ΚΑΙ ΤΣΑΓΙΟΥ ΠΟΥ ΕΧΕΙ ΥΠΟΣΤΕΙ ΕΝ ΜΕΡΕΙ ΖΥΜΩΣΗ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΣΕ ΑΜΕΣΕΣ ΣΥΣΚΕΥΑΣΙΕΣ ΠΕΡΙΕΧΟΜΕΝΟΥ <= 3 ~ KG',
  },
  {
    label: '10831400',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΕΚΧΥΛΙΣΜΑΤΩΝ, ΑΠΟΣΤΑΓΜΑΤΩΝ, ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΤΣΑΓΙΟΥ Η ΜΑΤΕ',
  },
  {
    label: '10831500',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΑΦΕΨΗΜΑΤΩΝ ΒΟΤΑΝΩΝ',
  },
  {
    label: '10839000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΚΑΦΕ ΚΑΙ ΤΣΑΓΙΟΥ',
  },
  {
    label: '10840000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΡΤΥΜΑΤΩΝ ΚΑΙ ΚΑΡΥΚΕΥΜΑΤΩΝ',
  },
  {
    label: '10841000',
    value:
      'ΠΑΡΑΓΩΓΗ ΞΙΔΙΟΥ· ΣΑΛΤΣΩΝ· ΑΝΑΜΕΙΚΤΩΝ ΚΑΡΥΚΕΥΜΑΤΩΝ· ΑΛΕΥΡΙΟΥ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΟΥ ΣΙΝΑΠΙΟΥ· ΠΑΡΑΣΚΕΥΑΣΜΕΝΗΣ ΜΟΥΣΤΑΡΔΑΣ',
  },
  {
    label: '10841100',
    value:
      'ΠΑΡΑΓΩΓΗ ΞΙΔΙΟΥ ΚΑΙ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΤΟΥ ΞΙΔΙΟΥ ΠΟΥ ΛΑΜΒΑΝΟΝΤΑΙ ΑΠΟ ΤΟ ΟΞΙΚΟ ΟΞΥ',
  },
  {
    label: '10841200',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΑΛΤΣΩΝ· ΜΕΙΓΜΑΤΩΝ ΑΡΤΥΜΑΤΩΝ ΚΑΙ ΜΕΙΓΜΑΤΩΝ ΚΑΡΥΚΕΥΜΑΤΩΝ, ΑΛΕΥΡΙΟΥ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΟΥ ΑΠΟ ΣΙΝΑΠΙ ΚΑΙ ΜΟΥΣΤΑΡΔΑ ΠΑΡΑΣΚΕΥΑΣΜΕΝΗ',
  },
  {
    label: '10841201',
    value: 'ΠΑΡΑΓΩΓΗ ΜΟΥΣΤΑΡΔΑΣ, ΜΑΓΙΟΝΕΖΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '10842000',
    value: 'ΠΑΡΑΓΩΓΗ ΜΠΑΧΑΡΙΚΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΚΑΤΕΡΓΑΣΜΕΝΑ',
  },
  {
    label: '10842100',
    value: 'ΠΑΡΑΓΩΓΗ ΠΙΠΕΡΙΑΣ (PIPER SPP), ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΚΑΤΕΡΓΑΣΜΕΝΗ',
  },
  {
    label: '10842200',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΟΚΚΙΝΩΝ ΚΑΙ ΠΡΑΣΙΝΩΝ ΚΑΥΤΕΡΩΝ ΠΙΠΕΡΙΩΝ (ΤΣΙΛΙ) ΚΑΙ ΠΙΠΕΡΙΩΝ , ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΑΠΟΞΗΡΑΜΕΝΕΣ (CAPSICUM SPP.), ΚΑΤΕΡΓΑΣΜΕΝΩΝ',
  },
  {
    label: '10842300',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΝΕΛΛΑΣ, ΚΑΤΕΡΓΑΣΜΕΝΗΣ· ΑΛΛΩΝ ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΜΠΑΧΑΡΙΚΩΝ',
  },
  {
    label: '10843000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΑΤΙΟΥ ΚΑΤΑΛΛΗΛΟΥ ΓΙΑ ΤΡΟΦΙΜΑ',
  },
  {
    label: '10843001',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΚΑΘΑΡΙΣΜΟΣ ΑΛΑΤΙΟΥ (ΑΛΑΤΟΤΡΙΒΕΙΟ)',
  },
  {
    label: '10849000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΡΤΥΜΑΤΩΝ ΚΑΙ ΚΑΡΥΚΕΥΜΑΤΩΝ',
  },
  {
    label: '10850000',
    value: 'ΠΑΡΑΓΩΓΗ ΕΤΟΙΜΩΝ ΓΕΥΜΑΤΩΝ ΚΑΙ ΦΑΓΗΤΩΝ',
  },
  {
    label: '10851100',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΤΟΙΜΩΝ ΓΕΥΜΑΤΩΝ ΚΑΙ ΦΑΓΗΤΩΝ ΜΕ ΒΑΣΗ ΤΟ ΚΡΕΑΣ, ΤΑ ΕΝΤΟΣΘΙΑ ΚΡΕΑΤΟΣ Η ΤΟ ΑΙΜΑ',
  },
  {
    label: '10851200',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΤΟΙΜΩΝ ΓΕΥΜΑΤΩΝ ΚΑΙ ΦΑΓΗΤΩΝ ΜΕ ΒΑΣΗ ΤΟ ΨΑΡΙ, ΤΑ ΚΑΡΚΙΝΟΕΙΔΗ ΚΑΙ ΤΑ ΜΑΛΑΚΙΑ',
  },
  {
    label: '10851300',
    value: 'ΠΑΡΑΓΩΓΗ ΕΤΟΙΜΩΝ ΓΕΥΜΑΤΩΝ ΚΑΙ ΦΑΓΗΤΩΝ ΜΕ ΒΑΣΗ ΤΑ ΛΑΧΑΝΙΚΑ',
  },
  {
    label: '10851400',
    value: 'ΠΑΡΑΓΩΓΗ ΕΤΟΙΜΩΝ ΓΕΥΜΑΤΩΝ ΚΑΙ ΦΑΓΗΤΩΝ ΜΕ ΒΑΣΗ ΤΑ ΖΥΜΑΡΙΚΑ',
  },
  {
    label: '10851900',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΕΤΟΙΜΩΝ ΓΕΥΜΑΤΩΝ ΚΑΙ ΦΑΓΗΤΩΝ (ΠΕΡΙΛΑΜΒΑΝΕΤΑΙ ΚΑΙ Η ΚΑΤΕΨΥΓΜΕΝΗ ΠΙΤΣΑ)',
  },
  {
    label: '10859000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΤΟΙΜΩΝ ΓΕΥΜΑΤΩΝ ΚΑΙ ΦΑΓΗΤΩΝ',
  },
  {
    label: '10860000',
    value:
      'ΠΑΡΑΓΩΓΗ ΟΜΟΓΕΝΟΠΟΙΗΜΕΝΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΔΙΑΤΡΟΦΗΣ ΚΑΙ ΔΙΑΙΤΗΤΙΚΩΝ ΤΡΟΦΩΝ',
  },
  {
    label: '10861001',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΙΔΙΚΩΝ ΤΡΟΦΩΝ',
  },
  {
    label: '10861002',
    value: 'ΠΑΡΑΓΩΓΗ ΤΡΟΦΩΝ ΓΙΑ ΔΙΑΒΗΤΙΚΟΥΣ',
  },
  {
    label: '10869000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΟΜΟΓΕΝΟΠΟΙΗΜΕΝΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΔΙΑΤΡΟΦΗΣ ΚΑΙ ΔΙΑΙΤΗΤΙΚΩΝ ΤΡΟΦΩΝ',
  },
  {
    label: '10890000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΕΙΔΩΝ ΔΙΑΤΡΟΦΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '10891000',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΟΥΠΩΝ, ΑΒΓΩΝ, ΜΑΓΙΩΝ ΚΑΙ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΔΙΑΤΡΟΦΗΣ· ΕΚΧΥΛΙΣΜΑΤΩΝ ΚΑΙ ΖΩΜΩΝ ΚΡΕΑΤΟΣ, ΨΑΡΙΩΝ ΚΑΙ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ',
  },
  {
    label: '10891100',
    value: 'ΠΑΡΑΓΩΓΗ ΣΟΥΠΩΝ ΚΑΙ ΖΩΜΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '10891200',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΒΓΩΝ, ΧΩΡΙΣ ΤΟ ΚΕΛΥΦΟΣ, ΚΑΙ ΚΡΟΚΩΝ ΑΒΓΩΝ, ΝΩΠΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ· ΑΒΓΩΝ ΜΕ ΤΟ ΚΕΛΥΦΟΣ ΔΙΑΤΗΡΗΜΕΝΩΝ Η ΜΑΓΕΙΡΕΜΕΝΩΝ· ΛΕΥΚΩΜΑΤΟΣ ΑΒΓΟΥ',
  },
  {
    label: '10891300',
    value:
      'ΠΑΡΑΓΩΓΗ ΖΥΜΩΝ (ΕΝΕΡΓΩΝ Η ΑΔΡΑΝΩΝ)· ΑΛΛΩΝ ΜΟΝΟΚΥΤΤΑΡΩΝ ΜΙΚΡΟΟΡΓΑΝΙΣΜΩΝ, ΝΕΚΡΩΝ·ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΔΙΟΓΚΩΤΙΚΩΝ ΣΚΟΝΩΝ',
  },
  {
    label: '10891301',
    value: 'ΠΑΡΑΓΩΓΗ ΖΥΜΩΝ ΑΡΤΟΠΟΙΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '10891302',
    value: 'ΠΑΡΑΓΩΓΗ ΜΠΕΙΚΙΓΚ ΠΑΟΥΝΤΕΡ',
  },
  {
    label: '10891400',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΚΧΥΛΙΣΜΑΤΩΝ ΚΑΙ ΖΩΜΩΝ ΚΡΕΑΤΟΣ, ΨΑΡΙΩΝ ΚΑΙ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ',
  },
  {
    label: '10891500',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΥΜΩΝ ΚΑΙ ΕΚΧΥΛΙΣΜΑΤΩΝ ΦΥΤΙΚΩΝ· ΠΕΠΤΙΚΩΝ ΟΥΣΙΩΝ· ΒΛΕΝΝΩΔΩΝ ΚΑΙ ΠΗΚΤΙΚΩΝ ΠΑΡΑΓΟΝΤΩΝ',
  },
  {
    label: '10891900',
    value: 'ΠΑΡΑΓΩΓΗ ΔΙΑΦΟΡΩΝ ΠΡΟΪΟΝΤΩΝ ΔΙΑΤΡΟΦΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '10899000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΔΙΑΤΡΟΦΗΣ',
  },
  {
    label: '10910000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΖΩΟΤΡΟΦΩΝ ΓΙΑ ΖΩΑ ΠΟΥ ΕΚΤΡΕΦΟΝΤΑΙ ΣΕ ΑΓΡΟΚΤΗΜΑΤΑ',
  },
  {
    label: '10911000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΖΩΟΤΡΟΦΩΝ ΓΙΑ ΖΩΑ ΠΟΥ ΕΚΤΡΕΦΟΝΤΑΙ ΣΕ ΑΓΡΟΚΤΗΜΑΤΑ, ΕΚΤΟΣ ΑΠΟ ΧΟΝΔΡΑΛΕΥΡΑ ΚΑΙ ΣΒΟΛΟΥΣ ΤΡΙΦΥΛΛΙΟΥ',
  },
  {
    label: '10911001',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΙΧΘΥΟΤΡΟΦΩΝ',
  },
  {
    label: '10912000',
    value: 'ΠΑΡΑΓΩΓΗ ΧΟΝΔΡΑΛΕΥΡΟΥ ΚΑΙ ΣΒΟΛΩΝ ΤΡΙΦΥΛΛΙΟΥ (ALFALFA)',
  },
  {
    label: '10919000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΖΩΟΤΡΟΦΩΝ ΓΙΑ ΖΩΑ ΕΚΤΡΕΦΟΜΕΝΑ ΣΕ ΑΓΡΟΚΤΗΜΑΤΑ',
  },
  {
    label: '10920000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΖΩΟΤΡΟΦΩΝ ΓΙΑ ΖΩΑ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '10921000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΤΡΟΦΩΝ ΓΙΑ ΖΩΑ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '10929000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΤΡΟΦΙΜΩΝ ΓΙΑ ΖΩΑ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '11010000',
    value: 'ΑΠΟΣΤΑΞΗ, ΑΝΑΚΑΘΑΡΙΣΜΟΣ ΚΑΙ ΑΝΑΜΙΞΗ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ',
  },
  {
    label: '11011000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΠΟΣΤΑΓΜΕΝΩΝ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ',
  },
  {
    label: '11019000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΑΠΟΣΤΑΞΗΣ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ',
  },
  {
    label: '11019900',
    value: 'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΓΙΑ ΤΗΝ ΑΠΟΣΤΑΞΗ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ',
  },
  {
    label: '11019901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΣΤΑΓΜΑΤΟΠΟΙΟΥ, ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ',
  },
  {
    label: '11020000',
    value: 'ΠΑΡΑΓΩΓΗ ΟΙΝΟΥ ΑΠΟ ΣΤΑΦΥΛΙΑ',
  },
  {
    label: '11021000',
    value: 'ΠΑΡΑΓΩΓΗ ΟΙΝΟΥ ΑΠΟ ΝΩΠΑ ΣΤΑΦΥΛΙΑ· ΜΟΥΣΤΟΥ ΣΤΑΦΥΛΙΩΝ',
  },
  {
    label: '11021100',
    value: 'ΠΑΡΑΓΩΓΗ ΑΦΡΩΔΟΥΣ ΟΙΝΟΥ ΑΠΟ ΝΩΠΑ ΣΤΑΦΥΛΙΑ',
  },
  {
    label: '11021200',
    value:
      'ΠΑΡΑΓΩΓΗ ΟΙΝΟΥ ΑΠΟ ΝΩΠΑ ΣΤΑΦΥΛΙΑ, ΕΚΤΟΣ ΑΠΟ ΤΟΝ ΑΦΡΩΔΗ ΟΙΝΟ· ΜΟΥΣΤΟΥ ΣΤΑΦΥΛΙΩΝ',
  },
  {
    label: '11022000',
    value: 'ΠΑΡΑΓΩΓΗ ΟΙΝΟΛΑΣΠΩΝ (ΚΑΤΑΚΑΘΙΩΝ)· ΤΡΥΓΙΑΣ ΑΚΑΘΑΡΤΗΣ',
  },
  {
    label: '11029000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΟΙΝΟΥ ΑΠΟ ΣΤΑΦΥΛΙΑ',
  },
  {
    label: '11030000',
    value: 'ΠΑΡΑΓΩΓΗ ΜΗΛΙΤΗ ΚΑΙ ΚΡΑΣΙΩΝ ΑΠΟ ΑΛΛΑ ΦΡΟΥΤΑ',
  },
  {
    label: '11031000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΠΟΤΩΝ ΠΟΥ ΠΡΟΕΡΧΟΝΤΑΙ ΑΠΟ ΖΥΜΩΣΗ (Π.Χ. ΜΗΛΙΤΗ, ΑΠΙΤΗ, ΥΔΡΟΜΕΛΙΟΥ)· ΜΕΙΓΜΑΤΩΝ ΠΟΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΑΛΚΟΟΛΗ',
  },
  {
    label: '11039000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΜΗΛΙΤΗ ΚΑΙ ΑΛΛΩΝ ΟΙΝΩΝ ΑΠΟ ΦΡΟΥΤΑ',
  },
  {
    label: '11040000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΜΗ ΑΠΟΣΤΑΓΜΕΝΩΝ ΠΟΤΩΝ ΠΟΥ ΥΦΙΣΤΑΝΤΑΙ ΖΥΜΩΣΗ',
  },
  {
    label: '11041000',
    value:
      'ΠΑΡΑΓΩΓΗ ΒΕΡΜΟΥΤ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΡΩΜΑΤΙΚΟΥ ΚΡΑΣΙΟΥ ΑΠΟ ΝΩΠΑ ΣΤΑΦΥΛΙΑ',
  },
  {
    label: '11049000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΜΗ ΑΠΟΣΤΑΓΜΕΝΩΝ ΠΟΤΩΝ ΠΟΥ ΠΡΟΕΡΧΟΝΤΑΙ ΑΠΟ ΖΥΜΩΣΗ',
  },
  {
    label: '11050000',
    value: 'ΖΥΘΟΠΟΙΙΑ',
  },
  {
    label: '11051000',
    value: 'ΠΑΡΑΓΩΓΗ ΜΠΙΡΑΣ, ΕΚΤΟΣ ΑΠΟ ΚΑΤΑΛΟΙΠΑ ΖΥΘΟΠΟΙΙΑΣ',
  },
  {
    label: '11052000',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΤΑΛΟΙΠΩΝ ΖΥΘΟΠΟΙΙΑΣ Η ΑΠΟΣΤΑΞΗΣ',
  },
  {
    label: '11059000',
    value: 'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΜΠΙΡΑΣ',
  },
  {
    label: '11060000',
    value: 'ΠΑΡΑΓΩΓΗ ΒΥΝΗΣ',
  },
  {
    label: '11069000',
    value: 'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΒΥΝΗΣ',
  },
  {
    label: '11070000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΝΑΨΥΚΤΙΚΩΝ· ΠΑΡΑΓΩΓΗ ΜΕΤΑΛΛΙΚΟΥ ΝΕΡΟΥ ΚΑΙ ΑΛΛΩΝ ΕΜΦΙΑΛΩΜΕΝΩΝ ΝΕΡΩΝ',
  },
  {
    label: '11071000',
    value: 'ΠΑΡΑΓΩΓΗ ΜΕΤΑΛΛΙΚΩΝ ΝΕΡΩΝ ΚΑΙ ΑΝΑΨΥΚΤΙΚΩΝ',
  },
  {
    label: '11071100',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΕΤΑΛΛΙΚΩΝ ΝΕΡΩΝ ΚΑΙ ΑΕΡΙΟΥΧΩΝ ΝΕΡΩΝ, ΠΟΥ ΔΕΝ ΕΧΟΥΝ ΓΛΥΚΑΘΕΙ Η ΑΡΩΜΑΤΙΣΘΕΙ',
  },
  {
    label: '11071900',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΜΗ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ',
  },
  {
    label: '11071901',
    value: 'ΠΑΡΑΓΩΓΗ ΑΕΡΙΟΥΧΩΝ Η ΜΗ ΑΝΑΨΥΚΤΙΚΩΝ',
  },
  {
    label: '11079000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΜΕΤΑΛΛΙΚΩΝ ΝΕΡΩΝ ΚΑΙ',
  },
  {
    label: '11079901',
    value: 'ΕΜΦΙΑΛΩΣΗ ΦΥΣΙΚΩΝ ΜΕΤΑΛΛΙΚΩΝ ΝΕΡΩΝ',
  },
  {
    label: '12000000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΟΪΟΝΤΩΝ ΚΑΠΝΟΥ',
  },
  {
    label: '12001000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΟΪΟΝΤΩΝ ΚΑΠΝΟΥ, ΕΚΤΟΣ ΑΠΟ ΚΑΤΑΛΟΙΠΑ ΚΑΠΝΟΥ',
  },
  {
    label: '12001100',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΟΥΡΩΝ, ΠΟΥΡΩΝ ΜΕ ΚΟΜΜΕΝΟ ΑΚΡΟ, ΠΟΥΡΑΚΙΩΝ ΚΑΙ ΤΣΙΓΑΡΩΝ, ΑΠΟ ΚΑΠΝΟ Η ΥΠΟΚΑΤΑΣΤΑΤΑ ΤΟΥ ΚΑΠΝΟΥ',
  },
  {
    label: '12001900',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΕΙΔΩΝ ΜΕΤΑΠΟΙΗΜΕΝΟΥ ΚΑΠΝΟΥ ΚΑΙ ΥΠΟΚΑΤΑΣΤΑΤΩΝ· ΟΜΟΓΕΝΟΠΟΙΗΜΕΝΟΥ Η ΑΝΑΣΥΣΤΑΜΕΝΟΥ ΚΑΠΝΟΥ· ΕΚΧΥΛΙΣΜΑΤΩΝ ΚΑΙ ΑΠΟΣΤΑΓΜΑΤΩΝ ΚΑΠΝΟΥ',
  },
  {
    label: '12002000',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΤΑΛΟΙΠΩΝ ΚΑΠΝΟΥ',
  },
  {
    label: '12009000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΡΟΪΟΝΤΩΝ ΚΑΠΝΟΥ',
  },
  {
    label: '13100000',
    value: 'ΠΡΟΠΑΡΑΣΚΕΥΗ ΚΑΙ ΝΗΜΑΤΟΠΟΙΗΣΗ ΥΦΑΝΤΙΚΩΝ ΙΝΩΝ',
  },
  {
    label: '13101000',
    value: 'ΠΑΡΑΓΩΓΗ ΕΡΙΟΛΙΠΟΥΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΗΣ ΤΗΣ ΛΑΝΟΛΙΝΗΣ)',
  },
  {
    label: '13102000',
    value: 'ΠΑΡΑΓΩΓΗ ΦΥΣΙΚΩΝ ΥΦΑΝΤΙΚΩΝ ΙΝΩΝ, ΠΡΟΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΓΙΑ ΚΛΩΣΗ',
  },
  {
    label: '13102100',
    value: 'ΠΑΡΑΓΩΓΗ ΜΕΤΑΞΙΟΥ ΩΜΟΥ (ΑΚΑΤΕΡΓΑΣΤΟΥ), ΟΧΙ ΣΤΡΙΜΜΕΝΟΥ',
  },
  {
    label: '13102200',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΑΛΛΙΟΥ, ΕΠΕΞΕΡΓΑΣΜΕΝΟΥ ΓΙΑ ΤΗΝ ΑΠΟΜΑΚΡΥΝΣΗ ΤΩΝ ΛΙΠΑΡΩΝ ΟΥΣΙΩΝ ΚΑΙ ΤΩΝ ΦΥΤΙΚΩΝ ΥΛΩΝ (ΑΠΑΝΘΡΑΚΩΜΕΝΟΥ), ΜΗ ΛΑΝΑΡΙΣΜΕΝΟΥ Η ΧΤΕΝΙΣΜΕΝΟΥ',
  },
  {
    label: '13102300',
    value: 'ΠΑΡΑΓΩΓΗ ΥΠΟΛΕΙΜΜΑΤΩΝ ΑΠΟ ΜΑΛΛΙ Η ΛΕΠΤΟΙΝΕΣ ΖΩΙΚΕΣ ΤΡΙΧΕΣ',
  },
  {
    label: '13102400',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΑΛΛΙΟΥ ΚΑΙ ΛΕΠΤΟΙΝΩΝ Η ΧΟΝΔΡΟΙΝΩΝ ΖΩΙΚΩΝ ΤΡΙΧΩΝ, ΛΑΝΑΡΙΣΜΕΝΩΝ Η ΧΤΕΝΙΣΜΕΝΩΝ',
  },
  {
    label: '13102500',
    value: 'ΠΑΡΑΓΩΓΗ ΒΑΜΒΑΚΙΟΥ, ΛΑΝΑΡΙΣΜΕΝΟΥ Η ΧΤΕΝΙΣΜΕΝΟΥ',
  },
  {
    label: '13102600',
    value:
      'ΠΑΡΑΓΩΓΗ ΓΙΟΥΤΑΣ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΙΝΩΝ (ΜΕ ΕΞΑΙΡΕΣΗ ΤΟ ΛΙΝΑΡΙ, ΤΗΝ ΚΑΝΝΑΒΗ ΚΑΙ ΤΟ ΡΑΜΙ), ΚΑΤΕΡΓΑΣΜΕΝΩΝ, ΑΛΛΑ ΟΧΙ ΝΗΜΑΤΟΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '13102900',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΦΥΤΙΚΩΝ ΥΦΑΝΤΙΚΩΝ ΙΝΩΝ, ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΑΛΛΑ ΟΧΙ ΝΗΜΑΤΟΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '13103000',
    value:
      'ΠΑΡΑΓΩΓΗ ΤΕΧΝΗΤΩΝ ΥΦΑΝΤΙΚΩΝ ΑΣΥΝΕΧΩΝ ΙΝΩΝ, ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΓΙΑ ΚΛΩΣΗ',
  },
  {
    label: '13103100',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΥΝΘΕΤΙΚΩΝ ΑΣΥΝΕΧΩΝ ΙΝΩΝ, ΠΟΥ ΕΙΝΑΙ ΛΑΝΑΡΙΣΜΕΝΕΣ, ΧΤΕΝΙΣΜΕΝΕΣ Η ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΚΑΤΕΡΓΑΣΜΕΝΕΣ ΓΙΑ ΝΗΜΑΤΟΠΟΙΗΣΗ',
  },
  {
    label: '13103200',
    value:
      'ΠΑΡΑΓΩΓΗ ΤΕΧΝΗΤΩΝ ΑΣΥΝΕΧΩΝ ΙΝΩΝ, ΠΟΥ ΕΙΝΑΙ ΛΑΝΑΡΙΣΜΕΝΕΣ, ΧΤΕΝΙΣΜΕΝΕΣ Η ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΚΑΤΕΡΓΑΣΜΕΝΕΣ ΓΙΑ ΝΗΜΑΤΟΠΟΙΗΣΗ',
  },
  {
    label: '13104000',
    value: 'ΠΑΡΑΓΩΓΗ ΝΗΜΑΤΩΝ ΑΠΟ ΜΕΤΑΞΙ ΚΑΙ ΝΗΜΑΤΩΝ ΑΠΟ ΑΠΟΡΡΙΜΜΑΤΑ ΜΕΤΑΞΙΟΥ',
  },
  {
    label: '13105000',
    value:
      'ΠΑΡΑΓΩΓΗ ΝΗΜΑΤΩΝ ΑΠΟ ΜΑΛΛΙ ΣΥΣΚΕΥΑΣΜΕΝΩΝ Η ΜΗ ΓΙΑ ΛΙΑΝΙΚΗ ΠΩΛΗΣΗ· ΝΗΜΑΤΩΝ ΑΠΟ ΛΕΠΤΟΙΝΕΣ Η ΧΟΝΔΡΟΙΝΕΣ ΖΩΙΚΕΣ ΤΡΙΧΕΣ Η ΑΛΟΓΟΤΡΙΧΕΣ',
  },
  {
    label: '13106000',
    value: 'ΠΑΡΑΓΩΓΗ ΝΗΜΑΤΩΝ ΑΠΟ ΒΑΜΒΑΚΙ· ΝΗΜΑΤΩΝ ΓΙΑ ΡΑΨΙΜΟ ΑΠΟ ΒΑΜΒΑΚΙ',
  },
  {
    label: '13106100',
    value: 'ΠΑΡΑΓΩΓΗ ΝΗΜΑΤΩΝ ΑΠΟ ΒΑΜΒΑΚΙ (ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΡΑΨΙΜΟ)',
  },
  {
    label: '13106200',
    value: 'ΠΑΡΑΓΩΓΗ ΝΗΜΑΤΩΝ ΑΠΟ ΒΑΜΒΑΚΙ, ΓΙΑ ΡΑΨΙΜΟ',
  },
  {
    label: '13107000',
    value:
      'ΠΑΡΑΓΩΓΗ ΝΗΜΑΤΩΝ ΑΠΟ ΦΥΤΙΚΕΣ ΥΦΑΝΤΙΚΕΣ ΙΝΕΣ ΕΚΤΟΣ ΑΠΟ ΒΑΜΒΑΚΙ (ΠΕΡΙΛΑΜΒΑΝΕΤΑΙ ΤΟ ΛΙΝΑΡΙ, Η ΓΙΟΥΤΑ, ΟΙ ΙΝΕΣ ΚΟΚΚΟΦΟΙΝΙΚΑ ΚΑΙ Η ΚΑΝΝΑΒΗ)· ΝΗΜΑΤΩΝ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '13107100',
    value: 'ΠΑΡΑΓΩΓΗ ΝΗΜΑΤΩΝ ΑΠΟ ΛΙΝΑΡΙ',
  },
  {
    label: '13107200',
    value:
      'ΠΑΡΑΓΩΓΗ ΝΗΜΑΤΩΝ ΑΠΟ ΓΙΟΥΤΑ Η ΑΠΟ ΑΛΛΕΣ ΥΦΑΝΤΙΚΕΣ ΙΝΕΣ ΠΟΥ ΠΡΟΕΡΧΟΝΤΑΙ ΑΠΟ ΤΟ ΕΣΩΤΕΡΙΚΟ ΤΟΥ ΦΛΟΙΟΥ (ΒΙΒΛΟΣ) ΟΡΙΣΜΕΝΗΣ ΚΑΤΗΓΟΡΙΑΣ ΦΥΤΩΝ· ΝΗΜΑΤΩΝ ΑΠΟ ΑΛΛΕΣ ΦΥΤΙΚΕΣ ΥΦΑΝΤΙΚΕΣ ΙΝΕΣ· ΝΗΜΑΤΩΝ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '13108000',
    value:
      'ΠΑΡΑΓΩΓΗ ΥΦΑΝΤΙΚΩΝ ΝΗΜΑΤΩΝ ΚΑΙ ΚΛΩΣΤΩΝ ΑΠΟ ΤΕΧΝΗΤΕΣ ΣΥΝΕΧΕΙΣ Η ΑΣΥΝΕΧΕΙΣ ΙΝΕΣ',
  },
  {
    label: '13108100',
    value:
      'ΠΑΡΑΓΩΓΗ ΝΗΜΑΤΩΝ ΑΠΟ ΤΕΧΝΗΤΕΣ ΣΥΝΕΧΕΙΣ ΙΝΕΣ, ΠΟΛΛΑΠΛΩΝ Η ΚΟΡΔΟΝΩΤΩΝ (ΕΚΤΟΣ ΑΠΟ ΝΗΜΑ ΓΙΑ ΡΑΨΙΜΟ, ΝΗΜΑ ΑΠΟ ΠΟΛΥΑΜΙΔΙΑ, ΠΟΛΥΕΣΤΕΡΕΣ Η ΤΕΧΝΗΤΗ ΒΙΣΚΟΖΗ) ΜΗ ΣΥΣΚΕΥΑΣΜΕΝΩΝ ΓΙΑ ΛΙΑΝΙΚΗ ΠΩΛΗΣΗ· ΝΗΜΑΤΩΝ ΑΠΟ ΤΕΧΝΗΤΕΣ ΙΝΕΣ, ΣΥΝΕΧΩΝ (ΕΚΤΟΣ ΑΠΟ ΝΗΜΑΤΑ ΓΙΑ',
  },
  {
    label: '13108200',
    value:
      'ΠΑΡΑΓΩΓΗ ΝΗΜΑΤΩΝ (ΕΚΤΟΣ ΑΠΟ ΝΗΜΑΤΑ ΓΙΑ ΡΑΨΙΜΟ) ΑΠΟ ΣΥΝΘΕΤΙΚΕΣ ΑΣΥΝΕΧΕΙΣ ΙΝΕΣ, ΜΕ ΠΕΡΙΕΚΤΙΚΟΤΗΤΑ >= 85 ;% ΚΑΤΑ ΒΑΡΟΣ ΑΠΟ ΤΙΣ ΙΝΕΣ ΑΥΤΕΣ',
  },
  {
    label: '13108300',
    value:
      'ΠΑΡΑΓΩΓΗ ΝΗΜΑΤΩΝ (ΕΚΤΟΣ ΑΠΟ ΝΗΜΑΤΑ ΓΙΑ ΡΑΨΙΜΟ) ΑΠΟ ΣΥΝΘΕΤΙΚΕΣ ΑΣΥΝΕΧΕΙΣ ΙΝΕΣ, ΜΕ ΠΕΡΙΕΚΤΙΚΟΤΗΤΑ <85 ;% ΚΑΤΑ ΒΑΡΟΣ ΑΠΟ ΤΙΣ ΙΝΕΣ ΑΥΤΕΣ',
  },
  {
    label: '13108400',
    value:
      'ΠΑΡΑΓΩΓΗ ΝΗΜΑΤΩΝ ΑΠΟ ΤΕΧΝΗΤΕΣ ΙΝΕΣ ΜΗ ΣΥΝΕΧΕΙΣ (ΕΚΤΟΣ ΑΠΟ ΝΗΜΑΤΑ ΓΙΑ ΡΑΨΙΜΟ), ΜΗ ΣΥΣΚΕΥΑΣΜΕΝΩΝ ΓΙΑ ΛΙΑΝΙΚΗ ΠΩΛΗΣΗ',
  },
  {
    label: '13108500',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΛΩΣΤΩΝ ΚΑΙ ΝΗΜΑΤΩΝ ΓΙΑ ΡΑΨΙΜΟ ΑΠΟ ΤΕΧΝΗΤΕΣ ΚΑΙ ΣΥΝΘΕΤΙΚΕΣ ΣΥΝΕΧΕΙΣ Η ΑΣΥΝΕΧΕΙΣ ΙΝΕΣ',
  },
  {
    label: '13109000',
    value:
      'ΠΑΡΑΓΩΓΗ ΞΕΦΤΙΔΙΩΝ· ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΣΚΕΥΗΣ ΦΥΣΙΚΩΝ ΥΦΑΝΤΙΚΩΝ ΙΝΩΝ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΕΡΓΑΣΙΑΣ ΥΦΑΝΤΙΚΩΝ ΝΗΜΑΤΩΝ ΚΑΙ ΚΛΩΣΤΩΝ',
  },
  {
    label: '13109100',
    value:
      'ΠΑΡΑΓΩΓΗ ΞΕΦΤΙΔΙΩΝ ΑΠΟ ΜΑΛΛΙ Η ΑΠΟ ΛΕΠΤΟΙΝΕΣ Η ΧΟΝΔΡΟΙΝΕΣ ΖΩΙΚΕΣ ΤΡΙΧΕΣ',
  },
  {
    label: '13109200',
    value: 'ΠΑΡΑΓΩΓΗ ΞΕΦΤΙΔΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΠΟΛΕΙΜΜΑΤΩΝ ΒΑΜΒΑΚΙΟΥ',
  },
  {
    label: '13109201',
    value: 'ΠΑΡΑΓΩΓΗ ΤΙΛΜΑΤΩΝ (ΣΤΟΥΠΙΩΝ)',
  },
  {
    label: '13109300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΣΚΕΥΗΣ ΦΥΣΙΚΩΝ ΥΦΑΝΤΙΚΩΝ ΙΝΩΝ',
  },
  {
    label: '13109900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΕΡΓΑΣΙΑΣ ΥΦΑΝΤΙΚΩΝ ΝΗΜΑΤΩΝ ΚΑΙ ΚΛΩΣΤΩΝ',
  },
  {
    label: '13200000',
    value: 'ΥΦΑΝΣΗ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΥΛΩΝ',
  },
  {
    label: '13201000',
    value:
      'ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ (ΕΚΤΟΣ ΤΩΝ ΕΙΔΙΚΩΝ ΥΦΑΣΜΑΤΩΝ), ΑΠΟ ΦΥΣΙΚΕΣ ΙΝΕΣ ΕΚΤΟΣ ΤΟΥ ΒΑΜΒΑΚΙΟΥ',
  },
  {
    label: '13201100',
    value: 'ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΜΕΤΑΞΙ Η ΑΠΟ ΑΠΟΡΡΙΜΜΑΤΑ ΜΕΤΑΞΙΟΥ',
  },
  {
    label: '13201200',
    value:
      'ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΛΑΝΑΡΙΣΜΕΝΟ Η ΧΤΕΝΙΣΜΕΝΟ ΜΑΛΛΙ, ΛΕΠΤΟΙΝΕΣ Η ΧΟΝΔΡΟΙΝΕΣ ΖΩΙΚΕΣ ΤΡΙΧΕΣ Η ΑΛΟΓΟΤΡΙΧΕΣ',
  },
  {
    label: '13201300',
    value: 'ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΛΙΝΑΡΙ',
  },
  {
    label: '13201400',
    value:
      'ΥΦΑΝΣΗ ΥΦΑΝΤΙΚΩΝ ΙΝΩΝ ΑΠΟ ΓΙΟΥΤΑ ΚΑΙ ΑΛΛΕΣ ΥΦΑΝΤΙΚΕΣ ΙΝΕΣ ΡΑΦΙΑΣ, ΑΠΟ ΤΟ ΕΣΩΤΕΡΙΚΟ ΤΟΥ ΦΛΟΙΟΥ ΟΡΙΣΜΕΝΗΣ ΚΑΤΗΓΟΡΙΑΣ ΦΥΤΩΝ (ΕΚΤΟΣ ΑΠΟ ΛΙΝΑΡΙ, ΚΑΝΝΑΒΗ ΚΑΙ ΡΑΜΙ)',
  },
  {
    label: '13201900',
    value:
      'ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΑΛΛΕΣ ΦΥΤΙΚΕΣ ΥΦΑΝΤΙΚΕΣ ΙΝΕΣ· ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΝΗΜΑΤΑ ΧΑΡΤΙΟΥ',
  },
  {
    label: '13202000',
    value: 'ΥΦΑΝΣΗ ΒΑΜΒΑΚΕΡΩΝ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '13203000',
    value:
      'ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ (ΕΚΤΟΣ ΤΩΝ ΕΙΔΙΚΩΝ ΥΦΑΣΜΑΤΩΝ), ΑΠΟ ΤΕΧΝΗΤΕΣ Η ΣΥΝΘΕΤΙΚΕΣ ΣΥΝΕΧΕΙΣ Η ΑΣΥΝΕΧΕΙΣ ΙΝΕΣ',
  },
  {
    label: '13203100',
    value:
      'ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΣΥΝΘΕΤΙΚΑ ΝΗΜΑΤΑ ΣΥΝΕΧΩΝ ΙΝΩΝ ΚΑΙ ΑΠΟ ΤΕΧΝΗΤΑ ΝΗΜΑΤΑ ΣΥΝΕΧΩΝ ΙΝΩΝ',
  },
  {
    label: '13203200',
    value: 'ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΣΥΝΘΕΤΙΚΕΣ ΑΣΥΝΕΧΕΙΣ ΙΝΕΣ',
  },
  {
    label: '13203300',
    value: 'ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΤΕΧΝΗΤΕΣ ΑΣΥΝΕΧΕΙΣ ΙΝΕΣ',
  },
  {
    label: '13204000',
    value:
      'ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ ΜΕ ΠΕΛΟΣ, ΘΗΛΕΙΩΤΩΝ ΥΦΑΣΜΑΤΩΝ ΣΠΟΓΓΩΔΟΥΣ ΜΟΡΦΗΣ (ΠΕΤΣΕΤΕ) ΚΑΙ ΑΛΛΩΝ ΕΙΔΙΚΩΝ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '13204100',
    value:
      'ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ ΜΕ ΠΕΛΟΣ ΚΑΙ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΣΕΝΙΛΛΗ,            [ΕΚΤΟΣ ΑΠΟ ΤΑ ΘΗΛΕΙΩΤΑ ΥΦΑΣΜΑΤΑ ΣΠΟΓΓΩΔΟΥΣ ΜΟΡΦΗΣ (ΠΕΤΣΕΤΕ) ΚΑΙ ΤΑ ΕΙΔΗ ΚΟΡΔΕΛΟΠΟΙΙΑΣ            ]',
  },
  {
    label: '13204200',
    value:
      'ΥΦΑΝΣΗ ΘΗΛΕΙΩΤΩΝ ΥΦΑΣΜΑΤΩΝ ΣΠΟΓΓΩΔΟΥΣ ΜΟΡΦΗΣ (ΠΕΤΣΕΤΕ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΦΑΝΤΩΝ ΘΗΛΕΙΩΤΩΝ ΥΦΑΣΜΑΤΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΑ ΕΙΔΗ ΚΟΡΔΕΛΟΠΟΙΙΑΣ) ΑΠΟ ΒΑΜΒΑΚΙ',
  },
  {
    label: '13204300',
    value:
      'ΥΦΑΝΣΗ ΑΛΛΩΝ ΘΗΛΕΙΩΤΩΝ ΥΦΑΣΜΑΤΩΝ ΣΠΟΓΓΩΔΟΥΣ ΜΟΡΦΗΣ (ΠΕΤΣΕΤΕ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΦΑΝΤΩΝ ΘΗΛΕΙΩΤΩΝ ΥΦΑΣΜΑΤΩΝ, (ΕΚΤΟΣ ΑΠΟ ΤΑ ΕΙΔΗ ΚΟΡΔΕΛΟΠΟΙΙΑΣ)',
  },
  {
    label: '13204400',
    value:
      'ΠΑΡΑΓΩΓΗ ΥΦΑΣΜΑΤΩΝ ΜΕ ΥΦΑΝΣΗ ΓΑΖΑΣ, (ΕΚΤΟΣ ΑΠΟ ΤΑ ΕΙΔΗ ΚΟΡΔΕΛΟΠΟΙΙΑΣ)',
  },
  {
    label: '13204500',
    value: 'ΥΦΑΝΣΗ ΘΥΣΑΝΩΤΩΝ ΥΦΑΝΤΙΚΩΝ ΥΛΩΝ, ΕΚΤΟΣ ΑΠΟ ΤΑΠΗΤΕΣ',
  },
  {
    label: '13204600',
    value:
      'ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ (ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΕΙΔΗ ΚΟΡΔΕΛΟΠΟΙΙΑΣ) ΑΠΟ ΓΥΑΛΙΝΕΣ ΙΝΕΣ',
  },
  {
    label: '13205000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΠΟΜΙΜΗΣΗΣ ΓΟΥΝΑΣ ΜΕ ΥΦΑΝΣΗ',
  },
  {
    label: '13209000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΕΡΓΑΣΙΑΣ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '13300000',
    value: 'ΤΕΛΕΙΟΠΟΙΗΣΗ (ΦΙΝΙΡΙΣΜΑ) ΥΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '13301000',
    value: 'ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΤΕΛΕΙΟΠΟΙΗΣΗΣ (ΦΙΝΙΡΙΣΜΑΤΟΣ)',
  },
  {
    label: '13301100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΥΚΑΝΣΗΣ ΚΑΙ ΒΑΦΗΣ ΥΦΑΝΤΙΚΩΝ ΙΝΩΝ ΚΑΙ ΝΗΜΑΤΩΝ',
  },
  {
    label: '13301200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΛΕΥΚΑΝΣΗΣ ΥΦΑΣΜΑΤΩΝ ΚΑΙ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ (ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΕΝΔΥΜΑΤΑ)',
  },
  {
    label: '13301300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΒΑΦΗΣ ΥΦΑΣΜΑΤΩΝ ΚΑΙ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ (ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ',
  },
  {
    label: '13301400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΥΠΩΜΑΤΟΣ ΥΦΑΣΜΑΤΩΝ ΚΑΙ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ (ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΕΝΔΥΜΑΤΑ)',
  },
  {
    label: '13301900',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΕΛΕΙΟΠΟΙΗΣΗΣ (ΦΙΝΙΡΙΣΜΑΤΟΣ) ΥΦΑΣΜΑΤΩΝ ΚΑΙ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ (ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΕΝΔΥΜΑΤΑ)',
  },
  {
    label: '13301901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΗΜΙΟΥΡΓΙΑΣ ΠΛΙΣΕΔΩΝ ΣΕ ΥΦΑΣΜΑΤΑ',
  },
  {
    label: '13301902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΚΟΥΜΠΟΤΡΥΠΩΝ',
  },
  {
    label: '13301903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΕΝΤΗΜΑΤΟΣ ΕΤΟΙΜΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '13301904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΛΛΑΡΙΣΜΑΤΟΣ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '13301905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΑΝΤΑΡΙΣΜΑΤΟΣ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '13910000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΕΚΤΩΝ ΥΦΑΣΜΑΤΩΝ ΚΑΙ ΥΦΑΣΜΑΤΩΝ ΠΛΕΞΗΣ ΚΡΟΣΕ',
  },
  {
    label: '13911000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΥΦΑΣΜΑΤΩΝ ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '13911100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΦΑΣΜΑΤΩΝ ΜΕ ΠΕΛΟΣ, ΘΗΛΕΙΩΤΩΝ ΥΦΑΣΜΑΤΩΝ ΣΠΟΓΓΩΔΟΥΣ ΜΟΡΦΗΣ (ΠΕΤΣΕΤΕ), ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '13911900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΥΦΑΣΜΑΤΩΝ ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ (ΠΕΡΙΛΑΜΒΑΝΕΤΑΙ Η ΑΠΟΜΙΜΗΣΗ ΓΟΥΝΑΣ ΜΕ ΠΛΕΞΙΜΟ)',
  },
  {
    label: '13919000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΥΦΑΣΜΑΤΩΝ ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '13920000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΤΟΙΜΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ, ΕΚΤΟΣ ΑΠΟ ΕΝΔΥΜΑΤΑ',
  },
  {
    label: '13921000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΤΟΙΜΩΝ ΕΙΔΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ ΓΙΑ ΤΟ ΝΟΙΚΟΚΥΡΙΟ',
  },
  {
    label: '13921100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΥΒΕΡΤΩΝ ΚΑΙ ΚΛΙΝΟΣΚΕΠΑΣΜΑΤΩΝ ΤΑΞΙΔΙΟΥ, ΕΚΤΟΣ ΑΠΟ ΗΛΕΚΤΡΙΚΕΣ ΚΟΥΒΕΡΤΕΣ',
  },
  {
    label: '13921200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΕΝΤΟΝΙΩΝ ΚΑΙ ΜΑΞΙΛΑΡΟΘΗΚΩΝ',
  },
  {
    label: '13921300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΡΑΠΕΖΟΜΑΝΤΙΛΩΝ ΚΑΙ ΠΕΤΣΕΤΩΝ ΦΑΓΗΤΟΥ',
  },
  {
    label: '13921400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΛΙΝΩΝ ΠΕΤΣΕΤΩΝ ΜΠΑΝΙΟΥ ΚΑΙ ΚΟΥΖΙΝΑΣ',
  },
  {
    label: '13921500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΑΡΑΠΕΤΑΣΜΑΤΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΣΤΟΡΙΩΝ ΓΙΑ ΕΣΩΤΕΡΙΚΟΥΣ ΧΩΡΟΥΣ· ΓΥΡΩΝ (ΠΟΔΙΩΝ) ΚΟΥΡΤΙΝΩΝ Η ΚΡΕΒΑΤΙΩΝ',
  },
  {
    label: '13921501',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΟΥΡΤΙΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΚΑΘΕ ΥΛΗ',
  },
  {
    label: '13921600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α., ΣΥΝΟΛΩΝ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ ΚΑΙ ΝΗΜΑΤΩΝ ΠΟΥ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΚΟΥΒΕΡΤΕΣ, ΤΑΠΕΤΣΑΡΙΕΣ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ',
  },
  {
    label: '13921601',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΓΧΩΡΙΩΝ ΟΙΚΙΑΚΩΝ ΥΦΑΝΤΩΝ',
  },
  {
    label: '13922000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΤΟΙΜΩΝ ΕΙΔΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ',
  },
  {
    label: '13922100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΑΚΩΝ ΚΑΙ ΣΑΚΙΔΙΩΝ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΓΙΑ ΤΗ ΣΥΣΚΕΥΑΣΙΑ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '13922101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΕΥΡΟΣΑΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '13922102',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΑΚΩΝ ΑΠΟ ΚΑΝΝΑΒΗ, ΓΙΟΥΤΑ ΚΑΙ ΑΠΟ ΑΛΛΕΣ ΥΛΕΣ',
  },
  {
    label: '13922200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΥΣΑΜΑΔΩΝ (ΚΑΛΥΜΜΑΤΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ, ΟΧΗΜΑΤΩΝ ΚΛΠ), ΕΞΩΤΕΡΙΚΩΝ ΠΡΟΠΕΤΑΣΜΑΤΩΝ (ΤΕΝΤΩΝ) ΚΑΙ ΣΚΙΑΣΤΡΩΝ· ΙΣΤΙΩΝ ΓΙΑ ΣΚΑΦΗ, ΙΣΤΙΟΣΑΝΙΔΕΣ Η ΓΙΑ ΙΣΤΙΟΦΟΡΑ ΟΧΗΜΑΤΑ ΞΗΡΑΣ· ΑΝΤΙΣΚΗΝΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΤΑΣΚΗΝΩΣΗΣ (ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΤΑ ΦΟΥΣΚΩΤΑ ΣΤΡΩΜ',
  },
  {
    label: '13922201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΑΛΥΜΜΑΤΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '13922202',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΕΝΤΩΝ, ΣΚΗΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '13922300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΕΞΙΠΤΩΤΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΠΗΔΑΛΙΟΥΧΟΥΜΕΝΑ ΑΛΕΞΙΠΤΩΤΑ) ΚΑΙ ΣΤΡΟΦΟΠΤΩΤΩΝ· ΚΑΤΑΣΚΕΥΗ ΕΞΑΡΤΗΜΑΤΩΝ ΑΥΤΩΝ',
  },
  {
    label: '13922400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΑΠΛΩΜΑΤΩΝ, ΣΤΡΩΜΑΤΩΝ, ΜΑΞΙΛΑΡΙΩΝ, ΠΑΡΑΓΕΜΙΣΜΕΝΩΝ ΧΑΜΗΛΩΝ ΚΑΘΙΣΜΑΤΩΝ (ΠΟΥΦ), ΠΡΟΣΚΕΦΑΛΙΩΝ, ΥΠΝΟΣΑΚΩΝ, ΠΟΥ ΦΕΡΟΥΝ ΕΛΑΤΗΡΙΑ Η ΕΙΝΑΙ ΠΑΡΑΓΕΜΙΣΜΕΝΑ Η ΕΠΕΝΔΥΜΕΝΑ ΕΣΩΤΕΡΙΚΑ ΜΕ ΟΠΟΙΑΔΗΠΟΤΕ ΥΛΗ, ΣΤΑ ΟΠΟΙΑ ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΕΚΕΙΝΑ ΑΠΟ ΚΥΨ',
  },
  {
    label: '13922401',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΑΠΛΩΜΑΤΩΝ',
  },
  {
    label: '13922900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΤOΙΜΩΝ ΥΦΑVΤOΥΡΓΙΚΩΝ ΕΙΔΩΝ (ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΥΦΑΣΜΑΤΑ ΓΙΑ ΤΟΝ ΚΑΘΑΡΙΣΜΟ ΠΑΤΩΜΑΤΩΝ, ΠΙΑΤΟΠΑΝΑ, ΞΕΣΚΟΝΟΠΑΝΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΥΦΑΣΜΑΤΑ ΚΑΘΑΡΙΣΜΟΥ, ΣΩΣΙΒΙΕΣ ΖΩΝΕΣ ΚΑΙ ΣΩΣΙΒΙΑ ΓΙΛΕΚΑ)',
  },
  {
    label: '13922901',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΗΜΑΙΩΝ ΚΑΙ ΛΑΒΑΡΩΝ',
  },
  {
    label: '13922902',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΝΙΩΝ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '13929000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΤΟΙΜΩΝ ΥΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ ΕΚΤΟΣ ΑΠΟ ΕΝΔΥΜΑΤΑ',
  },
  {
    label: '13929901',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΕΝΤΟΝΙΩΝ ΚΑΙ ΜΑΞΙΛΑΡΟΘΗΚΩΝ ΦΑΣΟΝ',
  },
  {
    label: '13929902',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΡΑΠΕΖΟΜΑΝΤΙΛΩΝ ΚΑΙ ΠΕΤΣΕΤΩΝ ΦΑΓΗΤΟΥ ΦΑΣΟΝ',
  },
  {
    label: '13930000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΑΛΙΩΝ ΚΑΙ ΚΙΛΙΜΙΩΝ',
  },
  {
    label: '13931100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΟΥ, ΜΕ ΚΟΜΠΟΥΣ',
  },
  {
    label: '13931200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΟΥ, ΥΦΑΣΜΕΝΩΝ, ΟΧΙ ΘΥΣΑΝΩΤΩΝ ΟΥΤΕ ΦΛΟΚΩΤΩΝ',
  },
  {
    label: '13931300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΟΥ, ΘΥΣΑΝΩΤΩΝ',
  },
  {
    label: '13931900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΧΑΛΙΩΝ ΚΑΙ ΥΦΑΝΤΙΚΩΝ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΟΥ [(ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΤΑ ΚΑΛΥΜΜΑΤΑ ΑΠΟ ΠΙΛΗΜΑ (ΤΣΟΧΑ)            ]',
  },
  {
    label: '13931901',
    value: 'ΠΑΡΑΓΩΓΗ ΒΕΛΕΝΤΖΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '13939000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΧΑΛΙΩΝ ΚΑΙ ΚΙΛΙΜΙΩΝ',
  },
  {
    label: '13940000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΟΝΤΡΩΝ ΚΑΙ ΛΕΠΤΩΝ ΣΧΟΙΝΙΩΝ, ΣΠΑΓΓΩΝ ΚΑΙ ΔΙΧΤΥΩΝ',
  },
  {
    label: '13941000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΡΔΟΝΙΩΝ, ΣΧΟΙΝΙΩΝ, ΣΠΑΓΓΩΝ ΚΑΙ ΔΙΧΤΥΩΝ, ΕΚΤΟΣ ΑΠΟ ΥΠΟΛΕΙΜΜΑΤΑ',
  },
  {
    label: '13941100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΠΑΓΓΩΝ, ΚΟΡΔΟΝΙΩΝ, ΣΧΟΙΝΙΩΝ ΚΑΙ ΚΑΛΩΔΙΩΝ, ΑΠΟ ΓΙΟΥΤΑ Η ΑΛΛΕΣ ΥΦΑΝΤΙΚΕΣ ΙΝΕΣ ΑΠΟ ΣΤΕΛΕΧΗ ΦΥΤΩΝ',
  },
  {
    label: '13941101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΟΡΔΟΝΙΩΝ ΑΠΟ ΚΑΘΕ ΥΛΗ, ΦΙΤΙΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '13941102',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΧΟΙΝΙΩΝ ΚΑΙ ΣΠΑΓΓΩΝ, ΑΠΟ ΚΑΘΕ ΥΛΗ',
  },
  {
    label: '13941200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΔΙΧΤΥΩΝ ΜΕ ΚΟΜΠΟΥΣ ΑΠΟ ΣΠΑΓΓΟΥΣ, ΚΟΡΔΟΝΙΑ Η ΣΧΟΙΝΙΑ, ΕΤΟΙΜΩΝ ΔΙΧΤΥΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ· ΕΙΔΩΝ ΑΠΟ ΝΗΜΑΤΑ, ΛΩΡΙΔΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '13941201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΡΤΑΝΩΝ ΑΠΟ ΣΧΟΙΝΙΑ',
  },
  {
    label: '13942000',
    value:
      'ΠΑΡΑΓΩΓΗ ΡΑΚΩΝ, ΑΧΡΗΣΤΩΝ ΣΠΑΓΓΩΝ, ΚΟΡΔΟΝΙΩΝ, ΣΧΟΙΝΙΩΝ ΚΑΙ ΚΑΛΩΔΙΩΝ ΚΑΙ ΦΘΑΡΜΕΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '13949000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΚΟΡΔΟΝΙΩΝ, ΣΧΟΙΝΙΩΝ, ΣΠΑΓΓΩΝ ΚΑΙ ΔΙΧΤΥΩΝ',
  },
  {
    label: '13950000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗ ΥΦΑΣΜΕΝΩΝ ΕΙΔΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΜΗ ΥΦΑΣΜΕΝΑ ΕΙΔΗ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΕΝΔΥΜΑΤΑ',
  },
  {
    label: '13959000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΜΗ ΥΦΑΣΜΕΝΩΝ ΕΙΔΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΜΗ ΥΦΑΣΜΕΝΑ ΕΙΔΗ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΕΝΔΥΜΑΤΑ',
  },
  {
    label: '13960000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΤΕΧΝΙΚΩΝ ΚΑΙ ΒΙΟΜΗΧΑΝΙΚΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '13961000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ ΝΗΜΑΤΩΝ Η ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ ΝΗΜΑΤΩΝ ΥΠΟ ΜΟΡΦΗ ΚΟΡΔΟΝΕΤΟΥ· ΥΦΑΝΣΗ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΜΕΤΑΛΛΙΚΗ ΚΛΩΣΤΗ ΚΑΙ ΑΠΟ ΕΠΙΜΕΤΑΛΛΩΜΕΝΟ ΝΗΜΑ· ΚΑΤΑΣΚΕΥΗ ΝΗΜΑΤΩΝ ΚΑΙ ΣΧΟΙΝΙΩΝ ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΕΠΙΚΑΛΥΜΜΕΝΩΝ ΜΕ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ ΚΑΙ ΕΙΔΩΝ ΚΛΩΣ',
  },
  {
    label: '13961100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ ΝΗΜΑΤΩΝ Η ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ ΝΗΜΑΤΩΝ ΥΠΟ ΜΟΡΦΗ ΚΟΡΔΟΝΕΤΟΥ',
  },
  {
    label: '13961200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΜΕΤΑΛΛΙΚΗ ΚΛΩΣΤΗ ΚΑΙ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΕΠΙΜΕΤΑΛΛΩΜΕΝΟ ΝΗΜΑ Π.Δ.Κ.Α.',
  },
  {
    label: '13961300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΝΗΜΑΤΩΝ ΚΑΙ ΣΧΟΙΝΙΩΝ ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΕΠΙΚΑΛΥΜΜΕΝΩΝ ΜΕ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ· ΥΦΑΝΤΙΚΟΥ ΝΗΜΑΤΟΣ ΚΑΙ ΛΩΡΙΔΩΝ, ΕΜΠΟΤΙΣΜΕΝΩΝ Η ΚΑΛΥΜΜΕΝΩΝ ΜΕ ΕΛΑΣΤΙΚΟ Η ΠΛΑΣΤΙΚΟ',
  },
  {
    label: '13961400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΦΑΣΜΑΤΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ, ΕΜΠΟΤΙΣΜΕΝΩΝ, ΕΠΕΝΔΥΜΕΝΩΝ Η ΕΠΙΚΑΛΥΜΜΕΝΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '13961500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΦΑΣΜΕΝΩΝ ΦΥΛΛΩΝ ΓΙΑ ΕΠΙΣΩΤΡΑ ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΠΟΥ ΛΑΜΒΑΝΟΝΤΑΙ ΑΠΟ ΝΗΜΑΤΑ ΥΨΗΛΗΣ ΑΝΤΟΧΗΣ ΑΠΟ ΝΑΙΛΟΝ Η ΑΠΟ ΑΛΛΑ ΠΟΛΥΑΜΙΔΙΑ, ΠΟΛΥΕΣΤΕΡΕΣ Η ΡΕΓΙΟΝ ΒΙΣΚΟΖΗΣ',
  },
  {
    label: '13961600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΕΙΔΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ ΓΙΑ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ (ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΦΙΤΙΛΙΑ, ΑΜΙΑΝΤΑ ΦΩΤΙΣΜΟΥ, ΕΥΚΑΜΠΤΟΙ ΣΩΛΗΝΕΣ, ΙΜΑΝΤΕΣ ΜΕΤΑΦΟΡΙΚΟΙ Η ΜΕΤΑΔΟΣΗΣ ΚΙΝΗΣΗΣ, ΓΑΖΑ ΚΑΙ ΥΦΑΣΜΑ ΓΙΑ ΚΟΣΚΙΝΑ ΚΑΙ ΦΙΛΤΡΑ)',
  },
  {
    label: '13961700',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΚΟΡΔΕΛΟΠΟΙΙΑΣ· ΤΑΙΝΙΩΝ ΧΩΡΙΣ ΥΦΑΔΙ, ΑΠΟ ΝΗΜΑΤΑ Η ΙΝΕΣ ΠΑΡΑΛΛΗΛΙΣΜΕΝΑ ΚΑΙ ΚΟΛΛΗΜΕΝΑ (BOLDUCS)· ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΓΑΡΝΙΤΟΥΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ',
  },
  {
    label: '13969000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΙΔΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ ΓΙΑ ΤΕΧΝΙΚΗ ΚΑΙ ΒΙΟΜΗΧΑΝΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '13990000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΥΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '13991000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΟΥΛΙΩΝ, ΔΑΝΤΕΛΩΝ ΚΑΙ ΚΕΝΤΗΜΑΤΩΝ· ΝΗΜΑΤΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΥΠΟ ΜΟΡΦΗ ΚΟΡΔΟΝΕΤΟΥ· ΝΗΜΑΤΩΝ ΣΕΝΙΛΛΗΣ· ΝΗΜΑΤΩΝ ΜΕ ΤΗΝ ΟΝΟΜΑΣΙΑ \\ΑΛΥΣΙΔΙΤΣΑ\\',
  },
  {
    label: '13991100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΟΥΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΚΤΥΩΤΩΝ ΥΦΑΣΜΑΤΩΝ, ΣΤΑ ΟΠΟΙΑ ΔΕΝ ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΤΑ ΥΦΑΣΜΕΝΑ, ΠΛΕΚΤΑ Η ΚΡΟΣΕ ΥΦΑΣΜΑΤΑ· ΔΑΝΤΕΛΩΝ ΣΕ ΤΟΠΙΑ, ΣΕ ΤΑΙΝΙΕΣ Η ΣΕ ΑΥΤΟΤΕΛΗ ΔΙΑΚΟΣΜΗΤΙΚΑ ΣΧΕΔΙΑ',
  },
  {
    label: '13991200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΕΝΤΗΜΑΤΩΝ ΣΕ ΤΟΠΙΑ, ΣΕ ΤΑΙΝΙΕΣ Η ΣΕ ΑΥΤΟΤΕΛΗ ΔΙΑΚΟΣΜΗΤΙΚΑ ΣΧΕΔΙΑ',
  },
  {
    label: '13991300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΙΛΗΜΑΤΟΣ (ΤΣΟΧΑΣ), ΕΠΕΝΔΥΜΕΝΟΥ, ΕΠΙΚΑΛΥΜΜΕΝΟΥ Η ΛΑΜΙΝΑΡΙΣΜΕΝΟΥ',
  },
  {
    label: '13991400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΦΑΝΤΙΚΩΝ ΙΝΩΝ ΜΕ ΜΗΚΟΣ <=5 ~ MM (ΧΝΟΥΔΙΟΥ ΑΠΟ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΤΩΝ ΥΦΑΣΜΑΤΩΝ) ΚΟΜΠΩΝ ΚΑΙ ΣΦΑΙΡΙΔΙΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '13991401',
    value: 'ΚΑΤΑΣΚΕΥΗ ΒΑΤΩΝ',
  },
  {
    label: '13991500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΝΗΜΑΤΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΥΠΟ ΜΟΡΦΗ ΚΟΡΔΟΝΕΤΟΥ· ΝΗΜΑΤΩΝ ΣΕΝΙΛΛΗΣ· ΝΗΜΑΤΩΝ ΜΕ ΤΗΝ ΟΝΟΜΑΣΙΑ \\ΑΛΥΣΙΔΙΤΣΑ\\',
  },
  {
    label: '13991600',
    value: 'ΚΑΤΑΣΚΕΥΗ ΥΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΠΙΤΟΝΕ ΣΕ ΤΟΠΙΑ',
  },
  {
    label: '13991900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΚΑΙ ΥΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '13999000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΕΙΔΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ',
  },
  {
    label: '14110000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΕΡΜΑΤΙΝΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '14111000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΝΔΥΜΑΤΩΝ ΑΠΟ ΔΕΡΜΑ ΦΥΣΙΚΟ Η ΑΝΑΣΧΗΜΑΤΙΣΜΕΝΟ',
  },
  {
    label: '14119000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΔΕΡΜΑΤΙΝΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '14120000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΝΔΥΜΑΤΩΝ ΕΡΓΑΣΙΑΣ',
  },
  {
    label: '14121000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΝΔΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ ΕΡΓΑΣΙΑΣ',
  },
  {
    label: '14121100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΔΡΙΚΩΝ ΣΥΝΟΛΩΝ, ΣΑΚΑΚΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΓΙΑ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΚΑΙ ΒΙΟΜΗΧΑΝΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '14121200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΔΡΙΚΩΝ ΠΑΝΤΕΛΟΝΙΩΝ, ΦΟΡΜΩΝ ΜΕ ΜΠΟΥΣΤΟ ΚΑΙ ΜΕ ΤΙΡΑΝΤΕΣ, ΠΑΝΤΕΛΟΝΙΩΝ ΩΣ ΤΟ ΓΟΝΑΤΟ (ΒΕΡΜΟΥΔΩΝ) ΚΑΙ ΣΟΡΤΣ, ΓΙΑ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΚΑΙ ΒΙΟΜΗΧΑΝΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '14122000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΥΝΑΙΚΕΙΩΝ ΕΝΔΥΜΑΤΩΝ ΕΡΓΑΣΙΑΣ',
  },
  {
    label: '14122100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΥΝΑΙΚΕΙΩΝ ΣΥΝΟΛΩΝ, ΣΑΚΑΚΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΓΙΑ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΚΑΙ ΒΙΟΜΗΧΑΝΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '14122200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΥΝΑΙΚΕΙΩΝ ΠΑΝΤΕΛΟΝΙΩΝ, ΦΟΡΜΩΝ ΜΕ ΜΠΟΥΣΤΟ ΚΑΙ ΜΕ ΤΙΡΑΝΤΕΣ, ΠΑΝΤΕΛΟΝΙΩΝ ΩΣ ΤΟ ΓΟΝΑΤΟ (ΒΕΡΜΟΥΔΩΝ) ΚΑΙ ΣΟΡΤΣ, ΓΙΑ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '14123000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΝΔΥΜΑΤΩΝ ΕΡΓΑΣΙΑΣ',
  },
  {
    label: '14123001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΙΕΡΑΤΙΚΩΝ ΕΝΔΥΜΑΣΙΩΝ, ΑΜΦΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '14123002',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΤΟΛΩΝ ΠΡΟΣΩΠΙΚΟΥ ΕΝΟΠΛΩΝ ΔΥΝΑΜΕΩΝ ΚΑΙ ΣΩΜΑΤΩΝ ΑΣΦΑΛΕΙΑΣ (ΣΤΡΑΤΙΩΤΙΚΩΝ ΣΤΟΛΩΝ)',
  },
  {
    label: '14129000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΝΔΥΜΑΤΩΝ ΕΡΓΑΣΙΑΣ ',
  },
  {
    label: '14130000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΞΩΤΕΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '14131000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΞΩΤΕΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14131100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΑΛΤΩΝ, ΗΜΙΠΑΛΤΩΝ, ΚΑΠΩΝ, ΕΠΕΝΔΥΤΩΝ, ΑΝΟΡΑΚ, ΑΝΤΙΑΝΕΜΙΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ, ΓΙΑ ΑΝΔΡΕΣ Η ΑΓΟΡΙΑ',
  },
  {
    label: '14131200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΣΤΟΥΜΙΩΝ, ΣΥΝΟΛΩΝ, ΣΑΚΑΚΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΠΑΝΤΕΛΟΝΙΩΝ, ΦΟΡΜΩΝ ΜΕ ΜΠΟΥΣΤΟ ΚΑΙ ΜΕ ΤΙΡΑΝΤΕΣ, ΠΑΝΤΕΛΟΝΙΩΝ ΩΣ ΤΟ ΓΟΝΑΤΟ ΚΑΙ ΣΟΡΤΣ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ, ΓΙΑ ΑΝΔΡΕΣ Η ΑΓΟΡΙΑ',
  },
  {
    label: '14131300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΑΛΤΩΝ, ΗΜΙΠΑΛΤΩΝ, ΚΑΠΩΝ, ΕΠΕΝΔΥΤΩΝ, ΑΝΟΡΑΚ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ, ΓΙΑ ΓΥΝΑΙΚΕΣ Η ΚΟΡΙΤΣΙΑ',
  },
  {
    label: '14131400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΣΤΟΥΜΙΩΝ;ΤΑΓΙΕΡ, ΣΥΝΟΛΩΝ, ΣΑΚΑΚΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΦΟΡΕΜΑΤΩΝ, ΦΟΥΣΤΩΝ, ΦΟΥΣΤΩΝ; ΠΑΝΤΕΛΟΝΙΩΝ (ΖΙΠ;ΚΙΛΟΤ), ΠΑΝΤΕΛΟΝΙΩΝ, ΦΟΡΜΩΝ ΜΕ ΤΙΡΑΝΤΕΣ (ΣΑΛΟΠΕΤ), ΚΟΝΤΩΝ ΠΑΝΤΕΛΟΝΙΩΝ ΠΟΥ ΚΑΛΥΠΤΟΥΝ ΚΑΙ ΤΟ ΓΟΝΑΤΟ (ΒΕΡΜΟΥΔΩΝ) ΚΑΙ ΠΑΝΤΕΛΟΝΙΩΝ ΚΟΝΤΩΝ (ΣΟ',
  },
  {
    label: '14132000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΞΩΤΕΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ, ΓΙΑ ΑΝΔΡΕΣ ΚΑΙ ΑΓΟΡΙΑ',
  },
  {
    label: '14132100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΑΛΤΩΝ, ΑΔΙΑΒΡΟΧΩΝ, ΗΜΙΠΑΛΤΩΝ, ΚΑΠΩΝ, ΕΠΕΝΔΥΤΩΝ, ΑΝΟΡΑΚ, ΑΝΤΙΑΝΕΜΙΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΑΝΔΡΕΣ Η ΑΓΟΡΙΑ',
  },
  {
    label: '14132200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΣΤΟΥΜΙΩΝ ΚΑΙ ΣΥΝΟΛΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΑΝΔΡΕΣ Η ΑΓΟΡΙΑ',
  },
  {
    label: '14132300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΑΚΑΚΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΑΝΔΡΕΣ Η ΑΓΟΡΙΑ',
  },
  {
    label: '14132400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΑΝΤΕΛΟΝΙΩΝ, ΦΟΡΜΩΝ ΜΕ ΜΠΟΥΣΤΟ ΚΑΙ ΜΕ ΤΙΡΑΝΤΕΣ, ΠΑΝΤΕΛΟΝΙΩΝ ΩΣ ΤΟ ΓΟΝΑΤΟ ΚΑΙ ΣΟΡΤΣ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΑΝΔΡΕΣ Η ΑΓΟΡΙΑ',
  },
  {
    label: '14133000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΞΩΤΕΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ, ΓΙΑ ΓΥΝΑΙΚΕΣ ΚΑΙ ΚΟΡΙΤΣΙΑ',
  },
  {
    label: '14133100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΑΛΤΩΝ, ΗΜΙΠΑΛΤΩΝ, ΚΑΠΩΝ, ΕΠΕΝΔΥΤΩΝ, ΑΝΟΡΑΚ, ΑΔΙΑΒΡΟΧΩΝ, ΑΝΤΙΑΝΕΜΙΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΓΥΝΑΙΚΕΣ Η ΚΟΡΙΤΣΙΑ',
  },
  {
    label: '14133200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΣΤΟΥΜΙΩΝ ΚΑΙ ΣΥΝΟΛΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΓΥΝΑΙΚΕΣ Η ΚΟΡΙΤΣΙΑ',
  },
  {
    label: '14133300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΑΚΑΚΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΓΥΝΑΙΚΕΣ Η ΚΟΡΙΤΣΙΑ',
  },
  {
    label: '14133400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΟΡΕΜΑΤΩΝ, ΦΟΥΣΤΩΝ, ΦΟΥΣΤΩΝ;ΠΑΝΤΕΛΟΝΙΩΝ (ΖΙΠ;ΚΙΛΟΤ), ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΓΥΝΑΙΚΕΣ Η ΚΟΡΙΤΣΙΑ',
  },
  {
    label: '14133500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΑΝΤΕΛΟΝΙΩΝ, ΦΟΡΜΩΝ ΜΕ ΜΠΟΥΣΤΟ ΚΑΙ ΜΕ ΤΙΡΑΝΤΕΣ, ΠΑΝΤΕΛΟΝΙΩΝ ΩΣ ΤΟ ΓΟΝΑΤΟ (ΒΕΡΜΟΥΔΩΝ) ΚΑΙ ΣΟΡΤΣ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΓΥΝΑΙΚΕΣ Η',
  },
  {
    label: '14134000',
    value:
      'ΑΝΑΚΑΤΑΣΚΕΥΗ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '14135000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΞΩΤΕΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '14135001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΑΜΠΡΙΑΤΙΚΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '14135002',
    value: 'ΚΑΤΑΣΚΕΥΗ ΝΥΦΙΚΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '14139000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΞΩΤΕΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '14139901',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΔΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ ΜΕ ΣΥΣΤΗΜΑ ΦΑΣΟΝ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΑΠΟ ΤΡΕΙΣ ΚΑΙ ΠΑΝΩ ΡΑΦΤΕΡΓΑΤΕΣ',
  },
  {
    label: '14139902',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΔΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ ΜΕ ΣΥΣΤΗΜΑ ΦΑΣΟΝ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΜΕΧΡΙ ΔΥΟ ΡΑΦΤΕΡΓΑΤΕΣ',
  },
  {
    label: '14139903',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΔΡΙΚΩΝ ΕΤΟΙΜΩΝ ΕΝΔΥΜΑΤΩΝ, ΜΕ ΣΥΣΤΗΜΑ ΦΑΣΟΝ ΓΙΑ ΟΙΚΟΥΣ ΕΞΩΤΕΡΙΚΟΥ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΑΝΩ ΤΩΝ ΠΕΝΤΕ ΕΡΓΑΤΩΝ',
  },
  {
    label: '14139904',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΥΝΑΙΚΕΙΩΝ ΕΝΔΥΜΑΤΩΝ ΜΕ ΣΥΣΤΗΜΑ ΦΑΣΟΝ, ΜΕ ΕΡΓΑΣΤΗΡΙΟ',
  },
  {
    label: '14139905',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΥΝΑΙΚΕΙΩΝ ΕΝΔΥΜΑΤΩΝ ΜΕ ΣΥΣΤΗΜΑ ΦΑΣΟΝ, ΧΩΡΙΣ ΕΡΓΑΣΤΗΡΙΟ (ΟΙΚΟΤΕΧΝΙΑ)',
  },
  {
    label: '14139906',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΥΝΑΙΚΕΙΩΝ ΕΤΟΙΜΩΝ ΕΝΔΥΜΑΤΩΝ, ΜΕ ΣΥΣΤΗΜΑ ΦΑΣΟΝ ΓΙΑ ΟΙΚΟΥΣ ΕΞΩΤΕΡΙΚΟΥ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΑΝΩ ΤΩΝ ΠΕΝΤΕ ΕΡΓΑΤΩΝ',
  },
  {
    label: '14139907',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΕΚΤΩΝ ΕΝΔΥΜΑΤΩΝ ΦΑΣΟΝ',
  },
  {
    label: '14140000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΣΩΡΟΥΧΩΝ',
  },
  {
    label: '14141000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΣΩΡΟΥΧΩΝ ΚΑΙ ΠΟΥΚΑΜΙΣΩΝ, ΠΛΕΚΤΩΝ ΚΑΙ ΚΡΟΣΕ',
  },
  {
    label: '14141100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΟΥΚΑΜΙΣΩΝ ΓΙΑ ΑΝΤΡΕΣ Η ΑΓΟΡΙΑ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14141200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΛΙΠ, ΣΩΒΡΑΚΩΝ, ΝΥΧΤΙΚΩΝ, ΠΙΤΖΑΜΩΝ, ΜΠΟΥΡΝΟΥΖΙΩΝ, ΡΟΜΠΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ, ΓΙΑ ΑΝΔΡΕΣ Η ΑΓΟΡΙΑ',
  },
  {
    label: '14141300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΠΛΟΥΖΩΝ, ΠΟΥΚΑΜΙΣΩΝ ΚΑΙ ΣΕΜΙΖΙΕ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ, ΓΙΑ ΓΥΝΑΙΚΕΣ Η ΚΟΡΙΤΣΙΑ',
  },
  {
    label: '14141400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΛΙΠ, ΚΟΜΠΙΝΕΖΟΝ Η ΜΕΣΟΦΟΡΙΩΝ, ΚΙΛΟΤΩΝ, ΝΥΧΤΙΚΩΝ, ΠΙΤΖΑΜΩΝ, ΡΟΜΠΩΝ, ΝΕΓΚΛΙΖΕ, ΜΠΟΥΡΝΟΥΖΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ, ΓΙΑ ΓΥΝΑΙΚΕΣ Η ΚΟΡΙΤΣΙΑ',
  },
  {
    label: '14142000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΣΩΡΟΥΧΩΝ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ',
  },
  {
    label: '14142100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΟΥΚΑΜΙΣΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΑΝΔΡΕΣ Η ΑΓΟΡΙΑ',
  },
  {
    label: '14142200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΑΝΕΛΑΚΙΩΝ, ΣΛΙΠ ΚΑΙ ΑΛΛΩΝ ΣΩΒΡΑΚΩΝ, ΝΥΧΤΙΚΩΝ, ΠΙΤΖΑΜΩΝ, ΜΠΟΥΡΝΟΥΖΙΩΝ, ΡΟΜΠΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΑΝΔΡΕΣ Η ΑΓΟΡΙΑ',
  },
  {
    label: '14142300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΠΛΟΥΖΩΝ, ΠΟΥΚΑΜΙΣΩΝ ΚΑΙ ΣΕΜΙΖΙΕ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΓΥΝΑΙΚΕΣ Η ΚΟΡΙΤΣΙΑ',
  },
  {
    label: '14142400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΑΝΕΛΑΚΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΣΛΙΠ, ΚΟΜΠΙΝΕΖΟΝ ΚΑΙ ΜΕΣΟΦΟΡΙΩΝ, ΚΙΛΟΤΩΝ, ΝΥΧΤΙΚΩΝ, ΠΙΤΖΑΜΩΝ, ΝΕΓΚΛΙΖΕ, ΜΠΟΥΡΝΟΥΖΙΩΝ, ΡΟΜΠΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, ΓΙΑ ΓΥΝΑΙΚΕΣ ΚΑΙ ΚΟΡΙΤΣΙΑ',
  },
  {
    label: '14142500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΤΗΘΟΔΕΣΜΩΝ, ΚΟΡΣΕΔΩΝ ΧΩΡΙΣ ΕΛΑΣΜΑΤΑ (ΛΑΣΤΕΞ), ΚΟΡΣΕΔΩΝ, ΤΙΡΑΝΤΩΝ, ΚΑΛΤΣΟΔΕΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ, ΕΙΤΕ ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ, ΕΙΤΕ ΟΧΙ',
  },
  {
    label: '14143000',
    value: 'ΚΑΤΑΣΚΕΥΗ \\T;SHIRT\\ ΚΑΙ ΦΑΝΕΛΑΚΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14149000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΣΩΡΟΥΧΩΝ',
  },
  {
    label: '14190000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ',
  },
  {
    label: '14191000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΡΕΦΙΚΩΝ ΕΝΔΥΜΑΤΩΝ, ΑΘΛΗΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΕΝΔΥΜΑΤΩΝ, ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14191100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΡΕΦΙΚΩΝ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14191101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΒΡΕΦΙΚΩΝ ΒΑΠΤΙΣΤΙΚΩΝ ΕΝΔΥΜΑΤΩΝ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14191200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΘΛΗΤΙΚΩΝ ΕΝΔΥΜΑΤΩΝ, ΣΤΟΛΩΝ ΣΚΙ, ΜΑΓΙΟ ΚΟΛΥΜΒΗΣΗΣ ΚΑΙ ΑΛΛΩΝ ΕΝΔΥΜΑΤΩΝ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14191300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΓΑΝΤΟΠΟΙΙΑΣ (ΚΟΙΝΩΝ ΓΑΝΤΙΩΝ, ΓΑΝΤΙΩΝ ΠΟΥ ΑΦΗΝΟΥΝ ΓΥΜΝΕΣ ΤΙΣ ΑΚΡΕΣ ΤΩΝ ΔΑΚΤΥΛΩΝ ΚΑΙ ΤΩΝ ΓΑΝΤΙΩΝ ΧΩΡΙΣ ΥΠΟΔΙΑΙΡΕΣΗ ΔΑΚΤΥΛΩΝ ΠΟΥ ΕΧΟΥΝ ΥΠΟΔΟΧΗ ΜΟΝΟ ΓΙΑ ΤΟΝ ΑΝΤΙΧΕΙΡΑ), ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14191900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΤΟΙΜΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ ΚΑΙ ΜΕΡΩΝ ΕΝΔΥΜΑΤΩΝ Η ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14192000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΡΕΦΙΚΩΝ ΕΝΔΥΜΑΤΩΝ, ΑΛΛΩΝ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ, ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ',
  },
  {
    label: '14192100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΡΕΦΙΚΩΝ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ',
  },
  {
    label: '14192101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΒΡΕΦΙΚΩΝ ΒΑΠΤΙΣΤΙΚΩΝ ΕΝΔΥΜΑΤΩΝ, ΟΧΙ ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14192200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΟΡΜΩΝ ΑΘΛΗΤΙΚΩΝ (ΠΡΟΠΟΝΗΣΗΣ), ΣΤΟΛΩΝ ΣΚΙ, ΜΑΓΙΟ ΚΟΛΥΜΒΗΣΗΣ· ΑΛΛΩΝ ΕΝΔΥΜΑΤΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ',
  },
  {
    label: '14192300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΑΝΤΙΛΙΩΝ ΚΑΙ ΜΑΝΤΙΛΑΚΙΩΝ ΤΣΕΠΗΣ, ΣΑΛΙΩΝ, ΕΣΑΡΠΩΝ, ΒΕΛΩΝ, ΓΡΑΒΑΤΩΝ, ΓΑΝΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΕΤΟΙΜΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ· ΜΕΡΩΝ ΕΝΔΥΜΑΤΩΝ Η ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ, Π.Δ.Κ.Α.',
  },
  {
    label: '14192301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΡΑΒΑΤΩΝ',
  },
  {
    label: '14192302',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΑΝΤΙΛΙΩΝ (ΡΙΝΟΜΑΚΤΡΩΝ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '14192303',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΑΝΤΙΛΙΩΝ ΚΕΦΑΛΗΣ (ΠΟΛΥΤΕΛΕΙΑΣ Η ΟΧΙ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '14193000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΔΕΡΜΑΤΙΝΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ· ΕΝΔΥΜΑΤΩΝ ΑΠΟ ΠΙΛΗΜΑ (ΤΣΟΧΑ) Η ΜΗ ΥΦΑΣΜΕΝΑ ΥΦΑΣΜΑΤΑ· ΕΝΔΥΜΑΤΩΝ ΑΠΟ ΕΠΙΧΡΙΣΜΕΝΕΣ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '14193100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ ΑΠΟ ΔΕΡΜΑ Η ΑΝΑΣΧΗΜΑΤΙΣΜΕΝΟ ΔΕΡΜΑ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΑΘΛΗΤΙΚΑ ΓΑΝΤΙΑ',
  },
  {
    label: '14193101',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΖΩΝΩΝ, ΓΑΝΤΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΔΕΡΜΑ Η ΑΠΟ ΑΛΛΗ ΥΛΗ',
  },
  {
    label: '14193200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΝΔΥΜΑΤΩΝ ΑΠΟ ΠΙΛΗΜΑ (ΤΣΟΧΑ) Η ΜΗ ΥΦΑΣΜΕΝΑ ΥΦΑΣΜΑΤΑ, ΕΝΔΥΜΑΤΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ ΕΜΠΟΤΙΣΜΕΝΕΣ Η ΕΠΙΧΡΙΣΜΕΝΕΣ',
  },
  {
    label: '14194000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΑΠΕΛΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΗΣ',
  },
  {
    label: '14194100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΥΠΩΝ ΚΑΠΕΛΩΝ, ΚΥΡΙΩΝ ΜΕΡΩΝ ΚΑΠΕΛΩΝ ΚΑΙ ΚΟΥΚΟΥΛΩΝ ΑΠΟ ΠΙΛΗΜΑ (ΤΣΟΧΑ) · ΔΙΣΚΩΝ ΚΑΙ ΚΥΛΙΝΔΡΩΝ ΓΙΑ ΚΑΠΕΛΑ ΑΠΟ ΠΙΛΗΜΑ· ΠΑΤΡΟΝ ΓΙΑ ΚΑΠΕΛΑ, ΠΛΕΓΜΕΝΩΝ Η ΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΜΕ ΣΥΝΑΡΜΟΛΟΓΗΣΗ ΤΑΙΝΙΩΝ, ΑΠΟ ΚΑΘΕ ΥΛΗ',
  },
  {
    label: '14194200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΠΕΛΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΗΣ ΑΠΟ ΠΙΛΗΜΑ (ΤΣΟΧΑ) Η ΠΛΕΓΜΕΝΩΝ Η ΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΜΕ ΣΥΝΑΡΜΟΛΟΓΗΣΗ ΤΑΙΝΙΩΝ, ΑΠΟ ΚΑΘΕ ΥΛΗ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ Η ΑΠΟ ΔΑΝΤΕΛΑ Η ΑΛΛΗ ΥΦΑΝΤΙΚΗ ΥΛΗ, ΣΕ ΤΟΠΙΑ· ΔΙΧΤΥΩΝ ΚΑΙ ΦΙΛΕΔΩΝ, ΓΙΑ ΤΑ ΜΑΛΛΙΑ',
  },
  {
    label: '14194201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΥΝΑΙΚΕΙΩΝ ΚΑΠΕΛΩΝ',
  },
  {
    label: '14194300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΗΣ ΕΚΤΟΣ ΑΠΟ ΚΑΛΥΜΜΑΤΑ ΚΕΦΑΛΗΣ ΑΠΟ ΚΑΟΥΤΣΟΥΚ Η ΠΛΑΣΤΙΚΟ, ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΗΣ ΑΣΦΑΛΕΙΑΣ ΚΑΙ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΗΣ ΑΠΟ ΑΜΙΑΝΤΟ· ΤΑΙΝΙΩΝ ΕΣΩΤΕΡΙΚΗΣ ΠΡΟΣΤΑΣΙΑΣ, ΕΣΩΤΕΡΙΚΩΝ ΕΠΕΝΔΥΣΕΩΝ (ΦΟΔΡΩΝ), ΚΑΛΥΜΜΑΤΩΝ, ΣΚΕΛΕΤΩΝ, ΓΕ',
  },
  {
    label: '14199000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ',
  },
  {
    label: '14200000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΟΥΝΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '14201000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΕΝΔΥΣΗΣ, ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΓΟΥΝΟΔΕΡΜΑ (ΕΚΤΟΣ ΤΩΝ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΗΣ)',
  },
  {
    label: '14201001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΝΔΥΜΑΤΩΝ ΑΠΟ ΓΟΥΝΑ, ΑΠΟΚΛΕΙΣΤΙΚΑ ΠΡΟΣ ΕΞΑΓΩΓΗ',
  },
  {
    label: '14209000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΓΟΥΝΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '14209901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΑΙ ΣΥΡΡΑΦΗΣ ΓΟΥΝΑΡΙΚΩΝ ΑΠΟ ΑΠΟΚΟΜΜΑΤΑ Η ΟΛΟΚΛΗΡΑ ΔΕΡΜΑΤΑ, ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΕΠΙΤΗΔΕΥΜΑΤΙΩΝ ΕΣΩΤΕΡΙΚΟΥ',
  },
  {
    label: '14209902',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΑΙ ΣΥΡΡΑΦΗΣ ΓΟΥΝΑΡΙΚΩΝ ΑΠΟ ΑΠΟΚΟΜΜΑΤΑ Η ΟΛΟΚΛΗΡΑ ΔΕΡΜΑΤΑ, ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΕΠΙΤΗΔΕΥΜΑΤΙΩΝ ΕΞΩΤΕΡΙΚΟΥ',
  },
  {
    label: '14209903',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΑΙ ΣΥΡΡΑΦΗΣ ΓΟΥΝΑΡΙΚΩΝ ΑΠΟ ΑΠΟΚΟΜΜΑΤΑ Η ΟΛΟΚΛΗΡΑ ΔΕΡΜΑΤΑ, ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΜΗ ΕΠΙΤΗΔΕΥΜΑΤΙΩΝ',
  },
  {
    label: '14310000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΚΑΛΤΣΟΠΟΙΙΑΣ ΑΠΛΗΣ ΠΛΕΞΗΣ ΚΑΙ ΠΛΕΞΗΣ ΚΡΟΣΕ',
  },
  {
    label: '14311000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΛΑΝ, ΚΑΛΣΟΝ, ΜΑΚΡΙΩΝ ΚΑΙ ΚΟΝΤΩΝ ΚΑΛΤΣΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΚΑΛΤΣΟΠΟΙΙΑΣ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14319000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΙΔΩΝ ΚΑΛΤΣΟΠΟΙΙΑΣ ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14390000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΛΕΚΤΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΠΛΕΞΗΣ ΚΡΟΣΕ',
  },
  {
    label: '14391000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΑΝΕΛΩΝ ΖΕΡΣΕΪ, ΠΟΥΛΟΒΕΡ, ΖΑΚΕΤΩΝ, ΓΙΛΕΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '14391001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΑΝΕΛΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΚΑΘΕ ΥΛΗ',
  },
  {
    label: '14399000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΠΛΕΚΤΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΠΛΕΞΗΣ ΚΡΟΣΕ',
  },
  {
    label: '15110000',
    value: 'ΚΑΤΕΡΓΑΣΙΑ ΚΑΙ ΔΕΨΗ ΔΕΡΜΑΤΟΣ· ΚΑΤΕΡΓΑΣΙΑ ΚΑΙ ΒΑΦΗ ΓΟΥΝΑΡΙΚΩΝ',
  },
  {
    label: '15111000',
    value: 'ΚΑΤΕΡΓΑΣΙΑ ΚΑΙ ΔΕΨΗ ΓΟΥΝΟΔΕΡΜΑΤΟΣ',
  },
  {
    label: '15112000',
    value:
      'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΟΣ ΑΙΓΑΓΡΟΥ (ΣΑΜΟΥΑ)· ΔΕΡΜΑΤΩΝ ΕΠΙΣΜΑΛΤΩΜΕΝΩΝ (ΛΟΥΣΤΡΙΝΙΩΝ) Η ΕΠΙΣΤΡΩΜΕΝΩΝ· ΔΕΡΜΑΤΩΝ ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ',
  },
  {
    label: '15112100',
    value: 'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΟΣ ΑΙΓΑΓΡΟΥ (ΣΑΜΟΥΑ)',
  },
  {
    label: '15112200',
    value:
      'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ ΕΠΙΣΜΑΛΤΩΜΕΝΩΝ (ΛΟΥΣΤΡΙΝΙΩΝ) Η ΕΠΙΣΤΡΩΜΕΝΩΝ· ΔΕΡΜΑΤΩΝ ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ',
  },
  {
    label: '15113000',
    value: 'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ, ΒΟΟΕΙΔΩΝ Η ΙΠΠΟΕΙΔΩΝ, ΑΠΟΤΡΙΧΩΜΕΝΩΝ',
  },
  {
    label: '15113100',
    value: 'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ ΒΟΟΕΙΔΩΝ, ΑΠΟΤΡΙΧΩΜΕΝΩΝ, ΟΛΟΚΛΗΡΩΝ',
  },
  {
    label: '15113200',
    value:
      'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ ΒΟΟΕΙΔΩΝ, ΑΠΟΤΡΙΧΩΜΕΝΩΝ, ΤΕΜΑΧΙΣΜΕΝΩΝ (ΟΧΙ ΟΛΟΚΛΗΡΩΝ)',
  },
  {
    label: '15113300',
    value: 'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ ΙΠΠΟΕΙΔΩΝ, ΑΠΟΤΡΙΧΩΜΕΝΩΝ',
  },
  {
    label: '15114000',
    value: 'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ ΑΙΓΟΠΡΟΒΑΤΩΝ Η ΧΟΙΡΟΕΙΔΩΝ, ΑΠΟΤΡΙΧΩΜΕΝΩΝ',
  },
  {
    label: '15114100',
    value: 'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ ΠΡΟΒΑΤΟΕΙΔΩΝ, ΑΠΟΤΡΙΧΩΜΕΝΩΝ',
  },
  {
    label: '15114200',
    value: 'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ ΑΙΓΟΕΙΔΩΝ, ΑΠΟΤΡΙΧΩΜΕΝΩΝ',
  },
  {
    label: '15114300',
    value: 'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ ΧΟΙΡΟΕΙΔΩΝ, ΑΠΟΤΡΙΧΩΜΕΝΩΝ',
  },
  {
    label: '15115000',
    value:
      'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ ΑΛΛΩΝ ΖΩΩΝ· ΑΝΑΣΧΗΜΑΤΙΣΜΕΝΩΝ ΔΕΡΜΑΤΩΝ ΜΕ ΒΑΣΗ ΤΟ ΔΕΡΜΑ',
  },
  {
    label: '15115100',
    value: 'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ ΑΛΛΩΝ ΖΩΩΝ, ΑΠΟΤΡΙΧΩΜΕΝΩΝ',
  },
  {
    label: '15115200',
    value:
      'ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΟΣ ΑΝΑΣΧΗΜΑΤΙΣΜΕΝΟΥ, ΜΕ ΒΑΣΗ ΤΟ ΔΕΡΜΑ Η ΤΙΣ ΙΝΕΣ ΤΟΥ ΔΕΡΜΑΤΟΣ',
  },
  {
    label: '15119000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΔΕΨΑΣΜΕΝΟΥ ΚΑΙ ΚΑΤΕΡΓΑΣΜΕΝΟΥ ΔΕΡΜΑΤΟΣ· ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΒΑΜΜΕΝΩΝ ΓΟΥΝΩΝ',
  },
  {
    label: '15120000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΤΑΞΙΔΙΟΥ (ΑΠΟΣΚΕΥΩΝ), ΤΣΑΝΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΕΙΔΩΝ ΣΕΛΟΠΟΙΙΑΣ ΚΑΙ ΣΑΓΜΑΤΟΠΟΙΙΑΣ',
  },
  {
    label: '15121000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΣΕΛΟΠΟΙΙΑΣ ΚΑΙ ΣΑΓΗΣ· ΑΠΟΣΚΕΥΩΝ, ΤΣΑΝΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ· ΑΛΛΩΝ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '15121100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΣΕΛΟΠΟΙΙΑΣ ΚΑΙ ΣΑΓΗΣ ΓΙΑ ΚΑΘΕ ΖΩΟ, ΑΠΟ ΚΑΘΕ ΥΛΙΚΟ',
  },
  {
    label: '15121101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΣΑΓΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '15121102',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΣΑΓΜΑΤΟΠΟΙΙΑΣ',
  },
  {
    label: '15121200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΠΟΣΚΕΥΩΝ, ΤΣΑΝΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΔΕΡΜΑ, ΑΝΑΣΧΗΜΑΤΙΣΜΕΝΟ ΔΕΡΜΑ, ΠΛΑΣΤΙΚΑ ΦΥΛΛΑ, ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΒΟΥΛΚΑΝΙΣΜΕΝΗ ΙΝΑ Η ΧΑΡΤΟΝΙ· ΣΥΝΟΛΩΝ ΕΙΔΩΝ ΤΑΞΙΔΙΟΥ ΜΕ ΕΙΔΗ ΓΙΑ ΤΗΝ ΑΤΟΜΙΚΗ ΠΕΡΙΠΟΙΗΣΗ, ΤΟ ΡΑΨΙΜΟ, ΤΟ ΚΑΘΑΡΙΣΜΑ ΤΩΝ ΥΠΟΔΗΜΑΤΩ',
  },
  {
    label: '15121201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΣΑΝΤΩΝ ΓΙΑ ΨΩΝΙΑ ΚΑΙ ΛΟΙΠΩΝ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '15121300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΛΟΥΡΙΩΝ, ΛΟΥΡΑΚΙΩΝ ΚΑΙ ΑΛΥΣΙΔΩΝ ΡΟΛΟΓΙΩΝ (ΠΛΗΝ ΤΩΝ ΜΕΤΑΛΛΙΚΩΝ) ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '15121900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΔΕΡΜΑ Η ΑΝΑΣΧΗΜΑΤΙΣΜΕΝΟ ΔΕΡΜΑ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΕΙΔΗ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΜΗΧΑΝΗΜΑΤΑ Η ΑΛΛΕΣ ΜΗΧΑΝΙΚΕΣ ΣΥΣΚΕΥΕΣ Η ΓΙΑ ΑΛΛΕΣ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ) Π.Δ.Κ.Α.',
  },
  {
    label: '15129000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΙΔΩΝ ΣΕΛΟΠΟΙΙΑΣ ΚΑΙ ΣΑΓΗΣ, ΑΠΟΣΚΕΥΩΝ, ΤΣΑΝΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '15200000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '15201000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΠΟΔΗΜΑΤΩΝ ΕΚΤΟΣ ΤΩΝ ΑΘΛΗΤΙΚΩΝ, ΤΩΝ ΠΡΟΣΤΑΤΕΥΤΙΚΩΝ ΚΑΙ ΟΡΘΟΠΕΔΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '15201100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΔΙΑΒΡΟΧΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΜΕ ΕΞΩΤΕΡΙΚΕΣ ΣΟΛΕΣ ΚΑΙ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΚΑΟΥΤΣΟΥΚ Η ΠΛΑΣΤΙΚΟ ΕΚΤΟΣ ΑΠΟ ΤΑ ΥΠΟΔΗΜΑΤΑ ΠΟΥ ΦΕΡΟΥΝ, ΣΤΟ ΜΠΡΟΣΤΙΝΟ ΜΕΡΟΣ, ΠΡΟΣΤΑΤΕΥΤΙΚΟ ΚΑΛΥΜΜΑ ΤΩΝ ΔΑΚΤΥΛΩΝ ΑΠΟ ΜΕΤΑΛΛΟ',
  },
  {
    label: '15201200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΠΟΔΗΜΑΤΩΝ ΜΕ ΕΞΩΤΕΡΙΚΕΣ ΣΟΛΕΣ ΚΑΙ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΚΑΟΥΤΣΟΥΚ Η ΠΛΑΣΤΙΚΟ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΑΔΙΑΒΡΟΧΑ Η ΑΘΛΗΤΙΚΑ ΥΠΟΔΗΜΑΤΑ',
  },
  {
    label: '15201300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΠΟΔΗΜΑΤΩΝ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΔΕΡΜΑ, ΕΚΤΟΣ ΤΩΝ ΑΘΛΗΤΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΥΠΟΔΗΜΑΤΩΝ ΠΟΥ ΦΕΡΟΥΝ, ΣΤΟ ΜΠΡΟΣΤΙΝΟ ΜΕΡΟΣ, ΠΡΟΣΤΑΤΕΥΤΙΚΟ ΚΑΛΥΜΜΑ ΤΩΝ ΔΑΚΤΥΛΩΝ ΑΠΟ ΜΕΤΑΛΛΟ ΚΑΙ ΔΙΑΦΟΡΩΝ ΕΙΔΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '15201400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΠΟΔΗΜΑΤΩΝ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ, ΕΚΤΟΣ ΤΩΝ ΑΘΛΗΤΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '15202000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΘΛΗΤΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '15202100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΠΟΔΗΜΑΤΩΝ ΑΝΤΙΣΦΑΙΡΙΣΗΣ (ΤΕΝΙΣ), ΚΑΛΑΘΟΣΦΑΙΡΙΣΗΣ, ΓΥΜΝΑΣΤΙΚΗΣ, ΠΡΟΠΟΝΗΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '15202900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΑΘΛΗΤΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΕΚΤΟΣ ΥΠΟΔΗΜΑΤΩΝ ΤΟΥ ΣΚΙ ΚΑΙ ΜΠΟΤΩΝ ΤΟΥ ΠΑΤΙΝΑΖ',
  },
  {
    label: '15203000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΡΟΣΤΑΤΕΥΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΥΠΟΔΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '15203100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΠΟΔΗΜΑΤΩΝ ΠΟΥ ΦΕΡΟΥΝ, ΣΤΟ ΜΠΡΟΣΤΙΝΟ ΜΕΡΟΣ, ΠΡΟΣΤΑΤΕΥΤΙΚΟ ΚΑΛΥΜΜΑ ΤΩΝ ΔΑΚΤΥΛΩΝ ΑΠΟ ΜΕΤΑΛΛΟ',
  },
  {
    label: '15203200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΔΙΑΦΟΡΩΝ ΕΙΔΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΥΠΟΔΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '15203201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΑΝΤΟΦΛΩΝ, ΣΑΝΔΑΛΙΩΝ ΚΛΠ',
  },
  {
    label: '15203202',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΠΟΔΗΜΑΤΩΝ, ΕΚΤΟΣ ΤΩΝ ΑΘΛΗΤΙΚΩΝ ΚΑΙ ΤΩΝ ΠΡΟΣΤΑΤΕΥΤΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΑΝΩ ΤΩΝ 12 ~ ΕΡΓΑΤΩΝ',
  },
  {
    label: '15203203',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΠΟΔΗΜΑΤΩΝ, ΕΚΤΟΣ ΤΩΝ ΑΘΛΗΤΙΚΩΝ ΚΑΙ ΤΩΝ ΠΡΟΣΤΑΤΕΥΤΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΜΕΧΡΙ 12 ~ ΕΡΓΑΤΕΣ',
  },
  {
    label: '15204000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΥΠΟΔΗΜΑΤΩΝ ΑΠΟ ΔΕΡΜΑ· ΕΣΩΤΕΡΙΚΩΝ ΚΙΝΗΤΩΝ ΠΕΛΜΑΤΩΝ, ΥΠΟΦΤΕΡΝΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ· ΓΚΕΤΩΝ, ΠΕΡΙΒΛΗΜΑΤΩΝ ΤΗΣ ΚΝΗΜΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '15204001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΥΠΟΔΗΜΑΤΟΠΟΙΙΑΣ',
  },
  {
    label: '15204002',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΟΛΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '15204003',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΑΚΟΥΝΙΩΝ ΑΠΟ ΚΑΘΕ ΥΛΗ, ΕΚΤΟΣ ΞΥΛΙΝΩΝ',
  },
  {
    label: '15204004',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΟΝΤΙΩΝ ΥΠΟΔΗΜΑΤΟΠΟΙΙΑΣ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΑΝΩ ΤΩΝ ΔΥΟ ΕΡΓΑΤΩΝ',
  },
  {
    label: '15204005',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΟΝΤΙΩΝ ΥΠΟΔΗΜΑΤΟΠΟΙΙΑΣ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΜΕΧΡΙ ΔΥΟ ΕΡΓΑΤΕΣ',
  },
  {
    label: '15209000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '16100000',
    value: 'ΠΡΙΟΝΙΣΜΑ, ΠΛΑΝΙΣΜΑ ΚΑΙ ΕΜΠΟΤΙΣΜΟΣ ΞΥΛΟΥ',
  },
  {
    label: '16101000',
    value:
      'ΠΑΡΑΓΩΓΗ ΞΥΛΕΙΑΣ, ΠΡΙΟΝΙΣΜΕΝΗΣ Η ΠΕΛΕΚΗΜΕΝΗΣ ΚΑΤΑ ΜΗΚΟΣ, ΤΕΜΑΧΙΣΜΕΝΗΣ Η ΑΠΟΦΛΟΙΩΜΕΝΗΣ, ΜΕ ΠΑΧΟΣ > 6 ~ MM · ΣΤΡΩΤΗΡΩΝ (ΤΡΑΒΕΡΣΩΝ) ΣΙΔΗΡΟΔΡΟΜΩΝ Η ΤΡΟΧΙΟΔΡΟΜΩΝ ΑΠΟ ΜΗ ΕΜΠΟΤΙΣΜΕΝΗ ΞΥΛΕΙΑ',
  },
  {
    label: '16101001',
    value: 'ΠΑΡΑΓΩΓΗ ΞΥΛΕΙΑΣ ΠΡΙΟΝΙΣΜΕΝΗΣ ΜΕ ΜΗΧΑΝΙΚΗ ΔΥΝΑΜΗ',
  },
  {
    label: '16102000',
    value:
      'ΠΑΡΑΓΩΓΗ ΞΥΛΕΙΑΣ ΣΥΝΕΧΩΣ ΔΙΑΜΟΡΦΩΜΕΝΗΣ ΚΑΤΑ ΜΗΚΟΣ ΟΠΟΙΑΣΔΗΠΟΤΕ ΑΚΡΗΣ Η ΕΠΙΦΑΝΕΙΑΣ· ΞΥΛΟΜΑΛΛΟΥ· ΞΥΛΑΛΕΥΡΟΥ· ΞΥΛΕΙΑΣ ΣΕ ΠΕΛΕΚΟΥΔΙΑ Η ΣΕ ΜΟΡΙΑ',
  },
  {
    label: '16102100',
    value:
      'ΠΑΡΑΓΩΓΗ ΞΥΛΕΙΑΣ, ΣΥΝΕΧΩΣ ΔΙΑΜΟΡΦΩΜΕΝΗΣ ΚΑΤΑ ΜΗΚΟΣ ΟΠΟΙΑΣΔΗΠΟΤΕ ΑΚΡΗΣ Η ΕΠΙΦΑΝΕΙΑΣ, ΣΤΗΝ ΟΠΟΙΑ ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΟΙ ΣΑΝΙΔΕΣ ΚΑΙ ΤΑ ΠΗΧΑΚΙΑ ΓΙΑ ΠΑΡΚΕΤΑ, ΜΗ ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΑ ΚΑΙ ΟΙ ΠΗΧΕΙΣ ΑΠΟ ΑΠΛΟ ΞΥΛΟ Η ΜΕ ΓΛΥΦΕΣ ΓΙΑ ΠΛΑΙΣΙΑ ΚΑΙ ΚΑΛΟΥΠΙΑ',
  },
  {
    label: '16102200',
    value: 'ΠΑΡΑΓΩΓΗ ΞΥΛΟΜΑΛΛΟΥ (ΑΧΥΡΟΥ ΞΥΛΟΥ)· ΞΥΛΑΛΕΥΡΟΥ',
  },
  {
    label: '16102300',
    value: 'ΠΑΡΑΓΩΓΗ ΞΥΛΕΙΑΣ ΣΕ ΠΕΛΕΚΟΥΔΙΑ Η ΣΕ ΜΟΡΙΑ',
  },
  {
    label: '16103000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΗΣ ΞΥΛΕΙΑΣ· ΣΤΡΩΤΗΡΩΝ (ΤΡΑΒΕΡΣΩΝ) ΣΙΔΗΡΟΔΡΟΜΩΝ Η ΤΡΟΧΙΟΔΡΟΜΩΝ ΑΠΟ ΞΥΛΟ, ΕΜΠΟΤΙΣΜΕΝΗΣ Η ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ ΕΠΕΞΕΡΓΑΣΜΕΝΗΣ',
  },
  {
    label: '16103100',
    value:
      'ΠΑΡΑΓΩΓΗ ΞΥΛΕΙΑΣ ΣΕ ΦΥΣΙΚΗ ΚΑΤΑΣΤΑΣΗ, ΕΠΕΞΕΡΓΑΣΜΕΝΗΣ ΜΕ ΧΡΩΜΑ, ΒΑΦΗ, ΚΡΕΟΖΩΤΟ Η ΑΛΛΑ ΣΥΝΤΗΡΗΤΙΚΑ',
  },
  {
    label: '16103200',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΤΡΩΤΗΡΩΝ (ΤΡΑΒΕΡΣΩΝ) ΣΙΔΗΡΟΔΡΟΜΩΝ Η ΤΡΟΧΙΟΔΡΟΜΩΝ ΑΠΟ ΞΥΛΟ, ΕΜΠΟΤΙΣΜΕΝΩΝ',
  },
  {
    label: '16103900',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΗΣ ΑΚΑΤΕΡΓΑΣΤΗΣ ΞΥΛΕΙΑΣ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΣΧΙΣΤΩΝ ΣΤΥΛΩΝ ΚΑΙ ΠΑΣΣΑΛΩΝ',
  },
  {
    label: '16109000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΞΗΡΑΝΣΗΣ, ΕΜΠΟΤΙΣΜΟΥ Η ΧΗΜΙΚΗΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΤΟΥ ΞΥΛΟΥ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΞΥΛΕΙΑΣ ΠΡΙΟΝΙΣΜΕΝΗΣ ΚΑΙ ΠΛΑΝΙΣΜΕΝΗΣ',
  },
  {
    label: '16109100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΞΗΡΑΝΣΗΣ, ΕΜΠΟΤΙΣΜΟΥ Η ΧΗΜΙΚΗΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΤΟΥ ΞΥΛΟΥ',
  },
  {
    label: '16109101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΞΗΡΑΝΣΗΣ ΞΥΛΟΥ',
  },
  {
    label: '16109900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΞΥΛΕΙΑΣ ΠΡΙΟΝΙΣΜΕΝΗΣ ΚΑΙ ΠΛΑΝΙΣΜΕΝΗΣ',
  },
  {
    label: '16210000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΤΙΚΟΛΛΗΤΩΝ (ΚΟΝΤΡΑ;ΠΛΑΚΕ) ΚΑΙ ΑΛΛΩΝ ΠΛΑΚΩΝ ΜΕ ΒΑΣΗ ΤΟ ΞΥΛΟ',
  },
  {
    label: '16211000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΤΙΚΟΛΛΗΤΩΝ (ΚΟΝΤΡΑ ΠΛΑΚΕ), ΕΠΕΝΔΥΜΕΝΩΝ ΞΥΛΟΦΥΛΛΩΝ (ΚΑΠΛΑΜΑ) ΚΑΙ ΠΑΡΟΜΟΙΑΣ ΕΠΙΚΟΛΛΗΤΗΣ ΞΥΛΕΙΑΣ· ΜΟΡΙΟΣΑΝΙΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΑΝΙΔΩΝ ΑΠΟ ΞΥΛΟ Η ΑΛΛΑ ΞΥΛΩΔΗ ΥΛΙΚΑ',
  },
  {
    label: '16211100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΤΙΚΟΛΛΗΤΩΝ (ΚΟΝΤΡΑ ΠΛΑΚΕ), ΕΠΕΝΔΥΜΕΝΩΝ ΞΥΛΟΦΥΛΛΩΝ (ΚΑΠΛΑΜΑ) ΚΑΙ ΠΑΡΟΜΟΙΑΣ ΕΠΙΚΟΛΛΗΤΗΣ ΞΥΛΕΙΑΣ, ΑΠΟ ΜΠΑΜΠΟΥ',
  },
  {
    label: '16211200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΑΝΤΙΚΟΛΛΗΤΩΝ, ΕΠΕΝΔΥΜΕΝΩΝ ΞΥΛΟΦΥΛΛΩΝ (ΚΑΠΛΑΜΑ) ΚΑΙ ΠΑΡΟΜΟΙΑΣ ΕΠΙΚΟΛΛΗΤΗΣ ΞΥΛΕΙΑΣ',
  },
  {
    label: '16211300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΡΙΟΣΑΝΙΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΑΝΙΔΩΝ ΑΠΟ ΞΥΛΟ Η ΑΛΛΑ ΞΥΛΩΔΗ ΥΛΙΚΑ',
  },
  {
    label: '16211400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΑΚΩΝ;ΔΙΑΦΡΑΓΜΑΤΩΝ ΑΠΟ ΙΝΕΣ ΞΥΛΟΥ Η ΑΛΛΕΣ ΞΥΛΩΔΕΙΣ ΥΛΕΣ',
  },
  {
    label: '16212000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΕΝΔΥΜΕΝΩΝ ΞΥΛΟΦΥΛΛΩΝ; ΦΥΛΛΩΝ ΓΙΑ ΑΝΤΙΚΟΛΛΗΤΑ· ΣΥΜΠΥΚΝΩΜΕΝΗΣ ΞΥΛΕΙΑΣ',
  },
  {
    label: '16212100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΕΝΔΥΜΕΝΩΝ ΞΥΛΟΦΥΛΛΩΝ ΚΑΙ ΦΥΛΛΩΝ ΓΙΑ ΑΝΤΙΚΟΛΛΗΤΑ ΚΑΙ ΑΛΛΗΣ ΞΥΛΕΙΑΣ ΠΡΙΟΝΙΣΜΕΝΗΣ ΚΑΤΑ ΜΗΚΟΣ, ΤΕΜΑΧΙΣΜΕΝΗΣ Η ΑΠΟΦΛΟΙΩΜΕΝΗΣ, ΠΑΧΟΥΣ <= 6 ;MM',
  },
  {
    label: '16212200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΜΠΥΚΝΩΜΕΝΗΣ ΞΥΛΕΙΑΣ, ΣΕ ΚΥΒΟΥΣ, ΠΛΑΚΕΣ, ΤΑΙΝΙΕΣ Η ΕΙΔΗ ΚΑΘΟΡΙΣΜΕΝΗΣ ΜΟΡΦΗΣ',
  },
  {
    label: '16219000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΕΛΕΙΟΠΟΙΗΣΗΣ (ΦΙΝΙΡΙΣΜΑΤΟΣ) ΓΙΑ ΦΥΛΛΑ ΚΑΙ ΣΑΝΙΔΕΣ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΠΕΝΔΥΜΕΝΩΝ ΞΥΛΟΦΥΛΛΩΝ ΚΑΙ ΣΑΝΙΔΩΝ ΜΕ ΒΑΣΗ ΤΟ ΞΥΛΟ',
  },
  {
    label: '16219100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΕΛΕΙΟΠΟΙΗΣΗΣ (ΦΙΝΙΡΙΣΜΑΤΟΣ) ΓΙΑ ΦΥΛΛΑ ΚΑΙ ΣΑΝΙΔΕΣ',
  },
  {
    label: '16219900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΠΕΝΔΥΜΕΝΩΝ ΞΥΛΟΦΥΛΛΩΝ ΚΑΙ ΣΑΝΙΔΩΝ ΜΕ ΒΑΣΗ ΤΟ ΞΥΛΟ',
  },
  {
    label: '16220000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΝΑΡΜΟΛΟΓΟΥΜΕΝΩΝ ΔΑΠΕΔΩΝ ΠΑΡΚΕ',
  },
  {
    label: '16221000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΝΑΡΜΟΛΟΓΟΥΜΕΝΩΝ ΣΑΝΙΔΩΝ ΔΑΠΕΔΩΝ ΠΑΡΚΕ',
  },
  {
    label: '16221001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΠΑΡΚΕΤΩΝ',
  },
  {
    label: '16221002',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΠΑΤΩΜΑΤΩΝ',
  },
  {
    label: '16229000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΣΥΝΑΡΜΟΛΟΓΟΥΜΕΝΩΝ ΔΑΠΕΔΩΝ ΠΑΡΚΕ',
  },
  {
    label: '16230000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΞΥΛΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΟΙΚΟΔΟΜΙΚΗΣ',
  },
  {
    label: '16231000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΕΧΝΟΥΡΓΗΜΑΤΩΝ ΛΕΠΤΟΞΥΛΟΥΡΓΙΚΗΣ ΚΑΙ ΧΟΝΔΡΟΞΥΛΟΥΡΓΙΚΗΣ ΓΙΑ ΟΙΚΟΔΟΜΕΣ (ΕΚΤΟΣ ΑΠΟ ΤΑ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΑ ΚΤΙΡΙΑ), ΑΠΟ ΞΥΛΟ',
  },
  {
    label: '16231100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΑΡΑΘΥΡΩΝ, ΜΠΑΛΚΟΝΟΠΟΡΤΩΝ ΚΑΙ ΠΛΑΙΣΙΩΝ ΤΟΥΣ, ΠΟΡΤΩΝ ΚΑΙ ΚΑΣΩΝ ΚΑΙ ΚΑΤΩΦΛΙΩΝ ΓΙΑ ΠΟΡΤΕΣ, ΑΠΟ ΞΥΛΟ',
  },
  {
    label: '16231101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΚΟΥΦΩΜΑΤΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '16231200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΛΟΥΠΙΩΝ ΓΙΑ ΟΙΚΟΔΟΜΙΚΟ ΣΚΥΡΟΔΕΜΑ, ΣΑΝΙΔΙΩΝ ΠΕΤΣΩΜΑΤΟΣ, ΑΠΟ ΞΥΛΟ',
  },
  {
    label: '16231900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΕΧΝΟΥΡΓΗΜΑΤΩΝ ΛΕΠΤΟΞΥΛΟΥΡΓΙΚΗΣ ΚΑΙ ΧΟΝΔΡΟΞΥΛΟΥΡΓΙΚΗΣ ΓΙΑ ΟΙΚΟΔΟΜΕΣ, ΑΠΟ ΞΥΛΟ, Π.Δ.Κ.Α.',
  },
  {
    label: '16232000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΞΥΛΙΝΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '16239000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΤΕΧΝΟΥΡΓΗΜΑΤΩΝ ΧΟΝΔΡΟΞΥΛΟΥΡΓΙΚΗΣ ΚΑΙ ΛΕΠΤΟΞΥΛΟΥΡΓΙΚΗΣ ΓΙΑ ΟΙΚΟΔΟΜΕΣ',
  },
  {
    label: '16240000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ',
  },
  {
    label: '16241100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΑΙΣΙΩΝ ΣΤΟΙΒΑΣΙΑΣ ΥΛΙΚΩΝ (ΠΑΛΕΤΩΝ), ΚΙΒΩΤΙΟΕΙΔΩΝ ΠΛΑΙΣΙΩΝ ΣΤΟΙΒΑΣΙΑΣ ΚΑΙ ΑΛΛΩΝ ΣΑΝΙΔΩΝ ΜΕΤΑΦΟΡΑΣ ΦΟΡΤΙΩΝ, ΑΠΟ ΞΥΛΟ',
  },
  {
    label: '16241200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΒΑΡΕΛΙΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΒΑΡΕΛΟΠΟΙΙΑΣ, ΑΠΟ ΞΥΛΟ',
  },
  {
    label: '16241201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΒΑΡΕΛΙΩΝ',
  },
  {
    label: '16241300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΞΥΛΙΝΩΝ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '16241301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΟΥΤΙΩΝ ΑΠΟ ΛΕΠΤΟ ΞΥΛΟ',
  },
  {
    label: '16241302',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΥΨΕΛΩΝ',
  },
  {
    label: '16249000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΞΥΛΙΝΩΝ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ',
  },
  {
    label: '16290000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΞΥΛΟ· ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΑΠΟ ΦΕΛΛΟ ΚΑΙ ΕΙΔΩΝ ΚΑΛΑΘΟΠΟΙΙΑΣ ΚΑΙ ΣΠΑΡΤΟΠΛΕΚΤΙΚΗΣ',
  },
  {
    label: '16291000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΞΥΛΟ',
  },
  {
    label: '16291100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΩΝ, ΣΤΕΛΕΧΩΝ ΕΡΓΑΛΕΙΩΝ, ΛΑΒΩΝ ΕΡΓΑΛΕΙΩΝ, ΣΤΕΛΕΧΩΝ ΚΑΙ ΛΑΒΩΝ ΓΙΑ ΣΚΟΥΠΕΣ Η ΒΟΥΡΤΣΕΣ, ΣΤΟΙΧΕΙΩΝ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΠΙΠΩΝ, ΚΑΛΑΠΟΔΙΩΝ ΓΙΑ ΜΠΟΤΕΣ Η ΠΑΠΟΥΤΣΙΑ, ΑΠΟ ΞΥΛΟ16291101 ~ ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΚΑΛΑΠΟΔΙΩΝ ΚΑΙ ΤΑΚΟΥΝΙΩΝ',
  },
  {
    label: '16291102',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΥΦΑΝΤΙΚΩΝ ΧΤΕΝΙΩΝ',
  },
  {
    label: '16291200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΠΙΤΡΑΠΕΖΙΩΝ ΚΑΙ ΜΑΓΕΙΡΙΚΩΝ ΣΚΕΥΩΝ, ΑΠΟ ΞΥΛΟ',
  },
  {
    label: '16291300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΨΗΦΙΔΟΘΕΤΗΜΑΤΩΝ ΚΑΙ ΕΝΘΕΤΙΚΗΣ ΞΥΛΙΝΗΣ ΔΙΑΚΟΣΜΗΣΗΣ ΕΠΙΠΛΩΝ, ΘΗΚΩΝ ΓΙΑ ΚΟΣΜΗΜΑΤΑ Η ΜΑΧΑΙΡΟΠΙΡΟΥΝΑ, ΑΓΑΛΜΑΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΕΙΔΩΝ, ΑΠΟ ΞΥΛΟ',
  },
  {
    label: '16291301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΨΗΦΙΔΩΤΩΝ',
  },
  {
    label: '16291400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΚΟΡΝΙΖΩΝ ΓΙΑ ΠΙΝΑΚΕΣ ΖΩΓΡΑΦΙΚΗΣ, ΦΩΤΟΓΡΑΦΙΕΣ, ΚΑΘΡΕΠΤΕΣ Η ΠΑΡΟΜΟΙΑ ΑΝΤΙΚΕΙΜΕΝΑ, ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΞΥΛΟ',
  },
  {
    label: '16291401',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΚΟΡΝΙΖΩΝ',
  },
  {
    label: '16291402',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΚΟΥΡΤΙΝΟΒΕΡΓΩΝ',
  },
  {
    label: '16291403',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΜΙΚΡΟΑΝΤΙΚΕΙΜΕΝΩΝ',
  },
  {
    label: '16291404',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΣΚΑΛΩΝ',
  },
  {
    label: '16291405',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΔΟΝΤΟΓΛΥΦΙΔΩΝ',
  },
  {
    label: '16291406',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΕΡΕΤΡΩΝ',
  },
  {
    label: '16292000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΑΠΟ ΦΕΛΛΟ, ΑΧΥΡΟ Η ΑΛΛΑ ΥΛΙΚΑ ΣΠΑΡΤΟΠΛΕΚΤΙΚΗΣ· ΕΙΔΩΝ ΚΑΛΑΘΟΠΛΕΚΤΙΚΗΣ',
  },
  {
    label: '16292100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΥΣΙΚΟΥ ΦΕΛΛΟΥ, ΠΟΥ ΤΟΥ ΕΧΕΙ ΑΦΑΙΡΕΘΕΙ Η ΕΞΩΤΕΡΙΚΗ ΚΡΟΥΣΤΑ Η ΧΟΝΔΡΙΚΑ ΤΕΤΡΑΓΩΝΙΣΜΕΝΟΥ Η ΣΕ ΚΥΒΟΥΣ, ΠΛΑΚΕΣ, ΦΥΛΛΑ Η ΤΑΙΝΙΕΣ· ΦΕΛΛΟΥ ΣΕ ΘΡΑΥΣΜΑΤΑ, ΚΟΚΚΟΥΣ Η16292200 ~ ΚΑΤΑΣΚΕΥΗ ΑΝΤΙΚΕΙΜΕΝΩΝ ΑΠΟ ΦΥΣΙΚΟ ΦΕΛΛΟ',
  },
  {
    label: '16292201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΩΜΑΤΩΝ ΑΠΟ ΦΕΛΛΟ',
  },
  {
    label: '16292300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΥΒΩΝ, ΠΛΑΚΩΝ, ΦΥΛΛΩΝ ΚΑΙ ΤΑΙΝΙΩΝ, ΠΛΑΚΑΚΙΩΝ ΚΑΘΕ ΣΧΗΜΑΤΟΣ, ΣΥΜΠΑΓΩΝ ΚΥΛΙΝΔΡΩΝ, ΑΠΟ ΣΥΣΣΩΜΑΤΩΜΕΝΟ ΦΕΛΛΟ',
  },
  {
    label: '16292400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΣΩΜΑΤΩΜΕΝΟΥ ΦΕΛΛΟΥ· ΕΙΔΩΝ ΑΠΟ ΣΥΣΣΩΜΑΤΩΜΕΝΟ ΦΕΛΛΟ Π.Δ.Κ.Α.',
  },
  {
    label: '16292500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΠΟΙΗΜΕΝΩΝ ΕΙΔΩΝ ΑΠΟ ΑΧΥΡΟ, ΣΠΑΡΤΟ Η ΑΛΛΑ ΥΛΙΚΑ ΣΠΑΡΤΟΠΛΕΚΤΙΚΗΣ· ΕΙΔΩΝ ΚΑΛΑΘΟΠΛΕΚΤΙΚΗΣ',
  },
  {
    label: '16292501',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΟΦΙΝΙΩΝ ΚΑΙ ΨΑΘΩΝ',
  },
  {
    label: '16292502',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΕΚΤΩΝ ΕΙΔΩΝ, ΕΚΤΟΣ ΑΠΟ ΕΠΙΠΛΑ',
  },
  {
    label: '17110000',
    value: 'ΠΑΡΑΓΩΓΗ ΧΑΡΤΟΠΟΛΤΟΥ',
  },
  {
    label: '17111000',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΑΡΤΟΠΟΛΤΩΝ ΑΠΟ ΞΥΛΟ Η ΑΛΛΕΣ ΙΝΩΔΕΙΣ ΚΑΙ ΚΥΤΤΑΡΙΝΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '17111100',
    value: 'ΠΑΡΑΓΩΓΗ ΧΗΜΙΚΟΥ ΞΥΛΟΠΟΛΤΟΥ, ΓΙΑ ΔΙΑΛΥΣΗ',
  },
  {
    label: '17111200',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΗΜΙΚΟΥ ΞΥΛΟΠΟΛΤΟΥ, ΣΟΔΑΣ Η ΘΕΙΙΚΟΥ ΑΛΑΤΟΣ, ΕΚΤΟΣ ΑΠΟ ΠΟΛΤΟ ΓΙΑ ΔΙΑΛΥΣΗ',
  },
  {
    label: '17111300',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΗΜΙΚΟΥ ΞΥΛΟΠΟΛΤΟΥ, ΘΕΙΩΔΟΥΣ ΑΛΑΤΟΣ, ΕΚΤΟΣ ΑΠΟ ΠΟΛΤΟ ΓΙΑ ΔΙΑΛΥΣΗ',
  },
  {
    label: '17111400',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΗΧΑΝΙΚΟΥ ΞΥΛΟΠΟΛΤΟΥ· ΗΜΙΧΗΜΙΚΟΥ ΞΥΛΟΠΟΛΤΟΥ· ΠΟΛΤΩΝ ΑΠΟ ΙΝΩΔΕΙΣ ΚΥΤΤΑΡΙΝΙΚΕΣ ΥΛΕΣ, ΕΚΤΟΣ ΑΠΟ ΞΥΛΟ',
  },
  {
    label: '17119000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΧΑΡΤΟΠΟΛΤΟΥ',
  },
  {
    label: '17120000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '17121000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΔΗΜΟΣΙΟΓΡΑΦΙΚΟΥ ΧΑΡΤΙΟΥ, ΧΕΙΡΟΠΟΙΗΤΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΑΛΛΟΥ ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ ΧΑΡΤΙΟΥ Η ΧΑΡΤΟΝΙΟΥ ΓΙΑ ΓΡΑΦΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '17121100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΗΜΟΣΙΟΓΡΑΦΙΚΟΥ ΧΑΡΤΙΟΥ ΣΕ ΚΥΛΙΝΔΡΟΥΣ Η ΣΕ ΦΥΛΛΑ',
  },
  {
    label: '17121200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΕΙΡΟΠΟΙΗΤΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '17121300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΩΣ ΒΑΣΗ ΓΙΑ ΦΩΤΟΕΥΑΙΣΘΗΤΟ, ΘΕΡΜΟΕΥΑΙΣΘΗΤΟ Η ΗΛΕΚΤΡΟΕΥΑΙΣΘΗΤΟ ΧΑΡΤΙ· ΧΑΡΤΙΟΥ ΑΠΟΤΥΠΩΤΙΚΗΣ ΒΑΣΗΣ· ΒΑΣΗΣ ΧΑΡΤΙΟΥ ΤΑΠΕΤΣΑΡΙΑΣ',
  },
  {
    label: '17121400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΓΙΑ ΓΡΑΦΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '17122000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΛΙΚΟΥ ΧΑΡΤΟΠΟΙΙΑΣ ΓΙΑ ΧΑΡΤΙ ΥΓΕΙΑΣ Η ΧΑΡΤΙ ΚΑΘΑΡΙΣΜΟΥ ΠΡΟΣΩΠΟΥ, ΧΑΡΤΟΠΕΤΣΕΤΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΧΑΡΤΟΒΑΜΒΑΚΑ ΚΑΙ ΕΠΙΠΕΔΩΝ ΕΠΙΦΑΝΕΙΩΝ ΑΠΟ ΙΝΕΣ ΚΥΤΤΑΡΙΝΗΣ',
  },
  {
    label: '17123000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΟΝΙΟΥ ΓΙΑ ΚΙΒΩΤΙΑ',
  },
  {
    label: '17123100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΟΝΔΡΟΥ ΧΑΡΤΙΟΥ ΠΕΡΙΤΥΛΙΓΜΑΤΟΣ (KRAFTLINER), ΜΗ ΛΕΥΚΑΣΜΕΝΟΥ, ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ',
  },
  {
    label: '17123200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΟΝΔΡΟΥ ΧΑΡΤΙΟΥ ΠΕΡΙΤΥΛΙΓΜΑΤΟΣ ΤΟΥ ΤΥΠΟΥ WHITE TOP KRAFTLINER· ΕΠΙΧΡΙΣΜΕΝΟΥ ΧΟΝΔΡΟΥ ΧΑΡΤΙΟΥ ΠΕΡΙΤΥΛΙΓΜΑΤΟΣ (KRAFTLINER)',
  },
  {
    label: '17123300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΜΙΧΗΜΙΚΟΥ ΑΥΛΑΚΩΤΟΥ ΧΑΡΤΙΟΥ',
  },
  {
    label: '17123400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΑΚΥΚΛΩΜΕΝΟΥ ΑΥΛΑΚΩΤΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΑΛΛΟΥ ΑΥΛΑΚΩΤΟΥ ΧΑΡΤΙΟΥ',
  },
  {
    label: '17123500',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΟΛΥΠΤΥΧΟΥ ΧΑΡΤΙΟΥ TESTLINER (ΑΝΑΚΥΚΛΩΜΕΝΩΝ ΙΝΩΝ)',
  },
  {
    label: '17124000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ ΧΑΡΤΙΟΥ',
  },
  {
    label: '17124100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ ΧΑΡΤΙΟΥ ΚΡΑΦΤ · ΧΑΡΤΙΟΥ ΚΡΑΦΤ ΓΙΑ ΣΑΚΟΥΣ, ΤΥΠΟΥ ΠΑΠΙΕ ΓΚΟΦΡΕ Η ΚΥΜΑΤΟΕΙΔΟΥΣ',
  },
  {
    label: '17124200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΟΥ ΘΕΙΩΜΕΝΟΥ ΣΥΣΚΕΥΑΣΙΑΣ ΚΑΙ ΑΛΛΟΥ ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ ΧΑΡΤΙΟΥ (ΑΛΛΟΥ ΑΠΟ ΕΚΕΙΝΟ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΤΗ ΓΡΑΦΗ, ΤΗΝ ΕΚΤΥΠΩΣΗ Η ΑΛΛΟΥΣ ΓΡΑΦΙΚΟΥΣ ΣΚΟΠΟΥΣ)',
  },
  {
    label: '17124300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΓΙΑ ΔΙΗΘΗΣΕΙΣ· ΠΙΛΗΜΑΤΟΕΙΔΟΥΣ (ΤΣΟΧΙΝΟΥ) ΧΑΡΤΙΟΥ',
  },
  {
    label: '17124400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΣΙΓΑΡΟΧΑΡΤΟΥ, ΠΟΥ ΔΕΝ ΕΧΕΙ ΚΟΠΕΙ ΣΤΙΣ ΚΑΝΟΝΙΚΕΣ ΔΙΑΣΤΑΣΕΙΣ Η ΣΕ ΜΟΡΦΗ ΦΥΛΛΑΔΙΩΝ Η ΣΩΛΗΝΩΝ',
  },
  {
    label: '17125000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ ΧΑΡΤΟΝΙΟΥ (ΑΛΛΟΥ ΑΠΟ ΕΚΕΙΝΟ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΤΗ ΓΡΑΦΗ, ΤΗΝ ΕΚΤΥΠΩΣΗ Η ΑΛΛΟΥΣ ΓΡΑΦΙΚΟΥΣ ΣΚΟΠΟΥΣ)',
  },
  {
    label: '17125100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ, ΕΣΩΤΕΡΙΚΟΥ ΓΚΡΙΖΟΥ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '17125900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΟΥ ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '17126000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΕΡΓΑΜΗΝΟΕΙΔΟΥΣ ΧΑΡΤΙΟΥ, ΑΔΙΑΒΡΟΧΟΥ ΧΑΡΤΙΟΥ (ΛΑΔΟΧΑΡΤΟΥ), ΔΙΑΦΑΝΟΥΣ ΧΑΡΤΙΟΥ ΑΝΤΙΓΡΑΦΗΣ ΚΑΙ ΧΑΡΤΙΟΥ ΓΚΛΑΣΕ ΚΑΙ ΑΛΛΩΝ ΣΤΙΛΠΝΩΝ ΔΙΑΦΑΝΩΝ Η ΗΜΙΔΙΑΦΑΝΩΝ ΧΑΡΤΙΩΝ',
  },
  {
    label: '17127000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΠΕΞΕΡΓΑΣΜΕΝΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '17127100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΝΘΕΤΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ ΕΠΙΦΑΝΕΙΑΚΑ Η ΕΜΠΟΤΙΣΜΕΝΟΥ',
  },
  {
    label: '17127200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΤΥΠΟΥ ΠΑΠΙΕ ΓΚΟΦΡΕ ΚΥΜΑΤΟΕΙΔΟΥΣ, ΑΝΑΓΛΥΦΟΥ Η ΔΙΑΤΡΗΤΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '17127300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΓΡΑΦΗ, ΕΚΤΥΠΩΣΗ Η ΑΛΛΕΣ ΓΡΑΦΙΚΕΣ ΤΕΧΝΕΣ, ΕΠΙΧΡΙΣΜΕΝΟΥ ΜΕ ΚΑΟΛΙΝΗ Η ΜΕ ΑΛΛΕΣ ΑΝΟΡΓΑΝΕΣ ΟΥΣΙΕΣ',
  },
  {
    label: '17127400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΟΝΔΡΟΥ ΧΑΡΤΙΟΥ ΚΡΑΦΤ (ΕΚΤΟΣ ΑΠΟ ΤΟ ΕΙΔΟΣ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΓΡΑΦΗ, ΕΚΤΥΠΩΣΗ Η ΑΛΛΕΣ ΓΡΑΦΙΚΕΣ ΤΕΧΝΕΣ), ΕΠΙΧΡΙΣΜΕΝΟΥ ΜΕ ΚΑΟΛΙΝΗ Η ΜΕ ΑΛΛΕΣ ΑΝΟΡΓΑΝΕΣ ΟΥΣΙΕΣ',
  },
  {
    label: '17127500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΟΝΔΡΟΥ ΧΑΡΤΟΝΙΟΥ ΚΡΑΦΤ (ΕΚΤΟΣ ΑΠΟ ΤΟ ΕΙΔΟΣ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΓΡΑΦΗ, ΕΚΤΥΠΩΣΗ Η ΣΕ ΑΛΛΕΣ ΓΡΑΦΙΚΕΣ ΤΕΧΝΕΣ), ΕΠΙΧΡΙΣΜΕΝΟΥ ΜΕ ΚΑΟΛΙΝΗ Η ΜΕ ΑΛΛΕΣ ΑΝΟΡΓΑΝΕΣ ΟΥΣΙΕΣ',
  },
  {
    label: '17127600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΠΟΤΥΠΩΤΙΚΟΥ ΧΑΡΤΙΟΥ (ΚΑΡΜΠΟΝ), ΑΥΤΟΑΝΤΙΓΡΑΦΙΚΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΑΛΛΩΝ ΧΑΡΤΙΩΝ ΓΙΑ ΑΝΤΙΓΡΑΦΗ Η ΜΕΤΑΦΟΡΑ ΚΕΙΜΕΝΩΝ, ΣΕ ΚΥΛΙΝΔΡΟΥΣ Η ΣΕ ΦΥΛΛΑ, ΠΛΑΤΟΥΣ > 36 ~ CM',
  },
  {
    label: '17127700',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΟΥ, ΧΑΡΤΟΝΙΟΥ, ΧΑΡΤΟΒΑΜΒΑΚΑ ΚΑΙ ΡΟΛΩΝ ΑΠΟ ΙΝΕΣ ΚΥΤΤΑΡΙΝΗΣ, ΕΠΙΧΡΙΣΜΕΝΩΝ, ΕΜΠΟΤΙΣΜΕΝΩΝ, ΕΠΕΝΔΥΜΕΝΩΝ, ΜΕ ΕΓΧΡΩΜΗ Η ΤΥΠΩΜΕΝΗ ΕΠΙΦΑΝΕΙΑ, ΣΕ ΚΥΛΙΝΔΡΟΥΣ Η ΣΕ ΦΥΛΛΑ',
  },
  {
    label: '17127701',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΑΡΑΦΙΝΟΧΑΡΤΟΥ ΚΑΙ ΓΟΜΜΑΡΙΣΜΕΝΟΥ ΧΑΡΤΙΟΥ',
  },
  {
    label: '17127702',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΟΥ ΚΑΤΑΛΛΗΛΟΥ ΓΙΑ ΜΟΝΩΤΙΚΟ ΥΛΙΚΟ',
  },
  {
    label: '17127800',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΟΝΔΡΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ (ΕΚΤΟΣ ΑΠΟ ΤΟ ΕΙΔΟΣ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΓΡΑΦΗ, ΕΚΤΥΠΩΣΗ Η ΑΛΛΟΥΣ ΓΡΑΦΙΚΟΥΣ ΣΚΟΠΟΥΣ), ΕΠΙΧΡΙΣΜΕΝΟΥ ΜΕ ΚΑΟΛΙΝΗ Η ΜΕ ΑΛΛΕΣ ΑΝΟΡΓΑΝΕΣ ΟΥΣΙΕΣ',
  },
  {
    label: '17127900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΟΥ ΧΑΡΤΟΝΙΟΥ (ΕΚΤΟΣ ΑΠΟ ΤΟ ΕΙΔΟΣ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΓΡΑΦΗ, ΕΚΤΥΠΩΣΗ Η ΑΛΛΟΥΣ ΓΡΑΦΙΚΟΥΣ ΣΚΟΠΟΥΣ), ΕΠΙΧΡΙΣΜΕΝΟΥ ΜΕ ΚΑΟΛΙΝΗ Η ΜΕ ΑΛΛΕΣ ΑΝΟΡΓΑΝΕΣ ΟΥΣΙΕΣ',
  },
  {
    label: '17129000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '17210000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΥΜΑΤΟΕΙΔΟΥΣ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΚΑΙ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ ΑΠΟ ΧΑΡΤΙ ΚΑΙ',
  },
  {
    label: '17211000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΥΜΑΤΟΕΙΔΟΥΣ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΚΑΙ ΚΙΒΩΤΙΩΝ ΑΠΟ ΧΑΡΤΙ ΚΑΙ ΧΑΡΤΟΝΙ',
  },
  {
    label: '17211100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΥΜΑΤΟΕΙΔΟΥΣ ΧΑΡΤΙΟΥ ΣΕ ΚΥΛΙΝΔΡΟΥΣ Η ΦΥΛΛΑ',
  },
  {
    label: '17211200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΑΚΩΝ ΚΑΙ ΤΣΑΝΤΩΝ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '17211201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΕΥΡΟΣΑΚΩΝ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '17211300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΟΚΙΒΩΤΙΩΝ, ΚΟΥΤΙΩΝ ΚΑΙ ΚΙΒΩΤΙΩΝ, ΑΠΟ ΚΥΜΑΤΟΕΙΔΕΣ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '17211400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΤΥΣΣΟΜΕΝΩΝ ΧΑΡΤΟΚΙΒΩΤΙΩΝ, ΚΟΥΤΙΩΝ ΚΑΙ ΚΙΒΩΤΙΩΝ ΑΠΟ ΜΗ ΚΥΜΑΤΟΕΙΔΕΣ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '17211401',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΤΥΣΣΟΜΕΝΩΝ ΚΙΒΩΤΙΩΝ ΑΠΟ ΧΑΡΤΟΝΙ',
  },
  {
    label: '17211402',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΚΟΥΤΙΩΝ ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '17211500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΥΤΙΩΝ ΤΑΞΙΝΟΜΗΣΗΣ ΕΓΓΡΑΦΩΝ, ΕΠΙΣΤΟΛΟΘΗΚΩΝ, ΚΟΥΤΙΩΝ ΑΡΧΕΙΟΘΕΤΗΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΓΡΑΦΕΙΑ, ΚΑΤΑΣΤΗΜΑΤΑ ΚΛΠ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '17219000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΚΥΜΑΤΟΕΙΔΟΥΣ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΚΑΙ ΚΙΒΩΤΙΩΝ ΑΠΟ ΧΑΡΤΙ ΚΑΙ ΧΑΡΤΟΝΙ',
  },
  {
    label: '17220000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΝΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ, ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΚΑΙ ΕΙΔΩΝ ΤΟΥΑΛΕΤΑΣ',
  },
  {
    label: '17221000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΟΥ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ ΚΑΙ ΧΑΡΤΙΟΥ ΥΓΕΙΑΣ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '17221100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΟΥ ΥΓΕΙΑΣ, ΧΑΡΤΟΜΑΝΤΙΛΩΝ, ΜΑΝΤΙΛΙΩΝ ΚΑΙ ΠΕΤΣΕΤΩΝ ΚΑΘΑΡΙΣΜΟΥ ΠΡΟΣΩΠΟΥ, ΤΡΑΠΕΖΟΜΑΝΤΙΛΩΝ ΚΑΙ ΠΕΤΣΕΤΩΝ ΦΑΓΗΤΟΥ ΑΠΟ ΧΑΡΤΟΠΟΛΤΟ, ΧΑΡΤΙ, ΧΑΡΤΟΒΑΜΒΑΚΑ Η ΕΠΙΠΕΔΕΣ ΕΠΙΦΑΝΕΙΕΣ ΙΝΩΝ ΚΥΤΤΑΡΙΝΗΣ',
  },
  {
    label: '17221200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΕΤΣΕΤΩΝ (ΣΕΡΒΙΕΤΩΝ) ΚΑΙ ΤΑΜΠΟΝ ΥΓΕΙΑΣ, ΑΠΟΡΡΟΦΗΤΙΚΩΝ ΠΑΝΩΝ ΓΙΑ ΒΡΕΦΗ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΓΕΙΟΝΟΜΙΚΑ ΕΙΔΩΝ, ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ, ΑΠΟ ΧΑΡΤΟΠΟΛΤΟ, ΧΑΡΤΙ, ΧΑΡΤΟΒΑΜΒΑΚΑ Η ΕΠΙΠΕΔΕΣ ΕΠΙΦΑΝΕΙΕΣ ΙΝΩΝ ΚΥΤΤΑΡΙΝΗΣ',
  },
  {
    label: '17221300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΔΙΣΚΩΝ, ΠΙΑΤΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΦΛΙΤΖΑΝΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '17229000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ, ΥΓΕΙΟΝΟΜΙΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΤΟΥΑΛΕΤΑΣ',
  },
  {
    label: '17230000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΧΑΡΤΟΠΩΛΕΙΟΥ (ΧΑΡΤΙΚΩΝ)',
  },
  {
    label: '17231100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΠΟΤΥΠΩΤΙΚΟΥ ΧΑΡΤΙΟΥ (ΚΑΡΜΠΟΝ), ΑΥΤΟΑΝΤΙΓΡΑΦΙΚΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΑΛΛΩΝ ΧΑΡΤΙΩΝ ΓΙΑ ΑΝΤΙΓΡΑΦΗ Η ΜΕΤΑΦΟΡΑ ΚΕΙΜΕΝΩΝ· ΜΕΜΒΡΑΝΩΝ ΠΟΛΥΓΡΑΦΩΝ ΚΑΙ ΠΛΑΚΩΝ ΟΦΣΕΤ ΑΠΟ ΧΑΡΤΙ· ΧΑΡΤΙΟΥ ΜΕ ΓΟΜΑ Η ΑΥΤΟΚΟΛΛΗΤΟΥ',
  },
  {
    label: '17231200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΑΚΕΛΩΝ, ΕΠΙΣΤΟΛΙΚΩΝ ΔΕΛΤΑΡΙΩΝ, ΤΑΧΥΔΡΟΜΙΚΩΝ ΔΕΛΤΑΡΙΩΝ ΚΑΙ ΔΕΛΤΑΡΙΩΝ ΑΛΛΗΛΟΓΡΑΦΙΑΣ ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ· ΚΟΥΤΙΩΝ, ΘΗΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΟΡΦΩΝ ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΣΥΛΛΟΓΗ ΕΙΔΩΝ ΑΛΛΗΛΟΓΡΑΦΙΑΣ',
  },
  {
    label: '17231201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΑΚΕΛΩΝ',
  },
  {
    label: '17231300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΙΒΛΙΩΝ ΜΗΤΡΩΩΝ, ΛΟΓΙΣΤΙΚΩΝ ΒΙΒΛΙΩΝ, ΚΛΑΣΕΡ, ΕΝΤΥΠΩΝ ΠΡΟΣ ΣΥΜΠΛΗΡΩΣΗ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΓΡΑΦΙΚΗΣ ΥΛΗΣ, ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '17231400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΓΡΑΦΗ, ΕΚΤΥΠΩΣΗ Η ΑΛΛΟΥΣ ΓΡΑΦΙΚΟΥΣ ΣΚΟΠΟΥΣ, ΤΥΠΩΜΕΝΟ, ΑΝΑΓΛΥΦΟ Η ΔΙΑΤΡΗΤΟ',
  },
  {
    label: '17231401',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΡΑΜΜΟΓΡΑΦΗΣΗΣ ΧΑΡΤΟΥ',
  },
  {
    label: '17239000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΙΔΩΝ ΧΑΡΤΟΠΩΛΕΙΟΥ (ΧΑΡΤΙΚΩΝ)',
  },
  {
    label: '17240000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΟΥ ΓΙΑ ΕΠΕΝΔΥΣΕΙΣ ΤΟΙΧΩΝ (ΤΑΠΕΤΣΑΡΙΑΣ)',
  },
  {
    label: '17241100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΡΤΙΟΥ ΓΙΑ ΕΠΕΝΔΥΣΕΙΣ ΤΟΙΧΩΝ (ΤΑΠΕΤΣΑΡΙΑΣ) ΚΑΙ ΠΑΡΟΜΟΙΕΣ ΕΠΕΝΔΥΣΕΙΣ ΤΟΙΧΩΝ· ΔΙΑΦΑΝΩΝ ΔΙΑΚΟΣΜΗΣΕΩΝ ΠΑΡΑΘΥΡΩΝ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '17241200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΠΕΝΔΥΣΕΩΝ ΤΟΙΧΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '17249000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΧΑΡΤΙΟΥ ΤΑΠΕΤΣΑΡΙΑΣ',
  },
  {
    label: '17290000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΧΑΡΤΙ ΚΑΙ ΧΑΡΤΟΝΙ',
  },
  {
    label: '17291100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΤΙΚΕΤΩΝ ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '17291200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΙΗΘΗΤΙΚΩΝ ΔΕΣΜΩΝ, ΠΛΑΚΩΝ ΚΑΙ ΦΥΛΛΩΝ, ΑΠΟ ΧΑΡΤΟΠΟΛΤΟ',
  },
  {
    label: '17291900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΣΙΓΑΡΟΧΑΡΤΟΥ· ΜΑΣΟΥΡΙΩΝ, ΚΑΡΟΥΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ· ΔΙΗΘΗΤΙΚΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ· ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΧΑΡΤΙ ΚΑΙ ΧΑΡΤΟΝΙ Π.Δ.Κ.Α.',
  },
  {
    label: '17299000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΧΑΡΤΙ ΚΑΙ ΧΑΡΤΟΝΙ',
  },
  {
    label: '18110000',
    value: 'ΕΚΤΥΠΩΣΗ ΕΦΗΜΕΡΙΔΩΝ',
  },
  {
    label: '18111000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΤΥΠΩΣΗΣ ΕΦΗΜΕΡΙΔΩΝ',
  },
  {
    label: '18120000',
    value: 'ΑΛΛΕΣ ΕΚΤΥΠΩΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '18121000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΚΤΥΠΩΣΗΣ',
  },
  {
    label: '18121100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΤΥΠΩΣΗΣ ΓΡΑΜΜΑΤΟΣΗΜΩΝ, ΧΑΡΤΟΣΗΜΩΝ, ΤΙΤΛΩΝ, ΕΥΦΥΩΝ ΚΑΡΤΩΝ, ΕΠΙΤΑΓΩΝ ΚΑΙ ΑΛΛΩΝ ΕΓΓΡΑΦΩΝ ΜΕ ΔΙΑΚΡΙΤΙΚΑ ΑΣΦΑΛΕΙΑΣ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '18121101',
    value: 'ΕΚΤΥΠΩΣΗ ΚΑΡΤΩΝ ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΗ ΜΑΓΝΗΤΙΚΗ ΤΑΙΝΙΑ',
  },
  {
    label: '18121200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΤΥΠΩΣΗΣ ΔΙΑΦΗΜΙΣΤΙΚΩΝ ΚΑΤΑΛΟΓΩΝ, ΦΥΛΛΑΔΙΩΝ, ΑΦΙΣΩΝ ΚΑΙ ΑΛΛΟΥ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΥΛΙΚΟΥ',
  },
  {
    label: '18121300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΤΥΠΩΣΗΣ ΕΦΗΜΕΡΙΔΩΝ ΚΑΙ ΠΕΡΙΟΔΙΚΩΝ, ΠΟΥ ΕΚΔΙΔΟΝΤΑΙ ΛΙΓΟΤΕΡΟ ΑΠΟ ΤΕΣΣΕΡΙΣ ΦΟΡΕΣ ΤΗΝ ΕΒΔΟΜΑΔΑ',
  },
  {
    label: '18121400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΤΥΠΩΣΗΣ ΒΙΒΛΙΩΝ, ΧΑΡΤΩΝ, ΥΔΡΟΓΡΑΦΙΚΩΝ Η ΠΑΡΟΜΟΙΩΝ ΔΙΑΓΡΑΜΜΑΤΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΕΙΚΟΝΩΝ, ΣΧΕΔΙΩΝ ΚΑΙ ΦΩΤΟΓΡΑΦΙΩΝ, ΤΑΧΥΔΡΟΜΙΚΩΝ ΔΕΛΤΑΡΙΩΝ',
  },
  {
    label: '18121401',
    value:
      'ΚΑΛΛΙΤΕΧΝΙΚΗ ΕΚΤΥΠΩΣΗ ΕΝΤΥΠΩΝ (ΕΠΙΣΚΕΠΤΗΡΙΩΝ, ΠΡΟΣΚΛΗΣΕΩΝ ΓΑΜΩΝ ΚΛΠ)',
  },
  {
    label: '18121500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΤΥΠΩΣΗΣ ΕΤΙΚΕΤΩΝ ΚΑΙ ΠΙΝΑΚΙΔΩΝ',
  },
  {
    label: '18121600',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΤΥΠΩΣΗΣ ΑΠΕΥΘΕΙΑΣ ΣΕ ΠΛΑΣΤΙΚΟ, ΓΥΑΛΙ, ΜΕΤΑΛΛΟ, ΞΥΛΟ ΚΑΙ ΠΗΛΟ',
  },
  {
    label: '18121900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΚΤΥΠΩΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '18121901',
    value: 'ΕΡΓΑΣΙΕΣ ΕΚΤΥΠΩΣΗΣ ΜΕ ΧΡΥΣΟ',
  },
  {
    label: '18121902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΤΥΠΩΣΗΣ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '18121903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΞΟΤΥΠΙΑΣ',
  },
  {
    label: '18121904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΑΜΠΩΜΑΤΟΣ Η ΕΠΙΚΟΛΛΗΣΗΣ ΧΑΛΚΟΜΑΝΙΑΣ ΕΠΙ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '18130000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΕΚΤΥΠΩΣΗΣ ΚΑΙ ΠΡΟΕΓΓΡΑΦΗΣ ΜΕΣΩΝ',
  },
  {
    label: '18131000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΕΚΤΥΠΩΣΗΣ',
  },
  {
    label: '18131001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΙΣΤΑ Η ΜΑΚΕΤΙΣΤΑ, ΕΚΤΟΣ ΔΙΑΦΗΜΙΣΗΣ',
  },
  {
    label: '18131002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΠΤΙΚΗΣ ΑΝΑΓΝΩΡΙΣΗΣ ΧΑΡΑΚΤΗΡΩΝ',
  },
  {
    label: '18131003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΕΡΕΟΤΥΠΙΑΣ',
  },
  {
    label: '18131004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΟΙΧΕΙΟΘΕΣΙΑΣ',
  },
  {
    label: '18131005',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΔΥΑΣΜΟΥ ΤΕΧΝΙΚΩΝ ΚΕΙΜΕΝΟΥ ΚΑΙ ΕΙΚΟΝΑΣ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΑΝΑΠΑΡΑΓΩΓΙΜΟΥ ΠΡΟΪΟΝΤΟΣ',
  },
  {
    label: '18131006',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΩΤΟΣΥΝΘΕΣΗΣ',
  },
  {
    label: '18131007',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΩΤΟΤΣΙΓΚΟΓΡΑΦΙΑΣ ΚΑΙ ΑΝΑΠΑΡΑΓΩΓΗΣ ΦΙΛΜ',
  },
  {
    label: '18132000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΤΥΠΩΣΗΣ ΤΥΠΟΓΡΑΦΙΚΩΝ ΠΛΑΚΩΝ Η ΚΥΛΙΝΔΡΩΝ ΚΑΙ ΑΛΛΩΝ ΕΓΧΑΡΑΚΤΩΝ ΜΕΣΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗΝ ΤΥΠΟΓΡΑΦΙΑ',
  },
  {
    label: '18132001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΜΕΤΑΞΟΤΥΠΙΩΝ & ΑΛΛΩΝ ΠΑΡΕΜΦΕΡΩΝ ΑΓΑΘΩΝ',
  },
  {
    label: '18132002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΟΙΧΕΙΟΧΥΤΗΡΙΟΥ',
  },
  {
    label: '18132003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΡΩΜΑΤΟΤΥΠΟΓΡΑΦΕΙΟΥ Η ΛΙΘΟΓΡΑΦΕΙΟΥ',
  },
  {
    label: '18133000',
    value: 'BOΗΘΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΥΝΑΦΕΙΣ ΜΕ ΤΗΝ ΕΚΤΥΠΩΣΗ',
  },
  {
    label: '18133001',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΡΕΠΡΟΓΡΑΦΙΚΩΝ ΠΡΟΪΟΝΤΩΝ,            [Π.Χ. ΦΥΛΛΩΝ (ΔΙΑΦΑΝΕΙΩΝ) ΟΠΙΣΘΟΠΡΟΒΟΛΕΩΝ, ΣΚΑΡΙΦΗΜΑΤΩΝ, ΜΑΚΕΤΩΝ, ΟΜΟΙΩΜΑΤΩΝ, ΤΟΠΟΓΡΑΦΙΚΩΝ ΣΧΕΔΙΑΓΡΑΜΜΑΤΩΝ            ]',
  },
  {
    label: '18133002',
    value:
      'ΠΡΟΕΤΟΙΜΑΣΙΑ ΨΗΦΙΑΚΩΝ ΔΕΔΟΜΕΝΩΝ (Π.Χ. ΒΕΛΤΙΩΣΗ, ΕΠΙΛΟΓΗ, ΔΙΑΣΥΝΔΕΣΗ ΨΗΦΙΑΚΩΝ ΔΕΔΟΜΕΝΩΝ ΑΠΟΘΗΚΕΥΜΕΝΩΝ ΣΕ ΦΟΡΕΙΣ ΗΛΕΚΤΡΟΝΙΚΗΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ), ΣΥΝΑΦΩΝ ΜΕ ΤΗΝ ΕΚΤΥΠΩΣΗ',
  },
  {
    label: '18133003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΣΕΤΙΣΤΑ',
  },
  {
    label: '18140000',
    value: 'ΒΙΒΛΙΟΔΕΤΙΚΕΣ ΚΑΙ ΣΥΝΑΦΕΙΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '18141001',
    value:
      'ΑΛΛΕΣ ΕΡΓΑΣΙΕΣ ΤΕΛΕΙΩΜΑΤΟΣ ΕΝΤΥΠΩΝ (Π.Χ. ΔΙΠΛΩΣΗ, ΚΟΠΗ, ΕΚΤΥΠΩΣΗ, ΔΙΑΤΡΗΣΗ ΜΗ ΠΡΟΔΙΑΜΟΡΦΩΜΕΝΩΝ ΟΠΩΝ, ΔΙΑΤΜΗΤΙΚΗ ΔΙΑΤΡΗΣΗ, ΔΙΑΤΡΗΣΗ, ΑΝΑΓΛΥΦΗ ΑΠΟΤΥΠΩΣΗ, ΚΟΛΛΗΣΗ ΚΑΙ ΔΙΑΧΩΡΙΣΜΟΣ ΣΕ ΛΕΠΤΑ ΦΥΛΛΑ)',
  },
  {
    label: '18141002',
    value: 'ΕΡΓΑΣΙΕΣ ΕΠΑΝΑΔΕΣΙΜΑΤΟΣ ΕΝΤΥΠΩΝ',
  },
  {
    label: '18141003',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΒΙΒΛΙΟΔΕΣΙΑΣ, ΔΙΠΛΩΣΗΣ, ΣΥΝΘΕΣΗΣ, ΣΥΡΡΑΦΗΣ, ΚΟΛΛΗΣΗΣ, ΔΙΑΤΑΞΙΝΟΜΗΣΗΣ, ΠΑΡΑΡΑΦΗΣ, ΔΕΣΙΜΑΤΟΣ ΜΕ ΑΥΤΟΚΟΛΛΗΤΗ ΤΑΙΝΙΑ, ΞΑΚΡΙΣΜΑΤΟΣ ΕΝΤΥΠΩΝ',
  },
  {
    label: '18200000',
    value: 'ΑΝΑΠΑΡΑΓΩΓΗ ΠΡΟΕΓΓΕΓΡΑΜΜΕΝΩΝ ΜΕΣΩΝ',
  },
  {
    label: '18201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΠΑΡΑΓΩΓΗΣ ΗΧΟΓΡΑΦΗΣΗΣ',
  },
  {
    label: '18202000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΠΑΡΑΓΩΓΗΣ ΒΙΝΤΕΟΕΓΓΡΑΦΗΣ',
  },
  {
    label: '18203000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΠΑΡΑΓΩΓΗΣ ΛΟΓΙΣΜΙΚΟΥ',
  },
  {
    label: '19100000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΟΪΟΝΤΩΝ ΟΠΤΑΝΘΡΑΚΟΠΟΙΗΣΗΣ (ΚΟΚΟΠΟΙΗΣΗΣ)',
  },
  {
    label: '19101000',
    value:
      'ΠΑΡΑΓΩΓΗ ΟΠΤΑΝΘΡΑΚΑ ΚΑΙ ΗΜΙΟΠΤΑΝΘΡΑΚΑ ΑΠΟ ΛΙΘΑΝΘΡΑΚΑ, ΛΙΓΝΙΤΗ Η ΤΥΡΦΗ· ΑΝΘΡΑΚΑ ΑΠΟΣΤΑΚΤΙΚΟΥ ΚΕΡΑΤΟΣ',
  },
  {
    label: '19102000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΙΣΣΩΝ ΑΠΟ ΛΙΘΑΝΘΡΑΚΑ, ΛΙΓΝΙΤΗ Η ΤΥΡΦΗ· ΑΛΛΩΝ ΟΡΥΚΤΩΝ ΠΙΣΣΩΝ',
  },
  {
    label: '19103000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΙΣΣΑΣ ΚΑΙ ΠΙΣΣΑΣΦΑΛΤΟΥ',
  },
  {
    label: '19109000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΡΟΪΟΝΤΩΝ ΟΠΤΑΝΘΡΑΚΟΠΟΙΗΣΗΣ',
  },
  {
    label: '19200000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΟΪΟΝΤΩΝ ΔΙΥΛΙΣΗΣ ΠΕΤΡΕΛΑΙΟΥ',
  },
  {
    label: '19201000',
    value: 'ΠΑΡΑΓΩΓΗ ΜΠΡΙΚΕΤΩΝ, ΣΦΑΙΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΤΕΡΕΩΝ ΚΑΥΣΙΜΩΝ',
  },
  {
    label: '19201100',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΠΡΙΚΕΤΩΝ, ΣΦΑΙΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΤΕΡΕΩΝ ΚΑΥΣΙΜΩΝ ΠΟΥ ΠΑΡΑΓΟΝΤΑΙ ΑΠΟ ΤΟΝ ΑΝΘΡΑΚΑ',
  },
  {
    label: '19201200',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΠΡΙΚΕΤΩΝ, ΣΦΑΙΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΤΕΡΕΩΝ ΚΑΥΣΙΜΩΝ ΠΟΥ ΠΑΡΑΓΟΝΤΑΙ ΑΠΟ ΤΟΝ ΛΙΓΝΙΤΗ',
  },
  {
    label: '19201300',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΠΡΙΚΕΤΩΝ, ΣΦΑΙΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΤΕΡΕΩΝ ΚΑΥΣΙΜΩΝ ΠΟΥ ΠΑΡΑΓΟΝΤΑΙ ΑΠΟ ΤΗΝ ΤΥΡΦΗ',
  },
  {
    label: '19202000',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΥΣΙΜΩΝ ΕΛΑΙΩΝ ΚΑΙ ΑΕΡΙΩΝ· ΛΙΠΑΝΤΙΚΩΝ ΕΛΑΙΩΝ',
  },
  {
    label: '19202100',
    value:
      'ΠΑΡΑΓΩΓΗ ΒΕΝΖΙΝΗΣ ΑΥΤΟΚΙΝΗΤΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΗΣ ΤΗΣ ΒΕΝΖΙΝΗΣ ΑΕΡΟΣΚΑΦΩΝ',
  },
  {
    label: '19202200',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΥΣΙΜΩΝ ΑΕΡΙΩΘΟΥΜΕΝΩΝ ΑΕΡΟΣΚΑΦΩΝ, ΤΥΠΟΥ ΒΕΝΖΙΝΗΣ',
  },
  {
    label: '19202300',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΛΑΦΡΩΝ ΛΙΠΑΝΤΙΚΩΝ ΕΛΑΙΩΝ ΠΕΤΡΕΛΑΙΟΥ· ΕΛΑΦΡΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '19202400',
    value: 'ΠΑΡΑΓΩΓΗ ΚΗΡΟΖΙΝΗΣ',
  },
  {
    label: '19202500',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΥΣΙΜΩΝ ΤΥΠΟΥ ΚΗΡΟΖΙΝΗΣ ΑΕΡΙΩΘΟΥΜΕΝΩΝ ΑΕΡΟΣΚΑΦΩΝ',
  },
  {
    label: '19202600',
    value: 'ΠΑΡΑΓΩΓΗ ΑΕΡΙΕΛΑΙΩΝ',
  },
  {
    label: '19202700',
    value: 'ΠΑΡΑΓΩΓΗ ΜΕΣΩΝ ΕΛΑΙΩΝ ΠΕΤΡΕΛΑΙΟΥ· ΜΕΣΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '19202800',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΥΣΙΜΩΝ ΕΛΑΙΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '19202900',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΙΠΑΝΤΙΚΩΝ ΕΛΑΙΩΝ ΠΕΤΡΕΛΑΙΟΥ· ΒΑΡΕΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '19203000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΕΡΙΩΝ ΠΕΤΡΕΛΑΙΟΥ ΚΑΙ ΑΛΛΩΝ ΑΕΡΙΩΝ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ, ΕΚΤΟΣ ΤΟΥ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '19203100',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΟΠΑΝΙΟΥ ΚΑΙ ΒΟΥΤΑΝΙΟΥ, ΥΓΡΟΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '19203200',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΙΘΥΛΕΝΙΟΥ, ΠΡΟΠΥΛΕΝΙΟΥ, ΒΟΥΤΥΛΕΝΙΟΥ, ΒΟΥΤΑΔΙΕΝΙΟΥ ΚΑΙ ΑΛΛΩΝ ΑΕΡΙΩΝ ΠΕΤΡΕΛΑΙΟΥ Η ΑΕΡΙΩΝ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ, ΕΚΤΟΣ ΤΟΥ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '19204000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΠΕΤΡΕΛΑΙΟΥ',
  },
  {
    label: '19204100',
    value:
      'ΠΑΡΑΓΩΓΗ ΒΑΖΕΛΙΝΗΣ· ΣΚΛΗΡΗΣ ΠΑΡΑΦΙΝΗΣ· ΠΕΤΡΕΛΑΪΚΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΥΚΤΩΝ ΚΕΡΙΩΝ',
  },
  {
    label: '19204200',
    value:
      'ΠΑΡΑΓΩΓΗ ΟΠΤΑΝΘΡΑΚΑ (ΚΟΚ) ΑΠΟ ΠΕΤΡΕΛΑΙΟ· ΑΣΦΑΛΤΟΥ ΑΠΟ ΠΕΤΡΕΛΑΙΟ ΚΑΙ ΑΛΛΩΝ ΚΑΤΑΛΟΙΠΩΝ ΤΩΝ ΕΛΑΙΩΝ ΠΕΤΡΕΛΑΙΟΥ',
  },
  {
    label: '19209000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΡΟΪΟΝΤΩΝ ΔΙΥΛΙΣΗΣ ΠΕΤΡΕΛΑΙΟΥ',
  },
  {
    label: '20110000',
    value: 'ΠΑΡΑΓΩΓΗ ΒΙΟΜΗΧΑΝΙΚΩΝ ΑΕΡΙΩΝ',
  },
  {
    label: '20111100',
    value: 'ΠΑΡΑΓΩΓΗ ΥΔΡΟΓΟΝΟΥ, ΑΡΓΟΥ, ΣΠΑΝΙΩΝ ΑΕΡΙΩΝ, ΑΖΩΤΟΥ ΚΑΙ ΟΞΥΓΟΝΟΥ',
  },
  {
    label: '20111101',
    value: 'ΠΑΡΑΓΩΓΗ ΜΕΙΓΜΑΤΩΝ ΒΙΟΜΗΧΑΝΙΚΩΝ ΑΕΡΙΩΝ',
  },
  {
    label: '20111102',
    value: 'ΠΑΡΑΓΩΓΗ ΟΞΥΓΟΝΟΥ',
  },
  {
    label: '20111200',
    value:
      'ΠΑΡΑΓΩΓΗ ΔΙΟΞΕΙΔΙΟΥ ΤΟΥ ΑΝΘΡΑΚΑ ΚΑΙ ΑΛΛΩΝ ΑΝΟΡΓΑΝΩΝ ΟΞΥΓΟΝΟΥΧΩΝ ΕΝΩΣΕΩΝ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΣΤΟΙΧΕΙΩΝ',
  },
  {
    label: '20111300',
    value: 'ΠΑΡΑΓΩΓΗ ΥΓΡΟΥ ΚΑΙ ΠΕΠΙΕΣΜΕΝΟΥ ΑΕΡΑ',
  },
  {
    label: '20111301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΕΠΙΕΣΜΕΝΟΥ ΑΕΡΑ ΠΟΥ ΔΙΑΝΕΜΕΤΑΙ ΜΕ ΑΓΩΓΟΥΣ',
  },
  {
    label: '20119000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΒΙΟΜΗΧΑΝΙΚΩΝ ΑΕΡΙΩΝ',
  },
  {
    label: '20120000',
    value: 'ΠΑΡΑΓΩΓΗ ΧΡΩΣΤΙΚΩΝ ΥΛΩΝ',
  },
  {
    label: '20121000',
    value: 'ΠΑΡΑΓΩΓΗ ΟΞΕΙΔΙΩΝ, ΥΠΕΡΟΞΕΙΔΙΩΝ ΚΑΙ ΥΔΡΟΞΕΙΔΙΩΝ',
  },
  {
    label: '20121100',
    value:
      'ΠΑΡΑΓΩΓΗ ΟΞΕΙΔΙΟΥ ΚΑΙ ΥΠΕΡΟΞΕΙΔΙΟΥ ΤΟΥ ΨΕΥΔΑΡΓΥΡΟΥ· ΟΞΕΙΔΙΩΝ ΤΟΥ ΤΙΤΑΝΙΟΥ',
  },
  {
    label: '20121200',
    value:
      'ΠΑΡΑΓΩΓΗ ΟΞΕΙΔΙΩΝ ΚΑΙ ΥΔΡΟΞΕΙΔΙΩΝ ΤΟΥ ΧΡΩΜΙΟΥ, ΤΟΥ ΜΑΓΓΑΝΙΟΥ, ΤΟΥ ΜΟΛΥΒΔΟΥ ΚΑΙ ΤΟΥ ΧΑΛΚΟΥ',
  },
  {
    label: '20121900',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΜΕΤΑΛΛΙΚΩΝ ΟΞΕΙΔΙΩΝ, ΥΔΡΟΞΕΙΔΙΩΝ ΚΑΙ ΥΠΕΡΟΞΕΙΔΙΩΝ',
  },
  {
    label: '20122000',
    value:
      'ΠΑΡΑΓΩΓΗ ΔΕΨΙΚΩΝ Η ΒΑΦΙΚΩΝ ΕΚΧΥΛΙΣΜΑΤΩΝ· ΤΑΝΝΙΝΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ· ΧΡΩΣΤΙΚΩΝ ΥΛΩΝ',
  },
  {
    label: '20122100',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΥΝΘΕΤΙΚΩΝ ΟΡΓΑΝΙΚΩΝ ΧΡΩΣΤΙΚΩΝ ΥΛΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΠΟΥ ΒΑΣΙΖΟΝΤΑΙ ΣΕ ΑΥΤΕΣ· ΟΡΓΑΝΙΚΩΝ ΣΥΝΘΕΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΤΩΝ ΤΥΠΩΝ ΕΚΕΙΝΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΩΣ ΠΑΡΑΓΟΝΤΕΣ ΤΟΝΩΣΗΣ ΤΟΥ ΦΘΟΡΙΣΜΟΥ Η ΩΣ ΦΩΤΟΦΟΡΑ· ΧΡΩΣΤΙΚΩΝ ΛΑΚΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑ',
  },
  {
    label: '20122200',
    value:
      'ΠΑΡΑΓΩΓΗ ΔΕΨΙΚΩΝ ΕΚΧΥΛΙΣΜΑΤΩΝ ΦΥΤΙΚΗΣ ΠΡΟΕΛΕΥΣΗΣ· ΤΑΝΝΙΝΩΝ ΚΑΙ ΤΩΝ ΑΛΑΤΩΝ, ΑΙΘΕΡΩΝ, ΕΣΤΕΡΩΝ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ· ΧΡΩΣΤΙΚΩΝ ΥΛΩΝ ΦΥΤΙΚΗΣ Η ΖΩΙΚΗΣ ΠΡΟΕΛΕΥΣΗΣ',
  },
  {
    label: '20122300',
    value:
      'ΠΑΡΑΓΩΓΗ ΔΕΨΙΚΩΝ ΣΥΝΘΕΤΙΚΩΝ ΟΡΓΑΝΙΚΩΝ ΠΡΟΪΟΝΤΩΝ· ΔΕΨΙΚΩΝ ΑΝΟΡΓΑΝΩΝ ΠΡΟΪΟΝΤΩΝ· ΔΕΨΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ· ΕΝΖΥΜΑΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΡΟΕΡΓΑΣΙΑ ΤΗΣ ΔΕΨΗΣ',
  },
  {
    label: '20122400',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΡΩΣΤΙΚΩΝ ΥΛΩΝ Π.Δ.Κ.Α.· ΑΝΟΡΓΑΝΩΝ ΠΡΟΪΟΝΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΩΣ ΦΩΤΟΦΟΡΑ',
  },
  {
    label: '20129000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΧΡΩΜΑΤΩΝ ΚΑΙ ΧΡΩΣΤΙΚΩΝ ΥΛΩΝ',
  },
  {
    label: '20130000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΑΝΟΡΓΑΝΩΝ ΒΑΣΙΚΩΝ ΧΗΜΙΚΩΝ ΟΥΣΙΩΝ',
  },
  {
    label: '20131000',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΜΠΛΟΥΤΙΣΜΕΝΟΥ ΟΥΡΑΝΙΟΥ ΚΑΙ ΠΛΟΥΤΩΝΙΟΥ· ΕΞΑΝΤΛΗΜΕΝΟΥ ΟΥΡΑΝΙΟΥ ΚΑΙ ΘΟΡΙΟΥ· ΑΛΛΩΝ ΡΑΔΙΕΝΕΡΓΩΝ ΣΤΟΙΧΕΙΩΝ',
  },
  {
    label: '20131100',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΜΠΛΟΥΤΙΣΜΕΝΟΥ ΟΥΡΑΝΙΟΥ ΚΑΙ ΠΛΟΥΤΩΝΙΟΥ ΚΑΙ ΤΩΝ ΕΝΩΣΕΩΝ ΤΟΥΣ',
  },
  {
    label: '20131200',
    value: 'ΠΑΡΑΓΩΓΗ ΕΞΑΝΤΛΗΜΕΝΟΥ ΟΥΡΑΝΙΟΥ ΚΑΙ ΘΟΡΙΟΥ ΚΑΙ ΤΩΝ ΕΝΩΣΕΩΝ ΤΟΥΣ',
  },
  {
    label: '20131300',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΡΑΔΙΕΝΕΡΓΩΝ ΣΤΟΙΧΕΙΩΝ, ΙΣΟΤΟΠΩΝ ΚΑΙ ΕΝΩΣΕΩΝ ΤΟΥΣ· ΚΡΑΜΑΤΩΝ, ΔΙΑΣΠΟΡΩΝ, ΚΕΡΑΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΜΕΙΓΜΑΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΑΥΤΑ ΤΑ ΣΤΟΙΧΕΙΑ, ΙΣΟΤΟΠΩΝ Η ΕΝΩΣΕΩΝ',
  },
  {
    label: '20131400',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΑΥΣΙΜΩΝ ΣΤΟΙΧΕΙΩΝ (ΚΑΣΕΤΩΝ), ΠΟΥ ΔΕΝ ΕΧΟΥΝ ΑΚΤΙΝΟΒΟΛΗΘΕΙ, ΓΙΑ ΠΥΡΗΝΙΚΟΥΣ ΑΝΤΙΔΡΑΣΤΗΡΕΣ',
  },
  {
    label: '20132000',
    value: 'ΠΑΡΑΓΩΓΗ ΧΗΜΙΚΩΝ ΣΤΟΙΧΕΙΩΝ Π.Δ.Κ.Α.· ΑΝΟΡΓΑΝΩΝ ΟΞΕΩΝ ΚΑΙ ΕΝΩΣΕΩΝ',
  },
  {
    label: '20132100',
    value: 'ΠΑΡΑΓΩΓΗ ΜΕΤΑΛΛΟΕΙΔΩΝ',
  },
  {
    label: '20132200',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΟΓΟΝΩΜΕΝΩΝ Η ΘΕΙΟΥΧΩΝ ΕΝΩΣΕΩΝ ΤΩΝ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΣΤΟΙΧΕΙΩΝ',
  },
  {
    label: '20132300',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΕΤΑΛΛΩΝ ΑΛΚΑΛΙΩΝ Η ΑΛΚΑΛΙΚΩΝ ΓΑΙΩΝ· ΜΕΤΑΛΛΩΝ ΣΠΑΝΙΩΝ ΓΑΙΩΝ, ΣΚΑΝΔΙΟΥ ΚΑΙ ΥΤΤΡΙΟΥ· ΥΔΡΑΡΓΥΡΟΥ',
  },
  {
    label: '20132400',
    value:
      'ΠΑΡΑΓΩΓΗ ΥΔΡΟΧΛΩΡΙΟΥ· ΔΙΘΕΙΙΚΟΥ ΟΞΕΩΣ· ΔΙΦΩΣΦΟΡΙΚΟΥ ΠΕΝΤΟΞΕΙΔΙΟΥ· ΑΛΛΩΝ ΑΝΟΡΓΑΝΩΝ ΟΞΕΩΝ· ΔΙΟΞΕΙΔΙΟΥ ΤΟΥ ΠΥΡΙΤΙΟΥ ΚΑΙ ΤΟΥ ΘΕΙΟΥ',
  },
  {
    label: '20132500',
    value:
      'ΠΑΡΑΓΩΓΗ ΟΞΕΙΔΙΩΝ, ΥΔΡΟΞΕΙΔΙΩΝ ΚΑΙ ΥΠΕΡΟΞΕΙΔΙΩΝ· ΥΔΡΑΖΙΝΗΣ ΚΑΙ ΥΔΡΟΞΥΛΑΜΙΝΗΣ ΚΑΙ ΑΝΟΡΓΑΝΩΝ ΑΛΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '20133000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΟΓΟΝΩΜΕΝΩΝ ΜΕΤΑΛΛΩΝ· ΥΠΟΧΛΩΡΙΩΔΩΝ, ΧΛΩΡΙΚΩΝ ΚΑΙ ΥΠΕΡΧΛΩΡΙΚΩΝ',
  },
  {
    label: '20133100',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΟΓΟΝΩΜΕΝΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '20133200',
    value: 'ΠΑΡΑΓΩΓΗ ΥΠΟΧΛΩΡΙΩΔΩΝ, ΧΛΩΡΙΚΩΝ ΚΑΙ ΥΠΕΡΧΛΩΡΙΚΩΝ',
  },
  {
    label: '20134000',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΟΥΛΦΙΔΙΩΝ, ΘΕΙΙΚΩΝ ΑΛΑΤΩΝ· ΝΙΤΡΙΚΩΝ, ΦΩΣΦΟΡΙΚΩΝ ΚΑΙ ΑΝΘΡΑΚΙΚΩΝ ΑΛΑΤΩΝ',
  },
  {
    label: '20134100',
    value: 'ΠΑΡΑΓΩΓΗ ΣΟΥΛΦΙΔΙΩΝ, ΘΕΙΩΔΩΝ ΚΑΙ ΘΕΙΙΚΩΝ ΑΛΑΤΩΝ',
  },
  {
    label: '20134200',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΩΣΦΙΝΙΚΩΝ, ΦΩΣΦΟΝΙΚΩΝ, ΦΩΣΦΟΡΙΚΩΝ, ΠΟΛΥΦΩΣΦΟΡΙΚΩΝ ΑΛΑΤΩΝ ΚΑΙ ΝΙΤΡΙΚΩΝ ΑΛΑΤΩ (ΕΚΤΟΣ ΤΟΥ ΚΑΛΙΟΥ)',
  },
  {
    label: '20134300',
    value: 'ΠΑΡΑΓΩΓΗ ΑΝΘΡΑΚΙΚΩΝ ΑΛΑΤΩΝ',
  },
  {
    label: '20135000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΑΤΩΝ ΑΛΛΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '20135100',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΑΤΩΝ ΟΞΟΜΕΤΑΛΛΙΚΩΝ Η ΥΠΕΡΟΞΟΜΕΤΑΛΛΙΚΩΝ ΟΞΕΩΝ· ΚΟΛΛΟΕΙΔΩΝ ΠΟΛΥΤΙΜΩΝΜΕΤΑΛΛΩΝ',
  },
  {
    label: '20135200',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΝΟΡΓΑΝΩΝ ΕΝΩΣΕΩΝ Π.Δ.Κ.Α., ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΑΠΟΣΤΑΓΜΕΝΟΥ ΝΕΡΟΥ· ΑΜΑΛΓΑΜΑΤΩΝ, ΕΚΤΟΣ ΤΩΝ ΑΜΑΛΓΑΜΑΤΩΝ ΤΩΝ ΠΟΛΥΤΙΜΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '20136000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΒΑΣΙΚΩΝ ΑΝΟΡΓΑΝΩΝ ΧΗΜΙΚΩΝ ΟΥΣΙΩΝ',
  },
  {
    label: '20136100',
    value:
      'ΠΑΡΑΓΩΓΗ ΙΣΟΤΟΠΩΝ Π.Δ.Κ.Α. ΚΑΙ ΤΩΝ ΕΝΩΣΕΩΝ ΤΟΥΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΒΑΡΕΩΣ ΥΔΑΤΟΣ)',
  },
  {
    label: '20136200',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΥΑΝΙΔΙΩΝ, ΟΞΕΙΔΙΩΝ ΤΩΝ ΚΥΑΝΙΔΙΩΝ ΚΑΙ ΣΥΜΠΛΟΚΩΝ ΚΥΑΝΙΔΙΩΝ· ΚΡΟΤΙΚΩΝ, ΚΥΑΝΙΚΩΝ ΚΑΙ ΘΕΙΟΚΥΑΝΙΚΩΝ ΑΛΑΤΩΝ· ΠΥΡΙΤΙΚΩΝ ΑΛΑΤΩΝ· ΒΟΡΙΚΩΝ ΑΛΑΤΩΝ· ΥΠΕΡΒΟΡΙΚΩΝ ΑΛΑΤΩΝ· ΑΛΛΩΝ ΑΛΑΤΩΝ ΑΝΟΡΓΑΝΩΝ ΟΞΕΩΝ Η ΥΠΕΡΟΞΕΩΝ',
  },
  {
    label: '20136300',
    value: 'ΠΑΡΑΓΩΓΗ ΥΠΕΡΟΞΕΙΔΙΟΥ ΤΟΥ ΥΔΡΟΓΟΝΟΥ',
  },
  {
    label: '20136400',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΩΣΦΙΔΙΩΝ, ΚΑΡΒΙΔΙΩΝ, ΥΔΡΙΔΙΩΝ, ΝΙΤΡΙΔΙΩΝ, ΑΖΩΤΙΔΙΩΝ, ΠΥΡΙΤΙΔΙΩΝ ΚΑΙ ΒΟΡΙΔΙΩΝ',
  },
  {
    label: '20136500',
    value: 'ΠΑΡΑΓΩΓΗ ΕΝΩΣΕΩΝ ΜΕΤΑΛΛΩΝ ΣΠΑΝΙΩΝ ΓΑΙΩΝ, ΥΤΤΡΙΟΥ Η ΣΚΑΝΔΙΟΥ',
  },
  {
    label: '20136600',
    value:
      'ΠΑΡΑΓΩΓΗ ΘΕΙΟΥ, ΜΕ ΕΞΑΙΡΕΣΗ ΑΥΤΟΥ ΠΟΥ ΠΑΡΑΓΕΤΑΙ ΜΕ ΕΞΑΧΝΩΣΗ, ΜΕ ΚΑΤΑΚΡΗΜΝΙΣΗ, ΚΑΘΩΣ ΚΑΙ ΤΟΥ ΚΟΛΛΟΕΙΔΟΥΣ',
  },
  {
    label: '20136700',
    value: 'ΠΑΡΑΓΩΓΗ ΦΡΥΓΜΕΝΩΝ ΣΙΔΗΡΟΠΥΡΙΤΩΝ',
  },
  {
    label: '20136800',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΙΕΖΟΗΛΕΚΤΡΙΚΟΥ ΧΑΛΑΖΙΑ· ΑΛΛΩΝ ΣΥΝΘΕΤΙΚΩΝ Η ΑΝΑΣΧΗΜΑΤΙΣΜΕΝΩΝ ΠΟΛΥΤΙΜΩΝ Η ΗΜΙΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ, ΑΚΑΤΕΡΓΑΣΤΩΝ',
  },
  {
    label: '20139000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΒΑΣΙΚΩΝ ΑΝΟΡΓΑΝΩΝ ΧΗΜΙΚΩΝ ΟΥΣΙΩΝ',
  },
  {
    label: '20140000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΟΡΓΑΝΙΚΩΝ ΒΑΣΙΚΩΝ ΧΗΜΙΚΩΝ ΟΥΣΙΩΝ',
  },
  {
    label: '20141000',
    value: 'ΠΑΡΑΓΩΓΗ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ ΚΑΙ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '20141100',
    value: 'ΠΑΡΑΓΩΓΗ ΑΚΥΚΛΩΝ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ',
  },
  {
    label: '20141200',
    value: 'ΠΑΡΑΓΩΓΗ ΚΥΚΛΙΚΩΝ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ',
  },
  {
    label: '20141300',
    value: 'ΠΑΡΑΓΩΓΗ ΧΛΩΡΙΩΜΕΝΩΝ ΠΑΡΑΓΩΓΩΝ ΑΚΥΚΛΩΝ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ',
  },
  {
    label: '20141400',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΟΥΛΦΟΝΩΜΕΝΩΝ, ΝΙΤΡΩΜΕΝΩΝ Η ΝΙΤΡΙΔΩΜΕΝΩΝ ΠΑΡΑΓΩΓΩΝ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ, ΑΛΟΓΟΝΩΜΕΝΩΝ Η ΟΧΙ',
  },
  {
    label: '20141900',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΠΑΡΑΓΩΓΩΝ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ',
  },
  {
    label: '20142000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΚΟΟΛΩΝ, ΦΑΙΝΟΛΩΝ, ΦΑΙΝΟΛΟΑΛΚΟΟΛΩΝ ΚΑΙ ΤΩΝ ΑΛΟΓΟΝΩΜΕΝΩΝ, ΣΟΥΛΦΟΝΩΜΕΝΩΝ, ΝΙΤΡΩΜΕΝΩΝ Η ΝΙΤΡΙΔΩΜΕΝΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ· ΒΙΟΜΗΧΑΝΙΚΩΝ ΛΙΠΑΡΩΝ ΑΛΚΟΟΛΩΝ',
  },
  {
    label: '20142100',
    value: 'ΠΑΡΑΓΩΓΗ ΒΙΟΜΗΧΑΝΙΚΩΝ ΛΙΠΑΡΩΝ ΑΛΚΟΟΛΩΝ',
  },
  {
    label: '20142200',
    value: 'ΠΑΡΑΓΩΓΗ ΜΟΝΟΣΘΕΝΩΝ ΑΛΚΟΟΛΩΝ',
  },
  {
    label: '20142300',
    value:
      'ΠΑΡΑΓΩΓΗ ΔΙΟΛΩΝ, ΠΟΛΥΑΛΚΟΟΛΩΝ, ΚΥΚΛΙΚΩΝ ΑΛΚΟΟΛΩΝ ΚΑΙ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '20142400',
    value: 'ΠΑΡΑΓΩΓΗ ΦΑΙΝΟΛΩΝ· ΦΑΙΝΟΛΟΑΛΚΟΟΛΩΝ ΚΑΙ ΠΑΡΑΓΩΓΩΝ ΑΠΟ ΦΑΙΝΟΛΕΣ',
  },
  {
    label: '20143000',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΙΠΑΡΩΝ ΟΞΕΩΝ ΜΟΝΟΚΑΡΒΟΞΥΛΙΚΩΝ ΒΙΟΜΗΧΑΝΙΚΩΝ· ΚΑΡΒΟΞΥΛΙΚΩΝ ΟΞΕΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '20143100',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΙΠΑΡΩΝ ΟΞΕΩΝ ΜΟΝΟΚΑΡΒΟΞΥΛΙΚΩΝ ΒΙΟΜΗΧΑΝΙΚΩΝ· ΟΞΙΝΩΝ ΛΑΔΙΩΝ ΑΠΟ ΕΞΕΥΓΕΝΙΣΜΟ',
  },
  {
    label: '20143200',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΟΡΕΣΜΕΝΩΝ ΑΚΥΚΛΙΚΩΝ ΜΟΝΟΚΑΡΒΟΞΥΛΙΚΩΝ ΟΞΕΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '20143300',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΚΟΡΕΣΤΩΝ ΜΟΝΟΚΑΡΒΟΞΥΛΙΚΩΝ, ΚΥΚΛΑΝΙΚΩΝ, ΚΥΚΛΕΝΙΚΩΝ Η ΚΥΚΛΟΤΕΡΠΕΝΙΚΩΝ ΑΚΥΚΛΙΚΩΝ ΠΟΛΥΚΑΡΒΟΞΥΛΙΚΩΝ ΟΞΕΩΝ ΚΑΙ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '20143400',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΡΩΜΑΤΙΚΩΝ ΠΟΛΥΚΑΡΒΟΞΥΛΙΚΩΝ ΚΑΙ ΚΑΡΒΟΞΥΛΙΚΩΝ ΟΞΕΩΝ ΜΕ ΠΡΟΣΘΕΤΗ ΟΞΥΓΟΝΟΥΧΟ ΟΜΑΔΑ· ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ, ΕΚΤΟΣ ΑΠΟ ΤΟ ΣΑΛΙΚΥΛΙΚΟ ΟΞΥ ΚΑΙ ΤΑ ΑΛΑΤΑ ΤΟΥ',
  },
  {
    label: '20144000',
    value: 'ΠΑΡΑΓΩΓΗ ΟΡΓΑΝΙΚΩΝ ΕΝΩΣΕΩΝ ΜΕ ΑΖΩΤΟΥΧΕΣ ΟΜΑΔΕΣ',
  },
  {
    label: '20144100',
    value: 'ΠΑΡΑΓΩΓΗ ΕΝΩΣΕΩΝ ΜΕ ΑΜΙΝΙΚΗ ΟΜΑΔΑ',
  },
  {
    label: '20144200',
    value:
      'ΠΑΡΑΓΩΓΗ ΟΞΥΓΟΝΟΥΧΩΝ ΑΜΙΝΙΚΩΝ ΕΝΩΣΕΩΝ, ΕΚΤΟΣ ΑΠΟ ΤΗ ΛΥΣΙΝΗ ΚΑΙ ΤΟ ΓΛΟΥΤΑΜΙΝΙΚΟ ΟΞΥ',
  },
  {
    label: '20144300',
    value:
      'ΠΑΡΑΓΩΓΗ ΟΥΡΕΪΝΩΝ· ΕΝΩΣΕΩΝ ΜΕ ΚΑΡΒΟΞΥΪΜΙΔΙΚΗ ΟΜΑΔΑ ΚΑΙ ΜΕ ΝΙΤΡΙΚΗ ΟΜΑΔΑ· ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '20144400',
    value: 'ΠΑΡΑΓΩΓΗ ΕΝΩΣΕΩΝ ΜΕ ΑΛΛΕΣ ΑΖΩΤΟΥΧΕΣ ΟΜΑΔΕΣ',
  },
  {
    label: '20145000',
    value:
      'ΠΑΡΑΓΩΓΗ ΟΡΓΑΝΙΚΩΝ ΘΕΙΟΕΝΩΣΕΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΟ;ΑΝΟΡΓΑΝΩΝ ΕΝΩΣΕΩΝ· ΕΤΕΡΟΚΥΚΛΙΚΩΝ ΕΝΩΣΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '20145100',
    value: 'ΠΑΡΑΓΩΓΗ ΟΡΓΑΝΙΚΩΝ ΘΕΙΟΕΝΩΣΕΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΟ;ΑΝΟΡΓΑΝΩΝ ΕΝΩΣΕΩΝ',
  },
  {
    label: '20145200',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΤΕΡΟΚΥΚΛΙΚΩΝ ΕΝΩΣΕΩΝ Π.Δ.Κ.Α.· ΝΟΥΚΛΕΪΝΙΚΩΝ ΟΞΕΩΝ ΚΑΙ ΤΩΝ ΑΛΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '20145300',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΩΣΦΟΡΙΚΩΝ ΕΣΤΕΡΩΝ ΚΑΙ ΤΩΝ ΑΛΑΤΩΝ ΤΟΥΣ Η ΕΣΤΕΡΩΝ ΑΛΛΩΝ ΑΝΟΡΓΑΝΩΝ ΟΞΕΩΝ (ΜΕ ΕΞΑΙΡΕΣΗ ΕΣΤΕΡΕΣ ΥΠΕΡΟΞΕΙΔΙΟΥ ΤΟΥ ΥΔΡΟΓΟΝΟΥ) ΚΑΙ ΤΩΝ ΑΛΑΤΩΝ ΤΟΥΣ· ΚΑΙ ΤΩΝ ΑΛΟΓΟΝΩΜΕΝΩΝ, ΣΟΥΛΦΟΝΩΜΕΝΩΝ, ΝΙΤΡΩΜΕΝΩΝ Η ΝΙΤΡΙΔΩΜΕΝΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '20146000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΙΘΕΡΩΝ, ΟΡΓΑΝΙΚΩΝ ΥΠΕΡΟΞΕΙΔΙΩΝ, ΕΠΟΞΕΙΔΙΩΝ, ΑΚΕΤΑΛΩΝ ΚΑΙ ΗΜΙΑΚΕΤΑΛΩΝ· ΑΛΛΩΝ ΟΡΓΑΝΙΚΩΝ ΕΝΩΣΕΩΝ',
  },
  {
    label: '20146100',
    value: 'ΠΑΡΑΓΩΓΗ ΕΝΩΣΕΩΝ ΜΕ ΑΛΔΕΫΔΙΚΕΣ ΟΜΑΔΕΣ',
  },
  {
    label: '20146200',
    value: 'ΠΑΡΑΓΩΓΗ ΕΝΩΣΕΩΝ ΜΕ ΚΕΤΟΝΙΚΕΣ ΚΑΙ ΚΙΝΟΝΙΚΕΣ ΟΜΑΔΕΣ',
  },
  {
    label: '20146300',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΙΘΕΡΩΝ, ΟΡΓΑΝΙΚΩΝ ΥΠΕΡΟΞΕΙΔΙΩΝ, ΕΠΟΞΕΙΔΙΩΝ, ΑΚΕΤΑΛΩΝ ΚΑΙ ΗΜΙΑΚΕΤΑΛΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '20146400',
    value: 'ΠΑΡΑΓΩΓΗ ΕΝΖΥΜΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΙΚΩΝ ΕΝΩΣΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '20146401',
    value: 'ΠΑΡΑΓΩΓΗ ΤΥΡΟΜΑΓΙΑΣ',
  },
  {
    label: '20147000',
    value: 'ΠΑΡΑΓΩΓΗ ΔΙΑΦΟΡΩΝ ΟΡΓΑΝΙΚΩΝ ΒΑΣΙΚΩΝ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '20147100',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΑΓΩΓΩΝ ΦΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Η ΠΡΟΪΟΝΤΩΝ ΡΗΤΙΝΗΣ',
  },
  {
    label: '20147101',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΟΪΟΝΤΩΝ ΡΗΤΙΝΗΣ',
  },
  {
    label: '20147200',
    value: 'ΠΑΡΑΓΩΓΗ ΞΥΛΑΝΘΡΑΚΑ',
  },
  {
    label: '20147300',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΛΑΙΩΝ ΚΑΙ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΠΟΥ ΠΡΟΕΡΧΟΝΤΑΙ ΑΠΟ ΤΗΝ ΑΠΟΣΤΑΞΗ ΣΕ ΥΨΗΛΗ ΘΕΡΜΟΚΡΑΣΙΑ ΤΩΝ ΠΙΣΣΩΝ ΑΠΟ ΛΙΘΑΝΘΡΑΚΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΠΡΟΪΟΝΤΑ',
  },
  {
    label: '20147400',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΗ ΜΕΤΟΥΣΙΩΜΕΝΗΣ ΑΙΘΥΛΙΚΗΣ ΑΛΚΟΟΛΗΣ ΜΕ ΑΠΟΚΤΗΜΕΝΟ ΑΛΚΟΟΛΙΚΟ ΤΙΤΛΟ ΠΟΥ ΥΠΕΡΒΑΙΝΕΙ ΤΟ 80 ~ % ΚΑΤ΄ ΟΓΚΟ',
  },
  {
    label: '20147500',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΙΘΥΛΙΚΗΣ ΑΛΚΟΟΛΗΣ ΚΑΙ ΑΠΟΣΤΑΓΜΑΤΩΝ ΜΕΤΟΥΣΙΩΜΕΝΩΝ, ΟΠΟΙΟΥΔΗΠΟΤΕ ΤΙΤΛΟΥ',
  },
  {
    label: '20148000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΚΑΛΙΚΩΝ ΚΑΤΑΛΟΙΠΩΝ ΑΠΟ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΤΟΥ ΞΥΛΟΠΟΛΤΟΥ ΕΚΤΟΣ ΑΠΟ ΤΟ ΤΑΛΛΕΛΑΙΟ',
  },
  {
    label: '20149000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΟΡΓΑΝΙΚΩΝ ΒΑΣΙΚΩΝ ΧΗΜΙΚΩΝ ΟΥΣΙΩΝ',
  },
  {
    label: '20150000',
    value: 'ΠΑΡΑΓΩΓΗ ΛΙΠΑΣΜΑΤΩΝ ΚΑΙ ΑΖΩΤΟΥΧΩΝ ΕΝΩΣΕΩΝ',
  },
  {
    label: '20151000',
    value: 'ΠΑΡΑΓΩΓΗ ΝΙΤΡΙΚΟΥ ΟΞΕΩΣ· ΣΟΥΛΦΟΝΙΤΡΙΚΩΝ ΟΞΕΩΝ· ΑΜΜΩΝΙΑΣ',
  },
  {
    label: '20152000',
    value: 'ΠΑΡΑΓΩΓΗ ΧΛΩΡΙΟΥΧΟΥ ΑΜΜΩΝΙΟΥ· ΝΙΤΡΩΔΩΝ ΑΛΑΤΩΝ',
  },
  {
    label: '20153000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΖΩΤΟΥΧΩΝ ΛΙΠΑΣΜΑΤΩΝ, ΟΡΥΚΤΩΝ Η ΧΗΜΙΚΩΝ',
  },
  {
    label: '20153100',
    value: 'ΠΑΡΑΓΩΓΗ ΟΥΡΙΑΣ',
  },
  {
    label: '20153200',
    value: 'ΠΑΡΑΓΩΓΗ ΘΕΙΙΚΟΥ ΑΜΜΩΝΙΟΥ',
  },
  {
    label: '20153300',
    value: 'ΠΑΡΑΓΩΓΗ ΝΙΤΡΙΚΟΥ ΑΜΜΩΝΙΟΥ',
  },
  {
    label: '20153400',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΑΤΩΝ ΔΙΠΛΩΝ ΚΑΙ ΜΕΙΓΜΑΤΩΝ ΝΙΤΡΙΚΟΥ ΑΣΒΕΣΤΙΟΥ ΚΑΙ ΝΙΤΡΙΚΟΥ ΑΜΜΩΝΙΟΥ',
  },
  {
    label: '20153500',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΕΙΓΜΑΤΩΝ ΝΙΤΡΙΚΟΥ ΑΜΜΩΝΙΟΥ ΚΑΙ ΑΝΘΡΑΚΙΚΟΥ ΑΣΒΕΣΤΙΟΥ Η ΑΛΛΩΝ ΑΝΟΡΓΑΝΩΝ ΥΛΩΝ ΧΩΡΙΣ ΛΙΠΑΝΤΙΚΕΣ ΙΚΑΝΟΤΗΤΕΣ',
  },
  {
    label: '20153900',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΑΖΩΤΟΥΧΩΝ ΛΙΠΑΣΜΑΤΩΝ ΚΑΙ ΜΕΙΓΜΑΤΩΝ',
  },
  {
    label: '20154000',
    value: 'ΠΑΡΑΓΩΓΗ ΦΩΣΦΟΡΙΚΩΝ ΛΙΠΑΣΜΑΤΩΝ, ΟΡΥΚΤΩΝ Η ΧΗΜΙΚΩΝ',
  },
  {
    label: '20154100',
    value: 'ΠΑΡΑΓΩΓΗ ΥΠΕΡΦΩΣΦΟΡΙΚΩΝ ΛΙΠΑΣΜΑΤΩΝ',
  },
  {
    label: '20154900',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΦΩΣΦΟΡΙΚΩΝ ΛΙΠΑΣΜΑΤΩΝ',
  },
  {
    label: '20155000',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΛΙΟΥΧΩΝ ΛΙΠΑΣΜΑΤΩΝ, ΟΡΥΚΤΩΝ Η ΧΗΜΙΚΩΝ',
  },
  {
    label: '20155100',
    value: 'ΠΑΡΑΓΩΓΗ ΧΛΩΡΙΟΥΧΟΥ ΚΑΛΙΟΥ',
  },
  {
    label: '20155200',
    value: 'ΠΑΡΑΓΩΓΗ ΘΕΙΙΚΟΥ ΚΑΛΙΟΥ',
  },
  {
    label: '20155900',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΚΑΛΙΟΥΧΩΝ ΛΙΠΑΣΜΑΤΩΝ',
  },
  {
    label: '20156000',
    value: 'ΠΑΡΑΓΩΓΗ ΝΙΤΡΙΚΟΥ ΝΑΤΡΙΟΥ',
  },
  {
    label: '20157000',
    value: 'ΠΑΡΑΓΩΓΗ ΛΙΠΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '20157100',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΙΠΑΣΜΑΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΤΡΙΑ ΘΡΕΠΤΙΚΑ ΣΤΟΙΧΕΙΑ: ΑΖΩΤΟ, ΦΩΣΦΟΡΟ ΚΑΙ ΚΑΛΙΟ',
  },
  {
    label: '20157200',
    value:
      'ΠΑΡΑΓΩΓΗ ΥΔΡΟΓΟΝΟΡΘΟΦΩΣΦΟΡΙΚΟΥ ΔΙΑΜΜΩΝΙΟΥ (ΔΙΑΜΜΩΝΙΚΟΥ ΦΩΣΦΟΡΙΚΟΥ ΑΛΑΤΟΣ)',
  },
  {
    label: '20157300',
    value: 'ΠΑΡΑΓΩΓΗ ΜΟΝΟΑΜΜΩΝΙΑΚΟΥ ΦΩΣΦΟΡΙΚΟΥ ΑΛΑΤΟΣ',
  },
  {
    label: '20157400',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΙΠΑΣΜΑΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΔΥΟ ΘΡΕΠΤΙΚΑ ΣΤΟΙΧΕΙΑ: ΑΖΩΤΟ ΚΑΙ ΦΩΣΦΟΡΟ',
  },
  {
    label: '20157500',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΙΠΑΣΜΑΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΔΥΟ ΘΡΕΠΤΙΚΑ ΣΤΟΙΧΕΙΑ: ΦΩΣΦΟΡΟ ΚΑΙ ΚΑΛΙΟ',
  },
  {
    label: '20157600',
    value: 'ΠΑΡΑΓΩΓΗ ΝΙΤΡΙΚΩΝ ΑΛΑΤΩΝ ΤΟΥ ΚΑΛΙΟΥ',
  },
  {
    label: '20157900',
    value:
      'ΠΑΡΑΓΩΓΗ ΟΡΥΚΤΩΝ Η ΧΗΜΙΚΩΝ ΛΙΠΑΣΜΑΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΤΟΥΛΑΧΙΣΤΟΝ ΔΥΟ ΘΡΕΠΤΙΚΑ ΣΤΟΙΧΕΙΑ (ΑΖΩΤΟ, ΦΩΣΦΟΡΟ, ΚΑΛΙΟ) Π.Δ.Κ.Α.',
  },
  {
    label: '20158000',
    value: 'ΠΑΡΑΓΩΓΗ ΖΩΙΚΩΝ Η ΦΥΤΙΚΩΝ ΛΙΠΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '20159000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΛΙΠΑΣΜΑΤΩΝ ΚΑΙ ΑΖΩΤΟΥΧΩΝ ΕΝΩΣΕΩΝ',
  },
  {
    label: '20160000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΛΑΣΤΙΚΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20161000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΟΛΥΜΕΡΩΝ ΤΟΥ ΑΙΘΥΛΕΝΙΟΥ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20162000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΟΛΥΜΕΡΩΝ ΤΟΥ ΣΤΥΡΟΛΙΟΥ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20163000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΟΛΥΜΕΡΩΝ ΤΟΥ ΧΛΩΡΙΟΥΧΟΥ ΒΙΝΥΛΙΟΥ Η ΑΛΛΩΝ ΑΛΟΓΟΝΩΜΕΝΩΝ ΟΛΕΦΙΝΩΝ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20163001',
    value: 'ΠΑΡΑΓΩΓΗ ΧΛΩΡΙΟΥΧΟΥ ΠΟΛΥΒΙΝΥΛΙΟΥ (PVC)',
  },
  {
    label: '20164000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΟΛΥΑΚΕΤΑΛΩΝ, ΑΛΛΩΝ ΠΟΛΥΑΙΘΕΡΩΝ ΚΑΙ ΡΗΤΙΝΩΝ· ΕΠΟΞΕΙΔΙΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ· ΠΟΛΥΑΝΘΡΑΚΙΚΩΝ ΑΛΑΤΩΝ, ΡΗΤΙΝΩΝ· ΑΛΚΥΔΙΩΝ, ΠΟΛΥΕΣΤΕΡΩΝ ΑΛΛΥΛΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΠΟΛΥΕΣΤΕΡΩΝ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20165000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ· ΙΟΝΤΟΑΝΤΑΛΛΑΚΤΩΝ',
  },
  {
    label: '20165100',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΟΛΥΜΕΡΩΝ ΤΟΥ ΠΡΟΠΥΛΕΝΙΟΥ Η ΑΛΛΩΝ ΟΛΕΦΙΝΩΝ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20165200',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΟΛΥΜΕΡΩΝ ΤΟΥ ΟΞΙΚΟΥ ΒΙΝΥΛΙΟΥ Η ΑΛΛΩΝ ΕΣΤΕΡΩΝ ΚΑΙ ΠΟΛΥΜΕΡΩΝ ΤΟΥ ΒΙΝΥΛΙΟΥ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20165300',
    value: 'ΠΑΡΑΓΩΓΗ ΑΚΡΥΛΙΚΩΝ ΠΟΛΥΜΕΡΩΝ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20165400',
    value: 'ΠΑΡΑΓΩΓΗ ΠΟΛΥΑΜΙΔΙΩΝ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20165500',
    value:
      'ΠΑΡΑΓΩΓΗ ΡΗΤΙΝΩΝ ΟΥΡΙΑΣ, ΘΕΙΟΥΡΙΑΣ ΚΑΙ ΜΕΛΑΜΙΝΗΣ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20165600',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΑΜΙΝΟΡΗΤΙΝΩΝ, ΦΑΙΝΟΛΙΚΩΝ ΡΗΤΙΝΩΝ ΚΑΙ ΠΟΛΥΟΥΡΕΘΑΝΩΝ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ',
  },
  {
    label: '20165700',
    value: 'ΠΑΡΑΓΩΓΗ ΣΙΛΙΚΟΝΩΝ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20165900',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ, ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ, Π.Δ.Κ.Α.',
  },
  {
    label: '20169000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΛΑΣΤΙΚΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20170000',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΥΝΘΕΤΙΚΟΥ ΕΛΑΣΤΙΚΟΥ (ΣΥΝΘΕΤΙΚΟΥ ΚΑΟΥΤΣΟΥΚ) ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20171000',
    value: 'ΠΑΡΑΓΩΓΗ ΣΥΝΘΕΤΙΚΟΥ ΕΛΑΣΤΙΚΟΥ (ΚΑΟΥΤΣΟΥΚ) ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20171001',
    value: 'ΠΑΡΑΓΩΓΗ ΕΛΑΣΤΙΚΟΥ ΓΙΑ ΣΦΡΑΓΙΔΕΣ',
  },
  {
    label: '20179000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΣΥΝΘΕΤΙΚΟΥ ΕΛΑΣΤΙΚΟΥ (ΚΑΟΥΤΣΟΥΚ) ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '20200000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΙΤΟΚΤΟΝΩΝ ΚΑΙ ΑΛΛΩΝ ΑΓΡΟΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '20201100',
    value: 'ΠΑΡΑΓΩΓΗ ΕΝΤΟΜΟΚΤΟΝΩΝ',
  },
  {
    label: '20201200',
    value: 'ΠΑΡΑΓΩΓΗ ΖΙΖΑΝΙΟΚΤΟΝΩΝ',
  },
  {
    label: '20201300',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΝΑΣΧΕΤΙΚΩΝ ΒΛΑΣΤΗΣΗΣ ΚΑΙ ΡΥΘΜΙΣΤΩΝ ΤΗΣ ΑΝΑΠΤΥΞΗΣ ΤΩΝ ΦΥΤΩΝ',
  },
  {
    label: '20201400',
    value: 'ΠΑΡΑΓΩΓΗ ΑΠΟΛΥΜΑΝΤΙΚΩΝ',
  },
  {
    label: '20201500',
    value: 'ΠΑΡΑΓΩΓΗ ΜΥΚΗΤΟΚΤΟΝΩΝ',
  },
  {
    label: '20201900',
    value: 'ΠΑΡΑΓΩΓΗ ΛΟΙΠΩΝ ΠΑΡΑΣΙΤΟΚΤΟΝΩΝ ΚΑΙ ΑΛΛΩΝ ΑΓΡΟΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '20209000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΑΡΑΣΙΤΟΚΤΟΝΩΝ ΚΑΙ ΛΟΙΠΩΝ ΑΓΡΟΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '20300000',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΡΩΜΑΤΩΝ, ΒΕΡΝΙΚΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΠΙΧΡΙΣΜΑΤΩΝ, ΜΕΛΑΝΙΩΝ ΤΥΠΟΓΡΑΦΙΑΣ ΚΑΙ ΜΑΣΤΙΧΩΝ',
  },
  {
    label: '20301000',
    value: 'ΠΑΡΑΓΩΓΗ ΧΡΩΜΑΤΩΝ ΚΑΙ ΒΕΡΝΙΚΙΩΝ ΜΕ ΒΑΣΗ ΠΟΛΥΜΕΡΗ',
  },
  {
    label: '20301100',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΡΩΜΑΤΩΝ ΚΑΙ ΒΕΡΝΙΚΙΩΝ ΜΕ ΒΑΣΗ ΑΚΡΥΛΙΚΑ ΠΟΛΥΜΕΡΗ Η ΠΟΛΥΜΕΡΗ ΤΟΥ ΒΙΝΥΛΙΟΥ, ΣΕ ΥΔΑΤΩΔΕΣ ΜΕΣΟ',
  },
  {
    label: '20301200',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΡΩΜΑΤΩΝ ΚΑΙ ΒΕΡΝΙΚΙΩΝ ΜΕ ΒΑΣΗ ΠΟΛΥΕΣΤΕΡΕΣ, ΑΚΡΥΛΙΚΑ ΠΟΛΥΜΕΡΗ Η ΠΟΛΥΜΕΡΗ ΤΟΥ ΒΙΝΥΛΙΟΥ, ΣΕ ΜΗ ΥΔΑΤΩΔΕΣ ΜΕΣΟ· ΔΙΑΛΥΜΑΤΩΝ',
  },
  {
    label: '20302000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΧΡΩΜΑΤΩΝ ΚΑΙ ΒΕΡΝΙΚΙΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΠΡΟΪΟΝΤΩΝ· ΚΑΛΛΙΤΕΧΝΙΚΩΝ ΧΡΩΜΑΤΩΝ ΚΑΙ ΤΥΠΟΓΡΑΦΙΚΗΣ ΜΕΛΑΝΗΣ',
  },
  {
    label: '20302100',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΧΡΩΣΤΙΚΩΝ ΟΥΣΙΩΝ, ΑΔΙΑΦΑΝΟΠΟΙΗΤΩΝ ΚΑΙ ΧΡΩΜΑΤΩΝ, ΥΑΛΩΔΩΝ ΣΜΑΛΤΩΝ ΚΑΙ ΕΠΙΣΤΡΩΣΕΩΝ, ΕΠΙΚΑΛΥΜΜΑΤΩΝ ΚΕΡΑΜΕΥΤΙΚΗΣ, ΥΓΡΩΝ ΛΟΥΣΤΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ· ΤΡΙΜΜΕΝΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '20302200',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΧΡΩΜΑΤΩΝ ΚΑΙ ΒΕΡΝΙΚΙΩΝ· ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΞΗΡΑΝΤΙΚΩΝ',
  },
  {
    label: '20302300',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΡΩΜΑΤΩΝ ΚΑΛΛΙΤΕΧΝΩΝ, ΣΠΟΥΔΑΣΤΩΝ Η ΖΩΓΡΑΦΩΝ ΕΠΙΓΡΑΦΩΝ, ΧΡΩΜΑΤΩΝ ΑΛΛΑΓΗΣ ΤΩΝ ΑΠΟΧΡΩΣΕΩΝ, ΧΡΩΜΑΤΩΝ ΑΝΑΨΥΧΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '20302400',
    value: 'ΠΑΡΑΓΩΓΗ ΤΥΠΟΓΡΑΦΙΚΗΣ ΜΕΛΑΝΗΣ',
  },
  {
    label: '20309000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΧΡΩΜΑΤΩΝ, ΒΕΡΝΙΚΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΠΙΧΡΙΣΜΑΤΩΝ, ΤΥΠΟΓΡΑΦΙΚΗΣ ΜΕΛΑΝΗΣ ΚΑΙ ΜΑΣΤΙΧΩΝ',
  },
  {
    label: '20410000',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΑΠΟΥΝΙΩΝ ΚΑΙ ΑΠΟΡΡΥΠΑΝΤΙΚΩΝ, ΠΡΟΪΟΝΤΩΝ ΚΑΘΑΡΙΣΜΟΥ ΚΑΙ ΣΤΙΛΒΩΣΗΣ',
  },
  {
    label: '20411000',
    value: 'ΠΑΡΑΓΩΓΗ ΓΛΥΚΕΡΙΝΗΣ',
  },
  {
    label: '20412000',
    value: 'ΠΑΡΑΓΩΓΗ ΕΠΙΦΑΝΕΙΟΔΡΑΣΤΙΚΩΝ ΟΡΓΑΝΙΚΩΝ ΟΥΣΙΩΝ, ΕΚΤΟΣ ΑΠΟ ΣΑΠΟΥΝΙ',
  },
  {
    label: '20413000',
    value: 'ΠΑΡΑΓΩΓΗ ΣΑΠΟΥΝΙΟΥ, ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΠΛΥΣΗΣ ΚΑΙ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '20413100',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΑΠΟΥΝΙΟΥ ΚΑΙ ΕΠΙΦΑΝΕΙΟΔΡΑΣΤΙΚΩΝ ΟΡΓΑΝΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΩΣ ΣΑΠΟΥΝΙ· ΧΑΡΤΙΟΥ, ΒΑΤΩΝ, ΠΙΛΗΜΑΤΩΝ (ΤΣΟΧΩΝ) ΚΑΙ ΜΗ ΥΦΑΣΜΕΝΩΝ ΥΦΑΣΜΑΤΩΝ, ΕΜΠΟΤΙΣΜΕΝΩΝ, ΕΠΙΧΡΙΣΜΕΝΩΝ Η ΚΑΛΥΜΜΕΝΩΝ ΜΕ ΣΑΠΟΥΝΙ Η ΑΠΟΡΡΥΠΑΝΤ',
  },
  {
    label: '20413101',
    value: 'ΠΑΡΑΓΩΓΗ ΣΑΠΟΥΝΙΟΥ ΠΟΛΥΤΕΛΕΙΑΣ',
  },
  {
    label: '20413200',
    value: 'ΠΑΡΑΓΩΓΗ ΑΠΟΡΡΥΠΑΝΤΙΚΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΠΛΥΣΗΣ',
  },
  {
    label: '20414000',
    value: 'ΠΑΡΑΓΩΓΗ ΕΥΩΔΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΚΕΡΙΩΝ',
  },
  {
    label: '20414100',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΑΡΩΜΑΤΙΣΜΟ Η ΑΠΟΣΜΗΣΗ ΧΩΡΩΝ',
  },
  {
    label: '20414101',
    value: 'ΠΑΡΑΓΩΓΗ ΜΟΣΧΟΛΙΒΑΝΟΥ',
  },
  {
    label: '20414200',
    value: 'ΠΑΡΑΓΩΓΗ ΤΕΧΝΗΤΩΝ ΚΕΡΙΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΚΕΡΙΩΝ',
  },
  {
    label: '20414300',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΤΙΛΒΩΤΙΚΩΝ ΟΥΣΙΩΝ ΚΑΙ ΚΡΕΜΩΝ, ΓΙΑ ΥΠΟΔΗΜΑΤΑ, ΕΠΙΠΛΑ, ΔΑΠΕΔΑ, ΑΜΑΞΩΜΑΤΑ, ΓΥΑΛΙ Η ΜΕΤΑΛΛΟ',
  },
  {
    label: '20414301',
    value: 'ΠΑΡΑΓΩΓΗ ΒΑΦΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '20414302',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΚΕΤΙΝΗΣ',
  },
  {
    label: '20414400',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΟΛΤΩΝ ΚΑΙ ΣΚΟΝΩΝ ΚΑΘΑΡΙΣΜΟΥ ΚΑΙ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '20419000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΣΑΠΟΥΝΙΟΥ ΚΑΙ ΑΠΟΡΡΥΠΑΝΤΙΚΩΝ, ΠΡΟΪΟΝΤΩΝ ΚΑΘΑΡΙΣΜΟΥ ΚΑΙ ΣΤΙΛΒΩΣΗΣ',
  },
  {
    label: '20420000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΡΩΜΑΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΛΛΩΠΙΣΜΟΥ',
  },
  {
    label: '20421100',
    value: 'ΠΑΡΑΓΩΓΗ ΑΡΩΜΑΤΩΝ ΚΑΙ ΚΟΛΟΝΙΩΝ',
  },
  {
    label: '20421200',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΜΑΚΙΓΙΑΖ ΧΕΙΛΙΩΝ ΚΑΙ ΜΑΤΙΩΝ',
  },
  {
    label: '20421300',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΕΡΙΠΟΙΗΣΗ ΤΩΝ ΧΕΡΙΩΝ ΚΑΙ ΤΩΝ ΠΟΔΙΩΝ',
  },
  {
    label: '20421400',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΚΟΝΩΝ (ΠΟΥΔΡΩΝ) ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΩΣ ΚΑΛΛΥΝΤΙΚΑ Η ΓΙΑ ΚΑΛΛΩΠΙΣΜΟ',
  },
  {
    label: '20421500',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΟΜΟΡΦΙΑΣ, ΜΑΚΙΓΙΑΖ (MAKE;UP) Η ΦΡΟΝΤΙΔΑΣ ΤΟΥ ΔΕΡΜΑΤΟΣ (ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΑΝΤΙΗΛΙΑΚΑ) Π.Δ.Κ.Α.',
  },
  {
    label: '20421600',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΑΜΠΟΥΑΝ, ΛΑΚ ΜΑΛΛΙΩΝ, ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΜΟΝΙΜΟ ΚΑΤΣΑΡΩΜΑ (ΠΕΡΜΑΝΑΝΤ) Η ΙΣΙΩΜΑ ΜΑΛΛΙΩΝ',
  },
  {
    label: '20421700',
    value: 'ΠΑΡΑΓΩΓΗ ΛΟΣΙΟΝ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΑ ΜΑΛΛΙΑ Π.Δ.Κ.Α.',
  },
  {
    label: '20421800',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΗΝ ΥΓΙΕΙΝΗ ΤΟΥ ΣΤΟΜΑΤΟΣ Η ΤΩΝ ΔΟΝΤΙΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΣΤΕΡΕΩΤΙΚΟΙ ΠΟΛΤΟΙ ΚΑΙ ΣΚΟΝΕΣ)· ΟΔΟΝΤΙΚΟΥ ΝΗΜΑΤΟΣ',
  },
  {
    label: '20421900',
    value:
      'ΠΑΡΑΓΩΓΗ ΞΥΡΙΣΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ· ΑΠΟΣΜΗΤΙΚΩΝ ΚΑΙ ΑΝΤΙΙΔΡΩΤΙΚΩΝ ΓΙΑ ΤΟ ΣΩΜΑ· ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΟ ΛΟΥΤΡΟ· ΑΛΛΩΝ ΑΡΩΜΑΤΩΝ, ΚΑΛΛΥΝΤΙΚΩΝ Η ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΛΛΩΠΙΣΜΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '20429000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΡΩΜΑΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΛΛΩΠΙΣΜΟΥ',
  },
  {
    label: '20510000',
    value: 'ΠΑΡΑΓΩΓΗ ΕΚΡΗΚΤΙΚΩΝ',
  },
  {
    label: '20511000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΕΚΡΗΚΤΙΚΩΝ· ΘΡΥΑΛΛΙΔΩΝ ΑΣΦΑΛΕΙΑΣ· ΚΑΨΟΥΛΙΩΝ ΚΑΙ ΑΠΛΩΝ ΠΥΡΟΚΡΟΤΗΤΩΝ· ΕΙΔΩΝ ΑΝΑΦΛΕΞΗΣ· ΗΛΕΚΤΡΙΚΩΝ ΠΥΡΟΚΡΟΤΗΤΩΝ· ΠΥΡΟΤΕΧΝΗΜΑΤΩΝ',
  },
  {
    label: '20511100',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΟΩΘΗΤΙΚΗΣ ΠΥΡΙΤΙΔΑΣ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΕΚΡΗΚΤΙΚΩΝ',
  },
  {
    label: '20511200',
    value:
      'ΠΑΡΑΓΩΓΗ ΘΡΥΑΛΛΙΔΩΝ ΑΣΦΑΛΕΙΑΣ· ΠΥΡΑΓΩΓΩΝ ΣΧΟΙΝΙΩΝ· ΚΑΨΥΛΙΩΝ· ΕΙΔΩΝ ΑΝΑΦΛΕΞΗΣ· ΗΛΕΚΤΡΙΚΩΝ ΠΥΡΟΚΡΟΤΗΤΩΝ',
  },
  {
    label: '20511300',
    value: 'ΠΑΡΑΓΩΓΗ ΠΥΡΟΤΕΧΝΗΜΑΤΩΝ',
  },
  {
    label: '20511400',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΩΤΟΒΟΛΙΔΩΝ, ΠΥΡΑΥΛΩΝ ΔΗΜΙΟΥΡΓΙΑΣ ΒΡΟΧΗΣ, ΣΗΜΑΤΩΝ ΟΜΙΧΛΗΣ ΚΑΙ ΑΛΛΩΝ ΠΥΡΟΤΕΧΝΙΚΩΝ ΕΙΔΩΝ (ΕΞΑΙΡΟΥΜΕΝΩΝ ΤΩΝ ΠΥΡΟΤΕΧΝΗΜΑΤΩΝ)',
  },
  {
    label: '20512000',
    value: 'ΠΑΡΑΓΩΓΗ ΣΠΙΡΤΩΝ',
  },
  {
    label: '20519000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΚΡΗΚΤΙΚΩΝ',
  },
  {
    label: '20520000',
    value: 'ΠΑΡΑΓΩΓΗ ΔΙΑΦΟΡΩΝ ΤΥΠΩΝ ΚΟΛΛΑΣ',
  },
  {
    label: '20521000',
    value: 'ΠΑΡΑΓΩΓΗ ΚΟΛΛΩΝ',
  },
  {
    label: '20521001',
    value: 'ΠΑΡΑΓΩΓΗ ΑΜΥΛΟΚΟΛΛΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '20521002',
    value: 'ΠΑΡΑΓΩΓΗ ΓΟΜΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '20529000',
    value: 'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΚΟΛΛΩΝ',
  },
  {
    label: '20530000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΙΘΕΡΙΩΝ ΕΛΑΙΩΝ',
  },
  {
    label: '20539000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΙΘΕΡΙΩΝ ΕΛΑΙΩΝ',
  },
  {
    label: '20590000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '20591000',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΩΤΟΓΡΑΦΙΚΩΝ ΠΛΑΚΩΝ, ΦΙΛΜ ΚΑΙ ΦΙΛΜ ΣΤΙΓΜΙΑΙΑΣ ΕΚΤΥΠΩΣΗΣ· ΧΗΜΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΑΜΙΓΩΝ ΠΡΟΪΟΝΤΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '20591100',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΩΤΟΓΡΑΦΙΚΩΝ ΠΛΑΚΩΝ, ΦΙΛΜ ΚΑΙ ΦΙΛΜ ΣΤΙΓΜΙΑΙΑΣ ΕΚΤΥΠΩΣΗΣ, ΕΥΑΙΣΘΗΤΟΠΟΙΗΜΕΝΩΝ ΜΗ ΕΚΤΕΘΕΙΜΕΝΩΝ· ΦΩΤΟΓΡΑΦΙΚΟΥ ΧΑΡΤΙΟΥ',
  },
  {
    label: '20591200',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΥΑΙΣΘΗΤΟΠΟΙΗΜΕΝΩΝ ΓΑΛΑΚΤΩΜΑΤΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΕΣ ΧΡΗΣΕΙΣ· ΧΗΜΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΕΣ ΧΡΗΣΕΙΣ Π.Δ.Κ.Α.',
  },
  {
    label: '20592000',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΗΜΙΚΑ ΤΡΟΠΟΠΟΙΗΜΕΝΩΝ ΖΩΙΚΩΝ Η ΦΥΤΙΚΩΝ ΛΙΠΩΝ ΚΑΙ ΕΛΑΙΩΝ· ΜΗ ΒΡΩΣΙΜΩΝ ΜΕΙΓΜΑΤΩΝ ΖΩΙΚΩΝ Η ΦΥΤΙΚΩΝ ΛΙΠΩΝ Η ΕΛΑΙΩΝ',
  },
  {
    label: '20592001',
    value: 'ΠΑΡΑΓΩΓΗ ΧΗΜΙΚΑ ΤΡΟΠΟΠΟΙΗΜΕΝΟΥ ΠΥΡΗΝΕΛΑΙΟΥ',
  },
  {
    label: '20593000',
    value: 'ΠΑΡΑΓΩΓΗ ΜΕΛΑΝΗΣ ΓΡΑΦΗΣ Η ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΑΛΛΩΝ ΜΕΛΑΝΙΩΝ',
  },
  {
    label: '20594000',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΙΠΑΝΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ· ΠΡΟΣΘΕΤΩΝ ΥΛΩΝ· ΑΝΤΙΨΥΚΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ',
  },
  {
    label: '20594100',
    value: 'ΠΑΡΑΓΩΓΗ ΛΙΠΑΝΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ',
  },
  {
    label: '20594200',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΝΤΙΚΡΟΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ· ΠΡΟΣΘΕΤΩΝ ΥΛΩΝ ΓΙΑ ΟΡΥΚΤΕΛΑΙΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΠΡΟΪΟΝΤΑ',
  },
  {
    label: '20594300',
    value:
      'ΠΑΡΑΓΩΓΗ ΥΓΡΩΝ ΓΙΑ ΥΔΡΑΥΛΙΚΑ ΦΡΕΝΑ· ΑΝΤΙΨΥΚΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΑΠΟΠΑΓΩΤΙΚΩΝ ΥΓΡΩΝ',
  },
  {
    label: '20595000',
    value: 'ΠΑΡΑΓΩΓΗ ΔΙΑΦΟΡΩΝ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '20595100',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΕΠΤΟΝΩΝ, ΑΛΛΩΝ ΠΡΩΤΕΪΝΙΚΩΝ ΟΥΣΙΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ Π.Δ.Κ.Α.· ΣΚΟΝΗΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΡΜΑΤΟΣ',
  },
  {
    label: '20595200',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΟΛΤΩΝ ΠΡΟΠΛΑΣΜΑΤΩΝ· ΟΔΟΝΤΙΑΤΡΙΚΟΥ ΚΗΡΟΥ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΧΡΗΣΗ ΣΤΗΝ ΟΔΟΝΤΙΑΤΡΙΚΗ ΜΕ ΒΑΣΗ ΤΟ ΓΥΨΟ, ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΓΟΜΩΣΕΩΝ ΓΙΑ ΠΥΡΟΣΒΕΣΤΗΡΕΣ· ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΜΕΣΩΝ ΚΑΛΛΙΕΡΓΕΙΑΣ ΓΙΑ ΤΗΝ ΑΝΑΠΤΥΞΗ ΜΙΚΡΟΟΡΓΑΝΙΣΜΩΝ· ΣΥΝ',
  },
  {
    label: '20595201',
    value: 'ΠΑΡΑΓΩΓΗ ΠΛΑΣΤΕΛΙΝΗΣ',
  },
  {
    label: '20595300',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΗΜΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΣΕ ΜΟΡΦΗ ΔΙΣΚΟΥ ΚΑΙ ΕΝΩΣΕΩΝ ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΧΗΜΙΚΗ ΚΑΤΕΡΓΑΣΙΑ ΓΙΑ ΧΡΗΣΗ ΣΤΗΝ ΗΛΕΚΤΡΟΝΙΚΗ',
  },
  {
    label: '20595400',
    value: 'ΠΑΡΑΓΩΓΗ ΕΝΕΡΓΟΥ ΑΝΘΡΑΚΑ',
  },
  {
    label: '20595500',
    value:
      'ΠΑΡΑΓΩΓΗ ΥΛΙΚΩΝ ΤΕΛΕΙΟΠΟΙΗΣΗΣ (ΦΙΝΙΡΙΣΜΑΤΟΣ), ΦΟΡΕΩΝ ΒΑΦΗΣ ΠΟΥ ΕΠΙΤΑΧΥΝΟΥΝ ΤΗ ΒΑΦΗ Η ΣΤΕΡΕΟΠΟΙΟΥΝ ΤΙΣ ΒΑΦΕΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '20595600',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΘΑΡΙΣΜΟΥ· ΣΥΛΛΙΠΑΣΜΑΤΩΝ· ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΕΠΙΤΑΧΥΝΤΩΝ ΒΟΥΛΚΑΝΙΣΜΟΥ· ΠΛΑΣΤΙΚΟΠΟΙΗΤΙΚΩΝ ΚΑΙ ΣΤΑΘΕΡΟΠΟΙΗΤΙΚΩΝ ΕΝΩΣΕΩΝ ΓΙΑ ΕΛΑΣΤΙΚΟ Η ΠΛΑΣΤΙΚΟ· ΚΑΤΑΛΥΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α.· ΜΕΙΚΤΟΥ ΑΛΚΥΛΟΒΕΝΖΟΛΙΟΥ ΚΑΙ ΑΛΚΥΛΟΝΑΦ',
  },
  {
    label: '20595700',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΥΝΔΕΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΓΙΑ ΚΑΛΟΥΠΙΑ Η ΠΥΡΗΝΕΣ ΧΥΤΗΡΙΟΥ',
  },
  {
    label: '20595900',
    value: 'ΠΑΡΑΓΩΓΗ ΔΙΑΦΟΡΩΝ ΑΛΛΩΝ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '20595901',
    value: 'ΠΑΡΑΓΩΓΗ ΒΙΟΑΕΡΙΟΥ ΑΠΟ ΑΓΡΟΤΙΚΕΣ ΠΡΩΤΕΣ ΥΛΕΣ',
  },
  {
    label: '20595902',
    value: 'ΠΑΡΑΓΩΓΗ ΒΙΟΚΑΥΣΙΜΩΝ (ΣΤΕΡΕΩΝ, ΥΓΡΩΝ Η ΑΕΡΙΩΝ)',
  },
  {
    label: '20596000',
    value:
      'ΠΑΡΑΓΩΓΗ ΖΕΛΑΤΙΝΩΝ ΚΑΙ ΠΑΡΑΓΩΓΩΝ ΖΕΛΑΤΙΝΩΝ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΓΑΛΑΚΤΟΑΛΒΟΥΜΙΝΩΝ',
  },
  {
    label: '20599000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '20600000',
    value: 'ΠΑΡΑΓΩΓΗ ΜΗ ΦΥΣΙΚΩΝ ΙΝΩΝ',
  },
  {
    label: '20601000',
    value: 'ΠΑΡΑΓΩΓΗ ΣΥΝΘΕΤΙΚΩΝ ΙΝΩΝ',
  },
  {
    label: '20601100',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΥΝΘΕΤΙΚΩΝ ΣΥΝΕΧΩΝ ΚΑΙ ΑΣΥΝΕΧΩΝ ΙΝΩΝ, ΜΗ ΛΑΝΑΡΙΣΜΕΝΩΝ Η ΧΤΕΝΙΣΜΕΝΩΝ',
  },
  {
    label: '20601200',
    value: 'ΠΑΡΑΓΩΓΗ ΙΝΩΝ ΥΨΗΛΗΣ ΑΝΤΟΧΗΣ ΑΠΟ ΠΟΛΥΑΜΙΔΙΑ ΚΑΙ ΠΟΛΥΕΣΤΕΡΕΣ',
  },
  {
    label: '20601300',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΣΥΝΘΕΤΙΚΩΝ ΙΝΩΝ, ΑΠΛΩΝ',
  },
  {
    label: '20601400',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΥΝΘΕΤΙΚΩΝ ΜΟΝΟΙΝΩΝ ΝΗΜΑΤΩΝ· ΛΩΡΙΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΣΥΝΘΕΤΙΚΑ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ',
  },
  {
    label: '20602000',
    value: 'ΠΑΡΑΓΩΓΗ ΤΕΧΝΗΤΩΝ ΙΝΩΝ',
  },
  {
    label: '20602100',
    value:
      'ΠΑΡΑΓΩΓΗ ΤΕΧΝΗΤΩΝ ΣΥΝΕΧΩΝ ΚΑΙ ΑΣΥΝΕΧΩΝ ΙΝΩΝ, ΜΗ ΛΑΝΑΡΙΣΜΕΝΩΝ Η ΧΤΕΝΙΣΜΕΝΩΝ',
  },
  {
    label: '20602200',
    value: 'ΠΑΡΑΓΩΓΗ ΙΝΩΝ ΥΨΗΛΗΣ ΑΝΤΟΧΗΣ ΑΠΟ ΒΙΣΚΟΖΗ',
  },
  {
    label: '20602300',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΤΕΧΝΗΤΩΝ ΙΝΩΝ, ΑΠΛΩΝ',
  },
  {
    label: '20602400',
    value:
      'ΠΑΡΑΓΩΓΗ ΤΕΧΝΗΤΩΝ ΜΟΝΟΙΝΩΝ ΝΗΜΑΤΩΝ· ΛΩΡΙΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΤΕΧΝΗΤΑ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ',
  },
  {
    label: '20609000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΤΕΧΝΗΤΩΝ ΙΝΩΝ',
  },
  {
    label: '21100000',
    value: 'ΠΑΡΑΓΩΓΗ ΒΑΣΙΚΩΝ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '21101000',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΑΛΙΚΥΛΙΚΟΥ ΟΞΕΩΣ, Ο;ΑΚΕΤΥΛΟΣΑΛΙΚΥΛΙΚΟΥ ΟΞΕΩΣ, ΤΩΝ ΑΛΑΤΩΝ ΚΑΙ ΤΩΝ ΕΣΤΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '21102000',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΥΣΙΝΗΣ, ΓΛΟΥΤΑΜΙΝΙΚΟΥ ΟΞΕΩΣ ΚΑΙ ΤΩΝ ΑΛΑΤΩΝ ΤΟΥΣ· ΑΛΑΤΩΝ ΚΑΙ ΥΔΡΟΞΕΙΔΙΩΝ ΤΟΥ ΤΕΤΑΡΤΟΤΑΓΟΥΣ ΑΜΜΩΝΙΟΥ· ΦΩΣΦΟΡΟΑΜΙΝΟΛΙΠΙΔΙΩΝ· ΑΜΙΔΙΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ ΚΑΘΩΣ ΚΑΙ ΤΩΝ ΑΛΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '21103000',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΑΚΤΟΝΩΝ Π.Δ.Κ.Α., ΕΤΕΡΟΚΥΚΛΙΚΩΝ ΕΝΩΣΕΩΝ ΜΟΝΟ ΜΕ ΕΤΕΡΟΑΤΟΜΟ(Α) ΤΟΥ ΑΖΩΤΟΥ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΣΤΗ ΔΟΜΗ ΤΟΥΣ ΜΗ ΣΥΝΕΝΩΜΕΝΟ ΔΑΚΤΥΛΙΟ ΠΥΡΑΖΟΛΙΟΥ Η ΤΡΙΑΖΙΝΗΣ, ΔΑΚΤΥΛΙΟ ΠΥΡΙΜΙΔΙΝΗΣ, ΠΙΠΕΡΑΖΙΝΗΣ Η ΣΥΣΤΗΜΑ ΔΑΚΤΥΛΙΩΝ ΦΑΙΝΟΘΕΙΑΖΙΝΗΣ ΧΩΡΙΣ ΑΛΛΕΣ Σ',
  },
  {
    label: '21103200',
    value: 'ΠΑΡΑΓΩΓΗ ΣΟΥΛΦΟΝΑΜΙΔΩΝ',
  },
  {
    label: '21104000',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΑΚΧΑΡΩΝ, ΧΗΜΙΚΑ ΚΑΘΑΡΩΝ, Π.Δ.Κ.Α.· ΑΙΘΕΡΩΝ ΚΑΙ ΕΣΤΕΡΩΝ ΣΑΚΧΑΡΩΝ ΚΑΙ ΤΩΝ ΑΛΑΤΩΝ ΤΟΥΣ Π.Δ.Κ.Α.',
  },
  {
    label: '21105000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΡΟΒΙΤΑΜΙΝΩΝ, ΒΙΤΑΜΙΝΩΝ ΚΑΙ ΟΡΜΟΝΩΝ· ΓΛΥΚΟΖΙΤΩΝ ΚΑΙ ΦΥΤΙΚΩΝ ΑΛΚΑΛΟΕΙΔΩΝ ΚΑΙ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ· ΑΝΤΙΒΙΟΤΙΚΩΝ',
  },
  {
    label: '21105100',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΟΒΙΤΑΜΙΝΩΝ, ΒΙΤΑΜΙΝΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '21105200',
    value:
      'ΠΑΡΑΓΩΓΗ ΟΡΜΟΝΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ· ΑΛΛΩΝ ΣΤΕΡΟΕΙΔΩΝ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΚΥΡΙΩΣ ΩΣ ΟΡΜΟΝΕΣ',
  },
  {
    label: '21105300',
    value:
      'ΠΑΡΑΓΩΓΗ ΓΛΥΚΟΖΙΤΩΝ, ΦΥΤΙΚΩΝ ΑΛΚΑΛΟΕΙΔΩΝ, ΤΩΝ ΑΛΑΤΩΝ, ΤΩΝ ΑΙΘΕΡΩΝ, ΤΩΝ ΕΣΤΕΡΩΝ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '21105400',
    value: 'ΠΑΡΑΓΩΓΗ ΑΝΤΙΒΙΟΤΙΚΩΝ',
  },
  {
    label: '21106000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΔΕΝΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΩΝ· ΕΚΧΥΛΙΣΜΑΤΩΝ ΤΟΥΣ ΚΑΙ ΑΛΛΩΝ ΑΝΘΡΩΠΙΝΩΝ Η ΖΩΙΚΩΝ ΟΥΣΙΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '21109000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '21200000',
    value: 'ΠΑΡΑΓΩΓΗ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΣΚΕΥΑΣΜΑΤΩΝ',
  },
  {
    label: '21201000',
    value: 'ΠΑΡΑΓΩΓΗ ΦΑΡΜΑΚΩΝ',
  },
  {
    label: '21201100',
    value: 'ΠΑΡΑΓΩΓΗ ΦΑΡΜΑΚΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΠΕΝΙΚΙΛΙΝΕΣ Η ΑΛΛΑ ΑΝΤΙΒΙΟΤΙΚΑ',
  },
  {
    label: '21201200',
    value: 'ΠΑΡΑΓΩΓΗ ΦΑΡΜΑΚΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΟΡΜΟΝΕΣ, ΑΛΛΑ ΟΧΙ ΑΝΤΙΒΙΟΤΙΚΑ',
  },
  {
    label: '21201300',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΑΡΜΑΚΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΑΛΚΑΛΟΕΙΔΗ Η ΠΑΡΑΓΩΓΑ ΤΟΥΣ, ΑΛΛΑ ΟΧΙ ΟΡΜΟΝΕΣ Η ΑΝΤΙΒΙΟΤΙΚΑ',
  },
  {
    label: '21202000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΣΚΕΥΑΣΜΑΤΩΝ',
  },
  {
    label: '21202100',
    value: 'ΠΑΡΑΓΩΓΗ ΑΝΤΙΟΡΩΝ ΚΑΙ ΕΜΒΟΛΙΩΝ',
  },
  {
    label: '21202200',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΗΜΙΚΩΝ ΑΝΤΙΣΥΛΛΗΠΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΜΕ ΒΑΣΗ ΟΡΜΟΝΕΣ Η ΣΠΕΡΜΑΤΟΚΤΟΝΑ',
  },
  {
    label: '21202300',
    value:
      'ΠΑΡΑΓΩΓΗ ΔΙΑΓΝΩΣΤΙΚΩΝ ΑΝΤΙΔΡΑΣΤΗΡΙΩΝ ΚΑΙ ΑΛΛΩΝ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΣΚΕΥΑΣΜΑΤΩΝ',
  },
  {
    label: '21202400',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΥΓΚΟΛΛΗΤΙΚΩΝ ΕΠΙΔΕΣΜΩΝ, ΧΕΙΡΟΥΡΓΙΚΩΝ ΡΑΜΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΛΙΚΩΝ· ΚΟΥΤΙΩΝ ΠΡΩΤΩΝ ΒΟΗΘΕΙΩΝ',
  },
  {
    label: '21209000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΣΚΕΥΑΣΜΑΤΩΝ',
  },
  {
    label: '22110000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΚΑΙ ΣΩΛΗΝΩΝ ΑΠΟ ΚΑΟΥΤΣΟΥΚ· ΑΝΑΓΟΜΩΣΗ ΚΑΙ ΑΝΑΚΑΤΑΣΚΕΥΗ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '22111000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΚΑΙ ΣΩΛΗΝΩΝ (ΑΕΡΟΘΑΛΑΜΩΝ)',
  },
  {
    label: '22111100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΑ ΟΧΗΜΑΤΑ ΜΕ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '22111200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΙΣ ΜΟΤΟΣΙΚΛΕΤΕΣ Η ΣΤΑ ΠΟΔΗΛΑΤΑ',
  },
  {
    label: '22111300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΑ ΛΕΩΦΟΡΕΙΑ, ΣΤΑ ΦΟΡΤΗΓΑ Η ΣΤΑ ΑΕΡΟΣΚΑΦΗ',
  },
  {
    label: '22111400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΓΡΟΤΙΚΩΝ ΕΠΙΣΩΤΡΩΝ· ΑΛΛΩΝ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '22111500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΣΩΤΕΡΙΚΩΝ ΣΩΛΗΝΩΝ (ΑΕΡΟΘΑΛΑΜΩΝ), ΣΥΜΠΑΓΩΝ Η ΗΜΙΣΥΜΠΑΓΩΝ (ΚΟΙΛΩΝ) ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ), ΕΥΚΟΛΑ ΑΝΤΙΚΑΘΙΣΤΩΜΕΝΩΝ ΠΕΛΜΑΤΩΝ ΕΠΙΣΩΤΡΩΝ ΚΑΙ ΕΣΩΤΕΡΙΚΩΝ ΠΡΟΣΤΑΤΕΥΤΙΚΩΝ ΤΑΙΝΙΩΝ ΕΠΙΣΩΤΡΩΝ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '22111600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΚΑΘΟΡΙΣΜΕΝΗΣ ΜΟΡΦΗΣ ΓΙΑ ΤΗΝ ΑΝΑΓΟΜΩΣΗ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ)',
  },
  {
    label: '22112000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΑΓΟΜΩΜΕΝΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '22119000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΛΑΣΤΙΚΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΚΑΙ ΣΩΛΗΝΩΝ (ΑΕΡΟΘΑΛΑΜΩΝ)· ΑΝΑΓΟΜΩΣΗ ΚΑΙ ΑΝΑΚΑΤΑΣΚΕΥΗ ΕΠΙΣΩΤΡΩΝ ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '22190000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΕΛΑΣΤΙΚΟ (ΚΑΟΥΤΣΟΥΚ)',
  },
  {
    label: '22191000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΑΓΕΝΝΗΜΕΝΟΥ ΕΛΑΣΤΙΚΟΥ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ Η ΠΛΑΚΕΣ, ΦΥΛΛΑ Η ΛΩΡΙΔΕΣ',
  },
  {
    label: '22192000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗ ΒΟΥΛΚΑΝΙΣΜΕΝΟΥ ΕΛΑΣΤΙΚΟΥ ΚΑΙ ΕΙΔΩΝ ΤΟΥ· ΒΟΥΛΚΑΝΙΣΜΕΝΟΥ ΕΛΑΣΤΙΚΟΥ, ΕΚΤΟΣ ΤΟΥ ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ, ΣΕ ΝΗΜΑΤΑ, ΣΧΟΙΝΙΑ, ΠΛΑΚΕΣ, ΦΥΛΛΑ, ΛΩΡΙΔΕΣ, ΡΑΒΔΟΥΣ ΚΑΙ ΚΑΘΟΡΙΣΜΕΝΕΣ ΜΟΡΦΕΣ',
  },
  {
    label: '22193000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΓΩΓΩΝ, ΣΩΛΗΝΩΝ ΚΑΙ ΜΑΝΙΚΩΝ, ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ ΕΚΤΟΣ ΤΟΥ ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ',
  },
  {
    label: '22194000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΙΜΑΝΤΩΝ ΜΕΤΑΦΟΡΑΣ Η ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ, ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ',
  },
  {
    label: '22195000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΛΑΣΤΙΚΟΠΟΙΗΜΕΝΩΝ ΥΦΑΣΜΑΤΩΝ, ΕΚΤΟΣ ΑΠΟ ΠΛΕΓΜΑΤΑ ΕΝΙΣΧΥΣΗΣ (ΛΙΝΑ) ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ)',
  },
  {
    label: '22196000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ, ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ, ΕΚΤΟΣ ΤΟΥ ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ',
  },
  {
    label: '22197000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ Π.Δ.Κ.Α.· ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ· ΑΝΤΙΚΕΙΜΕΝΩΝ ΑΠΟ ΣΚΛΗΡΥΜΕΝΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '22197100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ Η ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΕΙΔΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΤΑ ΘΗΛΑΣΤΡΑ), ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ, ΕΚΤΟΣ ΤΟΥ ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ',
  },
  {
    label: '22197200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΩΝ ΚΑΙ ΠΑΤΑΚΙΩΝ, ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ, ΕΚΤΟΣ ΤΟΥ ΚΥΤΤΑΡΙΝΟΕΙΔΟΥΣ',
  },
  {
    label: '22197300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ Π.Δ.Κ.Α.· ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ ΣΕ ΟΛΕΣ ΤΙΣ ΜΟΡΦΕΣ ΚΑΙ ΕΙΔΗ ΤΟΥ· ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΟΥ ΚΑΙ ΠΑΤΑΚΙΩΝ ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΚΥΨΕΛΩΔΕΣ',
  },
  {
    label: '22197301',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΚΟΛΛΗΤΩΝ ΥΦΑΣΜΑΤΙΝΩΝ ΤΑΙΝΙΩΝ ΕΜΠΟΤΙΣΜΕΝΩΝ ΜΕ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '22199000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΕΛΑΣΤΙΚΟ (ΚΑΟΥΤΣΟΥΚ)',
  },
  {
    label: '22210000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΑΣΤΙΚΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΣΩΛΗΝΩΝ ΚΑΙ ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ',
  },
  {
    label: '22211000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΝΟΙΝΩΝ ΝΗΜΑΤΩΝ ΣΤΑ ΟΠΟΙΑ Η ΜΕΓΑΛΥΤΕΡΗ ΔΙΑΣΤΑΣΗ ΤΗΣ ΕΓΚΑΡΣΙΑΣ ΤΟΜΗΣ ΥΠΕΡΒΑΙΝΕΙ ΤΟ 1 ~ MM, ΣΕ ΡΑΒΔΟΥΣ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΚΑΘΟΡΙΣΜΕΝΕΣ ΜΟΡΦΕΣ, ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22212000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΓΩΓΩΝ, ΣΩΛΗΝΩΝ ΚΑΙ ΜΑΝΙΚΩΝ, ΚΑΘΩΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ, ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22212100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΕΧΝΗΤΩΝ ΕΝΤΕΡΩΝ (ΑΛΛΑΝΤΟΠΟΙΙΑΣ) ΑΠΟ ΣΚΛΗΡΥΜΕΝΕΣ ΠΡΩΤΕΪΝΕΣ Η ΑΠΟ ΚΥΤΤΑΡΙΝΙΚΕΣ ΥΛΕΣ· ΑΓΩΓΩΝ, ΣΩΛΗΝΩΝ ΚΑΙ ΜΑΝΙΚΩΝ, ΑΚΑΜΠΤΩΝ, ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22212900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΑΓΩΓΩΝ, ΣΩΛΗΝΩΝ, ΜΑΝΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ, ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22212901',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΑΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΑΡΔΕΥΣΗΣ ΚΑΙ ΑΠΟΧΕΤΕΥΣΗΣ',
  },
  {
    label: '22213000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΕΝΙΣΧΥΜΕΝΕΣ Η ΚΑΤΑ ΠΑΡΟΜΟΙΟ ΤΡΟΠΟ ΣΥΝΔΥΑΣΜΕΝΕΣ ΜΕ ΑΛΛΑ ΥΛΙΚΑ',
  },
  {
    label: '22213001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΚΡΥΛΙΚΩΝ ΦΥΛΛΩΝ (PLEXI;GLASS), ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΕΝΙΣΧΥΜΕΝΑ',
  },
  {
    label: '22213002',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΟΝΩΤΙΚΩΝ ΥΛΙΚΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22214000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22214100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΚΥΨΕΛΩΔΕΙΣ',
  },
  {
    label: '22214200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΜΗ ΚΥΨΕΛΩΔΕΙΣ',
  },
  {
    label: '22219000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΛΑΣΤΙΚΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ',
  },
  {
    label: '22220000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΑΣΤΙΚΩΝ ΕΙΔΩΝ ΣΥΣΚΕΥΑΣΙΑΣ',
  },
  {
    label: '22221100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΑΚΩΝ ΚΑΙ ΤΣΑΝΤΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΧΩΝΙΑ), ΑΠΟ ΠΟΛΥΜΕΡΗ ΤΟΥ ΑΙΘΥΛΕΝΙΟΥ',
  },
  {
    label: '22221101',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΑΣΤΙΚΩΝ ΑΛΕΥΡΟΣΑΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΠΟΛΥΜΕΡΗ ΤΟΥ ΑΙΘΥΛΕΝΙΟΥ',
  },
  {
    label: '22221200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΑΚΩΝ ΚΑΙ ΤΣΑΝΤΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΧΩΝΙΑ), ΑΠΟ ΑΛΛΕΣ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ ΕΚΤΟΣ ΑΠΟ ΠΟΛΥΜΕΡΗ ΤΟΥ ΑΙΘΥΛΕΝΙΟΥ',
  },
  {
    label: '22221201',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΑΣΤΙΚΩΝ ΑΛΕΥΡΟΣΑΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΑΛΛΕΣ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ (ΕΚΤΟΣ ΤΟΥ ΑΙΘΥΛΕΝΙΟΥ)',
  },
  {
    label: '22221300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΥΤΙΩΝ, ΘΗΚΩΝ, ΚΙΒΩΤΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22221400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΝΤΑΜΙΤΖΑΝΩΝ, ΜΠΟΥΚΑΛΙΩΝ, ΦΙΑΛΩΝ, ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22221900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΕΙΔΩΝ ΣΥΣΚΕΥΑΣΙΑΣ',
  },
  {
    label: '22221901',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΑΣΤΙΚΩΝ ΣΩΛΗΝΑΡΙΩΝ',
  },
  {
    label: '22229000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΛΑΣΤΙΚΩΝ ΕΙΔΩΝ ΣΥΣΚΕΥΑΣΙΑΣ',
  },
  {
    label: '22230000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΑΣΤΙΚΩΝ ΟΙΚΟΔΟΜΙΚΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '22231000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΑΣΤΙΚΩΝ ΟΙΚΟΔΟΜΙΚΩΝ ΕΙΔΩΝ· ΛΙΝΟΤΑΠΗΤΩΝ ΚΑΙ ΣΚΛΗΡΩΝ ΜΗ ΠΛΑΣΤΙΚΩΝ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΟΥ',
  },
  {
    label: '22231100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΩΝ, ΤΟΙΧΩΝ Η ΟΡΟΦΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΣΕ ΡΟΛΑ Η ΥΠΟ ΜΟΡΦΗ ΠΛΑΚΙΔΙΩΝ',
  },
  {
    label: '22231101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΨΗΦΙΔΩΤΩΝ ΕΠΕΝΔΥΣΕΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22231200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΠΑΝΙΕΡΩΝ, ΝΙΠΤΗΡΩΝ, ΛΕΚΑΝΩΝ ΚΑΙ ΤΩΝ ΚΑΛΥΜΜΑΤΩΝ ΤΟΥΣ, ΚΑΖΑΝΑΚΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22231201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΑΠΟ ΠΟΛΥΕΣΤΕΡΑ',
  },
  {
    label: '22231300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΑΜΙΕΥΤΗΡΩΝ, ΔΕΞΑΜΕΝΩΝ, ΚΑΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ, ΧΩΡΗΤΙΚΟΤΗΤΑΣ > 300 ~ LT ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22231400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΟΡΤΩΝ, ΠΑΡΑΘΥΡΩΝ ΚΑΙ ΠΛΑΙΣΙΩΝ, ΚΑΘΩΣ ΚΑΙ ΚΑΤΩΦΛΙΩΝ ΓΙΑ ΠΟΡΤΕΣ· ΠΑΡΑΘΥΡΟΦΥΛΛΩΝ, ΡΟΛΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22231401',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΚΙΑΣΤΡΩΝ ΚΑΙ ΡΟΛΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22231500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΛΙΝΟΤΑΠΗΤΩΝ ΚΑΙ ΣΚΛΗΡΩΝ ΜΗ ΠΛΑΣΤΙΚΩΝ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΟΥ, Π.Χ. ΕΥΚΑΜΠΤΩΝ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΟΥ, ΟΠΩΣ ΔΑΠΕΔΩΝ ΒΙΝΥΛΙΟΥ ΚΛΠ',
  },
  {
    label: '22231900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΑΣΤΙΚΩΝ ΟΙΚΟΔΟΜΙΚΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '22232000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΚΤΙΡΙΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22239000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΟΙΚΟΔΟΜΙΚΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22290000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '22291000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΜΑΣΙΑΣ (ΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΓΑΝΤΙΑ), ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22291001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΑΣΤΙΚΩΝ ΓΑΝΤΙΩΝ',
  },
  {
    label: '22292000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '22292100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΚΟΛΛΗΤΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ, ΛΩΡΙΔΩΝ ΚΑΙ ΑΛΛΩΝ ΕΠΙΠΕΔΩΝ ΜΟΡΦΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΣΕ ΡΟΛΑ ΠΛΑΤΟΥΣ <= 20 ;CM',
  },
  {
    label: '22292200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΑΥΤΟΚΟΛΛΗΤΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ, ΛΟΥΡΙΔΩΝ, ΜΕΜΒΡΑΝΩΝ ΚΑΙ ΑΛΛΩΝ ΕΠΙΠΕΔΩΝ ΜΟΡΦΩΝ, ΑΥΤΟΚΟΛΛΗΤΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22292300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΚΕΥΩΝ, ΜΑΓΕΙΡΙΚΩΝ ΣΚΕΥΩΝ, ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22292400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ Π.Δ.Κ.Α. ΓΙΑ ΛΑΜΠΤΗΡΕΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΑ ΦΩΤΙΣΜΟΥ, ΓΙΑ ΦΩΤΕΙΝΕΣ ΠΙΝΑΚΙΔΕΣ ΚΑΙ ΓΙΑ ΠΑΡΟΜΟΙΑ ΕΙΔΗ, ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22292500',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΦΟΔΙΩΝ ΓΡΑΦΕΙΟΥ Η ΣΧΟΛΙΚΩΝ ΕΦΟΔΙΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22292501',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΑΣΤΙΚΩΝ ΕΠΟΠΤΙΚΩΝ ΜΕΣΩΝ ΔΙΔΑΣΚΑΛΙΑΣ',
  },
  {
    label: '22292600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΕΠΙΠΛΑ, ΑΜΑΞΩΜΑΤΑ Η ΠΑΡΟΜΟΙΑ ΕΙΔΗ· ΑΓΑΛΜΑΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22292900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '22292901',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΑΣΤΙΚΩΝ ΓΛΑΣΤΡΩΝ, ΖΑΡΝΤΙΝΙΕΡΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '22299000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '22299100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '22299101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΚΑΛΥΨΗΣ ΥΠΟ ΚΕΝΟ ΜΕ ΜΕΤΑΛΛΟ ΠΛΑΣΤΙΚΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ',
  },
  {
    label: '22299102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΠΛΑΣΤΙΚΩΝ ΜΕΡΩΝ ΜΕ ΔΙΑΔΙΚΑΣΙΕΣ ΠΛΑΣΤΙΚΟΠΟΙΗΣΗΣ, ΣΥΜΦΩΝΑ ΜΕ ΤΙΣ ΠΡΟΔΙΑΓΡΑΦΕΣ ΤΩΝ ΠΕΛΑΤΩΝ',
  },
  {
    label: '22299103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΧΥΤΕΥΤΩΝ Η ΘΕΡΜΟΧΥΤΕΥΤΩΝ ΜΕΡΩΝ ΑΠΟ ΘΕΡΜΟΠΛΑΣΤΙΚΑ Η ΘΕΡΜΟΣΚΛΗΡΥΝΟΜΕΝΑ ΥΛΙΚΑ',
  },
  {
    label: '22299104',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΟΠΗΣ, ΔΙΑΤΡΗΣΗΣ, ΧΑΡΑΞΗΣ, ΕΠΙΚΑΛΥΨΗΣ Η ΚΑΤΕΡΓΑΣΙΑΣ ΠΛΑΣΤΙΚΩΝ ΕΠΙΦΑΝΕΙΩΝ',
  },
  {
    label: '22299900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '23110000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΠΙΠΕΔΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '23111100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΥΑΛΙΟΥ ΧΥΤΕΥΤΟΥ, ΕΛΑΤΟΥ, ΟΛΚΙΜΟΥ Η ΦΥΣΗΤΟΥ, ΣΕ ΦΥΛΛΑ, ΑΛΛΑ ΟΧΙ ΚΑΤΕΡΓΑΣΜΕΝΟΥ ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ',
  },
  {
    label: '23111200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΥΑΛΙΟΥ ΕΠΙΠΛΕΥΣΕΩΣ (FLOAT GLASS) ΚΑΙ ΕΠΙΦΑΝΕΙΑΚΟΥ ΛΕΙΟΤΡΙΒΙΜΕΝΟΥ Η ΣΤΙΛΒΩΜΕΝΟΥ ΓΥΑΛΙΟΥ, ΣΕ ΦΥΛΛΑ, ΑΛΛΑ ΟΧΙ ΚΑΤΕΡΓΑΣΜΕΝΟΥ ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ',
  },
  {
    label: '23119000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΠΙΠΕΔΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '23120000',
    value: 'ΜΟΡΦΟΠΟΙΗΣΗ ΚΑΙ ΚΑΤΕΡΓΑΣΙΑ ΕΠΙΠΕΔΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '23121100',
    value:
      'ΜΟΡΦΟΠΟΙΗΣΗ ΚΑΙ ΚΑΤΕΡΓΑΣΙΑ ΓΥΑΛΙΟΥ ΣΕ ΦΥΛΛΑ, ΚΥΡΤΩΜΕΝΟΥ, ΜΕ ΚΑΤΕΡΓΑΣΜΕΝΑ ΑΚΡΑ, ΧΑΡΑΓΜΕΝΟΥ, ΔΙΑΤΡΗΤΟΥ, ΕΦΥΑΛΩΜΕΝΟΥ Η ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ ΚΑΤΕΡΓΑΣΜΕΝΟΥ, ΑΛΛΑ ΜΗ ΠΛΑΙΣΙΩΜΕΝΟΥ Η ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΟΥ',
  },
  {
    label: '23121200',
    value: 'ΜΟΡΦΟΠΟΙΗΣΗ ΚΑΙ ΚΑΤΕΡΓΑΣΙΑ ΓΥΑΛΙΟΥ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '23121300',
    value:
      'ΜΟΡΦΟΠΟΙΗΣΗ ΚΑΙ ΚΑΤΕΡΓΑΣΙΑ ΓΥΑΛΙΝΩΝ ΚΑΘΡΕΠΤΩΝ· ΜΟΝΩΤΙΚΩΝ ΠΛΑΚΩΝ ΑΠΟ ΓΥΑΛΙ ΜΕ ΠΟΛΛΑΠΛΑ ΤΟΙΧΩΜΑΤΑ',
  },
  {
    label: '23121301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΥΑΛΙΝΩΝ ΜΟΝΩΤΙΚΩΝ ΠΛΑΚΩΝ',
  },
  {
    label: '23121302',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΑΤΟΠΤΡΩΝ',
  },
  {
    label: '23129000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΜΟΡΦΟΠΟΙΗΜΕΝΟΥ ΚΑΙ ΚΑΤΕΡΓΑΣΜΕΝΟΥ ΕΠΙΠΕΔΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '23129901',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΑΛΟΧΑΡΑΚΤΙΚΗΣ ΚΑΙ ΔΙΑΚΟΣΜΗΣΗΣ ΓΥΑΛΙΟΥ ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ',
  },
  {
    label: '23129902',
    value: 'ΤΡΟΧΙΣΗ ΕΠΙΠΕΔΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '23130000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΟΙΛΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '23131100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΠΟΥΚΑΛΙΩΝ, ΠΛΑΤΥΣΤΟΜΩΝ ΔΟΧΕΙΩΝ, ΦΙΑΛΙΔΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΟΧΕΙΩΝ, ΑΠΟ ΓΥΑΛΙ, ΕΚΤΟΣ ΑΠΟ ΑΜΠΟΥΛΕΣ· ΠΩΜΑΤΩΝ ΚΑΙ ΛΟΙΠΩΝ ΕΙΔΩΝ ΠΩΜΑΤΙΣΜΟΥ, ΑΠΟ ΓΥΑΛΙ',
  },
  {
    label: '23131200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΟΤΗΡΙΩΝ ΑΠΟ ΓΥΑΛΙ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΥΑΛΟΚΕΡΑΜΙΚΑ',
  },
  {
    label: '23131201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΟΤΗΡΙΩΝ ΑΠΟ ΜΟΛΥΒΔΟΥΧΟ ΚΡΥΣΤΑΛΛΟ',
  },
  {
    label: '23131300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΥΑΛΙΝΩΝ ΕΙΔΩΝ, ΕΠΙΤΡΑΠΕΖΙΩΝ Η ΜΑΓΕΙΡΙΚΩΝ, ΚΑΛΛΩΠΙΣΜΟΥ, ΓΡΑΦΕΙΟΥ, ΕΣΩΤΕΡΙΚΗΣ ΔΙΑΚΟΣΜΗΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ',
  },
  {
    label: '23131301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΝΥΔΡΕΙΩΝ ΨΑΡΙΩΝ',
  },
  {
    label: '23131400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΥΑΛΙΝΩΝ ΕΣΩΤΕΡΙΚΩΝ ΓΙΑ ΦΙΑΛΕΣ ΚΕΝΟΥ Η ΑΛΛΑ ΣΚΕΥΗ ΚΕΝΟΥ',
  },
  {
    label: '23139000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΕΛΕΙΟΠΟΙΗΣΗΣ (ΦΙΝΙΡΙΣΜΑΤΟΣ) ΚΟΙΛΟΥ ΓΥΑΛΙΟΥ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΚΟΙΛΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '23139100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΕΛΕΙΟΠΟΙΗΣΗΣ (ΦΙΝΙΡΙΣΜΑΤΟΣ) ΠΟΤΗΡΙΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΓΥΑΛΙ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΟ ΤΡΑΠΕΖΙ Η ΣΤΗΝ ΚΟΥΖΙΝΑ',
  },
  {
    label: '23139200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΕΛΕΙΟΠΟΙΗΣΗΣ (ΦΙΝΙΡΙΣΜΑΤΟΣ) ΓΥΑΛΙΝΩΝ ΔΟΧΕΙΩΝ',
  },
  {
    label: '23139900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΚΟΙΛΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '23139901',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΑΛΟΧΑΡΑΚΤΙΚΗΣ ΚΑΙ ΔΙΑΚΟΣΜΗΣΗΣ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΚΡΥΣΤΑΛΛΑ ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ',
  },
  {
    label: '23139902',
    value: 'ΤΡΟΧΙΣΗ ΚΡΥΣΤΑΛΛΩΝ ΓΙΑ ΚΑΤΑΣΚΕΥΗ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '23140000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΙΝΩΝ ΓΥΑΛΙΟΥ',
  },
  {
    label: '23141100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΙΤΙΛΙΩΝ, ΠΡΟΝΗΜΑΤΩΝ, ΝΗΜΑΤΩΝ ΚΑΙ ΚΟΜΜΕΝΩΝ ΚΛΩΝΩΝ, ΑΠΟ ΙΝΕΣ ΓΥΑΛΙΟΥ',
  },
  {
    label: '23141200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΟΥΛΙΩΝ, ΠΛΕΓΜΑΤΩΝ, ΠΑΤΑΚΙΩΝ, ΣΤΡΩΜΑΤΩΝ, ΣΑΝΙΔΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΙΝΕΣ ΓΥΑΛΙΟΥ, ΕΚΤΟΣ ΑΠΟ ΥΦΑΝΤΑ ΥΦΑΣΜΑΤΑ',
  },
  {
    label: '23149000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΙΝΩΝ ΓΥΑΛΙΟΥ',
  },
  {
    label: '23190000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΙ ΚΑΤΕΡΓΑΣΙΑ ΑΛΛΩΝ ΕΙΔΩΝ ΓΥΑΛΙΟΥ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΓΥΑΛΙΟΥ ΓΙΑ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '23191000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΓΥΑΛΙ, ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΩΝ',
  },
  {
    label: '23191100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΥΑΛΙΟΥ ΣΕ ΜΑΖΑ, ΣΕ ΣΦΑΙΡΕΣ (ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΜΙΚΡΟΣΦΑΙΡΕΣ), ΣΕ ΡΑΒΔΟΥΣ Η ΣΕ ΣΩΛΗΝΕΣ, ΑΚΑΤΕΡΓΑΣΤΟΥ',
  },
  {
    label: '23191200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΥΒΟΛΙΘΩΝ, ΤΟΥΒΛΩΝ, ΠΛΑΚΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΠΡΕΣΣΑΡΙΣΤΟ Η ΧΥΤΟ ΓΥΑΛΙ· ΓΥΑΛΙΩΝ ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΩΝ ΣΕ ΔΙΑΚΟΣΜΗΤΙΚΑ ΥΑΛΟΣΤΑΣΙΑ (ΒΙΤΡΟ)· ΠΟΛΥΚΥΨΕΛΩΤΟΥ Η ΑΦΡΩΔΟΥΣ ΓΥΑΛΙΟΥ ΣΕ ΚΥΒΟΥΣ, ΠΛΑΚΕΣ Η ΠΑΡΟΜΟΙΕΣ ΜΟΡΦΕΣ',
  },
  {
    label: '23192000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΥΑΛΙΟΥ ΓΙΑ ΤΕΧΝΙΚΕΣ ΚΑΙ ΑΛΛΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '23192100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΥΑΛΙΝΩΝ ΠΕΡΙΒΛΗΜΑΤΩΝ, ΑΝΟΙΧΤΩΝ ΚΑΙ ΓΥΑΛΙΝΩΝ ΜΕΡΩΝ ΤΟΥΣ, ΓΙΑ ΗΛΕΚΤΡΙΚΟΥΣ ΛΑΜΠΤΗΡΕΣ, ΚΑΘΟΔΙΚΕΣ ΛΥΧΝΙΕΣ Η ΠΑΡΟΜΟΙΑ ΕΙΔΗ',
  },
  {
    label: '23192200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΥΑΛΙΩΝ ΡΟΛΟΓΙΩΝ ΤΟΙΧΟΥ ΚΑΙ ΧΕΡΙΟΥ Η ΜΑΤΟΓΥΑΛΙΩΝ, ΜΗ ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΟΠΤΙΚΑ· ΣΦΑΙΡΩΝ (ΜΠΑΛΩΝ) ΚΟΙΛΩΝ ΚΑΙ ΤΩΝ ΤΜΗΜΑΤΩΝ ΤΟΥΣ, ΑΠΟ ΓΥΑΛΙ, ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΠΑΡΟΜΟΙΩΝ ΓΥΑΛΙΩΝ',
  },
  {
    label: '23192201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΥΑΛΙΩΝ ΓΙΑ ΦΑΚΟΥΣ ΟΡΑΣΕΩΣ ΚΑΙ ΟΠΤΙΚΟΥΣ ΚΡΥΣΤΑΛΛΟΥΣ',
  },
  {
    label: '23192300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΣΤΗΡΙΑΚΩΝ ΕΙΔΩΝ, ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ Η ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΕΙΔΩΝ· ΑΜΠΟΥΛΩΝ, ΑΠΟ ΓΥΑΛΙ',
  },
  {
    label: '23192400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΥΑΛΙΝΩΝ ΜΕΡΩΝ ΓΙΑ ΛΑΜΠΤΗΡΕΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΑ ΦΩΤΙΣΜΟΥ, ΦΩΤΕΙΝΑ ΣΗΜΑΤΑ, ΠΙΝΑΚΙΔΕΣ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ',
  },
  {
    label: '23192500',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΜΟΝΩΤΙΚΩΝ ΥΛΙΚΩΝ ΑΠΟ ΓΥΑΛΙ',
  },
  {
    label: '23192600',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΑΠΟ ΓΥΑΛΙ Π.Δ.Κ.Α.',
  },
  {
    label: '23192601',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΙΚΡΟΑΝΤΙΚΕΙΜΕΝΩΝ ΑΠΟ ΓΥΑΛΙ',
  },
  {
    label: '23192602',
    value: 'ΚΑΤΑΣΚΕΥΗ ΨΗΦΙΔΩΤΩΝ ΑΠΟ ΓΥΑΛΙ',
  },
  {
    label: '23199000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΕΛΕΙΟΠΟΙΗΣΗΣ (ΦΙΝΙΡΙΣΜΑΤΟΣ) ΑΛΛΩΝ ΕΙΔΩΝ ΓΥΑΛΙΟΥ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΓΥΑΛΙΟΥ ΓΙΑ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΕΙΔΩΝ ΚΑΤΕΡΓΑΣΜΕΝΟΥ ΓΥΑΛΙΟΥ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΓΥΑΛΙΟΥ ΓΙΑ',
  },
  {
    label: '23199100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΕΛΕΙΟΠΟΙΗΣΗΣ (ΦΙΝΙΡΙΣΜΑΤΟΣ) ΑΛΛΩΝ ΕΙΔΩΝ ΓΥΑΛΙΟΥ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΓΥΑΛΙΟΥ ΓΙΑ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '23199900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΕΙΔΩΝ ΚΑΤΕΡΓΑΣΜΕΝΟΥ ΓΥΑΛΙΟΥ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΓΥΑΛΙΟΥ ΓΙΑ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '23200000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΥΡΙΜΑΧΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '23201100',
    value:
      'ΠΑΡΑΓΩΓΗ ΤΟΥΒΛΩΝ, ΚΥΒΟΛΙΘΩΝ, ΠΛΑΚΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΑΠΟ ΠΥΡΙΤΙΚΗ ΣΚΟΝΗ ΑΠΟΛΙΘΩΜΑΤΩΝ Η ΑΠΟ ΠΥΡΙΤΙΟΥΧΕΣ ΓΑΙΕΣ',
  },
  {
    label: '23201200',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΥΡΙΜΑΧΩΝ ΤΟΥΒΛΩΝ, ΚΥΒΟΛΙΘΩΝ, ΠΛΑΚΑΚΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΥΡΙΜΑΧΩΝ ΚΕΡΑΜΙΚΩΝ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΕΙΔΩΝ, ΕΚΤΟΣ ΤΩΝ ΕΙΔΩΝ ΑΠΟ ΠΥΡΙΤΙΚΗ ΣΚΟΝΗ ΑΠΟΛΙΘΩΜΑΤΩΝ Η ΑΠΟ ΠΥΡΙΤΙΟΥΧΕΣ ΓΑΙΕΣ',
  },
  {
    label: '23201300',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΥΡΙΜΑΧΩΝ ΤΣΙΜΕΝΤΩΝ, ΚΟΝΙΑΜΑΤΩΝ, ΣΚΥΡΟΔΕΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΥΝΘΕΣΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '23201400',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΨΗΤΩΝ ΠΥΡΙΜΑΧΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΑΛΛΩΝ ΠΥΡΙΜΑΧΩΝ ΚΕΡΑΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '23209000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΥΡΙΜΑΧΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '23310000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΕΡΑΜΙΚΩΝ ΠΛΑΚΙΔΙΩΝ ΚΑΙ ΠΛΑΚΩΝ',
  },
  {
    label: '23311001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΨΗΦΙΔΩΤΩΝ ΑΠΟ ΚΕΡΑΜΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '23319000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΚΕΡΑΜΙΚΩΝ ΠΛΑΚΙΔΙΩΝ ΚΑΙ ΠΛΑΚΩΝ',
  },
  {
    label: '23320000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΟΥΒΛΩΝ, ΠΛΑΚΙΔΙΩΝ ΚΑΙ ΛΟΙΠΩΝ ΔΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΟΠΤΗ ΓΗ',
  },
  {
    label: '23321000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΟΥΒΛΩΝ, ΠΛΑΚΙΔΙΩΝ ΚΑΙ ΔΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΑΠΟ ΟΠΤΗ ΓΗ (ΨΗΜΕΝΟ ΠΗΛΟ)',
  },
  {
    label: '23321100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗ ΠΥΡΙΜΑΧΩΝ ΚΕΡΑΜΙΚΩΝ ΟΙΚΟΔΟΜΙΚΩΝ ΤΟΥΒΛΩΝ, ΚΥΒΟΛΙΘΩΝ ΔΑΠΕΔΩΝ, ΠΛΑΚΑΚΙΩΝ ΥΠΟΣΤΗΡΙΞΗΣ Η ΠΛΗΡΩΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '23321101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΕΡΑΜΙΚΩΝ ΠΛΙΝΘΩΝ',
  },
  {
    label: '23321200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΕΡΑΜΙΔΙΩΝ ΣΤΕΓΩΝ, ΣΤΟΙΧΕΙΩΝ, ΚΑΛΥΜΜΑΤΩΝ ΚΑΙ ΕΠΕΝΔΥΣΕΩΝ ΚΑΠΝΟΔΟΧΩΝ, ΑΡΧΙΤΕΚΤΟΝΙΚΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΚΑΙ ΑΛΛΩΝ ΚΕΡΑΜΙΚΩΝ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '23321201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΕΡΑΜΙΔΙΩΝ ΣΤΕΓΩΝ',
  },
  {
    label: '23321300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ, ΥΔΡΟΡΡΟΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΣΕΩΝ, ΑΠΟ ΚΕΡΑΜΙΚΗ ΥΛΗ',
  },
  {
    label: '23329000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΤΟΥΒΛΩΝ, ΠΛΑΚΙΔΙΩΝ ΚΑΙ ΔΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΑΠΟ ΟΠΤΗ ΓΗ (ΨΗΜΕΝΟ ΠΗΛΟ)',
  },
  {
    label: '23410000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ ΚΑΙ ΚΕΡΑΜΙΚΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '23411100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΚΕΥΩΝ, ΜΑΓΕΙΡΙΚΩΝ ΣΚΕΥΩΝ, ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ ΑΠΟ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '23411101',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΠΙΝΑΚΙΔΙΩΝ, ΠΙΝΑΚΙΩΝ, ΑΓΓΕΙΩΝ ΚΛΠ ΜΕ ΔΙΑΚΟΣΜΗΣΗ, ΑΠΟ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '23411102',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΙΔΩΝ ΠΟΡΣΕΛΑΝΗΣ, ΦΑΓΕΝΤΙΑΝΩΝ ΚΑΙ ΔΙΑΚΟΣΜΗΜΕΝΩΝ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '23411200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΚΕΥΩΝ, ΜΑΓΕΙΡΙΚΩΝ ΣΚΕΥΩΝ, ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ ΕΚΤΟΣ ΑΠΟ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '23411201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΗΛΙΝΩΝ ΑΓΓΕΙΩΝ ΓΕΝΙΚΑ, ΧΩΡΙΣ ΔΙΑΚΟΣΜΗΣΗ',
  },
  {
    label: '23411202',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΗΛΙΝΩΝ Η ΤΣΙΜΕΝΤΕΝΙΩΝ ΓΛΑΣΤΡΩΝ ΚΑΙ ΖΑΡΝΤΙΝΙΕΡΩΝ',
  },
  {
    label: '23411203',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΙΝΑΚΙΩΝ, ΑΓΓΕΙΩΝ ΚΛΠ, ΑΠΟ ΚΕΡΑΜΙΚΕΣ ΥΛΕΣ ΕΚΤΟΣ ΑΠΟ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '23411300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΓΑΛΜΑΤΙΔΙΩΝ ΚΑΙ ΑΛΛΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ ΔΙΑΚΟΣΜΗΣΗΣ ΑΠΟ ΚΕΡΑΜΙΚΗ ΥΛΗ',
  },
  {
    label: '23411301',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΠΙΝΑΚΙΔΙΩΝ ΑΠΟ ΚΕΡΑΜΙΚΕΣ ΥΛΕΣ ΕΚΤΟΣ ΑΠΟ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '23419000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ ΚΑΙ ΚΕΡΑΜΙΚΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '23419901',
    value:
      'ΕΡΓΑΣΙΕΣ ΔΙΑΚΟΣΜΗΣΗΣ ΕΙΔΩΝ ΑΠΟ ΠΟΡΣΕΛΑΝΗ ΚΑΙ ΦΑΓΕΝΤΙΑΝΗ ΓΗ ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ',
  },
  {
    label: '23419902',
    value: 'ΕΡΓΑΣΙΕΣ ΚΕΡΑΜΙΣΤΑ, ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ',
  },
  {
    label: '23420000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ',
  },
  {
    label: '23429000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ',
  },
  {
    label: '23430000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΕΡΑΜΙΚΩΝ ΜΟΝΩΤΩΝ ΚΑΙ ΚΕΡΑΜΙΚΩΝ ΜΟΝΩΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '23431000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΜΟΝΩΤΩΝ ΑΠΟ ΚΕΡΑΜΙΚΑ· ΜΟΝΩΤΙΚΩΝ ΚΕΡΑΜΙΚΩΝ ΤΕΜΑΧΙΩΝ ΓΙΑ ΜΗΧΑΝΕΣ, ΣΥΣΚΕΥΕΣ Η ΗΛΕΚΤΡΙΚΕΣ ΕΓΚΑΤΑΣΤΑΣΕΙΣ',
  },
  {
    label: '23439000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΚΕΡΑΜΙΚΩΝ ΜΟΝΩΤΩΝ ΚΑΙ ΚΕΡΑΜΙΚΩΝ ΜΟΝΩΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '23440000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΚΕΡΑΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΓΙΑ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '23441100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΓΙΑ ΕΡΓΑΣΤΗΡΙΑΚΗ, ΧΗΜΙΚΗ Η ΑΛΛΕΣ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ, ΑΠΟ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '23441200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΓΙΑ ΕΡΓΑΣΤΗΡΙΑΚΗ, ΧΗΜΙΚΗ Η ΑΛΛΕΣ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ, ΕΚΤΟΣ ΑΠΟ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '23449000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΚΕΡΑΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΓΙΑ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '23490000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΚΕΡΑΜΙΚΗΣ',
  },
  {
    label: '23491100',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗ ΓΕΩΡΓΙΑ ΚΑΙ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ Η ΤΗ ΣΥΣΚΕΥΑΣΙΑ ΑΓΑΘΩΝ',
  },
  {
    label: '23491200',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΜΗ ΔΟΜΙΚΩΝ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '23499000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΚΕΡΑΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '23510000',
    value: 'ΠΑΡΑΓΩΓΗ ΤΣΙΜΕΝΤΟΥ',
  },
  {
    label: '23511100',
    value: 'ΠΑΡΑΓΩΓΗ ΗΜΙΥΑΛΟΠΟΙΗΜΕΝΩΝ ΣΚΩΡΙΩΝ (ΟΠΤΟΠΛΙΝΘΩΝ CLINKER)',
  },
  {
    label: '23511200',
    value:
      'ΠΑΡΑΓΩΓΗ ΤΣΙΜΕΝΤΟΥ PORTLAND, ΑΡΓΙΛΙΚΟΥ ΤΣΙΜΕΝΤΟΥ, ΚΟΝΙΩΝ ΥΨΙΚΑΜΙΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΔΡΑΥΛΙΚΩΝ ΤΣΙΜΕΝΤΩΝ',
  },
  {
    label: '23519000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΤΣΙΜΕΝΤΟΥ',
  },
  {
    label: '23520000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΣΒΕΣΤΗ ΚΑΙ ΓΥΨΟΥ',
  },
  {
    label: '23521000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΝΥΔΡΟΥ ΑΣΒΕΣΤΗ, ΕΝΥΔΡΟΥ ΑΣΒΕΣΤΗ ΚΑΙ ΥΔΡΑΥΛΙΚΟΥ ΑΣΒΕΣΤΗ',
  },
  {
    label: '23522000',
    value: 'ΠΑΡΑΓΩΓΗ ΓΥΨΟΥ',
  },
  {
    label: '23523000',
    value: 'ΠΑΡΑΓΩΓΗ ΦΡΥΓΜΕΝΟΥ Η ΣΥΣΣΩΜΑΤΩΜΕΝΟΥ ΔΟΛΟΜΙΤΗ',
  },
  {
    label: '23529000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΣΒΕΣΤΗ ΚΑΙ ΓΥΨΟΥ',
  },
  {
    label: '23610000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΣΚΥΡΟΔΕΜΑ',
  },
  {
    label: '23611000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΡΟΪΟΝΤΩΝ ΣΚΥΡΟΔΕΜΑΤΟΣ ΓΙΑ ΚΑΤΑΣΚΕΥΕΣ',
  },
  {
    label: '23611100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΑΚΑΚΙΩΝ, ΠΛΑΚΟΛΙΘΩΝ, ΤΟΥΒΛΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ',
  },
  {
    label: '23611101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΣΙΜΕΝΤΕΝΙΩΝ ΠΛΙΝΘΩΝ',
  },
  {
    label: '23611200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΔΟΜΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΓΙΑ ΟΙΚΟΔΟΜΙΚΑ ΕΡΓΑ Η ΕΡΓΑ ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ, ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ',
  },
  {
    label: '23611201',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΤΖΑΚΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ',
  },
  {
    label: '23612000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΚΤΙΡΙΩΝ ΑΠΟ ΣΚΥΡΟΔΕΜΑ',
  },
  {
    label: '23619000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΡΟΪΟΝΤΩΝ ΣΚΥΡΟΔΕΜΑΤΟΣ ΓΙΑ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '23620000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΓΥΨΟ',
  },
  {
    label: '23621000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΓΥΨΟ ΓΙΑ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '23621001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΙΑΚΟΣΜΗΣΕΩΝ ΑΠΟ ΓΥΨΟ ΓΙΑ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '23629000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΓΥΨΟ ΓΙΑ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '23630000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΤΟΙΜΟΥ ΣΚΥΡΟΔΕΜΑΤΟΣ',
  },
  {
    label: '23639000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΤΟΙΜΟΥ ΣΚΥΡΟΔΕΜΑΤΟΣ',
  },
  {
    label: '23640000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΟΝΙΑΜΑΤΩΝ',
  },
  {
    label: '23649000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΚΟΝΙΑΜΑΤΩΝ',
  },
  {
    label: '23650000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΙΝΟΤΣΙΜΕΝΤΟΥ',
  },
  {
    label: '23651000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΑΠΟ ΙΝΟΤΣΙΜΕΝΤΟ',
  },
  {
    label: '23651100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΑΝΙΔΩΝ ΣΕ ΤΕΜΑΧΙΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ ΑΠΟ ΦΥΤΙΚΕΣ ΙΝΕΣ, ΑΧΥΡΑ Η ΥΠΟΛΕΙΜΜΑΤΑ ΞΥΛΕΙΑΣ, ΣΥΣΣΩΜΑΤΩΜΕΝΑ ΜΕ ΟΡΥΚΤΕΣ ΣΥΝΔΕΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '23651200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΑΠΟ ΑΜΙΑΝΤΟΤΣΙΜΕΝΤΟ, ΙΝΟΤΣΙΜΕΝΤΟ ΚΥΤΤΑΡΙΝΗΣ Η ΑΠΟ ΠΑΡΟΜΟΙΑ',
  },
  {
    label: '23659000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΙΔΩΝ ΙΝΟΤΣΙΜΕΝΤΟΥ',
  },
  {
    label: '23690000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΣΚΥΡΟΔΕΜΑ, ΓΥΨΟ ΚΑΙ ΤΣΙΜΕΝΤΟ',
  },
  {
    label: '23691100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΓΥΨΟ Η ΣΥΝΘΕΣΕΙΣ ΜΕ ΒΑΣΗ ΤΟ ΓΥΨΟ Π.Δ.Κ.Α.',
  },
  {
    label: '23691101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΔΙΑΚΟΣΜΗΣΗΣ ΑΠΟ ΓΥΨΟ, ΕΚΤΟΣ ΤΩΝ ΔΟΜΙΚΩΝ',
  },
  {
    label: '23691900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ Π.Δ.Κ.Α.',
  },
  {
    label: '23699000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΣΚΥΡΟΔΕΜΑ, ΓΥΨΟ ΚΑΙ ΤΣΙΜΕΝΤΟ',
  },
  {
    label: '23700000',
    value: 'ΚΟΠΗ, ΜΟΡΦΟΠΟΙΗΣΗ ΚΑΙ ΤΕΛΙΚΗ ΕΠΕΞΕΡΓΑΣΙΑ ΛΙΘΩΝ',
  },
  {
    label: '23701100',
    value:
      'ΚΟΠΗ, ΜΟΡΦΟΠΟΙΗΣΗ ΚΑΙ ΤΕΛΙΚΗ ΕΠΕΞΕΡΓΑΣΙΑ ΜΑΡΜΑΡΟΥ, ΤΡΑΒΕΡΤΙΝΗ, ΑΛΑΒΑΣΤΡΟΥ, ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΤΟΥΣ (ΕΚΤΟΣ ΑΠΟ ΚΥΒΟΛΙΘΟΥΣ ΓΙΑ ΛΙΘΟΣΤΡΩΤΑ ΔΡΟΜΩΝ Η ΠΕΖΟΔΡΟΜΙΩΝ, ΠΛΑΚΕΣ ΓΙΑ ΣΤΡΩΣΙΜΟ, ΠΛΑΚΙΔΙΑ, ΚΥΒΟΥΣ ΚΛΠ) ΤΕΧΝΗΤΑ ΧΡΩΜΑΤΙΣΜΕΝΩΝ ΚΟΚΚΩΝ,            ',
  },
  {
    label: '23701101',
    value: 'ΕΡΓΑΣΙΕΣ ΚΟΝΙΟΠΟΙΗΣΗΣ ΜΑΡΜΑΡΩΝ',
  },
  {
    label: '23701102',
    value: 'ΕΡΓΑΣΙΕΣ ΚΟΠΗΣ ΜΑΡΜΑΡΩΝ ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ',
  },
  {
    label: '23701103',
    value: 'ΕΡΓΑΣΙΕΣ ΛΕΙΑΝΣΗΣ ΜΑΡΜΑΡΩΝ',
  },
  {
    label: '23701104',
    value: 'ΕΡΓΑΣΙΕΣ ΜΑΡΜΑΡΟΓΛΥΠΤΙΚΗΣ',
  },
  {
    label: '23701105',
    value: 'ΕΡΓΑΣΙΕΣ ΣΧΙΣΙΜΑΤΟΣ ΜΑΡΜΑΡΩΝ',
  },
  {
    label: '23701106',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΑΠΟ ΟΝΥΧΑ ΚΑΙ ΑΛΑΒΑΣΤΡΟ',
  },
  {
    label: '23701107',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΑΡΜΑΡΙΝΩΝ ΕΠΙΤΑΦΙΩΝ ΜΝΗΜΕΙΩΝ',
  },
  {
    label: '23701200',
    value:
      'ΚΟΠΗ, ΜΟΡΦΟΠΟΙΗΣΗ ΚΑΙ ΤΕΛΙΚΗ ΕΠΕΞΕΡΓΑΣΙΑ ΑΛΛΩΝ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ Η ΟΙΚΟΔΟΜΙΚΩΝ ΛΙΘΩΝ ΚΑΙ ΕΙΔΩΝ ΤΟΥΣ· ΑΛΛΩΝ ΤΕΧΝΗΤΑ ΧΡΩΜΑΤΙΣΜΕΝΩΝ ΚΟΚΚΩΝ ΚΑΙ ΣΚΟΝΩΝ ΑΠΟ ΦΥΣΙΚΟ ΛΙΘΟ· ΕΙΔΩΝ ΑΠΟ ΣΥΣΣΩΜΑΤΩΜΕΝΟ ΣΧΙΣΤΟΛΙΘΟ',
  },
  {
    label: '23701201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΨΗΦΙΔΩΤΩΝ ΑΠΟ ΛΑΞΕΥΤΟΥΣ ΛΙΘΟΥΣ',
  },
  {
    label: '23701202',
    value: 'ΚΟΠΗ ΚΑΙ ΚΑΤΕΡΓΑΣΙΑ ΤΕΧΝΗΤΩΝ ΜΑΡΜΑΡΩΝ ΚΑΙ ΜΩΣΑΪΚΩΝ ΠΛΑΚΩΝ',
  },
  {
    label: '23709000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΛΙΘΩΝ ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΚΟΠΗ, ΜΟΡΦΟΠΟΙΗΣΗ ΚΑΙ ΤΕΛΙΚΗ ΕΠΕΞΕΡΓΑΣΙΑ',
  },
  {
    label: '23910000',
    value: 'ΠΑΡΑΓΩΓΗ ΛΕΙΑΝΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '23911100',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΥΛΟΠΕΤΡΩΝ, ΑΚΟΝΟΠΕΤΡΩΝ, ΤΡΟΧΩΝ ΛΕΙΑΝΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΤΗΣ ΠΕΤΡΑΣ, ΧΩΡΙΣ ΠΛΑΙΣΙΑ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΑΠΟ ΦΥΣΙΚΟ ΛΙΘΟ, ΑΠΟ ΛΕΙΑΝΤΙΚΑ ΦΥΣΙΚΑ Η ΤΕΧΝΗΤΑ ΣΥΣΣΩΜΑΤΩΜΕΝΑ Η ΑΠΟ ΚΕΡΑΜΕΥΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '23911101',
    value:
      'ΚΑΤΕΡΓΑΣΙΑ ΣΜΥΡΙΔΑΣ ΚΑΙ ΚΑΤΑΣΚΕΥΗ ΛΕΙΑΝΤΙΚΩΝ Η ΚΟΠΤΙΚΩΝ ΜΕΣΩΝ ΑΠΟ ΣΜΥΡΙΔΑ',
  },
  {
    label: '23911200',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΕΙΑΝΤΙΚΩΝ ΣΚΟΝΩΝ Η ΚΟΚΚΩΝ ΣΕ ΒΑΣΗ ΑΠΟ ΥΦΑΝΤΙΚΟ ΥΛΙΚΟ, ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '23919000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΛΕΙΑΝΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '23990000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΟΡΥΚΤΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '23991100',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΜΙΑΝΤΟΥ ΕΠΕΞΕΡΓΑΣΜΕΝΟΥ ΣΕ ΙΝΕΣ· ΜΕΙΓΜΑΤΩΝ ΜΕ ΒΑΣΗ ΤΟΝ ΑΜΙΑΝΤΟ ΚΑΙ ΤΟ ΘΕΙΙΚΟ ΜΑΓΝΗΣΙΟ· ΠΡΟΪΟΝΤΩΝ ΠΑΡΟΜΟΙΩΝ ΜΕΙΓΜΑΤΩΝ Η ΑΠΟ ΑΜΙΑΝΤΟ· ΥΛΙΚΟΥ ΤΡΙΒΗΣ ΓΙΑ ΦΡΕΝΑ, ΣΥΜΠΛΕΚΤΕΣ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ, ΜΗ ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΟΥ',
  },
  {
    label: '23991200',
    value: 'ΠΑΡΑΓΩΓΗ ΕΙΔΩΝ ΑΠΟ ΑΣΦΑΛΤΟ Η ΑΠΟ ΠΑΡΟΜΟΙΑ ΥΛΙΚΑ',
  },
  {
    label: '23991201',
    value: 'ΠΑΡΑΓΩΓΗ ΘΕΡΜΟΜΟΝΩΤΙΚΩΝ ΥΛΙΚΩΝ ΑΠΟ ΑΣΦΑΛΤΟ ΓΙΑ ΕΠΙΚΑΛΥΨΗ ΚΤΙΡΙΩΝ',
  },
  {
    label: '23991202',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΟΝΩΤΙΚΩΝ ΥΛΙΚΩΝ ΑΠΟ ΑΣΦΑΛΤΟ (ΠΙΣΣΟΧΑΡΤΩΝ, ΑΣΦΑΛΤΟΠΑΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ)',
  },
  {
    label: '23991300',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΣΦΑΛΤΙΚΩΝ ΜΕΙΓΜΑΤΩΝ ΜΕ ΒΑΣΗ ΦΥΣΙΚΑ Η ΤΕΧΝΗΤΑ ΛΙΘΙΝΑ ΥΛΙΚΑ ΚΑΙ ΒΙΤΟΥΜΙΟ, ΦΥΣΙΚΗΣ ΑΣΦΑΛΤΟΥ Η ΣΥΝΑΦΩΝ ΟΥΣΙΩΝ ΩΣ ΣΥΝΔΕΤΙΚΟ ΥΛΙΚΟ',
  },
  {
    label: '23991400',
    value:
      'ΠΑΡΑΓΩΓΗ ΤΕΧΝΗΤΟΥ ΓΡΑΦΙΤΗ· ΓΡΑΦΙΤΗ ΚΟΛΛΟΕΙΔΟΥΣ Η ΗΜΙΚΟΛΛΟΕΙΔΟΥΣ· ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΜΕ ΒΑΣΗ ΤΟ ΓΡΑΦΙΤΗ Η ΑΛΛΟ ΑΝΘΡΑΚΑ ΥΠΟ ΜΟΡΦΗ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '23991500',
    value: 'ΠΑΡΑΓΩΓΗ ΤΕΧΝΗΤΟΥ ΚΟΡΟΥΝΔΙΟΥ',
  },
  {
    label: '23991900',
    value: 'ΠΑΡΑΓΩΓΗ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΟΡΥΚΤΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '23991901',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΟΡΥΚΤΩΝ (ΣΤΕΑΤΙΝΗΣ, ΘΗΡΑΪΚΗΣ ΓΗΣ, ΚΙΣΗΡΗΣ, ΛΕΥΚΟΛΙΘΟΥ ΚΛΠ)',
  },
  {
    label: '23991902',
    value:
      'ΠΑΡΑΓΩΓΗ ΘΕΡΜΟΜΟΝΩΤΙΚΩΝ ΥΛΙΚΩΝ ΕΠΙΚΑΛΥΨΗΣ ΚΤΙΡΙΩΝ ΑΠΟ ΜΗ ΜΕΤΑΛΛΙΚΑ ΟΡΥΚΤΑ',
  },
  {
    label: '23999000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΟΡΥΚΤΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '24100000',
    value: 'ΠΑΡΑΓΩΓΗ ΒΑΣΙΚΟΥ ΣΙΔΗΡΟΥ, ΧΑΛΥΒΑ ΚΑΙ ΣΙΔΗΡΟΚΡΑΜΑΤΩΝ',
  },
  {
    label: '24101000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΓΕΝΩΝ ΥΛΙΚΩΝ ΣΙΔΗΡΟΥ ΚΑΙ ΧΑΛΥΒΑ',
  },
  {
    label: '24101100',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΟΥ ΧΥΤΟΣΙΔΗΡΟΥ ΚΑΙ ΧΥΤΟΣΙΔΗΡΟΥ SPIEGEL ΣΕ ΧΕΛΩΝΕΣ, ΚΥΒΟΥΣ Η ΑΛΛΕΣ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '24101200',
    value: 'ΠΑΡΑΓΩΓΗ ΣΙΔΗΡΟΚΡΑΜΑΤΩΝ',
  },
  {
    label: '24101300',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΙΔΗΡΟΥΧΩΝ ΠΡΟΪΟΝΤΩΝ ΠΟΥ ΛΑΜΒΑΝΟΝΤΑΙ ΜΕ ΑΠΕΥΘΕΙΑΣ ΑΝΑΓΩΓΗ ΣΙΔΗΡΟΜΕΤΑΛΛΕΥΜΑΤΟΣ ΚΑΙ ΑΛΛΩΝ ΣΠΟΓΓΩΔΩΝ ΣΙΔΗΡΟΥΧΩΝ ΠΡΟΪΟΝΤΩΝ, ΣΕ ΤΕΜΑΧΙΑ, ΣΦΑΙΡΙΔΙΑ Η ΠΑΡΟΜΟΙΕΣ ΜΟΡΦΕΣ, ΣΙΔΗΡΟΥ ΜΕ ΕΛΑΧΙΣΤΗ ΚΑΘΑΡΟΤΗΤΑ ΚΑΤΑ ΒΑΡΟΣ 99 ;0,94; %, ΣΕ ΤΕΜΑΧΙΑ, ΣΦΑΙΡΙΔ',
  },
  {
    label: '24101400',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΟΚΚΩΝ ΚΑΙ ΣΚΟΝΩΝ, ΑΠΟ ΑΚΑΤΕΡΓΑΣΤΟ ΧΥΤΟΣΙΔΗΡΟ, ΧΥΤΟΣΙΔΗΡΟ SPIEGEL Η ΧΑΛΥΒΑ',
  },
  {
    label: '24102000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΟΥ ΧΑΛΥΒΑ',
  },
  {
    label: '24102100',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟΥ ΧΑΛΥΒΑ ΣΕ ΠΛΙΝΘΩΜΑΤΑ Η ΑΛΛΕΣ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ ΚΑΙ ΗΜΙΤΕΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24102200',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΝΟΞΕΙΔΩΤΟΥ ΧΑΛΥΒΑ ΣΕ ΠΛΙΝΘΩΜΑΤΑ Η ΑΛΛΕΣ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ ΚΑΙ ΗΜΙΤΕΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24102300',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΟΥ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟΥ ΧΑΛΥΒΑ ΣΕ ΠΛΙΝΘΩΜΑΤΑ Η ΑΛΛΕΣ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ ΚΑΙ ΗΜΙΤΕΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΑΛΛΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24103000',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΑΠΟ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΜΟΝΟ ΘΕΡΜΗ ΕΛΑΣΗ',
  },
  {
    label: '24103100',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟΥ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΕΙ ΥΠΟΣΤΕΙ ΜΟΝΟ ΘΕΡΜΗ ΕΛΑΣΗ, ΜΕ ΠΛΑΤΟΣ >= 600 ~ MM',
  },
  {
    label: '24103200',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟΥ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΕΙ ΥΠΟΣΤΕΙ ΜΟΝΟ ΘΕΡΜΗ ΕΛΑΣΗ, ΜΕ ΠΛΑΤΟΣ < 600 ~ MM',
  },
  {
    label: '24103300',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΑΝΟΞΕΙΔΩΤΟΥ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΕΙ ΥΠΟΣΤΕΙ ΜΟΝΟ ΘΕΡΜΗ ΕΛΑΣΗ, ΜΕ ΠΛΑΤΟΣ >= 600 ~ MM',
  },
  {
    label: '24103400',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΑΝΟΞΕΙΔΩΤΟΥ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΕΙ ΥΠΟΣΤΕΙ ΜΟΝΟ ΘΕΡΜΗ ΕΛΑΣΗ, ΜΕ ΠΛΑΤΟΣ < 600 ~ MM',
  },
  {
    label: '24103500',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΑΠΟ ΑΛΛΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΕΙ ΥΠΟΣΤΕΙ ΜΟΝΟ ΘΕΡΜΗ ΕΛΑΣΗ, ΜΕ ΠΛΑΤΟΣ >= 600 ~ MM',
  },
  {
    label: '24103600',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΑΠΟ ΑΛΛΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΕΙ ΥΠΟΣΤΕΙ ΜΟΝΟ ΘΕΡΜΗ ΕΛΑΣΗ, ΜΕ ΠΛΑΤΟΣ < 600 ~ MM (ΕΚΤΟΣ ΠΡΟΪΟΝΤΩΝ ΑΠΟ \\ΜΑΓΝΗΤΙΚΟ\\ ΠΥΡΙΤΙΟΥΧΟ ΧΑΛΥΒΑ)',
  },
  {
    label: '24104000',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΕΙ ΥΠΟΣΤΕΙ ΜΟΝΟ ΨΥΧΡΗ ΕΛΑΣΗ, ΜΕ ΠΛΑΤΟΣ >= 600 ~ MM',
  },
  {
    label: '24104100',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟΥ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΕΙ ΥΠΟΣΤΕΙ ΜΟΝΟ ΨΥΧΡΗ ΕΛΑΣΗ, ΜΕ ΠΛΑΤΟΣ >= 600 ~ MM',
  },
  {
    label: '24104200',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΑΝΟΞΕΙΔΩΤΟΥ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΕΙ ΥΠΟΣΤΕΙ ΜΟΝΟ ΨΥΧΡΗ ΕΛΑΣΗ, ΜΕ ΠΛΑΤΟΣ >= 600 ~ MM',
  },
  {
    label: '24104300',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΑΛΛΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΕΙ ΥΠΟΣΤΕΙ ΜΟΝΟ ΨΥΧΡΗ ΕΛΑΣΗ, ΜΕ ΠΛΑΤΟΣ >= 600 ~ MM',
  },
  {
    label: '24105000',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΑΠΟ ΧΑΛΥΒΑ, ΕΠΕΝΔΥΜΕΝΩΝ, ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ Η ΕΠΙΚΑΛΥΜΜΕΝΩΝ ΚΑΙ ΠΛΑΤΙΩΝ ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΑΠΟ ΧΑΛΥΒΑ ΤΑΧΕΙΑΣ ΚΟΠΗΣ ΚΑΙ \\ΜΑΓΝΗΤΙΚΟΥ\\ ΠΥΡΙΤΙΟΥΧΟΥ ΧΑΛΥΒΑ',
  },
  {
    label: '24105100',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟΥ ΧΑΛΥΒΑ, ΜΕ ΠΛΑΤΟΣ >= 600 ~ MM, ΕΠΕΝΔΥΜΕΝΩΝ, ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ Η ΕΠΙΚΑΛΥΜΜΕΝΩΝ',
  },
  {
    label: '24105200',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΑΠΟ ΑΛΛΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ, ΜΕ ΠΛΑΤΟΣ >= 600 ~ MM, ΕΠΕΝΔΥΜΕΝΩΝ, ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ Η ΕΠΙΚΑΛΥΜΜΕΝΩΝ',
  },
  {
    label: '24105300',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΑΠΟ \\ΜΑΓΝΗΤΙΚΟ\\ ΠΥΡΙΤΙΟΥΧΟ ΧΑΛΥΒΑ, ΜΕ ΠΛΑΤΟΣ >= 600 ~ MM',
  },
  {
    label: '24105400',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΑΠΟ \\ΜΑΓΝΗΤΙΚΟ\\ ΠΥΡΙΤΙΟΥΧΟ ΧΑΛΥΒΑ, ΜΕ ΠΛΑΤΟΣ < 600 ~ MM',
  },
  {
    label: '24105500',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΠΕΔΩΝ (ΠΛΑΤΙΩΝ) ΠΡΟΪΟΝΤΩΝ ΕΛΑΣΗΣ ΑΠΟ ΧΑΛΥΒΑ ΤΑΧΕΙΑΣ ΚΟΠΗΣ, ΜΕ ΠΛΑΤΟΣ < 600 ~ MM',
  },
  {
    label: '24106000',
    value: 'ΠΑΡΑΓΩΓΗ ΘΕΡΜΙΚΑ ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24106100',
    value:
      'ΠΑΡΑΓΩΓΗ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ, ΜΕ ΘΕΡΜΗ ΕΛΑΣΗ, ΣΕ ΑΚΑΝΟΝΙΣΤΑ ΠΕΡΙΕΛΙΓΜΕΝΑ ΠΗΝΙΑ, ΑΠΟ ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24106200',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ ΑΠΟ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΟΥΝ ΑΠΛΩΣ ΣΦΥΡΗΛΑΤΗΘΕΙ, ΕΛΑΘΕΙ Η ΔΙΕΛΑΘΕΙ ΣΕ ΘΕΡΜΗ ΚΑΤΑΣΤΑΣΗ, ΚΑΘΩΣ ΚΑΙ ΕΚΕΙΝΩΝ ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΣΤΡΙΨΙΜΟ ΜΕΤΑ ΤΗΝ ΕΛΑΣΗ',
  },
  {
    label: '24106300',
    value:
      'ΠΑΡΑΓΩΓΗ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ, ΜΕ ΘΕΡΜΗ ΕΛΑΣΗ, ΣΕ ΑΚΑΝΟΝΙΣΤΑ ΠΕΡΙΕΛΙΓΜΕΝΑ ΠΗΝΙΑ, ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24106400',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ, ΠΟΥ ΕΧΟΥΝ ΑΠΛΩΣ ΣΦΥΡΗΛΑΤΗΘΕΙ, ΕΛΑΘΕΙ Η ΔΙΕΛΑΘΕΙ ΣΕ ΘΕΡΜΗ ΚΑΤΑΣΤΑΣΗ, ΚΑΘΩΣ ΚΑΙ ΕΚΕΙΝΩΝ ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΣΤΡΙΨΙΜΟ ΜΕΤΑ ΤΗΝ ΕΛΑΣΗ',
  },
  {
    label: '24106500',
    value:
      'ΠΑΡΑΓΩΓΗ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ, ΜΕ ΘΕΡΜΗ ΕΛΑΣΗ, ΣΕ ΑΚΑΝΟΝΙΣΤΑ ΠΕΡΙΕΛΙΓΜΕΝΑ ΠΗΝΙΑ, ΑΠΟ ΑΛΛΟΥΣ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟΥΣ ΧΑΛΥΒΕΣ',
  },
  {
    label: '24106600',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ ΑΠΟ ΑΛΛΟΥΣ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟΥΣ ΧΑΛΥΒΕΣ, ΠΟΥ ΕΧΟΥΝ ΑΠΛΩΣ ΣΦΥΡΗΛΑΤΗΘΕΙ, ΕΛΑΘΕΙ Η ΔΙΕΛΑΘΕΙ ΣΕ ΘΕΡΜΗ ΚΑΤΑΣΤΑΣΗ, ΚΑΘΩΣ ΚΑΙ ΕΚΕΙΝΩΝ ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΣΤΡΙΨΙΜΟ ΜΕΤΑ ΤΗΝ ΕΛΑΣΗ',
  },
  {
    label: '24106700',
    value: 'ΠΑΡΑΓΩΓΗ ΡΑΒΔΩΝ ΚΟΙΛΩΝ ΓΙΑ ΓΕΩΤΡΗΣΕΙΣ',
  },
  {
    label: '24107000',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΟΡΦΟΡΑΒΔΩΝ (OPEN SECTIONS) ΑΠΟ ΧΑΛΥΒΑ ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΘΕΡΜΗ ΕΛΑΣΗ, ΠΑΣΣΑΛΟΣΑΝΙΔΩΝ ΑΠΟ ΧΑΛΥΒΑ ΚΑΙ ΔΟΜΙΚΩΝ ΥΛΙΚΩΝ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΓΡΑΜΜΩΝ ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24107100',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΟΡΦΟΡΑΒΔΩΝ, ΠΟΥ ΕΧΟΥΝ ΑΠΛΩΣ ΕΛΑΘΕΙ Η ΔΙΕΛΑΘΕΙ ΣΕ ΘΕΡΜΗ ΚΑΤΑΣΤΑΣΗ, ΑΠΟ ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24107200',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΟΡΦΟΡΑΒΔΩΝ, ΠΟΥ ΕΧΟΥΝ ΑΠΛΩΣ ΕΛΑΘΕΙ Η ΔΙΕΛΑΘΕΙ ΣΕ ΘΕΡΜΗ ΚΑΤΑΣΤΑΣΗ, ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24107300',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΟΡΦΟΡΑΒΔΩΝ, ΠΟΥ ΕΧΟΥΝ ΑΠΛΩΣ ΕΛΑΘΕΙ Η ΔΙΕΛΑΘΕΙ ΣΕ ΘΕΡΜΗ ΚΑΤΑΣΤΑΣΗ, ΑΠΟ ΑΛΛΟΥΣ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟΥΣ ΧΑΛΥΒΕΣ',
  },
  {
    label: '24107400',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΑΣΣΑΛΟΣΑΝΙΔΩΝ ΑΠΟ ΧΑΛΥΒΑ ΚΑΙ ΣΥΓΚΟΛΛΗΜΕΝΩΝ ΜΟΡΦΟΡΑΒΔΩΝ ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24107500',
    value: 'ΠΑΡΑΓΩΓΗ ΔΟΜΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΓΡΑΜΜΩΝ ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24109000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΒΑΣΙΚΟΥ ΣΙΔΗΡΟΥ ΚΑΙ ΧΑΛΥΒΑ ΚΑΙ ΣΙΔΗΡΟΚΡΑΜΑΤΩΝ',
  },
  {
    label: '24200000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΛΥΒΔΙΝΩΝ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ, ΚΟΙΛΩΝ ΕΙΔΩΝ ΜΕ ΚΑΘΟΡΙΣΜΕΝΗ ΜΟΡΦΗ ΚΑΙ ΣΥΝΑΦΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '24201000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΚΟΙΛΩΝ ΜΟΡΦΟΣΩΛΗΝΩΝ (HOLLOW PROFILES), ΧΩΡΙΣ ΣΥΓΚΟΛΛΗΣΗ, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24201100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΓΙΑ ΑΓΩΓΟΥΣ ΠΕΤΡΕΛΑΙΟΥ Η ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ, ΧΩΡΙΣ ΣΥΓΚΟΛΛΗΣΗ, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24201200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΕΝΔΥΣΕΩΝ ΚΑΙ ΣΩΛΗΝΩΣΕΩΝ ΦΡΕΑΤΩΝ ΚΑΙ ΔΙΑΤΡΗΤΙΚΩΝ ΣΤΕΛΕΧΩΝ ΑΓΩΓΩΝ, ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΓΙΑ ΤΗ ΓΕΩΤΡΗΣΗ ΠΕΤΡΕΛΑΙΟΥ Η ΑΕΡΙΟΥ, ΧΩΡΙΣ ΣΥΓΚΟΛΛΗΣΗ, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24201300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΣΩΛΗΝΩΝ ΚΥΚΛΙΚΗΣ ΔΙΑΤΟΜΗΣ, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24201400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ ΜΗ ΚΥΚΛΙΚΗΣ ΔΙΑΤΟΜΗΣ ΚΑΙ ΚΟΙΛΩΝ ΕΙΔΩΝ ΜΕ ΚΑΘΟΡΙΣΜΕΝΗ ΜΟΡΦΗ, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24202000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ, ΣΥΓΚΟΛΛΗΜΕΝΩΝ, ΚΥΚΛΙΚΗΣ ΔΙΑΤΟΜΗΣ, ΜΕ ΕΞΩΤΕΡΙΚΗ ΔΙΑΜΕΤΡΟ > 406 ;0,4; MM, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24202100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΓΙΑ ΤΟΥΣ ΑΓΩΓΟΥΣ ΠΕΤΡΕΛΑΙΟΥ Η ΑΕΡΙΟΥ, ΣΥΓΚΟΛΛΗΜΕΝΩΝ, ΜΕ ΕΞΩΤΕΡΙΚΗ ΔΙΑΜΕΤΡΟ > 406 ;0,4; MM, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24202200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΕΝΔΥΣΕΩΝ ΚΑΙ ΣΩΛΗΝΩΣΕΩΝ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΓΙΑ ΤΗ ΓΕΩΤΡΗΣΗ ΠΕΤΡΕΛΑΙΟΥ Η ΑΕΡΙΟΥ, ΣΥΓΚΟΛΛΗΜΕΝΩΝ, ΜΕ ΕΞΩΤΕΡΙΚΗ ΔΙΑΜΕΤΡΟ > 406 ;0,4; MM, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24202300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ ΚΥΚΛΙΚΗΣ ΔΙΑΤΟΜΗΣ, ΣΥΓΚΟΛΛΗΜΕΝΩΝ, ΜΕ ΕΞΩΤΕΡΙΚΗ ΔΙΑΜΕΤΡΟ > 406 ;0,4; MM, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24202400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΣΩΛΗΝΩΝ, ΚΥΚΛΙΚΗΣ ΔΙΑΤΟΜΗΣ, ΟΠΩΣ ΣΥΝΕΝΩΜΕΝΩΝ ΣΩΛΗΝΩΝ, ΣΥΝΔΕΔΕΜΕΝΩΝ ΜΕ ΗΛΟΥΣ Η ΜΕ ΠΑΡΟΜΟΙΟ ΚΛΕΙΣΙΜΟ, ΜΕ ΕΞΩΤΕΡΙΚΗ ΔΙΑΜΕΤΡΟ > 406 ;0,4; MM, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24203000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ ΜΕ ΕΞΩΤΕΡΙΚΗ ΔΙΑΜΕΤΡΟ <= 406 ;0,4; MM, ΣΥΓΚΟΛΛΗΜΕΝΩΝ, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24203100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΓΙΑ ΤΟΥΣ ΑΓΩΓΟΥΣ ΠΕΤΡΕΛΑΙΟΥ Η ΑΕΡΙΟΥ, ΣΥΓΚΟΛΛΗΜΕΝΩΝ, ΜΕ ΕΞΩΤΕΡΙΚΗ ΔΙΑΜΕΤΡΟ <= 406 ;0,4; MM, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24203200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΕΝΔΥΣΕΩΝ ΚΑΙ ΣΩΛΗΝΩΣΕΩΝ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΓΙΑ ΤΗ ΓΕΩΤΡΗΣΗ ΠΕΤΡΕΛΑΙΟΥ Η ΑΕΡΙΟΥ, ΣΥΓΚΟΛΛΗΜΕΝΩΝ, ΜΕ ΕΞΩΤΕΡΙΚΗ ΔΙΑΜΕΤΡΟ <= 406 ;0,4; MM, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24203300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ ΚΥΚΛΙΚΗΣ ΔΙΑΤΟΜΗΣ, ΣΥΓΚΟΛΛΗΜΕΝΩΝ, ΜΕ ΕΞΩΤΕΡΙΚΗ ΔΙΑΜΕΤΡΟ <= 406 ;0,4; MM, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24203400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ ΜΗ ΚΥΚΛΙΚΗΣ ΔΙΑΤΟΜΗΣ, ΣΥΓΚΟΛΛΗΜΕΝΩΝ, ΜΕ ΕΞΩΤΕΡΙΚΗ ΔΙΑΜΕΤΡΟ <= 406 ;0,4; MM, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24203500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΣΩΛΗΝΩΝ, ΟΠΩΣ ΣΥΝΕΝΩΜΕΝΩΝ ΣΩΛΗΝΩΝ, ΣΥΝΔΕΔΕΜΕΝΩΝ ΜΕ ΗΛΟΥΣ Η ΜΕ ΠΑΡΟΜΟΙΟ ΚΛΕΙΣΙΜΟ, ΜΕ ΕΞΩΤΕΡΙΚΗ ΔΙΑΜΕΤΡΟ <= 406 ;0,4; MM, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24204000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΣΕΩΝ ΑΠΟ ΧΑΛΥΒΑ, ΜΗ ΧΥΤΕΥΤΩΝ',
  },
  {
    label: '24209000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΣΩΛΗΝΩΝ, ΚΟΙΛΩΝ ΕΙΔΩΝ ΜΕ ΣΥΓΚΕΚΡΙΜΕΝΗ ΜΟΡΦΗ ΚΑΙ ΣΥΝΑΦΩΝ ΕΞΑΡΤΗΜΑΤΩΝ, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24310000',
    value: 'ΨΥΧΡΗ ΕΠΕΚΤΑΤΙΚΗ ΟΛΚΗ ΡΑΒΔΩΝ ΧΑΛΥΒΑ',
  },
  {
    label: '24311000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΡΑΒΔΩΝ (ΔΟΚΩΝ) ΨΥΧΡΗΣ ΟΛΚΗΣ ΚΑΙ ΠΛΗΡΩΝ ΕΙΔΩΝ ΜΕ ΣΥΓΚΕΚΡΙΜΕΝΗ ΜΟΡΦΗ (SOLID PROFILES) ΑΠΟ ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24312000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΡΑΒΔΩΝ (ΔΟΚΩΝ) ΨΥΧΡΗΣ ΟΛΚΗΣ ΚΑΙ ΠΛΗΡΩΝ ΕΙΔΩΝ ΜΕ ΣΥΓΚΕΚΡΙΜΕΝΗ ΜΟΡΦΗ (SOLID PROFILES) ΑΠΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ, ΕΚΤΟΣ ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24313000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΡΑΒΔΩΝ (ΔΟΚΩΝ) ΨΥΧΡΗΣ ΟΛΚΗΣ ΚΑΙ ΠΛΗΡΩΝ ΕΙΔΩΝ ΜΕ ΣΥΓΚΕΚΡΙΜΕΝΗ ΜΟΡΦΗ (SOLID PROFILES) ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24319000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΡΑΒΔΩΝ (ΔΟΚΩΝ) ΨΥΧΡΗΣ ΟΛΚΗΣ',
  },
  {
    label: '24320000',
    value: 'ΨΥΧΡΗ ΕΛΑΣΗ ΣΤΕΝΩΝ ΦΥΛΛΩΝ ΧΑΛΥΒΑ',
  },
  {
    label: '24321000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΙΠΕΔΩΝ ΦΥΛΛΩΝ ΨΥΧΡΗΣ ΕΛΑΣΗΣ ΑΠΟ ΧΑΛΥΒΑ, ΜΗ ΕΠΙΧΡΙΣΜΕΝΩΝ, ΜΕ ΠΛΑΤΟΣ < 600 ~ MM',
  },
  {
    label: '24322000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΙΠΕΔΩΝ ΦΥΛΛΩΝ ΨΥΧΡΗΣ ΕΛΑΣΗΣ ΑΠΟ ΧΑΛΥΒΑ, ΕΠΕΝΔΥΜΕΝΩΝ, ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ Η ΕΠΙΚΑΛΥΜΜΕΝΩΝ, ΜΕ ΠΛΑΤΟΣ < 600 ~ MM',
  },
  {
    label: '24329000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΠΙΠΕΔΩΝ ΦΥΛΛΩΝ ΨΥΧΡΗΣ ΕΛΑΣΗΣ',
  },
  {
    label: '24330000',
    value: 'ΨΥΧΡΗ ΜΟΡΦΟΠΟΙΗΣΗ Η ΔΙΠΛΩΣΗ ΜΟΡΦΟΡΑΒΔΩΝ ΧΑΛΥΒΑ',
  },
  {
    label: '24331000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΡΦΟΡΑΒΔΩΝ (OPEN SECTIONS), ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΜΟΡΦΟΠΟΙΗΣΗ Η ΔΙΠΛΩΣΗ ΣΕ ΨΥΧΡΗ ΚΑΤΑΣΤΑΣΗ, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24331100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΡΦΟΡΑΒΔΩΝ, ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΜΟΡΦΟΠΟΙΗΣΗ Η ΔΙΠΛΩΣΗ ΣΕ ΨΥΧΡΗ ΚΑΤΑΣΤΑΣΗ, ΑΠΟ ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24331200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΡΦΟΡΑΒΔΩΝ, ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΜΟΡΦΟΠΟΙΗΣΗ Η ΔΙΠΛΩΣΗ ΣΕ ΨΥΧΡΗ ΚΑΤΑΣΤΑΣΗ, ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24332000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΛΑΜΑΡΙΝΩΝ ΜΕ ΝΕΥΡΩΣΕΙΣ ΑΠΟ ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24333000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΕΤΑΣΜΑΤΩΝ \\ΣΑΝΤΟΥΙΤΣ\\ ΑΠΟ ΕΠΙΚΑΛΥΜΜΕΝΑ ΦΥΛΛΑ ΧΑΛΥΒΑ',
  },
  {
    label: '24339000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΡΟΪΟΝΤΩΝ, ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΜΟΡΦΟΠΟΙΗΣΗ Η ΔΙΠΛΩΣΗ ΣΕ ΨΥΧΡΗ ΚΑΤΑΣΤΑΣΗ, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24339900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΡΟΪΟΝΤΩΝ ΠΟΥ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΜΟΡΦΟΠΟΙΗΣΗ Η ΔΙΠΛΩΣΗ ΣΕ ΨΥΧΡΗ ΚΑΤΑΣΤΑΣΗ, ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24340000',
    value: 'ΨΥΧΡΗ ΕΠΕΚΤΑΤΙΚΗ ΟΛΚΗ ΣΥΡΜΑΤΩΝ',
  },
  {
    label: '24341000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΡΜΑΤΟΣ ΨΥΧΡΗΣ ΟΛΚΗΣ',
  },
  {
    label: '24341100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΡΜΑΤΟΣ ΨΥΧΡΗΣ ΟΛΚΗΣ ΑΠΟ ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24341200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΡΜΑΤΟΣ ΨΥΧΡΗΣ ΟΛΚΗΣ ΑΠΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24341300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΡΜΑΤΟΣ ΨΥΧΡΗΣ ΟΛΚΗΣ ΑΠΟ ΑΛΛΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24349000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΣΥΡΜΑΤΟΣ ΨΥΧΡΗΣ ΟΛΚΗΣ',
  },
  {
    label: '24410000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΟΛΥΤΙΜΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '24411000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΡΓΥΡΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ Η ΣΕ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΕΣ ΜΟΡΦΕΣ Η ΣΕ ΣΚΟΝΗ',
  },
  {
    label: '24411001',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΡΓΥΡΟΥ ΑΠΟ ΕΠΕΞΕΡΓΑΣΙΑ ΧΗΜΙΚΩΝ ΚΑΤΑΛΟΙΠΩΝ ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ',
  },
  {
    label: '24412000',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΡΥΣΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ Η ΣΕ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΕΣ ΜΟΡΦΕΣ Η ΣΕ ΣΚΟΝΗ',
  },
  {
    label: '24413000',
    value:
      'ΠΑΡΑΓΩΓΗ ΛΕΥΚΟΧΡΥΣΟΥ (ΠΛΑΤΙΝΑΣ), ΑΚΑΤΕΡΓΑΣΤΟΥ Η ΣΕ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΕΣ ΜΟΡΦΕΣ Η ΣΕ ΣΚΟΝΗ',
  },
  {
    label: '24414000',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΟΙΝΩΝ ΜΕΤΑΛΛΩΝ Η ΑΡΓΥΡΟΥ, ΕΠΙΧΡΥΣΩΜΕΝΩΝ, ΠΟΥ ΔΕΝ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΑΛΛΗ ΚΑΤΕΡΓΑΣΙΑ ΠΕΡΑΝ ΤΗΣ ΗΜΙΚΑΤΕΡΓΑΣΙΑΣ',
  },
  {
    label: '24415000',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΟΙΝΩΝ ΜΕΤΑΛΛΩΝ ΕΠΑΡΓΥΡΩΜΕΝΩΝ ΚΑΙ ΚΟΙΝΩΝ ΜΕΤΑΛΛΩΝ, ΑΡΓΥΡΟΥ Η ΧΡΥΣΟΥ ΕΠΙΠΛΑΤΙΝΩΜΕΝΩΝ, ΠΟΥ ΔΕΝ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΑΛΛΗ ΚΑΤΕΡΓΑΣΙΑ ΠΕΡΑΝ ΤΗΣ ΗΜΙΚΑΤΕΡΓΑΣΙΑΣ',
  },
  {
    label: '24419000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΠΟΛΥΤΙΜΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '24419901',
    value: 'ΠΑΡΑΓΩΓΗ ΑΡΓΥΡΟΥ ΑΠΟ ΕΠΕΞΕΡΓΑΣΙΑ ΧΗΜΙΚΩΝ ΚΑΤΑΛΟΙΠΩΝ',
  },
  {
    label: '24419902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΑΡΓΥΡΩΣΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '24419903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΧΡΥΣΩΣΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '24420000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΟΥΜΙΝΙΟΥ (ΑΡΓΙΛΙΟΥ)',
  },
  {
    label: '24421000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΟΥΜΙΝΙΟΥ (ΑΡΓΙΛΙΟΥ), ΑΚΑΤΕΡΓΑΣΤΟΥ· ΟΞΕΙΔΙΟΥ ΤΟΥ ΑΡΓΙΛΙΟΥ',
  },
  {
    label: '24421100',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΟΥΜΙΝΙΟΥ (ΑΡΓΙΛΙΟΥ), ΑΚΑΤΕΡΓΑΣΤΟΥ',
  },
  {
    label: '24421200',
    value: 'ΠΑΡΑΓΩΓΗ ΟΞΕΙΔΙΟΥ ΤΟΥ ΑΡΓΙΛΙΟΥ, ΕΚΤΟΣ ΤΟΥ ΤΕΧΝΗΤΟΥ ΚΟΡΟΥΝΔΙΟΥ',
  },
  {
    label: '24422000',
    value:
      'ΠΑΡΑΓΩΓΗ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ ΑΡΓΙΛΙΟΥ Η ΚΡΑΜΑΤΩΝ ΤΟΥ ΑΡΓΙΛΙΟΥ',
  },
  {
    label: '24422100',
    value: 'ΠΑΡΑΓΩΓΗ ΣΚΟΝΩΝ ΚΑΙ ΨΗΓΜΑΤΩΝ ΑΡΓΙΛΙΟΥ',
  },
  {
    label: '24422200',
    value: 'ΠΑΡΑΓΩΓΗ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΑΡΓΙΛΙΟΥ',
  },
  {
    label: '24422300',
    value: 'ΠΑΡΑΓΩΓΗ ΣΥΡΜΑΤΟΣ ΑΡΓΙΛΙΟΥ',
  },
  {
    label: '24422400',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ ΚΑΙ ΤΑΙΝΙΩΝ, ΑΠΟ ΑΡΓΙΛΙΟ, ΠΑΧΟΥΣ > 0 ;0,2; MM',
  },
  {
    label: '24422500',
    value: 'ΠΑΡΑΓΩΓΗ ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΑΡΓΙΛΙΟΥ, ΠΑΧΟΥΣ <= 0 ;0,2; MM',
  },
  {
    label: '24422501',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΟΥΜΙΝΟΧΑΡΤΟΥ',
  },
  {
    label: '24422600',
    value: 'ΠΑΡΑΓΩΓΗ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ, ΑΠΟ ΑΡΓΙΛΙΟ',
  },
  {
    label: '24429000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΡΓΙΛΙΟΥ',
  },
  {
    label: '24430000',
    value: 'ΠΑΡΑΓΩΓΗ ΜΟΛΥΒΔΟΥ, ΨΕΥΔΑΡΓΥΡΟΥ ΚΑΙ ΚΑΣΣΙΤΕΡΟΥ',
  },
  {
    label: '24431000',
    value: 'ΠΑΡΑΓΩΓΗ ΜΟΛΥΒΔΟΥ, ΨΕΥΔΑΡΓΥΡΟΥ ΚΑΙ ΚΑΣΣΙΤΕΡΟΥ, ΑΚΑΤΕΡΓΑΣΤΩΝ',
  },
  {
    label: '24431100',
    value: 'ΠΑΡΑΓΩΓΗ ΜΟΛΥΒΔΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ',
  },
  {
    label: '24431200',
    value: 'ΠΑΡΑΓΩΓΗ ΨΕΥΔΑΡΓΥΡΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ',
  },
  {
    label: '24431300',
    value: 'ΠΑΡΑΓΩΓΗ ΚΑΣΣΙΤΕΡΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ',
  },
  {
    label: '24432000',
    value:
      'ΠΑΡΑΓΩΓΗ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΜΟΛΥΒΔΟ, ΨΕΥΔΑΡΓΥΡΟ ΚΑΙ ΚΑΣΣΙΤΕΡΟ Η ΤΑ ΚΡΑΜΑΤΑ ΤΟΥΣ',
  },
  {
    label: '24432100',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ ΚΑΙ ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΑΠΟ ΜΟΛΥΒΔΟ· ΣΚΟΝΩΝ ΚΑΙ ΨΗΓΜΑΤΩΝ ΜΟΛΥΒΔΟΥ',
  },
  {
    label: '24432200',
    value: 'ΠΑΡΑΓΩΓΗ ΣΚΟΝΩΝ ΚΑΙ ΨΗΓΜΑΤΩΝ ΨΕΥΔΑΡΓΥΡΟΥ',
  },
  {
    label: '24432300',
    value:
      'ΠΑΡΑΓΩΓΗ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΜΟΡΦΟΡΑΒΔΩΝ ΚΑΙ ΣΥΡΜΑΤΟΣ ΨΕΥΔΑΡΓΥΡΟΥ· ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ ΚΑΙ ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΨΕΥΔΑΡΓΥΡΟΥ',
  },
  {
    label: '24432400',
    value: 'ΠΑΡΑΓΩΓΗ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΜΟΡΦΟΡΑΒΔΩΝ ΚΑΙ ΣΥΡΜΑΤΟΣ ΑΠΟ ΚΑΣΣΙΤΕΡΟ',
  },
  {
    label: '24439000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΜΟΛΥΒΔΟΥ, ΨΕΥΔΑΡΓΥΡΟΥ ΚΑΙ ΚΑΣΣΙΤΕΡΟΥ',
  },
  {
    label: '24440000',
    value: 'ΠΑΡΑΓΩΓΗ ΧΑΛΚΟΥ',
  },
  {
    label: '24441000',
    value:
      'ΠΑΡΑΓΩΓΗ ΧΑΛΚΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ· ΣΥΣΣΩΜΑΤΩΜΑΤΩΝ (MATTES) ΧΑΛΚΟΥ· ΧΑΛΚΟΥ ΚΟΝΙΑΣ (CEMENT)',
  },
  {
    label: '24441100',
    value: 'ΠΑΡΑΓΩΓΗ ΣΥΣΣΩΜΑΤΩΜΑΤΩΝ (MATTES) ΧΑΛΚΟΥ· ΧΑΛΚΟΥ ΚΟΝΙΑΣ (CEMENT)',
  },
  {
    label: '24441101',
    value: 'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΟΥ ΟΡΕΙΧΑΛΚΟΥ',
  },
  {
    label: '24441200',
    value:
      'ΠΑΡΑΓΩΓΗ ΜΗ ΚΑΘΑΡΙΣΜΕΝΟΥ ΧΑΛΚΟΥ· ΑΝΟΔΩΝ ΑΠΟ ΧΑΛΚΟ ΓΙΑ ΗΛΕΚΤΡΟΛΥΤΙΚΟ ΚΑΘΑΡΙΣΜΟ',
  },
  {
    label: '24441300',
    value:
      'ΠΑΡΑΓΩΓΗ ΚΑΘΑΡΙΣΜΕΝΟΥ ΧΑΛΚΟΥ ΚΑΙ ΚΡΑΜΑΤΩΝ ΧΑΛΚΟΥ, ΑΚΑΤΕΡΓΑΣΤΩΝ· ΜΗΤΡΙΚΩΝ ΚΡΑΜΑΤΩΝ ΧΑΛΚΟΥ',
  },
  {
    label: '24442000',
    value: 'ΠΑΡΑΓΩΓΗ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ ΧΑΛΚΟΥ Η ΚΡΑΜΑΤΩΝ ΤΟΥ ΧΑΛΚΟΥ',
  },
  {
    label: '24442100',
    value: 'ΠΑΡΑΓΩΓΗ ΣΚΟΝΩΝ ΚΑΙ ΨΗΓΜΑΤΩΝ ΧΑΛΚΟΥ',
  },
  {
    label: '24442200',
    value:
      'ΠΑΡΑΓΩΓΗ ΔΟΚΩΝ, ΡΑΒΔΩΝ ΚΑΙ ΜΟΡΦΟΡΑΒΔΩΝ (PROFILES), ΑΠΟ ΧΑΛΚΟ Η ΚΡΑΜΑΤΑ ΤΟΥ',
  },
  {
    label: '24442201',
    value: 'ΠΑΡΑΓΩΓΗ ΕΙΔΩΝ ΚΑΘΟΡΙΣΜΕΝΗΣ ΜΟΡΦΗΣ ΑΠΟ ΟΡΕΙΧΑΛΚΟ',
  },
  {
    label: '24442202',
    value: 'ΠΑΡΑΓΩΓΗ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ ΟΡΕΙΧΑΛΚΟΥ',
  },
  {
    label: '24442300',
    value: 'ΠΑΡΑΓΩΓΗ ΣΥΡΜΑΤΟΣ ΑΠΟ ΧΑΛΚΟ',
  },
  {
    label: '24442301',
    value: 'ΠΑΡΑΓΩΓΗ ΟΡΕΙΧΑΛΚΙΝΩΝ ΣΥΡΜΑΤΩΝ',
  },
  {
    label: '24442400',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ ΚΑΙ ΤΑΙΝΙΩΝ, ΑΠΟ ΧΑΛΚΟ, ΠΑΧΟΥΣ > 0 ;0,15; MM',
  },
  {
    label: '24442500',
    value: 'ΠΑΡΑΓΩΓΗ ΛΕΠΤΩΝ ΦΥΛΛΩΝ, ΑΠΟ ΧΑΛΚΟ, ΠΑΧΟΥΣ <= 0 ;0,15; MM',
  },
  {
    label: '24442600',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ, ΑΠΟ ΧΑΛΚΟ',
  },
  {
    label: '24449000',
    value: 'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΧΑΛΚΟΥ',
  },
  {
    label: '24450000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '24451000',
    value:
      'ΠΑΡΑΓΩΓΗ ΝΙΚΕΛΙΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ· ΕΝΔΙΑΜΕΣΩΝ ΠΡΟΪΟΝΤΩΝ ΤΗΣ ΜΕΤΑΛΛΟΥΡΓΙΑΣ ΤΟΥ ΝΙΚΕΛΙΟΥ',
  },
  {
    label: '24451100',
    value: 'ΠΑΡΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΟΥ ΝΙΚΕΛΙΟΥ',
  },
  {
    label: '24451200',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΥΣΣΩΜΑΤΩΜΑΤΩΝ (MATTES) ΝΙΚΕΛΙΟΥ, ΕΠΙΤΗΓΜΑΤΩΝ (SINTERS) ΟΞΕΙΔΙΩΝ ΤΟΥ ΝΙΚΕΛΙΟΥ ΚΑΙ ΑΛΛΩΝ ΕΝΔΙΑΜΕΣΩΝ ΠΡΟΪΟΝΤΩΝ ΤΗΣ ΜΕΤΑΛΛΟΥΡΓΙΑΣ ΤΟΥ ΝΙΚΕΛΙΟΥ',
  },
  {
    label: '24452000',
    value:
      'ΠΑΡΑΓΩΓΗ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ ΝΙΚΕΛΙΟΥ Η ΚΡΑΜΑΤΩΝ ΤΟΥ ΝΙΚΕΛΙΟΥ',
  },
  {
    label: '24452100',
    value: 'ΠΑΡΑΓΩΓΗ ΣΚΟΝΩΝ ΚΑΙ ΨΗΓΜΑΤΩΝ ΝΙΚΕΛΙΟΥ',
  },
  {
    label: '24452200',
    value: 'ΠΑΡΑΓΩΓΗ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΜΟΡΦΟΡΑΒΔΩΝ ΚΑΙ ΣΥΡΜΑΤΟΣ, ΑΠΟ ΝΙΚΕΛΙΟ',
  },
  {
    label: '24452300',
    value: 'ΠΑΡΑΓΩΓΗ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ ΚΑΙ ΛΕΠΤΩΝ ΦΥΛΛΩΝ, ΑΠΟ ΝΙΚΕΛΙΟ',
  },
  {
    label: '24452400',
    value:
      'ΠΑΡΑΓΩΓΗ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ, ΑΠΟ ΝΙΚΕΛΙΟ',
  },
  {
    label: '24453000',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΩΝ ΚΑΙ ΕΙΔΩΝ ΤΟΥΣ· ΚΕΡΑΜΟΜΕΤΑΛΛΟΥΡΓΙΚΩΝ ΕΝΩΣΕΩΝ· ΣΤΑΧΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΜΕΤΑΛΛΑ Η ΜΕΤΑΛΛΙΚΕΣ ΕΝΩΣΕΙΣ',
  },
  {
    label: '24459000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '24459900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '24460000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΠΥΡΗΝΙΚΩΝ ΚΑΥΣΙΜΩΝ',
  },
  {
    label: '24461000',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΦΥΣΙΚΟΥ ΟΥΡΑΝΙΟΥ ΚΑΙ ΤΩΝ ΕΝΩΣΕΩΝ ΤΟΥ· ΚΡΑΜΑΤΩΝ, ΔΙΑΣΠΟΡΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΚΕΡΑΜΟΜΕΤΑΛΛΟΥΡΓΙΚΩΝ ΕΝΩΣΕΩΝ), ΚΕΡΑΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΜΕΙΓΜΑΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΦΥΣΙΚΟ ΟΥΡΑΝΙΟ Η ΕΝΩΣΕΙΣ ΤΟΥ ΦΥΣΙΚΟΥ ΟΥΡΑΝΙΟΥ',
  },
  {
    label: '24469000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΠΥΡΗΝΙΚΩΝ ΚΑΥΣΙΜΩΝ',
  },
  {
    label: '24510000',
    value: 'ΧΥΤΕΥΣΗ ΣΙΔΗΡΟΥ',
  },
  {
    label: '24511000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΥΤΕΥΣΗΣ ΧΥΤΟΣΙΔΗΡΟΥ',
  },
  {
    label: '24511100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΥΤΕΥΣΗΣ ΕΛΑΤΟΥ ΧΥΤΟΣΙΔΗΡΟΥ',
  },
  {
    label: '24511200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΥΤΕΥΣΗΣ ΣΦΑΙΡΟΕΙΔΟΥΣ ΧΥΤΟΣΙΔΗΡΟΥ',
  },
  {
    label: '24511300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΥΤΕΥΣΗΣ ΦΑΙΟΥ ΧΥΤΟΣΙΔΗΡΟΥ',
  },
  {
    label: '24511301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΤΗΞΗΣ ΧΥΤΟΣΙΔΗΡΟΥ',
  },
  {
    label: '24512000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΚΟΙΛΩΝ ΜΟΡΦΟΣΩΛΗΝΩΝ (HOLLOW PROFILES) ΑΠΟ ΧΥΤΟΣΙΔΗΡΟ· ΣΩΛΗΝΩΝ ΚΑΙ ΑΓΩΓΩΝ ΑΠΟ ΧΑΛΥΒΑ',
  },
  {
    label: '24513000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ ΑΠΟ ΧΥΤΟΣΙΔΗΡΟ',
  },
  {
    label: '24519000',
    value: 'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΧΥΤΕΥΣΗΣ ΣΙΔΗΡΟΥ',
  },
  {
    label: '24520000',
    value: 'ΧΥΤΕΥΣΗ ΧΑΛΥΒΑ',
  },
  {
    label: '24521000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΥΤΕΥΣΗΣ ΧΑΛΥΒΑ',
  },
  {
    label: '24521001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΤΗΞΗΣ ΧΑΛΥΒΑ',
  },
  {
    label: '24522000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΝ ΚΑΙ ΑΓΩΓΩΝ ΦΥΓΟΚΕΝΤΡΙΚΗΣ ΧΥΤΕΥΣΗΣ ΧΑΛΥΒΑ',
  },
  {
    label: '24523000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ ΑΠΟ ΧΥΤΟΧΑΛΥΒΑ',
  },
  {
    label: '24530000',
    value: 'ΧΥΤΕΥΣΗ ΕΛΑΦΡΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '24531000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΥΤΕΥΣΗΣ ΕΛΑΦΡΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '24531001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΤΗΞΗΣ ΕΛΑΦΡΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '24540000',
    value: 'ΧΥΤΕΥΣΗ ΑΛΛΩΝ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '24541000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΥΤΕΥΣΗΣ ΑΛΛΩΝ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '24541001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΤΗΞΗΣ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25110000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΣΚΕΛΕΤΩΝ ΚΑΙ ΜΕΡΩΝ ΜΕΤΑΛΛΙΚΩΝ ΣΚΕΛΕΤΩΝ',
  },
  {
    label: '25111000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΚΤΙΡΙΩΝ ΑΠΟ ΜΕΤΑΛΛΟ',
  },
  {
    label: '25112000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΟΜΙΚΩΝ ΜΕΤΑΛΛΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '25112100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΕΦΥΡΩΝ ΚΑΙ ΣΤΟΙΧΕΙΩΝ ΓΕΦΥΡΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '25112200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΥΡΓΩΝ ΚΑΙ ΠΥΛΩΝΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '25112300',
    value:
      'ΔΗΜΙΟΥΡΓΙΑ ΑΛΛΩΝ ΚΑΤΑΣΚΕΥΩΝ ΚΑΙ ΜΕΡΩΝ ΚΑΤΑΣΚΕΥΩΝ, ΚΑΤΑΣΚΕΥΗ ΛΑΜΑΡΙΝΩΝ, ΡΑΒΔΩΝ, ΜΟΡΦΟΡΑΒΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '25112301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΟΜΙΚΩΝ ΜΕΤΑΛΛΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ ΣΤΗΡΙΞΕΩΣ',
  },
  {
    label: '25112302',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΣΤΗΘΑΙΩΝ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '25112303',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΤΖΑΚΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '25112304',
    value: 'ΠΑΡΑΓΩΓΗ ΔΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ ΑΠΟ ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '25119000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΕΤΑΛΛΙΚΩΝ ΣΚΕΛΕΤΩΝ ΚΑΙ ΜΕΡΩΝ ΜΕΤΑΛΛΙΚΩΝ ΣΚΕΛΕΤΩΝ',
  },
  {
    label: '25120000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΠΟΡΤΩΝ ΚΑΙ ΠΑΡΑΘΥΡΩΝ',
  },
  {
    label: '25121000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΟΡΤΩΝ, ΠΑΡΑΘΥΡΩΝ ΚΑΙ ΤΩΝ ΠΛΑΙΣΙΩΝ ΤΟΥΣ, ΚΑΘΩΣ ΚΑΙ ΚΑΤΩΦΛΙΩΝ ΓΙΑ ΠΟΡΤΕΣ, ΑΠΟ ΜΕΤΑΛΛΟ',
  },
  {
    label: '25121001',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΟΡΤΩΝ, ΠΑΡΑΘΥΡΩΝ ΚΑΙ ΤΩΝ ΠΛΑΙΣΙΩΝ ΤΟΥΣ, ΚΑΘΩΣ ΚΑΙ ΚΑΤΩΦΛΙΩΝ ΓΙΑ ΠΟΡΤΕΣ, ΑΠΟ ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '25121002',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΥΡΑΣΦΑΛΩΝ ΠΟΡΤΩΝ',
  },
  {
    label: '25121003',
    value: 'ΚΑΤΑΣΚΕΥΗ ΡΟΛΩΝ ΓΚΑΡΑΖΟΠΟΡΤΩΝ Η ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '25129000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΕΤΑΛΛΙΚΩΝ ΠΟΡΤΩΝ ΚΑΙ ΠΑΡΑΘΥΡΩΝ',
  },
  {
    label: '25210000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΩΜΑΤΩΝ ΚΑΙ ΛΕΒΗΤΩΝ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '25211100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΩΜΑΤΩΝ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ, ΜΗ ΗΛΕΚΤΡΙΚΑ ΘΕΡΜΑΙΝΟΜΕΝΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '25211200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΛΕΒΗΤΩΝ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΖΕΣΤΟΥ ΝΕΡΟΥ Η ΑΤΜΟΥ ΧΑΜΗΛΗΣ ΠΙΕΣΗΣ',
  },
  {
    label: '25211300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΛΕΒΗΤΩΝ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '25219000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΣΩΜΑΤΩΝ ΚΑΙ ΛΕΒΗΤΩΝ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '25290000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΕΤΑΛΛΙΚΩΝ ΝΤΕΠΟΖΙΤΩΝ, ΔΕΞΑΜΕΝΩΝ ΚΑΙ ΔΟΧΕΙΩΝ',
  },
  {
    label: '25291100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΝΤΕΠΟΖΙΤΩΝ, ΔΕΞΑΜΕΝΩΝ, ΚΑΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ (ΕΚΤΟΣ ΕΚΕΙΝΩΝ ΠΟΥ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΠΕΠΙΕΣΜΕΝΑ Η ΥΓΡΟΠΟΙΗΜΕΝΑ ΑΕΡΙΑ), ΑΠΟ ΜΕΤΑΛΛΟ, ΧΑΛΥΒΑ Η ΑΡΓΙΛΙΟ, ΧΩΡΗΤΙΚΟΤΗΤΑΣ > 300 ~ ΛΙΤΡΩΝ, ΧΩΡΙΣ ΜΗΧΑΝΙΚΕΣ Η ΘΕΡΜΙΚΕΣ ΔΙΑΤΑΞΕΙΣ',
  },
  {
    label: '25291101',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΛΕΒΗΤΩΝ, ΧΩΡΗΤΙΚΟΤΗΤΑΣ > 300 ~ LT, ΟΧΙ ΓΙΑ ΚΕΝΤΡΙΚΗ ΘΕΡΜΑΝΣΗ',
  },
  {
    label: '25291200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΔΟΧΕΙΩΝ ΓΙΑ ΣΥΜΠΙΕΣΜΕΝΟ Η ΥΓΡΟΠΟΙΗΜΕΝΟ ΑΕΡΙΟ, ΑΠΟ ΜΕΤΑΛΛΟ',
  },
  {
    label: '25291201',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΦΙΑΛΩΝ ΟΞΥΓΟΝΟΥ ΚΑΙ ΑΛΛΩΝ ΑΕΡΙΩΝ ΥΠΟ ΠΙΕΣΗ',
  },
  {
    label: '25291202',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΦΙΑΛΩΝ ΥΓΡΑΕΡΙΟΥ',
  },
  {
    label: '25299000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΕΤΑΛΛΙΚΩΝ ΔΕΞΑΜΕΝΩΝ, ΝΤΕΠΟΖΙΤΩΝ ΚΑΙ ΔΟΧΕΙΩΝ',
  },
  {
    label: '25300000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΤΜΟΓΕΝΝΗΤΡΙΩΝ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΟΥΣ ΛΕΒΗΤΕΣ ΖΕΣΤΟΥ ΝΕΡΟΥ ΓΙΑ ΤΗΝ ΚΕΝΤΡΙΚΗ',
  },
  {
    label: '25301000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΤΜΟΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '25301100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΤΜΟΛΕΒΗΤΩΝ Η ΑΛΛΩΝ ΛΕΒΗΤΩΝ ΠΑΡΑΓΩΓΗΣ ΑΤΜΟΥ· ΛΕΒΗΤΩΝ ΥΠΕΡΘΕΡΜΑΙΝΟΜΕΝΟΥ ΝΕΡΟΥ',
  },
  {
    label: '25301200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΟΗΘΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΛΕΒΗΤΕΣ· ΣΥΜΠΥΚΝΩΤΩΝ ΓΙΑ ΑΛΛΕΣ ΜΟΝΑΔΕΣ ΠΑΡΑΓΩΓΗΣ ΑΤΜΟΥ',
  },
  {
    label: '25301300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΤΜΟΓΕΝΝΗΤΡΙΩΝ',
  },
  {
    label: '25302000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΥΡΗΝΙΚΩΝ ΑΝΤΙΔΡΑΣΤΗΡΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '25302100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΥΡΗΝΙΚΩΝ ΑΝΤΙΔΡΑΣΤΗΡΩΝ, ΕΚΤΟΣ ΤΩΝ ΔΙΑΧΩΡΙΣΤΩΝ ΙΣΟΤΟΠΩΝ',
  },
  {
    label: '25302200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΠΥΡΗΝΙΚΩΝ ΑΝΤΙΔΡΑΣΤΗΡΩΝ, ΕΚΤΟΣ ΤΩΝ ΔΙΑΧΩΡΙΣΤΩΝ ΙΣΟΤΟΠΩΝ',
  },
  {
    label: '25309000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΤΜΟΓΕΝΝΗΤΡΙΩΝ, ΕΚΤΟΣ ΤΩΝ ΛΕΒΗΤΩΝ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '25400000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΠΛΩΝ ΚΑΙ ΠΥΡΟΜΑΧΙΚΩΝ',
  },
  {
    label: '25401000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΠΛΩΝ ΚΑΙ ΠΥΡΟΜΑΧΙΚΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '25401100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΟΛΕΜΙΚΩΝ ΟΠΛΩΝ, ΕΚΤΟΣ ΑΠΟ ΠΕΡΙΣΤΡΟΦΑ, ΠΙΣΤΟΛΙΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΟΠΛΑ',
  },
  {
    label: '25401200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΕΡΙΣΤΡΟΦΩΝ, ΠΙΣΤΟΛΙΩΝ, ΜΗ ΠΟΛΕΜΙΚΩΝ ΠΥΡΟΒΟΛΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΥΣΤΗΜΑΤΩΝ',
  },
  {
    label: '25401300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΟΜΒΩΝ, ΒΛΗΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΟΛΕΜΟΦΟΔΙΩΝ· ΦΥΣΙΓΓΙΩΝ, ΑΛΛΩΝ ΠΥΡΟΜΑΧΙΚΩΝ ΚΑΙ ΒΛΗΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '25401400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΠΟΛΕΜΙΚΩΝ ΟΠΛΩΝ ΚΑΙ ΑΛΛΩΝ ΟΠΛΩΝ',
  },
  {
    label: '25409000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΟΠΛΩΝ ΚΑΙ ΠΥΡΟΜΑΧΙΚΩΝ',
  },
  {
    label: '25500000',
    value:
      'ΣΦΥΡΗΛΑΤΗΣΗ, ΚΟΙΛΑΝΣΗ, ΑΝΙΣΟΠΑΧΗ ΤΥΠΩΣΗ ΚΑΙ ΜΟΡΦΟΠΟΙΗΣΗ ΜΕΤΑΛΛΩΝ ΜΕ ΕΛΑΣΗ· ΚΟΝΙΟΜΕΤΑΛΛΟΥΡΓΙΑ',
  },
  {
    label: '25501000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΦΥΡΗΛΑΤΗΣΗΣ, ΣΥΜΠΙΕΣΗΣ, ΤΥΠΩΣΗΣ ΚΑΙ ΕΛΑΣΗΣ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '25501100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΦΥΡΗΛΑΤΗΣΗΣ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '25501101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΨΥΧΡΗΣ ΔΙΕΛΑΣΗΣ Η ΕΛΑΣΗΣ ΜΕΤΑΛΛΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '25501200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΥΠΩΣΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25501300',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΛΑΣΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25501301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΜΟΡΦΩΣΗΣ ΜΕΤΑΛΛΩΝ ΣΕ ΚΥΛΙΝΔΡΟΥΣ',
  },
  {
    label: '25502000',
    value: 'ΚΟΝΙΟΜΕΤΑΛΛΟΥΡΓΙΑ',
  },
  {
    label: '25502001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΜΕΤΑΛΛΙΚΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ ΑΠΕΥΘΕΙΑΣ ΑΠΟ ΚΟΝΕΙΣ ΜΕΤΑΛΛΟΥ ΜΕ ΘΕΡΜΗ ΕΠΕΞΕΡΓΑΣΙΑ (ΕΠΙΤΗΞΗ) Η ΥΠΟ ΠΙΕΣΗ',
  },
  {
    label: '25502002',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΜΕΤΑΛΛΙΚΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ ΜΕ ΛΕΙΑΝΣΗ ΚΑΙ ΚΟΠΗ ΜΕΡΩΝ ΑΠΟ ΣΚΛΗΡΑ ΜΕΤΑΛΛΙΚΑ ΚΑΡΒΙΔΙΑ',
  },
  {
    label: '25610000',
    value: 'ΚΑΤΕΡΓΑΣΙΑ ΚΑΙ ΕΠΙΚΑΛΥΨΗ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25611000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΚΑΛΥΨΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25611100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΛΛΙΚΗΣ ΕΠΙΚΑΛΥΨΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25611101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΚΑΣΣΙΤΕΡΩΣΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25611102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΝΙΚΕΛΩΣΗΣ ΚΑΙ ΕΠΙΧΡΩΜΙΩΣΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25611103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΨΕΥΔΑΡΓΥΡΩΣΗΣ ΜΕΤΑΛΛΩΝ ΜΕ ΗΛΕΚΤΡΟΛΥΣΗ ΚΑΙ ΧΗΜΙΚΗ ΕΠΕΞΕΡΓΑΣΙΑ',
  },
  {
    label: '25611104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΛΛΙΚΗΣ ΕΠΙΧΡΙΣΗΣ ΜΕ ΨΕΚΑΣΜΟ ΕΝ ΘΕΡΜΩ',
  },
  {
    label: '25611200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗ ΜΕΤΑΛΛΙΚΗΣ ΕΠΙΧΡΙΣΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25611201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΛΑΣΤΙΚΗΣ ΕΠΙΧΡΙΣΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25612000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΑΤΕΡΓΑΣΙΑΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25612100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΕΡΜΙΚΗΣ ΚΑΤΕΡΓΑΣΙΑΣ ΜΕΤΑΛΛΩΝ, ΕΚΤΟΣ ΤΗΣ ΜΕΤΑΛΛΙΚΗΣ ΕΠΙΧΡΙΣΗΣ',
  },
  {
    label: '25612200',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΠΙΦΑΝΕΙΑΚΗΣ ΚΑΤΕΡΓΑΣΙΑΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25612201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΜΜΟΒΟΛΙΣΜΟΥ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25612202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΟΔΙΩΣΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25612203',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΦΑΙΡΕΣΗΣ ΓΡΕΖΙΩΝ ΚΑΙ ΚΑΘΑΡΙΣΜΟΥ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25612204',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΑΠΟΘΕΣΗΣ ΑΕΡΙΟΥ ΦΑΣΕΩΣ (CVD/PVD) ΣΕ ΜΕΤΑΛΛΑ',
  },
  {
    label: '25612205',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΙΑΝΣΗΣ ΜΕ ΠΕΡΙΣΤΡΟΦΗ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25612206',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΙΛΒΩΣΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25612207',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΑΡΑΞΗΣ ΚΑΙ ΑΠΟΤΥΠΩΣΗΣ ΕΠΙ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25612208',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΡΩΜΑΤΙΣΜΟΥ ΚΑΙ ΒΕΡΝΙΚΩΜΑΤΟΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25620000',
    value: 'ΜΕΤΑΛΛΟΤΕΧΝΙΑ',
  },
  {
    label: '25621000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΡΝΕΥΣΗΣ ΜΕΤΑΛΛΙΚΩΝ ΜΕΡΩΝ',
  },
  {
    label: '25622000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΛΛΟΤΕΧΝΙΑΣ',
  },
  {
    label: '25622001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΞΥΓΟΝΟΚΟΛΛΗΣΗΣ ΚΑΙ ΗΛΕΚΤΡΟΣΥΓΚΟΛΛΗΣΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '25710000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΑΧΑΙΡΟΠΙΡΟΥΝΩΝ',
  },
  {
    label: '25711100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΑΧΑΙΡΙΩΝ (ΕΚΤΟΣ ΤΩΝ ΜΑΧΑΙΡΙΩΝ ΓΙΑ ΜΗΧΑΝΕΣ) ΚΑΙ ΨΑΛΙΔΙΩΝ ΚΑΙ ΛΕΠΙΔΩΝ ΤΟΥΣ',
  },
  {
    label: '25711200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΡΑΦΙΩΝ ΚΑΙ ΛΕΠΙΔΩΝ ΞΥΡΑΦΙΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΑΚΑΤΕΡΓΑΣΤΩΝ ΜΕΤΑΛΛΙΚΩΝ ΤΑΙΝΙΩΝ, ΠΟΥ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΛΕΠΙΔΩΝ ΞΥΡΑΦΙΩΝ',
  },
  {
    label: '25711300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΜΑΧΑΙΡΟΠΙΡΟΥΝΩΝ· ΕΙΔΩΝ ΚΑΙ ΣΥΝΟΛΩΝ ΕΙΔΩΝ ΓΙΑ ΤΗΝ ΠΕΡΙΠΟΙΗΣΗ ΤΩΝ ΧΕΡΙΩΝ Η ΤΩΝ ΠΟΔΙΩΝ',
  },
  {
    label: '25711400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΥΤΑΛΙΩΝ, ΠΙΡΟΥΝΙΩΝ, ΤΡΥΠΗΤΩΝ ΚΟΥΤΑΛΩΝ, ΤΡΥΠΗΤΩΝ ΚΟΥΤΑΛΩΝ, ΣΠΑΤΟΥΛΩΝ ΓΙΑ ΓΛΥΚΑ, ΜΑΧΑΙΡΙΩΝ ΓΙΑ ΨΑΡΙΑ, ΓΙΑ ΒΟΥΤΥΡΟ, ΛΑΒΙΔΩΝ ΓΙΑ ΤΗ ΖΑΧΑΡΗ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΑΓΕΙΡΙΚΩΝ Η ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΚΕΥΩΝ',
  },
  {
    label: '25711500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΙΦΩΝ, ΣΠΑΘΙΩΝ, ΞΙΦΟΛΟΓΧΩΝ, ΛΟΓΧΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΟΠΛΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '25719000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΑΧΑΙΡΟΠΙΡΟΥΝΩΝ',
  },
  {
    label: '25720000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΛΕΙΔΑΡΙΩΝ ΚΑΙ ΜΕΝΤΕΣΕΔΩΝ',
  },
  {
    label: '25721100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΛΟΥΚΕΤΩΝ, ΚΛΕΙΔΑΡΙΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ ΚΑΙ ΓΙΑ ΕΠΙΠΛΑ, ΑΠΟ ΚΟΙΝΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '25721200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΚΛΕΙΔΑΡΙΩΝ, ΑΠΟ ΚΟΙΝΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '25721300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΛΕΙΣΤΡΩΝ ΚΑΙ ΠΛΑΙΣΙΩΝ ΜΕ ΚΛΕΙΣΤΡΑ, ΠΟΥ ΠΕΡΙΛΑΜΒΑΝΟΥΝ ΚΛΕΙΔΑΡΙΕΣ· ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '25721400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΝΤΕΣΕΔΩΝ, ΕΞΑΡΤΗΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ, ΠΟΡΤΕΣ, ΠΑΡΑΘΥΡΑ, ΕΠΙΠΛΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ, ΑΠΟ ΚΟΙΝΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '25721401',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΡΤΩΝ, ΘΗΛΥΚΩΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '25729000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΚΛΕΙΔΑΡΙΩΝ ΚΑΙ ΜΕΝΤΕΣΕΔΩΝ',
  },
  {
    label: '25730000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΩΝ',
  },
  {
    label: '25731000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗ ΓΕΩΡΓΙΑ, ΣΤΗΝ ΚΗΠΟΥΡΙΚΗ Η ΣΤΗ ΔΑΣΟΚΟΜΙΑ',
  },
  {
    label: '25732000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΕΙΡΟΠΡΙΟΝΩΝ· ΛΕΠΙΔΩΝ ΓΙΑ ΠΡΙΟΝΙΑ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '25733000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '25734000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΝΑΛΛΑΞΙΜΩΝ ΕΡΓΑΛΕΙΩΝ ΓΙΑ ΕΡΓΑΛΕΙΑ ΧΕΙΡΟΣ Η ΓΙΑ ΕΡΓΑΛΕΙΟΜΗΧΑΝΕΣ, ΠΟΥ ΕΙΤΕ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΡΕΥΜΑ ΕΙΤΕ ΧΩΡΙΣ ΡΕΥΜΑ',
  },
  {
    label: '25735000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΤΡΩΝ· ΚΑΣΩΝ (ΠΛΑΙΣΙΩΝ) ΧΥΤΗΡΙΟΥ ΓΙΑ ΧΥΤΗΡΙΑ ΜΕΤΑΛΛΟΥ· ΒΑΣΕΩΝ ΜΗΤΡΩΝ· ΜΟΝΤΕΛΩΝ ΓΙΑ ΜΗΤΡΕΣ',
  },
  {
    label: '25735001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΜΗΤΡΩΝ ΜΕ ΠΡΕΣΑ',
  },
  {
    label: '25736000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΡΓΑΛΕΙΩΝ',
  },
  {
    label: '25739000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΕΡΓΑΛΕΙΩΝ',
  },
  {
    label: '25910000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΑΛΥΒΔΙΝΩΝ ΒΑΡΕΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ',
  },
  {
    label: '25911000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΑΛΥΒΔΙΝΩΝ ΚΥΛΙΝΔΡΙΚΩΝ ΔΟΧΕΙΩΝ (ΒΑΡΕΛΙΩΝ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ',
  },
  {
    label: '25911100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΥΤΙΩΝ, ΒΑΡΕΛΙΩΝ, ΚΥΛΙΝΔΡΙΚΩΝ ΔΟΧΕΙΩΝ, ΜΠΙΤΟΝΙΩΝ, ΚΟΥΤΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ, ΓΙΑ ΚΑΘΕ ΥΛΙΚΟ (ΕΚΤΟΣ ΑΕΡΙΟΥ), ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΧΩΡΗΤΙΚΟΤΗΤΑΣ >= 50 ~ LT ΑΛΛΑ <= 300 ~ LT, ΧΩΡΙΣ ΜΗΧΑΝΙΚΕΣ Η ΘΕΡΜΙΚΕΣ ΔΙΑΤΑΞΕΙΣ',
  },
  {
    label: '25911200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΥΤΙΩΝ, ΒΑΡΕΛΙΩΝ, ΚΥΛΙΝΔΡΙΚΩΝ ΔΟΧΕΙΩΝ, ΜΠΙΤΟΝΙΩΝ, ΚΟΥΤΙΩΝ (ΕΚΤΟΣ ΕΚΕΙΝΩΝ ΠΟΥ ΠΡΟΚΕΙΤΑΙ ΝΑ ΚΛΕΙΣΘΟΥΝ ΜΕ ΣΥΓΚΟΛΛΗΣΗ Η ΛΙΘΟΚΟΛΛΗΣΗ), ΚΟΥΤΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ, ΓΙΑ ΚΑΘΕ ΥΛΙΚΟ (ΕΚΤΟΣ ΑΕΡΙΟΥ), ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΧΩΡΗΤΙΚΟΤΗΤΑΣ < 50 ',
  },
  {
    label: '25919000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΧΑΛΥΒΔΙΝΩΝ ΚΥΛΙΝΔΡΙΚΩΝ ΔΟΧΕΙΩΝ (ΒΑΡΕΛΙΩΝ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ',
  },
  {
    label: '25920000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΛΑΦΡΩΝ ΜΕΤΑΛΛΙΚΩΝ ΕΙΔΩΝ ΣΥΣΚΕΥΑΣΙΑΣ',
  },
  {
    label: '25921100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΥΤΙΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΠΟΥ ΚΛΕΙΝΟΝΤΑΙ ΜΕ ΣΥΓΚΟΛΛΗΣΗ Η ΛΙΘΟΚΟΛΛΗΣΗ (SERTISSAGE), ΧΩΡΗΤΙΚΟΤΗΤΑΣ < 50 ~ LT',
  },
  {
    label: '25921101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΛΕΥΚΟΣΙΔΗΡΩΝ ΔΟΧΕΙΩΝ',
  },
  {
    label: '25921200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΟΥΜΙΝΕΝΙΩΝ ΒΑΡΕΛΙΩΝ, ΚΥΛΙΝΔΡΙΚΩΝ ΔΟΧΕΙΩΝ, ΜΠΙΤΟΝΙΩΝ, ΚΟΥΤΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ, ΓΙΑ ΚΑΘΕ ΥΛΙΚΟ (ΕΚΤΟΣ ΑΕΡΙΟΥ), ΧΩΡΗΤΙΚΟΤΗΤΑΣ <= 300 ~ LT',
  },
  {
    label: '25921201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΑΡΙΩΝ, ΜΕΤΑΛΛΙΚΩΝ',
  },
  {
    label: '25921300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΩΜΑΤΩΝ;ΣΤΕΦΑΝΙΩΝ ΚΑΙ ΠΩΜΑΤΩΝ, ΤΑΠΩΝ ΚΑΙ ΚΑΠΑΚΙΩΝ, ΑΠΟ ΚΟΙΝΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '25921301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΠΩΜΑΤΩΝ',
  },
  {
    label: '25929000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΕΛΑΦΡΩΝ ΜΕΤΑΛΛΙΚΩΝ ΕΙΔΩΝ ΣΥΣΚΕΥΑΣΙΑΣ',
  },
  {
    label: '25930000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΑΠΟ ΣΥΡΜΑ, ΑΛΥΣΙΔΩΝ ΚΑΙ ΕΛΑΤΗΡΙΩΝ',
  },
  {
    label: '25931100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΡΜΑΤΟΣΧΟΙΝΩΝ, ΚΑΛΩΔΙΩΝ, ΠΛΕΞΟΥΔΩΝ, ΑΡΤΑΝΩΝ (ΣΑΜΠΑΝΙΩΝ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΜΗ ΗΛΕΚΤΡΟΜΟΝΩΜΕΝΩΝ',
  },
  {
    label: '25931101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΑΛΩΔΙΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΜΗ ΗΛΕΚΤΡΟΜΟΝΩΜΕΝΩΝ',
  },
  {
    label: '25931200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΡΜΑΤΟΠΛΕΓΜΑΤΟΣ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ· ΣΥΡΜΑΤΟΣΧΟΙΝΩΝ, ΚΑΛΩΔΙΩΝ, ΠΛΕΞΟΥΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΧΑΛΚΟ Η ΑΛΟΥΜΙΝΙΟ, ΜΗ ΗΛΕΚΤΡΟΜΟΝΩΜΕΝΩΝ',
  },
  {
    label: '25931300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΦΑΣΜΑΤΩΝ, ΣΙΤΩΝ, ΠΛΕΓΜΑΤΩΝ, ΔΙΚΤΥΩΤΩΝ ΚΑΙ ΥΛΙΚΩΝ ΠΕΡΙΦΡΑΞΗΣ, ΑΠΟ ΣΥΡΜΑ ΣΙΔΗΡΟΥ, ΧΑΛΥΒΑ Η ΧΑΛΚΟΥ· ΤΕΤΑΜΕΝΩΝ ΦΥΛΛΩΝ ΜΕΤΑΛΛΟΥ, ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ Η ΧΑΛΚΟ',
  },
  {
    label: '25931400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΑΡΦΙΩΝ, ΠΡΟΚΩΝ, ΠΙΝΕΖΩΝ, ΣΥΝΔΕΤΗΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '25931500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΡΜΑΤΟΣ, ΡΑΒΔΩΝ, ΣΩΛΗΝΩΝ, ΠΛΑΚΩΝ, ΗΛΕΚΤΡΟΔΙΩΝ, ΜΕ ΕΠΙΚΑΛΥΨΗ Η ΜΕ ΠΥΡΗΝΑ ΑΠΟ ΣΥΛΛΙΠΑΣΜΑ (FLUX)',
  },
  {
    label: '25931600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΛΑΤΗΡΙΩΝ ΚΑΙ ΕΛΑΣΜΑΤΩΝ ΕΛΑΤΗΡΙΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ· ΧΑΛΚΙΝΩΝ ΕΛΑΤΗΡΙΩΝ',
  },
  {
    label: '25931601',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΙΔΗΡΩΝ ΕΛΑΤΗΡΙΩΝ',
  },
  {
    label: '25931700',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΥΣΙΔΩΝ (ΕΚΤΟΣ ΤΩΝ ΑΡΘΡΩΤΩΝ ΑΛΥΣΙΔΩΝ) ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '25931800',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΕΛΟΝΩΝ ΡΑΨΙΜΑΤΟΣ, ΒΕΛΟΝΩΝ ΠΛΕΞΙΜΑΤΟΣ, ΣΑΚΟΡΑΦΩΝ, ΒΕΛΟΝΑΚΙΩΝ, ΚΕΝΤΗΤΗΡΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΓΙΑ ΧΡΗΣΗ ΜΕ ΤΟ ΧΕΡΙ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ· ΠΑΡΑΜΑΝΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΡΦΙΤΣΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, Π.Δ.Κ.Α.',
  },
  {
    label: '25939000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΣΥΡΜΑ, ΑΛΥΣΙΔΩΝ ΚΑΙ ΕΛΑΤΗΡΙΩΝ',
  },
  {
    label: '25940000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΝΔΕΤΗΡΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΚΟΧΛΙΟΜΗΧΑΝΩΝ',
  },
  {
    label: '25941100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΟΧΛΙΩΤΩΝ ΣΥΝΔΕΤΗΡΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, Π.Δ.Κ.Α.',
  },
  {
    label: '25941101',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΤΡΙΦΟΝΙΩΝ, ΒΙΔΩΝ ΚΑΙ ΠΕΡΙΚΟΧΛΙΩΝ (ΠΑΞΙΜΑΔΙΩΝ), ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '25941200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗ ΚΟΧΛΙΩΤΩΝ ΣΥΝΔΕΤΗΡΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, Π.Δ.Κ.Α.',
  },
  {
    label: '25941300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗ ΚΟΧΛΙΩΤΩΝ ΚΑΙ ΚΟΧΛΙΩΤΩΝ ΣΥΝΔΕΤΗΡΩΝ, ΑΠΟ ΧΑΛΚΟ',
  },
  {
    label: '25949000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΣΥΝΔΕΤΗΡΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΚΟΧΛΙΟΜΗΧΑΝΩΝ',
  },
  {
    label: '25990000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΕΤΑΛΛΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '25991000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΕΙΔΩΝ ΓΙΑ ΤΟ ΜΠΑΝΙΟ ΚΑΙ ΤΗΝ ΚΟΥΖΙΝΑ',
  },
  {
    label: '25991100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΝΕΡΟΧΥΤΩΝ, ΝΙΠΤΗΡΩΝ, ΜΠΑΝΙΕΡΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ, ΧΑΛΚΟ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '25991200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΙΤΡΑΠΕΖΙΩΝ, ΜΑΓΕΙΡΙΚΩΝ Η ΟΙΚΙΑΚΩΝ ΣΚΕΥΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ, ΧΑΛΚΟ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '25992000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΚΟΙΝΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '25992100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΡΗΜΑΤΟΚΙΒΩΤΙΩΝ, ΠΟΡΤΩΝ ΘΩΡΑΚΙΣΜΕΝΩΝ ΚΑΙ ΧΩΡΙΣΜΑΤΩΝ ΓΙΑ ΘΗΣΑΥΡΟΦΥΛΑΚΙΑ, ΚΙΒΩΤΙΑ ΚΑΙ ΚΑΣΕΤΙΝΕΣ ΑΣΦΑΛΕΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΚΟΙΝΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '25992101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΡΗΜΑΤΟΚΙΒΩΤΙΩΝ ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '25992200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΥΤΙΩΝ ΤΑΞΙΝΟΜΗΣΗΣ, ΘΗΚΩΝ ΓΙΑ ΤΗΝ ΤΟΠΟΘΕΤΗΣΗ ΑΝΤΙΓΡΑΦΩΝ, ΓΡΑΦΙΔΟΘΗΚΩΝ, ΘΗΚΩΝ ΣΦΡΑΓΙΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΟΥ ΥΛΙΚΟΥ ΚΑΙ ΕΙΔΩΝ ΓΡΑΦΕΙΟΥ, ΑΠΟ ΚΟΙΝΑ ΜΕΤΑΛΛΑ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΑ ΕΠΙΠΛΑ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '25992300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΕΞΩΦΥΛΛΑ (ΝΤΟΣΙΕ) Η ΦΑΚΕΛΟΥΣ ΚΙΝΗΤΩΝ ΦΥΛΛΩΝ, ΣΥΝΔΕΤΗΡΩΝ ΕΓΓΡΑΦΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΓΡΑΦΕΙΟΥ, ΚΑΘΩΣ ΚΑΙ ΣΥΝΔΕΤΗΡΩΝ ΣΥΡΡΑΦΗΣ ΣΕ ΠΛΑΚΕΤΕΣ, ΑΠΟ ΚΟΙΝΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '25992400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΓΑΛΜΑΤΙΔΙΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΔΙΑΚΟΣΜΗΣΗΣ, ΚΑΔΡΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΕΣ, ΠΙΝΑΚΕΣ Η ΠΑΡΟΜΟΙΑ ΕΙΔΗ ΚΑΙ ΚΑΘΡΕΠΤΩΝ, ΑΠΟ ΚΟΙΝΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '25992401',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΚΟΡΝΙΖΩΝ',
  },
  {
    label: '25992500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΛΕΙΣΤΡΩΝ, ΣΥΝΑΡΜΟΓΩΝ ΤΟΥΣ, ΠΟΡΠΩΝ, ΠΟΡΠΩΝ;ΚΛΕΙΣΤΡΩΝ, ΠΟΡΠΩΝ ΜΕ ΠΕΡΟΝΗ (ΑΓΚΡΑΦΩΝ), ΑΓΚΙΣΤΡΩΝ, ΚΟΠΙΤΣΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΚΟΙΝΑ ΜΕΤΑΛΛΑ, ΓΙΑ ΕΝΔΥΜΑΤΑ, ΥΠΟΔΗΜΑΤΑ Η ΓΙΑ ΚΑΘΕ ΚΑΤΑΣΚΕΥΗ· ΚΑΨΟΥΛΙΩΝ ΣΩΛΗΝΩΤΩΝ Η ΜΕ ΣΧΙΣΤΟ ΣΤΕΛΕΧΟΣ,            ',
  },
  {
    label: '25992501',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΘΗΛΥΚΩΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '25992502',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΛΕΥΚΟΣΙΔΗΡΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '25992503',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΟΡΕΙΧΑΛΚΙΝΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '25992600',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΛΙΚΩΝ ΠΛΟΙΩΝ ΚΑΙ ΤΩΝ ΠΤΕΡΥΓΙΩΝ ΤΟΥΣ',
  },
  {
    label: '25992900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΚΟΙΝΑ ΜΕΤΑΛΛΑ Π.Δ.Κ.Α.',
  },
  {
    label: '25992901',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΦΥΛΛΩΝ ΑΠΟ ΜΕΤΑΛΛΑ',
  },
  {
    label: '25992902',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΔΙΑΚΟΣΜΗΣΗΣ ΑΠΟ ΟΡΕΙΧΑΛΚΟ',
  },
  {
    label: '25992903',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΑΙ ΤΟΠΟΘΕΤΗΣΗ ΕΠΙΓΡΑΦΩΝ',
  },
  {
    label: '25992904',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΚΟΥΡΤΙΝΟΒΕΡΓΩΝ',
  },
  {
    label: '25992905',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ ΣΤΗΡΙΞΕΩΣ, ΑΛΛΩΝ ΑΠΟ ΔΟΜΙΚΑ',
  },
  {
    label: '25992906',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΣΦΡΑΓΙΔΩΝ, ΕΠΙΓΡΑΦΩΝ, ΣΗΜΑΤΩΝ ΚΛΠ',
  },
  {
    label: '25992907',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΙΝΑΚΙΔΩΝ ΟΔΙΚΗΣ ΣΗΜΑΝΣΗΣ',
  },
  {
    label: '25992908',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΚΑΛΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '25999000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '26110000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '26111000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΛΥΧΝΙΩΝ ΚΑΙ ΣΩΛΗΝΩΝ ΘΕΡΜΗΣ ΚΑΘΟΔΟΥ, ΨΥΧΡΗΣ ΚΑΘΟΔΟΥ Η ΦΩΤΟΚΑΘΟΔΟΥ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΛΥΧΝΙΩΝ ΚΑΘΟΔΙΚΩΝ ΑΚΤΙΝΩΝ',
  },
  {
    label: '26111100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΛΥΧΝΙΩΝ ΚΑΘΟΔΙΚΩΝ ΑΚΤΙΝΩΝ ΤΗΛΕΟΡΑΣΗΣ· ΛΥΧΝΙΩΝ ΓΙΑ ΤΗΛΕΟΠΤΙΚΕΣ ΜΗΧΑΝΕΣ ΛΗΨΗΣ· ΑΛΛΩΝ ΛΥΧΝΙΩΝ ΚΑΘΟΔΙΚΩΝ ΑΚΤΙΝΩΝ',
  },
  {
    label: '26111200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΛΫΧΝΙΩΝ MAGNETRON, ΛΥΧΝΙΩΝ KLYSTRON, ΛΥΧΝΙΩΝ ΜΙΚΡΟΚΥΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΛΥΧΝΙΩΝ',
  },
  {
    label: '26112000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΙΟΔΩΝ ΚΑΙ ΚΡΥΣΤΑΛΛΟΛΥΧΝΙΩΝ (TRANSISTORS)',
  },
  {
    label: '26112100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΔΙΟΔΩΝ· ΚΡΥΣΤΑΛΛΟΛΥΧΝΙΩΝ (TRANSISTORS)· ΘΥΡΙΣΤΟΡ (THYRISTORS), ΔΙΑΚΟΠΤΩΝ ΔΙΠΛΕΥΡΗΣ ΔΙΟΔΟΥ (DIACS) ΚΑΙ ΔΙΑΚΟΠΤΩΝ ΔΙΠΛΕΥΡΗΣ ΤΡΙΟΔΟΥ (TRIACS)',
  },
  {
    label: '26112200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΜΕ ΗΜΙΑΓΩΓΟΥΣ· ΔΙΟΔΩΝ ΕΚΠΟΜΠΗΣ ΦΩΤΟΣ· ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΩΝ ΠΙΕΖΟΗΛΕΚΤΡΙΚΩΝ ΚΡΥΣΤΑΛΛΩΝ· ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '26113000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΟΛΟΚΛΗΡΩΜΕΝΩΝ ΚΥΚΛΩΜΑΤΩΝ',
  },
  {
    label: '26114000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΛΥΧΝΙΩΝ ΚΑΙ ΑΛΛΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '26114100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΛΥΧΝΙΩΝ ΚΑΙ ΑΛΛΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '26114101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΩΤΟΒΟΛΤΑΪΚΩΝ ΚΥΤΤΑΡΩΝ',
  },
  {
    label: '26119000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΟΛΟΚΛΗΡΩΜΕΝΩΝ ΚΥΚΛΩΜΑΤΩΝ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΚΑΤΑΣΚΕΥΗΣ ΗΛΕΚΤΡΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '26119100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΟΛΟΚΛΗΡΩΜΕΝΩΝ ΚΥΚΛΩΜΑΤΩΝ',
  },
  {
    label: '26119900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΗΛΕΚΤΡΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '26120000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΜΦΟΡΤΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΠΛΑΚΕΤΩΝ',
  },
  {
    label: '26121000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΥΠΩΜΕΝΩΝ ΚΥΚΛΩΜΑΤΩΝ',
  },
  {
    label: '26122000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΡΤΩΝ ΗΧΟΥ, ΒΙΝΤΕΟ, ΔΙΚΤΥΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΚΑΡΤΩΝ ΓΙΑ ΜΗΧΑΝΕΣ ΑΥΤΟΜΑΤΗΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '26123000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΡΤΩΝ ΜΕ ΗΛΕΚΤΡΟΝΙΚΑ ΟΛΟΚΛΗΡΩΜΕΝΑ ΚΥΚΛΩΜΑΤΑ (\\ΕΞΥΠΝΩΝ\\ ΚΑΡΤΩΝ)',
  },
  {
    label: '26129000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΗΝ ΕΚΤΥΠΩΣΗ ΚΥΚΛΩΜΑΤΩΝ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΚΑΤΑΣΚΕΥΗΣ ΕΜΦΟΡΤΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΠΛΑΚΕΤΩΝ',
  },
  {
    label: '26129100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΗΝ ΕΚΤΥΠΩΣΗ ΚΥΚΛΩΜΑΤΩΝ',
  },
  {
    label: '26129900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΕΜΦΟΡΤΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΠΛΑΚΕΤΩΝ',
  },
  {
    label: '26200000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '26201000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '26201100',
    value:
      "ΚΑΤΑΣΚΕΥΗ ΦΟΡΗΤΩΝ ΨΗΦΙΑΚΩΝ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ, ΒΑΡΟΥΣ <= 10 ~ KG, ΟΠΩΣ ΕΙΝΑΙ ΟΙ ΥΠΟΛΟΓΙΣΤΕΣ ΤΩΝ ΤΥΠΩΝ \\LAPTOP\\ ΚΑΙ \\NOTEBOOK'· ΠΡΟΣΩΠΙΚΩΝ ΨΗΦΙΑΚΩΝ ΒΟΗΘΩΝ (PDA) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ",
  },
  {
    label: '26201200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΕΡΜΑΤΙΚΩΝ ΣΗΜΕΙΩΝ ΠΩΛΗΣΗΣ, ΑΥΤΟΜΑΤΩΝ ΤΑΜΙΑΚΩΝ ΜΗΧΑΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗΧΑΝΩΝ ΠΟΥ ΜΠΟΡΟΥΝ ΝΑ ΣΥΝΔΕΘΟΥΝ ΣΕ ΜΗΧΑΝΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ Η ΣΕ ΔΙΚΤΥΟ',
  },
  {
    label: '26201300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΜΑΤΩΝ ΨΗΦΙΑΚΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΣΤΟ ΙΔΙΟ ΠΕΡΙΒΛΗΜΑ ΤΟΥΛΑΧΙΣΤΟΝ ΜΙΑ ΚΕΝΤΡΙΚΗ ΜΟΝΑΔΑ ΕΠΕΞΕΡΓΑΣΙΑΣ, ΜΙΑ ΜΟΝΑΔΑ ΕΙΣΟΔΟΥ ΚΑΙ ΜΙΑ ΜΟΝΑΔΑ ΕΞΟΔΟΥ, ΣΥΝΔΥΑΣΜΕΝΩΝ Η ΜΗ',
  },
  {
    label: '26201400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΜΑΤΩΝ ΨΗΦΙΑΚΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ ΠΟΥ ΠΑΡΟΥΣΙΑΖΟΝΤΑΙ ΥΠΟ ΜΟΡΦΗ ΣΥΣΤΗΜΑΤΩΝ',
  },
  {
    label: '26201500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΨΗΦΙΑΚΩΝ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ, ΕΙΤΕ ΠΕΡΙΕΧΟΥΝ Η ΔΕΝ ΠΕΡΙΕΧΟΥΝ ΣΤΟ ΙΔΙΟ ΠΕΡΙΒΛΗΜΑ ΜΙΑ Η ΔΥΟ ΑΠΟ ΤΟΥΣ ΠΑΡΑΚΑΤΩ ΤΥΠΟΥΣ ΜΟΝΑΔΩΝ: ΜΟΝΑΔΕΣ ΜΝΗΜΗΣ, ΜΟΝΑΔΕΣ ΕΙΣΟΔΟΥ, ΜΟΝΑΔΕΣ ΕΞΟΔΟΥ',
  },
  {
    label: '26201600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΝΑΔΩΝ ΕΙΣΟΔΟΥ Η ΕΞΟΔΟΥ, ΕΙΤΕ ΠΕΡΙΕΧΟΥΝ Η ΔΕΝ ΠΕΡΙΕΧΟΥΝ ΣΤΟ ΙΔΙΟ ΠΕΡΙΒΛΗΜΑ ΜΟΝΑΔΕΣ ΜΝΗΜΗΣ',
  },
  {
    label: '26201601',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΑΓΝΗΤΙΚΩΝ Η ΟΠΤΙΚΩΝ ΑΝΑΓΝΩΣΤΩΝ',
  },
  {
    label: '26201700',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΘΟΝΩΝ ΚΑΙ ΠΡΟΒΟΛΕΩΝ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΚΥΡΙΩΣ ΣΕ ΑΥΤΟΜΑΤΟ ΣΥΣΤΗΜΑ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '26201800',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΝΑΔΩΝ ΠΟΥ ΕΚΤΕΛΟΥΝ ΔΥΟ Η ΠΕΡΙΣΣΟΤΕΡΕΣ ΑΠΟ ΤΙΣ ΕΞΗΣ ΛΕΙΤΟΥΡΓΙΕΣ: ΕΚΤΥΠΩΣΗ, ΣΑΡΩΣΗ, ΑΝΤΙΓΡΑΦΗ, ΑΠΟΣΤΟΛΗ ΦΑΞ',
  },
  {
    label: '26202000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΟΝΑΔΩΝ ΜΝΗΜΗΣ ΚΑΙ ΑΛΛΩΝ ΣΥΣΚΕΥΩΝ ΜΝΗΜΗΣ',
  },
  {
    label: '26202100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΟΝΑΔΩΝ ΜΝΗΜΗΣ',
  },
  {
    label: '26202200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΔΙΑΤΗΡΗΣΙΜΗΣ ΜΝΗΜΗΣ ΣΕ ΣΤΕΡΕΑ ΚΑΤΑΣΤΑΣΗ',
  },
  {
    label: '26203000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΟΝΑΔΩΝ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '26204000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΥΠΟΛΟΓΙΣΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '26209000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΚΑΤΑΣΚΕΥΗΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '26209100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '26209900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '26300000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΞΟΠΛΙΣΜΟΥ ΕΠΙΚΟΙΝΩΝΙΑΣ',
  },
  {
    label: '26301000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΕΚΠΟΜΠΗΣ ΡΑΔΙΟΦΩΝΟΥ Η ΤΗΛΕΟΡΑΣΗΣ· ΤΗΛΕΟΠΤΙΚΩΝ ΜΗΧΑΝΩΝ ΛΗΨΗΣ',
  },
  {
    label: '26301100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΕΚΠΟΜΠΗΣ ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΕΣ ΣΥΣΚΕΥΕΣ ΛΗΨΗΣ',
  },
  {
    label: '26301200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΕΚΠΟΜΠΗΣ ΧΩΡΙΣ ΕΝΣΩΜΑΤΩΜΕΝΕΣ ΣΥΣΚΕΥΕΣ ΛΗΨΗΣ',
  },
  {
    label: '26301300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΗΛΕΟΠΤΙΚΩΝ ΜΗΧΑΝΩΝ ΛΗΨΗΣ',
  },
  {
    label: '26302000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗΝ ΕΝΣΥΡΜΑΤΗ ΤΗΛΕΦΩΝΙΑ Η ΤΗΝ ΕΝΣΥΡΜΑΤΗ ΤΗΛΕΓΡΑΦΙΑ· ΕΙΚΟΝΟΤΗΛΕΦΩΝΩΝ',
  },
  {
    label: '26302100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΕΝΣΥΡΜΑΤΗΣ ΤΗΛΕΦΩΝΙΑΣ ΜΕ ΑΣΥΡΜΑΤΟ ΑΚΟΥΣΤΙΚΟ',
  },
  {
    label: '26302200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΚΥΨΕΛΟΕΙΔΟΥΣ (ΚΙΝΗΤΗΣ) ΤΗΛΕΦΩΝΙΑΣ Η ΑΛΛΩΝ ΑΣΥΡΜΑΤΩΝ ΔΙΚΤΥΩΝ',
  },
  {
    label: '26302300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΤΗΛΕΦΩΝΙΚΩΝ ΣΥΣΚΕΥΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΕΚΠΟΜΠΗΣ Η ΛΗΨΗΣ ΗΧΟΥ, ΕΙΚΟΝΑΣ Η ΑΛΛΩΝ ΔΕΔΟΜΕΝΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΣΥΣΚΕΥΩΝ ΕΠΙΚΟΙΝΩΝΙΑΣ ΕΝΣΥΡΜΑΤΟΥ Η ΑΣΥΡΜΑΤΟΥ ΔΙΚΤΥΟΥ (ΟΠΩΣ ΤΑ ΤΟΠΙΚΑ ΔΙΚΤΥΑ Η ΤΑ ΔΙΚΤΥΑ ΕΥΡΕΙΑΣ ΠΕΡΙΟΧΗΣ)',
  },
  {
    label: '26303000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΤΗΛΕΦΩΝΙΚΩΝ Η ΤΗΛΕΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '26304000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΕΡΑΙΩΝ ΚΑΙ ΑΝΑΚΛΑΣΤΗΡΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ· ΜΕΡΩΝ ΣΥΣΚΕΥΩΝ ΕΚΠΟΜΠΗΣ ΡΑΔΙΟΦΩΝΟΥ, ΤΗΛΕΟΡΑΣΗΣ ΚΑΙ ΤΗΛΕΟΠΤΙΚΩΝ ΜΗΧΑΝΩΝ ΛΗΨΗΣ',
  },
  {
    label: '26304001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΟΡΥΦΟΡΙΚΩΝ ΚΕΡΑΙΩΝ ΤΗΛΕΟΡΑΣΗΣ',
  },
  {
    label: '26304002',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΕΡΑΙΩΝ ΤΗΛΕΟΡΑΣΗΣ',
  },
  {
    label: '26305000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΤΙΚΛΕΠΤΙΚΩΝ Η ΠΥΡΟΣΒΕΣΤΙΚΩΝ ΣΥΝΑΓΕΡΜΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '26305001',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ ΑΝΙΧΝΕΥΣΗΣ, ΕΛΕΓΧΟΥ ΚΑΙ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '26306000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΝΤΙΚΛΕΠΤΙΚΩΝ Η ΠΥΡΟΣΒΕΣΤΙΚΩΝ ΣΥΝΑΓΕΡΜΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '26309000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΕΞΟΠΛΙΣΜΟΥ ΕΠΙΚΟΙΝΩΝΙΑΣ',
  },
  {
    label: '26400000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΕΙΔΩΝ ΕΥΡΕΙΑΣ ΚΑΤΑΝΑΛΩΣΗΣ',
  },
  {
    label: '26401000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΕΚΤΩΝ ΡΑΔΙΟΦΩΝΙΚΗΣ ΜΕΤΑΔΟΣΗΣ',
  },
  {
    label: '26401100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΔΕΚΤΩΝ ΡΑΔΙΟΦΩΝΙΚΗΣ ΜΕΤΑΔΟΣΗΣ (ΕΚΤΟΣ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΑ ΑΥΤΟΚΙΝΗΤΑ), ΠΟΥ ΜΠΟΡΟΥΝ ΝΑ ΛΕΙΤΟΥΡΓΗΣΟΥΝ ΧΩΡΙΣ ΕΞΩΤΕΡΙΚΗ ΠΗΓΗ ΕΝΕΡΓΕΙΑΣ',
  },
  {
    label: '26401200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΔΕΚΤΩΝ ΡΑΔΙΟΦΩΝΙΚΗΣ ΜΕΤΑΔΟΣΗΣ, ΠΟΥ ΔΕΝ ΜΠΟΡΟΥΝ ΝΑ ΛΕΙΤΟΥΡΓΗΣΟΥΝ ΧΩΡΙΣ ΕΞΩΤΕΡΙΚΗ ΠΗΓΗ ΕΝΕΡΓΕΙΑΣ',
  },
  {
    label: '26402000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΗΛΕΟΠΤΙΚΩΝ ΔΕΚΤΩΝ, ΣΕ ΣΥΝΔΥΑΣΜΟ ΜΕ Η ΧΩΡΙΣ ΡΑΔΙΟΦΩΝΙΚΟΥΣ ΔΕΚΤΕΣ Η ΣΥΣΚΕΥΕΣ ΕΓΓΡΑΦΗΣ Η ΑΝΑΠΑΡΑΓΩΓΗΣ ΗΧΟΥ Η ΕΙΚΟΝΑΣ',
  },
  {
    label: '26403000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗΝ ΕΓΓΡΑΦΗ Η ΑΝΑΠΑΡΑΓΩΓΗ ΗΧΟΥ Η ΕΙΚΟΝΑΣ',
  },
  {
    label: '26403100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΤΗΜΑΤΩΝ ΠΕΡΙΣΤΡΟΦΗΣ ΔΙΣΚΩΝ, ΠΙΚΑΠ, ΚΑΣΕΤΟΦΩΝΩΝ ΚΑΙ ΑΛΛΩΝ ΣΥΣΚΕΥΩΝ ΑΝΑΠΑΡΑΓΩΓΗΣ ΗΧΟΥ',
  },
  {
    label: '26403200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΑΓΝΗΤΟΦΩΝΩΝ ΚΑΙ ΑΛΛΩΝ ΣΥΣΚΕΥΩΝ ΕΓΓΡΑΦΗΣ ΗΧΟΥ',
  },
  {
    label: '26403300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΙΝΤΕΟΚΑΜΕΡΩΝ ΚΑΙ ΑΛΛΩΝ ΣΥΣΚΕΥΩΝ ΕΓΓΡΑΦΗΣ Η ΑΝΑΠΑΡΑΓΩΓΗΣ ΕΙΚΟΝΑΣ',
  },
  {
    label: '26403400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΘΟΝΩΝ ΚΑΙ ΠΡΟΒΟΛΕΩΝ, ΠΟΥ ΔΕΝ ΦΕΡΟΥΝ ΤΗΛΕΟΠΤΙΚΟΥΣ ΔΕΚΤΕΣ ΚΑΙ ΔΕΝ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΚΥΡΙΩΣ ΣΕ ΑΥΤΟΜΑΤΑ ΣΥΣΤΗΜΑΤΑ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '26404000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΙΚΡΟΦΩΝΩΝ, ΜΕΓΑΦΩΝΩΝ, ΔΕΚΤΩΝ ΡΑΔΙΟΤΗΛΕΦΩΝΙΑΣ Η ΡΑΔΙΟΤΗΛΕΓΡΑΦΙΑΣ',
  },
  {
    label: '26404100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΙΚΡΟΦΩΝΩΝ ΚΑΙ ΥΠΟΣΤΗΡΙΓΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '26404200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΓΑΦΩΝΩΝ· ΑΚΟΥΣΤΙΚΩΝ ΚΕΦΑΛΗΣ, ΚΟΙΝΩΝ ΑΚΟΥΣΤΙΚΩΝ ΚΑΙ ΣΥΝΟΛΩΝ (ΣΕΤ) ΣΥΝΔΥΑΣΜΕΝΩΝ ΜΕ ΜΙΚΡΟΦΩΝΟ',
  },
  {
    label: '26404300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΕΝΙΣΧΥΤΩΝ ΑΚΟΥΣΤΙΚΗΣ ΣΥΧΝΟΤΗΤΑΣ· ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ ΕΝΙΣΧΥΣΗΣ ΗΧΟΥ',
  },
  {
    label: '26404400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΕΚΤΩΝ ΡΑΔΙΟΤΗΛΕΦΩΝΙΑΣ Η ΡΑΔΙΟΤΗΛΕΓΡΑΦΙΑΣ Π.Δ.Κ.Α.',
  },
  {
    label: '26405000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΕΞΟΠΛΙΣΜΟΥ ΕΓΓΡΑΦΗΣ Η ΑΝΑΠΑΡΑΓΩΓΗΣ ΗΧΟΥ ΚΑΙ ΕΙΚΟΝΑΣ',
  },
  {
    label: '26405100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΞΟΠΛΙΣΜΟΥ ΕΓΓΡΑΦΗΣ Η ΑΝΑΠΑΡΑΓΩΓΗΣ ΗΧΟΥ ΚΑΙ ΕΙΚΟΝΑΣ',
  },
  {
    label: '26405200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΡΑΔΙΟΦΩΝΙΚΩΝ ΔΕΚΤΩΝ ΚΑΙ ΠΟΜΠΩΝ',
  },
  {
    label: '26406000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΕΙΡΙΣΤΗΡΙΩΝ ΒΙΝΤΕΟΠΑΙΧΝΙΔΙΩΝ (ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΜΕ ΕΝΑ ΤΗΛΕΟΠΤΙΚΟ ΔΕΚΤΗ Η ΕΧΟΥΝ ΕΝΣΩΜΑΤΩΜΕΝΗ ΟΘΟΝΗ) ΚΑΙ ΑΛΛΩΝ ΠΑΙΧΝΙΔΙΩΝ ΙΚΑΝΟΤΗΤΩΝ Η ΤΥΧΗΣ ΜΕ ΗΛΕΚΤΡΟΝΙΚΗ ΟΘΟΝΗ',
  },
  {
    label: '26409000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΣΥΣΚΕΥΩΝ ΕΥΡΕΙΑΣ ΚΑΤΑΝΑΛΩΣΗΣ',
  },
  {
    label: '26510000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΜΕΤΡΗΣΗΣ, ΔΟΚΙΜΩΝ ΚΑΙ ΠΛΟΗΓΗΣΗΣ',
  },
  {
    label: '26511000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΛΟΗΓΗΣΗΣ, ΜΕΤΕΩΡΟΛΟΓΙΑΣ, ΓΕΩΦΥΣΙΚΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΠΙΣΤΗΜΩΝ',
  },
  {
    label: '26511100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΥΞΙΔΩΝ ΠΡΟΣΑΝΑΤΟΛΙΣΜΟΥ· ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΛΟΗΓΗΣΗΣ',
  },
  {
    label: '26511200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΗΛΕΜΕΤΡΩΝ, ΘΕΟΔΟΛΙΧΩΝ ΚΑΙ ΤΑΧΥΜΕΤΡΩΝ· ΑΛΛΩΝ ΤΟΠΟΓΡΑΦΙΚΩΝ, ΥΔΡΟΓΡΑΦΙΚΩΝ, ΩΚΕΑΝΟΓΡΑΦΙΚΩΝ, ΥΔΡΟΛΟΓΙΚΩΝ, ΜΕΤΕΩΡΟΛΟΓΙΚΩΝ Η ΓΕΩΦΥΣΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '26512000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΡΑΔΙΟΑΝΙΧΝΕΥΣΗΣ (ΡΑΝΤΑΡ) ΚΑΙ ΡΑΔΙΟΚΑΤΕΥΘΥΝΣΗΣ (ΡΑΔΙΟΠΛΟΗΓΗΣΗΣ)',
  },
  {
    label: '26513000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΖΥΓΑΡΙΩΝ ΑΚΡΙΒΕΙΑΣ· ΟΡΓΑΝΩΝ ΣΧΕΔΙΑΣΗΣ, ΥΠΟΛΟΓΙΣΜΟΥ, ΜΕΤΡΗΣΗΣ ΤΟΥ ΜΗΚΟΥΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ',
  },
  {
    label: '26513100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΖΥΓΑΡΙΩΝ ΜΕ ΕΥΑΙΣΘΗΣΙΑ ΣΕ ΒΑΡΟΣ >= 5 ~ CG',
  },
  {
    label: '26513101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΖΥΓΑΡΙΩΝ ΑΚΡΙΒΕΙΑΣ',
  },
  {
    label: '26513200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΡΑΠΕΖΙΩΝ ΚΑΙ ΜΗΧΑΝΩΝ ΣΧΕΔΙΑΣΗΣ, ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΣΧΕΔΙΑΣΗΣ, ΧΑΡΑΞΗΣ Η ΔΙΕΝΕΡΓΕΙΑΣ ΜΑΘΗΜΑΤΙΚΩΝ ΥΠΟΛΟΓΙΣΜΩΝ',
  },
  {
    label: '26513300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ ΜΕΤΡΗΣΗΣ ΤΟΥ ΜΗΚΟΥΣ, ΓΙΑ ΧΡΗΣΗ ΜΕ ΤΟ ΧΕΡΙ [ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΜΙΚΡΟΜΕΤΡΩΝ ΚΑΙ ΜΕΤΡΗΤΩΝ (ΠΟΔΙΩΝ) ΜΕ ΑΥΛΑΚΩΣΕΙΣ            ] Π.Δ.Κ.Α.',
  },
  {
    label: '26514000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ ΜΕΤΡΗΣΗΣ ΗΛΕΚΤΡΙΚΩΝ ΜΕΓΕΘΩΝ Η ΙΟΝΤΙΖΟΥΣΩΝ ΑΚΤΙΝΟΒΟΛΙΩΝ',
  },
  {
    label: '26514100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΜΕΤΡΗΣΗΣ Η ΑΝΙΧΝΕΥΣΗΣ ΙΟΝΤΙΖΟΥΣΩΝ ΑΚΤΙΝΟΒΟΛΙΩΝ',
  },
  {
    label: '26514200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΑΛΑΝΤΟΣΚΟΠΙΩΝ ΚΑΙ ΤΑΛΑΝΤΟΓΡΑΦΩΝ ΚΑΘΟΔΙΚΩΝ ΑΚΤΙΝΩΝ',
  },
  {
    label: '26514300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ ΜΕΤΡΗΣΗΣ ΗΛΕΚΤΡΙΚΩΝ ΜΕΓΕΘΩΝ ΧΩΡΙΣ ΔΙΑΤΑΞΗ ΚΑΤΑΓΡΑΦΗΣ',
  },
  {
    label: '26514400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΙΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΕΣ',
  },
  {
    label: '26514500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΜΕΤΡΗΣΗΣ Η ΕΛΕΓΧΟΥ ΗΛΕΚΤΡΙΚΩΝ ΜΕΓΕΘΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '26515000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ ΕΛΕΓΧΟΥ ΑΛΛΩΝ ΦΥΣΙΚΩΝ ΧΑΡΑΚΤΗΡΙΣΤΙΚΩΝ',
  },
  {
    label: '26515100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΔΡΟΜΕΤΡΩΝ, ΘΕΡΜΟΜΕΤΡΩΝ, ΠΥΡΟΜΕΤΡΩΝ, ΒΑΡΟΜΕΤΡΩΝ, ΥΓΡΟΜΕΤΡΩΝ ΚΑΙ',
  },
  {
    label: '26515200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ ΜΕΤΡΗΣΗΣ Η ΕΛΕΓΧΟΥ ΤΗΣ ΠΑΡΟΧΗΣ, ΤΗΣ ΣΤΑΘΜΗΣ, ΤΗΣ ΠΙΕΣΗΣ Η ΑΛΛΩΝ ΜΕΤΑΒΛΗΤΩΝ ΤΩΝ ΥΓΡΩΝ ΚΑΙ ΤΩΝ ΑΕΡΙΩΝ',
  },
  {
    label: '26515300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΦΥΣΙΚΕΣ Η ΧΗΜΙΚΕΣ ΑΝΑΛΥΣΕΙΣ Π.Δ.Κ.Α.',
  },
  {
    label: '26516000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΜΕΤΡΗΣΕΩΝ, ΕΛΕΓΧΩΝ ΚΑΙ ΔΟΚΙΜΩΝ',
  },
  {
    label: '26516100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΙΚΡΟΣΚΟΠΙΩΝ (ΕΚΤΟΣ ΤΩΝ ΟΠΤΙΚΩΝ ΜΙΚΡΟΣΚΟΠΙΩΝ) ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΕΡΙΘΛΑΣΗΣ',
  },
  {
    label: '26516200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΔΟΚΙΜΗΣ ΤΩΝ ΜΗΧΑΝΙΚΩΝ ΙΔΙΟΤΗΤΩΝ ΤΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '26516300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΤΡΗΤΩΝ ΠΑΡΟΧΗΣ Η ΠΑΡΑΓΩΓΗΣ ΑΕΡΙΩΝ, ΥΓΡΩΝ Η ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ',
  },
  {
    label: '26516400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΤΡΟΦΟΜΕΤΡΩΝ ΚΑΙ ΜΕΤΡΗΤΩΝ ΠΑΡΑΓΩΓΗΣ, ΤΑΞΙΜΕΤΡΩΝ· ΟΡΓΑΝΩΝ ΕΝΔΕΙΞΗΣ ΤΗΣ ΤΑΧΥΤΗΤΑΣ ΚΑΙ ΤΑΧΟΓΡΑΦΩΝ· ΣΤΡΟΒΟΣΚΟΠΙΩΝ',
  },
  {
    label: '26516500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΑΥΤΟΜΑΤΗΣ ΡΥΘΜΙΣΗΣ Η ΕΛΕΓΧΟΥ, ΛΕΙΤΟΥΡΓΙΑΣ ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ Η ΥΔΡΑΥΛΙΚΗΣ ΛΕΙΤΟΥΡΓΙΑΣ',
  },
  {
    label: '26516600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ, ΣΥΣΚΕΥΩΝ ΚΑΙ ΜΗΧΑΝΩΝ ΜΕΤΡΗΣΗΣ Η ΕΛΕΓΧΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '26516601',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΥΘΥΓΡΑΜΜΙΣΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '26516602',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΠΡΟΣΤΑΣΙΑΣ ΤΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ ΠΟΥ ΕΓΚΑΘΙΣΤΑΝΤΑΙ ΣΕ ΠΛΟΙΑ ΚΑΙ ΝΑΥΠΗΓΕΙΑ',
  },
  {
    label: '26517000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΘΕΡΜΟΣΤΑΤΩΝ, ΡΥΘΜΙΣΤΩΝ ΠΙΕΣΗΣ (ΜΑΝΟΣΤΑΤΩΝ) ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΑΥΤΟΜΑΤΗΣ ΡΥΘΜΙΣΗΣ Η ΕΛΕΓΧΟΥ',
  },
  {
    label: '26518000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΤΟΝ ΕΞΟΠΛΙΣΜΟ ΜΕΤΡΗΣΕΩΝ, ΕΛΕΓΧΟΥ ΚΑΙ ΠΛΟΗΓΗΣΗΣ',
  },
  {
    label: '26518100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΣΥΣΚΕΥΩΝ ΡΑΔΙΟΑΝΙΧΝΕΥΣΗΣ (ΡΑΝΤΑΡ) ΚΑΙ ΡΑΔΙΟΚΑΤΕΥΘΥΝΣΗΣ (ΡΑΔΙΟΠΛΟΗΓΗΣΗΣ)',
  },
  {
    label: '26518200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΩΝ ΕΙΔΩΝ ΤΩΝ ΥΠΟΚΑΤΗΓΟΡΙΩΝ 26 ;.51 ;.12 ;, 26 ;.51 ;.32 ;, 26 ;.51 ;.33 ;, 26 ;.51 ;.4 ; ΚΑΙ 26 ;.51 ;.5 ;· ΜΙΚΡΟΤΟΜΩΝ· ΜΕΡΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '26518400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΩΝ ΕΙΔΩΝ ΤΩΝ ΥΠΟΚΑΤΗΓΟΡΙΩΝ 26 ;.51 ;.63 ~ ΚΑΙ 26 ;.51 ;.64 ',
  },
  {
    label: '26518500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΤΩΝ ΥΠΟΚΑΤΗΓΟΡΙΩΝ 26 ;.51 ;.65 ;,            26 ;.51 ;.66 ~ ΚΑΙ 26 ;.51 ;.70 ',
  },
  {
    label: '26518600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΤΩΝ ΥΠΟΚΑΤΗΓΟΡΙΩΝ 26 ;.51 ;.11 ;,            26 ;.51 ;.62 ',
  },
  {
    label: '26519000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΚΑΤΑΣΚΕΥΗΣ ΕΞΟΠΛΙΣΜΟΥ ΜΕΤΡΗΣΕΩΝ, ΕΛΕΓΧΟΥ ΚΑΙ ΠΛΟΗΓΗΣΗΣ',
  },
  {
    label: '26520000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΡΟΛΟΓΙΩΝ',
  },
  {
    label: '26521000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΡΟΛΟΓΙΩΝ ΧΕΡΙΟΥ ΚΑΙ ΤΟΙΧΟΥ, ΕΚΤΟΣ ΑΠΟ ΤΟΥΣ ΜΗΧΑΝΙΣΜΟΥΣ ΚΑΙ ΤΑ ΜΕΡΗ ΤΟΥΣ',
  },
  {
    label: '26521100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΡΟΛΟΓΙΩΝ ΧΕΡΙΟΥ, ΤΣΕΠΗΣ, ΜΕ ΘΗΚΗ ΑΠΟ ΠΟΛΥΤΙΜΟ ΜΕΤΑΛΛΟ Η ΕΠΙΜΕΤΑΛΛΩΜΕΝΗ ΜΕ ΠΟΛΥΤΙΜΟ ΜΕΤΑΛΛΟ',
  },
  {
    label: '26521200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΡΟΛΟΓΙΩΝ ΧΕΡΙΟΥ, ΤΣΕΠΗΣ ΚΑΙ ΑΛΛΩΝ ΡΟΛΟΓΙΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΧΡΟΝΟΜΕΤΡΩΝ',
  },
  {
    label: '26521300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΡΟΛΟΓΙΩΝ ΓΙΑ ΤΟΥΣ ΠΙΝΑΚΕΣ ΤΩΝ ΟΡΓΑΝΩΝ ΕΛΕΓΧΟΥ ΚΑΙ ΡΟΛΟΓΙΩΝ ΠΑΡΟΜΟΙΟΥ ΤΥΠΟΥ ΓΙΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '26521400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΙΤΡΑΠΕΖΙΩΝ ΡΟΛΟΓΙΩΝ ΜΕ ΜΗΧΑΝΙΣΜΟ ΡΟΛΟΓΙΟΥ ΧΕΡΙΟΥ· ΞΥΠΝΗΤΗΡΙΩΝ ΚΑΙ ΡΟΛΟΓΙΩΝ ΤΟΙΧΟΥ· ΑΛΛΩΝ ΡΟΛΟΓΙΩΝ',
  },
  {
    label: '26522000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΙΣΜΩΝ ΡΟΛΟΓΙΟΥ ΧΕΡΙΟΥ Η ΤΟΙΧΟΥ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '26522100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΙΣΜΩΝ ΡΟΛΟΓΙΟΥ ΧΕΡΙΟΥ, ΠΛΗΡΩΝ ΚΑΙ ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΩΝ',
  },
  {
    label: '26522200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΙΣΜΩΝ ΡΟΛΟΓΙΟΥ ΤΟΙΧΟΥ, ΠΛΗΡΩΝ ΚΑΙ ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΩΝ',
  },
  {
    label: '26522300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΗΡΩΝ ΜΗΧΑΝΙΣΜΩΝ ΡΟΛΟΓΙΟΥ ΧΕΡΙΟΥ, ΜΗ ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΩΝ Η ΕΝ ΜΕΡΕΙ ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΩΝ, ΑΤΕΛΩΝ ΜΗΧΑΝΙΣΜΩΝ ΡΟΛΟΓΙΟΥ ΧΕΡΙΟΥ, ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΩΝ',
  },
  {
    label: '26522400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΜΙΤΕΛΩΝ ΜΗΧΑΝΙΣΜΩΝ ΡΟΛΟΓΙΟΥ ΧΕΡΙΟΥ',
  },
  {
    label: '26522500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΗΡΩΝ, ΑΤΕΛΩΝ ΚΑΙ ΗΜΙΤΕΛΩΝ ΜΗΧΑΝΙΣΜΩΝ ΡΟΛΟΓΙΟΥ ΤΟΙΧΟΥ, ΜΗ ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΩΝ',
  },
  {
    label: '26522600',
    value: 'ΚΑΤΑΣΚΕΥΗ ΘΗΚΩΝ ΡΟΛΟΓΙΩΝ ΧΕΡΙΟΥ ΚΑΙ ΤΟΙΧΟΥ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '26522700',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΕΡΩΝ ΡΟΛΟΓΙΩΝ ΤΟΙΧΟΥ ΚΑΙ ΧΕΡΙΟΥ',
  },
  {
    label: '26522800',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΚΑΤΑΓΡΑΦΗΣ, ΜΕΤΡΗΣΗΣ ΧΡΟΝΟΥ, ΠΑΡΚΟΜΕΤΡΩΝ· ΧΡΟΝΟΔΙΑΚΟΠΤΩΝ ΜΕ ΜΗΧΑΝΙΣΜΟ ΡΟΛΟΓΙΟΥ ΤΟΙΧΟΥ Η ΧΕΡΙΟΥ',
  },
  {
    label: '26529000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΡΟΛΟΓΙΩΝ ΧΕΡΙΟΥ ΚΑΙ ΤΟΙΧΟΥ',
  },
  {
    label: '26600000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΚΤΙΝΟΛΟΓΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΙΑΤΡΙΚΗΣ ΚΑΙ ΘΕΡΑΠΕΥΤΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '26601000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΚΤΙΝΟΛΟΓΙΚΩΝ, ΗΛΕΚΤΡΟΪΑΤΡΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΟΘΕΡΑΠΕΥΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '26601100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΠΟΥ ΒΑΣΙΖΟΝΤΑΙ ΣΤΗ ΧΡΗΣΗ ΑΚΤΙΝΩΝ Χ Η ΑΚΤΙΝΟΒΟΛΙΩΝ Α, Β Η Γ',
  },
  {
    label: '26601200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΔΙΑΓΝΩΣΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗΝ ΙΑΤΡΙΚΗ',
  },
  {
    label: '26601300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΥΠΕΡΙΩΔΩΝ Η ΥΠΕΡΥΘΡΩΝ ΑΚΤΙΝΩΝ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗΝ ΙΑΤΡΙΚΗ, ΤΗ ΧΕΙΡΟΥΡΓΙΚΗ, ΤΗΝ ΟΔΟΝΤΙΑΤΡΙΚΗ Η ΤΗΝ ΚΤΗΝΙΑΤΡΙΚΗ',
  },
  {
    label: '26601400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΒΗΜΑΤΟΔΟΤΩΝ· ΑΚΟΥΣΤΙΚΩΝ ΒΑΡΗΚΟΪΑΣ',
  },
  {
    label: '26609000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΙΑΤΡΙΚΩΝ ΟΡΓΑΝΩΝ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΚΑΤΑΣΚΕΥΗΣ ΑΚΤΙΝΟΛΟΓΙΚΩΝ, ΗΛΕΚΤΡΟΪΑΤΡΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΟΘΕΡΑΠΕΥΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '26609100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΙΑΤΡΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '26609900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΚΤΙΝΟΛΟΓΙΚΩΝ, ΗΛΕΚΤΡΟΪΑΤΡΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΟΘΕΡΑΠΕΥΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '26700000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΠΤΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΦΩΤΟΓΡΑΦΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '26701000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΩΤΟΓΡΑΦΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΜΕΡΩΝ ΤΟΥ',
  },
  {
    label: '26701100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΤΙΚΕΙΜΕΝΙΚΩΝ ΦΑΚΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΕΣ ΜΗΧΑΝΕΣ, ΜΗΧΑΝΕΣ ΠΡΟΒΟΛΗΣ Η ΦΩΤΟΓΡΑΦΙΚΕΣ ΣΥΣΚΕΥΕΣ ΜΕΓΕΘΥΝΣΗΣ Η ΣΜΙΚΡΥΝΣΗΣ',
  },
  {
    label: '26701200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΩΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΠΡΟΕΤΟΙΜΑΣΙΑ ΕΚΤΥΠΩΤΙΚΩΝ ΠΛΑΚΩΝ Η ΚΥΛΙΝΔΡΩΝ· ΦΩΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΓΙΑ ΕΓΓΡΑΦΗ ΕΓΓΡΑΦΩΝ ΣΕ ΜΙΚΡΟΦΙΛΜ, ΜΙΚΡΟΦΩΤΟΔΕΛΤΙΑ ΚΑΙ ΠΑΡΟΜΟΙΑ',
  },
  {
    label: '26701300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΨΗΦΙΑΚΩΝ ΦΩΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '26701400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΩΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΑΜΕΣΗΣ ΕΚΤΥΠΩΣΗΣ ΚΑΙ ΕΜΦΑΝΙΣΗΣ ΚΑΙ ΑΛΛΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '26701500',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΛΗΨΗΣ',
  },
  {
    label: '26701600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΠΡΟΒΟΛΗΣ· ΕΠΙΔΙΑΣΚΟΠΙΩΝ· ΑΛΛΩΝ ΠΡΟΒΟΛΕΩΝ ΕΙΚΟΝΩΝ',
  },
  {
    label: '26701700',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΛΑΣ· ΦΩΤΟΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ ΜΕΓΕΘΥΝΣΗΣ· ΣΥΣΚΕΥΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΑ ΕΡΓΑΣΤΗΡΙΑ· ΝΕΓΚΑΤΟΣΚΟΠΙΩΝ, ΟΘΟΝΩΝ ΠΡΟΒΟΛΗΣ',
  },
  {
    label: '26701800',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΑΓΝΩΣΤΩΝ ΜΙΚΡΟΦΙΛΜ, ΜΙΚΡΟΦΩΤΟΔΕΛΤΙΩΝ Η ΑΛΛΩΝ ΜΙΚΡΟΦΟΡΜΩΝ',
  },
  {
    label: '26701900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΦΩΤΟΓΡΑΦΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '26702000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΟΠΤΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '26702100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΥΛΛΩΝ ΚΑΙ ΠΛΑΚΩΝ ΠΟΛΩΤΙΚΟΥ ΥΛΙΚΟΥ· ΦΑΚΩΝ, ΠΡΙΣΜΑΤΩΝ, ΚΑΘΡΕΠΤΩΝ ΚΑΙ ΑΛΛΩΝ ΣΤΟΙΧΕΙΩΝ ΟΠΤΙΚΗΣ (ΕΚΤΟΣ ΣΤΟΙΧΕΙΩΝ ΑΠΟ ΓΥΑΛΙ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΚΑΤΕΡΓΑΣΜΕΝΑ ΟΠΤΙΚΑ), ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΩΝ Η ΜΗ, ΕΚΤΟΣ ΣΥΣΚΕΥΩΝ ΛΗΨΗΣ ΕΙΚΟΝΩΝ, ΠΡΟΒΟΛΕΩΝ Η ΦΩΤΟΓΡΑΦΙΚ',
  },
  {
    label: '26702200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΑΛΙΩΝ, ΜΟΝΟΚΙΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΟΠΤΙΚΩΝ ΤΗΛΕΣΚΟΠΙΩΝ· ΑΛΛΩΝ ΑΣΤΡΟΝΟΜΙΚΩΝ ΟΡΓΑΝΩΝ· ΟΠΤΙΚΩΝ ΜΙΚΡΟΣΚΟΠΙΩΝ',
  },
  {
    label: '26702300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΥΓΡΩΝ ΚΡΥΣΤΑΛΛΩΝ· ΛΕΙΖΕΡ, ΕΚΤΟΣ ΤΩΝ ΔΙΟΔΩΝ ΛΕΙΖΕΡ· ΑΛΛΩΝ ΟΠΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΚΑΙ ΟΡΓΑΝΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '26702400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΚΙΑΛΙΩΝ, ΜΟΝΟΚΙΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΟΠΤΙΚΩΝ ΤΗΛΕΣΚΟΠΙΩΝ· ΑΛΛΩΝ ΑΣΤΡΟΝΟΜΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΟΠΤΙΚΩΝ ΜΙΚΡΟΣΚΟΠΙΩΝ',
  },
  {
    label: '26702500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΥΣΚΕΥΩΝ ΜΕ ΥΓΡΟΥΣ ΚΡΥΣΤΑΛΛΟΥΣ, ΛΕΙΖΕΡ (ΕΚΤΟΣ ΤΩΝ ΔΙΟΔΩΝ ΛΕΙΖΕΡ), ΑΛΛΩΝ ΟΠΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΚΑΙ ΟΡΓΑΝΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '26709000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΚΑΤΑΣΚΕΥΗΣ ΟΠΤΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΦΩΤΟΓΡΑΦΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '26800000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΑΓΝΗΤΙΚΩΝ ΚΑΙ ΟΠΤΙΚΩΝ ΜΕΣΩΝ',
  },
  {
    label: '26801100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΑΓΝΗΤΙΚΩΝ ΜΕΣΩΝ, ΜΗ ΕΓΓΕΓΡΑΜΜΕΝΩΝ, ΕΚΤΟΣ ΤΩΝ ΚΑΡΤΩΝ ΜΕ ΜΑΓΝΗΤΙΚΗ ΤΑΙΝΙΑ',
  },
  {
    label: '26801200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΠΤΙΚΩΝ ΜΕΣΩΝ, ΜΗ ΕΓΓΕΓΡΑΜΜΕΝΩΝ',
  },
  {
    label: '26801300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΕΣΩΝ ΕΓΓΡΑΦΗΣ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΜΗΤΡΩΝ ΚΑΙ ΤΩΝ ΓΑΛΒΑΝΙΣΜΕΝΩΝ ΕΚΜΑΓΕΙΩΝ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΔΙΣΚΩΝ',
  },
  {
    label: '26801400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΑΡΤΩΝ ΜΕ ΜΑΓΝΗΤΙΚΗ ΤΑΙΝΙΑ',
  },
  {
    label: '26809000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΑΓΝΗΤΙΚΩΝ ΚΑΙ ΟΠΤΙΚΩΝ ΜΕΣΩΝ',
  },
  {
    label: '27110000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΚΙΝΗΤΗΡΩΝ, ΗΛΕΚΤΡΟΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ',
  },
  {
    label: '27111000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΙΣΧΥΟΣ <= 37 ;0,5; W· ΑΛΛΩΝ ΚΙΝΗΤΗΡΩΝ ΣΥΝΕΧΟΥΣ ΡΕΥΜΑΤΟΣ· ΓΕΝΝΗΤΡΙΩΝ ΣΥΝΕΧΟΥΣ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '27112000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ/ΣΥΝΕΧΟΥΣ ΡΕΥΜΑΤΟΣ ΓΕΝΙΚΗΣ ΧΡΗΣΗΣ, ΙΣΧΥΟΣ > 37 ;0,5; W· ΑΛΛΩΝ ΚΙΝΗΤΗΡΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ ΡΕΥΜΑΤΟΣ· ΓΕΝΝΗΤΡΙΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ ΡΕΥΜΑΤΟΣ (ΕΝΑΛΛΑΚΤΩΝ)',
  },
  {
    label: '27112100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ/ΣΥΝΕΧΟΥΣ ΡΕΥΜΑΤΟΣ ΓΕΝΙΚΗΣ ΧΡΗΣΗΣ, ΙΣΧΥΟΣ > 37 ;0,5; W',
  },
  {
    label: '27112200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ ΡΕΥΜΑΤΟΣ, ΜΟΝΟΦΑΣΙΚΩΝ',
  },
  {
    label: '27112300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ ΡΕΥΜΑΤΟΣ, ΠΟΛΥΦΑΣΙΚΩΝ, ΙΣΧΥΟΣ <= 750 ~ W',
  },
  {
    label: '27112400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ ΡΕΥΜΑΤΟΣ, ΠΟΛΥΦΑΣΙΚΩΝ, ΙΣΧΥΟΣ > 750 ~ W ΑΛΛΑ <= 75 ~ KW',
  },
  {
    label: '27112500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ ΡΕΥΜΑΤΟΣ, ΠΟΛΥΦΑΣΙΚΩΝ, ΙΣΧΥΟΣ > 75 ~ KW',
  },
  {
    label: '27112600',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΕΝΝΗΤΡΙΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ ΡΕΥΜΑΤΟΣ (ΕΝΑΛΛΑΚΤΩΝ)',
  },
  {
    label: '27113000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΠΑΡΑΓΩΓΩΝ ΖΕΥΓΩΝ ΚΑΙ ΠΕΡΙΣΤΡΟΦΙΚΩΝ ΜΕΤΑΛΛΑΚΤΩΝ',
  },
  {
    label: '27113100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΖΕΥΓΩΝ ΓΕΝΝΗΤΡΙΑΣ ΜΕ ΕΜΒΟΛΟΦΟΡΟΥΣ ΚΙΝΗΤΗΡΕΣ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΥΜΠΙΕΣΗ',
  },
  {
    label: '27113200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΖΕΥΓΩΝ ΓΕΝΝΗΤΡΙΑΣ ΜΕ ΚΙΝΗΤΗΡΕΣ, ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ· ΑΛΛΩΝ ΖΕΥΓΩΝ ΓΕΝΝΗΤΡΙΑΣ· ΗΛΕΚΤΡΙΚΩΝ ΠΕΡΙΣΤΡΟΦΙΚΩΝ ΜΕΤΑΛΛΑΚΤΩΝ',
  },
  {
    label: '27114000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ',
  },
  {
    label: '27114100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΥΓΡΩΝ ΔΙΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ',
  },
  {
    label: '27114200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ, ΜΕ ΙΚΑΝΟΤΗΤΑ ΜΕΤΑΣΧΗΜΑΤΙΣΜΟΥ ΡΕΥΜΑΤΟΣ <= 16 ~ KVA',
  },
  {
    label: '27114300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ, ΜΕ ΙΚΑΝΟΤΗΤΑ ΜΕΤΑΣΧΗΜΑΤΙΣΜΟΥ ΡΕΥΜΑΤΟΣ > 16 ~ KVA',
  },
  {
    label: '27115000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΤΑΘΕΡΟΠΟΙΗΤΩΝ ΡΕΥΜΑΤΟΣ ΓΙΑ ΛΑΜΠΤΗΡΕΣ Η ΣΩΛΗΝΕΣ ΕΚΚΕΝΩΣΗΣ· ΣΤΑΤΙΚΩΝ ΜΕΤΑΛΛΑΚΤΩΝ· ΑΛΛΩΝ ΕΠΑΓΩΓΕΩΝ',
  },
  {
    label: '27116000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΟΚΙΝΗΤΗΡΩΝ, ΗΛΕΚΤΡΟΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ',
  },
  {
    label: '27116100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΗΛΕΚΤΡΟΚΙΝΗΤΗΡΕΣ ΚΑΙ ΗΛΕΚΤΡΟΓΕΝΝΗΤΡΙΕΣ',
  },
  {
    label: '27116200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ, ΕΠΑΓΩΓΕΩΝ ΚΑΙ ΣΤΑΤΙΚΩΝ ΜΕΤΑΛΛΑΚΤΩΝ',
  },
  {
    label: '27119000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΗΛΕΚΤΡΟΚΙΝΗΤΗΡΩΝ, ΗΛΕΚΤΡΟΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ',
  },
  {
    label: '27120000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΔΙΑΝΟΜΗΣ ΚΑΙ ΕΛΕΓΧΟΥ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '27121000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗ ΔΙΑΚΟΠΗ Η ΤΗΝ ΠΡΟΣΤΑΣΙΑ ΗΛΕΚΤΡΙΚΩΝ ΚΥΚΛΩΜΑΤΩΝ, ΓΙΑ ΤΑΣΗ > 1 ;.000 ~ V',
  },
  {
    label: '27122000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗ ΔΙΑΚΟΠΗ Η ΤΗΝ ΠΡΟΣΤΑΣΙΑ ΗΛΕΚΤΡΙΚΩΝ ΚΥΚΛΩΜΑΤΩΝ, ΓΙΑ ΤΑΣΗ <= 1 ;.000 ~ V',
  },
  {
    label: '27122100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΣΦΑΛΕΙΩΝ, ΓΙΑ ΤΑΣΗ <= 1 ;.000 ~ V',
  },
  {
    label: '27122200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΜΑΤΩΝ ΔΙΑΚΟΠΤΩΝ ΚΥΚΛΩΜΑΤΟΣ, ΓΙΑ ΤΑΣΗ <= 1 ;.000 ~ V',
  },
  {
    label: '27122300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗΝ ΠΡΟΣΤΑΣΙΑ ΗΛΕΚΤΡΙΚΩΝ ΚΥΚΛΩΜΑΤΩΝ Π.Δ.Κ.Α., ΓΙΑ ΤΑΣΗ <= 1 ;.000 ~ V',
  },
  {
    label: '27122400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΝΟΜΩΝ, ΓΙΑ ΤΑΣΗ <= 1 ;.000 ~ V',
  },
  {
    label: '27123000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΠΙΝΑΚΩΝ',
  },
  {
    label: '27123100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΙΝΑΚΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΤΑΞΕΩΝ, ΕΞΟΠΛΙΣΜΕΝΩΝ ΜΕ ΗΛΕΚΤΡΙΚΟΥΣ ΔΙΑΚΟΠΤΕΣ Η ΜΕ ΣΥΣΚΕΥΕΣ ΠΡΟΣΤΑΣΙΑΣ, ΓΙΑ ΤΑΣΗ <= 1 ;.000 ~ V',
  },
  {
    label: '27123200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΙΝΑΚΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΤΑΞΕΩΝ, ΕΞΟΠΛΙΣΜΕΝΩΝ ΜΕ ΗΛΕΚΤΡΙΚΟΥΣ ΔΙΑΚΟΠΤΕΣ Η ΜΕ ΣΥΣΚΕΥΕΣ ΠΡΟΣΤΑΣΙΑΣ, ΓΙΑ ΤΑΣΗ > 1 ;.000 ~ V',
  },
  {
    label: '27124000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΣΥΣΚΕΥΩΝ ΔΙΑΝΟΜΗΣ Η ΕΛΕΓΧΟΥ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '27129000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΣΥΣΚΕΥΩΝ ΔΙΑΝΟΜΗΣ ΚΑΙ ΕΛΕΓΧΟΥ ΤΟΥ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '27200000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΣΤΗΛΩΝ ΚΑΙ ΣΥΣΣΩΡΕΥΤΩΝ',
  },
  {
    label: '27201000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΡΩΤΟΓΕΝΩΝ ΣΤΟΙΧΕΙΩΝ ΚΑΙ ΠΡΩΤΟΓΕΝΩΝ ΣΥΣΤΟΙΧΙΩΝ (ΗΛΕΚΤΡΙΚΩΝ ΣΤΗΛΩΝ) ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '27201100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ (ΗΛΕΚΤΡΙΚΩΝ ΣΤΗΛΩΝ)ΣΥΣΤΟΙΧΙΩΝ',
  },
  {
    label: '27201200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΤΟΙΧΙΩΝ (ΗΛΕΚΤΡΙΚΩΝ ΣΤΗΛΩΝ)',
  },
  {
    label: '27202000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΣΩΡΕΥΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '27202100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΣΩΡΕΥΤΩΝ ΜΟΛΥΒΔΟΥ;ΟΞΕΟΣ ΓΙΑ ΕΜΒΟΛΟΦΟΡΟΥΣ ΚΙΝΗΤΗΡΕΣ ΕΚΚΙΝΗΣΗΣ',
  },
  {
    label: '27202200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΣΩΡΕΥΤΩΝ ΜΟΛΥΒΔΟΥ;ΟΞΕΟΣ, ΕΚΤΟΣ ΤΩΝ ΕΜΒΟΛΟΦΟΡΩΝ ΚΙΝΗΤΗΡΩΝ ΕΚΚΙΝΗΣΗΣ',
  },
  {
    label: '27202300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΣΩΡΕΥΤΩΝ ΝΙΚΕΛΙΟΥ;ΚΑΔΜΙΟΥ, ΝΙΚΕΛΙΟΥ;ΥΔΡΟΓΟΝΩΜΕΝΟΥ ΜΕΤΑΛΛΟΥ, ΙΟΝΤΩΝ ΛΙΘΙΟΥ, ΠΟΛΥΜΕΡΟΥΣ ΛΙΘΙΟΥ ΚΑΙ ΝΙΚΕΛΙΟΥ;ΣΙΔΗΡΟΥ ΚΑΙ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΣΩΡΕΥΤΩΝ',
  },
  {
    label: '27202400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΣΩΡΕΥΤΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΔΙΑΧΩΡΙΣΤΩΝ',
  },
  {
    label: '27209000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΣΥΣΤΟΙΧΙΩΝ (ΗΛΕΚΤΡΙΚΩΝ ΣΤΗΛΩΝ) ΚΑΙ ΣΥΣΣΩΡΕΥΤΩΝ',
  },
  {
    label: '27310000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΑΛΩΔΙΩΝ ΟΠΤΙΚΩΝ ΙΝΩΝ',
  },
  {
    label: '27311100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΛΩΔΙΩΝ ΟΠΤΙΚΩΝ ΙΝΩΝ ΠΟΥ ΑΠΟΤΕΛΟΥΝΤΑΙ ΑΠΟ ΙΝΕΣ ΚΑΘΕ ΜΙΑ ΑΠΟ ΤΙΣ ΟΠΟΙΕΣ ΕΧΕΙ ΜΟΝΩΘΕΙ ΕΞΩΤΕΡΙΚΑ ΧΩΡΙΣΤΑ',
  },
  {
    label: '27311200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΠΤΙΚΩΝ ΙΝΩΝ ΚΑΙ ΔΕΣΜΩΝ ΟΠΤΙΚΩΝ ΙΝΩΝ· ΚΑΛΩΔΙΩΝ ΟΠΤΙΚΩΝ ΙΝΩΝ (ΕΚΤΟΣ ΤΩΝ ΚΑΛΩΔΙΩΝ ΠΟΥ ΑΠΟΤΕΛΟΥΝΤΑΙ ΑΠΟ ΙΝΕΣ ΚΑΘΕ ΜΙΑ ΑΠΟ ΤΙΣ ΟΠΟΙΕΣ ΕΧΕΙ ΜΟΝΩΘΕΙ ΕΞΩΤΕΡΙΚΑ ΧΩΡΙΣΤΑ)',
  },
  {
    label: '27319000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΚΑΛΩΔΙΩΝ ΟΠΤΙΚΩΝ ΙΝΩΝ',
  },
  {
    label: '27320000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΣΥΡΜΑΤΩΝ ΚΑΙ ΚΑΛΩΔΙΩΝ',
  },
  {
    label: '27321000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΚΑΛΩΔΙΩΝ ΚΑΙ ΣΥΡΜΑΤΩΝ',
  },
  {
    label: '27321100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΟΝΩΜΕΝΩΝ ΣΥΡΜΑΤΩΝ ΠΕΡΙΕΛΙΞΕΩΝ',
  },
  {
    label: '27321200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΜΟΑΞΟΝΙΚΩΝ ΚΑΛΩΔΙΩΝ ΚΑΙ ΑΛΛΩΝ ΟΜΟΑΞΟΝΙΚΩΝ ΗΛΕΚΤΡΙΚΩΝ ΑΓΩΓΩΝ',
  },
  {
    label: '27321300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΑΓΩΓΩΝ, ΓΙΑ ΤΑΣΗ <= 1 ;.000 ~ V',
  },
  {
    label: '27321301',
    value: 'ΠΑΡΑΓΩΓΗ ΜΟΝΩΜΕΝΩΝ ΚΑΛΩΔΙΩΝ, ΓΙΑ ΤΑΣΗ <= 1 ;.000 ~ V',
  },
  {
    label: '27321400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΑΓΩΓΩΝ, ΓΙΑ ΤΑΣΗ > 1 ;.000 ~ V',
  },
  {
    label: '27321401',
    value: 'ΠΑΡΑΓΩΓΗ ΜΟΝΩΜΕΝΩΝ ΚΑΛΩΔΙΩΝ, ΓΙΑ ΤΑΣΗ > 1 ;.000 ~ V',
  },
  {
    label: '27329000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΚΑΛΩΔΙΩΝ ΚΑΙ ΣΥΡΜΑΤΩΝ',
  },
  {
    label: '27330000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΞΑΡΤΗΜΑΤΩΝ ΚΑΛΩΔΙΩΣΗΣ',
  },
  {
    label: '27331000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΚΑΛΩΔΙΩΣΗΣ',
  },
  {
    label: '27331100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΙΑΚΟΠΤΩΝ, ΓΙΑ ΤΑΣΗ <= 1 ;.000 ~ V',
  },
  {
    label: '27331200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΛΥΧΝΙΟΛΑΒΩΝ, ΓΙΑ ΤΑΣΗ <= 1 ;.000 ~ V',
  },
  {
    label: '27331300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΥΣΜΑΤΩΝ, ΠΡΙΖΩΝ ΚΑΙ ΑΛΛΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗ ΔΙΑΚΟΠΗ Η ΤΗΝ ΠΡΟΣΤΑΣΙΑ ΗΛΕΚΤΡΙΚΩΝ ΚΥΚΛΩΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '27331400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΜΟΝΩΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '27339000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΣΥΣΚΕΥΩΝ ΚΑΛΩΔΙΩΣΗΣ',
  },
  {
    label: '27400000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΦΩΤΙΣΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '27401000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ Η ΕΚΚΕΝΩΣΗΣ· ΛΑΜΠΤΗΡΩΝ ΤΟΞΟΥ',
  },
  {
    label: '27401100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΦΡΑΓΙΣΜΕΝΩΝ ΠΡΟΒΟΛΕΩΝ',
  },
  {
    label: '27401200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ ΒΟΛΦΡΑΜΙΟΥ;ΑΛΟΓΟΝΟΥ, ΕΚΤΟΣ ΤΩΝ ΥΠΕΡΙΩΔΩΝ Η ΥΠΕΡΥΘΡΩΝ ΛΑΜΠΤΗΡΩΝ',
  },
  {
    label: '27401300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ ΙΣΧΥΟΣ <= 200 ~ W ΚΑΙ ΤΑΣΗΣ > 100 ~ V Π.Δ.Κ.Α.',
  },
  {
    label: '27401400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '27401500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΛΑΜΠΤΗΡΩΝ ΕΚΚΕΝΩΣΗΣ· ΥΠΕΡΙΩΔΩΝ Η ΥΠΕΡΥΘΡΩΝ ΛΑΜΠΤΗΡΩΝ· ΛΑΜΠΤΗΡΩΝ ΤΟΞΟΥ',
  },
  {
    label: '27402000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΛΑΜΠΤΗΡΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '27402100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΟΡΗΤΩΝ ΗΛΕΚΤΡΙΚΩΝ ΛΑΜΠΤΗΡΩΝ ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΞΗΡΕΣ ΣΤΗΛΕΣ, ΣΥΣΣΩΡΕΥΤΕΣ, ΜΑΓΝΗΤΟΗΛΕΚΤΡΙΚΕΣ ΣΥΣΚΕΥΕΣ',
  },
  {
    label: '27402200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΛΑΜΠΤΗΡΩΝ ΤΡΑΠΕΖΙΟΥ, ΓΡΑΦΕΙΟΥ, ΚΟΜΟΔΙΝΟΥ Η ΛΥΧΝΟΣΤΑΤΩΝ',
  },
  {
    label: '27402300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΛΑΜΠΤΗΡΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '27402400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΩΤΕΙΝΩΝ ΠΙΝΑΚΙΔΩΝ, ΦΩΤΕΙΝΩΝ ΕΠΙΓΡΑΦΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '27402500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΟΛΥΕΛΑΙΩΝ ΚΑΙ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΟΡΟΦΗΣ Η ΤΟΙΧΟΥ',
  },
  {
    label: '27403000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΛΑΜΠΤΗΡΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '27403100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΩΤΟΓΡΑΦΙΚΩΝ ΛΥΧΝΙΩΝ ΦΛΑΣ, \\ΚΥΒΩΝ\\ ΦΛΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '27403200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΩΤΙΣΤΙΚΩΝ ΔΙΑΤΑΞΕΩΝ, ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΑ ΧΡΙΣΤΟΥΓΕΝΝΙΑΤΙΚΑ ΔΕΝΤΡΑ ΚΑΙ ΠΑΡΟΜΟΙΟΥΣ ΣΤΟΛΙΣΜΟΥΣ',
  },
  {
    label: '27403300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΡΟΒΟΛΕΩΝ ΚΑΙ ΣΠΟΤ',
  },
  {
    label: '27403900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΛΑΜΠΤΗΡΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '27404000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΛΑΜΠΤΗΡΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '27404100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ Η ΕΚΚΕΝΩΣΗΣ',
  },
  {
    label: '27404200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΛΛΩΝ ΛΑΜΠΤΗΡΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '27409000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΦΩΤΙΣΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '27510000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '27511000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΨΥΓΕΙΩΝ ΚΑΙ ΚΑΤΑΨΥΚΤΩΝ· ΠΛΥΝΤΗΡΙΩΝ· ΗΛΕΚΤΡΙΚΩΝ ΚΟΥΒΕΡΤΩΝ· ΑΝΕΜΙΣΤΗΡΩΝ',
  },
  {
    label: '27511100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΨΥΓΕΙΩΝ ΚΑΙ ΚΑΤΑΨΥΚΤΩΝ, ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '27511200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΥΝΤΗΡΙΩΝ ΠΙΑΤΩΝ, ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '27511300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΥΝΤΗΡΙΩΝ ΡΟΥΧΩΝ ΚΑΙ ΣΤΕΓΝΩΤΗΡΙΩΝ ΡΟΥΧΩΝ, ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '27511400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΚΟΥΒΕΡΤΩΝ',
  },
  {
    label: '27511500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΕΜΙΣΤΗΡΩΝ ΚΑΙ ΑΠΟΡΡΟΦΗΤΗΡΩΝ ΕΞΑΓΩΓΗΣ Η ΑΝΑΚΥΚΛΩΣΗΣ ΤΟΥ ΑΕΡΑ, ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '27512000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '27512100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΜΗΧΑΝΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ, ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΟ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '27512200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΡΙΣΤΙΚΩΝ, ΑΠΟΤΡΙΧΩΤΙΚΩΝ ΚΑΙ ΚΟΥΡΕΥΤΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΟ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '27512300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΘΕΡΜΙΚΩΝ ΣΥΣΚΕΥΩΝ ΚΟΜΜΩΤΙΚΗΣ Η ΣΤΕΓΝΩΤΗΡΩΝ ΧΕΡΙΩΝ· ΗΛΕΚΤΡΙΚΩΝ ΣΙΔΕΡΩΝ',
  },
  {
    label: '27512400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΗΛΕΚΤΡΟΘΕΡΜΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '27512401',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΙΑΚΩΝ ΘΕΡΜΟΣΙΦΩΝΩΝ, ΗΛΕΚΤΡΙΚΩΝ',
  },
  {
    label: '27512500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΘΕΡΜΑΝΤΗΡΩΝ ΝΕΡΟΥ, ΣΤΙΓΜΙΑΙΩΝ Η ΘΕΡΜΟΣΥΣΣΩΡΕΥΣΗΣ ΚΑΙ ΘΕΡΜΑΝΤΗΡΩΝ ΕΜΒΑΠΤΙΣΗΣ',
  },
  {
    label: '27512600',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΘΕΡΜΑΝΣΗΣ ΚΛΕΙΣΤΩΝ ΧΩΡΩΝ ΚΑΙ ΕΔΑΦΟΥΣ',
  },
  {
    label: '27512700',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΟΥΡΝΩΝ ΜΙΚΡΟΚΥΜΑΤΩΝ',
  },
  {
    label: '27512800',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΦΟΥΡΝΩΝ· ΚΟΥΖΙΝΩΝ, ΠΛΑΚΩΝ (ΜΑΤΙΩΝ) ΜΑΓΕΙΡΕΜΑΤΟΣ, ΚΑΜΙΝΕΤΩΝ· ΣΧΑΡΩΝ ΜΑΓΕΙΡΕΜΑΤΟΣ, ΨΗΣΤΙΕΡΩΝ, ΗΛΕΚΤΡΙΚΩΝ',
  },
  {
    label: '27512900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΘΕΡΜΑΝΤΙΚΩΝ ΑΝΤΙΣΤΑΣΕΩΝ',
  },
  {
    label: '27513000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '27519000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '27520000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '27521000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΙΚΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΜΑΓΕΙΡΕΜΑΤΟΣ ΚΑΙ ΘΕΡΜΑΝΣΗΣ, ΜΗ ΗΛΕΚΤΡΙΚΟΥ',
  },
  {
    label: '27521100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΜΑΓΕΙΡΕΜΑ ΚΑΙ ΖΕΣΤΑΜΑ ΦΑΓΗΤΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ Η ΑΠΟ ΧΑΛΚΟ, ΜΗ ΗΛΕΚΤΡΙΚΩΝ',
  },
  {
    label: '27521200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ, ΓΙΑ ΑΕΡΙΑ ΚΑΥΣΙΜΑ Η ΓΙΑ ΑΕΡΙΑ ΚΑΙ ΓΙΑ ΑΛΛΑ ΚΑΥΣΙΜΑ, ΓΙΑ ΥΓΡΑ ΚΑΥΣΙΜΑ Η ΓΙΑ ΣΤΕΡΕΑ ΚΑΥΣΙΜΑ',
  },
  {
    label: '27521201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ ΥΓΡΑΕΡΙΟΥ',
  },
  {
    label: '27521300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΘΕΡΜΑΝΤΗΡΩΝ ΑΕΡΑ Η ΔΙΑΝΕΜΗΤΩΝ ΘΕΡΜΟΥ ΑΕΡΑ Π.Δ.Κ.Α., ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΜΗ ΗΛΕΚΤΡΙΚΩΝ',
  },
  {
    label: '27521301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΘΕΡΜΑΣΤΡΩΝ ΠΕΤΡΕΛΑΙΟΥ',
  },
  {
    label: '27521302',
    value: 'ΚΑΤΑΣΚΕΥΗ ΘΕΡΜΑΣΤΡΩΝ ΣΤΕΡΕΩΝ Η ΥΓΡΩΝ ΚΑΥΣΙΜΩΝ',
  },
  {
    label: '27521400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΘΕΡΜΑΝΤΗΡΩΝ ΝΕΡΟΥ, ΣΤΙΓΜΙΑΙΩΝ Η ΘΕΡΜΟΣΥΣΣΩΡΕΥΣΗΣ, ΜΗ ΗΛΕΚΤΡΙΚΩΝ',
  },
  {
    label: '27521401',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΙΑΚΩΝ ΘΕΡΜΟΣΙΦΩΝΩΝ, ΜΗ ΗΛΕΚΤΡΙΚΩΝ',
  },
  {
    label: '27522000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΘΕΡΜΑΣΤΡΩΝ, ΚΟΥΖΙΝΩΝ, ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΟ ΖΕΣΤΑΜΑ ΦΑΓΗΤΩΝ ΚΑΙ ΜΕΡΩΝ ΠΑΡΟΜΟΙΩΝ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '27529000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ',
  },
  {
    label: '27900000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '27901000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΜΕΡΩΝ ΤΟΥ',
  },
  {
    label: '27901100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΟΥ ΕΧΟΥΝ ΧΩΡΙΣΤΕΣ ΛΕΙΤΟΥΡΓΙΕΣ',
  },
  {
    label: '27901200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΜΟΝΩΤΗΡΩΝ· ΜΟΝΩΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΗΛΕΚΤΡΙΚΕΣ ΜΗΧΑΝΕΣ Η ΕΞΟΠΛΙΣΜΟ· ΑΓΩΓΩΝ ΗΛΕΚΤΡΙΚΩΝ ΚΑΛΩΔΙΩΝ',
  },
  {
    label: '27901300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΔΙΩΝ ΑΝΘΡΑΚΑ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΓΡΑΦΙΤΗ Η ΑΛΛΟ ΑΝΘΡΑΚΑ ΓΙΑ ΗΛΕΚΤΡΟΛΟΓΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '27902000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΝΔΕΙΚΤΙΚΩΝ ΟΘΟΝΩΝ ΥΓΡΟΥ ΚΡΥΣΤΑΛΛΟΥ Η ΔΙΟΔΟΥ ΕΚΠΟΜΠΗΣ ΦΩΤΟΣ· ΗΛΕΚΤΡΙΚΩΝ ΜΟΝΑΔΩΝ ΑΚΟΥΣΤΙΚΗΣ Η ΟΠΤΙΚΗΣ ΠΡΟΕΙΔΟΠΟΙΗΣΗΣ',
  },
  {
    label: '27903000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΩΝ ΓΙΑ ΜΑΛΑΚΗ ΣΥΓΚΟΛΛΗΣΗ, ΣΚΛΗΡΗ ΣΥΓΚΟΛΛΗΣΗ ΚΑΙ ΘΕΡΜΟΣΥΓΚΟΛΛΗΣΗ ΜΕ ΗΛΕΚΤΡΙΚΟ ΡΕΥΜΑ ΚΑΙ ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΕΠΙΦΑΝΕΙΑΚΗ ΒΑΦΗ ΚΑΙ ΘΕΡΜΟ ΨΕΚΑΣΜΟ',
  },
  {
    label: '27903100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΜΑΛΑΚΗ ΣΥΓΚΟΛΛΗΣΗ, ΣΚΛΗΡΗ ΣΥΓΚΟΛΛΗΣΗ Η ΘΕΡΜΟΣΥΓΚΟΛΛΗΣΗ· ΗΛΕΚΤΡΙΚΩΝ ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΘΕΡΜΟ ΨΕΚΑΣΜΟ ΜΕΤΑΛΛΩΝ Η ΣΥΜΠΥΚΝΩΜΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΚΑΡΒΙΔΙΩΝ',
  },
  {
    label: '27903200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΜΑΛΑΚΗ ΣΥΓΚΟΛΛΗΣΗ, ΣΚΛΗΡΗ ΣΥΓΚΟΛΛΗΣΗ Η ΘΕΡΜΟΣΥΓΚΟΛΛΗΣΗ· ΗΛΕΚΤΡΙΚΩΝ ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΘΕΡΜΟ ΨΕΚΑΣΜΟ ΜΕΤΑΛΛΩΝ Η ΣΥΜΠΥΚΝΩΜΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΚΑΡΒΙΔΙΩΝ',
  },
  {
    label: '27903300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ· ΗΛΕΚΤΡΙΚΩΝ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Η ΣΥΣΚΕΥΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '27904000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α. (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΗΛΕΚΤΡΟΜΑΓΝΗΤΩΝ· ΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΣΥΖΕΥΞΕΩΝ ΚΑΙ ΦΡΕΝΩΝ· ΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΑΝΥΨΩΤΙΚΩΝ ΚΕΦΑΛΩΝ· ΗΛΕΚΤΡΙΚΩΝ ΕΠΙΤΑΧΥΝΤΩΝ ΣΩΜΑΤΙΔΙΩΝ· ΗΛΕΚΤΡΙΚΩΝ ΓΕΝΝΗΤΡΙΩΝ ΣΗΜΑΤΩΝ)',
  },
  {
    label: '27905000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΠΥΚΝΩΤΩΝ',
  },
  {
    label: '27905100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΤΑΘΕΡΩΝ ΠΥΚΝΩΤΩΝ ΓΙΑ ΚΥΚΛΩΜΑΤΑ ΤΩΝ 50 ;/60 ; HZ ΜΕ ΔΙΕΚΠΕΡΑΙΩΤΙΚΗ ΙΚΑΝΟΤΗΤΑ ΑΕΡΓΟΥ ΙΣΧΥΟΣ >= 0 ;0,5; KVAR',
  },
  {
    label: '27905200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΣΤΑΘΕΡΩΝ ΠΥΚΝΩΤΩΝ',
  },
  {
    label: '27905300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΒΛΗΤΩΝ Η ΡΥΘΜΙΖΟΜΕΝΩΝ (ΑΥΤΟΜΑΤΩΝ) ΠΥΚΝΩΤΩΝ',
  },
  {
    label: '27906000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΩΝ ΑΝΤΙΣΤΑΣΕΩΝ, ΕΚΤΟΣ ΤΩΝ ΘΕΡΜΑΝΤΙΚΩΝ ΑΝΤΙΣΤΑΣΕΩΝ',
  },
  {
    label: '27907000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΣΗΜΑΤΟΔΟΤΗΣΗΣ, ΑΣΦΑΛΕΙΑΣ Η ΕΛΕΓΧΟΥ ΤΗΣ ΚΥΚΛΟΦΟΡΙΑΣ ΓΙΑ ΣΙΔΗΡΟΔΡΟΜΟΥΣ, ΤΡΟΧΙΟΔΡΟΜΟΥΣ, ΔΡΟΜΟΥΣ, ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ, ΧΩΡΟΥΣ ΣΤΑΘΜΕΥΣΗΣ, ΕΓΚΑΤΑΣΤΑΣΕΙΣ ΛΙΜΕΝΩΝ Η ΑΕΡΟΛΙΜΕΝΩΝ',
  },
  {
    label: '27908000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΠΥΚΝΩΤΩΝ, ΑΝΤΙΣΤΑΣΕΩΝ, ΡΟΟΣΤΑΤΩΝ ΚΑΙ ΠΟΤΕΝΣΙΟΜΕΤΡΩΝ',
  },
  {
    label: '27908100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΠΥΚΝΩΤΩΝ',
  },
  {
    label: '27908200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΑΝΤΙΣΤΑΣΕΩΝ, ΡΟΟΣΤΑΤΩΝ ΚΑΙ ΠΟΤΕΝΣΙΟΜΕΤΡΩΝ',
  },
  {
    label: '27909000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '28110000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΚΑΙ ΣΤΡΟΒΙΛΩΝ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΟΥΣ ΚΙΝΗΤΗΡΕΣ ΑΕΡΟΣΚΑΦΩΝ, ΟΧΗΜΑΤΩΝ ΚΑΙ ΔΙΚΥΚΛΩΝ',
  },
  {
    label: '28111000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΟΥΣ ΚΙΝΗΤΗΡΕΣ ΑΕΡΟΣΚΑΦΩΝ, ΟΧΗΜΑΤΩΝ ΚΑΙ ΔΙΚΥΚΛΩΝ',
  },
  {
    label: '28111100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΞΩΛΕΜΒΙΩΝ ΚΙΝΗΤΗΡΩΝ ΓΙΑ ΘΑΛΑΣΣΙΑ ΠΡΟΩΘΗΣΗ',
  },
  {
    label: '28111200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΓΙΑ ΘΑΛΑΣΣΙΑ ΠΡΟΩΘΗΣΗ, ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΗΛΕΚΤΡΙΚΟ ΣΠΙΝΘΗΡΑ· ΑΛΛΩΝ ΚΙΝΗΤΗΡΩΝ',
  },
  {
    label: '28111300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΜΒΟΛΟΦΟΡΩΝ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΥΜΠΙΕΣΗ',
  },
  {
    label: '28112000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΤΡΟΒΙΛΩΝ',
  },
  {
    label: '28112100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΤΜΟΣΤΡΟΒΙΛΩΝ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '28112200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΥΔΡΑΥΛΙΚΩΝ ΣΤΡΟΒΙΛΩΝ ΚΑΙ ΥΔΡΑΥΛΙΚΩΝ ΤΡΟΧΩΝ',
  },
  {
    label: '28112300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΕΡΙΟΣΤΡΟΒΙΛΩΝ, ΕΚΤΟΣ ΤΩΝ ΣΤΡΟΒΙΛΟΚΙΝΗΤΗΡΩΝ ΚΑΙ ΤΩΝ ΕΛΙΚΟΣΤΡΟΒΙΛΟΚΙΝΗΤΗΡΩΝ',
  },
  {
    label: '28112400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΝΕΜΟΓΕΝΝΗΤΡΙΩΝ',
  },
  {
    label: '28113000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΣΤΡΟΒΙΛΩΝ',
  },
  {
    label: '28113100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΤΜΟΣΤΡΟΒΙΛΩΝ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '28113200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΥΔΡΑΥΛΙΚΩΝ ΣΤΡΟΒΙΛΩΝ, ΥΔΡΑΥΛΙΚΩΝ ΤΡΟΧΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΡΥΘΜΙΣΤΩΝ',
  },
  {
    label: '28113300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΕΡΙΟΣΤΡΟΒΙΛΩΝ, ΕΚΤΟΣ ΤΩΝ ΣΤΡΟΒΙΛΟΚΙΝΗΤΗΡΩΝ ΚΑΙ ΤΩΝ ΕΛΙΚΟΣΤΡΟΒΙΛΟΚΙΝΗΤΗΡΩΝ',
  },
  {
    label: '28114000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΙΝΗΤΗΡΩΝ',
  },
  {
    label: '28114100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΕΚΤΟΣ ΑΠΟ ΜΕΡΗ ΓΙΑ ΚΙΝΗΤΗΡΕΣ ΑΕΡΟΣΚΑΦΩΝ',
  },
  {
    label: '28114200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΛΛΩΝ ΚΙΝΗΤΗΡΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '28119000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΚΙΝΗΤΗΡΩΝ ΚΑΙ ΣΤΡΟΒΙΛΩΝ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΟΥΣ ΚΙΝΗΤΗΡΕΣ ΑΕΡΟΣΚΑΦΩΝ, ΟΧΗΜΑΤΩΝ ΚΑΙ ΔΙΚΥΚΛΩΝ',
  },
  {
    label: '28120000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΞΟΠΛΙΣΜΟΥ ΥΔΡΑΥΛΙΚΗΣ ΕΝΕΡΓΕΙΑΣ',
  },
  {
    label: '28121000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΔΡΑΥΛΙΚΩΝ ΚΙΝΗΤΗΡΩΝ ΚΑΙ ΚΙΝΗΤΗΡΩΝ ΠΕΠΙΕΣΜΕΝΟΥ ΑΕΡΑ ΓΡΑΜΜΙΚΗΣ ΚΑΙ ΠΕΡΙΣΤΡΟΦΙΚΗΣ ΚΙΝΗΣΗΣ',
  },
  {
    label: '28121100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΔΡΑΥΛΙΚΩΝ ΚΙΝΗΤΗΡΩΝ ΚΑΙ ΚΙΝΗΤΗΡΩΝ ΠΕΠΙΕΣΜΕΝΟΥ ΑΕΡΑ ΓΡΑΜΜΙΚΗΣ ΚΙΝΗΣΗΣ (ΚΥΛΙΝΔΡΩΝ)',
  },
  {
    label: '28121200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΔΡΑΥΛΙΚΩΝ ΚΙΝΗΤΗΡΩΝ ΚΑΙ ΚΙΝΗΤΗΡΩΝ ΠΕΠΙΕΣΜΕΝΟΥ ΑΕΡΑ ΠΕΡΙΣΤΡΟΦΙΚΗΣ ΚΙΝΗΣΗΣ',
  },
  {
    label: '28121300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΥΔΡΑΥΛΙΚΩΝ ΑΝΤΛΙΩΝ',
  },
  {
    label: '28121400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΥΔΡΑΥΛΙΚΩΝ ΔΙΚΛΕΙΔΩΝ ΚΑΙ ΔΙΚΛΕΙΔΩΝ ΠΕΠΙΕΣΜΕΝΟΥ ΑΕΡΑ',
  },
  {
    label: '28121500',
    value: 'ΚΑΤΑΣΚΕΥΗ ΥΔΡΑΥΛΙΚΩΝ ΣΥΓΚΡΟΤΗΜΑΤΩΝ',
  },
  {
    label: '28121600',
    value: 'ΚΑΤΑΣΚΕΥΗ ΥΔΡΑΥΛΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ',
  },
  {
    label: '28122000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΥΔΡΑΥΛΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ',
  },
  {
    label: '28129000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΥΔΡΑΥΛΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '28130000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΑΝΤΛΙΩΝ ΚΑΙ ΣΥΜΠΙΕΣΤΩΝ',
  },
  {
    label: '28131000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΝΤΛΙΩΝ ΓΙΑ ΥΓΡΑ· ΑΝΥΨΩΤΩΝ ΥΓΡΩΝ',
  },
  {
    label: '28131100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΤΛΙΩΝ ΓΙΑ ΚΑΥΣΙΜΑ, ΛΙΠΑΝΤΙΚΑ, ΨΥΚΤΙΚΑ ΜΕΣΑ ΚΑΙ ΣΚΥΡΟΔΕΜΑ',
  },
  {
    label: '28131200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΑΛΙΝΔΡΟΜΙΚΩΝ ΑΝΤΛΙΩΝ ΕΚΤΟΠΙΣΗΣ ΓΙΑ ΥΓΡΑ',
  },
  {
    label: '28131300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΕΡΙΣΤΡΟΦΙΚΩΝ ΑΝΤΛΙΩΝ ΕΚΤΟΠΙΣΗΣ ΓΙΑ ΥΓΡΑ',
  },
  {
    label: '28131400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΦΥΓΟΚΕΝΤΡΙΚΩΝ ΑΝΤΛΙΩΝ ΓΙΑ ΥΓΡΑ· ΑΛΛΩΝ ΑΝΤΛΙΩΝ',
  },
  {
    label: '28132000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΕΡΑΝΤΛΙΩΝ Η ΑΝΤΛΙΩΝ ΚΕΝΟΥ· ΑΕΡΟΣΥΜΠΙΕΣΤΩΝ ΚΑΙ ΑΛΛΩΝ ΑΕΡΙΟΣΥΜΠΙΕΣΤΩΝ',
  },
  {
    label: '28132100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΝΤΛΙΩΝ ΚΕΝΟΥ',
  },
  {
    label: '28132200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΕΙΡΟΚΙΝΗΤΩΝ Η ΠΟΔΟΚΙΝΗΤΩΝ ΑΕΡΑΝΤΛΙΩΝ',
  },
  {
    label: '28132300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΜΠΙΕΣΤΩΝ ΓΙΑ ΨΥΚΤΙΚΟ ΕΞΟΠΛΙΣΜΟ',
  },
  {
    label: '28132400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΕΡΟΣΥΜΠΙΕΣΤΩΝ ΣΤΕΡΕΩΜΕΝΩΝ ΣΕ ΤΡΟΧΟΦΟΡΟ ΣΚΕΛΕΤΟ ΓΙΑ ΡΥΜΟΥΛΚΗΣΗ',
  },
  {
    label: '28132500',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΤΡΟΒΙΛΟΣΥΜΠΙΕΣΤΩΝ',
  },
  {
    label: '28132600',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΑΛΙΝΔΡΟΜΙΚΩΝ ΣΥΜΠΙΕΣΤΩΝ ΜΕΤΑΤΟΠΙΣΗΣ',
  },
  {
    label: '28132700',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΕΡΙΣΤΡΟΦΙΚΩΝ ΣΥΜΠΙΕΣΤΩΝ ΜΕΤΑΤΟΠΙΣΗΣ, ΜΟΝΟΑΞΟΝΙΚΩΝ Η ΠΟΛΥΑΞΟΝΙΚΩΝ',
  },
  {
    label: '28132800',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΣΥΜΠΙΕΣΤΩΝ',
  },
  {
    label: '28133000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΝΤΛΙΩΝ ΚΑΙ ΣΥΜΠΙΕΣΤΩΝ',
  },
  {
    label: '28133100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΝΤΛΙΩΝ· ΜΕΡΩΝ ΑΝΥΨΩΤΩΝ ΥΓΡΩΝ',
  },
  {
    label: '28133200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΕΡΑΝΤΛΙΩΝ Η ΑΝΤΛΙΩΝ ΚΕΝΟΥ, ΑΕΡΟΣΥΜΠΙΕΣΤΩΝ Η ΑΕΡΙΟΣΥΜΠΙΕΣΤΩΝ, ΑΝΕΜΙΣΤΗΡΩΝ, ΑΠΟΡΡΟΦΗΤΗΡΩΝ',
  },
  {
    label: '28139000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΑΝΤΛΙΩΝ ΚΑΙ ΣΥΜΠΙΕΣΤΩΝ',
  },
  {
    label: '28140000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΚΡΟΥΝΟΠΟΙΙΑΣ ΚΑΙ ΒΑΛΒΙΔΩΝ',
  },
  {
    label: '28141000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΤΡΟΦΙΓΓΩΝ, ΚΑΝΟΥΛΩΝ, ΒΑΛΒΙΔΩΝ (ΔΙΚΛΕΙΔΩΝ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΣΩΛΗΝΩΣΕΙΣ, ΛΕΒΗΤΕΣ, ΒΥΤΙΑ, ΒΑΡΕΛΙΑ Η ΠΑΡΟΜΟΙΑ ΔΟΧΕΙΑ',
  },
  {
    label: '28141100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΑΛΒΙΔΩΝ (ΔΙΚΛΕΙΔΩΝ) ΜΕΙΩΣΗΣ ΤΗΣ ΠΙΕΣΗΣ, ΔΙΚΛΕΙΔΩΝ ΕΛΕΓΧΟΥ, ΡΥΘΜΙΣΤΙΚΩΝ ΚΑΙ ΑΣΦΑΛΙΣΤΙΚΩΝ ΔΙΚΛΕΙΔΩΝ',
  },
  {
    label: '28141200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΤΡΟΦΙΓΓΩΝ, ΚΑΝΟΥΛΩΝ, ΒΑΛΒΙΔΩΝ (ΔΙΚΛΕΙΔΩΝ) ΓΙΑ ΝΕΡΟΧΥΤΕΣ, ΝΙΠΤΗΡΕΣ, ΜΠΙΝΤΕΔΕΣ, ΚΑΖΑΝΑΚΙΑ, ΜΠΑΝΙΕΡΕΣ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ· ΒΑΛΒΙΔΩΝ (ΔΙΚΛΕΙΔΩΝ) ΣΩΜΑΤΩΝ ΚΑΛΟΡΙΦΕΡ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '28141300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΑΛΒΙΔΩΝ (ΔΙΚΛΕΙΔΩΝ) ΕΛΕΓΧΟΥ ΛΕΙΤΟΥΡΓΙΑΣ, ΔΙΚΛΕΙΔΩΝ ΕΙΣΟΔΟΥ, ΣΦΑΙΡΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΚΛΕΙΔΩΝ',
  },
  {
    label: '28142000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΣΤΡΟΦΙΓΓΩΝ ΚΑΙ ΒΑΛΒΙΔΩΝ (ΔΙΚΛΕΙΔΩΝ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '28149000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΣΤΡΟΦΙΓΓΩΝ ΚΑΙ ΒΑΛΒΙΔΩΝ (ΔΙΚΛΕΙΔΩΝ)',
  },
  {
    label: '28150000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΡΙΒΕΩΝ, ΟΔΟΝΤΩΤΩΝ ΜΗΧΑΝΙΣΜΩΝ ΜΕΤΑΔΟΣΗΣ ΚΙΝΗΣΗΣ, ΣΤΟΙΧΕΙΩΝ ΟΔΟΝΤΩΤΩΝ ΤΡΟΧΩΝ ΚΑΙ ΜΕΤΑΔΟΣΗΣ ΚΙΝΗΣΗΣ',
  },
  {
    label: '28151000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΦΑΙΡΙΚΩΝ ΚΑΙ ΚΥΛΙΝΔΡΙΚΩΝ ΕΔΡΑΝΩΝ ΚΥΛΙΣΗΣ (ΡΟΥΛΕΜΑΝ ~ ΤΡΙΒΕΩΝ)',
  },
  {
    label: '28152000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΔΡΑΝΩΝ ΚΥΛΙΣΗΣ (ΤΡΙΒΕΩΝ), ΟΔΟΝΤΩΤΩΝ ΜΗΧΑΝΙΣΜΩΝ ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ (ΓΡΑΝΑΖΙΩΝ), ΣΤΟΙΧΕΙΩΝ ΟΔΟΝΤΩΤΩΝ ΤΡΟΧΩΝ ΚΑΙ ΜΗΧΑΝΙΣΜΩΝ ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ',
  },
  {
    label: '28152100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΡΘΡΩΤΩΝ ΑΛΥΣΙΔΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '28152200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΞΟΝΩΝ ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΕΚΚΕΝΤΡΟΦΟΡΟΙ ΚΑΙ ΟΙ ΣΤΡΟΦΑΛΟΦΟΡΟΙ ΑΞΟΝΕΣ) ΚΑΙ ΣΤΡΟΦΑΛΩΝ (ΜΑΝΙΒΕΛΩΝ)',
  },
  {
    label: '28152300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΕΡΙΚΑΛΥΜΜΑΤΩΝ ΕΔΡΑΝΩΝ ΚΑΙ ΧΙΤΩΝΙΩΝ ΤΡΙΒΕΩΝ',
  },
  {
    label: '28152400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΔΟΝΤΩΤΩΝ ΤΡΟΧΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΟΔΟΝΤΩΤΩΝ ΤΡΟΧΩΝ· ΕΝΣΦΑΙΡΩΝ Η ΚΥΛΙΝΔΡΙΚΩΝ ΚΟΧΛΙΩΤΩΝ ΑΞΟΝΩΝ· ΚΙΒΩΤΙΩΝ ΤΑΧΥΤΗΤΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΤΑΞΕΩΝ ΑΛΛΑΓΗΣ ΤΑΧΥΤΗΤΑΣ',
  },
  {
    label: '28152500',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΦΟΝΔΥΛΩΝ ΚΑΙ ΤΡΟΧΑΛΙΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΤΑ ΣΥΣΠΑΣΤΑ)',
  },
  {
    label: '28152600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΜΠΛΕΚΤΩΝ ΚΑΙ ΣΥΖΕΥΚΤΗΡΩΝ ΑΞΟΝΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΚΑΘΟΛΙΚΕΣ ΑΡΘΡΩΣΕΙΣ)',
  },
  {
    label: '28153000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΕΔΡΑΝΩΝ ΚΥΛΙΣΗΣ (ΤΡΙΒΕΩΝ), ΣΤΟΙΧΕΙΩΝ ΟΔΟΝΤΩΤΩΝ ΤΡΟΧΩΝ ΚΑΙ ΜΗΧΑΝΙΣΜΩΝ ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ',
  },
  {
    label: '28153100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΦΑΙΡΩΝ, ΒΕΛΟΝΩΝ ΚΑΙ ΚΥΛΙΝΔΡΩΝ· ΜΕΡΩΝ ΕΝΣΦΑΙΡΩΝ ΤΡΙΒΕΩΝ Η ΚΥΛΙΝΔΡΟΤΡΙΒΕΩΝ',
  },
  {
    label: '28153200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΡΘΡΩΤΩΝ ΑΛΥΣΙΔΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '28153900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΤΡΙΒΕΩΝ ΚΑΙ ΜΗΧΑΝΙΣΜΩΝ ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '28159000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΤΡΙΒΕΩΝ (ΡΟΥΛΕΜΑΝ), ΟΔΟΝΤΩΤΩΝ ΜΗΧΑΝΙΣΜΩΝ ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ (ΓΡΑΝΑΖΙΩΝ), ΣΤΟΙΧΕΙΩΝ ΟΔΟΝΤΩΤΩΝ ΤΡΟΧΩΝ ΚΑΙ ΜΗΧΑΝΙΣΜΩΝ ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ',
  },
  {
    label: '28210000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΟΥΡΝΩΝ, ΚΛΙΒΑΝΩΝ ΚΑΙ ΚΑΥΣΤΗΡΩΝ',
  },
  {
    label: '28211000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΟΥΡΝΩΝ ΚΑΙ ΚΑΥΣΤΗΡΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '28211100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΥΣΤΗΡΩΝ· ΜΗΧΑΝΙΚΩΝ ΘΕΡΜΑΣΤΡΩΝ ΚΑΙ ΕΣΧΑΡΩΝ· ΜΗΧΑΝΙΚΩΝ ΔΙΑΤΑΞΕΩΝ ΓΙΑ ΤΗΝ ΑΠΟΜΑΚΡΥΝΣΗ ΤΗΣ ΣΤΑΧΤΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '28211200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΙΟΜΗΧΑΝΙΚΩΝ ΚΑΙ ΕΡΓΑΣΤΗΡΙΑΚΩΝ ΚΛΙΒΑΝΩΝ ΚΑΙ ΦΟΥΡΝΩΝ, ΜΗ ΗΛΕΚΤΡΙΚΩΝ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΚΑΙ ΤΩΝ ΑΠΟΤΕΦΡΩΤΗΡΩΝ, ΑΛΛΑ ΕΞΑΙΡΟΥΜΕΝΩΝ ΤΩΝ ΦΟΥΡΝΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '28211300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΙΟΜΗΧΑΝΙΚΩΝ Η ΕΡΓΑΣΤΗΡΙΑΚΩΝ ΗΛΕΚΤΡΙΚΩΝ ΚΛΙΒΑΝΩΝ ΚΑΙ ΦΟΥΡΝΩΝ· ΕΠΑΓΩΓΙΚΟΥ Η ΔΙΗΛΕΚΤΡΙΚΟΥ ΘΕΡΜΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '28211400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΥΣΤΗΡΩΝ, ΚΛΙΒΑΝΩΝ ΚΑΙ ΦΟΥΡΝΩΝ',
  },
  {
    label: '28219000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΦΟΥΡΝΩΝ, ΚΛΙΒΑΝΩΝ ΚΑΙ',
  },
  {
    label: '28220000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΞΟΠΛΙΣΜΟΥ ΑΝΥΨΩΣΗΣ ΚΑΙ ΔΙΑΚΙΝΗΣΗΣ ΦΟΡΤΙΩΝ',
  },
  {
    label: '28221000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΞΟΠΛΙΣΜΟΥ ΑΝΥΨΩΣΗΣ ΚΑΙ ΔΙΑΚΙΝΗΣΗΣ ΦΟΡΤΙΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥ',
  },
  {
    label: '28221100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΟΛΥΣΠΑΣΤΩΝ ΚΑΙ ΒΑΡΟΥΛΚΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '28221200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΑΝΕΛΚΥΣΗΣ ΣΤΟ ΣΤΟΜΙΟ ΤΟΥ ΦΡΕΑΤΟΣ· ΒΙΝΤΣΙΩΝ ΕΙΔΙΚΑ ΣΧΕΔΙΑΣΜΕΝΩΝ ΓΙΑ ΥΠΟΓΕΙΑ ΧΡΗΣΗ· ΑΛΛΩΝ ΒΙΝΤΣΙΩΝ· ΕΡΓΑΤΩΝ (ΜΠΟΤΖΕΡΓΑΤΩΝ)',
  },
  {
    label: '28221300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΡΥΛΩΝ· ΒΑΡΟΥΛΚΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΓΙΑ ΑΝΥΨΩΣΗ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '28221400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΟΡΤΩΤΗΡΩΝ· ΓΕΡΑΝΩΝ· ΚΙΝΗΤΩΝ ΑΝΥΨΩΤΙΚΩΝ ΠΛΑΙΣΙΩΝ, ΓΕΡΑΝΟΓΕΦΥΡΩΝ ΚΑΙ ΓΕΡΑΝΟΦΟΡΩΝ ΟΧΗΜΑΤΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '28221500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΕΡΟΝΟΦΟΡΩΝ ΑΝΥΨΩΤΙΚΩΝ ΟΧΗΜΑΤΩΝ, ΑΛΛΩΝ ΟΧΗΜΑΤΩΝ ΚΑΤΑΣΚΕΥΩΝ· ΕΛΚΥΣΤΗΡΩΝ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΑΠΟΒΑΘΡΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΣΤΑΘΜΩΝ',
  },
  {
    label: '28221600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΕΛΚΥΣΤΗΡΩΝ, ΚΑΔΟΦΟΡΩΝ ΒΑΡΟΥΛΚΩΝ, ΚΥΛΙΟΜΕΝΩΝ ΣΚΑΛΩΝ ΚΑΙ ΚΥΛΙΟΜΕΝΩΝ ΔΙΑΔΡΟΜΩΝ',
  },
  {
    label: '28221601',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΝΕΛΚΥΣΤΗΡΩΝ',
  },
  {
    label: '28221700',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΥΨΩΤΗΡΩΝ ΚΑΙ ΙΜΑΝΤΩΝ ΜΕΤΑΦΟΡΑΣ ΣΥΝΕΧΟΥΣ ΛΕΙΤΟΥΡΓΙΑΣ, ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΓΙΑ ΠΡΟΪΟΝΤΑ Η ΥΛΙΚΑ',
  },
  {
    label: '28221800',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΑΝΥΨΩΣΗΣ, ΜΕΤΑΚΙΝΗΣΗΣ, ΦΟΡΤΩΣΗΣ Η ΕΚΦΟΡΤΩΣΗΣ',
  },
  {
    label: '28221900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΕΞΟΠΛΙΣΜΟΥ ΑΝΥΨΩΣΗΣ ΚΑΙ ΔΙΑΚΙΝΗΣΗΣ ΦΟΡΤΙΩΝ',
  },
  {
    label: '28221901',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΞΑΡΤΗΜΑΤΩΝ ΑΝΕΛΚΥΣΤΗΡΩΝ (ΔΙΑΚΟΠΤΩΝ ΑΝΟΔΟΥ ~ ΚΑΘΟΔΟΥ ΚΛΠ)',
  },
  {
    label: '28222000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΔΩΝ, ΦΤΥΑΡΙΩΝ, ΑΡΠΑΓΩΝ ΚΑΙ ΛΑΒΩΝ ΓΙΑ ΓΕΡΑΝΟΥΣ, ΕΚΣΚΑΦΕΙΣ ΚΑΙ ΠΑΡΟΜΟΙΑ ΜΗΧΑΝΗΜΑΤΑ',
  },
  {
    label: '28229000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΚΑΤΑΣΚΕΥΗΣ ΕΞΟΠΛΙΣΜΟΥ ΑΝΥΨΩΣΗΣ ΚΑΙ ΔΙΑΚΙΝΗΣΗΣ ΦΟΡΤΙΩΝ',
  },
  {
    label: '28230000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΟΥ (ΕΚΤΟΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ)',
  },
  {
    label: '28231000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΡΑΦΟΜΗΧΑΝΩΝ, ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΕΙΜΕΝΟΥ ΚΑΙ ΑΡΙΘΜΟΜΗΧΑΝΩΝ',
  },
  {
    label: '28231100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΜΑΤΩΝ ΓΡΑΦΟΜΗΧΑΝΩΝ ΚΑΙ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΕΙΜΕΝΟΥ',
  },
  {
    label: '28231200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΓΡΑΦΟΜΗΧΑΝΩΝ',
  },
  {
    label: '28231300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΛΟΓΙΣΤΙΚΩΝ ΜΗΧΑΝΩΝ, ΤΑΜΙΑΚΩΝ ΜΗΧΑΝΩΝ, ΜΗΧΑΝΩΝ ΑΠΟΤΥΠΩΣΗΣ ΤΑΧΥΔΡΟΜΙΚΩΝ ΤΕΛΩΝ, ΜΗΧΑΝΩΝ ΕΚΔΟΣΗΣ ΕΙΣΙΤΗΡΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗΧΑΝΩΝ ΠΟΥ ΦΕΡΟΥΝ ΥΠΟΛΟΓΙΣΤΙΚΗ ΔΙΑΤΑΞΗ',
  },
  {
    label: '28232000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΓΡΑΦΕΙΟΥ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '28232100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΩΤΟΑΝΤΙΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ ΜΕ ΟΠΤΙΚΟ ΣΥΣΤΗΜΑ Η ΜΕ ΕΠΑΦΗ ΚΑΙ ΘΕΡΜΟΑΝΤΙΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '28232200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΚΤΥΠΩΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ OFFSET, ΓΡΑΦΕΙΟΥ, ΠΟΥ ΤΡΟΦΟΔΟΤΟΥΝΤΑΙ ΜΕ ΦΥΛΛΑ',
  },
  {
    label: '28232300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΗΧΑΝΩΝ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '28232400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΡΑΦΟΜΗΧΑΝΩΝ ΚΑΙ ΑΡΙΘΜΟΜΗΧΑΝΩΝ',
  },
  {
    label: '28232500',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΛΛΩΝ ΜΗΧΑΝΩΝ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '28232600',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΦΩΤΟΑΝΤΙΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '28239000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΩΝ ΓΡΑΦΕΙΟΥ ΚΑΙ ΛΟΓΙΣΤΙΚΩΝ ΜΗΧΑΝΩΝ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΟΥ (ΕΚΤΟΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ)',
  },
  {
    label: '28239100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΩΝ ΓΡΑΦΕΙΟΥ ΚΑΙ ΛΟΓΙΣΤΙΚΩΝ ΜΗΧΑΝΩΝ (ΕΚΤΟΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ)',
  },
  {
    label: '28239900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΟΥ (ΕΚΤΟΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ)',
  },
  {
    label: '28240000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΚΙΝΗΤΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '28241000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΜΗΧΑΝΙΚΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ· ΑΛΛΩΝ ΦΟΡΗΤΩΝ ΗΛΕΚΤΡΟΚΙΝΗΤΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΩΝΑΚΤΙΚΟΥ ΧΕΙΡΙΣΜΟΥ',
  },
  {
    label: '28241100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΟΜΗΧΑΝΙΚΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ, ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΟ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '28241200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΦΟΡΗΤΩΝ ΗΛΕΚΤΡΟΚΙΝΗΤΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΩΝΑΚΤΙΚΟΥ ΧΕΙΡΙΣΜΟΥ',
  },
  {
    label: '28242000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΟΚΙΝΗΤΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '28242100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΗΛΕΚΤΡΟΜΗΧΑΝΙΚΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ, ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΟ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '28242200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΛΛΩΝ ΦΟΡΗΤΩΝ ΗΛΕΚΤΡΟΚΙΝΗΤΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΩΝΑΚΤΙΚΟΥ ΧΕΙΡΙΣΜΟΥ',
  },
  {
    label: '28249000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΗΛΕΚΤΡΟΚΙΝΗΤΩΝ ΕΡΓΑΛΕΙΩΝ',
  },
  {
    label: '28250000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΨΥΚΤΙΚΟΥ ΚΑΙ ΚΛΙΜΑΤΙΣΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΜΗ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '28251000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΝΑΛΛΑΚΤΩΝ ΘΕΡΜΟΤΗΤΑΣ· ΜΗ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ ΚΛΙΜΑΤΙΣΜΟΥ, ΨΥΞΗΣ ΚΑΙ ΚΑΤΑΨΥΞΗΣ',
  },
  {
    label: '28251100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΝΑΔΩΝ ΕΝΑΛΛΑΓΗΣ ΘΕΡΜΟΤΗΤΑΣ ΚΑΙ ΜΗΧΑΝΗΜΑΤΩΝ ΥΓΡΟΠΟΙΗΣΗΣ ΑΕΡΑ Η ΑΕΡΙΩΝ',
  },
  {
    label: '28251200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΛΙΜΑΤΙΣΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '28251300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΞΟΠΛΙΣΜΟΥ ΨΥΞΗΣ ΚΑΙ ΚΑΤΑΨΥΞΗΣ ΚΑΙ ΑΝΤΛΙΩΝ ΘΕΡΜΟΤΗΤΑΣ, ΕΚΤΟΣ ΤΩΝ ΣΥΣΚΕΥΩΝ ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '28251301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΨΥΚΤΙΚΩΝ ΠΡΟΘΗΚΩΝ (ΒΙΤΡΙΝΩΝ;ΨΥΓΕΙΩΝ)',
  },
  {
    label: '28251400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΔΙΗΘΗΣΗΣ Η ΚΑΘΑΡΙΣΜΟΥ ΑΕΡΙΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '28252000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΕΜΙΣΤΗΡΩΝ, ΕΚΤΟΣ ΤΩΝ ΕΠΙΤΡΑΠΕΖΙΩΝ ΑΝΕΜΙΣΤΗΡΩΝ, ΤΩΝ ΑΝΕΜΙΣΤΗΡΩΝ ΔΑΠΕΔΟΥ, ΤΟΙΧΟΥ, ΠΑΡΑΘΥΡΟΥ, ΟΡΟΦΗΣ Η ΣΤΕΓΗΣ',
  },
  {
    label: '28253000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΕΞΟΠΛΙΣΜΟΥ ΨΥΞΗΣ ΚΑΙ ΚΑΤΑΨΥΞΗΣ ΚΑΙ ΑΝΤΛΙΩΝ ΘΕΡΜΟΤΗΤΑΣ',
  },
  {
    label: '28259000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΨΥΚΤΙΚΟΥ ΚΑΙ ΚΛΙΜΑΤΙΣΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΜΗ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '28290000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΝΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '28291000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΕΡΙΟΓΕΝΝΗΤΡΙΩΝ, ΣΥΣΚΕΥΩΝ ΑΠΟΣΤΑΞΗΣ ΚΑΙ ΔΙΗΘΗΣΗΣ',
  },
  {
    label: '28291100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΕΡΙΟΓΕΝΝΗΤΡΙΩΝ ΑΕΡΙΟΥ Η ΝΕΡΟΥ· ΑΕΡΙΟΓΕΝΝΗΤΡΙΩΝ ΑΚΕΤΥΛΕΝΙΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΑΕΡΙΟΓΕΝΝΗΤΡΙΩΝ· ΕΞΟΠΛΙΣΜΟΥ ΑΠΟΣΤΑΞΗΣ Η ΔΙΥΛΙΣΗΣ',
  },
  {
    label: '28291200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΔΙΗΘΗΣΗΣ Η ΚΑΘΑΡΙΣΜΟΥ, ΓΙΑ ΥΓΡΑ',
  },
  {
    label: '28291201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΙΛΤΡΩΝ ΚΑΙ ΔΙΑΤΑΞΕΩΝ ΚΑΘΑΡΙΣΜΟΥ ΝΕΡΟΥ',
  },
  {
    label: '28291300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΙΛΤΡΩΝ ΛΑΔΙΟΥ, ΦΙΛΤΡΩΝ ΒΕΝΖΙΝΗΣ ΚΑΙ ΦΙΛΤΡΩΝ ΕΙΣΑΓΩΓΗΣ ΑΕΡΑ ΓΙΑ ΚΙΝΗΤΗΡΕΣ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ',
  },
  {
    label: '28292000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΘΑΡΙΣΜΟΥ, ΓΕΜΙΣΜΑΤΟΣ, ΣΥΣΚΕΥΑΣΙΑΣ Η ΠΕΡΙΤΥΛΙΓΜΑΤΟΣ ΦΙΑΛΩΝ Η ΑΛΛΩΝ ΔΟΧΕΙΩΝ· ΠΥΡΟΣΒΕΣΤΗΡΩΝ, ΨΕΚΑΣΤΗΡΩΝ, ΜΗΧΑΝΩΝ ΑΤΜΟΒΟΛΗΣ Η ΑΜΜΟΒΟΛΗΣ· ΠΑΡΕΜΒΥΣΜΑΤΩΝ (ΤΣΙΜΟΥΧΩΝ)',
  },
  {
    label: '28292100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΘΑΡΙΣΜΟΥ, ΓΕΜΙΣΜΑΤΟΣ, ΣΥΣΚΕΥΑΣΙΑΣ Η ΠΕΡΙΤΥΛΙΓΜΑΤΟΣ ΦΙΑΛΩΝ Η ΑΛΛΩΝ ΔΟΧΕΙΩΝ',
  },
  {
    label: '28292200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΥΡΟΣΒΕΣΤΗΡΩΝ, ΨΕΚΑΣΤΗΡΩΝ, ΜΗΧΑΝΩΝ ΑΤΜΟΒΟΛΗΣ Η ΑΜΜΟΒΟΛΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗΧΑΝΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΕΚΤΟΣ ΑΥΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗ ΓΕΩΡΓΙΑ',
  },
  {
    label: '28292201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΥΡΟΣΒΕΣΤΗΡΩΝ',
  },
  {
    label: '28292300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΑΡΕΜΒΥΣΜΑΤΩΝ (ΤΣΙΜΟΥΧΩΝ) ΑΠΟ ΜΕΤΑΛΛΙΚΑ ΦΥΛΛΑ· ΜΗΧΑΝΙΚΩΝ ΣΤΕΓΑΝΟΠΟΙΗΣΕΩΝ',
  },
  {
    label: '28293000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΙΟΜΗΧΑΝΙΚΩΝ, ΟΙΚΙΑΚΩΝ ΚΑΙ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΖΥΓΙΣΗΣ ΚΑΙ ΜΕΤΡΗΣΗΣ',
  },
  {
    label: '28293100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΖΥΓΙΣΗΣ ΓΙΑ ΒΙΟΜΗΧΑΝΙΚΟΥΣ ΣΚΟΠΟΥΣ· ΣΥΣΚΕΥΩΝ ΓΙΑ ΔΙΑΡΚΗ ΖΥΓΙΣΗ ΠΡΟΪΟΝΤΩΝ ΣΤΟΥΣ ΙΜΑΝΤΕΣ ΜΕΤΑΦΟΡΑΣ· ΣΤΑΘΕΡΩΝ ΣΥΣΚΕΥΩΝ ΖΥΓΙΣΗΣ ΚΑΙ ΣΥΣΚΕΥΩΝ ΕΚΦΟΡΤΩΣΗΣ ΠΡΟΚΑΘΟΡΙΣΜΕΝΟΥ ΒΑΡΟΥΣ',
  },
  {
    label: '28293200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΤΟΜΙΚΩΝ ΚΑΙ ΟΙΚΙΑΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΖΥΓΙΣΗΣ',
  },
  {
    label: '28293900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΖΥΓΙΣΗΣ ΚΑΙ ΜΕΤΡΗΣΗΣ',
  },
  {
    label: '28294000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΥΓΟΚΕΝΤΡΙΚΩΝ ΜΗΧΑΝΩΝ, ΣΤΙΛΒΩΤΙΚΩΝ ΚΥΛΙΝΔΡΩΝ (ΜΑΓΓΑΝΩΝ) ΚΑΙ ΑΥΤΟΜΑΤΩΝ ΠΩΛΗΤΩΝ',
  },
  {
    label: '28294100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΥΓΟΚΕΝΤΡΙΚΩΝ ΜΗΧΑΝΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '28294200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΤΙΛΒΩΤΙΚΩΝ ΚΥΛΙΝΔΡΩΝ Η ΑΛΛΩΝ ΜΗΧΑΝΩΝ ΚΥΛΙΝΔΡΙΚΗΣ ΤΥΠΟΠΟΙΗΣΗΣ, ΕΚΤΟΣ ΟΣΩΝ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΜΕΤΑΛΛΟ Η ΓΥΑΛΙ',
  },
  {
    label: '28294300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΠΩΛΗΣΗΣ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '28295000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΥΝΤΗΡΙΩΝ ΠΙΑΤΩΝ, ΕΠΑΓΓΕΛΜΑΤΙΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '28296000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α. ΓΙΑ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΥΛΙΚΩΝ ΜΕ ΜΕΘΟΔΟ ΠΟΥ ΣΥΝΕΠΑΓΕΤΑΙ ΜΕΤΑΒΟΛΗ ΤΗΣ ΘΕΡΜΟΚΡΑΣΙΑΣ',
  },
  {
    label: '28297000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΜΑΛΑΚΗ ΣΥΓΚΟΛΛΗΣΗ, ΣΚΛΗΡΗ ΣΥΓΚΟΛΛΗΣΗ Η ΘΕΡΜΟΣΥΓΚΟΛΛΗΣΗ· ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΑΕΡΙΟ ΓΙΑ ΤΗΝ ΕΠΙΦΑΝΕΙΑΚΗ ΣΚΛΗΡΥΝΣΗ (ΒΑΨΙΜΟ)',
  },
  {
    label: '28298000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΝΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '28298100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΕΡΙΟΓΕΝΝΗΤΡΙΩΝ ΑΕΡΙΟΥ Η ΝΕΡΟΥ',
  },
  {
    label: '28298200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΦΥΓΟΚΕΝΤΡΙΚΩΝ ΜΗΧΑΝΩΝ· ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΔΙΗΘΗΣΗΣ Η ΚΑΘΑΡΙΣΜΟΥ ΓΙΑ ΥΓΡΑ Η ΑΕΡΙΑ',
  },
  {
    label: '28298300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΣΤΙΛΒΩΤΙΚΩΝ ΚΥΛΙΝΔΡΩΝ Η ΑΛΛΩΝ ΜΗΧΑΝΩΝ ΕΛΑΣΗΣ· ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΨΕΚΑΣΜΟΥ· ΣΤΑΘΜΩΝ ΓΙΑ ΜΗΧΑΝΕΣ ΖΥΓΙΣΗΣ',
  },
  {
    label: '28298400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΠΟΥ ΔΕΝ ΠΕΡΙΕΧΟΥΝ ΗΛΕΚΤΡΙΚΕΣ ΣΥΝΔΕΣΕΙΣ Π.Δ.Κ.Α.',
  },
  {
    label: '28298500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΠΛΥΝΤΗΡΙΩΝ ΠΙΑΤΩΝ ΚΑΙ ΜΗΧΑΝΩΝ ΚΑΘΑΡΙΣΜΑΤΟΣ, ΓΕΜΙΣΜΑΤΟΣ, ΣΥΣΚΕΥΑΣΙΑΣ ΚΑΙ ΠΕΡΙΤΥΛΙΞΕΩΣ',
  },
  {
    label: '28298600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΜΑΛΑΚΗ ΣΥΓΚΟΛΛΗΣΗ, ΣΚΛΗΡΗ ΣΥΓΚΟΛΛΗΣΗ Η ΘΕΡΜΟΣΥΓΚΟΛΛΗΣΗ· ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΑΕΡΙΟ ΓΙΑ ΤΗΝ ΕΠΙΦΑΝΕΙΑΚΗ ΣΚΛΗΡΥΝΣΗ (ΒΑΨΙΜΟ)',
  },
  {
    label: '28299000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΝΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '28300000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΕΩΡΓΙΚΩΝ ΚΑΙ ΔΑΣΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '28301000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΟΝΟΑΞΟΝΙΚΩΝ ΧΕΙΡΟΔΗΓΟΥΜΕΝΩΝ ΕΛΚΥΣΤΗΡΩΝ',
  },
  {
    label: '28302000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΓΕΩΡΓΙΚΩΝ ΕΛΚΥΣΤΗΡΩΝ',
  },
  {
    label: '28302100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΛΚΥΣΤΗΡΩΝ, ΙΣΧΥΟΣ <= 37 ~ KW',
  },
  {
    label: '28302200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΛΚΥΣΤΗΡΩΝ, ΙΣΧΥΟΣ > 37 ~ KW ΑΛΛΑ <= 59 ~ KW',
  },
  {
    label: '28302300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΛΚΥΣΤΗΡΩΝ, ΙΣΧΥΟΣ > 59 ~ KW',
  },
  {
    label: '28303000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΕΔΑΦΟΥΣ',
  },
  {
    label: '28303100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΡΟΤΡΩΝ',
  },
  {
    label: '28303200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΒΑΡΝΩΝ, ΑΝΑΜΟΧΛΕΥΤΗΡΩΝ, ΚΑΛΛΙΕΡΓΗΤΙΚΩΝ ΜΗΧΑΝΩΝ, ΣΚΑΛΙΣΤΗΡΙΩΝ ΚΑΙ ΤΣΑΠΩΝ',
  },
  {
    label: '28303300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΣΠΟΡΑΣ, ΦΥΤΕΥΣΗΣ ΚΑΙ ΜΕΤΑΦΥΤΕΥΣΗΣ',
  },
  {
    label: '28303400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΙΑΣΚΟΡΠΙΣΤΩΝ ΚΟΠΡΙΑΣ ΚΑΙ ΔΙΑΝΟΜΕΩΝ ΛΙΠΑΣΜΑΤΩΝ',
  },
  {
    label: '28303900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΔΑΦΟΥΣ',
  },
  {
    label: '28304000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΟΡΤΟΚΟΠΤΙΚΩΝ ΜΗΧΑΝΩΝ ΓΙΑ ΧΛΟΟΤΑΠΗΤΕΣ, ΠΑΡΚΑ Η ΑΘΛΗΤΙΚΑ ΓΗΠΕΔΑ',
  },
  {
    label: '28305000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΘΕΡΙΣΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '28305100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΟΡΤΟΚΟΠΤΙΚΩΝ ΜΗΧΑΝΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΡΑΒΔΟΙ ΚΟΠΗΣ ΓΙΑ ΣΥΝΑΡΜΟΛΟΓΗΣΗ ΣΕ ΕΛΚΥΣΤΗΡΕΣ) Π.Δ.Κ.Α.',
  },
  {
    label: '28305200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΚΟΠΗΣ ΚΑΙ ΞΗΡΑΝΣΗΣ ΣΑΝΟΥ',
  },
  {
    label: '28305300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΔΕΜΑΤΙΣΜΟΥ ΑΧΥΡΟΥ Η ΧΟΡΤΟΝΟΜΗΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΣΥΛΛΕΚΤΙΚΕΣ; ΣΥΜΠΙΕΣΤΙΚΕΣ ΜΗΧΑΝΕΣ)',
  },
  {
    label: '28305400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΘΕΡΙΣΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΡΙΖΩΝ Η ΒΟΛΒΩΝ',
  },
  {
    label: '28305900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΘΕΡΙΣΤΙΚΩΝ ΚΑΙ ΑΛΩΝΙΣΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '28306000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΕΚΤΟΞΕΥΣΗ, ΔΙΑΣΠΟΡΑ Η ΨΕΚΑΣΜΟ ΥΓΡΩΝ Η ΚΟΝΙΟΠΟΙΗΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ ΓΙΑ ΤΗ ΓΕΩΡΓΙΑ Η ΤΗΝ ΚΗΠΟΥΡΙΚΗ',
  },
  {
    label: '28307000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ Η ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΟΧΗΜΑΤΩΝ ΠΟΥ ΔΙΑΘΕΤΟΥΝ ΣΥΣΤΗΜΑΤΑ ΦΟΡΤΩΣΗΣ Η ΕΚΦΟΡΤΩΣΗΣ, ΓΙΑ ΓΕΩΡΓΙΚΟΥΣ ΣΚΟΠΟΥΣ',
  },
  {
    label: '28308000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΑΓΡΟΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '28308100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΓΙΑ ΤΟΝ ΚΑΘΑΡΙΣΜΟ, ΤΗ ΔΙΑΛΟΓΗ Η ΤΗ ΔΙΑΒΑΘΜΙΣΗ ΑΒΓΩΝ, ΦΡΟΥΤΩΝ Η ΑΛΛΩΝ ΓΕΩΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΚΤΟΣ ΣΠΟΡΩΝ, ΣΙΤΗΡΩΝ Η ΑΠΟΞΗΡΑΜΕΝΩΝ ΟΣΠΡΙΩΔΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '28308200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΡΜΕΚΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '28308300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΑΡΑΣΚΕΥΗ ΖΩΟΤΡΟΦΩΝ',
  },
  {
    label: '28308400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΠΩΑΣΤΗΡΩΝ ΚΑΙ ΑΝΑΘΡΕΦΤΗΡΩΝ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '28308500',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΤΗΝΟΤΡΟΦΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '28308600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΕΩΡΓΙΚΩΝ, ΚΗΠΕΥΤΙΚΩΝ, ΔΑΣΟΚΟΜΙΚΩΝ, ΠΤΗΝΟΤΡΟΦΙΚΩΝ Η ΜΕΛΙΣΣΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '28309000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΓΡΟΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΓΕΩΡΓΙΚΩΝ ΚΑΙ ΔΑΣΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '28309100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΘΕΡΙΣΤΙΚΩΝ ΚΑΙ ΑΛΩΝΙΣΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '28309200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΔΑΦΟΥΣ',
  },
  {
    label: '28309300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΛΛΩΝ ΑΓΡΟΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '28309400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΡΜΕΚΤΙΚΩΝ ΜΗΧΑΝΩΝ ΚΑΙ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '28309900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΓΕΩΡΓΙΚΩΝ ΚΑΙ ΔΑΣΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '28410000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΜΟΡΦΟΠΟΙΗΣΗΣ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '28411000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΟΥ ΜΕ ΛΕΙΖΕΡ ΚΑΙ ΠΑΡΟΜΟΙΟ ΤΡΟΠΟ· ΜΗΧΑΝΟΥΡΓΕΙΩΝ ΓΙΑ ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '28411100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΟΥ ΜΕ ΑΦΑΙΡΕΣΗ ΥΛΗΣ, ΜΕ ΛΕΙΖΕΡ, ΜΕ ΥΠΕΡΗΧΟΥΣ ΚΑΙ ΠΑΡΟΜΟΙΕΣ ΜΕΘΟΔΟΥΣ',
  },
  {
    label: '28411200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΟΥΡΓΕΙΩΝ, ΜΗΧΑΝΩΝ ΣΤΑΘΕΡΗΣ ΘΕΣΗΣ ΚΑΙ ΜΗΧΑΝΩΝ ΠΟΛΛΑΠΛΩΝ ΘΕΣΕΩΝ, ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '28412000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΟΡΝΩΝ, ΤΡΥΠΑΝΙΩΝ ΚΑΙ ΦΡΕΖΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '28412100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΟΡΝΩΝ ΓΙΑ ΑΦΑΙΡΕΣΗ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '28412200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗ ΔΙΑΤΡΗΣΗ, ΤΗ ΔΙΑΝΟΙΞΗ ΟΠΩΝ Η ΤΗ ΛΕΙΟΤΡΙΒΗΣΗ ΜΕΤΑΛΛΩΝ· ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΕΞΩΤΕΡΙΚΩΝ ΚΑΙ ΕΣΩΤΕΡΙΚΩΝ ΣΠΕΙΡΩΜΑΤΩΝ ΣΕ ΜΕΤΑΛΛΑ, Π.Δ.Κ.Α.',
  },
  {
    label: '28412300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΕΞΟΜΑΛΥΝΣΗ ΕΠΙΦΑΝΕΙΩΝ, ΓΙΑ ΑΚΟΝΙΣΜΑ, ΤΡΟΧΙΣΜΑ Η ΑΛΛΕΣ ΕΡΓΑΣΙΕΣ ΤΕΛΕΙΩΜΑΤΟΣ ΣΕ ΜΕΤΑΛΛΑ',
  },
  {
    label: '28412400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΠΛΑΝΙΣΜΑ, ΠΡΙΟΝΙΣΜΑ, ΚΟΠΗ Η ΑΛΛΕΣ ΕΡΓΑΣΙΕΣ ΚΟΠΗΣ ΣΕ ΜΕΤΑΛΛΑ',
  },
  {
    label: '28413000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '28413100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΚΑΜΨΗΣ, ΑΝΑΔΙΠΛΩΣΗΣ ΚΑΙ ΕΥΘΥΓΡΑΜΜΙΣΗΣ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '28413200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΔΙΑΤΜΗΣΗΣ, ΔΙΑΤΜΗΤΙΚΗΣ ΔΙΑΤΡΗΣΗΣ ΚΑΙ ΜΕΡΙΚΗΣ ΔΙΑΤΜΗΣΗΣ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '28413300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΚΑΙ ΣΦΥΡΙΩΝ ΓΙΑ ΣΦΥΡΗΛΑΣΙΑ Η ΑΝΙΣΟΠΑΧΗ ΤΥΠΩΣΗ· ΥΔΡΑΥΛΙΚΩΝ ΠΡΕΣΩΝ ΚΑΙ ΠΡΕΣΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '28413400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ Π.Δ.Κ.Α. ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΟΥ, ΕΠΙΤΗΓΜΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΚΑΡΒΙΔΙΩΝ Η ΚΕΡΑΜΟΜΕΤΑΛΛΟΥΡΓΙΚΩΝ ΕΝΩΣΕΩΝ, ΧΩΡΙΣ ΑΦΑΙΡΕΣΗ ΥΛΙΚΟΥ',
  },
  {
    label: '28414000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΕΡΓΑΛΕΙΟΜΗΧΑΝΕΣ ΚΑΤΕΡΓΑΣΙΑΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '28419000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΜΟΡΦΟΠΟΙΗΣΗΣ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '28490000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ',
  },
  {
    label: '28491000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΛΙΘΩΝ, ΞΥΛΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΚΛΗΡΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '28491100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΛΙΘΩΝ, ΚΕΡΑΜΙΚΩΝ ΥΛΙΚΩΝ, ΣΚΥΡΟΔΕΜΑΤΟΣ Η ΠΑΡΟΜΟΙΩΝ ΟΡΥΚΤΩΝ ΥΛΙΚΩΝ Η ΓΙΑ ΤΗΝ ΨΥΧΡΗ ΚΑΤΕΡΓΑΣΙΑ ΤΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '28491200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΞΥΛΟΥ, ΦΕΛΛΟΥ, ΚΟΚΑΛΟΥ, ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ, ΣΚΛΗΡΟΥ ΠΛΑΣΤΙΚΟΥ Η ΠΑΡΟΜΟΙΩΝ ΣΚΛΗΡΩΝ ΥΛΙΚΩΝ· ΜΗΧΑΝΗΜΑΤΩΝ ΓΑΛΒΑΝΟΠΛΑΣΤΙΚΗΣ',
  },
  {
    label: '28492000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΟΦΟΡΕΩΝ',
  },
  {
    label: '28492100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΡΓΑΛΕΙΟΦΟΡΕΩΝ ΚΑΙ ΚΕΦΑΛΩΝ ΕΛΙΚΟΤΟΜΗΣ ΑΥΤΟΜΑΤΟΥ ΑΝΟΙΓΜΑΤΟΣ, ΓΙΑ ΕΡΓΑΛΕΙΟΜΗΧΑΝΕΣ',
  },
  {
    label: '28492200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΔΙΑΤΑΞΕΩΝ ΣΤΕΡΕΩΣΗΣ ΤΩΝ ΠΡΟΣ ΕΠΕΞΕΡΓΑΣΙΑ ΤΕΜΑΧΙΩΝ ΓΙΑ ΕΡΓΑΛΕΙΟΜΗΧΑΝΕΣ',
  },
  {
    label: '28492300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΕΦΑΛΩΝ ΔΙΑΙΡΕΣΗΣ ΚΑΙ ΑΛΛΩΝ ΕΙΔΙΚΩΝ ΠΡΟΣΑΡΤΗΜΑΤΩΝ ΓΙΑ ΕΡΓΑΛΕΙΟΜΗΧΑΝΕΣ',
  },
  {
    label: '28492400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΕΡΓΑΛΕΙΟΜΗΧΑΝΕΣ ΚΑΤΕΡΓΑΣΙΑΣ ΞΥΛΟΥ, ΦΕΛΛΟΥ, ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΚΛΗΡΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '28499000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ',
  },
  {
    label: '28910000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΛΛΟΥΡΓΙΑ',
  },
  {
    label: '28911000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΟΥΡΓΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '28911100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΤΡΟΠΕΩΝ (ΜΕΤΑΛΛΑΚΤΩΝ), ΧΟΑΝΩΝ ΧΥΤΗΡΙΩΝ, ΜΗΤΡΩΝ ΧΕΛΩΝΩΝ ΚΑΙ ΜΗΧΑΝΩΝ ΧΥΤΕΥΣΗΣ· ΕΛΑΣΤΡΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '28911200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΕΤΑΛΛΟΥΡΓΙΚΩΝ ΜΗΧΑΝΩΝ· ΜΕΡΩΝ ΕΛΑΣΤΡΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '28919000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΕΤΑΛΛΟΥΡΓΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '28920000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΑ ΟΡΥΧΕΙΑ, ΤΑ ΛΑΤΟΜΕΙΑ ΚΑΙ ΤΙΣ ΔΟΜΙΚΕΣ ΚΑΤΑΣΚΕΥΕΣ',
  },
  {
    label: '28921000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΟΡΥΧΕΙΩΝ',
  },
  {
    label: '28921100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΥΨΩΤΗΡΩΝ ΚΑΙ ΙΜΑΝΤΩΝ ΜΕΤΑΦΟΡΑΣ ΣΥΝΕΧΟΥΣ ΛΕΙΤΟΥΡΓΙΑΣ, ΓΙΑ ΥΠΟΓΕΙΑ ΧΡΗΣΗ',
  },
  {
    label: '28921200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΚΟΠΗΣ ΑΝΘΡΑΚΑ Η ΒΡΑΧΩΝ ΚΑΙ ΜΗΧΑΝΗΜΑΤΩΝ ΔΙΑΝΟΙΞΗΣ ΣΗΡΑΓΓΩΝ· ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΩΤΡΗΣΗΣ ΚΑΙ ΔΙΑΝΟΙΞΗΣ ΦΡΕΑΤΩΝ',
  },
  {
    label: '28922000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΜΕΤΑΚΙΝΗΣΗΣ, ΙΣΟΠΕΔΩΣΗΣ, ΕΞΟΜΑΛΥΝΣΗΣ, ΑΠΟΞΕΣΗΣ, ΕΚΣΚΑΦΗΣ, ΣΥΜΠΙΕΣΗΣ, ΣΥΝΘΛΙΨΗΣ Η ΕΞΟΡΥΞΗΣ ΓΙΑ ΓΑΙΕΣ, ΟΡΥΚΤΑ Η ΜΕΤΑΛΛΕΥΜΑΤΑ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΜΠΟΥΛΝΤΟΖΩΝ, ΤΩΝ ΜΗΧΑΝΙΚΩΝ ΦΤΥΑΡΙΩΝ ΚΑΙ ΤΩΝ ΟΔΟΣΤΡ',
  },
  {
    label: '28922100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΜΠΟΥΛΝΤΟΖΩΝ ΚΑΙ ΠΛΑΓΙΩΝ ΜΠΟΥΛΝΤΟΖΩΝ',
  },
  {
    label: '28922200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΙΣΟΠΕΔΩΤΗΡΩΝ ΚΑΙ ΟΜΑΛΥΝΤΗΡΩΝ',
  },
  {
    label: '28922300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΑΠΟΞΕΣΤΩΝ',
  },
  {
    label: '28922400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΣΥΜΠΙΕΣΤΗΡΩΝ ΚΑΙ ΟΔΟΣΤΡΩΤΗΡΩΝ',
  },
  {
    label: '28922500',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΠΤΥΟΦΟΡΩΝ ΦΟΡΤΩΤΩΝ ΠΡΟΣΘΙΑΣ ΦΟΡΤΩΣΗΣ',
  },
  {
    label: '28922600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΜΗΧΑΝΙΚΩΝ ΦΤΥΑΡΙΩΝ, ΕΚΣΚΑΦΕΩΝ ΚΑΙ ΠΤΥΟΦΟΡΩΝ ΦΟΡΤΩΤΩΝ, ΣΤΑ ΟΠΟΙΑ Η ΥΠΕΡΚΑΤΑΣΚΕΥΗ ΜΠΟΡΕΙ ΝΑ ΚΑΝΕΙ ΣΤΡΟΦΗ 360 ~ ΜΟΙΡΕΣ, ΕΚΤΟΣ ΤΩΝ ΠΤΥΟΦΟΡΩΝ ΦΟΡΤΩΤΩΝ ΠΡΟΣΘΙΑΣ ΦΟΡΤΩΣΗΣ',
  },
  {
    label: '28922700',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΜΗΧΑΝΙΚΩΝ ΦΤΥΑΡΙΩΝ, ΕΚΣΚΑΦΕΩΝ ΚΑΙ ΠΤΥΟΦΟΡΩΝ ΦΟΡΤΩΤΩΝ· ΑΛΛΩΝ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΟΡΥΧΕΙΩΝ',
  },
  {
    label: '28922800',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΩΠΙΚΩΝ ΚΑΙ ΓΩΝΙΑΚΩΝ ΚΟΠΤΗΡΩΝ ΜΠΟΥΛΝΤΟΖΩΝ',
  },
  {
    label: '28922900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΑΤΡΕΠΟΜΕΝΩΝ ΟΧΗΜΑΤΩΝ, ΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΓΙΑ ΝΑ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΕΚΤΟΣ ΤΟΥ ΟΔΙΚΟΥ ΔΙΚΤΥΟΥ',
  },
  {
    label: '28923000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΚΣΚΑΦΗΣ',
  },
  {
    label: '28924000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΔΙΑΛΟΓΗ, ΑΛΕΣΗ, ΑΝΑΜΕΙΞΗ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΠΕΞΕΡΓΑΣΙΑ ΓΑΙΩΝ, ΛΙΘΩΝ, ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΥΚΤΩΝ ΟΥΣΙΩΝ',
  },
  {
    label: '28925000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΛΚΥΣΤΗΡΩΝ ΤΟΠΟΘΕΤΗΣΗΣ ΤΡΟΧΑΙΟΥ ΥΛΙΚΟΥ',
  },
  {
    label: '28926000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΟΡΥΧΕΙΩΝ, ΛΑΤΟΜΕΙΩΝ ΚΑΙ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '28926100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΩΤΡΗΣΗΣ Η ΔΙΑΝΟΙΞΗΣ ΦΡΕΑΤΩΝ Η ΕΚΣΚΑΦΗΣ· ΜΕΡΩΝ ΓΕΡΑΝΩΝ',
  },
  {
    label: '28926200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΔΙΑΛΟΓΗ, ΑΛΕΣΗ Η ΑΛΛΗ ΕΠΕΞΕΡΓΑΣΙΑ ΓΑΙΩΝ, ΛΙΘΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '28929000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΟΡΥΧΕΙΩΝ, ΛΑΤΟΜΕΙΩΝ ΚΑΙ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '28930000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ',
  },
  {
    label: '28931000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΜΕΡΗ ΤΟΥΣ',
  },
  {
    label: '28931100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΑΠΟΚΟΡΥΦΩΣΗΣ ΓΑΛΑΚΤΟΣ (ΚΟΡΥΦΟΛΟΓΩΝ)',
  },
  {
    label: '28931200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '28931300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΑΛΕΣΗ Η ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΔΗΜΗΤΡΙΑΚΩΝ Η ΟΣΠΡΙΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '28931400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗΝ ΠΑΡΑΣΚΕΥΗ ΚΡΑΣΙΟΥ, ΜΗΛΙΤΗ, ΦΡΟΥΤΟΧΥΜΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΟΤΩΝ',
  },
  {
    label: '28931500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΦΟΥΡΝΩΝ ΑΡΤΟΠΟΙΙΑΣ· ΜΗ ΟΙΚΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΜΑΓΕΙΡΕΜΑ Η ΖΕΣΤΑΜΑ ΦΑΓΗΤΟΥ',
  },
  {
    label: '28931600',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΗΡΑΝΤΗΡΩΝ ΓΕΩΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '28931700',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α. ΓΙΑ ΤΗ ΒΙΟΜΗΧΑΝΙΚΗ ΠΡΟΕΤΟΙΜΑΣΙΑ Η ΠΑΡΑΣΚΕΥΗ ΤΡΟΦΙΜΩΝ Η ΠΟΤΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΛΙΠΗ Η ΕΛΑΙΑ)',
  },
  {
    label: '28931900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΡΟΕΤΟΙΜΑΣΙΑ ΚΑΙ ΠΑΡΑΣΚΕΥΗ ΤΟΥ ΚΑΠΝΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '28932000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΓΙΑ ΤΟΝ ΚΑΘΑΡΙΣΜΟ, ΤΗ ΔΙΑΛΟΓΗ Η ΤΗ ΔΙΑΒΑΘΜΙΣΗ ΣΠΟΡΩΝ ΣΙΤΗΡΩΝ Η ΑΠΟΞΗΡΑΜΕΝΩΝ ΟΣΠΡΙΩΔΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '28933000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ',
  },
  {
    label: '28933100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΠΟΤΩΝ',
  },
  {
    label: '28933200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '28933300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΠΝΟΥ',
  },
  {
    label: '28933400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΩΝ ΓΙΑ ΤΟΝ ΚΑΘΑΡΙΣΜΟ, ΤΗ ΔΙΑΛΟΓΗ Η ΤΗ ΔΙΑΒΑΘΜΙΣΗ ΣΠΟΡΩΝ ΣΙΤΗΡΩΝ Η ΑΠΟΞΗΡΑΜΕΝΩΝ ΟΣΠΡΙΩΔΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '28939000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ',
  },
  {
    label: '28940000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗ ΒΙΟΜΗΧΑΝΙΑ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΝΔΥΜΑΤΩΝ Η ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '28941000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΡΟΕΤΟΙΜΑΣΙΑ, ΚΛΩΣΗ, ΥΦΑΝΣΗ ΚΑΙ ΠΛΕΞΗ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '28941100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΔΙΕΛΑΣΗΣ, ΕΠΕΚΤΑΤΙΚΗΣ ΟΛΚΗΣ, ΤΕΞΤΟΥΡΑΡΙΣΜΑΤΟΣ Η ΚΟΠΗΣ ΤΕΧΝΗΤΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΥΛΩΝ· ΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΠΡΟΕΤΟΙΜΑΣΙΑ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΙΝΩΝ',
  },
  {
    label: '28941200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΚΛΩΣΗΣ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ· ΜΗΧΑΝΩΝ ΔΙΠΛΙΑΣΜΑΤΟΣ, ΣΤΡΙΨΗΣ, ΠΕΡΙΕΛΙΞΗΣ Η ΑΝΑΠΗΝΙΣΗΣ (ΞΕΤΥΛΙΓΑΔΙΑΣΜΑΤΟΣ) ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '28941300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΥΦΑΝΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '28941400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΕΚΤΟΜΗΧΑΝΩΝ· ΡΑΠΤΟΠΛΕΚΤΟΜΗΧΑΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗΧΑΝΩΝ· ΜΗΧΑΝΩΝ ΚΑΤΑΣΚΕΥΗΣ ΘΥΣΑΝΩΝ',
  },
  {
    label: '28941500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΒΟΗΘΗΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΜΗΧΑΝΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ· ΜΗΧΑΝΗΜΑΤΩΝ ΕΚΤΥΠΩΣΗΣ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '28941501',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΕΚΤΥΠΩΣΗΣ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '28942000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΕΙΔΩΝ ΕΝΔΥΣΗΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΡΑΠΤΟΜΗΧΑΝΕΣ)',
  },
  {
    label: '28942100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΛΥΣΗ, ΤΟΝ ΚΑΘΑΡΙΣΜΟ, ΤΟ ΣΤΥΨΙΜΟ, ΤΟ ΣΙΔΕΡΩΜΑ, ΤΟ ΠΡΕΣΑΡΙΣΜΑ, ΤΗ ΒΑΦΗ, ΤΗΝ ΑΝΑΠΗΝΙΣΗ (ΞΕΤΥΛΙΓΑΔΙΑΣΜΑ) ΚΑΙ ΠΑΡΟΜΟΙΕΣ ΕΡΓΑΣΙΕΣ ΥΦΑΝΤΟΥΡΓΙΚΟΥ ΝΗΜΑΤΟΣ ΚΑΙ ΥΦΑΣΜΑΤΩΝ· ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΟ ΦΙΝΙΡΙΣΜΑ ΤΟΥ ΠΙΛΗΜΑΤΟΣ (ΤΣΟΧΑ',
  },
  {
    label: '28942200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΠΛΥΝΤΗΡΙΩΝ ΡΟΥΧΩΝ· ΜΗΧΑΝΩΝ ΣΤΕΓΝΟΥ ΚΑΘΑΡΙΣΜΟΥ· ΣΤΕΓΝΩΤΗΡΙΩΝ ΜΕ ΧΩΡΗΤΙΚΟΤΗΤΑ ΑΝΩ ΤΩΝ ΔΕΚΑ ΚΙΛΩΝ',
  },
  {
    label: '28942300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΥΓΟΚΕΝΤΡΙΚΩΝ ΣΤΕΓΝΩΤΗΡΙΩΝ ΡΟΥΧΩΝ',
  },
  {
    label: '28942400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΡΑΠΤΟΜΗΧΑΝΩΝ, ΕΚΤΟΣ ΤΩΝ ΡΑΠΤΟΜΗΧΑΝΩΝ ΓΙΑ ΒΙΒΛΙΑ ΚΑΙ ΤΩΝ ΟΙΚΙΑΚΩΝ ΡΑΠΤΟΜΗΧΑΝΩΝ',
  },
  {
    label: '28943000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΚΑΤΕΡΓΑΣΙΑ ΠΡΟΒΙΩΝ Η ΔΕΡΜΑΤΩΝ Η ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ Η ΕΠΙΣΚΕΥΗ ΥΠΟΔΗΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ',
  },
  {
    label: '28944000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΡΑΠΤΟΜΗΧΑΝΩΝ ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '28945000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΩΝ ΥΦΑΝΣΗΣ ΚΑΙ ΚΛΩΣΗΣ ΚΑΙ ΜΗΧΑΝΩΝ ΓΙΑ ΑΛΛΗ ΠΑΡΑΓΩΓΗ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΕΙΔΩΝ ΕΝΔΥΣΗΣ ΚΑΙ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ',
  },
  {
    label: '28945100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΩΝ ΚΛΩΣΗΣ ΚΑΙ ΥΦΑΝΣΗΣ',
  },
  {
    label: '28945101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΥΦΑΝΤΙΚΩΝ ΧΤΕΝΙΩΝ ΑΡΓΑΛΕΙΩΝ',
  },
  {
    label: '28945200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΑΛΛΗ ΠΑΡΑΓΩΓΗ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΕΙΔΩΝ ΕΝΔΥΣΗΣ ΚΑΙ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ',
  },
  {
    label: '28949000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΙΔΩΝ ΕΝΔΥΣΗΣ ΚΑΙ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '28950000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '28951000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '28951100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΜΕΡΗ ΤΟΥΣ',
  },
  {
    label: '28951200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '28959000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '28960000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΠΛΑΣΤΙΚΩΝ ΚΑΙ ΕΛΑΣΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '28961000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α. ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΠΛΑΣΤΙΚΟΥ ΚΑΙ ΕΛΑΣΤΙΚΟΥ Η ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΑΥΤΑ ΤΑ ΥΛΙΚΑ',
  },
  {
    label: '28962000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α. ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΠΛΑΣΤΙΚΟΥ ΚΑΙ ΕΛΑΣΤΙΚΟΥ Η ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΑΥΤΑ ΤΑ ΥΛΙΚΑ',
  },
  {
    label: '28969000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΠΛΑΣΤΙΚΩΝ ΚΑΙ ΕΛΑΣΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '28990000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '28991000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΕΚΤΥΠΩΣΗΣ ΚΑΙ ΒΙΒΛΙΟΔΕΣΙΑΣ',
  },
  {
    label: '28991100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΒΙΒΛΙΟΔΕΣΙΑΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΡΑΠΤΟΜΗΧΑΝΕΣ ΓΙΑ ΒΙΒΛΙΑ)',
  },
  {
    label: '28991200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ, ΣΥΣΚΕΥΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΤΗ ΣΤΟΙΧΕΙΟΘΕΣΙΑ, ΤΗΝ ΠΡΟΕΤΟΙΜΑΣΙΑ ΚΑΙ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΤΥΠΟΓΡΑΦΙΚΩΝ ΠΛΑΚΩΝ',
  },
  {
    label: '28991300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΚΤΥΠΩΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΟΦΣΕΤ (OFFSET), ΕΚΤΟΣ ΕΚΕΙΝΩΝ ΠΟΥ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΧΡΗΣΗ ΣΕ ΓΡΑΦΕΙΑ',
  },
  {
    label: '28991400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΚΤΥΠΩΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ, ΕΚΤΟΣ ΕΚΕΙΝΩΝ ΠΟΥ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΧΡΗΣΗ ΣΕ ΓΡΑΦΕΙΑ',
  },
  {
    label: '28991401',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΚΑΙ ΕΡΓΑΛΕΙΩΝ ΕΚΤΥΠΩΣΗΣ, (ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΤΕΛΑΡΩΝ',
  },
  {
    label: '28992000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΑΠΟΚΛΕΙΣΤΙΚΑ Η ΚΥΡΙΩΣ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΜΟΝΟΚΡΥΣΤΑΛΛΩΝ Η ΔΙΣΚΙΩΝ ΗΜΙΑΓΩΓΩΝ, ΣΥΣΚΕΥΩΝ ΜΕ ΗΜΙΑΓΩΓΟΥΣ, ΗΛΕΚΤΡΟΝΙΚΩΝ ΟΛΟΚΛΗΡΩΜΕΝΩΝ ΚΥΚΛΩΜΑΤΩΝ Η ΕΠΙΠΕΔΩΝ ΟΘΟΝΩΝ',
  },
  {
    label: '28993000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '28993100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΗΡΑΝΤΗΡΙΩΝ ΞΥΛΕΙΑΣ, ΧΑΡΤΟΠΟΛΤΟΥ, ΧΑΡΤΙΟΥ Η ΧΑΡΤΟΝΙΟΥ· ΣΤΕΓΝΩΤΗΡΙΩΝ ΜΗ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '28993200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΕΡΙΣΤΡΕΦΟΜΕΝΩΝ ΕΞΕΔΡΩΝ ΔΙΑΣΚΕΔΑΣΗΣ (ΜΥΛΩΝ), ΚΟΥΝΙΩΝ, ΠΕΡΙΠΤΕΡΩΝ ΣΚΟΠΟΒΟΛΗΣ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΔΙΑΣΚΕΔΑΣΗΣ ΥΠΑΙΘΡΙΩΝ ΧΩΡΩΝ ΚΑΙ ΠΑΝΗΓΥΡΕΩΝ',
  },
  {
    label: '28993900',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΙΣΜΟΥ ΕΚΤΟΞΕΥΣΗΣ ΑΕΡΟΣΚΑΦΩΝ· ΑΝΑΣΧΕΤΙΚΩΝ ΟΡΓΑΝΩΝ Η ΠΑΡΟΜΟΙΟΥ ΕΞΟΠΛΙΣΜΟΥ· ΣΥΣΚΕΥΩΝ ΖΥΓΟΣΤΑΘΜΙΣΗΣ· ΜΗΧΑΝΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '28994000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΚΤΥΠΩΣΗΣ ΚΑΙ ΒΙΒΛΙΟΔΕΣΙΑΣ',
  },
  {
    label: '28995000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΑΠΟΚΛΕΙΣΤΙΚΑ Η ΚΥΡΙΩΣ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΜΟΝΟΚΡΥΣΤΑΛΛΩΝ Η ΔΙΣΚΙΩΝ ΗΜΙΑΓΩΓΩΝ, ΣΥΣΚΕΥΩΝ ΜΕ ΗΜΙΑΓΩΓΟΥΣ, ΗΛΕΚΤΡΟΝΙΚΩΝ ΟΛΟΚΛΗΡΩΜΕΝΩΝ ΚΥΚΛΩΜΑΤΩΝ Η ΕΠΙΠΕΔΩΝ ΟΘΟΝΩΝ· ΜΕΡΩΝ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΙ',
  },
  {
    label: '28995100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΑΠΟΚΛΕΙΣΤΙΚΑ Η ΚΥΡΙΩΣ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΜΟΝΟΚΡΥΣΤΑΛΛΩΝ Η ΔΙΣΚΙΩΝ ΗΜΙΑΓΩΓΩΝ, ΣΥΣΚΕΥΩΝ ΜΕ ΗΜΙΑΓΩΓΟΥΣ, ΗΛΕΚΤΡΟΝΙΚΩΝ ΟΛΟΚΛΗΡΩΜΕΝΩΝ ΚΥΚΛΩΜΑΤΩΝ Η ΕΠΙΠΕΔΩΝ ΟΘΟΝΩΝ',
  },
  {
    label: '28995200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '28999000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '29100000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '29101000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΤΟΥ ΕΙΔΟΥΣ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΣΤΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '29101100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΜΕ ΠΑΛΙΝΔΡΟΜΙΚΑ ΕΜΒΟΛΑ, ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΚΥΛΙΝΔΡΙΣΜΟΥ <= 1 ;.000 ~ CM³ ',
  },
  {
    label: '29101200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΜΕ ΠΑΛΙΝΔΡΟΜΙΚΑ ΕΜΒΟΛΑ, ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΚΥΛΙΝΔΡΙΣΜΟΥ > 1 ;.000 ~ CM³ ',
  },
  {
    label: '29101300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΜΒΟΛΟΦΟΡΩΝ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΓΙΑ ΟΧΗΜΑΤΑ, ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΥΜΠΙΕΣΗ',
  },
  {
    label: '29102000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΠΙΒΑΤΙΚΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '29102100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΧΗΜΑΤΩΝ ΜΕ ΚΙΝΗΤΗΡΑ, ΣΤΟΝ ΟΠΟΙΟ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΚΥΛΙΝΔΡΙΣΜΟΥ <= 1 ;.500 ~ CM³ ;, ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '29102200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΧΗΜΑΤΩΝ ΜΕ ΚΙΝΗΤΗΡΑ, ΣΤΟΝ ΟΠΟΙΟ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΚΥΛΙΝΔΡΙΣΜΟΥ > 1 ;.500 ~ CM³ ;, ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '29102300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΧΗΜΑΤΩΝ ΜΕ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΣΤΟΝ ΟΠΟΙΟ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΥΜΠΙΕΣΗ (ΝΤΙΖΕΛ Η ΗΜΙΝΤΙΖΕΛ), ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '29102400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '29103000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΔΕΚΑ Η ΠΕΡΙΣΣΟΤΕΡΩΝ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '29104000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '29104100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΧΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΣΤΟΝ ΟΠΟΙΟ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΥΜΠΙΕΣΗ (ΝΤΙΖΕΛ Η ΗΜΙΝΤΙΖΕΛ), ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '29104200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΧΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΜΠΟΡΕΥΜΑΤΩΝ, ΜΕ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΣΤΟΝ ΟΠΟΙΟ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ· ΑΛΛΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΜΠΟΡΕΥΜΑΤΩΝ, ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '29104300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΔΙΚΩΝ ΕΛΚΥΣΤΗΡΩΝ ΓΙΑ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '29104400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΑΙΣΙΩΝ ΕΞΟΠΛΙΣΜΕΝΩΝ ΜΕ ΚΙΝΗΤΗΡΕΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '29105000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '29105100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΕΡΑΝΟΦΟΡΩΝ ΦΟΡΤΗΓΩΝ',
  },
  {
    label: '29105200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΧΗΜΑΤΩΝ ΠΟΥ ΚΙΝΟΥΝΤΑΙ ΠΑΝΩ ΣΤΟ ΧΙΟΝΙ· ΟΧΗΜΑΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΑ ΓΗΠΕΔΑ ΤΟΥ ΓΚΟΛΦ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΟΧΗΜΑΤΩΝ, ΜΕ ΚΙΝΗΤΗΡΕΣ',
  },
  {
    label: '29105900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '29109000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '29200000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΜΑΞΩΜΑΤΩΝ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ· ΚΑΤΑΣΚΕΥΗ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '29201000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΜΑΞΩΜΑΤΩΝ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '29202000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ· ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ',
  },
  {
    label: '29202100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ ΕΙΔΙΚΑ ΣΧΕΔΙΑΣΜΕΝΩΝ ΓΙΑ ΝΑ ΜΕΤΑΦΕΡΟΝΤΑΙ ΑΠΟ ΕΝΑ Η ΠΕΡΙΣΣΟΤΕΡΑ ΜΕΤΑΦΟΡΙΚΑ ΜΕΣΑ',
  },
  {
    label: '29202200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΤΥΠΟΥ ΤΡΟΧΟΣΠΙΤΟΥ, ΓΙΑ ΚΑΤΟΙΚΗΣΗ Η ΚΑΤΑΣΚΗΝΩΣΗ',
  },
  {
    label: '29202300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ',
  },
  {
    label: '29203000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ, ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΑΛΛΩΝ ΟΧΗΜΑΤΩΝ, ΜΗ ΜΗΧΑΝΟΚΙΝΗΤΩΝ',
  },
  {
    label: '29204000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΑΤΑΣΚΕΥΗΣ, ΣΥΝΑΡΜΟΛΟΓΗΣΗΣ, ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΚΤΕΛΕΣΗΣ ΕΡΓΑΣΙΩΝ ΣΕ ΑΜΑΞΩΜΑΤΑ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '29205000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΟΠΛΙΣΜΟΥ ΤΡΟΧΟΣΠΙΤΩΝ ΚΑΙ ΚΙΝΗΤΩΝ ΚΑΤΟΙΚΙΩΝ',
  },
  {
    label: '29209000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΜΑΞΩΜΑΤΩΝ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ· ΚΑΤΑΣΚΕΥΗΣ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '29310000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΟΥ ΚΑΙ ΗΛΕΚΤΡΟΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '29311000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΡΜΑΤΙΝΩΝ ΔΙΑΤΑΞΕΩΝ ΑΝΑΦΛΕΞΗΣ ΚΑΙ ΑΛΛΩΝ ΣΥΡΜΑΤΙΝΩΝ ΔΙΑΤΑΞΕΩΝ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΟΧΗΜΑΤΑ, ΑΕΡΟΣΚΑΦΗ Η ΠΛΟΙΑ',
  },
  {
    label: '29312000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΓΙΑ ΟΧΗΜΑΤΑ, ΚΑΙ ΜΕΡΗ ΤΟΥΣ',
  },
  {
    label: '29312100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΠΙΝΘΗΡΙΣΤΩΝ (ΜΠΟΥΖΙ), ΜΑΓΝΗΤΟΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΑΝΑΦΛΕΞΗΣ· ΔΥΝΑΜΟΜΑΓΝΗΤΟΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ· ΜΑΓΝΗΤΙΚΩΝ ΣΦΟΝΔΥΛΩΝ· ΔΙΑΝΟΜΕΩΝ· ΠΗΝΙΩΝ ΑΝΑΦΛΕΞΗΣ',
  },
  {
    label: '29312200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΚΚΙΝΗΣΗΣ ΚΑΙ ΕΚΚΙΝΗΤΩΝ ~ ΓΕΝΝΗΤΡΙΩΝ ΔΙΠΛΗΣ ΧΡΗΣΗΣ· ΑΛΛΩΝ ΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '29312300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΣΗΜΑΤΟΔΟΤΗΣΗΣ, ΥΑΛΟΚΑΘΑΡΙΣΤΗΡΩΝ, ΗΛΕΚΤΡΙΚΩΝ ΔΙΑΤΑΞΕΩΝ ΓΙΑ ΤΗ ΔΙΑΛΥΣΗ ΤΟΥ ΠΑΓΟΥ ΚΑΙ ΤΟΥ ΑΧΝΟΥ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ ΚΑΙ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '29313000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ ΚΑΙ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '29319000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΗΛΕΚΤΡΙΚΟΥ ΚΑΙ ΗΛΕΚΤΡΟΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '29320000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '29321000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΑΘΙΣΜΑΤΩΝ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '29322000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΖΩΝΩΝ ΑΣΦΑΛΕΙΑΣ, ΑΕΡΟΣΑΚΩΝ ΚΑΙ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΜΑΞΩΜΑΤΩΝ',
  },
  {
    label: '29323000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ Π.Δ.Κ.Α., ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '29323001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΞΑΤΜΙΣΕΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '29323002',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΟΥΣΤΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '29329000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΑΡΜΟΛΟΓΗΣΗΣ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ, Π.Δ.Κ.Α.· ΥΠΗΡΕΣΙΕΣ ΣΥΝΑΡΜΟΛΟΓΗΣΗΣ ΠΛΗΡΩΝ ΣΥΛΛΟΓΩΝ ΚΑΤΑΣΚΕΥΗΣ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ ΣΤΑ ΠΛΑΙΣΙΑ ΤΗΣ ΠΑΡΑΓΩΓΙΚΗΣ ΔΙΕΡΓΑΣΙΑΣ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΚΑΤΑΣ',
  },
  {
    label: '29329100',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΓΙΑ ΤΗ ΣΥΝΑΡΜΟΛΟΓΗΣΗ ΟΛΟΚΛΗΡΩΜΕΝΩΝ ΣΥΝΟΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '29329200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΑΡΜΟΛΟΓΗΣΗΣ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ, Π.Δ.Κ.Α.',
  },
  {
    label: '29329900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '29329901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΠΕΤΣΑΡΙΣΜΑΤΟΣ ΚΑΘΙΣΜΑΤΩΝ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '30110000',
    value: 'ΝΑΥΠΗΓΗΣΗ ΠΛΟΙΩΝ ΚΑΙ ΠΛΩΤΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '30111000',
    value: 'ΝΑΥΠΗΓΗΣΗ ΠΟΛΕΜΙΚΩΝ ΠΛΟΙΩΝ',
  },
  {
    label: '30112000',
    value:
      'ΝΑΥΠΗΓΗΣΗ ΠΛΟΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΚΑΦΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΠΙΒΑΤΩΝ Η ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '30112100',
    value:
      'ΝΑΥΠΗΓΗΣΗ ΚΡΟΥΑΖΙΕΡΟΠΛΟΙΩΝ, ΣΚΑΦΩΝ ΕΚΔΡΟΜΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΚΑΦΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΠΙΒΑΤΩΝ· ΟΧΗΜΑΤΑΓΩΓΩΝ',
  },
  {
    label: '30112200',
    value:
      'ΝΑΥΠΗΓΗΣΗ ΔΕΞΑΜΕΝΟΠΛΟΙΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΑΡΓΟΥ ΠΕΤΡΕΛΑΙΟΥ, ΠΡΟΪΟΝΤΩΝ ΠΕΤΡΕΛΑΙΟΥ, ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΥΓΡΟΠΟΙΗΜΕΝΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '30112300',
    value: 'ΝΑΥΠΗΓΗΣΗ ΠΛΟΙΩΝ ΨΥΓΕΙΩΝ, ΕΚΤΟΣ ΔΕΞΑΜΕΝΟΠΛΟΙΩΝ',
  },
  {
    label: '30112400',
    value: 'ΝΑΥΠΗΓΗΣΗ ΠΛΟΙΩΝ ΜΕΤΑΦΟΡΑΣ ΞΗΡΟΥ ΦΟΡΤΙΟΥ',
  },
  {
    label: '30113000',
    value: 'ΝΑΥΠΗΓΗΣΗ ΑΛΙΕΥΤΙΚΩΝ ΣΚΑΦΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΙΚΩΝ ΣΚΑΦΩΝ',
  },
  {
    label: '30113100',
    value:
      'ΝΑΥΠΗΓΗΣΗ ΑΛΙΕΥΤΙΚΩΝ ΣΚΑΦΩΝ· ΠΛΟΙΩΝ;ΕΡΓΟΣΤΑΣΙΩΝ ΚΑΙ ΑΛΛΩΝ ΣΚΑΦΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ Η ΤΗ ΣΥΝΤΗΡΗΣΗ ΑΛΙΕΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '30113200',
    value: 'ΝΑΥΠΗΓΗΣΗ ΑΛΛΩΝ ΣΚΑΦΩΝ ΜΗ ΜΕΤΑΦΟΡΑΣ ΦΟΡΤΙΩΝ',
  },
  {
    label: '30113300',
    value: 'ΝΑΥΠΗΓΗΣΗ ΒΥΘΟΚΟΡΩΝ· ΠΛΟΙΩΝ;ΦΑΡΩΝ, ΠΛΩΤΩΝ ΓΕΡΑΝΩΝ· ΑΛΛΩΝ ΣΚΑΦΩΝ',
  },
  {
    label: '30114000',
    value: 'ΝΑΥΠΗΓΗΣΗ ΠΑΡΑΚΤΙΩΝ ΣΚΑΦΩΝ ΚΑΙ ΥΠΟΔΟΜΗΣ',
  },
  {
    label: '30115000',
    value:
      'ΝΑΥΠΗΓΗΣΗ ΑΛΛΩΝ ΠΛΩΤΩΝ ΚΑΤΑΣΚΕΥΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΣΧΕΔΙΩΝ, ΠΛΩΤΩΝ ΔΕΞΑΜΕΝΩΝ, ΣΤΕΓΑΝΩΝ ΚΙΒΩΤΙΩΝ, ΠΡΟΣΔΕΤΗΡΩΝ ΠΛΟΙΩΝ, ΣΗΜΑΝΤΗΡΩΝ, ΠΛΩΤΩΝ ΥΦΑΛΟΔΕΙΚΤΩΝ)',
  },
  {
    label: '30119000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΤΡΟΠΗΣ, ΑΝΑΚΑΤΑΣΚΕΥΗΣ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΠΛΟΙΩΝ, ΠΛΩΤΩΝ ΕΞΕΔΡΩΝ ΚΑΙ ΚΑΤΑΣΚΕΥΩΝ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΚΑΤΑΣΚΕΥΗΣ ΠΛΟΙΩΝ ΚΑΙ ΠΛΩΤΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '30119100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΤΡΟΠΗΣ ΚΑΙ ΑΝΑΚΑΤΑΣΚΕΥΗΣ ΠΛΟΙΩΝ ΚΑΙ ΠΛΩΤΩΝ ΕΞΕΔΡΩΝ ΚΑΙ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '30119200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΟΠΛΙΣΜΟΥ ΠΛΟΙΩΝ ΚΑΙ ΠΛΩΤΩΝ ΕΞΕΔΡΩΝ ΚΑΙ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '30119201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΕΞΩΛΕΜΒΙΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '30119900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΠΛΟΙΩΝ ΚΑΙ ΠΛΩΤΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '30120000',
    value: 'ΝΑΥΠΗΓΗΣΗ ΣΚΑΦΩΝ ΑΝΑΨΥΧΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ',
  },
  {
    label: '30121100',
    value:
      'ΝΑΥΠΗΓΗΣΗ ΙΣΤΙΟΦΟΡΩΝ (ΕΚΤΟΣ ΤΩΝ ΦΟΥΣΚΩΤΩΝ) ΓΙΑ ΑΝΑΨΥΧΗ Η ΑΘΛΗΤΙΣΜΟ, ΜΕ Η ΧΩΡΙΣ ΒΟΗΘΗΤΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '30121200',
    value: 'ΝΑΥΠΗΓΗΣΗ ΦΟΥΣΚΩΤΩΝ ΣΚΑΦΩΝ ΓΙΑ ΑΝΑΨΥΧΗ Η ΑΘΛΗΤΙΣΜΟ',
  },
  {
    label: '30121900',
    value:
      'ΝΑΥΠΗΓΗΣΗ ΑΛΛΩΝ ΣΚΑΦΩΝ ΓΙΑ ΑΝΑΨΥΧΗ Η ΑΘΛΗΤΙΣΜΟ· ΚΩΠΗΛΑΤΩΝ ΒΑΡΚΩΝ ΚΑΙ ΚΑΝΟ',
  },
  {
    label: '30129000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΣΚΑΦΩΝ ΑΝΑΨΥΧΗΣ ΚΑΙ',
  },
  {
    label: '30200000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΑΜΑΞΩΝ ΚΑΙ ΤΡΟΧΑΙΟΥ ΥΛΙΚΟΥ',
  },
  {
    label: '30201000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΑΜΑΞΩΝ (ΜΗΧΑΝΩΝ) ΚΑΙ ΕΦΟΔΙΟΦΟΡΩΝ',
  },
  {
    label: '30201100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΑΜΑΞΩΝ (ΜΗΧΑΝΩΝ) ΠΟΥ ΚΙΝΟΥΝΤΑΙ ΜΕ ΕΞΩΤΕΡΙΚΗ ΠΗΓΗ ΗΛΕΚΤΡΙΣΜΟΥ',
  },
  {
    label: '30201200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΝΤΙΖΕΛΟΗΛΕΚΤΡΙΚΩΝ ΑΜΑΞΩΝ (ΜΗΧΑΝΩΝ)',
  },
  {
    label: '30201300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΑΜΑΞΩΝ (ΜΗΧΑΝΩΝ)· ΕΦΟΔΙΟΦΟΡΩΝ',
  },
  {
    label: '30202000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ Η ΤΡΟΧΙΟΔΡΟΜΙΚΩΝ ΟΧΗΜΑΤΩΝ (ΑΥΤΟΚΙΝΗΤΑΜΑΞΩΝ), ΣΚΕΥΟΦΟΡΩΝ, ΕΚΤΟΣ ΤΩΝ ΟΧΗΜΑΤΩΝ ΣΥΝΤΗΡΗΣΗΣ Η ΕΠΙΣΚΕΥΗΣ',
  },
  {
    label: '30203000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΟΥ ΤΡΟΧΑΙΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '30203100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΧΗΜΑΤΩΝ ΣΥΝΤΗΡΗΣΗΣ Η ΕΠΙΣΚΕΥΗΣ ΣΙΔΗΡΟΔΡΟΜΩΝ Η ΤΡΟΧΙΟΔΡΟΜΩΝ',
  },
  {
    label: '30203200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ Η ΤΡΟΧΙΟΔΡΟΜΙΚΩΝ ΕΠΙΒΑΤΙΚΩΝ ΟΧΗΜΑΤΩΝ, ΜΗ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ · ΣΚΕΥΟΦΟΡΩΝ ΚΑΙ ΑΛΛΩΝ ΟΧΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '30203300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ Η ΤΡΟΧΙΟΔΡΟΜΙΚΩΝ ΣΚΕΥΟΦΟΡΩΝ ΚΑΙ ΒΑΓΟΝΙΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΜΠΟΡΕΥΜΑΤΩΝ, ΜΗ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ',
  },
  {
    label: '30204000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΜΗΧΑΝΩΝ Η ΤΡΟΧΑΙΟΥ ΕΞΟΠΛΙΣΜΟΥ ΣΙΔΗΡΟΔΡΟΜΩΝ Η ΤΡΟΧΙΟΔΡΟΜΩΝ· ΜΟΝΙΜΟΥ ΥΛΙΚΟΥ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ· ΜΗΧΑΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΕΛΕΓΧΟΥ ΤΗΣ ΚΥΚΛΟΦΟΡΙΑΣ',
  },
  {
    label: '30209000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΑΤΑΣΚΕΥΗΣ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ (\\ΟΛΟΚΛΗΡΩΣΗΣ\\) ΜΗΧΑΝΩΝ ΚΑΙ ΤΡΟΧΑΙΟΥ ΕΞΟΠΛΙΣΜΟΥ ΣΙΔΗΡΟΔΡΟΜΩΝ ΚΑΙ ΤΡΟΧΙΟΔΡΟΜΩΝ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΩΝ ΚΑΙ ΤΡΟΧΑΙΟΥ ΕΞΟΠΛΙΣΜΟΥ ΣΙΔΗΡΟΔΡΟΜΩΝ',
  },
  {
    label: '30209100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΑΤΑΣΚΕΥΗΣ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ (\\ΟΛΟΚΛΗΡΩΣΗΣ\\) ΜΗΧΑΝΩΝ ΚΑΙ ΤΡΟΧΑΙΟΥ ΕΞΟΠΛΙΣΜΟΥ ΣΙΔΗΡΟΔΡΟΜΩΝ ΚΑΙ ΤΡΟΧΙΟΔΡΟΜΩΝ',
  },
  {
    label: '30209900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΗΧΑΝΩΝ ΚΑΙ ΤΡΟΧΑΙΟΥ ΕΞΟΠΛΙΣΜΟΥ ΣΙΔΗΡΟΔΡΟΜΩΝ',
  },
  {
    label: '30300000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΔΙΑΣΤΗΜΟΠΛΟΙΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '30301000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΩΝ ΚΑΙ ΚΙΝΗΤΗΡΩΝ ΓΙΑ ΑΕΡΟΣΚΑΦΗ Η ΔΙΑΣΤΗΜΙΚΑ ΟΧΗΜΑΤΑ· ΕΞΟΠΛΙΣΜΟΥ ΕΔΑΦΟΥΣ ΓΙΑ ΤΗΝ ΕΚΠΑΙΔΕΥΣΗ ΣΤΗΝ ΠΤΗΣΗ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '30301100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΑΕΡΟΣΚΑΦΩΝ ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ',
  },
  {
    label: '30301200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΤΡΟΒΙΛΟΚΙΝΗΤΗΡΩΝ ΚΑΙ ΕΛΙΚΟΣΤΡΟΒΙΛΟΚΙΝΗΤΗΡΩΝ',
  },
  {
    label: '30301300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΑΝΤΙΔΡΑΣΗΣ, ΕΚΤΟΣ ΤΩΝ ΣΤΡΟΒΙΛΟΚΙΝΗΤΗΡΩΝ',
  },
  {
    label: '30301400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΞΟΠΛΙΣΜΟΥ ΕΔΑΦΟΥΣ ΓΙΑ ΤΗΝ ΕΚΠΑΙΔΕΥΣΗ ΣΤΗΝ ΠΤΗΣΗ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '30301500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΙΝΗΤΗΡΩΝ ΑΕΡΟΣΚΑΦΩΝ ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ',
  },
  {
    label: '30302000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΕΡΟΣΤΑΤΩΝ ΚΑΙ ΠΗΔΑΛΙΟΥΧΟΥΜΕΝΩΝ· ΑΝΕΜΟΠΤΕΡΩΝ, ΑΙΩΡΟΠΛΑΝΩΝ ΚΑΙ ΑΛΛΩΝ ΜΗ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΑΕΡΟΣΚΑΦΩΝ',
  },
  {
    label: '30303000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΛΙΚΟΠΤΕΡΩΝ ΚΑΙ ΑΕΡΟΠΛΑΝΩΝ',
  },
  {
    label: '30303100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΛΙΚΟΠΤΕΡΩΝ',
  },
  {
    label: '30303200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΕΡΟΠΛΑΝΩΝ ΚΑΙ ΑΛΛΩΝ ΑΕΡΟΣΚΑΦΩΝ, ΒΑΡΟΥΣ ΧΩΡΙΣ ΦΟΡΤΙΟ <= 2 ;0; KG',
  },
  {
    label: '30303300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΕΡΟΠΛΑΝΩΝ ΚΑΙ ΑΛΛΩΝ ΑΕΡΟΣΚΑΦΩΝ, ΒΑΡΟΥΣ ΧΩΡΙΣ ΦΟΡΤΙΟ > 2 ;0; KG ΑΛΛΑ <= 15 ;0; KG',
  },
  {
    label: '30303400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΕΡΟΠΛΑΝΩΝ ΚΑΙ ΑΛΛΩΝ ΑΕΡΟΣΚΑΦΩΝ, ΒΑΡΟΥΣ ΧΩΡΙΣ ΦΟΡΤΙΟ > 15 ;.000 ~ KG',
  },
  {
    label: '30304000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΔΙΑΣΤΗΜΙΚΩΝ ΟΧΗΜΑΤΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΔΟΡΥΦΟΡΩΝ) ΚΑΙ ΟΧΗΜΑΤΩΝ ΕΚΤΟΞΕΥΣΗΣ ΔΙΑΣΤΗΜΙΚΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '30305000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΕΡΩΝ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΔΙΑΣΤΗΜΙΚΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '30306000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΜΕΤΑΤΡΟΠΗΣ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΚΙΝΗΤΗΡΩΝ ΑΕΡΟΣΚΑΦΩΝ',
  },
  {
    label: '30309000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΕΡΟΣΚΑΦΩΝ, ΔΙΑΣΤΗΜΟΠΛΟΙΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '30400000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΤΡΑΤΙΩΤΙΚΩΝ ΟΧΗΜΑΤΩΝ ΜΑΧΗΣ',
  },
  {
    label: '30401000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΑΡΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΤΕΘΩΡΑΚΙΣΜΕΝΩΝ ΟΧΗΜΑΤΩΝ ΜΑΧΗΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '30409000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΣΤΡΑΤΙΩΤΙΚΩΝ ΟΧΗΜΑΤΩΝ ΜΑΧΗΣ',
  },
  {
    label: '30910000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '30911000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΠΛΕΥΡΙΚΩΝ ΚΑΛΑΘΙΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '30911100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΔΙΤΡΟΧΩΝ ΜΕ ΒΟΗΘΗΤΙΚΟ ΚΙΝΗΤΗΡΑ, ΜΕ ΠΑΛΙΝΔΡΟΜΙΚΟ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΚΥΛΙΝΔΡΙΣΜΟΥ <= 50 ~ CM³ ',
  },
  {
    label: '30911200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΤΟΣΙΚΛΕΤΩΝ ΜΕ ΠΑΛΙΝΔΡΟΜΙΚΟ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΚΥΛΙΝΔΡΙΣΜΟΥ > 50 ~ CM³ ',
  },
  {
    label: '30911300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΟΤΟΣΙΚΛΕΤΩΝ Π.Δ.Κ.Α.· ΠΛΕΥΡΙΚΩΝ ΚΑΛΑΘΙΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '30912000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΠΛΕΥΡΙΚΩΝ ΚΑΛΑΘΙΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '30913000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΤΟΥ ΕΙΔΟΥΣ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΣΤΙΣ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '30913100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΜΕ ΠΑΛΙΝΔΡΟΜΙΚΑ ΕΜΒΟΛΑ, ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΚΥΛΙΝΔΡΙΣΜΟΥ <= 1 ;.000 ~ CM³ ;, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '30913200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΜΕ ΠΑΛΙΝΔΡΟΜΙΚΑ ΕΜΒΟΛΑ, ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΚΥΛΙΝΔΡΙΣΜΟΥ > 1 ;.000 ~ CM³ ;, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '30919000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '30920000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΟΔΗΛΑΤΩΝ ΚΑΙ ΑΝΑΠΗΡΙΚΩΝ ΑΜΑΞΙΔΙΩΝ',
  },
  {
    label: '30921000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΟΔΗΛΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΤΡΟΧΩΝ, ΧΩΡΙΣ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '30922000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΝΑΠΗΡΙΚΩΝ ΚΑΡΟΤΣΙΩΝ, ΕΚΤΟΣ ΑΠΟ ΜΕΡΗ ΚΑΙ ΕΞΑΡΤΗΜΑΤΑ ΤΟΥΣ',
  },
  {
    label: '30923000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΠΟΔΗΛΑΤΑ ΚΑΙ ΑΛΛΑ ΔΙΤΡΟΧΑ, ΧΩΡΙΣ ΚΙΝΗΤΗΡΑ, ΚΑΙ ΓΙΑ ΑΝΑΠΗΡΙΚΑ ΚΑΡΟΤΣΑΚΙΑ',
  },
  {
    label: '30924000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΑΙΔΙΚΩΝ ΚΑΡΟΤΣΙΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '30929000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΠΟΔΗΛΑΤΩΝ ΚΑΙ ΑΝΑΠΗΡΙΚΩΝ ΚΑΡΟΤΣΙΩΝ',
  },
  {
    label: '30990000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΛΟΙΠΟΥ ΕΞΟΠΛΙΣΜΟΥ ΜΕΤΑΦΟΡΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '30991001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΙΠΠΗΛΑΤΩΝ ΑΜΑΞΙΩΝ',
  },
  {
    label: '30999000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΜΕΤΑΦΟΡΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '31010000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΠΙΠΛΩΝ ΓΙΑ ΓΡΑΦΕΙΑ ΚΑΙ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '31011000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΠΙΠΛΩΝ ΓΡΑΦΕΙΩΝ ΚΑΙ ΚΑΤΑΣΤΗΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '31011100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΕΠΙΠΛΩΝ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΚΑΙ ΤΩΝ ΚΑΘΙΣΜΑΤΩΝ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΓΡΑΦΕΙΑ ΚΑΙ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '31011200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΚΑΙ ΤΩΝ ΚΑΘΙΣΜΑΤΩΝ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΓΡΑΦΕΙΑ',
  },
  {
    label: '31011201',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ ΓΡΑΦΕΙΟΥ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΜΕΧΡΙ ΚΑΙ ΔΥΟ ΕΡΓΑΤΕΣ',
  },
  {
    label: '31011202',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ ΓΡΑΦΕΙΟΥ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΤΡΕΙΣ ΚΑΙ ΑΝΩ ΕΡΓΑΤΕΣ',
  },
  {
    label: '31011300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ ΓΙΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '31011301',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΜΕΧΡΙ ΚΑΙ ΔΥΟ ΕΡΓΑΤΕΣ',
  },
  {
    label: '31011302',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΤΡΕΙΣ ΚΑΙ ΑΝΩ ΕΡΓΑΤΕΣ',
  },
  {
    label: '31019000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΕΠΙΠΛΩΝ ΓΡΑΦΕΙΩΝ ΚΑΙ ΚΑΤΑΣΤΗΜΑΤΩΝ',
  },
  {
    label: '31019100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΠΕΤΣΑΡΙΣΜΑΤΟΣ ΚΑΡΕΚΛΩΝ ΚΑΙ ΚΑΘΙΣΜΑΤΩΝ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '31019900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΕΠΙΠΛΩΝ ΓΡΑΦΕΙΩΝ ΚΑΙ ΚΑΤΑΣΤΗΜΑΤΩΝ',
  },
  {
    label: '31020000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΠΙΠΛΩΝ ΚΟΥΖΙΝΑΣ',
  },
  {
    label: '31021001',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ ΚΟΥΖΙΝΑΣ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΜΕΧΡΙ ΚΑΙ ΔΥΟ ΕΡΓΑΤΕΣ',
  },
  {
    label: '31021002',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ ΚΟΥΖΙΝΑΣ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΤΡΕΙΣ ΚΑΙ ΑΝΩ ΕΡΓΑΤΕΣ',
  },
  {
    label: '31029000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΕΠΙΠΛΩΝ ΚΟΥΖΙΝΑΣ',
  },
  {
    label: '31030000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΤΡΩΜΑΤΩΝ',
  },
  {
    label: '31031000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΤΗΡΙΓΜΑΤΩΝ ΣΤΡΩΜΑΤΩΝ· ΣΤΡΩΜΑΤΩΝ',
  },
  {
    label: '31031100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΤΗΡΙΓΜΑΤΩΝ ΣΤΡΩΜΑΤΩΝ',
  },
  {
    label: '31031101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΟΜΙΕΔΩΝ',
  },
  {
    label: '31031200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΤΡΩΜΑΤΩΝ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΣΤΗΡΙΓΜΑΤΑ ΣΤΡΩΜΑΤΩΝ',
  },
  {
    label: '31031201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΤΡΩΜΑΤΩΝ ΜΕ ΜΕΤΑΛΛΙΚΟ ΕΞΟΠΛΙΣΜΟ (ΣΤΡΩΜΑΤΕΞ)',
  },
  {
    label: '31039000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΣΤΡΩΜΑΤΩΝ',
  },
  {
    label: '31090000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΠΙΠΛΩΝ',
  },
  {
    label: '31091000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΠΙΠΛΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '31091100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΕΠΙΠΛΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '31091200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΚΡΕΒΑΤΟΚΑΜΑΡΕΣ, ΤΡΑΠΕΖΑΡΙΕΣ ΚΑΙ ΣΤΟ ΚΑΘΙΣΤΙΚΑ',
  },
  {
    label: '31091201',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΞΥΛΙΝΩΝ ΟΙΚΙΑΚΩΝ ΕΠΙΠΛΩΝ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΜΕΧΡΙ ΚΑΙ ΔΥΟ ΕΡΓΑΤΕΣ',
  },
  {
    label: '31091202',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΞΥΛΙΝΩΝ ΟΙΚΙΑΚΩΝ ΕΠΙΠΛΩΝ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΤΡΕΙΣ ΚΑΙ ΑΝΩ ΕΡΓΑΤΕΣ',
  },
  {
    label: '31091203',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΡΕΒΑΤΙΩΝ',
  },
  {
    label: '31091300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '31091301',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΜΕΧΡΙ ΚΑΙ ΔΥΟ ΕΡΓΑΤΕΣ',
  },
  {
    label: '31091302',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ, ΑΠΟ ΜΟΝΑΔΑ ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΤΡΕΙΣ ΚΑΙ ΑΝΩ ΕΡΓΑΤΕΣ',
  },
  {
    label: '31091400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΙΠΛΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ Η ΑΠΟ ΑΛΛΑ ΥΛΙΚΑ (ΟΠΩΣ Π.Χ. ΑΠΟ ΚΑΛΑΜΙΑ, ΛΥΓΑΡΙΕΣ Η ΜΠΑΜΠΟΥ)',
  },
  {
    label: '31091401',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΛΕΚΤΩΝ ΕΠΙΠΛΩΝ',
  },
  {
    label: '31099000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΕΛΕΙΟΠΟΙΗΣΗΣ (ΦΙΝΙΡΙΣΜΑΤΟΣ) ΝΕΩΝ ΕΠΙΠΛΩΝ· ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΕΠΙΠΛΩΝ',
  },
  {
    label: '31099100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΑΠΕΤΣΑΡΙΣΜΑΤΟΣ ΚΑΡΕΚΛΩΝ ΚΑΙ ΚΑΘΙΣΜΑΤΩΝ, ΟΧΙ ΓΡΑΦΕΙΟΥ ΚΑΙ ΕΚΤΟΣ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '31099200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΕΛΕΙΟΠΟΙΗΣΗΣ (ΦΙΝΙΡΙΣΜΑΤΟΣ) ΝΕΩΝ ΕΠΙΠΛΩΝ (ΕΚΤΟΣ ΤΟΥ ΤΑΠΕΤΣΑΡΙΣΜΑΤΟΣ ΚΑΡΕΚΛΩΝ ΚΑΙ ΚΑΘΙΣΜΑΤΩΝ)',
  },
  {
    label: '31099201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΚΑΤΑΣΤΑΣΗΣ ΚΑΙ ΑΝΑΚΑΙΝΙΣΗΣ ΕΠΙΠΛΩΝ',
  },
  {
    label: '31099202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΙΛΒΩΣΗΣ ΕΠΙΠΛΩΝ (ΛΟΥΣΤΡΑΔΟΡΟΥ)',
  },
  {
    label: '31099203',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΑΡΜΟΛΟΓΗΣΗΣ ΕΠΙΠΛΩΝ',
  },
  {
    label: '31099204',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΨΕΚΑΣΜΟΥ, ΛΟΥΣΤΡΑΡΙΣΜΑΤΟΣ, ΒΕΡΝΙΚΩΜΑΤΟΣ, ΕΠΙΧΡΥΣΩΣΗΣ ΚΑΙ ΒΑΨΙΜΑΤΟΣ ΕΠΙΠΛΩΝ',
  },
  {
    label: '31099900',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΕΠΙΠΛΩΝ',
  },
  {
    label: '32110000',
    value: 'ΚΟΠΗ ΝΟΜΙΣΜΑΤΩΝ',
  },
  {
    label: '32119000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΝΟΜΙΣΜΑΤΩΝ',
  },
  {
    label: '32120000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΟΣΜΗΜΑΤΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32121100',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΛΛΙΕΡΓΗΜΕΝΩΝ ΜΑΡΓΑΡΙΤΑΡΙΩΝ, ΠΟΛΥΤΙΜΩΝ Η ΗΜΙΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΣΥΝΘΕΤΙΚΩΝ Η ΑΝΑΣΧΗΜΑΤΙΣΜΕΝΩΝ ΛΙΘΩΝ, ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΑΛΛΑ ΟΧΙ ΔΕΜΕΝΩΝ ΣΕ ΚΟΣΜΗΜΑΤΑ',
  },
  {
    label: '32121101',
    value: 'ΠΑΡΑΓΩΓΗ ΗΜΙΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ',
  },
  {
    label: '32121102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΔΑΜΑΝΤΟΔΕΣΗΣ, ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΑΙ ΛΕΙΑΝΣΗΣ ΦΥΣΙΚΩΝ ΔΙΑΜΑΝΤΙΩΝ',
  },
  {
    label: '32121200',
    value:
      'ΕΠΕΞΕΡΓΑΣΙΑ ΒΙΟΜΗΧΑΝΙΚΩΝ ΔΙΑΜΑΝΤΙΩΝ, ΚΑΤΕΡΓΑΣΜΕΝΩΝ· ΣΚΟΝΩΝ ΦΥΣΙΚΩΝ Η ΣΥΝΘΕΤΙΚΩΝ ΠΟΛΥΤΙΜΩΝ Η ΗΜΙΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ',
  },
  {
    label: '32121201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΔΑΜΑΝΤΟΔΕΣΗΣ, ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΑΙ ΛΕΙΑΝΣΗΣ ΒΙΟΜΗΧΑΝΙΚΩΝ ΔΙΑΜΑΝΤΙΩΝ',
  },
  {
    label: '32121300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΚΟΣΜΗΜΑΤΟΠΟΙΙΑΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ· ΕΙΔΩΝ ΧΡΥΣΟΧΟΪΑΣ Η ΑΡΓΥΡΟΧΟΪΑΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '32121301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΑΠΟ ΑΡΓΥΡΟ',
  },
  {
    label: '32121302',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΧΡΥΣΟΧΟΪΑΣ',
  },
  {
    label: '32121303',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΚΟΣΜΗΜΑΤΑ ΑΠΟ ΑΡΓΥΡΟ (ΣΥΡΜΑΤΟΣ, ΦΥΛΛΩΝ, ΣΩΛΗΝΩΝ, ΧΥΤΩΝ ΚΛΠ)',
  },
  {
    label: '32121304',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΞΑΡΤΗΜΑΤΩΝ ΧΡΥΣΟΧΟΪΑΣ (ΣΥΡΜΑΤΟΣ, ΦΥΛΛΩΝ, ΣΩΛΗΝΩΝ, ΧΥΤΩΝ ΚΛΠ)',
  },
  {
    label: '32121305',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΚΕΥΩΝ ΑΠΟ ΑΡΓΥΡΟ',
  },
  {
    label: '32121306',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΡΥΣΩΝ ΚΑΔΕΝΩΝ',
  },
  {
    label: '32121307',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΡΥΣΩΝ ΚΑΙ ΑΡΓΥΡΩΝ ΚΟΣΜΗΜΑΤΩΝ',
  },
  {
    label: '32121400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΠΟΛΥΤΙΜΑ ΜΕΤΑΛΛΑ· ΕΙΔΩΝ ΑΠΟ ΦΥΣΙΚΑ Η ΚΑΛΛΙΕΡΓΗΜΕΝΑ ΜΑΡΓΑΡΙΤΑΡΙΑ, ΠΟΛΥΤΙΜΟΥΣ Η ΗΜΙΠΟΛΥΤΙΜΟΥΣ ΛΙΘΟΥΣ',
  },
  {
    label: '32129000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΚΟΣΜΗΜΑΤΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32129901',
    value: 'ΕΡΓΑΣΙΕΣ ΦΙΝΙΡΙΣΜΑΤΟΣ ΤΕΧΝΟΥΡΓΗΜΑΤΩΝ ΑΠΟ ΧΡΥΣΟ ΚΑΙ ΑΡΓΥΡΟ ΦΑΣΟΝ',
  },
  {
    label: '32129902',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΡΓΥΡΩΝ ΚΟΣΜΗΜΑΤΩΝ ΦΑΣΟΝ',
  },
  {
    label: '32129903',
    value: 'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΧΡΥΣΟΧΟΪΑΣ ΦΑΣΟΝ',
  },
  {
    label: '32129904',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΚΕΥΩΝ ΑΠΟ ΑΡΓΥΡΟ ΦΑΣΟΝ',
  },
  {
    label: '32129905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΙΛΒΩΣΗΣ ΚΟΣΜΗΜΑΤΩΝ',
  },
  {
    label: '32129906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΑΡΑΞΗΣ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΠΟΛΥΤΙΜΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '32129907',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΑΡΑΞΗΣ ΠΟΛΥΤΙΜΩΝ ΜΕΤΑΛΛΩΝ ΕΙΔΩΝ ΚΟΣΜΗΜΑΤΟΠΟΙΙΑΣ, ΧΡΥΣΟΧΟΪΑΣ, ΑΡΓΥΡΟΧΟΪΑΣ',
  },
  {
    label: '32130000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΟΣΜΗΜΑΤΩΝ ΑΠΟΜΙΜΗΣΗΣ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32131001',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΣΜΗΜΑΤΩΝ ΑΠΟ ΠΛΑΣΤΙΚΟ, ΥΦΑΣΜΑ, ΞΥΛΟ, ΟΣΤΡΑΚΑ, ΜΗ ΠΟΛΥΤΙΜΕΣ ΠΕΤΡΕΣ, ΚΟΙΝΑ ΜΕΤΑΛΛΑ ΚΑΙ ΑΛΛΑ ΥΛΙΚΑ',
  },
  {
    label: '32139000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΠΟΜΙΜΗΣΕΩΝ ΚΟΣΜΗΜΑΤΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32200000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '32201000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΙΑΝΩΝ ΚΑΙ ΑΛΛΩΝ ΕΓΧΟΡΔΩΝ ΚΑΙ ΠΝΕΥΣΤΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ, ΗΛΕΚΤΡΙΚΩΝ ΟΡΓΑΝΩΝ ΜΕ ΚΛΙΜΑΚΑ ΠΛΗΚΤΡΩΝ, ΜΕΤΡΟΝΟΜΩΝ, ΔΙΑΠΑΣΩΝ· ΜΗΧΑΝΙΣΜΩΝ ΓΙΑ ΜΟΥΣΙΚΑ ΚΟΥΤΙΑ',
  },
  {
    label: '32201100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΙΑΝΩΝ ΚΑΙ ΑΛΛΩΝ ΕΓΧΟΡΔΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ ΜΕ ΚΛΙΜΑΚΑ ΠΛΗΚΤΡΩΝ',
  },
  {
    label: '32201200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΓΧΟΡΔΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '32201300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΚΚΛΗΣΙΑΣΤΙΚΩΝ ΟΡΓΑΝΩΝ ΜΕ ΚΛΙΜΑΚΑ ΠΛΗΚΤΡΩΝ, ΑΡΜΟΝΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΟΡΓΑΝΩΝ· ΑΚΟΡΝΤΕΟΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΟΡΓΑΝΩΝ· ΦΥΣΑΡΜΟΝΙΚΩΝ· ΠΝΕΥΣΤΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '32201400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ Η ΟΡΓΑΝΩΝ ΜΕ ΚΛΙΜΑΚΑ ΠΛΗΚΤΡΩΝ, Ο ΗΧΟΣ ΤΩΝ ΟΠΟΙΩΝ ΠΑΡΑΓΕΤΑΙ Η ΠΡΕΠΕΙ ΝΑ ΕΝΙΣΧΥΕΤΑΙ ΜΕ ΗΛΕΚΤΡΙΚΑ ΜΕΣΑ',
  },
  {
    label: '32201500',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '32201600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΤΡΟΝΟΜΩΝ, ΔΙΑΠΑΣΩΝ ΚΑΙ ΠΝΕΥΣΤΩΝ ΔΙΑΠΑΣΩΝ· ΜΗΧΑΝΙΣΜΩΝ ΓΙΑ ΜΟΥΣΙΚΑ ΚΟΥΤΙΑ· ΧΟΡΔΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '32202000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '32209000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '32300000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΘΛΗΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32301100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΙΟΝΟΠΕΔΙΛΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΧΙΟΝΟΠΕΔΙΛΑ, ΕΚΤΟΣ ΥΠΟΔΗΜΑΤΩΝ· ΠΑΓΟΠΕΔΙΛΩΝ ΚΑΙ ΤΡΟΧΟΠΕΔΙΛΩΝ· ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '32301200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΧΙΟΝΟΠΕΔΙΛΩΝ',
  },
  {
    label: '32301300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΕΔΙΛΩΝ ΓΙΑ ΘΑΛΑΣΣΙΟ ΣΚΙ, ΚΥΜΑΤΟΣΑΝΙΔΩΝ, ΙΣΤΙΟΣΑΝΙΔΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΝΑΥΤΙΚΑ ΑΘΛΗΜΑΤΑ',
  },
  {
    label: '32301400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΥΜΝΑΣΤΗΡΙΩΝ Η ΑΘΛΗΤΙΚΩΝ ΕΙΔΩΝ ΚΑΙ ΑΘΛΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '32301401',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ ΓΥΜΝΑΣΤΙΚΗΣ',
  },
  {
    label: '32301402',
    value: 'ΚΑΤΑΣΚΕΥΗ ΡΑΚΕΤΩΝ ΑΝΤΙΣΦΑΙΡΙΣΗΣ',
  },
  {
    label: '32301500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΑΘΛΗΤΙΣΜΟ Η ΓΙΑ ΥΠΑΙΘΡΙΟΥΣ ΑΓΩΝΕΣ· ΚΟΛΥΜΒΗΤΙΚΩΝ ΔΕΞΑΜΕΝΩΝ ΚΑΙ ΔΕΞΑΜΕΝΩΝ ΚΩΠΗΛΑΣΙΑΣ',
  },
  {
    label: '32301600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΛΑΜΙΩΝ ΨΑΡΕΜΑΤΟΣ, ΑΛΛΩΝ ΣΥΝΕΡΓΩΝ ΨΑΡΕΜΑΤΟΣ ΜΕ ΠΕΤΟΝΙΑ· ΕΙΔΩΝ ΚΥΝΗΓΙΟΥ Η ΨΑΡΕΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '32309000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΘΛΗΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32400000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΑΙΧΝΙΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '32401000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΥΚΛΩΝ ΠΟΥ ΑΝΑΠΑΡΙΣΤΟΥΝ ΜΟΝΟ ΑΝΘΡΩΠΙΝΕΣ ΥΠΑΡΞΕΙΣ· ΠΑΙΧΝΙΔΙΩΝ ΠΟΥ ΑΝΑΠΑΡΙΣΤΟΥΝ ΖΩΑ Η ΜΗ ΑΝΘΡΩΠΙΝΕΣ ΥΠΑΡΞΕΙΣ· ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '32401100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΟΥΚΛΩΝ ΠΟΥ ΑΝΑΠΑΡΙΣΤΟΥΝ ΜΟΝΟ ΑΝΘΡΩΠΙΝΕΣ ΥΠΑΡΞΕΙΣ',
  },
  {
    label: '32401200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΑΙΧΝΙΔΙΩΝ ΠΟΥ ΑΝΑΠΑΡΙΣΤΟΥΝ ΖΩΑ Η ΜΗ ΑΝΘΡΩΠΙΝΕΣ ΥΠΑΡΞΕΙΣ',
  },
  {
    label: '32401300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΚΟΥΚΛΕΣ ΠΟΥ ΑΝΑΠΑΡΙΣΤΟΥΝ ΑΝΘΡΩΠΙΝΕΣ ΥΠΑΡΞΕΙΣ',
  },
  {
    label: '32402000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΑΙΔΙΚΩΝ ΤΡΕΝΩΝ ΚΑΙ ΤΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ· ΑΛΛΩΝ ΜΟΝΤΕΛΩΝ Η ΚΑΤΑΣΚΕΥΩΝ ΥΠΟ ΚΛΙΜΑΚΑ ΚΑΙ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΠΑΙΧΝΙΔΙΩΝ',
  },
  {
    label: '32403000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΑΙΧΝΙΔΙΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΠΑΙΔΙΚΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '32403100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΡΟΧΟΦΟΡΩΝ ΠΑΙΧΝΙΔΙΩΝ ΣΧΕΔΙΑΣΜΕΝΩΝ ΓΙΑ ΝΑ ΕΠΙΒΑΙΝΟΥΝ ΠΑΙΔΙΑ· ΚΑΡΟΤΣΙΩΝ ΓΙΑ ΚΟΥΚΛΕΣ',
  },
  {
    label: '32403200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΥΝΑΡΜΟΛΟΓΟΥΜΕΝΩΝ ΠΑΙΧΝΙΔΙΩΝ;ΣΠΑΖΟΚΕΦΑΛΙΩΝ',
  },
  {
    label: '32403900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΑΙΧΝΙΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ Π.Δ.Κ.Α.',
  },
  {
    label: '32404000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΠΑΙΧΝΙΔΙΩΝ',
  },
  {
    label: '32404100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΑΙΓΝΙΟΧΑΡΤΩΝ (ΤΡΑΠΟΥΛΩΝ)',
  },
  {
    label: '32404200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΙΔΩΝ ΓΙΑ ΣΦΑΙΡΙΣΤΗΡΙΑ, ΕΙΔΩΝ ΓΙΑ ΛΟΥΝΑ ΠΑΡΚ, ΓΙΑ ΕΠΙΤΡΑΠΕΖΙΑ ΠΑΙΧΝΙΔΙΑ Η ΓΙΑ ΠΑΙΧΝΙΔΙΑ ΣΥΝΑΝΑΣΤΡΟΦΗΣ· ΑΛΛΩΝ ΠΑΙΧΝΙΔΙΩΝ ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΝΟΜΙΣΜΑΤΟΔΕΚΤΗ Η ΜΕ ΔΙΣΚΕΤΑ',
  },
  {
    label: '32404201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΠΙΛΙΑΡΔΩΝ',
  },
  {
    label: '32409000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΠΑΙΧΝΙΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '32500000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΙΑΤΡΙΚΩΝ ΚΑΙ ΟΔΟΝΤΙΑΤΡΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ',
  },
  {
    label: '32501000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΙΑΤΡΙΚΩΝ, ΧΕΙΡΟΥΡΓΙΚΩΝ ΚΑΙ ΟΔΟΝΤΙΑΤΡΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '32501100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗΝ ΟΔΟΝΤΙΑΤΡΙΚΗ ΑΓΩΓΗ',
  },
  {
    label: '32501200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΙΑΤΡΙΚΩΝ, ΧΕΙΡΟΥΡΓΙΚΩΝ Η ΕΡΓΑΣΤΗΡΙΑΚΩΝ ΑΠΟΣΤΕΙΡΩΤΗΡΩΝ',
  },
  {
    label: '32501300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΡΙΓΓΩΝ, ΒΕΛΟΝΩΝ, ΚΑΘΕΤΗΡΩΝ, ΣΩΛΗΝΙΣΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ· ΟΦΘΑΛΜΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '32502000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΘΕΡΑΠΕΥΤΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ· ΣΥΣΚΕΥΩΝ ΜΕΤΡΗΣΕΩΝ, ΠΡΟΘΕΣΕΩΝ (ΤΕΧΝΗΤΩΝ ΜΕΛΩΝ) ΚΑΙ ΟΡΘΟΠΕΔΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '32502100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΘΕΡΑΠΕΥΤΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ· ΑΝΑΠΝΕΥΣΤΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '32502200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΕΧΝΗΤΩΝ ΑΡΘΡΩΣΕΩΝ· ΟΡΘΟΠΕΔΙΚΩΝ ΣΥΣΚΕΥΩΝ· ΤΕΧΝΗΤΩΝ ΔΟΝΤΙΩΝ· ΟΔΟΝΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ· ΤΕΧΝΗΤΩΝ ΜΕΛΩΝ ΤΟΥ ΣΩΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '32502201',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΡΘΟΠΕΔΙΚΩΝ ΕΙΔΩΝ ΑΠΟ ΥΦΑΣΜΑ, ΕΛΑΣΤΙΚΟ ΝΗΜΑ Η ΛΑΣΤΙΧΟ ΚΑΙ ΣΥΝΑΦΕΙΣ ΥΛΕΣ',
  },
  {
    label: '32502202',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΡΘΟΠΕΔΙΚΩΝ ΕΙΔΩΝ, ΚΗΛΕΠΙΔΕΣΜΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32502203',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΕΧΝΗΤΩΝ ΔΟΝΤΙΩΝ (ΕΡΓΑΣΙΕΣ ΟΔΟΝΤΟΤΕΧΝΙΤΗ)',
  },
  {
    label: '32502300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΠΡΟΘΕΣΕΩΝ (ΤΕΧΝΗΤΩΝ ΜΕΛΩΝ) ΚΑΙ ΟΡΘΟΠΕΔΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '32503000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΠΙΠΛΩΝ ΓΙΑ ΤΗΝ ΙΑΤΡΙΚΗ, ΤΗ ΧΕΙΡΟΥΡΓΙΚΗ, ΤΗΝ ΟΔΟΝΤΙΑΤΡΙΚΗ Η ΤΗΝ ΚΤΗΝΙΑΤΡΙΚΗ· ΚΑΘΙΣΜΑΤΩΝ ΚΟΜΜΩΤΗΡΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΚΑΘΙΣΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '32504000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΦΘΑΛΜΙΚΩΝ ΓΥΑΛΙΩΝ, ΦΑΚΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '32504100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΦΑΚΩΝ ΕΠΑΦΗΣ· ΦΑΚΩΝ ΟΦΘΑΛΜΙΚΩΝ ΓΥΑΛΙΩΝ ΑΠΟ ΟΠΟΙΟΔΗΠΟΤΕ ΥΛΙΚΟ',
  },
  {
    label: '32504200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΥΑΛΙΩΝ, ΠΡΟΦΥΛΑΚΤΙΚΩΝ ΟΦΘΑΛΜΙΚΩΝ ΓΥΑΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΔΙΟΡΘΩΤΙΚΩΝ, ΠΡΟΣΤΑΤΕΥΤΙΚΩΝ Η ΑΛΛΩΝ',
  },
  {
    label: '32504300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΚΕΛΕΤΩΝ ΚΑΙ ΥΠΟΣΤΗΡΙΓΜΑΤΩΝ ΟΦΘΑΛΜΙΚΩΝ ΓΥΑΛΙΩΝ, ΠΡΟΦΥΛΑΚΤΙΚΩΝ ΟΦΘΑΛΜΙΚΩΝ ΓΥΑΛΙΩΝ Η ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32504301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΚΕΛΕΤΩΝ ΜΑΤΟΓΥΑΛΙΩΝ',
  },
  {
    label: '32504400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΣΚΕΛΕΤΩΝ ΚΑΙ ΥΠΟΣΤΗΡΙΓΜΑΤΩΝ ΟΦΘΑΛΜΙΚΩΝ ΓΥΑΛΙΩΝ, ΠΡΟΦΥΛΑΚΤΙΚΩΝ ΟΦΘΑΛΜΙΚΩΝ ΓΥΑΛΙΩΝ Η ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32505000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΙΑΤΡΙΚΗΣ Η ΧΕΙΡΟΥΡΓΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '32509000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΙΑΤΡΙΚΟΥ ΚΑΙ ΧΕΙΡΟΥΡΓΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΟΡΘΟΠΕΔΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '32910000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΚΟΥΠΩΝ ΚΑΙ ΒΟΥΡΤΣΩΝ',
  },
  {
    label: '32911100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΚΟΥΠΩΝ ΚΑΙ ΒΟΥΡΤΣΩΝ ΓΙΑ ΟΙΚΙΑΚΗ ΚΑΘΑΡΙΟΤΗΤΑ',
  },
  {
    label: '32911200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΔΟΝΤΟΒΟΥΡΤΣΩΝ, ΨΗΚΤΡΩΝ ΚΑΙ ΠΙΝΕΛΩΝ ΓΙΑ ΤΑ ΓΕΝΙΑ, ΤΑ ΜΑΛΛΙΑ ΤΗΣ ΚΕΦΑΛΗΣ ΚΑΙ ΑΛΛΩΝ ΨΗΚΤΡΩΝ ΓΙΑ ΤΟΝ ΑΤΟΜΙΚΟ ΚΑΛΛΩΠΙΣΜΟ· ΠΙΝΕΛΩΝ ΚΑΙ ΨΗΚΤΡΩΝ ΓΙΑ ΚΑΛΛΙΤΕΧΝΕΣ, ΠΙΝΕΛΩΝ ΓΡΑΦΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΙΝΕΛΩΝ ΓΙΑ ΤΗ ΧΡΗΣΗ ΤΩΝ ΚΑΛΛΥΝΤΙΚΩΝ',
  },
  {
    label: '32911900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΒΟΥΡΤΣΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '32919000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΣΚΟΥΠΩΝ ΚΑΙ ΒΟΥΡΤΣΩΝ',
  },
  {
    label: '32990000',
    value: 'ΑΛΛΕΣ ΜΕΤΑΠΟΙΗΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '32991000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΗΣ ΑΣΦΑΛΕΙΑΣ· ΓΡΑΦΙΔΩΝ ΚΑΙ ΜΟΛΥΒΙΩΝ, ΣΦΡΑΓΙΔΩΝ ΑΝΑΓΡΑΦΗΣ ΗΜΕΡΟΜΗΝΙΩΝ, ΣΦΡΑΓΙΣΗΣ Η ΑΡΙΘΜΗΣΗΣ· ΜΕΛΑΝΟΤΑΙΝΙΩΝ ΓΡΑΦΟΜΗΧΑΝΗΣ, ΤΑΜΠΟΝ ΜΕΛΑΝΗΣ',
  },
  {
    label: '32991100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΗΣ ΑΣΦΑΛΕΙΑΣ ΚΑΙ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '32991200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΤΥΛΟΓΡΑΦΩΝ ΜΕ ΣΦΑΙΡΙΔΙΟ· ΣΤΥΛΟΓΡΑΦΩΝ ΚΑΙ ΜΑΡΚΑΔΟΡΩΝ ΜΕ ΜΥΤΗ ΑΠΟ ΠΙΛΗΜΑ (ΤΣΟΧΑ) Η ΑΛΛΟ ΠΟΡΩΔΕΣ ΥΛΙΚΟ· ΜΗΧΑΝΙΚΩΝ Η ΚΙΝΗΤΩΝ ΜΟΛΥΒΙΩΝ',
  },
  {
    label: '32991300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΕΝΩΝ ΓΙΑ ΣΙΝΙΚΗ ΜΕΛΑΝΗ· ΣΤΥΛΟΓΡΑΦΩΝ ΜΕΛΑΝΗΣ, ΑΛΛΩΝ ΣΤΥΛΟΓΡΑΦΩΝ ΚΑΙ ΑΛΛΩΝ ΓΡΑΦΙΔΩΝ',
  },
  {
    label: '32991400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΣΥΛΛΟΓΩΝ ΕΡΓΑΛΕΙΩΝ ΓΡΑΦΗΣ, ΚΟΝΔΥΛΟΦΟΡΩΝ ΚΑΙ ΘΗΚΩΝ ΜΟΛΥΒΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΘΗΚΩΝ· ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '32991500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΟΛΥΒΙΩΝ, ΚΡΑΓΙΟΝΙΩΝ, ΛΕΠΤΩΝ ΡΑΒΔΩΝ ΓΡΑΦΙΤΗ ΓΙΑ ΜΟΛΥΒΙΑ, ΚΡΗΤΙΔΩΝ (ΠΑΣΤΕΛ), ΚΑΡΒΟΥΝΩΝ ΣΧΕΔΙΑΣΗΣ, ΚΙΜΩΛΙΩΝ ΓΡΑΦΗΣ Η ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΚΙΜΩΛΙΩΝ ΡΑΠΤΙΚΗΣ',
  },
  {
    label: '32991600',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΛΑΚΩΝ ΚΑΙ ΠΙΝΑΚΩΝ· ΣΦΡΑΓΙΔΩΝ ΑΝΑΓΡΑΦΗΣ ΗΜΕΡΟΜΗΝΙΩΝ, ΣΦΡΑΓΙΣΗΣ Η ΑΡΙΘΜΗΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΧΡΗΣΕΩΝ· ΜΕΛΑΝΟΤΑΙΝΙΩΝ ΓΡΑΦΟΜΗΧΑΝΩΝ Η ΠΑΡΟΜΟΙΩΝ ΤΑΙΝΙΩΝ· ΤΑΜΠΟΝ ΜΕΛΑΝΗΣ',
  },
  {
    label: '32991601',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΦΡΑΓΙΔΩΝ ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '32992000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΜΠΡΕΛΩΝ· ΜΠΑΣΤΟΥΝΙΩΝ· ΚΟΥΜΠΙΩΝ· ΜΗΤΡΩΝ ΓΙΑ ΚΟΥΜΠΙΑ· ΑΓΚΡΑΦΩΝ· ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '32992100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΟΜΠΡΕΛΩΝ ΒΡΟΧΗΣ ΚΑΙ ΗΛΙΟΥ· ΜΠΑΣΤΟΥΝΙΩΝ, ΡΑΒΔΩΝ ~ ΚΑΘΙΣΜΑΤΩΝ, ΜΑΣΤΙΓΙΩΝ, ΜΑΣΤΙΓΙΩΝ ΙΠΠΑΣΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32992101',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΜΠΡΕΛΩΝ',
  },
  {
    label: '32992200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ, ΣΥΜΠΛΗΡΩΜΑΤΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΟΜΠΡΕΛΩΝ ΒΡΟΧΗΣ Η ΗΛΙΟΥ, ΜΠΑΣΤΟΥΝΙΩΝ, ΡΑΒΔΩΝ;ΚΑΘΙΣΜΑΤΩΝ, ΜΑΣΤΙΓΙΩΝ ΙΠΠΑΣΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32992300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΓΚΡΑΦΩΝ, ΣΟΥΣΤΩΝ, ΚΟΠΙΤΣΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ· ΚΟΥΜΠΙΩΝ· ΦΕΡΜΟΥΑΡ',
  },
  {
    label: '32992301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΟΥΜΠΙΩΝ',
  },
  {
    label: '32992302',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΕΡΜΟΥΑΡ',
  },
  {
    label: '32992400',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΗΤΡΩΝ ΓΙΑ ΚΟΥΜΠΙΑ ΚΑΙ ΑΛΛΩΝ ΜΕΡΩΝ ΚΟΥΜΠΙΩΝ· ΗΜΙΤΕΛΩΝ ΚΟΥΜΠΙΩΝ· ΜΕΡΩΝ ΑΠΟ ΦΕΡΜΟΥΑΡ',
  },
  {
    label: '32993000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΠΡΟΪΟΝΤΩΝ ΑΝΘΡΩΠΙΝΩΝ Η ΖΩΙΚΩΝ ΤΡΙΧΩΝ· ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΑ ΥΛΙΚΑ',
  },
  {
    label: '32993001',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΕΡΟΥΚΩΝ ΚΑΙ ΠΟΣΤΙΣ',
  },
  {
    label: '32994000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΑΠΤΗΡΩΝ, ΠΙΠΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ· ΕΙΔΩΝ ΑΠΟ ΕΥΦΛΕΚΤΑ ΥΛΙΚΑ· ΥΓΡΟΥ Η ΥΓΡΟΠΟΙΗΜΕΝΟΥ ΑΕΡΙΟΥ ΓΙΑ ΑΝΑΠΤΗΡΕΣ',
  },
  {
    label: '32994100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΝΑΠΤΗΡΩΝ ΤΣΙΓΑΡΩΝ ΚΑΙ ΑΛΛΩΝ ΑΝΑΠΤΗΡΩΝ· ΠΙΠΩΝ ΚΑΠΝΙΣΜΑΤΟΣ ΚΑΙ ΠΙΠΩΝ ΓΙΑ ΠΟΥΡΑ ΚΑΙ ΤΣΙΓΑΡΑ, ΚΑΘΩΣ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '32994200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΜΕΡΩΝ ΑΝΑΠΤΗΡΩΝ· ΠΥΡΟΦΟΡΙΚΩΝ ΚΡΑΜΑΤΩΝ· ΕΙΔΩΝ ΑΠΟ ΕΥΦΛΕΚΤΑ ΥΛΙΚΑ',
  },
  {
    label: '32994300',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΥΓΡΩΝ Η ΥΓΡΟΠΟΙΗΜΕΝΩΝ ΑΕΡΙΩΝ ΚΑΥΣΙΜΩΝ ΓΙΑ ΑΝΑΠΤΗΡΕΣ, ΣΕ ΔΟΧΕΙΑ ΧΩΡΗΤΙΚΟΤΗΤΑΣ <= 300 ~ CM3 ',
  },
  {
    label: '32995000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '32995100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΕΟΡΤΑΣΤΙΚΩΝ, ΑΠΟΚΡΙΑΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΨΥΧΑΓΩΓΙΚΩΝ ΕΙΔΩΝ, ΣΤΑ ΟΠΟΙΑ ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΤΑ ΤΑΧΥΔΑΚΤΥΛΟΥΡΓΙΚΑ ΤΕΧΝΑΣΜΑΤΑ (ΤΡΙΚ) ΚΑΙ ΤΑ ΕΙΔΗ;ΕΚΠΛΗΞΕΙΣ',
  },
  {
    label: '32995200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΧΤΕΝΩΝ, ΤΣΙΜΠΙΔΙΩΝ ΜΑΛΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ· ΦΟΥΡΚΕΤΩΝ· ΛΑΒΙΔΩΝ ΚΑΤΣΑΡΩΜΑΤΟΣ· ΒΑΣΕΩΝ ΚΑΙ ΚΕΦΑΛΩΝ ΤΟΥΣ',
  },
  {
    label: '32995201',
    value: 'ΚΑΤΑΣΚΕΥΗ ΦΟΥΡΚΕΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32995300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΡΓΑΝΩΝ, ΣΥΣΚΕΥΩΝ ΚΑΙ ΜΟΝΤΕΛΩΝ ΓΙΑ ΕΠΙΔΕΙΞΕΙΣ',
  },
  {
    label: '32995301',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΝΔΡΕΙΚΕΛΩΝ ΓΙΑ ΠΡΟΘΗΚΕΣ',
  },
  {
    label: '32995400',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΕΡΙΩΝ, ΚΗΡΩΜΕΝΩΝ ΦΙΤΙΛΙΩΝ ΦΩΤΙΣΜΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '32995500',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΕΧΝΗΤΩΝ ΑΝΘΕΩΝ, ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΦΥΛΛΩΜΑΤΩΝ ΚΑΙ ΦΡΟΥΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '32995501',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΕΧΝΗΤΩΝ ΑΝΘΕΩΝ',
  },
  {
    label: '32995900',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΙΑΦΟΡΩΝ ΑΛΛΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '32995901',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΕΙΔΩΝ ΑΠΟ ΠΑΓΟ',
  },
  {
    label: '32995902',
    value: 'ΚΑΤΑΣΚΕΥΗ ΘΕΡΜΟΣ',
  },
  {
    label: '32995903',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΠΟΜΠΟΝΙΕΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΓΑΜΩΝ ΚΑΙ ΒΑΠΤΙΣΕΩΝ',
  },
  {
    label: '32996000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΡΙΧΕΥΣΗΣ',
  },
  {
    label: '32999000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΠΕΡΓΟΛΑΒΙΑΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΔΙΑΔΙΚΑΣΙΑΣ ΚΑΤΑΣΚΕΥΗΣ ΑΛΛΩΝ ΜΕΤΑΠΟΙΗΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '33110000',
    value: 'ΕΠΙΣΚΕΥΗ ΜΕΤΑΛΛΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '33111000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '33111100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΔΟΜΙΚΩΝ ΜΕΤΑΛΛΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '33111101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ (ΜΕ ΕΠΙΣΜΑΛΤΩΣΗ, ΑΛΛΑΓΗ ΧΡΩΜΑΤΟΣ ΚΛΠ) ΜΠΑΝΙΕΡΩΝ ΚΑΙ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ',
  },
  {
    label: '33111200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΕΤΑΛΛΙΚΩΝ ΔΕΞΑΜΕΝΩΝ, ΤΑΜΙΕΥΤΗΡΩΝ ΚΑΙ ΔΟΧΕΙΩΝ',
  },
  {
    label: '33111300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΑΤΜΟΓΕΝΝΗΤΡΙΩΝ, ΕΚΤΟΣ ΤΩΝ ΛΕΒΗΤΩΝ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΖΕΣΤΟΥ ΝΕΡΟΥ',
  },
  {
    label: '33111301',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΛΕΒΗΤΩΝ ΣΕ ΔΙΑΦΟΡΑ ΣΥΣΤΗΜΑΤΑ ΣΩΛΗΝΩΣΕΩΝ',
  },
  {
    label: '33111400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΟΠΛΩΝ ΚΑΙ ΠΥΡΟΜΑΧΙΚΩΝ',
  },
  {
    label: '33111900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΑΛΛΩΝ ΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '33120000',
    value: 'ΕΠΙΣΚΕΥΗ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '33121000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΝΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '33121100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΚΙΝΗΤΗΡΩΝ ΚΑΙ ΣΤΡΟΒΙΛΩΝ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΟΥΣ ΚΙΝΗΤΗΡΕΣ ΑΕΡΟΣΚΑΦΩΝ, ΟΧΗΜΑΤΩΝ ΚΑΙ ΤΩΝ ΔΙΚΥΚΛΩΝ',
  },
  {
    label: '33121101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΙΝΗΤΗΡΩΝ ΚΑΙ ΣΤΡΟΒΙΛΩΝ ΠΛΟΙΩΝ',
  },
  {
    label: '33121200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΥΔΡΑΥΛΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ, ΑΛΛΩΝ ΑΝΤΛΙΩΝ, ΣΥΜΠΙΕΣΤΩΝ, ΣΤΡΟΦΙΓΓΩΝ ΚΑΙ ΒΑΛΒΙΔΩΝ (ΔΙΚΛΕΙΔΩΝ)',
  },
  {
    label: '33121300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΤΡΙΒΕΩΝ (ΡΟΥΛΕΜΑΝ), ΟΔΟΝΤΩΤΩΝ ΜΗΧΑΝΙΣΜΩΝ ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ, ΣΤΟΙΧΕΙΩΝ ΟΔΟΝΤΩΤΩΝ ΤΡΟΧΩΝ ΚΑΙ ΜΗΧΑΝΙΣΜΩΝ ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ',
  },
  {
    label: '33121400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΦΟΥΡΝΩΝ, ΚΛΙΒΑΝΩΝ ΚΑΙ ΚΑΥΣΤΗΡΩΝ',
  },
  {
    label: '33121500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΑΝΥΨΩΣΗΣ ΚΑΙ ΔΙΑΚΙΝΗΣΗΣ ΦΟΡΤΙΩΝ',
  },
  {
    label: '33121503',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΣΕ ΑΝΥΨΩΤΙΚΑ ΜΗΧΑΝΗΜΑΤΑ ΠΡΟΪΟΝΤΩΝ (ΒΑΡΟΥΛΚΑ, ΠΟΛΥΣΠΑΣΤΑ, ΓΡΥΛΟΙ ΚΛΠ)',
  },
  {
    label: '33121504',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΣΕ ΑΝΥΨΩΤΙΚΑ ΣΥΣΤΗΜΑΤΑ ΠΡΟΪΟΝΤΩΝ (ΓΕΡΑΝΟΙ, ΑΡΠΑΓΕΣ, ΚΑΔΟΙ ΑΝΥΨΩΣΗΣ, ΚΛΑΡΚ Κ.Λ.Π)',
  },
  {
    label: '33121505',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΔΙΑΚΙΝΗΣΗΣ ΠΡΟΪΟΝΤΩΝ (ΓΕΡΑΝΟΙ ΑΡΠΑΓΕΣ, ΚΑΔΟΙ ΜΕΤΑΚΙΝΗΣΗΣ, ΦΟΡΕΙΑ, ΤΑΙΝΙΟΔΡΟΜΟΙ Κ.Λ.Π)',
  },
  {
    label: '33121600',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΗΧΑΝΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΟΥ (ΕΚΤΟΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ)',
  },
  {
    label: '33121601',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΑΡΙΘΜΟΜΗΧΑΝΩΝ, ΓΡΑΦΟΜΗΧΑΝΩΝ ΚΛΠ',
  },
  {
    label: '33121602',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΤΑΜΙΑΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '33121603',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΛΟΓΙΣΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '33121604',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΦΩΤΟΤΥΠΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '33121700',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΗΛΕΚΤΡΟΚΙΝΗΤΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '33121800',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΨΥΚΤΙΚΟΥ ΚΑΙ ΚΛΙΜΑΤΙΣΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΜΗ ΟΙΚΙΑΚΗΣ',
  },
  {
    label: '33121900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΝΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '33121901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΓΟΜΩΣΗΣ ΠΥΡΟΣΒΕΣΤΗΡΩΝ',
  },
  {
    label: '33121902',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΘΕΩΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΑΛΛΩΝ ΣΩΣΤΙΚΩΝ ΚΑΙ ΠΥΡΟΣΒΕΣΤΙΚΩΝ ΜΕΣΩΝ',
  },
  {
    label: '33121903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΘΕΩΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΠΥΡΟΣΒΕΣΤΙΚΩΝ ΑΝΤΛΙΩΝ',
  },
  {
    label: '33122000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '33122100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΓΕΩΡΓΙΚΩΝ ΚΑΙ ΔΑΣΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '33122101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΚΗΠΟΥΡΙΚΩΝ ΚΑΙ ΧΟΡΤΟΚΟΠΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '33122200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΜΟΡΦΟΠΟΙΗΣΗΣ ΜΕΤΑΛΛΟΥ ΚΑΙ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ',
  },
  {
    label: '33122300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΛΛΟΥΡΓΙΑ',
  },
  {
    label: '33122400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΟΡΥΧΕΙΩΝ, ΛΑΤΟΜΕΙΩΝ ΚΑΙ ΔΟΜΙΚΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '33122500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ',
  },
  {
    label: '33122600',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '33122601',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΔΙΟΡΘΩΣΗΣ ΡΑΠΤΟΜΗΧΑΝΩΝ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ Η ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '33122700',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '33122800',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΠΛΑΣΤΙΚΩΝ ΚΑΙ ΕΛΑΣΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '33122900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '33130000',
    value: 'ΕΠΙΣΚΕΥΗ ΗΛΕΚΤΡΟΝΙΚΟΥ ΚΑΙ ΟΠΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33131000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΗΛΕΚΤΡΟΝΙΚΟΥ ΚΑΙ ΟΠΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33131100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΜΕΤΡΗΣΕΩΝ, ΔΟΚΙΜΩΝ ΚΑΙ ΠΛΟΗΓΗΣΗΣ',
  },
  {
    label: '33131101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΟΡΓΑΝΩΝ ΑΚΡΙΒΕΙΑΣ',
  },
  {
    label: '33131200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΑΚΤΙΝΟΛΟΓΙΚΟΥ, ΗΛΕΚΤΡΟΪΑΤΡΙΚΟΥ ΚΑΙ ΗΛΕΚΤΡΟΘΕΡΑΠΕΥΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33131300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΟΠΤΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΦΩΤΟΓΡΑΦΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33131900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΑΛΛΟΥ ΕΠΑΓΓΕΛΜΑΤΙΚΟΥ ΗΛΕΚΤΡΟΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33140000',
    value: 'ΕΠΙΣΚΕΥΗ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33141000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33141100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΗΛΕΚΤΡΟΚΙΝΗΤΗΡΩΝ, ΗΛΕΚΤΡΟΓΕΝΝΗΤΡΙΩΝ, ΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΔΙΑΝΟΜΗΣ ΚΑΙ ΕΛΕΓΧΟΥ ΤΟΥ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '33141101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΜΟΤΕΡ (ΠΕΡΙΕΛΙΞΕΙΣ ΚΛΠ)',
  },
  {
    label: '33141900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΑΛΛΟΥ ΕΠΑΓΓΕΛΜΑΤΙΚΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33150000',
    value: 'ΕΠΙΣΚΕΥΗ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΠΛΟΙΩΝ ΚΑΙ ΣΚΑΦΩΝ',
  },
  {
    label: '33151000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΠΛΟΙΩΝ ΚΑΙ ΣΚΑΦΩΝ',
  },
  {
    label: '33151001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΣΚΑΦΩΝ ΑΝΑΨΥΧΗΣ, ΛΕΜΒΩΝ ΚΑΙ ΜΗΧΑΝΩΝ ΘΑΛΑΣΣΗΣ',
  },
  {
    label: '33151002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ Η ΧΡΩΜΑΤΙΣΜΟΥ ΠΛΟΙΩΝ',
  },
  {
    label: '33151003',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΟΥΡΓΙΚΩΝ ΕΠΙΣΚΕΥΩΝ ΠΛΟΙΩΝ ΚΑΙ ΜΗΧΑΝΟΛΟΓΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΤΟΥΣ',
  },
  {
    label: '33151004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΠΟΒΡΥΧΙΩΝ ΕΡΓΑΣΙΩΝ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΠΛΟΙΩΝ',
  },
  {
    label: '33160000',
    value: 'ΕΠΙΣΚΕΥΗ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΔΙΑΣΤΗΜΟΠΛΟΙΩΝ',
  },
  {
    label: '33161000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΔΙΑΣΤΗΜΟΠΛΟΙΩΝ',
  },
  {
    label: '33170000',
    value: 'ΕΠΙΣΚΕΥΗ ΚΑΙ ΣΥΝΤΗΡΗΣΗ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΜΕΤΑΦΟΡΩΝ',
  },
  {
    label: '33171000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΜΕΤΑΦΟΡΩΝ',
  },
  {
    label: '33171100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΑΜΑΞΩΝ (ΜΗΧΑΝΩΝ) ΚΑΙ ΤΡΟΧΑΙΟΥ ΕΞΟΠΛΙΣΜΟΥ ΣΙΔΗΡΟΔΡΟΜΩΝ',
  },
  {
    label: '33171900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΜΕΤΑΦΟΡΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '33190000',
    value: 'ΕΠΙΣΚΕΥΗ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33191000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33200000',
    value: 'ΕΓΚΑΤΑΣΤΑΣΗ ΒΙΟΜΗΧΑΝΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33201000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΚΤΟΣ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33201100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΑΤΜΟΓΕΝΝΗΤΡΙΩΝ, ΕΚΤΟΣ ΤΩΝ ΛΕΒΗΤΩΝ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΖΕΣΤΟΥ ΝΕΡΟΥ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΚΑΙ ΤΩΝ ΥΠΗΡΕΣΙΩΝ ΕΓΚΑΤΑΣΤΑΣΗΣ ΣΥΣΤΗΜΑΤΩΝ ΜΕΤΑΛΛΙΚΩΝ ΣΩΛΗΝΩΣΕΩΝ ΣΕ ΒΙΟΜΗΧΑΝΙΚΕΣ ΜΟΝΑΔΕΣ',
  },
  {
    label: '33201101',
    value:
      'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΣΩΛΗΝΩΣΕΩΝ ΣΕ ΒΙΟΜΗΧΑΝΙΕΣ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΗΣ ΤΗΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΒΑΛΒΙΔΩΝ ΚΑΙ ΤΑΜΙΕΥΤΗΡΩΝ',
  },
  {
    label: '33201102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΔΙΑΦΟΡΩΝ ΕΞΟΠΛΙΣΜΩΝ ΛΕΒΗΤΩΝ ΓΙΑ ΜΗ ΠΥΡΗΝΙΚΑ ΕΡΓΟΣΤΑΣΙΑ',
  },
  {
    label: '33201103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΜΗ ΠΥΡΗΝΙΚΩΝ ΑΤΜΟΓΕΝΝΗΤΡΙΩΝ',
  },
  {
    label: '33201200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΑΛΛΩΝ ΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΚΤΟΣ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33201201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΤΟΠΙΑΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΔΕΞΑΜΕΝΩΝ, ΤΑΜΙΕΥΤΗΡΩΝ ΚΑΙ ΔΟΧΕΙΩΝ',
  },
  {
    label: '33202000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΝΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '33202100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΜΗΧΑΝΩΝ ΓΡΑΦΕΙΟΥ ΚΑΙ ΛΟΓΙΣΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '33202900',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΝΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '33202901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΔΕΣΗΣ ΣΥΣΤΗΜΑΤΩΝ ΣΩΛΗΝΩΣΕΩΝ ΓΙΑ ΥΔΡΑΥΛΙΚΑ ΣΥΣΤΗΜΑΤΑ Η ΓΙΑ ΣΥΣΤΗΜΑΤΑ ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ',
  },
  {
    label: '33203000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '33203100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΒΙΟΜΗΧΑΝΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΤΗ ΓΕΩΡΓΙΑ',
  },
  {
    label: '33203200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΜΟΡΦΟΠΟΙΗΣΗΣ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '33203300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΒΙΟΜΗΧΑΝΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΤΗ ΜΕΤΑΛΛΟΥΡΓΙΑ',
  },
  {
    label: '33203400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΒΙΟΜΗΧΑΝΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΟΡΥΧΕΙΑ',
  },
  {
    label: '33203500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΒΙΟΜΗΧΑΝΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ',
  },
  {
    label: '33203600',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΒΙΟΜΗΧΑΝΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '33203700',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΒΙΟΜΗΧΑΝΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '33203800',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΒΙΟΜΗΧΑΝΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΠΛΑΣΤΙΚΩΝ ΚΑΙ ΕΛΑΣΤΙΚΩΝ',
  },
  {
    label: '33203900',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '33204000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΗΛΕΚΤΡΟΝΙΚΟΥ ΚΑΙ ΟΠΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33204100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΙΑΤΡΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΟΡΓΑΝΩΝ ΑΚΡΙΒΕΙΑΣ ΚΑΙ ΟΠΤΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '33204200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΕΠΑΓΓΕΛΜΑΤΙΚΟΥ ΗΛΕΚΤΡΟΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33205000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '33206000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΤΟΝ ΕΛΕΓΧΟ ΠΑΡΑΓΩΓΙΚΩΝ ΔΙΑΔΙΚΑΣΙΩΝ',
  },
  {
    label: '33207000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΑΛΛΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '35110000',
    value: 'ΠΑΡΑΓΩΓΗ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '35111001',
    value:
      'ΠΑΡΑΓΩΓΗ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΑΠΟ ΑΕΡΟΣΤΡΟΒΙΛΙΚΕΣ ΜΟΝΑΔΕΣ ΠΕΤΡΕΛΑΙΟΥ',
  },
  {
    label: '35111002',
    value: 'ΠΑΡΑΓΩΓΗ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΑΠΟ ΛΙΓΝΙΤΙΚΕΣ ΜΟΝΑΔΕΣ',
  },
  {
    label: '35111003',
    value: 'ΠΑΡΑΓΩΓΗ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΑΠΟ ΜΕΤΑΤΡΟΠΗ ΑΙΟΛΙΚΗΣ ΕΝΕΡΓΕΙΑΣ',
  },
  {
    label: '35111004',
    value: 'ΠΑΡΑΓΩΓΗ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΑΠΟ ΜΕΤΑΤΡΟΠΗ ΗΛΙΑΚΗΣ ΕΝΕΡΓΕΙΑΣ',
  },
  {
    label: '35111005',
    value: 'ΠΑΡΑΓΩΓΗ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΑΠΟ ΜΟΝΑΔΕΣ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '35111006',
    value:
      'ΠΑΡΑΓΩΓΗ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΑΠΟ ΣΤΑΘΜΟΥΣ ΣΥΜΠΑΡΑΓΩΓΗΣ ΗΛΕΚΤΡΙΣΜΟΥ ΚΑΙ ΘΕΡΜΟΤΗΤΑΣ',
  },
  {
    label: '35111007',
    value: 'ΠΑΡΑΓΩΓΗ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΑΠΟ ΣΤΑΘΜΟΥΣ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ',
  },
  {
    label: '35111008',
    value: 'ΠΑΡΑΓΩΓΗ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΑΠΟ ΥΔΡΟΗΛΕΚΤΡΙΚΟΥΣ ΣΤΑΘΜΟΥΣ',
  },
  {
    label: '35111009',
    value: 'ΠΑΡΑΓΩΓΗ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΑΠΟ ΦΩΤΟΒΟΛΤΑΪΚΑ ΣΥΣΤΗΜΑΤΑ',
  },
  {
    label: '35120000',
    value: 'ΜΕΤΑΔΟΣΗ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '35121000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΔΟΣΗΣ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '35130000',
    value: 'ΔΙΑΝΟΜΗ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '35131000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '35131001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΓΝΩΣΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΕΤΡΗΤΩΝ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '35131002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ',
  },
  {
    label: '35140000',
    value: 'ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '35141000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΜΠΟΡΙΟΥ (ΠΩΛΗΣΗΣ) ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '35210000',
    value: 'ΠΑΡΑΓΩΓΗ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '35211000',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΩΤΑΕΡΙΟΥ, ΥΔΡΑΕΡΙΟΥ, ΠΤΩΧΟΥ ΑΕΡΙΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΑΕΡΙΩΝ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΑΕΡΙΑ ΠΑΡΑΓΩΓΑ ΤΟΥ ΠΕΤΡΕΛΑΙΟΥ',
  },
  {
    label: '35220000',
    value: 'ΔΙΑΝΟΜΗ ΑΕΡΙΩΝ ΚΑΥΣΙΜΩΝ ΜΕΣΩ ΑΓΩΓΩΝ',
  },
  {
    label: '35221000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΑΕΡΙΩΝ ΚΑΥΣΙΜΩΝ ΜΕΣΩ ΑΓΩΓΩΝ',
  },
  {
    label: '35221001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΓΝΩΣΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΕΤΡΗΤΩΝ ΑΕΡΙΩΝ ΚΑΥΣΙΜΩΝ',
  },
  {
    label: '35230000',
    value: 'ΕΜΠΟΡΙΟ ΑΕΡΙΩΝ ΚΑΥΣΙΜΩΝ ΜΕΣΩ ΑΓΩΓΩΝ',
  },
  {
    label: '35231000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΑΕΡΙΩΝ ΚΑΥΣΙΜΩΝ ΜΕΣΩ ΑΓΩΓΩΝ',
  },
  {
    label: '35300000',
    value: 'ΠΑΡΟΧΗ ΑΤΜΟΥ ΚΑΙ ΚΛΙΜΑΤΙΣΜΟΥ',
  },
  {
    label: '35301000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΑΤΜΟΥ ΚΑΙ ΖΕΣΤΟΥ ΝΕΡΟΥ',
  },
  {
    label: '35301101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΑΤΜΟΥ ΚΑΙ ΖΕΣΤΟΥ ΝΕΡΟΥ, ΠΡΟΣ ΘΕΡΜΑΝΣΗ ΠΟΛΕΩΝ',
  },
  {
    label: '35301200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΑΤΜΟΥ ΚΑΙ ΖΕΣΤΟΥ ΝΕΡΟΥ ΜΕΣΩ ΑΓΩΓΩΝ',
  },
  {
    label: '35302000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΠΑΓΟΥ· ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΨΥΧΡΟΥ ΑΕΡΑ ΚΑΙ ΝΕΡΟΥ',
  },
  {
    label: '35302100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΠΑΓΟΥ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΠΑΓΟΥ ΓΙΑ ΨΥΚΤΙΚΟΥΣ (ΔΗΛΑΔΗ ΓΙΑ ΜΗ ΔΙΑΤΡΟΦΙΚΟΥΣ) ΣΚΟΠΟΥΣ',
  },
  {
    label: '35302101',
    value: 'ΠΑΡΑΓΩΓΗ ΠΑΓΑΚΙΩΝ ΒΡΩΣΙΜΩΝ, ΣΕ ΚΥΒΟΥΣ Η ΝΙΦΑΔΕΣ',
  },
  {
    label: '35302102',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΑΓΟΥ ΜΗ ΒΡΩΣΙΜΟΥ (ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΘΡΥΜΜΑΤΙΣΜΕΝΟΥ ΠΑΓΟΥ), ΓΙΑ ΨΥΞΗ',
  },
  {
    label: '35302200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΨΥΧΡΟΥ ΑΕΡΑ ΚΑΙ ΝΕΡΟΥ',
  },
  {
    label: '35302201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΨΥΧΟΥΣ (ΕΚΤΟΣ ΠΑΓΟΠΟΙΕΙΟΥ)',
  },
  {
    label: '36000000',
    value: 'ΣΥΛΛΟΓΗ, ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΠΑΡΟΧΗ ΝΕΡΟΥ',
  },
  {
    label: '36001000',
    value: 'ΠΑΡΟΧΗ ΦΥΣΙΚΟΥ ΝΕΡΟΥ',
  },
  {
    label: '36001100',
    value: 'ΠΑΡΟΧΗ ΠΟΣΙΜΟΥ ΝΕΡΟΥ',
  },
  {
    label: '36001101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΝΕΡΟΥ ΜΕ ΒΥΤΙΟ',
  },
  {
    label: '36001200',
    value: 'ΠΑΡΟΧΗ ΜΗ ΠΟΣΙΜΟΥ ΝΕΡΟΥ',
  },
  {
    label: '36002000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΑΙ ΔΙΑΝΟΜΗΣ ΝΕΡΟΥ ΜΕΣΩ ΑΓΩΓΩΝ',
  },
  {
    label: '36002001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΦΑΛΑΤΩΣΗΣ ΘΑΛΑΣΣΙΝΟΥ ΝΕΡΟΥ',
  },
  {
    label: '36002002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΝΕΡΟΥ ΜΕ ΦΙΛΤΡΑ Η ΑΛΛΑ ΜΕΣΑ',
  },
  {
    label: '36003000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΜΠΟΡΙΑΣ (ΠΩΛΗΣΗΣ) ΝΕΡΟΥ ΜΕΣΩ ΑΓΩΓΩΝ',
  },
  {
    label: '36003001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΓΝΩΣΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΕΤΡΗΤΩΝ ΝΕΡΟΥ',
  },
  {
    label: '37000000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΛΥΜΑΤΩΝ',
  },
  {
    label: '37001000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΛΥΜΑΤΩΝ',
  },
  {
    label: '37001100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΚΟΜΙΔΗΣ ΚΑΙ ΕΠΕΞΕΡΓΑΣΙΑΣ ΛΥΜΑΤΩΝ',
  },
  {
    label: '37001101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΙΟΛΟΓΙΚΟΥ ΚΑΘΑΡΙΣΜΟΥ ΛΥΜΑΤΩΝ',
  },
  {
    label: '37001200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΛΥΜΑΤΩΝ ΒΟΘΡΩΝ ΚΑΙ ΣΗΠΤΙΚΩΝ ΔΕΞΑΜΕΝΩΝ',
  },
  {
    label: '37001201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΧΗΜΙΚΩΝ ΤΟΥΑΛΕΤΩΝ',
  },
  {
    label: '37001202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΚΕΝΩΣΗΣ ΚΑΙ ΚΑΘΑΡΙΣΜΟΥ ΒΟΘΡΩΝ',
  },
  {
    label: '37002000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΛΥΜΑΤΟΛΑΣΠΗΣ',
  },
  {
    label: '38110000',
    value: 'ΣΥΛΛΟΓΗ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38111000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΝΑΚΥΚΛΩΣΙΜΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38111100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΝΑΚΥΚΛΩΣΙΜΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, ΔΗΜΟΤΙΚΩΝ',
  },
  {
    label: '38111900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΝΑΚΥΚΛΩΣΙΜΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, ΑΛΛΩΝ',
  },
  {
    label: '38112000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΜΗ ΑΝΑΚΥΚΛΩΣΙΜΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38112100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΜΗ ΑΝΑΚΥΚΛΩΣΙΜΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, ΔΗΜΟΤΙΚΩΝ',
  },
  {
    label: '38112101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΚΟΜΙΔΗΣ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38112102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΠΟΚΟΜΙΔΗΣ ΑΠΟΡΡΙΜΜΑΤΩΝ ΑΠΟ ΙΔΙΟΚΤΗΤΕΣ ΑΓΡΟΤΙΚΩΝ ΦΟΡΤΗΓΩΝ ΙΧ',
  },
  {
    label: '38112103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΠΟΚΟΜΙΔΗΣ ΜΠΑΖΩΝ ΚΑΙ ΑΛΛΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, ΜΕ ΔΙΑΘΕΣΗ ΚΑΔΩΝ',
  },
  {
    label: '38112900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ, ΜΗ ΑΝΑΚΥΚΛΩΣΙΜΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, ΑΛΛΩΝ',
  },
  {
    label: '38113000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΜΗ ΑΝΑΚΥΚΛΩΣΙΜΩΝ, ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38113100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΜΗ ΑΝΑΚΥΚΛΩΣΙΜΩΝ, ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΔΗΜΟΤΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38113900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΛΛΩΝ ΜΗ ΑΝΑΚΥΚΛΩΣΙΜΩΝ, ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38114000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΑΧΡΗΣΤΕΥΜΕΝΩΝ ΕΙΔΩΝ, ΓΙΑ ΑΠΟΣΥΝΑΡΜΟΛΟΓΗΣΗ',
  },
  {
    label: '38114100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΣΚΑΦΩΝ ΚΑΙ ΑΛΛΩΝ ΠΛΩΤΩΝ ΚΑΤΑΣΚΕΥΩΝ ΠΡΟΣ ΔΙΑΛΥΣΗ',
  },
  {
    label: '38114900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΑΧΡΗΣΤΕΥΜΕΝΩΝ ΕΙΔΩΝ, ΕΚΤΟΣ ΣΚΑΦΩΝ ΚΑΙ ΠΛΩΤΩΝ ΚΑΤΑΣΚΕΥΩΝ, ΓΙΑ ΑΠΟΣΥΝΑΡΜΟΛΟΓΗΣΗ',
  },
  {
    label: '38115000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΛΛΩΝ ΑΝΑΚΥΚΛΩΣΙΜΩΝ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38115100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΓΥΑΛΙΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38115200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΠΟΡΡΙΜΜΑΤΩΝ ΑΠΟ ΧΑΡΤΙ ΚΑΙ ΧΑΡΤΟΝΙ',
  },
  {
    label: '38115300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '38115400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΛΛΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '38115500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΠΛΑΣΤΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38115600',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΥΦΑΣΜΑΤΙΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38115700',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΠΟΡΡΙΜΜΑΤΩΝ ΑΠΟ ΔΕΡΜΑ',
  },
  {
    label: '38115800',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38115900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΛΛΩΝ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΝΑΚΥΚΛΩΣΙΜΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '38116000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΕΩΝ ΜΕΤΑΦΟΡΑΣ ΓΙΑ ΜΗ ΕΠΙΚΙΝΔΥΝΑ ΑΠΟΒΛΗΤΑ',
  },
  {
    label: '38116100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΕΩΝ ΜΕΤΑΦΟΡΑΣ ΓΙΑ ΜΗ ΕΠΙΚΙΝΔΥΝΑ ΑΝΑΚΥΚΛΩΣΙΜΑ ΑΠΟΒΛΗΤΑ',
  },
  {
    label: '38116900',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΕΩΝ ΜΕΤΑΦΟΡΑΣ ΓΙΑ ΑΛΛΑ ΜΗ ΕΠΙΚΙΝΔΥΝΑ ΑΠΟΒΛΗΤΑ',
  },
  {
    label: '38120000',
    value: 'ΣΥΛΛΟΓΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38121000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38121100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΕΠΙΚΙΝΔΥΝΩΝ ΙΑΤΡΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ ΒΙΟΛΟΓΙΚΟΥ ΚΙΝΔΥΝΟΥ',
  },
  {
    label: '38121200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΑΛΛΩΝ ΕΠΙΚΙΝΔΥΝΩΝ ΒΙΟΜΗΧΑΝΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38121300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΕΠΙΚΙΝΔΥΝΩΝ ΔΗΜΟΤΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38122000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38122100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΕΞΑΝΤΛΗΜΕΝΩΝ (ΑΚΤΙΝΟΒΟΛΗΜΕΝΩΝ) ΣΤΟΙΧΕΙΩΝ ΚΑΥΣΙΜΩΝ (ΦΥΣΙΓΓΙΩΝ) ΠΥΡΗΝΙΚΩΝ ΑΝΤΙΔΡΑΣΤΗΡΩΝ',
  },
  {
    label: '38122200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38122300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΛΛΩΝ ΙΑΤΡΙΚΩΝ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38122400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΕΠΙΚΙΝΔΥΝΩΝ ΧΗΜΙΚΩΝ ΑΠΟΒΛΗΤΩΝ',
  },
  {
    label: '38122500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΧΡΗΣΙΜΟΠΟΙΗΜΕΝΩΝ ΟΡΥΚΤΕΛΑΙΩΝ',
  },
  {
    label: '38122600',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΕΠΙΚΙΝΔΥΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38122700',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΠΡΩΤΟΓΕΝΩΝ ΣΤΟΙΧΕΙΩΝ, ΠΡΩΤΟΓΕΝΩΝ ΣΥΣΤΟΙΧΙΩΝ (ΜΠΑΤΑΡΙΩΝ) ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΣΩΡΕΥΤΩΝ',
  },
  {
    label: '38122900',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΛΛΩΝ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38123000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΕΩΝ ΜΕΤΑΦΟΡΑΣ ΓΙΑ ΕΠΙΚΙΝΔΥΝΑ ΑΠΟΒΛΗΤΑ',
  },
  {
    label: '38210000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΔΙΑΘΕΣΗ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38211000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ ΓΙΑ ΤΕΛΙΚΗ ΔΙΑΘΕΣΗ',
  },
  {
    label: '38212000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38212100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΓΕΙΟΝΟΜΙΚΗΣ ΤΑΦΗΣ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38212200',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΑΦΗΣ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38212300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΤΕΦΡΩΣΗΣ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38212900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38212901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΜΠΟΣΤΟΠΟΙΗΣΗΣ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38212902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΙΠΑΣΜΑΤΟΠΟΙΗΣΗΣ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38213000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΟΡΓΑΝΙΚΩΝ ΔΙΑΛΥΤΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38214000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΣΤΑΧΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΑΠΟ ΑΠΟΤΕΦΡΩΣΗ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38220000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΙ ΔΙΑΘΕΣΗ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38221000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΠΥΡΗΝΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38221100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΠΥΡΗΝΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38221900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38222000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΠΥΡΗΝΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38222100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΠΥΡΗΝΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38222900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΛΛΩΝ ΕΠΙΚΙΝΔΥΝΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38310000',
    value: 'ΑΠΟΣΥΝΑΡΜΟΛΟΓΗΣΗ ΠΑΛΑΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '38311000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΣΥΝΑΡΜΟΛΟΓΗΣΗΣ ΑΧΡΗΣΤΕΥΜΕΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '38311100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΛΥΣΗΣ ΠΛΟΙΩΝ',
  },
  {
    label: '38311200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΠΟΣΥΝΑΡΜΟΛΟΓΗΣΗΣ ΑΧΡΗΣΤΕΥΜΕΝΩΝ ΕΙΔΩΝ, ΕΚΤΟΣ ΣΚΑΦΩΝ ΚΑΙ ΠΛΩΤΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '38311201',
    value:
      'ΔΙΑΛΥΣΗ (ΚΑΝΙΒΑΛΙΣΜΟΣ) ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΑΛΛΩΝ ΒΑΡΕΩΝ ΜΕΤΑΛΛΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, ΓΙΑ ΤΗ ΛΗΨΗ ΕΠΑΝΑΧΡΗΣΙΜΟΠΟΙΗΣΙΜΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '38311202',
    value:
      'ΔΙΑΛΥΣΗ (ΚΑΝΙΒΑΛΙΣΜΟΣ) ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΑΛΛΩΝ ΒΑΡΕΩΝ ΜΕΤΑΛΛΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, ΓΙΑ ΤΗΝ ΑΠΟΜΑΚΡΥΝΣΗ ΑΧΡΗΣΤΩΝ Η ΕΠΙΚΙΝΔΥΝΩΝ ΣΤΟΙΧΕΙΩΝ (Π.Χ. ΛΑΔΙΩΝ, ΚΑΥΣΙΜΩΝ ΚΛΠ)',
  },
  {
    label: '38311203',
    value:
      'ΜΗΧΑΝΙΚΗ ΚΟΠΗ Η ΘΡΑΥΣΗ ΜΕΤΑΛΛΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, (Π.Χ. ΑΥΤΟΚΙΝΗΤΩΝ), ΔΙΑΛΟΓΗ ΚΑΙ ΔΙΑΧΩΡΙΣΜΟΣ ΠΡΩΤΩΝ ΥΛΩΝ',
  },
  {
    label: '38320000',
    value: 'ΑΝΑΚΤΗΣΗ ΔΙΑΛΕΓΜΕΝΟΥ ΥΛΙΚΟΥ',
  },
  {
    label: '38321000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΔΙΑΛΕΓΜΕΝΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '38321100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΔΙΑΛΕΓΜΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '38321200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΔΙΑΛΕΓΜΕΝΩΝ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '38322000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΜΕΤΑΛΛΙΚΩΝ ΔΕΥΤΕΡΟΓΕΝΩΝ ΠΡΩΤΩΝ ΥΛΩΝ',
  },
  {
    label: '38322100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΠΡΩΤΩΝ ΥΛΩΝ ΠΟΛΥΤΙΜΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '38322200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΠΡΩΤΩΝ ΥΛΩΝ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '38322201',
    value:
      'ΘΡΑΥΣΗ, ΚΑΘΑΡΙΣΜΟΣ ΚΑΙ ΔΙΑΛΟΓΗ ΑΛΛΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ (Π.Χ. ΑΠΟ ΚΑΤΕΔΑΦΙΣΕΙΣ) ΓΙΑ ΤΗΝ ΑΝΑΚΤΗΣΗ ΜΕΤΑΛΛΙΚΩΝ ΔΕΥΤΕΡΟΓΕΝΩΝ ΠΡΩΤΩΝ ΥΛΩΝ',
  },
  {
    label: '38322202',
    value:
      'ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΠΑΛΑΙΟΣΙΔΗΡΙΚΩΝ, ΩΣΤΕ ΝΑ ΜΕΤΑΤΡΑΠΟΥΝ ΣΕ ΔΕΥΤΕΡΟΓΕΝΕΙΣ ΠΡΩΤΕΣ ΥΛΕΣ',
  },
  {
    label: '38322203',
    value: 'ΜΗΧΑΝΙΚΗ Η ΧΗΜΙΚΗ ΕΠΕΞΕΡΓΑΣΙΑ ΜΕΤΑΛΛΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '38322300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΠΡΩΤΩΝ ΥΛΩΝ ΧΑΛΚΟΥ',
  },
  {
    label: '38322400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΠΡΩΤΩΝ ΥΛΩΝ ΝΙΚΕΛΙΟΥ',
  },
  {
    label: '38322500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΠΡΩΤΩΝ ΥΛΩΝ ΑΛΟΥΜΙΝΙΟΥ',
  },
  {
    label: '38322900',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΑΛΛΩΝ ΜΕΤΑΛΛΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ',
  },
  {
    label: '38323000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΔΕΥΤΕΡΟΓΕΝΩΝ ΠΡΩΤΩΝ ΥΛΩΝ',
  },
  {
    label: '38323100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΠΡΩΤΩΝ ΥΛΩΝ ΓΥΑΛΙΟΥ',
  },
  {
    label: '38323200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΠΡΩΤΩΝ ΥΛΩΝ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '38323300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΠΡΩΤΩΝ ΥΛΩΝ ΠΛΑΣΤΙΚΟΥ',
  },
  {
    label: '38323400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΠΡΩΤΩΝ ΥΛΩΝ ΕΛΑΣΤΙΚΟΥ',
  },
  {
    label: '38323500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΥΦΑΝΤΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ',
  },
  {
    label: '38323900',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΤΗΣΗΣ ΑΛΛΩΝ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ',
  },
  {
    label: '38323901',
    value: 'ΑΝΑΚΤΗΣΗ ΧΗΜΙΚΩΝ ΟΥΣΙΩΝ ΑΠΟ ΧΗΜΙΚΑ ΑΠΟΡΡΙΜΜΑΤΑ',
  },
  {
    label: '38323902',
    value:
      'ΘΡΑΥΣΗ, ΚΑΘΑΡΙΣΜΟΣ ΚΑΙ ΔΙΑΛΟΓΗ ΑΛΛΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ (Π.Χ. ΑΠΟ ΚΑΤΕΔΑΦΙΣΕΙΣ) ΓΙΑ ΤΗΝ ΑΝΑΚΤΗΣΗ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΔΕΥΤΕΡΟΓΕΝΩΝ ΠΡΩΤΩΝ ΥΛΩΝ',
  },
  {
    label: '38323903',
    value:
      'ΜΗΧΑΝΙΚΗ, ΧΗΜΙΚΗ Η ΑΛΛΗ ΚΑΤΕΡΓΑΣΙΑ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, ΩΣΤΕ ΝΑ ΜΕΤΑΤΡΑΠΟΥΝ ΣΕ ΔΕΥΤΕΡΟΓΕΝΕΙΣ ΠΡΩΤΕΣ ΥΛΕΣ',
  },
  {
    label: '39000000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΕΞΥΓΙΑΝΣΗΣ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗ ΔΙΑΧΕΙΡΙΣΗ ΑΠΟΒΛΗΤΩΝ',
  },
  {
    label: '39001000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΥΓΙΑΝΣΗΣ ΚΑΙ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '39001100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΥΓΙΑΝΣΗΣ ΚΑΙ ΚΑΘΑΡΙΣΜΟΥ ΕΔΑΦΟΥΣ ΚΑΙ ΥΠΟΓΕΙΩΝ ΥΔΑΤΩΝ',
  },
  {
    label: '39001200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΥΓΙΑΝΣΗΣ ΚΑΙ ΚΑΘΑΡΙΣΜΟΥ ΕΠΙΦΑΝΕΙΑΚΩΝ ΥΔΑΤΩΝ',
  },
  {
    label: '39001201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΚΑΙ ΑΠΟΡΡΥΠΑΝΣΗΣ ΘΑΛΑΣΣΙΩΝ ΠΕΡΙΟΧΩΝ',
  },
  {
    label: '39001300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΥΓΙΑΝΣΗΣ ΚΑΙ ΚΑΘΑΡΙΣΜΟΥ ΑΕΡΑ',
  },
  {
    label: '39001400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΥΓΙΑΝΣΗΣ ΚΤΙΡΙΩΝ',
  },
  {
    label: '39001401',
    value: 'ΕΡΓΑΣΙΕΣ ΑΦΑΙΡΕΣΗΣ ΑΜΙΑΝΤΟΥ ΚΤΙΡΙΩΝ',
  },
  {
    label: '39002000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΞΥΓΙΑΝΣΗΣ ΚΑΙ ΕΞΕΙΔΙΚΕΥΜΕΝΟΥ ΕΛΕΓΧΟΥ ΡΥΠΑΝΣΗΣ',
  },
  {
    label: '39002100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΞΥΓΙΑΝΣΗΣ, ΠΕΡΙΟΡΙΣΜΟΥ ΤΗΣ ΡΥΠΑΝΣΗΣ, ΕΛΕΓΧΟΥ ΚΑΙ ΠΑΡΑΚΟΛΟΥΘΗΣΗΣ ΕΡΓΟΤΑΞΙΟΥ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΞΥΓΙΑΝΣΗΣ ΕΡΓΟΤΑΞΙΟΥ',
  },
  {
    label: '39002101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΒΙΟΜΗΧΑΝΙΚΩΝ ΡΥΠΩΝ',
  },
  {
    label: '39002102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΛΕΓΧΟΥ ΒΙΟΜΗΧΑΝΙΚΟΥ ΚΑΙ ΕΡΓΑΣΙΑΚΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ',
  },
  {
    label: '39002200',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΞΥΓΙΑΝΣΗΣ',
  },
  {
    label: '39002300',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΞΕΙΔΙΚΕΥΜΕΝΟΥ ΕΛΕΓΧΟΥ ΡΥΠΑΝΣΗΣ',
  },
  {
    label: '41100000',
    value: 'ΑΝΑΠΤΥΞΗ ΟΙΚΟΔΟΜΙΚΩΝ ΣΧΕΔΙΩΝ',
  },
  {
    label: '41200000',
    value: 'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΚΤΙΡΙΩΝ ΓΙΑ ΚΑΤΟΙΚΙΕΣ ΚΑΙ ΜΗ',
  },
  {
    label: '41201000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΟΙΚΙΣΤΙΚΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '41201001',
    value:
      'ΓΕΝΙΚΕΣ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΟΙΚΙΣΤΙΚΑ ΚΤΙΡΙΑ ΜΕ ΤΗ ΧΡΗΣΙΜΟΠΟΙΗΣΗ ΙΔΙΩΝ ΥΛΙΚΩΝ (ΕΠΙΧΕΙΡΗΣΗ ΠΟΥ ΔΕΝ ΥΠΑΓΕΤΑΙ ΣΤΙΣ ΔΙΑΤΑΞΕΙΣ ΤΟΥ ΑΡΘΡΟΥ 34 ~ Ν. 2238 ;/94 ;)',
  },
  {
    label: '41202000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΗ ΟΙΚΙΣΤΙΚΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '41202001',
    value:
      'ΕΡΓΑΣΙΕΣ ΔΙΑΜΟΡΦΩΣΗΣ Η ΑΝΕΓΕΡΣΗΣ ΚΤΙΣΜΑΤΟΣ Η ΑΛΛΟΥ ΕΙΔΟΥΣ ΚΑΤΑΣΚΕΥΩΝ (ΩΣ ΑΓΑΘΟΥ ΕΠΕΝΔΥΣΗΣ ΤΟΥ ΑΡΘΡ. 33 ~ ΠΑΡ. 4 ~ ΤΟΥ ΚΩΔΙΚΑ ΦΠΑ) ΓΙΑ ΙΔΙΑ ΑΣΚΗΣΗ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΔΡΑΣΤΗΡΙΟΤΗΤΑΣ ΜΕ ΔΙΚΑΙΩΜΑ ΕΚΠΤΩΣΗΣ ΤΟΥ ΦΠΑ ΤΩΝ ΕΙΣΡΟΩΝ ΤΟΥΣ',
  },
  {
    label: '41202002',
    value:
      'ΕΡΓΑΣΙΕΣ ΔΙΑΜΟΡΦΩΣΗΣ Η ΑΝΕΓΕΡΣΗΣ ΚΤΙΣΜΑΤΟΣ Η ΑΛΛΟΥ ΕΙΔΟΥΣ ΚΑΤΑΣΚΕΥΩΝ (ΩΣ ΑΓΑΘΟΥ ΕΠΕΝΔΥΣΗΣ ΤΟΥ ΑΡΘΡ. 33 ~ ΠΑΡ. 4 ~ ΤΟΥ ΚΩΔΙΚΑ ΦΠΑ) ΓΙΑ ΙΔΙΑ ΑΣΚΗΣΗ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΔΡΑΣΤΗΡΙΟΤΗΤΑΣ ΧΩΡΙΣ ΔΙΚΑΙΩΜΑ ΕΚΠΤΩΣΗΣ ΤΟΥ ΦΠΑ ΤΩΝ ΕΙΣΡΟΩΝ ΤΟΥΣ',
  },
  {
    label: '41202003',
    value:
      'ΓΕΝΙΚΕΣ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΜΗ ΟΙΚΙΣΤΙΚΑ ΚΤΙΡΙΑ ΜΕ ΤΗ ΧΡΗΣΙΜΟΠΟΙΗΣΗ ΙΔΙΩΝ ΥΛΙΚΩΝ (ΕΠΙΧΕΙΡΗΣΗ ΠΟΥ ΔΕΝ ΥΠΑΓΕΤΑΙ ΣΤΙΣ ΔΙΑΤΑΞΕΙΣ ΤΟΥ ΑΡΘΡΟΥ 34 ~ Ν. 2238 ;/94 ;)',
  },
  {
    label: '41203000',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΟΙΚΙΣΤΙΚΑ ΚΤΙΡΙΑ (ΝΕΕΣ ΕΡΓΑΣΙΕΣ, ΠΡΟΣΘΗΚΕΣ, ΜΕΤΑΤΡΟΠΕΣ ΚΑΙ ΑΝΑΚΑΙΝΙΣΕΙΣ)',
  },
  {
    label: '41204000',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΜΗ ΟΙΚΙΣΤΙΚΑ ΚΤΙΡΙΑ (ΝΕΕΣ ΕΡΓΑΣΙΕΣ, ΠΡΟΣΘΗΚΕΣ, ΜΕΤΑΤΡΟΠΕΣ ΚΑΙ ΑΝΑΚΑΙΝΙΣΕΙΣ)',
  },
  {
    label: '42110000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΔΡΟΜΩΝ ΚΑΙ ΑΥΤΟΚΙΝΗΤΟΔΡΟΜΩΝ',
  },
  {
    label: '42111000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΑΥΤΟΚΙΝΗΤΟΔΡΟΜΩΝ, ΕΘΝΙΚΩΝ, ΕΠΑΡΧΙΑΚΩΝ Η ΔΙΑΔΗΜΟΤΙΚΩΝ ΟΔΩΝ, ΔΡΟΜΩΝ ΕΝΤΟΣ ΟΙΚΙΣΜΩΝ ΚΑΙ ΑΛΛΩΝ ΑΜΑΞΙΤΩΝ ΟΔΩΝ Η ΠΕΖΟΔΡΟΜΩΝ ΚΑΙ ΔΙΑΔΡΟΜΩΝ ΑΕΡΟΔΡΟΜΙΩΝ',
  },
  {
    label: '42112000',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΑΥΤΟΚΙΝΗΤΟΔΡΟΜΟΥΣ, ΕΘΝΙΚΕΣ, ΕΠΑΡΧΙΑΚΕΣ Η ΔΙΑΔΗΜΟΤΙΚΕΣ ΟΔΟΥΣ, ΔΡΟΜΟΥΣ ΕΝΤΟΣ ΟΙΚΙΣΜΩΝ ΚΑΙ ΑΛΛΕΣ ΑΜΑΞΙΤΕΣ ΟΔΟΥΣ Η ΠΕΖΟΔΡΟΜΟΥΣ ΚΑΙ ΔΙΑΔΡΟΜΟΥΣ ΑΕΡΟΔΡΟΜΙΩΝ',
  },
  {
    label: '42112001',
    value: 'ΕΡΓΑΣΙΕΣ ΕΠΙΣΤΡΩΣΗΣ ΧΩΡΩΝ ΣΤΑΘΜΕΥΣΗΣ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '42112002',
    value: 'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΜΕΙΩΣΗ ΚΥΚΛΟΦΟΡΙΑΚΟΥ ΘΟΡΥΒΟΥ',
  },
  {
    label: '42112003',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΔΗΜΙΟΥΡΓΙΑΣ, ΣΥΝΤΗΡΗΣΗΣ, ΣΗΜΑΝΣΗΣ ΚΛΠ ΑΤΡΑΠΩΝ ΚΑΙ ΜΟΝΟΠΑΤΙΩΝ',
  },
  {
    label: '42112004',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΣΤΗΘΑΙΩΝ, ΧΑΜΗΛΩΝ ΔΙΑΧΩΡΙΣΤΙΚΩΝ ΤΟΙΧΙΩΝ, ΣΗΜΑΝΣΗΣ ΚΛΠ ΟΔΩΝ',
  },
  {
    label: '42112005',
    value:
      'ΚΑΤΑΣΚΕΥΗ Η ΑΠΟΚΑΤΑΣΤΑΣΗ ΟΔΙΚΩΝ ΕΠΙΦΑΝΕΙΩΝ ΜΕ ΑΣΦΑΛΤΟ Η ΣΚΥΡΟΔΕΜΑ ΚΛΠ',
  },
  {
    label: '42112006',
    value: 'ΚΑΤΑΣΚΕΥΗ ΠΕΖΟΔΡΟΜΩΝ, ΠΟΔΗΛΑΤΟΔΡΟΜΩΝ ΚΛΠ',
  },
  {
    label: '42120000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΓΡΑΜΜΩΝ ΚΑΙ ΥΠΟΓΕΙΩΝ ΣΙΔΗΡΟΔΡΟΜΩΝ',
  },
  {
    label: '42122000',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΣΙΔΗΡΟΔΡΟΜΙΚΕΣ ΓΡΑΜΜΕΣ ΚΑΙ ΥΠΟΓΕΙΟΥΣ ΣΙΔΗΡΟΔΡΟΜΟΥΣ',
  },
  {
    label: '42122001',
    value: 'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΣΚΥΡΟΣΤΡΩΜΑΤΟΣ ΚΑΙ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΓΡΑΜΜΩΝ',
  },
  {
    label: '42122002',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΣΥΣΤΗΜΑΤΩΝ ΕΛΕΓΧΟΥ ΚΑΙ ΑΣΦΑΛΕΙΑΣ ΓΙΑ ΣΙΔΗΡΟΔΡΟΜΙΚΕΣ ΓΡΑΜΜΕΣ',
  },
  {
    label: '42122003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΚΑΙΝΙΣΗΣ Η ΕΠΙΣΚΕΥΗΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΓΡΑΜΜΩΝ',
  },
  {
    label: '42130000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΓΕΦΥΡΩΝ ΚΑΙ ΣΗΡΑΓΓΩΝ',
  },
  {
    label: '42132000',
    value: 'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΓΕΦΥΡΕΣ ΚΑΙ ΣΗΡΑΓΓΕΣ',
  },
  {
    label: '42210000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΚΟΙΝΩΦΕΛΩΝ ΕΡΓΩΝ ΣΧΕΤΙΚΩΝ ΜΕ ΜΕΤΑΦΟΡΑ ΥΓΡΩΝ',
  },
  {
    label: '42211100',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΓΩΓΩΝ ΜΕΓΑΛΩΝ ΑΠΟΣΤΑΣΕΩΝ ΓΙΑ ΜΕΤΑΦΟΡΑ ΥΓΡΩΝ',
  },
  {
    label: '42211200',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΟΠΙΚΩΝ ΑΓΩΓΩΝ ΓΙΑ ΜΕΤΑΦΟΡΑ ΥΓΡΩΝ',
  },
  {
    label: '42211300',
    value:
      'ΚΑΤΑΣΚΕΥΕΣ ΣΥΣΤΗΜΑΤΩΝ ΑΡΔΕΥΣΗΣ (ΤΑΦΡΩΝ)· ΚΑΤΑΣΚΕΥΕΣ ΤΡΟΦΟΔΟΤΙΚΩΝ ΚΑΙ ΔΕΥΤΕΡΕΥΟΝΤΩΝ ΑΓΩΓΩΝ ΥΔΡΕΥΣΗΣ· ΜΟΝΑΔΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΝΕΡΟΥ, ΜΟΝΑΔΩΝ ΔΙΑΘΕΣΗΣ ΛΥΜΑΤΩΝ ΚΑΙ ΑΝΤΛΙΟΣΤΑΣΙΩΝ',
  },
  {
    label: '42212000',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΚΟΙΝΩΦΕΛΗ ΕΡΓΑ ΣΧΕΤΙΚΩΝ ΜΕ ΜΕΤΑΦΟΡΑ ΥΓΡΩΝ',
  },
  {
    label: '42212100',
    value: 'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΑΓΩΓΟΥΣ ΜΕΓΑΛΩΝ ΑΠΟΣΤΑΣΕΩΝ',
  },
  {
    label: '42212200',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΤΟΠΙΚΟΥΣ ΑΓΩΓΟΥΣ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΒΟΗΘΗΤΙΚΩΝ ΕΡΓΑΣΙΩΝ',
  },
  {
    label: '42212300',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΣΥΣΤΗΜΑΤΩΝ ΑΡΔΕΥΣΗΣ (ΤΑΦΡΩΝ), ΤΡΟΦΟΔΟΤΙΚΩΝ ΚΑΙ ΔΕΥΤΕΡΕΥΟΝΤΩΝ ΑΓΩΓΩΝ ΥΔΡΕΥΣΗΣ, ΜΟΝΑΔΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΝΕΡΟΥ, ΜΟΝΑΔΩΝ ΔΙΑΘΕΣΗΣ ΛΥΜΑΤΩΝ ΚΑΙ ΑΝΤΛΙΟΣΤΑΣΙΩΝ',
  },
  {
    label: '42212400',
    value:
      'ΔΙΑΝΟΙΞΗ ΦΡΕΑΤΩΝ ΥΔΑΤΟΣ ΚΑΙ ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΣΗΠΤΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ',
  },
  {
    label: '42212401',
    value: 'ΕΡΓΑΣΙΕΣ ΓΕΩΤΡΗΣΕΩΝ (ΓΙΑ ΑΝΤΛΗΣΗ ΥΔΑΤΟΣ)',
  },
  {
    label: '42212402',
    value:
      'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΑΝΤΛΙΩΝ ΦΡΕΑΤΩΝ ΥΔΑΤΟΣ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΣΩΛΗΝΩΣΕΩΝ ΦΡΕΑΤΩΝ',
  },
  {
    label: '42220000',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΚΟΙΝΩΦΕΛΩΝ ΕΡΓΩΝ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '42221100',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΓΡΑΜΜΩΝ ΜΕΤΑΦΟΡΑΣ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΜΕΓΑΛΩΝ ΑΠΟΣΤΑΣΕΩΝ ΚΑΙ ΓΡΑΜΜΩΝ ΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '42221200',
    value:
      'ΚΑΤΑΣΚΕΥΗ ΤΟΠΙΚΩΝ ΓΡΑΜΜΩΝ ΜΕΤΑΦΟΡΑΣ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΚΑΙ ΓΡΑΜΜΩΝ ΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '42221300',
    value: 'ΚΑΤΑΣΚΕΥΗ ΜΟΝΑΔΩΝ ΠΑΡΑΓΩΓΗΣ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ',
  },
  {
    label: '42221301',
    value: 'ΓΕΝΙΚΕΣ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΥΔΡΟΗΛΕΚΤΡΙΚΑ ΕΡΓΑ',
  },
  {
    label: '42222000',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΚΟΙΝΩΦΕΛΩΝ ΕΡΓΩΝ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '42222100',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΓΡΑΜΜΕΣ ΜΕΤΑΦΟΡΑΣ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΜΕΓΑΛΩΝ ΑΠΟΣΤΑΣΕΩΝ ΚΑΙ ΓΡΑΜΜΕΣ ΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '42222200',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΤΟΠΙΚΕΣ ΓΡΑΜΜΕΣ ΜΕΤΑΦΟΡΑΣ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ ΚΑΙ ΓΡΑΜΜΕΣ ΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '42222300',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΜΟΝΑΔΕΣ ΠΑΡΑΓΩΓΗΣ ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ',
  },
  {
    label: '42910000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΥΔΡΑΥΛΙΚΩΝ ΚΑΙ ΛΙΜΕΝΙΚΩΝ ΕΡΓΩΝ',
  },
  {
    label: '42911000',
    value:
      'ΚΑΤΑΣΚΕΥΕΣ ΠΑΡΑΚΤΙΩΝ ΚΑΙ ΛΙΜΕΝΙΚΩΝ ΕΡΓΩΝ, ΦΡΑΓΜΑΤΩΝ, ΥΔΑΤΟΦΡΑΧΤΩΝ (ΚΛΕΙΣΙΑΔΩΝ) ΚΑΙ ΣΥΝΑΦΕΙΣ ΥΔΡΟΜΗΧΑΝΙΚΕΣ ΚΑΤΑΣΚΕΥΕΣ',
  },
  {
    label: '42912000',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΠΑΡΑΚΤΙΕΣ ΚΑΙ ΛΙΜΕΝΙΚΕΣ ΚΑΤΑΣΚΕΥΕΣ, ΦΡΑΓΜΑΤΑ, ΥΔΑΤΟΦΡΑΚΤΕΣ (ΚΛΕΙΣΙΑΔΕΣ) ΚΑΙ ΣΥΝΑΦΕΙΣ ΥΔΡΟΜΗΧΑΝΙΚΕΣ ΚΑΤΑΣΚΕΥΕΣ',
  },
  {
    label: '42912001',
    value: 'ΕΡΓΑΣΙΕΣ ΒΥΘΟΚΟΡΗΣΗΣ (ΑΦΑΙΡΕΣΗΣ ΒΡΑΧΩΝ ΚΑΙ ΛΑΣΠΗΣ)',
  },
  {
    label: '42912002',
    value:
      'ΥΠΟΒΡΥΧΙΕΣ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΑΠΟ ΔΥΤΕΣ, ΒΑΤΡΑΧΑΝΘΡΩΠΟΥΣ Η ΜΕ ΑΛΛΕΣ ΜΕΘΟΔΟΥΣ',
  },
  {
    label: '42990000',
    value: 'ΚΑΤΑΣΚΕΥΗ ΑΛΛΩΝ ΕΡΓΩΝ ΠΟΛΙΤΙΚΟΥ ΜΗΧΑΝΙΚΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '42991000',
    value: 'ΑΛΛΕΣ ΚΑΤΑΣΚΕΥΕΣ ΠΟΛΙΤΙΚΟΥ ΜΗΧΑΝΙΚΟΥ',
  },
  {
    label: '42991100',
    value: 'ΚΑΤΑΣΚΕΥΕΣ ΣΤΟΝ ΕΞΟΡΥΚΤΙΚΟ ΚΑΙ ΜΕΤΑΠΟΙΗΤΙΚΟ ΤΟΜΕΑ',
  },
  {
    label: '42991200',
    value: 'ΚΑΤΑΣΚΕΥΕΣ ΑΘΛΗΤΙΣΜΟΥ ΚΑΙ ΑΝΑΨΥΧΗΣ',
  },
  {
    label: '42991900',
    value: 'ΑΛΛΕΣ ΚΑΤΑΣΚΕΥΕΣ ΠΟΛΙΤΙΚΟΥ ΜΗΧΑΝΙΚΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '42992000',
    value: 'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΑΛΛΕΣ ΚΑΤΑΣΚΕΥΕΣ ΠΟΛΙΤΙΚΟΥ ΜΗΧΑΝΙΚΟΥ',
  },
  {
    label: '42992100',
    value: 'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΣΤΟΝ ΕΞΟΡΥΚΤΙΚΟ ΚΑΙ ΜΕΤΑΠΟΙΗΤΙΚΟ ΤΟΜΕΑ',
  },
  {
    label: '42992200',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΔΟΜΙΚΟΥ ΣΚΕΛΕΤΟΥ ΓΙΑ ΥΠΑΙΘΡΙΑ ΣΤΑΔΙΑ ΚΑΙ ΑΘΛΗΤΙΚΑ ΓΗΠΕΔΑ',
  },
  {
    label: '42992900',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΚΑΤΑΣΚΕΥΕΣ ΠΟΛΙΤΙΚΟΥ ΜΗΧΑΝΙΚΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '42992901',
    value:
      'ΓΕΝΙΚΕΣ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΓΙΑ ΕΡΓΟΣΤΑΣΙΑ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΑΙ ΚΑΘΑΡΙΣΜΟΥ ΝΕΡΟΥ',
  },
  {
    label: '43110000',
    value: 'ΚΑΤΕΔΑΦΙΣΕΙΣ',
  },
  {
    label: '43111000',
    value: 'ΕΡΓΑΣΙΕΣ ΚΑΤΕΔΑΦΙΣΗΣ',
  },
  {
    label: '43120000',
    value: 'ΠΡΟΕΤΟΙΜΑΣΙΑ ΕΡΓΟΤΑΞΙΟΥ',
  },
  {
    label: '43121000',
    value: 'ΕΡΓΑΣΙΕΣ ΠΡΟΕΤΟΙΜΑΣΙΑΣ ΕΡΓΟΤΑΞΙΩΝ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΕΡΓΩΝ',
  },
  {
    label: '43121100',
    value: 'ΕΡΓΑΣΙΕΣ ΠΡΟΕΤΟΙΜΑΣΙΑΣ ΕΔΑΦΟΥΣ ΚΑΙ ΟΙΚΟΠΕΔΟΥ· ΕΡΓΑΣΙΕΣ ΕΚΚΕΝΩΣΗΣ',
  },
  {
    label: '43121101',
    value: 'ΕΡΓΑΣΙΕΣ ΣΤΑΘΕΡΟΠΟΙΗΣΗΣ ΤΩΝ ΕΔΑΦΩΝ',
  },
  {
    label: '43121102',
    value: 'ΕΡΓΑΣΙΕΣ ΑΠΟΣΤΡΑΓΓΙΣΗΣ ΑΓΡΟΤΙΚΩΝ Η ΔΑΣΙΚΩΝ ΕΚΤΑΣΕΩΝ',
  },
  {
    label: '43121200',
    value: 'ΕΡΓΑΣΙΕΣ ΕΚΣΚΑΦΩΝ ΚΑΙ ΜΕΤΑΚΙΝΗΣΗΣ ΓΑΙΩΝ',
  },
  {
    label: '43121201',
    value:
      'ΕΡΓΑΣΙΕΣ ΑΝΑΤΙΝΑΞΗΣ ΚΑΙ ΑΠΟΜΑΚΡΥΝΣΗΣ ΒΡΑΧΩΝ ΠΡΟΣ ΔΗΜΙΟΥΡΓΙΑ ΕΡΓΟΤΑΞΙΟΥ',
  },
  {
    label: '43121202',
    value: 'ΕΡΓΑΣΙΕΣ ΕΠΙΧΩΜΑΤΩΣΕΩΝ',
  },
  {
    label: '43130000',
    value: 'ΔΟΚΙΜΑΣΤΙΚΕΣ ΓΕΩΤΡΗΣΕΙΣ',
  },
  {
    label: '43131000',
    value: 'ΔΟΚΙΜΑΣΤΙΚΕΣ ΔΙΑΤΡΗΣΕΙΣ ΚΑΙ ΓΕΩΤΡΗΣΕΙΣ',
  },
  {
    label: '43131001',
    value: 'ΟΡΙΖΟΝΤΙΕΣ ΔΙΑΤΡΗΣΕΙΣ ΓΙΑ ΤΟ ΠΕΡΑΣΜΑ ΚΑΛΩΔΙΩΝ Η ΥΔΡΟΡΡΟΩΝ',
  },
  {
    label: '43210000',
    value: 'ΗΛΕΚΤΡΙΚΕΣ ΕΓΚΑΤΑΣΤΑΣΕΙΣ',
  },
  {
    label: '43211000',
    value: 'ΕΡΓΑΣΙΕΣ ΗΛΕΚΤΡΟΛΟΓΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ',
  },
  {
    label: '43211001',
    value: 'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΑΛΕΞΙΚΕΡΑΥΝΩΝ',
  },
  {
    label: '43211002',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΗΛΕΚΤΡΙΚΩΝ ΚΑΛΩΔΙΩΣΕΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ, ΜΕ ΔΙΑΘΕΣΗ ΚΑΙ ΥΛΙΚΩΝ',
  },
  {
    label: '43211003',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΗΛΕΚΤΡΙΚΩΝ ΚΑΛΩΔΙΩΣΕΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ, ΧΩΡΙΣ ΔΙΑΘΕΣΗ ΥΛΙΚΩΝ',
  },
  {
    label: '43211004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΗΛΕΚΤΡΟΛΟΓΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ',
  },
  {
    label: '43211005',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΣΥΣΤΗΜΑΤΩΝ ΣΥΝΑΓΕΡΜΟΥ (ΠΥΡΚΑΓΙΑΣ, ΑΝΤΙΚΛΕΠΤΙΚΩΝ ΚΛΠ) ΣΕ ΑΚΙΝΗΤΑ',
  },
  {
    label: '43211006',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΚΑΛΩΔΙΩΣΕΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ ΚΑΙ ΔΙΚΤΥΩΝ',
  },
  {
    label: '43220000',
    value: 'ΥΔΡΑΥΛΙΚΕΣ ΚΑΙ ΚΛΙΜΑΤΙΣΤΙΚΕΣ ΕΓΚΑΤΑΣΤΑΣΕΙΣ ΘΕΡΜΑΝΣΗΣ ΚΑΙ ΨΥΞΗΣ',
  },
  {
    label: '43221000',
    value:
      'ΕΡΓΑΣΙΕΣ ΥΔΡΑΥΛΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ, ΑΠΟΧΕΤΕΥΤΙΚΩΝ ΑΓΩΓΩΝ, ΘΕΡΜΑΝΣΗΣ, ΑΕΡΙΣΜΟΥ ΚΑΙ ΚΛΙΜΑΤΙΣΜΟΥ',
  },
  {
    label: '43221100',
    value: 'ΕΡΓΑΣΙΕΣ ΥΔΡΑΥΛΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ ΚΑΙ ΑΠΟΧΕΤΕΥΤΙΚΩΝ ΑΓΩΓΩΝ',
  },
  {
    label: '43221101',
    value:
      'ΕΓΚΑΤΑΣΤΑΣΗ ΠΑΡΟΧΩΝ ΝΕΡΟΥ ΜΕ ΠΙΕΣΗ ΓΙΑ ΠΥΡΟΣΒΕΣΗ (ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΠΥΡΟΣΒΕΣΤΙΚΩΝ ΚΡΟΥΝΩΝ)',
  },
  {
    label: '43221102',
    value:
      'ΕΓΚΑΤΑΣΤΑΣΗ ΣΥΣΤΗΜΑΤΩΝ ΓΙΑ ΤΗ ΔΙΑΘΕΣΗ ΤΩΝ ΛΥΜΑΤΩΝ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΥΠΟΝΟΜΩΝ ΚΑΙ ΤΩΝ ΣΗΠΤΙΚΩΝ ΔΕΞΑΜΕΝΩΝ',
  },
  {
    label: '43221103',
    value: 'ΕΓΚΑΤΑΣΤΑΣΗ ΣΥΣΤΗΜΑΤΩΝ ΣΩΛΗΝΩΣΕΩΝ ΖΕΣΤΟΥ ΚΑΙ ΚΡΥΟΥ ΝΕΡΟΥ',
  },
  {
    label: '43221104',
    value: 'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ',
  },
  {
    label: '43221105',
    value: 'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΣΥΣΤΗΜΑΤΩΝ ΚΑΤΑΙΟΝΙΣΜΟΥ (ΣΠΡΙΝΚΛΕΡ)',
  },
  {
    label: '43221106',
    value:
      'ΥΔΡΑΥΛΙΚΕΣ ΕΡΓΑΣΙΕΣ ΠΟΥ ΠΡΟΚΥΠΤΟΥΝ ΑΠΟ ΤΗΝ ΕΓΚΑΤΑΣΤΑΣΗ ΣΥΣΚΕΥΩΝ (Π.Χ. ΠΛΥΝΤΗΡΙΩΝ)',
  },
  {
    label: '43221107',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΦΡΑΞΕΩΣ ΦΡΕΑΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΔΡΑΥΛΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ',
  },
  {
    label: '43221108',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΥΔΡΑΥΛΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ, ΜΕ ΥΛΙΚΑ ΤΟΥ ΕΠΙΣΚΕΥΑΣΤΗ',
  },
  {
    label: '43221109',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΥΔΡΑΥΛΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ, ΧΩΡΙΣ ΥΛΙΚΑ',
  },
  {
    label: '43221200',
    value: 'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΕΩΝ ΘΕΡΜΑΝΣΗΣ, ΑΕΡΙΣΜΟΥ ΚΑΙ ΚΛΙΜΑΤΙΣΜΟΥ',
  },
  {
    label: '43221201',
    value: 'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΜΕΤΡΗΤΩΝ ΚΑΤΑΝΑΛΩΣΗΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '43221202',
    value:
      'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΜΗ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΘΕΡΜΑΝΣΗΣ (ΚΑΤΑΣΚΕΥΗ ΣΩΛΗΝΩΣΕΩΝ, ΑΕΡΑΓΩΓΩΝ ΚΑΙ ΣΥΝΑΦΕΙΣ ΕΡΓΑΣΙΕΣ ΜΕ ΛΑΜΑΡΙΝΑ)',
  },
  {
    label: '43221203',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΣΥΣΤΗΜΑΤΩΝ ΕΛΕΓΧΟΥ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '43221204',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΕΓΚΑΤΑΣΤΑΣΕΩΝ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '43221205',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΗΛΙΑΚΩΝ ΘΕΡΜΟΣΙΦΩΝΩΝ, ΚΛΙΜΑΤΙΣΤΙΚΩΝ ΚΛΠ',
  },
  {
    label: '43222000',
    value: 'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΕΩΝ ΑΕΡΙΟΥ',
  },
  {
    label: '43222001',
    value:
      'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΓΙΑ ΤΗΝ ΠΑΡΟΧΗ ΔΙΑΦΟΡΩΝ ΡΕΥΣΤΩΝ (Π.Χ. ΟΞΥΓΟΝΟΥ ΣΕ ΝΟΣΟΚΟΜΕΙΑ)',
  },
  {
    label: '43222002',
    value:
      'ΕΡΓΑΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΕΓΚΑΤΑΣΤΑΣΕΩΝ ΚΑΙ ΕΣΩΤΕΡΙΚΟΥ ΔΙΚΤΥΟΥ ΦΩΤΑΕΡΙΟΥ ΚΑΙ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '43222003',
    value:
      'ΕΡΓΑΣΙΕΣ ΣΥΝΔΕΣΗΣ ΕΓΚΑΤΑΣΤΑΣΕΩΝ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ ΜΕ ΕΞΟΠΛΙΣΜΟ ΠΟΥ ΛΕΙΤΟΥΡΓΕΙ ΜΕ ΑΥΤΟ',
  },
  {
    label: '43290000',
    value: 'ΑΛΛΕΣ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΓΚΑΤΑΣΤΑΣΕΙΣ',
  },
  {
    label: '43291000',
    value: 'ΑΛΛΕΣ ΕΡΓΑΣΙΕΣ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ',
  },
  {
    label: '43291100',
    value: 'ΕΡΓΑΣΙΕΣ ΜΟΝΩΣΗΣ',
  },
  {
    label: '43291101',
    value: 'ΕΡΓΑΣΙΕΣ ΗΧΟΜΟΝΩΣΗΣ ΚΤΙΡΙΩΝ Η ΑΛΛΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '43291102',
    value: 'ΕΡΓΑΣΙΕΣ ΘΕΡΜΟΜΟΝΩΣΗΣ ΕΞΩΤΕΡΙΚΩΝ ΕΠΙΦΑΝΕΙΩΝ ΤΟΙΧΩΝ',
  },
  {
    label: '43291103',
    value:
      'ΕΡΓΑΣΙΕΣ ΘΕΡΜΟΜΟΝΩΣΗΣ ΣΩΛΗΝΩΝ ΖΕΣΤΟΥ ΚΑΙ ΚΡΥΟΥ ΝΕΡΟΥ, ΛΕΒΗΤΩΝ ΚΑΙ ΑΕΡΑΓΩΓΩΝ',
  },
  {
    label: '43291104',
    value: 'ΕΡΓΑΣΙΕΣ ΜΟΝΩΣΗΣ ΚΑΤΑ ΤΩΝ ΔΟΝΗΣΕΩΝ ΚΤΙΡΙΩΝ Η ΑΛΛΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '43291105',
    value: 'ΕΡΓΑΣΙΕΣ ΠΥΡΙΜΑΧΟΠΟΙΗΣΗΣ ΚΤΙΡΙΩΝ Η ΑΛΛΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '43291200',
    value: 'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΠΕΡΙΦΡΑΞΕΩΝ ΚΑΙ ΚΙΓΚΛΙΔΩΜΑΤΩΝ',
  },
  {
    label: '43291900',
    value: 'ΑΛΛΕΣ ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '43291901',
    value: 'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΣΗΜΑΤΩΝ (ΦΩΤΕΙΝΩΝ Η ΟΧΙ)',
  },
  {
    label: '43291902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΑΝΕΛΚΥΣΤΗΡΩΝ',
  },
  {
    label: '43291903',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΚΥΛΙΟΜΕΝΩΝ ΚΛΙΜΑΚΩΝ ΚΑΙ ΚΥΛΙΟΜΕΝΩΝ ΠΕΖΟΔΡΟΜΙΩΝ',
  },
  {
    label: '43291904',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΑΝΕΛΚΥΣΤΗΡΩΝ, ΚΥΛΙΟΜΕΝΩΝ ΚΛΙΜΑΚΩΝ ΚΑΙ ΚΥΛΙΟΜΕΝΩΝ ΠΕΖΟΔΡΟΜΙΩΝ',
  },
  {
    label: '43291905',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ, ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΠΕΡΙΣΤΡΕΦΟΜΕΝΩΝ ΚΑΙ ΑΥΤΟΜΑΤΩΝ ΠΟΡΤΩΝ',
  },
  {
    label: '43310000',
    value: 'ΕΠΙΧΡΙΣΕΙΣ ΚΟΝΙΑΜΑΤΩΝ',
  },
  {
    label: '43311000',
    value: 'ΕΡΓΑΣΙΕΣ ΕΠΙΧΡΙΣΗΣ ΚΟΝΙΑΜΑΤΩΝ',
  },
  {
    label: '43320000',
    value: 'ΞΥΛΟΥΡΓΙΚΕΣ ΕΡΓΑΣΙΕΣ',
  },
  {
    label: '43321000',
    value: 'ΕΡΓΑΣΙΕΣ ΞΥΛΟΥΡΓΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ',
  },
  {
    label: '43321001',
    value: 'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΕΞΟΠΛΙΣΜΕΝΩΝ ΚΟΥΖΙΝΩΝ',
  },
  {
    label: '43321002',
    value: 'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΚΛΙΜΑΚΟΣΤΑΣΙΩΝ',
  },
  {
    label: '43321003',
    value: 'ΕΡΓΑΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΝΤΟΥΛΑΠΙΩΝ ΤΟΙΧΟΥ',
  },
  {
    label: '43321004',
    value:
      'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΚΙΝΗΤΩΝ ΧΩΡΙΣΜΑΤΩΝ ΚΑΙ ΨΕΥΔΟΡΟΦΩΝ ΣΕ ΚΑΤΑΣΚΕΥΕΣ',
  },
  {
    label: '43321005',
    value:
      'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΚΟΥΡΤΙΝΩΝ, ΣΤΟΡΙΩΝ, ΡΟΛΕΡ, ΣΙΤΩΝ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΠΕΤΑΣΜΑΤΩΝ, ΣΕ ΠΟΡΤΕΣ Η ΠΑΡΑΘΥΡΑ',
  },
  {
    label: '43321006',
    value: 'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΜΕΤΑΛΛΙΚΩΝ ΚΟΥΦΩΜΑΤΩΝ',
  },
  {
    label: '43321007',
    value: 'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΜΕΤΑΛΛΙΚΩΝ ΣΤΕΓΑΣΤΡΩΝ, ΘΕΡΜΟΚΗΠΙΩΝ ΚΛΠ',
  },
  {
    label: '43321008',
    value: 'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΞΥΛΕΠΕΝΔΥΣΗΣ',
  },
  {
    label: '43321009',
    value: 'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΞΥΛΙΝΩΝ Η ΜΕΤΑΛΛΙΚΩΝ ΚΟΥΦΩΜΑΤΩΝ, ΝΤΟΥΛΑΠΙΩΝ',
  },
  {
    label: '43321010',
    value: 'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΤΕΝΤΩΝ ΚΑΙ ΣΤΕΓΑΣΤΡΩΝ',
  },
  {
    label: '43321011',
    value: 'ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΠΟΥ ΠΕΡΙΛΑΜΒΑΝΟΥΝ ΞΥΛΟΥΡΓΙΚΕΣ ΕΡΓΑΣΙΕΣ',
  },
  {
    label: '43330000',
    value: 'ΕΠΕΝΔΥΣΕΙΣ ΔΑΠΕΔΩΝ ΚΑΙ ΤΟΙΧΩΝ',
  },
  {
    label: '43331000',
    value: 'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΠΛΑΚΙΔΙΩΝ',
  },
  {
    label: '43331001',
    value:
      'ΔΙΑΚΟΣΜΗΤΙΚΗ ΕΠΕΝΔΥΣΗ ΕΞΩΤΕΡΙΚΩΝ ΤΟΙΧΩΝ ΚΤΙΡΙΩΝ ΜΕ ΚΕΡΑΜΙΚΑ ΥΛΙΚΑ, ΤΟΥΒΛΑ ΚΛΠ',
  },
  {
    label: '43331002',
    value:
      'ΕΡΓΑΣΙΕΣ ΔΙΑΣΤΡΩΣΗΣ Η ΤΟΠΟΘΕΤΗΣΗΣ ΠΛΑΚΩΝ ΣΕ ΤΟΙΧΟΥΣ Η ΔΑΠΕΔΑ ΚΤΙΡΙΩΝ Η ΑΛΛΩΝ ΚΑΤΑΣΚΕΥΩΝ ΛΙΘΟΛΑΞΕΥΤΩΝ Η ΜΑΡΜΑΡΙΝΩΝ',
  },
  {
    label: '43332000',
    value:
      'ΑΛΛΕΣ ΕΡΓΑΣΙΕΣ ΔΙΑΣΤΡΩΣΗΣ ΚΑΙ ΕΠΕΝΔΥΣΗΣ ΔΑΠΕΔΩΝ, ΕΠΕΝΔΥΣΗΣ ΤΟΙΧΩΝ ΚΑΘΩΣ ΚΑΙ ΤΟΠΟΘΕΤΗΣΗΣ ΧΑΡΤΙΟΥ ΤΟΙΧΟΣΤΡΩΣΙΑΣ (ΤΑΠΕΤΣΑΡΙΑΣ)',
  },
  {
    label: '43332100',
    value:
      'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ (ΚΕΡΑΜΙΚΩΝ) ΠΛΑΚΙΔΙΩΝ TERRAZZO, ΜΑΡΜΑΡΟΥ, ΓΡΑΝΙΤΗ ΚΑΙ ΣΧΙΣΤΟΛΙΘΟΥ',
  },
  {
    label: '43332101',
    value: 'ΕΡΓΑΣΙΕΣ ΕΣΩΤΕΡΙΚΗΣ ΔΙΑΚΟΣΜΗΣΗΣ ΜΕ ΜΑΡΜΑΡΟ, ΓΡΑΝΙΤΗ Η ΣΧΙΣΤΟΛΙΘΟ',
  },
  {
    label: '43332102',
    value: 'ΕΡΓΑΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΜΩΣΑΪΚΟΥ, ΠΑΡΑΣΚΕΥΑΖΟΜΕΝΟΥ ΕΠΙΤΟΠΟΥ',
  },
  {
    label: '43332103',
    value: 'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΨΗΦΙΔΩΤΩΝ ΣΕ ΔΑΠΕΔΑ ΚΑΙ ΤΟΙΧΟΥΣ',
  },
  {
    label: '43332900',
    value:
      'ΑΛΛΕΣ ΕΡΓΑΣΙΕΣ ΔΙΑΣΤΡΩΣΗΣ ΚΑΙ ΕΠΕΝΔΥΣΗΣ ΔΑΠΕΔΩΝ, ΕΠΕΝΔΥΣΗΣ ΤΟΙΧΩΝ ΚΑΘΩΣ ΚΑΙ ΤΟΠΟΘΕΤΗΣΗΣ ΧΑΡΤΙΟΥ ΤΟΙΧΟΣΤΡΩΣΙΑΣ (ΤΑΠΕΤΣΑΡΙΑΣ) Π.Δ.Κ.Α.',
  },
  {
    label: '43332901',
    value: 'ΕΡΓΑΣΙΕΣ ΔΙΑΣΤΡΩΣΗΣ ΔΑΠΕΔΩΝ ΜΕ ΑΣΦΑΛΤΙΚΑ ΠΛΑΚΙΔΙΑ',
  },
  {
    label: '43332902',
    value: 'ΕΡΓΑΣΙΕΣ ΔΙΑΣΤΡΩΣΗΣ ΔΑΠΕΔΩΝ ΜΕ ΠΑΡΚΕΤΑ',
  },
  {
    label: '43332903',
    value: 'ΕΡΓΑΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΠΑΤΩΜΑΤΩΝ',
  },
  {
    label: '43340000',
    value: 'ΧΡΩΜΑΤΙΣΜΟΙ ΚΑΙ ΤΟΠΟΘΕΤΗΣΗ ΥΑΛΟΠΙΝΑΚΩΝ',
  },
  {
    label: '43341000',
    value: 'ΕΡΓΑΣΙΕΣ ΧΡΩΜΑΤΙΣΜΩΝ',
  },
  {
    label: '43342000',
    value: 'ΥΑΛΟΤΕΧΝΙΚΕΣ ΕΡΓΑΣΙΕΣ',
  },
  {
    label: '43342001',
    value:
      'ΕΡΓΑΣΙΕΣ ΚΑΤΑΣΚΕΥΩΝ ΑΠΟ ΓΥΑΛΙ, ΕΠΕΝΔΥΣΕΩΝ ΜΕ ΓΥΑΛΙ, ΚΑΘΡΕΠΤΩΝ ΤΟΙΧΟΥ ΚΛΠ',
  },
  {
    label: '43342002',
    value: 'ΕΡΓΑΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΤΖΑΜΙΩΝ ΣΕ ΠΑΡΑΘΥΡΑ, ΠΟΡΤΕΣ, ΒΙΤΡΙΝΕΣ',
  },
  {
    label: '43390000',
    value: 'ΑΛΛΕΣ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ ΟΛΟΚΛΗΡΩΣΗΣ ΚΑΙ ΤΕΛΕΙΩΜΑΤΟΣ',
  },
  {
    label: '43391100',
    value: 'ΕΡΓΑΣΙΕΣ ΚΑΤΑΣΚΕΥΩΝ ΔΙΑΚΟΣΜΗΣΗΣ',
  },
  {
    label: '43391101',
    value: 'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΑΠΟ ΣΙΔΕΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '43391102',
    value: 'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΚΙΓΚΛΙΔΩΜΑΤΩΝ',
  },
  {
    label: '43391103',
    value:
      'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΤΥΠΟΠΟΙΗΜΕΝΩΝ Η ΕΠΙ ΠΑΡΑΓΓΕΛΙΑ ΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΣΤΟΙΧΕΙΩΝ ΑΠΟ ΛΑΜΑΡΙΝΑ',
  },
  {
    label: '43391900',
    value:
      'ΑΛΛΕΣ ΕΡΓΑΣΙΕΣ ΟΛΟΚΛΗΡΩΣΗΣ (ΑΠΟΠΕΡΑΤΩΣΗΣ) ΚΤΙΡΙΩΝ ΚΑΙ ΤΕΛΕΙΩΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '43910000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΚΑΤΑΣΚΕΥΗΣ ΣΤΕΓΩΝ',
  },
  {
    label: '43911000',
    value: 'ΕΡΓΑΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΣΤΕΓΩΝ',
  },
  {
    label: '43911100',
    value: 'ΕΡΓΑΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΠΛΑΙΣΙΩΝ ΣΤΕΓΩΝ',
  },
  {
    label: '43911900',
    value: 'ΑΛΛΕΣ ΕΡΓΑΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΣΤΕΓΩΝ',
  },
  {
    label: '43990000',
    value: 'ΑΛΛΕΣ ΕΞΕΙΔΙΚΕΥΜΕΝΕΣ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '43991000',
    value: 'ΕΡΓΑΣΙΕΣ ΣΤΕΓΑΝΩΣΗΣ',
  },
  {
    label: '43991001',
    value: 'ΕΡΓΑΣΙΕΣ ΣΤΕΓΑΝΩΣΗΣ ΣΕ ΕΠΙΠΕΔΕΣ ΣΤΕΓΕΣ ΚΑΙ ΣΕ ΕΞΩΣΤΕΣ',
  },
  {
    label: '43991002',
    value:
      'ΕΡΓΑΣΙΕΣ ΣΤΕΓΑΝΩΣΗΣ ΤΟΥ ΕΣΩΤΕΡΙΚΟΥ ΜΕΡΟΥΣ ΚΑΤΑΣΚΕΥΩΝ ΚΑΙ ΑΛΛΩΝ ΥΠΟΓΕΙΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '43992000',
    value: 'ΕΡΓΑΣΙΕΣ ΙΚΡΙΩΜΑΤΩΝ',
  },
  {
    label: '43992001',
    value: 'ΕΝΟΙΚΙΑΣΗ ΙΚΡΙΩΜΑΤΩΝ ΚΑΙ ΕΞΕΔΡΩΝ ΕΡΓΑΣΙΑΣ',
  },
  {
    label: '43993000',
    value: 'ΕΡΓΑΣΙΕΣ ΕΜΠΗΞΗΣ ΠΑΣΑΛΩΝ· ΕΡΓΑΣΙΕΣ ΘΕΜΕΛΙΩΣΕΩΝ',
  },
  {
    label: '43994000',
    value: 'ΕΡΓΑΣΙΕΣ ΣΚΥΡΟΔΕΜΑΤΟΣ',
  },
  {
    label: '43994001',
    value:
      'ΕΡΓΑΣΙΕΣ ΚΑΜΨΗΣ ΧΑΛΥΒΑ ΓΙΑ ΚΑΤΑΣΚΕΥΑΣΤΙΚΑ ΕΡΓΑ ΕΝΙΣΧΥΜΕΝΟΥ ΣΚΥΡΟΔΕΜΑΤΟΣ',
  },
  {
    label: '43994002',
    value: 'ΕΡΓΑΣΙΕΣ ΣΤΑΘΕΡΟΠΟΙΗΣΗΣ ΘΕΜΕΛΙΩΝ',
  },
  {
    label: '43994003',
    value: 'ΚΑΤΑΣΚΕΥΗ ΘΟΛΩΝ ΚΑΙ ΛΕΠΤΩΝ ΚΕΛΥΦΩΝ ΑΠΟ ΣΚΥΡΟΔΕΜΑ',
  },
  {
    label: '43994004',
    value: 'ΚΑΤΑΣΚΕΥΗ ΤΥΠΩΝ (ΚΑΛΟΥΠΙΩΝ) ΧΥΤΕΥΣΗΣ ΣΚΥΡΟΔΕΜΑΤΟΣ',
  },
  {
    label: '43995000',
    value: 'ΕΡΓΑΣΙΕΣ ΑΝΕΓΕΡΣΗΣ ΧΑΛΥΒΔΙΝΩΝ ΔΟΜΙΚΩΝ ΜΕΡΩΝ',
  },
  {
    label: '43995001',
    value: 'ΑΝΕΓΕΡΣΗ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΧΑΛΥΒΔΙΝΩΝ ΔΟΜΙΚΩΝ ΜΕΡΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '43995002',
    value:
      'ΑΝΕΓΕΡΣΗ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΧΑΛΥΒΔΙΝΩΝ ΣΤΟΙΧΕΙΩΝ ΓΙΑ ΚΑΤΑΣΚΕΥΕΣ ΑΛΛΕΣ ΑΠΟ ΚΤΙΡΙΑ',
  },
  {
    label: '43995003',
    value:
      'ΕΡΓΑΣΙΕΣ ΣΥΝΔΕΣΗΣ ΧΑΛΥΒΔΙΝΩΝ ΔΟΜΙΚΩΝ ΜΕΡΩΝ ΓΙΑ ΚΑΤΑΣΚΕΥΕΣ ΑΛΛΕΣ ΑΠΟ ΚΤΙΡΙΑ',
  },
  {
    label: '43995004',
    value: 'ΕΡΓΑΣΙΕΣ ΣΥΝΔΕΣΗΣ ΧΑΛΥΒΔΙΝΩΝ ΔΟΜΙΚΩΝ ΜΕΡΩΝ ΓΙΑ ΚΤΙΡΙΑ',
  },
  {
    label: '43996000',
    value: 'ΕΡΓΑΣΙΕΣ ΤΟΙΧΟΠΟΙΙΑΣ ΚΑΙ ΟΠΤΟΠΛΙΝΘΟΔΟΜΩΝ',
  },
  {
    label: '43997000',
    value: 'ΣΥΝΑΡΜΟΛΟΓΗΣΗ ΚΑΙ ΕΡΓΑΣΙΕΣ ΑΝΕΓΕΡΣΗΣ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '43999000',
    value: 'ΕΞΕΙΔΙΚΕΥΜΕΝΕΣ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '43999001',
    value:
      'ΑΛΛΕΣ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ, ΠΟΥ ΔΕΝ ΚΑΤΟΝΟΜΑΖΟΝΤΑΙ ΕΙΔΙΚΑ, ΜΕ ΙΔΙΑ ΥΛΙΚΑ',
  },
  {
    label: '43999002',
    value:
      'ΑΛΛΕΣ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΕΡΓΑΣΙΕΣ, ΠΟΥ ΔΕΝ ΚΑΤΟΝΟΜΑΖΟΝΤΑΙ ΕΙΔΙΚΑ, ΧΩΡΙΣ ΙΔΙΑ ΥΛΙΚΑ',
  },
  {
    label: '43999003',
    value: 'ΕΡΓΑΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΚΟΛΥΜΒΗΤΙΚΩΝ ΔΕΞΑΜΕΝΩΝ (ΠΙΣΙΝΩΝ)',
  },
  {
    label: '43999004',
    value:
      'ΕΡΓΑΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΙΣΤΟΡΙΚΩΝ ΚΑΙ ΠΑΡΑΔΟΣΙΑΚΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '43999005',
    value: 'ΕΡΓΑΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΕΣΤΙΩΝ (ΤΖΑΚΙΩΝ)',
  },
  {
    label: '43999006',
    value: 'ΕΡΓΑΣΙΕΣ ΜΕΤΑΚΙΝΗΣΗΣ ΚΤΙΡΙΩΝ',
  },
  {
    label: '43999007',
    value:
      'ΕΡΓΑΣΙΕΣ ΧΕΙΡΙΣΤΗ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΤΑΣΚΕΥΩΝ (ΧΩΜΑΤΟΥΡΓΙΚΩΝ, ΟΔΟΠΟΙΗΤΙΚΩΝ ΚΛΠ)',
  },
  {
    label: '43999008',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΛΑΣΤΙΚΗΣ ΕΠΙΚΑΛΥΨΗΣ ΔΕΞΑΜΕΝΩΝ ΚΟΛΥΜΒΗΤΗΡΙΩΝ ΚΛΠ',
  },
  {
    label: '45110000',
    value: 'ΠΩΛΗΣΗ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45111000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45111100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΒΑΤΗΓΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45111101',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΗΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΠΙΒΑΤΩΝ, ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ',
  },
  {
    label: '45111102',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΤΡΟΧΟΣΠΙΤΩΝ ΜΕ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '45111103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΤΡΟΧΟΣΠΙΤΩΝ ΜΕ ΚΙΝΗΤΗΡΑ ΣΤΟΝ ΟΠΟΙΟ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '45111104',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΒΑΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΜΕ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '45111105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΒΑΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΜΕ ΚΙΝΗΤΗΡΑ ΣΤΟΝ ΟΠΟΙΟ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '45111200',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΒΑΤΗΓΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ, ΟΠΩΣ ΑΣΘΕΝΟΦΟΡΑ ΚΑΙ ΜΙΚΡΑ ΛΕΩΦΟΡΕΙΑ ΚΛΠ, ΚΑΙ ΟΧΗΜΑΤΩΝ ΠΑΝΤΟΣ ΕΔΑΦΟΥΣ (ΒΑΡΟΥΣ <= 3 ;0,5; ΤΟΝΩΝ)',
  },
  {
    label: '45111201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΤΡΕΠΟΜΕΝΩΝ ΟΧΗΜΑΤΩΝ ΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΓΙΑ ΝΑ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΕΚΤΟΣ ΤΟΥ ΟΔΙΚΟΥ ΔΙΚΤΥΟΥ',
  },
  {
    label: '45111202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '45111203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΧΗΜΑΤΩΝ ΠΟΥ ΚΙΝΟΥΝΤΑΙ ΠΑΝΩ ΣΤΟ ΧΙΟΝΙ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΟΧΗΜΑΤΩΝ, ΜΕ ΚΙΝΗΤΗΡΕΣ',
  },
  {
    label: '45112000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '45112100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΒΑΤΗΓΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45112101',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΠΙΒΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '45112102',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΜΕ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '45112103',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΜΕ ΚΙΝΗΤΗΡΑ ΣΤΟΝ ΟΠΟΙΟ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '45112200',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΕΠΙΒΑΤΗΓΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45112201',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΕΠΙΒΑΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45112300',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΒΑΤΗΓΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ, ΟΠΩΣ ΑΣΘΕΝΟΦΟΡΑ ΚΑΙ ΜΙΚΡΑ ΛΕΩΦΟΡΕΙΑ ΚΛΠ, ΚΑΙ ΟΧΗΜΑΤΩΝ ΠΑΝΤΟΣ ΕΔΑΦΟΥΣ (ΒΑΡΟΥΣ <= 3 ;0,5; ΤΟΝΩΝ)',
  },
  {
    label: '45112400',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΕΠΙΒΑΤΗΓΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ, ΟΠΩΣ ΑΣΘΕΝΟΦΟΡΑ ΚΑΙ ΜΙΚΡΑ ΛΕΩΦΟΡΕΙΑ ΚΛΠ, ΚΑΙ ΟΧΗΜΑΤΩΝ ΠΑΝΤΟΣ ΕΔΑΦΟΥΣ (ΒΑΡΟΥΣ <= 3 ;0,5; ΤΟΝΩΝ)',
  },
  {
    label: '45113000',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45113100',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '45113900',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '45114000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45114100',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '45114900',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45114901',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '45114902',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΠΙΒΑΤΙΚΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45114903',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΑΙΝΟΥΡΓΙΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45114904',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΛΕΩΦΟΡΕΙΩΝ',
  },
  {
    label: '45114905',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45114906',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΦΟΡΤΗΓΩΝ',
  },
  {
    label: '45190000',
    value: 'ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45191000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45191100',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΟΡΤΗΓΩΝ, ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΟΧΗΜΑΤΩΝ ΚΑΙ ΛΕΩΦΟΡΕΙΩΝ',
  },
  {
    label: '45191101',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45191102',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΔΕΚΑ Η ΠΕΡΙΣΣΟΤΕΡΩΝ ΕΠΙΒΑΤΩΝ (ΛΕΩΦΟΡΕΙΩΝ)',
  },
  {
    label: '45191103',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΕΡΑΝΟΦΟΡΩΝ ΦΟΡΤΗΓΩΝ',
  },
  {
    label: '45191104',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΕΩΦΟΡΕΙΩΝ, ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ',
  },
  {
    label: '45191105',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΦΟΡΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45191106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΔΙΚΩΝ ΕΛΚΥΣΤΗΡΩΝ ΓΙΑ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45191107',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΧΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '45191108',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΧΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΚΙΝΗΤΗΡΑ ΣΤΟΝ ΟΠΟΙΟ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '45191200',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΧΗΜΑΤΩΝ ΚΑΤΑΣΚΗΝΩΣΗΣ (CAMPING), ΟΠΩΣ ΤΡΟΧΟΣΠΙΤΩΝ ΚΑΙ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΚΑΤΟΙΚΙΩΝ',
  },
  {
    label: '45191201',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΧΗΜΑΤΩΝ ΚΑΤΑΣΚΗΝΩΣΗΣ, ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ',
  },
  {
    label: '45191202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ, ΤΥΠΟΥ ΤΡΟΧΟΣΠΙΤΟΥ, ΓΙΑ ΚΑΤΟΙΚΗΣΗ Η ΚΑΤΑΣΚΗΝΩΣΗ',
  },
  {
    label: '45192000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '45192100',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΟΡΤΗΓΩΝ, ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΟΧΗΜΑΤΩΝ ΚΑΙ ΛΕΩΦΟΡΕΙΩΝ',
  },
  {
    label: '45192200',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΧΗΜΑΤΩΝ ΚΑΤΑΣΚΗΝΩΣΗΣ (CAMPING), ΟΠΩΣ ΤΡΟΧΟΣΠΙΤΩΝ ΚΑΙ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΚΑΤΟΙΚΙΩΝ',
  },
  {
    label: '45192201',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΤΡΟΧΟΣΠΙΤΩΝ, ΚΑΙΝΟΥΡΓΙΩΝ',
  },
  {
    label: '45192202',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΧΗΜΑΤΩΝ ΚΑΤΑΣΚΗΝΩΣΗΣ, ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ',
  },
  {
    label: '45192203',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΤΥΠΟΥ ΤΡΟΧΟΣΠΙΤΟΥ, ΓΙΑ ΚΑΤΟΙΚΗΣΗ Η ΚΑΤΑΣΚΗΝΩΣΗ',
  },
  {
    label: '45193000',
    value: 'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45193100',
    value: 'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '45193900',
    value: 'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '45194000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45194100',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '45194900',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45194901',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΑΛΛΩΝ ΟΧΗΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '45200000',
    value: 'ΣΥΝΤΗΡΗΣΗ ΚΑΙ ΕΠΙΣΚΕΥΗ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45201000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΕΜΠΟΡΕΥΜΑΤΑ',
  },
  {
    label: '45201100',
    value:
      'ΣΥΝΗΘΕΙΣ ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΕΜΠΟΡΕΥΜΑΤΑ (ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΤΟΥ ΗΛΕΚΤΡΙΚΟΥ ΣΥΣΤΗΜΑΤΟΣ, ΤΩΝ ΕΛΑΣΤΙΚΩΝ ΚΑΙ ΤΟΥ ΑΜΑΞΩΜΑΤΟΣ)',
  },
  {
    label: '45201101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΛΛΑΓΗΣ ΛΑΔΙΩΝ ΕΠΙΒΑΤΗΓΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΦΟΡΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45201102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΡΥΘΜΙΣΗΣ ΤΟΥ ΚΑΡΜΠΥΡΑΤΕΡ ΕΠΙΒΑΤΗΓΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΦΟΡΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45201103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΡΥΘΜΙΣΗΣ ΤΩΝ ΦΡΕΝΩΝ ΕΠΙΒΑΤΗΓΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΦΟΡΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45201104',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΕΞΑΡΤΗΜΑΤΩΝ ΕΠΙΒΑΤΗΓΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΦΟΡΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45201105',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΕΡΩΝ ΤΗΣ ΜΗΧΑΝΗΣ ΕΠΙΒΑΤΗΓΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΦΟΡΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45201106',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΥΛΙΝΔΡΩΝ ΚΙΝΗΤΗΡΩΝ ΕΠΙΒΑΤΗΓΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΦΟΡΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ (ΡΕΚΤΙΦΙΕ)',
  },
  {
    label: '45201107',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΣΥΣΤΗΜΑΤΟΣ ΕΞΑΤΜΙΣΗΣ ΕΠΙΒΑΤΗΓΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΦΟΡΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45201108',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΕΠΙΒΑΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ, ΜΕ ΥΛΙΚΑ ΚΑΙ ΑΝΤΑΛΛΑΚΤΙΚΑ',
  },
  {
    label: '45201109',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΕΠΙΒΑΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ, ΧΩΡΙΣ ΥΛΙΚΑ ΚΑΙ ΑΝΤΑΛΛΑΚΤΙΚΑ',
  },
  {
    label: '45201200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΤΟΥ ΗΛΕΚΤΡΙΚΟΥ ΣΥΣΤΗΜΑΤΟΣ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΕΜΠΟΡΕΥΜΑΤΑ',
  },
  {
    label: '45201300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΤΩΝ ΕΛΑΣΤΙΚΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΗΣ ΤΗΣ ΡΥΘΜΙΣΗΣ ΤΟΥ ΑΝΟΙΓΜΑΤΟΣ ΤΩΝ ΤΡΟΧΩΝ ΚΑΙ ΤΗΣ ΖΥΓΟΣΤΑΘΜΙΣΗΣ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΕΜΠΟΡΕΥΜΑΤΑ',
  },
  {
    label: '45201301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΕΛΑΣΤΙΚΩΝ ΑΥΤΟΚΙΝΗΤΩΝ (ΒΟΥΛΚΑΝΙΖΑΤΕΡ)',
  },
  {
    label: '45201302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΖΥΓΟΣΤΑΘΜΙΣΗΣ ΕΠΙΒΑΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45201400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΤΟΥ ΑΜΑΞΩΜΑΤΟΣ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΕΜΠΟΡΕΥΜΑΤΑ (ΕΠΙΣΚΕΥΗ ΘΥΡΩΝ, ΚΛΕΙΔΑΡΙΩΝ ΚΑΙ ΠΑΡΑΘΥΡΩΝ, ΕΠΑΝΑΧΡΩΜΑΤΙΣΜΟΣ, ΕΠΙΣΚΕΥΗ ΜΕΤΑ ΑΠΟ ΣΥΓΚΡΟΥΣΗ) ΚΑΙ ΠΑΡΟΜΟΙΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '45201401',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΤΙΚΑΤΑΣΤΑΣΗΣ ΑΝΕΜΟΘΩΡΑΚΩΝ (ΠΑΡΜΠΡΙΖ) ΚΑΙ ΠΑΡΑΘΥΡΩΝ ΕΠΙΒΑΤΗΓΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΦΟΡΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45201402',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΚΗΡΩΣΗΣ ΕΠΙΒΑΤΗΓΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΦΟΡΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45201403',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΒΑΦΗΣ ΑΜΑΞΩΜΑΤΟΣ ΕΠΙΒΑΤΗΓΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΦΟΡΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45201404',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΜΕΤΑΤΡΟΠΩΝ ΑΜΑΞΩΜΑΤΟΣ ΕΠΙΒΑΤΗΓΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΦΟΡΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45201405',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΚΑΘΡΕΠΤΩΝ ΣΕ ΕΠΙΒΑΤΗΓΑ ΚΑΙ ΕΛΑΦΡΑ ΦΟΡΤΗΓΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45202000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45202100',
    value:
      'ΣΥΝΗΘΕΙΣ ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΤΟΥ ΗΛΕΚΤΡΙΚΟΥ ΣΥΣΤΗΜΑΤΟΣ ΚΑΙ ΤΟΥ ΑΜΑΞΩΜΑΤΟΣ)',
  },
  {
    label: '45202101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΡΥΘΜΙΣΗΣ ΤΟΥ ΚΑΡΜΠΥΡΑΤΕΡ ΑΛΛΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45202102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΡΥΘΜΙΣΗΣ ΤΟΥ ΣΥΣΤΗΜΑΤΟΣ ΕΞΑΤΜΙΣΗΣ ΑΛΛΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45202103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΡΥΘΜΙΣΗΣ ΤΩΝ ΦΡΕΝΩΝ ΑΛΛΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45202104',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΥΛΙΝΔΡΩΝ ΚΙΝΗΤΗΡΩΝ ΑΛΛΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ (ΡΕΚΤΙΦΙΕ)',
  },
  {
    label: '45202105',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΑΛΛΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ, ΜΕ ΥΛΙΚΑ ΚΑΙ ΑΝΤΑΛΛΑΚΤΙΚΑ',
  },
  {
    label: '45202106',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΑΛΛΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ, ΧΩΡΙΣ ΥΛΙΚΑ ΚΑΙ ΑΝΤΑΛΛΑΚΤΙΚΑ',
  },
  {
    label: '45202200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΤΟΥ ΗΛΕΚΤΡΙΚΟΥ ΣΥΣΤΗΜΑΤΟΣ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45202300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΤΟΥ ΑΜΑΞΩΜΑΤΟΣ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ (ΕΠΙΣΚΕΥΗ ΘΥΡΩΝ, ΚΛΕΙΔΑΡΙΩΝ ΚΑΙ ΠΑΡΑΘΥΡΩΝ, ΕΠΑΝΑΧΡΩΜΑΤΙΣΜΟΣ, ΕΠΙΣΚΕΥΗ ΜΕΤΑ ΑΠΟ ΣΥΓΚΡΟΥΣΗ) ΚΑΙ ΠΑΡΟΜΟΙΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '45202301',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΤΙΚΑΤΑΣΤΑΣΗΣ ΑΝΕΜΟΘΩΡΑΚΩΝ (ΠΑΡΜΠΡΙΖ) ΚΑΙ ΠΑΡΑΘΥΡΩΝ ΑΛΛΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45202302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΑΦΗΣ ΤΟΥ ΑΜΑΞΩΜΑΤΟΣ ΑΛΛΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45202303',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΑΝΤΙΚΑΤΑΣΤΑΣΗΣ ΕΛΑΣΤΙΚΩΝ ΑΛΛΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45202304',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΜΕΤΑΤΡΟΠΩΝ ΤΟΥ ΑΜΑΞΩΜΑΤΟΣ ΑΛΛΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45202305',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΚΑΘΡΕΠΤΩΝ ΣΕ ΑΛΛΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45203000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΛΥΣΙΜΑΤΟΣ, ΓΥΑΛΙΣΜΑΤΟΣ ΟΧΗΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '45203001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΙΣΣΑΡΙΣΜΑΤΟΣ, ΣΤΙΛΒΩΜΑΤΟΣ ΚΑΙ ΕΠΑΛΕΙΨΗΣ ΜΕ ΚΕΡΙ, ΣΤΙΛΒΩΜΑΤΟΣ ΥΠΟ ΚΕΝΟ ΚΛΠ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45310000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45311000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45311100',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΚΑΙ ΕΣΩΤΕΡΙΚΩΝ ΑΕΡΟΘΑΛΑΜΩΝ ΕΠΙΣΩΤΡΩΝ',
  },
  {
    label: '45311101',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΓΡΟΤΙΚΩΝ ΕΠΙΣΩΤΡΩΝ, ΑΛΛΩΝ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '45311102',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΓΟΜΩΜΕΝΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '45311103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΣΩΤΕΡΙΚΩΝ ΑΕΡΟΘΑΛΑΜΩΝ, ΠΕΛΜΑΤΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΚΑΙ ΕΣΩΤΕΡΙΚΩΝ ΠΡΟΣΤΑΤΕΥΤΙΚΩΝ ΤΑΙΝΙΩΝ ΕΠΙΣΩΤΡΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '45311104',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΑ ΛΕΩΦΟΡΕΙΑ Η ΣΤΑ ΦΟΡΤΗΓΑ ΚΑΙ ΣΤΑ ΑΕΡΟΣΚΑΦΗ',
  },
  {
    label: '45311105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΘΑΡΜΕΝΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45311200',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45311201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ Π.Δ.Κ.Α., ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΜΑΞΩΜΑΤΩΝ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311203',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΛΙΩΝ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45311204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΞΟΝΩΝ ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311205',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΘΡΩΤΩΝ ΑΛΥΣΙΔΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311206',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΡΥΛΩΝ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45311207',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΟΥ ΑΣΦΑΛΕΙΑΣ, ΓΙΑ ΧΡΗΣΗ ΣΤΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311208',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΣΤΙΚΟΥ ΓΙΑ ΠΑΡΕΜΒΥΣΜΑΤΑ ΣΕ ΜΕΤΑΛΛΙΚΑ ΑΝΤΙΚΕΙΜΕΝΑ ΚΑΙ ΕΙΔΩΝ ΑΠΟ ΧΥΤΟ ΕΛΑΣΤΙΚΟ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311209',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΜΒΟΛΟΦΟΡΩΝ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΥΜΠΙΕΣΗ',
  },
  {
    label: '45311210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΑΜΑΞΩΜΑΤΑ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '45311211',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΤΜΙΣΕΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45311212',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΣΕΩΝ ΚΑΙ ΕΠΙΣΤΡΩΣΕΩΝ ΦΡΕΝΩΝ ΑΠΟ ΑΜΙΑΝΤΟ Η ΑΛΛΕΣ ΜΕΤΑΛΛΙΚΕΣ ΟΥΣΙΕΣ, ΕΙΔΩΝ ΑΠΟ ΥΛΙΚΟ ΤΡΙΒΗΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311213',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΩΝΩΝ ΑΣΦΑΛΕΙΑΣ ΚΑΙ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΜΑΞΩΜΑΤΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45311214',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΦΩΤΙΣΜΟΥ Η ΣΗΜΑΤΟΔΟΤΗΣΗΣ, ΥΑΛΟΚΑΘΑΡΙΣΤΗΡΩΝ, ΗΛΕΚΤΡΙΚΩΝ ΔΙΑΤΑΞΕΩΝ ΓΙΑ ΤΗ ΔΙΑΛΥΣΗ ΤΟΥ ΠΑΓΟΥ ΚΑΙ ΤΟΥ ΑΧΝΟΥ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311215',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΝΑΓΕΡΜΩΝ ΔΙΑΡΡΗΞΗΣ Η ΦΩΤΙΑΣ, ΑΚΟΥΣΤΙΚΗΣ Η ΟΠΤΙΚΗΣ ΣΗΜΑΤΟΔΟΤΗΣΗΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45311216',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΙΣΜΑΤΩΝ, ΚΥΡΙΩΣ ΜΕ ΜΕΤΑΛΛΙΚΟ ΣΚΕΛΕΤΟ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311217',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΙΝΟΥΡΓΙΩΝ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45311218',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΙΩΝ ΚΑΙ ΑΝΑΚΛΑΣΤΗΡΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΡΑΔΙΟΦΩΝΙΚΩΝ ΔΕΚΤΩΝ ΚΑΙ ΠΟΜΠΩΝ, ΕΞΟΠΛΙΣΜΟΥ ΡΑΝΤΑΡ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311219',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΕΚΚΙΝΗΣΗΣ ΚΑΙ ΕΚΚΙΝΗΤΩΝ;ΓΕΝΝΗΤΡΙΩΝ ΔΙΠΛΗΣ ΧΡΗΣΗΣ, ΑΛΛΩΝ ΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311220',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΜΕ ΠΑΛΙΝΔΡΟΜΙΚΑ ΕΜΒΟΛΑ ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311221',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΛΕΙΔΑΡΙΩΝ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311222',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ ΒΟΛΦΡΑΜΙΟΥ;ΑΛΟΓΟΝΟΥ (ΕΚΤΟΣ ΤΩΝ ΥΠΕΡΙΩΔΩΝ Η ΤΩΝ ΥΠΕΡΥΘΡΩΝ), ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311223',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ Π.Δ.Κ.Α., ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311224',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΓΕΘΥΝΤΙΚΩΝ ΚΑΘΡΕΠΤΩΝ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311225',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α., ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311226',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΓΙΑ ΑΛΛΟΥΣ ΚΙΝΗΤΗΡΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '45311227',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΓΙΑ ΚΙΝΗΤΗΡΕΣ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ (ΕΚΤΟΣ ΤΩΝ ΚΙΝΗΤΗΡΩΝ ΑΕΡΟΣΚΑΦΩΝ)',
  },
  {
    label: '45311228',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ, ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΑΛΛΩΝ ΟΧΗΜΑΤΩΝ, ΜΗ ΜΗΧΑΝΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45311229',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΔΙΗΘΗΣΗΣ Η ΚΑΘΑΡΙΣΜΟΥ ΑΕΡΙΩΝ ΜΕ ΤΗ ΜΕΘΟΔΟ ΤΟΥ ΚΑΤΑΛΥΤΗ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311230',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΛΑΙΩΝ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45311231',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΟΣΒΕΣΤΗΡΩΝ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45311232',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΟΛΟΓΙΩΝ ΓΙΑ ΤΟΥΣ ΠΙΝΑΚΕΣ ΤΩΝ ΟΡΓΑΝΩΝ ΕΛΕΓΧΟΥ ΚΑΙ ΡΟΛΟΓΙΩΝ ΠΑΡΟΜΟΙΟΥ ΤΥΠΟΥ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311233',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΙΝΘΗΡΙΣΤΩΝ (ΜΠΟΥΖΙ), ΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΑΝΑΦΛΕΞΗΣ, ΔΥΝΑΜΟΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΜΑΓΝΗΤΙΚΩΝ ΣΦΟΝΔΥΛΩΝ, ΔΙΑΝΟΜΕΩΝ, ΠΗΝΙΩΝ ΑΝΑΦΛΕΞΗΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311234',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΜΠΛΕΚΤΩΝ ΚΑΙ ΣΥΖΕΥΚΤΗΡΩΝ ΑΞΟΝΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΚΑΘΟΛΙΚΕΣ ΑΡΘΡΩΣΕΙΣ), ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45311235',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΣΩΡΕΥΤΩΝ ΜΟΛΥΒΔΟΥ;ΟΞΕΟΣ ΓΙΑ ΕΜΒΟΛΟΦΟΡΟΥΣ ΚΙΝΗΤΗΡΕΣ ΕΚΚΙΝΗΣΗΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45311236',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΕΛΕΓΧΟΥ ΚΑΥΣΑΕΡΙΩΝ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45311237',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΛΑΔΙΟΥ, ΦΙΛΤΡΩΝ ΒΕΝΖΙΝΗΣ ΚΑΙ ΦΙΛΤΡΩΝ ΕΙΣΑΓΩΓΗΣ ΑΕΡΑ ΓΙΑ ΚΙΝΗΤΗΡΕΣ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45312000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45312001',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45312002',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΚΑΙ ΕΣΩΤΕΡΙΚΩΝ ΑΕΡΟΘΑΛΑΜΩΝ, ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45312003',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΗΛΕΚΤΡΙΚΟΥ ΚΑΙ ΗΛΕΚΤΡΟΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΓΙΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45312004',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΑΙΝΟΥΡΓΙΩΝ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45312005',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45312006',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΑΛΙΩΝ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45320000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '45321000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '45321100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΣΤΙΚΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45321101',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΓΡΟΤΙΚΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΚΑΙ ΑΛΛΩΝ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '45321102',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΓΟΜΩΜΕΝΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '45321103',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΣΩΤΕΡΙΚΩΝ ΑΕΡΟΘΑΛΑΜΩΝ, ΣΥΜΠΑΓΩΝ Η ΗΜΙΣΥΜΠΑΓΩΝ (ΚΟΙΛΩΝ) ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ), ΠΕΛΜΑΤΩΝ ΕΠΙΣΩΤΡΩΝ ΠΟΥ ΑΝΤΙΚΑΘΙΣΤΑΝΤΑΙ ΕΥΚΟΛΑ ΚΑΙ ΕΣΩΤΕΡΙΚΩΝ ΠΡΟΣΤΑΤΕΥΤΙΚΩΝ ΤΑΙΝΙΩΝ ΕΠΙΣΩΤΡΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '45321104',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321105',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΑ ΛΕΩΦΟΡΕΙΑ Η ΣΤΑ ΦΟΡΤΗΓΑ ΚΑΙ ΣΤΑ ΑΕΡΟΣΚΑΦΗ',
  },
  {
    label: '45321106',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΘΑΡΜΕΝΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '45321200',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΛΛΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '45321201',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ Π.Δ.Κ.Α., ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321202',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΛΙΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45321203',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΡΘΡΩΤΩΝ ΑΛΥΣΙΔΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321204',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΡΥΛΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45321205',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΟΥ ΑΣΦΑΛΕΙΑΣ ΓΙΑ ΧΡΗΣΗ ΣΤΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321206',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΑΜΑΞΩΜΑΤΑ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '45321207',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΤΜΙΣΕΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45321208',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΖΩΝΩΝ ΑΣΦΑΛΕΙΑΣ ΚΑΙ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΜΑΞΩΜΑΤΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45321209',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΦΩΤΙΣΜΟΥ Η ΣΗΜΑΤΟΔΟΤΗΣΗΣ, ΥΑΛΟΚΑΘΑΡΙΣΤΗΡΩΝ, ΗΛΕΚΤΡΙΚΩΝ ΔΙΑΤΑΞΕΩΝ ΓΙΑ ΤΗ ΔΙΑΛΥΣΗ ΤΟΥ ΠΑΓΟΥ ΚΑΙ ΤΟΥ ΑΧΝΟΥ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321210',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΝΑΓΕΡΜΩΝ ΔΙΑΡΡΗΞΗΣ Η ΦΩΤΙΑΣ, ΑΚΟΥΣΤΙΚΗΣ Η ΟΠΤΙΚΗΣ ΣΗΜΑΤΟΔΟΤΗΣΗΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45321211',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΙΣΜΑΤΩΝ, ΚΥΡΙΩΣ ΜΕ ΜΕΤΑΛΛΙΚΟ ΣΚΕΛΕΤΟ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321212',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΙΝΟΥΡΓΙΩΝ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45321213',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΙΩΝ ΚΑΙ ΑΝΑΚΛΑΣΤΗΡΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΡΑΔΙΟΦΩΝΙΚΩΝ ΔΕΚΤΩΝ ΚΑΙ ΠΟΜΠΩΝ, ΕΞΟΠΛΙΣΜΟΥ ΡΑΝΤΑΡ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321214',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΕΚΚΙΝΗΣΗΣ ΚΑΙ ΕΚΚΙΝΗΤΩΝ;ΓΕΝΝΗΤΡΙΩΝ ΔΙΠΛΗΣ ΧΡΗΣΗΣ, ΑΛΛΩΝ ΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321215',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΛΕΙΔΑΡΙΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321216',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ ΒΟΛΦΡΑΜΙΟΥ;ΑΛΟΓΟΝΟΥ (ΕΚΤΟΣ ΤΩΝ ΥΠΕΡΙΩΔΩΝ Η ΤΩΝ ΥΠΕΡΥΘΡΩΝ), ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321217',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ Π.Δ.Κ.Α., ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321218',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΓΕΘΥΝΤΙΚΩΝ ΚΑΘΡΕΠΤΩΝ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321219',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α., ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321220',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΓΙΑ ΑΛΛΟΥΣ ΚΙΝΗΤΗΡΕΣ Π.Δ.Κ.Α., ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321221',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΓΙΑ ΚΙΝΗΤΗΡΕΣ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ (ΕΚΤΟΣ ΤΩΝ ΚΙΝΗΤΗΡΩΝ ΑΕΡΟΣΚΑΦΩΝ)',
  },
  {
    label: '45321222',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ, ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΚΑΙ ΑΛΛΩΝ ΟΧΗΜΑΤΩΝ, ΜΗ ΜΗΧΑΝΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45321223',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΛΑΙΩΝ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '45321224',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΕΜΒΥΣΜΑΤΩΝ ΑΠΟ ΜΕΤΑΛΛΙΚΑ ΕΛΑΣΜΑΤΑ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321225',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΟΣΒΕΣΤΗΡΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45321226',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΟΛΟΓΙΩΝ ΓΙΑ ΤΟΥΣ ΠΙΝΑΚΕΣ ΤΩΝ ΟΡΓΑΝΩΝ ΕΛΕΓΧΟΥ ΚΑΙ ΡΟΛΟΓΙΩΝ ΠΑΡΟΜΟΙΟΥ ΤΥΠΟΥ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321227',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΠΙΝΘΗΡΙΣΤΩΝ (ΜΠΟΥΖΙ), ΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΑΝΑΦΛΕΞΗΣ, ΔΥΝΑΜΟΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΜΑΓΝΗΤΙΚΩΝ ΣΦΟΝΔΥΛΩΝ, ΔΙΑΝΟΜΕΩΝ, ΠΗΝΙΩΝ ΑΝΑΦΛΕΞΗΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321228',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΜΠΛΕΚΤΩΝ ΚΑΙ ΣΥΖΕΥΚΤΗΡΩΝ ΑΞΟΝΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΚΑΘΟΛΙΚΕΣ ΑΡΘΡΩΣΕΙΣ), ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45321229',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΣΩΡΕΥΤΩΝ ΜΟΛΥΒΔΟΥ;ΟΞΕΟΣ ΓΙΑ ΕΜΒΟΛΟΦΟΡΟΥΣ ΚΙΝΗΤΗΡΕΣ ΕΚΚΙΝΗΣΗΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321230',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΦΡΑΓΙΣΜΕΝΩΝ ΠΡΟΒΟΛΕΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '45321231',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΕΛΕΓΧΟΥ ΚΑΥΣΑΕΡΙΩΝ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45321232',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΛΑΔΙΟΥ, ΦΙΛΤΡΩΝ ΒΕΝΖΙΝΗΣ ΚΑΙ ΦΙΛΤΡΩΝ ΕΙΣΑΓΩΓΗΣ ΑΕΡΑ ΓΙΑ ΚΙΝΗΤΗΡΕΣ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45321233',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΟΡΓΑΝΩΝ ΑΚΡΙΒΕΙΑΣ ΣΕ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '45321234',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΣΥΣΤΗΜΑΤΩΝ ΣΥΝΑΓΕΡΜΟΥ ΣΕ ΑΥΤΟΚΙΝΗΤΑ ΚΑΙ ΑΛΛΑ ΑΥΤΟΚΙΝΟΥΜΕΝΑ ΜΗΧΑΝΗΜΑΤΑ',
  },
  {
    label: '45322000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '45322100',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΜΕΣΩ ΤΟΥ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '45322200',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ',
  },
  {
    label: '45322900',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '45400000',
    value:
      'ΠΩΛΗΣΗ, ΣΥΝΤΗΡΗΣΗ ΚΑΙ ΕΠΙΣΚΕΥΗ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '45401000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΜΟΤΟΠΟΔΗΛΑΤΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '45401001',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΘΡΩΤΩΝ ΑΛΥΣΙΔΩΝ ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401002',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΣΤΙΚΟΥ ΓΙΑ ΠΑΡΕΜΒΥΣΜΑΤΑ ΣΕ ΜΕΤΑΛΛΙΚΑ ΑΝΤΙΚΕΙΜΕΝΑ ΚΑΙ ΕΙΔΩΝ ΑΠΟ ΧΥΤΟ ΕΛΑΣΤΙΚΟ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401003',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΣΕΩΝ ΚΑΙ ΕΠΙΣΤΡΩΣΕΩΝ ΦΡΕΝΩΝ ΑΠΟ ΑΜΙΑΝΤΟ Η ΑΛΛΕΣ ΜΕΤΑΛΛΙΚΕΣ ΟΥΣΙΕΣ, ΕΙΔΩΝ ΑΠΟ ΥΛΙΚΟ ΤΡΙΒΗΣ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401004',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΣΩΤΕΡΙΚΩΝ ΑΕΡΟΘΑΛΑΜΩΝ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401005',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΦΩΤΙΣΜΟΥ Η ΣΗΜΑΤΟΔΟΤΗΣΗΣ, ΥΑΛΟΚΑΘΑΡΙΣΤΗΡΩΝ, ΗΛΕΚΤΡΙΚΩΝ ΔΙΑΤΑΞΕΩΝ ΓΙΑ ΤΗ ΔΙΑΛΥΣΗ ΤΟΥ ΠΑΓΟΥ ΚΑΙ ΤΟΥ ΑΧΝΟΥ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401006',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΝΑΓΕΡΜΩΝ ΔΙΑΡΡΗΞΗΣ Η ΦΩΤΙΑΣ, ΑΚΟΥΣΤΙΚΗΣ Η ΟΠΤΙΚΗΣ ΣΗΜΑΤΟΔΟΤΗΣΗΣ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401007',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΙΣ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401008',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΕΚΚΙΝΗΣΗΣ ΚΑΙ ΕΚΚΙΝΗΤΩΝ;ΓΕΝΝΗΤΡΙΩΝ ΔΙΠΛΗΣ ΧΡΗΣΗΣ, ΑΛΛΩΝ ΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401009',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΜΕ ΠΑΛΙΝΔΡΟΜΙΚΑ ΕΜΒΟΛΑ ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401010',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ Π.Δ.Κ.Α., ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401011',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΚΕΤΩΝ ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401012',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΓΕΘΥΝΤΙΚΩΝ ΚΑΘΡΕΠΤΩΝ ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401013',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α., ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401014',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΚΑΛΑΘΙΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '45401015',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΜΟΤΟΠΟΔΗΛΑΤΩΝ',
  },
  {
    label: '45401016',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΤΟΠΟΔΗΛΑΤΩΝ ΜΕ ΠΑΛΙΝΔΡΟΜΙΚΟ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΚΥΛΙΝΔΡΙΣΜΟΥ < 50 ~ CC',
  },
  {
    label: '45401017',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΔΙΤΡΟΧΩΝ ΜΕ ΒΟΗΘΗΤΙΚΟ ΚΙΝΗΤΗΡΑ ΜΕ ΠΑΛΙΝΔΡΟΜΙΚΟ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΚΥΛΙΝΔΡΙΣΜΟΥ >= 50 ~ CC',
  },
  {
    label: '45401018',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΤΟΣΙΚΛΕΤΩΝ Π.Δ.Κ.Α., ΚΑΛΑΘΙΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '45401019',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΙΝΘΗΡΙΣΤΩΝ (ΜΠΟΥΖΙ), ΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΑΝΑΦΛΕΞΗΣ, ΔΥΝΑΜΟΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΜΑΓΝΗΤΙΚΩΝ ΣΦΟΝΔΥΛΩΝ, ΔΙΑΝΟΜΕΩΝ, ΠΗΝΙΩΝ ΑΝΑΦΛΕΞΗΣ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401020',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΣΩΡΕΥΤΩΝ ΜΟΛΥΒΔΟΥ;ΟΞΕΟΣ ΓΙΑ ΕΜΒΟΛΟΦΟΡΟΥΣ ΚΙΝΗΤΗΡΕΣ ΕΚΚΙΝΗΣΗΣ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401021',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΕΛΕΓΧΟΥ ΚΑΥΣΑΕΡΙΩΝ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45401022',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΛΑΔΙΟΥ, ΦΙΛΤΡΩΝ ΒΕΝΖΙΝΗΣ ΚΑΙ ΦΙΛΤΡΩΝ ΕΙΣΑΓΩΓΗΣ ΑΕΡΑ ΓΙΑ ΚΙΝΗΤΗΡΕΣ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΜΟΤΟΠΟΔΗΛΑΤΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '45402001',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΡΘΡΩΤΩΝ ΑΛΥΣΙΔΩΝ ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402002',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΣΩΤΕΡΙΚΩΝ ΑΕΡΟΘΑΛΑΜΩΝ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402003',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΦΩΤΙΣΜΟΥ Η ΣΗΜΑΤΟΔΟΤΗΣΗΣ, ΥΑΛΟΚΑΘΑΡΙΣΤΗΡΩΝ, ΗΛΕΚΤΡΙΚΩΝ ΔΙΑΤΑΞΕΩΝ ΓΙΑ ΤΗ ΔΙΑΛΥΣΗ ΤΟΥ ΠΑΓΟΥ ΚΑΙ ΤΟΥ ΑΧΝΟΥ ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402004',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΝΑΓΕΡΜΩΝ ΔΙΑΡΡΗΞΗΣ Η ΦΩΤΙΑΣ, ΑΚΟΥΣΤΙΚΗΣ Η ΟΠΤΙΚΗΣ ΣΗΜΑΤΟΔΟΤΗΣΗΣ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402005',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΙΝΟΥΡΓΙΩΝ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΙΣ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402006',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΕΚΚΙΝΗΣΗΣ ΚΑΙ ΕΚΚΙΝΗΤΩΝ;ΓΕΝΝΗΤΡΙΩΝ ΔΙΠΛΗΣ ΧΡΗΣΗΣ, ΑΛΛΩΝ ΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402007',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΑΝΩΝ ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402008',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ ΒΟΛΦΡΑΜΙΟΥ;ΑΛΟΓΟΝΟΥ (ΕΚΤΟΣ ΤΩΝ ΥΠΕΡΙΩΔΩΝ Η ΤΩΝ ΥΠΕΡΥΘΡΩΝ), ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402009',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ Π.Δ.Κ.Α., ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402010',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΚΕΤΩΝ ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402011',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΓΕΘΥΝΤΙΚΩΝ ΚΑΘΡΕΠΤΩΝ ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402012',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α., ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402013',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΚΑΛΑΘΙΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '45402014',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΜΟΤΟΠΟΔΗΛΑΤΩΝ',
  },
  {
    label: '45402015',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΤΟΠΟΔΗΛΑΤΩΝ ΜΕ ΠΑΛΙΝΔΡΟΜΙΚΟ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΚΥΛΙΝΔΡΙΣΜΟΥ < 50 ~ CC',
  },
  {
    label: '45402016',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΔΙΤΡΟΧΩΝ ΜΕ ΒΟΗΘΗΤΙΚΟ ΚΙΝΗΤΗΡΑ ΜΕ ΠΑΛΙΝΔΡΟΜΙΚΟ ΕΜΒΟΛΟΦΟΡΟ ΚΙΝΗΤΗΡΑ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΚΥΛΙΝΔΡΙΣΜΟΥ >= 50 ~ CC',
  },
  {
    label: '45402017',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΤΟΣΙΚΛΕΤΩΝ Π.Δ.Κ.Α., ΚΑΛΑΘΙΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '45402018',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΑΣΦΑΛΕΙΑΣ ΑΝΑΒΑΤΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '45402019',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΟΛΟΓΙΩΝ ΓΙΑ ΤΟΥΣ ΠΙΝΑΚΕΣ ΤΩΝ ΟΡΓΑΝΩΝ ΕΛΕΓΧΟΥ ΚΑΙ ΡΟΛΟΓΙΩΝ ΠΑΡΟΜΟΙΟΥ ΤΥΠΟΥ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402020',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΠΙΝΘΗΡΙΣΤΩΝ (ΜΠΟΥΖΙ), ΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΑΝΑΦΛΕΞΗΣ, ΔΥΝΑΜΟΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΜΑΓΝΗΤΙΚΩΝ ΣΦΟΝΔΥΛΩΝ, ΔΙΑΝΟΜΕΩΝ, ΠΗΝΙΩΝ ΑΝΑΦΛΕΞΗΣ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402021',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΜΠΛΕΚΤΩΝ ΚΑΙ ΣΥΖΕΥΚΤΗΡΩΝ ΑΞΟΝΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΚΑΘΟΛΙΚΕΣ ΑΡΘΡΩΣΕΙΣ), ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402022',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΣΩΡΕΥΤΩΝ ΜΟΛΥΒΔΟΥ;ΟΞΕΟΣ ΓΙΑ ΕΜΒΟΛΟΦΟΡΟΥΣ ΚΙΝΗΤΗΡΕΣ ΕΚΚΙΝΗΣΗΣ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402023',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΕΛΕΓΧΟΥ ΚΑΥΣΑΕΡΙΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '45402024',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΛΑΔΙΟΥ, ΦΙΛΤΡΩΝ ΒΕΝΖΙΝΗΣ ΚΑΙ ΦΙΛΤΡΩΝ ΕΙΣΑΓΩΓΗΣ ΑΕΡΑ ΓΙΑ ΚΙΝΗΤΗΡΕΣ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45402025',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΣΥΣΤΗΜΑΤΩΝ ΣΥΝΑΓΕΡΜΟΥ ΣΕ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45403000',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΜΟΤΟΠΟΔΗΛΑΤΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ, ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ',
  },
  {
    label: '45404000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΜΟΤΟΠΟΔΗΛΑΤΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '45404001',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '45404002',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΙΣ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '45404003',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '45405000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΜΟΤΟΠΟΔΗΛΑΤΩΝ',
  },
  {
    label: '45405001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΕΡΩΝ ΤΗΣ ΜΗΧΑΝΗΣ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΜΟΤΟΠΟΔΗΛΑΤΩΝ',
  },
  {
    label: '45405002',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΤΗΣ ΚΑΡΟΤΣΑΣ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΜΟΤΟΠΟΔΗΛΑΤΩΝ',
  },
  {
    label: '45405003',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΚΑΙ ΕΠΙΣΚΕΥΗΣ ΕΞΑΡΤΗΜΑΤΩΝ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΜΟΤΟΠΟΔΗΛΑΤΩΝ',
  },
  {
    label: '45405004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΚΑΘΡΕΠΤΩΝ ΣΕ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '46110000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΓΕΩΡΓΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ, ΖΩΝΤΩΝ ΖΩΩΝ, ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ ΚΑΙ ΗΜΙΤΕΛΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46111000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΚΑΤΕΡΓΑΣΤΩΝ ΑΓΡΟΤΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ, ΖΩΝΤΩΝ ΖΩΩΝ, ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ ΚΑΙ ΗΜΙΤΕΛΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46111100',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΖΩΝΤΩΝ ΖΩΩΝ',
  },
  {
    label: '46111101',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΖΩΝΤΩΝ ΖΩΩΝ, ΠΟΥ ΕΚΤΡΕΦΟΝΤΑΙ ΣΕ ΑΓΡΟΚΤΗΜΑΤΑ',
  },
  {
    label: '46111102',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΖΩΝΤΩΝ ΑΙΓΟΠΡΟΒΑΤΩΝ',
  },
  {
    label: '46111103',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΖΩΝΤΩΝ ΒΟΟΕΙΔΩΝ ΚΑΙ ΒΟΥΒΑΛΙΩΝ',
  },
  {
    label: '46111104',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΖΩΝΤΩΝ ΚΑΜΗΛΩΝ ΚΑΙ ΚΑΜΗΛΙΔΩΝ',
  },
  {
    label: '46111105',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΖΩΝΤΩΝ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '46111106',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΖΩΝΤΩΝ ΩΔΙΚΩΝ ΠΤΗΝΩΝ, ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΨΑΡΙΩΝ, ΣΚΥΛΩΝ, ΓΑΤΩΝ ΚΛΠ',
  },
  {
    label: '46111107',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΨΑΡΙΩΝ, ΖΩΝΤΩΝ ΚΑΙ ΓΟΝΟΥ',
  },
  {
    label: '46111200',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΛΟΥΛΟΥΔΙΩΝ ΚΑΙ ΦΥΤΩΝ',
  },
  {
    label: '46111201',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΖΩΝΤΩΝ ΔΑΣΙΚΩΝ ΦΥΤΩΝ· ΣΠΟΡΩΝ ΔΑΣΙΚΩΝ ΦΥΤΩΝ, ΦΥΤΩΡΙΩΝ ΔΑΣΙΚΩΝ ΔΕΝΤΡΩΝ',
  },
  {
    label: '46111202',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΟΜΜΕΝΩΝ ΑΝΘΕΩΝ ΚΑΙ ΜΠΟΥΜΠΟΥΚΙΩΝ ΑΝΘΕΩΝ ΚΑΘΩΣ ΚΑΙ ΑΝΘΟΔΕΣΜΩΝ, ΣΤΕΦΑΝΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46111203',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΥΛΙΚΩΝ ΦΥΤΕΥΣΗΣ: ΖΩΝΤΩΝ ΦΥΤΩΝ· ΚΟΝΔΥΛΩΝ, ΒΟΛΒΩΝ ΚΑΙ ΡΙΖΩΝ· ΜΟΣΧΕΥΜΑΤΩΝ ΚΑΙ ΞΕΜΑΣΚΑΛΙΔΙΩΝ· ΜΥΚΗΛΙΩΝ ΜΑΝΙΤΑΡΙΩΝ',
  },
  {
    label: '46111900',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΑΚΑΤΕΡΓΑΣΤΩΝ ΑΓΡΟΤΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ, ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ ΚΑΙ ΗΜΙΤΕΛΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46111901',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΚΑΤΕΡΓΑΣΤΩΝ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '46111902',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΚΑΤΕΡΓΑΣΤΩΝ ΓΟΥΝΟΔΕΡΜΑΤΩΝ ΚΑΙ ΔΙΑΦΟΡΩΝ ΑΚΑΤΕΡΓΑΣΤΩΝ ΠΡΟΒΙΩΝ ΚΑΙ ΔΕΡΜΑΤΩΝ',
  },
  {
    label: '46111903',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΔΕΝΔΡΩΔΩΝ ΚΑΙ ΘΑΜΝΩΔΩΝ ΚΑΛΛΙΕΡΓΕΙΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46111904',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΖΩΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΠΟΥ ΠΑΡΑΓΟΝΤΑΙ ΣΕ ΑΓΡΟΚΤΗΜΑΤΑ',
  },
  {
    label: '46111905',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΦΥΣΙΚΩΝ ΜΑΡΓΑΡΙΤΑΡΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΦΥΤΩΝ, ΖΩΩΝ ΚΑΙ ΤΩΝ ΠΡΟΪΟΝΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46111906',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΒΑΜΒΑΚΙΟΥ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΤΟΥ, ΕΚΚΟΚΚΙΣΜΕΝΟΥ Η ΜΗ',
  },
  {
    label: '46111907',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΗΜΗΤΡΙΑΚΩΝ (ΕΚΤΟΣ ΡΥΖΙΟΥ)',
  },
  {
    label: '46111908',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΛΑΙΟΥΧΩΝ ΣΠΟΡΩΝ',
  },
  {
    label: '46111909',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΛΑΙΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΡΠΩΝ, ΕΛΑΙΟΠΟΙΗΣΙΜΩΝ',
  },
  {
    label: '46111910',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΣΠΕΡΙΔΟΕΙΔΩΝ',
  },
  {
    label: '46111911',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΖΑΧΑΡΟΚΑΛΑΜΩΝ',
  },
  {
    label: '46111912',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΑΠΝΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ',
  },
  {
    label: '46111913',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΑΡΥΚΕΥΤΙΚΩΝ, ΑΡΩΜΑΤΙΚΩΝ, ΘΕΡΑΠΕΥΤΙΚΩΝ ΚΑΙ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΦΥΤΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46111914',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΛΑΧΑΝΙΚΩΝ ΚΑΙ ΠΕΠΟΝΟΕΙΔΩΝ, ΡΙΖΩΝ ΚΑΙ ΚΟΝΔΥΛΩΝ',
  },
  {
    label: '46111915',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗΛΟΕΙΔΩΝ ΚΑΙ ΠΥΡΗΝΟΚΑΡΠΩΝ',
  },
  {
    label: '46111916',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΟΣΠΡΙΩΝ',
  },
  {
    label: '46111917',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΑΤΑΤΩΝ',
  },
  {
    label: '46111918',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΡΟΪΟΝΤΩΝ ΑΛΛΩΝ ΜΗ ΠΟΛΥΕΤΩΝ ΦΥΤΩΝ',
  },
  {
    label: '46111919',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΡΟΪΟΝΤΩΝ ΑΛΛΩΝ ΦΥΤΩΝ ΠΟΛΥΕΤΩΝ ΚΑΛΛΙΕΡΓΕΙΩΝ',
  },
  {
    label: '46111920',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΡΟΪΟΝΤΩΝ ΑΥΤΟΦΥΩΝ ΦΥΤΩΝ ΜΗ ΞΥΛΩΔΟΥΣ ΜΟΡΦΗΣ',
  },
  {
    label: '46111921',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΡΟΪΟΝΤΩΝ ΙΝΩΔΩΝ ΦΥΤΩΝ',
  },
  {
    label: '46111922',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΡΥΖΙΟΥ',
  },
  {
    label: '46111923',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΙΤΑΡΙΟΥ',
  },
  {
    label: '46111924',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΤΑΦΥΛΙΩΝ',
  },
  {
    label: '46111925',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΤΡΟΠΙΚΩΝ ΚΑΙ ΥΠΟΤΡΟΠΙΚΩΝ ΦΡΟΥΤΩΝ',
  },
  {
    label: '46111926',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΥΦΑΝΤΙΚΩΝ ΙΝΩΝ',
  },
  {
    label: '46111927',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '46111928',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΦΥΤΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΤΟΥΣ ΓΙΑ ΑΦΕΨΗΜΑΤΑ',
  },
  {
    label: '46120000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΑΥΣΙΜΩΝ, ΜΕΤΑΛΛΕΥΜΑΤΩΝ, ΜΕΤΑΛΛΩΝ ΚΑΙ ΒΙΟΜΗΧΑΝΙΚΩΝ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46121000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΑΥΣΙΜΩΝ, ΜΕΤΑΛΛΕΥΜΑΤΩΝ, ΜΕΤΑΛΛΩΝ ΚΑΙ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46121100',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΤΕΡΕΩΝ, ΥΓΡΩΝ ΚΑΙ ΑΕΡΙΩΝ ΚΑΥΣΙΜΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46121101',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΕΡΙΩΝ ΠΕΤΡΕΛΑΙΟΥ ΚΑΙ ΑΛΛΩΝ ΑΕΡΙΩΝ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ, ΕΚΤΟΣ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '46121102',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΠΕΤΡΕΛΑΙΟΥ',
  },
  {
    label: '46121103',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΒΕΝΖΙΝΗΣ ΑΥΤΟΚΙΝΗΤΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΗΣ ΚΑΙ ΤΗΣ ΒΕΝΖΙΝΗΣ ΑΕΡΟΠΛΑΝΩΝ',
  },
  {
    label: '46121104',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΛΑΙΩΝ ΠΟΥ ΛΑΜΒΑΝΟΝΤΑΙ ΑΠΟ ΑΣΦΑΛΤΟΥΧΑ ΟΡΥΚΤΑ, ΣΧΙΣΤΟΛΙΘΟ ΚΑΙ ΠΙΣΣΟΥΧΕΣ ΑΜΜΟΥΣ',
  },
  {
    label: '46121105',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΑΥΣΙΜΩΝ ΕΛΑΙΩΝ ΚΑΙ ΑΕΡΙΩΝ· ΛΙΠΑΝΤΙΚΩΝ ΕΛΑΙΩΝ',
  },
  {
    label: '46121106',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΑΥΣΟΞΥΛΩΝ',
  },
  {
    label: '46121107',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΛΙΠΑΝΤΙΚΩΝ ΕΛΑΙΩΝ ΠΕΤΡΕΛΑΙΟΥ, ΒΑΡΕΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46121108',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΠΡΙΚΕΤΩΝ, ΣΦΑΙΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΤΕΡΕΩΝ ΚΑΥΣΙΜΩΝ',
  },
  {
    label: '46121109',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΡΟΪΟΝΤΩΝ ΟΠΤΑΝΘΡΑΚΟΠΟΙΗΣΗΣ, ΠΙΣΣΑΣ ΚΑΙ ΠΙΣΣΑΣΦΑΛΤΟΥ',
  },
  {
    label: '46121110',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '46121200',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΜΕΤΑΛΛΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46121201',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΤΟΥΣ ΜΟΡΦΕΣ (ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΣΩΛΗΝΩΝ ΚΑΙ ΤΟΥ ΣΥΡΜΑΤΟΣ)',
  },
  {
    label: '46121202',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΑΛΑΙΩΝ ΣΙΔΗΡΩΝ ΚΑΙ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '46121203',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΤΟΥΣ ΜΟΡΦΕΣ (ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΣΩΛΗΝΩΝ ΚΑΙ ΤΟΥ ΣΥΡΜΑΤΟΣ)',
  },
  {
    label: '46121204',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΧΡΥΣΟΥ Η ΑΡΓΥΡΟΥ',
  },
  {
    label: '46121300',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΛΙΠΑΣΜΑΤΩΝ ΚΑΙ ΑΓΡΟΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46121301',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΙΘΕΡΙΩΝ ΕΛΑΙΩΝ',
  },
  {
    label: '46121302',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΑΤΙΟΥ ΚΑΙ ΚΑΘΑΡΟΥ ΧΛΩΡΙΟΥΧΟΥ ΝΑΤΡΙΟΥ',
  },
  {
    label: '46121303',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΟΡΥΚΤΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46121304',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΕΛΑΣΤΙΚΟ (ΚΑΟΥΤΣΟΥΚ)',
  },
  {
    label: '46121305',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46121306',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΝΟΡΓΑΝΩΝ ΒΑΣΙΚΩΝ ΧΗΜΙΚΩΝ ΟΥΣΙΩΝ',
  },
  {
    label: '46121307',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΒΙΟΜΗΧΑΝΙΚΩΝ ΑΕΡΙΩΝ',
  },
  {
    label: '46121308',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΙΑΦΟΡΩΝ ΤΥΠΩΝ ΚΟΛΛΑΣ',
  },
  {
    label: '46121309',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΚΡΗΚΤΙΚΩΝ',
  },
  {
    label: '46121310',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΛΙΠΑΝΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ, ΠΡΟΣΘΕΤΙΚΩΝ, ΑΝΤΙΨΥΚΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ',
  },
  {
    label: '46121311',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΛΙΠΑΣΜΑΤΩΝ ΚΑΙ ΑΖΩΤΟΥΧΩΝ ΕΝΩΣΕΩΝ',
  },
  {
    label: '46121312',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΕΛΑΝΙΩΝ ΤΥΠΟΓΡΑΦΙΑΣ',
  },
  {
    label: '46121313',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΟΡΓΑΝΙΚΩΝ ΒΑΣΙΚΩΝ ΧΗΜΙΚΩΝ ΟΥΣΙΩΝ',
  },
  {
    label: '46121314',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΟΡΥΚΤΩΝ ΓΙΑ ΤΗ ΧΗΜΙΚΗ ΒΙΟΜΗΧΑΝΙΑ ΚΑΙ ΤΗ ΒΙΟΜΗΧΑΝΙΑ ΛΙΠΑΣΜΑΤΩΝ',
  },
  {
    label: '46121315',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΑΡΑΣΙΤΟΚΤΟΝΩΝ ΚΑΙ ΑΛΛΩΝ ΑΓΡΟΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46121316',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΛΑΣΤΙΚΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΣΩΛΗΝΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΘΟΡΙΣΜΕΝΗΣ ΜΟΡΦΗΣ',
  },
  {
    label: '46121317',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΛΑΣΤΙΚΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46121318',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΥΝΘΕΤΙΚΟΥ ΕΛΑΣΤΙΚΟΥ (ΣΥΝΘΕΤΙΚΟΥ ΚΑΟΥΤΣΟΥΚ)',
  },
  {
    label: '46121319',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΥΝΘΕΤΙΚΩΝ ΙΝΩΝ',
  },
  {
    label: '46121320',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΧΡΩΣΤΙΚΩΝ ΥΛΩΝ',
  },
  {
    label: '46130000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΞΥΛΕΙΑΣ ΚΑΙ ΟΙΚΟΔΟΜΙΚΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46131100',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΞΥΛΕΙΑΣ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΞΥΛΕΙΑΣ',
  },
  {
    label: '46131101',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΚΑΤΕΡΓΑΣΤΗΣ ΞΥΛΕΙΑΣ',
  },
  {
    label: '46131102',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΞΥΛΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΟΙΚΟΔΟΜΙΚΗΣ (ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΚΟΥΦΩΜΑΤΩΝ)',
  },
  {
    label: '46131103',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΝΤΙΚΟΛΛΗΤΩΝ (ΚΟΝΤΡΑ;ΠΛΑΚΕ) ΚΑΙ ΑΛΛΩΝ ΠΛΑΚΩΝ ΜΕ ΒΑΣΗ ΤΟ ΞΥΛΟ',
  },
  {
    label: '46131104',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΞΥΛΕΙΑΣ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΤΗΣ',
  },
  {
    label: '46131105',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΞΥΛΙΝΩΝ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ',
  },
  {
    label: '46131106',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΞΥΛΙΝΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '46131107',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΥΝΑΡΜΟΛΟΓΟΥΜΕΝΩΝ ΔΑΠΕΔΩΝ ΠΑΡΚΕ',
  },
  {
    label: '46131200',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΟΙΚΟΔΟΜΙΚΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46131201',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΕΤΑΛΛΙΚΩΝ ΝΤΕΠΟΖΙΤΩΝ, ΔΕΞΑΜΕΝΩΝ ΚΑΙ ΔΟΧΕΙΩΝ',
  },
  {
    label: '46131202',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΕΤΑΛΛΙΚΩΝ ΣΚΕΛΕΤΩΝ ΚΑΙ ΜΕΡΩΝ ΜΕΤΑΛΛΙΚΩΝ ΣΚΕΛΕΤΩΝ',
  },
  {
    label: '46131203',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΣΚΥΡΟΔΕΜΑ, ΓΥΨΟ ΚΑΙ ΤΣΙΜΕΝΤΟ',
  },
  {
    label: '46131204',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΜΜΟΧΑΛΙΚΟΥ ΚΑΙ ΑΜΜΟΥ· ΑΡΓΙΛΟΥ ΚΑΙ ΚΑΟΛΙΝΗ',
  },
  {
    label: '46131205',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΣΒΕΣΤΗ ΚΑΙ ΓΥΨΟΥ',
  },
  {
    label: '46131206',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΚΑΙ ΟΙΚΟΔΟΜΙΚΩΝ ΛΙΘΩΝ, ΑΣΒΕΣΤΟΛΙΘΟΥ, ΓΥΨΟΥ, ΚΙΜΩΛΙΑΣ ΚΑΙ ΣΧΙΣΤΟΛΙΘΟΥ',
  },
  {
    label: '46131207',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΓΥΨΟ',
  },
  {
    label: '46131208',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ',
  },
  {
    label: '46131209',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΠΙΠΕΔΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '46131210',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΤΟΙΜΟΥ ΣΚΥΡΟΔΕΜΑΤΟΣ',
  },
  {
    label: '46131211',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ',
  },
  {
    label: '46131212',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΕΡΑΜΙΚΩΝ ΠΛΑΚΙΔΙΩΝ ΚΑΙ ΠΛΑΚΩΝ',
  },
  {
    label: '46131213',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΟΝΙΑΜΑΤΩΝ',
  },
  {
    label: '46131214',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΕΤΑΛΛΙΚΩΝ ΠΟΡΤΩΝ ΚΑΙ ΠΑΡΑΘΥΡΩΝ ΚΑΙ ΤΩΝ ΠΛΑΙΣΙΩΝ ΤΟΥΣ',
  },
  {
    label: '46131215',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΛΑΣΤΙΚΩΝ ΟΙΚΟΔΟΜΙΚΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46131216',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΟΡΤΩΝ, ΠΑΡΑΘΥΡΩΝ, ΠΛΑΙΣΙΩΝ ΚΑΙ ΚΑΤΩΦΛΙΩΝ ΤΟΥΣ, ΠΑΡΑΘΥΡΟΦΥΛΛΩΝ, ΡΟΛΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46131217',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΥΡΙΜΑΧΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46131218',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΙΔΗΡΙΚΩΝ ΟΙΚΟΔΟΜΩΝ',
  },
  {
    label: '46131219',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΩΜΑΤΩΝ ΚΑΙ ΛΕΒΗΤΩΝ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '46131220',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΤΟΥΒΛΩΝ, ΠΛΑΚΙΔΙΩΝ ΚΑΙ ΛΟΙΠΩΝ ΔΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΟΠΤΗ ΓΗ',
  },
  {
    label: '46131221',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΤΣΙΜΕΝΤΟΥ',
  },
  {
    label: '46131222',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΧΡΩΜΑΤΩΝ, ΒΕΡΝΙΚΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΠΙΧΡΙΣΜΑΤΩΝ ΚΑΙ ΜΑΣΤΙΧΩΝ',
  },
  {
    label: '46140000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗΧΑΝΗΜΑΤΩΝ, ΒΙΟΜΗΧΑΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΠΛΟΙΩΝ ΚΑΙ ΑΕΡΟΣΚΑΦΩΝ',
  },
  {
    label: '46141100',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ, ΛΟΓΙΣΜΙΚΟΥ, ΗΛΕΚΤΡΟΝΙΚΟΥ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΩΝ',
  },
  {
    label: '46141101',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΟΥ ΗΛΕΚΤΡΟΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46141102',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΜΦΟΡΤΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΠΛΑΚΕΤΩΝ',
  },
  {
    label: '46141103',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΞΟΠΛΙΣΜΟΥ ΕΠΙΚΟΙΝΩΝΙΑΣ',
  },
  {
    label: '46141104',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΕΙΔΩΝ ΕΥΡΕΙΑΣ ΚΑΤΑΝΑΛΩΣΗΣ',
  },
  {
    label: '46141105',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '46141106',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46141107',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗΧΑΝΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΟΥ (ΕΚΤΟΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ)',
  },
  {
    label: '46141200',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΛΟΙΩΝ ΚΑΙ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΜΕΤΑΦΟΡΑΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46141201',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΔΙΑΣΤΗΜΟΠΛΟΙΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46141202',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΛΟΙΩΝ ΚΑΙ ΠΛΩΤΩΝ ΚΑΤΑΣΚΕΥΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46141203',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΑΜΑΞΩΝ ΚΑΙ ΤΡΟΧΑΙΟΥ ΥΛΙΚΟΥ',
  },
  {
    label: '46141204',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΚΑΦΩΝ ΑΝΑΨΥΧΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46141205',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΤΡΑΤΙΩΤΙΚΩΝ ΟΧΗΜΑΤΩΝ ΜΑΧΗΣ',
  },
  {
    label: '46141300',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΒΙΟΜΗΧΑΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '46141301',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46141302',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΑΝΤΛΙΩΝ ΚΑΙ ΣΥΜΠΙΕΣΤΩΝ',
  },
  {
    label: '46141303',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΕΙΔΩΝ ΓΥΑΛΙΟΥ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΓΥΑΛΙΟΥ ΓΙΑ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '46141304',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ',
  },
  {
    label: '46141305',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΣΥΡΜΑΤΩΝ ΚΑΙ ΚΑΛΩΔΙΩΝ',
  },
  {
    label: '46141306',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΚΕΡΑΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΓΙΑ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΜΟΝΩΤΙΚΩΝ',
  },
  {
    label: '46141307',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΝΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46141308',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46141309',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46141310',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΓΕΩΡΓΙΚΩΝ ΕΛΚΥΣΤΗΡΩΝ',
  },
  {
    label: '46141311',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΓΕΩΡΓΙΚΩΝ ΚΑΙ ΔΑΣΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '46141312',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΛΑΦΡΩΝ ΜΕΤΑΛΛΙΚΩΝ ΕΙΔΩΝ ΣΥΣΚΕΥΑΣΙΑΣ',
  },
  {
    label: '46141313',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΞΑΡΤΗΜΑΤΩΝ ΚΑΛΩΔΙΩΣΗΣ',
  },
  {
    label: '46141314',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΞΟΠΛΙΣΜΟΥ ΑΝΥΨΩΣΗΣ ΚΑΙ ΔΙΑΚΙΝΗΣΗΣ ΦΟΡΤΙΩΝ',
  },
  {
    label: '46141315',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΣΩΡΕΥΤΩΝ',
  },
  {
    label: '46141316',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΗΛΕΚΤΡΟΚΙΝΗΤΗΡΩΝ, ΗΛΕΚΤΡΟΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ',
  },
  {
    label: '46141317',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΗΛΕΚΤΡΟΚΙΝΗΤΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '46141318',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΦΩΤΙΣΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46141319',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΙΑΤΡΙΚΩΝ ΚΑΙ ΟΔΟΝΤΙΑΤΡΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ',
  },
  {
    label: '46141320',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΙΝΩΝ ΓΥΑΛΙΟΥ',
  },
  {
    label: '46141321',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46141322',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΙΝΗΤΗΡΩΝ ΚΑΙ ΣΤΡΟΒΙΛΩΝ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΟΥΣ ΚΙΝΗΤΗΡΕΣ ΑΕΡΟΣΚΑΦΩΝ, ΟΧΗΜΑΤΩΝ ΚΑΙ ΔΙΚΥΚΛΩΝ',
  },
  {
    label: '46141323',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΛΕΙΑΝΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46141324',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΕΣΩΝ ΠΡΟΕΚΤΥΠΩΣΗΣ ΚΑΙ ΠΡΟΕΓΓΡΑΦΗΣ',
  },
  {
    label: '46141325',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΑ ΟΡΥΧΕΙΑ, ΤΑ ΛΑΤΟΜΕΙΑ ΚΑΙ ΤΙΣ ΔΟΜΙΚΕΣ ΚΑΤΑΣΚΕΥΕΣ',
  },
  {
    label: '46141326',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗ ΜΕΤΑΛΛΟΥΡΓΙΑ',
  },
  {
    label: '46141327',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΝΔΥΜΑΤΩΝ Η ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46141328',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '46141329',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΥΠΟΔΗΜΑΤΟΠΟΙΙΑ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46141330',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗΧΑΝΗΜΑΤΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ',
  },
  {
    label: '46141331',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗΧΑΝΗΜΑΤΩΝ ΜΟΡΦΟΠΟΙΗΣΗΣ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '46141332',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΟΠΛΩΝ ΚΑΙ ΠΥΡΟΜΑΧΙΚΩΝ',
  },
  {
    label: '46141333',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΜΕΤΡΗΣΗΣ, ΔΟΚΙΜΩΝ ΚΑΙ ΠΛΟΗΓΗΣΗΣ',
  },
  {
    label: '46141334',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΛΑΣΤΙΚΩΝ ΕΙΔΩΝ ΣΥΣΚΕΥΑΣΙΑΣ',
  },
  {
    label: '46141335',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΥΣΚΕΥΩΝ ΔΙΑΝΟΜΗΣ ΚΑΙ ΕΛΕΓΧΟΥ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '46141336',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΤΡΙΒΕΩΝ, ΟΔΟΝΤΩΤΩΝ ΜΗΧΑΝΙΣΜΩΝ ΜΕΤΑΔΟΣΗΣ ΚΙΝΗΣΗΣ, ΣΥΝΔΕΤΗΡΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΚΟΧΛΙΟΜΗΧΑΝΩΝ',
  },
  {
    label: '46141337',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΥΔΡΑΥΛΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46141338',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΦΟΥΡΝΩΝ, ΚΛΙΒΑΝΩΝ ΚΑΙ ΚΑΥΣΤΗΡΩΝ',
  },
  {
    label: '46141339',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΧΑΛΥΒΔΙΝΩΝ ΒΑΡΕΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ',
  },
  {
    label: '46141340',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΨΥΚΤΙΚΟΥ ΚΑΙ ΚΛΙΜΑΤΙΣΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΜΗ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46150000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΠΙΠΛΩΝ, ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ, ΣΙΔΗΡΙΚΩΝ ΚΑΙ ΕΙΔΩΝ ΚΙΓΚΑΛΕΡΙΑΣ',
  },
  {
    label: '46151100',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΠΙΠΛΩΝ',
  },
  {
    label: '46151101',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΕΠΙΠΛΩΝ',
  },
  {
    label: '46151102',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΠΙΠΛΩΝ ΓΙΑ ΓΡΑΦΕΙΑ ΚΑΙ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '46151103',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΠΙΠΛΩΝ ΚΟΥΖΙΝΑΣ',
  },
  {
    label: '46151104',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΤΡΩΜΑΤΩΝ',
  },
  {
    label: '46151200',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΞΟΠΛΙΣΜΟΥ ΡΑΔΙΟΦΩΝΙΑΣ, ΤΗΛΕΟΡΑΣΗΣ ΚΑΙ ΒΙΝΤΕΟ',
  },
  {
    label: '46151300',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΙΔΗΡΙΚΩΝ ΚΑΙ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '46151301',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '46151302',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΛΕΙΔΑΡΙΩΝ ΚΑΙ ΜΕΝΤΕΣΕΔΩΝ',
  },
  {
    label: '46151900',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΑΧΑΙΡΟΠΙΡΟΥΝΩΝ ΚΑΙ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46151901',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΚΟΙΝΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46151902',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΕΤΑΛΛΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46151903',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46151904',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΞΥΛΟ· ΕΙΔΩΝ ΑΠΟ ΦΕΛΛΟ ΚΑΙ ΕΙΔΩΝ ΚΑΛΑΘΟΠΟΙΙΑΣ ΚΑΙ ΣΠΑΡΤΟΠΛΕΚΤΙΚΗΣ',
  },
  {
    label: '46151905',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΓΥΑΛΙΝΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ (ΚΑΘΡΕΠΤΩΝ, ΦΙΑΛΩΝ, ΠΟΤΗΡΙΩΝ ΚΛΠ)',
  },
  {
    label: '46151906',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΙΔΩΝ ΑΠΟ ΣΥΡΜΑ, ΑΛΥΣΙΔΩΝ ΚΑΙ ΕΛΑΤΗΡΙΩΝ',
  },
  {
    label: '46151907',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ ΚΑΙ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46151908',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46151909',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΦΩΤΙΣΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46151910',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΑΧΑΙΡΟΠΙΡΟΥΝΩΝ ΚΑΙ ΚΟΠΤΙΚΩΝ',
  },
  {
    label: '46151911',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΕΤΑΛΛΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΚΕΥΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΕΩΣ',
  },
  {
    label: '46151912',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46160000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΝΔΥΜΑΤΩΝ, ΓΟΥΝΑΡΙΚΩΝ, ΥΠΟΔΗΜΑΤΩΝ ΚΑΙ ΔΕΡΜΑΤΙΝΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46161000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΙΔΩΝ ΙΜΑΤΙΣΜΟΥ, ΓΟΥΝΩΝ, ΥΠΟΔΗΜΑΤΩΝ ΚΑΙ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46161100',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46161101',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΕΤΟΙΜΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ, ΕΚΤΟΣ ΑΠΟ ΕΝΔΥΜΑΤΑ ',
  },
  {
    label: '46161102',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΤΕΧΝΙΚΩΝ ΚΑΙ ΒΙΟΜΗΧΑΝΙΚΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46161103',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΥΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46161104',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΟΥΡΤΙΝΩΝ',
  },
  {
    label: '46161105',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗ ΥΦΑΣΜΕΝΩΝ ΕΙΔΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΜΗ ΥΦΑΣΜΕΝΑ ΕΙΔΗ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΕΝΔΥΜΑΤΑ',
  },
  {
    label: '46161106',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΧΟΙΝΙΩΝ, ΣΠΑΓΓΩΝ ΚΑΙ ΔΙΧΤΥΩΝ',
  },
  {
    label: '46161107',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΥΦΑΝΤΙΚΩΝ ΝΗΜΑΤΩΝ',
  },
  {
    label: '46161108',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '46161109',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΧΑΛΙΩΝ ΚΑΙ ΚΙΛΙΜΙΩΝ',
  },
  {
    label: '46161200',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΙΔΩΝ ΙΜΑΤΙΣΜΟΥ, ΓΟΥΝΩΝ ΚΑΙ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '46161201',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΘΛΗΤΙΚΩΝ ΡΟΥΧΩΝ',
  },
  {
    label: '46161202',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ',
  },
  {
    label: '46161203',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΕΞΩΤΕΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ ΓΙΑ ΑΝΔΡΕΣ ΚΑΙ ΑΓΟΡΙΑ',
  },
  {
    label: '46161204',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΕΞΩΤΕΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ ΓΙΑ ΓΥΝΑΙΚΕΣ ΚΑΙ ΚΟΡΙΤΣΙΑ',
  },
  {
    label: '46161205',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΒΡΕΦΙΚΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '46161206',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΓΟΥΝΙΝΩΝ ΕΙΔΩΝ ΕΝΔΥΣΗΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΝΔΥΣΗΣ',
  },
  {
    label: '46161207',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΕΡΜΑΤΙΝΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '46161208',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΙΔΩΝ ΚΑΛΤΣΟΠΟΙΙΑΣ ΑΠΛΗΣ ΠΛΕΞΗΣ ΚΑΙ ΠΛΕΞΗΣ ΚΡΟΣΕ',
  },
  {
    label: '46161209',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΝΔΥΜΑΤΩΝ ΕΡΓΑΣΙΑΣ',
  },
  {
    label: '46161210',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΣΩΡΟΥΧΩΝ',
  },
  {
    label: '46161211',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΟΥΚΑΜΙΣΩΝ ΠΟΥΛΟΒΕΡ, ΖΑΚΕΤΩΝ, ΓΙΛΕΚΩΝ ΚΑΙ ΜΠΛΟΥΖΩΝ',
  },
  {
    label: '46161212',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '46161300',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΤΑΞΙΔΙΟΥ',
  },
  {
    label: '46161301',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΔΕΡΜΑΤΙΝΩΝ ΚΑΙ ΓΟΥΝΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46161302',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΓΟΥΝΟΔΕΡΜΑΤΩΝ',
  },
  {
    label: '46161303',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΙΔΩΝ ΤΑΞΙΔΙΟΥ (ΑΠΟΣΚΕΥΩΝ), ΤΣΑΝΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46170000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ',
  },
  {
    label: '46171100',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '46171101',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΒΓΩΝ ΜΕ ΤΟ ΚΕΛΥΦΟΣ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΝΩΠΑ',
  },
  {
    label: '46171102',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΕΙΔΩΝ ΔΙΑΤΡΟΦΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46171103',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΜΥΛΩΝ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΑΜΥΛΟΥ',
  },
  {
    label: '46171104',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΡΤΥΜΑΤΩΝ ΚΑΙ ΚΑΡΥΚΕΥΜΑΤΩΝ',
  },
  {
    label: '46171105',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΚΑΙ ΤΥΡΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46171106',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΙΔΩΝ ΑΡΤΟΠΟΙΙΑΣ ΚΑΙ ΝΩΠΩΝ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ',
  },
  {
    label: '46171107',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΔΙΑΤΡΟΦΗΣ',
  },
  {
    label: '46171108',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΛΑΙΩΝ ΚΑΙ ΛΙΠΩΝ',
  },
  {
    label: '46171109',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΤΟΙΜΩΝ ΓΕΥΜΑΤΩΝ ΚΑΙ ΦΑΓΗΤΩΝ',
  },
  {
    label: '46171110',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΖΑΧΑΡΗΣ',
  },
  {
    label: '46171111',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΑΚΑΟΥ, ΣΟΚΟΛΑΤΑΣ ΚΑΙ ΖΑΧΑΡΩΤΩΝ',
  },
  {
    label: '46171112',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΡΕΑΤΟΣ ΕΚΤΟΣ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '46171113',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΡΕΑΤΟΣ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '46171114',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΑΚΑΡΟΝΙΩΝ, ΛΑΖΑΝΙΩΝ, ΚΟΥΣΚΟΥΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΑΛΕΥΡΩΔΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46171115',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΑΡΓΑΡΙΝΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΒΡΩΣΙΜΩΝ ΛΙΠΩΝ',
  },
  {
    label: '46171116',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΟΜΟΓΕΝΟΠΟΙΗΜΕΝΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΔΙΑΤΡΟΦΗΣ ΚΑΙ ΔΙΑΙΤΗΤΙΚΩΝ ΤΡΟΦΩΝ',
  },
  {
    label: '46171117',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΑΓΩΤΩΝ',
  },
  {
    label: '46171118',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΑΞΙΜΑΔΙΩΝ ΚΑΙ ΜΠΙΣΚΟΤΩΝ· ΔΙΑΤΗΡΟΥΜΕΝΩΝ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ',
  },
  {
    label: '46171119',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΖΩΟΤΡΟΦΩΝ ΓΙΑ ΖΩΑ ΠΟΥ ΕΚΤΡΕΦΟΝΤΑΙ ΣΕ ΑΓΡΟΚΤΗΜΑΤΑ',
  },
  {
    label: '46171120',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΖΩΟΤΡΟΦΩΝ ΓΙΑ ΖΩΑ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '46171121',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΚΑΙ ΔΙΑΤΗΡΗΜΕΝΩΝ ΛΑΧΑΝΙΚΩΝ, ΠΑΤΑΤΩΝ, ΦΡΟΥΤΩΝ ΚΑΙ ΞΗΡΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '46171122',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΡΟΪΟΝΤΩΝ ΑΛΕΥΡΟΜΥΛΩΝ',
  },
  {
    label: '46171123',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ ΚΑΙ ΚΡΕΑΤΟΣ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '46171124',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΤΣΑΓΙΟΥ ΚΑΙ ΚΑΦΕ',
  },
  {
    label: '46171125',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΕΙΔΩΝ ΔΙΑΤΡΟΦΗΣ',
  },
  {
    label: '46171126',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΧΥΜΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '46171127',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΨΑΡΙΩΝ, ΚΑΡΚΙΝΟΕΙΔΩΝ ΚΑΙ ΜΑΛΑΚΙΩΝ, ΜΗ ΖΩΝΤΩΝ',
  },
  {
    label: '46171200',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΟΤΩΝ',
  },
  {
    label: '46171201',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΜΗ ΑΠΟΣΤΑΓΜΕΝΩΝ ΠΟΤΩΝ ΠΟΥ ΥΦΙΣΤΑΝΤΑΙ ΖΥΜΩΣΗ',
  },
  {
    label: '46171202',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΝΑΨΥΚΤΙΚΩΝ· ΜΕΤΑΛΛΙΚΟΥ ΝΕΡΟΥ ΚΑΙ ΑΛΛΩΝ ΕΜΦΙΑΛΩΜΕΝΩΝ ΝΕΡΩΝ',
  },
  {
    label: '46171203',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΠΟΣΤΑΓΜΕΝΩΝ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ',
  },
  {
    label: '46171204',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΒΥΝΗΣ',
  },
  {
    label: '46171205',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΖΥΘΟΥ',
  },
  {
    label: '46171206',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΗΛΙΤΗ ΚΑΙ ΚΡΑΣΙΩΝ ΑΠΟ ΑΛΛΑ ΦΡΟΥΤΑ',
  },
  {
    label: '46171207',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΟΙΝΟΥ ΑΠΟ ΣΤΑΦΥΛΙΑ',
  },
  {
    label: '46171300',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΡΟΪΟΝΤΩΝ ΚΑΠΝΟΥ',
  },
  {
    label: '46180000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΕΙΔΙΚΕΥΜΕΝΟΙ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΣΥΓΚΕΚΡΙΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46181000',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΣΥΓΚΕΚΡΙΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46181100',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΚΑΙ ΙΑΤΡΙΚΩΝ ΕΙΔΩΝ, ΑΡΩΜΑΤΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ ΚΑΙ ΥΛΙΚΩΝ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '46181101',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΚΤΙΝΟΛΟΓΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΛΟΙΠΟΥ ΕΞΟΠΛΙΣΜΟΥ ΙΑΤΡΙΚΗΣ ΚΑΙ ΘΕΡΑΠΕΥΤΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46181102',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΡΩΜΑΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΛΛΩΠΙΣΜΟΥ',
  },
  {
    label: '46181103',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΒΑΣΙΚΩΝ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46181104',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΡΓΑΣΤΗΡΙΑΚΩΝ ΕΙΔΩΝ, ΙΑΤΡΟΦΑΡΜΑΚΕΥΤΙΚΩΝ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ Η ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46181105',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΙΑΤΡΙΚΩΝ ΑΝΑΛΩΣΙΜΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46181106',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΙΑΤΡΙΚΩΝ ΚΑΙ ΟΔΟΝΤΙΑΤΡΙΚΩΝ ΟΡΓΑΝΩΝ, ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΡΓΑΛΕΙΩΝ',
  },
  {
    label: '46181107',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΑΠΟΥΝΙΩΝ ΚΑΙ ΑΠΟΡΡΥΠΑΝΤΙΚΩΝ, ΠΡΟΪΟΝΤΩΝ ΚΑΘΑΡΙΣΜΟΥ ΚΑΙ ΣΤΙΛΒΩΤΙΚΩΝ',
  },
  {
    label: '46181108',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΣΚΕΥΑΣΜΑΤΩΝ',
  },
  {
    label: '46181200',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΑΙΧΝΙΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΕΙΔΩΝ ΑΘΛΗΤΙΣΜΟΥ, ΠΟΔΗΛΑΤΩΝ, ΒΙΒΛΙΩΝ, ΕΦΗΜΕΡΙΔΩΝ, ΠΕΡΙΟΔΙΚΩΝ ΚΑΙ ΧΑΡΤΙΚΩΝ ΕΙΔΩΝ, ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ, ΡΟΛΟΓΙΩΝ ΧΕΡΙΟΥ ΚΑΙ ΤΟΙΧΟΥ, ΦΩΤΟΓΡΑΦΙΚΟΥ ΚΑΙ ΟΠΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46181201',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΘΛΗΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46181202',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΟΥ ΕΝΤΥΠΟΥ ΥΛΙΚΟΥ',
  },
  {
    label: '46181203',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΧΑΡΤΙ ΚΑΙ ΧΑΡΤΟΝΙ',
  },
  {
    label: '46181204',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΒΙΒΛΙΩΝ',
  },
  {
    label: '46181205',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ, ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΚΑΙ ΕΙΔΩΝ ΤΟΥΑΛΕΤΑΣ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '46181206',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΙΔΩΝ ΧΑΡΤΟΠΩΛΕΙΟΥ',
  },
  {
    label: '46181207',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΦΗΜΕΡΙΔΩΝ ΚΑΙ ΠΕΡΙΟΔΙΚΩΝ',
  },
  {
    label: '46181208',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΑΓΝΗΤΙΚΩΝ ΚΑΙ ΟΠΤΙΚΩΝ ΜΕΣΩΝ ΕΓΓΡΑΦΗΣ ΔΕΔΟΜΕΝΩΝ, ΗΧΟΥ ΚΑΙ ΕΙΚΟΝΑΣ',
  },
  {
    label: '46181209',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '46181210',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΟΠΤΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΦΩΤΟΓΡΑΦΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46181211',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΑΙΧΝΙΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '46181212',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΟΔΗΛΑΤΩΝ ΚΑΙ ΑΜΑΞΙΔΙΩΝ',
  },
  {
    label: '46181213',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΡΟΛΟΓΙΩΝ',
  },
  {
    label: '46181214',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΚΑΙ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ ΑΠΟ ΧΑΡΤΙ ΚΑΙ ΧΑΡΤΟΝΙ',
  },
  {
    label: '46181215',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΧΑΡΤΟΠΟΛΤΟΥ, ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '46181900',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΣΥΓΚΕΚΡΙΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46181901',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46181902',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΝΑΛΩΣΙΜΩΝ ΕΙΔΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ',
  },
  {
    label: '46181903',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ',
  },
  {
    label: '46181904',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΙΑΦΟΡΩΝ ΑΛΛΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46181905',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΙΑΦΟΡΩΝ ΚΑΛΛΙΤΕΧΝΙΚΩΝ ΚΑΙ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΠΟΛΥΤΕΛΕΙΑΣ',
  },
  {
    label: '46181906',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΚΟΣΜΗΜΑΤΩΝ ΑΠΟΜΙΜΗΣΗΣ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46181907',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΝΟΜΙΣΜΑΤΩΝ, ΚΟΣΜΗΜΑΤΩΝ, ΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46181908',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΣΚΟΥΠΩΝ ΚΑΙ ΒΟΥΡΤΣΩΝ',
  },
  {
    label: '46190000',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΙΑΦΟΡΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46191000',
    value: 'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΟΙΚΙΛΙΑΣ ΕΙΔΩΝ',
  },
  {
    label: '46191001',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΠΟΙΚΙΛΙΑΣ ΕΙΔΩΝ ΓΙΑ ΠΛΟΙΑ',
  },
  {
    label: '46191002',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΑΡΧΑΙΟΤΗΤΩΝ, ΑΝΤΙΚΩΝ ΚΑΙ ΓΕΝΙΚΑ ΠΑΛΑΙΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ ΤΕΧΝΗΣ',
  },
  {
    label: '46191003',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΙΑΦΟΡΩΝ ΕΙΔΩΝ ΑΛΛΟΔΑΠΩΝ ΟΙΚΩΝ',
  },
  {
    label: '46191004',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΙΑΦΟΡΩΝ ΕΙΔΩΝ ΟΙΚΩΝ ΕΣΩΤΕΡΙΚΟΥ',
  },
  {
    label: '46191005',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΔΙΑΦΟΡΩΝ ΤΟΥΡΙΣΤΙΚΩΝ ΚΑΙ ΛΟΙΠΩΝ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΛΑΪΚΗΣ ΤΕΧΝΗΣ',
  },
  {
    label: '46191006',
    value:
      'ΕΜΠΟΡΙΚΟΙ ΑΝΤΙΠΡΟΣΩΠΟΙ ΠΟΥ ΜΕΣΟΛΑΒΟΥΝ ΣΤΗΝ ΠΩΛΗΣΗ ΕΙΔΩΝ ΓΕΝΙΚΑ ΠΡΟΣ ΤΟ ΔΗΜΟΣΙΟ, ΝΟΜΙΚΑ ΠΡΟΣΩΠΑ ΔΗΜΟΣΙΟΥ ΔΙΚΑΙΟΥ, ΟΡΓΑΝΙΣΜΟΥΣ ΤΟΠΙΚΗΣ ΑΥΤΟΔΙΟΙΚΗΣΕΩΣ, ΝΟΣΟΚΟΜΕΙΑ, ΔΗΜΟΤΙΚΑ ΚΛΠ ΚΟΙΝΩΦΕΛΗ Η ΟΧΙ ΙΔΡΥΜΑΤΑ ΚΑΙ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '46191007',
    value:
      'ΕΡΓΑΣΙΕΣ ΓΕΩΡΓΙΚΩΝ ΜΕΣΟΛΑΒΗΤΙΚΩΝ ΟΡΓΑΝΙΣΜΩΝ (ΓΙΑ ΑΓΡΟΤΙΚΑ ΠΡΟΪΟΝΤΑ)',
  },
  {
    label: '46210000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΤΗΡΩΝ, ΑΚΑΤΕΡΓΑΣΤΟΥ ΚΑΠΝΟΥ, ΣΠΟΡΩΝ ΚΑΙ ΖΩΟΤΡΟΦΩΝ',
  },
  {
    label: '46211000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΗΜΗΤΡΙΑΚΩΝ, ΣΠΟΡΩΝ ΚΑΙ ΖΩΟΤΡΟΦΩΝ',
  },
  {
    label: '46211100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '46211101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '46211102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΑΜΠΟΚΙΟΥ',
  },
  {
    label: '46211103',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΙΘΑΡΙΟΥ',
  },
  {
    label: '46211104',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΛΑΚΟΥ ΣΙΤΑΡΙΟΥ ΚΑΙ ΣΜΙΓΑΔΙΟΥ, ΓΙΑ ΚΑΤΑΝΑΛΩΣΗ ΑΠΟ ΑΝΘΡΩΠΟΥΣ',
  },
  {
    label: '46211105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΛΑΚΟΥ ΣΙΤΑΡΙΟΥ ΚΑΙ ΣΜΙΓΑΔΙΟΥ, ΓΙΑ ΚΑΤΑΝΑΛΩΣΗ ΑΠΟ ΖΩΑ',
  },
  {
    label: '46211106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΥΖΙΟΥ, ΜΗ ΑΠΟΦΛΟΙΩΜΕΝΟΥ',
  },
  {
    label: '46211107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΚΑΛΗΣ, ΒΡΩΜΗΣ',
  },
  {
    label: '46211108',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΛΗΡOΥ ΣΙΤΑΡΙΟΥ, ΓΙΑ ΚΑΤΑΝΑΛΩΣΗ ΑΠΟ ΑΝΘΡΩΠΟΥΣ',
  },
  {
    label: '46211109',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΛΗΡΟΥ ΣΙΤΑΡΙΟΥ, ΓΙΑ ΚΑΤΑΝΑΛΩΣΗ ΑΠΟ ΖΩΑ',
  },
  {
    label: '46211110',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΓΙΑ ΠΤΗΝΟΤΡΟΦΕΣ ΚΑΙ ΚΤΗΝΟΤΡΟΦΕΣ',
  },
  {
    label: '46211200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ (ΕΚΤΟΣ ΤΩΝ ΕΛΑΙΟΥΧΩΝ ΣΠΟΡΩΝ)',
  },
  {
    label: '46211201',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΔΗΜΗΤΡΙΑΚΩΝ, ΓΙΑ ΣΠΟΡΑ',
  },
  {
    label: '46211202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΞΗΡΑΜΕΝΩΝ ΟΣΠΡΙΩΔΩΝ ΛΑΧΑΝΙΚΩΝ, ΑΠΟΦΛΟΙΩΜΕΝΩΝ, ΓΙΑ ΣΠΟΡΑ',
  },
  {
    label: '46211203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΡΩΣΙΜΩΝ ΡΙΖΩΝ ΚΑΙ ΒΟΛΒΩΝ ΜΕ ΥΨΗΛΟ ΠΕΡΙΕΧΟΜΕΝΟ ΣΕ ΑΜΥΛΟ Η ΙΝΟΥΛΙΝΗ, ΓΙΑ ΣΠΟΡΑ',
  },
  {
    label: '46211204',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΑΜΠΟΚΙΟΥ ΓΙΑ ΣΠΟΡΑ',
  },
  {
    label: '46211205',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΙΘΑΡΙΟΥ, ΓΙΑ ΣΠΟΡΑ',
  },
  {
    label: '46211206',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΛΑΚΟΥ ΣΙΤΑΡΙΟΥ ΚΑΙ ΣΜΙΓΑΔΙΟΥ, ΓΙΑ ΣΠΟΡΑ',
  },
  {
    label: '46211207',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΛΗΡΟΥ ΣΙΤΑΡΙΟΥ, ΓΙΑ ΣΠΟΡΑ',
  },
  {
    label: '46211208',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΑΝΘΕΩΝ ΚΑΙ ΚΑΡΠΩΝ',
  },
  {
    label: '46211209',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΖΑΧΑΡΟΤΕΥΤΛΩΝ ΚΑΙ ΣΠΟΡΩΝ ΚΤΗΝΟΤΡΟΦΙΚΩΝ ΦΥΤΩΝ',
  },
  {
    label: '46211210',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '46211211',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΠΑΤΑΤΑΣ',
  },
  {
    label: '46211300',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΟΥΧΩΝ ΣΠΟΡΩΝ ΚΑΙ ΚΑΡΠΩΝ',
  },
  {
    label: '46211301',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΛΑΙΟΥΧΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '46211302',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΛΑΙΟΥΧΩΝ ΣΠΟΡΩΝ',
  },
  {
    label: '46211303',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΑΠΙΚΩΝ ΦΙΣΤΙΚΙΩΝ',
  },
  {
    label: '46211304',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΩΝ',
  },
  {
    label: '46211305',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΒΑΜΒΑΚΙΟΥ',
  },
  {
    label: '46211306',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΗΛΙΑΝΘΟΥ, ΣΟΥΣΑΜΙΟΥ, ΚΑΡΔΑΜΟΥ, ΚΡΑΜΒΗΣ, ΕΛΑΙΟΚΡΑΜΒΗΣ ΚΑΙ',
  },
  {
    label: '46211400',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΩΟΤΡΟΦΩΝ',
  },
  {
    label: '46211401',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΕΥΡΙΩΝ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΩΝ ΑΠΟ ΕΛΑΙΟΥΧΟΥΣ ΣΠΟΡΟΥΣ Η ΚΑΡΠΟΥΣ ΕΚΤΟΣ ΤΟΥ ΣΙΝΑΠΙΟΥ',
  },
  {
    label: '46211402',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΕΥΡΙΩΝ, ΧΟΝΔΡΑΛΕΥΡΩΝ ΚΑΙ ΣΒΟΛΩΝ ΚΡΕΑΤΟΣ, ΑΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΑΝΘΡΩΠΙΝΗ ΚΑΤΑΝΑΛΩΣΗ, ΥΠΟΛΕΙΜΜΑΤΩΝ ΖΩΙΚΟΥ ΛΙΠΟΥΣ',
  },
  {
    label: '46211403',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΕΥΡΙΩΝ, ΧΟΝΔΡΑΛΕΥΡΩΝ ΚΑΙ ΣΒΟΛΩΝ ΨΑΡΙΩΝ, ΚΑΡΚΙΝΟΕΙΔΩΝ, ΜΑΛΑΚΙΩΝ Η ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΜΗ ΒΡΩΣΙΜΩΝ',
  },
  {
    label: '46211404',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΞΗΡΑΜΕΝΩΝ ΟΣΠΡΙΩΔΩΝ ΛΑΧΑΝΙΚΩΝ, ΑΠΟΦΛΟΙΩΜΕΝΩΝ ΓΙΑ ΤΡΟΦΗ ΖΩΩΝ',
  },
  {
    label: '46211405',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΧΥΡΩΝ ΚΑΙ ΣΑΝΟΥ (ΧΟΡΤΟΝΟΜΗΣ)',
  },
  {
    label: '46211406',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΛΟΓΙΚΩΝ ΖΩΟΤΡΟΦΩΝ',
  },
  {
    label: '46211407',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΟΠΙΤΩΝ ΚΑΙ ΑΛΛΩΝ ΣΤΕΡΕΩΝ ΚΑΤΑΛΟΙΠΩΝ ΦΥΤΙΚΩΝ ΛΙΠΩΝ Η ΕΛΑΙΩΝ',
  },
  {
    label: '46211408',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΑΛΟΙΠΩΝ ΠΑΡΑΓΩΓΗΣ ΑΜΥΛΟΥ, ΖΥΘΟΠΟΙΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΚΑΤΑΛΟΙΠΩΝ',
  },
  {
    label: '46211409',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΖΩΟΤΡΟΦΩΝ ΓΙΑ ΖΩΑ ΠΟΥ ΕΚΤΡΕΦΟΝΤΑΙ ΣΕ ΑΓΡΟΚΤΗΜΑΤΑ',
  },
  {
    label: '46211410',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΙΤΟΥΡΟΥ, ΠΙΤΟΥΡΑΛΕΥΡΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΤΑΛΟΙΠΩΝ ΑΠΟ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '46211411',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΒΟΛΩΝ ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '46211412',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΤΙΚΩΝ ΑΛΕΥΡΙΩΝ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΩΝ, ΓΙΑ ΤΡΟΦΗ ΖΩΩΝ',
  },
  {
    label: '46211413',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΤΙΚΩΝ ΥΛΩΝ ΚΑΙ ΦΥΤΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, ΓΙΑ ΤΡΟΦΗ ΖΩΩΝ',
  },
  {
    label: '46211414',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧOΝΔΡΑΛΕΥΡΟΥ ΚΑΙ ΣΒΟΛΩΝ ΤΡΙΦΥΛΛΙΟΥ (ALFALFA)',
  },
  {
    label: '46211900',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΚΑΤΕΡΓΑΣΤΩΝ ΑΓΡΟΤΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46211901',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ~ ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ ~ ΑΦΡΥΚΤΟΥ ΚΑΦΕ',
  },
  {
    label: '46211902',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΦΥΤΙΚΩΝ ΠΡΩΤΩΝ ΥΛΩΝ',
  },
  {
    label: '46211903',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΑΛΑΤΑΣ, ΓΟΥΤΑΠΕΡΚΑΣ, ΓΟΥΑΓΙΟΥΛΗΣ, ΤΣΙΚΛΑΣ, ΛΑΚΑΣ, ΡΗΤΙΝΩΝ, ΚΟΜΜΕΟΡΗΤΙΝΩΝ, ΒΑΛΣΑΜΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΦΥΣΙΚΩΝ ΚΟΜΜΕΩΝ',
  },
  {
    label: '46211904',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΑΜΒΑΚΙΟΥ, ΕΚΚΟΚΚΙΣΜΕΝΟΥ Η ΜΗ',
  },
  {
    label: '46211905',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΙΟΥΤΑΣ, ΛΙΝΑΡΙΟΥ, ΚΑΝΝΑΒΗΣ, ΣΙΖΑΛ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΙΝΩΝ, ΑΚΑΤΕΡΓΑΣΤΩΝ',
  },
  {
    label: '46211906',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΚΚΟΚΚΙΣΜΕΝΟΥ ΒΑΜΒΑΚΙΟΥ',
  },
  {
    label: '46211907',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΑΧΑΡΟΚΑΛΑΜΩΝ ΚΑΙ ΖΑΧΑΡΟΤΕΥΤΛΩΝ',
  },
  {
    label: '46211908',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΙΩΝ ΕΝΤΟΜΩΝ ΚΑΙ ΣΠΑΡΜΑΤΣΕΤΩΝ',
  },
  {
    label: '46211909',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΟΒΟΥ ΚΑΙ ΦΛΟΙΟΥ ΚΑΦΕ (ΑΦΡΥΚΤΟΥ)',
  },
  {
    label: '46211910',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΕΚΚΟΚΚΙΣΜΕΝΟΥ (ΣΥΣΠΟΡΟΥ) ΒΑΜΒΑΚΙΟΥ',
  },
  {
    label: '46211911',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α. ΨΑΡΙΩΝ Η ΚΑΡΚΙΝΟΕΙΔΩΝ, ΜΑΛΑΚΙΩΝ Η ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ',
  },
  {
    label: '46211912',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΗΤΙΝΗΣ',
  },
  {
    label: '46211913',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΕΡΜΑΤΟΣ ΒΟΟΕΙΔΩΝ',
  },
  {
    label: '46211914',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΦΟΥΓΓΑΡΙΩΝ',
  },
  {
    label: '46211915',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΤΕΡΩΝ ΚΑΙ ΠΟΥΠΟΥΛΩΝ ΚΑΙ ΔΕΡΜΑΤΩΝ ΠΟΥΛΙΩΝ ΜΕ ΦΤΕΡΑ ΚΑΙ ΠΟΥΠΟΥΛΑ',
  },
  {
    label: '46211916',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΑΛΓΩΝ, ΝΩΠΩΝ Η ΑΠΟΞΗΡΑΜΕΝΩΝ',
  },
  {
    label: '46211917',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΟΥ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '46211918',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΟΥ ΦΕΛΛΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ Η ΑΠΛΗΣ ΚΑΤΕΡΓΑΣΙΑΣ',
  },
  {
    label: '46211919',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΩΝ ΣΦΟΥΓΓΑΡΙΩΝ ΖΩΙΚΗΣ ΠΡΟΕΛΕΥΣΗΣ',
  },
  {
    label: '46211920',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΤΙΚΩΝ ΥΛΩΝ Π.Δ.Κ.Α. ΓΙΑ ΣΠΑΡΤΟΠΛΕΚΤΙΚΗ, ΠΑΡΑΓΕΜΙΣΜΑ, ΒΑΤΕΣ, ΒΑΦΗ Η ΔΕΨΗ, ΦΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46211921',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΚΥΡΙΩΣ ΣΤΗΝ ΑΡΩΜΑΤΟΠΟΙΙΑ, ΤΗ ΦΑΡΜΑΚΕΥΤΙΚΗ Η ΤΗΝ ΠΑΡΑΓΩΓΗ ΕΝΤΟΜΟΚΤΟΝΩΝ, ΜΥΚΗΤΟΚΤΟΝΩΝ Η ΓΙΑ ΠΑΡΟΜΟΙΟΥΣ ΣΚΟΠΟΥΣ, ΞΗΡΩΝ',
  },
  {
    label: '46211922',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΚΥΡΙΩΣ ΣΤΗΝ ΑΡΩΜΑΤΟΠΟΙΙΑ, ΤΗ ΦΑΡΜΑΚΕΥΤΙΚΗ Η ΤΗΝ ΠΑΡΑΓΩΓΗ ΕΝΤΟΜΟΚΤΟΝΩΝ, ΜΥΚΗΤΟΚΤΟΝΩΝ Η ΓΙΑ ΠΑΡΟΜΟΙΟΥΣ ΣΚΟΠΟΥΣ, ΦΡΕΣΚΩΝ',
  },
  {
    label: '46211923',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΩΜΩΝ ΕΝΤΟΣΘΙΩΝ, ΜΗ ΒΡΩΣΙΜΩΝ, ΥΠΟΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46212000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΟΥ ΚΑΠΝΟΥ',
  },
  {
    label: '46212001',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΜΕΤΑΠΟΙΗΜΕΝΟΥ ΚΑΠΝΟΥ',
  },
  {
    label: '46220000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΛΟΥΔΙΩΝ ΚΑΙ ΦΥΤΩΝ',
  },
  {
    label: '46221001',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΞΗΡΑΜΕΝΩΝ ΦΥΤΩΝ',
  },
  {
    label: '46221002',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΝΔΡΥΛΛΙΩΝ ΚΑΙ ΦΥΤΩΝ (ΕΚΤΟΣ ΚΑΛΛΩΠΙΣΤΙΚΩΝ ΦΥΤΩΝ)',
  },
  {
    label: '46221003',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΩΝΤΩΝ ΦΥΤΩΝ, ΚΟΝΔΥΛΩΝ, ΒΟΛΒΩΝ ΚΑΙ ΡΙΖΩΝ, ΜΟΣΧΕΥΜΑΤΩΝ ΚΑΙ ΠΑΡΑΦΥΑΔΩΝ, ΜΥΚΗΛΙΩΝ ΜΑΝΙΤΑΡΙΩΝ',
  },
  {
    label: '46221004',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΜΜΕΝΩΝ ΑΝΘΕΩΝ ΚΑΙ ΜΠΟΥΜΠΟΥΚΙΩΝ ΤΟΥΣ, ΣΥΝΘΕΣΕΩΝ ΑΝΘΕΩΝ ΚΑΘΩΣ ΚΑΙ ΑΝΘΟΔΕΣΜΩΝ, ΣΤΕΦΑΝΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46221005',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΦΥΤΩΝ, ΧΟΡΤΑΡΙΩΝ, ΒΡΥΩΝ ΚΑΙ ΛΕΙΧΗΝΩΝ, ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΔΙΑΚΟΣΜΗΤΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '46221006',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΛΑΠΛΑΣΙΑΣΤΙΚΟΥ ΥΛΙΚΟΥ ΦΥΤΩΝ',
  },
  {
    label: '46221007',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΩΝ ΧΡΙΣΤΟΥΓΕΝΝΙΑΤΙΚΩΝ ΔΕΝΤΡΩΝ',
  },
  {
    label: '46230000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΩΝΤΩΝ ΖΩΩΝ',
  },
  {
    label: '46231001',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΙΓΟΕΙΔΩΝ, ΖΩΝΤΩΝ',
  },
  {
    label: '46231002',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΖΩΝΤΩΝ ΖΩΩΝ',
  },
  {
    label: '46231003',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΟΓΩΝ, ΟΝΩΝ, ΗΜΙΟΝΩΝ ΚΑΙ ΓΙΝΝΩΝ, ΖΩΝΤΩΝ',
  },
  {
    label: '46231004',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΟΟΕΙΔΩΝ, ΖΩΝΤΩΝ, ΕΚΤΟΣ ΤΩΝ ΜΟΣΧΑΡΙΩΝ',
  },
  {
    label: '46231005',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΝΕΛΙΩΝ, ΖΩΝΤΩΝ',
  },
  {
    label: '46231006',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΛΙΣΣΟΣΜΗΝΩΝ',
  },
  {
    label: '46231007',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΣΧΑΡΙΩΝ, ΖΩΝΤΩΝ',
  },
  {
    label: '46231008',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΥΛΕΡΙΚΩΝ, ΖΩΝΤΩΝ',
  },
  {
    label: '46231009',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΒΑΤΩΝ, ΖΩΝΤΩΝ',
  },
  {
    label: '46231010',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΛΙΓΚΑΡΙΩΝ, ΖΩΝΤΩΝ',
  },
  {
    label: '46231011',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΟΙΡΟΕΙΔΩΝ, ΖΩΝΤΩΝ',
  },
  {
    label: '46231012',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΩΔΙΚΩΝ ΠΤΗΝΩΝ, ΣΚΥΛΩΝ, ΓΑΤΩΝ ΚΛΠ, ΖΩΝΤΩΝ',
  },
  {
    label: '46240000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΩΝ, ΠΡΟΒΙΩΝ ΚΑΙ ΚΑΤΕΡΓΑΣΜΕΝΟΥ ΔΕΡΜΑΤΟΣ',
  },
  {
    label: '46241000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΒΙΩΝ, ΔΕΡΜΑΤΩΝ ΚΑΙ ΚΑΤΕΡΓΑΣΜΕΝΟΥ ΔΕΡΜΑΤΟΣ',
  },
  {
    label: '46241001',
    value: 'ΕΞΑΓΩΓΗ ΑΚΑΤΕΡΓΑΣΤΩΝ ΔΕΡΜΑΤΩΝ',
  },
  {
    label: '46241002',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΩΝ ΓΟΥΝΟΔΕΡΜΑΤΩΝ, ΕΚΤΟΣ ΑΠΟ ΔΕΡΜΑΤΑ ΚΟΥΝΕΛΙΩΝ, ΛΑΓΩΝ ΚΑΙ ΓΟΥΝΟΦΟΡΩΝ ΑΡΝΙΩΝ',
  },
  {
    label: '46241003',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΩΝ ΔΕΡΜΑΤΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '46241004',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΩΝ ΔΕΡΜΑΤΩΝ ΑΛΛΩΝ ΖΩΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46241005',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΩΝ ΔΕΡΜΑΤΩΝ ΒΟΟΕΙΔΩΝ Η ΙΠΠΟΕΙΔΩΝ',
  },
  {
    label: '46241006',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΩΝ ΔΕΡΜΑΤΩΝ ΠΡΟΒΑΤΩΝ Η ΑΡΝΙΩΝ, ΑΙΓΩΝ Η ΜΙΚΡΩΝ ΚΑΤΣΙΚΙΩΝ',
  },
  {
    label: '46241007',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΟΣ ΑΙΓΑΓΡΟΥ (ΣΑΜΟΥΑ), ΛΟΥΣΤΡΙΝΙΟΥ ΚΑΙ ΔΕΡΜΑΤΟΣ ΜΕ ΣΤΙΛΠΝΗ ΕΠΙΚΑΛΥΨΗ, ΕΠΙΜΕΤΑΛΛΩΜΕΝΟΥ ΔΕΡΜΑΤΟΣ',
  },
  {
    label: '46241008',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΩΝ ΑΙΓΩΝ Η ΜΙΚΡΩΝ ΚΑΤΣΙΚΙΩΝ, ΧΩΡΙΣ ΤΡΙΧΕΣ',
  },
  {
    label: '46241009',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΩΝ ΑΛΛΩΝ ΖΩΩΝ',
  },
  {
    label: '46241010',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΩΝ ΑΠΟ ΒΟΟΕΙΔΗ Η ΙΠΠΟΕΙΔΗ ΖΩΑ, ΧΩΡΙΣ ΤΡΙΧΕΣ',
  },
  {
    label: '46241011',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΔΕΡΜΑΤΩΝ',
  },
  {
    label: '46241012',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΝΘΕΤΙΚΩΝ ΔΕΡΜΑΤΩΝ, ΜΕ ΒΑΣΗ ΤΟ ΔΕΡΜΑ',
  },
  {
    label: '46310000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '46311100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΩΠΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '46311101',
    value: 'ΕΞΑΓΩΓΗ ΕΓΧΩΡΙΩΝ ΝΩΠΩΝ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46311102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΩΝ ΞΗΡΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '46311103',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΛΑΧΑΝΙΚΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46311104',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΣΤΑΦΥΛΙΩΝ, ΝΩΠΩΝ',
  },
  {
    label: '46311105',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΦΡΟΥΤΩΝ, ΧΑΡΟΥΠΙΩΝ',
  },
  {
    label: '46311106',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΡΩΣΙΜΩΝ ΡΙΖΩΝ ΚΑΙ ΒΟΛΒΩΝ ΜΕ ΥΨΗΛΟ ΠΕΡΙΕΧΟΜΕΝΟ ΣΕ ΑΜΥΛΟ Η ΙΝΟΥΛΙΝΗ, ΓΙΑ ΑΝΘΡΩΠΙΝΗ ΚΑΤΑΝΑΛΩΣΗ',
  },
  {
    label: '46311107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΟΠΥΡΗΝΑ',
  },
  {
    label: '46311108',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΡΠΩΝ, ΦΡΕΣΚΩΝ',
  },
  {
    label: '46311109',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΤΑΦΥΛΙΩΝ',
  },
  {
    label: '46311110',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΣΠΕΡΙΔΟΕΙΔΩΝ',
  },
  {
    label: '46311111',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΠΩΡΟΚΗΠΕΥΤΙΚΩΝ',
  },
  {
    label: '46311112',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΤΑΤΩΝ, ΦΡΕΣΚΩΝ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '46311113',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΙΖΩΔΩΝ ΚΑΙ ΒΟΛΒΟΕΙΔΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '46311114',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΑΡΑΓΓΙΩΝ',
  },
  {
    label: '46311115',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΑΦΙΔΩΝ',
  },
  {
    label: '46311116',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΟΥΡΜΑΔΩΝ, ΣΥΚΩΝ, ΜΠΑΝΑΝΩΝ, ΙΝΔΙΚΩΝ ΚΑΡΥΔΩΝ, ΒΡΑΖΙΛΙΑΝΙΚΩΝ ΚΑΡΥΔΩΝ ΑΝΑΚΑΡΔΙΟΥ, ΑΒΟΚΑΝΤΟ, ΜΑΝΓΚΟ, ΓΟΥΑΒΑΣ, ΦΡΕΣΚΩΝ',
  },
  {
    label: '46311200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '46311201',
    value:
      'ΕΞΑΓΩΓΗ ΜΕΤΑΠΟΙΗΜΕΝΩΝ ΛΑΧΑΝΙΚΩΝ, ΦΡΟΥΤΩΝ ΚΑΙ ΚΑΡΠΩΝ ΜΕ ΚΕΛΥΦΟΣ (ΑΚΡΟΔΡΥΩΝ)',
  },
  {
    label: '46311202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΔΙΑΤΗΡΗΜΕΝΩΝ ΦΡΟΥΤΩΝ',
  },
  {
    label: '46311203',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΞΗΡΑΜΕΝΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '46311204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΞΗΡΑΜΕΝΩΝ ΟΣΠΡΙΩΔΩΝ ΛΑΧΑΝΙΚΩΝ, ΑΠΟΦΛΟΙΩΜΕΝΩΝ, ΟΧΙ ΓΙΑ ΣΠΟΡΑ',
  },
  {
    label: '46311205',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΤΗΡΗΜΕΝΩΝ ΠΑΤΑΤΩΝ',
  },
  {
    label: '46311206',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΡΠΩΝ, ΞΗΡΩΝ',
  },
  {
    label: '46311207',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΣΠΕΡΙΔΟΕΙΔΩΝ, ΞΗΡΩΝ',
  },
  {
    label: '46311208',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΞΗΡΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '46311209',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΚΟΥΤΣΙΩΝ ΒΕΡΙΚΟΚΩΝ, ΡΟΔΑΚΙΝΩΝ Η ΔΑΜΑΣΚΗΝΩΝ',
  },
  {
    label: '46311210',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΑΧΑΝΙΚΩΝ ΔΙΑΤΗΡΗΜΕΝΩΝ ΣΕ ΞΙΔΙ Η ΣΕ ΟΞΙΚΟ ΟΞΥ',
  },
  {
    label: '46311211',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΑΧΑΝΙΚΩΝ ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '46311212',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΑΧΑΝΙΚΩΝ ΠΡΟΣΩΡΙΝΑ ΔΙΑΤΗΡΗΜΕΝΩΝ',
  },
  {
    label: '46311213',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΑΧΑΝΙΚΩΝ, ΔΙΑΤΗΡΗΜΕΝΩΝ ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΕΚΤΟΣ ΑΠΟ ΞΙΔΙ Η ΟΞΙΚΟ ΟΞΥ',
  },
  {
    label: '46311214',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΡΜΕΛΑΔΩΝ, ΖΕΛΕΔΩΝ ΚΑΙ ΠΟΥΡΕ ΚΑΙ ΠΟΛΤΩΝ ΦΡΟΥΤΩΝ Η ΞΗΡΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '46311215',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΗΡΩΝ ΚΑΡΠΩΝ, ΚΑΒΟΥΡΔΙΣΜΕΝΩΝ ΑΡΑΠΙΚΩΝ ΦΙΣΤΙΚΙΩΝ, ΑΛΑΤΙΣΜΕΝΩΝ Η ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΣΥΝΤΗΡΗΜΕΝΩΝ',
  },
  {
    label: '46311216',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΤΑΤΩΝ ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '46311217',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΡΟΥΤΩΝ ΚΑΙ ΞΗΡΩΝ ΚΑΡΠΩΝ, ΜΑΓΕΙΡΕΜΕΝΩΝ Η ΑΜΑΓΕΙΡΕΥΤΩΝ, ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '46311218',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΡΟΥΤΩΝ ΚΑΙ ΞΗΡΩΝ ΚΑΡΠΩΝ, ΠΡΟΣΩΡΙΝΑ ΔΙΑΤΗΡΗΜΕΝΩΝ, ΟΧΙ ΓΙΑ ΑΜΕΣΗ ΚΑΤΑΝΑΛΩΣΗ',
  },
  {
    label: '46311219',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΟΥΡΜΑΔΩΝ, ΣΥΚΩΝ, ΜΠΑΝΑΝΩΝ, ΙΝΔΙΚΩΝ ΚΑΡΥΔΩΝ, ΒΡΑΖΙΛΙΑΝΙΚΩΝ ΚΑΡΥΔΩΝ ΑΝΑΚΑΡΔΙΟΥ, ΑΒΟΚΑΝΤΟ, ΜΑΝΓΚΟ, ΓΟΥΑΒΑΣ, ΞΗΡΩΝ',
  },
  {
    label: '46320000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ',
  },
  {
    label: '46321100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΠΟΥΛΕΡΙΚΩΝ)',
  },
  {
    label: '46321101',
    value: 'ΕΞΑΓΩΓΗ ΕΓΧΩΡΙΩΝ ΚΑΤΕΨΥΓΜΕΝΩΝ ΚΡΕΑΤΩΝ',
  },
  {
    label: '46321102',
    value: 'ΕΞΑΓΩΓΗ ΕΓΧΩΡΙΩΝ ΝΩΠΩΝ ΚΡΕΑΤΩΝ',
  },
  {
    label: '46321103',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΡΩΝ ΖΩΩΝ',
  },
  {
    label: '46321104',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΡΕΑΤΩΝ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΚΡΕΑΤΟΣ ΚΟΥΝΕΛΙΩΝ), ΕΚΤΟΣ ΑΠΟ ΒΑΤΡΑΧΟΠΟΔΑΡΑ',
  },
  {
    label: '46321105',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ',
  },
  {
    label: '46321106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΕΨΥΓΜΕΝΟΥ ΚΡΕΑΤΟΣ ΒΟΟΕΙΔΩΝ',
  },
  {
    label: '46321107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΕΨΥΓΜΕΝΟΥ ΚΡΕΑΤΟΣ ΧΟΙΡΟΕΙΔΩΝ',
  },
  {
    label: '46321108',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΝΕΛΙΩΝ, ΝΩΠΩΝ Η ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '46321109',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΑΙΓΩΝ',
  },
  {
    label: '46321110',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΒΟΟΕΙΔΩΝ, ΝΩΠΟΥ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '46321111',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ ΠΟΥΛΕΡΙΚΩΝ, ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '46321112',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ ΠΟΥΛΕΡΙΚΩΝ, ΝΩΠΩΝ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '46321113',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΠΡΟΒΑΤΩΝ, ΚΑΤΕΨΥΓΜΕΝΟΥ',
  },
  {
    label: '46321114',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΠΡΟΒΑΤΩΝ, ΝΩΠΟΥ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '46321115',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΧΟΙΡΟΕΙΔΩΝ, ΝΩΠΟΥ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '46321116',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΩΠΩΝ ΚΑΙ ΚΑΤΕΨΥΓΜΕΝΩΝ ΚΡΕΑΤΩΝ',
  },
  {
    label: '46321117',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΛΙΓΚΑΡΙΩΝ, ΝΩΠΩΝ, ΑΠΛΗΣ ΨΥΞΗΣ, ΚΑΤΕΨΥΓΜΕΝΩΝ, ΑΠΟΞΗΡΑΜΕΝΩΝ, ΠΑΣΤΩΝ Η ΣΕ ΑΛΜΗ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΘΑΛΑΣΣΙΝΑ ΣΑΛΙΓΚΑΡΙΑ, ΒΑΤΡΑΧΟΠΟΔΑΡΩΝ, ΝΩΠΩΝ, ΑΠΛΗΣ ΨΥΞΗΣ Η ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '46321200',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΠΡΟΪΟΝΤΩΝ ΠΟΥΛΕΡΙΚΩΝ)',
  },
  {
    label: '46321201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΠΑΡΑΣΚΕΥΑΣΜΕΝΟΥ ΚΑΙ ΔΙΑΤΗΡΗΜΕΝΟΥ ΚΡΕΑΤΟΣ, ΕΝΤΟΣΘΙΩΝ Η ΑΙΜΑΤΟΣ, ΕΚΧΥΛΙΣΜΑΤΩΝ ΚΑΙ ΖΩΜΩΝ ΚΡΕΑΤΟΣ, ΨΑΡΙΩΝ ΚΑΙ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ',
  },
  {
    label: '46321202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ (ΓΥΡΟΥ, ΣΟΥΒΛΑΚΙΩΝ ΚΛΠ)',
  },
  {
    label: '46321203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ, ΑΛΑΤΙΣΜΕΝΩΝ, ΣΕ ΑΛΜΗ, ΑΠΟΞΗΡΑΜΕΝΩΝ Η ΚΑΠΝΙΣΤΩΝ, ΒΡΩΣΙΜΩΝ ΑΛΕΥΡΙΩΝ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΩΝ ΚΡΕΑΤΟΣ Η ΕΝΤΟΣΘΙΩΝ',
  },
  {
    label: '46330000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΑΒΓΩΝ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΛΑΙΩΝ ΚΑΙ ΛΙΠΩΝ',
  },
  {
    label: '46331100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46331101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΟΥΤΥΡΟΥ',
  },
  {
    label: '46331102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΣ ΚΑΙ ΚΡΕΜΑΣ ΣΕ ΣΤΕΡΕΕΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46331103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΣ ΚΑΙ ΚΡΕΜΑΣ, ΜΕ ΠΕΡΙΣΣΟΤΕΡΟ ΑΠΟ 6 ;% ΛΙΠΟΣ, ΟΧΙ ΣΥΜΠΥΚΝΩΜΕΝΩΝ Η ΖΑΧΑΡΟΥΧΩΝ',
  },
  {
    label: '46331104',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΣ ΚΑΙ ΚΡΕΜΑΣ, ΣΥΜΠΥΚΝΩΜΕΝΩΝ Η ΜΕ ΠΡΟΣΘΗΚΗ ΖΑΧΑΡΗΣ Η ΑΛΛΩΝ ΓΛΥΚΑΝΤΙΚΩΝ ΥΛΩΝ, ΣΕ ΑΛΛΕΣ ΜΟΡΦΕΣ ΕΚΤΟΣ ΤΗΣ ΣΤΕΡΕΑΣ',
  },
  {
    label: '46331105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΙΑΟΥΡΤΙΟΥ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΖΥΜΩΜΕΝΟΥ Η ΟΞΙΝΙΣΜΕΝΟΥ ΓΑΛΑΚΤΟΣ Η ΚΡΕΜΑΣ',
  },
  {
    label: '46331106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΞΕΡΓΑΣΜΕΝΟΥ ΡΕΥΣΤΟΥ ΓΑΛΑΚΤΟΣ',
  },
  {
    label: '46331107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΖΕΪΝΗΣ',
  },
  {
    label: '46331108',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΥΡΙΟΥ ΚΑΙ ΤΥΡΟΠΗΓΜΑΤΟΣ',
  },
  {
    label: '46331109',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΥΡΟΓΑΛΟΥ',
  },
  {
    label: '46331200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΒΓΩΝ',
  },
  {
    label: '46331201',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΒΓΩΝ ΜΕ ΤΟ ΚΕΛΥΦΟΣ',
  },
  {
    label: '46331300',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΡΩΣΙΜΩΝ ΕΛΑΙΩΝ ΚΑΙ ΛΙΠΩΝ',
  },
  {
    label: '46331301',
    value: 'ΕΞΑΓΩΓΗ ΕΛΑΙΟΛΑΔΟΥ',
  },
  {
    label: '46331302',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΡΩΣΙΜΩΝ ΛΙΠΩΝ',
  },
  {
    label: '46331303',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΟΛΑΔΟΥ',
  },
  {
    label: '46331304',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΩΙΚΩΝ ΕΛΑΙΩΝ ΚΑΙ ΛΙΠΩΝ, ΑΚΑΤΕΡΓΑΣΤΩΝ ΚΑΙ ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΕΚΤΟΣ ΑΠΟ ΛΙΠΗ ΒΟΟΕΙΔΩΝ, ΑΙΓΟΠΡΟΒΑΤΩΝ, ΧΟΙΡΩΝ ΚΑΙ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '46331305',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΩΙΚΩΝ Η ΦΥΤΙΚΩΝ ΛΙΠΩΝ ΚΑΙ ΕΛΑΙΩΝ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥΣ, ΥΔΡΟΓΟΝΩΜΕΝΩΝ, ΕΣΤΕΡΟΠΟΙΗΜΕΝΩΝ, ΑΛΛΑ ΧΩΡΙΣ ΝΑ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΠΕΡΑΙΤΕΡΩ ΠΑΡΑΣΚΕΥΗ',
  },
  {
    label: '46331306',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΑΜΠΟΚΕΛΑΙΟΥ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥ, ΜΗ ΧΗΜΙΚΑ ΤΡΟΠΟΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '46331307',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΙΠΩΝ ΒΟΟΕΙΔΩΝ, ΠΡΟΒΑΤΩΝ, ΑΙΓΩΝ, ΧΟΙΡΩΝ ΚΑΙ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '46331308',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΡΓΑΡΙΝΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ',
  },
  {
    label: '46331309',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΟΓΙΕΛΑΙΟΥ, ΑΡΑΧΙΔΕΛΑΙΟΥ, ΗΛΙΕΛΑΙΟΥ, ΚΑΡΔΑΜΕΛΑΙΟΥ, ΒΑΜΒΑΚΕΛΑΙΟΥ, ΚΡΑΜΒΕΛΑΙΟΥ, ΓΟΓΓΥΛΕΛΑΙΟΥ (COLZA OIL) ΚΑΙ ΣΙΝΑΠΕΛΑΙΟΥ',
  },
  {
    label: '46331310',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΟΙΝΙΚΕΛΑΙΟΥ, ΕΛΑΙΟΥ ΙΝΔΙΚΗΣ ΚΑΡΥΔΑΣ, ΦΟΙΝΙΚΟΠΥΡΗΝΩΝ, BABASSU, ΛΙΝΕΛΑΙΟΥ, ΣΤΑΘΕΡΟΠΟΙΗΜΕΝΩΝ ΦΥΤΙΚΩΝ ΛΙΠΩΝ ΚΑΙ ΕΛΑΙΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΟ ΚΑΛΑΜΠΟΚΕΛΑΙΟ) ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46340000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΤΩΝ',
  },
  {
    label: '46341100',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΥΜΩΝ, ΜΕΤΑΛΛΙΚΩΝ ΝΕΡΩΝ, ΑΝΑΨΥΚΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΜΗ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ',
  },
  {
    label: '46341101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ',
  },
  {
    label: '46341102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΨΥΚΤΙΚΩΝ ΚΑΙ ΕΜΦΙΑΛΩΜΕΝΩΝ ΝΕΡΩΝ',
  },
  {
    label: '46341103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΙΚΩΝ ΝΕΡΩΝ ΚΑΙ ΑΕΡΙΟΥΧΩΝ ΝΕΡΩΝ, ΠΟΥ ΔΕΝ ΕΧΟΥΝ ΓΛΥΚΑΝΘΕΙ Η ΑΡΩΜΑΤΙΣΤΕΙ',
  },
  {
    label: '46341104',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΓΑΚΙΩΝ ΒΡΩΣΙΜΩΝ, ΣΕ ΚΥΒΟΥΣ Η ΝΙΦΑΔΕΣ',
  },
  {
    label: '46341105',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΓΩΜΕΝΟΥ ΤΣΑΓΙΟΥ',
  },
  {
    label: '46341106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΥΜΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '46341200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ',
  },
  {
    label: '46341201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΟΤΩΝ ΠΟΥ ΠΡΟΕΡΧΟΝΤΑΙ ΑΠΟ ΖΥΜΩΣΗ (Π.Χ. ΜΗΛΙΤΗ, ΑΠΙΔΙΤΗ, ΥΔΡΟΜΕΛΙΟΥ), ΜΕΙΓΜΑΤΩΝ ΠΟΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΑΛΚΟΟΛΗ',
  },
  {
    label: '46341202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΣΤΑΓΜΑΤΩΝ, ΗΔΥΠΟΤΩΝ, ΑΛΛΩΝ ΟΙΝΟΠΝΕΥΜΑΤΩΔΩΝ ΠΟΤΩΝ, ΣΥΝΘΕΤΩΝ ΑΛΚΟΟΛΟΥΧΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΠΟΤΩΝ',
  },
  {
    label: '46341203',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΦΡΩΔΟΥΣ ΚΡΑΣΙΟΥ',
  },
  {
    label: '46341204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΕΡΜΟΥΤ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΡΩΜΑΤΙΚΟΥ ΚΡΑΣΙΟΥ ΑΠΟ ΝΩΠΑ ΣΤΑΦΥΛΙΑ',
  },
  {
    label: '46341205',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΑΣΙΟΥ ΑΠΟ ΝΩΠΑ ΣΤΑΦΥΛΙΑ, ΕΚΤΟΣ ΑΠΟ ΤΟ ΑΦΡΩΔΕΣ ΚΡΑΣΙ, ΜΟΥΣΤΟΥ ΣΤΑΦΥΛΙΩΝ',
  },
  {
    label: '46341206',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΠΟΤΩΝ',
  },
  {
    label: '46341207',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΠΙΡΑΣ',
  },
  {
    label: '46350000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΚΑΠΝΟΥ',
  },
  {
    label: '46351001',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΜΕΤΑΠΟΙΗΜΕΝΟΥ ΚΑΠΝΟΥ ΚΑΙ ΥΠΟΚΑΤΑΣΤΑΤΩΝ, ΟΜΟΓΕΝΟΠΟΙΗΜΕΝΟΥ Η ΑΝΑΣΥΣΤΑΜΕΝΟΥ ΚΑΠΝΟΥ, ΕΚΧΥΛΙΣΜΑΤΩΝ ΚΑΙ ΑΠΟΣΤΑΓΜΑΤΩΝ ΚΑΠΝΟΥ',
  },
  {
    label: '46351002',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΥΡΩΝ, ΠΟΥΡΩΝ ΜΕ ΚΟΜΜΕΝΟ ΑΚΡΟ, ΠΟΥΡΑΚΙΩΝ ΚΑΙ ΤΣΙΓΑΡΩΝ, ΑΠΟ ΚΑΠΝΟ Η ΥΠΟΚΑΤΑΣΤΑΤΑ ΤΟΥ ΚΑΠΝΟΥ',
  },
  {
    label: '46351003',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΣΙΓΑΡΟΧΑΡΤΟΥ',
  },
  {
    label: '46360000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΑΧΑΡΗΣ, ΣΟΚΟΛΑΤΑΣ ΚΑΙ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ',
  },
  {
    label: '46361100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΑΧΑΡΗΣ',
  },
  {
    label: '46361101',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΗΣ ΖΑΧΑΡΗΣ ΑΠΟ ΖΑΧΑΡΟΚΑΛΑΜΟ Η ΖΑΧΑΡΟΤΕΥΤΛΑ, ΣΕ ΣΤΕΡΕΑ ΜΟΡΦΗ',
  },
  {
    label: '46361102',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΛΥΚΟΖΗΣ ΚΑΙ ΣΙΡΟΠΙΟΥ ΓΛΥΚΟΖΗΣ, ΦΡΟΥΚΤΟΖΗΣ ΚΑΙ ΣΙΡΟΠΙΟΥ ΦΡΟΥΚΤΟΖΗΣ, ΙΜΒΕΡΤΟΣΑΚΧΑΡΟΥ, ΣΑΚΧΑΡΩΝ ΚΑΙ ΣΙΡΟΠΙΟΥ ΣΑΚΧΑΡΩΝ Π.Δ.Κ.Α., ΤΕΧΝΗΤΟΥ ΜΕΛΙΟΥ ΚΑΙ ΚΑΡΑΜΕΛΑΣ',
  },
  {
    label: '46361103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΑΡΙΣΜΕΝΗΣ ΖΑΧΑΡΗΣ ΚΑΙ ΧΗΜΙΚΑ ΚΑΘΑΡΗΣ ΣΑΚΧΑΡΟΖΗΣ ΣΕ ΣΤΕΡΕΑ ΜΟΡΦΗ, ΖΑΧΑΡΗΣ ΚΑΙ ΣΙΡΟΠΙΟΥ ΣΦΕΝΔΑΜΟΥ ΚΑΙ ΜΕΛΑΣΑΣ',
  },
  {
    label: '46361200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '46361201',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ (ΠΡΑΤΗΡΙΟ) ΨΩΜΙΟΥ ΚΑΙ ΕΙΔΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '46361202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΨΩΜΙΟΥ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '46361203',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΩΝΩΝ ΠΑΓΩΤΟΥ',
  },
  {
    label: '46361204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΛΟΨΩΜΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΓΛΥΚΩΝ ΜΠΙΣΚΟΤΩΝ, ΒΑΦΛΩΝ ΚΑΙ ΛΕΠΤΩΝ ΜΠΙΣΚΟΤΩΝ',
  },
  {
    label: '46361205',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΙΤΩΝ ΚΑΙ ΚΟΥΛΟΥΡΙΩΝ',
  },
  {
    label: '46361206',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΡΑΓΑΝΟΥ ΨΩΜΙΟΥ, ΠΑΞΙΜΑΔΙΩΝ, ΦΡΥΓΑΝΙΣΜΕΝΟΥ ΨΩΜΙΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΦΡΥΓΑΝΙΣΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46361207',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΕΙΔΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '46361208',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΥΡΟΠΙΤΩΝ ΚΑΙ ΣΑΝΤΟΥΙΤΣ',
  },
  {
    label: '46361209',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΡΕΣΚΟΥ ΨΩΜΙΟΥ',
  },
  {
    label: '46361210',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΡΕΣΚΩΝ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ ΚΑΙ ΓΛΥΚΙΣΜΑΤΩΝ',
  },
  {
    label: '46361211',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΛΛΩΝ ΚΡΟΥΣΤΑΣ Η ΚΑΝΤΑΪΦΙΟΥ',
  },
  {
    label: '46361300',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΣΟΚΟΛΑΤΑΣ ΚΑΙ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ',
  },
  {
    label: '46361301',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΜΗΧΑΝΟΠΟΙΗΜΕΝΟΥ ΠΑΓΩΤΟΥ, ΜΕ ΠΡΟΚΑΘΟΡΙΣΜΕΝΗ ΤΙΜΗ ΠΩΛΗΣΗΣ',
  },
  {
    label: '46361302',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ ΓΕΝΙΚΑ',
  },
  {
    label: '46361303',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΓΩΤΟΥ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΒΡΩΣΙΜΟΥ ΠΑΓΟΥ',
  },
  {
    label: '46361304',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΕΤΑΙ Η ΛΕΥΚΗ ΣΟΚΟΛΑΤΑ) ΠΟΥ ΔΕΝ ΠΕΡΙΕΧΟΥΝ ΚΑΚΑΟ',
  },
  {
    label: '46361305',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΟΚΟΛΑΤΑΣ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΚΑΚΑΟ (ΕΚΤΟΣ ΑΠΟ ΖΑΧΑΡΟΥΧΟ ΣΚΟΝΗ ΚΑΚΑΟΥ), ΣΕ ΑΛΛΕΣ ΜΟΡΦΕΣ ΕΚΤΟΣ ΑΠΟ ΧΥΜΑ',
  },
  {
    label: '46361306',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΟΚΟΛΑΤΑΣ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΚΑΚΑΟ (ΕΚΤΟΣ ΑΠΟ ΖΑΧΑΡΟΥΧΟ ΣΚΟΝΗ ΚΑΚΑΟΥ), ΣΕ ΜΟΡΦΕΣ ΧΥΜΑ',
  },
  {
    label: '46361307',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΖΑΧΑΡΩΔΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46361308',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΡΟΥΤΩΝ, ΞΗΡΩΝ ΚΑΡΠΩΝ, ΦΛΟΥΔΑΣ ΦΡΟΥΤΩΝ ΚΑΙ ΑΛΛΩΝ ΜΕΡΩΝ ΦΥΤΩΝ, ΔΙΑΤΗΡΗΜΕΝΩΝ ΜΕ ΖΑΧΑΡΗ',
  },
  {
    label: '46370000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΦΕ, ΤΣΑΓΙΟΥ, ΚΑΚΑΟΥ ΚΑΙ ΜΠΑΧΑΡΙΚΩΝ',
  },
  {
    label: '46371001',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΩΜΑΤΙΚΩΝ ΦΥΤΩΝ',
  },
  {
    label: '46371002',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΦΕΨΗΜΑΤΩΝ ΒΟΤΑΝΩΝ',
  },
  {
    label: '46371003',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΟΥΤΥΡΟΥ, ΛΙΠΟΥΣ ΚΑΙ ΕΛΑΙΟΥ ΚΑΚΑΟΥ',
  },
  {
    label: '46371004',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΚΧΥΛΙΣΜΑΤΩΝ, ΑΠΟΣΤΑΓΜΑΤΩΝ, ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΤΣΑΓΙΟΥ Η ΜΑΤΕ',
  },
  {
    label: '46371005',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΒΟΥΡΔΙΣΜΕΝΟΥ ΚΑΙ ΑΛΕΣΜΕΝΟΥ ΚΑΦΕ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46371006',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΚΑΟΥ ΣΕ ΣΚΟΝΗ, ΠΟΥ ΔΕΝ ΠΕΡΙΕΧΕΙ ΠΡΟΣΘΕΤΗ ΖΑΧΑΡΗ Η ΑΛΛΗ ΓΛΥΚΑΝΤΙΚΗ ΥΛΗ',
  },
  {
    label: '46371007',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΚΑΟΥ ΣΕ ΣΚΟΝΗ, ΠΟΥ ΠΕΡΙΕΧΕΙ ΠΡΟΣΘΕΤΗ ΖΑΧΑΡΗ Η ΑΛΛΗ ΓΛΥΚΑΝΤΙΚΗ ΥΛΗ',
  },
  {
    label: '46371008',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΡΥΚΕΥΜΑΤΩΝ ~ ΜΠΑΧΑΡΙΚΩΝ ΚΑΙ ΛΟΙΠΩΝ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΛΕΣΜΕΝΩΝ ΚΑΙ ΣΥΣΚΕΥΑΣΜΕΝΩΝ',
  },
  {
    label: '46371009',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΦΕ, ΑΠΟΚΑΦΕΪΝΩΜΕΝΟΥ',
  },
  {
    label: '46371010',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΦΕ, ΜΗ ΑΠΟΚΑΦΕΪΝΩΜΕΝΟΥ',
  },
  {
    label: '46371011',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΠΑΧΑΡΙΚΩΝ, ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ',
  },
  {
    label: '46371012',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΠΑΧΑΡΙΚΩΝ, ΜΗ ΚΑΤΕΡΓΑΣΜΕΝΩΝ',
  },
  {
    label: '46371013',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΑΣΙΝΟΥ ΤΣΑΓΙΟΥ (ΜΗ ΖΥΜΩΜΕΝΟΥ), ΜΑΥΡΟΥ ΤΣΑΓΙΟΥ (ΖΥΜΩΜΕΝΟΥ) ΚΑΙ ΕΝ ΜΕΡΕΙ ΖΥΜΩΜΕΝΟΥ ΤΣΑΓΙΟΥ',
  },
  {
    label: '46371014',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΚΑΦΕ',
  },
  {
    label: '46371015',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΤΟΥ ΚΑΦΕ, ΕΚΧΥΛΙΣΜΑΤΩΝ, ΟΥΣΙΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΤΟΥ ΚΑΦΕ Η ΤΩΝ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΤΟΥ ΚΑΦΕ',
  },
  {
    label: '46380000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΤΡΟΦΙΜΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΨΑΡΙΩΝ, ΚΑΡΚΙΝΟΕΙΔΩΝ ΚΑΙ ΜΑΛΑΚΙΩΝ',
  },
  {
    label: '46381000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ, ΚΑΡΚΙΝΟΕΙΔΩΝ ΚΑΙ ΜΑΛΑΚΙΩΝ',
  },
  {
    label: '46381001',
    value: 'ΕΞΑΓΩΓΗ ΕΓΧΩΡΙΩΝ ΝΩΠΩΝ ΨΑΡΙΩΝ',
  },
  {
    label: '46381002',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΑΛΑΚΙΩΝ Η ΟΣΤΡΑΚΟΔΕΡΜΩΝ ΚΑΙ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΖΩΝΤΩΝ, ΝΩΠΩΝ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '46381003',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΨΑΡΙΩΝ, ΖΩΝΤΑΝΩΝ',
  },
  {
    label: '46381004',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΡΚΙΝΟΕΙΔΩΝ ΜΗ ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '46381005',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΡΚΙΝΟΕΙΔΩΝ, ΚΑΤΕΨΥΓΜΕΝΩΝ, ΜΑΛΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΚΑΤΕΨΥΓΜΕΝΩΝ, ΑΠΟΞΗΡΑΜΕΝΩΝ, ΑΛΑΤΙΣΜΕΝΩΝ',
  },
  {
    label: '46381006',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΡΚΙΝΟΕΙΔΩΝ, ΜΑΛΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ',
  },
  {
    label: '46381007',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΕΙΔΙΩΝ',
  },
  {
    label: '46381008',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΕΤΩΝ ΨΑΡΙΩΝ, ΑΛΛΟΥ ΚΡΕΑΤΟΣ ΨΑΡΙΩΝ, ΣΥΚΩΤΙΩΝ ΨΑΡΙΩΝ ΚΑΙ ΑΒΓΟΤΑΡΑΧΟΥ, ΝΩΠΩΝ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '46381009',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ ΑΛΙΠΑΣΤΩΝ',
  },
  {
    label: '46381010',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ ΑΠΟΞΗΡΑΜΕΝΩΝ, ΑΛΑΤΙΣΜΕΝΩΝ Η ΣΕ ΑΛΜΗ, ΚΑΠΝΙΣΤΩΝ ΨΑΡΙΩΝ, ΒΡΩΣΙΜΟΥ ΙΧΘΥΑΛΕΥΡΟΥ',
  },
  {
    label: '46381011',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ, ΧΑΒΙΑΡΙΟΥ',
  },
  {
    label: '46381012',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ, ΖΩΝΤΩΝ',
  },
  {
    label: '46381013',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ, ΝΩΠΩΝ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '46381014',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ, ΝΩΠΩΝ ΚΑΙ ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '46381015',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ, ΦΙΛΕΤΩΝ ΨΑΡΙΩΝ, ΑΛΛΟΥ ΚΡΕΑΤΟΣ ΨΑΡΙΩΝ, ΣΥΚΩΤΙΩΝ ΨΑΡΙΩΝ ΚΑΙ ΑΒΓΟΤΑΡΑΧΟΥ, ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '46382000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '46382100',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΜΟΓΕΝΟΠΟΙΗΜΕΝΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΤΡΟΦΙΜΩΝ ΚΑΙ ΔΙΑΙΤΗΤΙΚΩΝ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '46382101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΙΤΗΤΙΚΩΝ ΤΡΟΦΩΝ',
  },
  {
    label: '46382102',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΔΙΚΩΝ ΤΡΟΦΩΝ ΚΑΙ ΑΛΛΩΝ ΟΜΟΓΕΝΟΠΟΙΗΜΕΝΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '46382103',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΜΠΛΗΡΩΜΑΤΩΝ ΥΓΙΕΙΝΗΣ ΔΙΑΤΡΟΦΗΣ',
  },
  {
    label: '46382900',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΤΡΟΦΙΜΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46382901',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΒΓΩΝ ΧΩΡΙΣ ΤΟ ΚΕΛΥΦΟΣ, ΚΡΟΚΩΝ ΑΒΓΩΝ, ΝΩΠΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ, ΛΕΥΚΩΜΑΤΟΣ ΑΒΓΟΥ',
  },
  {
    label: '46382902',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΑΤΙΟΥ ΕΠΙΤΡΑΠΕΖΙΟΥ',
  },
  {
    label: '46382903',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΕΥΡΙΩΝ ΔΗΜΗΤΡΙΑΚΩΝ, ΣΥΣΚΕΥΑΣΜΕΝΩΝ',
  },
  {
    label: '46382904',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΛΕΥΡΙΩΝ ΔΗΜΗΤΡΙΑΚΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46382905',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΔΗΜΗΤΡΙΑΚΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΟΙ ΝΙΦΑΔΕΣ ΑΡΑΒΟΣΙΤΟΥ)',
  },
  {
    label: '46382906',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΔΙΑΤΡΟΦΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46382907',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΜΑΓΕΙΡΕΥΤΩΝ ΖΥΜΑΡΙΚΩΝ, ΜΗ ΠΑΡΑΓΕΜΙΣΜΕΝΩΝ Η ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ',
  },
  {
    label: '46382908',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΜΥΛΩΝ, ΙΝΟΥΛΙΝΗΣ, ΓΛΟΥΤΕΝΗΣ ΣΙΤΑΡΙΟΥ, ΔΕΞΤΡΙΝΩΝ ΚΑΙ ΑΛΛΩΝ ΤΡΟΠΟΠΟΙΗΜΕΝΩΝ ΑΜΥΛΩΝ',
  },
  {
    label: '46382909',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΦΛΟΙΩΜΕΝΟΥ ΡΥΖΙΟΥ',
  },
  {
    label: '46382910',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΡΩΣΙΜΩΝ ΠΡΟΪΟΝΤΩΝ ΖΩΙΚΗΣ ΠΡΟΕΛΕΥΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46382911',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΥΝΗΣ',
  },
  {
    label: '46382912',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΔΙΑΤΡΟΦΗΣ',
  },
  {
    label: '46382913',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΓΕΙΡΕΜΕΝΩΝ ΖΥΜΑΡΙΚΩΝ, ΠΑΡΑΓΕΜΙΣΜΕΝΩΝ Η ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ, ΚΟΥΣΚΟΥΣ',
  },
  {
    label: '46382914',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΓΙΑΣ (ΕΝΕΡΓΟΥ Η ΑΔΡΑΝΟΥΣ), ΑΛΛΩΝ ΜΟΝΟΚΥΤΤΑΡΩΝ ΜΙΚΡΟΟΡΓΑΝΙΣΜΩΝ, ΝΕΚΡΩΝ, ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΔΙΟΓΚΩΤΙΚΩΝ ΣΚΟΝΩΝ',
  },
  {
    label: '46382915',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΙΓΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΑΡΑΣΚΕΥΗ ΕΙΔΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '46382916',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΙΔΙΟΥ ΚΑΙ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΤΟΥ ΞΙΔΙΟΥ, ΠΟΥ ΛΑΜΒΑΝΟΝΤΑΙ ΑΠΟ ΤΟ ΟΞΙΚΟ ΟΞΥ',
  },
  {
    label: '46382917',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΤΡΟΦΩΝ ΓΙΑ ΚΑΤΟΙΚΙΔΙΑ ΖΩΑ Η ΠΤΗΝΑ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '46382918',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΤΗΝΟΤΡΟΦΩΝ ΓΙΑ ΟΙΚΙΑΚΑ ΠΤΗΝΑ',
  },
  {
    label: '46382919',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΥΖΙΟΥ, ΑΛΕΣΜΕΝΟΥ',
  },
  {
    label: '46382920',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΛΤΣΩΝ, ΑΝΑΜΕΙΚΤΩΝ ΚΑΡΥΚΕΥΜΑΤΩΝ ΚΑΙ ΑΡΤΥΜΑΤΩΝ, ΑΛΕΥΡΙΟΥ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΟΥ ΣΙΝΑΠΙΟΥ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΕΝΗΣ ΜΟΥΣΤΑΡΔΑΣ',
  },
  {
    label: '46382921',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΤΑΛΕΥΡΟΥ Η ΑΛΕΥΡΙΟΥ ΣΜΙΓΑΔΙΟΥ',
  },
  {
    label: '46382922',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΟΥΠΩΝ ΚΑΙ ΖΩΜΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46382923',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΑΠΙΟΚΑΣ ΚΑΙ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΑΠΟ ΑΜΥΛΟ ΣΕ ΜΟΡΦΗ ΝΙΦΑΔΩΝ, ΚΟΚΚΩΝ ΚΛΠ',
  },
  {
    label: '46382924',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΟΥ ΜΕΛΙΟΥ',
  },
  {
    label: '46382925',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΤΙΚΩΝ ΑΛΕΥΡΙΩΝ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΩΝ ΓΙΑ ΑΝΘΡΩΠΙΝΗ ΚΑΤΑΝΑΛΩΣΗ',
  },
  {
    label: '46382926',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΤΙΚΩΝ ΧΥΜΩΝ ΚΑΙ ΕΚΧΥΛΙΣΜΑΤΩΝ, ΠΕΠΤΙΚΩΝ ΟΥΣΙΩΝ, ΒΛΕΝΝΩΔΩΝ ΚΑΙ ΠΗΚΤΙΚΩΝ ΠΑΡΑΓΟΝΤΩΝ',
  },
  {
    label: '46382927',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΟΝΔΡΩΝ (ΜΠΛΙΓΟΥΡΙΟΥ) ΔΗΜΗΤΡΙΑΚΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46382928',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΟΝΔΡΩΝ (ΜΠΛΙΓΟΥΡΙΟΥ), ΧΟΝΔΡΑΛΕΥΡΩΝ ΣΙΤΑΡΙΟΥ',
  },
  {
    label: '46390000',
    value: 'ΜΗ ΕΞΕΙΔΙΚΕΥΜΕΝΟ ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ',
  },
  {
    label: '46391100',
    value: 'ΜΗ ΕΞΕΙΔΙΚΕΥΜΕΝΟ ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΕΨΥΓΜΕΝΩΝ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '46391200',
    value:
      'ΜΗ ΕΞΕΙΔΙΚΕΥΜΕΝΟ ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΚΑΤΕΨΥΓΜΕΝΩΝ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ',
  },
  {
    label: '46391201',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΛΟΓΙΚΩΝ ΤΡΟΦΙΜΩΝ, ΜΗ ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '46410000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46411100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΗΜΑΤΩΝ',
  },
  {
    label: '46411101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΑΜΒΑΚΕΡΩΝ ΝΗΜΑΤΩΝ',
  },
  {
    label: '46411102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΛΛΙΝΩΝ ΝΗΜΑΤΩΝ',
  },
  {
    label: '46411103',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΞΩΤΩΝ ΝΗΜΑΤΩΝ',
  },
  {
    label: '46411104',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΗΜΑΤΩΝ ΑΠΟ ΓΙΟΥΤΑ Η ΑΠΟ ΑΛΛΕΣ ΙΝΕΣ ΑΠΟ ΣΤΕΛΕΧΗ ΦΥΤΩΝ, ΝΗΜΑΤΩΝ ΑΠΟ ΑΛΛΕΣ ΦΥΤΙΚΕΣ ΥΦΑΝΤΙΚΕΣ ΙΝΕΣ ΚΑΙ ΧΑΡΤΙΝΩΝ ΝΗΜΑΤΩΝ',
  },
  {
    label: '46411105',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΗΜΑΤΩΝ ΑΠΟ ΛΙΝΑΡΙ',
  },
  {
    label: '46411106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΗΜΑΤΩΝ ΑΠΟ ΣΥΝΘΕΤΙΚΕΣ ΚΑΙ ΤΕΧΝΗΤΕΣ ΙΝΕΣ',
  },
  {
    label: '46411107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΗΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46411200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '46411201',
    value: 'ΕΞΑΓΩΓΗ ΥΦΑΣΜΑΤΩΝ, ΓΙΑ ΓΥΝΑΙΚΕΙΑ ΡΟΥΧΑ',
  },
  {
    label: '46411202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΕΚΤΩΝ ΥΦΑΣΜΑΤΩΝ Η ΥΦΑΣΜΑΤΩΝ ΚΡΟΣΕ',
  },
  {
    label: '46411203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΣΤΙΚΟΠΟΙΗΜΕΝΩΝ ΥΦΑΣΜΑΤΩΝ, ΕΚΤΟΣ ΑΠΟ ΠΛΕΓΜΑΤΑ ΕΝΙΣΧΥΣΗΣ (ΛΙΝΑ) ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ)',
  },
  {
    label: '46411204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΥΦΑΣΜΑΤΩΝ ΠΟΛΥΤΕΛΕΙΑΣ, ΓΙΑ ΓΥΝΑΙΚΕΙΑ ΡΟΥΧΑ',
  },
  {
    label: '46411205',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΥΦΑΣΜΑΤΩΝ, ΓΙΑ ΑΝΔΡΙΚΑ ΡΟΥΧΑ',
  },
  {
    label: '46411206',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΥΦΑΣΜΑΤΩΝ, ΓΙΑ ΓΥΝΑΙΚΕΙΑ ΡΟΥΧΑ',
  },
  {
    label: '46411207',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΒΑΜΒΑΚΙ',
  },
  {
    label: '46411208',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΤΕΧΝΗΤΕΣ Η ΣΥΝΘΕΤΙΚΕΣ ΑΣΥΝΕΧΕΙΣ ΙΝΕΣ',
  },
  {
    label: '46411209',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΤΕΧΝΗΤΕΣ Η ΣΥΝΘΕΤΙΚΕΣ ΣΥΝΕΧΕΙΣ ΙΝΕΣ',
  },
  {
    label: '46411210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΦΥΤΙΚΕΣ ΙΝΕΣ ΕΚΤΟΣ ΤΟΥ ΒΑΜΒΑΚΙΟΥ',
  },
  {
    label: '46411211',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ ΕΠΙΠΛΩΣΕΩΝ Η ΑΛΛΩΝ ΥΦΑΣΜΑΤΙΝΩΝ ΕΙΔΩΝ ΤΑΠΕΤΣΑΡΙΑΣ',
  },
  {
    label: '46411212',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ ΛΑΪΚΗΣ ΚΑΤΑΝΑΛΩΣΗΣ',
  },
  {
    label: '46411213',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ ΜΕ ΠΕΛΟΣ, ΘΗΛΕΙΩΤΩΝ ΥΦΑΣΜΑΤΩΝ, ΤΕΡΙ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '46411214',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ ΠΟΛΥΤΕΛΕΙΑΣ, ΓΙΑ ΓΥΝΑΙΚΕΙΑ ΡΟΥΧΑ',
  },
  {
    label: '46411215',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ, ΓΙΑ ΑΝΔΡΙΚΑ ΡΟΥΧΑ',
  },
  {
    label: '46411216',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ, ΓΙΑ ΓΥΝΑΙΚΕΙΑ ΡΟΥΧΑ',
  },
  {
    label: '46411300',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΙΝΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ, ΚΟΥΡΤΙΝΩΝ ΚΑΙ ΔΙΑΦΟΡΩΝ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ ΑΠΟ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΑ ΥΛΙΚΑ',
  },
  {
    label: '46411301',
    value: 'ΕΞΑΓΩΓΗ ΚΙΛΙΜΙΩΝ, ΒΕΛΕΝΤΖΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46411302',
    value: 'ΕΞΑΓΩΓΗ ΛΕΥΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46411303',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΤΑΠΟΙΗΜΕΝΩΝ ΕΙΔΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΚΑΙ ΤΩΝ ΠΑΤΡΟΝ',
  },
  {
    label: '46411304',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46411305',
    value:
      "ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΑΤΩΝ ΑΠΟ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ ΚΑΙ ΕΙΔΩΝ ΑΠ' ΑΥΤΕΣ, ΓΙΑ ΧΡΗΣΗ ΑΛΛΗ ΑΠΟ ΦΑΡΜΑΚΕΥΤΙΚΗ",
  },
  {
    label: '46411306',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΧΤΥΩΝ ΜΕ ΚΟΜΠΟΥΣ ΑΠΟ ΣΠΑΓΓΟΥΣ, ΚΟΡΔΟΝΙΩΝ Η ΣΧΟΙΝΙΩΝ, ΕΤΟΙΜΩΝ ΔΙΧΤΥΩΝ ΑΠΟ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ, ΕΙΔΩΝ ΑΠΟ ΝΗΜΑΤΑ, ΛΩΡΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46411307',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΤΕΝΤΟΠΟΙΙΑΣ',
  },
  {
    label: '46411308',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΠΝΟΥ',
  },
  {
    label: '46411309',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΥΜΜΑΤΩΝ ΚΡΕΒΑΤΙΩΝ',
  },
  {
    label: '46411310',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΝΩΝ ΥΦΑΣΜΑΤΙΝΩΝ ΣΑΚΩΝ',
  },
  {
    label: '46411311',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΛΙΜΙΩΝ, ΒΕΛΕΝΤΖΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46411312',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΡΔΟΝΙΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΤΑΙΝΙΩΝ, ΦΙΤΙΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46411313',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΒΕΡΤΩΝ ΚΑΙ ΚΛΙΝΟΣΚΕΠΑΣΜΑΤΩΝ ΤΑΞΙΔΙΟΥ (ΕΚΤΟΣ ΑΠΟ ΗΛΕΚΤΡΙΚΕΣ',
  },
  {
    label: '46411314',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΡΤΙΝΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΟΙ ΠΤΥΧΩΤΕΣ) ΚΑΙ ΕΣΩΤΕΡΙΚΩΝ ΣΤΟΡΙΩΝ, ΓΥΡΩΝ (ΒΟΛΑΝ) ΚΟΥΡΤΙΝΩΝ Η ΚΡΕΒΑΤΙΩΝ',
  },
  {
    label: '46411315',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΕΥΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46411316',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΥΦΑΝΤΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΕΙΔΩΝ ΑΠΟ ΜΗ ΥΦΑΝΤΑ, ΕΚΤΟΣ ΑΠΟ ΕΙΔΗ ΕΝΔΥΣΗΣ',
  },
  {
    label: '46411317',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΥΣΑΜΑΔΩΝ, ΤΕΝΤΩΝ, ΠΕΡΣΙΔΩΝ ΠΑΡΑΘΥΡΩΝ, ΣΚΗΝΩΝ ΤΣΙΡΚΟΥ',
  },
  {
    label: '46411318',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΤΣΕΤΩΝ ΜΠΑΝΙΟΥ ΚΑΙ ΚΟΥΖΙΝΑΣ',
  },
  {
    label: '46411319',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΙΛΗΜΑΤΟΣ (ΤΣΟΧΑΣ), ΕΠΕΝΔΥΜΕΝΟΥ, ΕΠΙΚΑΛΥΜΜΕΝΟΥ Η ΛΑΜΙΝΑΡΙΣΜΕΝΟΥ',
  },
  {
    label: '46411320',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΤΥΠΩΝ (ΠΑΤΡΟΝ) ΓΥΝΑΙΚΕΙΩΝ ΑΜΦΙΕΣΕΩΝ',
  },
  {
    label: '46411321',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΕΝΤΟΝΙΩΝ ΚΑΙ ΜΑΞΙΛΑΡΟΘΗΚΩΝ',
  },
  {
    label: '46411322',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΗΜΑΙΩΝ ΚΑΙ ΛΑΒΑΡΩΝ',
  },
  {
    label: '46411323',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΑΓΓΩΝ, ΚΟΡΔΟΝΙΩΝ, ΣΧΟΙΝΙΩΝ ΚΑΙ ΚΑΛΩΔΙΩΝ, ΑΠΟ ΓΙΟΥΤΑ Η ΑΛΛΕΣ ΥΦΑΝΤΙΚΕΣ ΙΝΕΣ ΑΠΟ ΣΤΕΛΕΧΗ ΦΥΤΩΝ',
  },
  {
    label: '46411324',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΕΝΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46411325',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΟΥΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΚΤΥΩΤΩΝ ΥΦΑΣΜΑΤΩΝ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '46411326',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΡΑΠΕΖΟΜΑΝΤΙΛΩΝ ΚΑΙ ΠΕΤΣΕΤΩΝ ΦΑΓΗΤΟΥ',
  },
  {
    label: '46411327',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΝΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΠΙΤΟΝΕ ΜΕ ΤΟ ΚΟΜΜΑΤΙ',
  },
  {
    label: '46411328',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΙΝΩΝ ΕΙΔΩΝ ΛΑΪΚΗΣ ΤΕΧΝΗΣ',
  },
  {
    label: '46411400',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΙΚΡΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46411401',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΓΚΡΑΦΩΝ, ΣΟΥΣΤΩΝ, ΚΟΠΙΤΣΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΚΟΥΜΠΙΩΝ, ΦΕΡΜΟΥΑΡ',
  },
  {
    label: '46411402',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΕΛΟΝΩΝ ΡΑΨΙΜΑΤΟΣ, ΒΕΛΟΝΩΝ ΠΛΕΞΙΜΑΤΟΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΓΙΑ ΧΡΗΣΗ ΜΕ ΤΟ ΧΕΡΙ',
  },
  {
    label: '46411403',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΑΝΤΕΛΩΝ ΜΕ ΤΟ ΚΟΜΜΑΤΙ, ΣΕ ΛΩΡΙΔΕΣ Η ΣΕ ΔΙΑΚΟΣΜΗΤΙΚΑ ΣΧΕΔΙΑ',
  },
  {
    label: '46411404',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΓΧΩΡΙΩΝ ΚΕΝΤΗΜΑΤΩΝ',
  },
  {
    label: '46411405',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΟΧΕΙΡΩΝ',
  },
  {
    label: '46411406',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΝΤΗΜΑΤΩΝ ΜΕ ΤΟ ΚΟΜΜΑΤΙ, ΣΕ ΛΩΡΙΔΕΣ Η ΣΕ ΔΙΑΚΟΣΜΗΤΙΚΑ ΣΧΕΔΙΑ',
  },
  {
    label: '46411407',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΛΩΣΤΩΝ ΚΑΙ ΚΟΡΔΟΝΙΩΝ ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΚΑΛΥΜΜΕΝΩΝ ΜΕ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ, ΥΦΑΝΤΙΚΟΥ ΝΗΜΑΤΟΣ ΚΑΙ ΛΩΡΙΔΩΝ, ΕΜΠΟΤΙΣΜΕΝΩΝ Η ΚΑΛΥΜΜΕΝΩΝ ΜΕ ΕΛΑΣΤΙΚΟ Η ΠΛΑΣΤΙΚΟ',
  },
  {
    label: '46411408',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΛΩΣΤΩΝ ΚΑΙ ΝΗΜΑΤΩΝ ΡΑΨΙΜΑΤΟΣ',
  },
  {
    label: '46411409',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΛΩΣΤΩΝ ΚΑΙ ΝΗΜΑΤΩΝ ΡΑΨΙΜΑΤΟΣ ΑΠΟ ΤΕΧΝΗΤΕΣ Η ΣΥΝΘΕΤΙΚΕΣ ΣΥΝΕΧΕΙΣ Η ΑΣΥΝΕΧΕΙΣ ΙΝΕΣ',
  },
  {
    label: '46411410',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΜΠΙΩΝ, ΦΙΓΟΥΡΙΝΙΩΝ ΚΑΙ ΠΛΙΣΕΔΩΝ',
  },
  {
    label: '46411411',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΚΕΝΤΗΜΑΤΩΝ',
  },
  {
    label: '46411412',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΤΡΩΝ ΓΙΑ ΚΟΥΜΠΙΑ ΚΑΙ ΑΛΛΩΝ ΜΕΡΩΝ ΚΟΥΜΠΙΩΝ, ΗΜΙΤΕΛΩΝ ΚΟΥΜΠΙΩΝ, ΜΕΡΩΝ ΑΠΟ ΦΕΡΜΟΥΑΡ',
  },
  {
    label: '46411413',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΠΟΜΠΟΝΙΕΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΓΑΜΩΝ ΚΑΙ ΒΑΠΤΙΣΕΩΝ',
  },
  {
    label: '46411414',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΗΜΑΤΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΥΠΟ ΜΟΡΦΗ ΚΟΡΔΟΝΕΤΟΥ, ΝΗΜΑΤΩΝ ΣΕΝΙΛΛΙΑΣ, ΡΑΒΔΩΤΩΝ ΝΗΜΑΤΩΝ ΜΕ ΘΗΛΙΕΣ',
  },
  {
    label: '46411415',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΕΝΩΝ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ, ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΓΑΡΝΙΤΟΥΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46411416',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΝΕΡΓΩΝ ΓΙΑ ΤΟ ΚΕΝΤΗΜΑ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46411417',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΛΙΚΩΝ ΡΑΠΤΙΚΗΣ ΓΕΝΙΚΑ',
  },
  {
    label: '46420000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '46421000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΙΜΑΤΙΣΜΟΥ (ΕΝΔΥΜΑΤΩΝ) ΚΑΙ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '46421100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΙΜΑΤΙΣΜΟΥ (ΕΝΔΥΜΑΤΩΝ)',
  },
  {
    label: '46421101',
    value: 'ΕΞΑΓΩΓΗ ΓΥΝΑΙΚΕΙΩΝ ΕΤΟΙΜΩΝ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΦΟΡΕΜΑΤΩΝ',
  },
  {
    label: '46421102',
    value:
      'ΕΞΑΓΩΓΗ ΜΠΛΟΥΖΩΝ ΓΥΝΑΙΚΕΙΩΝ, ΠΟΥΚΑΜΙΣΩΝ ΑΝΔΡΙΚΩΝ, ΠΙΤΖΑΜΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46421103',
    value: 'ΕΞΑΓΩΓΗ ΠΛΕΚΤΩΝ ΕΝΔΥΜΑΤΩΝ, ΑΠΟ ΚΑΘΕ ΥΛΗ',
  },
  {
    label: '46421104',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ~ ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ ~ ΠΑΙΔΙΚΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '46421105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΘΛΗΤΙΚΩΝ ΡΟΥΧΩΝ, ΣΤΟΛΩΝ ΣΚΙ ΚΑΙ ΜΑΓΙΟ ΚΟΛΥΜΒΗΣΗΣ, ΚΑΙ ΑΛΛΩΝ ΠΑΡΟΜΟΙΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '46421106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΕΞΙΣΦΑΙΡΩΝ ΣΤΟΛΩΝ',
  },
  {
    label: '46421107',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΙΟΥ, ΚΕΦΑΛΟΔΕΣΜΩΝ, ΦΟΔΡΩΝ, ΣΚΕΛΕΤΩΝ ΚΑΠΕΛΩΝ, ΠΛΑΙΣΙΩΝ ΚΑΠΕΛΩΝ, ΓΕΙΣΩΝ ΚΑΙ ΥΠΟΣΙΑΓΩΝΩΝ, ΓΙΑ ΚΑΛΥΜΜΑΤΑ ΚΕΦΑΛΙΟΥ',
  },
  {
    label: '46421108',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΝΔΥΜΑΤΩΝ ΕΡΓΑΣΙΑΣ',
  },
  {
    label: '46421109',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΔΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ ΓΙΑ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '46421110',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΔΡΙΚΩΝ Η ΑΓΟΡΙΣΤΙΚΩΝ ΚΟΝΤΟΜΑΝΙΚΩΝ ΑΘΛΗΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΦΑΝΕΛΑΚΙΩΝ, ΣΩΒΡΑΚΩΝ, ΣΛΙΠ, ΠΙΤΖΑΜΩΝ ΚΑΙ ΡΟΜΠΩΝ',
  },
  {
    label: '46421111',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΔΡΙΚΩΝ Η ΑΓΟΡΙΣΤΙΚΩΝ ΚΟΣΤΟΥΜΙΩΝ, ΣΥΝΟΛΩΝ, ΣΑΚΑΚΙΩΝ, ΜΠΛΕΙΖΕΡ, ΠΑΝΤΕΛΟΝΙΩΝ, ΦΟΡΜΩΝ ΜΕ ΜΠΟΥΣΤΟ ΚΑΙ ΜΕ ΤΙΡΑΝΤΕΣ, ΒΕΡΜΟΥΔΩΝ ΚΑΙ ΣΟΡΤΣ',
  },
  {
    label: '46421112',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΔΡΙΚΩΝ Η ΑΓΟΡΙΣΤΙΚΩΝ ΠΑΛΤΩΝ, ΗΜΙΠΑΛΤΩΝ, ΚΑΠΩΝ, ΕΠΕΝΔΥΤΩΝ, ΑΝΟΡΑΚ, ΑΔΙΑΒΡΟΧΩΝ, ΑΝΤΙΑΝΕΜΙΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46421113',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΔΡΙΚΩΝ Η ΑΓΟΡΙΣΤΙΚΩΝ ΠΟΥΚΑΜΙΣΩΝ',
  },
  {
    label: '46421114',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΔΡΙΚΩΝ ΠΟΥΚΑΜΙΣΩΝ, ΠΙΤΖΑΜΩΝ, ΜΠΛΟΥΖΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46421115',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΡΕΦΙΚΩΝ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ',
  },
  {
    label: '46421116',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΑΝΤΙΩΝ, ΓΑΝΤΙΩΝ ΧΩΡΙΣ ΔΑΚΤΥΛΑ',
  },
  {
    label: '46421117',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ ΕΝΔΥΜΑΤΩΝ ΓΙΑ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '46421118',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ ΕΣΩΡΟΥΧΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '46421119',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ ΖΩΝΩΝ',
  },
  {
    label: '46421120',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ Η ΚΟΡΙΤΣΙΣΤΙΚΩΝ ΑΘΛΗΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΦΑΝΕΛΑΚΙΩΝ, ΚΟΜΠΙΝΕΖΟΝ, ΜΕΣΟΦΟΡΙΩΝ, ΚΙΛΟΤΩΝ, ΝΥΧΤΙΚΩΝ, ΜΠΟΥΡΝΟΥΖΙΩΝ, ΡΟΜΠΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46421121',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ Η ΚΟΡΙΤΣΙΣΤΙΚΩΝ ΚΟΣΤΟΥΜΙΩΝ, ΣΥΝΟΛΩΝ, ΣΑΚΑΚΙΩΝ, ΦΟΡΕΜΑΤΩΝ, ΦΟΥΣΤΩΝ, ΠΑΝΤΕΛΟΝΙΩΝ, ΦΟΡΜΩΝ ΜΕ ΜΠΟΥΣΤΟ ΚΑΙ ΜΕ ΤΙΡΑΝΤΕΣ, ΒΕΡΜΟΥΔΩΝ ΚΑΙ ΣΟΡΤΣ',
  },
  {
    label: '46421122',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ Η ΚΟΡΙΤΣΙΣΤΙΚΩΝ ΜΠΛΟΥΖΩΝ, ΠΟΥΚΑΜΙΣΩΝ ΚΑΙ ΣΕΜΙΖΙΕ',
  },
  {
    label: '46421123',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ Η ΚΟΡΙΤΣΙΣΤΙΚΩΝ ΠΑΛΤΩΝ, ΗΜΙΠΑΛΤΩΝ, ΚΑΠΩΝ, ΕΠΕΝΔΥΤΩΝ, ΑΝΟΡΑΚ, ΑΔΙΑΒΡΟΧΩΝ, ΑΝΤΙΑΝΕΜΙΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46421124',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ ΚΑΠΕΛΩΝ',
  },
  {
    label: '46421125',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ ΣΤΗΘΟΔΕΣΜΩΝ, ΖΩΝΩΝ ΕΣΩΡΟΥΧΩΝ, ΚΟΡΣΕΔΩΝ, ΛΑΣΤΕΞ, ΝΥΧΤΙΚΩΝ, ΡΟΜΠΩΝ ΤΙΡΑΝΤΩΝ, ΖΑΡΤΙΕΡΩΝ, ΚΑΛΤΣΟΔΕΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46421126',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΙΝΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '46421127',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΨΑΣΜΕΝΩΝ Η ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΓΟΥΝΟΔΕΡΜΑΤΩΝ',
  },
  {
    label: '46421128',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΕΝΔΥΣΗΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ, ΕΚΤΟΣ ΤΟΥ ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ',
  },
  {
    label: '46421129',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΕΝΔΥΣΗΣ, ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΓΟΥΝΟΔΕΡΜΑ (ΕΚΤΟΣ ΑΠΟ ΚΑΛΥΜΜΑΤΑ ΚΕΦΑΛΙΟΥ)',
  },
  {
    label: '46421130',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΕΣΩΤΕΡΙΚΗΣ ΕΝΔΥΣΗΣ, ΑΠΟ ΧΑΡΤΙ Η ΚΥΤΤΑΡΙΝΗ',
  },
  {
    label: '46421131',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΝΔΥΜΑΤΩΝ ΑΠΟ ΠΙΛΗΜΑ (ΤΣΟΧΑ) Η ΜΗ ΥΦΑΝΤΩΝ, ΥΦΑΝΤΙΚΩΝ ΥΛΩΝ ΕΜΠΟΤΙΣΜΕΝΩΝ Η ΕΠΕΝΔΥΜΕΝΩΝ',
  },
  {
    label: '46421132',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΝΔΥΜΑΤΩΝ ΑΠΟ ΠΛΑΣΤΙΚΟ',
  },
  {
    label: '46421133',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΝΔΥΜΑΤΩΝ ΑΣΦΑΛΕΙΑΣ ΕΡΓΑΖΟΜΕΝΩΝ',
  },
  {
    label: '46421134',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΙΜΑΤΙΣΜΟΥ ΓΙΑ ΤΗΝ ΑΣΦΑΛΕΙΑ ΕΡΓΑΖΟΜΕΝΩΝ',
  },
  {
    label: '46421135',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΓΑΝΤΙΑ) ΑΠΟ ΠΛΑΣΤΙΚΟ',
  },
  {
    label: '46421136',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ ΑΠΟ ΓΟΥΝΟΔΕΡΜΑ (ΕΚΤΟΣ ΑΠΟ ΚΑΛΥΜΜΑΤΑ ΚΕΦΑΛΙΟΥ)',
  },
  {
    label: '46421137',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ ΑΠΟ ΔΕΡΜΑ Η ΣΥΝΘΕΣΗ ΔΕΡΜΑΤΟΣ',
  },
  {
    label: '46421138',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ, ΑΠΟ ΧΑΡΤΟΠΟΛΤΟ, ΧΑΡΤΙ, ΧΑΡΤΟΒΑΜΒΑΚΑ Η ΡΟΛΑ ΙΝΩΝ ΚΥΤΤΑΡΙΝΗΣ',
  },
  {
    label: '46421139',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΩΝΩΝ ΑΠΟ ΔΕΡΜΑ Η ΑΠΟ ΑΛΛΗ ΥΛΗ',
  },
  {
    label: '46421140',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΜΙΕΤΟΙΜΩΝ ΓΟΥΝΑΡΙΚΩΝ',
  },
  {
    label: '46421141',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΗΣ ΑΣΦΑΛΕΙΑΣ, ΚΑΠΕΛΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΗΣ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ Η ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46421142',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΠΕΛΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '46421143',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΠΕΛΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΙΟΥ, ΦΟΡΜΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΦΙΛΕΔΩΝ ΜΑΛΛΙΩΝ',
  },
  {
    label: '46421144',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΛΑΝ, ΚΑΛΣΟΝ, ΜΑΚΡΙΩΝ ΚΑΙ ΚΟΝΤΩΝ ΚΑΛΤΣΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΚΑΛΤΣΟΠΟΙΙΑΣ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '46421145',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΝΤΟΜΑΝΙΚΩΝ ΦΑΝΕΛΑΚΙΩΝ',
  },
  {
    label: '46421146',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΑΝΩΝ ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ ΚΑΙ ΠΟΔΗΛΑΤΑ',
  },
  {
    label: '46421147',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΝΤΙΛΙΩΝ, ΣΑΛΙΩΝ, ΓΡΑΒΑΤΩΝ, ΓΑΝΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ, ΜΕΡΩΝ ΕΝΔΥΜΑΤΩΝ Η ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ, ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46421148',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΓΑΝΤΙΩΝ ΠΡΟΣΤΑΣΙΑΣ ΕΡΓΑΤΩΝ',
  },
  {
    label: '46421149',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΓΥΝΑΙΚΕΙΩΝ ΚΑΛΤΣΩΝ ΑΠΟ ΚΑΘΕ ΥΛΗ',
  },
  {
    label: '46421150',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΕΤΟΙΜΩΝ ΑΝΔΡΙΚΩΝ ΚΑΙ ΓΥΝΑΙΚΕΙΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '46421151',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΥΦΙΚΩΝ ΚΑΙ ΒΑΠΤΙΣΤΙΚΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '46421152',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΜΠΡΕΛΩΝ',
  },
  {
    label: '46421153',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΜΠΡΕΛΩΝ, ΜΠΑΣΤΟΥΝΙΩΝ, ΡΑΒΔΩΝ;ΚΑΘΙΣΜΑΤΩΝ',
  },
  {
    label: '46421154',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΣΤΙΚΩΝ ΕΝΔΥΜΑΤΩΝ, ΟΠΩΣ ΔΥΤΩΝ',
  },
  {
    label: '46421155',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ ΓΟΥΝΩΝ ΚΑΙ ΕΙΔΩΝ ΑΠΟ ΤΕΧΝΗΤΗ ΓΟΥΝΑ',
  },
  {
    label: '46421156',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΑΝΕΛΩΝ ΖΕΡΣΕΪ, ΠΟΥΛΟΒΕΡ, ΖΑΚΕΤΩΝ, ΓΙΛΕΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '46421157',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΝΩΝ ΕΙΔΩΝ ΕΝΔΥΣΗΣ ΝΟΣΟΚΟΜΕΙΩΝ ΜΙΑΣ ΧΡΗΣΕΩΣ (ΚΑΠΕΛΩΝ, ΜΠΛΟΥΖΩΝ ΚΑΙ ΣΧΕΤΙΚΩΝ ΕΙΔΩΝ)',
  },
  {
    label: '46421158',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΟΝΔΡΑΔΩΝ (ΑΠΟΚΟΜΜΑΤΩΝ) ΓΟΥΝΑΡΙΚΩΝ',
  },
  {
    label: '46421200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '46421201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΔΙΑΒΡΟΧΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΜΕ ΕΞΩΤΕΡΙΚΕΣ ΣΟΛΕΣ ΚΑΙ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΚΑΟΥΤΣΟΥΚ Η ΠΛΑΣΤΙΚΟ',
  },
  {
    label: '46421202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΔΙΑΒΡΟΧΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΜΕ ΕΞΩΤΕΡΙΚΕΣ ΣΟΛΕΣ ΚΑΙ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΚΑΟΥΤΣΟΥΚ Η ΠΛΑΣΤΙΚΟ, ΓΙΑ ΣΠΟΡ',
  },
  {
    label: '46421203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΘΛΗΤΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΕΚΤΟΣ ΑΠΟ ΜΠΟΤΕΣ ΤΟΥ ΠΑΤΙΝΑΖ',
  },
  {
    label: '46421204',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΠΟΔΗΜΑΤΟΠΟΙΙΑΣ',
  },
  {
    label: '46421205',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '46421206',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΔΙΑΦΟΡΩΝ ΕΙΔΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΥΠΟΔΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46421207',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ ΜΕ ΕΞΩΤΕΡΙΚΕΣ ΣΟΛΕΣ ΚΑΙ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΚΑΟΥΤΣΟΥΚ Η ΠΛΑΣΤΙΚΟ',
  },
  {
    label: '46421208',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΔΕΡΜΑ',
  },
  {
    label: '46421209',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ, ΕΚΤΟΣ ΤΩΝ ΑΘΛΗΤΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '46421210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ ΠΟΥ ΕΧΟΥΝ ΕΝΣΩΜΑΤΩΜΕΝΑ ΠΡΟΣΤΑΤΕΥΤΙΚΑ ΜΕΤΑΛΛΙΚΑ ΨΙΔΙΑ',
  },
  {
    label: '46421211',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ ΠΡΟΠΟΝΗΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΠΟΔΗΜΑΤΩΝ ΜΕ ΕΛΑΣΤΙΚΕΣ Η ΠΛΑΣΤΙΚΕΣ ΣΟΛΕΣ ΚΑΙ ΜΕ ΥΦΑΣΜΑΤΙΝΑ ΕΠΑΝΩ ΜΕΡΗ',
  },
  {
    label: '46430000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46431100',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ, ΕΚΤΟΣ ΡΑΔΙΟΦΩΝΙΚΩΝ, ΤΗΛΕΟΠΤΙΚΩΝ ΚΑΙ ΦΩΤΟΓΡΑΦΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46431101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΗΛΕΚΤΡΟΘΕΡΜΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46431102',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΦΟΥΡΝΩΝ, ΚΟΥΖΙΝΩΝ, ΠΛΑΚΩΝ (ΜΑΤΙΩΝ) ΜΑΓΕΙΡΕΜΑΤΟΣ, ΚΑΜΙΝΕΤΩΝ, ΣΧΑΡΩΝ ΜΑΓΕΙΡΕΜΑΤΟΣ, ΨΗΣΤΙΕΡΩΝ',
  },
  {
    label: '46431103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΕΜΙΣΤΗΡΩΝ ΚΑΙ ΑΠΟΡΡΟΦΗΤΗΡΩΝ ΕΞΑΓΩΓΗΣ Η ΑΝΑΚΥΚΛΩΣΗΣ ΤΟΥ ΑΕΡΑ, ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '46431104',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΘΕΡΜΑΝΤΗΡΩΝ ΝΕΡΟΥ, ΣΤΙΓΜΙΑΙΩΝ Η ΘΕΡΜΟΣΥΣΣΩΡΕΥΣΗΣ ΚΑΙ ΘΕΡΜΑΝΤΗΡΩΝ ΕΜΒΑΠΤΙΣΗΣ',
  },
  {
    label: '46431105',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΘΕΡΜΑΝΤΙΚΩΝ ΑΝΤΙΣΤΑΣΕΩΝ',
  },
  {
    label: '46431106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΚΟΥΒΕΡΤΩΝ',
  },
  {
    label: '46431107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΞΥΡΙΣΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '46431108',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΝΑΓΕΡΜΩΝ ΔΙΑΡΡΗΞΗΣ Η ΦΩΤΙΑΣ, ΑΚΟΥΣΤΙΚΗΣ Η ΟΠΤΙΚΗΣ ΣΗΜΑΤΟΔΟΤΗΣΗΣ',
  },
  {
    label: '46431109',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΘΕΡΜΑΝΣΗΣ ΚΛΕΙΣΤΩΝ ΧΩΡΩΝ ΚΑΙ ΕΔΑΦΟΥΣ',
  },
  {
    label: '46431110',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΘΕΡΜΙΚΩΝ ΣΥΣΚΕΥΩΝ ΚΟΜΜΩΤΙΚΗΣ Η ΣΤΕΓΝΩΤΗΡΩΝ ΧΕΡΙΩΝ, ΗΛΕΚΤΡΙΚΩΝ ΣΙΔΕΡΩΝ',
  },
  {
    label: '46431111',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΜΗΧΑΝΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ, ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΟ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '46431112',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΟΥ ΟΙΚΙΑΚΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΗΛΕΚΤΡΙΚΩΝ ΜΕΡΩΝ ΟΙΚΙΑΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Η ΣΥΣΚΕΥΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46431113',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46431114',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΟΙΚΙΑΚΩΝ ΠΛΥΝΤΗΡΙΩΝ ΠΙΑΤΩΝ',
  },
  {
    label: '46431115',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46431116',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΟ ΣΙΔΕΡΩΜΑ, ΤΟ ΠΡΕΣΑΡΙΣΜΑ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΠΡΕΣΩΝ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '46431117',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΡΙΣΤΙΚΩΝ ΚΑΙ ΚΟΥΡΕΥΤΙΚΩΝ ΜΗΧΑΝΩΝ, ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΟ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '46431118',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΥΝΤΗΡΙΩΝ ΠΙΑΤΩΝ, ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '46431119',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΥΝΤΗΡΙΩΝ ΡΟΥΧΩΝ ΚΑΙ ΣΤΕΓΝΩΤΗΡΙΩΝ ΡΟΥΧΩΝ, ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '46431120',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΟΥΡΝΩΝ ΜΙΚΡΟΚΥΜΑΤΩΝ',
  },
  {
    label: '46431121',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΥΓΕΙΩΝ ΚΑΙ ΚΑΤΑΨΥΚΤΩΝ, ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '46431200',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΑΔΙΟΦΩΝΙΚΟΥ ΚΑΙ ΤΗΛΕΟΠΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΚΑΘΩΣ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΒΙΝΤΕΟ ΚΑΙ DVD',
  },
  {
    label: '46431201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΔΕΚΤΩΝ ΡΑΔΙΟΦΩΝΟΥ Η ΤΗΛΕΟΡΑΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46431202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΚΤΩΝ ΡΑΔΙΟΦΩΝΙΚΗΣ ΜΕΤΑΔΟΣΗΣ',
  },
  {
    label: '46431203',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΡΥΦΟΡΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ (ΚΕΡΑΙΩΝ, ΑΝΑΚΛΑΣΤΗΡΩΝ)',
  },
  {
    label: '46431204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΕΝΙΣΧΥΤΩΝ ΑΚΟΥΣΤΙΚΗΣ ΣΥΧΝΟΤΗΤΑΣ, ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ ΕΝΙΣΧΥΣΗΣ ΗΧΟΥ',
  },
  {
    label: '46431205',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗΝ ΕΝΣΥΡΜΑΤΗ ΤΗΛΕΦΩΝΙΑ Η ΤΗΝ ΕΝΣΥΡΜΑΤΗ ΤΗΛΕΓΡΑΦΙΑ',
  },
  {
    label: '46431206',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΙΩΝ ΚΑΙ ΑΝΑΚΛΑΣΤΗΡΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΜΕΡΩΝ ΡΑΔΙΟΦΩΝΙΚΩΝ ΔΕΚΤΩΝ ΚΑΙ ΠΟΜΠΩΝ, ΜΕΡΩΝ ΕΞΟΠΛΙΣΜΟΥ ΡΑΝΤΑΡ, ΟΧΙ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '46431207',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΓΝΗΤΟΦΩΝΩΝ ΚΑΙ ΑΛΛΩΝ ΣΥΣΚΕΥΩΝ ΕΓΓΡΑΦΗΣ ΗΧΟΥ',
  },
  {
    label: '46431208',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΓΑΦΩΝΩΝ, ΑΚΟΥΣΤΙΚΩΝ ΚΕΦΑΛΗΣ, ΑΚΟΥΣΤΙΚΩΝ ΚΑΙ ΣΥΝΔΥΑΣΜΩΝ ΜΙΚΡΟΦΩΝΩΝ ΚΑΙ ΑΚΟΥΣΤΙΚΩΝ',
  },
  {
    label: '46431209',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΞΟΠΛΙΣΜΟΥ ΕΓΓΡΑΦΗΣ Η ΑΝΑΠΑΡΑΓΩΓΗΣ ΗΧΟΥ ΚΑΙ ΕΙΚΟΝΑΣ',
  },
  {
    label: '46431210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΔΕΚΤΩΝ ΤΗΛΕΟΡΑΣΗΣ, ΡΑΔΙΟΦΩΝΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46431211',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΙΚΡΟΦΩΝΩΝ ΚΑΙ ΥΠΟΣΤΗΡΙΓΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46431212',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΕΓΓΡΑΦΗΣ Η ΑΝΑΠΑΡΑΓΩΓΗΣ ΕΙΚΟΝΑΣ',
  },
  {
    label: '46431213',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΤΗΜΑΤΩΝ ΔΟΡΥΦΟΡΙΚΩΝ ΛΗΨΕΩΝ',
  },
  {
    label: '46431214',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΤΗΜΑΤΩΝ ΠΕΡΙΣΤΡΟΦΗΣ ΔΙΣΚΩΝ, ΠΙΚΑΠ, ΚΑΣΕΤΟΦΩΝΩΝ ΚΑΙ ΑΛΛΩΝ ΣΥΣΚΕΥΩΝ ΑΝΑΠΑΡΑΓΩΓΗΣ ΗΧΟΥ',
  },
  {
    label: '46431215',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΗΛΕΟΠΤΙΚΩΝ ΔΕΚΤΩΝ',
  },
  {
    label: '46431216',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΗΛΕΟΠΤΙΚΩΝ ΜΗΧΑΝΩΝ ΛΗΨΗΣ',
  },
  {
    label: '46431300',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΣΚΩΝ ΓΡΑΜΜΟΦΩΝΟΥ, ΚΑΣΕΤΩΝ ΚΑΙ ΜΑΓΝΗΤΟΤΑΙΝΙΩΝ, ΣΥΜΠΥΚΝΩΝ ΔΙΣΚΩΝ (CD) ΚΑΙ ΔΙΣΚΩΝ DVD (ΕΚΤΟΣ ΚΕΝΩΝ ΚΑΣΕΤΩΝ)',
  },
  {
    label: '46431301',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΣΚΩΝ, ΟΠΤΙΚΩΝ ΔΙΣΚΩΝ ΚΑΙ ΚΑΣΕΤΩΝ ΔΙΔΑΣΚΑΛΙΑΣ ΞΕΝΩΝ ΓΛΩΣΣΩΝ',
  },
  {
    label: '46431302',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΓΓΕΓΡΑΜΜΕΝΩΝ ΜΟΥΣΙΚΩΝ ΔΙΣΚΩΝ, ΟΠΤΙΚΩΝ ΔΙΣΚΩΝ (CDS, DVDS ΚΛΠ) ΚΑΙ',
  },
  {
    label: '46431303',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΓΝΗΤΙΚΩΝ ΤΑΙΝΙΩΝ ΕΓΓΡΑΦΗΣ ΗΧΟΥ',
  },
  {
    label: '46431304',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΓΝΗΤΙΚΩΝ ΤΑΙΝΙΩΝ ΜΕ ΠΕΡΙΕΧΟΜΕΝΟ ΗΧΟ ΚΑΙ ΕΙΚΟΝΑ',
  },
  {
    label: '46431305',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΕΓΓΕΓΡΑΜΜΕΝΩΝ ΜΟΥΣΙΚΩΝ ΔΙΣΚΩΝ, ΟΠΤΙΚΩΝ ΔΙΣΚΩΝ (CDS, DVDS ΚΛΠ) ΚΑΙ ΚΑΣΕΤΩΝ',
  },
  {
    label: '46431400',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΩΝ ΚΑΙ ΟΠΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46431401',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΓΝΩΣΤΩΝ ΜΙΚΡΟΦΙΛΜ, ΜΙΚΡΟΦΩΤΟΔΕΛΤΙΩΝ Η ΑΛΛΩΝ ΜΙΚΡΟΦΟΡΜΩΝ',
  },
  {
    label: '46431402',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΙΚΕΙΜΕΝΙΚΩΝ ΦΑΚΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΕΣ ΜΗΧΑΝΕΣ, ΜΗΧΑΝΕΣ ΠΡΟΒΟΛΗΣ Η ΦΩΤΟΓΡΑΦΙΚΕΣ ΣΥΣΚΕΥΕΣ ΜΕΓΕΘΥΝΣΗΣ Η ΣΜΙΚΡΥΝΣΗΣ',
  },
  {
    label: '46431403',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΥΑΙΣΘΗΤΟΠΟΙΗΜΕΝΩΝ ΓΑΛΑΚΤΩΜΑΤΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΗ ΧΡΗΣΗ, ΧΗΜΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΗ ΧΡΗΣΗ Π.Δ.Κ.Α.',
  },
  {
    label: '46431404',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΑΛΙΩΝ, ΜΟΝΟΚΙΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΟΠΤΙΚΩΝ ΤΗΛΕΣΚΟΠΙΩΝ, ΑΛΛΩΝ ΑΣΤΡΟΝΟΜΙΚΩΝ ΟΡΓΑΝΩΝ, ΟΠΤΙΚΩΝ ΜΙΚΡΟΣΚΟΠΙΩΝ',
  },
  {
    label: '46431405',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΛΗΨΗΣ',
  },
  {
    label: '46431406',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΠΡΟΒΟΛΗΣ, ΕΠΙΔΙΑΣΚΟΠΙΩΝ, ΑΛΛΩΝ ΠΡΟΒΟΛΕΩΝ ΕΙΚΟΝΩΝ',
  },
  {
    label: '46431407',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΤΟΓΥΑΛΙΩΝ ΜΗ ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΟΠΤΙΚΩΣ, ΜΕΡΩΝ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΤΕΤΟΙΩΝ ΓΥΑΛΙΩΝ',
  },
  {
    label: '46431408',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΤΟΓΥΑΛΙΩΝ, ΜΑΤΟΓΥΑΛΙΩΝ ΗΛΙΟΥ ΚΑΙ ΠΡΟΦΥΛΑΞΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΔΙΟΡΘΩΤΙΚΩΝ, ΠΡΟΣΤΑΤΕΥΤΙΚΩΝ Η ΑΛΛΩΝ',
  },
  {
    label: '46431409',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΛΛΩΝ ΟΠΤΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '46431410',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΦΩΤΟΓΡΑΦΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46431411',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΣΚΕΛΕΤΩΝ ΚΑΙ ΥΠΟΣΤΗΡΙΓΜΑΤΩΝ ΜΑΤΟΓΥΑΛΙΩΝ, ΜΑΤΟΓΥΑΛΙΩΝ ΗΛΙΟΥ ΚΑΙ ΠΡΟΦΥΛΑΞΗΣ Η ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46431412',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΠΤΙΚΩΝ ΙΝΩΝ, ΦΥΛΛΩΝ, ΠΛΑΚΩΝ ΑΠΟ ΠΟΛΩΤΙΚΟ ΥΛΙΚΟ, ΦΑΚΩΝ, ΦΙΛΤΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46431413',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΕΛΕΤΩΝ ΚΑΙ ΥΠΟΣΤΗΡΙΓΜΑΤΩΝ ΜΑΤΟΓΥΑΛΙΩΝ, ΜΑΤΟΓΥΑΛΙΩΝ ΗΛΙΟΥ ΚΑΙ ΠΡΟΦΥΛΑΞΗΣ Η ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46431414',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΜΕ ΥΓΡΟΥΣ ΚΡΥΣΤΑΛΛΟΥΣ, ΛΕΙΖΕΡ ΕΚΤΟΣ ΤΩΝ ΔΙΟΔΩΝ ΛΕΙΖΕΡ',
  },
  {
    label: '46431415',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΑΚΩΝ ΕΠΑΦΗΣ, ΦΑΚΩΝ ΜΑΤΟΓΥΑΛΙΩΝ ΑΠΟ ΓΥΑΛΙ, ΦΑΚΩΝ ΜΑΤΟΓΥΑΛΙΩΝ ΑΠΟ ΑΛΛΑ ΥΛΙΚΑ',
  },
  {
    label: '46431416',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΛΑΣ, ΦΩΤΟΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ ΜΕΓΕΘΥΝΣΗΣ, ΣΥΣΚΕΥΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΑ ΕΡΓΑΣΤΗΡΙΑ, ΝΕΓΚΑΤΟΣΚΟΠΙΩΝ, ΟΘΟΝΩΝ ΠΡΟΒΟΛΗΣ',
  },
  {
    label: '46431417',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΩΝ ΚΑΙ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46431418',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΩΝ ΛΥΧΝΙΩΝ ΦΛΑΣ, \\ΚΥΒΩΝ\\ ΦΛΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46431419',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '46431420',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΠΡΟΕΤΟΙΜΑΣΙΑ ΕΚΤΥΠΩΤΙΚΩΝ ΠΛΑΚΩΝ Η ΚΥΛΙΝΔΡΩΝ, ΦΩΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΓΙΑ ΕΓΓΡΑΦΗ ΕΓΓΡΑΦΩΝ ΣΕ ΜΙΚΡΟΦΙΛΜ, ΜΙΚΡΟΦΩΤΟΔΕΛΤΙΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ',
  },
  {
    label: '46431421',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΩΝ ΠΛΑΚΩΝ ΚΑΙ ΦΙΛΜ, ΦΙΛΜ ΣΤΙΓΜΙΑΙΑΣ ΕΚΤΥΠΩΣΗΣ, ΕΥΑΙΣΘΗΤΟΠΟΙΗΜΕΝΩΝ, ΜΗ ΕΚΤΕΘΕΙΜΕΝΩΝ, ΦΩΤΟΓΡΑΦΙΚΟΥ ΧΑΡΤΙΟΥ',
  },
  {
    label: '46440000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΠΟΡΣΕΛΑΝΗΣ ΚΑΙ ΓΥΑΛΙΚΩΝ ΚΑΙ ΥΛΙΚΩΝ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '46441100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΚΩΝ, ΕΙΔΩΝ ΠΟΡΣΕΛΑΝΗΣ ΚΑΙ ΑΓΓΕΙΟΠΛΑΣΤΙΚΗΣ',
  },
  {
    label: '46441101',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΓΑΛΜΑΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46441102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46441103',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΝΩΝ ΕΙΔΩΝ ΕΜΦΙΑΛΩΣΗΣ ΥΓΡΩΝ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '46441104',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΝΩΝ ΕΙΔΩΝ, ΕΠΙΤΡΑΠΕΖΙΩΝ Η ΜΑΓΕΙΡΙΚΩΝ, ΚΑΛΛΩΠΙΣΜΟΥ, ΓΡΑΦΕΙΟΥ, ΕΣΩΤΕΡΙΚΗΣ ΔΙΑΚΟΣΜΗΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ',
  },
  {
    label: '46441105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΝΩΝ, ΠΟΡΣΕΛΑΝΙΝΩΝ Η ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΛΑΪΚΗΣ ΤΕΧΝΗΣ',
  },
  {
    label: '46441106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΑΠΟ ΓΥΑΛΙ Π.Δ.Κ.Α.',
  },
  {
    label: '46441107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΑΠΟ ΓΥΑΛΙ, ΚΡΥΣΤΑΛΛΟ ΚΑΙ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '46441108',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΛΑΪΚΗΣ ΤΕΧΝΗΣ',
  },
  {
    label: '46441109',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΝΥΔΡΕΙΩΝ ΨΑΡΙΩΝ',
  },
  {
    label: '46441110',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΚΕΥΩΝ, ΜΑΓΕΙΡΙΚΩΝ ΣΚΕΥΩΝ, ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ (ΕΚΤΟΣ ΑΠΟ ΠΟΡΣΕΛΑΝΗ)',
  },
  {
    label: '46441111',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΚΕΥΩΝ, ΜΑΓΕΙΡΙΚΩΝ ΣΚΕΥΩΝ, ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ ΑΠΟ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '46441112',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΠΟΥΚΑΛΙΩΝ, ΑΜΠΟΥΛΩΝ, ΠΛΑΤΥΣΤΟΜΩΝ ΔΟΧΕΙΩΝ, ΦΙΑΛΙΔΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΟΧΕΙΩΝ, ΑΠΟ ΓΥΑΛΙ',
  },
  {
    label: '46441113',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΗΛΙΝΩΝ ΑΓΓΕΙΩΝ ΓΕΝΙΚΑ ΧΩΡΙΣ ΔΙΑΚΟΣΜΗΣΗ',
  },
  {
    label: '46441114',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΗΛΙΝΩΝ Η ΤΣΙΜΕΝΤΕΝΙΩΝ ΓΛΑΣΤΡΩΝ ΚΑΙ ΖΑΡΝΤΙΝΙΕΡΩΝ',
  },
  {
    label: '46441115',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΤΗΡΙΩΝ ΑΠΟ ΓΥΑΛΙ, ΕΚΤΟΣ ΑΠΟ ΥΑΛΟΚΕΡΑΜΙΚΑ ΥΛΙΚΑ',
  },
  {
    label: '46441200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΛΙΚΩΝ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '46441201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΥΠΑΝΤΙΚΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΕΚΠΛΥΣΗΣ, ΟΧΙ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '46441202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΑΦΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '46441203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΦΑΝΕΙΟΔΡΑΣΤΙΚΩΝ ΟΡΓΑΝΙΚΩΝ ΟΥΣΙΩΝ, ΕΚΤΟΣ ΑΠΟ ΣΑΠΟΥΝΙ',
  },
  {
    label: '46441204',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΑΡΩΜΑΤΙΣΜΟ Η ΑΠΟΣΜΗΣΗ ΧΩΡΩΝ',
  },
  {
    label: '46441205',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΕΚΠΛΥΣΗΣ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '46441206',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΤΩΝ ΚΑΙ ΣΚΟΝΩΝ ΚΑΘΑΡΙΣΜΟΥ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '46441207',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΠΟΥΝΙΟΥ',
  },
  {
    label: '46441208',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΠΟΥΝΙΟΥ ΚΑΙ ΕΠΙΦΑΝΕΙΟΔΡΑΣΤΙΚΩΝ ΟΡΓΑΝΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΩΣ ΣΑΠΟΥΝΙ, ΟΧΙ ΓΙΑ ΠΡΟΣΩΠΙΚΗ ΥΓΙΕΙΝΗ',
  },
  {
    label: '46441209',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΙΛΒΩΤΙΚΩΝ ΟΥΣΙΩΝ ΚΑΙ ΚΡΕΜΩΝ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '46441210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΙΛΒΩΤΙΚΩΝ ΟΥΣΙΩΝ ΚΑΙ ΚΡΕΜΩΝ, ΓΙΑ ΥΠΟΔΗΜΑΤΑ, ΕΠΙΠΛΑ, ΔΑΠΕΔΑ, ΑΜΑΞΩΜΑΤΑ, ΓΥΑΛΙ Η ΜΕΤΑΛΛΟ',
  },
  {
    label: '46441211',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ ΚΕΡΙΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΚΕΡΙΩΝ',
  },
  {
    label: '46450000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΩΜΑΤΩΝ ΚΑΙ ΚΑΛΛΥΝΤΙΚΩΝ',
  },
  {
    label: '46451001',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΣΤΕΙΡΩΤΙΚΩΝ ΔΙΑΛΥΜΑΤΩΝ ΦΑΚΩΝ ΕΠΑΦΗΣ',
  },
  {
    label: '46451002',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΩΜΑΤΩΝ ΚΑΙ ΚΟΛΟΝΙΩΝ',
  },
  {
    label: '46451003',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΟΣΙΟΝ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΑ ΜΑΛΛΙΑ Π.Δ.Κ.Α.',
  },
  {
    label: '46451004',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΡΙΣΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ, ΑΠΟΣΜΗΤΙΚΩΝ ΚΑΙ ΑΝΤΙΙΔΡΩΤΙΚΩΝ ΓΙΑ ΤΟ ΣΩΜΑ, ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΟ ΛΟΥΤΡΟ, ΑΛΛΩΝ ΑΡΩΜΑΤΩΝ ΚΑΛΛΥΝΤΙΚΩΝ Η ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΛΛΩΠΙΣΜΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '46451005',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΜΑΚΙΓΙΑΖ ΧΕΙΛΙΩΝ ΚΑΙ ΜΑΤΙΩΝ',
  },
  {
    label: '46451006',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΕΡΙΠΟΙΗΣΗ ΤΩΝ ΧΕΡΙΩΝ ΚΑΙ ΤΩΝ ΠΟΔΙΩΝ',
  },
  {
    label: '46451007',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΗΝ ΥΓΙΕΙΝΗ ΤΟΥ ΣΤΟΜΑΤΟΣ Η ΤΩΝ ΔΟΝΤΙΩΝ,            [ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΟΙ ΣΤΕΡΕΩΤΙΚΟΙ ΠΟΛΤΟΙ ΚΑΙ ΣΚΟΝΕΣ ΓΙΑ ΤΗΝ ΟΔΟΝΤΟΣΤΟΙΧΙΑ            ]',
  },
  {
    label: '46451008',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΟΜΟΡΦΙΑΣ, ΜΑΚΙΓΙΑΖ, ΦΡΟΝΤΙΔΑΣ ΤΟΥ ΔΕΡΜΑΤΟΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΑΝΤΙΗΛΙΑΚΑ) Π.Δ.Κ.Α.',
  },
  {
    label: '46451009',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΜΠΟΥΑΝ, ΛΑΚ ΜΑΛΛΙΩΝ, ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΜΟΝΙΜΟ ΚΑΤΣΑΡΩΜΑ Η ΙΣΙΩΜΑ ΜΑΛΛΙΩΝ',
  },
  {
    label: '46451010',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΠΟΥΝΙΟΥ ΓΙΑ ΠΡΟΣΩΠΙΚΗ ΥΓΙΕΙΝΗ',
  },
  {
    label: '46451011',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΠΟΥΝΙΟΥ ΚΑΙ ΕΠΙΦΑΝΕΙΟΔΡΑΣΤΙΚΩΝ ΟΡΓΑΝΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΩΣ ΣΑΠΟΥΝΙ, ΓΙΑ ΠΡΟΣΩΠΙΚΗ ΥΓΙΕΙΝΗ',
  },
  {
    label: '46451012',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΟΝΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΩΣ ΚΑΛΛΥΝΤΙΚΑ Η ΓΙΑ ΚΑΛΛΩΠΙΣΜΟ',
  },
  {
    label: '46460000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46461100',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΑΣΙΚΩΝ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΣΚΕΥΑΣΜΑΤΩΝ',
  },
  {
    label: '46461101',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΔΕΝΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΩΝ, ΕΚΧΥΛΙΣΜΑΤΩΝ ΤΟΥΣ ΚΑΙ ΑΛΛΩΝ ΑΝΘΡΩΠΙΝΩΝ Η ΖΩΙΚΩΝ ΟΥΣΙΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46461102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΙΒΙΟΤΙΚΩΝ',
  },
  {
    label: '46461103',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΙΟΡΩΝ ΚΑΙ ΕΜΒΟΛΙΩΝ',
  },
  {
    label: '46461104',
    value:
      "ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΑΤΩΝ ΑΠΟ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ ΚΑΙ ΕΙΔΩΝ ΑΠ' ΑΥΤΕΣ, ΓΙΑ ΦΑΡΜΑΚΕΥΤΙΚΗ ΧΡΗΣΗ",
  },
  {
    label: '46461105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΛΥΚΟΖΙΤΩΝ, ΣΑΚΧΑΡΩΝ, ΦΥΤΙΚΩΝ ΑΛΚΑΛΟΕΙΔΩΝ, ΤΩΝ ΑΛΑΤΩΝ, ΤΩΝ ΑΙΘΕΡΩΝ, ΤΩΝ ΕΣΤΕΡΩΝ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '46461106',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΓΝΩΣΤΙΚΩΝ ΑΝΤΙΔΡΑΣΤΗΡΙΩΝ ΚΑΙ ΑΛΛΩΝ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46461107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΤΙΩΝ ΠΡΩΤΩΝ ΒΟΗΘΕΙΩΝ',
  },
  {
    label: '46461108',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΥΣΙΝΗΣ, ΓΛΟΥΤΑΜΙΝΙΚΟΥ ΟΞΕΟΣ ΚΑΙ ΤΩΝ ΑΛΑΤΩΝ ΤΟΥΣ, ΑΛΑΤΩΝ ΚΑΙ ΥΔΡΟΞΕΙΔΙΩΝ ΤΟΥ ΤΕΤΡΑΔΙΚΟΥ ΑΜΜΩΝΙΟΥ, ΦΩΣΦΟΡΟΑΜΙΝΟΛΙΠΙΔΙΩΝ, ΑΜΙΔΙΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ ΚΑΘΩΣ ΚΑΙ ΤΩΝ ΑΛΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46461109',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΜΟΝΩΝ, ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ, ΑΛΛΩΝ ΣΤΕΡΟΕΙΔΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΚΥΡΙΩΣ ΩΣ ΟΡΜΟΝΕΣ',
  },
  {
    label: '46461110',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΦΑΡΜΑΚΕΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46461111',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΒΙΤΑΜΙΝΩΝ, ΒΙΤΑΜΙΝΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '46461112',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΓΚΟΛΛΗΤΙΚΩΝ ΕΠΙΔΕΣΜΩΝ, ΧΕΙΡΟΥΡΓΙΚΩΝ ΡΑΜΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46461113',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΓΕΙΟΝΟΜΙΚΩΝ Η ΝΟΣΟΚΟΜΕΙΑΚΩΝ ΕΙΔΩΝ, ΑΠΟ ΧΑΡΤΟΠΟΛΤΟ, ΧΑΡΤΙ, ΧΑΡΤΟΒΑΜΒΑΚΑ Η ΡΟΛΑ ΙΝΩΝ ΚΥΤΤΑΡΙΝΗΣ',
  },
  {
    label: '46461114',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΑΦΕΨΗΜΑΤΩΝ ΒΟΤΑΝΩΝ',
  },
  {
    label: '46461115',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΑΛΚΑΛΟΕΙΔΗ Η ΠΑΡΑΓΩΓΑ ΤΟΥΣ, ΑΛΛΑ ΟΧΙ ΟΡΜΟΝΕΣ Η ΑΝΤΙΒΙΟΤΙΚΑ',
  },
  {
    label: '46461116',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΟΡΜΟΝΕΣ, ΑΛΛΑ ΟΧΙ ΑΝΤΙΒΙΟΤΙΚΑ',
  },
  {
    label: '46461117',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΠΕΝΙΚΙΛΙΝΕΣ Η ΑΛΛΑ ΑΝΤΙΒΙΟΤΙΚΑ',
  },
  {
    label: '46461118',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΝΩΝ ΕΙΔΩΝ ΝΟΣΟΚΟΜΕΙΩΝ ΜΙΑΣ ΧΡΗΣΕΩΣ, ΕΚΤΟΣ ΑΠΟ ΕΙΔΗ ΕΝΔΥΣΗΣ',
  },
  {
    label: '46461119',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΗΜΙΚΩΝ ΑΝΤΙΣΥΛΛΗΠΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΜΕ ΒΑΣΗ ΟΡΜΟΝΕΣ Η ΣΠΕΡΜΑΤΟΚΤΟΝΑ',
  },
  {
    label: '46461120',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΩΝ ΕΙΔΙΚΑ ΚΤΗΝΙΑΤΡΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46461200',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΕΙΡΟΥΡΓΙΚΩΝ, ΙΑΤΡΙΚΩΝ ΚΑΙ ΟΡΘΟΠΕΔΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46461201',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΟΥΣΤΙΚΩΝ ΒΑΡΗΚΟΪΑΣ',
  },
  {
    label: '46461202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΟΥΣΤΙΚΩΝ ΒΑΡΗΚΟΪΑΣ, ΒΗΜΑΤΟΔΟΤΩΝ, ΜΕΡΩΝ ΤΟΥΣ, ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΠΡΟΘΕΣΕΩΝ (ΤΕΧΝΗΤΩΝ ΜΕΛΩΝ) ΚΑΙ ΟΡΘΟΠΕΔΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46461203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗΝ ΟΔΟΝΤΙΑΤΡΙΚΗ',
  },
  {
    label: '46461204',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΠΗΡΙΚΩΝ ΚΑΡΟΤΣΙΩΝ',
  },
  {
    label: '46461205',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΘΕΡΑΠΕΥΤΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ, ΑΝΑΠΝΕΥΣΤΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46461206',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΕΠΕΜΒΑΤΙΚΗΣ ΚΑΡΔΙΟΛΟΓΙΑΣ',
  },
  {
    label: '46461207',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ Η ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΕΙΔΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΤΑ ΘΗΛΑΣΤΡΑ) ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ, ΕΚΤΟΣ ΤΟΥ ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ',
  },
  {
    label: '46461208',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΔΕΣΜΙΚΟΥ ΥΛΙΚΟΥ',
  },
  {
    label: '46461209',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΛΩΝ ΓΙΑ ΤΗΝ ΙΑΤΡΙΚΗ, ΤΗ ΧΕΙΡΟΥΡΓΙΚΗ, ΤΗΝ ΟΔΟΝΤΙΑΤΡΙΚΗ Η ΤΗΝ ΚΤΗΝΙΑΤΡΙΚΗ, ΚΑΘΙΣΜΑΤΩΝ ΚΟΜΜΩΤΗΡΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΚΑΘΙΣΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46461210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΣΤΗΡΙΑΚΩΝ ΕΙΔΩΝ, ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ Η ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΕΙΔΩΝ ΑΠΟ ΓΥΑΛΙ',
  },
  {
    label: '46461211',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΔΙΑΓΝΩΣΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΥΠΕΡΙΩΔΩΝ Η ΥΠΕΡΥΘΡΩΝ ΑΚΤΙΝΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗΝ ΙΑΤΡΙΚΗ',
  },
  {
    label: '46461212',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΙΑΤΡΙΚΩΝ ΑΝΑΛΩΣΙΜΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46461213',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΙΑΤΡΙΚΩΝ ΘΕΡΜΟΜΕΤΡΩΝ',
  },
  {
    label: '46461214',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΙΑΤΡΙΚΩΝ, ΧΕΙΡΟΥΡΓΙΚΩΝ Η ΕΡΓΑΣΤΗΡΙΑΚΩΝ ΑΠΟΣΤΕΙΡΩΤΗΡΩΝ',
  },
  {
    label: '46461215',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΙΣΜΑΤΩΝ ΚΟΜΜΩΤΗΡΙΟΥ',
  },
  {
    label: '46461216',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΑΝΑΠΗΡΙΚΑ ΚΑΡΟΤΣΑΚΙΑ',
  },
  {
    label: '46461217',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΙΚΡΟΒΙΟΛΟΓΙΚΩΝ ΑΝΤΙΔΡΑΣΤΗΡΙΩΝ',
  },
  {
    label: '46461218',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΘΟΠΕΔΙΚΩΝ ΕΙΔΩΝ ΑΠΟ ΥΦΑΣΜΑ, ΕΛΑΣΤΙΚΟ ΝΗΜΑ Η ΛΑΣΤΙΧΟ ΚΑΙ ΣΥΝΑΦΕΙΣ ΥΛΕΣ',
  },
  {
    label: '46461219',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΘΟΠΕΔΙΚΩΝ ΕΙΔΩΝ, ΚΗΛΕΠΙΔΕΣΜΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46461220',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΙΓΓΩΝ, ΒΕΛΟΝΩΝ, ΚΑΘΕΤΗΡΩΝ, ΣΩΛΗΝΙΣΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΟΦΘΑΛΜΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46461221',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ ΑΡΘΡΩΣΕΩΝ, ΟΡΘΟΠΕΔΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΤΕΧΝΗΤΩΝ ΔΟΝΤΙΩΝ, ΟΔΟΝΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ, ΤΕΧΝΗΤΩΝ ΜΕΛΩΝ ΤΟΥ ΣΩΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46461222',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ ΜΟΣΧΕΥΜΑΤΩΝ',
  },
  {
    label: '46461223',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΝΕΦΡΟΥ ΜΙΑΣ ΧΡΗΣΕΩΣ, ΚΑΘΕΤΗΡΩΝ, ΓΑΖΩΝ ΚΛΠ',
  },
  {
    label: '46461224',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΕΙΡΟΥΡΓΙΚΩΝ ΚΑΙ ΙΑΤΡΙΚΩΝ ΓΕΝΙΚΑ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΡΓΑΛΕΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46470000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΛΩΝ, ΧΑΛΙΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΩΝ',
  },
  {
    label: '46471000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΛΩΝ, ΧΑΛΙΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46471100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΙΚΙΑΚΩΝ ΕΠΙΠΛΩΝ',
  },
  {
    label: '46471101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΑΘΙΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46471102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΝΩΝ ΚΑΘΡΕΠΤΩΝ',
  },
  {
    label: '46471103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΛΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ ΚΑΙ ΕΠΙΠΛΩΝ ΑΠΟ ΑΛΛΑ ΥΛΙΚΑ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΚΑΛΑΜΙΟΥ, ΤΗΣ ΛΥΓΑΡΙΑΣ, ΤΟΥ ΜΠΑΜΠΟΥ Η ΠΑΡΟΜΟΙΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46471104',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΛΩΝ ΚΟΥΖΙΝΑΣ',
  },
  {
    label: '46471105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΙΣΜΑΤΩΝ, ΚΥΡΙΩΣ ΜΕ ΜΕΤΑΛΛΙΚΟ ΣΚΕΛΕΤΟ, ΟΧΙ ΓΙΑ ΓΡΑΦΕΙΑ',
  },
  {
    label: '46471106',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΙΣΜΑΤΩΝ, ΚΥΡΙΩΣ ΜΕ ΞΥΛΙΝΟ ΣΚΕΛΕΤΟ, ΟΧΙ ΓΙΑ ΓΡΑΦΕΙΑ',
  },
  {
    label: '46471107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΒΑΤΙΩΝ ΚΑΙ ΣΟΜΙΕΔΩΝ',
  },
  {
    label: '46471108',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΕΠΙΠΛΩΝ',
  },
  {
    label: '46471109',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΘΙΣΜΑΤΩΝ',
  },
  {
    label: '46471110',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΕΠΙΠΛΩΝ ΚΑΙ ΜΙΚΡΟΕΠΙΠΛΩΝ',
  },
  {
    label: '46471111',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΙΚΩΝ ΕΠΙΠΛΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '46471112',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΙΚΩΝ ΕΠΙΠΛΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46471113',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46471114',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗΝ ΚΡΕΒΑΤΟΚΑΜΑΡΑ, ΣΤΗΝ ΤΡΑΠΕΖΑΡΙΑ ΚΑΙ ΣΤΟ ΚΑΘΙΣΤΙΚΟ',
  },
  {
    label: '46471115',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΕΚΤΩΝ ΕΠΙΠΛΩΝ',
  },
  {
    label: '46471116',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΗΡΙΓΜΑΤΩΝ ΣΤΡΩΜΑΤΩΝ',
  },
  {
    label: '46471117',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΩΜΑΤΩΝ',
  },
  {
    label: '46471118',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΩΜΑΤΩΝ ΜΕ ΜΕΤΑΛΛΙΚΟ ΕΞΟΠΛΙΣΜΟ (ΣΤΡΩΜΑΤΕΞ)',
  },
  {
    label: '46471200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΙΣΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46471201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΛΑΜΠΤΗΡΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '46471202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΝΩΝ ΜΕΡΩΝ ΓΙΑ ΛΑΜΠΤΗΡΕΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΑ ΦΩΤΙΣΜΟΥ, ΦΩΤΕΙΝΩΝ ΣΗΜΑΤΩΝ, ΠΙΝΑΚΙΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46471203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΛΑΜΠΤΗΡΩΝ ΤΡΑΠΕΖΙΟΥ, ΓΡΑΦΕΙΟΥ, ΚΟΜΟΔΙΝΟΥ Η ΛΥΧΝΟΣΤΑΤΩΝ',
  },
  {
    label: '46471204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΑΜΠΤΗΡΩΝ ΕΚΚΕΝΩΣΗΣ, ΛΑΜΠΤΗΡΩΝ ΥΠΕΡΙΩΔΩΝ Η ΥΠΕΡΥΘΡΩΝ ΑΚΤΙΝΩΝ, ΛΑΜΠΤΗΡΩΝ ΤΟΞΟΥ',
  },
  {
    label: '46471205',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ, ΟΧΙ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '46471206',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΛΑΜΠΤΗΡΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '46471207',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΣΤΙΚΩΝ ΜΕΡΩΝ Π.Δ.Κ.Α. ΓΙΑ ΛΑΜΠΤΗΡΕΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΑ ΦΩΤΙΣΜΟΥ, ΦΩΤΕΙΝΕΣ ΠΙΝΑΚΙΔΕΣ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46471208',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΕΛΑΙΩΝ ΚΑΙ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΟΡΟΦΗΣ Η ΤΟΙΧΟΥ',
  },
  {
    label: '46471209',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΒΟΛΕΩΝ ΚΑΙ ΣΠΟΤ',
  },
  {
    label: '46471210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΟΡΗΤΩΝ ΗΛΕΚΤΡΙΚΩΝ ΛΑΜΠΤΗΡΩΝ ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΞΗΡΕΣ ΣΤΗΛΕΣ, ΣΥΣΣΩΡΕΥΤΕΣ, ΔΥΝΑΜΟΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΕΣ ΣΥΣΚΕΥΕΣ',
  },
  {
    label: '46471211',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΕΙΝΩΝ ΠΙΝΑΚΙΔΩΝ, ΦΩΤΕΙΝΩΝ ΕΠΙΓΡΑΦΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46471212',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΙΣΤΙΚΩΝ ΔΙΑΤΑΞΕΩΝ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΑ ΧΡΙΣΤΟΥΓΕΝΝΙΑΤΙΚΑ ΔΕΝΤΡΑ',
  },
  {
    label: '46471213',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΙΣΤΙΚΩΝ ΣΚΗΝΗΣ, ΦΩΤΙΣΤΙΚΩΝ ΔΡΟΜΟΥ, ΑΛΛΩΝ ΦΩΤΙΣΤΙΚΩΝ',
  },
  {
    label: '46471300',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΛΙΩΝ ΚΑΙ ΚΙΛΙΜΙΩΝ',
  },
  {
    label: '46471301',
    value: 'ΕΞΑΓΩΓΗ ΕΓΧΩΡΙΩΝ ΥΦΑΝΤΩΝ ΣΤΡΩΣΙΔΙΩΝ ΔΑΠΕΔΟΥ',
  },
  {
    label: '46471302',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΧΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΩΝ [ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΚΑΛΥΜΜΑΤΑ ΑΠΟ ΠΙΛΗΜΑ (ΤΣΟΧΑ)            ]',
  },
  {
    label: '46471303',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΓΧΩΡΙΩΝ ΥΦΑΝΤΩΝ ΣΤΡΩΣΙΔΙΩΝ ΔΑΠΕΔΟΥ',
  },
  {
    label: '46471304',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΙΝΟΤΑΠΗΤΩΝ',
  },
  {
    label: '46471305',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΩΝ, ΘΥΣΑΝΩΤΩΝ',
  },
  {
    label: '46471306',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΩΝ, ΜΕ ΚΟΜΠΟΥΣ',
  },
  {
    label: '46471307',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΩΝ, ΥΦΑΝΤΩΝ',
  },
  {
    label: '46480000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΟΛΟΓΙΩΝ ΚΑΙ ΚΟΣΜΗΜΑΤΩΝ',
  },
  {
    label: '46481001',
    value: 'ΕΞΑΓΩΓΗ ΣΚΕΥΩΝ ΑΠΟ ΑΡΓΥΡΟ',
  },
  {
    label: '46481002',
    value: 'ΕΞΑΓΩΓΗ ΧΡΥΣΩΝ ΚΑΙ ΑΡΓΥΡΩΝ ΚΟΣΜΗΜΑΤΩΝ',
  },
  {
    label: '46481003',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΠΟΛΥΤΙΜΑ ΜΕΤΑΛΛΑ, ΕΙΔΩΝ ΑΠΟ ΦΥΣΙΚΑ Η ΚΑΛΛΙΕΡΓΗΜΕΝΑ ΜΑΡΓΑΡΙΤΑΡΙΑ, ΠΟΛΥΤΙΜΟΥΣ Η ΗΜΙΠΟΛΥΤΙΜΟΥΣ ΛΙΘΟΥΣ',
  },
  {
    label: '46481004',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΡΩΝ ΡΟΛΟΓΙΩΝ',
  },
  {
    label: '46481005',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΡΟΛΟΓΙΩΝ ΧΕΡΙΟΥ, ΤΣΕΠΗΣ ΚΑΙ ΑΛΛΩΝ ΡΟΛΟΓΙΩΝ ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΧΡΟΝΟΜΕΤΡΩΝ',
  },
  {
    label: '46481006',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΜΗΧΑΝΙΚΩΝ ΔΙΑΜΑΝΤΙΩΝ, ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΣΚΟΝΩΝ ΦΥΣΙΚΩΝ Η ΣΥΝΘΕΤΙΚΩΝ ΠΟΛΥΤΙΜΩΝ Η ΗΜΙΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ',
  },
  {
    label: '46481007',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΩΝ ΡΟΛΟΓΙΩΝ ΤΟΙΧΟΥ ΚΑΙ ΧΕΡΙΟΥ, ΜΕΡΩΝ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΤΕΤΟΙΩΝ ΓΥΑΛΙΩΝ',
  },
  {
    label: '46481008',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΚΟΣΜΗΜΑΤΟΠΟΙΙΑΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΕΙΔΩΝ ΧΡΥΣΟΧΟΪΑΣ Η ΑΡΓΥΡΟΧΟΪΑΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46481009',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ ΡΟΛΟΓΙΩΝ ΜΕ ΜΗΧΑΝΙΣΜΟ ΡΟΛΟΓΙΟΥ ΧΕΡΙΟΥ, ΞΥΠΝΗΤΗΡΙΩΝ ΚΑΙ ΡΟΛΟΓΙΩΝ ΤΟΙΧΟΥ, ΑΛΛΩΝ ΡΟΛΟΓΙΩΝ',
  },
  {
    label: '46481010',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΛΙΕΡΓΗΜΕΝΩΝ ΜΑΡΓΑΡΙΤΑΡΙΩΝ, ΠΟΛΥΤΙΜΩΝ Η ΗΜΙΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΣΥΝΘΕΤΙΚΩΝ Η ΑΝΑΣΧΗΜΑΤΙΣΜΕΝΩΝ ΛΙΘΩΝ, ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΑΛΛΑ ΟΧΙ ΔΕΜΕΝΩΝ ΣΕ ΚΟΣΜΗΜΑΤΑ',
  },
  {
    label: '46481011',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΡΑΚΙΩΝ, ΘΗΚΩΝ ΡΟΛΟΓΙΩΝ ΚΑΙ ΑΛΥΣΙΔΩΝ ΡΟΛΟΓΙΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46481012',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΡΟΛΟΓΙΩΝ',
  },
  {
    label: '46481013',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΙΣΜΩΝ ΡΟΛΟΓΙΩΝ',
  },
  {
    label: '46481014',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ ΚΑΙ ΚΟΣΜΗΜΑΤΩΝ ΑΠΟ ΠΟΛΥΤΙΜΟΥΣ ΛΙΘΟΥΣ',
  },
  {
    label: '46481015',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΟΛΟΓΙΩΝ ΧΕΡΙΟΥ, ΤΣΕΠΗΣ, ΜΕ ΘΗΚΗ ΑΠΟ ΠΟΛΥΤΙΜΟ ΜΕΤΑΛΛΟ Η ΕΠΙΜΕΤΑΛΛΩΜΕΝΗ ΜΕ ΠΟΛΥΤΙΜΟ ΜΕΤΑΛΛΟ',
  },
  {
    label: '46481016',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΕΥΩΝ ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ ΜΕ ΧΡΥΣΟ Η ΑΡΓΥΡΟ',
  },
  {
    label: '46481017',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΚΑΤΑΓΡΑΦΗΣ, ΜΕΤΡΗΣΗΣ ΤΗΣ ΩΡΑΣ, ΠΑΡΚΟΜΕΤΡΩΝ, ΧΡΟΝΟΔΙΑΚΟΠΤΩΝ ΜΕ ΜΗΧΑΝΙΣΜΟ ΡΟΛΟΓΙΟΥ',
  },
  {
    label: '46490000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46491000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΧΑΙΡΟΠΙΡΟΥΝΩΝ ΚΑΙ ΜΕΤΑΛΛΙΚΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ, ΕΙΔΩΝ ΚΑΛΑΘΟΠΛΕΚΤΙΚΗΣ, ΕΙΔΩΝ ΑΠΟ ΦΕΛΛΟ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46491100',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΧΑΙΡΟΠΙΡΟΥΝΩΝ ΚΑΙ ΜΕΤΑΛΛΙΚΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46491101',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΟΠΤΙΚΩΝ ΕΙΔΩΝ, ΕΙΔΩΝ ΚΑΙ ΣΥΝΟΛΩΝ ΕΙΔΩΝ ΓΙΑ ΤΗΝ ΠΕΡΙΠΟΙΗΣΗ ΤΩΝ ΧΕΡΙΩΝ Η ΤΩΝ ΠΟΔΙΩΝ',
  },
  {
    label: '46491102',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ, ΜΑΓΕΙΡΙΚΩΝ Η ΟΙΚΙΑΚΩΝ ΣΚΕΥΩΝ ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ, ΧΑΛΚΟ Η ΑΛΟΥΜΙΝΙΟ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46491103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΤΑΛΙΩΝ, ΠΙΡΟΥΝΙΩΝ, ΚΟΥΤΑΛΩΝ, ΤΡΥΠΗΤΩΝ ΚΟΥΤΑΛΩΝ, ΣΠΑΤΟΥΛΩΝ ΓΙΑ ΓΛΥΚΑ, ΜΑΧΑΙΡΙΩΝ ΓΙΑ ΨΑΡΙΑ ΚΑΙ ΓΙΑ ΒΟΥΤΥΡΟ, ΛΑΒΙΔΩΝ ΓΙΑ ΤΗ ΖΑΧΑΡΗ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΑΓΕΙΡΙΚΩΝ Η ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΚΕΥΩΝ',
  },
  {
    label: '46491104',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΧΑΙΡΙΩΝ (ΕΚΤΟΣ ΤΩΝ ΜΑΧΑΙΡΙΩΝ ΓΙΑ ΜΗΧΑΝΕΣ) ΚΑΙ ΨΑΛΙΔΙΩΝ, ΚΑΙ ΛΕΠΙΔΩΝ ΤΟΥΣ',
  },
  {
    label: '46491105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΡΑΦΙΩΝ ΚΑΙ ΛΕΠΙΔΩΝ ΞΥΡΑΦΙΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΑΚΑΤΕΡΓΑΣΤΩΝ ΜΕΤΑΛΛΙΚΩΝ ΤΑΙΝΙΩΝ ΠΟΥ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΛΕΠΙΔΩΝ ΞΥΡΑΦΙΩΝ)',
  },
  {
    label: '46491200',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΚΑΛΑΘΟΠΛΕΚΤΙΚΗΣ, ΕΙΔΩΝ ΑΠΟ ΦΕΛΛΟ, ΕΙΔΩΝ ΒΑΡΕΛΟΠΟΙΙΑΣ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΞΥΛΟ',
  },
  {
    label: '46491201',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΞΥΛΙΝΩΝ ΚΙΒΩΤΙΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46491202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΠΛΕΚΤΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46491203',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΚΚΛΗΣΙΑΣΤΙΚΩΝ ΕΙΚΟΝΩΝ ΑΠΟ ΞΥΛΟ (ΟΧΙ ΖΩΓΡΑΦΙΣΤΩΝ)',
  },
  {
    label: '46491204',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ ΚΑΙ ΜΑΓΕΙΡΙΚΩΝ ΣΚΕΥΩΝ, ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '46491205',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ, ΣΤΕΛΕΧΩΝ ΕΡΓΑΛΕΙΩΝ, ΛΑΒΩΝ ΕΡΓΑΛΕΙΩΝ, ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '46491206',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΦΙΝΙΩΝ ΚΑΙ ΨΑΘΩΝ',
  },
  {
    label: '46491207',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΥΒΩΝ, ΠΛΑΚΩΝ, ΦΥΛΛΩΝ ΚΑΙ ΤΑΙΝΙΩΝ, ΠΛΑΚΙΔΙΩΝ ΚΑΘΕ ΣΧΗΜΑΤΟΣ, ΣΥΜΠΑΓΩΝ ΚΥΛΙΝΔΡΩΝ, ΑΠΟ ΣΥΣΣΩΜΑΤΩΜΕΝΟ ΦΕΛΛΟ',
  },
  {
    label: '46491208',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΠΟΙΗΜΕΝΩΝ ΕΙΔΩΝ ΑΠΟ ΑΧΥΡΟ, ΣΠΑΡΤΟ Η ΑΛΛΑ ΥΛΙΚΑ ΣΠΑΡΤΟΠΛΕΚΤΙΚΗΣ, ΕΙΔΩΝ ΚΑΛΑΘΟΠΟΙΙΑΣ ΚΑΙ ΨΑΘΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46491209',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΒΑΡΕΛΙΩΝ',
  },
  {
    label: '46491210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΚΟΡΝΙΖΩΝ ΓΙΑ ΠΙΝΑΚΕΣ ΖΩΓΡΑΦΙΚΗΣ, ΦΩΤΟΓΡΑΦΙΕΣ, ΚΑΘΡΕΠΤΩΝ Η ΠΑΡΟΜΟΙΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '46491211',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΣΚΑΛΩΝ',
  },
  {
    label: '46491212',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΨΗΦΙΔΟΘΕΤΗΜΑΤΩΝ ΚΑΙ ΕΝΘΕΤΙΚΗΣ ΔΙΑΚΟΣΜΗΣΗΣ ΕΠΙΠΛΩΝ, ΘΗΚΩΝ ΓΙΑ ΚΟΣΜΗΜΑΤΑ Η ΜΑΧΑΙΡΟΠΙΡΟΥΝΑ, ΑΓΑΛΜΑΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΕΙΔΩΝ, ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '46491213',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΕΛΛΟΥ ΚΑΙ ΕΙΔΩΝ ΑΠΟ ΦΥΣΙΚΟ ΦΕΛΛΟ',
  },
  {
    label: '46491214',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΑΘΙΝΩΝ ΕΙΔΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '46491900',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '46491901',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΓΑΛΜΑΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46491902',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46491903',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ, ΓΙΑ ΑΕΡΙΑ ΚΑΥΣΙΜΑ Η ΓΙΑ ΑΕΡΙΑ ΚΑΙ ΓΙΑ ΑΛΛΑ ΚΑΥΣΙΜΑ, ΓΙΑ ΥΓΡΑ ΚΑΥΣΙΜΑ Η ΓΙΑ ΣΤΕΡΕΑ ΚΑΥΣΙΜΑ',
  },
  {
    label: '46491904',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΣΥΣΚΕΥΑΣΙΑΣ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46491905',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΤΟΜΙΚΩΝ ΚΑΙ ΟΙΚΙΑΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΖΥΓΙΣΗΣ ΚΑΙ ΣΥΣΚΕΥΩΝ ΖΥΓΙΣΗΣ',
  },
  {
    label: '46491906',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΛΑΣΤΡΩΝ, ΖΑΡΝΤΙΝΙΕΡΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46491907',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΠΛΑΣΤΙΚΩΝ ΕΙΔΩΝ ΝΟΙΚΟΚΥΡΙΟΥ',
  },
  {
    label: '46491908',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΚΕΥΩΝ, ΜΑΓΕΙΡΙΚΩΝ ΣΚΕΥΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46491909',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΙΑΚΩΝ ΘΕΡΜΟΣΙΦΩΝΩΝ',
  },
  {
    label: '46491910',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΘΕΡΜΑΝΤΗΡΩΝ ΑΕΡΑ Η ΔΙΑΝΕΜΗΤΩΝ ΘΕΡΜΟΥ ΑΕΡΑ Π.Δ.Κ.Α. ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΜΗ ΗΛΕΚΤΡΙΚΩΝ',
  },
  {
    label: '46491911',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΘΕΡΜΑΝΤΗΡΩΝ ΝΕΡΟΥ, ΣΤΙΓΜΙΑΙΩΝ Η ΘΕΡΜΟΣΥΣΣΩΡΕΥΣΗΣ, ΜΗ ΗΛΕΚΤΡΙΚΩΝ',
  },
  {
    label: '46491912',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΡΤΙΝΟΒΕΡΓΩΝ (ΞΥΛΙΝΩΝ, ΜΕΤΑΛΛΙΚΩΝ, ΠΛΑΣΤΙΚΩΝ ΚΛΠ)',
  },
  {
    label: '46491913',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΤΙΩΝ, ΘΗΚΩΝ, ΚΙΒΩΤΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46491914',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΘΕΡΜΑΣΤΡΩΝ, ΚΟΥΖΙΝΩΝ, ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΟ ΖΕΣΤΑΜΑ ΦΑΓΗΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46491915',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΛΑΜΠΤΗΡΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '46491916',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΜΑΓΕΙΡΕΜΑ ΚΑΙ ΖΕΣΤΑΜΑ ΦΑΓΗΤΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ Η ΑΠΟ ΧΑΛΚΟ, ΜΗ ΗΛΕΚΤΡΙΚΩΝ',
  },
  {
    label: '46491917',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΜΠΡΕΛΩΝ ΗΛΙΟΥ ΚΑΙ ΟΜΠΡΕΛΩΝ ΚΗΠΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46491918',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΚΩΝ ΚΑΙ ΤΣΑΝΤΩΝ, ΑΠΟ ΑΛΛΕΣ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ (ΕΚΤΟΣ ΤΟΥ ΑΙΘΥΛΕΝΙΟΥ), ΓΙΑ ΟΙΚΙΑΚΗ ΧΡΗΣΗ',
  },
  {
    label: '46491919',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΚΩΝ ΚΑΙ ΤΣΑΝΤΩΝ, ΑΠΟ ΠΟΛΥΜΕΡΗ ΤΟΥ ΑΙΘΥΛΕΝΙΟΥ, ΓΙΑ ΟΙΚΙΑΚΗ ΧΡΗΣΗ',
  },
  {
    label: '46491920',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΑΛΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '46491921',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΥΓΡΑΕΡΙΟΥ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ (ΚΟΥΖΙΝΩΝ ~ ΠΛΥΝΤΗΡΙΩΝ ~ ΨΥΓΕΙΩΝ ΚΛΠ)',
  },
  {
    label: '46491922',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΓΡΩΝ ΧΑΡΤΟΜΑΝΤΙΛΩΝ',
  },
  {
    label: '46491923',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΥΓΕΙΑΣ, ΧΑΡΤΟΜΑΝΤΙΛΩΝ, ΜΑΝΤΙΛΙΩΝ ΚΑΙ ΠΕΤΣΕΤΩΝ ΚΑΘΑΡΙΣΜΟΥ ΠΡΟΣΩΠΟΥ, ΤΡΑΠΕΖΟΜΑΝΤΙΛΩΝ ΚΑΙ ΠΕΤΣΕΤΩΝ ΦΑΓΗΤΟΥ, ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '46492000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΒΛΙΩΝ, ΠΕΡΙΟΔΙΚΩΝ ΚΑΙ ΧΑΡΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46492100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΒΛΙΩΝ',
  },
  {
    label: '46492101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΒΛΙΩΝ, ΓΕΝΙΚΑ',
  },
  {
    label: '46492102',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΕΩΓΡΑΦΙΚΩΝ ΑΤΛΑΝΤΩΝ ΚΑΙ ΑΛΛΩΝ ΒΙΒΛΙΩΝ ΜΕ ΧΑΡΤΕΣ Η ΔΙΑΓΡΑΜΜΑΤΑ',
  },
  {
    label: '46492103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΚΤΥΠΩΜΕΝΩΝ ΒΙΒΛΙΩΝ, ΦΥΛΛΑΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΠΑΡΟΜΟΙΟΥ ΕΝΤΥΠΟΥ ΥΛΙΚΟΥ, ΣΕ ΧΩΡΙΣΤΑ ΦΥΛΛΑ',
  },
  {
    label: '46492104',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΚΤΥΠΩΜΕΝΩΝ ΒΙΒΛΙΩΝ, ΦΥΛΛΑΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46492105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΕΞΙΚΩΝ ΚΑΙ ΕΓΚΥΚΛΟΠΑΙΔΕΙΩΝ, ΚΑΘΩΣ ΚΑΙ ΤΕΥΧΩΝ ΤΟΥΣ',
  },
  {
    label: '46492106',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΩΝ ΚΑΙ ΥΔΡΟΓΡΑΦΙΚΩΝ Η ΠΑΡΟΜΟΙΩΝ ΔΙΑΓΡΑΜΜΑΤΩΝ, ΕΚΤΥΠΩΜΕΝΩΝ ΣΕ ΑΛΛΗ ΜΟΡΦΗ ΕΚΤΟΣ ΑΠΟ ΒΙΒΛΙΑ, ΥΔΡΟΓΕΙΩΝ ΣΦΑΙΡΩΝ',
  },
  {
    label: '46492200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΙΟΔΙΚΩΝ ΚΑΙ ΕΦΗΜΕΡΙΔΩΝ',
  },
  {
    label: '46492201',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ (ΠΡΑΚΤΟΡΕΙΟ) ΕΦΗΜΕΡΙΔΩΝ ΚΑΙ ΠΕΡΙΟΔΙΚΩΝ',
  },
  {
    label: '46492202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ (ΠΡΑΚΤΟΡΕΙΟ) ΚΑΘΕ ΦΥΣΕΩΣ ΕΝΤΥΠΩΝ',
  },
  {
    label: '46492203',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΦΗΜΕΡΙΔΩΝ ΚΑΙ ΠΕΡΙΟΔΙΚΩΝ, ΓΕΝΙΚΑ',
  },
  {
    label: '46492300',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46492301',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΟΥ ΕΝΤΥΠΟΥ ΥΛΙΚΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '46492302',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΓΡΑΦΗ, ΕΚΤΥΠΩΣΗ Η ΑΛΛΟΥΣ ΓΡΑΦΙΚΟΥΣ ΣΚΟΠΟΥΣ, ΤΥΠΩΜΕΝΟΥ, ΑΝΑΓΛΥΦΟΥ Η ΔΙΑΤΡΗΤΟΥ',
  },
  {
    label: '46492303',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΤΥΠΩΤΙΚΟΥ ΧΑΡΤΙΟΥ (ΚΑΡΜΠΟΝ), ΑΥΤΟΑΝΤΙΓΡΑΦΙΚΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΑΛΛΩΝ ΧΑΡΤΙΩΝ ΓΙΑ ΑΝΤΙΓΡΑΦΗ Η ΜΕΤΑΦΟΡΑ ΚΕΙΜΕΝΩΝ, ΜΕΜΒΡΑΝΩΝ ΠΟΛΥΓΡΑΦΩΝ ΚΑΙ ΠΛΑΚΩΝ ΟΦΣΕΤ ΑΠΟ ΧΑΡΤΙ, ΧΑΡΤΙΟΥ ΜΕ ΓΟΜΑ Η ΑΥΤΟΚΟΛΛΗΤΟΥ',
  },
  {
    label: '46492304',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΒΛΙΩΝ ΜΗΤΡΩΩΝ, ΛΟΓΙΣΤΙΚΩΝ ΒΙΒΛΙΩΝ, ΚΛΑΣΕΡ, ΕΝΤΥΠΩΝ ΠΡΟΣ ΣΥΜΠΛΗΡΩΣΗ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΓΡΑΦΙΚΗΣ ΥΛΗΣ, ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '46492305',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΣΚΩΝ, ΠΙΑΤΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΦΛΙΤΖΑΝΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '46492306',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΓΡΑΦΙΚΩΝ ΤΕΧΝΩΝ (ΜΕΛΑΝΙΩΝ, ΧΡΩΜΑΤΩΝ ΚΛΠ)',
  },
  {
    label: '46492307',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '46492308',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΚΟΝΩΝ, ΣΧΕΔΙΩΝ ΚΑΙ ΦΩΤΟΓΡΑΦΙΩΝ',
  },
  {
    label: '46492309',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΚΤΥΠΩΜΕΝΩΝ Η ΕΙΚΟΝΟΓΡΑΦΗΜΕΝΩΝ ΤΑΧΥΔΡΟΜΙΚΩΝ ΚΑΡΤΩΝ, ΕΚΤΥΠΩΜΕΝΩΝ ΜΕ ΕΥΧΕΣ ΚΛΠ',
  },
  {
    label: '46492310',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΝΤΟΣΙΕ ΚΙΝΗΤΩΝ ΦΥΛΛΩΝ Η ΧΑΡΤΟΦΥΛΑΚΩΝ ΤΑΞΙΝΟΜΗΣΗΣ ΕΓΓΡΑΦΩΝ, ΕΙΔΩΝ ΓΡΑΦΕΙΟΥ ΚΑΙ ΣΥΝΔΕΤΗΡΩΝ ΣΥΡΡΑΦΗΣ ΣΕ ΠΛΑΚΕΤΕΣ, ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46492311',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΤΙΚΕΤΩΝ ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '46492312',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΦΟΔΙΩΝ ΓΡΑΦΕΙΟΥ Η ΣΧΟΛΙΚΩΝ ΕΦΟΔΙΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46492313',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΛΛΩΝ, ΓΙΑ ΤΟ ΣΧΟΛΕΙΟ ΚΑΙ ΤΟ ΓΡΑΦΕΙΟ',
  },
  {
    label: '46492314',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΤΙΩΝ ΤΑΞΙΝΟΜΗΣΗΣ ΕΓΓΡΑΦΩΝ, ΕΠΙΣΤΟΛΟΘΗΚΩΝ, ΚΟΥΤΙΩΝ ΑΡΧΕΙΟΘΕΤΗΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΓΡΑΦΕΙΑ, ΚΑΤΑΣΤΗΜΑΤΑ ΚΛΠ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '46492315',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΛΑΝΗΣ ΓΡΑΦΗΣ Η ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΑΛΛΩΝ ΜΕΛΑΝΙΩΝ',
  },
  {
    label: '46492316',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΛΑΝΙΩΝ, ΜΕ ΑΝΑΓΟΜΩΣΗ ΦΥΣΙΓΓΙΩΝ (CARTRIDGES) ΕΚΤΥΠΩΤΩΝ',
  },
  {
    label: '46492317',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΙΚΡΟΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΟΥ ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46492318',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΛΥΒΙΩΝ, ΚΡΑΓΙΟΝΙΩΝ, ΛΕΠΤΩΝ ΡΑΒΔΩΝ ΓΡΑΦΙΤΗ ΓΙΑ ΜΟΛΥΒΙΑ, ΚΡΗΤΙΔΩΝ (ΠΑΣΤΕΛ), ΚΑΡΒΟΥΝΩΝ ΣΧΕΔΙΑΣΗΣ, ΚΙΜΩΛΙΩΝ ΓΡΑΦΗΣ Η ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΚΙΜΩΛΙΩΝ ΡΑΠΤΙΚΗΣ',
  },
  {
    label: '46492319',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΝΩΝ ΓΙΑ ΣΙΝΙΚΗ ΜΕΛΑΝΗ, ΣΤΥΛΟΓΡΑΦΩΝ ΜΕΛΑΝΗΣ, ΑΛΛΩΝ ΣΤΥΛΟΓΡΑΦΩΝ ΚΑΙ ΑΛΛΩΝ ΠΕΝΩΝ',
  },
  {
    label: '46492320',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΚΩΝ ΚΑΙ ΠΙΝΑΚΩΝ, ΣΦΡΑΓΙΔΩΝ ΑΝΑΓΡΑΦΗΣ ΗΜΕΡΟΜΗΝΙΩΝ, ΣΦΡΑΓΙΣΗΣ Η ΑΡΙΘΜΗΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΧΡΗΣΕΩΝ, ΜΕΛΑΝΟΤΑΙΝΙΩΝ ΓΡΑΦΟΜΗΧΑΝΩΝ Η ΠΑΡΟΜΟΙΩΝ ΤΑΙΝΙΩΝ, ΤΑΜΠΟΝ ΜΕΛΑΝΗΣ',
  },
  {
    label: '46492321',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΣΤΙΚΩΝ ΕΠΟΠΤΙΚΩΝ ΜΕΣΩΝ ΔΙΔΑΣΚΑΛΙΑΣ',
  },
  {
    label: '46492322',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΤΥΣΣΟΜΕΝΩΝ ΧΑΡΤΟΚΙΒΩΤΙΩΝ, ΚΟΥΤΙΩΝ ΚΑΙ ΚΑΣΩΝ ΑΠΟ ΜΗ ΚΥΜΑΤΟΕΙΔΕΣ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '46492323',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΚΩΝ ΚΑΙ ΤΣΑΝΤΩΝ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '46492324',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΥΛΟΓΡΑΦΩΝ ΜΕ ΣΦΑΙΡΙΔΙΟ, ΣΤΥΛΟΓΡΑΦΩΝ ΚΑΙ ΜΑΡΚΑΔΟΡΩΝ ΜΕ ΜΥΤΗ ΑΠΟ ΠΙΛΗΜΑ (ΤΣΟΧΑ) Η ΑΛΛΟ ΠΟΡΩΔΕΣ ΥΛΙΚΟ, ΜΗΧΑΝΙΚΩΝ Η ΚΙΝΗΤΩΝ ΜΟΛΥΒΙΩΝ',
  },
  {
    label: '46492325',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΛΛΟΓΩΝ ΕΡΓΑΛΕΙΩΝ ΓΡΑΦΗΣ, ΚΟΝΔΥΛΟΦΟΡΩΝ ΚΑΙ ΘΗΚΩΝ ΜΟΛΥΒΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΘΗΚΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46492326',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΡΑΠΕΖΙΩΝ ΚΑΙ ΜΗΧΑΝΩΝ ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΣΧΕΔΙΑΣΗΣ, ΧΑΡΑΞΗΣ Η ΔΙΕΝΕΡΓΕΙΑΣ ΜΑΘΗΜΑΤΙΚΩΝ ΥΠΟΛΟΓΙΣΜΩΝ',
  },
  {
    label: '46492327',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΑΚΕΛΩΝ, ΕΠΙΣΤΟΛΙΚΩΝ ΔΕΛΤΑΡΙΩΝ, ΤΑΧΥΔΡΟΜΙΚΩΝ ΔΕΛΤΑΡΙΩΝ, ΑΠΟ ΧΑΡΤΙ Η ΚΟΥΤΙΩΝ ΑΠΟ ΧΑΡΤΟΝΙ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΓΡΑΦΙΚΗ ΥΛΗ',
  },
  {
    label: '46492328',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΑΚΕΛΩΝ, ΚΟΛΛΩΝ ΑΝΑΦΟΡΑΣ, ΚΑΘΕ ΕΙΔΟΥΣ ΓΡΑΦΙΚΗΣ ΥΛΗΣ',
  },
  {
    label: '46492329',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΛΚΟΜΑΝΙΩΝ, ΕΚΤΥΠΩΜΕΝΩΝ ΗΜΕΡΟΛΟΓΙΩΝ',
  },
  {
    label: '46492330',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΟΚΙΒΩΤΙΩΝ, ΚΟΥΤΙΩΝ ΚΑΙ ΚΑΣΩΝ, ΑΠΟ ΚΥΜΑΤΟΕΙΔΕΣ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '46492331',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΟΚΟΠΤΩΝ, ΜΑΧΑΙΡΙΩΝ ΓΙΑ ΤΟ ΑΝΟΙΓΜΑ ΓΡΑΜΜΑΤΩΝ, ΜΑΧΑΙΡΙΩΝ ΣΒΗΣΤΗΡΩΝ, ΞΥΣΤΡΩΝ ΚΛΠ',
  },
  {
    label: '46492332',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΡΩΜΑΤΩΝ ΚΑΛΛΙΤΕΧΝΩΝ, ΣΠΟΥΔΑΣΤΩΝ Η ΖΩΓΡΑΦΩΝ ΕΠΙΓΡΑΦΩΝ, ΧΡΩΜΑΤΩΝ ΑΛΛΑΓΗΣ ΤΩΝ ΑΠΟΧΡΩΣΕΩΝ, ΧΡΩΜΑΤΩΝ ΑΝΑΨΥΧΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46493000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΑΤΑΝΑΛΩΤΙΚΩΝ ΑΓΑΘΩΝ',
  },
  {
    label: '46493100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '46493101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΓΧΟΡΔΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '46493102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '46493103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΚΚΛΗΣΙΑΣΤΙΚΩΝ ΟΡΓΑΝΩΝ ΜΕ ΚΛΙΜΑΚΑ ΠΛΗΚΤΡΩΝ, ΑΡΜΟΝΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΟΡΓΑΝΩΝ, ΑΚΟΡΝΤΕΟΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΟΡΓΑΝΩΝ, ΦΥΣΑΡΜΟΝΙΚΩΝ',
  },
  {
    label: '46493104',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '46493105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΡΟΝΟΜΩΝ, ΔΙΑΠΑΣΩΝ ΚΑΙ ΠΝΕΥΣΤΩΝ ΔΙΑΠΑΣΩΝ, ΜΗΧΑΝΙΣΜΩΝ ΓΙΑ ΜΟΥΣΙΚΑ ΚΟΥΤΙΑ, ΧΟΡΔΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '46493106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΥΣΙΚΗΣ ΣΕ ΕΝΤΥΠΗ ΜΟΡΦΗ',
  },
  {
    label: '46493107',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ, Ο ΗΧΟΣ ΤΩΝ ΟΠΟΙΩΝ ΠΑΡΑΓΕΤΑΙ Η ΠΡΕΠΕΙ ΝΑ ΕΝΙΣΧΥΕΤΑΙ ΜΕ ΗΛΕΚΤΡΙΚΑ ΜΕΣΑ',
  },
  {
    label: '46493108',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΙΑΝΩΝ ΚΑΙ ΑΛΛΩΝ ΕΓΧΟΡΔΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ ΜΕ ΚΛΙΜΑΚΑ ΠΛΗΚΤΡΩΝ',
  },
  {
    label: '46493200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΧΝΙΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '46493201',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΑΙΧΝΙΔΙΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46493202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΓΙΑ ΣΦΑΙΡΙΣΤΗΡΙΑ, ΕΙΔΩΝ ΓΙΑ ΛΟΥΝΑ ΠΑΡΚ, ΓΙΑ ΕΠΙΤΡΑΠΕΖΙΑ ΠΑΙΧΝΙΔΙΑ Η ΓΙΑ ΠΑΙΧΝΙΔΙΑ ΣΥΝΑΝΑΣΤΡΟΦΗΣ, ΑΛΛΩΝ ΠΑΙΧΝΙΔΙΩΝ ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΝΟΜΙΣΜΑΤΟΔΕΚΤΗ Η ΜΕ ΔΙΣΚΕΤΑ',
  },
  {
    label: '46493203',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΜΟΝΤΕΛΙΣΜΟΥ',
  },
  {
    label: '46493204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΚΛΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΠΟΥ ΑΝΑΠΑΡΙΣΤΟΥΝ ΜΟΝΟ ΑΝΘΡΩΠΙΝΕΣ ΥΠΑΡΞΕΙΣ',
  },
  {
    label: '46493205',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΓΝΙΟΧΑΡΤΩΝ (ΤΡΑΠΟΥΛΩΝ)',
  },
  {
    label: '46493206',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΔΙΚΩΝ ΤΡΕΝΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ, ΑΛΛΩΝ ΜΟΝΤΕΛΩΝ Η ΚΑΤΑΣΚΕΥΩΝ ΥΠΟ ΚΛΙΜΑΚΑ ΚΑΙ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΠΑΙΧΝΙΔΙΩΝ',
  },
  {
    label: '46493207',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΧΝΙΔΙΩΝ ΒΙΝΤΕΟ, ΠΟΥ ΠΑΙΖΟΝΤΑΙ ΜΕ ΤΗΛΕΟΠΤΙΚΟ ΔΕΚΤΗ',
  },
  {
    label: '46493208',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΧΝΙΔΙΩΝ ΠΟΥ ΑΝΑΠΑΡΙΣΤΟΥΝ ΖΩΑ Η ΜΗ ΑΝΘΡΩΠΙΝΕΣ ΥΠΑΡΞΕΙΣ',
  },
  {
    label: '46493209',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΝΑΡΜΟΛΟΓΟΥΜΕΝΩΝ ΠΑΙΧΝΙΔΙΩΝ ~ ΣΠΑΖΟΚΕΦΑΛΙΩΝ',
  },
  {
    label: '46493210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΡΟΧΟΦΟΡΩΝ ΠΑΙΧΝΙΔΙΩΝ ΣΧΕΔΙΑΣΜΕΝΩΝ ΓΙΑ ΝΑ ΕΠΙΒΑΙΝΟΝΤΑΙ ΑΠΟ ΠΑΙΔΙΑ, ΚΑΡΟΤΣΙΩΝ ΓΙΑ ΚΟΥΚΛΕΣ',
  },
  {
    label: '46493300',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΘΛΗΤΙΚΩΝ ΕΙΔΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΠΟΔΗΛΑΤΩΝ)',
  },
  {
    label: '46493301',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΕΡΟΣΤΑΤΩΝ, ΠΗΔΑΛΙΟΥΧΟΥΜΕΝΩΝ ΚΑΙ ΑΛΛΩΝ ΜΗ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΑΕΡΟΣΚΑΦΩΝ',
  },
  {
    label: '46493302',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΕΞΙΠΤΩΤΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΠΗΔΑΛΙΟΥΧΟΥΜΕΝΑ ΑΛΕΞΙΠΤΩΤΑ) ΚΑΙ ΣΤΡΟΦΟΠΤΩΤΩΝ, ΚΑΘΩΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46493303',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΑΘΛΗΤΙΣΜΟ Η ΓΙΑ ΥΠΑΙΘΡΙΟΥΣ ΑΓΩΝΕΣ, ΚΟΛΥΜΒΗΤΙΚΩΝ ΔΕΞΑΜΕΝΩΝ ΚΑΙ ΔΕΞΑΜΕΝΩΝ ΚΩΠΗΛΑΣΙΑΣ',
  },
  {
    label: '46493304',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΣΚΑΦΩΝ ΓΙΑ ΑΝΑΨΥΧΗ Η ΑΘΛΗΤΙΣΜΟ, ΚΩΠΗΛΑΤΩΝ ΒΑΡΚΩΝ ΚΑΙ ΚΑΝΟ',
  },
  {
    label: '46493305',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΠΝΕΥΣΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΔΥΤΩΝ',
  },
  {
    label: '46493306',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΕΜΟΠΤΕΡΩΝ ΚΑΙ ΑΙΩΡΟΠΛΑΝΩΝ',
  },
  {
    label: '46493307',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΕΙΔΩΝ ΓΙΑ ΠΟΔΗΛΑΤΑ',
  },
  {
    label: '46493308',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΙΝΩΝ ΣΥΝΟΛΩΝ ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '46493309',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΥΜΝΑΣΤΙΚΗΣ Η ΑΘΛΗΤΙΣΜΟΥ',
  },
  {
    label: '46493310',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΚΥΝΗΓΙΟΥ (ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΚΑΙ ΤΩΝ ΟΠΛΩΝ ΚΥΝΗΓΙΟΥ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46493311',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΠΟΒΡΥΧΙΑΣ ΑΛΙΕΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46493312',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΩΛΕΜΒΙΩΝ ΚΙΝΗΤΗΡΩΝ ΓΙΑ ΠΡΟΩΘΗΣΗ',
  },
  {
    label: '46493313',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΙΣΤΙΟΦΟΡΩΝ ΓΙΑ ΑΝΑΨΥΧΗ Η ΑΘΛΗΤΙΣΜΟ',
  },
  {
    label: '46493314',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΙΣΤΙΩΝ ΓΙΑ ΣΚΑΦΗ, ΙΣΤΙΟΣΑΝΙΔΕΣ Η ΙΣΤΙΟΦΟΡΑ ΟΧΗΜΑΤΑ, ΑΛΛΩΝ ΣΚΗΝΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΤΑΣΚΗΝΩΣΗΣ',
  },
  {
    label: '46493315',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΑΜΙΩΝ ΨΑΡΕΜΑΤΟΣ, ΑΛΛΩΝ ΣΥΝΕΡΓΩΝ ΨΑΡΕΜΑΤΟΣ ΜΕ ΠΕΤΟΝΙΑ, ΕΙΔΩΝ ΚΥΝΗΓΙΟΥ Η ΨΑΡΕΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46493316',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΣΤΙΓΙΩΝ, ΜΑΣΤΙΓΙΩΝ ΙΠΠΑΣΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46493317',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΠΟΔΗΛΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΤΡΟΧΩΝ, ΧΩΡΙΣ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '46493318',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΠΑΛΟΝΙΩΝ',
  },
  {
    label: '46493319',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΠΟΤΩΝ ΤΟΥ ΣΚΙ ΚΑΙ ΥΠΟΔΗΜΑΤΩΝ ΧΙΟΝΟΠΟΡΕΙΑΣ',
  },
  {
    label: '46493320',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΑΥΤΙΛΙΑΚΩΝ ΕΙΔΩΝ, ΑΠΟ ΑΥΤΑ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΚΥΡΙΩΣ ΣΤΗΝ ΕΡΑΣΙΤΕΧΝΙΚΗ ΝΑΥΤΙΛΙΑ',
  },
  {
    label: '46493321',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ Η ΠΛΑΣΤΙΚΩΝ ΛΕΜΒΩΝ, ΓΙΑ ΑΝΑΨΥΧΗ Η ΑΘΛΗΤΙΣΜΟ',
  },
  {
    label: '46493322',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΧΝΙΔΙΩΝ ΘΑΛΑΣΣΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΝΑΨΥΧΗΣ',
  },
  {
    label: '46493323',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΔΙΛΩΝ ΓΙΑ ΘΑΛΑΣΣΙΟ ΣΚΙ, ΚΥΜΑΤΟΣΑΝΙΔΩΝ, ΙΣΤΙΟΣΑΝΙΔΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΝΑΥΤΙΚΑ ΑΘΛΗΜΑΤΑ',
  },
  {
    label: '46493324',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΔΗΛΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΤΡΟΧΩΝ, ΧΩΡΙΣ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '46493325',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΔΗΛΑΤΩΝ, ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46493326',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΗΝΩΝ',
  },
  {
    label: '46493327',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΩΣΙΒΙΩΝ ΧΙΤΩΝΩΝ ΚΑΙ ΣΩΣΙΒΙΩΝ',
  },
  {
    label: '46493328',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΝΟΣΑΚΩΝ',
  },
  {
    label: '46493329',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΟΥΣΚΩΤΩΝ ΣΚΑΦΩΝ ΓΙΑ ΑΝΑΨΥΧΗ Η ΑΘΛΗΤΙΣΜΟ',
  },
  {
    label: '46493330',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΙΟΝΟΠΕΔΙΛΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΧΙΟΝΟΠΕΔΙΛΑ, ΠΑΓΟΠΕΔΙΛΑ ΚΑΙ ΤΡΟΧΟΠΕΔΙΛΑ, ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46493400',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΤΑΞΙΔΙΟΥ',
  },
  {
    label: '46493401',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΔΕΡΜΑ Η ΣΥΝΘΕΤΙΚΑ ΔΕΡΜΑΤΑ (ΧΩΡΙΣ ΤΑ ΕΙΔΗ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΜΗΧΑΝΗΜΑΤΑ Η ΑΛΛΕΣ ΜΗΧΑΝΙΚΕΣ ΣΥΣΚΕΥΕΣ)',
  },
  {
    label: '46493402',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΣΚΕΥΩΝ, ΤΣΑΝΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΚΑΘΕ ΥΛΙΚΟ',
  },
  {
    label: '46493403',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΣΕΛΟΠΟΙΙΑΣ ΚΑΙ ΣΑΓΗΣ, ΑΠΟ ΚΑΘΕ ΥΛΙΚΟ',
  },
  {
    label: '46493404',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΛΑΡΩΝ ΓΙΑ ΓΑΤΕΣ ΚΑΙ ΣΚΥΛΟΥΣ ΚΑΙ ΛΟΥΡΙΩΝ',
  },
  {
    label: '46493405',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΡΙΩΝ ΚΑΙ ΑΛΥΣΙΔΩΝ ΡΟΛΟΓΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46493406',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΟΦΥΛΑΚΩΝ ΑΠΟ ΔΕΡΜΑ Η ΑΠΟ ΑΛΛΗ ΥΛΗ',
  },
  {
    label: '46493500',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΡΑΜΜΑΤΟΣΗΜΩΝ ΚΑΙ ΝΟΜΙΣΜΑΤΩΝ',
  },
  {
    label: '46493501',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΟΜΙΣΜΑΤΩΝ ΚΑΙ ΜΕΤΑΛΛΙΩΝ',
  },
  {
    label: '46493502',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΛΑΙΩΝ ΓΡΑΜΜΑΤΟΣΗΜΩΝ',
  },
  {
    label: '46493503',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΛΛΟΓΩΝ ΓΡΑΜΜΑΤΟΣΗΜΩΝ ΚΑΙ ΝΟΜΙΣΜΑΤΩΝ',
  },
  {
    label: '46493600',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΛΙΤΕΧΝΙΚΩΝ ΚΑΙ ΑΝΑΜΝΗΣΤΙΚΩΝ (ΣΟΥΒΕΝΙΡ) ΕΙΔΩΝ',
  },
  {
    label: '46493601',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΓΑΛΜΑΤΙΩΝ, ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46493602',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΙΚΩΝ',
  },
  {
    label: '46493603',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΧΑΙΟΤΗΤΩΝ ΚΑΙ ΓΕΝΙΚΑ ΠΑΛΑΙΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ ΤΕΧΝΗΣ',
  },
  {
    label: '46493604',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΙΕΡΟΓΡΑΦΙΩΝ, ΕΙΚΟΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46493900',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΑΤΑΝΑΛΩΤΙΚΩΝ ΑΓΑΘΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46493901',
    value: 'ΕΞΑΓΩΓΗ ΨΕΥΔΟΚΟΣΜΗΜΑΤΩΝ ΑΠΟ ΚΑΘΕ ΥΛΗ',
  },
  {
    label: '46493902',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΒΟΥΡΤΣΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46493903',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΟΛΥΤΕΛΩΝ ΜΙΚΡΟΑΝΤΙΚΕΙΜΕΝΩΝ, ΟΧΙ ΑΠΟ ΠΟΛΥΤΙΜΑ ΜΕΤΑΛΛΑ Η ΛΙΘΟΥΣ',
  },
  {
    label: '46493904',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΠΤΗΡΩΝ ΤΣΙΓΑΡΩΝ ΚΑΙ ΑΛΛΩΝ ΑΝΑΠΤΗΡΩΝ, ΠΙΠΩΝ ΚΑΠΝΙΣΜΑΤΟΣ ΚΑΙ ΠΙΠΩΝ ΓΙΑ ΠΟΥΡΑ Η ΤΣΙΓΑΡΑ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46493905',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΜΙΜΗΣΕΩΝ ΚΟΣΜΗΜΑΤΩΝ',
  },
  {
    label: '46493906',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΟΥΡΤΣΑΚΙΩΝ ΤΟΥΑΛΕΤΑΣ ΓΙΑ ΠΡΟΣΩΠΙΚΗ ΧΡΗΣΗ, ΒΟΥΡΤΣΑΚΙΩΝ ΓΙΑ ΚΑΛΛΥΝΤΙΚΑ ΚΑΙ ΟΔΟΝΤΟΒΟΥΡΤΣΩΝ',
  },
  {
    label: '46493907',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΚΕΡΙΩΝ',
  },
  {
    label: '46493908',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΗΜΙΣΤΙΚΩΝ ΕΙΔΩΝ (ΜΠΡΕΛΟΚ, ΜΠΛΟΥΖΩΝ, ΑΝΑΠΤΗΡΩΝ, ΣΤΥΛΟ ΚΛΠ)',
  },
  {
    label: '46493909',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΑΛΛΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46493910',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΔΙΑΚΟΣΜΗΣΗΣ ΕΣΩΤΕΡΙΚΩΝ ΧΩΡΩΝ',
  },
  {
    label: '46493911',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΟΡΤΑΣΤΙΚΩΝ, ΑΠΟΚΡΙΑΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΨΥΧΑΓΩΓΙΚΩΝ ΕΙΔΩΝ, ΣΤΑ ΟΠΟΙΑ ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΤΑ ΤΑΧΥΔΑΚΤΥΛΟΥΡΓΙΚΑ ΤΕΧΝΑΣΜΑΤΑ (ΤΡΙΚ) ΚΑΙ ΤΑ ΕΙΔΗ;ΕΚΠΛΗΞΕΙΣ',
  },
  {
    label: '46493912',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΔΡΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΕΣ, ΠΙΝΑΚΕΣ Η ΠΑΡΟΜΟΙΑ ΕΙΔΗ ΚΑΙ ΚΑΘΡΕΠΤΕΣ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΔΙΑΚΟΣΜΗΣΗΣ, ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46493913',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΙΩΝ, ΚΗΡΩΜΕΝΩΝ ΦΙΤΙΛΙΩΝ ΦΩΤΙΣΜΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46493914',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΣΟΥΡΙΩΝ, ΚΑΡΟΥΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΔΙΗΘΗΤΙΚΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ, ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΧΑΡΤΙ ΚΑΙ ΧΑΡΤΟΝΙ Π.Δ.Κ.Α.',
  },
  {
    label: '46493915',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΨΕΥΔΟΚΟΣΜΗΜΑΤΩΝ',
  },
  {
    label: '46493916',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΙΚΩΝ ΣΦΡΑΓΙΔΩΝ, ΕΠΙΓΡΑΦΩΝ, ΣΗΜΑΤΩΝ ΚΛΠ',
  },
  {
    label: '46493917',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΥΦΙΚΩΝ ΚΑΙ ΒΑΠΤΙΣΤΙΚΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α. (ΛΑΜΠΑΔΩΝ, ΣΤΕΦΑΝΩΝ ΚΛΠ)',
  },
  {
    label: '46493918',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΔΙΚΩΝ ΑΜΑΞΙΩΝ',
  },
  {
    label: '46493919',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΔΙΚΩΝ ΚΑΡΟΤΣΙΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46493920',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΟΥΚΩΝ ΚΑΙ ΠΟΣΤΙΣ',
  },
  {
    label: '46493921',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΙΝΕΛΩΝ ΖΩΓΡΑΦΙΚΗΣ, ΓΡΑΦΗΣ',
  },
  {
    label: '46493922',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΑΝΘΡΩΠΙΝΕΣ Η ΖΩΙΚΕΣ ΤΡΙΧΕΣ, ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΕΣ ΙΝΕΣ',
  },
  {
    label: '46493923',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΡΩΘΡΩΝ',
  },
  {
    label: '46493924',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΟΥΠΩΝ ΚΑΙ ΒΟΥΡΤΣΩΝ, ΓΙΑ ΤΗΝ ΟΙΚΙΑΚΗ ΚΑΘΑΡΙΟΤΗΤΑ',
  },
  {
    label: '46493925',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΙΡΤΩΝ',
  },
  {
    label: '46493926',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΦΡΑΓΙΔΩΝ ΑΠΟ ΚΑΟΥΤΣΟΥΚ',
  },
  {
    label: '46493927',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ ΑΝΘΕΩΝ, ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΦΥΛΛΩΜΑΤΩΝ ΚΑΙ ΦΡΟΥΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46493928',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΓΡΟΥ Η ΥΓΡΟΠΟΙΗΜΕΝΟΥ ΑΕΡΙΟΥ ΓΙΑ ΓΕΜΙΣΜΑ ΑΝΑΠΤΗΡΩΝ',
  },
  {
    label: '46493929',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΡΙΣΤΟΥΓΕΝΝΙΑΤΙΚΩΝ ΕΙΔΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '46493930',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΤΕΝΩΝ, ΤΣΙΜΠΙΔΙΩΝ ΜΑΛΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΦΟΥΡΚΕΤΩΝ, ΛΑΒΙΔΩΝ ΚΑΤΣΑΡΩΜΑΤΟΣ, ΨΕΚΑΣΤΗΡΩΝ ΑΡΩΜΑΤΩΝ ΚΑΙ ΒΑΣΕΩΝ ΤΟΥΣ, ΠΟΜΠΟΝ ΚΑΙ ΤΑΜΠΟΝ ΠΟΥΔΡΑΡΙΣΜΑΤΟΣ',
  },
  {
    label: '46510000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ, ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΛΟΓΙΣΜΙΚΟΥ',
  },
  {
    label: '46511001',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΟΝΑΔΩΝ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46511002',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΛΟΓΙΚΩΝ Η ΥΒΡΙΔΙΚΩΝ ΜΗΧΑΝΩΝ ΑΥΤΟΜΑΤΗΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '46511003',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΣΚΕΤΩΝ, ΜΑΓΝΗΤΙΚΩΝ ΤΑΙΝΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΣΚΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ',
  },
  {
    label: '46511004',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΓΝΗΤΙΚΩΝ Η ΟΠΤΙΚΩΝ ΑΝΑΓΝΩΣΤΩΝ',
  },
  {
    label: '46511005',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΥΠΟΛΟΓΙΣΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '46511006',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΣΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΑΙ ΜΕΤΑΦΟΡΑΣ ΔΕΔΟΜΕΝΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΑΥΤΟΜΑΤΕΣ ΜΗΧΑΝΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '46511007',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΝΑΔΩΝ ΕΙΣΟΔΟΥ Η ΕΞΟΔΟΥ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ Η ΟΧΙ ΣΤΟ ΙΔΙΟ ΠΕΡΙΒΛΗΜΑ ΜΟΝΑΔΕΣ ΜΝΗΜΗΣ',
  },
  {
    label: '46511008',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΝΑΔΩΝ ΜΝΗΜΗΣ',
  },
  {
    label: '46511009',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΓΡΑΜΜΑΤΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ',
  },
  {
    label: '46511010',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΟΡΗΤΩΝ ΨΗΦΙΑΚΩΝ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ, ΒΑΡΟΥΣ <= 10 ~ KG, ΟΠΩΣ ΑΥΤΕΣ ΤΩΝ ΤΥΠΩΝ \\LAPTOPS\\, \\NOTEBOOKS\\ ΚΑΙ \\SUB;NOTEBOOKS\\',
  },
  {
    label: '46511011',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΗΦΙΑΚΩΝ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '46511012',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΗΦΙΑΚΩΝ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ ΠΟΥ ΠΑΡΟΥΣΙΑΖΟΝΤΑΙ ΥΠΟ ΜΟΡΦΗ ΣΥΣΤΗΜΑΤΩΝ',
  },
  {
    label: '46520000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΝΙΚΟΥ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '46521100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '46521101',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΚΤΩΝ ΡΑΔΙΟΤΗΛΕΦΩΝΙΑΣ Η ΡΑΔΙΟΤΗΛΕΓΡΑΦΙΑΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46521102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΚΑΙ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΙΝΗΤΗΣ ΤΗΛΕΦΩΝΙΑΣ',
  },
  {
    label: '46521103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΥΧΝΙΩΝ ΤΗΛΕΟΡΑΣΗΣ, ΚΑΘΟΔΙΚΩΝ ΑΚΤΙΝΩΝ, ΛΥΧΝΙΩΝ ΓΙΑ ΤΗΛΕΟΠΤΙΚΕΣ ΜΗΧΑΝΕΣ ΛΗΨΗΣ, ΑΛΛΩΝ ΛΥΧΝΙΩΝ ΜΙΚΡΟΚΥΜΑΤΩΝ ΚΑΙ ΚΑΘΟΔΙΚΩΝ ΑΚΤΙΝΩΝ',
  },
  {
    label: '46521104',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΤΗΛΕΦΩΝΙΚΩΝ Η ΤΗΛΕΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46521105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΕΚΠΟΜΠΗΣ ΓΙΑ ΤΗ ΡΑΔΙΟΤΗΛΕΦΩΝΙΑ, ΡΑΔΙΟΤΗΛΕΓΡΑΦΙΑ, ΡΑΔΙΟΤΗΛΕΟΠΤΙΚΗ ΜΕΤΑΔΟΣΗ',
  },
  {
    label: '46521106',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΚΙΝΗΤΗΣ ΤΗΛΕΦΩΝΙΑΣ ΚΑΙ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΤΟΥΣ',
  },
  {
    label: '46521107',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΡΑΝΤΑΡ, ΡΑΔΙΟΝΑΥΣΙΠΛΟΪΑΣ ΚΑΙ ΡΑΔΙΟΤΗΛΕΧΕΙΡΙΣΜΟΥ',
  },
  {
    label: '46521108',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΤΗΛΕΟΜΟΙΟΤΥΠΙΑΣ',
  },
  {
    label: '46521109',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΗΛΕΦΩΝΙΚΩΝ ΚΕΝΤΡΩΝ, ΣΥΜΒΑΤΙΚΩΝ ΤΗΛΕΦΩΝΩΝ, ΘΥΡΟΤΗΛΕΦΩΝΩΝ ΚΑΙ ΛΟΙΠΟΥ ΤΗΛΕΦΩΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46521200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΟΥ ΗΛΕΚΤΡΟΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '46521300',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΝΩΝ ΚΑΣΕΤΩΝ ΚΑΙ ΔΙΣΚΕΤΩΝ ΜΟΥΣΙΚΗΣ ΚΑΙ ΒΙΝΤΕΟ, ΜΑΓΝΗΤΙΚΩΝ ΚΑΙ ΟΠΤΙΚΩΝ ΔΙΣΚΩΝ',
  },
  {
    label: '46521301',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΓΡΑΦΩΝ ΔΙΣΚΩΝ ΓΡΑΜΜΟΦΩΝΟΥ, ΒΙΝΥΛΙΟΥ ΚΑΙ ΟΠΤΙΚΩΝ ΔΙΣΚΩΝ',
  },
  {
    label: '46521302',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΑΓΡΑΦΩΝ ΒΙΝΤΕΟΚΑΣΕΤΩΝ ΚΑΙ ΚΑΣΕΤΩΝ ΜΑΓΝΗΤΟΦΩΝΟΥ ΚΑΙ ΟΠΤΙΚΩΝ ΔΙΣΚΩΝ',
  },
  {
    label: '46521303',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΑΓΡΑΦΩΝ ΜΕΣΩΝ ΓΙΑ ΗΧΟΓΡΑΦΗΣΕΙΣ Η ΠΑΡΟΜΟΙΕΣ ΕΓΓΡΑΦΕΣ ΑΛΛΩΝ ΦΑΙΝΟΜΕΝΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΕΣ ΤΑΙΝΙΕΣ)',
  },
  {
    label: '46610000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΕΩΡΓΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ, ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ',
  },
  {
    label: '46611000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΓΡΟΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ, ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ',
  },
  {
    label: '46611100',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΓΡΟΤΙΚΩΝ ΚΑΙ ΔΑΣΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ, ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΕΛΚΥΣΤΗΡΩΝ',
  },
  {
    label: '46611101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΓΡΟΤΙΚΩΝ ΕΛΚΥΣΤΗΡΩΝ',
  },
  {
    label: '46611102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΓΕΩΡΓΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '46611103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΑΓΡΟΤΙΚΩΝ ΚΑΙ ΔΑΣΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '46611104',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΜΑΞΩΜΑΤΩΝ ΓΙΑ ΓΕΩΡΓΙΚΟΥΣ ΚΑΙ ΔΑΣΙΚΟΥΣ ΕΛΚΥΣΤΗΡΕΣ',
  },
  {
    label: '46611105',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΔΕΥΤΙΚΩΝ ΣΥΓΚΡΟΤΗΜΑΤΩΝ',
  },
  {
    label: '46611106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΜΕΚΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '46611107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΟΤΡΩΝ ΚΑΙ ΔΙΣΚΟΣΒΑΡΝΩΝ',
  },
  {
    label: '46611108',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΕΩΡΓΙΚΩΝ ΚΑΙ ΔΑΣΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46611109',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΕΩΡΓΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46611110',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΕΩΡΓΙΚΩΝ, ΔΑΣΟΚΟΜΙΚΩΝ, ΠΤΗΝΟΤΡΟΦΙΚΩΝ Η ΜΕΛΙΣΣΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46611111',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΣΚΟΡΠΙΣΤΩΝ ΚΟΠΡΙΑΣ ΚΑΙ ΔΙΑΝΟΜΕΩΝ ΛΙΠΑΣΜΑΤΩΝ',
  },
  {
    label: '46611112',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΑΠΟ ΤΥΡΦΗ',
  },
  {
    label: '46611113',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΜΒΟΛΟΦΟΡΩΝ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΓΙΑ ΑΓΡΟΤΙΚOΥΣ ΚΑΙ ΔΑΣΙΚΟΥΣ ΕΛΚΥΣΤΗΡΕΣ',
  },
  {
    label: '46611114',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΘΕΡΙΣΤΙΚΩΝ ΚΑΙ ΑΛΩΝΙΣΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46611115',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗ ΓΕΩΡΓΙΑ ΚΑΙ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ Η ΤΗ ΣΥΣΚΕΥΑΣΙΑ ΑΓΑΘΩΝ',
  },
  {
    label: '46611116',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΓΕΩΡΓΙΚΩΝ ΚΑΙ ΔΑΣΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '46611117',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΕΛΚΥΣΤΗΡΩΝ',
  },
  {
    label: '46611118',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΕΚΤΟΞΕΥΣΗ, ΔΙΑΣΠΟΡΑ Η ΨΕΚΑΣΜΟ ΥΓΡΩΝ Η ΚΟΝΙΟΠΟΙΗΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ ΓΙΑ ΤΗ ΓΕΩΡΓΙΑ',
  },
  {
    label: '46611119',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΑΡΑΣΚΕΥΗ ΖΩΟΤΡΟΦΩΝ, ΠΤΗΝΟΤΡΟΦΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ, ΕΠΩΑΣΤΗΡΩΝ ΚΑΙ ΑΝΑΘΡΕΦΤΗΡΩΝ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '46611120',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΣΠΟΡΑΣ, ΦΥΤΕΥΣΗΣ ΚΑΙ ΜΕΤΑΦΥΤΕΥΣΗΣ',
  },
  {
    label: '46611121',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΙΚΩΝ ΓΕΩΡΓΙΚΩΝ ΕΡΓΑΛΕΙΩΝ, ΕΚΤΟΣ ΑΠΟ ΑΥΤΑ ΤΗΣ ΧΕΙΡΟΣ',
  },
  {
    label: '46611122',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΩΝ ΔΕΜΑΤΙΣΜΟΥ ΑΧΥΡΟΥ Η ΧΟΡΤΟΝΟΜΗΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΣΥΛΛΕΚΤΙΚΕΣ;ΣΥΜΠΙΕΣΤΙΚΕΣ ΜΗΧΑΝΕΣ)',
  },
  {
    label: '46611123',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΥΜΟΥΛΚΟΥΜΕΝΩΝ Η ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΩΝ ΟΧΗΜΑΤΩΝ ΠΟΥ ΔΙΑΘΕΤΟΥΝ ΣΥΣΤΗΜΑΤΑ ΦΟΡΤΩΣΗΣ Η ΕΚΦΟΡΤΩΣΗΣ ΓΙΑ ΓΕΩΡΓΙΚΟΥΣ ΣΚΟΠΟΥΣ',
  },
  {
    label: '46611124',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΒΑΡΝΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΔΙΣΚΟΣΒΑΡΝΕΣ), ΑΝΑΜΟΧΛΕΥΤΗΡΩΝ, ΚΑΛΛΙΕΡΓΗΤΙΚΩΝ ΜΗΧΑΝΩΝ, ΣΚΑΛΙΣΤΗΡΙΩΝ ΚΑΙ ΤΣΑΠΩΝ',
  },
  {
    label: '46611125',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΟΡΤΟΚΟΠΤΙΚΩΝ ΜΗΧΑΝΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΡΑΒΔΟΙ ΚΟΠΗΣ ΓΙΑ ΣΥΝΑΡΜΟΛΟΓΗΣΗ ΕΛΚΥΣΤΗΡΩΝ) Π.Δ.Κ.Α.',
  },
  {
    label: '46611200',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ, ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ ΣΧΕΤΙΚΩΝ ΜΕ ΤΟ ΓΡΑΣΙΔΙ ΚΑΙ ΤΟΝ ΚΗΠΟ',
  },
  {
    label: '46611201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΣΚΟΡΠΙΣΤΩΝ ΚΟΠΡΙΑΣ ΚΑΙ ΔΙΑΝΟΜΕΩΝ ΛΙΠΑΣΜΑΤΩΝ, ΓΙΑ ΤΟ ΓΡΑΣΙΔΙ ΚΑΙ ΤΟΝ ΚΗΠΟ',
  },
  {
    label: '46611202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΑΠΟ ΤΥΡΦΗ, ΓΙΑ ΤΟ ΓΡΑΣΙΔΙ ΚΑΙ ΤΟΝ ΚΗΠΟ',
  },
  {
    label: '46611203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΚΥΣΤΗΡΩΝ ΟΔΗΓΟΥΜΕΝΩΝ ΑΠΟ ΠΕΖΟΥΣ, ΓΙΑ ΤΟ ΓΡΑΣΙΔΙ ΚΑΙ ΤΟΝ ΚΗΠΟ',
  },
  {
    label: '46611204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΕΚΤΟΞΕΥΣΗ, ΔΙΑΣΠΟΡΑ Η ΨΕΚΑΣΜΟ ΥΓΡΩΝ Η ΚΟΝΙΟΠΟΙΗΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ ΓΙΑ ΤΗΝ ΚΗΠΟΥΡΙΚΗ',
  },
  {
    label: '46611205',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α., ΣΤΡΩΤΗΡΩΝ, ΓΙΑ ΧΟΡΤΟΤΑΠΗΤΕΣ Η ΑΘΛΗΤΙΚΑ ΓΗΠΕΔΑ',
  },
  {
    label: '46611206',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΒΑΡΝΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΔΙΣΚΟΣΒΑΡΝΕΣ), ΑΝΑΜΟΧΛΕΥΤΗΡΩΝ, ΚΑΛΛΙΕΡΓΗΤΙΚΩΝ ΜΗΧΑΝΩΝ, ΣΚΑΛΙΣΤΗΡΙΩΝ ΚΑΙ ΤΣΑΠΩΝ, ΓΙΑ ΤΟ ΓΡΑΣΙΔΙ ΚΑΙ ΤΟΝ ΚΗΠΟ',
  },
  {
    label: '46611207',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΟΡΤΟΚΟΠΤΙΚΩΝ ΜΗΧΑΝΩΝ ΓΙΑ ΧΛΟΟΤΑΠΗΤΕΣ, ΠΑΡΚΑ Η ΑΘΛΗΤΙΚΑ ΓΗΠΕΔΑ',
  },
  {
    label: '46620000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ',
  },
  {
    label: '46621100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΞΥΛΕΙΑΣ',
  },
  {
    label: '46621101',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΞΥΛΟΥ, ΦΕΛΛΟΥ, ΚΟΚΑΛΟΥ, ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ, ΣΚΛΗΡΟΥ ΠΛΑΣΤΙΚΟΥ Η ΠΑΡΟΜΟΙΩΝ ΣΚΛΗΡΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46621200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '46621201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΕΞΟΜΑΛΥΝΣΗ ΕΠΙΦΑΝΕΙΩΝ, ΓΙΑ ΑΚΟΝΙΣΜΑ, ΤΡΟΧΙΣΜΑ, ΠΛΑΝΙΣΜΑ, ΠΡΙΟΝΙΣΜΑ, ΚΟΠΗ Η ΑΛΛΕΣ ΕΡΓΑΣΙΕΣ ΤΕΛΕΙΩΜΑΤΟΣ ΣΕ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46621202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΚΑΤΕΡΓΑΣΙΑ ΟΠΟΙΟΥΔΗΠΟΤΕ ΥΛΙΚΟΥ ΜΕ ΑΦΑΙΡΕΣΗ ΥΛΗΣ, ΜΕ ΛΕΙΖΕΡ, ΜΕ ΥΠΕΡΗΧΟΥΣ ΚΑΙ ΠΑΡΟΜΟΙΕΣ ΜΕΘΟΔΟΥΣ',
  },
  {
    label: '46621203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗ ΔΙΑΤΡΗΣΗ, ΤΗ ΔΙΑΝΟΙΞΗ ΟΠΩΝ Η ΤΟ ΦΡΕΖΑΡΙΣΜΑ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '46621204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ Π.Δ.Κ.Α. ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΟΥ, ΠΕΡΙΤΕΤΗΓΜΕΝΩΝ ΜΕΤΑΛΛΙΚΩΝ ΚΑΡΒΙΔΙΩΝ Η ΚΕΡΑΜΟΜΕΤΑΛΛΩΝ, ΧΩΡΙΣ ΑΦΑΙΡΕΣΗ ΥΛΙΚΟΥ',
  },
  {
    label: '46621205',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ ΓΙΑ ΜΑΛΑΚΗ ΣΥΓΚΟΛΛΗΣΗ, ΣΚΛΗΡΗ ΣΥΓΚΟΛΛΗΣΗ ΚΑΙ ΘΕΡΜΟΣΥΓΚΟΛΛΗΣΗ, ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΕΠΙΦΑΝΕΙΑΚΗ ΒΑΦΗ ΚΑΙ ΘΕΡΜΟ ΨΕΚΑΣΜΟ, ΟΧΙ ΧΕΙΡΟΣ',
  },
  {
    label: '46621206',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΩΝ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ',
  },
  {
    label: '46621207',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΕΡΓΑΛΕΙΟΜΗΧΑΝΕΣ ΚΑΤΕΡΓΑΣΙΑΣ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '46621208',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΟΥΡΓΕΙΩΝ, ΜΗΧΑΝΩΝ ΣΤΑΘΕΡΗΣ ΘΕΣΗΣ ΚΑΙ ΜΗΧΑΝΩΝ ΠΟΛΛΑΠΛΩΝ ΘΕΣΕΩΝ, ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '46621209',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΩΝ ΓΙΑ ΚΑΜΨΗ, ΔΙΠΛΩΣΗ, ΙΣΙΩΜΑ Η ΕΠΙΠΕΔΟΠΟΙΗΣΗ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '46621210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΩΝ ΚΑΙ ΣΦΥΡΙΩΝ ΓΙΑ ΣΦΥΡΗΛΑΣΙΑ Η ΑΝΙΣΟΠΑΧΗ ΤΥΠΩΣΗ, ΥΔΡΑΥΛΙΚΩΝ ΠΡΕΣΩΝ ΚΑΙ ΠΡΕΣΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '46621211',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΟΡΝΩΝ ΓΙΑ ΑΦΑΙΡΕΣΗ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '46621900',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΑΛΛΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46621901',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΕΙΔΙΚΩΝ ΠΡΟΣΑΡΤΗΜΑΤΩΝ ΓΙΑ ΕΡΓΑΛΕΙΟΜΗΧΑΝΕΣ',
  },
  {
    label: '46621902',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΛΙΘΩΝ, ΚΕΡΑΜΙΚΩΝ, ΣΚΥΡΟΔΕΜΑΤΟΣ Η ΠΑΡΟΜΟΙΩΝ ΟΡΥΚΤΩΝ ΥΛΙΚΩΝ ΓΙΑ ΤΗΝ ΨΥΧΡΗ ΚΑΤΕΡΓΑΣΙΑ ΤΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '46621903',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΦΟΡΕΩΝ ΚΑΙ ΑΥΤΟΑΝΟΙΓΟΜΕΝΩΝ ΣΥΡΜΑΤΩΤΗΡΩΝ',
  },
  {
    label: '46621904',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΜΗΧΑΝΙΚΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ, ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΟ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ (ΕΚΤΟΣ ΑΠΟ ΚΛΑΔΕΥΤΙΚΕΣ ΨΑΛΙΔΕΣ ΦΡΑΚΤΩΝ, ΨΑΛΙΔΕΣ ΚΟΠΗΣ ΧΛΟΟΤΑΠΗΤΑ, ΜΗΧΑΝΕΣ ΚΟΠΗΣ ΤΩΝ ΑΚΡΩΝ ΤΗΣ ΧΛΟΗΣ)',
  },
  {
    label: '46630000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΡΥΚΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ, ΚΑΘΩΣ ΚΑΙ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΚΑΤΑΣΚΕΥΑΣΤΙΚΑ ΕΡΓΑ ΚΑΙ ΕΡΓΑ ΠΟΛΙΤΙΚΟΥ ΜΗΧΑΝΙΚΟΥ',
  },
  {
    label: '46631000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΡΥΚΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΚΑΤΑΣΚΕΥΑΣΤΙΚΑ ΕΡΓΑ ΚΑΙ ΕΡΓΑ ΠΟΛΙΤΙΚΟΥ ΜΗΧΑΝΙΚΟΥ',
  },
  {
    label: '46631001',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΚΣΚΑΦΗΣ',
  },
  {
    label: '46631002',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΛΙΩΝ ΣΚΥΡΟΔΕΜΑΤΟΣ',
  },
  {
    label: '46631003',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΥΨΩΤΗΡΩΝ ΚΑΙ ΙΜΑΝΤΩΝ ΜΕΤΑΦΟΡΑΣ ΣΥΝΕΧΟΥΣ ΛΕΙΤΟΥΡΓΙΑΣ, ΓΙΑ ΥΠΟΓΕΙΑ',
  },
  {
    label: '46631004',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΑΠΟΞΕΣΤΩΝ ΔΡΟΜΩΝ, ΙΣΟΠΕΔΩΤΗΡΩΝ ΚΑΙ ΟΜΑΛΥΝΤΗΡΩΝ',
  },
  {
    label: '46631005',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΜΗΧΑΝΙΚΩΝ ΦΤΥΑΡΙΩΝ, ΕΚΣΚΑΦΕΩΝ ΚΑΙ ΠΤΥΟΦΟΡΩΝ ΦΟΡΤΩΤΩΝ',
  },
  {
    label: '46631006',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΠΤΥΟΦΟΡΩΝ ΦΟΡΤΩΤΩΝ ΠΡΟΣΘΙΑΣ ΦΟΡΤΩΣΗΣ',
  },
  {
    label: '46631007',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΣΥΜΠΙΕΣΤΩΝ ΚΑΙ ΟΔΟΣΤΡΩΤΗΡΩΝ',
  },
  {
    label: '46631008',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΕΠΙΔΩΝ ΓΙΑ ΜΠΟΥΛΝΤΟΖΕΣ Η ΠΛΑΓΙΕΣ ΜΠΟΥΛΝΤΟΖΕΣ',
  },
  {
    label: '46631009',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΩΤΡΗΣΗΣ Η ΔΙΑΝΟΙΞΗΣ ΦΡΕΑΤΩΝ Η ΕΚΣΚΑΦΗΣ, ΜΕΡΩΝ ΓΕΡΑΝΩΝ',
  },
  {
    label: '46631010',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΞΟΡΥΞΗΣ, ΓΙΑ ΚΑΤΑΣΚΕΥΑΣΤΙΚΑ ΕΡΓΑ ΚΑΙ ΓΙΑ ΕΡΓΑ ΠΟΛΙΤΙΚΟΥ ΜΗΧΑΝΙΚΟΥ',
  },
  {
    label: '46631011',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΔΙΑΛΟΓΗ, ΑΛΕΣΗ, ΑΝΑΜΕΙΞΗ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΠΕΞΕΡΓΑΣΙΑ ΧΩΜΑΤΟΣ, ΛΙΘΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΥΚΤΩΝ ΟΥΣΙΩΝ ΚΑΙ ΜΗΧΑΝΗΜΑΤΩΝ ΣΧΗΜΑΤΙΣΜΟΥ ΜΗΤΡΩΝ ΧΥΤΗΡΙΩΝ',
  },
  {
    label: '46631012',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΚΟΠΗΣ ΑΝΘΡΑΚΑ Η ΒΡΑΧΩΝ ΚΑΙ ΜΗΧΑΝΗΜΑΤΩΝ ΔΙΑΝΟΙΞΗΣ ΣΗΡΑΓΓΩΝ, ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΩΤΡΗΣΗΣ ΚΑΙ ΔΙΑΝΟΙΞΗΣ ΦΡΕΑΤΩΝ',
  },
  {
    label: '46631013',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΟΔΟΠΟΙΙΑΣ ΚΑΙ ΑΝΟΙΚΟΔΟΜΗΣΕΩΣ',
  },
  {
    label: '46631014',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΠΟΥΛΝΤΟΖΩΝ ΚΑΙ ΠΛΑΓΙΩΝ ΜΠΟΥΛΝΤΟΖΩΝ, ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ',
  },
  {
    label: '46640000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΗ ΒΙΟΜΗΧΑΝΙΑ, ΚΑΙ ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΑΠΤΟΜΗΧΑΝΩΝ ΚΑΙ ΠΛΕΚΤΟΜΗΧΑΝΩΝ',
  },
  {
    label: '46641000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΗ ΒΙΟΜΗΧΑΝΙΑ, ΚΑΘΩΣ ΚΑΙ ΡΑΠΤΟΜΗΧΑΝΩΝ ΚΑΙ ΠΛΕΚΤΟΜΗΧΑΝΩΝ',
  },
  {
    label: '46641001',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΩΝ ΥΦΑΝΣΗΣ ΚΑΙ ΚΛΩΣΗΣ',
  },
  {
    label: '46641002',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΑΛΛΗ ΠΑΡΑΓΩΓΗ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΕΙΔΩΝ ΕΝΔΥΣΗΣ ΚΑΙ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΔΕΡΜΑΤΩΝ',
  },
  {
    label: '46641003',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΚΑΤΕΡΓΑΣΙΑ ΠΡΟΒΙΩΝ Η ΔΕΡΜΑΤΩΝ Η ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ Η ΕΠΙΣΚΕΥΗ ΥΠΟΔΗΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46641004',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΛΥΣΗ, ΤΟΝ ΚΑΘΑΡΙΣΜΟ, ΤΟ ΣΤΥΨΙΜΟ, ΤΟ ΣΙΔΕΡΩΜΑ, ΤΟ ΠΡΕΣΑΡΙΣΜΑ, ΤΗ ΒΑΦΗ, ΤΗΝ ΑΝΑΠΗΝΙΣΗ (ΞΕΤΥΛΙΓΑΔΙΑΣΜΑ) ΚΑΙ ΠΑΡΟΜΟΙΕΣ ΕΡΓΑΣΙΕΣ ΥΦΑΝΤΟΥΡΓΙΚΟΥ ΝΗΜΑΤΟΣ ΚΑΙ ΥΦΑΣΜΑΤΩΝ, ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΦΙΝΙΡΙΣΜΑ ΤΟΥ ΠΙΛΗΜΑΤΟΣ (Τ',
  },
  {
    label: '46641005',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΥΠΟΔΗΜΑΤΟΠΟΙΙΑΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46641006',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΩΝ ΚΛΩΣΗΣ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΜΗΧΑΝΩΝ ΔΙΠΛΩΜΑΤΟΣ Η ΣΤΡΙΨΙΜΑΤΟΣ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΜΗΧΑΝΩΝ ΠΕΡΙΕΛΙΞΗΣ Η ΑΝΑΠΗΝΙΣΗΣ (ΞΕΤΥΛΙΓΑΔΙΑΣΜΑΤΟΣ) ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46641007',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΕΚΤΟΜΗΧΑΝΩΝ',
  },
  {
    label: '46641008',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΕΚΤΟΜΗΧΑΝΩΝ, ΡΑΠΤΟΜΗΧΑΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗΧΑΝΩΝ, ΜΗΧΑΝΩΝ ΚΑΤΑΣΚΕΥΗΣ ΘΥΣΑΝΩΝ',
  },
  {
    label: '46641009',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΑΠΤΟΜΗΧΑΝΩΝ ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '46641010',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΑΠΤΟΜΗΧΑΝΩΝ, ΕΚΤΟΣ ΤΩΝ ΡΑΠΤΟΜΗΧΑΝΩΝ ΓΙΑ ΒΙΒΛΙΑ ΚΑΙ ΤΩΝ ΟΙΚΙΑΚΩΝ ΡΑΠΤΟΜΗΧΑΝΩΝ',
  },
  {
    label: '46641011',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΝΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '46650000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΛΩΝ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '46651001',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΘΩΡΑΚΙΣΜΕΝΩΝ Η ΕΝΙΣΧΥΜΕΝΩΝ ΘΗΣΑΥΡΟΦΥΛΑΚΙΩΝ, ΧΡΗΜΑΤΟΚΙΒΩΤΙΩΝ ΚΑΙ ΠΟΡΤΩΝ ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46651002',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΙΣΜΑΤΩΝ, ΚΥΡΙΩΣ ΜΕ ΜΕΤΑΛΛΙΚΟ ΣΚΕΛΕΤΟ, ΓΙΑ ΓΡΑΦΕΙΑ',
  },
  {
    label: '46651003',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΙΣΜΑΤΩΝ, ΚΥΡΙΩΣ ΜΕ ΞΥΛΙΝΟ ΣΚΕΛΕΤΟ, ΓΙΑ ΓΡΑΦΕΙΑ',
  },
  {
    label: '46651004',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΕΠΙΠΛΩΝ ΚΑΙ ΜΙΚΡΟΕΠΙΠΛΩΝ, ΓΙΑ ΓΡΑΦΕΙΑ',
  },
  {
    label: '46651005',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΙΚΩΝ ΕΠΙΠΛΩΝ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΓΡΑΦΕΙΑ',
  },
  {
    label: '46651006',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ ΓΙΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '46651007',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΓΡΑΦΕΙΑ',
  },
  {
    label: '46651008',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΡΤΩΝ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '46651009',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΡΗΜΑΤΟΚΙΒΩΤΙΩΝ',
  },
  {
    label: '46660000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '46661000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΩΝ',
  },
  {
    label: '46661001',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΓΡΑΦΟΜΗΧΑΝΩΝ',
  },
  {
    label: '46661002',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΩΝ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '46661003',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΙΘΜΟΜΗΧΑΝΩΝ ΚΑΙ ΛΟΓΙΣΤΙΚΩΝ ΜΗΧΑΝΩΝ, ΤΑΜΙΑΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗΧΑΝΩΝ, ΠΟΥ ΦΕΡΟΥΝ ΥΠΟΛΟΓΙΣΤΙΚΗ ΔΙΑΤΑΞΗ',
  },
  {
    label: '46661004',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΜΑΤΩΝ ΓΡΑΦΟΜΗΧΑΝΩΝ ΚΑΙ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΕΙΜΕΝΟΥ',
  },
  {
    label: '46661005',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΚΤΥΠΩΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ OFFSET, ΤΥΠΟΥ ΓΡΑΦΕΙΟΥ, ΠΟΥ ΤΡΟΦΟΔΟΤΟΥΝΤΑΙ ΜΕ ΦΥΛΛΑ ΧΑΡΤΙΟΥ',
  },
  {
    label: '46661006',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΝΙΚΩΝ ΤΑΜΙΑΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '46661007',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΛΛΩΝ ΜΗΧΑΝΩΝ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '46661008',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΡΑΦΟΜΗΧΑΝΩΝ ΚΑΙ ΑΡΙΘΜΟΜΗΧΑΝΩΝ',
  },
  {
    label: '46661009',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΦΩΤΟΑΝΤΙΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46661010',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΑΝΤΙΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ ΜΕ ΟΠΤΙΚΟ ΣΥΣΤΗΜΑ Η ΜΕ ΕΠΑΦΗ ΚΑΙ ΘΕΡΜΟΑΝΤΙΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46690000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46691100',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΜΕΤΑΦΟΡΩΝ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΜΗΧΑΝΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ, ΤΙΣ ΜΟΤΟΣΙΚΛΕΤΕΣ ΚΑΙ ΤΑ ΠΟΔΗΛΑΤΑ',
  },
  {
    label: '46691101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΕΡΟΠΛΑΝΩΝ ΚΑΙ ΑΛΛΩΝ ΑΕΡΟΣΚΑΦΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46691102',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΙΕΥΤΙΚΩΝ ΣΚΑΦΩΝ, ΠΛΟΙΩΝ ΕΡΓΟΣΤΑΣΙΩΝ ΚΑΙ ΑΛΛΩΝ ΣΚΑΦΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ Η ΤΗ ΣΥΝΤΗΡΗΣΗ ΑΛΙΕΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46691103',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΜΕΤΑΦΟΡΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46691104',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΡΩΝ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΔΙΑΣΤΗΜΙΚΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '46691105',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΩΤΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '46691106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΜΗΧΑΝΩΝ ΠΛΟΙΩΝ',
  },
  {
    label: '46691107',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ Η ΤΡΟΧΙΟΔΡΟΜΙΚΩΝ ΑΥΤΟΚΙΝΗΤΑΜΑΞΩΝ, ΣΚΕΥΟΦΟΡΩΝ (ΕΚΤΟΣ ΤΩΝ ΟΧΗΜΑΤΩΝ ΣΥΝΤΗΡΗΣΗΣ Η ΕΠΙΣΚΕΥΗΣ)',
  },
  {
    label: '46691108',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΥΘΟΚΟΡΩΝ, ΠΛΟΙΩΝ;ΦΑΡΩΝ, ΠΥΡΟΣΒΕΣΤΙΚΩΝ ΠΛΟΙΩΝ, ΠΛΩΤΩΝ ΓΕΡΑΝΩΝ, ΑΛΛΩΝ ΣΚΑΦΩΝ',
  },
  {
    label: '46691109',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΞΑΜΕΝΟΠΛΟΙΩΝ',
  },
  {
    label: '46691110',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΙΚΟΠΤΕΡΩΝ',
  },
  {
    label: '46691111',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΙΚΩΝ ΠΛΟΙΩΝ ΚΑΙ ΤΩΝ ΠΤΕΡΥΓΙΩΝ ΤΟΥΣ',
  },
  {
    label: '46691112',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ, ΕΙΔΙΚΑ ΣΧΕΔΙΑΣΜΕΝΩΝ ΓΙΑ ΝΑ ΜΕΤΑΦΕΡΟΝΤΑΙ ΑΠΟ ΕΝΑ Η ΠΕΡΙΣΣΟΤΕΡΑ ΜΕΤΑΦΟΡΙΚΑ ΜΕΣΑ',
  },
  {
    label: '46691113',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΦΩΤΙΣΜΟΥ Η ΣΗΜΑΤΟΔΟΤΗΣΗΣ, ΥΑΛΟΚΑΘΑΡΙΣΤΗΡΩΝ, ΗΛΕΚΤΡΙΚΩΝ ΔΙΑΤΑΞΕΩΝ ΓΙΑ ΤΗ ΔΙΑΛΥΣΗ ΤΟΥ ΠΑΓΟΥ ΚΑΙ ΤΟΥ ΑΧΝΟΥ ΓΙΑ ΠΛΟΙΑ, ΑΕΡΟΣΚΑΦΗ ΚΑΙ ΜΗΧΑΝΕΣ ΤΡΑΙΝΟΥ',
  },
  {
    label: '46691114',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691115',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΑΝΤΙΔΡΑΣΗΣ (ΕΚΤΟΣ ΤΩΝ ΣΤΡΟΒΙΛΟΚΙΝΗΤΗΡΩΝ)',
  },
  {
    label: '46691116',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΓΙΑ ΘΑΛΑΣΣΙΑ ΠΡΟΩΘΗΣΗ, ΚΙΝΗΤΗΡΩΝ ΓΙΑ ΣΙΔΗΡΟΔΡΟΜΙΚΗ ΕΛΞΗ',
  },
  {
    label: '46691117',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΡΟΥΑΖΙΕΡΟΠΛΟΙΩΝ, ΠΟΡΘΜΕΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΚΑΦΩΝ, ΕΙΔΙΚΑ ΣΧΕΔΙΑΣΜΕΝΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '46691118',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α. ΓΙΑ ΠΛΟΙΑ, ΑΕΡΟΣΚΑΦΗ ΚΑΙ ΜΗΧΑΝΕΣ ΤΡΑΙΝΟΥ',
  },
  {
    label: '46691119',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΣΤΡΟΒΙΛΟΚΙΝΗΤΗΡΩΝ ΚΑΙ ΕΛΙΚΟΣΤΡΟΒΙΛΟΚΙΝΗΤΗΡΩΝ',
  },
  {
    label: '46691120',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΙΣΜΟΥ ΚΑΘΑΙΡΕΣΗΣ ΑΕΡΟΣΚΑΦΟΥΣ, ΑΝΑΣΧΕΤΙΚΩΝ ΟΡΓΑΝΩΝ Η ΠΑΡΟΜΟΙΩΝ ΜΗΧΑΝΙΣΜΩΝ, ΣΥΣΚΕΥΩΝ ΕΔΑΦΟΥΣ ΓΙΑ ΤΗΝ ΕΚΠΑΙΔΕΥΣΗ ΣΤΗΝ ΠΤΗΣΗ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691121',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΑΥΤΙΛΙΑΚΩΝ ΕΙΔΩΝ, ΑΠΟ ΑΥΤΑ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΕΙΔΙΚΑ ΣΤΗΝ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΝΑΥΤΙΛΙΑ',
  },
  {
    label: '46691122',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΤΙΖΕΛΟΗΛΕΚΤΡΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '46691123',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ Η ΠΛΑΣΤΙΚΩΝ ΛΕΜΒΩΝ, ΟΧΙ ΓΙΑ ΑΝΑΨΥΧΗ Η ΑΘΛΗΤΙΣΜΟ',
  },
  {
    label: '46691124',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΟΙΩΝ ~ ΨΥΓΕΙΩΝ',
  },
  {
    label: '46691125',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΟΛΟΓΙΩΝ ΓΙΑ ΤΟΥΣ ΠΙΝΑΚΕΣ ΤΩΝ ΟΡΓΑΝΩΝ ΕΛΕΓΧΟΥ ΚΑΙ ΡΟΛΟΓΙΩΝ ΠΑΡΟΜΟΙΟΥ ΤΥΠΟΥ ΓΙΑ ΠΛΟΙΑ ΚΑΙ ΑΕΡΟΣΚΑΦΗ (ΚΑΙ ΓΙΑ ΑΘΛΗΤΙΚΕΣ ΧΡΗΣΕΙΣ)',
  },
  {
    label: '46691126',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΥΜΟΥΛΚΩΝ ΚΑΙ ΠΡΟΩΘΗΤΙΚΩΝ ΠΛΟΙΩΝ',
  },
  {
    label: '46691127',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ Η ΤΡΟΧΙΟΔΡΟΜΙΚΩΝ ΕΠΙΒΑΤΙΚΩΝ ΑΥΤΟΚΙΝΗΤΑΜΑΞΩΝ, ΜΗ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ, ΣΚΕΥΟΦΟΡΩΝ ΚΑΙ ΑΛΛΩΝ ΟΧΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46691128',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ Η ΤΡΟΧΙΟΔΡΟΜΙΚΩΝ ΣΚΕΥΟΦΟΡΩΝ ΚΑΙ ΒΑΓΟΝΙΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΜΠΟΡΕΥΜΑΤΩΝ, ΜΗ ΑΥΤΟΚΙΝΟΥΜΕΝΩΝ',
  },
  {
    label: '46691129',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΜΗΧΑΝΩΝ, ΕΦΟΔΙΟΦΟΡΩΝ',
  },
  {
    label: '46691130',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΑΦΩΝ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΕΜΠΟΡΕΥΜΑΤΩΝ ΚΑΘΩΣ ΚΑΙ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ ΚΑΙ ΕΠΙΒΑΤΩΝ ΚΑΙ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '46691131',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΑΦΩΝ ΚΑΙ ΑΛΛΩΝ ΠΛΩΤΩΝ ΚΑΤΑΣΚΕΥΩΝ ΠΡΟΣ ΔΙΑΛΥΣΗ',
  },
  {
    label: '46691132',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΟΒΙΛΟΚΙΝΗΤΗΡΩΝ ΚΑΙ ΕΛΙΚΟΣΤΡΟΒΙΛΟΚΙΝΗΤΗΡΩΝ',
  },
  {
    label: '46691200',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΜΗΘΕΙΩΝ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΜΗΧΑΝΗΜΑΤΑ ΚΑΙ ΕΙΔΗ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '46691201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΓΚΙΣΤΡΩΝ, ΚΟΠΙΤΣΩΝ ΚΑΙ ΠΟΡΠΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46691202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΞΟΝΩΝ ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ',
  },
  {
    label: '46691203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ Π.Δ.Κ.Α., ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ ΣΕ ΟΛΕΣ ΤΙΣ ΜΟΡΦΕΣ ΚΑΙ ΕΙΔΗ ΤΟΥ',
  },
  {
    label: '46691204',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΘΡΩΠΙΝΩΝ ΜΑΛΛΙΩΝ, ΑΚΑΤΕΡΓΑΣΤΩΝ',
  },
  {
    label: '46691205',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΝΩΝ ΠΕΡΙΒΛΗΜΑΤΩΝ ΓΙΑ ΦΙΑΛΕΣ ΚΕΝΟΥ Η ΑΛΛΑ ΣΚΕΥΗ ΚΕΝΟΥ',
  },
  {
    label: '46691206',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΧΕΙΩΝ ΓΙΑ ΠΕΠΙΕΣΜΕΝΑ Η ΥΓΡΟΠΟΙΗΜΕΝΑ ΑΕΡΙΑ, ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '46691207',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΝΣΦΑΙΡΩΝ ΤΡΙΒΕΩΝ ΚΑΙ ΚΥΛΙΝΔΡΟΤΡΙΒΕΩΝ',
  },
  {
    label: '46691208',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΕΠΙΠΛΑ, ΑΜΑΞΩΜΑΤΑ Η ΠΑΡΟΜΟΙΑ ΕΙΔΗ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46691209',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΙΜΑΝΤΩΝ ΜΕΤΑΦΟΡΑΣ Η ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ, ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ',
  },
  {
    label: '46691210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΓΙΑ ΕΡΓΑΣΤΗΡΙΑΚΗ, ΧΗΜΙΚΗ Η ΑΛΛΕΣ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ, ΑΠΟ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '46691211',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΓΙΑ ΕΡΓΑΣΤΗΡΙΑΚΗ, ΧΗΜΙΚΗ Η ΑΛΛΕΣ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ, ΕΚΤΟΣ ΑΠΟ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '46691212',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΕΠΙΔΩΝ ΓΙΑ ΠΡΙΟΝΙΑ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '46691213',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΜΗΧΑΝΩΝ Η ΤΡΟΧΑΙΟΥ ΕΞΟΠΛΙΣΜΟΥ ΣΙΔΗΡΟΔΡΟΜΩΝ Η ΤΡΟΧΙΟΔΡΟΜΩΝ, ΜΗΧΑΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΕΛΕΓΧΟΥ ΤΗΣ ΚΥΚΛΟΦΟΡΙΑΣ',
  },
  {
    label: '46691214',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΕΜΒΥΣΜΑΤΩΝ ΑΠΟ ΜΕΤΑΛΛΙΚΑ ΕΛΑΣΜΑΤΑ, ΟΧΙ ΓΙΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '46691215',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΣ, ΡΑΒΔΩΝ, ΣΩΛΗΝΩΝ, ΠΛΑΚΩΝ, ΗΛΕΚΤΡΟΔΙΩΝ, ΜΕ ΕΠΙΚΑΛΥΨΗ Η ΜΕ ΠΥΡΗΝΑ ΑΠΟ ΣΥΛΛΙΠΑΣΜΑ (FLUX)',
  },
  {
    label: '46691216',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΣΧΟΙΝΩΝ, ΚΑΛΩΔΙΩΝ, ΠΛΕΞΟΥΔΩΝ, ΑΡΤΑΝΩΝ (ΣΑΜΠΑΝΙΩΝ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΜΗ ΗΛΕΚΤΡΟΜΟΝΩΜΕΝΩΝ',
  },
  {
    label: '46691217',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΥΠΟΓΡΑΦΙΚΩΝ ΠΛΑΚΩΝ Η ΚΥΛΙΝΔΡΩΝ ΚΑΙ ΑΛΛΩΝ ΕΓΧΑΡΑΚΤΩΝ ΜΕΣΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗΝ ΤΥΠΟΓΡΑΦΙΑ',
  },
  {
    label: '46691218',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΙΤΙΛΙΩΝ, ΠΡΟΝΗΜΑΤΩΝ ΚΑΙ ΝΗΜΑΤΩΝ ΚΑΙ ΚΟΜΜΕΝΩΝ ΚΛΩΝΩΝ ΑΠΟ ΓΥΑΛΙΝΕΣ ΙΝΕΣ, ΓΙΑ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΗ ΧΡΗΣΗ',
  },
  {
    label: '46691300',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΑΝΥΨΩΣΗΣ ΚΑΙ ΔΙΑΚΙΝΗΣΗΣ ΦΟΡΤΙΩΝ',
  },
  {
    label: '46691301',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΓΡΥΛΩΝ, ΒΑΡΟΥΛΚΩΝ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΓΙΑ ΑΝΥΨΩΣΗ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '46691302',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΑΝΥΨΩΣΗΣ, ΜΕΤΑΚΙΝΗΣΗΣ, ΦΟΡΤΩΣΗΣ Η ΕΚΦΟΡΤΩΣΗΣ',
  },
  {
    label: '46691303',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΕΛΚΥΣΤΗΡΩΝ, ΚΑΔΟΦΟΡΩΝ ΒΑΡΟΥΛΚΩΝ, ΚΥΛΙΟΜΕΝΩΝ ΣΚΑΛΩΝ ΚΑΙ ΚΥΛΙΟΜΕΝΩΝ ΔΙΑΔΡΟΜΩΝ',
  },
  {
    label: '46691304',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΝΕΛΚΥΣΤΗΡΩΝ',
  },
  {
    label: '46691305',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΥΨΩΤΗΡΩΝ ΚΑΙ ΙΜΑΝΤΩΝ ΜΕΤΑΦΟΡΑΣ ΣΥΝΕΧΟΥΣ ΛΕΙΤΟΥΡΓΙΑΣ, ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΓΙΑ ΠΡΟΪΟΝΤΑ Η ΥΛΙΚΑ',
  },
  {
    label: '46691306',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΔΩΝ, ΦΤΥΑΡΙΩΝ, ΑΡΠΑΓΩΝ ΚΑΙ ΛΑΒΩΝ ΓΙΑ ΓΕΡΑΝΟΥΣ, ΕΚΣΚΑΦΕΙΣ ΚΑΙ ΠΑΡΟΜΟΙΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '46691307',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΕΞΟΠΛΙΣΜΟΥ ΑΝΥΨΩΣΗΣ ΚΑΙ ΜΕΤΑΚΙΝΗΣΗΣ ΥΛΙΚΩΝ',
  },
  {
    label: '46691308',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΟΝΟΦΟΡΩΝ ΑΝΥΨΩΤΙΚΩΝ ΟΧΗΜΑΤΩΝ, ΑΛΛΩΝ ΟΧΗΜΑΤΩΝ ΚΑΤΑΣΚΕΥΩΝ, ΕΛΚΥΣΤΗΡΩΝ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΑΠΟΒΑΘΡΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΣΤΑΘΜΩΝ',
  },
  {
    label: '46691309',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΣΠΑΣΤΩΝ, ΒΑΡΟΥΛΚΩΝ, ΑΛΛΩΝ ΒΙΝΤΣΙΩΝ ΚΑΙ ΕΡΓΑΤΩΝ (ΜΠΟΤΖΕΡΓΑΤΩΝ)',
  },
  {
    label: '46691310',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΟΡΤΩΤΗΡΩΝ, ΓΕΡΑΝΩΝ, ΚΙΝΗΤΩΝ ΑΝΥΨΩΤΙΚΩΝ ΠΛΑΙΣΙΩΝ, ΓΕΡΑΝΟΓΕΦΥΡΩΝ ΚΑΙ ΓΕΡΑΝΟΦΟΡΩΝ ΟΧΗΜΑΤΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '46691400',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗ ΒΙΟΜΗΧΑΝΙΑ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ',
  },
  {
    label: '46691401',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '46691402',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΕΞΟΠΛΙΣΜΟΥ ΚΡΕΟΠΩΛΕΙΩΝ',
  },
  {
    label: '46691403',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ Η ΣΥΣΚΕΥΩΝ ΥΓΡΑΕΡΙΟΥ, ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΤΡΟΦΙΜΩΝ ΚΑΙ ΠΟΤΩΝ, ΖΑΧΑΡΟΠΛΑΣΤΕΙΩΝ, ΕΣΤΙΑΤΟΡΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ',
  },
  {
    label: '46691404',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΡΜΕΚΤΙΚΩΝ ΜΗΧΑΝΩΝ ΚΑΙ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ, ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΠΟΤΩΝ',
  },
  {
    label: '46691405',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΚΑΠΝΟΥ',
  },
  {
    label: '46691406',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '46691407',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΠΛΥΝΤΗΡΙΩΝ ΠΙΑΤΩΝ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΚΑΙ ΜΗΧΑΝΩΝ ΚΑΘΑΡΙΣΜΟΥ, ΓΕΜΙΣΜΑΤΟΣ, ΣΥΣΚΕΥΑΣΙΑΣ ΚΑΙ ΠΕΡΙΤΥΛΙΓΜΑΤΟΣ',
  },
  {
    label: '46691408',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΦΟΥΡΝΩΝ ΑΡΤΟΠΟΙΙΑΣ, ΞΗΡΑΝΤΗΡΩΝ ΓΕΩΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΜΗ ΟΙΚΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΜΑΓΕΙΡΕΜΑ Η ΖΕΣΤΑΜΑ ΦΑΓΗΤΟΥ',
  },
  {
    label: '46691409',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΑΠΟΚΟΡΥΦΩΣΗΣ ΓΑΛΑΚΤΟΣ (ΚΟΡΥΦΟΛΟΓΩΝ)',
  },
  {
    label: '46691410',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΑΛΕΣΗ Η ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΔΗΜΗΤΡΙΑΚΩΝ Η ΟΣΠΡΙΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46691411',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΡΟΕΤΟΙΜΑΣΙΑ ΚΑΙ ΠΑΡΑΣΚΕΥΗ ΤΟΥ ΚΑΠΝΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '46691412',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΘΑΡΙΣΜΟΥ, ΓΕΜΙΣΜΑΤΟΣ, ΣΥΣΚΕΥΑΣΙΑΣ Η ΠΕΡΙΤΥΛΙΓΜΑΤΟΣ ΦΙΑΛΩΝ Η ΑΛΛΩΝ ΔΟΧΕΙΩΝ, ΓΙΑ ΤΗ ΒΙΟΜΗΧΑΝΙΑ ΤΡΟΦΙΜΩΝ ΚΑΙ ΠΟΤΩΝ',
  },
  {
    label: '46691413',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α. ΓΙΑ ΤΗ ΒΙΟΜΗΧΑΝΙΚΗ ΠΡΟΕΤΟΙΜΑΣΙΑ Η ΠΑΡΑΣΚΕΥΗ ΤΡΟΦΙΜΩΝ Η ΠΟΤΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΛΙΠΗ Η ΕΛΑΙΑ)',
  },
  {
    label: '46691414',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗΝ ΠΑΡΑΣΚΕΥΗ ΚΡΑΣΙΟΥ, ΜΗΛΙΤΗ, ΦΡΟΥΤΟΧΥΜΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΟΤΩΝ',
  },
  {
    label: '46691415',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΥΝΤΗΡΙΩΝ ΠΙΑΤΩΝ, ΕΠΑΓΓΕΛΜΑΤΙΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '46691500',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΗΛΕΚΤΡΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ, ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΚΑΙ ΥΛΙΚΩΝ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ Η ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46691501',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΔΕΡΜΑ Η ΣΥΝΘΕΤΙΚΑ ΔΕΡΜΑΤΑ (ΕΙΔΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΜΗΧΑΝΗΜΑΤΑ Η ΑΛΛΕΣ ΜΗΧΑΝΙΚΕΣ ΣΥΣΚΕΥΕΣ)',
  },
  {
    label: '46691502',
    value: 'XΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΑΓΩΓΩΝ, ΓΙΑ ΤΑΣΗ ΕΩΣ 1000 ~ V',
  },
  {
    label: '46691503',
    value:
      'XΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΡΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΛΥΧΝΙΩΝ ΑΣΥΡΜΑΤΟΥ ΚΑΙ ΡΑΔΙΟΦΩΝΟΥ ΚΑΙ ΑΛΛΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46691504',
    value: 'XΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ',
  },
  {
    label: '46691505',
    value: 'XΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΠΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΚΑΙ ΟΡΓΑΝΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46691506',
    value:
      'XΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΣΥΣΣΩΡΕΥΤΩΝ ΜΟΛΥΒΔΟΥ;ΟΞΕΟΣ ΓΙΑ ΕΜΒΟΛΟΦΟΡΟΥΣ ΚΙΝΗΤΗΡΕΣ',
  },
  {
    label: '46691507',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΤΟΠΟΓΡΑΦΙΚΩΝ, ΥΔΡΟΓΡΑΦΙΚΩΝ, ΩΚΕΑΝΟΓΡΑΦΙΚΩΝ, ΥΔΡΟΛΟΓΙΚΩΝ, ΜΕΤΕΩΡΟΛΟΓΙΚΩΝ Η ΓΕΩΦΥΣΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46691508',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46691509',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΜΑΤΩΝ ΗΛΕΚΤΡΙΚΩΝ ΔΙΑΚΟΠΤΩΝ ΚΥΚΛΩΜΑΤΟΣ',
  },
  {
    label: '46691510',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΥΣΜΑΤΩΝ, ΠΡΙΖΩΝ ΚΑΙ ΑΛΛΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗ ΔΙΑΚΟΠΗ Η ΤΗΝ ΠΡΟΣΤΑΣΙΑ ΗΛΕΚΤΡΙΚΩΝ ΚΥΚΛΩΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46691511',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΕΝΝΗΤΡΙΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ ΡΕΥΜΑΤΟΣ (ΕΝΑΛΛΑΚΤΩΝ)',
  },
  {
    label: '46691512',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΟΔΩΝ, ΚΡΥΣΤΑΛΛΟΛΥΧΝΙΩΝ, ΘΥΡΙΣΤΟΡ, ΔΙΑΚΟΠΤΩΝ ΔΙΠΛΕΥΡΗΣ ΔΙΟΔΟΥ (ΔΙΑΚ) ΚΑΙ ΔΙΑΚΟΠΤΩΝ ΔΙΠΛΕΥΡΗΣ ΤΡΙΟΔΟΥ (ΤΡΙΑΚ)',
  },
  {
    label: '46691513',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΕΥΓΩΝ ΓΕΝΝΗΤΡΙΑΣ ΜΕ ΕΜΒΟΛΟΦΟΡΟΥΣ ΚΙΝΗΤΗΡΕΣ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΥΜΠΙΕΣΗ',
  },
  {
    label: '46691514',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΕΥΓΩΝ ΓΕΝΝΗΤΡΙΑΣ ΜΕ ΚΙΝΗΤΗΡΕΣ ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΠΙΝΘΗΡΙΣΤΗ, ΑΛΛΩΝ ΖΕΥΓΩΝ ΓΕΝΝΗΤΡΙΑΣ, ΗΛΕΚΤΡΙΚΩΝ ΠΕΡΙΣΤΡΟΦΙΚΩΝ ΜΕΤΑΛΛΑΚΤΩΝ',
  },
  {
    label: '46691515',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΑΓΩΓΩΝ, ΓΙΑ ΤΑΣΗ > 1000 ~ V',
  },
  {
    label: '46691516',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΑΝΤΙΣΤΑΣΕΩΝ (ΕΚΤΟΣ ΤΩΝ ΘΕΡΜΑΝΤΙΚΩΝ ΑΝΤΙΣΤΑΣΕΩΝ)',
  },
  {
    label: '46691517',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΑΣΦΑΛΕΙΩΝ',
  },
  {
    label: '46691518',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΔΙΑΚΟΠΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46691519',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΒΛΗΤΩΝ Η ΡΥΘΜΙΖΟΜΕΝΩΝ (ΑΥΤΟΜΑΤΩΝ) ΠΥΚΝΩΤΩΝ',
  },
  {
    label: '46691520',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ',
  },
  {
    label: '46691521',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΟΥ ΕΧΟΥΝ ΧΩΡΙΣΤΕΣ ΛΕΙΤΟΥΡΓΙΕΣ',
  },
  {
    label: '46691522',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΜΟΝΩΤΗΡΩΝ, ΜΟΝΩΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΗΛΕΚΤΡΙΚΕΣ ΜΗΧΑΝΕΣ Η ΕΞΟΠΛΙΣΜΟ, ΑΓΩΓΩΝ ΗΛΕΚΤΡΙΚΩΝ ΚΑΛΩΔΙΩΝ',
  },
  {
    label: '46691523',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΜΟΝΩΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46691524',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΜΟΝΩΤΙΚΩΝ ΥΛΙΚΩΝ ΑΠΟ ΓΥΑΛΙ',
  },
  {
    label: '46691525',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΠΙΝΑΚΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΤΑΞΕΩΝ',
  },
  {
    label: '46691526',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΤΟΙΧΙΩΝ',
  },
  {
    label: '46691527',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΑΚΟΥΣΤΙΚΗΣ Η ΟΠΤΙΚΗΣ ΣΗΜΑΤΟΔΟΤΗΣΗΣ ΓΙΑ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ, ΧΩΡΟΥΣ ΣΤΑΘΜΕΥΣΗΣ, ΛΙΜΕΝΙΚΕΣ ΕΓΚΑΤΑΣΤΑΣΕΙΣ Η ΑΕΡΟΔΡΟΜΙΑ',
  },
  {
    label: '46691528',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗ ΔΙΑΚΟΠΗ Η ΤΗΝ ΠΡΟΣΤΑΣΙΑ ΗΛΕΚΤΡΙΚΩΝ ΚΥΚΛΩΜΑΤΩΝ ΤΑΣΗΣ > 1000 ~ V',
  },
  {
    label: '46691529',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗ ΔΙΑΚΟΠΗ Η ΤΗΝ ΠΡΟΣΤΑΣΙΑ ΗΛΕΚΤΡΙΚΩΝ ΚΥΚΛΩΜΑΤΩΝ ΤΑΣΗΣ <= 1000 ~ V',
  },
  {
    label: '46691530',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΣΩΡΕΥΤΩΝ',
  },
  {
    label: '46691531',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΔΙΩΝ ΑΝΘΡΑΚΑ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΓΡΑΦΙΤΗ Η ΑΛΛΟ ΑΝΘΡΑΚΑ ΓΙΑ ΗΛΕΚΤΡΟΛΟΓΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '46691532',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΚΙΝΗΤΗΡΩΝ, ΗΛΕΚΤΡΟΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ',
  },
  {
    label: '46691533',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΛΟΓΙΚΟΥ ΥΛΙΚΟΥ ΥΨΗΛΗΣ ΤΑΣΕΩΣ',
  },
  {
    label: '46691534',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΝΙΚΩΝ ΟΛΟΚΛΗΡΩΜΕΝΩΝ ΚΥΚΛΩΜΑΤΩΝ ΚΑΙ ΜΙΚΡΟΣΥΝΑΡΜΟΛΟΓΗΣΕΩΝ',
  },
  {
    label: '46691535',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΝΟΜΩΝ',
  },
  {
    label: '46691536',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΙΟΝΙΣΤΩΝ ΑΕΡΑ',
  },
  {
    label: '46691537',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΩΔΙΩΝ ΟΠΤΙΚΩΝ ΙΝΩΝ, ΠΟΥ ΑΠΟΤΕΛΟΥΝΤΑΙ ΑΠΟ ΙΝΕΣ ΚΑΘΕ ΜΙΑ ΑΠΟ ΤΙΣ ΟΠΟΙΕΣ ΕΧΕΙ ΜΟΝΩΘΕΙ ΕΞΩΤΕΡΙΚΑ ΧΩΡΙΣΤΑ',
  },
  {
    label: '46691538',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΚΩΝ ΜΟΝΩΤΙΚΩΝ ΥΛΙΚΩΝ ΚΑΙ ΜΟΝΩΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '46691539',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ ΡΕΥΜΑΤΟΣ, ΜΟΝΟΦΑΣΙΚΩΝ',
  },
  {
    label: '46691540',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ ΡΕΥΜΑΤΟΣ, ΠΟΛΥΦΑΣΙΚΩΝ',
  },
  {
    label: '46691541',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΕΝΑΛΛΑΣΣΟΜΕΝΟΥ/ΣΥΝΕΧΟΥΣ ΡΕΥΜΑΤΟΣ ΓΕΝΙΚΗΣ ΧΡΗΣΗΣ ΙΣΧΥΟΣ > 37 ;0,5; W',
  },
  {
    label: '46691542',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΜΕ ΙΣΧΥ ΕΩΣ 37 ;0,5; W, ΑΛΛΩΝ ΚΙΝΗΤΗΡΩΝ ΣΥΝΕΧΟΥΣ ΡΕΥΜΑΤΟΣ, ΓΕΝΝΗΤΡΙΩΝ ΣΥΝΕΧΟΥΣ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '46691543',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΟΥ ΕΠΑΓΓΕΛΜΑΤΙΚΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΗΛΕΚΤΡΙΚΩΝ ΜΕΡΩΝ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Η ΣΥΣΚΕΥΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46691544',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΑΝΤΙΣΤΑΣΕΩΝ, ΡΟΟΣΤΑΤΩΝ ΚΑΙ ΠΟΤΕΝΣΙΟΜΕΤΡΩΝ',
  },
  {
    label: '46691545',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ, ΕΠΑΓΩΓΕΩΝ ΚΑΙ ΣΤΑΤΙΚΩΝ ΜΕΤΑΛΛΑΚΤΩΝ',
  },
  {
    label: '46691546',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΠΥΚΝΩΤΩΝ',
  },
  {
    label: '46691547',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΣΩΡΕΥΤΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΔΙΑΧΩΡΙΣΤΩΝ)',
  },
  {
    label: '46691548',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΗΛΕΚΤΡΟΚΙΝΗΤΗΡΕΣ ΚΑΙ ΗΛΕΚΤΡΟΓΕΝΝΗΤΡΙΕΣ',
  },
  {
    label: '46691549',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΣΥΣΚΕΥΩΝ ΔΙΑΝΟΜΗΣ Η ΕΛΕΓΧΟΥ ΤΟΥ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '46691550',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΣΩΡΕΥΤΩΝ',
  },
  {
    label: '46691551',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΜΕΤΑΤΡΟΠΗΣ ΗΛΙΑΚΗΣ ΕΝΕΡΓΕΙΑΣ ΣΕ ΗΛΕΚΤΡΙΚΗ',
  },
  {
    label: '46691552',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΝΙΜΩΝ ΜΑΓΝΗΤΩΝ, ΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΣΥΖΕΥΞΕΩΝ, ΣΥΜΠΛΕΚΤΩΝ ΚΑΙ ΦΡΕΝΩΝ, ΜΑΓΝΗΤΙΚΩΝ ΑΝΥΨΩΤΙΚΩΝ ΚΕΦΑΛΩΝ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691553',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΝΩΜΕΝΩΝ ΣΥΡΜΑΤΩΝ ΚΑΙ ΚΑΛΩΔΙΩΝ',
  },
  {
    label: '46691554',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΜΟΑΞΟΝΙΚΩΝ ΚΑΛΩΔΙΩΝ ΚΑΙ ΑΛΛΩΝ ΟΜΟΑΞΟΝΙΚΩΝ ΗΛΕΚΤΡΙΚΩΝ ΑΓΩΓΩΝ',
  },
  {
    label: '46691555',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΙΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΕΣ',
  },
  {
    label: '46691556',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΜΕΤΡΗΣΗΣ Η ΕΛΕΓΧΟΥ ΗΛΕΚΤΡΙΚΩΝ ΜΕΓΕΘΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46691557',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΩΝ ΜΕΤΡΗΣΗΣ ΗΛΕΚΤΡΙΚΩΝ ΜΕΓΕΘΩΝ ΧΩΡΙΣ ΔΙΑΤΑΞΗ ΚΑΤΑΓΡΑΦΗΣ',
  },
  {
    label: '46691558',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΙΝΑΚΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΤΑΞΕΩΝ, ΕΞΟΠΛΙΣΜΕΝΩΝ ΜΕ ΗΛΕΚΤΡΙΚΟΥΣ ΔΙΑΚΟΠΤΕΣ Η ΣΥΣΚΕΥΕΣ ΠΡΟΣΤΑΣΙΑΣ, ΓΙΑ ΤΑΣΗ <= 1000 ~ V',
  },
  {
    label: '46691559',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΙΝΑΚΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΤΑΞΕΩΝ, ΕΞΟΠΛΙΣΜΕΝΩΝ ΜΕ ΗΛΕΚΤΡΙΚΟΥΣ ΔΙΑΚΟΠΤΕΣ Η ΣΥΣΚΕΥΕΣ ΠΡΟΣΤΑΣΙΑΣ, ΓΙΑ ΤΑΣΗ > 1000 ~ V',
  },
  {
    label: '46691560',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΥΞΙΔΩΝ ΠΡΟΣΑΝΑΤΟΛΙΣΜΟΥ, ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΝΑΥΣΙΠΛΟΪΑΣ',
  },
  {
    label: '46691561',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΑΘΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΠΥΚΝΩΤΩΝ',
  },
  {
    label: '46691562',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΑΝΙΧΝΕΥΣΗΣ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '46691563',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΔΙΑΝΟΜΗΣ ΚΑΙ ΕΛΕΓΧΟΥ ΤΟΥ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ',
  },
  {
    label: '46691564',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΜΕ ΗΜΙΑΓΩΓΟΥΣ, ΔΙΟΔΩΝ ΕΚΠΟΜΠΗΣ ΦΩΤΟΣ, ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΩΝ ΠΙΕΖΟΗΛΕΚΤΡΙΚΩΝ ΚΡΥΣΤΑΛΛΩΝ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691565',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΣΩΡΕΥΤΩΝ ΜΟΛΥΒΔΟΥ;ΟΞΕΟΣ (ΕΚΤΟΣ ΤΩΝ ΕΜΒΟΛΟΦΟΡΩΝ ΚΙΝΗΤΗΡΩΝ ΕΚΚΙΝΗΣΗΣ)',
  },
  {
    label: '46691566',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΣΩΡΕΥΤΩΝ ΝΙΚΕΛΙΟΥ;ΚΑΔΜΙΟΥ ΚΑΙ ΝΙΚΕΛΙΟΥ;ΣΙΔΗΡΟΥ ΚΑΙ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΣΩΡΕΥΤΩΝ',
  },
  {
    label: '46691567',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΣΩΡΕΥΤΩΝ, ΠΡΩΤΟΓΕΝΩΝ ΣΤΟΙΧΕΙΩΝ ΚΑΙ ΠΡΩΤΟΓΕΝΩΝ ΣΥΣΤΟΙΧΙΩΝ',
  },
  {
    label: '46691568',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΤΗΜΑΤΩΝ ΑΝΙΧΝΕΥΣΗΣ, ΕΛΕΓΧΟΥ ΚΑΙ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '46691569',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΤΗΜΑΤΩΝ ΑΥΤΟΝΟΜΙΑΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '46691570',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΥΠΩΜΕΝΩΝ ΚΥΚΛΩΜΑΤΩΝ',
  },
  {
    label: '46691571',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΓΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ',
  },
  {
    label: '46691572',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΒΟΛΤΑΪΚΩΝ ΣΤΟΙΧΕΙΩΝ',
  },
  {
    label: '46691600',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΠΛΩΝ ΚΑΙ ΠΥΡΟΜΑΧΙΚΩΝ',
  },
  {
    label: '46691601',
    value:
      'XΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΙΦΩΝ, ΣΠΑΘΙΩΝ, ΞΙΦΟΛΟΓΧΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΟΠΛΩΝ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691602',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΟΜΒΩΝ, ΒΛΗΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΟΛΕΜΟΦΟΔΙΩΝ, ΦΥΣΙΓΓΙΩΝ, ΑΛΛΩΝ ΠΥΡΟΜΑΧΙΚΩΝ ΚΑΙ ΒΛΗΜΑΤΩΝ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691603',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΠΟΛΕΜΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΟΠΛΩΝ',
  },
  {
    label: '46691604',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΙΣΤΡΟΦΩΝ, ΠΙΣΤΟΛΙΩΝ, ΑΛΛΩΝ ΠΥΡΟΒΟΛΩΝ, ΠΑΡΟΜΟΙΩΝ ΣΥΣΤΗΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΟΠΛΩΝ (ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΚΥΝΗΓΙ Η ΑΘΛΗΤΙΣΜΟ)',
  },
  {
    label: '46691605',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΕΜΙΚΩΝ ΟΠΛΩΝ, ΕΚΤΟΣ ΑΠΟ ΠΕΡΙΣΤΡΟΦΑ, ΠΙΣΤΟΛΙΑ ΚΑΙ ΞΙΦΗ ΚΑΙ ΠΑΡΟΜΟΙΑ ΟΠΛΑ',
  },
  {
    label: '46691606',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΟΒΟΛΩΝ ΟΠΛΩΝ ΠΟΥ ΟΠΛΙΖΟΝΤΑΙ ΑΠΟ ΤΗΝ ΚΑΝΝΗ, ΤΟΥΦΕΚΙΩΝ ΑΘΛΗΣΗΣ, ΚΥΝΗΓΙΟΥ Η ΣΚΟΠΟΒΟΛΗΣ',
  },
  {
    label: '46691900',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ, ΣΥΣΚΕΥΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΕΝΙΚΗΣ ΚΑΙ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46691901',
    value:
      'XΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΥΛΟΠΕΤΡΩΝ, ΑΚΟΝΟΠΕΤΡΩΝ, ΤΡΟΧΩΝ ΛΕΙΑΝΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46691902',
    value:
      'XΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΗΡΑΝΤΗΡΙΩΝ ΞΥΛΕΙΑΣ, ΧΑΡΤΟΠΟΛΤΟΥ, ΧΑΡΤΙΟΥ Η ΧΑΡΤΟΝΙΟΥ ΚΑΙ ΣΤΕΓΝΩΤΗΡΙΩΝ ΜΗ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46691903',
    value:
      'XΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΔΟΝΤΩΤΩΝ ΤΡΟΧΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΟΔΟΝΤΩΤΩΝ ΤΡΟΧΩΝ, ΕΝΣΦΑΙΡΩΝ ΚΟΧΛΙΩΤΩΝ ΑΞΟΝΩΝ, ΚΙΒΩΤΙΩΝ ΤΑΧΥΤΗΤΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΤΑΞΕΩΝ ΑΛΛΑΓΗΣ ΤΑΧΥΤΗΤΑΣ',
  },
  {
    label: '46691904',
    value:
      'XΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΑΥΤΟΜΑΤΗΣ ΡΥΘΜΙΣΗΣ Η ΕΛΕΓΧΟΥ, ΘΕΡΜΟΣΤΑΤΩΝ',
  },
  {
    label: '46691905',
    value:
      'XΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΦΥΣΙΚΕΣ Η ΧΗΜΙΚΕΣ ΑΝΑΛΥΣΕΙΣ',
  },
  {
    label: '46691906',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΕΡΑΝΤΛΙΩΝ Η ΑΝΤΛΙΩΝ ΚΕΝΟΥ, ΑΕΡΟΣΥΜΠΙΕΣΤΩΝ ΚΑΙ ΑΛΛΩΝ ΑΕΡΙΟΣΥΜΠΙΕΣΤΩΝ',
  },
  {
    label: '46691907',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΕΡΙΟΓΕΝΝΗΤΡΙΩΝ ΑΕΡΙΟΥ Η ΝΕΡΟΥ, ΑΕΡΙΟΓΕΝΝΗΤΡΙΩΝ ΑΚΕΤΥΛΕΝΙΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΑΕΡΙΟΓΕΝΝΗΤΡΙΩΝ, ΕΞΟΠΛΙΣΜΟΥ ΑΠΟΣΤΑΞΗΣ Η ΔΙΥΛΙΣΗΣ',
  },
  {
    label: '46691908',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΣΥΜΠΙΕΣΤΩΝ',
  },
  {
    label: '46691909',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΟΥΜΙΝΕΝΙΩΝ ΒΑΡΕΛΙΩΝ, ΚΥΛΙΝΔΡΙΚΩΝ ΔΟΧΕΙΩΝ, ΜΠΙΤΟΝΙΩΝ, ΚΟΥΤΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ, ΓΙΑ ΚΑΘΕ ΥΛΙΚΟ, ΧΩΡΗΤΙΚΟΤΗΤΑΣ > ΤΩΝ 300 ~ LT',
  },
  {
    label: '46691910',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΕΜΙΣΤΗΡΩΝ, ΕΚΤΟΣ ΤΩΝ ΕΠΙΤΡΑΠΕΖΙΩΝ ΑΝΕΜΙΣΤΗΡΩΝ, ΤΩΝ ΑΝΕΜΙΣΤΗΡΩΝ ΔΑΠΕΔΟΥ, ΤΟΙΧΟΥ, ΠΑΡΑΘΥΡΟΥ, ΟΡΟΦΗΣ Η ΣΤΕΓΗΣ',
  },
  {
    label: '46691911',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΙΥΓΡΑΣΙΑΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '46691912',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΛΙΩΝ ΓΙΑ ΥΓΡΑ, ΑΝΥΨΩΤΩΝ ΥΓΡΩΝ',
  },
  {
    label: '46691913',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΛΙΩΝ ΓΙΑ ΥΓΡΑ (ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ), ΕΚΤΟΣ ΤΩΝ ΑΝΤΛΙΩΝ ΣΚΥΡΟΔΕΜΑΤΟΣ',
  },
  {
    label: '46691914',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΛΙΩΝ ΚΕΝΟΥ',
  },
  {
    label: '46691915',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΘΡΩΤΩΝ ΣΙΔΗΡΩΝ ΑΛΥΣΙΔΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΤΡΟΧΟΦΟΡΑ',
  },
  {
    label: '46691916',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΤΜΟΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691917',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΤΜΟΛΕΒΗΤΩΝ Η ΑΛΛΩΝ ΛΕΒΗΤΩΝ ΠΑΡΑΓΩΓΗΣ ΑΤΜΟΥ, ΛΕΒΗΤΩΝ ΥΠΕΡΘΕΡΜΑΙΝΟΜΕΝΟΥ ΝΕΡΟΥ',
  },
  {
    label: '46691918',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΤΟΜΙΚΩΝ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΖΥΓΙΣΗΣ ΚΑΙ ΣΥΣΚΕΥΩΝ ΖΥΓΙΣΗΣ, ΣΥΣΚΕΥΩΝ ΓΙΑ ΔΙΑΡΚΗ ΖΥΓΙΣΗ ΠΡΟΪΟΝΤΩΝ ΣΤΟΥΣ ΙΜΑΝΤΕΣ ΜΕΤΑΦΟΡΑΣ, ΣΤΑΘΕΡΩΝ ΣΥΣΚΕΥΩΝ ΖΥΓΙΣΗΣ ΚΑΙ ΣΥΣΚΕΥΩΝ ΕΚΦΟΡΤΩΣΗΣ ΠΡΟΚΑΘΟΡΙΣΜΕΝΟΥ ΒΑΡΟΥΣ',
  },
  {
    label: '46691919',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΜΑΤΩΝ ΖΥΓΑΡΙΩΝ',
  },
  {
    label: '46691920',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΠΩΛΗΣΗΣ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46691921',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΜΗΧΑΝΙΚΩΝ Η ΕΡΓΑΣΤΗΡΙΑΚΩΝ ΚΛΙΒΑΝΩΝ ΚΑΙ ΦΟΥΡΝΩΝ',
  },
  {
    label: '46691922',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΟΗΘΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΛΕΒΗΤΕΣ, ΣΥΜΠΥΚΝΩΤΩΝ ΓΙΑ ΑΛΛΕΣ ΜΟΝΑΔΕΣ ΠΑΡΑΓΩΓΗΣ ΑΤΜΟΥ',
  },
  {
    label: '46691923',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΞΑΜΕΝΩΝ, ΒΑΡΕΛΙΩΝ, ΚΥΛΙΝΔΡΙΚΩΝ ΔΟΧΕΙΩΝ, ΜΠΙΤΟΝΙΩΝ, ΚΟΥΤΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ (ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΑΕΡΙΑ), ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46691924',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΚΛΕΙΔΩΝ ΕΛΕΓΧΟΥ ΛΕΙΤΟΥΡΓΙΑΣ, ΔΙΚΛΕΙΔΩΝ ΕΙΣΟΔΟΥ, ΣΦΑΙΡΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΚΛΕΙΔΩΝ',
  },
  {
    label: '46691925',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΚΛΕΙΔΩΝ ΜΕΙΩΣΗΣ ΤΗΣ ΠΙΕΣΗΣ, ΔΙΚΛΕΙΔΩΝ ΕΛΕΓΧΟΥ, ΡΥΘΜΙΣΤΙΚΩΝ ΚΑΙ ΑΣΦΑΛΙΣΤΙΚΩΝ ΔΙΚΛΕΙΔΩΝ',
  },
  {
    label: '46691926',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΧΕΙΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΠΟΥ ΚΛΕΙΝΟΝΤΑΙ ΜΕ ΣΥΓΚΟΛΛΗΣΗ Η ΛΙΘΟΚΟΛΛΗΣΗ',
  },
  {
    label: '46691927',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΧΕΙΩΝ ΕΛΑΦΡΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '46691928',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΔΡΑΝΩΝ ΚΑΙ ΚΟΥΖΙΝΕΤΩΝ',
  },
  {
    label: '46691929',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΚΤΥΠΩΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ OFFSET',
  },
  {
    label: '46691930',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΚΧΙΟΝΙΣΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ (ΑΡΟΤΡΩΝ ΧΙΟΝΙΟΥ ΚΑΙ ΦΥΣΕΡΩΝ ΧΙΟΝΙΟΥ)',
  },
  {
    label: '46691931',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΨΥΞΗΣ ΚΑΙ ΚΑΤΑΨΥΞΗΣ ΚΑΙ ΑΝΤΛΙΩΝ ΘΕΡΜΟΤΗΤΑΣ, ΕΚΤΟΣ ΤΩΝ ΣΥΣΚΕΥΩΝ ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691932',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ Η ΣΥΣΚΕΥΩΝ ΥΓΡΑΕΡΙΟΥ, ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΤΡΟΦΙΜΩΝ ΚΑΙ ΠΟΤΩΝ, ΞΕΝΟΔΟΧΕΙΩΝ, ΖΑΧΑΡΟΠΛΑΣΤΕΙΩΝ, ΕΣΤΙΑΤΟΡΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ',
  },
  {
    label: '46691933',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΠΛΥΝΤΗΡΙΩΝ ΡΟΥΧΩΝ, ΜΗΧΑΝΩΝ ΣΤΕΓΝΟΥ ΚΑΘΑΡΙΣΜΟΥ, ΣΤΕΓΝΩΤΗΡΙΩΝ ΜΕ ΧΩΡΗΤΙΚΟΤΗΤΑ > 10 ~ ΚΙΛΩΝ',
  },
  {
    label: '46691934',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΥΓΑΡΙΩΝ ΜΕ ΕΥΑΙΣΘΗΣΙΑ ΣΕ ΒΑΡΟΣ >= 5 ~ CG',
  },
  {
    label: '46691935',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΤΗΡΩΝ, ΜΗΧΑΝΙΚΩΝ ΘΕΡΜΑΣΤΡΩΝ ΚΑΙ ΕΣΧΑΡΩΝ, ΜΗΧΑΝΙΚΩΝ ΔΙΑΤΑΞΕΩΝ ΓΙΑ ΤΗΝ ΑΠΟΜΑΚΡΥΝΣΗ ΤΗΣ ΣΤΑΧΤΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '46691936',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΕΚΚΙΝΗΣΗΣ ΚΑΙ ΕΚΚΙΝΗΤΩΝ ~ ΓΕΝΝΗΤΡΙΩΝ ΔΙΠΛΗΣ ΧΡΗΣΗΣ, ΑΛΛΩΝ ΓΕΝΝΗΤΡΙΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΓΙΑ ΑΛΛΕΣ ΜΗΧΑΝΕΣ',
  },
  {
    label: '46691937',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ, ΣΤΟΥΣ ΟΠΟΙΟΥΣ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΗΛΕΚΤΡΙΚΟ ΣΠΙΝΘΗΡΑ, ΑΛΛΩΝ ΚΙΝΗΤΗΡΩΝ',
  },
  {
    label: '46691938',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΛΙΜΑΤΙΣΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '46691939',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΤΙΩΝ, ΘΗΚΩΝ, ΚΙΒΩΤΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46691940',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΕΙΑΝΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46691941',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΕΙΑΝΤΙΚΩΝ ΣΚΟΝΩΝ Η ΚΟΚΚΩΝ, ΣΕ ΒΑΣΗ ΑΠΟ ΥΦΑΝΤΙΚΟ ΥΛΙΚΟ, ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '46691942',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΕΡΑΝΤΛΙΩΝ Η ΑΝΤΛΙΩΝ ΚΕΝΟΥ, ΑΕΡΟΣΥΜΠΙΕΣΤΩΝ Η ΑΕΡΙΟΣΥΜΠΙΕΣΤΩΝ, ΑΝΕΜΙΣΤΗΡΩΝ, ΑΠΟΡΡΟΦΗΤΗΡΩΝ',
  },
  {
    label: '46691943',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΓΕΝΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46691944',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46691945',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΝΤΛΙΩΝ ΚΑΙ ΥΔΡΑΥΛΙΚΩΝ ΚΙΝΗΤΗΡΩΝ ΚΑΙ ΚΙΝΗΤΗΡΩΝ ΠΕΠΙΕΣΜΕΝΟΥ ΑΕΡΑ',
  },
  {
    label: '46691946',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΝΤΛΙΩΝ, ΜΕΡΩΝ ΑΝΥΨΩΤΩΝ ΥΓΡΩΝ',
  },
  {
    label: '46691947',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΓΕΝΝΗΤΡΙΩΝ ΑΕΡΙΟΥ Η ΝΕΡΟΥ',
  },
  {
    label: '46691948',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΕΤΡΗΤΩΝ ΑΕΡΙΩΝ, ΥΓΡΩΝ Η ΗΛΕΚΤΡΙΣΜΟΥ, ΠΑΡΑΓΩΓΗΣ, ΤΑΞΙΜΕΤΡΩΝ, ΤΑΧΟΓΡΑΦΩΝ ΚΑΙ ΣΤΡΟΒΟΣΚΟΠΙΩΝ',
  },
  {
    label: '46691949',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΑΥΤΟΜΑΤΗΣ ΡΥΘΜΙΣΗΣ Η ΕΛΕΓΧΟΥ',
  },
  {
    label: '46691950',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΙΑ ΜΕΤΡΗΣΕΙΣ, ΕΛΕΓΧΟΥΣ, ΔΟΚΙΜΕΣ, ΓΙΑ ΤΗ ΝΑΥΣΙΠΛΟΪΑ ΚΑΙ ΑΛΛΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '46691951',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΝΑΥΣΙΠΛΟΪΑΣ, ΜΕΤΕΩΡΟΛΟΓΙΑΣ, ΓΕΩΦΥΣΙΚΗΣ ΚΛΠ, ΟΡΓΑΝΩΝ ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΜΕΤΡΗΣΗΣ ΜΗΚΟΥΣ, ΜΕΤΡΗΣΗΣ ΗΛΕΚΤΡΙΚΩΝ ΜΕΓΕΘΩΝ ΚΑΙ ΙΟΝΤΙΖΟΥΣΩΝ ΑΚΤΙΝΟΒΟΛΙΩΝ, ΕΛΕΓΧΟΥ ΑΛΛΩΝ ΦΥΣΙΚΩΝ ΧΑΡΑΚΤΗΡΙΣΤΙΚΩΝ, Δ',
  },
  {
    label: '46691952',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΠΟΥ ΔΕΝ ΠΕΡΙΕΧΟΥΝ ΗΛΕΚΤΡΙΚΕΣ ΣΥΝΔΕΣΕΙΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46691953',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΤΡΙΒΕΩΝ ΚΑΙ ΜΗΧΑΝΙΣΜΩΝ ΜΕΤΑΔΟΣΗΣ ΤΗΣ ΚΙΝΗΣΗΣ',
  },
  {
    label: '46691954',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΥΔΡΑΥΛΙΚΩΝ ΣΤΡΟΒΙΛΩΝ, ΥΔΡΑΥΛΙΚΩΝ ΤΡΟΧΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΡΥΘΜΙΣΤΩΝ',
  },
  {
    label: '46691955',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΟΥΡΓΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691956',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΡΗΤΩΝ ΠΑΡΟΧΗΣ Η ΠΑΡΑΓΩΓΗΣ ΑΕΡΙΩΝ, ΥΓΡΩΝ Η ΗΛΕΚΤΡΙΚΗΣ ΕΝΕΡΓΕΙΑΣ',
  },
  {
    label: '46691957',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΤΡΩΝ, ΚΑΣΩΝ (ΠΛΑΙΣΙΩΝ) ΧΥΤΗΡΙΟΥ ΓΙΑ ΧΥΤΗΡΙΑ ΜΕΤΑΛΛΟΥ, ΒΑΣΕΩΝ ΜΗΤΡΩΝ, ΜΟΝΤΕΛΩΝ ΓΙΑ ΜΗΤΡΕΣ',
  },
  {
    label: '46691958',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΒΙΒΛΙΟΔΕΣΙΑΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΟΙ ΡΑΠΤΟΜΗΧΑΝΕΣ ΓΙΑ ΒΙΒΛΙΑ) ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691959',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46691960',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΕΚΤΥΠΩΣΗΣ ΚΑΙ ΒΙΒΛΙΟΔΕΣΙΑΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691961',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΖΥΓΙΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46691962',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΘΑΡΙΣΜΟΥ, ΓΕΜΙΣΜΑΤΟΣ, ΣΥΣΚΕΥΑΣΙΑΣ Η ΠΕΡΙΤΥΛΙΓΜΑΤΟΣ ΦΙΑΛΩΝ Η ΑΛΛΩΝ ΔΟΧΕΙΩΝ',
  },
  {
    label: '46691963',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΔΙΗΘΗΣΗΣ Η ΚΑΘΑΡΙΣΜΟΥ ΑΕΡΙΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691964',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΔΙΗΘΗΣΗΣ Η ΚΑΘΑΡΙΣΜΟΥ ΥΓΡΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691965',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΥΔΑΤΟΣ',
  },
  {
    label: '46691966',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α. ΓΙΑ ΤΗΝ ΕΠΕΞΕΡΓΑΣΙΑ ΥΛΙΚΩΝ, ΜΕ ΜΕΘΟΔΟ ΠΟΥ ΣΥΝΕΠΑΓΕΤΑΙ ΜΕΤΑΒΟΛΗ ΤΗΣ ΘΕΡΜΟΚΡΑΣΙΑΣ',
  },
  {
    label: '46691967',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α. ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΕΛΑΣΤΙΚΟΥ Η ΠΛΑΣΤΙΚΟΥ Η ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΑΥΤΑ ΤΑ ΥΛΙΚΑ',
  },
  {
    label: '46691968',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΠΑΡΑΓΩΓΗΣ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691969',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ, ΣΥΣΚΕΥΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΤΗ ΣΤΟΙΧΕΙΟΘΕΣΙΑ, ΤΗΝ ΠΡΟΕΤΟΙΜΑΣΙΑ ΚΑΙ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΤΥΠΟΓΡΑΦΙΚΩΝ ΠΛΑΚΩΝ',
  },
  {
    label: '46691970',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΑΡΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΤΕΘΩΡΑΚΙΣΜΕΝΩΝ ΟΧΗΜΑΤΩΝ ΜΑΧΗΣ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691971',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΔΟΚΙΜΗΣ ΤΩΝ ΜΗΧΑΝΙΚΩΝ ΙΔΙΟΤΗΤΩΝ ΚΑΙ ΥΛΙΚΩΝ',
  },
  {
    label: '46691972',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΙΚΡΟΣΚΟΠΙΩΝ (ΕΚΤΟΣ ΤΩΝ ΟΠΤΙΚΩΝ ΜΙΚΡΟΣΚΟΠΙΩΝ) ΚΑΙ ΣΥΣΚΕΥΩΝ ΠΕΡΙΘΛΑΣΗΣ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691973',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΝΑΔΩΝ ΕΝΑΛΛΑΓΗΣ ΘΕΡΜΟΤΗΤΑΣ ΚΑΙ ΜΗΧΑΝΗΜΑΤΩΝ ΥΓΡΟΠΟΙΗΣΗΣ ΑΕΡΑ Η ΑΕΡΙΩΝ',
  },
  {
    label: '46691974',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΩΝ ΜΕΤΡΗΣΗΣ Η ΕΛΕΓΧΟΥ ΤΗΣ ΠΑΡΟΧΗΣ, ΤΗΣ ΣΤΑΘΜΗΣ, ΤΗΣ ΠΙΕΣΗΣ Η ΑΛΛΩΝ ΜΕΤΑΒΛΗΤΩΝ ΤΩΝ ΥΓΡΩΝ ΚΑΙ ΤΩΝ ΑΕΡΙΩΝ',
  },
  {
    label: '46691975',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΩΝ ΜΕΤΡΗΣΗΣ Η ΕΛΕΓΧΟΥ, ΣΥΣΚΕΥΩΝ ΚΑΙ ΜΗΧΑΝΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46691976',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΩΝ, ΣΥΣΚΕΥΩΝ ΚΑΙ ΜΟΝΤΕΛΩΝ ΓΙΑ ΕΠΙΔΕΙΞΕΙΣ',
  },
  {
    label: '46691977',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΙΣΤΡΕΦΟΜΕΝΩΝ ΕΞΕΔΡΩΝ ΜΕ ΜΕΣΑ ΔΙΑΣΚΕΔΑΣΗΣ, ΚΟΥΝΙΩΝ, ΠΕΡΙΠΤΕΡΩΝ ΣΚΟΠΟΒΟΛΗΣ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΔΙΑΣΚΕΔΑΣΗΣ ΥΠΑΙΘΡΙΩΝ ΧΩΡΩΝ ΠΑΝΗΓΥΡΕΩΝ',
  },
  {
    label: '46691978',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΙΣΤΡΟΦΙΚΩΝ ΑΝΤΛΙΩΝ ΘΕΤΙΚΟΥ ΕΚΤΟΠΙΣΜΑΤΟΣ ΓΙΑ ΥΓΡΑ',
  },
  {
    label: '46691979',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΕΙΔΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ ΓΙΑ ΤΕΧΝΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '46691980',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΓΕΝΙΚΗΣ ΚΑΙ ΕΙΔΙΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46691981',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΟΣΒΕΣΤΗΡΩΝ',
  },
  {
    label: '46691982',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΟΣΒΕΣΤΗΡΩΝ, ΨΕΚΑΣΤΗΡΩΝ, ΜΗΧΑΝΩΝ ΑΤΜΟΒΟΛΗΣ Η ΑΜΜΟΒΟΛΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗΧΑΝΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΕΚΤΟΣ ΤΩΝ ΣΥΣΚΕΥΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗ ΓΕΩΡΓΙΑ',
  },
  {
    label: '46691983',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΩΜΑΤΩΝ ~ ΣΤΕΦΑΝΙΩΝ ΚΑΙ ΠΩΜΑΤΩΝ, ΤΑΠΩΝ ΚΑΙ ΚΑΠΑΚΙΩΝ ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46691984',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΚΩΝ ΚΑΙ ΤΣΑΝΤΩΝ ΑΠΟ ΑΛΛΕΣ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ (ΕΚΤΟΣ ΤΟΥ ΑΙΘΥΛΕΝΙΟΥ), ΓΙΑ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '46691985',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΚΩΝ ΚΑΙ ΤΣΑΝΤΩΝ ΑΠΟ ΠΟΛΥΜΕΡΗ ΤΟΥ ΑΙΘΥΛΕΝΙΟΥ, ΓΙΑ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '46691986',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΠΙΝΘΗΡΙΣΤΩΝ (ΜΠΟΥΖΙ), ΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΑΝΑΦΛΕΞΗΣ, ΔΥΝΑΜΟΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΜΑΓΝΗΤΙΚΩΝ ΣΦΟΝΔΥΛΩΝ, ΔΙΑΝΟΜΕΩΝ, ΠΗΝΙΩΝ ΑΝΑΦΛΕΞΗΣ, ΓΙΑ ΑΛΛΕΣ ΜΗΧΑΝΕΣ',
  },
  {
    label: '46691987',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΟΒΙΛΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691988',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΟΦΟΜΕΤΡΩΝ ΚΑΙ ΜΕΤΡΗΤΩΝ ΠΑΡΑΓΩΓΗΣ, ΤΑΞΙΜΕΤΡΩΝ, ΟΡΓΑΝΩΝ ΕΝΔΕΙΞΗΣ ΤΗΣ ΤΑΧΥΤΗΤΑΣ ΚΑΙ ΤΑΧΟΓΡΑΦΩΝ, ΣΤΡΟΒΟΣΚΟΠΙΩΝ',
  },
  {
    label: '46691989',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΜΠΙΕΣΤΩΝ ΓΙΑ ΨΥΚΤΙΚΟ ΕΞΟΠΛΙΣΜΟ',
  },
  {
    label: '46691990',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΠΟΥ ΒΑΣΙΖΟΝΤΑΙ ΣΤΗ ΧΡΗΣΗ ΑΚΤΙΝΩΝ Χ Η ΑΚΤΙΝΟΒΟΛΙΩΝ Α, Β Η Γ',
  },
  {
    label: '46691991',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΤΗΜΑΤΩΝ ΚΑΘΑΡΙΣΜΟΥ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΑΠΟΡΡΙΜΜΑΤΩΝ',
  },
  {
    label: '46691992',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΦΑΙΡΙΔΙΩΝ, ΒΕΛΟΝΩΝ ΚΑΙ ΚΥΛΙΝΔΡΩΝ, ΜΕΡΩΝ ΕΝΣΦΑΙΡΩΝ ΤΡΙΒΕΩΝ Η ΚΥΛΙΝΔΡΟΤΡΙΒΕΩΝ',
  },
  {
    label: '46691993',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΦΟΝΔΥΛΩΝ ΚΑΙ ΤΡΟΧΑΛΙΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΤΑ ΣΥΣΠΑΣΤΑ)',
  },
  {
    label: '46691994',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΑΜΙΕΥΤΗΡΩΝ, ΔΕΞΑΜΕΝΩΝ, ΚΑΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46691995',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΑΜΙΕΥΤΗΡΩΝ, ΔΕΞΑΜΕΝΩΝ, ΚΑΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ, ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '46691996',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΑΞΙΜΕΤΡΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '46691997',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΔΡΑΥΛΙΚΩΝ ΚΙΝΗΤΗΡΩΝ ΚΑΙ ΚΙΝΗΤΗΡΩΝ ΠΕΠΙΕΣΜΕΝΟΥ ΑΕΡΑ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46691998',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΚΑΘΑΡΙΣΜΟΥ ΝΕΡΟΥ ΚΑΙ ΑΕΡΑ',
  },
  {
    label: '46691999',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΚΤΥΠΩΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46692001',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΜΒΟΛΟΦΟΡΩΝ ΚΙΝΗΤΗΡΩΝ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ, ΤΩΝ ΟΠΟΙΩΝ Η ΑΝΑΦΛΕΞΗ ΓΙΝΕΤΑΙ ΜΕ ΣΥΜΠΙΕΣΗ',
  },
  {
    label: '46692002',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΣΥΣΚΕΥΑΣΙΑΣ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46692003',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΛΗΤΙΚΩΝ ΣΥΓΚΡΟΤΗΜΑΤΩΝ',
  },
  {
    label: '46692004',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΝΩΝ ΦΙΑΛΩΝ ΟΞΥΓΟΝΟΥ ΚΑΙ ΑΛΛΩΝ ΑΕΡΙΩΝ ΥΠΟ ΠΙΕΣΗ',
  },
  {
    label: '46692005',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΕΚΤΥΠΩΣΗ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '46692006',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΡΟΣΤΑΣΙΑ ΤΟΥ ΠΕΡΙΒΑΛΛΟΝΤΟΣ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΠΛΟΙΑ ΚΑΙ ΝΑΥΠΗΓΕΙΑ',
  },
  {
    label: '46692007',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΚΑΙ ΕΡΓΑΛΕΙΩΝ ΕΚΤΥΠΩΣΗΣ, (ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΤΕΛΑΡΩΝ ΜΕΤΑΞΟΤΥΠΙΑΣ)',
  },
  {
    label: '46692008',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΔΡΟΜΕΤΡΩΝ, ΘΕΡΜΟΜΕΤΡΩΝ, ΠΥΡΟΜΕΤΡΩΝ, ΒΑΡΟΜΕΤΡΩΝ, ΥΓΡΟΜΕΤΡΩΝ ΚΑΙ ΨΥΧΡΟΜΕΤΡΩΝ',
  },
  {
    label: '46692009',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΕΝΕΡΓΟΥ ΑΝΘΡΑΚΑ',
  },
  {
    label: '46692010',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΚΑΙ ΔΙΑΤΑΞΕΩΝ ΚΑΘΑΡΙΣΜΟΥ ΝΕΡΟΥ ΚΑΙ ΑΕΡΑ',
  },
  {
    label: '46692011',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΕΛΕΓΧΟΥ ΚΑΥΣΑΕΡΙΩΝ',
  },
  {
    label: '46692012',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΛΑΔΙΟΥ, ΦΙΛΤΡΩΝ ΒΕΝΖΙΝΗΣ ΚΑΙ ΦΙΛΤΡΩΝ ΕΙΣΑΓΩΓΗΣ ΑΕΡΑ ΓΙΑ ΚΙΝΗΤΗΡΕΣ ΕΣΩΤΕΡΙΚΗΣ ΚΑΥΣΗΣ',
  },
  {
    label: '46692013',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΟΥΡΝΩΝ, ΚΑΥΣΤΗΡΩΝ, ΚΛΙΒΑΝΩΝ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '46692014',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΓΟΚΕΝΤΡΙΚΩΝ ΑΝΤΛΙΩΝ ΓΙΑ ΥΓΡΑ, ΑΛΛΩΝ ΑΝΤΛΙΩΝ ΚΑΙ ΑΝΥΨΩΤΩΝ ΥΓΡΩΝ',
  },
  {
    label: '46692015',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΓΟΚΕΝΤΡΙΚΩΝ ΜΗΧΑΝΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46692016',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΥΚΤΙΚΩΝ ΘΑΛΑΜΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46710000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΕΡΕΩΝ, ΥΓΡΩΝ ΚΑΙ ΑΕΡΙΩΝ ΚΑΥΣΙΜΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46711100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΕΡΕΩΝ ΚΑΥΣΙΜΩΝ',
  },
  {
    label: '46711101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΘΡΑΚΑ, ΜΗ ΣΥΣΣΩΜΑΤΩΜΕΝΟΥ',
  },
  {
    label: '46711102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΑΙΑΝΘΡΑΚΩΝ',
  },
  {
    label: '46711103',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΟΞΥΛΩΝ',
  },
  {
    label: '46711104',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΙΓΝΙΤΗ',
  },
  {
    label: '46711105',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΠΡΙΚΕΤΩΝ, ΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΑΠΟ ΤΥΡΦΗ',
  },
  {
    label: '46711106',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΠΡΙΚΕΤΩΝ, ΣΦΑΙΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΤΕΡΕΩΝ ΚΑΥΣΙΜΩΝ, ΠΟΥ ΠΑΡΑΓΟΝΤΑΙ ΑΠΟ ΤΟΝ ΑΝΘΡΑΚΑ',
  },
  {
    label: '46711107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΑΝΘΡΑΚΑ, ΚΑΥΣΙΜΟΥ',
  },
  {
    label: '46711108',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΠΤΑΝΘΡΑΚΑ ΚΑΙ ΗΜΙΟΠΤΑΝΘΡΑΚΑ ΑΠΟ ΛΙΘΑΝΘΡΑΚΑ, ΑΠΟ ΛΙΓΝΙΤΗ Η ΤΥΡΦΗ, ΑΝΘΡΑΚΑ ΑΠΟΣΤΑΚΤΙΚΟΥ ΚΕΡΑΤΟΣ',
  },
  {
    label: '46711109',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΕΡΕΩΝ ΒΙΟΚΑΥΣΙΜΩΝ',
  },
  {
    label: '46711200',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΩΝ ΚΙΝΗΤΗΡΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΚΑΥΣΙΜΩΝ ΓΙΑ ΑΕΡΟΣΚΑΦΗ',
  },
  {
    label: '46711201',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ (ΠΡΑΤΗΡΙΟ) ΒΕΝΖΙΝΗΣ ΚΑΙ ΠΕΤΡΕΛΑΙΟΥ ΚΙΝΗΣΗΣ',
  },
  {
    label: '46711202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ (ΠΡΑΤΗΡΙΟ) ΥΓΡΑΕΡΙΩΝ ΓΙΑ ΕΦΟΔΙΑΣΜΟ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '46711203',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΩΝ ΑΕΡΙΩΘΟΥΜΕΝΩΝ ΑΕΡΟΣΚΑΦΩΝ ΤΥΠΟΥ ΒΕΝΖΙΝΗΣ',
  },
  {
    label: '46711204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΗΡΟΖΙΝΗΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΚΑΥΣΙΜΩΝ ΑΕΡΙΩΘΟΥΜΕΝΩΝ ΑΕΡΟΣΚΑΦΩΝ ΤΥΠΟΥ ΚΗΡΟΖΙΝΗΣ)',
  },
  {
    label: '46711205',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΤΡΕΛΑΙΟΥ ΓΙΑ ΚΙΝΗΤΗΡΕΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΑΥΤΩΝ ΤΩΝ ΣΚΑΦΩΝ)',
  },
  {
    label: '46711206',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΠΑΝΙΟΥ ΚΑΙ ΒΟΥΤΑΝΙΟΥ, ΥΓΡΟΠΟΙΗΜΕΝΩΝ ΓΙΑ ΧΡΗΣΙΜΟΠΟΙΗΣΗ ΣΕ ΜΗΧΑΝΕΣ',
  },
  {
    label: '46711207',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΓΡΩΝ Η ΑΕΡΙΩΝ ΒΙΟΚΑΥΣΙΜΩΝ ΚΑΙ ΜΕΙΓΜΑΤΩΝ ΤΟΥΣ, ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΚΙΝΗΤΗΡΕΣ',
  },
  {
    label: '46711300',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΥΓΡΩΝ ΚΑΙ ΑΕΡΙΩΝ ΚΑΥΣΙΜΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46711301',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΕΡΙΕΛΑΙΩΝ',
  },
  {
    label: '46711302',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΙΘΥΛΕΝΙΟΥ, ΠΡΟΠΥΛΕΝΙΟΥ, ΒΟΥΤΥΛΕΝΙΟΥ, ΒΟΥΤΑΔΙΕΝΙΟΥ ΚΑΙ ΑΛΛΩΝ ΑΕΡΙΩΝ ΠΕΤΡΕΛΑΙΟΥ Η ΑΕΡΙΩΝ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ, ΕΚΤΟΣ ΤΟΥ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ',
  },
  {
    label: '46711303',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΛΑΦΡΩΝ ΕΛΑΙΩΝ ΠΕΤΡΕΛΑΙΟΥ, ΕΛΑΦΡΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46711304',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΣΑΙΩΝ ΕΛΑΙΩΝ ΠΕΤΡΕΛΑΙΟΥ, ΜΕΣΑΙΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46711305',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΣΦΑΛΤΟΥΧΟΥ Η ΠΕΤΡΕΛΑΙΟΥΧΟΥ ΣΧΙΣΤΟΛΙΘΟΥ ΚΑΙ ΠΙΣΣΟΥΧΩΝ ΑΜΜΩΝ',
  },
  {
    label: '46711306',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΑΕΡΙΟΥ',
  },
  {
    label: '46711307',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΝΤΙΖΕΛ ΚΑΙ ΑΛΛΩΝ ΥΓΡΩΝ Η ΑΕΡΙΩΝ ΒΙΟΚΑΥΣΙΜΩΝ, ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΚΙΝΗΤΗΡΕΣ',
  },
  {
    label: '46711308',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΩΝ ΕΛΑΙΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46711309',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΙΠΑΝΤΙΚΩΝ ΕΛΑΙΩΝ ΠΕΤΡΕΛΑΙΟΥ, ΒΑΡΕΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46711310',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΥΚΤΕΛΑΙΩΝ ΚΑΙ ΛΙΠΑΝΤΙΚΩΝ',
  },
  {
    label: '46711311',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΤΡΕΛΑΪΚΩΝ ΕΛΑΙΩΝ ΚΑΙ ΕΛΑΙΩΝ ΠΟΥ ΛΑΜΒΑΝΟΝΤΑΙ ΑΠΟ ΑΣΦΑΛΤΟΥΧΑ ΟΡΥΚΤΑ, ΑΚΑΤΕΡΓΑΣΤΩΝ',
  },
  {
    label: '46711312',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ (ΠΡΑΤΗΡΙΟ) ΠΕΤΡΕΛΑΙΟΥ ΘΕΡΜΑΝΣΗΣ (ΠΑΡΑΔΟΣΗ ΣΤΗΝ ΕΓΚΑΤΑΣΤΑΣΗ ΤΟΥ ΠΩΛΗΤΗ)',
  },
  {
    label: '46711313',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ (ΠΡΑΤΗΡΙΟ) ΠΕΤΡΕΛΑΙΟΥ ΘΕΡΜΑΝΣΗΣ (ΠΑΡΑΔΟΣΗ ΣΤΗΝ ΕΓΚΑΤΑΣΤΑΣΗ ΤΟΥ',
  },
  {
    label: '46711314',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΤΡΕΛΑΙΟΥ ΘΕΡΜΑΝΣΗΣ ΑΠΟ ΜΕΤΑΠΩΛΗΤΗ',
  },
  {
    label: '46711315',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΠΑΝΙΟΥ ΚΑΙ ΒΟΥΤΑΝΙΟΥ, ΕΜΦΙΑΛΩΜΕΝΟΥ',
  },
  {
    label: '46711316',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΓΡΑΕΡΙΟΥ ΕΜΦΙΑΛΩΜΕΝΟΥ Η ΜΗ',
  },
  {
    label: '46711317',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ, ΥΓΡΟΠΟΙΗΜΕΝΟΥ Η ΣΕ ΑΕΡΙΩΔΗ ΚΑΤΑΣΤΑΣΗ',
  },
  {
    label: '46720000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΩΝ ΚΑΙ ΜΕΤΑΛΛΕΥΜΑΤΩΝ',
  },
  {
    label: '46721100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΕΥΜΑΤΩΝ',
  },
  {
    label: '46721101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΣΙΔΗΡΟΥ',
  },
  {
    label: '46721200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΕΥΜΑΤΩΝ',
  },
  {
    label: '46721201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ',
  },
  {
    label: '46721202',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΑΡΓΙΛΙΟΥ',
  },
  {
    label: '46721203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΜΟΛΥΒΔΟΥ, ΨΕΥΔΑΡΓΥΡΟΥ ΚΑΙ ΚΑΣΣΙΤΕΡΟΥ',
  },
  {
    label: '46721204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΠΟΛΥΤΙΜΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '46721205',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΕΥΜΑΤΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΧΑΛΚΟΥ ΚΑΙ ΟΡΕΙΧΑΛΚΟΥ',
  },
  {
    label: '46721300',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΥ ΚΑΙ ΧΑΛΥΒΑ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46721301',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΟΥ ΧΥΤΟΣΙΔΗΡΟΥ ΚΑΙ ΧΥΤΟΣΙΔΗΡΟΥ SPIEGEL ΣΕ ΧΕΛΩΝΕΣ, ΚΥΒΟΥΣ Η ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46721302',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46721303',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '46721304',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ ΓΙΑ ΤΙΣ ΚΑΤΑΣΚΕΥΕΣ',
  },
  {
    label: '46721305',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΣΙΔΗΡΟΚΡΑΜΑΤΩΝ',
  },
  {
    label: '46721306',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΣΦΥΡΗΛΑΤΗΜΕΝΩΝ',
  },
  {
    label: '46721307',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ, ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ Η ΑΛΛΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '46721308',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES), ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΑΠΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '46721309',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΑΠΟ ΣΙΔΗΡΟ Η ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ, ΑΛΛΩΝ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ ΑΠΟ ΑΛΛΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '46721310',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ Π.Δ.Κ.Α.',
  },
  {
    label: '46721311',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΣΥΓΚΟΛΛΗΜΕΝΩΝ',
  },
  {
    label: '46721312',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES), ΑΠΟ ΣΙΔΗΡΟ Η ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ, ΠΟΥ ΔΕΝ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΑΛΛΗ ΚΑΤΕΡΓΑΣΙΑ ΠΕΡΑΝ ΤΗΣ ΘΕΡΜΗΣ ΕΛΑΣΗΣ, ΤΗΣ ΘΕΡΜΗΣ ΕΠΕΚΤΑΤΙΚΗΣ ΟΛΚΗΣ Η ΤΗΣ ΔΙΕΛΑΣΗΣ',
  },
  {
    label: '46721313',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES), ΣΧΗΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ',
  },
  {
    label: '46721314',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES), ΣΧΗΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '46721315',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ Π.Δ.Κ.Α.',
  },
  {
    label: '46721316',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΜΙΤΕΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ Η ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '46721317',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΜΙΤΕΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '46721318',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΚΚΩΝ ΚΑΙ ΣΚΟΝΩΝ, ΑΠΟ ΑΚΑΤΕΡΓΑΣΤΟ ΧΥΤΟΣΙΔΗΡΟ, ΧΥΤΟΣΙΔΗΡΟ SPIEGEL, ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46721319',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΣΣΑΛΟΣΑΝΙΔΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46721320',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΕΔΩΝ ΦΥΛΛΩΝ ΕΛΑΣΗΣ ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ Η ΑΠΟ ΑΛΛΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ, ΠΛΑΤΟΥΣ >500 ~ MM',
  },
  {
    label: '46721321',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΕΔΩΝ ΦΥΛΛΩΝ ΕΛΑΣΗΣ ΑΠΟ ΣΙΔΗΡΟ Η ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ, ΠΛΑΤΟΥΣ > 500 ~ MM',
  },
  {
    label: '46721322',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΕΔΩΝ ΦΥΛΛΩΝ ΕΛΑΣΗΣ ΑΠΟ ΣΙΔΗΡΟ Η ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ, ΠΛΑΤΟΥΣ > 500 ~ MM, ΕΠΕΝΔΥΜΕΝΩΝ, ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ Η ΕΠΙΚΑΛΥΜΜΕΝΩΝ',
  },
  {
    label: '46721323',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΕΔΩΝ ΦΥΛΛΩΝ ΕΛΑΣΗΣ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46721324',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΙΝΘΩΜΑΤΩΝ ΑΠΟ ΥΠΟΛΕΙΜΜΑΤΑ ΔΕΥΤΕΡΗΣ ΤΗΞΗΣ',
  },
  {
    label: '46721325',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΙΝΘΩΜΑΤΩΝ, ΑΛΛΩΝ ΠΡΩΤΟΓΕΝΩΝ ΜΟΡΦΩΝ ΚΑΙ ΗΜΙΤΕΛΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46721326',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΜΑΓΓΑΝΙΟΥ',
  },
  {
    label: '46721327',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΝΙΚΕΛΙΟΥ',
  },
  {
    label: '46721328',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΥ ΜΠΕΤΟΝ',
  },
  {
    label: '46721329',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΥΧΩΝ ΠΡΟΪΟΝΤΩΝ ΠΟΥ ΛΑΜΒΑΝΟΝΤΑΙ ΜΕ ΑΠΕΥΘΕΙΑΣ ΑΝΑΓΩΓΗ ΣΙΔΗΡΟΥ, ΑΛΛΩΝ ΣΠΟΓΓΩΔΩΝ ΣΙΔΗΡΟΥΧΩΝ ΠΡΟΪΟΝΤΩΝ, ΣΙΔΗΡΟΥ ΜΕ ΕΛΑΧΙΣΤΗ ΚΑΘΑΡΟΤΗΤΑ ΚΑΤΑ ΒΑΡΟΣ 99 ;0,            94;%, ΣΕ ΤΕΜΑΧΙΑ, ΣΦΑΙΡΙΔΙΑ Η ΠΑΡΟΜΟΙΕΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46721330',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΧΡΩΜΙΟΥ',
  },
  {
    label: '46721331',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΟΙΧΕΙΩΝ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΓΡΑΜΜΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46721332',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΣ ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ Η ΑΛΛΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '46721333',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΣ ΑΠΟ ΣΙΔΗΡΟ Η ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '46721334',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΚΟΙΛΩΝ ΜΟΡΦΟΣΩΛΗΝΩΝ (HOLLOW PROFILES), ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46721335',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΚΟΙΛΩΝ ΜΟΡΦΟΣΩΛΗΝΩΝ (HOLLOW PROFILES), ΑΠΟ ΧΥΤΟΣΙΔΗΡΟ',
  },
  {
    label: '46721336',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΟΝΔΡΟΣΥΡΜΑΤΟΣ ΘΕΡΜΗΣ ΕΛΑΣΗΣ, ΣΕ ΑΚΑΝΟΝΙΣΤΑ ΠΕΡΙΕΛΙΓΜΕΝΑ ΠΗΝΙΑ',
  },
  {
    label: '46721337',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΥΤΩΝ ΕΞΑΡΤΗΜΑΤΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46721400',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46721401',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΟΥ ΑΡΓΙΛΙΟΥ',
  },
  {
    label: '46721402',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΟΥ ΝΙΚΕΛΙΟΥ',
  },
  {
    label: '46721403',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗ ΣΙΔΗΡΟΥΧΩΝ ΜΕΤΑΛΛΩΝ ΚΑΙ ΕΙΔΩΝ ΤΟΥΣ, ΚΕΡΑΜΟΜΕΤΑΛΛΩΝ, ΣΤΑΧΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΜΕΤΑΛΛΑ Η ΜΕΤΑΛΛΙΚΕΣ ΕΝΩΣΕΙΣ',
  },
  {
    label: '46721404',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΟΥΜΙΝΟΧΑΡΤΟΥ',
  },
  {
    label: '46721405',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΓΙΛΙΟΞΕΙΔΙΟΥ (ΕΚΤΟΣ ΤΟΥ ΤΕΧΝΗΤΟΥ ΚΟΡΟΥΝΔΙΟΥ)',
  },
  {
    label: '46721406',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΓΥΡΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ Η ΣΕ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΕΣ ΜΟΡΦΕΣ Η ΣΕ ΣΚΟΝΗ',
  },
  {
    label: '46721407',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΚΑΙ ΣΥΡΜΑΤΟΣ, ΑΠΟ ΝΙΚΕΛΙΟ',
  },
  {
    label: '46721408',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ ΚΑΙ ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΑΠΟ ΑΡΓΙΛΙΟ',
  },
  {
    label: '46721409',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ ΚΑΙ ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES), ΑΠΟ ΧΑΛΚΟ',
  },
  {
    label: '46721410',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΚΑΙ ΣΥΡΜΑΤΟΣ ΑΠΟ',
  },
  {
    label: '46721411',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΚΑΙ ΣΥΡΜΑΤΟΣ ΑΠΟ',
  },
  {
    label: '46721412',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΚΑΙ ΣΥΡΜΑΤΟΣ ΨΕΥΔΑΡΓΥΡΟΥ, ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ ΚΑΙ ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΨΕΥΔΑΡΓΥΡΟΥ',
  },
  {
    label: '46721413',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΣΑΓΟΜΕΝΟΥ ΧΡΥΣΟΥ Η ΑΡΓΥΡΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ Η ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΟΥ',
  },
  {
    label: '46721414',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΑΡΙΣΜΕΝΟΥ ΧΑΛΚΟΥ ΚΑΙ ΚΡΑΜΑΤΩΝ ΧΑΛΚΟΥ, ΑΚΑΤΕΡΓΑΣΤΩΝ ΜΗΤΡΙΚΩΝ ΚΡΑΜΑΤΩΝ ΧΑΛΚΟΥ',
  },
  {
    label: '46721415',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΣΣΙΤΕΡΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ',
  },
  {
    label: '46721416',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΑΛΥΤΩΝ ΣΕ ΜΟΡΦΗ ΣΥΡΜΑΤΙΝΩΝ ΥΦΑΣΜΑΤΩΝ Η ΔΙΚΤΥΩΤΩΝ ΑΠΟ ΠΛΑΤΙΝΑ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '46721417',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΙΝΩΝ ΜΕΤΑΛΛΩΝ ΕΠΑΡΓΥΡΩΜΕΝΩΝ ΚΑΙ ΚΟΙΝΩΝ ΜΕΤΑΛΛΩΝ, ΑΡΓΥΡΟΥ Η ΧΡΥΣΟΥ ΕΠΙΠΛΑΤΙΝΩΜΕΝΟΥ, ΠΟΥ ΔΕΝ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΑΛΛΗ ΚΑΤΕΡΓΑΣΙΑ ΠΕΡΑΝ ΤΗΣ ΗΜΙΚΑΤΕΡΓΑΣΙΑΣ',
  },
  {
    label: '46721418',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΙΝΩΝ ΜΕΤΑΛΛΩΝ Η ΑΡΓΥΡΟΥ, ΕΠΙΧΡΥΣΩΜΕΝΩΝ, ΠΟΥ ΔΕΝ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΑΛΛΗ ΚΑΤΕΡΓΑΣΙΑ ΠΕΡΑΝ ΤΗΣ ΗΜΙΚΑΤΕΡΓΑΣΙΑΣ',
  },
  {
    label: '46721419',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΑΡΓΙΛΙΟΥ, ΠΑΧΟΥΣ >= 0 ;.2 ~ MM',
  },
  {
    label: '46721420',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΕΠΤΩΝ ΦΥΛΛΩΝ, ΑΠΟ ΧΑΛΚΟ, ΠΑΧΟΥΣ >= 0 ;.15 ~ MM',
  },
  {
    label: '46721421',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΕΥΚΟΧΡΥΣΟΥ (ΠΛΑΤΙΝΑΣ), ΑΚΑΤΕΡΓΑΣΤΟΥ Η ΣΕ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΕΣ ΜΟΡΦΕΣ Η ΣΕ ΣΚΟΝΗ',
  },
  {
    label: '46721422',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΚΑΘΑΡΙΣΜΕΝΟΥ ΧΑΛΚΟΥ, ΑΝΟΔΩΝ ΑΠΟ ΧΑΛΚΟ ΓΙΑ ΗΛΕΚΤΡΟΛΥΤΙΚΟ ΚΑΘΑΡΙΣΜΟ',
  },
  {
    label: '46721423',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΛΥΒΔΟΥ ΑΚΑΤΕΡΓΑΣΤΟΥ',
  },
  {
    label: '46721424',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ ΚΑΙ ΤΑΙΝΙΩΝ, ΑΠΟ ΑΡΓΙΛΙΟ ΠΑΧΟΥΣ > 0 ;.2 ~ MM',
  },
  {
    label: '46721425',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ ΚΑΙ ΤΑΙΝΙΩΝ, ΑΠΟ ΧΑΛΚΟ, ΠΑΧΟΥΣ > 0 ;.15 ~ MM',
  },
  {
    label: '46721426',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ ΚΑΙ ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΑΠΟ ΚΑΣΣΙΤΕΡΟ, ΣΚΟΝΩΝ ΚΑΙ ΨΗΓΜΑΤΩΝ ΚΑΣΣΙΤΕΡΟΥ',
  },
  {
    label: '46721427',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ ΚΑΙ ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΑΠΟ ΜΟΛΥΒΔΟ, ΣΚΟΝΩΝ ΚΑΙ ΨΗΓΜΑΤΩΝ ΜΟΛΥΒΔΟΥ',
  },
  {
    label: '46721428',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ ΚΑΙ ΛΕΠΤΩΝ ΦΥΛΛΩΝ, ΑΠΟ ΝΙΚΕΛΙΟ',
  },
  {
    label: '46721429',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΟΝΩΝ ΚΑΙ ΨΗΓΜΑΤΩΝ ΑΡΓΙΛΙΟΥ',
  },
  {
    label: '46721430',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΟΝΩΝ ΚΑΙ ΨΗΓΜΑΤΩΝ ΝΙΚΕΛΙΟΥ',
  },
  {
    label: '46721431',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΟΝΩΝ ΚΑΙ ΨΗΓΜΑΤΩΝ ΧΑΛΚΟΥ',
  },
  {
    label: '46721432',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΟΝΩΝ ΚΑΙ ΨΗΓΜΑΤΩΝ ΨΕΥΔΑΡΓΥΡΟΥ',
  },
  {
    label: '46721433',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΣ ΑΠΟ ΑΡΓΙΛΙΟ',
  },
  {
    label: '46721434',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΣ ΑΠΟ ΧΑΛΚΟ',
  },
  {
    label: '46721435',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΣΩΜΑΤΩΜΑΤΩΝ (ΣΥΜΠΗΓΜΑΤΩΝ, MATTES) ΝΙΚΕΛΙΟΥ, ΕΠΙΤΗΓΜΑΤΩΝ (ΣΥΝΤΗΓΜΑΤΩΝ, SINTERS) ΟΞΕΙΔΙΩΝ ΤΟΥ ΝΙΚΕΛΙΟΥ ΚΑΙ ΑΛΛΩΝ ΕΝΔΙΑΜΕΣΩΝ ΠΡΟΪΟΝΤΩΝ ΤΗΣ ΜΕΤΑΛΛΟΥΡΓΙΑΣ ΤΟΥ ΝΙΚΕΛΙΟΥ',
  },
  {
    label: '46721436',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΣΩΜΑΤΩΜΑΤΩΝ (ΣΥΜΠΗΓΜΑΤΩΝ, MATTES) ΧΑΛΚΟΥ, ΧΑΛΚΟΥ ΚΟΝΙΑΣ',
  },
  {
    label: '46721437',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ ΑΠΟ ΚΑΣΣΙΤΕΡΟ',
  },
  {
    label: '46721438',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ ΑΠΟ ΨΕΥΔΑΡΓΥΡΟ',
  },
  {
    label: '46721439',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ, ΑΠΟ ΑΡΓΙΛΙΟ',
  },
  {
    label: '46721440',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ, ΑΠΟ ΝΙΚΕΛΙΟ',
  },
  {
    label: '46721441',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΡΥΣΟΥ ΑΚΑΤΕΡΓΑΣΤΟΥ Η ΣΕ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΕΣ ΜΟΡΦΕΣ Η ΣΕ ΣΚΟΝΗ',
  },
  {
    label: '46721442',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΕΥΔΑΡΓΥΡΟΥ, ΑΚΑΤΕΡΓΑΣΤΟΥ',
  },
  {
    label: '46730000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΕΙΑΣ, ΟΙΚΟΔΟΜΙΚΩΝ ΥΛΙΚΩΝ ΚΑΙ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ',
  },
  {
    label: '46731100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΗΣ ΞΥΛΕΙΑΣ',
  },
  {
    label: '46731101',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΗΣ ΑΚΑΤΕΡΓΑΣΤΗΣ ΞΥΛΕΙΑΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΣΧΙΣΤΩΝ ΣΤΥΛΩΝ ΚΑΙ ΠΑΣΣΑΛΩΝ)',
  },
  {
    label: '46731102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΡΜΩΝ ΞΥΛΕΙΑΣ ΚΩΝΟΦΟΡΩΝ',
  },
  {
    label: '46731103',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΡΜΩΝ ΞΥΛΕΙΑΣ ΜΗ ΚΩΝΟΦΟΡΩΝ',
  },
  {
    label: '46731104',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΡΜΩΝ ΞΥΛΕΙΑΣ ΤΡΟΠΙΚΩΝ ΔΕΝΔΡΩΝ',
  },
  {
    label: '46731200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΤΗΣ ΠΡΩΤΟΓΕΝΟΥΣ ΚΑΤΕΡΓΑΣΙΑΣ ΤΟΥ ΞΥΛΟΥ',
  },
  {
    label: '46731201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΝΤΙΚΟΛΛΗΤΩΝ, ΕΠΕΝΔΥΜΕΝΩΝ ΞΥΛΟΦΥΛΛΩΝ (ΚΑΠΛΑΜΑΔΩΝ) ΚΑΙ ΠΑΡΟΜΟΙΑΣ ΕΠΙΚΟΛΛΗΤΗΣ ΞΥΛΕΙΑΣ',
  },
  {
    label: '46731202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΙΚΟΛΛΗΤΩΝ ΠΟΥ ΑΠΟΤΕΛΟΥΝΤΑΙ ΑΠΟΚΛΕΙΣΤΙΚΑ ΑΠΟ ΦΥΛΛΑ ΞΥΛΕΙΑΣ',
  },
  {
    label: '46731203',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΟΛΛΗΤΩΝ ΚΑΠΛΑΜΑΔΩΝ',
  },
  {
    label: '46731204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΜΕΝΩΝ ΞΥΛΟΦΥΛΛΩΝ ΚΑΙ ΦΥΛΛΩΝ ΓΙΑ ΑΝΤΙΚΟΛΛΗΤΑ ΚΑΙ ΑΛΛΗΣ ΞΥΛΕΙΑΣ ΠΡΙΟΝΙΣΜΕΝΗΣ ΚΑΤΑ ΜΗΚΟΣ, ΤΕΜΑΧΙΣΜΕΝΗΣ Η ΑΠΟΦΛΟΙΩΜΕΝΗΣ, ΜΕΓΙΣΤΟΥ ΠΑΧΟΥΣ 6 ~ MM',
  },
  {
    label: '46731205',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΙΝΟΣΑΝΙΔΩΝ ΑΠΟ ΞΥΛΟ Η ΑΛΛΩΝ ΞΥΛΩΔΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46731206',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΡΙΟΣΑΝΙΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΑΝΙΔΩΝ ΑΠΟ ΞΥΛΟ Η ΑΛΛΩΝ ΞΥΛΩΔΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46731207',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΕΙΑΣ ΣΕ ΠΕΛΕΚΟΥΔΙΑ Η ΣΕ ΜΟΡΙΑ',
  },
  {
    label: '46731208',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΕΙΑΣ ΣΕ ΦΥΣΙΚΗ ΚΑΤΑΣΤΑΣΗ, ΕΠΕΞΕΡΓΑΣΜΕΝΗΣ ΜΕ ΧΡΩΜΑ, ΒΑΦΗ, ΚΡΕΟΖΩΤΟ Η ΑΛΛΑ ΣΥΝΤΗΡΗΤΙΚΑ',
  },
  {
    label: '46731209',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΕΙΑΣ, ΠΡΙΟΝΙΣΜΕΝΗΣ Η ΠΕΛΕΚΗΜΕΝΗΣ ΚΑΤΑ ΜΗΚΟΣ, ΤΕΜΑΧΙΣΜΕΝΗΣ Η ΑΠΟΦΛΟΙΩΜΕΝΗΣ, ΠΑΧΟΥΣ >= 6 ;MM, ΣΤΡΩΤΗΡΩΝ (ΤΡΑΒΕΡΣΩΝ) ΣΙΔΗΡΟΔΡΟΜΩΝ Η ΤΡΟΧΙΟΔΡΟΜΩΝ, ΑΠΟ ΜΗ ΕΜΠΟΤΙΣΜΕΝΗ ΞΥΛΕΙΑ',
  },
  {
    label: '46731210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΕΙΑΣ, ΣΥΝΕΧΩΣ ΔΙΑΜΟΡΦΩΜΕΝΗΣ ΚΑΤΑ ΜΗΚΟΣ ΟΠΟΙΑΣΔΗΠΟΤΕ ΑΚΡΗΣ Η ΕΠΙΦΑΝΕΙΑΣ',
  },
  {
    label: '46731211',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΟΒΑΜΒΑΚΑ ΚΑΙ ΞΥΛΑΛΕΥΡΟΥ',
  },
  {
    label: '46731212',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΙΣΙΩΝ ΣΤΟΙΒΑΣΙΑΣ ΥΛΙΚΩΝ (ΠΑΛΕΤΩΝ), ΚΙΒΩΤΙΟΕΙΔΩΝ ΠΛΑΙΣΙΩΝ ΣΤΟΙΒΑΣΙΑΣ ΚΑΙ ΑΛΛΩΝ ΣΑΝΙΔΩΝ ΜΕΤΑΦΟΡΑΣ ΦΟΡΤΙΩΝ, ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '46731213',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΩΤΗΡΩΝ (ΤΡΑΒΕΡΣΩΝ) ΣΙΔΗΡΟΔΡΟΜΩΝ Η ΤΡΟΧΙΟΔΡΟΜΩΝ ΑΠΟ ΞΥΛΕΙΑ, ΕΜΠΟΤΙΣΜΕΝΩΝ',
  },
  {
    label: '46731214',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΜΠΥΚΝΩΜΕΝΗΣ ΞΥΛΕΙΑΣ, ΣΕ ΚΥΒΟΥΣ, ΠΛΑΚΕΣ, ΤΑΙΝΙΕΣ, Η ΣΧΗΜΑΤΑ ΚΑΘΟΡΙΣΜΕΝΗΣ ΜΟΡΦΗΣ',
  },
  {
    label: '46731215',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΛΛΩΝ ΠΑΡΚΕΤΩΝ, ΚΑΛΟΥΠΙΩΝ ΓΙΑ ΟΙΚΟΔΟΜΙΚΟ ΣΚΥΡΟΔΕΜΑ, ΤΑΒΑΝΟΣΑΝΙΔΩΝ ΚΑΙ ΤΕΜΑΧΙΩΝ ΞΥΛΩΝ ΓΙΑ ΠΑΡΚΕΤΑ',
  },
  {
    label: '46731300',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ',
  },
  {
    label: '46731301',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ',
  },
  {
    label: '46731302',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΠΑΝΙΕΡΩΝ, ΝΙΠΤΗΡΩΝ, ΛΕΚΑΝΩΝ ΚΑΙ ΤΩΝ ΚΑΛΥΜΜΑΤΩΝ ΤΟΥΣ, ΚΑΖΑΝΑΚΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46731303',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΕΡΟΧΥΤΩΝ, ΝΙΠΤΗΡΩΝ, ΜΠΑΝΙΕΡΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ, ΧΑΛΚΟ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '46731400',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΡΩΜΑΤΩΝ, ΒΕΡΝΙΚΙΩΝ ΚΑΙ ΛΟΥΣΤΡΩΝ',
  },
  {
    label: '46731401',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΧΡΩΜΑΤΩΝ ΕΠΙΧΡΙΣΗΣ ΚΑΙ ΒΕΡΝΙΚΙΩΝ, ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΣΤΕΓΑΝΩΤΙΚΩΝ',
  },
  {
    label: '46731402',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΣΠΡΟΥ ΠΕΤΡΕΛΑΪΚΟΥ ΑΙΘΕΡΑ (WHITE SPIRIT)',
  },
  {
    label: '46731403',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΧΡΩΣΤΙΚΩΝ ΟΥΣΙΩΝ, ΑΔΙΑΦΑΝΟΠΟΙΗΤΩΝ ΚΑΙ ΧΡΩΜΑΤΩΝ, ΥΑΛΩΔΩΝ ΣΜΑΛΤΩΝ ΚΑΙ ΕΠΙΣΤΡΩΣΕΩΝ, ΕΠΙΚΑΛΥΜΜΑΤΩΝ ΚΕΡΑΜΕΥΤΙΚΗΣ, ΥΓΡΩΝ ΛΟΥΣΤΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΤΡΙΜΜΕΝΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '46731404',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΙΣΣΩΝ ΑΠΟ ΛΙΘΑΝΘΡΑΚΑ, ΑΠΟ ΛΙΓΝΙΤΗ Η ΤΥΡΦΗ ΚΑΙ ΑΛΛΩΝ ΟΡΥΚΤΩΝ ΠΙΣΣΩΝ',
  },
  {
    label: '46731405',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΡΩΜΑΤΩΝ ΕΠΙΧΡΙΣΗΣ ΚΑΙ ΒΕΡΝΙΚΙΩΝ ΜΕ ΒΑΣΗ ΑΚΡΥΛΙΚΑ ΠΟΛΥΜΕΡΗ Η ΠΟΛΥΜΕΡΗ ΤΟΥ ΒΙΝΥΛΙΟΥ, ΣΕ ΥΔΑΤΩΔΕΣ ΜΕΣΟ',
  },
  {
    label: '46731406',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΡΩΜΑΤΩΝ ΕΠΙΧΡΙΣΗΣ ΚΑΙ ΒΕΡΝΙΚΙΩΝ ΜΕ ΒΑΣΗ ΠΟΛΥΕΣΤΕΡΕΣ, ΑΚΡΥΛΙΚΑ ΠΟΛΥΜΕΡΗ ΤΟΥ ΒΙΝΥΛΙΟΥ, ΣΕ ΜΗ ΥΔΑΤΩΔΕΣ ΔΙΑΛΥΜΑ',
  },
  {
    label: '46731500',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΖΑΜΙΩΝ',
  },
  {
    label: '46731501',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΟΥ \\ΒΙΤΡΟ\\',
  },
  {
    label: '46731502',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΟΥ ΑΣΦΑΛΕΙΑΣ (ΕΚΤΟΣ ΑΥΤΟΥ ΓΙΑ ΕΞΟΠΛΙΣΜΟ ΜΕΤΑΦΟΡΑΣ)',
  },
  {
    label: '46731503',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΟΥ ΣΕ ΦΥΛΛΑ, ΚΥΡΤΩΜΕΝΟΥ, ΜΕ ΚΑΤΕΡΓΑΣΜΕΝΑ ΑΚΡΑ, ΧΑΡΑΓΜΕΝΟΥ, ΔΙΑΤΡΗΤΟΥ, ΕΦΥΑΛΩΜΕΝΟΥ Η ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ ΚΑΤΕΡΓΑΣΜΕΝΟΥ, ΑΛΛΑ ΜΗ ΠΛΑΙΣΙΩΜΕΝΟΥ Η ΣΥΝΑΡΜΟΛΟΓΗΜΕΝΟΥ',
  },
  {
    label: '46731504',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΟΥ ΧΥΤΕΥΤΟΥ, ΕΛΑΤΟΥ, ΟΛΚΙΜΟΥ Η ΦΥΣΗΤΟΥ ΣΕ ΦΥΛΛΑ, ΑΛΛΑ ΟΧΙ ΚΑΤΕΡΓΑΣΜΕΝΟΥ ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ',
  },
  {
    label: '46731505',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΕΔΟΥ ΓΥΑΛΙΟΥ ΚΑΙ ΕΠΙΦΑΝΕΙΑΚΑ ΛΕΙΑΣΜΕΝΟΥ Η ΣΤΙΛΒΩΜΕΝΟΥ ΓΥΑΛΙΟΥ, ΣΕ ΦΥΛΛΑ, ΑΛΛΑ ΟΧΙ ΚΑΤΕΡΓΑΣΜΕΝΟΥ ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ',
  },
  {
    label: '46731506',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΝΩΤΙΚΩΝ ΠΛΑΚΩΝ ΑΠΟ ΓΥΑΛΙ ΜΕ ΠΟΛΛΑΠΛΑ ΤΟΙΧΩΜΑΤΑ, ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΕΞΟΠΛΙΣΜΟ ΜΕΤΑΦΟΡΑΣ',
  },
  {
    label: '46731507',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΖΑΜΙΩΝ ΓΕΝΙΚΑ ΚΑΙ ΚΑΤΟΠΤΡΩΝ',
  },
  {
    label: '46731600',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΙΚΟΔΟΜΙΚΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46731601',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΓΩΓΩΝ, ΣΩΛΗΝΩΝ, ΜΑΝΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46731602',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΡΓΙΛΩΝ, ΑΝΔΑΛΟΥΣΙΤΗ, ΚΥΑΝΙΤΗ ΚΑΙ ΣΙΛΙΜΑΝΙΤΗ, ΜΟΥΛΙΤΗ, ΠΥΡΙΜΑΧΩΝ ΓΑΙΩΝ ΚΑΙ ΓΑΙΩΝ ΑΠΟ ΜΕΙΓΜΑ ΑΛΕΣΜΕΝΟΥ ΧΑΛΑΖΙΤΗ ΚΑΙ ΑΡΓΙΛΟΥ',
  },
  {
    label: '46731603',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΓΥΨΟ Η ΣΥΝΘΕΣΕΙΣ ΜΕ ΒΑΣΗ ΤΟ ΓΥΨΟ Π.Δ.Κ.Α.',
  },
  {
    label: '46731604',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΛΙΘΩΝ ΓΙΑ ΛΑΞΕΥΣΗ Η ΟΙΚΟΔΟΜΙΚΩΝ ΛΙΘΩΝ ΚΑΙ ΕΙΔΩΝ ΤΟΥΣ, ΑΛΛΩΝ ΤΕΧΝΗΤΑ ΧΡΩΜΑΤΙΣΜΕΝΩΝ ΚΟΚΚΩΝ ΚΑΙ ΣΚΟΝΩΝ ΑΠΟ ΦΥΣΙΚΟ ΛΙΘΟ, ΕΙΔΩΝ ΑΠΟ ΣΥΣΣΩΜΑΤΩΜΕΝΟ ΣΧΙΣΤΟΛΙΘΟ',
  },
  {
    label: '46731605',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΑΤΑΣΚΕΥΩΝ ΚΑΙ ΜΕΡΩΝ ΚΑΤΑΣΚΕΥΩΝ, ΛΑΜΑΡΙΝΩΝ, ΡΑΒΔΩΝ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '46731606',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΙΚΟΔΟΜΙΚΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46731607',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΚΥΨΕΛΩΔΕΙΣ ΓΙΑ ΚΑΤΑΣΚΕΥΕΣ',
  },
  {
    label: '46731608',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΜΗ ΚΥΨΕΛΩΔΕΙΣ ΓΙΑ ΚΑΤΑΣΚΕΥΕΣ',
  },
  {
    label: '46731609',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΕΝΙΣΧΥΜΕΝΕΣ Η ΚΑΤΑ ΠΑΡΟΜΟΙΟ ΤΡΟΠΟ ΣΥΝΔΥΑΣΜΕΝΕΣ ΜΕ ΑΛΛΑ',
  },
  {
    label: '46731610',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΥΔΡΟΥ ΑΣΒΕΣΤΗ, ΕΝΥΔΡΟΥ ΑΣΒΕΣΤΗ ΚΑΙ ΥΔΡΑΥΛΙΚΟΥ ΑΣΒΕΣΤΗ',
  },
  {
    label: '46731611',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΣΒΕΣΤΟΛΙΘΟΥ ΚΑΙ ΓΥΨΟΥ',
  },
  {
    label: '46731612',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΨΗΤΩΝ ΠΥΡΙΜΑΧΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΑΛΛΩΝ ΠΥΡΙΜΑΧΩΝ ΚΕΡΑΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46731613',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΕΦΥΡΩΝ ΚΑΙ ΣΤΟΙΧΕΙΩΝ ΓΕΦΥΡΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46731614',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΡΑΝΙΤΗ, ΨΑΜΜΙΤΗ ΚΑΙ ΑΛΛΩΝ ΛΙΘΩΝ ΓΙΑ ΜΝΗΜΕΙΑ Η ΚΤΙΡΙΑ (ΟΙΚΟΔΟΜΙΚΩΝ ΛΙΘΩΝ)',
  },
  {
    label: '46731615',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΨΙΝΩΝ ΠΡΟΪΟΝΤΩΝ ΓΙΑ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '46731616',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΨΟΥ',
  },
  {
    label: '46731617',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΑΠΟ ΑΜΙΑΝΤΟΤΣΙΜΕΝΤΟ, ΤΣΙΜΕΝΤΟ ΜΕ ΙΝΕΣ ΚΥΤΤΑΡΙΝΗΣ Η ΑΠΟ ΠΑΡΟΜΟΙΑ ΥΛΙΚΑ',
  },
  {
    label: '46731618',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ Π.Δ.Κ.Α.',
  },
  {
    label: '46731619',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΜΙΥΑΛΟΠΟΙΗΜΕΝΩΝ ΣΚΩΡΙΩΝ ΤΣΙΜΕΝΤΟΥ (ΟΠΤΟΠΛΙΝΘΩΝ CLINKER)',
  },
  {
    label: '46731620',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΟΛΙΝΗ ΚΑΙ ΑΛΛΩΝ ΚΑΟΛΙΝΙΚΩΝ ΑΡΓΙΛΩΝ',
  },
  {
    label: '46731621',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΔΙΩΝ ΣΤΕΓΩΝ, ΣΤΟΙΧΕΙΩΝ, ΚΑΛΥΜΜΑΤΩΝ ΚΑΙ ΕΠΕΝΔΥΣΕΩΝ ΚΑΠΝΟΔΟΧΩΝ, ΑΡΧΙΤΕΚΤΟΝΙΚΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΚΑΙ ΑΛΛΩΝ ΚΕΡΑΜΙΚΩΝ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46731622',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΚΩΝ ΠΛΑΚΑΚΙΩΝ ΚΑΙ ΠΛΑΚΩΝ',
  },
  {
    label: '46731623',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΚΩΝ ΣΩΛΗΝΩΣΕΩΝ, ΑΓΩΓΩΝ, ΥΔΡΟΡΡΟΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΣΕΩΝ',
  },
  {
    label: '46731624',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΜΩΛΙΑΣ ΚΑΙ ΔΟΛΟΜΙΤΗ',
  },
  {
    label: '46731625',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΝΙΑΜΑΤΩΝ',
  },
  {
    label: '46731626',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΥΒΟΛΙΘΩΝ, ΤΟΥΒΛΩΝ, ΠΛΑΚΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΠΡΕΣΑΡΙΣΤΟ Η ΧΥΤΟ ΓΥΑΛΙ, ΜΙΚΡΩΝ ΥΑΛΟΠΙΝΑΚΩΝ ΠΟΥ ΣΥΓΚΡΑΤΟΥΝΤΑΙ ΜΕ ΜΟΛΥΒΔΙΝΟ ΔΙΚΤΥΩΤΟ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΠΟΛΥΚΥΨΕΛΩΤΟΥ Η ΑΦΡΩΔΟΥΣ ΓΥΑΛΙΟΥ ΣΕ ΚΥΒΟΥΣ, ΠΛΑΚΕΣ Η ΠΑΡΟΜΟΙΕΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46731627',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΙΘΟΚΟΚΚΩΝ, ΨΙΛΟΥ ΧΑΛΙΚΙΟΥ ΚΑΙ ΛΙΘΟΣΚΟΝΗΣ, ΚΡΟΚΑΛΩΝ, ΑΜΜΟΧΑΛΙΚΟΥ, ΣΠΑΣΜΕΝΩΝ Η ΘΡΥΜΜΑΤΙΣΜΕΝΩΝ ΠΕΤΡΩΝ',
  },
  {
    label: '46731628',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΖΩΝ ΚΕΡΑΜΙΚΗΣ',
  },
  {
    label: '46731629',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΛΛΙΩΝ ΑΠΟ ΣΚΟΥΡΙΕΣ ΥΨΙΚΑΜΙΝΩΝ, ΟΡΥΚΤΩΝ ΜΑΛΛΙΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΜΕΙΓΜΑΤΩΝ ΣΕ ΟΓΚΟΥΣ, ΦΥΛΛΑ Η ΚΥΛΙΝΔΡΟΥΣ, ΜΕΙΓΜΑΤΩΝ ΚΑΙ ΕΙΔΩΝ ΑΠΟ ΘΕΡΜΟ/ΗΧΟΜΟΝΩΤΙΚΑ ΥΛΙΚΑ Π.Δ.Κ.Α.',
  },
  {
    label: '46731630',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΡΜΑΡΟΥ, ΤΡΑΒΕΡΤΙΝΗ, ΑΛΑΒΑΣΤΡΟΥ, ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ, ΤΕΧΝΗΤΑ ΧΡΩΜΑΤΙΣΜΕΝΩΝ ΚΟΚΚΩΝ ΚΑΙ ΣΚΟΝΩΝ ΑΠΟ ΜΑΡΜΑΡΟ, ΤΡΑΒΕΡΤΙΝΗ, ΑΛΑΒΑΣΤΡΟ',
  },
  {
    label: '46731631',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΡΜΑΡΩΝ ΚΑΙ ΑΛΛΩΝ ΑΣΒΕΣΤΟΛΙΘΙΚΩΝ ΛΙΘΩΝ ΓΙΑ ΜΝΗΜΕΙΑ Η ΚΤΙΡΙΑ (ΟΙΚΟΔΟΜΙΚΩΝ ΛΙΘΩΝ)',
  },
  {
    label: '46731632',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΠΥΡΙΜΑΧΩΝ ΚΕΡΑΜΙΚΩΝ ΟΙΚΟΔΟΜΙΚΩΝ ΤΟΥΒΛΩΝ, ΚΥΒΟΛΙΘΩΝ ΔΑΠΕΔΩΝ, ΠΛΑΚΑΚΙΩΝ ΥΠΟΣΤΗΡΙΞΗΣ Η ΠΛΗΡΩΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46731633',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΙΚΟΔΟΜΙΚΗΣ ΛΕΠΤΟΞΥΛΟΥΡΓΙΚΗΣ ΚΑΙ ΧΟΝΔΡΟΞΥΛΟΥΡΓΙΚΗΣ, ΑΠΟ ΞΥΛΕΙΑ Π.Δ.Κ.Α.',
  },
  {
    label: '46731634',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΘΥΡΩΝ, ΜΠΑΛΚΟΝΟΠΟΡΤΩΝ ΚΑΙ ΠΛΑΙΣΙΩΝ ΤΟΥΣ, ΠΟΡΤΩΝ, ΠΛΑΙΣΙΩΝ ΚΑΙ ΚΑΤΩΦΛΙΩΝ ΤΟΥΣ, ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '46731635',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΚΑΚΙΩΝ, ΠΛΑΚΟΛΙΘΩΝ, ΤΟΥΒΛΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ',
  },
  {
    label: '46731636',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΡΤΩΝ, ΠΑΡΑΘΥΡΩΝ ΚΑΙ ΤΩΝ ΠΛΑΙΣΙΩΝ ΤΟΥΣ, ΚΑΘΩΣ ΚΑΙ ΚΑΤΩΦΛΙΩΝ ΓΙΑ ΠΟΡΤΕΣ, ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '46731637',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΡΤΩΝ, ΠΑΡΑΘΥΡΩΝ, ΠΛΑΙΣΙΩΝ ΚΑΙ ΚΑΤΩΦΛΙΩΝ ΓΙΑ ΠΟΡΤΕΣ, ΠΑΡΑΘΥΡΟΦΥΛΛΩΝ, ΡΟΛΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46731638',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΟΡΟΦΗΣ Η ΠΡΟΣΟΨΗΣ ΑΠΟ ΑΣΦΑΛΤΟ Η ΑΠΟ ΠΑΡΟΜΟΙΑ ΥΛΙΚΑ, ΣΕ ΡΟΛΑ',
  },
  {
    label: '46731639',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΔΟΜΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΓΙΑ ΟΙΚΟΔΟΜΙΚΑ ΕΡΓΑ Η ΕΡΓΑ ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ',
  },
  {
    label: '46731640',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '46731641',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΚΤΙΡΙΩΝ ΑΠΟ ΜΕΤΑΛΛΟ',
  },
  {
    label: '46731642',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΚΤΙΡΙΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46731643',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΚΤΙΡΙΩΝ ΑΠΟ ΣΚΥΡΟΔΕΜΑ',
  },
  {
    label: '46731644',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΞΥΛΙΝΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '46731645',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΑΣΦΑΛΩΝ ΠΟΡΤΩΝ',
  },
  {
    label: '46731646',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΓΩΝ ΚΑΙ ΠΥΛΩΝΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46731647',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΙΜΑΧΩΝ ΤΟΥΒΛΩΝ, ΚΥΒΟΛΙΘΩΝ, ΠΛΑΚΑΚΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΥΡΙΜΑΧΩΝ ΚΕΡΑΜΙΚΩΝ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΕΙΔΩΝ, ΕΚΤΟΣ ΤΩΝ ΕΙΔΩΝ ΑΠΟ ΠΥΡΙΤΙΚΗ ΣΚΟΝΗ ΑΠΟΛΙΘΩΜΑΤΩΝ Η ΑΠΟ ΠΥΡΙΤΙΟΥΧΕΣ ΓΑΙΕΣ',
  },
  {
    label: '46731648',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΙΜΑΧΩΝ ΤΣΙΜΕΝΤΩΝ, ΚΟΝΙΑΜΑΤΩΝ, ΣΚΥΡΟΔΕΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΥΝΘΕΣΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46731649',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΑΝΙΔΩΝ, ΤΕΜΑΧΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΦΥΤΙΚΕΣ ΙΝΕΣ, ΑΧΥΡΩΝ Η ΥΠΟΛΕΙΜΜΑΤΩΝ ΞΥΛΕΙΑΣ, ΣΥΣΣΩΜΑΤΩΜΕΝΩΝ ΜΕ ΟΡΥΚΤΕΣ ΣΥΝΔΕΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46731650',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΥΡΟΣΤΡΩΜΑΤΟΣ ΚΑΙ ΠΙΣΣΟΣΚΥΡΟΣΤΡΩΜΑΤΟΣ',
  },
  {
    label: '46731651',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΧΙΣΤΟΛΙΘΟΥ',
  },
  {
    label: '46731652',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΣΕΩΝ ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ',
  },
  {
    label: '46731653',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ ΝΗΜΑΤΩΝ ΑΠΟ ΣΚΛΗΡΥΜΕΝΕΣ ΠΡΩΤΕΪΝΕΣ Η ΑΠΟ ΚΥΤΤΑΡΙΝΙΚΕΣ ΥΛΕΣ, ΑΚΑΜΠΤΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46731654',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΟΥΒΛΩΝ, ΚΥΒΟΛΙΘΩΝ, ΠΛΑΚΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46731655',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΟΥΛΙΩΝ, ΠΛΕΓΜΑΤΩΝ, ΠΑΤΑΚΙΩΝ, ΣΤΡΩΜΑΤΩΝ, ΣΑΝΙΔΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΓΥΑΛΙΝΕΣ ΙΝΕΣ',
  },
  {
    label: '46731656',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΣΙΜΕΝΤΟΠΛΙΝΘΩΝ',
  },
  {
    label: '46731657',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΣΙΜΕΝΤΟΥ PORTLAND, ΑΡΓΙΛΙΚΟΥ ΤΣΙΜΕΝΤΟΥ, ΤΣΙΜΕΝΤΟΥ ΣΚΟΥΡΙΩΝ ΥΨΙΚΑΜΙΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΔΡΑΥΛΙΚΩΝ ΤΣΙΜΕΝΤΩΝ',
  },
  {
    label: '46731658',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΩΝ ΑΜΜΩΝ',
  },
  {
    label: '46731659',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΩΜΑΤΟΣ ΚΑΤΑΛΛΗΛΟΥ ΓΙΑ ΤΗΝ ΚΗΠΟΥΡΙΚΗ',
  },
  {
    label: '46731660',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΨΕΥΔΟΡΟΦΩΝ ΚΑΙ ΧΩΡΙΣΜΑΤΩΝ',
  },
  {
    label: '46731700',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΤΟΙΧΟΣΤΡΩΣΙΑΣ (ΤΑΠΕΤΣΑΡΙΑΣ)',
  },
  {
    label: '46731701',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΣΕΩΝ ΤΟΙΧΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46731702',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΣΕΩΝ ΤΟΙΧΩΝ Η ΟΡΟΦΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΣΕ ΡΟΛΑ Η ΥΠΟ ΜΟΡΦΗ ΠΛΑΚΙΔΙΩΝ',
  },
  {
    label: '46731703',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΤΑΠΕΤΣΑΡΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΠΕΝΔΥΣΕΩΝ ΤΟΙΧΩΝ, ΔΙΑΦΑΝΩΝ ΣΤΟΙΧΕΙΩΝ ΠΑΡΑΘΥΡΩΝ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '46731800',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΟΥ (ΕΚΤΟΣ ΧΑΛΙΩΝ)',
  },
  {
    label: '46731801',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΩΝ ΚΑΙ ΠΑΤΑΚΙΩΝ ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ, ΕΚΤΟΣ ΤΟΥ ΚΥΤΤΑΡΙΝΟΕΙΔΟΥΣ',
  },
  {
    label: '46731802',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΣΕ ΡΟΛΑ Η ΥΠΟ ΜΟΡΦΗ ΠΛΑΚΙΔΙΩΝ',
  },
  {
    label: '46731803',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΩΝ ΜΕ ΥΠΟΘΕΜΑ ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '46740000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΙΚΩΝ, ΥΔΡΑΥΛΙΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ ΓΙΑ ΕΓΚΑΤΑΣΤΑΣΕΙΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '46741000',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΙΚΩΝ, ΥΔΡΑΥΛΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ ΓΙΑ ΕΓΚΑΤΑΣΤΑΣΕΙΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '46741100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΙΚΩΝ',
  },
  {
    label: '46741101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ Π.Δ.Κ.Α.',
  },
  {
    label: '46741102',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΛΕΙΔΑΡΙΩΝ ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46741103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΥΣΙΔΩΝ (ΕΚΤΟΣ ΤΩΝ ΑΡΘΡΩΤΩΝ ΑΛΥΣΙΔΩΝ) ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '46741104',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΤΗΡΙΩΝ ΚΑΙ ΕΛΑΣΜΑΤΩΝ ΕΛΑΤΗΡΙΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΧΑΛΚΙΝΩΝ ΕΛΑΤΗΡΙΩΝ',
  },
  {
    label: '46741105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΡΦΙΩΝ, ΠΡΟΚΩΝ, ΠΙΝΕΖΩΝ, ΣΥΝΔΕΤΗΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46741106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΧΛΙΩΤΩΝ ΣΥΝΔΕΤΗΡΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ Π.Δ.Κ.Α.',
  },
  {
    label: '46741107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΚΕΤΩΝ ΓΙΑ ΠΟΔΗΛΑΤΑ',
  },
  {
    label: '46741108',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΚΕΤΩΝ ΚΑΙ ΚΛΕΙΔΑΡΙΩΝ ΓΙΑ ΕΠΙΠΛΑ, ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46741109',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΝΤΕΣΕΔΩΝ, ΕΞΑΡΤΗΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ, ΠΟΡΤΕΣ, ΠΑΡΑΘΥΡΑ, ΕΠΙΠΛΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ, ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46741110',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΙΚΩΝ ΥΦΑΣΜΑΤΩΝ, ΣΙΤΩΝ, ΠΛΕΓΜΑΤΩΝ, ΔΙΚΤΥΩΤΩΝ ΚΑΙ ΥΛΙΚΩΝ ΠΕΡΙΦΡΑΞΗΣ ΑΠΟ ΣΥΡΜΑ ΣΙΔΗΡΟΥ, ΧΑΛΥΒΑ Η ΧΑΛΚΟΥ, ΤΕΤΑΜΕΝΩΝ ΦΥΛΛΩΝ ΜΕΤΑΛΛΟΥ ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ Η ΧΑΛΚΟ',
  },
  {
    label: '46741111',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΚΟΧΛΙΩΤΩΝ ΣΥΝΔΕΤΗΡΩΝ, ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '46741112',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΡΠΩΝ ΚΑΙ ΠΛΑΙΣΙΩΝ ΜΕ ΠΟΡΠΕΣ, ΠΟΥ ΠΕΡΙΛΑΜΒΑΝΟΥΝ ΚΛΕΙΔΑΡΙΕΣ, ΜΕΡΩΝ ΤΟΥΣ ΚΑΙ ΧΩΡΙΣΤΩΝ ΚΛΕΙΔΙΩΝ',
  },
  {
    label: '46741113',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΩΝ ΣΩΛΗΝΩΝ, ΣΙΔΗΡΩΝ ΑΝΟΞΕΙΔΩΤΩΝ ΑΞΟΝΩΝ ΚΑΙ ΣΙΔΗΡΟΔΟΚΩΝ',
  },
  {
    label: '46741114',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΠΛΕΓΜΑΤΟΣ',
  },
  {
    label: '46741115',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΠΛΕΓΜΑΤΟΣ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΣΥΡΜΑΤΟΣΧΟΙΝΩΝ, ΚΑΛΩΔΙΩΝ, ΠΛΕΞΟΥΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΧΑΛΚΟ Η ΑΛΟΥΜΙΝΙΟ, ΜΗ ΗΛΕΚΤΡΟΜΟΝΩΜΕΝΩΝ',
  },
  {
    label: '46741200',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΔΡΑΥΛΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ ΓΙΑ ΕΓΚΑΤΑΣΤΑΣΕΙΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '46741201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΑΛΒΙΔΩΝ, ΗΛΕΚΤΡΟΒΑΛΒΙΔΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΥΔΡΑΥΛΙΚΩΝ ΚΥΚΛΩΜΑΤΩΝ',
  },
  {
    label: '46741202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ (ΛΕΒΗΤΩΝ, ΚΑΥΣΤΗΡΩΝ ΑΕΡΙΩΝ ΚΑΥΣΙΜΩΝ Η ΠΕΤΡΕΛΑΙΟΥ, ΚΥΚΛΟΦΟΡΗΤΩΝ, ΘΕΡΜΟΣΙΦΩΝΩΝ ΚΛΠ ΕΞΑΡΤΗΜΑΤΩΝ ΘΕΡΜΑΝΣΗΣ)',
  },
  {
    label: '46741203',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '46741204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΘΕΡΜΟΜΟΝΩΜΕΝΩΝ ΔΕΞΑΜΕΝΩΝ (ΕΚΤΟΣ ΤΩΝ ΔΟΧΕΙΩΝ ΓΙΑ ΑΕΡΙΑ), ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46741205',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΕΒΗΤΩΝ ΓΙΑ ΚΕΝΤΡΙΚΗ ΘΕΡΜΑΝΣΗ',
  },
  {
    label: '46741206',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΛΕΒΗΤΩΝ ΓΙΑ ΚΕΝΤΡΙΚΗ ΘΕΡΜΑΝΣΗ',
  },
  {
    label: '46741207',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΟΦΙΓΓΩΝ, ΚΑΝΟΥΛΩΝ, ΔΙΚΛΕΙΔΩΝ ΓΙΑ ΝΕΡΟΧΥΤΕΣ, ΝΙΠΤΗΡΕΣ, ΜΠΙΝΤΕΔΕΣ, ΚΑΖΑΝΑΚΙΑ, ΜΠΑΝΙΕΡΕΣ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ, ΔΙΚΛΕΙΔΩΝ ΣΩΜΑΤΩΝ ΚΑΛΟΡΙΦΕΡ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '46741208',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ, ΑΠΟ ΜΟΛΥΒΔΟ',
  },
  {
    label: '46741209',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ, ΑΠΟ ΧΑΛΚΟ',
  },
  {
    label: '46741210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΩΜΑΤΩΝ ΚΑΛΟΡΙΦΕΡ ΓΙΑ ΚΕΝΤΡΙΚΗ ΘΕΡΜΑΝΣΗ, ΠΟΥ ΔΕΝ ΘΕΡΜΑΙΝΟΝΤΑΙ ΗΛΕΚΤΡΙΚΑ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46741211',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΑΜΙΕΥΤΗΡΩΝ, ΔΕΞΑΜΕΝΩΝ, ΚΑΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΟΧΕΙΩΝ, ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ Η ΑΛΟΥΜΙΝΙΟ, ΧΩΡΗΤΙΚΟΤΗΤΑΣ >= 300 ~ LT, ΓΙΑ ΚΕΝΤΡΙΚΗ ΘΕΡΜΑΝΣΗ',
  },
  {
    label: '46741212',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΔΡΑΥΛΙΚΩΝ ΕΙΔΩΝ ΠΙΣΙΝΑΣ',
  },
  {
    label: '46741300',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '46741301',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΡΓΑΛΕΙΩΝ',
  },
  {
    label: '46741302',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '46741303',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΕΩΡΓΙΚΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '46741304',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΝΑΛΛΑΚΤΙΚΩΝ ΕΡΓΑΛΕΙΩΝ ΓΙΑ ΕΡΓΑΛΕΙΑ ΧΕΙΡΟΣ, ΠΟΥ ΕΙΤΕ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΡΕΥΜΑ, ΕΙΤΕ ΧΩΡΙΣ ΡΕΥΜΑ, Η ΓΙΑ ΕΡΓΑΛΕΙΟΜΗΧΑΝΕΣ',
  },
  {
    label: '46741305',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ ΓΙΑ ΜΑΛΑΚΗ ΣΥΓΚΟΛΛΗΣΗ, ΣΚΛΗΡΗ ΣΥΓΚΟΛΛΗΣΗ ΚΑΙ ΘΕΡΜΟΣΥΓΚΟΛΛΗΣΗ, ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΧΕΙΡΟΣ ΓΙΑ ΕΠΙΦΑΝΕΙΑΚΗ ΒΑΦΗ ΚΑΙ ΘΕΡΜΟ ΨΕΚΑΣΜΟ',
  },
  {
    label: '46741306',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ, ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ Η ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΟ ΜΗ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '46741307',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ, ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗ ΓΕΩΡΓΙΑ, ΣΤΗΝ ΚΗΠΟΥΡΙΚΗ Η ΣΤΗ ΔΑΣΟΚΟΜΙΑ',
  },
  {
    label: '46741308',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΛΑΔΕΥΤΙΚΩΝ ΨΑΛΙΔΩΝ ΦΡΑΚΤΩΝ, ΨΑΛΙΔΩΝ ΚΟΠΗΣ ΧΛΟΟΤΑΠΗΤΑ, ΜΗΧΑΝΩΝ ΚΟΠΗΣ ΤΩΝ ΑΚΡΩΝ ΤΗΣ ΧΛΟΗΣ',
  },
  {
    label: '46741309',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΥΣΟΠΡΙΟΝΩΝ, ΜΕΡΩΝ ΕΡΓΑΛΕΙΩΝ ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ, ΜΕΡΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ, ΠΟΥ ΕΧΟΥΝ ΕΝΣΩΜΑΤΩΜΕΝΟ ΜΗ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '46741310',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ, ΜΕ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '46741311',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΩΝ ΜΕΤΡΗΣΗΣ',
  },
  {
    label: '46741312',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΕΛΕΧΩΝ ΚΑΙ ΛΑΒΩΝ ΓΙΑ ΣΚΟΥΠΕΣ Η ΒΟΥΡΤΣΕΣ, ΚΑΛΑΠΟΔΙΩΝ ΓΙΑ ΜΠΟΤΕΣ Η ΠΑΠΟΥΤΣΙΑ, ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '46741313',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΕΙΡΟΠΡΙΟΝΩΝ',
  },
  {
    label: '46750000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46751100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΙΠΑΣΜΑΤΩΝ ΚΑΙ ΑΓΡΟΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46751101',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΖΩΤΟΥΧΩΝ ΛΙΠΑΣΜΑΤΩΝ, ΟΡΥΚΤΩΝ Η ΧΗΜΙΚΩΝ',
  },
  {
    label: '46751102',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΣΧΕΤΙΚΩΝ ΒΛΑΣΤΗΣΗΣ, ΡΥΘΜΙΣΤΩΝ ΤΗΣ ΑΝΑΠΤΥΞΗΣ ΤΩΝ ΦΥΤΩΝ',
  },
  {
    label: '46751103',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΛΥΜΑΝΤΙΚΩΝ',
  },
  {
    label: '46751104',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΕΩΡΓΙΚΩΝ ΦΑΡΜΑΚΩΝ',
  },
  {
    label: '46751105',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΝΤΟΜΟΚΤΟΝΩΝ, ΣΥΣΚΕΥΑΣΜΕΝΩΝ ΓΙΑ ΛΙΑΝΙΚΗ ΠΩΛΗΣΗ',
  },
  {
    label: '46751106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΙΖΑΝΙΟΚΤΟΝΩΝ',
  },
  {
    label: '46751107',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΖΩΙΚΩΝ Η ΦΥΤΙΚΩΝ ΛΙΠΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46751108',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΙΟΥΧΩΝ ΛΙΠΑΣΜΑΤΩΝ, ΟΡΥΚΤΩΝ Η ΧΗΜΙΚΩΝ',
  },
  {
    label: '46751109',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΙΠΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46751110',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΥΚΗΤΟΚΤΟΝΩΝ, ΦΑΡΜΑΚΩΝ ΚΑΤΑ ΤΩΝ ΤΡΩΚΤΙΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46751111',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΙΤΡΙΚΟΥ ΝΑΤΡΙΟΥ',
  },
  {
    label: '46751112',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΥΡΦΗΣ, ΕΚΤΟΣ ΑΥΤΗΣ ΣΕ ΜΠΡΙΚΕΤΕΣ',
  },
  {
    label: '46751113',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΩΝ ΦΩΣΦΟΡΙΚΩΝ ΑΛΑΤΩΝ ΑΣΒΕΣΤΙΟΥ Η ΑΡΓΙΛΙΟΥ ΚΑΙ ΑΣΒΕΣΤΙΟΥ, ΚΑΡΝΑΛΙΤΗ, ΣΥΛΒΙΤΗ ΚΑΙ ΑΛΛΩΝ ΦΥΣΙΚΩΝ ΑΚΑΤΕΡΓΑΣΤΩΝ ΑΛΑΤΩΝ ΚΑΛΙΟΥ',
  },
  {
    label: '46751114',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΣΦΟΡΙΚΩΝ ΛΙΠΑΣΜΑΤΩΝ, ΟΡΥΚΤΩΝ Η ΧΗΜΙΚΩΝ',
  },
  {
    label: '46751115',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΛΩΡΙΟΥΧΟΥ ΑΜΜΩΝΙΟΥ, ΝΙΤΡΩΔΩΝ ΑΛΑΤΩΝ, ΝΙΤΡΙΚΩΝ ΑΛΑΤΩΝ ΤΟΥ ΚΑΛΙΟΥ, ΦΩΣΦΟΡΙΚΩΝ ΑΛΑΤΩΝ ΤΟΥ ΤΡΙΑΜΜΩΝΙΟΥ ΚΑΙ ΑΝΘΡΑΚΙΚΩΝ ΑΛΑΤΩΝ ΑΜΜΩΝΙΟΥ',
  },
  {
    label: '46751200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΒΙΟΜΗΧΑΝΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46751201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΙΘΥΛΙΚΗΣ ΑΛΚΟΟΛΗΣ ΚΑΙ ΑΛΛΩΝ ΜΕΤΟΥΣΙΩΜΕΝΩΝ ΑΠΟΣΤΑΓΜΑΤΩΝ ΜΕ ΟΠΟΙΑΔΗΠΟΤΕ ΠΕΡΙΕΚΤΙΚΟΤΗΤΑ ΣΕ ΟΙΝΟΠΝΕΥΜΑ',
  },
  {
    label: '46751202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΑΖΕΛΙΝΗΣ, ΣΚΛΗΡΗΣ ΠΑΡΑΦΙΝΗΣ, ΒΑΡΕΩΝ ΠΡΟΪΟΝΤΩΝ ΠΕΤΡΕΛΑΙΟΥ ΚΑΙ ΑΛΛΩΝ ΟΡΥΚΤΩΝ ΚΕΡΙΩΝ',
  },
  {
    label: '46751203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΣΤΟΡΕΛΑΙΟΥ, ΒΕΡΝΙΚΕΛΑΙΟΥ ΚΑΙ ΕΛΑΙΟΥ ΖΟΖΟΜΠΑ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥΣ, ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑ ΤΡΟΠΟΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '46751204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΠΤΑΝΘΡΑΚΑ (ΚΟΚ) ΑΠΟ ΠΕΤΡΕΛΑΙΟ, ΑΣΦΑΛΤΟΥ ΑΠΟ ΠΕΤΡΕΛΑΙΟ ΚΑΙ ΑΛΛΩΝ ΚΑΤΑΛΟΙΠΩΝ ΤΩΝ ΕΛΑΙΩΝ ΠΕΤΡΕΛΑΙΟΥ',
  },
  {
    label: '46751205',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΙΘΕΡΙΩΝ ΕΛΑΙΩΝ, ΜΕΙΓΜΑΤΩΝ ΕΥΩΔΩΝ ΟΥΣΙΩΝ',
  },
  {
    label: '46751206',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΙΘΕΡΩΝ, ΟΡΓΑΝΙΚΩΝ ΥΠΕΡΟΞΕΙΔΙΩΝ, ΕΠΟΞΕΙΔΙΩΝ, ΑΚΕΤΑΛΩΝ ΚΑΙ ΗΜΙΑΚΕΤΑΛΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '46751207',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΟΡΕΣΤΩΝ ΜΟΝΟΚΑΡΒΟΞΥΛΙΚΩΝ, ΚΥΚΛΑΝΙΚΩΝ, ΚΥΚΛΕΝΙΚΩΝ Η ΚΥΚΛΟΤΕΡΠΕΝΙΚΩΝ ΑΚΥΚΛΙΚΩΝ ΠΟΛΥΚΑΡΒΟΞΥΛΙΚΩΝ ΟΞΕΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '46751208',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΥΚΛΩΝ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ',
  },
  {
    label: '46751209',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΑΤΙΟΥ ΚΑΙ ΚΑΘΑΡΟΥ ΧΛΩΡΙΟΥΧΟΥ ΝΑΤΡΙΟΥ',
  },
  {
    label: '46751210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΑΤΩΝ ΟΞΟΜΕΤΑΛΛΙΚΩΝ Η ΥΠΕΡΟΞΟΜΕΤΑΛΛΙΚΩΝ ΟΞΕΩΝ, ΚΟΛΛΟΕΙΔΩΝ ΠΟΛΥΤΙΜΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '46751211',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΧΗΜΙΚΩΝ ΟΡΥΚΤΩΝ',
  },
  {
    label: '46751212',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΟΓΟΝΩΜΕΝΩΝ Η ΘΕΙΟΥΧΩΝ ΕΝΩΣΕΩΝ ΤΩΝ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΣΤΟΙΧΕΙΩΝ',
  },
  {
    label: '46751213',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΓΕΝΝΗΜΕΝΟΥ ΕΛΑΣΤΙΚΟΥ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ Η ΠΛΑΚΕΣ, ΦΥΛΛΑ Η',
  },
  {
    label: '46751214',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΘΡΑΚΙΚΩΝ ΑΛΑΤΩΝ',
  },
  {
    label: '46751215',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΙΕΚΡΗΚΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ, ΠΡΟΣΘΕΤΙΚΩΝ ΓΙΑ ΟΡΥΚΤΕΛΑΙΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΠΡΟΪΟΝΤΑ',
  },
  {
    label: '46751216',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΡΩΜΑΤΙΚΩΝ ΠΟΛΥΚΑΡΒΟΞΥΛΙΚΩΝ ΚΑΙ ΚΑΡΒΟΞΥΛΙΚΩΝ ΟΞΕΩΝ ΜΕ ΠΡΟΣΘΕΤΕΣ ΟΞΥΓΟΝΟΥΧΕΣ ΟΜΑΔΕΣ ΚΑΙ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ, ΕΚΤΟΣ ΑΠΟ ΤΟ ΣΑΛΙΚΥΛΙΚΟ ΟΞΥ ΚΑΙ ΤΑ ΑΛΑΤΑ ΤΟΥ',
  },
  {
    label: '46751217',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΕΓΓΑΛΙΚΩΝ, ΦΩΤΟΒΟΛΙΔΩΝ, ΒΑΡΕΛΟΤΩΝ ΚΑΙ ΑΛΛΩΝ ΠΥΡΟΤΕΧΝΙΚΩΝ ΕΙΔΩΝ (ΕΞΑΙΡΟΥΜΕΝΩΝ ΤΩΝ ΠΥΡΟΤΕΧΝΗΜΑΤΩΝ)',
  },
  {
    label: '46751218',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΜΗΧΑΝΙΚΩΝ ΛΙΠΑΡΩΝ ΑΛΚΟΟΛΩΝ',
  },
  {
    label: '46751219',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΜΗΧΑΝΙΚΩΝ ΜΟΝΟΚΑΡΒΟΞΥΛΙΚΩΝ ΛΙΠΑΡΩΝ ΟΞΕΩΝ, ΟΞΙΝΩΝ ΕΛΑΙΩΝ ΑΠΟ ΡΑΦΙΝΑΡΙΣΜΑ',
  },
  {
    label: '46751220',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΡΑΔΥΚΑΥΣΤΩΝ ΠΥΡΑΓΩΓΩΝ ΣΧΟΙΝΙΩΝ, ΑΚΑΡΙΑΙΩΝ ΠΥΡΑΓΩΓΩΝ ΣΧΟΙΝΙΩΝ, ΚΑΨΥΛΙΩΝ, ΕΝΑΥΣΤΗΡΩΝ, ΗΛΕΚΤΡΙΚΩΝ ΠΥΡΟΚΡΟΤΗΤΩΝ',
  },
  {
    label: '46751221',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΛΥΚΕΡΙΝΗΣ',
  },
  {
    label: '46751222',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΕΨΙΚΩΝ ΕΚΧΥΛΙΣΜΑΤΩΝ ΦΥΤΙΚΗΣ ΠΡΟΕΛΕΥΣΗΣ, ΤΑΝΝΙΝΩΝ ΚΑΙ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ, ΧΡΩΣΤΙΚΩΝ ΥΛΩΝ ΦΥΤΙΚΗΣ Η ΖΩΙΚΗΣ ΠΡΟΕΛΕΥΣΗΣ',
  },
  {
    label: '46751223',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΑΛΛΩΝ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46751224',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΟΛΩΝ, ΠΟΛΥΑΛΚΟΟΛΩΝ, ΚΥΚΛΙΚΩΝ ΑΛΚΟΟΛΩΝ ΚΑΙ ΠΑΡΑΓΩΓΩΝ ΤΟΥΣ',
  },
  {
    label: '46751225',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΟΞΕΙΔΙΟΥ ΤΟΥ ΑΝΘΡΑΚΑ ΚΑΙ ΑΛΛΩΝ ΑΝΟΡΓΑΝΩΝ ΟΞΥΓΟΝΟΥΧΩΝ ΕΝΩΣΕΩΝ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΣΤΟΙΧΕΙΩΝ',
  },
  {
    label: '46751226',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΒΙΟΤΕΧΝΟΛΟΓΙΑΣ',
  },
  {
    label: '46751227',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΚΡΗΚΤΙΚΩΝ ΥΛΩΝ, ΦΩΣΦΟΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46751228',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΩΝ ΚΑΙ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΤΗΣ ΑΠΟΣΤΑΞΗΣ ΤΗΣ ΛΙΘΑΝΘΡΑΚΟΠΙΣΣΑΣ ΣΕ ΥΨΗΛΗ ΘΕΡΜΟΚΡΑΣΙΑ, ΠΙΣΣΑΣ ΚΑΙ ΠΙΣΣΑΣΦΑΛΤΟΥ',
  },
  {
    label: '46751229',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΝΕΡΓΟΥ ΑΝΘΡΑΚΑ',
  },
  {
    label: '46751230',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΝΖΥΜΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΙΚΩΝ ΕΝΩΣΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46751231',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΝΩΣΕΩΝ ΜΕ ΚΕΤΟΝΙΚΕΣ ΚΑΙ ΚΙΝΟΝΙΚΕΣ ΟΜΑΔΕΣ',
  },
  {
    label: '46751232',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΤΕΡΟΚΥΚΛΙΚΩΝ ΕΝΩΣΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46751233',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΩΝ ΣΤΟΙΧΕΙΩΝ (ΚΑΣΕΤΩΝ), ΠΟΥ ΔΕΝ ΕΧΟΥΝ ΑΚΤΙΝΟΒΟΛΗΘΕΙ, ΓΙΑ ΠΥΡΗΝΙΚΟΥΣ ΑΝΤΙΔΡΑΣΤΗΡΕΣ',
  },
  {
    label: '46751234',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΥΑΝΙΔΙΩΝ, ΟΞΕΙΔΙΩΝ ΤΩΝ ΚΥΑΝΙΔΙΩΝ ΚΑΙ ΣΥΜΠΛΟΚΩΝ ΚΥΑΝΙΔΙΩΝ, ΚΡΟΤΙΚΩΝ, ΚΥΑΝΙΚΩΝ ΚΑΙ ΘΕΙΟΚΥΑΝΙΚΩΝ ΑΛΑΤΩΝ, ΠΥΡΙΤΙΚΩΝ ΑΛΑΤΩΝ, ΒΟΡΙΚΩΝ ΑΛΑΤΩΝ, ΥΠΕΡΒΟΡΙΚΩΝ ΑΛΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΑΛΑΤΩΝ ΑΝΟΡΓΑΝΩΝ ΟΞΕΩΝ Η ΥΠΕΡΟΞΕΩΝ',
  },
  {
    label: '46751235',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΥΚΛΙΚΩΝ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ',
  },
  {
    label: '46751236',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΙΘΟΓΡΑΦΙΚΩΝ ΜΕΛΑΝΙΩΝ',
  },
  {
    label: '46751237',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΟΕΙΔΩΝ',
  },
  {
    label: '46751238',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΒΟΥΛΚΑΝΙΣΜΕΝΟΥ ΕΛΑΣΤΙΚΟΥ ΚΑΙ ΕΙΔΩΝ ΤΟΥ, ΒΟΥΛΚΑΝΙΣΜΕΝΟΥ ΕΛΑΣΤΙΚΟΥ, ΕΚΤΟΣ ΤΟΥ ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ ΣΕ ΝΗΜΑΤΑ, ΣΧΟΙΝΙΑ, ΠΛΑΚΕΣ, ΦΥΛΛΑ, ΛΩΡΙΔΕΣ, ΡΑΒΔΟΥΣ ΚΑΙ ΕΙΔΗ ΚΑΘΟΡΙΣΜΕΝΗΣ ΜΟΡΦΗΣ',
  },
  {
    label: '46751239',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΜΕΤΟΥΣΙΩΜΕΝΗΣ ΑΙΘΥΛΙΚΗΣ ΑΛΚΟΟΛΗΣ ΜΕ ΠΕΡΙΕΚΤΙΚΟΤΗΤΑ ΣΕ ΟΙΝΟΠΝΕΥΜΑ >= 80 ;%',
  },
  {
    label: '46751240',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΙΤΡΙΚΟΥ ΟΞΕΟΣ, ΣΟΥΛΦΟΝΙΤΡΙΚΩΝ ΟΞΕΩΝ, ΑΜΜΩΝΙΑΣ',
  },
  {
    label: '46751241',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΑΝΘΡΑΚΑ',
  },
  {
    label: '46751242',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΞΕΙΔΙΟΥ ΚΑΙ ΥΠΕΡΟΞΕΙΔΙΟΥ ΤΟΥ ΨΕΥΔΑΡΓΥΡΟΥ, ΟΞΕΙΔΙΟΥ ΤΟΥ ΤΙΤΑΝΙΟΥ',
  },
  {
    label: '46751243',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΞΕΙΔΙΩΝ, ΥΔΡΟΞΕΙΔΙΩΝ ΚΑΙ ΥΠΕΡΟΞΕΙΔΙΩΝ· ΥΔΡΑΖΙΝΗΣ ΚΑΙ ΥΔΡΟΞΥΛΑΜΙΝΗΣ ΚΑΙ ΑΝΟΡΓΑΝΩΝ ΑΛΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '46751244',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΞΕΙΔΙΩΝ ΚΑΙ ΥΔΡΟΞΕΙΔΙΩΝ ΤΟΥ ΧΡΩΜΙΟΥ, ΤΟΥ ΜΑΓΓΑΝΙΟΥ, ΤΟΥ ΜΟΛΥΒΔΟΥ ΚΑΙ ΤΟΥ ΧΑΛΚΟΥ',
  },
  {
    label: '46751245',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΞΥΓΟΝΟΥΧΩΝ ΑΜΙΝΙΚΩΝ ΕΝΩΣΕΩΝ, ΕΚΤΟΣ ΑΠΟ ΤΗ ΛΥΣΙΝΗ ΚΑΙ ΤΟ ΓΛΟΥΤΑΜΙΝΙΚΟ ΟΞΥ',
  },
  {
    label: '46751246',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΙΚΩΝ ΕΝΩΣΕΩΝ ΜΕ ΑΛΛΕΣ ΑΖΩΤΟΥΧΕΣ ΟΜΑΔΕΣ',
  },
  {
    label: '46751247',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΙΚΩΝ ΘΕΙΟΕΝΩΣΕΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΟΑΝΟΡΓΑΝΩΝ ΕΝΩΣΕΩΝ',
  },
  {
    label: '46751248',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΓΩΓΩΝ ΦΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Η ΠΡΟΪΟΝΤΩΝ ΡΗΤΙΝΗΣ',
  },
  {
    label: '46751249',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΛΙΠΑΝΤΙΚΑ ΥΛΙΚΑ',
  },
  {
    label: '46751250',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΘΑΡΙΣΜΟΥ ΜΕ ΟΞΕΑ, ΣΥΛΛΙΠΑΣΜΑΤΩΝ (FLUXES), ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΕΠΙΤΑΧΥΝΤΩΝ ΒΟΥΛΚΑΝΙΣΜΟΥ, ΠΛΑΣΤΙΚΟΠΟΙΗΤΙΚΩΝ ΚΑΙ ΣΤΑΘΕΡΟΠΟΙΗΤΙΚΩΝ ΕΝΩΣΕΩΝ ΓΙΑ ΕΛΑΣΤΙΚΟ Η ΠΛΑΣΤΙΚΟ, ΚΑΤΑΛΥΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α., ΜΕΙΚΤΟΥ ΑΛΚΥ',
  },
  {
    label: '46751251',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΣΥΝΔΕΤΙΚΩΝ ΥΛΩΝ ΓΙΑ ΤΙΣ ΜΗΤΡΕΣ Η ΤΥΠΟΥΣ ΧΥΤΗΡΙΩΝ, ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΚΑΤΑΛΟΙΠΩΝ ΤΗΣ ΧΗΜΙΚΗΣ ΒΙΟΜΗΧΑΝΙΑΣ ΚΑΙ ΤΩΝ ΠΑΡΟΜΟΙΩΝ ΒΙΟΜΗΧΑΝΙΩΝ',
  },
  {
    label: '46751252',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΠΤΟΝΩΝ/ΠΡΩΤΕΪΝΙΚΩΝ ΟΥΣΙΩΝ ΚΑΙ ΠΑΡΑΓΩΓΩΝ Π.Δ.Κ.Α. ΚΑΙ ΣΚΟΝΗΣ ΔΕΡΜΑΤΟΣ',
  },
  {
    label: '46751253',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΣΤΕΛΙΝΗΣ',
  },
  {
    label: '46751254',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΤΩΝ ΠΡΟΠΛΑΣΜΑΤΩΝ, ΟΔΟΝΤΙΑΤΡΙΚΟΥ ΚΗΡΟΥ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΟΔΟΝΤΙΑΤΡΙΚΗ ΧΡΗΣΗ ΜΕ ΒΑΣΗ ΤΟ ΓΥΨΟ, ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΓΟΜΩΣΕΩΝ ΓΙΑ ΠΥΡΟΣΒΕΣΤΗΡΕΣ, ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΜΕΣΩΝ ΚΑΛΛΙΕΡΓΕΙΑΣ ΓΙΑ ΤΗΝ ΑΝΑΠΤΥΞΗ ΜΙΚΡΟΟΡΓΑΝΙΣΜΩΝ Κ',
  },
  {
    label: '46751255',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΩΘΗΤΙΚΗΣ ΠΥΡΙΤΙΔΑΣ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΕΚΡΗΚΤΙΚΩΝ',
  },
  {
    label: '46751256',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΟΤΕΧΝΗΜΑΤΩΝ',
  },
  {
    label: '46751257',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΑΔΙΕΝΕΡΓΩΝ ΣΤΟΙΧΕΙΩΝ, ΙΣΟΤΟΠΩΝ ΚΑΙ ΕΝΩΣΕΩΝ ΤΟΥΣ Π.Δ.Κ.Α. ΚΑΙ ΡΑΔΙΕΝΕΡΓΩΝ ΚΑΤΑΛΟΙΠΩΝ',
  },
  {
    label: '46751258',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΟΥΛΦΙΔΙΩΝ, ΘΕΙΩΔΩΝ ΚΑΙ ΘΕΙΙΚΩΝ ΑΛΑΤΩΝ',
  },
  {
    label: '46751259',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΟΥΛΦΟΝΩΜΕΝΩΝ, ΝΙΤΡΩΜΕΝΩΝ Η ΝΙΤΡΙΔΩΜΕΝΩΝ ΠΑΡΑΓΩΓΩΝ ΥΔΡΟΓΟΝΑΝΘΡΑΚΩΝ ΑΛΟΓΟΝΩΜΕΝΩΝ Η ΜΗ',
  },
  {
    label: '46751260',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΝΘΕΤΙΚΩΝ ΟΡΓΑΝΙΚΩΝ ΚΑΙ ΑΝΟΡΓΑΝΩΝ ΔΕΨΙΚΩΝ ΟΥΣΙΩΝ, ΔΕΨΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ',
  },
  {
    label: '46751261',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΝΘΕΤΙΚΩΝ ΟΡΓΑΝΙΚΩΝ ΧΡΩΣΤΙΚΩΝ ΥΛΩΝ ΚΑΙ ΧΡΩΣΤΙΚΩΝ ΛΑΚΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΠΟΥ ΒΑΣΙΖΟΝΤΑΙ ΣΕ ΑΥΤΕΣ',
  },
  {
    label: '46751262',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΥΠΟΓΡΑΦΙΚΗΣ ΜΕΛΑΝΗΣ',
  },
  {
    label: '46751263',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΓΡΟΥ ΚΑΙ ΠΕΠΙΕΣΜΕΝΟΥ ΑΕΡΑ',
  },
  {
    label: '46751264',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΓΡΩΝ ΓΙΑ ΥΔΡΑΥΛΙΚΑ ΦΡΕΝΑ, ΑΝΤΙΨΥΚΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΑΠΟΠΑΓΩΤΙΚΩΝ ΥΓΡΩΝ',
  },
  {
    label: '46751265',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΔΡΟΓΟΝΟΥ, ΑΡΓΟΥ, ΣΠΑΝΙΩΝ ΑΕΡΙΩΝ, ΑΖΩΤΟΥ ΚΑΙ ΟΞΥΓΟΝΟΥ',
  },
  {
    label: '46751266',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΔΡΟΧΛΩΡΙΟΥ, ΔΙΘΕΙΙΚΟΥ ΟΞΕΟΣ, ΔΙΦΩΣΦΟΡΙΚΟΥ ΠΕΝΤΟΞΕΙΔΙΟΥ, ΑΛΛΩΝ ΑΝΟΡΓΑΝΩΝ ΟΞΕΩΝ, ΔΙΟΞΕΙΔΙΟΥ ΤΟΥ ΠΥΡΙΤΙΟΥ ΚΑΙ ΤΟΥ ΘΕΙΟΥ',
  },
  {
    label: '46751267',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΛΙΚΩΝ ΦΙΝΙΡΙΣΜΑΤΟΣ, ΦΟΡΕΩΝ ΒΑΦΗΣ ΠΟΥ ΕΠΙΤΑΧΥΝΟΥΝ ΤΗ ΒΑΦΗ Η ΣΤΕΡΕΟΠΟΙΟΥΝ ΤΙΣ ΒΑΦΕΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46751268',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΕΡΟΞΕΙΔΙΟΥ ΤΟΥ ΥΔΡΟΓΟΝΟΥ',
  },
  {
    label: '46751269',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΧΛΩΡΙΩΔΩΝ, ΧΛΩΡΙΚΩΝ ΚΑΙ ΥΠΕΡΧΛΩΡΙΚΩΝ',
  },
  {
    label: '46751270',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΑΙΝΟΛΩΝ, ΦΑΙΝΟΛΟΑΛΚΟΟΛΩΝ ΚΑΙ ΠΑΡΑΓΩΓΩΝ ΑΠΟ ΦΑΙΝΟΛΕΣ',
  },
  {
    label: '46751271',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΡΥΓΜΕΝΩΝ ΣΙΔΗΡΟΠΥΡΙΤΩΝ',
  },
  {
    label: '46751272',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΩΣΦΙΝΙΚΩΝ, ΦΩΣΦΟΝΙΚΩΝ, ΦΩΣΦΟΡΙΚΩΝ ΚΑΙ ΠΟΛΥΦΩΣΦΟΡΙΚΩΝ ΑΛΑΤΩΝ',
  },
  {
    label: '46760000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΝΔΙΑΜΕΣΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '46761100',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '46761101',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΟΥ ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ, ΤΣΙΓΑΡΟΧΑΡΤΟΥ ΠΟΥ ΔΕΝ ΕΧΕΙ ΚΟΠΕΙ ΣΕ ΚΑΤΑΛΛΗΛΑ ΜΕΓΕΘΗ',
  },
  {
    label: '46761102',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΟΥ ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ ΧΑΡΤΙΟΥ ΠΕΡΙΤΥΛΙΓΜΑΤΟΣ ΚΑΙ ΧΑΡΤΟΝΙΟΥ, ΧΟΝΔΡΟΥ ΧΑΡΤΙΟΥ ΓΙΑ ΣΑΚΟΥΣ ΤΥΠΟΥ ΠΑΠΙΕ ΓΚΟΦΡΕ Η ΚΥΜΑΤΟΕΙΔΟΥΣ',
  },
  {
    label: '46761103',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΟΥ ΧΑΡΤΙΟΥ, ΧΑΡΤΟΝΙΟΥ, ΧΑΡΤΟΒΑΜΒΑΚΑ ΚΑΙ ΡΟΛΩΝ ΑΠΟ ΜΑΛΑΚΗ ΚΥΤΤΑΡΙΝΗ',
  },
  {
    label: '46761104',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΧΑΡΤΙΩΝ ΚΑΙ ΧΑΡΤΟΝΙΩΝ',
  },
  {
    label: '46761105',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΤΥΠΩΤΙΚΟΥ ΧΑΡΤΙΟΥ (ΚΑΡΜΠΟΝ), ΑΥΤΟΑΝΤΙΓΡΑΦΙΚΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΑΛΛΩΝ ΧΑΡΤΙΩΝ ΓΙΑ ΑΝΤΙΓΡΑΦΗ Η ΜΕΤΑΦΟΡΑ ΚΕΙΜΕΝΩΝ, ΣΕ ΚΥΛΙΝΔΡΟΥΣ Η ΣΕ ΦΥΛΛΑ, ΠΛΑΤΟΥΣ > 36 ~ CM',
  },
  {
    label: '46761106',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΗΜΟΣΙΟΓΡΑΦΙΚΟΥ ΧΑΡΤΗ, ΣΕ ΚΥΛΙΝΔΡΟΥΣ Η ΣΕ ΦΥΛΛΑ',
  },
  {
    label: '46761107',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΗΘΗΤΙΚΩΝ ΔΕΣΜΩΝ, ΠΛΑΚΩΝ ΚΑΙ ΦΥΛΛΩΝ, ΑΠΟ ΧΑΡΤΟΠΟΛΤΟ',
  },
  {
    label: '46761108',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΗΜΙΧΗΜΙΚΟΥ ΑΥΛΑΚΩΤΟΥ ΧΑΡΤΙΟΥ (ΚΥΜΑΤΟΕΙΔΟΥΣ ΜΕΣΟΥ), ΣΕ ΚΥΛΙΝΔΡΟΥΣ Η',
  },
  {
    label: '46761109',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΥΜΑΤΟΕΙΔΟΥΣ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ, ΣΕ ΚΥΛΙΝΔΡΟΥΣ Η ΣΕ ΦΥΛΛΑ',
  },
  {
    label: '46761110',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΙΚΟΥ ΞΥΛΟΠΟΛΤΟΥ, ΗΜΙΧΗΜΙΚΟΥ ΞΥΛΟΠΟΛΤΟΥ, ΠΟΛΤΩΝ ΑΠΟ ΙΝΩΔΕΙΣ ΚΥΤΤΑΡΙΝΙΚΕΣ ΥΛΕΣ, ΕΚΤΟΣ ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '46761111',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΓΑΜΗΝΟΕΙΔΟΥΣ ΧΑΡΤΙΟΥ, ΑΔΙΑΒΡΟΧΟΥ ΧΑΡΤΙΟΥ (ΛΑΔΟΧΑΡΤΟΥ), ΔΙΑΦΑΝΟΥΣ ΧΑΡΤΙΟΥ ΑΝΤΙΓΡΑΦΗΣ ΚΑΙ ΧΑΡΤΙΟΥ ΓΚΛΑΣΕ ΚΑΙ ΑΛΛΩΝ ΣΤΙΛΠΝΩΝ ΔΙΑΦΑΝΩΝ Η ΗΜΙΔΙΑΦΑΝΩΝ ΧΑΡΤΙΩΝ',
  },
  {
    label: '46761112',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΠΤΥΧΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ, ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ',
  },
  {
    label: '46761113',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΝΘΕΤΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ ΕΠΙΦΑΝΕΙΑΚΑ Η ΕΜΠΟΤΙΣΜΕΝΟΥ',
  },
  {
    label: '46761114',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΛΙΚΟΥ ΧΑΡΤΟΠΟΙΙΑΣ ΓΙΑ ΧΑΡΤΙ ΥΓΕΙΑΣ Η ΧΑΡΤΙ ΚΑΘΑΡΙΣΜΟΥ ΠΡΟΣΩΠΟΥ, ΓΙΑ ΧΑΡΤΟΠΕΤΣΕΤΕΣ ΚΑΘΕ ΕΙΔΟΥΣ, ΧΑΡΤΟΒΑΜΒΑΚΑ ΚΑΙ ΡΟΛΩΝ ΑΠΟ ΙΝΕΣ ΚΥΤΤΑΡΙΝΗΣ',
  },
  {
    label: '46761115',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΓΡΑΦΗ, ΕΚΤΥΠΩΣΗ Η ΑΛΛΟΥΣ ΓΡΑΦΙΚΟΥΣ ΣΚΟΠΟΥΣ, ΕΠΙΧΡΙΣΜΕΝΟΥ ΜΕ ΚΑΟΛΙΝΗ Η ΜΕ ΑΛΛΕΣ ΑΝΟΡΓΑΝΕΣ ΟΥΣΙΕΣ',
  },
  {
    label: '46761116',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΩΣ ΒΑΣΗ ΓΙΑ ΦΩΤΟΕΥΑΙΣΘΗΤΟ, ΘΕΡΜΟΕΥΑΙΣΘΗΤΟ Η ΗΛΕΚΤΡΟΕΥΑΙΣΘΗΤΟ ΧΑΡΤΙ, ΧΑΡΤΙΟΥ ΑΠΟΤΥΠΩΤΙΚΗΣ ΒΑΣΗΣ, ΒΑΣΗΣ ΧΑΡΤΙΟΥ ΤΑΠΕΤΣΑΡΙΑΣ',
  },
  {
    label: '46761117',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΤΥΠΟΥ ΠΑΠΙΕ ΓΚΟΦΡΕ, ΚΥΜΑΤΟΕΙΔΟΥΣ, ΑΝΑΓΛΥΦΟΥ Η ΔΙΑΤΡΗΤΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '46761118',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΠΕΡΙΤΥΛΙΓΜΑΤΟΣ',
  },
  {
    label: '46761119',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ, ΧΑΡΤΟΝΙΟΥ, ΧΑΡΤΟΒΑΜΒΑΚΑ ΚΑΙ ΡΟΛΩΝ ΑΠΟ ΙΝΕΣ ΚΥΤΤΑΡΙΝΗΣ, ΕΠΙΧΡΙΣΜΕΝΩΝ, ΕΜΠΟΤΙΣΜΕΝΩΝ, ΕΠΕΝΔΥΜΕΝΩΝ, ΜΕ ΕΓΧΡΩΜΗ Η ΤΥΠΩΜΕΝΗ ΕΠΙΦΑΝΕΙΑ, ΣΕ ΚΥΛΙΝΔΡΟΥΣ Η ΣΕ ΦΥΛΛΑ',
  },
  {
    label: '46761120',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΕΙΡΟΠΟΙΗΤΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '46761121',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΗΜΙΚΟΥ ΞΥΛΟΠΟΛΤΟΥ, ΓΙΑ ΔΙΑΛΥΣΗ',
  },
  {
    label: '46761122',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΗΜΙΚΟΥ ΞΥΛΟΠΟΛΤΟΥ, ΕΠΕΞΕΡΓΑΣΜΕΝΟΥ ΜΕ ΘΕΙΩΔΕΣ ΑΛΑΣ, ΕΚΤΟΣ ΑΠΟ ΠΟΛΤΟ ΓΙΑ ΔΙΑΛΥΣΗ',
  },
  {
    label: '46761123',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΗΜΙΚΟΥ ΞΥΛΟΠΟΛΤΟΥ, ΕΠΕΞΕΡΓΑΣΜΕΝΟΥ ΜΕ ΣΟΔΑ Η ΘΕΙΙΚΟ ΑΛΑΣ, ΕΚΤΟΣ ΑΠΟ ΠΟΛΤΟ ΓΙΑ ΔΙΑΛΥΣΗ',
  },
  {
    label: '46761124',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΟΝΔΡΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ, ΕΚΤΟΣ ΑΠΟ ΤΟ ΕΙΔΟΣ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΓΡΑΦΗ, ΕΚΤΥΠΩΣΗ Η ΑΛΛΟΥΣ ΓΡΑΦΙΚΟΥΣ ΣΚΟΠΟΥΣ, ΕΠΙΧΡΙΣΜΕΝΟΥ ΜΕ ΚΑΟΛΙΝΗ Η ΜΕ ΑΛΛΕΣ ΑΝΟΡΓΑΝΕΣ ΟΥΣΙΕΣ',
  },
  {
    label: '46761125',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΟΝΔΡΟΥ ΧΑΡΤΙΟΥ ΠΕΡΙΤΥΛΙΓΜΑΤΟΣ, ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ',
  },
  {
    label: '46761200',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΙΝΩΝ',
  },
  {
    label: '46761201',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΚΟΥΛΙΩΝ ΜΕΤΑΞΟΣΚΩΛΗΚΑ ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΑΝΑΠΗΝΙΣΗ (ΞΕΤΥΛΙΓΑΔΙΑΣΜΑ)',
  },
  {
    label: '46761202',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΡΕΜΕΝΟΥ ΜΑΛΛΙΟΥ, ΛΙΠΑΡΟΥ (ΑΠΛΥΤΟΥ), ΚΑΘΩΣ ΚΑΙ ΚΟΥΡΕΜΕΝΟΥ ΜΑΛΛΙΟΥ ΠΛΥΜΕΝΟΥ ΣΤΗΝ ΠΡΟΒΙΑ',
  },
  {
    label: '46761203',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΛΕΠΤΟΙΝΩΝ Η ΧΟΝΔΡΟΙΝΩΝ ΖΩΙΚΩΝ ΤΡΙΧΩΝ (ΚΑΙ ΑΛΟΓΟΤΡΙΧΩΝ) ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΛΑΝΑΡΙΣΜΕΝΕΣ Η ΧΤΕΝΙΣΜΕΝΕΣ',
  },
  {
    label: '46761204',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΛΛΙΟΥ ΠΟΥ ΕΧΕΙ ΑΦΑΙΡΕΘΕΙ ΑΠΟ ΤΗΝ ΠΡΟΒΙΑ ΝΕΚΡΩΝ ΖΩΩΝ',
  },
  {
    label: '46761205',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΝΟΙΝΩΝ ΝΗΜΑΤΩΝ, ΛΩΡΙΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΤΕΧΝΗΤΑ Η ΣΥΝΘΕΤΙΚΑ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ',
  },
  {
    label: '46761206',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΗΜΑΤΟΣ ΜΕΓΑΛΗΣ ΑΝΤΟΧΗΣ ΑΠΟ ΝΑΙΛΟΝ Η ΑΛΛΑ ΠΟΛΥΑΜΙΔΙΑ ΚΑΙ ΑΠΟ ΠΟΛΥΕΣΤΕΡΕΣ',
  },
  {
    label: '46761207',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΗΜΑΤΟΣ ΜΕΓΑΛΗΣ ΑΝΤΟΧΗΣ ΑΠΟ ΤΕΧΝΗΤΗ ΒΙΣΚΟΖΗ',
  },
  {
    label: '46761208',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΑΣΜΑΤΩΝ ΚΑΙ ΑΠΟΡΡΙΜΜΑΤΩΝ ΤΕΧΝΗΤΩΝ ΙΝΩΝ',
  },
  {
    label: '46761209',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΞΕΦΤΙΔΙΩΝ ΑΠΟ ΜΑΛΛΙ Η ΑΠΟ ΛΕΠΤΟΙΝΕΣ Η ΧΟΝΔΡΟΙΝΕΣ ΖΩΙΚΕΣ ΤΡΙΧΕΣ',
  },
  {
    label: '46761210',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ Η ΣΥΝΘΕΤΙΚΩΝ ΥΦΑΝΤΙΚΩΝ ΑΣΥΝΕΧΩΝ ΙΝΩΝ, ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΓΙΑ',
  },
  {
    label: '46761211',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΙΛΜΑΤΩΝ (ΣΤΟΥΠΙΩΝ)',
  },
  {
    label: '46761212',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΧΟΝΔΡΑΔΙΩΝ ΒΑΜΒΑΚΙΟΥ (LINTER)',
  },
  {
    label: '46761300',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΣΤΙΚΩΝ ΚΑΙ ΕΛΑΣΤΙΚΟΥ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46761301',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΡΥΛΙΚΩΝ ΠΟΛΥΜΕΡΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46761302',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΜΙΝΟΡΗΤΙΝΩΝ, ΦΑΙΝΟΛΙΚΩΝ ΡΗΤΙΝΩΝ ΚΑΙ ΠΟΛΥΟΥΡΕΘΑΝΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46761303',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46761304',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΑΠΟ ΚΑΟΥΤΣΟΥΚ (ΕΚΤΟΣ ΤΟΥ ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ) ΚΑΙ ΣΚΟΝΩΝ ΚΑΙ ΚΟΚΚΩΝ',
  },
  {
    label: '46761305',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΠΛΑΣΤΙΚΩΝ',
  },
  {
    label: '46761306',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΑΙΘΕΡΩΝ ΚΑΙ ΠΟΛΥΕΣΤΕΡΩΝ, ΠΟΛΥΑΝΘΡΑΚΙΚΩΝ ΑΛΑΤΩΝ, ΑΛΚΥΔΙΚΩΝ ΚΑΙ ΕΠΟΞΕΙΔΙΚΩΝ ΡΗΤΙΝΩΝ',
  },
  {
    label: '46761307',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΑΜΙΔΙΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46761308',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΜΕΡΩΝ ΤΟΥ ΑΙΘΥΛΕΝΙΟΥ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46761309',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΜΕΡΩΝ ΤΟΥ ΟΞΙΚΟΥ ΒΙΝΥΛΙΟΥ Η ΑΛΛΩΝ ΕΣΤΕΡΩΝ ΚΑΙ ΠΟΛΥΜΕΡΩΝ ΤΟΥ ΒΙΝΥΛΙΟΥ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46761310',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΜΕΡΩΝ ΤΟΥ ΠΡΟΠΥΛΕΝΙΟΥ Η ΑΛΛΩΝ ΟΛΕΦΙΝΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46761311',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΜΕΡΩΝ ΤΟΥ ΣΤΥΡΟΛΙΟΥ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46761312',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΜΕΡΩΝ ΤΟΥ ΧΛΩΡΙΟΥΧΟΥ ΒΙΝΥΛΙΟΥ Η ΑΛΛΩΝ ΑΛΟΓΟΝΩΜΕΝΩΝ ΟΛΕΦΙΝΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46761313',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΗΤΙΝΩΝ ΟΥΡΙΑΣ, ΘΕΙΟΥΡΙΑΣ ΚΑΙ ΜΕΛΑΜΙΝΗΣ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46761314',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΛΙΚΟΝΩΝ ΣΕ ΠΡΩΤΟΓΕΝΕΙΣ ΜΟΡΦΕΣ',
  },
  {
    label: '46761315',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΥΝΘΕΤΙΚΟΥ ΕΛΑΣΤΙΚΟΥ',
  },
  {
    label: '46761900',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΝΔΙΑΜΕΣΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΚΤΟΣ ΤΩΝ ΑΓΡΟΤΙΚΩΝ, Π.Δ.Κ.Α.',
  },
  {
    label: '46761901',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΓΩΓΩΝ, ΣΩΛΗΝΩΝ ΚΑΙ ΜΑΝΙΚΩΝ, ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ, ΕΚΤΟΣ ΤΟΥ ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ',
  },
  {
    label: '46761902',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΚΡΥΛΙΚΩΝ ΦΥΛΛΩΝ',
  },
  {
    label: '46761903',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΥΤΟΚΟΛΛΗΤΩΝ ΤΑΙΝΙΩΝ, ΠΛΑΚΩΝ, ΛΩΡΙΔΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ, ΣΕ ΡΟΛΑ ΚΑΙ ΑΛΛΕΣ ΤΑΙΝΙΕΣ ΣΕ ΕΠΙΠΕΔΕΣ ΜΟΡΦΕΣ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '46761904',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΑΣΦΑΛΤΟ Η ΑΠΟ ΠΑΡΟΜΟΙΑ ΥΛΙΚΑ',
  },
  {
    label: '46761905',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΡΥΚΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46761906',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΚΥΨΕΛΩΔΕΙΣ',
  },
  {
    label: '46761907',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΜΗ ΚΥΨΕΛΩΔΕΙΣ',
  },
  {
    label: '46761908',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΣΩΛΗΝΩΝ, ΜΗ ΜΕΤΑΛΛΙΚΩΝ',
  },
  {
    label: '46761909',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΣΦΑΛΤΙΚΩΝ ΜΕΙΓΜΑΤΩΝ ΜΕ ΒΑΣΗ ΤΗ ΦΥΣΙΚΗ ΑΣΦΑΛΤΟ Η ΤΟ ΦΥΣΙΚΟ ΒΙΤΟΥΜΙΟ, ΤΟ ΒΙΤΟΥΜΙΟ ΤΟΥ ΠΕΤΡΕΛΑΙΟΥ, ΤΗΝ ΟΡΥΚΤΗ ΠΙΣΣΑ Η ΠΙΣΣΑΣΦΑΛΤΟ',
  },
  {
    label: '46761910',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΟΛΛΗΤΩΝ ΤΑΙΝΙΩΝ, ΠΛΑΚΩΝ, ΛΩΡΙΔΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ, ΣΕ ΡΟΛΑ ΚΑΙ ΑΛΛΕΣ ΕΠΙΠΕΔΕΣ ΜΟΡΦΕΣ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΠΛΑΤΟΥΣ >= 20 ~ CM',
  },
  {
    label: '46761911',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΤΟΥΜΙΟΥ ΚΑΙ ΑΣΦΑΛΤΟΥ, ΦΥΣΙΚΩΝ, ΑΣΦΑΛΤΙΤΩΝ ΚΑΙ ΑΣΦΑΛΤΙΚΩΝ ΠΕΤΡΩΜΑΤΩΝ',
  },
  {
    label: '46761912',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΟΥ ΣΕ ΜΑΖΑ, ΣΕ ΣΦΑΙΡΕΣ (ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΜΙΚΡΟΣΦΑΙΡΕΣ), ΣΕ ΡΑΒΔΟΥΣ Η ΣΕ ΣΩΛΗΝΕΣ, ΑΚΑΤΕΡΓΑΣΤΟΥ',
  },
  {
    label: '46761913',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΙΣΗΡΟΛΙΘΩΝ (ΕΛΑΦΡΟΠΕΤΡΩΝ), ΣΜΥΡΙΔΑΣ, ΦΥΣΙΚΟΥ ΚΟΡΟΥΝΔΙΟΥ, ΦΥΣΙΚΟΥ ΓΡΑΝΑΤΗ ΚΑΙ ΑΛΛΩΝ ΦΥΣΙΚΩΝ ΛΕΙΑΝΤΙΚΩΝ',
  },
  {
    label: '46761914',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΟΡΑΛΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ, ΟΣΤΡΑΚΩΝ ΜΑΛΑΚΙΩΝ, ΚΑΡΚΙΝΟΕΙΔΩΝ Η ΕΧΙΝΟΔΕΡΜΩΝ ΚΑΙ ΟΣΤΩΝ ΣΟΥΠΙΩΝ',
  },
  {
    label: '46761915',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΑΡΓΑΡΙΤΑΡΙΩΝ ΑΠΟ ΚΑΛΛΙΕΡΓΕΙΑ, ΑΚΑΤΕΡΓΑΣΤΩΝ',
  },
  {
    label: '46761916',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΜΕΤΑΛΛΙΚΩΝ ΟΡΥΚΤΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α., ΕΚΤΟΣ ΑΠΟ ΜΑΛΛΙΑ ΑΠΟ ΣΚΟΥΡΙΕΣ ΥΨΙΚΑΜΙΝΩΝ, ΟΡΥΚΤΑ ΜΑΛΛΙΑ ΚΑΙ ΑΝΤΙΚΕΙΜΕΝΑ ΘΕΡΜΟ/ΗΧΟΜΟΝΩΤΙΚΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '46761917',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΟΝΟΙΝΩΝ ΝΗΜΑΤΩΝ > 1 ~ MM, ΣΕ ΡΑΒΔΟΥΣ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΚΑΘΟΡΙΣΜΕΝΕΣ ΜΟΡΦΕΣ, ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46761918',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΝΤΑΜΙΤΖΑΝΩΝ, ΜΠΟΥΚΑΛΙΩΝ, ΦΙΑΛΩΝ, ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '46761919',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΟΙΝΟΛΑΣΠΗΣ, ΤΡΥΓΙΑΣ',
  },
  {
    label: '46761920',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΕΝΙΣΧΥΜΕΝΕΣ Η ΚΑΤΑ ΠΑΡΟΜΟΙΟ ΤΡΟΠΟ ΣΥΝΔΥΑΣΜΕΝΕΣ ΜΕ ΑΛΛΑ ΥΛΙΚΑ',
  },
  {
    label: '46761921',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΤΟΥ ΤΕΥΤΛΩΝ, ΥΠΟΛΕΙΜΜΑΤΟΣ ΕΚΧΥΛΙΣΗΣ ΣΑΚΧΑΡΟΥ (ΒΑΓΑΣΣΗΣ) ΚΑΙ ΑΛΛΩΝ ΥΠΟΛΕΙΜΜΑΤΩΝ ΑΠΟ ΤΗΝ ΠΑΡΑΓΩΓΗ ΖΑΧΑΡΗΣ',
  },
  {
    label: '46761922',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΤΙΜΩΝ ΚΑΙ ΗΜΙΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ (ΕΚΤΟΣ ΤΩΝ ΒΙΟΜΗΧΑΝΙΚΩΝ ΔΙΑΜΑΝΤΙΩΝ) ΑΚΑΤΕΡΓΑΣΤΩΝ Η ΑΠΛΩΣ ΚΟΜΜΕΝΩΝ Η ΧΟΝΔΡΙΚΑ ΔΙΑΜΟΡΦΩΜΕΝΩΝ',
  },
  {
    label: '46761923',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΟΓΙΕΛΑΙΟΥ, ΑΡΑΧΙΔΕΛΑΙΟΥ, ΕΛΑΙΟΛΑΔΟΥ, ΗΛΙΕΛΑΙΟΥ, ΚΑΡΔΑΜΕΛΑΙΟΥ, ΒΑΜΒΑΚΕΛΑΙΟΥ, ΚΡΑΜΒΕΛΑΙΟΥ, ΓΟΓΓΥΛΕΛΑΙΟΥ (COLZA OIL) ΚΑΙ ΕΛΑΙΟΥ ΣΙΝΑΠΗΣ, ΑΚΑΤΕΡΓΑΣΤΩΝ ΓΙΑ ΒΙΟΜΗΧΑΝΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '46761924',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΕΑΤΙΝΗΣ',
  },
  {
    label: '46761925',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΟΥ ΓΡΑΦΙΤΗ, ΚΟΛΛΟΕΙΔΟΥΣ Η ΗΜΙΚΟΛΛΟΕΙΔΟΥΣ ΓΡΑΦΙΤΗ, ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΜΕ ΒΑΣΗ ΤΟ ΓΡΑΦΙΤΗ Η ΑΛΛΟ ΑΝΘΡΑΚΑ ΥΠΟ ΜΟΡΦΗ ΗΜΙΚΑΤΕΡΓΑΣΜΕΝΩΝ',
  },
  {
    label: '46761926',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΟΥ ΚΟΡΟΥΝΔΙΟΥ',
  },
  {
    label: '46761927',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΛΙΚΩΝ ΕΜΦΙΑΛΩΣΗΣ ΥΓΡΩΝ ΤΡΟΦΙΜΩΝ, ΕΚΤΟΣ ΑΠΟ ΓΥΑΛΙΝΑ',
  },
  {
    label: '46761928',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΙΝΩΝ ΠΛΕΓΜΑΤΩΝ ΕΛΑΣΤΙΚΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΑΠΟ ΝΗΜΑΤΑ ΥΨΗΛΗΣ ΣΥΝΕΚΤΙΚΟΤΗΤΑΣ, ΠΟΥ ΑΠΟΤΕΛΟΥΝΤΑΙ ΑΠΟ ΝΑΙΛΟΝ Η ΑΛΛΑ ΠΟΛΥΑΜΙΔΙΑ, ΠΟΛΥΕΣΤΕΡΕΣ Η ΒΙΣΚΟΖΗ',
  },
  {
    label: '46761929',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ, ΕΜΠΟΤΙΣΜΕΝΩΝ, ΕΠΕΝΔΥΜΕΝΩΝ Η ΕΠΙΚΑΛΥΜΜΕΝΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '46761930',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΩΝ ΜΑΡΓΑΡΙΤΑΡΙΩΝ, ΑΚΑΤΕΡΓΑΣΤΩΝ',
  },
  {
    label: '46761931',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΤΙΚΩΝ ΚΗΡΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΑ ΤΡΙΓΛΥΚΕΡΙΔΙΑ), ΓΑΛΑΚΤΩΜΑΤΩΝ ΔΕΡΜΑΤΟΣ (ΔΕΡΜΑΤΕΛΑΙΩΝ), ΚΑΤΑΛΟΙΠΩΝ ΤΗΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΛΙΠΑΡΩΝ ΟΥΣΙΩΝ Η ΖΩΙΚΩΝ Η ΦΥΤΙΚΩΝ ΚΗΡΩΝ',
  },
  {
    label: '46770000',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ',
  },
  {
    label: '46771001',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΚΑΛΙΚΩΝ ΚΑΤΑΛΟΙΠΩΝ ΑΠΟ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΤΟΥ ΞΥΛΟΠΟΛΤΟΥ, ΕΚΤΟΣ ΑΠΟ ΤΟ ΤΑΛΛΕΛΑΙΟ',
  },
  {
    label: '46771002',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΥΠΟΛΕΙΜΜΑΤΩΝ ΒΑΜΒΑΚΙΟΥ, ΞΕΦΤΙΔΙΩΝ',
  },
  {
    label: '46771003',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΙΜΜΑΤΩΝ ΑΠΟ ΑΝΘΡΩΠΙΝΑ ΜΑΛΛΙΑ',
  },
  {
    label: '46771004',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΑΡΓΙΛΙΟΥ',
  },
  {
    label: '46771005',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΜΟΛΥΒΔΟΥ, ΨΕΥΔΑΡΓΥΡΟΥ ΚΑΙ ΚΑΣΣΙΤΕΡΟΥ',
  },
  {
    label: '46771006',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΝΙΚΕΛΙΟΥ',
  },
  {
    label: '46771007',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΧΑΛΚΟΥ',
  },
  {
    label: '46771008',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΧΡΥΣΟΥ Η ΕΠΙΧΡΥΣΩΜΕΝΟΥ ΜΕΤΑΛΛΟΥ, ΛΕΥΚΟΧΡΥΣΟΥ (ΠΛΑΤΙΝΑΣ) ΚΑΙ ΑΛΛΩΝ ΠΟΛΥΤΙΜΩΝ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '46771009',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΙΜΜΑΤΩΝ ΤΕΧΝΗΤΩΝ ΙΝΩΝ',
  },
  {
    label: '46771010',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΑΛΟΙΠΩΝ ΚΑΠΝΟΥ',
  },
  {
    label: '46771011',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΣΙΔΕΡΕΝΙΩΝ ΒΑΡΕΛΙΩΝ',
  },
  {
    label: '46771012',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΛΑΙΩΝ ΣΙΔΗΡΩΝ ΚΑΙ ΜΕΤΑΛΛΩΝ (SCRAP)',
  },
  {
    label: '46771013',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΛΑΙΩΝ ΣΙΔΗΡΩΝ ΚΑΙ ΜΕΤΑΛΛΩΝ, ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΕΠΑΝΑΧΡΗΣΙΜΟΠΟΙΗΣΗ',
  },
  {
    label: '46771014',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΑΛΑΙΩΝ ΣΙΔΗΡΩΝ ΚΑΙ ΜΕΤΑΛΛΩΝ, ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΕΠΑΝΑΧΡΗΣΙΜΟΠΟΙΗΣΗ, ΜΕΤΑ ΑΠΟ ΚΟΠΗ',
  },
  {
    label: '46771015',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΙΟΝΙΔΙΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΞΥΛΕΙΑΣ',
  },
  {
    label: '46771016',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΡΑΚΩΝ, ΑΧΡΗΣΤΩΝ ΣΠΑΓΓΩΝ, ΚΟΡΔΟΝΙΩΝ, ΣΧΟΙΝΙΩΝ ΚΑΙ ΚΑΛΩΔΙΩΝ ΚΑΙ ΦΘΑΡΜΕΝΩΝ ΕΙΔΩΝ ΑΠΟ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ',
  },
  {
    label: '46771017',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΥΧΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ',
  },
  {
    label: '46771018',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΚΩΡΙΩΝ, ΣΤΑΧΤΩΝ ΚΑΙ ΑΛΛΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ ΑΠΟ ΠΑΡΑΓΩΓΗ ΣΙΔΗΡΟΥ Η ΧΑΛΥΒΑ',
  },
  {
    label: '46771019',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΑΧΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΚΥΡΙΩΣ ΑΡΓΙΛΙΟ',
  },
  {
    label: '46771020',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΑΧΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΚΥΡΙΩΣ ΒΑΝΑΔΙΟ Η ΑΛΛΑ ΜΕΤΑΛΛΑ Η ΜΕΤΑΛΛΙΚΕΣ ΕΝΩΣΕΙΣ',
  },
  {
    label: '46771021',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΣΤΑΧΤΩΝ ΚΑΙ ΥΠΟΛΕΙΜΜΑΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΚΥΡΙΩΣ ΧΑΛΚΟ, ΨΕΥΔΑΡΓΥΡΟ Η ΜΟΛΥΒΔΟ',
  },
  {
    label: '46771022',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΛΕΙΜΜΑΤΩΝ ΒΑΜΒΑΚΙΟΥ, ΕΚΤΟΣ ΑΠΟ ΞΕΦΤΙΔΙΑ',
  },
  {
    label: '46771023',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΛΕΙΜΜΑΤΩΝ ΔΕΡΜΑΤΟΣ, ΠΡΙΟΝΙΔΙΟΥ, ΣΚΟΝΗΣ ΚΑΙ ΑΛΕΥΡΙΟΥ ΔΕΡΜΑΤΟΣ',
  },
  {
    label: '46771024',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΛΕΙΜΜΑΤΩΝ ΚΑΙ ΘΡΑΥΣΜΑΤΩΝ ΓΥΑΛΙΟΥ',
  },
  {
    label: '46771025',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΛΕΙΜΜΑΤΩΝ ΜΑΛΛΙΟΥ Η ΛΕΠΤΟΙΝΩΝ Η ΧΟΝΔΡΟΙΝΩΝ ΖΩΙΚΩΝ ΤΡΙΧΩΝ',
  },
  {
    label: '46771026',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΛΕΙΜΜΑΤΩΝ ΜΕΤΑΞΙΟΥ, ΜΗ ΛΑΝΑΡΙΣΜΕΝΩΝ Η ΚΤΕΝΙΣΜΕΝΩΝ',
  },
  {
    label: '46771027',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΛΕΙΜΜΑΤΩΝ ΦΕΛΛΟΥ',
  },
  {
    label: '46771028',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΛΕΙΜΜΑΤΩΝ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '46771029',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΘΑΡΜΕΝΩΝ ΕΙΔΩΝ ΡΟΥΧΙΣΜΟΥ ΚΑΙ ΑΛΛΩΝ ΦΘΑΡΜΕΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46771030',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΦΥΤΙΚΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ ΚΑΙ ΦΥΤΙΚΩΝ ΥΠΟΛΕΙΜΜΑΤΩΝ',
  },
  {
    label: '46771031',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΩΜΩΝ ΕΝΤΟΣΘΙΩΝ ΑΠΟΡΡΙΜΜΑΤΩΝ, ΜΗ ΒΡΩΣΙΜΩΝ',
  },
  {
    label: '46900000',
    value: 'ΜΗ ΕΞΕΙΔΙΚΕΥΜΕΝΟ ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ',
  },
  {
    label: '46901001',
    value: 'ΕΞΑΓΩΓΗ ΤΟΥΡΙΣΤΙΚΩΝ ΚΑΙ ΛΟΙΠΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46901002',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΦΟΔΙΑΣΜΟΥ ΣΚΑΦΩΝ ΑΝΑΨΥΧΗΣ, ΙΔΙΩΤΙΚΩΝ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΟΠΟΙΟΥΔΗΠΟΤΕ ΑΛΛΟΥ ΜΕΤΑΦΟΡΙΚΟΥ ΜΕΣΟΥ ΙΔΙΩΤΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '46901003',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΛΟΓΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46901004',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΕΚΚΛΗΣΙΑΣΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46901005',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΣΥΛΛΕΚΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '46901006',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΤΟΥΡΙΣΤΙΚΩΝ ΚΑΙ ΛΟΙΠΩΝ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΛΑΪΚΗΣ ΤΕΧΝΗΣ',
  },
  {
    label: '46901007',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΔΩΡΩΝ',
  },
  {
    label: '46901008',
    value:
      'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΜΗΘΕΙΑΣ ΔΙΑΦΟΡΩΝ ΕΙΔΩΝ ΓΕΝΙΚΑ ΠΡΟΣ ΤΟ ΔΗΜΟΣΙΟ, ΝΟΜΙΚΑ ΠΡΟΣΩΠΑ ΔΗΜΟΣΙΟΥ ΔΙΚΑΙΟΥ, ΟΡΓΑΝΙΣΜΟΥΣ ΤΟΠΙΚΗΣ ΑΥΤΟΔΙΟΙΚΗΣΗΣ, ΝΟΣΟΚΟΜΕΙΑ, ΔΗΜΟΤΙΚΑ ΚΛΠ ΚΟΙΝΩΦΕΛΗ Η ΟΧΙ ΙΔΡΥΜΑΤΑ ΚΑΙ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '46901009',
    value: 'ΧΟΝΔΡΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΜΗΘΕΙΑΣ ΠΛΟΙΩΝ ΜΕ ΔΙΑΦΟΡΑ ΕΙΔΗ',
  },
  {
    label: '47110000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΕ ΜΗ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ ΠΟΥ ΠΩΛΟΥΝ ΚΥΡΙΩΣ ΤΡΟΦΙΜΑ, ΠΟΤΑ Η ΚΑΠΝΟ',
  },
  {
    label: '47111001',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ SUPER MARKET, ΜΕ ΕΜΦΑΣΗ ΣΤΟ ΕΜΠΟΡΙΟ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '47111002',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΛΟΓΙΚΩΝ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '47111003',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΔΙΑΤΡΟΦΗΣ ΓΕΝΙΚΑ',
  },
  {
    label: '47111004',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΟΙΝΟΠΑΝΤΟΠΩΛΕΙΟΥ',
  },
  {
    label: '47111005',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΠΑΝΤΟΠΩΛΕΙΟΥ',
  },
  {
    label: '47190000',
    value: 'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΕ ΜΗ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47191001',
    value: 'ΕΚΜΕΤΑΛΛΕΥΣΗ ΚΑΤΑΣΤΗΜΑΤΟΣ ΨΙΛΙΚΩΝ ΕΙΔΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47191002',
    value: 'ΕΚΜΕΤΑΛΛΕΥΣΗ ΠΕΡΙΠΤΕΡΟΥ',
  },
  {
    label: '47191003',
    value: 'ΕΚΜΕΤΑΛΛΕΥΣΗ ΠΟΛΥΚΑΤΑΣΤΗΜΑΤΩΝ (ΥΠΕΡΑΓΟΡΩΝ)',
  },
  {
    label: '47191004',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΛΟΓΙΚΩΝ ΕΙΔΩΝ, ΕΚΤΟΣ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '47191005',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΗΜΙΣΤΙΚΩΝ ΕΙΔΩΝ (ΜΠΡΕΛΟΚ, ΜΠΛΟΥΖΩΝ, ΑΝΑΠΤΗΡΩΝ, ΣΤΥΛΟ ΚΛΠ)',
  },
  {
    label: '47191006',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΚΑΤΑΣΤΗΜΑΤΑ OUTLET',
  },
  {
    label: '47191007',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΚΑΤΑΣΤΗΜΑΤΑ STOCK',
  },
  {
    label: '47191008',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΔΩΡΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47191009',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΕΡΩΤΙΚΟΥ ΠΕΡΙΕΧΟΜΕΝΟΥ (SEX SHOP)',
  },
  {
    label: '47210000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47211100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΝΩΠΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '47211101',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΛΑΧΑΝΙΚΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47211102',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΦΡΟΥΤΩΝ, ΧΑΡΟΥΠΙΩΝ',
  },
  {
    label: '47211103',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΡΩΣΙΜΩΝ ΡΙΖΩΝ ΚΑΙ ΒΟΛΒΩΝ ΜΕ ΥΨΗΛΟ ΠΕΡΙΕΧΟΜΕΝΟ ΣΕ ΑΜΥΛΟ Η ΙΝΟΥΛΙΝΗ, ΓΙΑ ΑΝΘΡΩΠΙΝΗ ΚΑΤΑΝΑΛΩΣΗ',
  },
  {
    label: '47211104',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΩΝ ΚΑΙ ΑΛΛΩΝ ΕΛΑΙΟΥΧΩΝ ΚΑΡΠΩΝ, ΦΡΕΣΚΩΝ',
  },
  {
    label: '47211105',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΤΑΦΥΛΙΩΝ',
  },
  {
    label: '47211106',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΣΠΕΡΙΔΟΕΙΔΩΝ',
  },
  {
    label: '47211107',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΑΜΠΟΚΙΟΥ',
  },
  {
    label: '47211108',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΠΩΡΟΚΗΠΕΥΤΙΚΩΝ',
  },
  {
    label: '47211109',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΤΑΤΑΣ, ΦΡΕΣΚΙΑΣ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '47211110',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΙΖΩΔΩΝ ΚΑΙ ΒΟΛΒΟΕΙΔΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '47211111',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΟΥΡΜΑΔΩΝ, ΣΥΚΩΝ, ΜΠΑΝΑΝΩΝ, ΙΝΔΙΚΩΝ ΚΑΡΥΔΩΝ, ΒΡΑΖΙΛΙΑΝΙΚΩΝ ΚΑΡΥΔΩΝ ΑΝΑΚΑΡΔΙΟΥ, ΑΒΟΚΑΝΤΟ, ΜΑΝΓΚΟ ΚΑΙ ΓΟΥΑΒΑΣ, ΦΡΕΣΚΩΝ',
  },
  {
    label: '47211200',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΠΟΙΗΜΕΝΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '47211201',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΔΙΑΤΗΡΗΜΕΝΩΝ ΦΡΟΥΤΩΝ',
  },
  {
    label: '47211202',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΞΗΡΑΜΕΝΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '47211203',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΞΗΡΑΜΕΝΩΝ ΟΣΠΡΙΩΔΩΝ ΛΑΧΑΝΙΚΩΝ, ΑΠΟΦΛΟΙΩΜΕΝΩΝ, ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΣΠΟΡΑ',
  },
  {
    label: '47211204',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΤΗΡΗΜΕΝΩΝ ΠΑΤΑΤΩΝ',
  },
  {
    label: '47211205',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΩΝ ΚΑΙ ΑΛΛΩΝ ΕΛΑΙΟΥΧΩΝ ΚΑΡΠΩΝ, ΟΧΙ ΦΡΕΣΚΩΝ',
  },
  {
    label: '47211206',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΣΠΕΡΙΔΟΕΙΔΩΝ, ΞΗΡΩΝ',
  },
  {
    label: '47211207',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΚΟΥΤΣΙΩΝ ΒΕΡΙΚΟΚΩΝ, ΡΟΔΑΚΙΝΩΝ Η ΔΑΜΑΣΚΗΝΩΝ',
  },
  {
    label: '47211208',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΑΧΑΝΙΚΩΝ ΔΙΑΤΗΡΗΜΕΝΩΝ ΣΕ ΞΙΔΙ Η ΣΕ ΟΞΙΚΟ ΟΞΥ',
  },
  {
    label: '47211209',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΑΧΑΝΙΚΩΝ ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '47211210',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΑΧΑΝΙΚΩΝ, ΔΙΑΤΗΡΗΜΕΝΩΝ ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΕΚΤΟΣ ΑΠΟ ΞΙΔΙ Η ΟΞΙΚΟ ΟΞΥ',
  },
  {
    label: '47211211',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΡΜΕΛΑΔΩΝ, ΖΕΛΕΔΩΝ, ΠΟΥΡΕ ΚΑΙ ΠΟΛΤΩΝ ΦΡΟΥΤΩΝ Η ΞΗΡΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '47211212',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΤΑΤΩΝ ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '47211213',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΡΟΥΤΩΝ ΚΑΙ ΞΗΡΩΝ ΚΑΡΠΩΝ, ΜΑΓΕΙΡΕΜΕΝΩΝ Η ΑΜΑΓΕΙΡΕΥΤΩΝ, ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '47211214',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΟΥΡΜΑΔΩΝ, ΣΥΚΩΝ, ΜΠΑΝΑΝΩΝ, ΙΝΔΙΚΩΝ ΚΑΡΥΔΩΝ, ΒΡΑΖΙΛΙΑΝΙΚΩΝ ΚΑΡΥΔΩΝ ΑΝΑΚΑΡΔΙΟΥ, ΑΒΟΚΑΝΤΟ, ΜΑΝΓΚΟ, ΓΟΥΑΒΑΣ, ΞΗΡΩΝ',
  },
  {
    label: '47220000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΚΑΙ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47221300',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ',
  },
  {
    label: '47221301',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΠΑΡΑΣΚΕΥΑΣΜΕΝΟΥ ΚΑΙ ΔΙΑΤΗΡΗΜΕΝΟΥ ΚΡΕΑΤΟΣ, ΕΝΤΟΣΘΙΩΝ Η ΑΙΜΑΤΟΣ, ΕΚΧΥΛΙΣΜΑΤΩΝ ΚΑΙ ΖΩΜΩΝ ΚΡΕΑΤΟΣ',
  },
  {
    label: '47221302',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΡΕΑΤΩΝ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΚΡΕΑΤΟΣ ΚΟΥΝΕΛΙΩΝ), ΕΚΤΟΣ ΑΠΟ ΒΑΤΡΑΧΟΠΟΔΑΡΑ',
  },
  {
    label: '47221303',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΕΨΥΓΜΕΝΟΥ ΚΡΕΑΤΟΣ ΒΟΟΕΙΔΩΝ',
  },
  {
    label: '47221304',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΕΨΥΓΜΕΝΟΥ ΚΡΕΑΤΟΣ ΧΟΙΡΟΕΙΔΩΝ',
  },
  {
    label: '47221305',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΑΙΓΩΝ',
  },
  {
    label: '47221306',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΑΛΟΓΩΝ, ΓΑΪΔΟΥΡΙΩΝ, ΜΟΥΛΑΡΙΩΝ Η ΓΙΝΝΩΝ',
  },
  {
    label: '47221307',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΒΟΟΕΙΔΩΝ, ΝΩΠΟΥ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '47221308',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΚΟΥΝΕΛΙΩΝ',
  },
  {
    label: '47221309',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΠΡΟΒΑΤΩΝ, ΚΑΤΕΨΥΓΜΕΝΟΥ',
  },
  {
    label: '47221310',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΠΡΟΒΑΤΩΝ, ΝΩΠΟΥ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '47221311',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΧΟΙΡΟΕΙΔΩΝ, ΝΩΠΟΥ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '47221312',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΑΛΙΓΚΑΡΙΩΝ ΚΑΙ ΒΑΤΡΑΧΟΠΟΔΑΡΩΝ, ΝΩΠΩΝ, ΑΠΛΗΣ ΨΥΞΗΣ, ΚΑΤΕΨΥΓΜΕΝΩΝ, ΑΠΟΞΗΡΑΜΕΝΩΝ, ΠΑΣΤΩΝ Η ΣΕ ΑΛΜΗ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΘΑΛΑΣΣΙΝΑ ΣΑΛΙΓΚΑΡΙΑ',
  },
  {
    label: '47221400',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ',
  },
  {
    label: '47221401',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΚΡΩΝ ΖΩΩΝ',
  },
  {
    label: '47221402',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ',
  },
  {
    label: '47221403',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ ΠΟΥΛΕΡΙΚΩΝ, ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '47221404',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ ΠΟΥΛΕΡΙΚΩΝ, ΝΩΠΩΝ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '47221405',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΚΑΙ ΒΡΩΣΙΜΩΝ ΕΝΤΟΣΘΙΩΝ, ΑΛΑΤΙΣΜΕΝΩΝ, ΣΕ ΑΛΜΗ, ΑΠΟΞΗΡΑΜΕΝΩΝ Η ΚΑΠΝΙΣΤΩΝ, ΒΡΩΣΙΜΩΝ ΑΛΕΥΡΙΩΝ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΩΝ ΚΡΕΑΤΟΣ Η ΕΝΤΟΣΘΙΩΝ',
  },
  {
    label: '47221406',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΙΠΩΝ ΒΟΟΕΙΔΩΝ, ΠΡΟΒΑΤΩΝ, ΑΙΓΩΝ, ΧΟΙΡΩΝ ΚΑΙ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '47230000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ, ΚΑΡΚΙΝΟΕΙΔΩΝ ΚΑΙ ΜΑΛΑΚΙΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47231500',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ, ΟΣΤΡΑΚΟΕΙΔΩΝ ΚΑΙ ΜΑΛΑΚΙΩΝ',
  },
  {
    label: '47231501',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΑΛΑΚΙΩΝ Η ΟΣΤΡΑΚΟΔΕΡΜΩΝ ΚΑΙ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΖΩΝΤΩΝ, ΝΩΠΩΝ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '47231502',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΡΚΙΝΟΕΙΔΩΝ, ΚΑΤΕΨΥΓΜΕΝΩΝ, ΜΑΛΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΚΑΤΕΨΥΓΜΕΝΩΝ, ΑΠΟΞΗΡΑΜΕΝΩΝ, ΑΛΑΤΙΣΜΕΝΩΝ',
  },
  {
    label: '47231503',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΡΚΙΝΟΕΙΔΩΝ, ΜΑΛΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΔΡΟΒΙΩΝ ΑΣΠΟΝΔΥΛΩΝ, ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ',
  },
  {
    label: '47231504',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΡΚΙΝΟΕΙΔΩΝ, ΜΗ ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '47231505',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΝΩΠΩΝ, ΑΠΛΗΣ ΨΥΞΗΣ ΚΑΙ ΚΑΤΕΨΥΓΜΕΝΩΝ ΨΑΡΙΩΝ',
  },
  {
    label: '47231506',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΕΙΔΙΩΝ',
  },
  {
    label: '47231507',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΕΤΩΝ ΨΑΡΙΩΝ, ΑΛΛΟΥ ΚΡΕΑΤΟΣ ΨΑΡΙΩΝ, ΣΥΚΩΤΙΩΝ ΨΑΡΙΩΝ ΚΑΙ ΑΒΓΟΤΑΡΑΧΟΥ, ΝΩΠΩΝ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '47231508',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ ΑΠΟΞΗΡΑΜΕΝΩΝ, ΑΛΑΤΙΣΜΕΝΩΝ Η ΣΕ ΑΛΜΗ, ΚΑΠΝΙΣΤΩΝ ΨΑΡΙΩΝ ΚΑΙ ΒΡΩΣΙΜΟΥ ΙΧΘΥΑΛΕΥΡΟΥ',
  },
  {
    label: '47231509',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ, ΧΑΒΙΑΡΙΟΥ',
  },
  {
    label: '47231510',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ, ΖΩΝΤΩΝ',
  },
  {
    label: '47231511',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ, ΝΩΠΩΝ Η ΑΠΛΗΣ ΨΥΞΗΣ',
  },
  {
    label: '47231512',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ, ΦΙΛΕΤΩΝ ΨΑΡΙΩΝ, ΑΛΛΟΥ ΚΡΕΑΤΟΣ ΨΑΡΙΩΝ, ΣΥΚΩΤΙΩΝ ΨΑΡΙΩΝ ΚΑΙ ΑΒΓΟΤΑΡΑΧΟΥ, ΚΑΤΕΨΥΓΜΕΝΩΝ',
  },
  {
    label: '47240000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΩΜΙΟΥ, ΑΡΤΟΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΛΟΙΠΩΝ ΕΙΔΩΝ ΑΡΤΟΠΟΙΙΑΣ ΚΑΙ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47241600',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '47241601',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ (ΠΡΑΤΗΡΙΟ) ΨΩΜΙΟΥ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '47241602',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΨΩΜΙΟΥ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '47241603',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΤΗΡΗΜΕΝΩΝ ΓΛΥΚΩΝ ΜΕ ΒΑΣΗ ΤΟ ΑΛΕΥΡΙ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47241604',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΛΟΨΩΜΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΓΛΥΚΩΝ ΜΠΙΣΚΟΤΩΝ, ΒΑΦΛΩΝ ΚΑΙ ΛΕΠΤΩΝ ΜΠΙΣΚΟΤΩΝ',
  },
  {
    label: '47241605',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΖΥΜΗΣ',
  },
  {
    label: '47241606',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΡΑΓΑΝΟΥ ΨΩΜΙΟΥ, ΠΑΞΙΜΑΔΙΩΝ, ΦΡΥΓΑΝΙΣΜΕΝΟΥ ΨΩΜΙΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΦΡΥΓΑΝΙΣΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '47241607',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΕΙΔΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '47241608',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΥΡΟΠΙΤΩΝ, ΣΑΝΤΟΥΙΤΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47241609',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΡΕΣΚΟΥ ΨΩΜΙΟΥ',
  },
  {
    label: '47241610',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΡΕΣΚΩΝ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ ΚΑΙ ΓΛΥΚΙΣΜΑΤΩΝ',
  },
  {
    label: '47241611',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΛΛΩΝ ΚΡΟΥΣΤΑΣ Η ΚΑΝΤΑΪΦΙΟΥ',
  },
  {
    label: '47241700',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ ΜΕ ΒΑΣΗ ΤΗ ΖΑΧΑΡΗ',
  },
  {
    label: '47241701',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΤΗΡΗΜΕΝΩΝ ΓΛΥΚΩΝ ΜΕ ΒΑΣΗ ΤΗ ΖΑΧΑΡΗ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47241702',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΓΩΤΟΥ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΒΡΩΣΙΜΟΥ ΠΑΓΟΥ',
  },
  {
    label: '47241703',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΓΩΤΟΥ, ΧΥΜΑ Η ΤΥΠΟΠΟΙΗΜΕΝΟΥ',
  },
  {
    label: '47241704',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΕΤΑΙ Η ΛΕΥΚΗ ΣΟΚΟΛΑΤΑ), ΠΟΥ ΔΕΝ ΠΕΡΙΕΧΟΥΝ ΚΑΚΑΟ',
  },
  {
    label: '47241705',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΟΚΟΛΑΤΑΣ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΚΑΚΑΟ (ΕΚΤΟΣ ΑΠΟ ΖΑΧΑΡΟΥΧΟ ΣΚΟΝΗ ΚΑΚΑΟΥ), ΣΕ ΑΛΛΕΣ ΜΟΡΦΕΣ ΕΚΤΟΣ ΑΠΟ ΧΥΜΑ',
  },
  {
    label: '47241706',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΖΑΧΑΡΩΔΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '47241707',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΡΟΥΤΩΝ, ΞΗΡΩΝ ΚΑΡΠΩΝ, ΦΛΟΥΔΑΣ ΦΡΟΥΤΩΝ ΚΑΙ ΑΛΛΩΝ ΜΕΡΩΝ ΦΥΤΩΝ ΔΙΑΤΗΡΗΜΕΝΩΝ ΜΕ ΖΑΧΑΡΗ',
  },
  {
    label: '47250000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΤΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47252500',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ',
  },
  {
    label: '47252501',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ (ΠΡΑΤΗΡΙΟ) ΜΠΙΡΑΣ, ΑΝΑΨΥΚΤΙΚΩΝ ΚΑΙ ΕΜΦΙΑΛΩΜΕΝΩΝ ΝΕΡΩΝ',
  },
  {
    label: '47252502',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΟΤΩΝ ΠΟΥ ΠΡΟΕΡΧΟΝΤΑΙ ΑΠΟ ΖΥΜΩΣΗ (Π.Χ. ΜΗΛΙΤΗ, ΑΠΙΔΙΤΗ, ΥΔΡΟΜΕΛΙΟΥ) ΚΑΙ ΜΕΙΓΜΑΤΩΝ ΠΟΤΩΝ ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΑΛΚΟΟΛΗ',
  },
  {
    label: '47252503',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΣΤΑΓΜΑΤΩΝ, ΗΔΥΠΟΤΩΝ, ΑΛΛΩΝ ΟΙΝΟΠΝΕΥΜΑΤΩΔΩΝ ΠΟΤΩΝ, ΣΥΝΘΕΤΩΝ ΑΛΚΟΟΛΟΥΧΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΑΡΑΓΩΓΗ ΠΟΤΩΝ',
  },
  {
    label: '47252504',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΦΡΩΔΟΥΣ ΚΡΑΣΙΟΥ',
  },
  {
    label: '47252505',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΕΡΜΟΥΤ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΡΩΜΑΤΙΚΟΥ ΚΡΑΣΙΟΥ ΑΠΟ ΝΩΠΑ ΣΤΑΦΥΛΙΑ',
  },
  {
    label: '47252506',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΑΣΙΟΥ ΑΠΟ ΝΩΠΑ ΣΤΑΦΥΛΙΑ, ΕΚΤΟΣ ΑΠΟ ΤΟ ΑΦΡΩΔΕΣ ΚΡΑΣΙ, ΜΟΥΣΤΟΥ ΣΤΑΦΥΛΙΩΝ',
  },
  {
    label: '47252507',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΠΟΤΩΝ',
  },
  {
    label: '47252508',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΠΙΡΑΣ',
  },
  {
    label: '47252600',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΟΤΩΝ',
  },
  {
    label: '47252601',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ',
  },
  {
    label: '47252602',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΙΚΩΝ ΝΕΡΩΝ ΚΑΙ ΑΕΡΙΟΥΧΩΝ ΝΕΡΩΝ, ΠΟΥ ΔΕΝ ΕΧΟΥΝ ΓΛΥΚΑΝΘΕΙ Η',
  },
  {
    label: '47252603',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΓΑΚΙΩΝ ΒΡΩΣΙΜΩΝ, ΣΕ ΚΥΒΟΥΣ Η ΝΙΦΑΔΕΣ',
  },
  {
    label: '47252604',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΓΩΜΕΝΟΥ ΤΣΑΓΙΟΥ',
  },
  {
    label: '47252605',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΥΜΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '47260000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΚΑΠΝΟΥ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47262700',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΚΑΠΝΟΥ',
  },
  {
    label: '47262701',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΜΕΤΑΠΟΙΗΜΕΝΟΥ ΚΑΠΝΟΥ ΚΑΙ ΥΠΟΚΑΤΑΣΤΑΤΩΝ, ΟΜΟΓΕΝΟΠΟΙΗΜΕΝΟΥ Η ΑΝΑΣΥΣΤΑΜΕΝΟΥ ΚΑΠΝΟΥ, ΕΚΧΥΛΙΣΜΑΤΩΝ ΚΑΙ ΑΠΟΣΤΑΓΜΑΤΩΝ ΚΑΠΝΟΥ',
  },
  {
    label: '47262702',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΠΤΗΡΩΝ',
  },
  {
    label: '47262703',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΠΤΗΡΩΝ ΤΣΙΓΑΡΩΝ ΚΑΙ ΑΛΛΩΝ ΑΝΑΠΤΗΡΩΝ, ΠΙΠΩΝ ΚΑΠΝΙΣΜΑΤΟΣ ΚΑΙ ΠΙΠΩΝ ΓΙΑ ΠΟΥΡΑ Η ΤΣΙΓΑΡΑ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '47262704',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΚΑΠΝΙΣΤΟΥ',
  },
  {
    label: '47262705',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΝΑΠΤΗΡΩΝ, ΠΥΡΟΦΟΡΙΚΩΝ ΚΡΑΜΑΤΩΝ, ΕΙΔΩΝ ΑΠΟ ΕΥΦΛΕΚΤΑ ΥΛΙΚΑ ΚΑΙ ΤΕΜΑΧΙΩΝ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΠΙΠΩΝ',
  },
  {
    label: '47262706',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΥΡΩΝ, ΠΟΥΡΩΝ ΜΕ ΚΟΜΜΕΝΟ ΑΚΡΟ, ΠΟΥΡΑΚΙΩΝ ΚΑΙ ΤΣΙΓΑΡΩΝ, ΑΠΟ ΚΑΠΝΟ Η ΥΠΟΚΑΤΑΣΤΑΤΑ ΤΟΥ ΚΑΠΝΟΥ',
  },
  {
    label: '47262707',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΠΙΡΤΩΝ',
  },
  {
    label: '47262708',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΣΙΓΑΡΟΧΑΡΤΟΥ',
  },
  {
    label: '47262709',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΓΡΟΥ Η ΥΓΡΟΠΟΙΗΜΕΝΟΥ ΑΕΡΙΟΥ ΓΙΑ ΓΕΜΙΣΜΑ ΑΝΑΠΤΗΡΩΝ, ΟΙ ΟΠΟΙΟΙ ΕΧΟΥΝ ΧΩΡΗΤΙΚΟΤΗΤΑ >= 300 ~ CM3 ',
  },
  {
    label: '47290000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΤΡΟΦΙΜΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47291000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΑΒΓΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47291800',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '47291801',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΟΥΤΥΡΟΥ',
  },
  {
    label: '47291802',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47291803',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΣ',
  },
  {
    label: '47291804',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΣ ΚΑΙ ΚΡΕΜΑΣ ΜΕ ΠΕΡΙΣΣΟΤΕΡΟ ΑΠΟ 6 ;% ΛΙΠΟΣ, ΟΧΙ ΣΥΜΠΥΚΝΩΜΕΝΩΝ Η ΖΑΧΑΡΟΥΧΩΝ',
  },
  {
    label: '47291805',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΣ ΚΑΙ ΚΡΕΜΑΣ ΣΕ ΣΤΕΡΕΕΣ ΜΟΡΦΕΣ',
  },
  {
    label: '47291806',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΣ ΚΑΙ ΚΡΕΜΑΣ, ΣΥΜΠΥΚΝΩΜΕΝΩΝ Η ΜΕ ΠΡΟΣΘΗΚΗ ΖΑΧΑΡΗΣ Η ΑΛΛΩΝ ΓΛΥΚΑΝΤΙΚΩΝ ΥΛΩΝ, ΣΕ ΑΛΛΕΣ ΜΟΡΦΕΣ ΕΚΤΟΣ ΤΗΣ ΣΤΕΡΕΑΣ',
  },
  {
    label: '47291807',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΙΑΟΥΡΤΙΟΥ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΖΥΜΩΜΕΝΟΥ Η ΟΞΙΝΙΣΜΕΝΟΥ ΓΑΛΑΚΤΟΣ Η ΚΡΕΜΑΣ',
  },
  {
    label: '47291808',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΞΕΡΓΑΣΜΕΝΟΥ ΡΕΥΣΤΟΥ ΓΑΛΑΚΤΟΣ',
  },
  {
    label: '47291809',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΥΡΙΟΥ ΚΑΙ ΤΥΡΟΠΗΓΜΑΤΟΣ',
  },
  {
    label: '47291900',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΒΓΩΝ',
  },
  {
    label: '47291901',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΒΓΩΝ ΜΕ ΤΟ ΚΕΛΥΦΟΣ',
  },
  {
    label: '47292000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ',
  },
  {
    label: '47292100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΦΕ, ΤΣΑΓΙΟΥ, ΚΑΚΑΟΥ ΚΑΙ ΜΠΑΧΑΡΙΚΩΝ',
  },
  {
    label: '47292101',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΑΤΙΟΥ ΕΠΙΤΡΑΠΕΖΙΟΥ',
  },
  {
    label: '47292102',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΦΕΨΗΜΑΤΩΝ ΒΟΤΑΝΩΝ',
  },
  {
    label: '47292103',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΚΧΥΛΙΣΜΑΤΩΝ, ΑΠΟΣΤΑΓΜΑΤΩΝ, ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΤΣΑΓΙΟΥ Η ΜΑΤΕ',
  },
  {
    label: '47292104',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΒΟΥΡΔΙΣΜΕΝΟΥ ΚΑΙ ΑΛΕΣΜΕΝΟΥ ΚΑΦΕ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47292105',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΚΑΟΥ ΣΕ ΣΚΟΝΗ, ΠΟΥ ΔΕΝ ΠΕΡΙΕΧΕΙ ΠΡΟΣΘΕΤΗ ΖΑΧΑΡΗ Η ΑΛΛΗ ΓΛΥΚΑΝΤΙΚΗ ΥΛΗ',
  },
  {
    label: '47292106',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΚΑΟΥ ΣΕ ΣΚΟΝΗ, ΠΟΥ ΠΕΡΙΕΧΕΙ ΠΡΟΣΘΕΤΗ ΖΑΧΑΡΗ Η ΑΛΛΗ ΓΛΥΚΑΝΤΙΚΗ ΥΛΗ',
  },
  {
    label: '47292107',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΡΥΚΕΥΜΑΤΩΝ ~ ΜΠΑΧΑΡΙΚΩΝ ΚΑΙ ΛΟΙΠΩΝ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΛΕΣΜΕΝΩΝ ΚΑΙ ΣΥΣΚΕΥΑΣΜΕΝΩΝ',
  },
  {
    label: '47292108',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΦΕ ΑΠΟΚΑΦΕΪΝΩΜΕΝΟΥ',
  },
  {
    label: '47292109',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΦΕ ΜΗ ΑΠΟΚΑΦΕΪΝΩΜΕΝΟΥ',
  },
  {
    label: '47292110',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΤΕ',
  },
  {
    label: '47292111',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΠΑΧΑΡΙΚΩΝ, ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ',
  },
  {
    label: '47292112',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΠΑΧΑΡΙΚΩΝ, ΜΗ ΚΑΤΕΡΓΑΣΜΕΝΩΝ',
  },
  {
    label: '47292113',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΑΣΙΝΟΥ ΤΣΑΓΙΟΥ (ΜΗ ΖΥΜΩΜΕΝΟΥ), ΜΑΥΡΟΥ ΤΣΑΓΙΟΥ (ΖΥΜΩΜΕΝΟΥ) ΚΑΙ ΕΝ ΜΕΡΕΙ ΖΥΜΩΜΕΝΟΥ ΤΣΑΓΙΟΥ ΣΕ ΑΜΕΣΗ ΣΥΣΚΕΥΑΣΙΑ, ΠΟΥ ΔΕΝ ΥΠΕΡΒΑΙΝΕΙ ΤΑ 3 ~ KG',
  },
  {
    label: '47292114',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΑΛΤΣΩΝ, ΑΝΑΜΕΙΚΤΩΝ ΚΑΡΥΚΕΥΜΑΤΩΝ ΚΑΙ ΑΡΤΥΜΑΤΩΝ, ΑΛΕΥΡΙΟΥ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΟΥ ΣΙΝΑΠΙΟΥ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΕΝΗΣ ΜΟΥΣΤΑΡΔΑΣ',
  },
  {
    label: '47292115',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΤΟΥ ΚΑΦΕ, ΕΚΧΥΛΙΣΜΑΤΩΝ, ΟΥΣΙΩΝ ΚΑΙ ΣΥΜΠΥΚΝΩΜΑΤΩΝ ΤΟΥ ΚΑΦΕ Η ΤΩΝ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΤΟΥ ΚΑΦΕ',
  },
  {
    label: '47292200',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΡΩΣΙΜΩΝ ΕΛΑΙΩΝ ΚΑΙ ΛΙΠΩΝ',
  },
  {
    label: '47292201',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΟΛΑΔΟΥ',
  },
  {
    label: '47292202',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΩΝ ΑΛΛΩΝ ΕΛΑΙΟΥΧΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '47292203',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΖΩΙΚΩΝ ΕΛΑΙΩΝ ΚΑΙ ΛΙΠΩΝ, ΑΚΑΤΕΡΓΑΣΤΩΝ ΚΑΙ ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΕΚΤΟΣ ΑΠΟ ΛΙΠΗ ΒΟΟΕΙΔΩΝ, ΑΙΓΟΠΡΟΒΑΤΩΝ, ΧΟΙΡΩΝ ΚΑΙ ΠΟΥΛΕΡΙΚΩΝ',
  },
  {
    label: '47292204',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΖΩΙΚΩΝ Η ΦΥΤΙΚΩΝ ΛΙΠΩΝ ΚΑΙ ΕΛΑΙΩΝ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥΣ, ΥΔΡΟΓΟΝΩΜΕΝΩΝ, ΕΣΤΕΡΟΠΟΙΗΜΕΝΩΝ, ΑΛΛΑ ΧΩΡΙΣ ΝΑ ΕΧΟΥΝ ΥΠΟΣΤΕΙ ΠΕΡΑΙΤΕΡΩ ΕΠΕΞΕΡΓΑΣΙΑ',
  },
  {
    label: '47292205',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΑΜΠΟΚΕΛΑΙΟΥ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥ, ΟΧΙ ΧΗΜΙΚΑ ΤΡΟΠΟΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '47292206',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΡΓΑΡΙΝΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ',
  },
  {
    label: '47292207',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΟΓΙΕΛΑΙΟΥ, ΑΡΑΧΙΔΕΛΑΙΟΥ, ΕΛΑΙΟΛΑΔΟΥ, ΗΛΙΕΛΑΙΟΥ, ΚΑΡΔΑΜΕΛΑΙΟΥ, ΒΑΜΒΑΚΕΛΑΙΟΥ, ΚΡΑΜΒΕΛΑΙΟΥ, ΓΟΓΓΥΛΕΛΑΙΟΥ (COLZA OIL) ΚΑΙ ΕΛΑΙΟΥ ΣΙΝΑΠΗΣ, ΑΚΑΤΕΡΓΑΣΤΩΝ',
  },
  {
    label: '47292208',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΟΓΙΕΛΑΙΟΥ, ΑΡΑΧΙΔΕΛΑΙΟΥ, ΕΛΑΙΟΛΑΔΟΥ, ΗΛΙΕΛΑΙΟΥ, ΚΑΡΔΑΜΕΛΑΙΟΥ, ΒΑΜΒΑΚΕΛΑΙΟΥ, ΚΡΑΜΒΕΛΑΙΟΥ, ΓΟΓΓΥΛΕΛΑΙΟΥ (COLZA OIL), ΣΟΥΣΑΜΕΛΑΙΟΥ ΚΑΙ ΣΙΝΑΠΕΛΑΙΟΥ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥΣ, ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΑΛΛΑ ΜΗ ΧΗΜΙΚΑ ΤΡΟΠΟΠΟΙΗΜΕΝΩΝ',
  },
  {
    label: '47292209',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΟΙΝΙΚΕΛΑΙΟΥ, ΕΛΑΙΟΥ ΙΝΔΙΚΗΣ ΚΑΡΥΔΑΣ, ΦΟΙΝΙΚΟΠΥΡΗΝΩΝ, BABASSU ΚΑΙ ΛΙΝΕΛΑΙΟΥ ΚΑΙ ΤΩΝ ΚΛΑΣΜΑΤΩΝ ΤΟΥΣ, ΕΞΕΥΓΕΝΙΣΜΕΝΩΝ, ΑΛΛΑ ΟΧΙ ΧΗΜΙΚΑ ΤΡΟΠΟΠΟΙΗΜΕΝΩΝ, ΣΤΑΘΕΡΟΠΟΙΗΜΕΝΩΝ ΦΥΤΙΚΩΝ ΛΙΠΩΝ ΚΑΙ ΕΛΑΙΟΥ (ΕΚΤΟΣ ΑΠΟ ΤΟ ΚΑΛΑΜΠΟΚΕΛΑΙΟ) ΚΑΙ ΤΩ',
  },
  {
    label: '47292300',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΡΟΦΙΜΩΝ ΓΙΑ ΒΡΕΦΗ, ΤΡΟΦΙΜΩΝ ΔΙΑΙΤΗΣ ΚΑΙ ΑΛΛΩΝ ΟΜΟΓΕΝΟΠΟΙΗΜΕΝΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΔΙΑΤΡΟΦΗΣ',
  },
  {
    label: '47292301',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΔΙΑΤΡΟΦΗΣ',
  },
  {
    label: '47292302',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΠΑΙΔΙΚΩΝ ΤΡΟΦΩΝ',
  },
  {
    label: '47292303',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΜΟΓΕΝΟΠΟΙΗΜΕΝΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΤΡΟΦΙΜΩΝ ΚΑΙ ΔΙΑΙΤΗΤΙΚΩΝ ΤΡΟΦΩΝ',
  },
  {
    label: '47292304',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΔΙΚΩΝ ΤΡΟΦΩΝ',
  },
  {
    label: '47292400',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΤΡΟΦΙΜΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47292401',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΒΓΩΝ ΧΩΡΙΣ ΤΟ ΚΕΛΥΦΟΣ, ΚΑΙ ΚΡΟΚΩΝ ΑΒΓΩΝ, ΝΩΠΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ, ΛΕΥΚΩΜΑΤΟΣ ΑΒΓΟΥ',
  },
  {
    label: '47292402',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΗΣ ΖΑΧΑΡΗΣ ΑΠΟ ΖΑΧΑΡΟΚΑΛΑΜΟ Η ΖΑΧΑΡΟΤΕΥΤΛΑ, ΣΕ ΣΤΕΡΕΑ ΜΟΡΦΗ',
  },
  {
    label: '47292403',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΕΥΡΙΩΝ ΔΗΜΗΤΡΙΑΚΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47292404',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΛΕΥΡΙΩΝ ΔΗΜΗΤΡΙΑΚΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47292405',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΔΗΜΗΤΡΙΑΚΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΟΙ ΝΙΦΑΔΕΣ ΑΡΑΒΟΣΙΤΟΥ)',
  },
  {
    label: '47292406',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΔΙΑΤΡΟΦΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '47292407',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΜΑΓΕΙΡΕΥΤΩΝ ΖΥΜΑΡΙΚΩΝ, ΜΗ ΠΑΡΑΓΕΜΙΣΜΕΝΩΝ Η ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ',
  },
  {
    label: '47292408',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΜΥΛΩΝ, ΙΝΟΥΛΙΝΗΣ, ΓΛΟΥΤΕΝΗΣ ΣΙΤΑΡΙΟΥ, ΔΕΞΤΡΙΝΩΝ ΚΑΙ ΑΛΛΩΝ ΤΡΟΠΟΠΟΙΗΜΕΝΩΝ ΑΜΥΛΩΝ',
  },
  {
    label: '47292409',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΦΛΟΙΩΜΕΝΟΥ ΡΥΖΙΟΥ',
  },
  {
    label: '47292410',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΡΑΠΙΚΩΝ ΦΙΣΤΙΚΙΩΝ',
  },
  {
    label: '47292411',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΡΩΣΙΜΩΝ ΠΡΟΪΟΝΤΩΝ ΖΩΙΚΗΣ ΠΡΟΕΛΕΥΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '47292412',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΥΝΗΣ',
  },
  {
    label: '47292413',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΛΥΚΟΖΗΣ ΚΑΙ ΣΙΡΟΠΙΟΥ ΓΛΥΚΟΖΗΣ, ΦΡΟΥΚΤΟΖΗΣ ΚΑΙ ΣΙΡΟΠΙΟΥ ΦΡΟΥΚΤΟΖΗΣ, ΙΜΒΕΡΤΟΣΑΚΧΑΡΟΥ, ΣΑΚΧΑΡΩΝ ΚΑΙ ΣΙΡΟΠΙΟΥ ΣΑΚΧΑΡΩΝ Π.Δ.Κ.Α., ΤΕΧΝΗΤΟΥ ΜΕΛΙΟΥ ΚΑΙ ΚΑΡΑΜΕΛΑΣ',
  },
  {
    label: '47292414',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΑΡΙΣΜΕΝΗΣ ΖΑΧΑΡΗΣ ΑΠΟ ΖΑΧΑΡΟΚΑΛΑΜΟ Η ΖΑΧΑΡΟΤΕΥΤΛΑ ΚΑΙ ΧΗΜΙΚΑ ΚΑΘΑΡΗΣ ΣΑΚΧΑΡΟΖΗΣ ΣΕ ΣΤΕΡΕΑ ΜΟΡΦΗ, ΠΟΥ ΔΕΝ ΠΕΡΙΕΧΕΙ ΠΡΟΣΘΕΤΕΣ ΑΡΩΜΑΤΙΚΕΣ Η ΧΡΩΣΤΙΚΕΣ ΟΥΣΙΕΣ',
  },
  {
    label: '47292415',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΑΡΙΣΜΕΝΗΣ ΖΑΧΑΡΗΣ ΑΠΟ ΖΑΧΑΡΟΚΑΛΑΜΟ Η ΖΑΧΑΡΟΤΕΥΤΛΑ ΠΟΥ ΠΕΡΙΕΧΕΙ ΠΡΟΣΘΕΤΕΣ ΑΡΩΜΑΤΙΚΕΣ Η ΧΡΩΣΤΙΚΕΣ ΟΥΣΙΕΣ, ΖΑΧΑΡΗΣ ΚΑΙ ΣΙΡΟΠΙΟΥ ΣΦΕΝΔΑΜΟΥ',
  },
  {
    label: '47292416',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΓΕΙΡΕΜΕΝΩΝ ΖΥΜΑΡΙΚΩΝ, ΠΑΡΑΓΕΜΙΣΜΕΝΩΝ Η ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ, ΚΟΥΣΚΟΥΣ',
  },
  {
    label: '47292417',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΓΙΑΣ (ΕΝΕΡΓΟΥ Η ΑΔΡΑΝΟΥΣ), ΑΛΛΩΝ ΜΟΝΟΚΥΤΤΑΡΩΝ ΜΙΚΡΟΟΡΓΑΝΙΣΜΩΝ, ΝΕΚΡΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΔΙΟΓΚΩΤΙΚΩΝ ΣΚΟΝΩΝ',
  },
  {
    label: '47292418',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΛΑΚΟΥ ΣΙΤΑΡΙΟΥ ΚΑΙ ΣΜΙΓΑΔΙΟΥ, ΓΙΑ ΚΑΤΑΝΑΛΩΣΗ ΑΠΟ ΑΝΘΡΩΠΟΥΣ',
  },
  {
    label: '47292419',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΙΓΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΑΡΑΣΚΕΥΗ ΕΙΔΩΝ ΑΡΤΟΠΟΙΙΑΣ',
  },
  {
    label: '47292420',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΛΑΣΑΣ',
  },
  {
    label: '47292421',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΗΡΩΝ ΚΑΡΠΩΝ',
  },
  {
    label: '47292422',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΗΡΩΝ ΚΑΡΠΩΝ, ΚΑΒΟΥΡΔΙΣΜΕΝΩΝ ΑΡΑΠΙΚΩΝ ΦΙΣΤΙΚΙΩΝ, ΑΛΑΤΙΣΜΕΝΩΝ Η ΜΕ ΑΛΛΟ ΤΡΟΠΟ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ',
  },
  {
    label: '47292423',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΙΔΙΟΥ ΚΑΙ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΤΟΥ ΞΙΔΙΟΥ, ΠΟΥ ΛΑΜΒΑΝΟΝΤΑΙ ΑΠΟ ΤΟ ΟΞΙΚΟ ΟΞΥ',
  },
  {
    label: '47292424',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΣΠΡΙΩΝ, ΣΥΣΚΕΥΑΣΜΕΝΩΝ',
  },
  {
    label: '47292425',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΥΖΙΟΥ, ΑΛΕΣΜΕΝΟΥ',
  },
  {
    label: '47292426',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΙΤΑΛΕΥΡΟΥ Η ΑΛΕΥΡΙΟΥ ΣΜΙΓΑΔΙΟΥ',
  },
  {
    label: '47292427',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΚΛΗΡOΥ ΣΙΤΑΡΙΟΥ, ΓΙΑ ΚΑΤΑΝΑΛΩΣΗ ΑΠΟ ΑΝΘΡΩΠΟΥΣ',
  },
  {
    label: '47292428',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΟΥΠΩΝ ΚΑΙ ΖΩΜΩΝ ΚΑΙ ΤΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '47292429',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΗΛΙΑΝΘΟΥ, ΣΟΥΣΑΜΙΟΥ, ΚΑΡΔΑΜΟΥ, ΚΡΑΜΒΗΣ, ΕΛΑΙΟΚΡΑΜΒΗΣ ΚΑΙ ΣΙΝΑΠΙΟΥ, ΓΙΑ ΑΝΘΡΩΠΙΝΗ ΚΑΤΑΝΑΛΩΣΗ',
  },
  {
    label: '47292430',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΣΟΓΙΑΣ',
  },
  {
    label: '47292431',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΑΠΙΟΚΑΣ ΚΑΙ ΥΠΟΚΑΤΑΣΤΑΤΩΝ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΑΠΟ ΑΜΥΛΟ ΣΕ ΜΟΡΦΗ ΝΙΦΑΔΩΝ, ΚΟΚΚΩΝ ΚΛΠ',
  },
  {
    label: '47292432',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΑΛΓΩΝ, ΝΩΠΩΝ Η ΑΠΟΞΗΡΑΜΕΝΩΝ',
  },
  {
    label: '47292433',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΟΥ ΜΕΛΙΟΥ',
  },
  {
    label: '47292434',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΤΙΚΩΝ ΑΛΕΥΡΙΩΝ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΩΝ, ΓΙΑ ΑΝΘΡΩΠΙΝΗ ΚΑΤΑΝΑΛΩΣΗ',
  },
  {
    label: '47292435',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΟΝΔΡΩΝ (ΜΠΛΙΓΟΥΡΙΟΥ) ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '47300000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΩΝ ΚΙΝΗΣΗΣ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47308100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΩΝ ΓΙΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '47308101',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ (ΠΡΑΤΗΡΙΟ) ΒΕΝΖΙΝΗΣ ΚΑΙ ΠΕΤΡΕΛΑΙΟΥ ΚΙΝΗΣΗΣ',
  },
  {
    label: '47308102',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΙΓΜΑΤΩΝ ΚΑΥΣΙΜΩΝ ΜΕ ΒΙΟΚΑΥΣΙΜΑ, ΓΙΑ ΚΙΝΗΤΗΡΕΣ',
  },
  {
    label: '47308103',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΙΠΑΝΤΙΚΩΝ ΕΛΑΙΩΝ ΠΕΤΡΕΛΑΙΟΥ, ΟΡΥΚΤΕΛΑΙΩΝ, ΑΛΛΩΝ ΛΙΠΑΝΤΙΚΩΝ, ΒΑΡΕΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47308104',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΕΚΠΛΥΣΗΣ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '47308105',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΤΙΛΒΩΤΙΚΩΝ ΟΥΣΙΩΝ ΚΑΙ ΚΡΕΜΩΝ, ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '47308106',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ (ΠΡΑΤΗΡΙΟ) ΥΓΡΑΕΡΙΩΝ ΓΙΑ ΕΦΟΔΙΑΣΜΟ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '47308107',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΓΡΩΝ ΓΙΑ ΥΔΡΑΥΛΙΚΑ ΦΡΕΝΑ, ΑΝΤΙΨΥΚΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΑΠΟΠΑΓΩΤΙΚΩΝ ΥΓΡΩΝ',
  },
  {
    label: '47410000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ, ΠΕΡΙΦΕΡΕΙΑΚΩΝ ΜΟΝΑΔΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΛΟΓΙΣΜΙΚΟΥ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47413100',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ, ΠΕΡΙΦΕΡΕΙΑΚΩΝ ΜΟΝΑΔΩΝ ΚΑΙ ΛΟΓΙΣΜΙΚΟΥ',
  },
  {
    label: '47413101',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΟΝΑΔΩΝ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47413102',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΨΗΦΙΑΚΩΝ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ Η ΟΧΙ ΣΤΟ ΙΔΙΟ ΠΕΡΙΒΛΗΜΑ ΜΙΑ Η ΔΥΟ ΑΠΟ ΤΟΥΣ ΠΑΡΑΚΑΤΩ ΤΥΠΟΥΣ ΜΟΝΑΔΩΝ: ΜΟΝΑΔΩΝ ΜΝΗΜΗΣ, ΜΟΝΑΔΩΝ ΕΙΣΟΔΟΥ, ΜΟΝΑΔΩΝ ΕΞΟΔΟΥ',
  },
  {
    label: '47413103',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΛΟΓΙΚΩΝ Η ΥΒΡΙΔΙΚΩΝ ΜΗΧΑΝΩΝ ΑΥΤΟΜΑΤΗΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '47413104',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΩΝ ΤΟΥΣ',
  },
  {
    label: '47413105',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΓΝΗΤΙΚΩΝ Η ΟΠΤΙΚΩΝ ΑΝΑΓΝΩΣΤΩΝ',
  },
  {
    label: '47413106',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΥΠΟΛΟΓΙΣΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '47413107',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΣΩΝ ΜΕΤΑΦΟΡΑΣ ΔΕΔΟΜΕΝΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΑΥΤΟΜΑΤΕΣ ΜΗΧΑΝΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '47413108',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΝΑΔΩΝ ΕΙΣΟΔΟΥ Η ΕΞΟΔΟΥ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ Η ΟΧΙ ΣΤΟ ΙΔΙΟ ΠΕΡΙΒΛΗΜΑ ΜΟΝΑΔΕΣ ΜΝΗΜΗΣ',
  },
  {
    label: '47413109',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΝΑΔΩΝ ΜΝΗΜΗΣ',
  },
  {
    label: '47413110',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΓΡΑΜΜΑΤΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ',
  },
  {
    label: '47413111',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΟΡΗΤΩΝ ΨΗΦΙΑΚΩΝ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ, ΒΑΡΟΥΣ <=10 ~ KG, ΟΠΩΣ ΑΥΤΕΣ ΤΩΝ ΤΥΠΩΝ \\LAPTOPS\\, \\NOTEBOOKS\\ ΚΑΙ \\SUB;NOTEBOOKS\\',
  },
  {
    label: '47413112',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΗΦΙΑΚΩΝ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ ΠΟΥ ΠΑΡΟΥΣΙΑΖΟΝΤΑΙ ΥΠΟ ΜΟΡΦΗ ΣΥΣΤΗΜΑΤΩΝ',
  },
  {
    label: '47413113',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΗΦΙΑΚΩΝ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΣΤΟ ΙΔΙΟ ΠΕΡΙΒΛΗΜΑ ΤΟΥΛΑΧΙΣΤΟΝ ΜΙΑ ΚΕΝΤΡΙΚΗ ΜΟΝΑΔΑ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ, ΜΙΑΣ ΜΟΝΑΔΑΣ ΕΙΣΟΔΟΥ ΚΑΙ ΜΙΑΣ ΜΟΝΑΔΑΣ ΕΞΟΔΟΥ, ΣΥΝΔΥΑΣΜΕΝΩΝ Η ΜΗ',
  },
  {
    label: '47420000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47423200',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '47423201',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΚΤΩΝ ΡΑΔΙΟΤΗΛΕΦΩΝΙΑΣ Η ΡΑΔΙΟΤΗΛΕΓΡΑΦΙΑΣ Π.Δ.Κ.Α.',
  },
  {
    label: '47423202',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΚΑΙ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΙΝΗΤΗΣ ΤΗΛΕΦΩΝΙΑΣ',
  },
  {
    label: '47423203',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗΝ ΕΝΣΥΡΜΑΤΗ ΤΗΛΕΦΩΝΙΑ Η ΤΗΝ ΕΝΣΥΡΜΑΤΗ ΤΗΛΕΓΡΑΦΙΑ',
  },
  {
    label: '47423204',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΕΚΠΟΜΠΗΣ ΓΙΑ ΤΗ ΡΑΔΙΟΤΗΛΕΦΩΝΙΑ, ΡΑΔΙΟΤΗΛΕΓΡΑΦΙΑ, ΡΑΔΙΟΤΗΛΕΟΠΤΙΚΗ ΜΕΤΑΔΟΣΗ',
  },
  {
    label: '47423205',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΚΙΝΗΤΗΣ ΤΗΛΕΦΩΝΙΑΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '47423206',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΤΗΛΕΟΜΟΙΟΤΥΠΙΑΣ',
  },
  {
    label: '47423207',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΤΗΜΑΤΩΝ ΔΟΡΥΦΟΡΙΚΩΝ ΛΗΨΕΩΝ (ΚΕΡΑΙΩΝ, ΑΝΑΚΛΑΣΤΗΡΩΝ)',
  },
  {
    label: '47423208',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΗΛΕΦΩΝΙΚΩΝ ΚΕΝΤΡΩΝ, ΣΥΜΒΑΤΙΚΩΝ ΤΗΛΕΦΩΝΩΝ, ΘΥΡΟΤΗΛΕΦΩΝΩΝ ΚΑΙ ΛΟΙΠΟΥ ΤΗΛΕΦΩΝΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '47430000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΗΧΟΥ ΚΑΙ ΕΙΚΟΝΑΣ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47433300',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΧΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΒΙΝΤΕΟ',
  },
  {
    label: '47433301',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΔΕΚΤΩΝ ΡΑΔΙΟΦΩΝΟΥ Η ΤΗΛΕΟΡΑΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47433302',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΜΑΤΩΝ ΜΗΧΑΝΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΠΑΙΓΝΙΩΝ, ΣΦΑΙΡΙΣΤΗΡΙΩΝ, ΗΛΕΚΤΡΟΦΩΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47433303',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΚΤΩΝ ΡΑΔΙΟΦΩΝΙΚΗΣ ΜΕΤΑΔΟΣΗΣ (ΕΚΤΟΣ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΑ ΑΥΤΟΚΙΝΗΤΑ), ΠΟΥ ΜΠΟΡΟΥΝ ΝΑ ΛΕΙΤΟΥΡΓΗΣΟΥΝ ΧΩΡΙΣ ΕΞΩΤΕΡΙΚΗ ΠΗΓΗ ΕΝΕΡΓΕΙΑΣ',
  },
  {
    label: '47433304',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΚΤΩΝ ΡΑΔΙΟΦΩΝΙΚΗΣ ΜΕΤΑΔΟΣΗΣ ΠΟΥ ΔΕΝ ΜΠΟΡΟΥΝ ΝΑ ΛΕΙΤΟΥΡΓΗΣΟΥΝ ΧΩΡΙΣ ΕΞΩΤΕΡΙΚΗ ΠΗΓΗ ΕΝΕΡΓΕΙΑΣ',
  },
  {
    label: '47433305',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΚΤΩΝ ΤΗΛΕΟΡΑΣΗΣ',
  },
  {
    label: '47433306',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΕΝΙΣΧΥΤΩΝ ΑΚΟΥΣΤΙΚΗΣ ΣΥΧΝΟΤΗΤΑΣ, ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ ΕΝΙΣΧΥΣΗΣ ΗΧΟΥ',
  },
  {
    label: '47433307',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΙΩΝ ΚΑΙ ΑΝΑΚΛΑΣΤΗΡΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΜΕΡΩΝ ΡΑΔΙΟΦΩΝΙΚΩΝ ΔΕΚΤΩΝ ΚΑΙ ΠΟΜΠΩΝ, ΜΕΡΩΝ ΕΞΟΠΛΙΣΜΟΥ ΡΑΝΤΑΡ, ΟΧΙ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '47433308',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΓΝΗΤΟΦΩΝΩΝ ΚΑΙ ΑΛΛΩΝ ΣΥΣΚΕΥΩΝ ΕΓΓΡΑΦΗΣ ΗΧΟΥ',
  },
  {
    label: '47433309',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΓΑΦΩΝΩΝ, ΑΚΟΥΣΤΙΚΩΝ ΚΕΦΑΛΗΣ, ΑΚΟΥΣΤΙΚΩΝ ΚΑΙ ΣΥΝΔΥΑΣΜΩΝ ΜΙΚΡΟΦΩΝΩΝ ΚΑΙ ΑΚΟΥΣΤΙΚΩΝ',
  },
  {
    label: '47433310',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΕΞΟΠΛΙΣΜΟΥ ΕΓΓΡΑΦΗΣ Η ΑΝΑΠΑΡΑΓΩΓΗΣ ΗΧΟΥ ΚΑΙ',
  },
  {
    label: '47433311',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΙΚΡΟΦΩΝΩΝ ΚΑΙ ΥΠΟΣΤΗΡΙΓΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '47433312',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΑΔΙΟΦΩΝΙΚΩΝ ΔΕΚΤΩΝ, ΣΥΣΚΕΥΩΝ ΒΙΝΤΕΟ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47433313',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΕΓΓΡΑΦΗΣ Η ΑΝΑΠΑΡΑΓΩΓΗΣ ΕΙΚΟΝΑΣ',
  },
  {
    label: '47433314',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΤΗΜΑΤΩΝ ΠΕΡΙΣΤΡΟΦΗΣ ΔΙΣΚΩΝ, ΠΙΚΑΠ, ΚΑΣΕΤΟΦΩΝΩΝ ΚΑΙ ΑΛΛΩΝ ΣΥΣΚΕΥΩΝ ΑΝΑΠΑΡΑΓΩΓΗΣ ΗΧΟΥ',
  },
  {
    label: '47433315',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΗΛΕΟΠΤΙΚΩΝ ΜΗΧΑΝΩΝ ΛΗΨΗΣ',
  },
  {
    label: '47433316',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΟΠΟΘΕΤΗΣΗΣ ΡΑΔΙΟΜΑΓΝΗΤΟΦΩΝΩΝ ΣΕ ΑΥΤΟΚΙΝΗΤΑ, ΜΟΤΟΣΙΚΛΕΤΕΣ ΚΑΙ ΑΥΤΟΚΙΝΟΥΜΕΝΑ ΜΗΧΑΝΗΜΑΤΑ',
  },
  {
    label: '47510000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47515100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ',
  },
  {
    label: '47515101',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΓΚΙΣΤΡΩΝ, ΚΟΠΙΤΣΩΝ ΚΑΙ ΠΟΡΠΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '47515102',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΓΚΡΑΦΩΝ, ΣΟΥΣΤΩΝ, ΚΟΠΙΤΣΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΚΟΥΜΠΙΩΝ, ΦΕΡΜΟΥΑΡ',
  },
  {
    label: '47515103',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΤΑΠΟΙΗΜΕΝΩΝ ΕΙΔΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΚΑΙ ΤΩΝ ΠΑΤΡΟΝ',
  },
  {
    label: '47515104',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΕΚΤΩΝ ΥΦΑΣΜΑΤΩΝ Η ΥΦΑΣΜΑΤΩΝ ΚΡΟΣΕ',
  },
  {
    label: '47515105',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΕΛΟΝΩΝ ΡΑΨΙΜΑΤΟΣ, ΒΕΛΟΝΩΝ ΠΛΕΞΙΜΑΤΟΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΓΙΑ ΧΡΗΣΗ ΜΕ ΤΟ ΧΕΡΙ',
  },
  {
    label: '47515106',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΑΝΤΕΛΩΝ ΜΕ ΤΟ ΚΟΜΜΑΤΙ, ΣΕ ΛΩΡΙΔΕΣ Η ΣΕ ΔΙΑΚΟΣΜΗΤΙΚΑ ΣΧΕΔΙΑ',
  },
  {
    label: '47515107',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΓΧΩΡΙΩΝ ΥΦΑΝΤΩΝ',
  },
  {
    label: '47515108',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΠΝΟΥ',
  },
  {
    label: '47515109',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΣΤΙΚΟΠΟΙΗΜΕΝΩΝ ΥΦΑΣΜΑΤΩΝ, ΕΚΤΟΣ ΑΠΟ ΠΛΕΓΜΑΤΑ ΕΝΙΣΧΥΣΗΣ (ΛΙΝΑ) ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ)',
  },
  {
    label: '47515110',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ ΝΗΜΑΤΩΝ',
  },
  {
    label: '47515111',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΟΧΕΙΡΩΝ',
  },
  {
    label: '47515112',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΥΜΜΑΤΩΝ ΚΡΕΒΑΤΙΩΝ',
  },
  {
    label: '47515113',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΕΝΤΗΜΑΤΩΝ ΜΕ ΤΟ ΚΟΜΜΑΤΙ, ΣΕ ΛΩΡΙΔΕΣ Η ΣΕ ΔΙΑΚΟΣΜΗΤΙΚΑ ΣΧΕΔΙΑ',
  },
  {
    label: '47515114',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΛΩΣΤΩΝ',
  },
  {
    label: '47515115',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΛΩΣΤΩΝ ΚΑΙ ΚΟΡΔΟΝΙΩΝ ΑΠΟ ΚΑΟΥΤΣΟΥΚ, ΚΑΛΥΜΜΕΝΩΝ ΜΕ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ, ΥΦΑΝΤΙΚΟΥ ΝΗΜΑΤΟΣ ΚΑΙ ΛΩΡΙΔΩΝ, ΕΜΠΟΤΙΣΜΕΝΩΝ Η ΚΑΛΥΜΜΕΝΩΝ ΜΕ ΕΛΑΣΤΙΚΟ Η ΠΛΑΣΤΙΚΟ',
  },
  {
    label: '47515116',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΛΩΣΤΩΝ ΚΑΙ ΝΗΜΑΤΩΝ ΡΑΨΙΜΑΤΟΣ',
  },
  {
    label: '47515117',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΒΕΡΤΩΝ ΚΑΙ ΚΛΙΝΟΣΚΕΠΑΣΜΑΤΩΝ ΤΑΞΙΔΙΟΥ (ΕΚΤΟΣ ΑΠΟ ΗΛΕΚΤΡΙΚΕΣ ΚΟΥΒΕΡΤΕΣ)',
  },
  {
    label: '47515118',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΡΕΜΕΝΟΥ ΜΑΛΛΙΟΥ, ΛΙΠΑΡΟΥ (ΑΠΛΥΤΟΥ), ΚΑΘΩΣ ΚΑΙ ΚΟΥΡΕΜΕΝΟΥ ΜΑΛΛΙΟΥ, ΠΛΥΜΕΝΟΥ ΣΤΗΝ ΠΡΟΒΙΑ',
  },
  {
    label: '47515119',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΕΠΤΟΙΝΩΝ Η ΧΟΝΔΡΟΙΝΩΝ ΖΩΙΚΩΝ ΤΡΙΧΩΝ (ΚΑΙ ΑΛΟΓΟΤΡΙΧΩΝ) ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΛΑΝΑΡΙΣΜΕΝΕΣ Η ΧΤΕΝΙΣΜΕΝΕΣ',
  },
  {
    label: '47515120',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΑΝΔΡΙΚΩΝ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '47515121',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΚΕΝΤΗΜΑΤΩΝ',
  },
  {
    label: '47515122',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΥΦΑΣΜΑΤΩΝ ΠΟΛΥΤΕΛΕΙΑΣ, ΓΙΑ ΓΥΝΑΙΚΕΙΑ ΡΟΥΧΑ',
  },
  {
    label: '47515123',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΥΦΑΣΜΑΤΩΝ, ΓΙΑ ΓΥΝΑΙΚΕΙΑ ΡΟΥΧΑ',
  },
  {
    label: '47515124',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΥΦΑΝΤΩΝ ΚΑΙ ΕΙΔΩΝ ΑΠΟ ΜΗ ΥΦΑΝΤΑ, ΕΚΤΟΣ ΑΠΟ ΤΑ ΕΙΔΗ ΕΝΔΥΣΗΣ',
  },
  {
    label: '47515125',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΥΣΑΜΑΔΩΝ, ΤΕΝΤΩΝ, ΠΕΡΣΙΔΩΝ ΠΑΡΑΘΥΡΩΝ ΚΑΙ ΣΚΗΝΩΝ ΤΣΙΡΚΟΥ',
  },
  {
    label: '47515126',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΠΟΜΠΟΝΙΕΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΓΑΜΩΝ ΚΑΙ ΒΑΠΤΙΣΕΩΝ',
  },
  {
    label: '47515127',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΝΗΜΑΤΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΥΠΟ ΜΟΡΦΗ ΚΟΡΔΟΝΕΤΟΥ, ΝΗΜΑΤΩΝ ΣΕΝΙΛΛΙΑΣ ΚΑΙ ΡΑΒΔΩΤΩΝ ΝΗΜΑΤΩΝ ΜΕ ΘΗΛΙΕΣ',
  },
  {
    label: '47515128',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΝΗΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47515129',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΠΛΩΜΑΤΩΝ',
  },
  {
    label: '47515130',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΤΣΕΤΩΝ ΜΠΑΝΙΟΥ ΚΑΙ ΚΟΥΖΙΝΑΣ',
  },
  {
    label: '47515131',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΙΛΗΜΑΤΟΣ (ΤΣΟΧΑΣ), ΕΠΕΝΔΥΜΕΝΟΥ, ΕΠΙΚΑΛΥΜΜΕΝΟΥ Η ΛΑΜΙΝΑΡΙΣΜΕΝΟΥ',
  },
  {
    label: '47515132',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΤΥΠΩΝ ΓΥΝΑΙΚΕΙΩΝ ΑΜΦΙΕΣΕΩΝ (ΠΑΤΡΟΝ)',
  },
  {
    label: '47515133',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΕΝΤΟΝΙΩΝ ΚΑΙ ΜΑΞΙΛΑΡΟΘΗΚΩΝ',
  },
  {
    label: '47515134',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΗΜΑΙΩΝ ΚΑΙ ΛΑΒΑΡΩΝ',
  },
  {
    label: '47515135',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΤΕΝΩΝ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ, ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΓΑΡΝΙΤΟΥΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47515136',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΝΕΡΓΩΝ ΓΙΑ ΤΟ ΚΕΝΤΗΜΑ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47515137',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΕΝΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47515138',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΙΛΜΑΤΩΝ (ΣΤΟΥΠΙΩΝ)',
  },
  {
    label: '47515139',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΟΛΥΠΩΝ ΚΑΙ ΣΚΟΝΗΣ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ ΚΑΙ ΝΕΠ ΜΥΛΩΝ',
  },
  {
    label: '47515140',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΟΥΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΚΤΥΩΤΩΝ ΥΦΑΣΜΑΤΩΝ, ΥΦΑΣΜΑΤΩΝ ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '47515141',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΡΑΠΕΖΟΜΑΝΤΙΛΩΝ ΚΑΙ ΠΕΤΣΕΤΩΝ ΦΑΓΗΤΟΥ',
  },
  {
    label: '47515142',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΛΙΚΩΝ ΡΑΠΤΙΚΗΣ ΓΕΝΙΚΑ',
  },
  {
    label: '47515143',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΝΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΠΙΤΟΝΕ ΜΕ ΤΟ ΚΟΜΜΑΤΙ',
  },
  {
    label: '47515144',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ (ΕΚΤΟΣ ΤΩΝ ΕΙΔΙΚΩΝ ΥΦΑΣΜΑΤΩΝ)',
  },
  {
    label: '47515145',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΜΕΤΑΛΛΙΚΗ ΚΛΩΣΤΗ ΚΑΙ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΕΠΙΜΕΤΑΛΛΩΜΕΝΟ ΝΗΜΑ Π.Δ.Κ.Α.',
  },
  {
    label: '47515146',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΣΥΝΘΕΤΙΚΑ Η ΤΕΧΝΗΤΑ ΝΗΜΑΤΑ ΑΣΥΝΕΧΩΝ ΙΝΩΝ',
  },
  {
    label: '47515147',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΝΤΩΝ ΥΦΑΣΜΑΤΩΝ ΑΠΟ ΣΥΝΘΕΤΙΚΑ Η ΤΕΧΝΗΤΑ ΝΗΜΑΤΑ ΣΥΝΕΧΩΝ ΙΝΩΝ',
  },
  {
    label: '47515148',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ ΓΙΑ ΓΥΝΑΙΚΕΙΑ ΡΟΥΧΑ ΚΑΙ ΛΕΥΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47515149',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ ΕΠΙΠΛΩΣΕΩΝ Η ΑΛΛΩΝ ΥΦΑΣΜΑΤΙΝΩΝ ΕΙΔΩΝ ΤΑΠΕΤΣΑΡΙΑΣ',
  },
  {
    label: '47515150',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ, ΕΜΠΟΤΙΣΜΕΝΩΝ, ΕΠΕΝΔΥΜΕΝΩΝ Η ΕΠΙΚΑΛΥΜΜΕΝΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47515151',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ ΛΑΪΚΗΣ ΚΑΤΑΝΑΛΩΣΗΣ',
  },
  {
    label: '47515152',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ ΜΕ ΠΕΛΟΣ, ΘΗΛΕΙΩΤΩΝ ΥΦΑΣΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΙΚΩΝ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '47515153',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ ΜΕ ΠΕΛΟΣ, ΘΗΛΕΙΩΤΩΝ ΥΦΑΣΜΑΤΩΝ ΤΕΡΙ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '47515154',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ ΠΟΛΥΤΕΛΕΙΑΣ, ΓΙΑ ΓΥΝΑΙΚΕΙΑ ΡΟΥΧΑ',
  },
  {
    label: '47515155',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΣΜΑΤΩΝ, ΓΙΑ ΑΝΔΡΙΚΑ ΡΟΥΧΑ',
  },
  {
    label: '47515156',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΙΓΟΥΡΙΝΙΩΝ ΚΑΙ ΠΛΙΣΕΔΩΝ',
  },
  {
    label: '47515157',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΙΛΙΚΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47515200',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΡΤΙΝΩΝ ΚΑΙ ΔΙΧΤΥΩΤΩΝ ΚΟΥΡΤΙΝΩΝ',
  },
  {
    label: '47515201',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΡΤΙΝΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΟΙ ΠΤΥΧΩΤΕΣ) ΚΑΙ ΕΣΩΤΕΡΙΚΩΝ ΣΤΟΡΙΩΝ, ΓΥΡΩΝ (ΒΟΛΑΝ) ΚΟΥΡΤΙΝΩΝ Η ΚΡΕΒΑΤΙΩΝ',
  },
  {
    label: '47520000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΙΚΩΝ, ΧΡΩΜΑΤΩΝ ΚΑΙ ΤΖΑΜΙΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47524100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΙΚΩΝ',
  },
  {
    label: '47524101',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ',
  },
  {
    label: '47524102',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ Π.Δ.Κ.Α.',
  },
  {
    label: '47524103',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΛΕΙΔΑΡΙΩΝ ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '47524104',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΚΑΙ ΣΥΡΜΑΤΟΣ ΑΠΟ ΚΑΣΣΙΤΕΡΟ',
  },
  {
    label: '47524105',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΚΑΙ ΣΥΡΜΑΤΟΣ ΑΠΟ ΜΟΛΥΒΔΟ',
  },
  {
    label: '47524106',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΤΗΡΙΩΝ ΚΑΙ ΕΛΑΣΜΑΤΩΝ ΕΛΑΤΗΡΙΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ ΚΑΙ ΧΑΛΚΙΝΩΝ ΕΛΑΤΗΡΙΩΝ',
  },
  {
    label: '47524107',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΘΕΡΜΟΜΟΝΩΜΕΝΩΝ ΔΕΞΑΜΕΝΩΝ (ΕΚΤΟΣ ΤΩΝ ΔΟΧΕΙΩΝ ΓΙΑ ΑΕΡΙΑ), ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΧΩΡΗΤΙΚΟΤΗΤΑΣ < 300 ~ LT',
  },
  {
    label: '47524108',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΡΦΙΩΝ, ΠΡΟΚΩΝ, ΠΙΝΕΖΩΝ, ΣΥΝΔΕΤΗΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47524109',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΧΛΙΩΝ (ΒΙΔΩΝ) ΚΑΙ ΛΟΙΠΩΝ ΒΙΟΜΗΧΑΝΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47524110',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΧΛΙΩΤΩΝ ΚΑΙ ΜΗ ΚΟΧΛΙΩΤΩΝ ΜΕΤΑΛΛΙΚΩΝ ΣΥΝΔΕΤΗΡΩΝ',
  },
  {
    label: '47524111',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΚΕΤΩΝ ΚΑΙ ΚΛΕΙΔΑΡΙΩΝ ΓΙΑ ΕΠΙΠΛΑ, ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '47524112',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΝΤΕΣΕΔΩΝ, ΕΞΑΡΤΗΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ, ΠΟΡΤΕΣ, ΠΑΡΑΘΥΡΑ, ΕΠΙΠΛΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ, ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '47524113',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΙΚΩΝ ΥΦΑΣΜΑΤΩΝ, ΣΙΤΩΝ, ΠΛΕΓΜΑΤΩΝ, ΔΙΚΤΥΩΤΩΝ ΚΑΙ ΥΛΙΚΩΝ ΠΕΡΙΦΡΑΞΗΣ ΑΠΟ ΣΥΡΜΑ ΣΙΔΗΡΟΥ, ΧΑΛΥΒΑ Η ΧΑΛΚΟΥ, ΤΕΤΑΜΕΝΩΝ ΦΥΛΛΩΝ ΜΕΤΑΛΛΟΥ ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ Η ΧΑΛΚΟ',
  },
  {
    label: '47524114',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΡΠΩΝ ΚΑΙ ΠΛΑΙΣΙΩΝ ΜΕ ΠΟΡΠΕΣ, ΠΟΥ ΠΕΡΙΛΑΜΒΑΝΟΥΝ ΚΛΕΙΔΑΡΙΕΣ, ΜΕΡΩΝ ΤΟΥΣ ΚΑΙ ΧΩΡΙΣΤΩΝ ΚΛΕΙΔΙΩΝ',
  },
  {
    label: '47524115',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΙΚΩΝ ΟΙΚΟΔΟΜΩΝ ΚΑΙ ΕΡΓΑΛΕΙΩΝ ΤΕΧΝΙΚΩΝ',
  },
  {
    label: '47524116',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΤΕΛΕΧΩΝ ΚΑΙ ΛΑΒΩΝ ΓΙΑ ΣΚΟΥΠΕΣ Η ΒΟΥΡΤΣΕΣ, ΚΑΛΑΠΟΔΙΩΝ ΓΙΑ ΜΠΟΤΕΣ Η ΠΑΠΟΥΤΣΙΑ, ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '47524117',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΠΛΕΓΜΑΤΟΣ',
  },
  {
    label: '47524118',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΠΛΕΓΜΑΤΟΣ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΣΥΡΜΑΤΟΣΧΟΙΝΩΝ, ΚΑΛΩΔΙΩΝ, ΠΛΕΞΟΥΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΧΑΛΚΟ Η ΑΛΟΥΜΙΝΙΟ, ΜΗ ΗΛΕΚΤΡΟΜΟΝΩΜΕΝΩΝ',
  },
  {
    label: '47524119',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΣ ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ Η ΑΛΛΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '47524120',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΣ ΑΠΟ ΣΙΔΗΡΟ Η ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '47524121',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΣ ΑΠΟ ΧΑΛΚΟ Η ΑΡΓΙΛΙΟ',
  },
  {
    label: '47524122',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΣ, ΡΑΒΔΩΝ, ΣΩΛΗΝΩΝ, ΠΛΑΚΩΝ, ΗΛΕΚΤΡΟΔΙΩΝ, ΜΕ ΕΠΙΚΑΛΥΨΗ Η ΜΕ ΠΥΡΗΝΑ ΑΠΟ ΣΥΛΛΙΠΑΣΜΑ (FLUX)',
  },
  {
    label: '47524123',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΜΑΤΟΣΧΟΙΝΩΝ, ΚΑΛΩΔΙΩΝ, ΠΛΕΞΟΥΔΩΝ, ΑΡΤΑΝΩΝ (ΣΑΜΠΑΝΙΩΝ) ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΜΗ ΗΛΕΚΤΡΟΜΟΝΩΜΕΝΩΝ',
  },
  {
    label: '47524200',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΡΩΜΑΤΩΝ, ΒΕΡΝΙΚΙΩΝ, ΛΟΥΣΤΡΩΝ ΚΑΙ ΑΛΛΩΝ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '47524201',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΙΘΥΛΙΚΗΣ ΑΛΚΟΟΛΗΣ ΚΑΙ ΑΛΛΩΝ ΜΕΤΟΥΣΙΩΜΕΝΩΝ ΑΠΟΣΤΑΓΜΑΤΩΝ ΜΕ ΟΠΟΙΑΔΗΠΟΤΕ ΠΕΡΙΕΚΤΙΚΟΤΗΤΑ ΣΕ ΟΙΝΟΠΝΕΥΜΑ',
  },
  {
    label: '47524202',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΒΟΥΡΤΣΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47524203',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΟΛΛΩΝ',
  },
  {
    label: '47524204',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΧΡΩΜΑΤΩΝ ΕΠΙΧΡΙΣΗΣ ΚΑΙ ΒΕΡΝΙΚΙΩΝ, ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΣΤΕΓΑΝΩΤΙΚΩΝ',
  },
  {
    label: '47524205',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΣΠΡΟΥ ΠΕΤΡΕΛΑΪΚΟΥ ΑΙΘΕΡΑ (WHITE SPIRIT)',
  },
  {
    label: '47524206',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΑΛΛΩΝ ΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47524207',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΘΑΡΙΣΜΟΥ ΜΕ ΟΞΕΑ, ΣΥΛΛΙΠΑΣΜΑΤΩΝ, ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΕΠΙΤΑΧΥΝΤΩΝ ΒΟΥΛΚΑΝΙΣΜΟΥ, ΠΛΑΣΤΙΚΟΠΟΙΗΤΙΚΩΝ ΚΑΙ ΣΤΑΘΕΡΟΠΟΙΗΤΙΚΩΝ ΕΝΩΣΕΩΝ ΓΙΑ ΕΛΑΣΤΙΚΟ Η ΠΛΑΣΤΙΚΟ, ΚΑΤΑΛΥΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α., ΜΕΙΚΤΟΥ ΑΛΚΥΛΟΒΕΝΖΟΛΙΟ',
  },
  {
    label: '47524208',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΧΡΩΣΤΙΚΩΝ ΟΥΣΙΩΝ, ΑΔΙΑΦΑΝΟΠΟΙΗΤΩΝ ΚΑΙ ΧΡΩΜΑΤΩΝ, ΥΑΛΩΔΩΝ ΣΜΑΛΤΩΝ ΚΑΙ ΕΠΙΣΤΡΩΣΕΩΝ, ΕΠΙΚΑΛΥΜΜΑΤΩΝ ΚΕΡΑΜΕΥΤΙΚΗΣ, ΥΓΡΩΝ ΛΟΥΣΤΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΚΑΙ ΤΡΙΜΜΕΝΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '47524209',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΙΣΣΩΝ ΑΠΟ ΛΙΘΑΝΘΡΑΚΑ, ΑΠΟ ΛΙΓΝΙΤΗ Η ΤΥΡΦΗ ΚΑΙ ΑΛΛΩΝ ΟΡΥΚΤΩΝ ΠΙΣΣΩΝ',
  },
  {
    label: '47524210',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΡΩΜΑΤΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47524211',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΡΩΜΑΤΩΝ ΕΠΙΧΡΙΣΗΣ ΚΑΙ ΒΕΡΝΙΚΙΩΝ ΜΕ ΒΑΣΗ ΑΚΡΥΛΙΚΑ ΠΟΛΥΜΕΡΗ Η ΠΟΛΥΜΕΡΗ ΤΟΥ ΒΙΝΥΛΙΟΥ, ΣΕ ΥΔΑΤΩΔΕΣ ΜΕΣΟ',
  },
  {
    label: '47524212',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΡΩΜΑΤΩΝ ΕΠΙΧΡΙΣΗΣ ΚΑΙ ΒΕΡΝΙΚΙΩΝ ΜΕ ΒΑΣΗ ΠΟΛΥΕΣΤΕΡΕΣ, ΑΚΡΥΛΙΚΑ ΠΟΛΥΜΕΡΗ ΤΟΥ ΒΙΝΥΛΙΟΥ, ΣΕ ΜΗ ΥΔΑΤΩΔΕΣ ΔΙΑΛΥΜΑ',
  },
  {
    label: '47524300',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΕΔΩΝ ΤΖΑΜΙΩΝ',
  },
  {
    label: '47524301',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΟΥ \\ΒΙΤΡΟ\\',
  },
  {
    label: '47524302',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΟΥ ΑΣΦΑΛΕΙΑΣ (ΟΧΙ ΓΙΑ ΕΞΟΠΛΙΣΜΟ ΜΕΤΑΦΟΡΑΣ)',
  },
  {
    label: '47524303',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΟΥ ΣΕ ΦΥΛΛΑ, ΚΥΡΤΩΜΕΝΟΥ, ΜΕ ΚΑΤΕΡΓΑΣΜΕΝΑ ΑΚΡΑ, ΧΑΡΑΓΜΕΝΟΥ, ΔΙΑΤΡΗΤΟΥ, ΕΦΥΑΛΩΜΕΝΟΥ Η ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ ΚΑΤΕΡΓΑΣΜΕΝΟΥ, ΑΛΛΑ ΜΗ ΠΛΑΙΣΙΩΜΕΝΟΥ Η',
  },
  {
    label: '47524304',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΟΥ ΧΥΤΕΥΤΟΥ, ΕΛΑΤΟΥ, ΟΛΚΙΜΟΥ Η ΦΥΣΗΤΟΥ ΣΕ ΦΥΛΛΑ, ΑΛΛΑ ΜΗ ΚΑΤΕΡΓΑΣΜΕΝΟΥ ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ',
  },
  {
    label: '47524305',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΕΔΟΥ ΓΥΑΛΙΟΥ ΚΑΙ ΕΠΙΦΑΝΕΙΑΚΑ ΛΕΙΑΣΜΕΝΟΥ Η ΣΤΙΛΒΩΜΕΝΟΥ ΓΥΑΛΙΟΥ, ΣΕ ΦΥΛΛΑ, ΑΛΛΑ ΜΗ ΚΑΤΕΡΓΑΣΜΕΝΟΥ ΚΑΤΑ ΑΛΛΟ ΤΡΟΠΟ',
  },
  {
    label: '47524306',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΝΩΤΙΚΩΝ ΠΛΑΚΩΝ ΑΠΟ ΓΥΑΛΙ ΜΕ ΠΟΛΛΑΠΛΑ ΤΟΙΧΩΜΑΤΑ, ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΕΞΟΠΛΙΣΜΟ ΜΕΤΑΦΟΡΑΣ',
  },
  {
    label: '47524400',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΤΟ ΓΡΑΣΙΔΙ ΚΑΙ ΤΟΝ ΚΗΠΟ',
  },
  {
    label: '47524401',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΛΑΔΕΥΤΙΚΩΝ ΨΑΛΙΔΩΝ ΦΡΑΚΤΩΝ, ΨΑΛΙΔΩΝ ΚΟΠΗΣ ΧΛΟΟΤΑΠΗΤΑ, ΜΗΧΑΝΩΝ ΚΟΠΗΣ ΤΩΝ ΑΚΡΩΝ ΤΗΣ ΧΛΟΗΣ',
  },
  {
    label: '47524402',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΟΡΤΟΚΟΠΤΙΚΩΝ ΜΗΧΑΝΩΝ ΓΙΑ ΧΛΟΟΤΑΠΗΤΕΣ, ΠΑΡΚΑ Η ΑΘΛΗΤΙΚΑ ΓΗΠΕΔΑ',
  },
  {
    label: '47524500',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΔΡΑΥΛΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΘΕΡΜΑΝΣΗΣ, ΚΑΘΩΣ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ',
  },
  {
    label: '47524501',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΚΛΕΙΔΩΝ ΜΕΙΩΣΗΣ ΤΗΣ ΠΙΕΣΗΣ, ΔΙΚΛΕΙΔΩΝ ΕΛΕΓΧΟΥ, ΡΥΘΜΙΣΤΙΚΩΝ ΚΑΙ ΑΣΦΑΛΙΣΤΙΚΩΝ ΔΙΚΛΕΙΔΩΝ',
  },
  {
    label: '47524502',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΚΩΝ ΣΩΛΗΝΩΣΕΩΝ, ΑΓΩΓΩΝ, ΥΔΡΟΡΡΟΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΣΕΩΝ',
  },
  {
    label: '47524503',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΕΒΗΤΩΝ ΓΙΑ ΚΕΝΤΡΙΚΗ ΘΕΡΜΑΝΣΗ',
  },
  {
    label: '47524504',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΣΤΡΟΦΙΓΓΩΝ ΚΑΙ ΔΙΚΛΕΙΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47524505',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΟΦΙΓΓΩΝ, ΚΑΝΟΥΛΩΝ, ΔΙΚΛΕΙΔΩΝ ΓΙΑ ΝΕΡΟΧΥΤΕΣ, ΝΙΠΤΗΡΕΣ, ΜΠΙΝΤΕΔΕΣ, ΚΑΖΑΝΑΚΙΑ, ΜΠΑΝΙΕΡΕΣ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ, ΔΙΚΛΕΙΔΩΝ ΣΩΜΑΤΩΝ ΚΑΛΟΡΙΦΕΡ ΚΕΝΤΡΙΚΗΣ ΘΕΡΜΑΝΣΗΣ',
  },
  {
    label: '47524506',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΩΜΑΤΩΝ ΚΑΛΟΡΙΦΕΡ ΓΙΑ ΚΕΝΤΡΙΚΗ ΘΕΡΜΑΝΣΗ, ΠΟΥ ΔΕΝ ΘΕΡΜΑΙΝΟΝΤΑΙ ΗΛΕΚΤΡΙΚΑ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '47524507',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΔΡΑΥΛΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47524600',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ',
  },
  {
    label: '47524601',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ',
  },
  {
    label: '47524602',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΠΑΝΙΕΡΩΝ, ΝΙΠΤΗΡΩΝ, ΛΕΚΑΝΩΝ ΚΑΙ ΤΩΝ ΚΑΛΥΜΜΑΤΩΝ ΤΟΥΣ, ΚΑΖΑΝΑΚΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47524603',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΝΕΡΟΧΥΤΩΝ, ΝΙΠΤΗΡΩΝ, ΜΠΑΝΙΕΡΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ, ΧΑΛΚΟ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '47524700',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '47524701',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΡΓΑΛΕΙΩΝ',
  },
  {
    label: '47524702',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '47524703',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΥΣΙΔΩΝ (ΕΚΤΟΣ ΤΩΝ ΑΡΘΡΩΤΩΝ ΑΛΥΣΙΔΩΝ) ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '47524704',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΕΩΡΓΙΚΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ',
  },
  {
    label: '47524705',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΛΚΥΣΤΗΡΩΝ ΟΔΗΓΟΥΜΕΝΩΝ ΑΠΟ ΠΕΖΟΥΣ',
  },
  {
    label: '47524706',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΝΑΛΛΑΚΤΙΚΩΝ ΕΡΓΑΛΕΙΩΝ ΓΙΑ ΕΡΓΑΛΕΙΑ ΧΕΙΡΟΣ, ΠΟΥ ΕΙΤΕ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΡΕΥΜΑ, ΕΙΤΕ ΧΩΡΙΣ ΡΕΥΜΑ, Η ΓΙΑ ΕΡΓΑΛΕΙΟΜΗΧΑΝΕΣ',
  },
  {
    label: '47524707',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΕΞΟΜΑΛΥΝΣΗ ΕΠΙΦΑΝΕΙΩΝ, ΓΙΑ ΑΚΟΝΙΣΜΑ, ΤΡΟΧΙΣΜΑ, ΠΛΑΝΙΣΜΑ, ΠΡΙΟΝΙΣΜΑ, ΚΟΠΗ Η ΑΛΛΕΣ ΕΡΓΑΣΙΕΣ ΤΕΛΕΙΩΜΑΤΟΣ ΣΕ ΜΕΤΑΛΛΑ',
  },
  {
    label: '47524708',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗ ΔΙΑΤΡΗΣΗ, ΤΗ ΔΙΑΝΟΙΞΗ ΟΠΩΝ Η ΤΟ ΦΡΕΖΑΡΙΣΜΑ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '47524709',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΛΙΘΩΝ, ΚΕΡΑΜΙΚΩΝ, ΣΚΥΡΟΔΕΜΑΤΟΣ Η ΠΑΡΟΜΟΙΩΝ ΟΡΥΚΤΩΝ ΥΛΙΚΩΝ ΚΑΙ ΓΙΑ ΤΗΝ ΨΥΧΡΗ ΚΑΤΕΡΓΑΣΙΑ ΤΟΥ ΓΥΑΛΙΟΥ',
  },
  {
    label: '47524710',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΚΑΤΕΡΓΑΣΙΑ ΞΥΛΟΥ, ΦΕΛΛΟΥ, ΚΟΚΑΛΟΥ, ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ, ΣΚΛΗΡΟΥ ΠΛΑΣΤΙΚΟΥ Η ΠΑΡΟΜΟΙΩΝ ΣΚΛΗΡΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '47524711',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ ΓΙΑ ΜΑΛΑΚΗ ΣΥΓΚΟΛΛΗΣΗ, ΣΚΛΗΡΗ ΣΥΓΚΟΛΛΗΣΗ ΚΑΙ ΘΕΡΜΟΣΥΓΚΟΛΛΗΣΗ, ΜΗΧΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ, ΓΙΑ ΕΠΙΦΑΝΕΙΑΚΗ ΒΑΦΗ ΚΑΙ ΘΕΡΜΟ ΨΕΚΑΣΜΟ',
  },
  {
    label: '47524712',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ, ΜΕ ΠΕΠΙΕΣΜΕΝΟ ΑΕΡΑ Η ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΟ ΜΗ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '47524713',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ, ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗ ΓΕΩΡΓΙΑ, ΣΤΗΝ ΚΗΠΟΥΡΙΚΗ Η ΣΤΗ ΔΑΣΟΚΟΜΙΑ',
  },
  {
    label: '47524714',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΜΗΧΑΝΙΚΩΝ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ, ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΟ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ (ΕΚΤΟΣ ΑΠΟ ΚΛΑΔΕΥΤΙΚΕΣ ΨΑΛΙΔΕΣ ΦΡΑΚΤΩΝ, ΨΑΛΙΔΕΣ ΚΟΠΗΣ ΧΛΟΟΤΑΠΗΤΑ, ΜΗΧΑΝΕΣ ΚΟΠΗΣ ΤΩΝ ΑΚΡΩΝ ΤΗΣ ΧΛΟΗΣ)',
  },
  {
    label: '47524715',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΓΕΩΡΓΙΚΩΝ ΚΑΙ ΔΑΣΟΚΟΜΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '47524716',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΩΝ ΓΙΑ ΚΑΤΑΣΚΕΥΗ ΣΠΕΙΡΩΜΑΤΩΝ Η ΓΙΑ ΕΛΙΚΟΤΜΗΣΗ, ΜΕ ΑΦΑΙΡΕΣΗ ΜΕΤΑΛΛΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '47524717',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΩΝ ΜΕΤΡΗΣΗΣ',
  },
  {
    label: '47524718',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΕΙΡΟΠΡΙΟΝΩΝ',
  },
  {
    label: '47524900',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΥΛΙΚΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47524901',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΚΡΥΛΙΚΩΝ ΦΥΛΛΩΝ',
  },
  {
    label: '47524902',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΗΣ ΑΚΑΤΕΡΓΑΣΤΗΣ ΞΥΛΕΙΑΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΣΧΙΣΤΩΝ ΣΤΥΛΩΝ ΚΑΙ ΠΑΣΣΑΛΩΝ)',
  },
  {
    label: '47524903',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΓΩΓΩΝ, ΣΩΛΗΝΩΝ, ΜΑΝΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47524904',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΝΤΙΚΟΛΛΗΤΩΝ, ΕΠΕΝΔΥΜΕΝΩΝ ΞΥΛΟΦΥΛΛΩΝ (ΚΑΠΛΑΜΑΔΩΝ) ΚΑΙ ΠΑΡΟΜΟΙΑΣ ΕΠΙΚΟΛΛΗΤΗΣ ΞΥΛΕΙΑΣ',
  },
  {
    label: '47524905',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '47524906',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΔΟΚΩΝ ΚΑΙ ΡΑΒΔΩΝ ΓΙΑ ΤΙΣ ΚΑΤΑΣΚΕΥΕΣ',
  },
  {
    label: '47524907',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΓΥΨΟ Η ΣΥΝΘΕΣΕΙΣ ΜΕ ΒΑΣΗ ΤΟ ΓΥΨΟ Π.Δ.Κ.Α.',
  },
  {
    label: '47524908',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ ΛΙΘΩΝ ΓΙΑ ΛΑΞΕΥΣΗ Η ΟΙΚΟΔΟΜΙΚΩΝ ΛΙΘΩΝ ΚΑΙ ΕΙΔΩΝ ΤΟΥΣ, ΑΛΛΩΝ ΤΕΧΝΗΤΑ ΧΡΩΜΑΤΙΣΜΕΝΩΝ ΚΟΚΚΩΝ ΚΑΙ ΣΚΟΝΩΝ ΑΠΟ ΦΥΣΙΚΟ ΛΙΘΟ ΚΑΙ ΕΙΔΩΝ ΑΠΟ ΣΥΣΣΩΜΑΤΩΜΕΝΟ ΣΧΙΣΤΟΛΙΘΟ',
  },
  {
    label: '47524909',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΙΚΟΔΟΜΙΚΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '47524910',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΓΙΑ ΚΑΤΑΣΚΕΥΕΣ',
  },
  {
    label: '47524911',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΕΝΙΣΧΥΜΕΝΕΣ Η ΚΑΤΑ ΠΑΡΟΜΟΙΟ ΤΡΟΠΟ ΣΥΝΔΥΑΣΜΕΝΕΣ ΜΕ ΑΛΛΑ ΥΛΙΚΑ',
  },
  {
    label: '47524912',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΙΚΟΛΛΗΤΩΝ ΠΟΥ ΑΠΟΤΕΛΟΥΝΤΑΙ ΑΠΟΚΛΕΙΣΤΙΚΑ ΑΠΟ ΦΥΛΛΑ ΞΥΛΕΙΑΣ',
  },
  {
    label: '47524913',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΥΔΡΟΥ ΑΣΒΕΣΤΗ, ΕΝΥΔΡΟΥ ΑΣΒΕΣΤΗ ΚΑΙ ΥΔΡΑΥΛΙΚΟΥ ΑΣΒΕΣΤΗ',
  },
  {
    label: '47524914',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΣΒΕΣΤΟΛΙΘΟΥ ΚΑΙ ΓΥΨΟΥ',
  },
  {
    label: '47524915',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΣΦΑΛΤΙΚΩΝ ΜΕΙΓΜΑΤΩΝ ΜΕ ΒΑΣΗ ΤΗ ΦΥΣΙΚΗ ΑΣΦΑΛΤΟ Η ΤΟ ΦΥΣΙΚΟ ΒΙΤΟΥΜΙΟ, ΤΟ ΒΙΤΟΥΜΙΟ ΤΟΥ ΠΕΤΡΕΛΑΙΟΥ, ΤΗΝ ΟΡΥΚΤΗ ΠΙΣΣΑ Η ΠΙΣΣΑΣΦΑΛΤΟ',
  },
  {
    label: '47524916',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΟΛΛΗΤΩΝ ΚΑΠΛΑΜΑΔΩΝ',
  },
  {
    label: '47524917',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΨΗΤΩΝ ΠΥΡΙΜΑΧΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΑΛΛΩΝ ΠΥΡΙΜΑΧΩΝ ΚΕΡΑΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '47524918',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΡΑΝΙΤΗ, ΨΑΜΜΙΤΗ ΚΑΙ ΑΛΛΩΝ ΛΙΘΩΝ ΓΙΑ ΜΝΗΜΕΙΑ Η ΚΤΙΡΙΑ (ΟΙΚΟΔΟΜΙΚΩΝ ΛΙΘΩΝ)',
  },
  {
    label: '47524919',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΨΙΝΩΝ ΠΡΟΪΟΝΤΩΝ ΓΙΑ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΧΡΗΣΕΙΣ',
  },
  {
    label: '47524920',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΨΟΥ',
  },
  {
    label: '47524921',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ ΚΑΙ ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΑΠΟ ΑΡΓΙΛΙΟ',
  },
  {
    label: '47524922',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ ΚΑΙ ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES), ΑΠΟ ΧΑΛΚΟ',
  },
  {
    label: '47524923',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES) ΚΑΙ ΣΥΡΜΑΤΟΣ ΨΕΥΔΑΡΓΥΡΟΥ, ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ ΚΑΙ ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΨΕΥΔΑΡΓΥΡΟΥ',
  },
  {
    label: '47524924',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES), ΣΧΗΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΑΠΟ ΑΝΟΞΕΙΔΩΤΟ ΧΑΛΥΒΑ Η ΑΠΟ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '47524925',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΟΚΩΝ, ΡΑΒΔΩΝ, ΚΑΘΟΡΙΣΜΕΝΩΝ ΜΟΡΦΩΝ (PROFILES), ΣΧΗΜΑΤΩΝ ΚΑΙ ΜΕΡΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΜΗ ΚΡΑΜΑΤΟΠΟΙΗΜΕΝΟ ΧΑΛΥΒΑ',
  },
  {
    label: '47524926',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΑΠΟ ΑΜΙΑΝΤΟΤΣΙΜΕΝΤΟ, ΤΣΙΜΕΝΤΟ ΜΕ ΙΝΕΣ ΚΥΤΤΑΡΙΝΗΣ Η ΑΠΟ ΠΑΡΟΜΟΙΑ ΥΛΙΚΑ',
  },
  {
    label: '47524927',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ Π.Δ.Κ.Α.',
  },
  {
    label: '47524928',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ Π.Δ.Κ.Α.',
  },
  {
    label: '47524929',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΜΕΝΩΝ ΞΥΛΟΦΥΛΛΩΝ ΚΑΙ ΦΥΛΛΩΝ ΓΙΑ ΑΝΤΙΚΟΛΛΗΤΑ ΚΑΙ ΑΛΛΗΣ ΞΥΛΕΙΑΣ ΠΡΙΟΝΙΣΜΕΝΗΣ ΚΑΤΑ ΜΗΚΟΣ, ΤΕΜΑΧΙΣΜΕΝΗΣ Η ΑΠΟΦΛΟΙΩΜΕΝΗΣ, ΜΕΓΙΣΤΟΥ ΠΑΧΟΥΣ 6 ~ MM',
  },
  {
    label: '47524930',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΙΝΟΣΑΝΙΔΩΝ ΑΠΟ ΞΥΛΟ Η ΑΛΛΩΝ ΞΥΛΩΔΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '47524931',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΟΛΙΝΗ ΚΑΙ ΑΛΛΩΝ ΚΑΟΛΙΝΙΚΩΝ ΑΡΓΙΛΩΝ',
  },
  {
    label: '47524932',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΔΙΩΝ ΣΤΕΓΩΝ, ΣΤΟΙΧΕΙΩΝ, ΚΑΛΥΜΜΑΤΩΝ ΚΑΙ ΕΠΕΝΔΥΣΕΩΝ ΚΑΠΝΟΔΟΧΩΝ, ΑΡΧΙΤΕΚΤΟΝΙΚΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΚΑΙ ΑΛΛΩΝ ΚΕΡΑΜΙΚΩΝ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47524933',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΚΩΝ ΠΛΑΚΑΚΙΩΝ ΚΑΙ ΠΛΑΚΩΝ',
  },
  {
    label: '47524934',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΙΜΩΛΙΑΣ ΚΑΙ ΔΟΛΟΜΙΤΗ',
  },
  {
    label: '47524935',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΝΙΑΜΑΤΩΝ',
  },
  {
    label: '47524936',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΥΒΟΛΙΘΩΝ, ΤΟΥΒΛΩΝ, ΠΛΑΚΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΠΡΕΣΑΡΙΣΤΟ Η ΧΥΤΟ ΓΥΑΛΙ, ΓΥΑΛΙΟΥ ΒΙΤΡΟ, ΠΟΛΥΚΥΨΕΛΩΤΟΥ Η ΑΦΡΩΔΟΥΣ ΓΥΑΛΙΟΥ ΣΕ ΚΥΒΟΥΣ, ΠΛΑΚΕΣ Η ΠΑΡΟΜΟΙΕΣ ΜΟΡΦΕΣ',
  },
  {
    label: '47524937',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΕΙΑΝΤΙΚΩΝ ΣΚΟΝΩΝ Η ΚΟΚΚΩΝ ΣΕ ΒΑΣΗ ΑΠΟ ΥΦΑΝΤΙΚΟ ΥΛΙΚΟ, ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '47524938',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΙΘΟΚΟΚΚΩΝ, ΨΙΛΟΥ ΧΑΛΙΚΙΟΥ ΚΑΙ ΛΙΘΟΣΚΟΝΗΣ, ΚΡΟΚΑΛΩΝ, ΑΜΜΟΧΑΛΙΚΟΥ, ΣΠΑΣΜΕΝΩΝ Η ΘΡΥΜΜΑΤΙΣΜΕΝΩΝ ΠΕΤΡΩΝ',
  },
  {
    label: '47524939',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΖΩΝ ΚΕΡΑΜΙΚΗΣ',
  },
  {
    label: '47524940',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΛΛΙΩΝ ΑΠΟ ΣΚΟΥΡΙΕΣ ΥΨΙΚΑΜΙΝΩΝ, ΟΡΥΚΤΩΝ ΜΑΛΛΙΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΜΕΙΓΜΑΤΩΝ ΣΕ ΟΓΚΟΥΣ, ΦΥΛΛΑ Η ΚΥΛΙΝΔΡΟΥΣ, ΜΕΙΓΜΑΤΩΝ ΚΑΙ ΕΙΔΩΝ ΑΠΟ ΘΕΡΜΟ/ΗΧΟΜΟΝΩΤΙΚΑ ΥΛΙΚΑ Π.Δ.Κ.Α.',
  },
  {
    label: '47524941',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΡΜΑΡΟΥ, ΤΡΑΒΕΡΤΙΝΗ, ΑΛΑΒΑΣΤΡΟΥ, ΕΠΕΞΕΡΓΑΣΜΕΝΩΝ, ΤΕΧΝΗΤΑ ΧΡΩΜΑΤΙΣΜΕΝΩΝ ΚΟΚΚΩΝ ΚΑΙ ΣΚΟΝΩΝ ΑΠΟ ΜΑΡΜΑΡΟ, ΤΡΑΒΕΡΤΙΝΗ Η ΑΛΑΒΑΣΤΡΟ',
  },
  {
    label: '47524942',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΡΜΑΡΩΝ ΚΑΙ ΑΛΛΩΝ ΑΣΒΕΣΤΟΛΙΘΙΚΩΝ ΛΙΘΩΝ ΓΙΑ ΜΝΗΜΕΙΑ Η ΚΤΙΡΙΑ (ΟΙΚΟΔΟΜΙΚΩΝ ΛΙΘΩΝ)',
  },
  {
    label: '47524943',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΡΜΑΡΩΝ ΚΑΙ ΣΧΙΣΤΟΛΙΘΩΝ',
  },
  {
    label: '47524944',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΠΥΡΙΜΑΧΩΝ ΚΕΡΑΜΙΚΩΝ ΟΙΚΟΔΟΜΙΚΩΝ ΤΟΥΒΛΩΝ, ΚΥΒΟΛΙΘΩΝ ΔΑΠΕΔΩΝ, ΠΛΑΚΑΚΙΩΝ ΥΠΟΣΤΗΡΙΞΗΣ Η ΠΛΗΡΩΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47524945',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΡΙΟΣΑΝΙΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΑΝΙΔΩΝ ΑΠΟ ΞΥΛΟ Η ΑΛΛΩΝ ΞΥΛΩΔΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '47524946',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΥΛΟΠΕΤΡΩΝ, ΑΚΟΝΟΠΕΤΡΩΝ, ΤΡΟΧΩΝ ΛΕΙΑΝΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47524947',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΕΙΑΣ ΣΕ ΦΥΣΙΚΗ ΚΑΤΑΣΤΑΣΗ, ΕΠΕΞΕΡΓΑΣΜΕΝΗΣ ΜΕ ΧΡΩΜΑ, ΒΑΦΗ, ΚΡΕΟΖΩΤΟ Η ΑΛΛΑ ΣΥΝΤΗΡΗΤΙΚΑ',
  },
  {
    label: '47524948',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΕΙΑΣ, ΠΡΙΟΝΙΣΜΕΝΗΣ Η ΠΕΛΕΚΗΜΕΝΗΣ ΚΑΤΑ ΜΗΚΟΣ, ΤΕΜΑΧΙΣΜΕΝΗΣ Η ΑΠΟΦΛΟΙΩΜΕΝΗΣ, ΠΑΧΟΥΣ >= 6 ~ MM, ΣΤΡΩΤΗΡΩΝ (ΤΡΑΒΕΡΣΩΝ) ΣΙΔΗΡΟΔΡΟΜΩΝ Η ΤΡΟΧΙΟΔΡΟΜΩΝ, ΑΠΟ ΜΗ ΕΜΠΟΤΙΣΜΕΝΗ ΞΥΛΕΙΑ',
  },
  {
    label: '47524949',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΕΙΑΣ, ΣΥΝΕΧΩΣ ΔΙΑΜΟΡΦΩΜΕΝΗΣ ΚΑΤΑ ΜΗΚΟΣ ΟΠΟΙΑΣΔΗΠΟΤΕ ΑΚΡΗΣ Η ΕΠΙΦΑΝΕΙΑΣ',
  },
  {
    label: '47524950',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΙΚΟΔΟΜΗΣΙΜΩΝ ΥΛΙΚΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47524951',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΙΚΟΔΟΜΙΚΗΣ ΛΕΠΤΟΞΥΛΟΥΡΓΙΚΗΣ ΚΑΙ ΧΟΝΔΡΟΞΥΛΟΥΡΓΙΚΗΣ, ΑΠΟ ΞΥΛΕΙΑ Π.Δ.Κ.Α.',
  },
  {
    label: '47524952',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΘΥΡΩΝ, ΜΠΑΛΚΟΝΟΠΟΡΤΩΝ ΚΑΙ ΠΛΑΙΣΙΩΝ ΤΟΥΣ, ΠΟΡΤΩΝ, ΠΛΑΙΣΙΩΝ ΚΑΙ ΚΑΤΩΦΛΙΩΝ ΤΟΥΣ, ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '47524953',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΚΑΚΙΩΝ, ΠΛΑΚΟΛΙΘΩΝ, ΤΟΥΒΛΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ',
  },
  {
    label: '47524954',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ ΚΑΙ ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΑΠΟ ΜΟΛΥΒΔΟ, ΣΚΟΝΩΝ ΚΑΙ ΨΗΓΜΑΤΩΝ ΜΟΛΥΒΔΟΥ',
  },
  {
    label: '47524955',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΡΤΩΝ, ΠΑΡΑΘΥΡΩΝ ΚΑΙ ΤΩΝ ΠΛΑΙΣΙΩΝ ΤΟΥΣ, ΚΑΘΩΣ ΚΑΙ ΚΑΤΩΦΛΙΩΝ ΓΙΑ ΠΟΡΤΕΣ, ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '47524956',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΡΤΩΝ, ΠΑΡΑΘΥΡΩΝ, ΠΛΑΙΣΙΩΝ ΚΑΙ ΚΑΤΩΦΛΙΩΝ ΓΙΑ ΠΟΡΤΕΣ, ΠΑΡΑΘΥΡΟΦΥΛΛΩΝ, ΡΟΛΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47524957',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΟΡΟΦΗΣ Η ΠΡΟΣΟΨΗΣ ΑΠΟ ΑΣΦΑΛΤΟ Η ΑΠΟ ΠΑΡΟΜΟΙΑ ΥΛΙΚΑ, ΣΕ ΡΟΛΑ',
  },
  {
    label: '47524958',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΔΟΜΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΓΙΑ ΟΙΚΟΔΟΜΙΚΑ ΕΡΓΑ Η ΕΡΓΑ ΠΟΛΙΤΙΚΩΝ ΜΗΧΑΝΙΚΩΝ ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ',
  },
  {
    label: '47524959',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΚΤΙΡΙΩΝ, ΕΚΤΟΣ ΑΠΟ ΞΥΛΙΝΑ',
  },
  {
    label: '47524960',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΞΥΛΙΝΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '47524961',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΑΣΦΑΛΩΝ ΠΟΡΤΩΝ',
  },
  {
    label: '47524962',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΙΜΑΧΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '47524963',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΙΜΑΧΩΝ ΤΟΥΒΛΩΝ, ΚΥΒΟΛΙΘΩΝ, ΠΛΑΚΑΚΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΥΡΙΜΑΧΩΝ ΚΕΡΑΜΙΚΩΝ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΕΙΔΩΝ, ΕΚΤΟΣ ΤΩΝ ΕΙΔΩΝ ΑΠΟ ΠΥΡΙΤΙΚΗ ΣΚΟΝΗ ΑΠΟΛΙΘΩΜΑΤΩΝ Η ΑΠΟ ΠΥΡΙΤΙΟΥΧΕΣ ΓΑΙΕΣ',
  },
  {
    label: '47524964',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΙΜΑΧΩΝ ΤΣΙΜΕΝΤΩΝ, ΚΟΝΙΑΜΑΤΩΝ, ΣΚΥΡΟΔΕΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΥΝΘΕΣΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47524965',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΑΝΙΔΩΝ, ΤΕΜΑΧΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΦΥΤΙΚΕΣ ΙΝΕΣ, ΑΧΥΡΩΝ Η ΥΠΟΛΕΙΜΜΑΤΩΝ ΞΥΛΕΙΑΣ, ΣΥΣΣΩΜΑΤΩΜΕΝΩΝ ΜΕ ΟΡΥΚΤΕΣ ΣΥΝΔΕΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47524966',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΥ ΚΑΙ ΜΕΤΑΛΛΩΝ ΓΙΑ ΚΑΤΑΣΚΕΥΕΣ ΓΕΝΙΚΑ',
  },
  {
    label: '47524967',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΟΥ ΜΠΕΤΟΝ',
  },
  {
    label: '47524968',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΚΥΡΟΣΤΡΩΜΑΤΟΣ, ΠΙΣΣΟΣΚΥΡΟΣΤΡΩΜΑΤΟΣ',
  },
  {
    label: '47524969',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΜΠΥΚΝΩΜΕΝΗΣ ΞΥΛΕΙΑΣ, ΣΕ ΚΥΒΟΥΣ, ΠΛΑΚΕΣ, ΤΑΙΝΙΕΣ, Η ΣΧΗΜΑΤΑ ΚΑΘΟΡΙΣΜΕΝΗΣ ΜΟΡΦΗΣ',
  },
  {
    label: '47524970',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΧΙΣΤΟΛΙΘΟΥ',
  },
  {
    label: '47524971',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ ΑΠΟ ΜΟΛΥΒΔΟ',
  },
  {
    label: '47524972',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ ΑΠΟ ΨΕΥΔΑΡΓΥΡΟ',
  },
  {
    label: '47524973',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΣΩΛΗΝΩΝ Η ΑΓΩΓΩΝ, ΑΠΟ ΧΑΛΚΟ',
  },
  {
    label: '47524974',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΝ, ΑΓΩΓΩΝ ΚΑΙ ΚΟΙΛΩΝ ΜΟΡΦΟΣΩΛΗΝΩΝ (HOLLOW PROFILES), ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ',
  },
  {
    label: '47524975',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΩΛΗΝΩΣΕΩΝ ΑΠΟ ΤΣΙΜΕΝΤΟ, ΣΚΥΡΟΔΕΜΑ Η ΤΕΧΝΗΤΟ ΛΙΘΟ',
  },
  {
    label: '47524976',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ ΝΗΜΑΤΩΝ ΑΠΟ ΣΚΛΗΡΥΜΕΝΕΣ ΠΡΩΤΕΪΝΕΣ Η ΑΠΟ ΚΥΤΤΑΡΙΝΙΚΕΣ ΥΛΕΣ, ΑΚΑΜΠΤΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47524977',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΟΥΒΛΩΝ, ΚΥΒΟΛΙΘΩΝ, ΠΛΑΚΑΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47524978',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΟΥΛΙΩΝ, ΠΛΕΓΜΑΤΩΝ, ΠΑΤΑΚΙΩΝ, ΣΤΡΩΜΑΤΩΝ, ΣΑΝΙΔΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΓΥΑΛΙΝΕΣ ΙΝΕΣ',
  },
  {
    label: '47524979',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΣΙΜΕΝΤΟΥ PORTLAND, ΑΡΓΙΛΙΚΟΥ ΤΣΙΜΕΝΤΟΥ, ΤΣΙΜΕΝΤΟΥ ΣΚΟΥΡΙΩΝ ΥΨΙΚΑΜΙΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΔΡΑΥΛΙΚΩΝ ΤΣΙΜΕΝΤΩΝ',
  },
  {
    label: '47524980',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΤΖΑΚΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47524981',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΛΛΩΝ ΠΑΡΚΕΤΩΝ, ΚΑΛΟΥΠΙΩΝ ΓΙΑ ΟΙΚΟΔΟΜΙΚΟ ΣΚΥΡΟΔΕΜΑ, ΤΑΒΑΝΟΣΑΝΙΔΩΝ ΚΑΙ ΤΕΜΑΧΙΩΝ ΞΥΛΩΝ ΓΙΑ ΠΑΡΚΕΤΑ',
  },
  {
    label: '47524982',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΩΝ ΑΜΜΩΝ',
  },
  {
    label: '47524983',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΩΜΑΤΟΣ ΚΑΤΑΛΛΗΛΟΥ ΓΙΑ ΤΗΝ ΚΗΠΟΥΡΙΚΗ',
  },
  {
    label: '47530000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΛΙΩΝ, ΚΙΛΙΜΙΩΝ ΚΑΙ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΟΥ ΚΑΙ ΤΟΙΧΟΥ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47535300',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΤΟΙΧΟΣΤΡΩΣΙΑΣ (ΤΑΠΕΤΣΑΡΙΑΣ) ΚΑΙ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΟΥ, ΧΑΛΙΩΝ ΚΑΙ ΚΙΛΙΜΙΩΝ',
  },
  {
    label: '47535301',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΧΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΩΝ [ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΚΑΛΥΜΜΑΤΑ ΑΠΟ ΠΙΛΗΜΑ (ΤΣΟΧΑ)            ]',
  },
  {
    label: '47535302',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΩΝ ΚΑΙ ΠΑΤΑΚΙΩΝ ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ, ΕΚΤΟΣ ΤΟΥ ΚΥΤΤΑΡΙΝΟΕΙΔΟΥΣ',
  },
  {
    label: '47535303',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΣΕ ΡΟΛΑ Η ΥΠΟ ΜΟΡΦΗ ΠΛΑΚΙΔΙΩΝ',
  },
  {
    label: '47535304',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΣΕΩΝ ΤΟΙΧΩΝ ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47535305',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΕΝΔΥΣΕΩΝ ΤΟΙΧΩΝ Η ΟΡΟΦΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΣΕ ΡΟΛΑ Η ΥΠΟ ΜΟΡΦΗ ΠΛΑΚΙΔΙΩΝ',
  },
  {
    label: '47535306',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΩΝ ΜΕ ΥΠΟΘΕΜΑ ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '47535307',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΙΛΙΜΙΩΝ, ΒΕΛΕΝΤΖΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47535308',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΙΝΟΤΑΠΗΤΩΝ',
  },
  {
    label: '47535309',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΣΤΙΚΩΝ ΔΑΠΕΔΩΝ ΚΑΙ ΣΥΝΘΕΤΙΚΩΝ ΠΛΑΚΙΔΙΩΝ ΔΑΠΕΔΩΝ ΚΑΙ ΟΡΟΦΗΣ',
  },
  {
    label: '47535310',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΑΠΕΤΣΑΡΙΩΝ ΤΟΙΧΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47535311',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΛΙΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47535312',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΩΝ, ΘΥΣΑΝΩΤΩΝ',
  },
  {
    label: '47535313',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΩΝ, ΜΕ ΚΟΜΠΟΥΣ',
  },
  {
    label: '47535314',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΥΦΑΝΤΙΚΩΝ ΚΑΛΥΜΜΑΤΩΝ ΔΑΠΕΔΩΝ, ΥΦΑΝΤΩΝ',
  },
  {
    label: '47535315',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΤΑΠΕΤΣΑΡΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΠΕΝΔΥΣΕΩΝ ΤΟΙΧΩΝ, ΔΙΑΦΑΝΩΝ ΣΤΟΙΧΕΙΩΝ ΠΑΡΑΘΥΡΩΝ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '47540000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47545400',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '47545401',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΑΓΩΓΩΝ, ΓΙΑ ΤΑΣΗ ΕΩΣ 1000 ~ V',
  },
  {
    label: '47545402',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΗΛΕΚΤΡΟΘΕΡΜΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '47545403',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΤΑΣΧΗΜΑΤΙΣΤΩΝ, ΜΕ ΙΚΑΝΟΤΗΤΑ ΜΕΤΑΣΧΗΜΑΤΙΣΜΟΥ ΡΕΥΜΑΤΟΣ >= 16 ~ KVA',
  },
  {
    label: '47545404',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΦΟΥΡΝΩΝ, ΚΟΥΖΙΝΩΝ, ΠΛΑΚΩΝ (ΜΑΤΙΩΝ) ΜΑΓΕΙΡΕΜΑΤΟΣ, ΚΑΜΙΝΕΤΩΝ, ΣΧΑΡΩΝ ΜΑΓΕΙΡΕΜΑΤΟΣ, ΨΗΣΤΙΕΡΩΝ',
  },
  {
    label: '47545405',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΕΜΙΣΤΗΡΩΝ ΚΑΙ ΑΠΟΡΡΟΦΗΤΗΡΩΝ ΕΞΑΓΩΓΗΣ Η ΑΝΑΚΥΚΛΩΣΗΣ ΤΟΥ ΑΕΡΑ, ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '47545406',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΜΑΤΩΝ ΔΙΑΚΟΠΤΩΝ ΚΥΚΛΩΜΑΤΟΣ, ΤΑΣΗΣ >= 1000 ~ V',
  },
  {
    label: '47545407',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΥΣΜΑΤΩΝ, ΠΡΙΖΩΝ ΚΑΙ ΑΛΛΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗ ΔΙΑΚΟΠΗ Η ΤΗΝ ΠΡΟΣΤΑΣΙΑ ΗΛΕΚΤΡΙΚΩΝ ΚΥΚΛΩΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47545408',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΚΟΠΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47545409',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΕΦΑΡΜΟΓΗΣ ΗΛΕΚΤΡΙΣΜΟΥ (ΚΟΥΖΙΝΩΝ ~ ΠΛΥΝΤΗΡΙΩΝ ~ ΨΥΓΕΙΩΝ ΚΛΠ)',
  },
  {
    label: '47545410',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΑΣΦΑΛΕΙΩΝ',
  },
  {
    label: '47545411',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΘΕΡΜΑΝΤΗΡΩΝ ΝΕΡΟΥ, ΣΤΙΓΜΙΑΙΩΝ Η ΘΕΡΜΟΣΥΣΣΩΡΕΥΣΗΣ ΚΑΙ ΘΕΡΜΑΝΤΗΡΩΝ ΕΜΒΑΠΤΙΣΗΣ',
  },
  {
    label: '47545412',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΘΕΡΜΑΝΤΙΚΩΝ ΑΝΤΙΣΤΑΣΕΩΝ',
  },
  {
    label: '47545413',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΚΟΥΒΕΡΤΩΝ',
  },
  {
    label: '47545414',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΤΟΙΧΕΙΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΤΟΙΧΙΩΝ',
  },
  {
    label: '47545415',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΝΑΓΕΡΜΩΝ ΔΙΑΡΡΗΞΗΣ Η ΦΩΤΙΑΣ, ΑΚΟΥΣΤΙΚΗΣ Η ΟΠΤΙΚΗΣ ΣΗΜΑΤΟΔΟΤΗΣΗΣ',
  },
  {
    label: '47545416',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΘΕΡΜΑΝΣΗΣ ΚΛΕΙΣΤΩΝ ΧΩΡΩΝ ΚΑΙ ΕΔΑΦΟΥΣ',
  },
  {
    label: '47545417',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΘΕΡΜΙΚΩΝ ΣΥΣΚΕΥΩΝ ΚΟΜΜΩΤΙΚΗΣ Η ΣΤΕΓΝΩΤΗΡΩΝ ΧΕΡΙΩΝ, ΗΛΕΚΤΡΙΚΩΝ ΣΙΔΕΡΩΝ',
  },
  {
    label: '47545418',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΜΗΧΑΝΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ, ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΟ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '47545419',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΝΟΜΩΝ',
  },
  {
    label: '47545420',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΙΟΝΙΣΤΩΝ ΑΕΡΑ',
  },
  {
    label: '47545421',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΛΙΜΑΤΙΣΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '47545422',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΥΧΝΙΟΛΑΒΩΝ, ΓΙΑ ΤΑΣΗ >= 1000 ~ V',
  },
  {
    label: '47545423',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΟΥ ΗΛΕΚΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΗΛΕΚΤΡΙΚΩΝ ΜΕΡΩΝ ΜΗΧΑΝΗΜΑΤΩΝ Η ΣΥΣΚΕΥΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47545424',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '47545425',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΔΕΚΤΩΝ ΤΗΛΕΟΡΑΣΗΣ, ΡΑΔΙΟΦΩΝΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47545426',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΣΩΡΕΥΤΩΝ',
  },
  {
    label: '47545427',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΓΙΑ ΤΟ ΣΙΔΕΡΩΜΑ, ΤΟ ΠΡΕΣΑΡΙΣΜΑ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΠΡΕΣΩΝ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '47545428',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΡΙΣΤΙΚΩΝ ΚΑΙ ΚΟΥΡΕΥΤΙΚΩΝ ΜΗΧΑΝΩΝ, ΜΕ ΕΝΣΩΜΑΤΩΜΕΝΟ ΗΛΕΚΤΡΙΚΟ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '47545429',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΜΟΑΞΟΝΙΚΩΝ ΚΑΛΩΔΙΩΝ ΚΑΙ ΑΛΛΩΝ ΟΜΟΑΞΟΝΙΚΩΝ ΗΛΕΚΤΡΙΚΩΝ ΑΓΩΓΩΝ',
  },
  {
    label: '47545430',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΕΚΤΟΜΗΧΑΝΩΝ',
  },
  {
    label: '47545431',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΕΚΤΟΜΗΧΑΝΩΝ, ΡΑΠΤΟΜΗΧΑΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗΧΑΝΩΝ, ΜΗΧΑΝΩΝ ΚΑΤΑΣΚΕΥΗΣ ΘΥΣΑΝΩΝ',
  },
  {
    label: '47545432',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΥΝΤΗΡΙΩΝ ΠΙΑΤΩΝ, ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '47545433',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΥΝΤΗΡΙΩΝ ΡΟΥΧΩΝ ΚΑΙ ΣΤΕΓΝΩΤΗΡΙΩΝ ΡΟΥΧΩΝ, ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '47545434',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΑΠΤΟΜΗΧΑΝΩΝ ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '47545435',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΗΝ ΠΡΟΣΤΑΣΙΑ ΗΛΕΚΤΡΙΚΩΝ ΚΥΚΛΩΜΑΤΩΝ Π.Δ.Κ.Α., ΤΑΣΗΣ >= 1000 ~ V',
  },
  {
    label: '47545436',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΣΩΡΕΥΤΩΝ ΝΙΚΕΛΙΟΥ;ΚΑΔΜΙΟΥ ΚΑΙ ΝΙΚΕΛΙΟΥ;ΣΙΔΗΡΟΥ ΚΑΙ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΣΩΡΕΥΤΩΝ',
  },
  {
    label: '47545437',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΤΗΜΑΤΩΝ ΣΥΝΑΓΕΡΜΟΥ',
  },
  {
    label: '47545438',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΛΙΚΩΝ ΗΛΕΚΤΡΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ',
  },
  {
    label: '47545439',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΦΑΝΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '47545440',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΟΥΡΝΩΝ ΜΙΚΡΟΚΥΜΑΤΩΝ',
  },
  {
    label: '47545441',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΒΟΛΤΑΪΚΩΝ ΣΤΟΙΧΕΙΩΝ',
  },
  {
    label: '47545442',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΥΓΕΙΩΝ ΚΑΙ ΚΑΤΑΨΥΚΤΩΝ, ΟΙΚΙΑΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '47590000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΛΩΝ, ΦΩΤΙΣΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47595500',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΛΩΝ',
  },
  {
    label: '47595501',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΑΘΙΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47595502',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΝΩΝ ΚΑΘΡΕΠΤΩΝ',
  },
  {
    label: '47595503',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΛΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ ΚΑΙ ΕΠΙΠΛΩΝ ΑΠΟ ΑΛΛΑ ΥΛΙΚΑ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΟΥ ΤΟΥ ΚΑΛΑΜΙΟΥ, ΤΗΣ ΛΥΓΑΡΙΑΣ, ΤΟΥ ΜΠΑΜΠΟΥ Η ΠΑΡΟΜΟΙΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '47595504',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΛΩΝ ΚΟΥΖΙΝΑΣ',
  },
  {
    label: '47595505',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΘΩΡΑΚΙΣΜΕΝΩΝ Η ΕΝΙΣΧΥΜΕΝΩΝ ΘΗΣΑΥΡΟΦΥΛΑΚΙΩΝ, ΧΡΗΜΑΤΟΚΙΒΩΤΙΩΝ ΚΑΙ ΠΟΡΤΩΝ ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '47595506',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΙΣΜΑΤΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47595507',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΙΣΜΑΤΩΝ, ΚΥΡΙΩΣ ΜΕ ΜΕΤΑΛΛΙΚΟ ΣΚΕΛΕΤΟ',
  },
  {
    label: '47595508',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΘΙΣΜΑΤΩΝ, ΚΥΡΙΩΣ ΜΕ ΞΥΛΙΝΟ ΣΚΕΛΕΤΟ',
  },
  {
    label: '47595509',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΒΑΤΙΩΝ ΚΑΙ ΣΟΜΙΕΔΩΝ',
  },
  {
    label: '47595510',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΑΛΛΩΝ ΕΠΙΠΛΩΝ',
  },
  {
    label: '47595511',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΘΙΣΜΑΤΩΝ',
  },
  {
    label: '47595512',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΕΠΙΠΛΩΝ ΚΑΙ ΜΙΚΡΟΕΠΙΠΛΩΝ',
  },
  {
    label: '47595513',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΙΚΩΝ ΕΠΙΠΛΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47595514',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΛΛΙΚΩΝ ΕΠΙΠΛΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47595515',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47595516',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ, ΓΙΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47595517',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΕΠΙΠΛΩΝ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗΝ ΚΡΕΒΑΤΟΚΑΜΑΡΑ, ΣΤΗΝ ΤΡΑΠΕΖΑΡΙΑ ΚΑΙ ΣΤΟ ΚΑΘΙΣΤΙΚΟ',
  },
  {
    label: '47595518',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΕΚΤΩΝ ΕΠΙΠΛΩΝ',
  },
  {
    label: '47595519',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΡΤΩΝ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '47595520',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΤΗΡΙΓΜΑΤΩΝ ΣΤΡΩΜΑΤΩΝ',
  },
  {
    label: '47595521',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΩΜΑΤΩΝ',
  },
  {
    label: '47595522',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΩΜΑΤΩΝ ΜΕ ΜΕΤΑΛΛΙΚΟ ΕΞΟΠΛΙΣΜΟ (ΣΤΡΩΜΑΤΕΞ)',
  },
  {
    label: '47595523',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΡΗΜΑΤΟΚΙΒΩΤΙΩΝ',
  },
  {
    label: '47595600',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΙΣΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47595601',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΛΑΜΠΤΗΡΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '47595602',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΝΩΝ ΜΕΡΩΝ ΓΙΑ ΛΑΜΠΤΗΡΕΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΑ ΦΩΤΙΣΜΟΥ, ΦΩΤΕΙΝΩΝ ΣΗΜΑΤΩΝ, ΠΙΝΑΚΙΔΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47595603',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΜΑΤΩΝ ΓΙΑ ΛΑΜΠΤΗΡΕΣ Η ΛΥΧΝΙΕΣ ΕΚΚΕΝΩΣΗΣ, ΣΤΑΤΙΚΩΝ ΜΕΤΑΛΛΑΚΤΩΝ, ΑΛΛΩΝ ΕΠΑΓΩΓΕΩΝ',
  },
  {
    label: '47595604',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΛΑΜΠΤΗΡΩΝ ΤΡΑΠΕΖΙΟΥ, ΓΡΑΦΕΙΟΥ ΚΟΜΟΔΙΝΟΥ Η ΛΥΧΝΟΣΤΑΤΩΝ',
  },
  {
    label: '47595605',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΑΜΠΤΗΡΩΝ ΕΚΚΕΝΩΣΗΣ, ΛΑΜΠΤΗΡΩΝ ΥΠΕΡΙΩΔΩΝ Η ΥΠΕΡΥΘΡΩΝ ΑΚΤΙΝΩΝ, ΛΑΜΠΤΗΡΩΝ ΤΟΞΟΥ',
  },
  {
    label: '47595606',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ ΒΟΛΦΡΑΜΙΟΥ;ΑΛΟΓΟΝΟΥ (ΕΚΤΟΣ ΤΩΝ ΥΠΕΡΙΩΔΩΝ Η ΤΩΝ ΥΠΕΡΥΘΡΩΝ), ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '47595607',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΑΜΠΤΗΡΩΝ ΠΥΡΑΚΤΩΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '47595608',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΛΑΜΠΤΗΡΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '47595609',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΛΑΜΠΤΗΡΩΝ ΚΑΙ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '47595610',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΣΤΙΚΩΝ ΜΕΡΩΝ Π.Δ.Κ.Α., ΓΙΑ ΛΑΜΠΤΗΡΕΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΑ ΦΩΤΙΣΜΟΥ, ΦΩΤΕΙΝΕΣ ΠΙΝΑΚΙΔΕΣ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47595611',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΕΛΑΙΩΝ ΚΑΙ ΑΛΛΩΝ ΗΛΕΚΤΡΙΚΩΝ ΦΩΤΙΣΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΟΡΟΦΗΣ Η ΤΟΙΧΟΥ',
  },
  {
    label: '47595612',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΑΛΙΚΩΝ ΦΩΤΙΣΤΙΚΩΝ',
  },
  {
    label: '47595613',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΛΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΦΩΤΙΣΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47595614',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΟΡΗΤΩΝ ΗΛΕΚΤΡΙΚΩΝ ΛΑΜΠΤΗΡΩΝ, ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΞΗΡΕΣ ΣΤΗΛΕΣ, ΣΥΣΣΩΡΕΥΤΕΣ, ΔΥΝΑΜΟΗΛΕΚΤΡΟΜΑΓΝΗΤΙΚΕΣ ΣΥΣΚΕΥΕΣ',
  },
  {
    label: '47595615',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΕΙΝΩΝ ΠΙΝΑΚΙΔΩΝ, ΦΩΤΕΙΝΩΝ ΕΠΙΓΡΑΦΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47595616',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΙΣΤΙΚΩΝ ΔΙΑΤΑΞΕΩΝ ΤΩΝ ΤΥΠΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΑ ΧΡΙΣΤΟΥΓΕΝΝΙΑΤΙΚΑ ΔΕΝΤΡΑ',
  },
  {
    label: '47595700',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΕΙΔΩΝ, ΕΙΔΩΝ ΑΠΟ ΦΕΛΛΟ ΚΑΙ ΕΙΔΩΝ ΚΑΛΑΘΟΠΛΕΚΤΙΚΗΣ',
  },
  {
    label: '47595701',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΑΠΟ ΦΕΛΛΟ',
  },
  {
    label: '47595702',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΑΠΟ ΦΥΣΙΚΟ ΦΕΛΛΟ',
  },
  {
    label: '47595703',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ ΚΑΙ ΜΑΓΕΙΡΙΚΩΝ ΣΚΕΥΩΝ, ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '47595704',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ, ΣΤΕΛΕΧΩΝ ΕΡΓΑΛΕΙΩΝ, ΛΑΒΩΝ ΕΡΓΑΛΕΙΩΝ, ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '47595705',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΦΙΝΙΩΝ ΚΑΙ ΨΑΘΩΝ',
  },
  {
    label: '47595706',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΥΒΩΝ, ΠΛΑΚΩΝ, ΦΥΛΛΩΝ ΚΑΙ ΤΑΙΝΙΩΝ, ΠΛΑΚΙΔΙΩΝ ΚΑΘΕ ΣΧΗΜΑΤΟΣ, ΣΥΜΠΑΓΩΝ ΚΥΛΙΝΔΡΩΝ, ΑΠΟ ΣΥΣΣΩΜΑΤΩΜΕΝΟ ΦΕΛΛΟ',
  },
  {
    label: '47595707',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΠΟΙΗΜΕΝΩΝ ΕΙΔΩΝ ΑΠΟ ΑΧΥΡΟ, ΣΠΑΡΤΟ Η ΑΛΛΑ ΥΛΙΚΑ ΣΠΑΡΤΟΠΛΕΚΤΙΚΗΣ, ΕΙΔΩΝ ΚΑΛΑΘΟΠΟΙΙΑΣ ΚΑΙ ΨΑΘΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47595708',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΒΑΡΕΛΙΩΝ',
  },
  {
    label: '47595709',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΚΟΡΝΙΖΩΝ ΓΙΑ ΠΙΝΑΚΕΣ ΖΩΓΡΑΦΙΚΗΣ, ΦΩΤΟΓΡΑΦΙΕΣ, ΚΑΘΡΕΠΤΕΣ Η ΠΑΡΟΜΟΙΑ ΑΝΤΙΚΕΙΜΕΝΑ, ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '47595710',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΣΚΑΛΩΝ',
  },
  {
    label: '47595711',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΨΗΦΙΔΟΘΕΤΗΜΑΤΩΝ ΚΑΙ ΕΝΘΕΤΙΚΗΣ ΔΙΑΚΟΣΜΗΣΗΣ ΕΠΙΠΛΩΝ, ΘΗΚΩΝ ΓΙΑ ΚΟΣΜΗΜΑΤΑ Η ΜΑΧΑΙΡΟΠΙΡΟΥΝΑ, ΑΓΑΛΜΑΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΕΙΔΩΝ, ΑΠΟ ΞΥΛΕΙΑ',
  },
  {
    label: '47595712',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΙΝΑΚΩΝ ΚΑΙ ΕΚΚΛΗΣΙΑΣΤΙΚΩΝ ΕΙΚΟΝΩΝ ΑΠΟ ΞΥΛΟ, ΟΧΙ ΖΩΓΡΑΦΙΣΤΩΝ',
  },
  {
    label: '47595713',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΣΩΜΑΤΩΜΕΝΟΥ ΦΕΛΛΟΥ, ΕΙΔΩΝ ΑΠΟ ΣΥΣΣΩΜΑΤΩΜΕΝΟ ΦΕΛΛΟ Π.Δ.Κ.Α.',
  },
  {
    label: '47595714',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΛΕΙΜΜΑΤΩΝ ΦΕΛΛΟΥ',
  },
  {
    label: '47595715',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΟΥ ΦΕΛΛΟΥ, ΠΟΥ ΤΟΥ ΕΧΕΙ ΑΦΑΙΡΕΘΕΙ Η ΕΞΩΤΕΡΙΚΗ ΚΡΟΥΣΤΑ Η ΧΟΝΔΡΙΚΑ ΤΕΤΡΑΓΩΝΙΣΜΕΝΟΥ Η ΣΕ ΚΥΒΟΥΣ, ΠΛΑΚΕΣ, ΦΥΛΛΑ Η ΤΑΙΝΙΕΣ, ΦΕΛΛΟΥ ΣΕ ΘΡΑΥΣΜΑΤΑ, ΚΟΚΚΟΥΣ Η ΣΚΟΝΗ',
  },
  {
    label: '47595716',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΑΘΙΝΩΝ ΕΙΔΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47595800',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47595801',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΓΑΛΜΑΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47595802',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΓΑΛΜΑΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47595803',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47595804',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47595805',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ, ΓΙΑ ΑΕΡΙΑ ΚΑΥΣΙΜΑ Η ΓΙΑ ΑΕΡΙΑ ΚΑΙ ΓΙΑ ΑΛΛΑ ΚΑΥΣΙΜΑ, ΓΙΑ ΥΓΡΑ ΚΑΥΣΙΜΑ Η ΓΙΑ ΣΤΕΡΕΑ ΚΑΥΣΙΜΑ',
  },
  {
    label: '47595806',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΤΟΜΙΚΩΝ ΚΑΙ ΟΙΚΙΑΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΖΥΓΙΣΗΣ ΚΑΙ ΣΥΣΚΕΥΩΝ ΖΥΓΙΣΗΣ',
  },
  {
    label: '47595807',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΟΥΡΤΣΩΝ',
  },
  {
    label: '47595808',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΝΩΝ ΕΙΔΩΝ, ΕΠΙΤΡΑΠΕΖΙΩΝ Η ΜΑΓΕΙΡΙΚΩΝ, ΚΑΛΛΩΠΙΣΜΟΥ, ΓΡΑΦΕΙΟΥ, ΕΣΩΤΕΡΙΚΗΣ ΔΙΑΚΟΣΜΗΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ',
  },
  {
    label: '47595809',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΝΥΔΡΕΙΩΝ ΨΑΡΙΩΝ',
  },
  {
    label: '47595810',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΕΠΙΠΛΑ, ΑΜΑΞΩΜΑΤΑ Η ΠΑΡΟΜΟΙΑ ΕΙΔΗ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47595811',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΚΕΥΩΝ, ΜΑΓΕΙΡΙΚΩΝ ΣΚΕΥΩΝ, ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ ΑΠΟ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '47595812',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΚΕΥΩΝ, ΜΑΓΕΙΡΙΚΩΝ ΣΚΕΥΩΝ, ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ, (ΕΚΤΟΣ ΑΥΤΩΝ ΑΠΟ ΠΟΡΣΕΛΑΝΗ)',
  },
  {
    label: '47595813',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΚΕΥΩΝ, ΜΑΓΕΙΡΙΚΩΝ ΣΚΕΥΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47595814',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ, ΜΑΓΕΙΡΙΚΩΝ Η ΟΙΚΙΑΚΩΝ ΣΚΕΥΩΝ ΑΠΟ ΣΙΔΗΡΟ, ΧΑΛΥΒΑ, ΧΑΛΚΟ Η ΑΛΟΥΜΙΝΙΟ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '47595815',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΙΑΚΩΝ ΘΕΡΜΟΣΙΦΩΝΩΝ',
  },
  {
    label: '47595816',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΘΕΡΜΑΝΤΗΡΩΝ ΑΕΡΑ Η ΔΙΑΝΕΜΗΤΩΝ ΘΕΡΜΟΥ ΑΕΡΑ Π.Δ.Κ.Α. ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ, ΜΗ ΗΛΕΚΤΡΙΚΩΝ',
  },
  {
    label: '47595817',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΘΕΡΜΑΝΤΗΡΩΝ ΝΕΡΟΥ, ΣΤΙΓΜΙΑΙΩΝ Η ΘΕΡΜΟΣΥΣΣΩΡΕΥΣΗΣ, ΜΗ ΗΛΕΚΤΡΙΚΩΝ',
  },
  {
    label: '47595818',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΡΤΙΝΟΒΕΡΓΩΝ (ΞΥΛΙΝΩΝ, ΜΕΤΑΛΛΙΚΩΝ, ΠΛΑΣΤΙΚΩΝ ΚΛΠ)',
  },
  {
    label: '47595819',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΤΑΛΙΩΝ, ΠΙΡΟΥΝΙΩΝ, ΚΟΥΤΑΛΩΝ, ΤΡΥΠΗΤΩΝ ΚΟΥΤΑΛΩΝ, ΣΠΑΤΟΥΛΩΝ ΓΙΑ ΓΛΥΚΑ, ΜΑΧΑΙΡΙΩΝ ΓΙΑ ΨΑΡΙΑ ΚΑΙ ΓΙΑ ΒΟΥΤΥΡΟ, ΛΑΒΙΔΩΝ ΓΙΑ ΤΗ ΖΑΧΑΡΗ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΑΓΕΙΡΙΚΩΝ Η ΕΠΙΤΡΑΠΕΖΙΩΝ ΣΚΕΥΩΝ',
  },
  {
    label: '47595820',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΤΙΩΝ, ΘΗΚΩΝ, ΚΙΒΩΤΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47595821',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΧΑΙΡΙΩΝ (ΕΚΤΟΣ ΤΩΝ ΜΑΧΑΙΡΙΩΝ ΓΙΑ ΜΗΧΑΝΕΣ) ΚΑΙ ΨΑΛΙΔΙΩΝ, ΚΑΙ ΛΕΠΙΔΩΝ ΤΟΥΣ',
  },
  {
    label: '47595822',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΘΕΡΜΑΣΤΡΩΝ, ΚΟΥΖΙΝΩΝ, ΣΥΣΚΕΥΩΝ ΓΙΑ ΤΟ ΖΕΣΤΑΜΑ ΦΑΓΗΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '47595823',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΠΟΥΚΑΛΙΩΝ, ΠΛΑΤΥΣΤΟΜΩΝ ΔΟΧΕΙΩΝ, ΦΙΑΛΙΔΙΩΝ ΚΑΙ ΑΛΛΩΝ ΔΟΧΕΙΩΝ, ΑΠΟ ΓΥΑΛΙ ΕΚΤΟΣ ΑΠΟ ΑΜΠΟΥΛΕΣ, ΠΩΜΑΤΑ, ΚΑΛΥΜΜΑΤΑ ΚΑΙ ΑΛΛΑ ΕΙΔΗ ΚΛΕΙΣΙΜΑΤΟΣ, ΑΠΟ ΓΥΑΛΙ',
  },
  {
    label: '47595824',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΝΤΑΜΙΤΖΑΝΩΝ, ΜΠΟΥΚΑΛΙΩΝ, ΦΙΑΛΩΝ, ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47595825',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ ΑΠΟ ΓΥΑΛΙ, ΚΡΥΣΤΑΛΛΟ ΚΑΙ ΠΟΡΣΕΛΑΝΗ',
  },
  {
    label: '47595826',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ ΓΙΑ ΜΑΓΕΙΡΕΜΑ ΚΑΙ ΖΕΣΤΑΜΑ ΦΑΓΗΤΩΝ, ΑΠΟ ΣΙΔΗΡΟ Η ΧΑΛΥΒΑ Η ΑΠΟ ΧΑΛΚΟ, ΜΗ ΗΛΕΚΤΡΙΚΩΝ',
  },
  {
    label: '47595827',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΜΠΡΕΛΩΝ ΗΛΙΟΥ ΚΑΙ ΟΜΠΡΕΛΩΝ ΚΗΠΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47595828',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΗΛΙΝΩΝ ΑΓΓΕΙΩΝ ΓΕΝΙΚΑ, ΧΩΡΙΣ ΔΙΑΚΟΣΜΗΣΗ',
  },
  {
    label: '47595829',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΗΛΙΝΩΝ Η ΤΣΙΜΕΝΤΕΝΙΩΝ ΓΛΑΣΤΡΩΝ ΚΑΙ ΖΑΡΝΤΙΝΙΕΡΩΝ',
  },
  {
    label: '47595830',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΙΝΑΚΙΔΙΩΝ, ΠΙΝΑΚΙΩΝ, ΑΓΓΕΙΩΝ ΚΛΠ ΜΕ ΔΙΑΚΟΣΜΗΣΗ, ΑΠΟ ΚΕΡΑΜΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47595831',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΣΤΙΚΩΝ ΓΛΑΣΤΡΩΝ, ΖΑΡΝΤΙΝΙΕΡΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47595832',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΤΗΡΙΩΝ ΑΠΟ ΓΥΑΛΙ, ΕΚΤΟΣ ΑΠΟ ΥΑΛΟΚΕΡΑΜΙΚΑ ΥΛΙΚΑ',
  },
  {
    label: '47595833',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΑΚΩΝ ΚΑΙ ΤΣΑΝΤΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΧΩΝΙΑ), ΑΠΟ ΑΛΛΕΣ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ (ΕΚΤΟΣ ΤΟΥ ΑΙΘΥΛΕΝΙΟΥ)',
  },
  {
    label: '47595834',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΑΚΩΝ ΚΑΙ ΤΣΑΝΤΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΧΩΝΙΑ), ΑΠΟ ΠΟΛΥΜΕΡΗ ΤΟΥ ΑΙΘΥΛΕΝΙΟΥ',
  },
  {
    label: '47595835',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΑΡΩΘΡΩΝ ΓΙΑ ΟΙΚΙΑΚΗ ΚΑΘΑΡΙΟΤΗΤΑ',
  },
  {
    label: '47595836',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΚΑΛΩΝ ΑΠΟ ΣΙΔΗΡΟ Η ΑΛΟΥΜΙΝΙΟ',
  },
  {
    label: '47595837',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΚΟΥΠΩΝ ΚΑΙ ΒΟΥΡΤΣΩΝ ΓΙΑ ΤΗΝ ΟΙΚΙΑΚΗ ΚΑΘΑΡΙΟΤΗΤΑ',
  },
  {
    label: '47595838',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΥΓΡΑΕΡΙΟΥ ΟΙΚΙΑΚΗΣ ΧΡΗΣΕΩΣ (ΚΟΥΖΙΝΩΝ ~ ΠΛΥΝΤΗΡΙΩΝ ~ ΨΥΓΕΙΩΝ ΚΛΠ)',
  },
  {
    label: '47610000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΙΒΛΙΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47616100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΙΒΛΙΩΝ',
  },
  {
    label: '47616101',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΕΩΓΡΑΦΙΚΩΝ ΑΤΛΑΝΤΩΝ ΚΑΙ ΑΛΛΩΝ ΒΙΒΛΙΩΝ ΜΕ ΧΑΡΤΕΣ Η ΔΙΑΓΡΑΜΜΑΤΑ',
  },
  {
    label: '47616102',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΚΤΥΠΩΜΕΝΩΝ ΒΙΒΛΙΩΝ, ΦΥΛΛΑΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΚΑΙ ΠΑΡΟΜΟΙΟΥ ΕΝΤΥΠΟΥ ΥΛΙΚΟΥ, ΣΕ ΧΩΡΙΣΤΑ ΦΥΛΛΑ',
  },
  {
    label: '47616103',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΚΤΥΠΩΜΕΝΩΝ ΒΙΒΛΙΩΝ, ΦΥΛΛΑΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47616104',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΕΞΙΚΩΝ ΚΑΙ ΕΓΚΥΚΛΟΠΑΙΔΕΙΩΝ, ΚΑΘΩΣ ΚΑΙ ΤΕΥΧΩΝ ΤΟΥΣ',
  },
  {
    label: '47616105',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΩΝ ΚΑΙ ΥΔΡΟΓΡΑΦΙΚΩΝ Η ΠΑΡΟΜΟΙΩΝ ΔΙΑΓΡΑΜΜΑΤΩΝ, ΕΚΤΥΠΩΜΕΝΩΝ ΣΕ ΑΛΛΗ ΜΟΡΦΗ ΕΚΤΟΣ ΑΠΟ ΒΙΒΛΙΑ ΚΑΙ ΥΔΡΟΓΕΙΩΝ ΣΦΑΙΡΩΝ',
  },
  {
    label: '47620000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΦΗΜΕΡΙΔΩΝ ΚΑΙ ΓΡΑΦΙΚΗΣ ΥΛΗΣ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47626200',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΦΗΜΕΡΙΔΩΝ ΚΑΙ ΠΕΡΙΟΔΙΚΩΝ',
  },
  {
    label: '47626201',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΜΠΟΡΙΚΟΥ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΥΛΙΚΟΥ, ΕΜΠΟΡΙΚΩΝ ΚΑΤΑΛΟΓΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47626202',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΦΗΜΕΡΙΔΩΝ ΚΑΙ ΠΕΡΙΟΔΙΚΩΝ, ΕΚΤΟΣ ΑΠΟ ΠΡΑΚΤΟΡΕΙΟ',
  },
  {
    label: '47626203',
    value: 'ΠΡΑΚΤΟΡΕΙΟ ΕΦΗΜΕΡΙΔΩΝ, ΠΕΡΙΟΔΙΚΩΝ ΚΑΙ ΚΑΘΕ ΦΥΣΕΩΣ ΕΝΤΥΠΩΝ',
  },
  {
    label: '47626300',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47626301',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΟΥ ΕΝΤΥΠΟΥ ΥΛΙΚΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '47626302',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΓΡΑΦΗ, ΕΚΤΥΠΩΣΗ Η ΑΛΛΟΥΣ ΓΡΑΦΙΚΟΥΣ ΣΚΟΠΟΥΣ, ΤΥΠΩΜΕΝΟΥ, ΑΝΑΓΛΥΦΟΥ Η ΔΙΑΤΡΗΤΟΥ',
  },
  {
    label: '47626303',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΟΥ ΧΑΡΤΙΟΥ, ΧΑΡΤΟΝΙΟΥ, ΧΑΡΤΟΒΑΜΒΑΚΑ ΚΑΙ ΡΟΛΩΝ ΑΠΟ ΜΑΛΑΚΗ ΚΥΤΤΑΡΙΝΗ',
  },
  {
    label: '47626304',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΧΑΡΤΙΩΝ ΚΑΙ ΧΑΡΤΟΝΙΩΝ',
  },
  {
    label: '47626305',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΤΥΠΩΤΙΚΟΥ ΧΑΡΤΙΟΥ (ΚΑΡΜΠΟΝ), ΑΥΤΟΑΝΤΙΓΡΑΦΙΚΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΑΛΛΩΝ ΧΑΡΤΙΩΝ ΓΙΑ ΑΝΤΙΓΡΑΦΗ Η ΜΕΤΑΦΟΡΑ ΚΕΙΜΕΝΩΝ, ΧΑΡΤΙΟΥ ΜΕ ΓΟΜΑ Η ΑΥΤΟΚΟΛΛΗΤΟΥ, ΜΕΜΒΡΑΝΩΝ ΠΟΛΥΓΡΑΦΩΝ ΚΑΙ ΠΛΑΚΩΝ ΟΦΣΕΤ, ΑΠΟ ΧΑΡΤΙ, ΣΕ ΚΥΛΙΝΔΡΟΥΣ Η ΣΕ ΦΥΛΛΑ',
  },
  {
    label: '47626306',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΥΤΟΚΟΛΛΗΤΩΝ ΤΑΙΝΙΩΝ, ΠΛΑΚΩΝ, ΛΩΡΙΔΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ, ΣΕ ΡΟΛΑ ΚΑΙ ΑΛΛΕΣ ΕΠΙΠΕΔΕΣ ΜΟΡΦΕΣ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΠΛΑΤΟΥΣ >= 20 ~ CM',
  },
  {
    label: '47626307',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΙΒΛΙΩΝ ΜΗΤΡΩΩΝ, ΛΟΓΙΣΤΙΚΩΝ ΒΙΒΛΙΩΝ, ΚΛΑΣΕΡ, ΕΝΤΥΠΩΝ ΠΡΟΣ ΣΥΜΠΛΗΡΩΣΗ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΓΡΑΦΙΚΗΣ ΥΛΗΣ, ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '47626308',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΟΜΟΛΑΣΤΙΧΩΝ ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ',
  },
  {
    label: '47626309',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΣΚΩΝ, ΠΙΑΤΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΦΛΙΤΖΑΝΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '47626310',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΚΟΝΩΝ, ΣΧΕΔΙΩΝ ΚΑΙ ΦΩΤΟΓΡΑΦΙΩΝ',
  },
  {
    label: '47626311',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΚΤΥΠΩΜΕΝΩΝ Η ΕΙΚΟΝΟΓΡΑΦΗΜΕΝΩΝ ΤΑΧΥΔΡΟΜΙΚΩΝ ΚΑΡΤΩΝ, ΕΚΤΥΠΩΜΕΝΩΝ ΜΕ ΕΥΧΕΣ ΚΛΠ',
  },
  {
    label: '47626312',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΝΤΟΣΙΕ ΚΙΝΗΤΩΝ ΦΥΛΛΩΝ Η ΧΑΡΤΟΦΥΛΑΚΩΝ ΤΑΞΙΝΟΜΗΣΗΣ ΕΓΓΡΑΦΩΝ, ΕΙΔΩΝ ΓΡΑΦΕΙΟΥ ΚΑΙ ΣΥΝΔΕΤΗΡΩΝ ΣΥΡΡΑΦΗΣ ΣΕ ΠΛΑΚΕΤΕΣ, ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '47626313',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΤΙΚΕΤΩΝ ΑΠΟ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '47626314',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΦΟΔΙΩΝ ΓΡΑΦΕΙΟΥ Η ΣΧΟΛΙΚΩΝ ΕΦΟΔΙΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47626315',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΛΛΩΝ, ΓΙΑ ΤΟ ΣΧΟΛΕΙΟ ΚΑΙ ΤΟ ΓΡΑΦΕΙΟ',
  },
  {
    label: '47626316',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΤΙΩΝ ΤΑΞΙΝΟΜΗΣΗΣ ΕΓΓΡΑΦΩΝ, ΕΠΙΣΤΟΛΟΘΗΚΩΝ, ΚΟΥΤΙΩΝ ΑΡΧΕΙΟΘΕΤΗΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΓΡΑΦΕΙΑ, ΚΑΤΑΣΤΗΜΑΤΑ ΚΛΠ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '47626317',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΛΑΝΗΣ ΓΡΑΦΗΣ Η ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΑΛΛΩΝ ΜΕΛΑΝΙΩΝ',
  },
  {
    label: '47626318',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΛΑΝΙΩΝ, ΜΕ ΑΝΑΓΟΜΩΣΗ ΦΥΣΙΓΓΙΩΝ (CARTRIDGES) ΕΚΤΥΠΩΤΩΝ',
  },
  {
    label: '47626319',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΙΚΡΟΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΟΥ ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '47626320',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΛΥΒΙΩΝ, ΚΡΑΓΙΟΝΙΩΝ, ΛΕΠΤΩΝ ΡΑΒΔΩΝ ΓΡΑΦΙΤΗ ΓΙΑ ΜΟΛΥΒΙΑ, ΚΡΗΤΙΔΩΝ (ΠΑΣΤΕΛ), ΚΑΡΒΟΥΝΩΝ ΣΧΕΔΙΑΣΗΣ, ΚΙΜΩΛΙΩΝ ΓΡΑΦΗΣ Η ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΚΙΜΩΛΙΩΝ ΡΑΠΤΙΚΗΣ',
  },
  {
    label: '47626321',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΝΩΝ ΓΙΑ ΣΙΝΙΚΗ ΜΕΛΑΝΗ, ΣΤΥΛΟΓΡΑΦΩΝ ΜΕΛΑΝΗΣ, ΑΛΛΩΝ ΣΤΥΛΟΓΡΑΦΩΝ ΚΑΙ ΑΛΛΩΝ ΠΕΝΩΝ',
  },
  {
    label: '47626322',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΓΑΜΗΝΟΕΙΔΟΥΣ ΧΑΡΤΙΟΥ, ΑΔΙΑΒΡΟΧΟΥ ΧΑΡΤΙΟΥ (ΛΑΔΟΧΑΡΤΟΥ), ΔΙΑΦΑΝΟΥΣ ΧΑΡΤΙΟΥ ΑΝΤΙΓΡΑΦΗΣ ΚΑΙ ΧΑΡΤΙΟΥ ΓΚΛΑΣΕ ΚΑΙ ΑΛΛΩΝ ΣΤΙΛΠΝΩΝ ΔΙΑΦΑΝΩΝ Η ΗΜΙΔΙΑΦΑΝΩΝ ΧΑΡΤΙΩΝ',
  },
  {
    label: '47626323',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΚΩΝ ΚΑΙ ΠΙΝΑΚΩΝ, ΣΦΡΑΓΙΔΩΝ ΑΝΑΓΡΑΦΗΣ ΗΜΕΡΟΜΗΝΙΩΝ, ΣΦΡΑΓΙΣΗΣ Η ΑΡΙΘΜΗΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΧΡΗΣΕΩΝ, ΜΕΛΑΝΟΤΑΙΝΙΩΝ ΓΡΑΦΟΜΗΧΑΝΩΝ Η ΠΑΡΟΜΟΙΩΝ ΤΑΙΝΙΩΝ ΚΑΙ ΤΑΜΠΟΝ ΜΕΛΑΝΗΣ',
  },
  {
    label: '47626324',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΤΥΣΣΟΜΕΝΩΝ ΧΑΡΤΟΚΙΒΩΤΙΩΝ, ΚΟΥΤΙΩΝ ΚΑΙ ΚΑΣΩΝ ΑΠΟ ΜΗ ΚΥΜΑΤΟΕΙΔΕΣ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '47626325',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΑΚΩΝ ΚΑΙ ΤΣΑΝΤΩΝ ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '47626326',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΤΥΛΟΓΡΑΦΩΝ ΜΕ ΣΦΑΙΡΙΔΙΟ, ΣΤΥΛΟΓΡΑΦΩΝ ΚΑΙ ΜΑΡΚΑΔΟΡΩΝ ΜΕ ΜΥΤΗ ΑΠΟ ΠΙΛΗΜΑ (ΤΣΟΧΑ) Η ΑΛΛΟ ΠΟΡΩΔΕΣ ΥΛΙΚΟ, ΜΗΧΑΝΙΚΩΝ Η ΚΙΝΗΤΩΝ ΜΟΛΥΒΙΩΝ',
  },
  {
    label: '47626327',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΛΛΟΓΩΝ ΕΡΓΑΛΕΙΩΝ ΓΡΑΦΗΣ, ΚΟΝΔΥΛΟΦΟΡΩΝ ΚΑΙ ΘΗΚΩΝ ΜΟΛΥΒΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΘΗΚΩΝ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '47626328',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΝΘΕΤΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΜΗ ΕΠΙΧΡΙΣΜΕΝΟΥ ΕΠΙΦΑΝΕΙΑΚΑ Η',
  },
  {
    label: '47626329',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΦΡΑΓΙΔΩΝ, ΕΠΙΓΡΑΦΩΝ, ΣΗΜΑΤΩΝ ΚΛΠ ΑΠΟ ΚΑΟΥΤΣΟΥΚ Η ΜΕΤΑΛΛΟ',
  },
  {
    label: '47626330',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΑΚΕΛΩΝ, ΕΠΙΣΤΟΛΙΚΩΝ ΔΕΛΤΑΡΙΩΝ, ΤΑΧΥΔΡΟΜΙΚΩΝ ΔΕΛΤΑΡΙΩΝ, ΑΠΟ ΧΑΡΤΙ Η ΚΟΥΤΙΩΝ ΑΠΟ ΧΑΡΤΟΝΙ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΓΡΑΦΙΚΗ ΥΛΗ',
  },
  {
    label: '47626331',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΛΚΟΜΑΝΙΩΝ ΚΑΙ ΕΚΤΥΠΩΜΕΝΩΝ ΗΜΕΡΟΛΟΓΙΩΝ',
  },
  {
    label: '47626332',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΑΚΩΝ',
  },
  {
    label: '47626333',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΓΡΑΦΗ, ΕΚΤΥΠΩΣΗ Η ΑΛΛΟΥΣ ΓΡΑΦΙΚΟΥΣ ΣΚΟΠΟΥΣ, ΕΠΙΧΡΙΣΜΕΝΟΥ ΜΕ ΚΑΟΛΙΝΗ Η ΜΕ ΑΛΛΕΣ ΑΝΟΡΓΑΝΕΣ ΟΥΣΙΕΣ',
  },
  {
    label: '47626334',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΤΥΠΟΥ ΠΑΠΙΕ ΓΚΟΦΡΕ, ΚΥΜΑΤΟΕΙΔΟΥΣ ΚΑΙ ΑΝΑΓΛΥΦΟΥ Η ΔΙΑΤΡΗΤΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '47626335',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ, ΧΑΡΤΟΝΙΟΥ, ΧΑΡΤΟΒΑΜΒΑΚΑ ΚΑΙ ΡΟΛΩΝ ΑΠΟ ΙΝΕΣ ΚΥΤΤΑΡΙΝΗΣ, ΕΠΙΧΡΙΣΜΕΝΩΝ, ΕΜΠΟΤΙΣΜΕΝΩΝ, ΕΠΕΝΔΥΜΕΝΩΝ, ΜΕ ΕΓΧΡΩΜΗ Η ΤΥΠΩΜΕΝΗ ΕΠΙΦΑΝΕΙΑ, ΣΕ ΚΥΛΙΝΔΡΟΥΣ Η ΣΕ ΦΥΛΛΑ',
  },
  {
    label: '47626336',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΟΚΙΒΩΤΙΩΝ, ΚΟΥΤΙΩΝ ΚΑΙ ΚΑΣΩΝ, ΑΠΟ ΚΥΜΑΤΟΕΙΔΕΣ ΧΑΡΤΙ Η ΧΑΡΤΟΝΙ',
  },
  {
    label: '47626337',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΟΚΟΠΤΩΝ, ΜΑΧΑΙΡΙΩΝ ΓΙΑ ΤΟ ΑΝΟΙΓΜΑ ΓΡΑΜΜΑΤΩΝ, ΜΑΧΑΙΡΙΩΝ ΣΒΗΣΤΗΡΩΝ, ΞΥΣΤΡΩΝ ΚΛΠ',
  },
  {
    label: '47626338',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΕΙΡΟΠΟΙΗΤΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ',
  },
  {
    label: '47626339',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΟΝΔΡΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ, ΕΚΤΟΣ ΑΠΟ ΤΟ ΕΙΔΟΣ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΕΙΤΑΙ ΓΙΑ ΓΡΑΦΗ, ΕΚΤΥΠΩΣΗ Η ΑΛΛΟΥΣ ΓΡΑΦΙΚΟΥΣ ΣΚΟΠΟΥΣ, ΕΠΙΧΡΙΣΜΕΝΟΥ ΜΕ ΚΑΟΛΙΝΗ Η ΜΕ ΑΛΛΕΣ ΑΝΟΡΓΑΝΕΣ ΟΥΣΙΕΣ',
  },
  {
    label: '47626340',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΡΩΜΑΤΩΝ ΚΑΛΛΙΤΕΧΝΩΝ, ΣΠΟΥΔΑΣΤΩΝ Η ΖΩΓΡΑΦΩΝ, ΕΠΙΓΡΑΦΩΝ, ΧΡΩΜΑΤΩΝ ΑΛΛΑΓΗΣ ΤΩΝ ΑΠΟΧΡΩΣΕΩΝ, ΧΡΩΜΑΤΩΝ ΑΝΑΨΥΧΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47630000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΓΓΡΑΦΩΝ ΜΟΥΣΙΚΗΣ ΚΑΙ ΕΙΚΟΝΑΣ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47636400',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΓΓΡΑΦΩΝ ΜΟΥΣΙΚΗΣ ΚΑΙ ΒΙΝΤΕΟ',
  },
  {
    label: '47636401',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΓΡΑΦΩΝ ΔΙΣΚΩΝ, ΚΑΣΕΤΩΝ ΚΑΙ ΟΠΤΙΚΩΝ ΔΙΣΚΩΝ (CDS, DVDS ΚΛΠ)',
  },
  {
    label: '47636402',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΙΝΤΕΟΚΑΣΕΤΩΝ ΚΑΙ ΚΑΣΕΤΩΝ ΜΑΓΝΗΤΟΦΩΝΟΥ',
  },
  {
    label: '47636403',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΙΝΤΕΟΤΑΙΝΙΩΝ',
  },
  {
    label: '47636404',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΣΚΩΝ ΚΑΙ ΚΑΣΕΤΩΝ ΔΙΔΑΣΚΑΛΙΑΣ ΞΕΝΩΝ ΓΛΩΣΣΩΝ',
  },
  {
    label: '47636405',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΓΓΕΓΡΑΜΜΕΝΩΝ ΜΟΥΣΙΚΩΝ ΔΙΣΚΩΝ, ΟΠΤΙΚΩΝ ΔΙΣΚΩΝ (CDS, DVDS ΚΛΠ) ΚΑΙ ΚΑΣΕΤΩΝ',
  },
  {
    label: '47636406',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΓΝΗΤΙΚΩΝ ΤΑΙΝΙΩΝ ΕΓΓΡΑΦΗΣ ΗΧΟΥ',
  },
  {
    label: '47636407',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΓΝΗΤΙΚΩΝ ΤΑΙΝΙΩΝ ΜΕ ΠΕΡΙΕΧΟΜΕΝΟ ΗΧΟ ΚΑΙ ΕΙΚΟΝΑ',
  },
  {
    label: '47636408',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΑΓΡΑΦΩΝ ΒΙΝΤΕΟΚΑΣΕΤΩΝ ΚΑΙ ΚΑΣΕΤΩΝ ΜΑΓΝΗΤΟΦΩΝΟΥ',
  },
  {
    label: '47636409',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΑΓΡΑΦΩΝ ΜΕΣΩΝ ΓΙΑ ΗΧΟΓΡΑΦΗΣΕΙΣ Η ΠΑΡΟΜΟΙΕΣ ΕΓΓΡΑΦΕΣ ΑΛΛΩΝ ΦΑΙΝΟΜΕΝΩΝ, (ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΕΣ ΤΑΙΝΙΕΣ)',
  },
  {
    label: '47640000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΘΛΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47646500',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΘΛΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '47646501',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΔΙΑΒΡΟΧΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΜΕ ΕΞΩΤΕΡΙΚΕΣ ΣΟΛΕΣ ΚΑΙ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΚΑΟΥΤΣΟΥΚ Η ΠΛΑΣΤΙΚΟ, ΓΙΑ ΣΠΟΡ',
  },
  {
    label: '47646502',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΕΡΟΣΤΑΤΩΝ, ΠΗΔΑΛΙΟΥΧΟΥΜΕΝΩΝ ΚΑΙ ΑΛΛΩΝ ΜΗ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΑΕΡΟΣΚΑΦΩΝ',
  },
  {
    label: '47646503',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΘΛΗΤΙΚΩΝ ΕΙΔΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47646504',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΘΛΗΤΙΚΩΝ ΡΟΥΧΩΝ, ΣΤΟΛΩΝ ΣΚΙ ΚΑΙ ΜΑΓΙΟ ΚΟΛΥΜΒΗΣΗΣ ΚΑΙ ΑΛΛΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '47646505',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΕΞΙΠΤΩΤΩΝ, (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΠΗΔΑΛΙΟΥΧΟΥΜΕΝΑ ΑΛΕΞΙΠΤΩΤΑ) ΚΑΙ ΣΤΡΟΦΟΠΤΩΤΩΝ ΚΑΙ ΤΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '47646506',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΘΛΗΤΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΕΚΤΟΣ ΑΠΟ ΜΠΟΤΕΣ ΤΟΥ ΠΑΤΙΝΑΖ',
  },
  {
    label: '47646507',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΑΘΛΗΤΙΣΜΟ Η ΓΙΑ ΥΠΑΙΘΡΙΟΥΣ ΑΓΩΝΕΣ, ΚΟΛΥΜΒΗΤΙΚΩΝ ΔΕΞΑΜΕΝΩΝ ΚΑΙ ΔΕΞΑΜΕΝΩΝ ΚΩΠΗΛΑΣΙΑΣ',
  },
  {
    label: '47646508',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΣΚΑΦΩΝ ΓΙΑ ΑΝΑΨΥΧΗ Η ΑΘΛΗΤΙΣΜΟ, ΚΩΠΗΛΑΤΩΝ ΒΑΡΚΩΝ ΚΑΙ ΚΑΝΟ',
  },
  {
    label: '47646509',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΥΣΙΔΩΝ ΓΙΑ ΠΟΔΗΛΑΤΑ',
  },
  {
    label: '47646510',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΠΝΕΥΣΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΔΥΤΩΝ',
  },
  {
    label: '47646511',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΕΜΟΠΤΕΡΩΝ ΚΑΙ ΑΙΩΡΟΠΛΑΝΩΝ',
  },
  {
    label: '47646512',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΟΜΒΩΝ, ΒΛΗΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΟΛΕΜΟΦΟΔΙΩΝ, ΦΥΣΙΓΓΙΩΝ, ΑΛΛΩΝ ΠΥΡΟΜΑΧΙΚΩΝ ΚΑΙ ΒΛΗΜΑΤΩΝ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ, ΓΙΑ ΚΥΝΗΓΙ Η ΑΘΛΗΤΙΣΜΟ',
  },
  {
    label: '47646513',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΙΝΩΝ ΣΥΝΟΛΩΝ ΓΙΑ ΜΟΤΟΣΙΚΛΕΤΕΣ',
  },
  {
    label: '47646514',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΧΤΥΩΝ ΓΙΑ ΑΘΛΗΤΙΣΜΟ',
  },
  {
    label: '47646515',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΑΛΙΕΙΑΣ ΓΕΝΙΚΑ',
  },
  {
    label: '47646516',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΥΜΝΑΣΤΙΚΗΣ Η ΑΘΛΗΤΙΣΜΟΥ',
  },
  {
    label: '47646517',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΠΟΒΡΥΧΙΑΣ ΑΛΙΕΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47646518',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΛΙΚΩΝ ΠΛΟΙΩΝ ΚΑΙ ΤΩΝ ΠΤΕΡΥΓΙΩΝ ΤΟΥΣ',
  },
  {
    label: '47646519',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΘΑΛΑΣΣΗΣ (ΒΑΤΡΑΧΟΠΕΔΙΛΩΝ, ΜΑΣΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ',
  },
  {
    label: '47646520',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΩΛΕΜΒΙΩΝ ΚΙΝΗΤΗΡΩΝ ΓΙΑ ΠΡΟΩΘΗΣΗ',
  },
  {
    label: '47646521',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΣΩΤΡΩΝ (ΕΛΑΣΤΙΚΩΝ ΟΧΗΜΑΤΩΝ) ΚΑΙ ΑΕΡΟΘΑΛΑΜΩΝ ΓΙΑ ΠΟΔΗΛΑΤΑ',
  },
  {
    label: '47646522',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΙΣΤΙΟΦΟΡΩΝ ΓΙΑ ΑΝΑΨΥΧΗ Η ΑΘΛΗΤΙΣΜΟ',
  },
  {
    label: '47646523',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΑΜΙΩΝ ΨΑΡΕΜΑΤΟΣ, ΑΛΛΩΝ ΣΥΝΕΡΓΩΝ ΨΑΡΕΜΑΤΟΣ ΜΕ ΠΕΤΟΝΙΑ, ΕΙΔΩΝ ΚΥΝΗΓΙΟΥ Η ΨΑΡΕΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '47646524',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΤΗΡΩΝ ΓΙΑ ΘΑΛΑΣΣΙΑ ΠΡΟΩΘΗΣΗ ΚΑΙ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΤΟΥΣ',
  },
  {
    label: '47646525',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΑΝΩΝ ΓΙΑ ΠΟΔΗΛΑΤΑ',
  },
  {
    label: '47646526',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΚΕΤΩΝ ΓΙΑ ΠΟΔΗΛΑΤΑ',
  },
  {
    label: '47646527',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΣΤΙΓΙΩΝ, ΜΑΣΤΙΓΙΩΝ ΙΠΠΑΣΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47646528',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΠΟΔΗΛΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΤΡΟΧΩΝ, ΧΩΡΙΣ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '47646529',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΠΑΛΟΝΙΩΝ',
  },
  {
    label: '47646530',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΠΟΤΩΝ ΤΟΥ ΣΚΙ ΚΑΙ ΥΠΟΔΗΜΑΤΩΝ ΧΙΟΝΟΠΟΡΕΙΑΣ',
  },
  {
    label: '47646531',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΝΑΥΤΙΛΙΑΚΩΝ ΕΙΔΩΝ ΓΕΝΙΚΑ, ΑΠΟ ΑΥΤΑ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΚΑΙ ΣΤΗΝ ΕΡΑΣΙΤΕΧΝΙΚΗ ΝΑΥΤΙΛΙΑ',
  },
  {
    label: '47646532',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΙΦΩΝ, ΣΠΑΘΙΩΝ, ΞΙΦΟΛΟΓΧΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΟΠΛΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '47646533',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ Η ΠΛΑΣΤΙΚΩΝ ΛΕΜΒΩΝ',
  },
  {
    label: '47646534',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΠΛΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΚΥΝΗΓΙΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47646535',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΠΛΩΝ ΚΑΙ ΦΥΣΙΓΓΙΩΝ ΚΥΝΗΓΙΟΥ',
  },
  {
    label: '47646536',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΩΝ ΓΥΜΝΑΣΤΙΚΗΣ',
  },
  {
    label: '47646537',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΔΙΛΩΝ ΓΙΑ ΘΑΛΑΣΣΙΟ ΣΚΙ, ΚΥΜΑΤΟΣΑΝΙΔΩΝ, ΙΣΤΙΟΣΑΝΙΔΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΝΑΥΤΙΚΑ ΑΘΛΗΜΑΤΑ',
  },
  {
    label: '47646538',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΣΤΙΚΩΝ ΕΝΔΥΜΑΤΩΝ, ΟΠΩΣ ΔΥΤΩΝ',
  },
  {
    label: '47646539',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΔΗΛΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΔΙΤΡΟΧΩΝ, ΧΩΡΙΣ ΚΙΝΗΤΗΡΑ',
  },
  {
    label: '47646540',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΔΗΛΑΤΩΝ, ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΤΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '47646541',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΟΒΟΛΩΝ ΟΠΛΩΝ ΠΟΥ ΟΠΛΙΖΟΝΤΑΙ ΑΠΟ ΤΗΝ ΚΑΝΝΗ, ΤΟΥΦΕΚΙΩΝ ΑΘΛΗΣΗΣ, ΚΥΝΗΓΙΟΥ Η ΣΚΟΠΟΒΟΛΗΣ',
  },
  {
    label: '47646542',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΟΛΟΓΙΩΝ ΓΙΑ ΤΟΥΣ ΠΙΝΑΚΕΣ ΤΩΝ ΟΡΓΑΝΩΝ ΕΛΕΓΧΟΥ ΚΑΙ ΡΟΛΟΓΙΩΝ ΠΑΡΟΜΟΙΟΥ ΤΥΠΟΥ ΓΙΑ ΠΛΟΙΑ ΚΑΙ ΑΕΡΟΣΚΑΦΗ (ΚΑΙ ΓΙΑ ΑΘΛΗΤΙΚΕΣ ΧΡΗΣΕΙΣ)',
  },
  {
    label: '47646543',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΡΑΝΤΑΡ, ΡΑΔΙΟΝΑΥΣΙΠΛΟΪΑΣ ΚΑΙ ΡΑΔΙΟΤΗΛΕΧΕΙΡΙΣΜΟΥ, ΣΥΣΚΕΥΩΝ GPS',
  },
  {
    label: '47646544',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΧΟΙΝΙΩΝ Η ΚΟΡΔΟΝΙΩΝ ΓΙΑ ΑΘΛΗΤΙΣΜΟ',
  },
  {
    label: '47646545',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΩΣΙΒΙΩΝ ΧΙΤΩΝΩΝ ΚΑΙ ΣΩΣΙΒΙΩΝ',
  },
  {
    label: '47646546',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΓΡΟΥ ΚΑΙ ΠΕΠΙΕΣΜΕΝΟΥ ΑΕΡΑ, ΓΙΑ ΑΘΛΗΤΙΣΜΟ',
  },
  {
    label: '47646547',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΔΡΟΓΟΝΟΥ, ΑΡΓΟΥ, ΣΠΑΝΙΩΝ ΑΕΡΙΩΝ, ΑΖΩΤΟΥ ΚΑΙ ΟΞΥΓΟΝΟΥ, ΓΙΑ ΑΘΛΗΤΙΣΜΟ',
  },
  {
    label: '47646548',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ ΠΡΟΠΟΝΗΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΠΟΔΗΜΑΤΩΝ ΜΕ ΕΛΑΣΤΙΚΕΣ Η ΠΛΑΣΤΙΚΕΣ ΣΟΛΕΣ ΚΑΙ ΜΕ ΥΦΑΣΜΑΤΙΝΑ ΕΠΑΝΩ ΜΕΡΗ',
  },
  {
    label: '47646549',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΟΥΣΚΩΤΩΝ ΣΚΑΦΩΝ ΓΙΑ ΑΝΑΨΥΧΗ Η ΑΘΛΗΤΙΣΜΟ',
  },
  {
    label: '47646550',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΙΟΝΟΠΕΔΙΛΩΝ ΚΑΙ ΑΛΛΟΥ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΧΙΟΝΟΠΕΔΙΛΑ, ΠΑΓΟΠΕΔΙΛΑ ΚΑΙ ΤΡΟΧΟΠΕΔΙΛΑ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '47646600',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΚΑΤΑΣΚΗΝΩΣΗΣ',
  },
  {
    label: '47646601',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΙΣΤΙΩΝ ΓΙΑ ΣΚΑΦΗ, ΙΣΤΙΟΣΑΝΙΔΩΝ Η ΙΣΤΙΟΦΟΡΩΝ ΟΧΗΜΑΤΩΝ, ΑΛΛΩΝ ΣΚΗΝΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΤΑΣΚΗΝΩΣΗΣ',
  },
  {
    label: '47646602',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΝΟΣΑΚΩΝ',
  },
  {
    label: '47650000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΧΝΙΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47656700',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΧΝΙΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '47656701',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΑΙΧΝΙΔΙΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47656702',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΜΙΜΗΣΕΩΝ ΧΡΙΣΤΟΥΓΕΝΝΙΑΤΙΚΩΝ ΔΕΝΤΡΩΝ',
  },
  {
    label: '47656703',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΕΓΓΑΛΙΚΩΝ, ΦΩΤΟΒΟΛΙΔΩΝ, ΒΑΡΕΛΟΤΩΝ ΚΑΙ ΑΛΛΩΝ ΠΥΡΟΤΕΧΝΙΚΩΝ ΕΙΔΩΝ (ΕΞΑΙΡΟΥΜΕΝΩΝ ΤΩΝ ΠΥΡΟΤΕΧΝΗΜΑΤΩΝ)',
  },
  {
    label: '47656704',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΓΙΑ ΣΦΑΙΡΙΣΤΗΡΙΑ, ΓΙΑ ΛΟΥΝΑ ΠΑΡΚ, ΓΙΑ ΕΠΙΤΡΑΠΕΖΙΑ ΠΑΙΧΝΙΔΙΑ Η ΓΙΑ ΠΑΙΧΝΙΔΙΑ ΣΥΝΑΝΑΣΤΡΟΦΗΣ Η ΠΑΙΧΝΙΔΙΩΝ ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΝΟΜΙΣΜΑΤΟΔΕΚΤΗ Η ΜΕ ΔΙΣΚΕΤΑ',
  },
  {
    label: '47656705',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΜΟΝΤΕΛΙΣΜΟΥ',
  },
  {
    label: '47656706',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΟΡΤΑΣΤΙΚΩΝ ΕΙΔΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47656707',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΟΡΤΑΣΤΙΚΩΝ, ΑΠΟΚΡΙΑΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΨΥΧΑΓΩΓΙΚΩΝ ΕΙΔΩΝ, ΣΤΑ ΟΠΟΙΑ ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΤΑ ΤΑΧΥΔΑΚΤΥΛΟΥΡΓΙΚΑ ΤΕΧΝΑΣΜΑΤΑ (ΤΡΙΚ) ΚΑΙ ΤΑ ΕΙΔΗ;ΕΚΠΛΗΞΕΙΣ',
  },
  {
    label: '47656708',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΚΛΩΝ ΠΟΥ ΑΝΑΠΑΡΙΣΤΟΥΝ ΜΟΝΟ ΑΝΘΡΩΠΙΝΕΣ ΥΠΑΡΞΕΙΣ',
  },
  {
    label: '47656709',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΚΟΥΚΛΕΣ ΠΟΥ ΑΝΑΠΑΡΙΣΤΟΥΝ ΑΝΘΡΩΠΙΝΕΣ ΥΠΑΡΞΕΙΣ',
  },
  {
    label: '47656710',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΓΝΙΟΧΑΡΤΩΝ (ΤΡΑΠΟΥΛΩΝ)',
  },
  {
    label: '47656711',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΔΙΚΩΝ ΤΡΕΝΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ, ΑΛΛΩΝ ΜΟΝΤΕΛΩΝ Η ΚΑΤΑΣΚΕΥΩΝ ΥΠΟ ΚΛΙΜΑΚΑ ΚΑΙ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΠΑΙΧΝΙΔΙΩΝ',
  },
  {
    label: '47656712',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΧΝΙΔΙΩΝ ΒΙΝΤΕΟ ΠΟΥ ΠΑΙΖΟΝΤΑΙ ΜΕ ΤΗΛΕΟΠΤΙΚΟ ΔΕΚΤΗ',
  },
  {
    label: '47656713',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΧΝΙΔΙΩΝ ΠΟΥ ΑΝΑΠΑΡΙΣΤΟΥΝ ΖΩΑ Η ΜΗ ΑΝΘΡΩΠΙΝΕΣ ΥΠΑΡΞΕΙΣ',
  },
  {
    label: '47656714',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΟΤΕΧΝΗΜΑΤΩΝ',
  },
  {
    label: '47656715',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΝΑΡΜΟΛΟΓΟΥΜΕΝΩΝ ΠΑΙΧΝΙΔΙΩΝ;ΣΠΑΖΟΚΕΦΑΛΙΩΝ',
  },
  {
    label: '47656716',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΡΟΧΟΦΟΡΩΝ ΠΑΙΧΝΙΔΙΩΝ ΣΧΕΔΙΑΣΜΕΝΩΝ ΓΙΑ ΝΑ ΕΠΙΒΑΙΝΟΝΤΑΙ ΑΠΟ ΠΑΙΔΙΑ ΚΑΙ ΚΑΡΟΤΣΙΩΝ ΓΙΑ ΚΟΥΚΛΕΣ',
  },
  {
    label: '47710000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΝΔΥΜΑΤΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47717100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΙΜΑΤΙΣΜΟΥ',
  },
  {
    label: '47717101',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ~ ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ ~ ΠΑΙΔΙΚΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '47717102',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΤΟΙΜΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ ΚΑΙ ΜΕΡΩΝ ΕΝΔΥΜΑΤΩΝ Η ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '47717103',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΙΟΥ, ΚΕΦΑΛΟΔΕΣΜΩΝ, ΦΟΔΡΩΝ, ΚΑΛΥΜΜΑΤΩΝ, ΣΚΕΛΕΤΩΝ ΚΑΠΕΛΩΝ, ΠΛΑΙΣΙΩΝ ΚΑΠΕΛΩΝ, ΓΕΙΣΩΝ ΚΑΙ ΥΠΟΣΙΑΓΩΝΩΝ, ΓΙΑ ΚΑΛΥΜΜΑΤΑ ΚΕΦΑΛΙΟΥ',
  },
  {
    label: '47717104',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΝΔΥΜΑΤΩΝ ΕΡΓΑΣΙΑΣ',
  },
  {
    label: '47717105',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΔΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ ΓΙΑ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '47717106',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΔΡΙΚΩΝ Η ΑΓΟΡΙΣΤΙΚΩΝ ΑΘΛΗΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΦΑΝΕΛΑΚΙΩΝ, ΣΩΒΡΑΚΩΝ, ΣΛΙΠ, ΠΙΤΖΑΜΩΝ, ΡΟΜΠΩΝ',
  },
  {
    label: '47717107',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΔΡΙΚΩΝ Η ΑΓΟΡΙΣΤΙΚΩΝ ΚΟΣΤΟΥΜΙΩΝ, ΣΥΝΟΛΩΝ, ΣΑΚΑΚΙΩΝ, ΜΠΛΕΙΖΕΡ, ΠΑΝΤΕΛΟΝΙΩΝ, ΦΟΡΜΩΝ ΜΕ ΜΠΟΥΣΤΟ ΚΑΙ ΜΕ ΤΙΡΑΝΤΕΣ, ΒΕΡΜΟΥΔΩΝ ΚΑΙ ΣΟΡΤΣ',
  },
  {
    label: '47717108',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΔΡΙΚΩΝ Η ΑΓΟΡΙΣΤΙΚΩΝ ΠΑΛΤΩΝ, ΗΜΙΠΑΛΤΩΝ, ΚΑΠΩΝ, ΕΠΕΝΔΥΤΩΝ, ΑΝΟΡΑΚ, ΑΔΙΑΒΡΟΧΩΝ, ΑΝΤΙΑΝΕΜΙΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47717109',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΔΡΙΚΩΝ Η ΑΓΟΡΙΣΤΙΚΩΝ ΣΑΚΑΚΙΩΝ Η ΜΠΛΕΙΖΕΡ',
  },
  {
    label: '47717110',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΔΡΙΚΩΝ ΠΟΥΚΑΜΙΣΩΝ, ΠΙΤΖΑΜΩΝ, ΜΠΛΟΥΖΩΝ, ΕΣΩΡΟΥΧΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47717111',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΡΕΦΙΚΩΝ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ',
  },
  {
    label: '47717112',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΑΝΤΙΩΝ ΚΑΙ ΓΑΝΤΙΩΝ ΧΩΡΙΣ ΔΑΚΤΥΛΑ',
  },
  {
    label: '47717113',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΟΥΝΑΡΙΚΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47717114',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ ΕΝΔΥΜΑΤΩΝ, ΓΙΑ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '47717115',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ ΕΣΩΡΟΥΧΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47717116',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ ΕΤΟΙΜΩΝ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΦΟΡΕΜΑΤΩΝ',
  },
  {
    label: '47717117',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ ΖΩΝΩΝ',
  },
  {
    label: '47717118',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ ΖΩΝΩΝ, ΕΣΩΡΟΥΧΩΝ, ΝΥΧΤΙΚΩΝ, ΡΟΜΠΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47717119',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ Η ΚΟΡΙΤΣΙΣΤΙΚΩΝ ΑΘΛΗΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΦΑΝΕΛΑΚΙΩΝ, ΚΟΜΠΙΝΕΖΟΝ, ΜΕΣΟΦΟΡΙΩΝ, ΣΛΙΠ, ΚΙΛΟΤΩΝ, ΝΥΧΤΙΚΩΝ, ΜΠΟΥΡΝΟΥΖΙΩΝ, ΡΟΜΠΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47717120',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ Η ΚΟΡΙΤΣΙΣΤΙΚΩΝ ΚΟΣΤΟΥΜΙΩΝ, ΣΥΝΟΛΩΝ, ΣΑΚΑΚΙΩΝ, ΦΟΡΕΜΑΤΩΝ, ΦΟΥΣΤΩΝ, ΠΑΝΤΕΛΟΝΙΩΝ, ΦΟΡΜΩΝ ΜΕ ΜΠΟΥΣΤΟ ΚΑΙ ΜΕ ΤΙΡΑΝΤΕΣ, ΒΕΡΜΟΥΔΩΝ ΚΑΙ ΣΟΡΤΣ',
  },
  {
    label: '47717121',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ Η ΚΟΡΙΤΣΙΣΤΙΚΩΝ ΜΠΛΟΥΖΩΝ, ΠΟΥΚΑΜΙΣΩΝ ΚΑΙ ΣΕΜΙΖΙΕ',
  },
  {
    label: '47717122',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ Η ΚΟΡΙΤΣΙΣΤΙΚΩΝ ΠΑΛΤΩΝ, ΗΜΙΠΑΛΤΩΝ, ΚΑΠΩΝ, ΕΠΕΝΔΥΤΩΝ, ΑΝΟΡΑΚ, ΑΔΙΑΒΡΟΧΩΝ, ΑΝΤΙΑΝΕΜΙΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47717123',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΝΑΙΚΕΙΩΝ ΚΑΠΕΛΩΝ',
  },
  {
    label: '47717124',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΙΝΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '47717125',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΨΑΣΜΕΝΩΝ Η ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΓΟΥΝΟΔΕΡΜΑΤΩΝ',
  },
  {
    label: '47717126',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΕΝΔΥΣΗΣ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ, ΕΚΤΟΣ ΤΟΥ ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ',
  },
  {
    label: '47717127',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΕΝΔΥΣΗΣ, ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΓΟΥΝΟΔΕΡΜΑ (ΕΚΤΟΣ ΑΠΟ ΚΑΛΥΜΜΑΤΑ ΚΕΦΑΛΙΟΥ)',
  },
  {
    label: '47717128',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΕΣΩΤΕΡΙΚΗΣ ΕΝΔΥΣΗΣ, ΑΠΟ ΧΑΡΤΙ Η ΚΥΤΤΑΡΙΝΗ',
  },
  {
    label: '47717129',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΝΕΩΤΕΡΙΣΜΩΝ',
  },
  {
    label: '47717130',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΝΔΥΜΑΤΩΝ ΑΠΟ ΠΙΛΗΜΑ (ΤΣΟΧΑ) Η ΜΗ ΥΦΑΝΤΩΝ, ΥΦΑΝΤΙΚΩΝ ΥΛΩΝ ΕΜΠΟΤΙΣΜΕΝΩΝ Η ΕΠΕΝΔΥΜΕΝΩΝ',
  },
  {
    label: '47717131',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΝΔΥΜΑΤΩΝ ΑΠΟ ΠΛΑΣΤΙΚΟ',
  },
  {
    label: '47717132',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΝΔΥΜΑΤΩΝ ΓΑΜΟΥ ΚΑΙ ΒΑΠΤΙΣΤΙΚΩΝ',
  },
  {
    label: '47717133',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΓΑΝΤΙΑ) ΑΠΟ ΠΛΑΣΤΙΚΟ',
  },
  {
    label: '47717134',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ ΑΠΟ ΓΟΥΝΟΔΕΡΜΑ, (ΕΚΤΟΣ ΑΠΟ ΚΑΛΥΜΜΑΤΑ ΚΕΦΑΛΙΟΥ)',
  },
  {
    label: '47717135',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ ΑΠΟ ΔΕΡΜΑ Η ΣΥΝΘΕΣΗ ΔΕΡΜΑΤΟΣ',
  },
  {
    label: '47717136',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ, ΑΠΟ ΧΑΡΤΟΠΟΛΤΟ, ΧΑΡΤΙ, ΧΑΡΤΟΒΑΜΒΑΚΑ Η ΡΟΛΑ ΙΝΩΝ ΚΥΤΤΑΡΙΝΗΣ',
  },
  {
    label: '47717137',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΤΟΙΜΩΝ ΑΝΔΡΙΚΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '47717138',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΖΩΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΔΕΡΜΑ Η ΑΠΟ ΑΛΛΗ ΥΛΗ',
  },
  {
    label: '47717139',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΙΕΡΑΤΙΚΩΝ ΑΜΦΙΩΝ ΚΑΙ ΤΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΤΟΥΣ',
  },
  {
    label: '47717140',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΗΣ ΑΣΦΑΛΕΙΑΣ, ΚΑΠΕΛΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΗΣ, ΑΠΟ ΚΑΟΥΤΣΟΥΚ Η ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47717141',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΠΕΛΩΝ',
  },
  {
    label: '47717142',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΠΕΛΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΛΥΜΜΑΤΩΝ ΚΕΦΑΛΙΟΥ, ΦΙΛΕΔΩΝ ΜΑΛΛΙΩΝ',
  },
  {
    label: '47717143',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΛΑΝ, ΚΑΛΣΟΝ, ΜΑΚΡΙΩΝ ΚΑΙ ΚΟΝΤΩΝ ΚΑΛΤΣΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΚΑΛΤΣΟΠΟΙΙΑΣ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '47717144',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΝΤΟΜΑΝΙΚΩΝ ΦΑΝΕΛΑΚΙΩΝ',
  },
  {
    label: '47717145',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΝΤΙΛΙΩΝ, ΣΑΛΙΩΝ, ΓΡΑΒΑΤΩΝ, ΓΑΝΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ, ΜΕΡΩΝ ΕΝΔΥΜΑΤΩΝ Η ΕΞΑΡΤΗΜΑΤΩΝ ΡΟΥΧΙΣΜΟΥ, ΑΠΟ ΥΦΑΝΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΠΛΕΚΤΑ Η ΚΡΟΣΕ Π.Δ.Κ.Α.',
  },
  {
    label: '47717146',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΕΤΟΙΜΩΝ ΑΝΔΡΙΚΩΝ ΚΑΙ ΓΥΝΑΙΚΕΙΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '47717147',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΝΥΦΙΚΩΝ ΚΑΙ ΒΑΠΤΙΣΤΙΚΩΝ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '47717148',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΜΠΡΕΛΩΝ',
  },
  {
    label: '47717149',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΜΠΡΕΛΩΝ, ΜΠΑΣΤΟΥΝΙΩΝ, ΡΑΒΔΩΝ;ΚΑΘΙΣΜΑΤΩΝ',
  },
  {
    label: '47717150',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΔΙΚΩΝ ΕΝΔΥΜΑΤΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47717151',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΙΤΖΑΜΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47717152',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΥΚΑΜΙΣΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47717153',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΤΗΘΟΔΕΣΜΩΝ, ΚΟΡΣΕΔΩΝ, ΛΑΣΤΕΞ, ΜΑΓΙΟ, ΤΙΡΑΝΤΩΝ, ΖΑΡΤΙΕΡΩΝ, ΚΑΛΤΣΟΔΕΤΩΝ ΚΑΙ ΛΟΙΠΩΝ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47717154',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΤΡΑΤΙΩΤΙΚΩΝ ΚΑΙ ΑΣΤΥΝΟΜΙΚΩΝ ΣΤΟΛΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '47717155',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ ΓΟΥΝΩΝ ΚΑΙ ΕΙΔΩΝ ΑΠΟ ΤΕΧΝΗΤΗ ΓΟΥΝΑ',
  },
  {
    label: '47717156',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΑΝΕΛΩΝ ΖΕΡΣΕΪ, ΠΟΥΛΟΒΕΡ, ΖΑΚΕΤΩΝ, ΓΙΛΕΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΠΛΕΚΤΩΝ Η ΚΡΟΣΕ',
  },
  {
    label: '47720000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ ΚΑΙ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47727200',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '47727201',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΔΙΑΒΡΟΧΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΜΕ ΕΞΩΤΕΡΙΚΕΣ ΣΟΛΕΣ ΚΑΙ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΚΑΟΥΤΣΟΥΚ Η ΠΛΑΣΤΙΚΟ, ΟΧΙ ΓΙΑ ΣΠΟΡ',
  },
  {
    label: '47727202',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΠΟΔΗΜΑΤΟΠΟΙΙΑΣ',
  },
  {
    label: '47727203',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '47727204',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΥΠΟΔΗΜΑΤΩΝ, ΔΙΑΦΟΡΩΝ ΕΙΔΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΥΠΟΔΗΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47727205',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ ΜΕ ΕΞΩΤΕΡΙΚΕΣ ΣΟΛΕΣ ΚΑΙ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΚΑΟΥΤΣΟΥΚ Η ΠΛΑΣΤΙΚΟ',
  },
  {
    label: '47727206',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΔΕΡΜΑ',
  },
  {
    label: '47727207',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ ΜΕ ΕΠΑΝΩ ΜΕΡΗ ΑΠΟ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ, ΕΚΤΟΣ ΤΩΝ ΑΘΛΗΤΙΚΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '47727208',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ ΠΟΥ ΕΧΟΥΝ ΕΝΣΩΜΑΤΩΜΕΝΑ ΠΡΟΣΤΑΤΕΥΤΙΚΑ ΜΕΤΑΛΛΙΚΑ ΨΙΔΙΑ',
  },
  {
    label: '47727300',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΤΑΞΙΔΙΟΥ',
  },
  {
    label: '47727301',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΔΕΡΜΑ Η ΣΥΝΘΕΤΙΚΑ ΔΕΡΜΑΤΑ (ΧΩΡΙΣ ΤΑ ΕΙΔΗ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΜΗΧΑΝΗΜΑΤΑ Η ΑΛΛΕΣ ΜΗΧΑΝΙΚΕΣ ΣΥΣΚΕΥΕΣ)',
  },
  {
    label: '47727302',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΣΚΕΥΩΝ, ΤΣΑΝΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΑΠΟ ΚΑΘΕ ΥΛΙΚΟ',
  },
  {
    label: '47727303',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΟΣ ΑΙΓΑΓΡΟΥ (ΣΑΜΟΥΑ), ΛΟΥΣΤΡΙΝΙΟΥ ΚΑΙ ΔΕΡΜΑΤΟΣ ΜΕ ΣΤΙΛΠΝΗ ΕΠΙΚΑΛΥΨΗ ΚΑΙ ΕΠΙΜΕΤΑΛΛΩΜΕΝΟΥ ΔΕΡΜΑΤΟΣ',
  },
  {
    label: '47727304',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΩΝ ΑΛΛΩΝ ΖΩΩΝ, ΧΩΡΙΣ ΤΡΙΧΕΣ',
  },
  {
    label: '47727305',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΣΕΛΟΠΟΙΙΑΣ ΚΑΙ ΣΑΓΗΣ ΓΙΑ ΚΑΘΕ ΖΩΟ, ΑΠΟ ΚΑΘΕ ΥΛΙΚΟ',
  },
  {
    label: '47727306',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΔΕΡΜΑΤΩΝ',
  },
  {
    label: '47727307',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΝΘΕΤΙΚΩΝ ΔΕΡΜΑΤΩΝ',
  },
  {
    label: '47727308',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΟΦΥΛΑΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΠΟ ΔΕΡΜΑ Η ΑΠΟ ΑΛΛΗ ΥΛΗ',
  },
  {
    label: '47730000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΕΙΔΩΝ (ΦΑΡΜΑΚΕΙΑ)',
  },
  {
    label: '47737401',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΙΟΡΩΝ ΚΑΙ ΕΜΒΟΛΙΩΝ',
  },
  {
    label: '47737402',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΣΤΕΙΡΩΤΙΚΩΝ ΔΙΑΛΥΜΑΤΩΝ ΦΑΚΩΝ ΕΠΑΦΗΣ',
  },
  {
    label: '47737403',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΓΝΩΣΤΙΚΩΝ ΑΝΤΙΔΡΑΣΤΗΡΙΩΝ ΚΑΙ ΑΛΛΩΝ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '47737404',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΜΕΤΟΥΣΙΩΜΕΝΗΣ ΑΙΘΥΛΙΚΗΣ ΑΛΚΟΟΛΗΣ, ΜΕ ΠΕΡΙΕΚΤΙΚΟΤΗΤΑ ΣΕ ΟΙΝΟΠΝΕΥΜΑ >= 80 ;%',
  },
  {
    label: '47737405',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΦΑΡΜΑΚΕΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '47737406',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΓΚΟΛΛΗΤΙΚΩΝ ΕΠΙΔΕΣΜΩΝ, ΧΕΙΡΟΥΡΓΙΚΩΝ ΡΑΜΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '47737407',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΕΡΟΞΕΙΔΙΟΥ ΤΟΥ ΥΔΡΟΓΟΝΟΥ',
  },
  {
    label: '47737408',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΑΦΕΨΗΜΑΤΩΝ ΒΟΤΑΝΩΝ',
  },
  {
    label: '47737409',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΑΛΚΑΛΟΕΙΔΗ Η ΠΑΡΑΓΩΓΑ ΤΟΥΣ, ΑΛΛΑ ΟΧΙ ΟΡΜΟΝΕΣ Η ΑΝΤΙΒΙΟΤΙΚΑ',
  },
  {
    label: '47737410',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΟΡΜΟΝΕΣ, ΑΛΛΑ ΟΧΙ ΑΝΤΙΒΙΟΤΙΚΑ',
  },
  {
    label: '47737411',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΩΝ, ΠΟΥ ΠΕΡΙΕΧΟΥΝ ΠΕΝΙΚΙΛΙΝΕΣ Η ΑΛΛΑ ΑΝΤΙΒΙΟΤΙΚΑ',
  },
  {
    label: '47737412',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΗΜΙΚΩΝ ΑΝΤΙΣΥΛΛΗΠΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΜΕ ΒΑΣΗ ΟΡΜΟΝΕΣ Η ΣΠΕΡΜΑΤΟΚΤΟΝΑ',
  },
  {
    label: '47737413',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΩΝ ΕΙΔΙΚΑ ΚΤΗΝΙΑΤΡΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '47740000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΙΑΤΡΙΚΩΝ ΚΑΙ ΟΡΘΟΠΕΔΙΚΩΝ ΕΙΔΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47747500',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΙΑΤΡΙΚΩΝ ΚΑΙ ΟΡΘΟΠΕΔΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47747501',
    value: 'ΔΙΑΘΕΣΗ ΙΑΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ ΠΡΟΣ ΤΟΥΣ ΑΣΘΕΝΕΙΣ, ΜΕΣΩ ΤΩΝ ΝΟΣΟΚΟΜΕΙΩΝ',
  },
  {
    label: '47747502',
    value:
      'ΔΙΑΘΕΣΗ ΤΕΧΝΗΤΩΝ ΜΟΣΧΕΥΜΑΤΩΝ ΠΡΟΣ ΤΟΥΣ ΑΣΘΕΝΕΙΣ, ΜΕΣΩ ΤΩΝ ΝΟΣΟΚΟΜΕΙΩΝ',
  },
  {
    label: '47747503',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΚΟΥΣΤΙΚΩΝ ΒΑΡΗΚΟΪΑΣ',
  },
  {
    label: '47747504',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΚΟΥΣΤΙΚΩΝ ΒΑΡΗΚΟΪΑΣ, ΒΗΜΑΤΟΔΟΤΩΝ, ΜΕΡΩΝ ΤΟΥΣ, ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΠΡΟΘΕΣΕΩΝ (ΤΕΧΝΗΤΩΝ ΜΕΛΩΝ) ΚΑΙ ΟΡΘΟΠΕΔΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '47747505',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΠΗΡΙΚΩΝ ΚΑΡΟΤΣΙΩΝ',
  },
  {
    label: '47747506',
    value:
      "ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΑΤΩΝ ΑΠΟ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ ΚΑΙ ΕΙΔΩΝ ΑΠ' ΑΥΤΕΣ, ΓΙΑ ΦΑΡΜΑΚΕΥΤΙΚΗ ΧΡΗΣΗ",
  },
  {
    label: '47747507',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΥΤΕΡΕΥΟΝΤΩΝ ΘΕΡΑΠΕΥΤΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΚΑΙ ΑΝΑΠΝΕΥΣΤΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '47747508',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΕΠΕΜΒΑΤΙΚΗΣ ΚΑΡΔΙΟΛΟΓΙΑΣ',
  },
  {
    label: '47747509',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ Η ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΕΙΔΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΤΑ ΘΗΛΑΣΤΡΑ) ΑΠΟ ΒΟΥΛΚΑΝΙΣΜΕΝΟ ΕΛΑΣΤΙΚΟ, ΕΚΤΟΣ ΤΟΥ ΣΚΛΗΡΟΥ ΕΛΑΣΤΙΚΟΥ',
  },
  {
    label: '47747510',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΙΑΤΡΙΚΩΝ ΑΝΑΛΩΣΙΜΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '47747511',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΙΑΤΡΙΚΩΝ ΘΕΡΜΟΜΕΤΡΩΝ',
  },
  {
    label: '47747512',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΤΙΩΝ ΠΡΩΤΩΝ ΒΟΗΘΕΙΩΝ',
  },
  {
    label: '47747513',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΓΙΑ ΑΝΑΠΗΡΙΚΑ ΚΑΡΟΤΣΑΚΙΑ',
  },
  {
    label: '47747514',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΡΘΟΠΕΔΙΚΩΝ ΕΙΔΩΝ ΑΠΟ ΥΦΑΣΜΑ, ΕΛΑΣΤΙΚΟ ΝΗΜΑ Η ΛΑΣΤΙΧΟ ΚΑΙ ΣΥΝΑΦΕΙΣ ΥΛΕΣ',
  },
  {
    label: '47747515',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΡΘΟΠΕΔΙΚΩΝ ΕΙΔΩΝ, ΚΗΛΕΠΙΔΕΣΜΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47747516',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΡΙΓΓΩΝ, ΒΕΛΟΝΩΝ, ΚΑΘΕΤΗΡΩΝ, ΣΩΛΗΝΙΣΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΟΦΘΑΛΜΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47747517',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ ΑΡΘΡΩΣΕΩΝ, ΟΡΘΟΠΕΔΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΤΕΧΝΗΤΩΝ ΔΟΝΤΙΩΝ, ΟΔΟΝΤΙΚΩΝ ΕΞΑΡΤΗΜΑΤΩΝ, ΤΕΧΝΗΤΩΝ ΜΕΛΩΝ ΤΟΥ ΣΩΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '47747518',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ ΜΟΣΧΕΥΜΑΤΩΝ',
  },
  {
    label: '47747519',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΓΕΙΟΝΟΜΙΚΩΝ Η ΝΟΣΟΚΟΜΕΙΑΚΩΝ ΕΙΔΩΝ, ΑΠΟ ΧΑΡΤΟΠΟΛΤΟ, ΧΑΡΤΙ, ΧΑΡΤΟΒΑΜΒΑΚΑ Η ΡΟΛΑ ΙΝΩΝ ΚΥΤΤΑΡΙΝΗΣ',
  },
  {
    label: '47747520',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΝΕΦΡΟΥ ΜΙΑΣ ΧΡΗΣΕΩΣ, ΚΑΘΕΤΗΡΩΝ, ΓΑΖΩΝ ΚΛΠ',
  },
  {
    label: '47747521',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΝΩΝ ΕΙΔΩΝ ΝΟΣΟΚΟΜΕΙΩΝ ΜΙΑΣ ΧΡΗΣΕΩΣ (ΚΑΠΕΛΩΝ, ΜΠΛΟΥΖΩΝ ΚΑΙ ΣΧΕΤΙΚΩΝ ΕΙΔΩΝ)',
  },
  {
    label: '47747522',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΕΙΡΟΥΡΓΙΚΩΝ ΚΑΙ ΙΑΤΡΙΚΩΝ ΓΕΝΙΚΑ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΡΓΑΛΕΙΩΝ',
  },
  {
    label: '47750000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΛΥΝΤΙΚΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47757600',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΛΥΝΤΙΚΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ',
  },
  {
    label: '47757601',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΚΟΠΤΙΚΩΝ ΕΙΔΩΝ, ΕΙΔΩΝ ΚΑΙ ΣΥΝΟΛΩΝ ΕΙΔΩΝ ΓΙΑ ΤΗΝ ΠΕΡΙΠΟΙΗΣΗ ΤΩΝ ΧΕΡΙΩΝ Η ΤΩΝ ΠΟΔΙΩΝ',
  },
  {
    label: '47757602',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΡΩΜΑΤΩΝ ΚΑΙ ΚΟΛΟΝΙΩΝ',
  },
  {
    label: '47757603',
    value:
      "ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΑΤΩΝ ΑΠΟ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ ΚΑΙ ΕΙΔΩΝ ΑΠ' ΑΥΤΕΣ, ΓΙΑ ΧΡΗΣΗ ΑΛΛΗ ΑΠΟ ΦΑΡΜΑΚΕΥΤΙΚΗ",
  },
  {
    label: '47757604',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΟΥΡΤΣΑΚΙΩΝ ΤΟΥΑΛΕΤΑΣ ΓΙΑ ΠΡΟΣΩΠΙΚΗ ΧΡΗΣΗ ΚΑΙ ΒΟΥΡΤΣΑΚΙΩΝ ΓΙΑ ΚΑΛΛΥΝΤΙΚΑ ΚΑΙ ΟΔΟΝΤΟΒΟΥΡΤΣΩΝ',
  },
  {
    label: '47757605',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΟΣΙΟΝ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΑ ΜΑΛΛΙΑ Π.Δ.Κ.Α.',
  },
  {
    label: '47757606',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΗΡΩΝ ΦΥΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΚΥΡΙΩΣ ΣΤΗΝ ΑΡΩΜΑΤΟΠΟΙΙΑ, ΤΗ ΦΑΡΜΑΚΕΥΤΙΚΗ Η ΤΗΝ ΠΑΡΑΓΩΓΗ ΕΝΤΟΜΟΚΤΟΝΩΝ, ΜΥΚΗΤΟΚΤΟΝΩΝ Η ΓΙΑ ΠΑΡΟΜΟΙΟΥΣ ΣΚΟΠΟΥΣ',
  },
  {
    label: '47757607',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΡΑΦΙΩΝ ΚΑΙ ΛΕΠΙΔΩΝ ΞΥΡΑΦΙΩΝ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΑΚΑΤΕΡΓΑΣΤΩΝ ΜΕΤΑΛΛΙΚΩΝ ΤΑΙΝΙΩΝ ΠΟΥ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΛΕΠΙΔΩΝ ΞΥΡΑΦΙΩΝ)',
  },
  {
    label: '47757608',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΡΙΣΤΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ, ΑΠΟΣΜΗΤΙΚΩΝ ΚΑΙ ΑΝΤΙΙΔΡΩΤΙΚΩΝ ΓΙΑ ΤΟ ΣΩΜΑ, ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΟ ΛΟΥΤΡΟ, ΑΛΛΩΝ ΑΡΩΜΑΤΩΝ ΚΑΛΛΥΝΤΙΚΩΝ Η ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΛΛΩΠΙΣΜΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '47757609',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΜΑΚΙΓΙΑΖ ΧΕΙΛΙΩΝ ΚΑΙ ΜΑΤΙΩΝ',
  },
  {
    label: '47757610',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΗΝ ΠΕΡΙΠΟΙΗΣΗ ΤΩΝ ΧΕΡΙΩΝ ΚΑΙ ΤΩΝ ΠΟΔΙΩΝ',
  },
  {
    label: '47757611',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΤΗΝ ΥΓΙΕΙΝΗ ΤΟΥ ΣΤΟΜΑΤΟΣ Η ΤΩΝ ΔΟΝΤΙΩΝ, (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΟΙ ΣΤΕΡΕΩΤΙΚΟΙ ΠΟΛΤΟΙ ΚΑΙ ΣΚΟΝΕΣ ΓΙΑ ΤΗΝ ΟΔΟΝΤΟΣΤΟΙΧΙΑ)',
  },
  {
    label: '47757612',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΟΜΟΡΦΙΑΣ, ΜΑΚΙΓΙΑΖ, ΦΡΟΝΤΙΔΑΣ ΤΟΥ ΔΕΡΜΑΤΟΣ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΝΤΑΙ ΚΑΙ ΤΑ ΑΝΤΙΗΛΙΑΚΑ) Π.Δ.Κ.Α.',
  },
  {
    label: '47757613',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΑΜΠΟΥΑΝ, ΛΑΚ ΜΑΛΛΙΩΝ, ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΜΟΝΙΜΟ ΚΑΤΣΑΡΩΜΑ Η ΙΣΙΩΜΑ ΜΑΛΛΙΩΝ',
  },
  {
    label: '47757614',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΑΠΟΥΝΙΟΥ ΚΑΙ ΕΠΙΦΑΝΕΙΟΔΡΑΣΤΙΚΩΝ ΟΡΓΑΝΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΩΣ ΣΑΠΟΥΝΙ, ΓΙΑ ΠΡΟΣΩΠΙΚΗ ΥΓΙΕΙΝΗ',
  },
  {
    label: '47757615',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΚΟΝΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΩΣ ΚΑΛΛΥΝΤΙΚΑ Η ΓΙΑ ΚΑΛΛΩΠΙΣΜΟ',
  },
  {
    label: '47757616',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΦΟΥΓΓΑΡΙΩΝ',
  },
  {
    label: '47757617',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΓΡΩΝ ΧΑΡΤΟΜΑΝΤΙΛΩΝ',
  },
  {
    label: '47757618',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΩΝ ΣΦΟΥΓΓΑΡΙΩΝ ΖΩΙΚΗΣ ΠΡΟΕΛΕΥΣΗΣ',
  },
  {
    label: '47757619',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΥΓΕΙΑΣ, ΧΑΡΤΟΜΑΝΤΙΛΩΝ, ΜΑΝΤΙΛΙΩΝ ΚΑΙ ΠΕΤΣΕΤΩΝ ΚΑΘΑΡΙΣΜΟΥ ΠΡΟΣΩΠΟΥ, ΤΡΑΠΕΖΟΜΑΝΤΙΛΩΝ ΚΑΙ ΠΕΤΣΕΤΩΝ ΦΑΓΗΤΟΥ, ΑΠΟ ΧΑΡΤΙ',
  },
  {
    label: '47757620',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΤΕΝΩΝ, ΤΣΙΜΠΙΔΙΩΝ ΜΑΛΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΦΟΥΡΚΕΤΩΝ, ΛΑΒΙΔΩΝ ΚΑΤΣΑΡΩΜΑΤΟΣ, ΨΕΚΑΣΤΗΡΩΝ ΑΡΩΜΑΤΩΝ ΚΑΙ ΒΑΣΕΩΝ ΤΟΥΣ, ΠΟΜΠΟΝ ΚΑΙ ΤΑΜΠΟΝ ΠΟΥΔΡΑΡΙΣΜΑΤΟΣ',
  },
  {
    label: '47760000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΛΟΥΔΙΩΝ, ΦΥΤΩΝ, ΣΠΟΡΩΝ, ΛΙΠΑΣΜΑΤΩΝ, ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ ΚΑΙ ΣΧΕΤΙΚΩΝ ΖΩΟΤΡΟΦΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47767700',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΛΟΥΔΙΩΝ, ΦΥΤΩΝ ΚΑΙ ΣΠΟΡΩΝ',
  },
  {
    label: '47767701',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΘΕΩΝ',
  },
  {
    label: '47767702',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΞΗΡΑΜΕΝΩΝ ΟΣΠΡΙΩΔΩΝ ΛΑΧΑΝΙΚΩΝ, ΑΠΟΦΛΟΙΩΜΕΝΩΝ, ΓΙΑ ΣΠΟΡΑ',
  },
  {
    label: '47767703',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΞΗΡΑΜΕΝΩΝ ΦΥΤΩΝ',
  },
  {
    label: '47767704',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΕΩΡΓΙΚΩΝ ΣΠΟΡΩΝ ΣΕ ΜΙΚΡΟΣΥΣΚΕΥΑΣΙΕΣ',
  },
  {
    label: '47767705',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΝΔΡΥΛΛΙΩΝ ΚΑΙ ΦΥΤΩΝ (ΕΚΤΟΣ ΚΑΛΛΩΠΙΣΤΙΚΩΝ ΦΥΤΩΝ)',
  },
  {
    label: '47767706',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΛΑΙΟΥΧΩΝ ΣΠΟΡΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47767707',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΖΩΝΤΩΝ ΦΥΤΩΝ, ΚΟΝΔΥΛΩΝ, ΒΟΛΒΩΝ ΚΑΙ ΡΙΖΩΝ, ΜΟΣΧΕΥΜΑΤΩΝ ΚΑΙ ΠΑΡΑΦΥΑΔΩΝ, ΜΥΚΗΛΙΩΝ ΜΑΝΙΤΑΡΙΩΝ',
  },
  {
    label: '47767708',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΑΜΠΟΚΙΟΥ ΓΙΑ ΣΠΟΡΑ',
  },
  {
    label: '47767709',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗ ΓΕΩΡΓΙΑ ΚΑΙ ΓΙΑ ΤΗ ΜΕΤΑΦΟΡΑ Η ΤΗ ΣΥΣΚΕΥΑΣΙΑ ΑΓΑΘΩΝ',
  },
  {
    label: '47767710',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΜΜΕΝΩΝ ΑΝΘΕΩΝ ΚΑΙ ΜΠΟΥΜΠΟΥΚΙΩΝ ΤΟΥΣ, ΣΥΝΘΕΣΕΩΝ ΑΝΘΕΩΝ, ΚΑΘΩΣ ΚΑΙ ΑΝΘΟΔΕΣΜΩΝ, ΣΤΕΦΑΝΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47767711',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΦΥΤΩΝ, ΧΟΡΤΑΡΙΩΝ, ΒΡΥΩΝ ΚΑΙ ΛΕΙΧΗΝΩΝ, ΚΑΤΑΛΛΗΛΩΝ ΓΙΑ ΔΙΑΚΟΣΜΗΤΙΚΗ ΧΡΗΣΗ',
  },
  {
    label: '47767712',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΑΝΘΕΩΝ',
  },
  {
    label: '47767713',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΑΝΘΕΩΝ ΚΑΙ ΚΑΡΠΩΝ',
  },
  {
    label: '47767714',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΖΑΧΑΡΟΤΕΥΤΛΩΝ ΚΑΙ ΣΠΟΡΩΝ ΚΤΗΝΟΤΡΟΦΙΚΩΝ ΦΥΤΩΝ',
  },
  {
    label: '47767715',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΗΛΙΑΝΘΟΥ, ΣΟΥΣΑΜΙΟΥ, ΚΑΡΔΑΜΟΥ, ΚΡΑΜΒΗΣ, ΕΛΑΙΟΚΡΑΜΒΗΣ ΚΑΙ ΣΙΝΑΠΙΟΥ, ΓΙΑ ΣΠΟΡΑ',
  },
  {
    label: '47767716',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '47767717',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΠΟΡΩΝ ΠΑΤΑΤΑΣ',
  },
  {
    label: '47767718',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΡΕΣΚΩΝ ΦΥΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΚΥΡΙΩΣ ΣΤΗΝ ΑΡΩΜΑΤΟΠΟΙΙΑ, ΤΗ ΦΑΡΜΑΚΕΥΤΙΚΗ Η ΤΗΝ ΠΑΡΑΓΩΓΗ ΕΝΤΟΜΟΚΤΟΝΩΝ, ΜΥΚΗΤΟΚΤΟΝΩΝ Η ΓΙΑ ΠΑΡΟΜΟΙΟΥΣ ΣΚΟΠΟΥΣ',
  },
  {
    label: '47767719',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΩΝ ΧΡΙΣΤΟΥΓΕΝΝΙΑΤΙΚΩΝ ΔΕΝΤΡΩΝ',
  },
  {
    label: '47767720',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΤΙΚΩΝ ΥΛΩΝ Π.Δ.Κ.Α. ΓΙΑ ΣΠΑΡΤΟΠΛΕΚΤΙΚΗ, ΠΑΡΑΓΕΜΙΣΜΑ, ΒΑΤΕΣ, ΒΑΦΗ Η ΔΕΨΗ, ΦΥΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47767800',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΙΠΑΣΜΑΤΩΝ ΚΑΙ ΑΓΡΟΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '47767801',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΖΩΤΟΥΧΩΝ ΛΙΠΑΣΜΑΤΩΝ, ΟΡΥΚΤΩΝ Η ΧΗΜΙΚΩΝ',
  },
  {
    label: '47767802',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΣΧΕΤΙΚΩΝ ΒΛΑΣΤΗΣΗΣ, ΡΥΘΜΙΣΤΩΝ ΤΗΣ ΑΝΑΠΤΥΞΗΣ ΤΩΝ ΦΥΤΩΝ',
  },
  {
    label: '47767803',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΛΥΜΑΝΤΙΚΩΝ',
  },
  {
    label: '47767804',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΦΡΥΚΤΟΥ ΣΙΔΗΡΟΠΥΡΙΤΗ, ΑΚΑΤΕΡΓΑΣΤΟΥ Η ΜΗ ΕΞΕΥΓΕΝΙΣΜΕΝΟΥ ΘΕΙΟΥ',
  },
  {
    label: '47767805',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΕΩΡΓΙΚΩΝ ΦΑΡΜΑΚΩΝ ΚΑΙ ΛΙΠΑΣΜΑΤΩΝ ΣΕ ΜΙΚΡΟΣΥΣΚΕΥΑΣΙΕΣ',
  },
  {
    label: '47767806',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΑΠΟ ΤΥΡΦΗ',
  },
  {
    label: '47767807',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΝΤΟΜΟΚΤΟΝΩΝ, ΣΥΣΚΕΥΑΣΜΕΝΩΝ ΓΙΑ ΛΙΑΝΙΚΗ ΠΩΛΗΣΗ',
  },
  {
    label: '47767808',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΖΙΖΑΝΙΟΚΤΟΝΩΝ',
  },
  {
    label: '47767809',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΖΩΙΚΩΝ Η ΦΥΤΙΚΩΝ ΛΙΠΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47767810',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΙΟΥΧΩΝ ΛΙΠΑΣΜΑΤΩΝ, ΟΡΥΚΤΩΝ Η ΧΗΜΙΚΩΝ',
  },
  {
    label: '47767811',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΙΠΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47767812',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΥΚΗΤΟΚΤΟΝΩΝ, ΦΑΡΜΑΚΩΝ ΚΑΤΑ ΤΩΝ ΤΡΩΚΤΙΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '47767813',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΝΙΤΡΙΚΟΥ ΝΑΤΡΙΟΥ',
  },
  {
    label: '47767814',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΥΡΦΗΣ, ΟΧΙ ΣΕ ΜΠΡΙΚΕΤΕΣ',
  },
  {
    label: '47767815',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΩΝ ΦΩΣΦΟΡΙΚΩΝ ΑΛΑΤΩΝ ΑΣΒΕΣΤΙΟΥ Η ΑΡΓΙΛΙΟΥ ΚΑΙ ΑΣΒΕΣΤΙΟΥ, ΚΑΡΝΑΛΙΤΗ, ΣΥΛΒΙΤΗ ΚΑΙ ΑΛΛΩΝ ΦΥΣΙΚΩΝ ΑΚΑΤΕΡΓΑΣΤΩΝ ΑΛΑΤΩΝ ΚΑΛΙΟΥ',
  },
  {
    label: '47767816',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΣΦΟΡΙΚΩΝ ΛΙΠΑΣΜΑΤΩΝ, ΟΡΥΚΤΩΝ Η ΧΗΜΙΚΩΝ',
  },
  {
    label: '47767817',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΛΩΡΙΟΥΧΟΥ ΑΜΜΩΝΙΟΥ, ΝΙΤΡΩΔΩΝ ΑΛΑΤΩΝ, ΝΙΤΡΙΚΩΝ ΑΛΑΤΩΝ ΤΟΥ ΚΑΛΙΟΥ, ΦΩΣΦΟΡΙΚΩΝ ΑΛΑΤΩΝ ΤΟΥ ΤΡΙΑΜΜΩΝΙΟΥ ΚΑΙ ΑΝΘΡΑΚΙΚΩΝ ΑΛΑΤΩΝ ΑΜΜΩΝΙΟΥ',
  },
  {
    label: '47767900',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ ΚΑΙ ΤΡΟΦΩΝ ΓΙΑ ΖΩΑ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '47767901',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΖΩΝΤΩΝ ΖΩΩΝ',
  },
  {
    label: '47767902',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΓΙΑ ΚΑΤΟΙΚΙΔΙΑ ΖΩΑ',
  },
  {
    label: '47767903',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΛΑΡΩΝ ΚΑΙ ΛΟΥΡΙΩΝ ΓΙΑ ΓΑΤΕΣ ΚΑΙ ΣΚΥΛΟΥΣ',
  },
  {
    label: '47767904',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΛΑΚΟΥ ΣΙΤΑΡΙΟΥ ΚΑΙ ΣΜΙΓΑΔΙΟΥ, ΓΙΑ ΚΑΤΑΝΑΛΩΣΗ ΑΠΟ ΖΩΑ',
  },
  {
    label: '47767905',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΤΡΟΦΩΝ ΓΙΑ ΚΑΤΟΙΚΙΔΙΑ ΖΩΑ Η ΠΤΗΝΑ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '47767906',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΒΟΛΩΝ ΔΗΜΗΤΡΙΑΚΩΝ Π.Δ.Κ.Α., ΕΚΤΟΣ ΣΙΤΑΡΙΟΥ',
  },
  {
    label: '47767907',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΒΟΛΩΝ ΣΙΤΑΡΙΟΥ',
  },
  {
    label: '47767908',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΚΛΗΡΟΥ ΣΙΤΑΡΙΟΥ, ΓΙΑ ΚΑΤΑΝΑΛΩΣΗ ΑΠΟ ΖΩΑ',
  },
  {
    label: '47767909',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΤΙΚΩΝ ΑΛΕΥΡΙΩΝ ΚΑΙ ΧΟΝΔΡΑΛΕΥΡΩΝ ΓΙΑ ΤΡΟΦΗ ΖΩΩΝ',
  },
  {
    label: '47767910',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΩΔΙΚΩΝ ΠΤΗΝΩΝ, ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΨΑΡΙΩΝ, ΣΚΥΛΩΝ, ΓΑΤΩΝ ΚΛΠ, ΖΩΝΤΩΝ',
  },
  {
    label: '47770000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΟΛΟΓΙΩΝ ΚΑΙ ΚΟΣΜΗΜΑΤΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47778200',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΟΛΟΓΙΩΝ ΚΑΙ ΚΟΣΜΗΜΑΤΩΝ',
  },
  {
    label: '47778201',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΠΟΛΥΤΙΜΑ ΜΕΤΑΛΛΑ, ΕΙΔΩΝ ΑΠΟ ΦΥΣΙΚΑ Η ΚΑΛΛΙΕΡΓΗΜΕΝΑ ΜΑΡΓΑΡΙΤΑΡΙΑ, ΠΟΛΥΤΙΜΟΥΣ Η ΗΜΙΠΟΛΥΤΙΜΟΥΣ ΛΙΘΟΥΣ',
  },
  {
    label: '47778202',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΡΟΛΟΓΙΩΝ ΧΕΡΙΟΥ, ΤΣΕΠΗΣ ΚΑΙ ΑΛΛΩΝ ΡΟΛΟΓΙΩΝ ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΧΡΟΝΟΜΕΤΡΩΝ',
  },
  {
    label: '47778203',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΥΑΛΙΩΝ ΡΟΛΟΓΙΩΝ ΤΟΙΧΟΥ ΚΑΙ ΧΕΡΙΟΥ, ΜΕΡΩΝ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΤΕΤΟΙΩΝ ΓΥΑΛΙΩΝ',
  },
  {
    label: '47778204',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΚΟΣΜΗΜΑΤΟΠΟΙΙΑΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ, ΕΙΔΩΝ ΧΡΥΣΟΧΟΪΑΣ Η ΑΡΓΥΡΟΧΟΪΑΣ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '47778205',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΤΡΑΠΕΖΙΩΝ ΡΟΛΟΓΙΩΝ ΜΕ ΜΗΧΑΝΙΣΜΟ ΡΟΛΟΓΙΟΥ ΧΕΡΙΟΥ, ΞΥΠΝΗΤΗΡΙΩΝ ΚΑΙ ΡΟΛΟΓΙΩΝ ΤΟΙΧΟΥ ΚΑΙ ΑΛΛΩΝ ΡΟΛΟΓΙΩΝ',
  },
  {
    label: '47778206',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΛΙΕΡΓΗΜΕΝΩΝ ΜΑΡΓΑΡΙΤΑΡΙΩΝ, ΠΟΛΥΤΙΜΩΝ Η ΗΜΙΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ, ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΣΥΝΘΕΤΙΚΩΝ Η ΑΝΑΣΧΗΜΑΤΙΣΜΕΝΩΝ ΛΙΘΩΝ, ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΑΛΛΑ ΜΗ ΔΕΜΕΝΩΝ ΣΕ ΚΟΣΜΗΜΑΤΑ',
  },
  {
    label: '47778207',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΡΑΚΙΩΝ ΚΑΙ ΑΛΥΣΙΔΩΝ ΡΟΛΟΓΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΤΩΝ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '47778208',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΡΓΑΡΙΤΑΡΙΩΝ ΑΠΟ ΚΑΛΛΙΕΡΓΕΙΑ, ΑΚΑΤΕΡΓΑΣΤΩΝ',
  },
  {
    label: '47778209',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΥΤΙΜΩΝ ΛΙΘΩΝ ΚΑΙ ΚΟΣΜΗΜΑΤΩΝ ΑΠΟ ΠΟΛΥΤΙΜΟΥΣ ΛΙΘΟΥΣ',
  },
  {
    label: '47778210',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΟΛΟΓΙΩΝ ΧΕΡΙΟΥ Η ΤΣΕΠΗΣ, ΜΕ ΘΗΚΗ ΑΠΟ ΠΟΛΥΤΙΜΟ ΜΕΤΑΛΛΟ Η ΕΠΙΜΕΤΑΛΛΩΜΕΝΗ ΜΕ ΠΟΛΥΤΙΜΟ ΜΕΤΑΛΛΟ',
  },
  {
    label: '47778211',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΚΕΥΩΝ ΑΠΟ ΑΡΓΥΡΟ',
  },
  {
    label: '47778212',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΚΑΤΑΓΡΑΦΗΣ, ΜΕΤΡΗΣΗΣ ΤΗΣ ΩΡΑΣ, ΠΑΡΚΟΜΕΤΡΩΝ ΚΑΙ ΧΡΟΝΟΔΙΑΚΟΠΤΩΝ ΜΕ ΜΗΧΑΝΙΣΜΟ ΡΟΛΟΓΙΟΥ ΤΟΙΧΟΥ Η ΧΕΡΙΟΥ',
  },
  {
    label: '47778213',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΩΝ ΜΑΡΓΑΡΙΤΑΡΙΩΝ, ΑΚΑΤΕΡΓΑΣΤΩΝ',
  },
  {
    label: '47778214',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΚΕΥΩΝ ΕΠΙΜΕΤΑΛΛΩΜΕΝΩΝ ΜΕ ΧΡΥΣΟ Η ΑΡΓΥΡΟ',
  },
  {
    label: '47780000',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΙΝΟΥΡΓΙΩΝ ΕΙΔΩΝ ΣΕ ΕΞΕΙΔΙΚΕΥΜΕΝΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47788300',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΟΥ ΚΑΙ ΟΠΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΑΚΡΙΒΕΙΑΣ, ΥΠΗΡΕΣΙΕΣ ΟΠΤΙΚΟΥ',
  },
  {
    label: '47788301',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΟΠΤΙΚΩΝ ΣΥΣΚΕΥΩΝ ΚΑΙ ΟΡΓΑΝΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47788302',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΤΟΠΟΓΡΑΦΙΚΩΝ, ΥΔΡΟΓΡΑΦΙΚΩΝ, ΩΚΕΑΝΟΓΡΑΦΙΚΩΝ, ΥΔΡΟΛΟΓΙΚΩΝ, ΜΕΤΕΩΡΟΛΟΓΙΚΩΝ Η ΓΕΩΦΥΣΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '47788303',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΙΚΕΙΜΕΝΙΚΩΝ ΦΑΚΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΕΣ ΜΗΧΑΝΕΣ, ΜΗΧΑΝΕΣ ΠΡΟΒΟΛΗΣ Η ΦΩΤΟΓΡΑΦΙΚΕΣ ΣΥΣΚΕΥΕΣ ΜΕΓΕΘΥΝΣΗΣ Η ΣΜΙΚΡΥΝΣΗΣ',
  },
  {
    label: '47788304',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΥΑΙΣΘΗΤΟΠΟΙΗΜΕΝΩΝ ΓΑΛΑΚΤΩΜΑΤΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΗ ΧΡΗΣΗ, ΧΗΜΙΚΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΗ ΧΡΗΣΗ Π.Δ.Κ.Α.',
  },
  {
    label: '47788305',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΙΑΛΙΩΝ, ΜΟΝΟΚΙΑΛΙΩΝ ΚΑΙ ΑΛΛΩΝ ΟΠΤΙΚΩΝ ΤΗΛΕΣΚΟΠΙΩΝ, ΑΛΛΩΝ ΑΣΤΡΟΝΟΜΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΟΠΤΙΚΩΝ ΜΙΚΡΟΣΚΟΠΙΩΝ',
  },
  {
    label: '47788306',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΛΗΨΗΣ',
  },
  {
    label: '47788307',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΠΡΟΒΟΛΗΣ, ΕΠΙΔΙΑΣΚΟΠΙΩΝ ΚΑΙ ΑΛΛΩΝ ΠΡΟΒΟΛΕΩΝ ΕΙΚΟΝΩΝ',
  },
  {
    label: '47788308',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΤΟΓΥΑΛΙΩΝ ΜΗ ΚΑΤΕΡΓΑΣΜΕΝΩΝ ΟΠΤΙΚΩΣ ΚΑΙ ΜΕΡΩΝ ΓΙΑ ΤΗΝ ΚΑΤΑΣΚΕΥΗ ΤΕΤΟΙΩΝ ΓΥΑΛΙΩΝ',
  },
  {
    label: '47788309',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΤΟΓΥΑΛΙΩΝ, ΜΑΤΟΓΥΑΛΙΩΝ ΗΛΙΟΥ ΚΑΙ ΠΡΟΦΥΛΑΞΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΔΙΟΡΘΩΤΙΚΩΝ, ΠΡΟΣΤΑΤΕΥΤΙΚΩΝ Η ΑΛΛΩΝ',
  },
  {
    label: '47788310',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΛΛΩΝ ΟΠΤΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '47788311',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΦΩΤΟΓΡΑΦΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '47788312',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΣΚΕΛΕΤΩΝ ΚΑΙ ΥΠΟΣΤΗΡΙΓΜΑΤΩΝ ΜΑΤΟΓΥΑΛΙΩΝ, ΜΑΤΟΓΥΑΛΙΩΝ ΗΛΙΟΥ ΚΑΙ ΠΡΟΦΥΛΑΞΗΣ Η ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47788313',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΠΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47788314',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΠΤΙΚΩΝ ΙΝΩΝ, ΦΥΛΛΩΝ, ΠΛΑΚΩΝ ΑΠΟ ΠΟΛΩΤΙΚΟ ΥΛΙΚΟ, ΦΑΚΩΝ, ΦΙΛΤΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47788315',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΥΞΙΔΩΝ ΠΡΟΣΑΝΑΤΟΛΙΣΜΟΥ, ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΣΥΣΚΕΥΩΝ ΝΑΥΣΙΠΛΟΪΑΣ',
  },
  {
    label: '47788316',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΚΕΛΕΤΩΝ ΚΑΙ ΥΠΟΣΤΗΡΙΓΜΑΤΩΝ ΜΑΤΟΓΥΑΛΙΩΝ, ΜΑΤΟΓΥΑΛΙΩΝ ΗΛΙΟΥ ΚΑΙ ΠΡΟΦΥΛΑΞΗΣ Η ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47788317',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΣΚΕΥΩΝ ΜΕ ΥΓΡΟΥΣ ΚΡΥΣΤΑΛΛΟΥΣ, ΛΕΙΖΕΡ ΕΚΤΟΣ ΤΩΝ ΔΙΟΔΩΝ ΛΕΙΖΕΡ',
  },
  {
    label: '47788318',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΔΡΟΜΕΤΡΩΝ, ΘΕΡΜΟΜΕΤΡΩΝ, ΠΥΡΟΜΕΤΡΩΝ, ΒΑΡΟΜΕΤΡΩΝ, ΥΓΡΟΜΕΤΡΩΝ ΚΑΙ ΨΥΧΡΟΜΕΤΡΩΝ',
  },
  {
    label: '47788319',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΑΚΩΝ ΕΠΑΦΗΣ',
  },
  {
    label: '47788320',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΑΚΩΝ ΕΠΑΦΗΣ, ΦΑΚΩΝ ΜΑΤΟΓΥΑΛΙΩΝ ΑΠΟ ΓΥΑΛΙ, ΦΑΚΩΝ ΜΑΤΟΓΥΑΛΙΩΝ ΑΠΟ ΑΛΛΑ ΥΛΙΚΑ',
  },
  {
    label: '47788321',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΛΑΣ, ΦΩΤΟΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ ΜΕΓΕΘΥΝΣΗΣ, ΣΥΣΚΕΥΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΚΑ ΕΡΓΑΣΤΗΡΙΑ, ΝΕΓΚΑΤΟΣΚΟΠΙΩΝ ΚΑΙ ΟΘΟΝΩΝ ΠΡΟΒΟΛΗΣ',
  },
  {
    label: '47788322',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΩΝ ΚΑΙ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47788323',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΩΝ ΛΥΧΝΙΩΝ ΦΛΑΣ, \\ΚΥΒΩΝ\\ ΦΛΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47788324',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΑΜΕΣΗΣ ΕΚΤΥΠΩΣΗΣ ΚΑΙ ΕΜΦΑΝΙΣΗΣ ΚΑΙ ΑΛΛΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '47788325',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΓΙΑ ΤΗΝ ΠΡΟΕΤΟΙΜΑΣΙΑ ΕΚΤΥΠΩΤΙΚΩΝ ΠΛΑΚΩΝ Η ΚΥΛΙΝΔΡΩΝ, ΦΩΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ ΓΙΑ ΕΓΓΡΑΦΗ ΕΓΓΡΑΦΩΝ ΣΕ ΜΙΚΡΟΦΙΛΜ, ΜΙΚΡΟΦΩΤΟΔΕΛΤΙΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΕΙΔΗ',
  },
  {
    label: '47788326',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΩΝ ΠΛΑΚΩΝ ΚΑΙ ΦΙΛΜ, ΦΙΛΜ ΣΤΙΓΜΙΑΙΑΣ ΕΚΤΥΠΩΣΗΣ, ΕΥΑΙΣΘΗΤΟΠΟΙΗΜΕΝΩΝ, ΜΗ ΕΚΤΕΘΕΙΜΕΝΩΝ, ΦΩΤΟΓΡΑΦΙΚΟΥ ΧΑΡΤΙΟΥ',
  },
  {
    label: '47788400',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΛΙΚΩΝ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '47788401',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΥΠΑΝΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47788402',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΡΡΥΠΑΝΤΙΚΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΕΚΠΛΥΣΗΣ, ΟΧΙ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '47788403',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΣΜΗΤΙΚΩΝ ΧΩΡΟΥ',
  },
  {
    label: '47788404',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΑΖΕΛΙΝΗΣ, ΣΚΛΗΡΗΣ ΠΑΡΑΦΙΝΗΣ, ΠΕΤΡΕΛΑΙΟΥ ΚΑΙ ΑΛΛΩΝ ΟΡΥΚΤΩΝ ΚΕΡΙΩΝ',
  },
  {
    label: '47788405',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΑΦΩΝ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '47788406',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΦΑΝΕΙΟΔΡΑΣΤΙΚΩΝ ΟΡΓΑΝΙΚΩΝ ΟΥΣΙΩΝ, ΕΚΤΟΣ ΑΠΟ ΣΑΠΟΥΝΙ',
  },
  {
    label: '47788407',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΑΡΩΜΑΤΙΣΜΟ Η ΑΠΟΣΜΗΣΗ ΧΩΡΩΝ',
  },
  {
    label: '47788408',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΤΩΝ ΚΑΙ ΣΚΟΝΩΝ ΚΑΘΑΡΙΣΜΟΥ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '47788409',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΑΠΟΥΝΙΟΥ ΚΑΙ ΕΠΙΦΑΝΕΙΟΔΡΑΣΤΙΚΩΝ ΟΡΓΑΝΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΩΣ ΣΑΠΟΥΝΙ, ΟΧΙ ΓΙΑ ΠΡΟΣΩΠΙΚΗ ΥΓΙΕΙΝΗ',
  },
  {
    label: '47788410',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΤΙΛΒΩΤΙΚΩΝ ΟΥΣΙΩΝ ΚΑΙ ΚΡΕΜΩΝ ΓΙΑ ΥΠΟΔΗΜΑΤΑ, ΕΠΙΠΛΑ, ΔΑΠΕΔΑ, ΑΜΑΞΩΜΑΤΑ, ΓΥΑΛΙ Η ΜΕΤΑΛΛΟ',
  },
  {
    label: '47788411',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ ΚΕΡΙΩΝ ΚΑΙ ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΚΕΡΙΩΝ',
  },
  {
    label: '47788500',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΟΥ ΠΕΤΡΕΛΑΙΟΥ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ, ΥΓΡΑΕΡΙΟΥ, ΑΝΘΡΑΚΑ ΚΑΙ ΞΥΛΕΙΑΣ',
  },
  {
    label: '47788501',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΕΡΙΕΛΑΙΩΝ',
  },
  {
    label: '47788502',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΛΑΦΡΩΝ ΕΛΑΙΩΝ ΠΕΤΡΕΛΑΙΟΥ, ΕΛΑΦΡΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47788503',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΣΑΙΩΝ ΕΛΑΙΩΝ ΠΕΤΡΕΛΑΙΟΥ, ΜΕΣΑΙΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47788504',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΘΡΑΚΑ, ΜΗ ΣΥΣΣΩΜΑΤΩΜΕΝΟΥ',
  },
  {
    label: '47788505',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΚΑΥΣΙΜΩΝ, ΟΧΙ ΓΙΑ ΚΙΝΗΤΗΡΕΣ',
  },
  {
    label: '47788506',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΩΝ ΕΛΑΙΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47788507',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΩΝ ΥΛΩΝ (ΥΓΡΩΝ ΚΑΙ ΣΤΕΡΕΩΝ)',
  },
  {
    label: '47788508',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΟΞΥΛΩΝ',
  },
  {
    label: '47788509',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΙΓΝΙΤΗ',
  },
  {
    label: '47788510',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΠΡΙΚΕΤΩΝ, ΚΑΤΑΣΚΕΥΑΣΜΕΝΩΝ ΑΠΟ ΤΥΡΦΗ',
  },
  {
    label: '47788511',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΠΡΙΚΕΤΩΝ, ΣΦΑΙΡΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΣΤΕΡΕΩΝ ΚΑΥΣΙΜΩΝ ΠΟΥ ΠΑΡΑΓΟΝΤΑΙ ΑΠΟ ΤΟΝ ΑΝΘΡΑΚΑ',
  },
  {
    label: '47788512',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΑΝΘΡΑΚΑ, ΚΑΥΣΙΜΟΥ',
  },
  {
    label: '47788513',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΕΙΑΣ ΣΕ ΠΕΛΕΚΟΥΔΙΑ Η ΣΕ ΜΟΡΙΑ',
  },
  {
    label: '47788514',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΠΤΑΝΘΡΑΚΑ ΚΑΙ ΗΜΙΟΠΤΑΝΘΡΑΚΑ ΑΠΟ ΛΙΘΑΝΘΡΑΚΑ, ΑΠΟ ΛΙΓΝΙΤΗ Η ΤΥΡΦΗ, ΑΝΘΡΑΚΑ ΑΠΟΣΤΑΚΤΙΚΟΥ ΚΕΡΑΤΟΣ',
  },
  {
    label: '47788515',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΤΡΕΛΑΙΟΥ ΘΕΡΜΑΝΣΗΣ, (ΠΑΡΑΔΟΣΗ ΣΤΗΝ ΕΓΚΑΤΑΣΤΑΣΗ ΤΟΥ ΠΩΛΗΤΗ)',
  },
  {
    label: '47788516',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΤΡΕΛΑΙΟΥ ΘΕΡΜΑΝΣΗΣ, ΑΠΟ ΜΕΤΑΠΩΛΗΤΗ',
  },
  {
    label: '47788517',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΠΑΝΙΟΥ ΚΑΙ ΒΟΥΤΑΝΙΟΥ, ΕΜΦΙΑΛΩΜΕΝΟΥ',
  },
  {
    label: '47788518',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΓΡΑΕΡΙΟΥ ΣΕ ΦΙΑΛΕΣ Η ΟΧΙ',
  },
  {
    label: '47788519',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ, ΥΓΡΟΠΟΙΗΜΕΝΟΥ Η ΣΕ ΑΕΡΙΩΔΗ ΚΑΤΑΣΤΑΣΗ',
  },
  {
    label: '47788600',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗ ΕΔΩΔΙΜΩΝ ΚΑΤΑΝΑΛΩΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47788601',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΓΑΛΜΑΤΙΩΝ ΚΑΙ ΑΛΛΩΝ ΕΙΔΩΝ ΔΙΑΚΟΣΜΗΣΗΣ, ΚΑΔΡΩΝ ΓΙΑ ΦΩΤΟΓΡΑΦΙΕΣ, ΠΙΝΑΚΕΣ Η ΠΑΡΟΜΟΙΑ ΕΙΔΗ ΚΑΙ ΚΑΘΡΕΠΤΩΝ, ΑΠΟ ΒΑΣΙΚΑ ΜΕΤΑΛΛΑ',
  },
  {
    label: '47788602',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΑΥΤΟΚΟΛΛΗΤΩΝ ΤΑΙΝΙΩΝ, ΠΛΑΚΩΝ, ΛΩΡΙΔΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ, ΤΑΙΝΙΩΝ ΣΕ ΡΟΛΑ ΚΑΙ ΑΛΛΩΝ ΤΑΙΝΙΩΝ ΣΕ ΕΠΙΠΕΔΕΣ ΜΟΡΦΕΣ, ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '47788603',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΔΕΡΜΑ Η ΣΥΝΘΕΤΙΚΑ ΔΕΡΜΑΤΑ (ΕΙΔΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΕ ΜΗΧΑΝΗΜΑΤΑ Η ΑΛΛΕΣ ΜΗΧΑΝΙΚΕΣ ΣΥΣΚΕΥΕΣ)',
  },
  {
    label: '47788604',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΓΑΜΟΥ ΚΑΙ ΒΑΠΤΙΣΤΙΚΩΝ (ΛΑΜΠΑΔΩΝ, ΣΤΕΦΑΝΩΝ ΚΛΠ)',
  },
  {
    label: '47788605',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΚΕΡΑΜΙΚΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47788606',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ',
  },
  {
    label: '47788607',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΛΑΣΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΣΥΣΚΕΥΑΣΙΑΣ',
  },
  {
    label: '47788608',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΟΛΥΤΕΛΩΝ ΜΙΚΡΟΑΝΤΙΚΕΙΜΕΝΩΝ, ΟΧΙ ΑΠΟ ΠΟΛΥΤΙΜΑ ΜΕΤΑΛΛΑ Η ΛΙΘΟΥΣ',
  },
  {
    label: '47788609',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΟΥΜΙΝΟΧΑΡΤΟΥ',
  },
  {
    label: '47788610',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟΜΙΜΗΣΕΩΝ ΚΟΣΜΗΜΑΤΩΝ',
  },
  {
    label: '47788611',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΙΟΜΗΧΑΝΙΚΩΝ ΔΙΑΜΑΝΤΙΩΝ, ΚΙΣΗΡΟΛΙΘΩΝ (ΕΛΑΦΡΟΠΕΤΡΩΝ), ΣΜΥΡΙΔΑΣ, ΦΥΣΙΚΟΥ ΚΟΡΟΥΝΔΙΟΥ, ΦΥΣΙΚΟΥ ΓΡΑΝΑΤΗ ΚΑΙ ΑΛΛΩΝ ΦΥΣΙΚΩΝ ΛΕΙΑΝΤΙΚΩΝ',
  },
  {
    label: '47788612',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΚΕΡΙΩΝ',
  },
  {
    label: '47788613',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΑΛΛΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47788614',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΧΤΥΩΝ ΜΕ ΚΟΜΠΟΥΣ ΑΠΟ ΣΠΑΓΓΟΥΣ, ΚΟΡΔΟΝΙΩΝ Η ΣΧΟΙΝΙΩΝ, ΕΤΟΙΜΩΝ ΔΙΧΤΥΩΝ, ΑΠΟ ΥΦΑΝΤΙΚΑ ΥΛΙΚΑ, ΕΙΔΩΝ ΑΠΟ ΝΗΜΑΤΑ, ΛΩΡΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47788615',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΔΙΑΚΟΣΜΗΣΗΣ ΕΣΩΤΕΡΙΚΩΝ ΧΩΡΩΝ',
  },
  {
    label: '47788616',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΚΚΛΗΣΙΑΣΤΙΚΩΝ ΕΙΔΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47788617',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΕΡΙΩΝ, ΚΗΡΩΜΕΝΩΝ ΦΙΤΙΛΙΩΝ ΦΩΤΙΣΜΟΥ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47788618',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΡΑΛΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ, ΟΣΤΡΑΚΩΝ ΜΑΛΑΚΙΩΝ, ΚΑΡΚΙΝΟΕΙΔΩΝ Η ΕΧΙΝΟΔΕΡΜΩΝ ΚΑΙ ΟΣΤΩΝ ΣΟΥΠΙΩΝ',
  },
  {
    label: '47788619',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΥΜΑΤΟΕΙΔΟΥΣ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ ΣΕ ΚΥΛΙΝΔΡΟΥΣ Η ΣΕ ΦΥΛΛΑ',
  },
  {
    label: '47788620',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΑΡΓΙΛΙΟΥ, ΠΑΧΟΥΣ >= 0 ;.2 ~ MM',
  },
  {
    label: '47788621',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΣΟΥΡΙΩΝ, ΚΑΡΟΥΛΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ, ΔΙΗΘΗΤΙΚΟΥ ΧΑΡΤΙΟΥ ΚΑΙ ΧΑΡΤΟΝΙΟΥ, ΑΛΛΩΝ ΕΙΔΩΝ ΑΠΟ ΧΑΡΤΙ ΚΑΙ ΧΑΡΤΟΝΙ Π.Δ.Κ.Α.',
  },
  {
    label: '47788622',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ;ΜΕΤΑ ΑΠΟ ΕΙΣΑΓΩΓΗ; ΨΕΥΔΟΚΟΣΜΗΜΑΤΩΝ',
  },
  {
    label: '47788623',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΔΙΚΩΝ ΚΑΡΟΤΣΙΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '47788624',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΟΥΚΩΝ ΚΑΙ ΠΟΣΤΙΣ',
  },
  {
    label: '47788625',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΙΝΕΛΩΝ ΖΩΓΡΑΦΙΚΗΣ ΚΑΙ ΓΡΑΦΗΣ',
  },
  {
    label: '47788626',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΚΩΝ, ΦΥΛΛΩΝ, ΜΕΜΒΡΑΝΩΝ, ΛΕΠΤΩΝ ΦΥΛΛΩΝ ΚΑΙ ΛΩΡΙΔΩΝ, ΑΠΟ ΠΛΑΣΤΙΚΕΣ ΥΛΕΣ, ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΕΝΙΣΧΥΜΕΝΕΣ Η ΚΑΤΑ ΠΑΡΟΜΟΙΟ ΤΡΟΠΟ ΣΥΝΔΥΑΣΜΕΝΕΣ ΜΕ ΑΛΛΑ ΥΛΙΚΑ',
  },
  {
    label: '47788627',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΛΑΣΤΕΛΙΝΗΣ',
  },
  {
    label: '47788628',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΤΩΝ ΠΡΟΠΛΑΣΜΑΤΩΝ, ΟΔΟΝΤΙΑΤΡΙΚΟΥ ΚΗΡΟΥ ΚΑΙ ΑΛΛΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΓΙΑ ΟΔΟΝΤΙΑΤΡΙΚΗ ΧΡΗΣΗ ΜΕ ΒΑΣΗ ΤΟ ΓΥΨΟ, ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΚΑΙ ΓΟΜΩΣΕΩΝ ΓΙΑ ΠΥΡΟΣΒΕΣΤΗΡΕΣ, ΠΑΡΑΣΚΕΥΑΣΜΕΝΩΝ ΜΕΣΩΝ ΚΑΛΛΙΕΡΓΕΙΑΣ ΓΙΑ ΤΗΝ ΑΝΑΠΤΥΞΗ ΜΙΚΡΟΟΡΓΑΝΙΣΜΩΝ ΚΑ',
  },
  {
    label: '47788629',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΑΝΘΡΩΠΙΝΕΣ Η ΖΩΙΚΕΣ ΤΡΙΧΕΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ ΑΠΟ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΕΣ ΙΝΕΣ',
  },
  {
    label: '47788630',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΠΑΓΓΩΝ, ΚΟΡΔΟΝΙΩΝ, ΣΧΟΙΝΙΩΝ ΚΑΙ ΚΑΛΩΔΙΩΝ, ΑΠΟ ΓΙΟΥΤΑ Η ΑΛΛΕΣ ΥΦΑΝΤΙΚΕΣ ΙΝΕΣ ΑΠΟ ΣΤΕΛΕΧΗ ΦΥΤΩΝ',
  },
  {
    label: '47788631',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΕΧΝΗΤΩΝ ΑΝΘΕΩΝ, ΔΙΑΚΟΣΜΗΤΙΚΩΝ ΦΥΛΛΩΜΑΤΩΝ ΚΑΙ ΦΡΟΥΤΩΝ ΚΑΙ ΜΕΡΩΝ ΤΟΥΣ',
  },
  {
    label: '47788632',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΤΕΡΩΝ ΚΑΙ ΠΟΥΠΟΥΛΩΝ ΚΑΙ ΔΕΡΜΑΤΩΝ ΠΟΥΛΙΩΝ ΜΕ ΦΤΕΡΑ ΚΑΙ ΠΟΥΠΟΥΛΑ',
  },
  {
    label: '47788700',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΩΝ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47788800',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '47788801',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΓΡΟΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ, ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ',
  },
  {
    label: '47788802',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗΧΑΝΩΝ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '47788803',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΑΓΝΩΣΤΩΝ ΜΙΚΡΟΦΙΛΜ, ΜΙΚΡΟΦΩΤΟΔΕΛΤΙΩΝ Η ΑΛΛΩΝ ΜΙΚΡΟΦΟΡΜΩΝ',
  },
  {
    label: '47788804',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΑΛΛΑΚΤΙΚΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΑΝΕΛΚΥΣΤΗΡΩΝ',
  },
  {
    label: '47788805',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΛΗΤΙΚΩΝ ΣΥΓΚΡΟΤΗΜΑΤΩΝ',
  },
  {
    label: '47788806',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΛΙΩΝ ΓΙΑ ΥΓΡΑ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΑΝΤΛΙΩΝ ΣΚΥΡΟΔΕΜΑΤΟΣ, ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΑΥΤΟΚΙΝΗΤΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '47788807',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΝΤΛΙΩΝ ΚΕΝΟΥ',
  },
  {
    label: '47788808',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΡΔΕΥΤΙΚΩΝ ΣΥΓΚΡΟΤΗΜΑΤΩΝ',
  },
  {
    label: '47788809',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΡΙΘΜΟΜΗΧΑΝΩΝ ΚΑΙ ΛΟΓΙΣΤΙΚΩΝ ΜΗΧΑΝΩΝ, ΤΑΜΙΑΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗΧΑΝΩΝ ΠΟΥ ΦΕΡΟΥΝ ΥΠΟΛΟΓΙΣΤΙΚΗ ΔΙΑΤΑΞΗ',
  },
  {
    label: '47788810',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΡΑΦΟΜΗΧΑΝΩΝ ΚΑΙ ΜΗΧΑΝΩΝ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΕΙΜΕΝΟΥ',
  },
  {
    label: '47788811',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΚΤΥΠΩΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ OFFSET, ΤΥΠΟΥ ΓΡΑΦΕΙΟΥ, ΠΟΥ ΤΡΟΦΟΔΟΤΟΥΝΤΑΙ ΜΕ ΦΥΛΛΑ ΧΑΡΤΙΟΥ',
  },
  {
    label: '47788812',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΑΝΥΨΩΣΗΣ ΚΑΙ ΔΙΑΚΙΝΗΣΗΣ ΦΟΡΤΙΩΝ',
  },
  {
    label: '47788813',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΟΜΗΧΑΝΩΝ',
  },
  {
    label: '47788814',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΗΧΑΝΩΝ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '47788815',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΦΩΤΟΑΝΤΙΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '47788816',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΡΓΑΝΩΝ ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47788817',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΙΣΤΡΟΦΩΝ, ΠΙΣΤΟΛΙΩΝ, ΑΛΛΩΝ ΠΥΡΟΒΟΛΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗΧΑΝΗΜΑΤΩΝ, ΑΛΛΩΝ ΟΠΛΩΝ (ΕΚΤΟΣ ΑΥΤΩΝ ΓΙΑ ΚΥΝΗΓΙ Η ΑΘΛΗΤΙΣΜΟ)',
  },
  {
    label: '47788818',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΥΡΟΣΒΕΣΤΗΡΩΝ',
  },
  {
    label: '47788819',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΟΡΝΩΝ ΚΑΙ ΑΛΛΩΝ ΜΗΧΑΝΩΝ ΓΙΑ ΚΑΜΨΗ, ΔΙΠΛΩΣΗ, ΙΣΙΩΜΑ, ΕΠΙΠΕΔΟΠΟΙΗΣΗ ΚΑΙ ΑΦΑΙΡΕΣΗ ΜΕΤΑΛΛΟΥ',
  },
  {
    label: '47788820',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΡΑΠΕΖΙΩΝ ΚΑΙ ΜΗΧΑΝΩΝ ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΑΛΛΩΝ ΟΡΓΑΝΩΝ ΣΧΕΔΙΑΣΗΣ, ΧΑΡΑΞΗΣ Η ΔΙΕΝΕΡΓΕΙΑΣ ΜΑΘΗΜΑΤΙΚΩΝ ΥΠΟΛΟΓΙΣΜΩΝ',
  },
  {
    label: '47788821',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΙΛΤΡΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ ΚΑΘΑΡΙΣΜΟΥ ΝΕΡΟΥ Η ΑΕΡΑ',
  },
  {
    label: '47788822',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΑΝΤΙΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ ΜΕ ΟΠΤΙΚΟ ΣΥΣΤΗΜΑ Η ΜΕ ΕΠΑΦΗ ΚΑΙ ΘΕΡΜΟΑΝΤΙΓΡΑΦΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '47788823',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΕΙΡΟΚΙΝΗΤΩΝ Η ΠΟΔΟΚΙΝΗΤΩΝ ΑΕΡΑΝΤΛΙΩΝ',
  },
  {
    label: '47788824',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΕΚΑΣΤΗΡΩΝ, ΜΗΧΑΝΩΝ ΑΤΜΟΒΟΛΗΣ Η ΑΜΜΟΒΟΛΗΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΜΗΧΑΝΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΕΚΤΟΣ ΤΩΝ ΣΥΣΚΕΥΩΝ ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΗ ΓΕΩΡΓΙΑ',
  },
  {
    label: '47788900',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΕΔΩΔΙΜΩΝ ΜΗ ΚΑΤΑΝΑΛΩΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '47788901',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΓΧΟΡΔΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '47788902',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '47788903',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΣΥΛΛΕΚΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47788904',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΙΑΦΟΡΩΝ ΤΟΥΡΙΣΤΙΚΩΝ ΚΑΙ ΛΟΙΠΩΝ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΛΑΪΚΗΣ ΤΕΧΝΗΣ',
  },
  {
    label: '47788905',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΚΚΛΗΣΙΑΣΤΙΚΩΝ ΟΡΓΑΝΩΝ ΜΕ ΚΛΙΜΑΚΑ ΠΛΗΚΤΡΩΝ, ΑΡΜΟΝΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΟΡΓΑΝΩΝ, ΑΚΟΡΝΤΕΟΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΟΡΓΑΝΩΝ, ΦΥΣΑΡΜΟΝΙΚΩΝ',
  },
  {
    label: '47788906',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΩΝ ΤΕΧΝΗΣ',
  },
  {
    label: '47788907',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΙΕΡΟΓΡΑΦΙΩΝ, ΖΩΓΡΑΦΙΣΤΩΝ ΕΙΚΟΝΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47788908',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΡΩΝ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '47788909',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΡΟΝΟΜΩΝ, ΔΙΑΠΑΣΩΝ ΚΑΙ ΠΝΕΥΣΤΩΝ ΔΙΑΠΑΣΩΝ, ΜΗΧΑΝΙΣΜΩΝ ΓΙΑ ΜΟΥΣΙΚΑ ΚΟΥΤΙΑ ΚΑΙ ΧΟΡΔΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '47788910',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΥΣΙΚΗΣ ΣΕ ΕΝΤΥΠΗ ΜΟΡΦΗ (ΠΑΡΤΙΤΟΥΡΩΝ)',
  },
  {
    label: '47788911',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '47788912',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ Η ΟΡΓΑΝΩΝ ΜΕ ΚΛΙΜΑΚΑ ΠΛΗΚΤΡΩΝ, Ο ΗΧΟΣ ΤΩΝ ΟΠΟΙΩΝ ΠΑΡΑΓΕΤΑΙ Η ΠΡΕΠΕΙ ΝΑ ΕΝΙΣΧΥΕΤΑΙ ΜΕ ΗΛΕΚΤΡΙΚΑ ΜΕΣΑ',
  },
  {
    label: '47788913',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΝΟΜΙΣΜΑΤΩΝ ΚΑΙ ΜΕΤΑΛΛΙΩΝ',
  },
  {
    label: '47788914',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΛΑΙΩΝ ΓΡΑΜΜΑΤΟΣΗΜΩΝ',
  },
  {
    label: '47788915',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΙΑΝΩΝ ΚΑΙ ΑΛΛΩΝ ΕΓΧΟΡΔΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ ΜΕ ΚΛΙΜΑΚΑ ΠΛΗΚΤΡΩΝ',
  },
  {
    label: '47788916',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΙΝΑΚΩΝ ΖΩΓΡΑΦΙΚΗΣ ΓΕΝΙΚΑ',
  },
  {
    label: '47788917',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΝΕΥΣΤΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '47788918',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΛΛΟΓΩΝ ΓΡΑΜΜΑΤΟΣΗΜΩΝ ΚΑΙ ΝΟΜΙΣΜΑΤΩΝ',
  },
  {
    label: '47788919',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΡΥΣΩΝ ΚΑΙ ΛΟΙΠΩΝ ΝΟΜΙΣΜΑΤΩΝ',
  },
  {
    label: '47790000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΕΙΔΩΝ ΣΕ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '47799100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΛΑΙΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ ΑΞΙΑΣ (ΑΝΤΙΚΩΝ)',
  },
  {
    label: '47799101',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΡΧΑΙΟΤΗΤΩΝ ΚΑΙ ΓΕΝΙΚΑ ΠΑΛΑΙΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ ΤΕΧΝΗΣ',
  },
  {
    label: '47799102',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΥΛΛΕΚΤΙΚΩΝ ΕΙΔΩΝ ΑΞΙΑΣ',
  },
  {
    label: '47799200',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΒΙΒΛΙΩΝ',
  },
  {
    label: '47799900',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47799901',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '47799902',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΗΛΕΚΤΡΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47799903',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47799904',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΣΙΔΕΡΕΝΙΩΝ ΒΑΡΕΛΙΩΝ',
  },
  {
    label: '47799905',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΘΑΡΜΕΝΩΝ ΕΙΔΩΝ ΡΟΥΧΙΣΜΟΥ ΚΑΙ ΑΛΛΩΝ ΦΘΑΡΜΕΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47810000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ, ΣΕ ΥΠΑΙΘΡΙΟΥΣ ΠΑΓΚΟΥΣ ΚΑΙ ΑΓΟΡΕΣ',
  },
  {
    label: '47820000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΥΠΟΔΗΜΑΤΩΝ, ΣΕ ΥΠΑΙΘΡΙΟΥΣ ΠΑΓΚΟΥΣ ΚΑΙ ΑΓΟΡΕΣ',
  },
  {
    label: '47890000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΕΙΔΩΝ ΣΕ ΥΠΑΙΘΡΙΟΥΣ ΠΑΓΚΟΥΣ ΚΑΙ ΑΓΟΡΕΣ',
  },
  {
    label: '47910000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟ ΕΠΙΧΕΙΡΗΣΕΙΣ ΠΩΛΗΣΕΩΝ ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47911000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΡΟΥΤΩΝ, ΛΑΧΑΝΙΚΩΝ, ΚΡΕΑΤΟΣ, ΨΑΡΙΩΝ, ΠΡΟΪΟΝΤΩΝ ΑΡΤΟΠΟΙΙΑΣ, ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΑΒΓΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47911100',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΝΩΠΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47911200',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΠΟΙΗΜΕΝΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47911300',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47911400',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47911500',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ, ΟΣΤΡΑΚΟΕΙΔΩΝ ΚΑΙ ΜΑΛΑΚΙΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47911600',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΑΡΤΟΠΟΙΙΑΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47911700',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ ΜΕ ΒΑΣΗ ΤΗ ΖΑΧΑΡΗ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47911800',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47911900',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΒΓΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47912000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47912100',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΦΕ, ΤΣΑΓΙΟΥ, ΚΑΚΑΟΥ ΚΑΙ ΜΠΑΧΑΡΙΚΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47912200',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΡΩΣΙΜΩΝ ΕΛΑΙΩΝ ΚΑΙ ΛΙΠΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47912300',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΡΟΦΙΜΩΝ ΓΙΑ ΒΡΕΦΗ, ΤΡΟΦΙΜΩΝ ΔΙΑΙΤΗΣ ΚΑΙ ΑΛΛΩΝ ΟΜΟΓΕΝΟΠΟΙΗΜΕΝΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΔΙΑΤΡΟΦΗΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47912400',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΤΡΟΦΙΜΩΝ Π.Δ.Κ.Α., ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47912500',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47912600',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΟΤΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47912700',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΚΑΠΝΟΥ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47913000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΕΠΙΚΟΙΝΩΝΙΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47913100',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ, ΠΕΡΙΦΕΡΕΙΑΚΩΝ ΜΟΝΑΔΩΝ ΚΑΙ ΛΟΓΙΣΜΙΚΟΥ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47913200',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47913300',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΧΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΒΙΝΤΕΟ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47914000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΥΛΙΚΩΝ ΚΑΙ ΣΙΔΗΡΙΚΩΝ Π.Δ.Κ.Α., ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47914100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΙΚΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47914200',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΡΩΜΑΤΩΝ, ΒΕΡΝΙΚΙΩΝ ΚΑΙ ΛΟΥΣΤΡΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47914300',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΕΔΩΝ ΤΖΑΜΙΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47914400',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΤΟ ΓΡΑΣΙΔΙ ΚΑΙ ΤΟΝ ΚΗΠΟ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47914500',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΔΡΑΥΛΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΘΕΡΜΑΝΣΗΣ, ΚΑΘΩΣ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47914600',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47914700',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47914900',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΥΛΙΚΩΝ Π.Δ.Κ.Α., ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47915000',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47915100',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47915200',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΡΤΙΝΩΝ ΚΑΙ ΔΙΧΤΥΩΤΩΝ ΚΟΥΡΤΙΝΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47915300',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΤΟΙΧΟΣΤΡΩΣΙΑΣ (ΤΑΠΕΤΣΑΡΙΑΣ) ΚΑΙ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΟΥ, ΧΑΛΙΩΝ ΚΑΙ ΚΙΛΙΜΙΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47915400',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47915500',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΛΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47915600',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΙΣΤΙΚΩΝ ΕΙΔΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47915700',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΕΙΔΩΝ, ΕΙΔΩΝ ΑΠΟ ΦΕΛΛΟ ΚΑΙ ΕΙΔΩΝ ΚΑΛΑΘΟΠΛΕΚΤΙΚΗΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47915800',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΠΑΡΤΙΤΟΥΡΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47915900',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΧΑΙΡΟΠΙΡΟΥΝΩΝ, ΠΙΑΤΙΚΩΝ, ΓΥΑΛΙΚΩΝ, ΕΙΔΩΝ ΠΟΡΣΕΛΑΝΗΣ ΚΑΙ ΑΓΓΕΙΟΠΛΑΣΤΙΚΗΣ ΚΑΙ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ, ΕΙΔΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α., ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47916000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΙΤΙΣΤΙΚΩΝ ΚΑΙ ΨΥΧΑΓΩΓΙΚΩΝ ΕΙΔΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47916100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΙΒΛΙΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47916200',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΦΗΜΕΡΙΔΩΝ ΚΑΙ ΠΕΡΙΟΔΙΚΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47916300',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΚΩΝ ΕΙΔΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47916400',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΓΓΡΑΦΩΝ ΜΟΥΣΙΚΗΣ ΚΑΙ ΒΙΝΤΕΟ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47916500',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΘΛΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47916600',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΚΑΤΑΣΚΗΝΩΣΗΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47916700',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΧΝΙΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47916800',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΡΑΜΜΑΤΟΣΗΜΩΝ ΚΑΙ ΝΟΜΙΣΜΑΤΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47916900',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΛΙΤΕΧΝΙΚΩΝ ΚΑΙ ΑΝΑΜΝΗΣΤΙΚΩΝ ΕΙΔΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47917000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΙΜΑΤΙΣΜΟΥ, ΙΑΤΡΟΦΑΡΜΑΚΕΥΤΙΚΩΝ ΕΙΔΩΝ, ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ, ΛΟΥΛΟΥΔΙΩΝ, ΦΥΤΩΝ, ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ ΚΑΙ ΤΡΟΦΩΝ ΓΙΑ ΖΩΑ ΣΥΝΤΡΟΦΙΑΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47917100',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΙΜΑΤΙΣΜΟΥ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47917200',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47917300',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΤΑΞΙΔΙΟΥ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47917400',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΕΙΔΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47917500',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΙΑΤΡΙΚΩΝ ΚΑΙ ΟΡΘΟΠΕΔΙΚΩΝ ΕΙΔΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47917600',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΛΥΝΤΙΚΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47917700',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΛΟΥΔΙΩΝ, ΦΥΤΩΝ ΚΑΙ ΣΠΟΡΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47917800',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΙΠΑΣΜΑΤΩΝ ΚΑΙ ΑΓΡΟΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47917900',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ ΚΑΙ ΤΡΟΦΩΝ ΓΙΑ ΖΩΑ ΣΥΝΤΡΟΦΙΑΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47918000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΩΝ ΓΙΑ ΟΧΗΜΑΤΑ ΚΑΙ ΑΛΛΩΝ ΝΕΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ Π.Δ.Κ.Α., ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47918100',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΩΝ ΓΙΑ ΟΧΗΜΑΤΑ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47918200',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΟΛΟΓΙΩΝ ΚΑΙ ΚΟΣΜΗΜΑΤΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47918300',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΟΥ ΚΑΙ ΟΠΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΑΚΡΙΒΕΙΑΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47918400',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΛΙΚΩΝ ΚΑΘΑΡΙΣΜΟΥ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47918500',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΤΡΕΛΑΙΟΥ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ, ΥΓΡΑΕΡΙΟΥ, ΑΝΘΡΑΚΑ ΚΑΙ ΞΥΛΕΙΑΣ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47918600',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗ ΕΔΩΔΙΜΩΝ ΚΑΤΑΝΑΛΩΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α., ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47918700',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΩΝ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α., ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47918800',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α., ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47918900',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΕΔΩΔΙΜΩΝ ΜΗ ΚΑΤΑΝΑΛΩΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α., ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47919000',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΚΑΙ ΜΗ ΕΞΕΙΔΙΚΕΥΜΕΝΩΝ ΕΙΔΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47919100',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΛΑΙΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ ΑΞΙΑΣ (ΑΝΤΙΚΩΝ), ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47919200',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΒΙΒΛΙΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47919300',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΕΙΔΩΝ, ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '47919900',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΠΟ ΕΠΙΧΕΙΡΗΣΕΙΣ ΠΩΛΗΣΕΩΝ ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ Η ΜΕΣΩ ΔΙΑΔΙΚΤΥΟΥ ΜΗ ΕΞΕΙΔΙΚΕΥΜΕΝΩΝ ΑΓΑΘΩΝ',
  },
  {
    label: '47919901',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΣΩ ΤΗΛΕΠΩΛΗΣΕΩΝ ~ ΤΗΛΕΜΑΡΚΕΤΙΝΓΚ ΔΙΑΦΟΡΩΝ ΑΓΑΘΩΝ, ΓΙΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ',
  },
  {
    label: '47990000',
    value: 'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47991000',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΡΟΥΤΩΝ, ΛΑΧΑΝΙΚΩΝ, ΚΡΕΑΤΟΣ, ΨΑΡΙΩΝ, ΠΡΟΪΟΝΤΩΝ ΑΡΤΟΠΟΙΙΑΣ, ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΚΑΙ ΑΒΓΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47991100',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΝΩΠΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47991101',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΙΟΔΕΥΟΝΤΑ ΕΜΠΟΡΟΥ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ',
  },
  {
    label: '47991200',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΠΟΙΗΜΕΝΩΝ ΦΡΟΥΤΩΝ ΚΑΙ ΛΑΧΑΝΙΚΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47991300',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΡΕΑΤΟΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47991400',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΚΡΕΑΤΟΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47991500',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΨΑΡΙΩΝ, ΟΣΤΡΑΚΟΕΙΔΩΝ ΚΑΙ ΜΑΛΑΚΙΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47991600',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΑΡΤΟΠΟΙΙΑΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47991601',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΠΡΟΪΟΝΤΩΝ ΑΡΤΟΠΟΙΙΑΣ, ΜΕΣΩ ΑΥΤΟΜΑΤΩΝ ΠΩΛΗΤΩΝ',
  },
  {
    label: '47991700',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ ΜΕ ΒΑΣΗ ΤΗ ΖΑΧΑΡΗ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47991701',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΕΙΔΩΝ ΖΑΧΑΡΟΠΛΑΣΤΙΚΗΣ, ΜΕΣΩ ΑΥΤΟΜΑΤΩΝ ΠΩΛΗΤΩΝ',
  },
  {
    label: '47991800',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΑΛΑΚΤΟΚΟΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47991900',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΒΓΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47992000',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΡΟΪΟΝΤΩΝ ΤΡΟΦΙΜΩΝ, ΠΟΤΩΝ ΚΑΙ ΚΑΠΝΟΥ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47992100',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΦΕ, ΤΣΑΓΙΟΥ, ΚΑΚΑΟΥ ΚΑΙ ΜΠΑΧΑΡΙΚΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47992101',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΟΦΗΜΑΤΩΝ, ΜΕΣΩ ΑΥΤΟΜΑΤΩΝ ΠΩΛΗΤΩΝ',
  },
  {
    label: '47992102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΡΟΜΗΘΕΙΑΣ ΑΠΟ ΤΗ ΛΕΙΤΟΥΡΓΙΑ ΑΥΤΟΜΑΤΩΝ ΠΩΛΗΤΩΝ ΤΡΙΤΩΝ ΓΙΑ ΡΟΦΗΜΑΤΑ',
  },
  {
    label: '47992200',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΡΩΣΙΜΩΝ ΕΛΑΙΩΝ ΚΑΙ ΛΙΠΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47992300',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΡΟΦΙΜΩΝ ΓΙΑ ΒΡΕΦΗ, ΤΡΟΦΙΜΩΝ ΔΙΑΙΤΗΣ ΚΑΙ ΑΛΛΩΝ ΟΜΟΓΕΝΟΠΟΙΗΜΕΝΩΝ ΠΑΡΑΣΚΕΥΑΣΜΑΤΩΝ ΔΙΑΤΡΟΦΗΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47992400',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΤΡΟΦΙΜΩΝ Π.Δ.Κ.Α. ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47992401',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΤΥΠΟΠΟΙΗΜΕΝΩΝ ΤΡΟΦΙΜΩΝ Π.Δ.Κ.Α., ΜΕΣΩ ΑΥΤΟΜΑΤΩΝ ΠΩΛΗΤΩΝ',
  },
  {
    label: '47992500',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΚΟΟΛΟΥΧΩΝ ΠΟΤΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47992600',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΠΟΤΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47992700',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΡΟΪΟΝΤΩΝ ΚΑΠΝΟΥ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47993000',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΠΛΗΡΟΦΟΡΙΚΗΣ ΚΑΙ ΕΠΙΚΟΙΝΩΝΙΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47993100',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ, ΠΕΡΙΦΕΡΕΙΑΚΩΝ ΜΟΝΑΔΩΝ ΚΑΙ ΛΟΓΙΣΜΙΚΟΥ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47993200',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47993300',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΧΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΒΙΝΤΕΟ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47994000',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΥΛΙΚΩΝ ΚΑΙ ΣΙΔΗΡΙΚΩΝ Π.Δ.Κ.Α. ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47994100',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΣΙΔΗΡΙΚΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47994200',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΡΩΜΑΤΩΝ, ΒΕΡΝΙΚΙΩΝ ΚΑΙ ΛΟΥΣΤΡΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47994300',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΕΔΩΝ ΤΖΑΜΙΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47994400',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΤΟ ΓΡΑΣΙΔΙ ΚΑΙ ΤΟΝ ΚΗΠΟ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47994500',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΔΡΑΥΛΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΘΕΡΜΑΝΣΗΣ, ΚΑΘΩΣ ΚΑΙ ΠΡΟΜΗΘΕΙΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47994600',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΥΓΙΕΙΝΗΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47994700',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΡΓΑΛΕΙΩΝ ΧΕΙΡΟΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47994900',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ ΥΛΙΚΩΝ Π.Δ.Κ.Α. ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47995000',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΟΙΚΙΑΚΩΝ ΕΙΔΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47995100',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΑΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47995200',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΟΥΡΤΙΝΩΝ ΚΑΙ ΔΙΧΤΥΩΤΩΝ ΚΟΥΡΤΙΝΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47995300',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΟΥ ΤΟΙΧΟΣΤΡΩΣΙΑΣ (ΤΑΠΕΤΣΑΡΙΑΣ) ΚΑΙ ΕΠΕΝΔΥΣΕΩΝ ΔΑΠΕΔΟΥ, ΧΑΛΙΩΝ ΚΑΙ ΚΙΛΙΜΙΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47995400',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47995500',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΠΙΠΛΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47995501',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΙΟΔΕΥΟΝΤΑ ΕΜΠΟΡΟΥ ΕΠΙΠΛΩΝ',
  },
  {
    label: '47995600',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΙΣΤΙΚΩΝ ΕΙΔΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47995700',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΞΥΛΙΝΩΝ ΕΙΔΩΝ, ΕΙΔΩΝ ΑΠΟ ΦΕΛΛΟ ΚΑΙ ΕΙΔΩΝ ΚΑΛΑΘΟΠΛΕΚΤΙΚΗΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47995800',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ ΚΑΙ ΠΑΡΤΙΤΟΥΡΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47995900',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΑΧΑΙΡΟΠΙΡΟΥΝΩΝ, ΠΙΑΤΙΚΩΝ, ΓΥΑΛΙΚΩΝ, ΕΙΔΩΝ ΠΟΡΣΕΛΑΝΗΣ ΚΑΙ ΑΓΓΕΙΟΠΛΑΣΤΙΚΗΣ ΚΑΙ ΜΗ ΗΛΕΚΤΡΙΚΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ, ΕΙΔΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α. ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47995901',
    value: 'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΙΟΔΕΥΟΝΤΑ ΕΜΠΟΡΟΥ ΟΙΚΙΑΚΩΝ ΣΚΕΥΩΝ',
  },
  {
    label: '47996000',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΟΛΙΤΙΣΤΙΚΩΝ ΚΑΙ ΨΥΧΑΓΩΓΙΚΩΝ ΕΙΔΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47996100',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΒΙΒΛΙΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47996200',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΦΗΜΕΡΙΔΩΝ ΚΑΙ ΠΕΡΙΟΔΙΚΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47996300',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΧΑΡΤΙΚΩΝ ΕΙΔΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47996400',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΓΓΡΑΦΩΝ ΜΟΥΣΙΚΗΣ ΚΑΙ ΒΙΝΤΕΟ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47996500',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΘΛΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47996600',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΞΟΠΛΙΣΜΟΥ ΚΑΤΑΣΚΗΝΩΣΗΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47996700',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΙΧΝΙΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47996800',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΓΡΑΜΜΑΤΟΣΗΜΩΝ ΚΑΙ ΝΟΜΙΣΜΑΤΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47996900',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΛΙΤΕΧΝΙΚΩΝ ΚΑΙ ΑΝΑΜΝΗΣΤΙΚΩΝ ΕΙΔΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47997000',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΙΜΑΤΙΣΜΟΥ, ΙΑΤΡΟΦΑΡΜΑΚΕΥΤΙΚΩΝ ΕΙΔΩΝ, ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ, ΛΟΥΛΟΥΔΙΩΝ, ΦΥΤΩΝ, ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ ΚΑΙ ΤΡΟΦΕΣ ΓΙΑ ΖΩΑ ΣΥΝΤΡΟΦΙΑΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47997100',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΙΔΩΝ ΙΜΑΤΙΣΜΟΥ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47997101',
    value:
      'ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΡΙΟΔΕΥΟΝΤΑ ΕΜΠΟΡΟΥ ΕΙΔΩΝ ΙΜΑΤΙΣΜΟΥ ΚΑΙ ΣΥΝΑΦΩΝ ΕΙΔΩΝ',
  },
  {
    label: '47997200',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΠΟΔΗΜΑΤΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47997300',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΤΑΞΙΔΙΟΥ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47997400',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΑΡΜΑΚΕΥΤΙΚΩΝ ΕΙΔΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47997500',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΙΑΤΡΙΚΩΝ ΚΑΙ ΟΡΘΟΠΕΔΙΚΩΝ ΕΙΔΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47997600',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΛΛΥΝΤΙΚΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΛΛΩΠΙΣΜΟΥ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47997700',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΟΥΛΟΥΔΙΩΝ, ΦΥΤΩΝ ΚΑΙ ΣΠΟΡΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47997800',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΛΙΠΑΣΜΑΤΩΝ ΚΑΙ ΑΓΡΟΧΗΜΙΚΩΝ ΠΡΟΪΟΝΤΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47997900',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ ΚΑΙ ΤΡΟΦΩΝ ΓΙΑ ΖΩΑ ΣΥΝΤΡΟΦΙΑΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47998000',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΩΝ ΓΙΑ ΟΧΗΜΑΤΑ ΚΑΙ ΑΛΛΩΝ ΝΕΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ Π.Δ.Κ.Α. ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47998100',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΚΑΥΣΙΜΩΝ ΓΙΑ ΟΧΗΜΑΤΑ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47998200',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΡΟΛΟΓΙΩΝ ΚΑΙ ΚΟΣΜΗΜΑΤΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47998300',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΦΩΤΟΓΡΑΦΙΚΟΥ ΚΑΙ ΟΠΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΑΚΡΙΒΕΙΑΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47998400',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΥΛΙΚΩΝ ΚΑΘΑΡΙΣΜΟΥ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47998500',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΤΡΕΛΑΙΟΥ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ, ΥΓΡΑΕΡΙΟΥ, ΑΝΘΡΑΚΑ ΚΑΙ ΞΥΛΕΙΑΣ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47998501',
    value: "ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΕΤΡΕΛΑΙΟΥ ΘΕΡΜΑΝΣΗΣ, ΜΕ ΔΙΑΝΟΜΗ ΚΑΤ' ΟΙΚΟΝ",
  },
  {
    label: '47998600',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΗ ΕΔΩΔΙΜΩΝ ΚΑΤΑΝΑΛΩΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α. ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47998700',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΚΑΤΕΡΓΑΣΤΩΝ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α. ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47998800',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ Π.Δ.Κ.Α. ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47998900',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΗ ΕΔΩΔΙΜΩΝ ΜΗ ΚΑΤΑΝΑΛΩΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ Π.Δ.Κ.Α. ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47999000',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΚΑΙ ΜΗ ΕΞΕΙΔΙΚΕΥΜΕΝΩΝ ΕΙΔΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47999100',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΠΑΛΑΙΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ ΑΞΙΑΣ (ΑΝΤΙΚΩΝ) ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47999200',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΒΙΒΛΙΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47999300',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΑΛΛΩΝ ΜΕΤΑΧΕΙΡΙΣΜΕΝΩΝ ΕΙΔΩΝ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ',
  },
  {
    label: '47999900',
    value:
      'ΑΛΛΟ ΛΙΑΝΙΚΟ ΕΜΠΟΡΙΟ ΕΚΤΟΣ ΚΑΤΑΣΤΗΜΑΤΩΝ, ΥΠΑΙΘΡΙΩΝ ΠΑΓΚΩΝ Η ΑΓΟΡΩΝ ΜΗ ΕΞΕΙΔΙΚΕΥΜΕΝΩΝ ΑΓΑΘΩΝ',
  },
  {
    label: '49100000',
    value: 'ΥΠΕΡΑΣΤΙΚΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '49101000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ, ΥΠΕΡΑΣΤΙΚΕΣ',
  },
  {
    label: '49101100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ ΓΙΑ ΠΕΡΙΗΓΗΣΗ ΣΕ ΑΞΙΟΘΕΑΤΑ',
  },
  {
    label: '49101900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ, ΥΠΕΡΑΣΤΙΚΕΣ',
  },
  {
    label: '49200000',
    value: 'ΣΙΔΗΡΟΔΡΟΜΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '49201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '49201100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΟΧΗΜΑΤΑ;ΨΥΓΕΙΑ',
  },
  {
    label: '49201200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΒΥΤΙΟΦΟΡΑ ΟΧΗΜΑΤΑ, ΠΡΟΪΟΝΤΩΝ ΠΕΤΡΕΛΑΙΟΥ',
  },
  {
    label: '49201300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΒΥΤΙΟΦΟΡΑ ΟΧΗΜΑΤΑ, ΧΥΔΗΝ ΥΓΡΩΝ ΚΑΙ ΑΕΡΙΩΝ',
  },
  {
    label: '49201400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΜΕ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΑ',
  },
  {
    label: '49201500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΣΤΟΛΩΝ ΚΑΙ ΔΕΜΑΤΩΝ',
  },
  {
    label: '49201600',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΞΗΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ ΧΥΔΗΝ',
  },
  {
    label: '49201900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '49310000',
    value: 'ΑΣΤΙΚΕΣ ΚΑΙ ΠΡΟΑΣΤΙΑΚΕΣ ΧΕΡΣΑΙΕΣ ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '49311000',
    value: 'ΑΣΤΙΚΕΣ ΚΑΙ ΠΡΟΑΣΤΙΑΚΕΣ ΣΙΔΗΡΟΔΡΟΜΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '49312000',
    value: 'ΑΛΛΕΣ ΑΣΤΙΚΕΣ ΚΑΙ ΠΡΟΑΣΤΙΑΚΕΣ ΧΕΡΣΑΙΕΣ ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '49312100',
    value: 'ΑΣΤΙΚΕΣ ΚΑΙ ΠΡΟΑΣΤΙΑΚΕΣ ΤΑΚΤΙΚΕΣ ΟΔΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '49312101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΑΚΤΙΚΩΝ ΑΣΤΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΜΕ ΛΕΩΦΟΡΕΙΑ, ΜΕ ΟΔΗΓΟ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49312102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΑΚΤΙΚΩΝ ΑΣΤΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΜΕ ΛΕΩΦΟΡΕΙΑ, ΜΕ ΟΔΗΓΟ ΜΗ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49312200',
    value: 'ΜΙΚΤΕΣ ΑΣΤΙΚΕΣ ΚΑΙ ΠΡΟΑΣΤΙΑΚΕΣ ΤΑΚΤΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '49320000',
    value: 'ΕΚΜΕΤΑΛΛΕΥΣΗ ΤΑΞΙ',
  },
  {
    label: '49321000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΤΑΞΙ',
  },
  {
    label: '49321101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΞΙ Η ΑΓΟΡΑΙΩΝ, ΜΕ ΟΔΗΓΟ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49321102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΞΙ Η ΑΓΟΡΑΙΩΝ, ΜΕ ΟΔΗΓΟ ΜΗ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49321200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΒΑΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΜΕ ΟΔΗΓΟ',
  },
  {
    label: '49390000',
    value: 'ΑΛΛΕΣ ΧΕΡΣΑΙΕΣ ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '49391000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΑΚΤΙΚΗΣ, ΥΠΕΡΑΣΤΙΚΗΣ ΚΑΙ ΕΙΔΙΚΟΥ ΣΚΟΠΟΥ ΧΕΡΣΑΙΑΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '49391100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΚΤΙΚΗΣ, ΥΠΕΡΑΣΤΙΚΗΣ ΟΔΙΚΗΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '49391101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΑΚΤΙΚΩΝ ΥΠΕΡΑΣΤΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΜΕ ΛΕΩΦΟΡΕΙΑ, ΜΕ ΟΔΗΓΟ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49391102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΑΚΤΙΚΩΝ ΥΠΕΡΑΣΤΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΜΕ ΛΕΩΦΟΡΕΙΑ, ΜΕ ΟΔΗΓΟ ΜΗ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49391200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΑΚΤΙΚΗΣ, ΥΠΕΡΑΣΤΙΚΗΣ ΕΙΔΙΚΟΥ ΣΚΟΠΟΥ ΟΔΙΚΗΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '49391201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΜΑΘΗΤΩΝ ΜΕ ΑΓΡΟΤΙΚΑ ΟΧΗΜΑΤΑ ΙΔΙΩΤΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '49391202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΜΑΘΗΤΩΝ ΜΕ ΑΛΛΑ ΜΕΤΑΦΟΡΙΚΑ ΜΕΣΑ',
  },
  {
    label: '49391203',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΜΑΘΗΤΩΝ ΜΕ ΛΕΩΦΟΡΕΙΑ',
  },
  {
    label: '49391300',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΥ ΣΚΟΠΟΥ ΤΑΚΤΙΚΗΣ ΟΔΙΚΗΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '49392000',
    value:
      'ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ ΜΕ ΤΕΛΕΦΕΡΙΚ ΚΑΙ ΑΝΕΛΚΥΣΤΗΡΕΣ ΧΙΟΝΟΔΡΟΜΙΚΩΝ ΚΕΝΤΡΩΝ',
  },
  {
    label: '49393000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗ ΤΑΚΤΙΚΩΝ ΧΕΡΣΑΙΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '49393100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΛΕΩΦΟΡΕΙΩΝ ΚΑΙ ΑΜΑΞΩΝ ΜΕ ΟΔΗΓΟ',
  },
  {
    label: '49393101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΒΑΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ (ΠΟΥΛΜΑΝ), ΜΕ ΟΔΗΓΟ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49393102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΒΑΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ (ΠΟΥΛΜΑΝ), ΜΕ ΟΔΗΓΟ ΜΗ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49393200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΙΚΗΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ ΓΙΑ ΠΕΡΙΗΓΗΣΗ ΣΕ ΑΞΙΟΘΕΑΤΑ',
  },
  {
    label: '49393300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗ ΤΑΚΤΙΚΩΝ ΤΟΠΙΚΩΝ ΛΕΩΦΟΡΕΙΩΝ ΚΑΙ ΜΙΣΘΩΜΕΝΩΝ ΛΕΩΦΟΡΕΙΩΝ',
  },
  {
    label: '49393400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΗ ΤΑΚΤΙΚΩΝ ΥΠΕΡΑΣΤΙΚΩΝ ΛΕΩΦΟΡΕΙΩΝ ΚΑΙ ΜΙΣΘΩΜΕΝΩΝ ΛΕΩΦΟΡΕΙΩΝ',
  },
  {
    label: '49393401',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΤΑΚΤΩΝ ΥΠΕΡΑΣΤΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΜΕ ΛΕΩΦΟΡΕΙΑ ΜΕ ΟΔΗΓΟ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49393402',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΤΑΚΤΩΝ ΥΠΕΡΑΣΤΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΜΕ ΛΕΩΦΟΡΕΙΑ ΜΕ ΟΔΗΓΟ ΜΗ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49393500',
    value:
      'ΟΔΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ ΜΕ ΟΧΗΜΑΤΑ ΠΟΥ ΕΛΚΟΝΤΑΙ ΑΠΟ ΑΝΘΡΩΠΟ Η ΖΩΑ',
  },
  {
    label: '49393501',
    value: 'ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ ΜΕ ΟΧΗΜΑΤΑ ΠΟΥ ΕΛΚΟΝΤΑΙ ΑΠΟ ΖΩΑ',
  },
  {
    label: '49393900',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΕΡΣΑΙΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '49410000',
    value: 'ΟΔΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '49411000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΙΚΗΣ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '49411100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΙΚΗΣ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΟΧΗΜΑΤΑ;ΨΥΓΕΙΑ',
  },
  {
    label: '49411101',
    value:
      'ΟΔΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΦΟΡΤΗΓΟΥ ΑΥΤΟΚΙΝΗΤΟΥ ΨΥΓΕΙΟΥ ΔΙΕΘΝΩΝ ΜΕΤΑΦΟΡΩΝ, ΜΕ ΟΔΗΓΟ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49411102',
    value:
      'ΟΔΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΦΟΡΤΗΓΟΥ ΑΥΤΟΚΙΝΗΤΟΥ ΨΥΓΕΙΟΥ ΔΙΕΘΝΩΝ ΜΕΤΑΦΟΡΩΝ, ΜΕ ΟΔΗΓΟ ΜΗ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49411200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΟΔΙΚΗΣ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΠΡΟΪΟΝΤΩΝ ΠΕΤΡΕΛΑΙΟΥ, ΜΕ ΒΥΤΙΟΦΟΡΑ ΟΧΗΜΑΤΑ Η ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΑ',
  },
  {
    label: '49411201',
    value:
      'ΜΕΤΑΦΟΡΕΣ ΠΕΤΡΕΛΑΪΚΩΝ ΠΡΟΪΟΝΤΩΝ ΜΕ ΒΥΤΙΟΦΟΡΑ ΑΥΤΟΚΙΝΗΤΑ, ΜΕ ΟΔΗΓΟ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49411202',
    value:
      'ΜΕΤΑΦΟΡΕΣ ΠΕΤΡΕΛΑΪΚΩΝ ΠΡΟΪΟΝΤΩΝ ΜΕ ΒΥΤΙΟΦΟΡΑ ΑΥΤΟΚΙΝΗΤΑ, ΜΕ ΟΔΗΓΟ ΜΗ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49411300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΟΔΙΚΗΣ ΜΕΤΑΦΟΡΑΣ ΑΛΛΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ ΧΥΔΗΝ ΥΓΡΩΝ Η ΑΕΡΙΩΝ ΠΡΟΪΟΝΤΩΝ ΜΕ ΒΥΤΙΟΦΟΡΑ ΟΧΗΜΑΤΑ Η ΗΜΙΡΥΜΟΥΛΚΟΥΜΕΝΑ',
  },
  {
    label: '49411301',
    value:
      'ΜΕΤΑΦΟΡΕΣ ΑΛΛΩΝ ΥΓΡΩΝ Η ΑΕΡΙΩΝ ΜΕ ΒΥΤΙΟΦΟΡΑ ΑΥΤΟΚΙΝΗΤΑ, ΜΕ ΟΔΗΓΟ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49411302',
    value:
      'ΜΕΤΑΦΟΡΕΣ ΑΛΛΩΝ ΥΓΡΩΝ Η ΑΕΡΙΩΝ ΜΕ ΒΥΤΙΟΦΟΡΑ ΑΥΤΟΚΙΝΗΤΑ, ΜΕ ΟΔΗΓΟ ΜΗ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49411303',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΕΤΟΙΜΟΥ ΣΚΥΡΟΔΕΜΑΤΟΣ',
  },
  {
    label: '49411400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΟΔΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΜΕ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΑ (ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΑΠΟ ΔΙΑΦΟΡΕΤΙΚΑ ΜΕΤΑΦΟΡΙΚΑ ΜΕΣΑ)',
  },
  {
    label: '49411500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΞΗΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ ΧΥΔΗΝ',
  },
  {
    label: '49411501',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΑΣΦΑΛΤΟΥ ΓΙΑ ΣΚΥΡΟΣΤΡΩΜΑ',
  },
  {
    label: '49411502',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΜΕΤΑΛΛΕΥΜΑΤΩΝ, ΠΡΩΤΩΝ ΥΛΩΝ ΚΛΠ ΜΕ ΕΙΔΙΚΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '49411503',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΤΣΙΜΕΝΤΟΥ ΣΕ ΣΚΟΝΗ',
  },
  {
    label: '49411600',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΙΚΗΣ ΜΕΤΑΦΟΡΑΣ ΖΩΝΤΩΝ ΖΩΩΝ',
  },
  {
    label: '49411700',
    value:
      'ΟΔΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΟΧΗΜΑΤΑ ΠΟΥ ΕΛΚΟΝΤΑΙ ΑΠΟ ΑΝΘΡΩΠΟ Η ΖΩΑ',
  },
  {
    label: '49411800',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΣΤΟΛΩΝ ΚΑΙ ΔΕΜΑΤΩΝ',
  },
  {
    label: '49411900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΟΔΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '49411901',
    value:
      'ΟΔΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΑΛΛΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΦΟΡΤΗΓΟ ΑΥΤΟΚΙΝΗΤΟ ΜΕ ΟΔΗΓΟ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49411902',
    value:
      'ΟΔΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΑΛΛΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΦΟΡΤΗΓΟ ΑΥΤΟΚΙΝΗΤΟ ΜΕ ΟΔΗΓΟ ΜΗ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49411903',
    value:
      'ΟΔΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΑΛΛΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ, ΜΕ ΦΟΡΤΗΓΟ ΑΥΤΟΚΙΝΗΤΟ ΔΙΕΘΝΩΝ ΜΕΤΑΦΟΡΩΝ ΚΑΙ ΜΕ ΟΔΗΓΟ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49411904',
    value:
      'ΟΔΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΑΛΛΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ, ΜΕ ΦΟΡΤΗΓΟ ΑΥΤΟΚΙΝΗΤΟ ΔΙΕΘΝΩΝ ΜΕΤΑΦΟΡΩΝ ΚΑΙ ΜΕ ΟΔΗΓΟ ΜΗ ΙΔΙΟΚΤΗΤΗ',
  },
  {
    label: '49411905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '49411906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΒΑΡΕΩΝ ΜΗΧΑΝΗΜΑΤΩΝ (ΜΕ ΠΛΑΤΦΟΡΜΑ)',
  },
  {
    label: '49411907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΜΕ ΓΕΡΑΝΟΦΟΡΑ ΑΥΤΟΚΙΝΗΤΑ',
  },
  {
    label: '49412000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΦΟΡΤΗΓΩΝ ΟΧΗΜΑΤΩΝ ΜΕ ΧΕΙΡΙΣΤΗ',
  },
  {
    label: '49420000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΚΟΜΙΣΗΣ',
  },
  {
    label: '49421100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΚΟΜΙΣΗΣ ΓΙΑ ΝΟΙΚΟΚΥΡΙΑ',
  },
  {
    label: '49421101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΟΙΚΟΣΚΕΥΩΝ',
  },
  {
    label: '49421900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΚΟΜΙΣΗΣ',
  },
  {
    label: '49500000',
    value: 'ΜΕΤΑΦΟΡΕΣ ΜΕΣΩ ΑΓΩΓΩΝ',
  },
  {
    label: '49501000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΩΝ ΜΕΣΩ ΑΓΩΓΩΝ',
  },
  {
    label: '49501100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΜΕΣΩ ΑΓΩΓΩΝ ΑΡΓΟΥ Η ΔΙΥΛΙΣΜΕΝΟΥ ΠΕΤΡΕΛΑΙΟΥ ΚΑΙ ΠΕΤΡΕΛΑΪΚΩΝ',
  },
  {
    label: '49501200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΦΥΣΙΚΟΥ ΑΕΡΙΟΥ ΜΕΣΩ ΑΓΩΓΩΝ',
  },
  {
    label: '49501900',
    value: 'ΥΠΗΡΕΣΙΑΣ ΜΕΤΑΦΟΡΑΣ ΑΛΛΩΝ ΑΓΑΘΩΝ ΜΕΣΩ ΑΓΩΓΩΝ',
  },
  {
    label: '50100000',
    value: 'ΘΑΛΑΣΣΙΕΣ ΚΑΙ ΑΚΤΟΠΛΟΪΚΕΣ ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '50101000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΑΚΤΟΠΛΟΪΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '50101100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΑΚΤΟΠΛΟΪΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ ΜΕ ΠΟΡΘΜΕΙΑ (FERRY BOAT)',
  },
  {
    label: '50101101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ ΜΕ ΥΔΡΟΠΤΕΡΥΓΑ Η ΧΟΒΕΡΚΡΑΦΤ',
  },
  {
    label: '50101200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΑΚΤΟΠΛΟΪΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ ΜΕ ΚΡΟΥΑΖΙΕΡΟΠΛΟΙΑ',
  },
  {
    label: '50101201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΠΑΡΑΚΤΙΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ ΜΕ ΘΑΛΑΜΗΓΟΥΣ ~ ΤΟΥΡΙΣΤΙΚΑ ΠΛΟΙΑ ΜΕ ΕΛΛΗΝΙΚΗ ΣΗΜΑΙΑ',
  },
  {
    label: '50101202',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΠΑΡΑΚΤΙΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ ΜΕ ΘΑΛΑΜΗΓΟΥΣ ~ ΤΟΥΡΙΣΤΙΚΑ ΠΛΟΙΑ ΜΕ ΣΗΜΑΙΑ ΑΛΛΗ ΑΠΟ ΕΛΛΗΝΙΚΗ',
  },
  {
    label: '50101203',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΡΟΥΑΖΙΕΡΩΝ',
  },
  {
    label: '50101204',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΚΑΦΩΝ ΕΚΔΡΟΜΩΝ ΚΑΙ ΠΕΡΙΗΓΗΣΕΩΝ ΘΑΛΑΣΣΑΣ',
  },
  {
    label: '50101900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΑΚΤΟΠΛΟΪΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '50101901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΠΑΡΑΚΤΙΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ ΜΕ ΠΛΟΙΑ Β΄ ΚΑΤΗΓΟΡΙΑΣ ΤΟΥ ΑΡΘΡΟΥ 3 ~ ΤΟΥ Ν.27 ;/1975 ',
  },
  {
    label: '50101902',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΠΑΡΑΚΤΙΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ ΜΕ ΠΛΟΙΑ ΙΔΙΟΚΤΗΣΙΑΣ ΤΡΙΤΩΝ',
  },
  {
    label: '50101903',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΠΑΡΑΚΤΙΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ ΜΕ ΠΛΟΙΑ ΠΟΥ ΕΝΕΡΓΟΥΝ ΠΛΟΕΣ ΕΞΩΤΕΡΙΚΟΥ Η ΜΕΙΚΤΟΥΣ',
  },
  {
    label: '50101904',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΠΑΡΑΚΤΙΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ ΜΕ ΠΛΟΙΑ ΠΟΥ ΕΝΕΡΓΟΥΝ ΠΛΟΕΣ ΕΣΩΤΕΡΙΚΟΥ',
  },
  {
    label: '50101905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ ΜΕ ΛΕΜΒΟΥΣ',
  },
  {
    label: '50101906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΛΩΤΩΝ ΤΑΞΙ ΘΑΛΑΣΣΑΣ',
  },
  {
    label: '50102000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΣΚΑΦΩΝ ΘΑΛΑΣΣΙΑΣ ΚΑΙ ΑΚΤΟΠΛΟΪΚΗΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ ΜΕ ΧΕΙΡΙΣΤΗ',
  },
  {
    label: '50102001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΑΓΓΕΛΜΑΤΙΚΟΥ ΤΟΥΡΙΣΤΙΚΟΥ ΣΚΑΦΟΥΣ ΜΕ ΠΛΗΡΩΜΑ',
  },
  {
    label: '50102002',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΒΑΤΗΓΩΝ ΠΛΟΙΩΝ ΙΔΙΟΚΤΗΣΙΑΣ ΤΡΙΤΩΝ ΜΕ ΠΛΗΡΩΜΑ',
  },
  {
    label: '50102003',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΠΛΟΙΩΝ ΨΥΧΑΓΩΓΙΑΣ (ΚΟΤΕΡΩΝ, ΘΑΛΑΜΗΓΩΝ, ΒΕΝΖΙΝΑΚΑΤΩΝ ΚΛΠ) ΜΕ ΠΛΗΡΩΜΑ',
  },
  {
    label: '50200000',
    value: 'ΘΑΛΑΣΣΙΕΣ ΚΑΙ ΑΚΤΟΠΛΟΪΚΕΣ ΜΕΤΑΦΟΡΕΣ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '50201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΑΚΤΟΠΛΟΪΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '50201100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΑΣ Η ΑΚΤΟΠΛΟΪΚΗΣ ΜΕΤΑΦΟΡΑΣ ΚΑΤΕΨΥΓΜΕΝΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ ΜΕ ΑΠΛΗ ΨΥΞΗ ΕΜΠΟΡΕΥΜΑΤΩΝ ΑΠΟ ΣΚΑΦΗ;ΨΥΓΕΙΑ',
  },
  {
    label: '50201200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΑΣ ΚΑΙ ΑΚΤΟΠΛΟΪΚΗΣ ΜΕΤΑΦΟΡΑΣ ΑΡΓΟΥ ΠΕΤΡΕΛΑΙΟΥ ΜΕ ΔΕΞΑΜΕΝΟΠΛΟΙΑ',
  },
  {
    label: '50201300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΑΣ ΚΑΙ ΑΚΤΟΠΛΟΪΚΗΣ ΜΕΤΑΦΟΡΑΣ ΑΛΛΩΝ ΥΓΡΩΝ Η ΑΕΡΙΩΝ ΧΥΔΗΝ ΜΕ ΔΕΞΑΜΕΝΟΠΛΟΙΑ',
  },
  {
    label: '50201400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΑΣ ΚΑΙ ΑΚΤΟΠΛΟΪΚΗΣ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ ΜΕ ΠΛΟΙΑ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ',
  },
  {
    label: '50201500',
    value: 'ΘΑΛΑΣΣΙΕΣ ΚΑΙ ΠΑΡΑΚΤΙΕΣ ΜΕΤΑΦΟΡΕΣ ΞΗΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ ΧΥΔΗΝ',
  },
  {
    label: '50201900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΠΑΡΑΚΤΙΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '50201901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΩΝ ΚΑΙ ΠΑΡΑΚΤΙΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΛΕΜΒΟΥΣ',
  },
  {
    label: '50202000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΣΚΑΦΩΝ ΘΑΛΑΣΣΙΑΣ ΚΑΙ ΑΚΤΟΠΛΟΪΚΗΣ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΧΕΙΡΙΣΤΗ· ΥΠΗΡΕΣΙΕΣ ΡΥΜΟΥΛΚΗΣΗΣ ΚΑΙ ΩΘΗΣΗΣ',
  },
  {
    label: '50202100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΣΚΑΦΩΝ ΘΑΛΑΣΣΙΑΣ ΚΑΙ ΑΚΤΟΠΛΟΪΚΗΣ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ',
  },
  {
    label: '50202101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΦΟΡΤΗΓΩΝ ΠΛΟΙΩΝ ΙΔΙΟΚΤΗΣΙΑΣ ΤΡΙΤΩΝ ΜΕ ΠΛΗΡΩΜΑ',
  },
  {
    label: '50202200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΡΥΜΟΥΛΚΗΣΗΣ ΚΑΙ ΩΘΗΣΗΣ ΣΕ ΘΑΛΑΣΣΙΑ ΚΑΙ ΣΕ ΠΑΡΑΚΤΙΑ ΥΔΑΤΑ',
  },
  {
    label: '50202201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΑΣ ΡΥΜΟΥΛΚΗΣΗΣ ΚΑΙ ΩΘΗΣΗΣ ΜΕ ΠΛΟΙΑ ΙΔΙΟΚΤΗΣΙΑΣ ΤΡΙΤΩΝ',
  },
  {
    label: '50300000',
    value: 'ΕΣΩΤΕΡΙΚΕΣ ΠΛΩΤΕΣ ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '50301000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ',
  },
  {
    label: '50301100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ ΜΕ ΠΟΡΘΜΕΙΑ',
  },
  {
    label: '50301101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΛΩΤΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ ΜΕ ΛΕΜΒΟΥΣ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ',
  },
  {
    label: '50301200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ ΜΕ ΚΡΟΥΑΖΙΕΡΟΠΛΟΙΑ',
  },
  {
    label: '50301300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΚΑΦΩΝ ΕΚΔΡΟΜΩΝ ΚΑΙ ΠΕΡΙΗΓΗΣΕΩΝ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ',
  },
  {
    label: '50301301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΚΑΦΩΝ ΕΚΔΡΟΜΩΝ ΚΑΙ ΠΕΡΙΗΓΗΣΕΩΝ ΠΟΤΑΜΩΝ, ΛΙΜΝΩΝ',
  },
  {
    label: '50301900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ',
  },
  {
    label: '50302000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΣΚΑΦΩΝ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ ΜΕ ΧΕΙΡΙΣΤΗ',
  },
  {
    label: '50400000',
    value: 'ΕΣΩΤΕΡΙΚΕΣ ΠΛΩΤΕΣ ΜΕΤΑΦΟΡΕΣ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '50401000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ',
  },
  {
    label: '50401100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ ΚΑΤΕΨΥΓΜΕΝΩΝ Η ΔΙΑΤΗΡΗΜΕΝΩΝ ΜΕ ΑΠΛΗ ΨΥΞΗ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΣΚΑΦΗ;ΨΥΓΕΙΑ',
  },
  {
    label: '50401200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ ΑΡΓΟΥ ΠΕΤΡΕΛΑΙΟΥ ΜΕ ΔΕΞΑΜΕΝΟΠΛΟΙΑ',
  },
  {
    label: '50401300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ ΑΛΛΩΝ ΧΥΔΗΝ ΥΓΡΩΝ ΚΑΙ ΑΕΡΙΩΝ ΠΡΟΪΟΝΤΩΝ ΜΕ ΔΕΞΑΜΕΝΟΠΛΟΙΑ',
  },
  {
    label: '50401400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ ΜΕ ΠΛΟΙΑ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ',
  },
  {
    label: '50401900',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ',
  },
  {
    label: '50401901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΛΩΤΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΛΕΜΒΟΥΣ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ',
  },
  {
    label: '50402000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΣΚΑΦΩΝ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ ΜΕ ΧΕΙΡΙΣΤΗ· ΥΠΗΡΕΣΙΕΣ ΡΥΜΟΥΛΚΗΣΗΣ ΚΑΙ ΩΘΗΣΗΣ',
  },
  {
    label: '50402100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΣΚΑΦΩΝ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ ΣΕ ΕΣΩΤΕΡΙΚΕΣ ΥΔΑΤΙΝΕΣ ΟΔΟΥΣ ΜΕ ΧΕΙΡΙΣΤΗ',
  },
  {
    label: '50402200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΡΥΜΟΥΛΚΗΣΗΣ ΚΑΙ ΩΘΗΣΗΣ ΣΕ ΕΣΩΤΕΡΙΚΑ ΥΔΑΤΑ',
  },
  {
    label: '51100000',
    value: 'ΑΕΡΟΠΟΡΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '51101000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΑΕΡΙΑΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '51101100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΚΤΙΚΗΣ ΕΣΩΤΕΡΙΚΗΣ ΕΝΑΕΡΙΑΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '51101200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΗ ΤΑΚΤΙΚΗΣ ΕΣΩΤΕΡΙΚΗΣ ΕΝΑΕΡΙΑΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ, ΕΚΤΟΣ ΑΠΟ ΠΕΡΙΗΓΗΣΕΙΣ',
  },
  {
    label: '51101300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΚΤΙΚΗΣ ΔΙΕΘΝΟΥΣ ΕΝΑΕΡΙΑΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '51101400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗ ΤΑΚΤΙΚΗΣ ΔΙΕΘΝΟΥΣ ΕΝΑΕΡΙΑΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '51101500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗ ΤΑΚΤΙΚΗΣ ΕΝΑΕΡΙΑΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ ΓΙΑ ΠΕΡΙΗΓΗΣΕΙΣ',
  },
  {
    label: '51101501',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΕΡΟΤΑΞΙ (ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΕΛΙΚΟΠΤΕΡΑ Η ΑΕΡΟΣΚΑΦΗ)',
  },
  {
    label: '51102000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΕΝΑΕΡΙΑΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΒΑΤΩΝ ΜΕ ΧΕΙΡΙΣΤΗ',
  },
  {
    label: '51210000',
    value: 'ΑΕΡΟΠΟΡΙΚΕΣ ΜΕΤΑΦΟΡΕΣ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '51211000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΑΕΡΙΑΣ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '51211100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΚΤΙΚΗΣ ΕΝΑΕΡΙΑΣ ΜΕΤΑΦΟΡΑΣ ΜΕ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΑ',
  },
  {
    label: '51211200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΑΕΡΙΑΣ ΜΕΤΑΦΟΡΑΣ ΕΠΙΣΤΟΛΩΝ ΚΑΙ ΔΕΜΑΤΩΝ',
  },
  {
    label: '51211300',
    value: 'ΤΑΚΤΙΚΕΣ ΕΝΑΕΡΙΕΣ ΜΕΤΑΦΟΡΕΣ ΑΛΛΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '51211400',
    value: 'ΜΗ ΤΑΚΤΙΚΕΣ ΕΝΑΕΡΙΕΣ ΜΕΤΑΦΟΡΕΣ ΑΛΛΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '51212000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΕΝΑΕΡΙΑΣ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ ΜΕ ΧΕΙΡΙΣΤΗ',
  },
  {
    label: '51220000',
    value: 'ΔΙΑΣΤΗΜΙΚΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '51221000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΣΤΗΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ',
  },
  {
    label: '51221100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΣΤΗΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΠΙΒΑΤΩΝ',
  },
  {
    label: '51221200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΣΤΗΜΙΚΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '52100000',
    value: 'ΑΠΟΘΗΚΕΥΣΗ',
  },
  {
    label: '52101000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΘΗΚΕΥΣΗΣ',
  },
  {
    label: '52101100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΘΗΚΕΥΣΗΣ ΥΠΟ ΨΥΞΗ',
  },
  {
    label: '52101101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΘΗΚΕΥΣΗΣ ΜΠΑΝΑΝΩΝ ΚΑΙ ΛΟΙΠΩΝ ΤΡΟΠΙΚΩΝ ΦΡΟΥΤΩΝ',
  },
  {
    label: '52101200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΘΗΚΕΥΣΗΣ ΧΥΔΗΝ ΥΓΡΩΝ Η ΑΕΡΙΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '52101300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΘΗΚΕΥΣΗΣ ΔΗΜΗΤΡΙΑΚΩΝ',
  },
  {
    label: '52101900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΑΠΟΘΗΚΕΥΣΗΣ',
  },
  {
    label: '52101901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΡΟΕΤΟΙΜΑΣΙΑΣ (ΣΥΣΚΕΥΑΣΙΑ, ΣΥΝΤΗΡΗΣΗ ΚΛΠ), ΠΡΟΣ ΑΠΟΘΗΚΕΥΣΗ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '52210000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΥΝΑΦΕΙΣ ΜΕ ΤΙΣ ΧΕΡΣΑΙΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '52211000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΙΣ ΣΙΔΗΡΟΔΡΟΜΙΚΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '52211100',
    value: 'ΣΙΔΗΡΟΔΡΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΩΘΗΣΗΣ Η ΡΥΜΟΥΛΚΗΣΗΣ',
  },
  {
    label: '52211900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΙΣ ΣΙΔΗΡΟΔΡΟΜΙΚΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '52212000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΙΣ ΟΔΙΚΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '52212100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΑΘΜΩΝ ΛΕΩΦΟΡΕΙΩΝ',
  },
  {
    label: '52212101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΥΛΑΞΗΣ ΑΠΟΣΚΕΥΩΝ ΣΕ ΣΤΑΘΜΟΥΣ ΛΕΩΦΟΡΕΙΩΝ',
  },
  {
    label: '52212200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΑΥΤΟΚΙΝΗΤΟΔΡΟΜΩΝ',
  },
  {
    label: '52212300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΓΕΦΥΡΩΝ ΚΑΙ ΣΗΡΑΓΓΩΝ',
  },
  {
    label: '52212400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΩΡΩΝ ΣΤΑΘΜΕΥΣΗΣ',
  },
  {
    label: '52212401',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΚΟΛΟΥΘΗΣΗΣ ΧΩΡΩΝ ΚΑΙ ΣΥΛΛΟΓΗΣ ΤΕΛΩΝ, ΜΕ ΣΥΣΤΗΜΑ ΕΛΕΓΧΟΜΕΝΗΣ ΣΤΑΘΜΕΥΣΗΣ',
  },
  {
    label: '52212402',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΠΑΙΘΡΙΟΥ ΧΩΡΟΥ ΣΤΑΘΜΕΥΣΗΣ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '52212403',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΩΡΟΥ ΣΤΑΘΜΕΥΣΗΣ ΕΠΙΒΑΤΙΚΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '52212404',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΩΡΩΝ ΣΤΑΘΜΕΥΣΗΣ ΚΑΘΕ ΕΙΔΟΥΣ ΜΕΤΑΦΟΡΙΚΩΝ ΜΕΣΩΝ ΚΑΙ ΤΡΟΧΟΣΠΙΤΩΝ',
  },
  {
    label: '52212405',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΩΡΩΝ ΣΤΑΘΜΕΥΣΗΣ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '52212500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΡΥΜΟΥΛΚΗΣΗΣ ΓΙΑ ΟΧΗΜΑΤΑ ΙΔΙΩΤΙΚΗΣ ΚΑΙ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '52212501',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΙΚΗΣ ΒΟΗΘΕΙΑΣ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '52212900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΙΣ ΟΔΙΚΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '52212901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΗΓΟΥ ΤΑΞΙ (ΜΗ ΕΚΜΕΤΑΛΛΕΥΤΗ)',
  },
  {
    label: '52212902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΗΓΟΥ ΛΕΩΦΟΡΕΙΟΥ (ΜΗ ΕΚΜΕΤΑΛΛΕΥΤΗ)',
  },
  {
    label: '52212903',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΕΙΣΙΤΗΡΙΩΝ ΑΣΤΙΚΩΝ ΧΕΡΣΑΙΩΝ ΣΥΓΚΟΙΝΩΝΙΑΚΩΝ ΜΕΣΩΝ ΑΠΟ ΤΡΙΤΟΥΣ, ΛΙΑΝΙΚΑ',
  },
  {
    label: '52212904',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΕΙΣΙΤΗΡΙΩΝ ΑΣΤΙΚΩΝ ΧΕΡΣΑΙΩΝ ΣΥΓΚΟΙΝΩΝΙΑΚΩΝ ΜΕΣΩΝ ΑΠΟ ΤΡΙΤΟΥΣ, ΧΟΝΔΡΙΚΑ',
  },
  {
    label: '52212905',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΕΙΣΙΤΗΡΙΩΝ ΥΠΕΡΑΣΤΙΚΩΝ ΧΕΡΣΑΙΩΝ ΣΥΓΚΟΙΝΩΝΙΑΚΩΝ ΜΕΣΩΝ ΑΠΟ ΤΡΙΤΟΥΣ',
  },
  {
    label: '52212906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΟΔΟΥ ΣΧΟΛΙΚΩΝ ΛΕΩΦΟΡΕΙΩΝ',
  },
  {
    label: '52213000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΜΕΤΑΦΟΡΕΣ ΜΕΣΩ ΑΓΩΓΩΝ',
  },
  {
    label: '52220000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΥΝΑΦΕΙΣ ΜΕ ΤΙΣ ΠΛΩΤΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '52221000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΙΣ ΥΔΑΤΙΝΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '52221100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΛΙΜΑΝΙΩΝ ΚΑΙ ΥΔΑΤΙΝΩΝ ΟΔΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΗ ΔΙΑΚΙΝΗΣΗ ΦΟΡΤΙΩΝ) ΣΕ ΘΑΛΑΣΣΙΑ Η ΠΑΡΑΚΤΙΑ ΥΔΑΤΑ',
  },
  {
    label: '52221101',
    value:
      'ΛΙΜΕΝΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΕΝΙΚΑ (ΠΡΟΣΟΡΜΙΣΗΣ, ΠΡΥΜΝΟΔΕΤΗΣΗΣ, ΠΑΡΟΠΛΙΣΜΟΥ, ΕΛΛΙΜΕΝΙΣΜΟΥ, ΑΝΕΛΚΥΣΗΣ, ΠΛΟΗΓΗΣΗΣ ΠΛΟΙΩΝ ΚΛΠ).',
  },
  {
    label: '52221102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΕΛΚΥΣΗΣ ΚΑΙ ΚΑΘΕΛΚΥΣΗΣ ΣΚΑΦΩΝ',
  },
  {
    label: '52221103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΑΘΜΕΥΣΗΣ ΚΑΙ ΦΥΛΑΞΗΣ ΣΚΑΦΩΝ, ΣΕ ΠΑΡΑΚΤΙΟ ΧΩΡΟ',
  },
  {
    label: '52221104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΒΑΡΚΩΝ (ΕΚΤΟΣ ΤΩΝ ΕΠΙΣΚΕΥΩΝ)',
  },
  {
    label: '52221105',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΥΡΙΣΤΙΚΩΝ ΛΙΜΑΝΙΩΝ (ΜΑΡΙΝΩΝ)',
  },
  {
    label: '52221200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΥΔΑΤΙΝΩΝ ΟΔΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΗ ΔΙΑΚΙΝΗΣΗ ΦΟΡΤΙΩΝ)',
  },
  {
    label: '52221300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΛΟΗΓΗΣΗΣ ΚΑΙ ΕΛΛΙΜΕΝΙΣΜΟΥ ΠΛΟΙΩΝ ΣΕ ΘΑΛΑΣΣΙΑ ΚΑΙ ΠΑΡΑΚΤΙΑ ΥΔΑΤΑ',
  },
  {
    label: '52221400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΛΟΗΓΗΣΗΣ ΚΑΙ ΕΛΛΙΜΕΝΙΣΜΟΥ ΠΛΟΙΩΝ ΣΕ ΕΣΩΤΕΡΙΚΑ ΥΔΑΤΑ',
  },
  {
    label: '52221500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΣΩΣΗΣ ΚΑΙ ΑΝΕΛΚΥΣΗΣ ΣΚΑΦΩΝ ΣΕ ΘΑΛΑΣΣΙΑ ΚΑΙ ΠΑΡΑΚΤΙΑ ΥΔΑΤΑ',
  },
  {
    label: '52221501',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΕΛΚΥΣΗΣ ΝΑΥΑΓΙΩΝ',
  },
  {
    label: '52221502',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΡΥΜΟΥΛΚΗΣΗΣ ΠΟΝΤΟΠΟΡΩΝ ΠΛΟΙΩΝ, ΠΟΥ ΒΡΙΣΚΟΝΤΑΙ ΣΕ ΚΙΝΔΥΝΟ (ΝΑΥΑΓΟΣΩΣΤΙΚΩΝ)',
  },
  {
    label: '52221600',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΣΩΣΗΣ ΚΑΙ ΑΝΕΛΚΥΣΗΣ ΣΚΑΦΩΝ ΣΕ ΕΣΩΤΕΡΙΚΑ ΥΔΑΤΑ',
  },
  {
    label: '52221900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΙΣ ΥΔΑΤΙΝΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '52221901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΦΟΡΤΗΓΙΔΩΝ',
  },
  {
    label: '52221902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΑΘΜΕΥΣΗΣ ΚΑΙ ΦΥΛΑΞΗΣ ΣΚΑΦΩΝ, ΣΕ ΧΕΡΣΑΙΟ ΧΩΡΟ',
  },
  {
    label: '52230000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΥΝΑΦΕΙΣ ΜΕ ΤΙΣ ΑΕΡΟΠΟΡΙΚΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '52231000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΑΕΡΟΛΙΜΕΝΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΗ ΔΙΑΚΙΝΗΣΗ ΦΟΡΤΙΩΝ), ΥΠΗΡΕΣΙΕΣ ΕΛΕΓΧΟΥ ΕΝΑΕΡΙΑΣ ΚΥΚΛΟΦΟΡΙΑΣ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΙΣ ΕΝΑΕΡΙΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '52231100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΑΕΡΟΛΙΜΕΝΩΝ (ΕΚΤΟΣ ΑΠΟ ΤΗ ΔΙΑΚΙΝΗΣΗ ΦΟΡΤΙΩΝ)',
  },
  {
    label: '52231200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΛΕΓΧΟΥ ΕΝΑΕΡΙΑΣ ΚΥΚΛΟΦΟΡΙΑΣ',
  },
  {
    label: '52231900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΙΣ ΕΝΑΕΡΙΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '52231901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΥΡΟΣΒΕΣΤΙΚΩΝ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΠΡΟΛΗΨΗΣ ΠΥΡΚΑΓΙΩΝ',
  },
  {
    label: '52231902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΡΥΜΟΥΛΚΗΣΗΣ ΑΕΡΟΣΚΑΦΩΝ',
  },
  {
    label: '52231903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΑΕΡΟΣΚΑΦΩΝ (ΕΚΤΟΣ ΤΩΝ ΕΠΙΣΚΕΥΩΝ)',
  },
  {
    label: '52231904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΩΡΩΝ ΣΤΑΘΜΕΥΣΗΣ ΑΕΡΟΠΛΑΝΩΝ',
  },
  {
    label: '52232000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΙΣ ΔΙΑΣΤΗΜΙΚΕΣ ΜΕΤΑΦΟΡΕΣ',
  },
  {
    label: '52240000',
    value: 'ΔΙΑΚΙΝΗΣΗ ΦΟΡΤΙΩΝ',
  },
  {
    label: '52241000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΚΙΝΗΣΗΣ ΦΟΡΤΙΩΝ',
  },
  {
    label: '52241100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΚΙΝΗΣΗΣ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ ΣΕ ΑΕΡΟΛΙΜΕΝΕΣ ΚΑΙ ΛΙΜΕΝΕΣ',
  },
  {
    label: '52241200',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΚΙΝΗΣΗΣ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ',
  },
  {
    label: '52241201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΟΡΤΟΕΚΦΟΡΤΩΣΗΣ ΚΑΙ ΣΤΟΙΒΑΣΗΣ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ',
  },
  {
    label: '52241300',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΚΙΝΗΣΗΣ ΦΟΡΤΙΩΝ ΣΕ ΑΕΡΟΛΙΜΕΝΕΣ ΚΑΙ ΛΙΜΕΝΕΣ',
  },
  {
    label: '52241900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΚΙΝΗΣΗΣ ΦΟΡΤΙΩΝ',
  },
  {
    label: '52241901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΤΛΗΣΗΣ ΕΤΟΙΜΟΥ ΣΚΥΡΟΔΕΜΑΤΟΣ (ΠΡΕΣΑΣ), ΚΑΤΑ ΤΗΝ ΤΕΛΙΚΗ ΤΟΥ ΠΑΡΑΔΟΣΗ',
  },
  {
    label: '52241902',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΚΙΝΗΣΗΣ ΑΠΟΣΚΕΥΩΝ ΣΕ ΕΓΚΑΤΑΣΤΑΣΕΙΣ ΣΤΑΘΜΩΝ ΚΑΘΕ ΜΕΣΟΥ ΜΕΤΑΦΟΡΑΣ',
  },
  {
    label: '52241903',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΚΙΝΗΣΕΩΝ ΦΟΡΤΙΩΝ ΜΕ ΓΕΡΑΝΟΦΟΡΑ ΟΧΗΜΑΤΑ Η ΕΓΚΑΤΑΣΤΗΜΕΝΟΥΣ ΓΕΡΑΝΟΥΣ',
  },
  {
    label: '52241904',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΦΟΡΤΟΕΚΦΟΡΤΩΣΗΣ ΚΑΙ ΣΤΟΙΒΑΣΗΣ ΦΟΡΤΙΩΝ ΣΕ ΕΓΚΑΤΑΣΤΑΣΕΙΣ ΤΕΡΜΑΤΙΚΩΝ ΣΤΑΘΜΩΝ ΚΑΘΕ ΜΕΣΟΥ ΜΕΤΑΦΟΡΑΣ',
  },
  {
    label: '52290000',
    value: 'ΑΛΛΕΣ ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΠΡΟΣ ΤΗ ΜΕΤΑΦΟΡΑ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '52291000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΑΚΤΟΡΕΙΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '52291100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΝΑΥΛΟΜΕΣΙΤΩΝ',
  },
  {
    label: '52291200',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΜΠΟΡΟΜΕΣΙΤΩΝ',
  },
  {
    label: '52291900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΡΑΚΤΟΡΕΙΩΝ ΜΕΤΑΦΟΡΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '52291901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΜΕΣΟΛΑΒΗΣΗΣ ΣΤΗ ΜΕΤΑΦΟΡΑ ΑΓΑΘΩΝ',
  },
  {
    label: '52291902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '52291903',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΜΕ ΔΙΑΧΕΙΡΙΣΗ ΤΗΣ ΑΛΥΣΙΔΑΣ ΕΦΟΔΙΑΣΜΟΥ (LOGISTICS)',
  },
  {
    label: '52291904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΝΑΥΤΙΛΙΑΚΩΝ ΠΡΑΚΤΟΡΩΝ',
  },
  {
    label: '52291905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΑΚΤΟΡΕΥΣΗΣ ΠΛΟΙΩΝ ΕΞΩΤΕΡΙΚΟΥ',
  },
  {
    label: '52291906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΑΚΤΟΡΕΥΣΗΣ ΕΝΑΕΡΙΩΝ ΜΕΤΑΦΟΡΩΝ',
  },
  {
    label: '52291907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΠΙΚΗΣ ΣΥΓΚΕΝΤΡΩΣΗΣ ΚΑΙ ΔΙΑΝΟΜΗΣ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '52292000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΤΩΝ ΜΕΤΑΦΟΡΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '52292001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΣΤΟΛΗΣ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '53100000',
    value:
      'ΤΑΧΥΔΡΟΜΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΜΕ ΥΠΟΧΡΕΩΣΗ ΠΑΡΟΧΗΣ ΚΑΘΟΛΙΚΗΣ ΥΠΗΡΕΣΙΑΣ',
  },
  {
    label: '53101000',
    value:
      'ΤΑΧΥΔΡΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΥΠΟΧΡΕΩΣΗΣ ΠΑΡΟΧΗΣ ΚΑΘΟΛΙΚΗΣ ΥΠΗΡΕΣΙΑΣ',
  },
  {
    label: '53101100',
    value:
      'ΤΑΧΥΔΡΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΥΠΟΧΡΕΩΣΗΣ ΠΑΡΟΧΗΣ ΚΑΘΟΛΙΚΗΣ ΥΠΗΡΕΣΙΑΣ ΠΟΥ ΑΦΟΡΟΥΝ ΕΦΗΜΕΡΙΔΕΣ ΚΑΙ ΠΕΡΙΟΔΙΚΑ',
  },
  {
    label: '53101200',
    value:
      'ΤΑΧΥΔΡΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΥΠΟΧΡΕΩΣΗΣ ΠΑΡΟΧΗΣ ΚΑΘΟΛΙΚΗΣ ΥΠΗΡΕΣΙΑΣ ΠΟΥ ΑΦΟΡΟΥΝ ΕΠΙΣΤΟΛΕΣ',
  },
  {
    label: '53101300',
    value:
      'ΤΑΧΥΔΡΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΥΠΟΧΡΕΩΣΗΣ ΠΑΡΟΧΗΣ ΚΑΘΟΛΙΚΗΣ ΥΠΗΡΕΣΙΑΣ ΠΟΥ ΑΦΟΡΟΥΝ ΔΕΜΑΤΑ',
  },
  {
    label: '53101400',
    value: 'ΤΑΧΥΔΡΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΥΝΑΛΛΑΓΗΣ ΜΕ ΤΟ ΚΟΙΝΟ',
  },
  {
    label: '53101401',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΓΡΑΜΜΑΤΟΣΗΜΩΝ',
  },
  {
    label: '53101402',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΧΥΔΡΟΜΙΚΩΝ ΠΡΑΚΤΟΡΕΙΩΝ',
  },
  {
    label: '53101900',
    value:
      'ΑΛΛΕΣ ΤΑΧΥΔΡΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΤΟ ΠΛΑΙΣΙΟ ΤΗΣ ΥΠΟΧΡΕΩΣΗΣ ΠΑΡΟΧΗΣ ΚΑΘΟΛΙΚΗΣ ΥΠΗΡΕΣΙΑΣ',
  },
  {
    label: '53200000',
    value: 'ΑΛΛΕΣ ΤΑΧΥΔΡΟΜΙΚΕΣ ΚΑΙ ΤΑΧΥΜΕΤΑΦΟΡΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '53201000',
    value: 'ΑΛΛΕΣ ΤΑΧΥΔΡΟΜΙΚΕΣ ΚΑΙ ΤΑΧΥΜΕΤΑΦΟΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '53201100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΧΥΜΕΤΑΦΟΡΩΝ ΠΟΛΛΑΠΛΗΣ ΦΥΣΗΣ',
  },
  {
    label: '53201101',
    value: 'ΤΑΧΥΜΕΤΑΦΟΡΕΣ ΕΓΓΡΑΦΩΝ ΚΑΙ ΑΝΤΙΚΕΙΜΕΝΩΝ',
  },
  {
    label: '53201200',
    value: "ΥΠΗΡΕΣΙΕΣ ΚΑΤ' ΟΙΚΟΝ ΠΑΡΑΔΟΣΗΣ ΤΡΟΦΙΜΩΝ (DELIVERY)",
  },
  {
    label: '53201900',
    value: 'ΑΛΛΕΣ ΤΑΧΥΔΡΟΜΙΚΕΣ ΚΑΙ ΤΑΧΥΜΕΤΑΦΟΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '55100000',
    value: 'ΞΕΝΟΔΟΧΕΙΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΚΑΤΑΛΥΜΑΤΑ',
  },
  {
    label: '55101000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΔΩΜΑΤΙΟΥ Η ΜΟΝΑΔΑΣ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΕΠΙΣΚΕΠΤΕΣ, ΜΕ ΚΑΘΗΜΕΡΙΝΗ ΚΑΘΑΡΙΟΤΗΤΑ (ΕΚΤΟΣ ΤΗΣ ΧΡΟΝΟΜΕΡΙΣΤΙΚΗΣ ΜΙΣΘΩΣΗΣ)',
  },
  {
    label: '55101001',
    value: "ΥΠΗΡΕΣΙΕΣ ΞΕΝΟΔΟΧΕΙΟΥ ΥΠΝΟΥ, Β' ΚΑΤΗΓΟΡΙΑΣ ΚΑΙ ΚΑΤΩ, ΜΕ ΕΣΤΙΑΤΟΡΙΟ",
  },
  {
    label: '55101002',
    value:
      "ΥΠΗΡΕΣΙΕΣ ΞΕΝΟΔΟΧΕΙΟΥ ΥΠΝΟΥ, Β' ΚΑΤΗΓΟΡΙΑΣ ΚΑΙ ΚΑΤΩ, ΧΩΡΙΣ ΕΣΤΙΑΤΟΡΙΟ",
  },
  {
    label: '55101003',
    value:
      "ΥΠΗΡΕΣΙΕΣ ΞΕΝΟΔΟΧΕΙΟΥ ΥΠΝΟΥ, ΠΟΛΥΤΕΛΕΙΑΣ ΚΑΙ Α' ΚΑΤΗΓΟΡΙΑΣ, ΜΕ ΕΣΤΙΑΤΟΡΙΟ",
  },
  {
    label: '55101004',
    value:
      "ΥΠΗΡΕΣΙΕΣ ΞΕΝΟΔΟΧΕΙΟΥ ΥΠΝΟΥ, ΠΟΛΥΤΕΛΕΙΑΣ ΚΑΙ Α' ΚΑΤΗΓΟΡΙΑΣ, ΧΩΡΙΣ ΕΣΤΙΑΤΟΡΙΟ",
  },
  {
    label: '55200000',
    value: 'ΚΑΤΑΛΥΜΑΤΑ ΔΙΑΚΟΠΩΝ ΚΑΙ ΑΛΛΑ ΚΑΤΑΛΥΜΑΤΑ ΣΥΝΤΟΜΗΣ ΔΙΑΜΟΝΗΣ',
  },
  {
    label: '55201000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΛΥΜΑΤΩΝ ΔΙΑΚΟΠΩΝ ΚΑΙ ΑΛΛΩΝ ΤΥΠΩΝ ΚΑΤΑΛΥΜΑΤΟΣ ΣΥΝΤΟΜΗΣ ΔΙΑΡΚΕΙΑΣ',
  },
  {
    label: '55201100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΔΩΜΑΤΙΟΥ Η ΜΟΝΑΔΑΣ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΕΠΙΣΚΕΠΤΕΣ ΣΕ ΞΕΝΩΝΕΣ ΝΕΟΤΗΤΑΣ ΚΑΙ ΣΕ ΑΥΤΟΝΟΜΕΣ ΕΝΟΤΗΤΕΣ ΔΙΑΚΟΠΩΝ',
  },
  {
    label: '55201101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΜΙΣΘΩΣΗΣ ΜΙΚΡΗΣ ΔΙΑΡΚΕΙΑΣ ΔΩΜΑΤΙΩΝ ΣΠΙΤΙΩΝ',
  },
  {
    label: '55201103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΠΛΩΜΕΝΩΝ ΔΙΑΜΕΡΙΣΜΑΤΩΝ, ΜΕ ΠΑΡΟΧΗ ΥΠΗΡΕΣΙΩΝ ΠΕΡΙΠΟΙΗΣΗΣ ΠΕΛΑΤΩΝ',
  },
  {
    label: '55201104',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΠΛΩΜΕΝΩΝ ΔΩΜΑΤΙΩΝ Η ΔΙΑΜΕΡΙΣΜΑΤΩΝ ΓΙΑ ΜΙΚΡΗ ΔΙΑΡΚΕΙΑ',
  },
  {
    label: '55201105',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΩΣ ΕΠΤΑ (7 ;) ΕΠΙΠΛΩΜΕΝΩΝ ΔΩΜΑΤΙΩΝ ΓΙΑ ΜΙΚΡΗ ΔΙΑΡΚΕΙΑ',
  },
  {
    label: '55201200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΔΩΜΑΤΙΟΥ Η ΜΟΝΑΔΑΣ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΕΠΙΣΚΕΠΤΕΣ ΣΕ ΙΔΙΟΚΤΗΣΙΕΣ ΧΡΟΝΟΜΕΡΙΣΤΙΚΗΣ ΜΙΣΘΩΣΗΣ',
  },
  {
    label: '55201900',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΔΩΜΑΤΙΟΥ Η ΜΟΝΑΔΑΣ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΕΠΙΣΚΕΠΤΕΣ, ΧΩΡΙΣ ΚΑΘΗΜΕΡΙΝΗ ΚΑΘΑΡΙΟΤΗΤΑ',
  },
  {
    label: '55201901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΠΛΩΜΕΝΩΝ ΔΙΑΜΕΡΙΣΜΑΤΩΝ ΜΙΚΡΗΣ ΔΙΑΡΚΕΙΑΣ, ΧΩΡΙΣ ΠΑΡΟΧΗ ΥΠΗΡΕΣΙΩΝ ΠΕΡΙΠΟΙΗΣΗΣ ΠΕΛΑΤΩΝ',
  },
  {
    label: '55300000',
    value:
      'ΧΩΡΟΙ ΚΑΤΑΣΚΗΝΩΣΗΣ, ΕΓΚΑΤΑΣΤΑΣΕΙΣ ΓΙΑ ΟΧΗΜΑΤΑ ΑΝΑΨΥΧΗΣ ΚΑΙ ΡΥΜΟΥΛΚΟΥΜΕΝΑ ΟΧΗΜΑΤΑ',
  },
  {
    label: '55301000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΗΝΩΣΗΣ (ΚΑΜΠΙΓΚ), ΕΓΚΑΤΑΣΤΑΣΕΩΝ ΓΙΑ ΟΧΗΜΑΤΑ ΑΝΑΨΥΧΗΣ (ΤΡΟΧΟΣΠΙΤΑ) ΚΑΙ ΡΥΜΟΥΛΚΟΥΜΕΝΑ ΟΧΗΜΑΤΑ (ΤΡΕΙΛΕΡ)',
  },
  {
    label: '55301100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΗΝΩΣΗΣ (ΚΑΜΠΙΓΚ)',
  },
  {
    label: '55301200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΕΩΝ ΓΙΑ ΟΧΗΜΑΤΑ ΑΝΑΨΥΧΗΣ (ΤΡΟΧΟΣΠΙΤΑ) ΚΑΙ ΡΥΜΟΥΛΚΟΥΜΕΝΑ ΟΧΗΜΑΤΑ (ΤΡΕΙΛΕΡ)',
  },
  {
    label: '55301201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΑΚΡΟΧΡΟΝΗΣ ΜΙΣΘΩΣΗΣ ΧΩΡΟΥ ΓΙΑ ΤΡΟΧΟΣΠΙΤΑ',
  },
  {
    label: '55900000',
    value: 'ΑΛΛΑ ΚΑΤΑΛΥΜΑΤΑ',
  },
  {
    label: '55901000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΛΥΜΑΤΟΣ',
  },
  {
    label: '55901100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΩΜΑΤΙΟΥ Η ΜΟΝΑΔΑΣ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΣΠΟΥΔΑΣΤΕΣ ΣΕ ΦΟΙΤΗΤΙΚΕΣ ΕΣΤΙΕΣ ΚΑΙ ΣΧΟΛΙΚΟΥΣ ΚΟΙΤΩΝΕΣ',
  },
  {
    label: '55901200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΩΜΑΤΙΟΥ Η ΜΟΝΑΔΑΣ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΕΡΓΑΖΟΜΕΝΟΥΣ ΣΕ ΞΕΝΩΝΕΣ ΕΡΓΑΖΟΜΕΝΩΝ Η ΚΑΤΑΣΚΗΝΩΣΕΙΣ',
  },
  {
    label: '55901300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΛΙΝΑΜΑΞΩΝ (ΒΑΓΚΟΝ;ΛΙ) ΚΑΙ ΥΠΗΡΕΣΙΕΣ ΥΠΝΟΥ ΣΕ ΑΛΛΑ ΜΕΤΑΦΟΡΙΚΑ ΜΕΣΑ',
  },
  {
    label: '55901900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΛΥΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '55901901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΠΛΩΜΕΝΩΝ ΔΙΑΜΕΡΙΣΜΑΤΩΝ ΜΑΚΡΑΣ ΔΙΑΡΚΕΙΑΣ, ΜΕ ΠΑΡΟΧΗ ΥΠΗΡΕΣΙΩΝ ΠΕΡΙΠΟΙΗΣΗΣ ΠΕΛΑΤΩΝ',
  },
  {
    label: '56100000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΥΠΗΡΕΣΙΩΝ ΕΣΤΙΑΤΟΡΙΩΝ ΚΑΙ ΚΙΝΗΤΩΝ ΜΟΝΑΔΩΝ ΕΣΤΙΑΣΗΣ',
  },
  {
    label: '56101000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΣΤΙΑΤΟΡΙΩΝ ΚΑΙ ΚΙΝΗΤΩΝ ΜΟΝΑΔΩΝ ΕΣΤΙΑΣΗΣ',
  },
  {
    label: '56101100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΜΕ ΠΛΗΡΗ ΕΞΥΠΗΡΕΤΗΣΗ ΕΣΤΙΑΤΟΡΙΟΥ',
  },
  {
    label: '56101101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΦΕΖΑΧΑΡΟΠΛΑΣΤΕΙΟΥ, ΜΕ ΔΙΑΘΕΣΗ ΠΡΟΣΒΑΣΗΣ ΣΤΟ ΔΙΑΔΙΚΤΥΟ',
  },
  {
    label: '56101102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΣΤΙΑΤΟΡΙΟΥ ΜΕΣΑ ΣΕ ΞΕΝΟΔΟΧΕΙΟ ΥΠΝΟΥ',
  },
  {
    label: '56101103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΑΠΟ ΕΣΤΙΑΤΟΡΙΟ, ΤΑΒΕΡΝΑ, ΨΑΡΟΤΑΒΕΡΝΑ, ΨΗΣΤΑΡΙΑ, ΜΕ ΖΩΝΤΑΝΗ ΜΟΥΣΙΚΗ ΑΠΟ ΟΡΧΗΣΤΡΑ ΤΡΙΩΝ ΤΟΥΛΑΧΙΣΤΩΝ ΟΡΓΑΝΩΝ (ΠΟΥ ΥΠΑΓΕΤΑΙ ΣΤΗΝ 1059176 ;/ 625 ;/ΠΟΛ.1087 ;/25 ;.6 ;.2003 ~ (ΦΕΚ Β 932 ;) ΑΠΟΦΑΣΗ ΥΠΟΥΡΓΟΥ ΟΙΚΟΝΟΜΙΑΣ ΚΑΙ ΟΙΚΟΝΟΜΙΚΩΝ, ΟΠΩΣ ΙΣΧΥΕΙ ΚΑΘΕ ΦΟΡΑ), ΜΕ ΠΑΡΟΧΗ ΣΕΡΒΙΡΙΣΜΑΤΟΣ',
  },
  {
    label: '56101104',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΑΠΟ ΕΣΤΙΑΤΟΡΙΟ, ΤΑΒΕΡΝΑ, ΨΑΡΟΤΑΒΕΡΝΑ, ΨΗΣΤΑΡΙΑ, ΧΩΡΙΣ ΖΩΝΤΑΝΗ ΜΟΥΣΙΚΗ Η ΜΕ ΟΡΧΗΣΤΡΑ ΛΙΓΟΤΕΡΗ ΤΩΝ ΤΡΙΩΝ ΟΡΓΑΝΩΝ (ΠΟΥ ΔΕΝ ΥΠΑΓΕΤΑΙ ΣΤΗΝ 1059176 ;/625 ;/ΠΟΛ.1087 ;/25 ;.6 ;.2003 ~ (ΦΕΚ Β 932 ;) ΑΠΟΦΑΣΗ ΥΠΟΥΡΓΟΥ ΟΙΚΟΝΟΜΙΑΣ ΚΑΙ ΟΙΚΟΝΟΜΙΚΩΝ, ΟΠΩΣ ΙΣΧΥΕΙ ΚΑΘΕ ΦΟΡΑ), ΜΕ ΠΑΡΟΧΗ ΣΕΡΒΙΡΙΣΜΑΤΟΣ',
  },
  {
    label: '56101105',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΑΠΟ ΕΣΤΙΑΤΟΡΙΟ ΤΑΧΕΙΑΣ ΕΞΥΠΗΡΕΤΗΣΕΩΣ (ΦΑΣΤ ~ ΦΟΥΝΤ), ΜΕ ΠΑΡΟΧΗ ΣΕΡΒΙΡΙΣΜΑΤΟΣ',
  },
  {
    label: '56101106',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΑΠΟ ΚΕΝΤΡΟ ΔΙΑΣΚΕΔΑΣΗΣ ~ ΚΟΣΜΙΚΗ ΤΑΒΕΡΝΑ',
  },
  {
    label: '56101107',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΑΠΟ ΟΙΝΕΣΤΙΑΤΟΡΙΟ Η ΟΙΝΟΜΑΓΕΙΡΕΙΟ (ΟΙΚΟΓΕΝΕΙΑΚΗ ΕΠΙΧΕΙΡΗΣΗ, ΧΩΡΙΣ ΠΡΟΣΩΠΙΚΟ)',
  },
  {
    label: '56101108',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΑΠΟ ΠΙΤΣΑΡΙΑ, ΜΕ ΠΑΡΟΧΗ ΣΕΡΒΙΡΙΣΜΑΤΟΣ',
  },
  {
    label: '56101109',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΑΠΟ ΨΗΤΟΠΩΛΕΙΑ ~ ΣΟΥΒΛΑΤΖΙΔΙΚΑ, ΜΕ ΠΑΡΟΧΗ ΣΕΡΒΙΡΙΣΜΑΤΟΣ',
  },
  {
    label: '56101110',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΚΑΙ ΠΟΤΩΝ ΑΠΟ ΟΥΖΕΡΙ, ΜΕΖΕΔΟΠΩΛΕΙΟ, ΤΣΙΠΟΥΡΑΔΙΚΟ, ΖΥΘΟΠΩΛΕΙΟ ΜΕ ΠΑΡΟΧΗ ΣΕΡΒΙΡΙΣΜΑΤΟΣ',
  },
  {
    label: '56101111',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΚΑΙ ΠΟΤΩΝ ΑΠΟ ΣΝΑΚ ΜΠΑΡ, ΜΕ ΠΑΡΟΧΗ ΣΕΡΒΙΡΙΣΜΑΤΟΣ',
  },
  {
    label: '56101112',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΜΕ ΔΙΑΘΕΣΗ ΠΡΟΣΒΑΣΗΣ ΣΤΟ ΔΙΑΔΙΚΤΥΟ',
  },
  {
    label: '56101113',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΛΥΚΩΝ, ΠΑΓΩΤΩΝ ΚΛΠ ΑΠΟ ΖΑΧΑΡΟΠΛΑΣΤΕΙΟ, ΓΑΛΑΚΤΟΖΑΧΑΡΟΠΛΑΣΤΕΙΟ, ΚΑΦΕΖΑΧΑΡΟΠΛΑΣΤΕΙΟ, ΜΕ ΠΑΡΟΧΗ ΣΕΡΒΙΡΙΣΜΑΤΟΣ',
  },
  {
    label: '56101200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΣΕ ΒΑΓΟΝΙ;ΕΣΤΙΑΤΟΡΙΟ ΚΑΙ ΣΕ ΠΛΟΙΑ',
  },
  {
    label: '56101201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΚΑΙ ΠΟΤΩΝ ΑΠΟ ΚΥΛΙΚΕΙΟ, ΠΟΥ ΒΡΙΣΚΕΤΑΙ ΣΕ ΠΛΟΙΟ',
  },
  {
    label: '56101300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΣΕ ΕΣΤΙΑΤΟΡΙΑ ΑΥΤΟΕΞΥΠΗΡΕΤΗΣΗΣ (SELF SERVICE)',
  },
  {
    label: '56101301',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΑΠΟ ΕΣΤΙΑΤΟΡΙΟ ΤΑΧΕΙΑΣ ΕΞΥΠΗΡΕΤΗΣΕΩΣ (ΦΑΣΤ;ΦΟΥΝΤ), ΜΕ ΠΑΡΟΧΗ ΚΑΘΙΣΜΑΤΟΣ, ΑΛΛΑ ΟΧΙ ΣΕΡΒΙΡΙΣΜΑΤΟΣ',
  },
  {
    label: '56101302',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΑΠΟ ΕΣΤΙΑΤΟΡΙΟ, ΤΑΒΕΡΝΑ, ΨΑΡΟΤΑΒΕΡΝΑ, ΠΙΤΣΑΡΙΑ ΚΛΠ ΧΩΡΙΣ ΖΩΝΤΑΝΗ ΜΟΥΣΙΚΗ, ΜΕ ΠΑΡΟΧΗ ΚΑΘΙΣΜΑΤΟΣ ΑΛΛΑ ΟΧΙ ΣΕΡΒΙΡΙΣΜΑΤΟΣ',
  },
  {
    label: '56101303',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΑΠΟ ΨΗΤΟΠΩΛΕΙΟ ~ ΣΟΥΒΛΑΤΖΙΔΙΚΟ ΜΕ ΠΑΡΟΧΗ ΚΑΘΙΣΜΑΤΟΣ ΑΛΛΑ ΟΧΙ ΣΕΡΒΙΡΙΣΜΑΤΟΣ',
  },
  {
    label: '56101304',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΚΑΙ ΠΟΤΩΝ ΑΠΟ ΣΝΑΚ ΜΠΑΡ, ΟΥΖΕΡΙ, ΜΕΖΕΔΟΠΩΛΕΙΟ, ΤΣΙΠΟΥΡΑΔΙΚΟ, ΖΥΘΟΠΩΛΕΙΟ, ΜΕ ΠΑΡΟΧΗ ΚΑΘΙΣΜΑΤΟΣ ΑΛΛΑ ΟΧΙ ΣΕΡΒΙΡΙΣΜΑΤΟΣ',
  },
  {
    label: '56101900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ',
  },
  {
    label: '56101901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΕΥΜΑΤΩΝ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΙΝΗΤΕΣ ΚΑΝΤΙΝΕΣ, ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΥΠΑΙΘΡΙΑ (Η ΕΞΥΠΗΡΕΤΟΥΝ ΥΠΑΙΘΡΙΕΣ ΕΚΔΗΛΩΣΕΙΣ)',
  },
  {
    label: '56101902',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΑΠΟ ΕΣΤΙΑΤΟΡΙΟ ΤΑΧΕΙΑΣ ΕΞΥΠΗΡΕΤΗΣΕΩΣ (ΦΑΣΤ;ΦΟΥΝΤ), ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΘΙΣΜΑΤΟΣ',
  },
  {
    label: '56101903',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΑΠΟ ΨΗΤΟΠΩΛΕΙΟ ~ ΣΟΥΒΛΑΤΖΙΔΙΚΟ), ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΘΙΣΜΑΤΟΣ',
  },
  {
    label: '56101904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΚΑΙ ΠΟΤΩΝ ΑΠΟ ΚΥΛΙΚΕΙΟ',
  },
  {
    label: '56101905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΚΑΙ ΠΟΤΩΝ ΑΠΟ ΚΥΛΙΚΕΙΟ ΓΗΠΕΔΟΥ',
  },
  {
    label: '56101906',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΚΑΙ ΠΟΤΩΝ ΑΠΟ ΚΥΛΙΚΕΙΟ ΘΕΑΤΡΟΥ Η ΚΙΝΗΜΑΤΟΓΡΑΦΟΥ',
  },
  {
    label: '56101907',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΚΑΙ ΠΟΤΩΝ ΑΠΟ ΚΥΛΙΚΕΙΟ, ΠΟΥ ΒΡΙΣΚΕΤΑΙ ΣΕ ΑΕΡΟΔΡΟΜΙΑ, ΔΗΜΟΣΙΕΣ ΥΠΗΡΕΣΙΕΣ ΚΑΙ ΑΛΛΟΥΣ ΔΗΜΟΣΙΟΥΣ ΧΩΡΟΥΣ',
  },
  {
    label: '56101908',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΚΑΙ ΠΟΤΩΝ ΑΠΟ ΣΝΑΚ ΜΠΑΡ, ΟΥΖΕΡΙ, ΚΑΦΕ;ΟΥΖΕΡΙ, ΜΕΖΕΔΟΠΩΛΕΙΟ, ΤΣΙΠΟΥΡΑΔΙΚΟ, ΖΥΘΟΠΩΛΕΙΟ, ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΘΙΣΜΑΤΟΣ',
  },
  {
    label: '56101909',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΥΜΑΤΩΝ ΚΑΙ ΠΟΤΩΝ ΣΕ ΥΠΑΙΘΡΙΕΣ ΕΚΔΗΛΩΣΕΙΣ, ΟΧΙ ΑΠΟ ΚΙΝΗΤΕΣ ΚΑΝΤΙΝΕΣ',
  },
  {
    label: '56101910',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΑΛΛΑΝΤΟΖΥΘΟΠΩΛΕΙΟ',
  },
  {
    label: '56101911',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΕΣΤΙΑΤΟΡΙΑ, ΠΟΥ ΠΩΛΟΥΝ ΜΕΡΙΔΕΣ ΦΑΓΗΤΟΥ ΣΕ ΠΑΚΕΤΑ',
  },
  {
    label: '56101912',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΑΤΑΣΤΗΜΑΤΑ ΑΝΑΨΥΚΤΗΡΙΩΝ, ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΘΙΣΜΑΤΟΣ',
  },
  {
    label: '56101913',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΑΤΑΣΤΗΜΑΤΑ ΠΟΥ ΠΩΛΟΥΝ ΣΟΥΒΛΑΚΙΑ, ΣΑΝΤΟΥΙΤΣ ΚΑΙ ΤΑ ΣΥΝΑΦΗ, ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΘΙΣΜΑΤΟΣ',
  },
  {
    label: '56101914',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΑΤΑΣΤΗΜΑΤΑ ΠΩΛΗΣΗΣ ΠΑΓΩΤΩΝ Η ΑΛΛΩΝ ΓΛΥΚΩΝ, ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΘΙΣΜΑΤΟΣ',
  },
  {
    label: '56101915',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΠΙΤΣΑΣ ΣΕ ΠΑΚΕΤΟ',
  },
  {
    label: '56210000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΥΠΗΡΕΣΙΩΝ ΤΡΟΦΟΔΟΣΙΑΣ ΓΙΑ ΕΚΔΗΛΩΣΕΙΣ',
  },
  {
    label: '56211000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΡΟΦΟΔΟΣΙΑΣ ΕΚΔΗΛΩΣΕΩΝ (CATERING)',
  },
  {
    label: '56211100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΡΟΦΟΔΟΣΙΑΣ ΕΚΔΗΛΩΣΕΩΝ (CATERING) ΙΔΙΩΤΙΚΩΝ ΟΙΚΙΩΝ',
  },
  {
    label: '56211101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΡΟΦΟΔΟΣΙΑΣ ΣΥΝΕΣΤΙΑΣΕΩΝ ~ ΕΚΔΗΛΩΣΕΩΝ (CATERING) ΣΕ ΙΔΙΩΤΙΚΕΣ ΟΙΚΙΕΣ',
  },
  {
    label: '56211900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΡΟΦΟΔΟΣΙΑΣ ΕΚΔΗΛΩΣΕΩΝ (CATERING)',
  },
  {
    label: '56211901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΡΟΦΟΔΟΣΙΑΣ ΣΥΝΕΣΤΙΑΣΕΩΝ ~ ΕΚΔΗΛΩΣΕΩΝ (CATERING) ΣΕ ΕΠΑΓΓΕΛΜΑΤΙΚΟΥΣ ΧΩΡΟΥΣ',
  },
  {
    label: '56290000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΣΤΙΑΣΗΣ',
  },
  {
    label: '56291000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΣΤΙΑΤΟΡΙΟΥ ΕΠΙ ΣΥΜΒΑΣΕΙ',
  },
  {
    label: '56291100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΣΤΙΑΤΟΡΙΟΥ ΕΠΙ ΣΥΜΒΑΣΕΙ ΓΙΑ ΜΕΤΑΦΟΡΙΚΕΣ ΕΤΑΙΡΕΙΕΣ',
  },
  {
    label: '56291101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΦΟΔΙΑΣΜΟΥ ΑΕΡΟΣΚΑΦΩΝ ΜΕ ΕΤΟΙΜΑ ΦΑΓΗΤΑ',
  },
  {
    label: '56291102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΦΟΔΙΑΣΜΟΥ ΣΚΑΦΩΝ ΑΝΑΨΥΧΗΣ ΜΕ ΕΤΟΙΜΑ ΦΑΓΗΤΑ',
  },
  {
    label: '56291103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΡΟΦΟΔΟΣΙΑΣ ΜΕ ΕΤΟΙΜΑ ΦΑΓΗΤΑ ΣΚΑΦΩΝ ΑΝΑΨΥΧΗΣ, ΙΔΙΩΤΙΚΩΝ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΟΠΟΙΟΥΔΗΠΟΤΕ ΑΛΛΟΥ ΜΕΤΑΦΟΡΙΚΟΥ ΜΕΣΟΥ ΙΔΙΩΤΙΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '56291900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΣΤΙΑΤΟΡΙΟΥ ΕΠΙ ΣΥΜΒΑΣΕΙ',
  },
  {
    label: '56291901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΑΓΕΙΡΑ (ΜΕ ΣΥΜΒΑΣΗ ΕΡΓΟΥ)',
  },
  {
    label: '56292000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΝΤΙΝΑΣ',
  },
  {
    label: '56292001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΕΥΜΑΤΩΝ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΣΤΡΑΤΙΩΤΙΚΕΣ ΤΡΑΠΕΖΑΡΙΕΣ',
  },
  {
    label: '56292002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΑΝΤΙΝΕΣ ΑΘΛΗΤΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ',
  },
  {
    label: '56292003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΑΝΤΙΝΕΣ ΕΡΓΟΣΤΑΣΙΩΝ Η ΓΡΑΦΕΙΩΝ',
  },
  {
    label: '56292004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΣΧΟΛΙΚΕΣ ΚΑΝΤΙΝΕΣ (ΚΥΛΙΚΕΙΑ)',
  },
  {
    label: '56292005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΦΟΙΤΗΤΙΚΑ ΕΣΤΙΑΤΟΡΙΑ',
  },
  {
    label: '56300000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΑΡΟΧΗΣ ΠΟΤΩΝ',
  },
  {
    label: '56301000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΠΟΤΩΝ',
  },
  {
    label: '56301001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΠΑΡ, ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΧΟΡΕΥΤΙΚΟ ΚΕΝΤΡΟ',
  },
  {
    label: '56301002',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΑΛΛΑ ΚΑΤΑΣΤΗΜΑΤΑ ΠΩΛΗΣΗΣ ΠΟΤΩΝ ΜΕ ΔΙΑΘΕΣΗ ΠΡΟΣΒΑΣΗΣ ΣΤΟ ΔΙΑΔΙΚΤΥΟ',
  },
  {
    label: '56301003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΑΝΑΨΥΚΤΗΡΙΟ',
  },
  {
    label: '56301004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΑΦΕ ΜΠΑΡ',
  },
  {
    label: '56301005',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΑΦΕΝΕΙΟ, ΜΕ ΤΕΧΝΙΚΑ Η ΜΗΧΑΝΙΚΑ ΠΑΙΧΝΙΔΙΑ',
  },
  {
    label: '56301006',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΑΦΕΝΕΙΟ, ΧΩΡΙΣ ΤΕΧΝΙΚΑ ΚΑΙ ΜΗΧΑΝΙΚΑ ΠΑΙΧΝΙΔΙΑ',
  },
  {
    label: '56301007',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΑΦΕΤΕΡΙΑ',
  },
  {
    label: '56301008',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΑΦΕΤΕΡΙΑ ΜΕ ΔΙΑΘΕΣΗ ΠΡΟΣΒΑΣΗΣ ΣΤΟ ΔΙΑΔΙΚΤΥΟ (INTERNET;CAFE)',
  },
  {
    label: '56301009',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΕΝΤΡΟ ΔΙΑΣΚΕΔΑΣΗΣ ~ ΚΑΜΠΑΡΕ Η ΝΑΙΤ ΚΛΑΜΠ',
  },
  {
    label: '56301010',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΕΝΤΡΟ ΔΙΑΣΚΕΔΑΣΗΣ ~ ΚΑΦΩΔΕΙΟ',
  },
  {
    label: '56301011',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΕΝΤΡΟ ΔΙΑΣΚΕΔΑΣΗΣ ~ ΜΠΟΥΑΤ',
  },
  {
    label: '56301012',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΚΕΝΤΡΟ ΔΙΑΣΚΕΔΑΣΗΣ ~ ΝΤΙΣΚΟΤΕΚ',
  },
  {
    label: '56301013',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΜΠΑΡ ΞΕΝΟΔΟΧΕΙΩΝ',
  },
  {
    label: '56301014',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΠΑΡΑΔΟΣΙΑΚΟ ΚΑΦΕΝΕΙΟ',
  },
  {
    label: '58110000',
    value: 'ΕΚΔΟΣΗ ΒΙΒΛΙΩΝ',
  },
  {
    label: '58111000',
    value: 'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΒΙΒΛΙΩΝ',
  },
  {
    label: '58111100',
    value: 'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΔΙΔΑΚΤΙΚΩΝ ΒΙΒΛΙΩΝ ΕΚΠΑΙΔΕΥΤΙΚΟΥ ΠΕΡΙΕΧΟΜΕΝΟΥ',
  },
  {
    label: '58111200',
    value:
      'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΒΙΒΛΙΩΝ ΕΠΑΓΓΕΛΜΑΤΙΚΟΥ, ΤΕΧΝΙΚΟΥ ΚΑΙ ΑΚΑΔΗΜΑΪΚΟΥ ΠΕΡΙΕΧΟΜΕΝΟΥ',
  },
  {
    label: '58111300',
    value: 'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΠΑΙΔΙΚΩΝ ΒΙΒΛΙΩΝ',
  },
  {
    label: '58111400',
    value: 'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΛΕΞΙΚΩΝ ΚΑΙ ΕΓΚΥΚΛΟΠΑΙΔΕΙΩΝ',
  },
  {
    label: '58111500',
    value: 'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΑΤΛΑΝΤΩΝ ΚΑΙ ΑΛΛΩΝ ΒΙΒΛΙΩΝ ΜΕ ΧΑΡΤΕΣ',
  },
  {
    label: '58111600',
    value:
      'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΧΑΡΤΩΝ ΚΑΙ ΥΔΡΟΓΡΑΦΙΚΩΝ Η ΠΑΡΟΜΟΙΩΝ ΔΙΑΓΡΑΜΜΑΤΩΝ, ΣΕ ΑΛΛΗ ΜΟΡΦΗ ΕΚΤΟΣ ΒΙΒΛΙΟΥ',
  },
  {
    label: '58111900',
    value: 'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΒΙΒΛΙΩΝ, ΦΥΛΛΑΔΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ, ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '58112000',
    value: 'ΕΚΔΟΣΗ ΒΙΒΛΙΩΝ ΣΕ ΔΙΣΚΟ, ΤΑΙΝΙΑ Η ΑΛΛΑ ΦΥΣΙΚΑ ΜΕΣΑ',
  },
  {
    label: '58113000',
    value: 'ΠΑΡΑΓΩΓΗ ΕΠΙΓΡΑΜΜΙΚΩΝ (ON LINE) ΒΙΒΛΙΩΝ',
  },
  {
    label: '58114000',
    value: 'ΔΙΑΘΕΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ ΣΕ ΒΙΒΛΙΑ',
  },
  {
    label: '58114100',
    value: 'ΔΙΑΘΕΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ ΣΕ ΒΙΒΛΙΑ, ΕΝΤΥΠΗΣ ΜΟΡΦΗΣ',
  },
  {
    label: '58114200',
    value: 'ΔΙΑΘΕΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ ΣΕ ΒΙΒΛΙΑ, ΗΛΕΚΤΡΟΝΙΚΗΣ ΜΟΡΦΗΣ',
  },
  {
    label: '58115000',
    value: 'ΕΚΔΟΣΕΙΣ ΒΙΒΛΙΩΝ ΜΕ ΑΜΟΙΒΗ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '58116000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΩΝ ΓΙΑ ΒΙΒΛΙΑ',
  },
  {
    label: '58120000',
    value: 'ΕΚΔΟΣΗ ΤΗΛΕΦΩΝΙΚΩΝ ΚΑΙ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΤΑΛΟΓΩΝ',
  },
  {
    label: '58121000',
    value:
      'ΕΚΔΟΣΗ ΚΑΤΑΛΟΓΩΝ ΤΗΛΕΦΩΝΙΚΩΝ, ΤΑΧΥΔΡΟΜΙΚΩΝ ΔΙΕΥΘΥΝΣΕΩΝ ΚΑΙ ΚΑΘΕ ΕΙΔΟΥΣ ΣΕ ΕΝΤΥΠΗ ΜΟΡΦΗ Η ΣΕ ΑΛΛΟΥΣ ΦΥΣΙΚΟΥΣ ΦΟΡΕΙΣ',
  },
  {
    label: '58122000',
    value:
      'ΠΑΡΑΓΩΓΗ ΕΠΙΓΡΑΜΜΙΚΩΝ (ON LINE) ΚΑΤΑΛΟΓΩΝ ΤΗΛΕΦΩΝΙΚΩΝ, ΤΑΧΥΔΡΟΜΙΚΩΝ ΔΙΕΥΘΥΝΣΕΩΝ ΚΑΙ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '58123000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΑΣ ΤΑ ΔΙΚΑΙΩΜΑΤΑ ΧΡΗΣΗΣ ΚΑΤΑΛΟΓΩΝ ΤΗΛΕΦΩΝΙΚΩΝ, ΤΑΧΥΔΡΟΜΙΚΩΝ ΔΙΕΥΘΥΝΣΕΩΝ ΚΑΙ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '58130000',
    value: 'ΕΚΔΟΣΗ ΕΦΗΜΕΡΙΔΩΝ',
  },
  {
    label: '58131000',
    value: 'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΕΦΗΜΕΡΙΔΩΝ',
  },
  {
    label: '58132000',
    value: 'ΠΑΡΑΓΩΓΗ ΕΠΙΓΡΑΜΜΙΚΩΝ (ON LINE) ΕΦΗΜΕΡΙΔΩΝ',
  },
  {
    label: '58133000',
    value: 'ΔΙΑΘΕΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ ΣΕ ΕΦΗΜΕΡΙΔΕΣ',
  },
  {
    label: '58133100',
    value: 'ΔΙΑΘΕΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ ΣΕ ΕΦΗΜΕΡΙΔΕΣ, ΕΝΤΥΠΗΣ ΜΟΡΦΗΣ',
  },
  {
    label: '58133200',
    value: 'ΔΙΑΘΕΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ ΣΕ ΕΦΗΜΕΡΙΔΕΣ, ΗΛΕΚΤΡΟΝΙΚΗΣ ΜΟΡΦΗΣ',
  },
  {
    label: '58140000',
    value: 'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΠΕΡΙΟΔΙΚΩΝ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '58141100',
    value: 'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΠΕΡΙΟΔΙΚΩΝ ΓΕΝΙΚΟΥ ΕΝΔΙΑΦΕΡΟΝΤΟΣ',
  },
  {
    label: '58141200',
    value:
      'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΠΕΡΙΟΔΙΚΩΝ ΕΠΙΧΕΙΡΗΜΑΤΙΚΟΥ, ΕΠΑΓΓΕΛΜΑΤΙΚΟΥ ΚΑΙ ΑΚΑΔΗΜΑΪΚΟΥ ΠΕΡΙΕΧΟΜΕΝΟΥ',
  },
  {
    label: '58141900',
    value: 'ΕΚΔΟΣΗ ΑΛΛΩΝ ΕΝΤΥΠΩΝ ΠΕΡΙΟΔΙΚΩΝ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '58142000',
    value: 'ΠΑΡΑΓΩΓΗ ΕΠΙΓΡΑΜΜΙΚΩΝ (ON LINE) ΠΕΡΙΟΔΙΚΩΝ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '58143000',
    value: 'ΔΙΑΘΕΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ ΣΕ ΠΕΡΙΟΔΙΚΑ',
  },
  {
    label: '58143100',
    value: 'ΔΙΑΘΕΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ ΣΕ ΠΕΡΙΟΔΙΚΑ, ΕΝΤΥΠΗΣ ΜΟΡΦΗΣ',
  },
  {
    label: '58143200',
    value: 'ΔΙΑΘΕΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ ΣΕ ΠΕΡΙΟΔΙΚΑ, ΗΛΕΚΤΡΟΝΙΚΗΣ ΜΟΡΦΗΣ',
  },
  {
    label: '58144000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΩΝ ΓΙΑ ΠΕΡΙΟΔΙΚΑ',
  },
  {
    label: '58190000',
    value: 'ΑΛΛΕΣ ΕΚΔΟΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '58191000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΚΔΟΣΗΣ ΕΝΤΥΠΩΝ',
  },
  {
    label: '58191100',
    value:
      'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΤΑΧΥΔΡΟΜΙΚΩΝ ΔΕΛΤΑΡΙΩΝ, ΚΑΡΤΩΝ ΜΕ ΕΥΧΕΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ',
  },
  {
    label: '58191200',
    value: 'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΕΙΚΟΝΩΝ, ΣΧΕΔΙΩΝ ΚΑΙ ΦΩΤΟΓΡΑΦΙΩΝ',
  },
  {
    label: '58191300',
    value: 'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΧΑΛΚΟΜΑΝΙΩΝ ΚΑΙ ΗΜΕΡΟΛΟΓΙΩΝ',
  },
  {
    label: '58191400',
    value:
      'ΕΚΔΟΣΗ ΕΝΤΥΠΩΝ ΑΣΦΡΑΓΙΣΤΩΝ ΓΡΑΜΜΑΤΟΣΗΜΩΝ, ΧΑΡΤΟΣΗΜΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ· ΧΑΡΤΟΣΗΜΑΣΜΕΝΟΥ ΧΑΡΤΙΟΥ· ΕΠΙΤΑΓΩΝ· ΧΑΡΤΟΝΟΜΙΣΜΑΤΩΝ, ΤΙΤΛΩΝ ΜΕΤΟΧΩΝ, ΜΕΡΙΣΜΑΤΩΝ Η ΟΜΟΛΟΓΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΓΓΡΑΦΩΝ ΤΙΤΛΩΝ',
  },
  {
    label: '58191500',
    value:
      'ΕΚΔΟΣΗ ΕΝΤΥΠΟΥ ΕΜΠΟΡΙΚΟΥ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΥΛΙΚΟΥ, ΕΜΠΟΡΙΚΩΝ ΚΑΤΑΛΟΓΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ',
  },
  {
    label: '58191900',
    value: 'ΕΚΔΟΣΗ ΑΛΛΟΥ ΕΝΤΥΠΟΥ ΥΛΙΚΟΥ',
  },
  {
    label: '58192000',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΟΥ ΕΠΙΓΡΑΜΜΙΚΟΥ (ON LINE) ΠΕΡΙΕΧΟΜΕΝΟΥ',
  },
  {
    label: '58192100',
    value: 'ΠΑΡΑΓΩΓΗ ΕΠΙΓΡΑΜΜΙΚΟΥ (ON LINE) ΠΕΡΙΕΧΟΜΕΝΟΥ ΓΙΑ ΕΝΗΛΙΚΟΥΣ',
  },
  {
    label: '58192900',
    value: 'ΠΑΡΑΓΩΓΗ ΑΛΛΟΥ ΕΠΙΓΡΑΜΜΙΚΟΥ (ON LINE) ΠΕΡΙΕΧΟΜΕΝΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '58193000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΩΝ ΓΙΑ ΑΛΛΟ ΕΝΤΥΠΟ ΥΛΙΚΟ',
  },
  {
    label: '58210000',
    value: 'ΕΚΔΟΣΗ ΠΑΙΧΝΙΔΙΩΝ ΓΙΑ ΗΛΕΚΤΡΟΝΙΚΟΥΣ ΥΠΟΛΟΓΙΣΤΕΣ',
  },
  {
    label: '58211000',
    value: 'ΕΚΔΟΣΗ ΠΑΙΧΝΙΔΙΩΝ ΥΠΟΛΟΓΙΣΤΗ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΣΥΣΚΕΥΑΣΜΕΝΑ',
  },
  {
    label: '58212000',
    value:
      'ΕΚΔΟΣΗ ΠΑΙΧΝΙΔΙΩΝ ΥΠΟΛΟΓΙΣΤΗ, ΠΟΥ ΚΑΤΕΒΑΖΟΝΤΑΙ (DOWNLOAD) ΑΠΟ ΤΟ INTERNET',
  },
  {
    label: '58213000',
    value: "ΔΙΑΘΕΣΗ ΠΑΙΧΝΙΔΙΩΝ ΣΕ ΑΠ' ΕΥΘΕΙΑΣ (ON LINE) ΣΥΝΔΕΣΗ",
  },
  {
    label: '58214000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΩΝ ΓΙΑ ΤΗ ΧΡΗΣΗ ΠΑΙΧΝΙΔΙΩΝ ΥΠΟΛΟΓΙΣΤΗ',
  },
  {
    label: '58290000',
    value: 'ΕΚΔΟΣΗ ΑΛΛΟΥ ΛΟΓΙΣΜΙΚΟΥ',
  },
  {
    label: '58291000',
    value: 'ΕΚΔΟΣΗ ΛΟΓΙΣΜΙΚΟΥ ΣΥΣΤΗΜΑΤΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΣΕ ΣΥΣΚΕΥΑΣΙΑ',
  },
  {
    label: '58291100',
    value: 'ΕΚΔΟΣΗ ΛΕΙΤΟΥΡΓΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΣΕ ΣΥΣΚΕΥΑΣΙΑ',
  },
  {
    label: '58291200',
    value: 'ΕΚΔΟΣΗ ΛΟΓΙΣΜΙΚΟΥ ΔΙΚΤΥΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΣΕ ΣΥΣΚΕΥΑΣΙΑ',
  },
  {
    label: '58291300',
    value:
      'ΕΚΔΟΣΗ ΛΟΓΙΣΜΙΚΟΥ ΔΙΑΧΕΙΡΙΣΗΣ ΒΑΣΕΩΝ ΔΕΔΟΜΕΝΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΣΕ ΣΥΣΚΕΥΑΣΙΑ',
  },
  {
    label: '58291400',
    value:
      'ΕΚΔΟΣΗ ΛΟΓΙΣΜΙΚΟΥ ΕΡΓΑΛΕΙΩΝ ΑΝΑΠΤΥΞΗΣ ΚΑΙ ΓΛΩΣΣΩΝ ΠΡΟΓΡΑΜΜΑΤΙΣΜΟΥ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΣΕ ΣΥΣΚΕΥΑΣΙΑ',
  },
  {
    label: '58292000',
    value: 'ΕΚΔΟΣΗ ΛΟΓΙΣΜΙΚΟΥ ΕΦΑΡΜΟΓΩΝ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΣΕ ΣΥΣΚΕΥΑΣΙΑ',
  },
  {
    label: '58292100',
    value:
      'ΕΚΔΟΣΗ ΓΕΝΙΚΩΝ ΕΦΑΡΜΟΓΩΝ ΛΟΓΙΣΜΙΚΟΥ ΕΠΙΧΕΙΡΗΜΑΤΙΚΗΣ ΠΑΡΑΓΩΓΙΚΟΤΗΤΑΣ ΚΑΙ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ, ΠΟΥ ΔΙΑΘΕΤΕΤΑΙ ΣΕ ΣΥΣΚΕΥΑΣΙΑ',
  },
  {
    label: '58292900',
    value: 'ΕΚΔΟΣΗ ΑΛΛΩΝ ΛΟΓΙΣΜΙΚΩΝ ΕΦΑΡΜΟΓΩΝ, ΠΟΥ ΔΙΑΘΕΤΟΝΤΑΙ ΣΕ ΣΥΣΚΕΥΑΣΙΑ',
  },
  {
    label: '58293000',
    value: 'ΕΚΔΟΣΗ ΛΟΓΙΣΜΙΚΟΥ, ΠΟΥ ΚΑΤΕΒΑΖΕΤΑΙ (DOWNLOAD) ΑΠΟ ΤΟ INTERNET',
  },
  {
    label: '58293100',
    value:
      'ΕΚΔΟΣΗ ΛΟΓΙΣΜΙΚΟΥ ΣΥΣΤΗΜΑΤΩΝ, ΠΟΥ ΚΑΤΕΒΑΖΕΤΑΙ (DOWNLOAD) ΑΠΟ ΤΟ INTERNET',
  },
  {
    label: '58293200',
    value:
      'ΕΚΔΟΣΗ ΛΟΓΙΣΜΙΚΟΥ ΕΦΑΡΜΟΓΩΝ, ΠΟΥ ΚΑΤΕΒΑΖΕΤΑΙ (DOWNLOAD) ΑΠΟ ΤΟ INTERNET',
  },
  {
    label: '58294000',
    value: 'ΔΙΑΘΕΣΗ ΕΠΙΓΡΑΜΜΙΚΟΥ (ON LINE) ΛΟΓΙΣΜΙΚΟΥ',
  },
  {
    label: '58295000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΩΝ ΓΙΑ ΤΑ ΔΙΚΑΙΩΜΑΤΑ ΧΡΗΣΗΣ ΛΟΓΙΣΜΙΚΟΥ ΥΠΟΛΟΓΙΣΤΗ',
  },
  {
    label: '59110000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΑΡΑΓΩΓΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ, ΒΙΝΤΕΟ ΚΑΙ ΤΗΛΕΟΠΤΙΚΩΝ ΠΡΟΓΡΑΜΜΑΤΩΝ',
  },
  {
    label: '59111000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ, ΒΙΝΤΕΟ ΚΑΙ ΤΗΛΕΟΠΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ',
  },
  {
    label: '59111100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59111101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59111102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΤΗΛΕΟΠΤΙΚΩΝ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59111200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΤΑΙΝΙΩΝ ΠΡΟΩΘΗΣΗΣ Η ΔΙΑΦΗΜΙΣΤΙΚΩΝ ΚΑΙ ΒΙΝΤΕΟ',
  },
  {
    label: '59111201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΙΝΤΕΟΣΚΟΠΗΣΕΩΝ ΓΙΑ ΠΡΟΩΘΗΣΗ ΠΩΛΗΣΕΩΝ',
  },
  {
    label: '59111202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΔΙΑΦΗΜΙΣΤΙΚΩΝ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59111300',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΤΗΛΕΟΠΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ',
  },
  {
    label: '59112000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ, ΒΙΝΤΕΟ ΚΑΙ ΤΗΛΕΟΠΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ',
  },
  {
    label: '59112100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΠΡΩΤΟΤΥΠΩΝ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ, ΒΙΝΤΕΟ ΚΑΙ ΤΗΛΕΟΠΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ',
  },
  {
    label: '59112200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59112300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ ΚΑΙ ΑΛΛΟΥ ΠΕΡΙΕΧΟΜΕΝΟΥ ΒΙΝΤΕΟ ΣΕ ΔΙΣΚΟ, ΤΑΙΝΙΑ Η ΑΛΛΟ ΦΥΣΙΚΟ ΜΕΣΟ',
  },
  {
    label: '59112301',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΒΙΝΤΕΟΣΚΟΠΗΣΕΩΝ, ΕΚΤΟΣ ΔΙΑΦΗΜΙΣΤΙΚΩΝ ΚΑΙ ΕΚΤΟΣ ΕΚΔΗΛΩΣΕΩΝ',
  },
  {
    label: '59112400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΤΑΙΝΙΩΝ ΚΑΙ ΑΛΛΩΝ ΒΙΝΤΕΟ, ΠΟΥ ΚΑΤΕΒΑΖΟΝΤΑΙ (DOWNLOAD) ΑΠΟ ΤΟ INTERNET',
  },
  {
    label: '59113000',
    value:
      'ΠΩΛΗΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ Η ΧΡΟΝΟΥ ΣΕ ΤΑΙΝΙΕΣ, ΒΙΝΤΕΟ ΚΑΙ ΤΗΛΕΟΠΤΙΚΑ ΠΡΟΪΟΝΤΑ',
  },
  {
    label: '59120000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΥΝΟΔΕΥΤΙΚΕΣ ΤΗΣ ΠΑΡΑΓΩΓΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ, ΒΙΝΤΕΟ ΚΑΙ ΤΗΛΕΟΠΤΙΚΩΝ ΠΡΟΓΡΑΜΜΑΤΩΝ',
  },
  {
    label: '59121000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΟΔΕΥΤΙΚΕΣ ΤΗΣ ΠΑΡΑΓΩΓΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ, ΒΙΝΤΕΟ ΚΑΙ ΤΗΛΕΟΠΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ',
  },
  {
    label: '59121100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΠΤΙΚΟΑΚΟΥΣΤΙΚΗΣ ΕΠΙΜΕΛΕΙΑΣ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59121101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΟΝΤΑΖ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59121102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΝΤΟΥΜΠΛΑΡΙΣΜΑΤΟΣ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59121200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΣΧΗΜΑΤΙΣΜΩΝ ΚΑΙ ΑΝΑΠΑΡΑΓΩΓΗΣ ΠΡΩΤΟΤΥΠΩΝ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59121201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΑΠΑΡΑΓΩΓΗΣ ΠΡΟΕΓΓΕΓΡΑΜΜΕΝΩΝ ΜΕΣΩΝ ΕΓΓΡΑΦΗΣ ΗΧΟΥ, ΕΙΚΟΝΑΣ ΚΑΙ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '59121300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΡΩΜΑΤΙΚΗΣ ΔΙΟΡΘΩΣΗΣ ΚΑΙ ΨΗΦΙΑΚΗΣ ΑΠΟΚΑΤΑΣΤΑΣΗΣ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59121400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΠΤΙΚΩΝ ΕΦΕ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59121500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΙΝΟΥΜΕΝΩΝ ΣΧΕΔΙΩΝ (ANIMATION)',
  },
  {
    label: '59121600',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΓΡΑΦΗΣ, ΤΙΤΛΙΣΜΟΥ ΚΑΙ ΥΠΟΤΙΤΛΙΣΜΟΥ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59121601',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΤΥΠΩΣΗΣ ΥΠΟΤΙΤΛΩΝ ΣΕ ΤΑΙΝΙΕΣ',
  },
  {
    label: '59121700',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΚΟΥΣΤΙΚΗΣ ΕΠΙΜΕΛΕΙΑΣ ΚΑΙ ΣΧΕΔΙΑΣΗΣ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59121900',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΣΥΝΟΔΕΥΤΙΚΕΣ ΤΗΣ ΠΑΡΑΓΩΓΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ, ΒΙΝΤΕΟ ΚΑΙ ΤΗΛΕΟΠΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ',
  },
  {
    label: '59130000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΔΙΑΝΟΜΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ, ΒΙΝΤΕΟ ΚΑΙ ΤΗΛΕΟΠΤΙΚΩΝ ΠΡΟΓΡΑΜΜΑΤΩΝ',
  },
  {
    label: '59131000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΔΕΙΟΔΟΤΗΣΗΣ ΚΑΙ ΔΙΑΝΟΜΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ, ΒΙΝΤΕΟ ΚΑΙ ΤΗΛΕΟΠΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ',
  },
  {
    label: '59131100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΩΝ ΓΙΑ ΤΑ ΔΙΚΑΙΩΜΑΤΑ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ ΚΑΙ ΓΙΑ ΤΑ ΕΣΟΔΑ ΤΟΥΣ',
  },
  {
    label: '59131101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΔΙΚΑΙΩΜΑΤΩΝ ΡΑΔΙΟΤΗΛΕΟΠΤΙΚΩΝ ΠΡΟΓΡΑΜΜΑΤΩΝ',
  },
  {
    label: '59131102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59131200',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ, ΒΙΝΤΕΟ ΚΑΙ ΤΗΛΕΟΠΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ',
  },
  {
    label: '59131201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΜΕ ΠΟΣΟΣΤΑ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59140000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΡΟΒΟΛΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59141000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΒΟΛΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ',
  },
  {
    label: '59141001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΟΥ',
  },
  {
    label: '59200000',
    value: 'ΗΧΟΓΡΑΦΗΣΕΙΣ ΚΑΙ ΜΟΥΣΙΚΕΣ ΕΚΔΟΣΕΙΣ',
  },
  {
    label: '59201000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΗΧΟΓΡΑΦΗΣΗΣ ΚΑΙ ΖΩΝΤΑΝΗΣ ΕΓΓΡΑΦΗΣ ΗΧΟΥ· ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΗΧΟΓΡΑΦΗΣΕΩΝ',
  },
  {
    label: '59201100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΗΧΟΓΡΑΦΗΣΗΣ',
  },
  {
    label: '59201200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΖΩΝΤΑΝΗΣ ΕΓΓΡΑΦΗΣ ΗΧΟΥ',
  },
  {
    label: '59201300',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΗΧΟΓΡΑΦΗΣΕΩΝ',
  },
  {
    label: '59202000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΡΑΔΙΟΦΩΝΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ· ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΡΑΔΙΟΦΩΝΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ',
  },
  {
    label: '59202100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΡΑΔΙΟΦΩΝΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ',
  },
  {
    label: '59202200',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΡΑΔΙΟΦΩΝΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ',
  },
  {
    label: '59203000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΟΥΣΙΚΩΝ ΕΚΔΟΣΕΩΝ',
  },
  {
    label: '59203100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΕΝΤΥΠΗΣ ΜΟΥΣΙΚΗΣ',
  },
  {
    label: '59203200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΠΑΡΤΙΤΟΥΡΩΝ ΣΕ ΗΛΕΚΤΡΟΝΙΚΗ ΜΟΡΦΗ',
  },
  {
    label: '59203300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΜΟΥΣΙΚΩΝ ΔΙΣΚΩΝ, ΤΑΙΝΙΩΝ Η ΑΛΛΩΝ ΕΓΓΡΑΦΩΝ ΜΟΥΣΙΚΗΣ ΣΕ ΦΥΣΙΚΑ ΜΕΣΑ',
  },
  {
    label: '59203400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΑΛΛΩΝ ΔΙΣΚΩΝ ΚΑΙ ΤΑΙΝΙΩΝ ΗΧΟΥ',
  },
  {
    label: '59203500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΕΒΑΣΜΑΤΟΣ (DOWNLOADS) ΜΟΥΣΙΚΗΣ',
  },
  {
    label: '59204000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΑΣ ΓΙΑ ΤΑ ΔΙΚΑΙΩΜΑΤΑ ΧΡΗΣΗΣ ΑΚΟΥΣΤΙΚΩΝ ΠΡΩΤΟΤΥΠΩΝ',
  },
  {
    label: '60100000',
    value: 'ΡΑΔΙΟΦΩΝΙΚΕΣ ΕΚΠΟΜΠΕΣ',
  },
  {
    label: '60101000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΡΑΔΙΟΦΩΝΙΚΩΝ ΕΚΠΟΜΠΩΝ',
  },
  {
    label: '60101100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΡΑΔΙΟΦΩΝΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΙΣΜΟΥ ΚΑΙ ΕΚΠΟΜΠΩΝ',
  },
  {
    label: '60101101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΚΤΥΟΥ ΡΑΔΙΟΦΩΝΙΑΣ ΕΘΝΙΚΗΣ ΕΜΒΕΛΕΙΑΣ, ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΕΜΠΟΡΙΚΟΥ ΧΑΡΑΚΤΗΡΑ',
  },
  {
    label: '60101102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΡΑΔΙΟΦΩΝΙΚΟΥ ΣΤΑΘΜΟΥ ΤΟΠΙΚΗΣ ΕΜΒΕΛΕΙΑΣ',
  },
  {
    label: '60101200',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΡΑΔΙΟΦΩΝΙΚΗΣ ΕΚΠΟΜΠΗΣ',
  },
  {
    label: '60102000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΠΡΟΓΡΑΜΜΑΤΩΝ ΡΑΔΙΟΦΩΝΙΚΗΣ ΣΥΧΝΟΤΗΤΑΣ (ΚΑΝΑΛΙΟΥ)',
  },
  {
    label: '60103000',
    value: 'ΔΙΑΘΕΣΗ ΧΡΟΝΟΥ ΡΑΔΙΟΦΩΝΙΚΗΣ ΔΙΑΦΗΜΙΣΗΣ',
  },
  {
    label: '60200000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΟΠΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΙΣΜΟΥ ΚΑΙ ΤΗΛΕΟΠΤΙΚΩΝ ΕΚΠΟΜΠΩΝ',
  },
  {
    label: '60201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΟΠΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ ΚΑΙ ΕΚΠΟΜΠΗΣ',
  },
  {
    label: '60201100',
    value:
      "ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΟΠΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ ΚΑΙ ΕΚΠΟΜΠΗΣ ΣΕ ΑΠ' ΕΥΘΕΙΑΣ ΣΥΝΔΕΣΗ, ΕΚΤΟΣ ΣΥΝΔΡΟΜΗΤΙΚΩΝ",
  },
  {
    label: '60201101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΚΤΥΟΥ ΤΗΛΕΟΡΑΣΗΣ ΕΘΝΙΚΗΣ ΕΜΒΕΛΕΙΑΣ, ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΕΜΠΟΡΙΚΟΥ ΧΑΡΑΚΤΗΡΑ',
  },
  {
    label: '60201102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΟΠΤΙΚΟΥ ΣΤΑΘΜΟΥ ΤΟΠΙΚΗΣ ΕΜΒΕΛΕΙΑΣ',
  },
  {
    label: '60201200',
    value:
      "ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΟΠΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ ΚΑΙ ΕΚΠΟΜΠΗΣ ΣΕ ΑΠ' ΕΥΘΕΙΑΣ ΣΥΝΔΕΣΗ, ΕΚΤΟΣ ΣΥΝΔΡΟΜΗΤΙΚΩΝ",
  },
  {
    label: '60201300',
    value:
      "ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΟΠΤΙΚΟΥ ΣΥΝΔΡΟΜΗΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ ΚΑΙ ΕΚΠΟΜΠΗΣ ΣΕ ΑΠ' ΕΥΘΕΙΑΣ ΣΥΝΔΕΣΗ",
  },
  {
    label: '60201400',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΟΠΤΙΚΟΥ ΣΥΝΔΡΟΜΗΤΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ ΚΑΙ ΕΚΠΟΜΠΗΣ',
  },
  {
    label: '60202000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΤΗΛΕΟΠΤΙΚΩΝ ΕΚΠΟΜΠΩΝ',
  },
  {
    label: '60203000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΠΡΟΓΡΑΜΜΑΤΩΝ ΤΗΛΕΟΠΤΙΚΟΥ ΚΑΝΑΛΙΟΥ',
  },
  {
    label: '60203100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΠΡΟΓΡΑΜΜΑΤΩΝ ΤΗΛΕΟΠΤΙΚΟΥ ΚΑΝΑΛΙΟΥ, ΕΚΤΟΣ ΤΗΣ ΣΥΝΔΡΟΜΗΤΙΚΗΣ ΤΗΛΕΟΡΑΣΗΣ',
  },
  {
    label: '60203200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΠΡΟΓΡΑΜΜΑΤΩΝ ΣΥΝΔΡΟΜΗΤΙΚΩΝ ΤΗΛΕΟΠΤΙΚΩΝ ΚΑΝΑΛΙΩΝ',
  },
  {
    label: '60204000',
    value: 'ΔΙΑΘΕΣΗ ΤΗΛΕΟΠΤΙΚΟΥ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΡΟΝΟΥ',
  },
  {
    label: '61100000',
    value: 'ΕΝΣΥΡΜΑΤΕΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '61101000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΔΟΣΗΣ ΔΕΔΟΜΕΝΩΝ ΚΑΙ ΜΗΝΥΜΑΤΩΝ',
  },
  {
    label: '61101100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΑΘΕΡΗΣ ΤΗΛΕΦΩΝΙΑΣ ~ ΠΡΟΣΒΑΣΗ ΚΑΙ ΧΡΗΣΗ',
  },
  {
    label: '61101200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΑΘΕΡΗΣ ΤΗΛΕΦΩΝΙΑΣ ~ ΣΤΟΙΧΕΙΑ ΚΛΗΣΕΩΝ',
  },
  {
    label: '61101300',
    value:
      'ΙΔΙΩΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΚΤΥΟΥ ΓΙΑ ΕΝΣΥΡΜΑΤΑ (ΚΑΛΩΔΙΑΚΑ) ΣΥΣΤΗΜΑΤΑ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '61102000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΟΡΕΑ ΓΙΑ ΕΝΣΥΡΜΑΤΕΣ (ΚΑΛΩΔΙΑΚΕΣ) ΤΗΛΕΠΙΚΟΙΝΩΝΙΕΣ',
  },
  {
    label: '61103000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΔΕΔΟΜΕΝΩΝ ΜΕΣΩ ΕΝΣΥΡΜΑΤΩΝ (ΚΑΛΩΔΙΑΚΩΝ) ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΩΝ ΔΙΚΤΥΩΝ',
  },
  {
    label: '61104000',
    value: 'ΕΝΣΥΡΜΑΤΕΣ (ΚΑΛΩΔΙΑΚΕΣ) ΔΙΑΔΙΚΤΥΑΚΕΣ ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '61104100',
    value: 'ΒΑΣΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '61104200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΤΕΝΟΖΩΝΙΚΗΣ ΠΡΟΣΒΑΣΗΣ ΣΤΟ ΔΙΑΔΙΚΤΥΟ ΜΕΣΩ ΚΑΛΩΔΙΑΚΩΝ ΔΙΚΤΥΩΝ',
  },
  {
    label: '61104300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΥΡΥΖΩΝΙΚΗΣ ΠΡΟΣΒΑΣΗΣ ΣΤΟ ΔΙΑΔΙΚΤΥΟ ΜΕΣΩ ΚΑΛΩΔΙΑΚΩΝ ΔΙΚΤΥΩΝ',
  },
  {
    label: '61104900',
    value:
      'ΑΛΛΕΣ ΕΝΣΥΡΜΑΤΕΣ (ΚΑΛΩΔΙΑΚΕΣ) ΔΙΑΔΙΚΤΥΑΚΕΣ ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '61104901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΣΥΝΕΔΡΙΑΣΕΩΝ ΜΕΣΩ ΚΑΛΩΔΙΑΚΟΥ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '61105000',
    value:
      "ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΠΡΟΓΡΑΜΜΑΤΟΣ ΚΑΤ' ΟΙΚΟΝ ΜΕΣΩ ΚΑΛΩΔΙΑΚΗΣ ΥΠΟΔΟΜΗΣ",
  },
  {
    label: '61105100',
    value:
      "ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΠΡΟΓΡΑΜΜΑΤΟΣ ΚΑΤ' ΟΙΚΟΝ ΜΕΣΩ ΚΑΛΩΔΙΑΚΗΣ ΥΠΟΔΟΜΗΣ ~ ΜΕ ΠΑΡΟΧΗ ΒΑΣΙΚΟΥ ΠΑΚΕΤΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ",
  },
  {
    label: '61105200',
    value:
      "ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΠΡΟΓΡΑΜΜΑΤΟΣ ΚΑΤ' ΟΙΚΟΝ ΜΕΣΩ ΚΑΛΩΔΙΑΚΗΣ ΥΠΟΔΟΜΗΣ ~ ΜΕ ΠΑΡΟΧΗ ΔΙΑΚΡΙΤΟΥ ΠΑΚΕΤΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ",
  },
  {
    label: '61105300',
    value:
      "ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΠΡΟΓΡΑΜΜΑΤΟΣ ΚΑΤ' ΟΙΚΟΝ ΜΕΣΩ ΚΑΛΩΔΙΑΚΗΣ ΥΠΟΔΟΜΗΣ ~ ΜΕ ΧΡΕΩΣΗ ΑΝΑ ΘΕΑΣΗ",
  },
  {
    label: '61200000',
    value: 'ΑΣΥΡΜΑΤΕΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '61201000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΙΝΗΤΗΣ ΤΗΛΕΦΩΝΙΑΣ ΚΑΙ ΙΔΙΩΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΚΤΥΟΥ ΓΙΑ ΑΣΥΡΜΑΤΑ ΣΥΣΤΗΜΑΤΑ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '61201100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΙΝΗΤΗΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΣ ~ ΠΡΟΣΒΑΣΗ ΚΑΙ ΧΡΗΣΗ',
  },
  {
    label: '61201101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΤΙΠΡΟΣΩΠΟΥ ΚΙΝΗΤΗΣ ΤΗΛΕΦΩΝΙΑΣ, ΠΟΥ ΑΜΕΙΒΕΤΑΙ ΜΕ ΠΡΟΜΗΘΕΙΑ ΕΠΙ ΤΩΝ ΛΟΓΑΡΙΑΣΜΩΝ ΤΩΝ ΣΥΝΔΡΟΜΗΤΩΝ, ΣΥΝΔΕΣΗΣ, ΦΕΡΕΓΓΥΟΤΗΤΑΣ ΠΕΛΑΤΩΝ, ΕΤΑΙΡΙΚΩΝ ΣΥΝΔΕΣΕΩΝ, ΚΟΙΝΗΣ ΔΙΑΦΗΜΙΣΗΣ, ΕΠΙΤΕΥΞΗΣ ΣΤΟΧΩΝ ΚΛΠ, ΚΑΘΩΣ ΚΑΙ ΕΠΙ ΤΗΣ ΕΠΙΔΟΤΗΣΗΣ ΤΗΣ ΣΥΣΚΕΥ',
  },
  {
    label: '61201200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΙΝΗΤΗΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΣ ~ ΣΤΟΙΧΕΙΑ ΚΛΗΣΗΣ',
  },
  {
    label: '61201300',
    value: 'ΙΔΙΩΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΚΤΥΟΥ ΓΙΑ ΑΣΥΡΜΑΤΑ ΣΥΣΤΗΜΑΤΑ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '61202000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΟΡΕΑ ΓΙΑ ΑΣΥΡΜΑΤΕΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΕΣ',
  },
  {
    label: '61203000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΔΕΔΟΜΕΝΩΝ ΜΕΣΩ ΑΣΥΡΜΑΤΩΝ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΩΝ ΔΙΚΤΥΩΝ',
  },
  {
    label: '61204000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΥΡΜΑΤΩΝ ΔΙΑΔΙΚΤΥΑΚΩΝ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '61204100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΤΕΝΟΖΩΝΙΚΗΣ ΠΡΟΣΒΑΣΗΣ ΣΤΟ ΔΙΑΔΙΚΤΥΟ ΜΕΣΩ ΑΣΥΡΜΑΤΩΝ ΔΙΚΤΥΩΝ',
  },
  {
    label: '61204200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΥΡΥΖΩΝΙΚΗΣ ΠΡΟΣΒΑΣΗΣ ΣΤΟ ΔΙΑΔΙΚΤΥΟ ΜΕΣΩ ΑΣΥΡΜΑΤΩΝ ΔΙΚΤΥΩΝ',
  },
  {
    label: '61204900',
    value: 'ΑΛΛΕΣ ΑΣΥΡΜΑΤΕΣ ΔΙΑΔΙΚΤΥΑΚΕΣ ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '61204901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΣΥΝΕΔΡΙΑΣΕΩΝ ΜΕΣΩ ΑΣΥΡΜΑΤΟΥ ΔΙΑΔΙΚΤΥΟΥ',
  },
  {
    label: '61205000',
    value: "ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΠΡΟΓΡΑΜΜΑΤΟΣ ΚΑΤ' ΟΙΚΟΝ ΜΕΣΩ ΑΣΥΡΜΑΤΗΣ ΥΠΟΔΟΜΗΣ",
  },
  {
    label: '61300000',
    value: 'ΔΟΡΥΦΟΡΙΚΕΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '61301000',
    value:
      "ΥΠΗΡΕΣΙΕΣ ΔΟΡΥΦΟΡΙΚΩΝ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ, ΕΚΤΟΣ ΤΩΝ ΥΠΗΡΕΣΙΩΝ ΚΑΤ' ΟΙΚΟΝ ΔΙΑΝΟΜΗΣ ΠΡΟΓΡΑΜΜΑΤΟΣ ΜΕΣΩ ΔΟΡΥΦΟΡΟΥ",
  },
  {
    label: '61301001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΟΡΥΦΟΡΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ ΡΑΔΙΟΤΗΛΕΦΩΝΙΑΣ',
  },
  {
    label: '61302000',
    value: "ΥΠΗΡΕΣΙΕΣ ΚΑΤ' ΟΙΚΟΝ ΔΙΑΝΟΜΗΣ ΠΡΟΓΡΑΜΜΑΤΟΣ ΜΕΣΩ ΔΟΡΥΦΟΡΟΥ",
  },
  {
    label: '61900000',
    value: 'ΑΛΛΕΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '61901000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '61901001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΑΛΑΣΣΙΑΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΣ',
  },
  {
    label: '61901002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΡΑΔΙΟΤΑΞΙ',
  },
  {
    label: '61901003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΠΙΚΟΙΝΩΝΙΑΣ ΑΕΡΑ ~ ΕΔΑΦΟΥΣ',
  },
  {
    label: '61901004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΦΩΝΙΑΣ ΜΕΣΩ ΔΙΑΔΙΚΤΥΑΚΟΥ ΠΡΩΤΟΚΟΛΛΟΥ (VOIP)',
  },
  {
    label: '61901005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΦΩΝΙΚΩΝ ΤΗΛΕΣΥΝΕΔΡΙΑΣΕΩΝ',
  },
  {
    label: '61901006',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΦΩΝΙΚΗΣ ΕΞΥΠΗΡΕΤΗΣΗΣ ΤΟΥ ΚΟΙΝΟΥ',
  },
  {
    label: '61901007',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΡΟΣΒΑΣΗΣ ΤΟΥ ΚΟΙΝΟΥ ΣΤΟ ΔΙΑΔΙΚΤΥΟ (ΣΕ ΧΩΡΟΥΣ, ΠΟΥ ΔΕΝ ΠΑΡΕΧΟΝΤΑΙ ΤΡΟΦΙΜΑ Η',
  },
  {
    label: '62010000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΡΟΓΡΑΜΜΑΤΙΣΜΟΥ ΗΛΕΚΤΡΟΝΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ',
  },
  {
    label: '62011000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΚΑΙ ΑΝΑΠΤΥΞΗΣ ΤΕΧΝΟΛΟΓΙΩΝ ΤΗΣ ΠΛΗΡΟΦΟΡΙΑΣ',
  },
  {
    label: '62011100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΚΑΙ ΑΝΑΠΤΥΞΗΣ ΤΕΧΝΟΛΟΓΙΩΝ ΤΗΣ ΠΛΗΡΟΦΟΡΙΑΣ ΓΙΑ ΕΦΑΡΜΟΓΕΣ',
  },
  {
    label: '62011101',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΡΟΓΡΑΜΜΑΤΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ, ΠΟΥ ΠΑΡΑΓΟΝΤΑΙ Η ΟΛΟΚΛΗΡΩΝΟΝΤΑΙ ΚΑΤΟΠΙΝ ΠΑΡΑΓΓΕΛΙΑΣ',
  },
  {
    label: '62011102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΑΠΤΥΞΗΣ ΚΑΙ ΥΠΟΣΤΗΡΙΞΗΣ ΛΟΓΙΣΜΙΚΟΥ ΕΦΑΡΜΟΓΩΝ ΤΗΛΕΜΑΤΙΚΗΣ',
  },
  {
    label: '62011103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΠΤΥΞΗΣ ΛΟΓΙΣΜΙΚΟΥ ΠΟΛΥΜΕΣΩΝ (MULTIMEDIA)',
  },
  {
    label: '62011104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΗΜΙΟΥΡΓΙΑΣ ΙΣΤΟΣΕΛΙΔΩΝ ΣΤΟ ΔΙΑΔΙΚΤΥΟ',
  },
  {
    label: '62011105',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΑΝΟΡΘΩΣΗΣ ΚΑΤΑΣΤΡΑΦΕΝΤΟΣ ΛΟΓΙΣΜΙΚΟΥ',
  },
  {
    label: '62011106',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΙΟΤΙΚΟΥ ΕΛΕΓΧΟΥ ΣΥΣΤΗΜΑΤΟΣ ΛΟΓΙΣΜΙΚΟΥ',
  },
  {
    label: '62011107',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ, ΥΠΟΣΤΗΡΙΞΗΣ ΚΑΙ ΟΛΟΚΛΗΡΩΣΗΣ ΣΥΣΤΗΜΑΤΟΣ ΛΟΓΙΣΜΙΚΟΥ',
  },
  {
    label: '62011200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΚΑΙ ΑΝΑΠΤΥΞΗΣ ΤΕΧΝΟΛΟΓΙΩΝ ΤΗΣ ΠΛΗΡΟΦΟΡΙΑΣ ΓΙΑ ΔΙΚΤΥΑ ΚΑΙ ΣΥΣΤΗΜΑΤΑ',
  },
  {
    label: '62012000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΛΟΓΙΣΜΙΚΟΥ',
  },
  {
    label: '62012100',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΛΟΓΙΣΜΙΚΟΥ ΠΑΙΧΝΙΔΙΩΝ ΥΠΟΛΟΓΙΣΤΗ',
  },
  {
    label: '62012900',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΑΛΛΟΥ ΛΟΓΙΣΜΙΚΟΥ',
  },
  {
    label: '62020000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΣΧΕΤΙΚΑ ΜΕ ΤΟΥΣ ΗΛΕΚΤΡΟΝΙΚΟΥΣ ΥΠΟΛΟΓΙΣΤΕΣ',
  },
  {
    label: '62021000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΓΙΑ ΘΕΜΑΤΑ ΥΛΙΚΟΥ (HARDWARE) ΥΠΟΛΟΓΙΣΤΩΝ',
  },
  {
    label: '62022000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΓΙΑ ΘΕΜΑΤΑ ΣΥΣΤΗΜΑΤΩΝ ΚΑΙ ΛΟΓΙΣΜΙΚΟΥ',
  },
  {
    label: '62023000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ ΓΙΑ ΤΕΧΝΟΛΟΓΙΕΣ ΤΗΣ ΠΛΗΡΟΦΟΡΙΑΣ',
  },
  {
    label: '62023001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ ΔΙΚΤΥΩΝ',
  },
  {
    label: '62023002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ ΕΞΕΙΔΙΚΕΥΜΕΝΟΥ ΛΟΓΙΣΜΙΚΟΥ ΕΦΑΡΜΟΓΩΝ',
  },
  {
    label: '62023003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ ΣΥΣΤΗΜΑΤΩΝ ΥΠΟΛΟΓΙΣΤΩΝ',
  },
  {
    label: '62023004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΠΟΣΤΗΡΙΞΗΣ ΛΟΓΙΣΜΙΚΟΥ ΠΟΛΥΜΕΣΩΝ',
  },
  {
    label: '62030000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ',
  },
  {
    label: '62031100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΔΙΚΤΥΟΥ',
  },
  {
    label: '62031200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΣΥΣΤΗΜΑΤΩΝ ΗΛΕΚΤΡΟΝΙΚΟΥ ΥΠΟΛΟΓΙΣΤΗ',
  },
  {
    label: '62090000',
    value:
      'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΤΗΣ ΤΕΧΝΟΛΟΓΙΑΣ ΤΗΣ ΠΛΗΡΟΦΟΡΙΑΣ ΚΑΙ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΥΠΗΡΕΣΙΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ',
  },
  {
    label: '62091000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '62092000',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΩΝ ΤΕΧΝΟΛΟΓΙΩΝ ΤΗΣ ΠΛΗΡΟΦΟΡΙΑΣ ΚΑΙ ΤΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '62092001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΤΡΟΠΗΣ ΚΑΙ ΔΙΟΡΘΩΣΗΣ ΨΗΦΙΑΚΩΝ ΥΠΟΒΑΘΡΩΝ (CD, ΔΙΣΚΕΤΩΝ ΚΛΠ)',
  },
  {
    label: '63110000',
    value: 'ΕΠΕΞΕΡΓΑΣΙΑ ΔΕΔΟΜΕΝΩΝ, ΚΑΤΑΧΩΡΗΣΗ ΚΑΙ ΣΥΝΑΦΕΙΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '63111000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ, ΠΑΡΟΧΗΣ ΚΕΝΤΡΙΚΟΥ ΥΠΟΛΟΓΙΣΤΗ, ΛΕΙΤΟΥΡΓΙΑΣ ΕΦΑΡΜΟΓΩΝ ΚΑΙ ΠΑΡΟΧΗΣ ΛΟΙΠΗΣ ΥΠΟΔΟΜΗΣ ΤΕΧΝΟΛΟΓΙΩΝ ΤΗΣ ΠΛΗΡΟΦΟΡΙΑΣ',
  },
  {
    label: '63111100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '63111101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΠΤΥΞΗΣ ΒΑΣΕΩΝ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '63111102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΘΗΚΕΥΣΗΣ ΒΑΣΕΩΝ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '63111103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΕΠΕΞΕΡΓΑΣΙΑΣ ΔΕΔΟΜΕΝΩΝ Η ΔΙΚΤΥΩΝ (ΥΠΟΛΟΓΙΣΤΙΚΗΣ ΙΣΧΥΟΣ ΚΛΠ)',
  },
  {
    label: '63111104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΕΤΟΙΜΑΣΙΑΣ ΕΙΣΑΓΩΓΗΣ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '63111105',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ Η ΕΝΟΙΚΙΑΣΗΣ ΧΡΟΝΟΥ ΑΠΑΣΧΟΛΗΣΗΣ ΜΗΧΑΝΗΣ ΠΡΟΣ ΕΠΕΞΕΡΓΑΣΙΑ ΔΕΔΟΜΕΝΩΝ',
  },
  {
    label: '63111200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΙΣΤΟΦΙΛΟΞΕΝΙΑΣ (WEB HOSTING)',
  },
  {
    label: '63111300',
    value: 'ΠΑΡΟΧΗ ΥΠΗΡΕΣΙΩΝ ΕΦΑΡΜΟΓΩΝ ΠΛΗΡΟΦΟΡΙΚΗΣ',
  },
  {
    label: '63111900',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΦΙΛΟΞΕΝΙΑΣ (ΚΑΤΑΧΩΡΙΣΗΣ) ΚΑΙ ΥΠΟΔΟΜΗΣ ΤΕΧΝΟΛΟΓΙΩΝ ΤΗΣ ΠΛΗΡΟΦΟΡΙΑΣ (ΙΤ)',
  },
  {
    label: '63112000',
    value: 'ΜΕΤΑΔΟΣΗ ΣΥΝΕΧΟΥΣ ΡΟΗΣ ΕΙΚΟΝΑΣ ΚΑΙ ΗΧΟΥ',
  },
  {
    label: '63112100',
    value: 'ΜΕΤΑΔΟΣΗ ΣΥΝΕΧΟΥΣ ΡΟΗΣ ΕΙΚΟΝΑΣ',
  },
  {
    label: '63112200',
    value: 'ΜΕΤΑΔΟΣΗ ΣΥΝΕΧΟΥΣ ΡΟΗΣ ΗΧΟΥ',
  },
  {
    label: '63113000',
    value: 'ΔΙΑΘΕΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ Η ΧΡΟΝΟΥ ΣΤΟ ΔΙΑΔΙΚΤΥΟ',
  },
  {
    label: '63120000',
    value: 'ΔΙΚΤΥΑΚΕΣ ΠΥΛΕΣ (WEB PORTALS)',
  },
  {
    label: '63121000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΕΡΙΕΧΟΜΕΝΟΥ ΔΙΚΤΥΑΚΩΝ ΠΥΛΩΝ (WEB PORTALS)',
  },
  {
    label: '63910000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΡΑΚΤΟΡΕΙΩΝ ΕΙΔΗΣΕΩΝ',
  },
  {
    label: '63911000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΙΔΗΣΕΟΓΡΑΦΙΚΩΝ ΠΡΑΚΤΟΡΕΙΩΝ',
  },
  {
    label: '63911100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΙΔΗΣΕΟΓΡΑΦΙΚΩΝ ΠΡΑΚΤΟΡΕΙΩΝ ΠΡΟΣ ΕΦΗΜΕΡΙΔΕΣ ΚΑΙ ΠΕΡΙΟΔΙΚΑ',
  },
  {
    label: '63911101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΔΗΜΟΣΙΟΓΡΑΦΙΚΟΥ ΥΛΙΚΟΥ ΗΜΕΡΗΣΙΟΥ ΚΑΙ ΠΕΡΙΟΔΙΚΟΥ ΤΥΠΟΥ',
  },
  {
    label: '63911200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΙΔΗΣΕΟΓΡΑΦΙΚΩΝ ΠΡΑΚΤΟΡΕΙΩΝ ΠΡΟΣ ΟΠΤΙΚΟΑΚΟΥΣΤΙΚΑ ΜΕΣΑ',
  },
  {
    label: '63990000',
    value: 'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΥΠΗΡΕΣΙΩΝ ΠΛΗΡΟΦΟΡΙΑΣ Π.Δ.Κ.Α.',
  },
  {
    label: '63991000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΛΗΡΟΦΟΡΙΑΣ Π.Δ.Κ.Α.',
  },
  {
    label: '63991001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΕΞΑΡΤΗΤΟΥ ΔΗΜΟΣΙΟΓΡΑΦΟΥ',
  },
  {
    label: '63991002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΡΘΡΟΓΡΑΦΟΥ',
  },
  {
    label: '63991003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΙΚΟΝΟΛΗΠΤΗ ΕΙΔΗΣΕΩΝ',
  },
  {
    label: '63991004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΑΚΤΗ ΜΕΣΩΝ ΜΑΖΙΚΗΣ ΕΝΗΜΕΡΩΣΗΣ',
  },
  {
    label: '63991005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΩΤΟΡΕΠΟΡΤΕΡ',
  },
  {
    label: '63992000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΣΥΛΛΟΓΩΝ ΔΕΔΟΜΕΝΩΝ/ ΠΛΗΡΟΦΟΡΙΩΝ',
  },
  {
    label: '64110000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΚΕΝΤΡΙΚΩΝ ΤΡΑΠΕΖΩΝ',
  },
  {
    label: '64111000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΕΝΤΡΙΚΩΝ ΤΡΑΠΕΖΩΝ',
  },
  {
    label: '64190000',
    value:
      'ΑΛΛΟΙ ΟΡΓΑΝΙΣΜΟΙ ΧΡΗΜΑΤΙΚΗΣ ΔΙΑΜΕΣΟΛΑΒΗΣΗΣ (ΤΡΑΠΕΖΕΣ ΑΛΛΕΣ ΑΠΟ ΤΗΝ ΚΕΝΤΡΙΚΗ)',
  },
  {
    label: '64191000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΘΕΣΕΩΝ',
  },
  {
    label: '64191100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΘΕΣΕΩΝ ΑΠΟ ΕΤΑΙΡΙΚΟΥΣ ΚΑΙ ΘΕΣΜΙΚΟΥΣ ΚΑΤΑΘΕΤΕΣ',
  },
  {
    label: '64191200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΘΕΣΕΩΝ ΑΠΟ ΑΛΛΟΥΣ ΚΑΤΑΘΕΤΕΣ',
  },
  {
    label: '64191201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΤΡΑΠΕΖΙΚΩΝ ΟΜΟΛΟΓΩΝ ΑΠΟ ΦΟΡΕΙΣ ΑΛΛΟΥΣ ΑΠΟ ΤΡΑΠΕΖΕΣ',
  },
  {
    label: '64191202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΕΓΑΣΤΙΚΩΝ ΤΑΜΙΕΥΤΗΡΙΩΝ',
  },
  {
    label: '64191203',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΧΥΔΡΟΜΙΚΩΝ ΤΑΜΙΕΥΤΗΡΙΩΝ',
  },
  {
    label: '64191204',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΡΑΠΕΖΩΝ',
  },
  {
    label: '64192000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΠΙΣΤΩΣΕΩΝ ΑΠΟ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64192100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΠΙΣΤΩΣΕΩΝ ΠΡΟΣ ΕΠΙΧΕΙΡΗΣΕΙΣ ΑΠΟ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64192200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΚΑΤΑΝΑΛΩΤΙΚΩΝ ΠΙΣΤΩΣΕΩΝ ΑΠΟ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64192300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΕΝΥΠΟΘΗΚΩΝ ΣΤΕΓΑΣΤΙΚΩΝ ΠΙΣΤΩΣΕΩΝ ΑΠΟ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64192400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΕΝΥΠΟΘΗΚΩΝ ΜΗ ΣΤΕΓΑΣΤΙΚΩΝ ΠΙΣΤΩΣΕΩΝ ΑΠΟ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64192500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΜΗ ΕΝΥΠΟΘΗΚΩΝ ΕΜΠΟΡΙΚΩΝ ΠΙΣΤΩΣΕΩΝ ΑΠΟ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64192600',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΙΣΤΩΤΙΚΩΝ ΚΑΡΤΩΝ ΑΠΟ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64192900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΠΙΣΤΩΣΕΩΝ ΑΠΟ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64193000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΧΡΗΜΑΤΙΚΗΣ ΔΙΑΜΕΣΟΛΑΒΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '64193001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΙΣΘΩΣΗΣ ΧΡΗΜΑΤΟΘΥΡΙΔΩΝ ΣΕ ΤΡΑΠΕΖΕΣ',
  },
  {
    label: '64200000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΕΤΑΙΡΕΙΩΝ ΧΑΡΤΟΦΥΛΑΚΙΟΥ (HOLDING)',
  },
  {
    label: '64201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΤΑΙΡΕΙΩΝ ΧΑΡΤΟΦΥΛΑΚΙΟΥ (HOLDING)',
  },
  {
    label: '64201001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΛΛΟΔΑΠΩΝ ΕΤΑΙΡΕΙΩΝ, ΠΟΥ ΣΥΜΜΕΤΕΧΟΥΝ ΣΕ ΗΜΕΔΑΠΕΣ ΕΤΑΙΡΕΙΕΣ',
  },
  {
    label: '64201002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΡΗΜΑΤΟΠΙΣΤΩΤΙΚΩΝ ΕΛΕΓΧΟΥΣΩΝ ΕΤΑΙΡΙΩΝ',
  },
  {
    label: '64300000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΚΑΤΑΠΙΣΤΕΥΜΑΤΑ (TRUSTS), ΚΕΦΑΛΑΙΑ (FUNDS) ΚΑΙ ΠΑΡΕΜΦΕΡΗ ΧΡΗΜΑΤΟΠΙΣΤΩΤΙΚΑ ΜΕΣΑ',
  },
  {
    label: '64301000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΚΑΤΑΠΙΣΤΕΥΜΑΤΑ (TRUSTS), ΚΕΦΑΛΑΙΑ (FUNDS) ΚΑΙ ΠΑΡΕΜΦΕΡΗ ΧΡΗΜΑΤΟΠΙΣΤΩΤΙΚΑ ΜΕΣΑ',
  },
  {
    label: '64301001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΤΑΙΡΕΙΩΝ ΕΠΕΝΔΥΣΕΩΝ (ΣΕ ΜΕΤΟΧΕΣ, ΧΡΕΟΓΡΑΦΑ, ΑΚΙΝΗΤΑ ΚΛΠ)',
  },
  {
    label: '64910000',
    value: 'ΧΡΗΜΑΤΟΔΟΤΙΚΗ ΜΙΣΘΩΣΗ (LEASING)',
  },
  {
    label: '64911000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ',
  },
  {
    label: '64920000',
    value: 'ΑΛΛΕΣ ΠΙΣΤΩΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '64921000',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΠΙΣΤΩΣΕΩΝ, ΕΚΤΟΣ ΑΥΤΩΝ ΑΠΟ ΤΑ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64921100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΠΙΣΤΩΣΕΩΝ ΜΕΤΑΞΥ ΕΠΙΧΕΙΡΗΣΕΩΝ, ΕΚΤΟΣ ΑΥΤΩΝ ΑΠΟ ΤΑ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64921200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΚΑΤΑΝΑΛΩΤΙΚΩΝ ΠΙΣΤΩΣΕΩΝ, ΕΚΤΟΣ ΑΥΤΩΝ ΑΠΟ ΤΑ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64921201',
    value:
      "ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΠΙΣΤΩΣΕΩΝ \\ΕΠ' ΕΝΕΧΥΡΩ\\ ΑΝΤΙΚΕΙΜΕΝΩΝ (ΥΠΗΡΕΣΙΕΣ ΕΝΕΧΥΡΟΔΑΝΕΙΣΤΗ)",
  },
  {
    label: '64921300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΕΝΥΠΟΘΗΚΩΝ ΣΤΕΓΑΣΤΙΚΩΝ ΠΙΣΤΩΣΕΩΝ, ΕΚΤΟΣ ΑΥΤΩΝ ΑΠΟ ΤΑ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64921400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΕΝΥΠΟΘΗΚΩΝ ΜΗ ΣΤΕΓΑΣΤΙΚΩΝ ΠΙΣΤΩΣΕΩΝ, ΕΚΤΟΣ ΑΥΤΩΝ ΑΠΟ ΤΑ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64921500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΜΗ ΕΝΥΠΟΘΗΚΩΝ ΚΑΤΑΝΑΛΩΤΙΚΩΝ ΠΙΣΤΩΣΕΩΝ, ΕΚΤΟΣ ΑΥΤΩΝ ΑΠΟ ΤΑ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64921600',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΙΣΤΩΤΙΚΩΝ ΚΑΡΤΩΝ, ΕΚΤΟΣ ΑΥΤΩΝ ΑΠΟ ΤΑ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ',
  },
  {
    label: '64921900',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΠΙΣΤΩΣΕΩΝ, ΕΚΤΟΣ ΑΥΤΩΝ ΑΠΟ ΤΑ ΝΟΜΙΣΜΑΤΙΚΑ ΙΔΡΥΜΑΤΑ Π.Δ.Κ.Α.',
  },
  {
    label: '64990000',
    value:
      'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΧΡΗΜΑΤΟΠΙΣΤΩΤΙΚΩΝ ΥΠΗΡΕΣΙΩΝ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΙΣ ΑΣΦΑΛΕΙΕΣ ΚΑΙ ΤΑ ΣΥΝΤΑΞΙΟΔΟΤΙΚΑ ΤΑΜΕΙΑ Π.Δ.Κ.Α.',
  },
  {
    label: '64991000',
    value:
      'ΑΛΛΕΣ ΧΡΗΜΑΤΟΠΙΣΤΩΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ, ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΑΣΦΑΛΙΣΤΙΚΕΣ ΚΑΙ ΤΗ ΧΡΗΜΑΤΟΔΟΤΗΣΗ ΣΥΝΤΑΞΕΩΝ, Π.Δ.Κ.Α.',
  },
  {
    label: '64991100',
    value: 'ΕΠΕΝΔΥΤΙΚΕΣ ΤΡΑΠΕΖΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '64991900',
    value:
      'ΧΡΗΜΑΤΟΠΙΣΤΩΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ, ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΑΣΦΑΛΙΣΤΙΚΕΣ ΚΑΙ ΤΗ ΧΡΗΜΑΤΟΔΟΤΗΣΗ ΣΥΝΤΑΞΕΩΝ, Π.Δ.Κ.Α.',
  },
  {
    label: '64991901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΡΑΚΤΟΡΕΙΑΣ ΕΠΙΧΕΙΡΗΜΑΤΙΚΩΝ ΑΠΑΙΤΗΣΕΩΝ ΤΡΙΤΩΝ (FACTORING ~ FORFAITING)',
  },
  {
    label: '64991902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΕΞΟΦΛΗΤΗ',
  },
  {
    label: '64991903',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ, ΔΙΑΠΡΑΓΜΑΤΕΥΣΗΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΠΙΣΤΩΣΕΩΝ, ΧΩΡΙΣ ΤΗΝ ΑΠΟΔΟΧΗ ΚΑΤΑΘΕΣΕΩΝ',
  },
  {
    label: '65110000',
    value: 'ΑΣΦΑΛΕΙΕΣ ΖΩΗΣ',
  },
  {
    label: '65111000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΕΙΩΝ ΖΩΗΣ',
  },
  {
    label: '65120000',
    value: 'ΑΣΦΑΛΕΙΕΣ ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΑΣΦΑΛΕΙΕΣ ΖΩΗΣ',
  },
  {
    label: '65121000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΑΤΥΧΗΜΑΤΟΣ ΚΑΙ ΑΣΘΕΝΕΙΑΣ',
  },
  {
    label: '65121100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΕΝΑΝΤΙ ΑΤΥΧΗΜΑΤΩΝ',
  },
  {
    label: '65121200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΑΣΘΕΝΕΙΑΣ',
  },
  {
    label: '65122000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '65122100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΑΣΤΙΚΗ ΕΥΘΥΝΗ',
  },
  {
    label: '65122900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '65123000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΘΑΛΑΣΣΙΩΝ, ΕΝΑΕΡΙΩΝ ΚΑΙ ΑΛΛΩΝ ΜΕΤΑΦΟΡΩΝ',
  },
  {
    label: '65123100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΤΡΟΧΑΙΟΥ ΣΙΔΗΡΟΔΡΟΜΙΚΟΥ ΥΛΙΚΟΥ',
  },
  {
    label: '65123200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΑΕΡΟΣΚΑΦΩΝ ΓΙΑ ΑΣΤΙΚΗ ΕΥΘΥΝΗ',
  },
  {
    label: '65123300',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΑΕΡΟΣΚΑΦΩΝ',
  },
  {
    label: '65123400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΠΛΟΙΩΝ ΓΙΑ ΑΣΤΙΚΗ ΕΥΘΥΝΗ',
  },
  {
    label: '65123500',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΠΛΟΙΩΝ',
  },
  {
    label: '65123600',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΦΟΡΤΙΩΝ',
  },
  {
    label: '65124000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΙΔΙΟΚΤΗΣΙΑΣ ΚΑΤΑ ΠΥΡΚΑΓΙΑΣ ΚΑΙ ΛΟΙΠΩΝ ΥΛΙΚΩΝ ΖΗΜΙΩΝ',
  },
  {
    label: '65124100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΙΔΙΟΚΤΗΣΙΑΣ ΕΝΑΝΤΙ ΖΗΜΙΩΝ ΑΠΟ ΠΥΡΚΑΓΙΑ',
  },
  {
    label: '65124900',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΙΔΙΟΚΤΗΣΙΑΣ ΕΝΑΝΤΙ ΛΟΙΠΩΝ ΥΛΙΚΩΝ ΖΗΜΙΩΝ',
  },
  {
    label: '65125000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΓΕΝΙΚΗΣ ΕΥΘΥΝΗΣ',
  },
  {
    label: '65126000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΠΙΣΤΩΣΕΩΝ ΚΑΙ ΕΓΓΥΗΣΕΩΝ',
  },
  {
    label: '65126100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΠΙΣΤΩΣΕΩΝ',
  },
  {
    label: '65126200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΕΓΓΥΗΣΕΩΝ',
  },
  {
    label: '65127000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΤΑΞΙΔΙΩΝ ΚΑΙ ΠΑΡΟΧΗΣ ΥΠΟΣΤΗΡΙΞΗΣ, ΝΟΜΙΚΗΣ ΠΡΟΣΤΑΣΙΑΣ ΚΑΙ ΑΣΦΑΛΙΣΗΣ ΚΑΤΑ ΔΙΑΦΟΡΩΝ ΟΙΚΟΝΟΜΙΚΩΝ ΖΗΜΙΩΝ',
  },
  {
    label: '65127100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΤΑΞΙΔΙΩΝ ΚΑΙ ΠΑΡΟΧΗΣ ΥΠΟΣΤΗΡΙΞΗΣ',
  },
  {
    label: '65127200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΝΟΜΙΚΗΣ ΠΡΟΣΤΑΣΙΑΣ',
  },
  {
    label: '65127300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ ΕΝΑΝΤΙ ΔΙΑΦΟΡΩΝ ΟΙΚΟΝΟΜΙΚΩΝ ΖΗΜΙΩΝ',
  },
  {
    label: '65129000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΗΣ, ΕΚΤΟΣ ΤΗΣ ΑΣΦΑΛΕΙΑΣ ΖΩΗΣ',
  },
  {
    label: '65200000',
    value: 'ΑΝΤΑΣΦΑΛΙΣΗ',
  },
  {
    label: '65201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΖΩΗΣ, ΑΤΥΧΗΜΑΤΟΣ ΚΑΙ ΑΣΘΕΝΕΙΑΣ',
  },
  {
    label: '65201100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΖΩΗΣ',
  },
  {
    label: '65201200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΕΝΑΝΤΙ ΑΤΥΧΗΜΑΤΩΝ',
  },
  {
    label: '65201300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΑΣΘΕΝΕΙΑΣ',
  },
  {
    label: '65202000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΜΕΤΑΦΟΡΩΝ ΚΑΙ ΙΔΙΟΚΤΗΣΙΑΣ',
  },
  {
    label: '65202100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ ΓΙΑ ΑΣΤΙΚΗ ΕΥΘΥΝΗ',
  },
  {
    label: '65202200',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '65202300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΘΑΛΑΣΣΙΩΝ, ΕΝΑΕΡΙΩΝ ΚΑΙ ΑΛΛΩΝ ΜΕΤΑΦΟΡΩΝ',
  },
  {
    label: '65202400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΦΟΡΤΙΩΝ',
  },
  {
    label: '65202500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΙΔΙΟΚΤΗΣΙΑΣ ΚΑΤΑ ΠΥΡΚΑΓΙΑΣ ΚΑΙ ΛΟΙΠΩΝ ΥΛΙΚΩΝ ΖΗΜΙΩΝ',
  },
  {
    label: '65203000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΓΕΝΙΚΗΣ ΕΥΘΥΝΗΣ ΚΑΙ ΑΝΤΑΣΦΑΛΙΣΗΣ ΠΙΣΤΩΣΕΩΝ ΚΑΙ ΕΓΓΥΗΣΕΩΝ',
  },
  {
    label: '65203100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΓΕΝΙΚΗΣ ΕΥΘΥΝΗΣ',
  },
  {
    label: '65203200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΠΙΣΤΩΣΕΩΝ ΚΑΙ ΕΓΓΥΗΣΕΩΝ',
  },
  {
    label: '65204000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΝΟΜΙΚΗΣ ΠΡΟΣΤΑΣΙΑΣ ΚΑΙ ΑΝΤΑΣΦΑΛΙΣΗΣ ΚΑΤΑ ΔΙΑΦΟΡΩΝ ΟΙΚΟΝΟΜΙΚΩΝ ΖΗΜΙΩΝ',
  },
  {
    label: '65204100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΝΟΜΙΚΗΣ ΠΡΟΣΤΑΣΙΑΣ',
  },
  {
    label: '65204200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΕΝΑΝΤΙ ΔΙΑΦΟΡΩΝ ΟΙΚΟΝΟΜΙΚΩΝ ΖΗΜΙΩΝ',
  },
  {
    label: '65205000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΑ ΣΥΝΤΑΞΙΟΔΟΤΙΚΑ ΤΑΜΕΙΑ',
  },
  {
    label: '65206000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΣΦΑΛΙΣΗΣ, ΕΚΤΟΣ ΤΗΣ ΑΝΤΑΣΦΑΛΙΣΗΣ ΖΩΗΣ',
  },
  {
    label: '65300000',
    value: 'ΣΥΝΤΑΞΙΟΔΟΤΙΚΑ ΤΑΜΕΙΑ (ΕΚΤΟΣ ΥΠΟΧΡΕΩΤΙΚΗΣ ΚΟΙΝΩΝΙΚΗΣ ΑΣΦΑΛΙΣΗΣ)',
  },
  {
    label: '65301000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΑΞΙΟΔΟΤΙΚΩΝ ΤΑΜΕΙΩΝ (ΕΚΤΟΣ ΥΠΟΧΡΕΩΤΙΚΗΣ ΚΟΙΝΩΝΙΚΗΣ ΑΣΦΑΛΙΣΗΣ)',
  },
  {
    label: '65301100',
    value:
      'ΜΕΜΟΝΩΜΕΝΕΣ ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΑΞΙΟΔΟΤΙΚΩΝ ΤΑΜΕΙΩΝ (ΕΚΤΟΣ ΥΠΟΧΡΕΩΤΙΚΗΣ ΚΟΙΝΩΝΙΚΗΣ ΑΣΦΑΛΙΣΗΣ)',
  },
  {
    label: '65301200',
    value:
      'ΟΜΑΔΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΑΞΙΟΔΟΤΙΚΩΝ ΤΑΜΕΙΩΝ (ΕΚΤΟΣ ΥΠΟΧΡΕΩΤΙΚΗΣ ΚΟΙΝΩΝΙΚΗΣ ΑΣΦΑΛΙΣΗΣ)',
  },
  {
    label: '66110000',
    value: 'ΔΙΑΧΕΙΡΙΣΗ ΧΡΗΜΑΤΑΓΟΡΩΝ',
  },
  {
    label: '66111000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΗ ΔΙΑΧΕΙΡΙΣΗ ΤΩΝ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΩΝ ΑΓΟΡΩΝ',
  },
  {
    label: '66111100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΤΩΝ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΩΝ ΑΓΟΡΩΝ',
  },
  {
    label: '66111101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΧΡΗΜΑΤΙΣΤΗΡΙΩΝ ΑΞΙΩΝ',
  },
  {
    label: '66111102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΧΡΗΜΑΤΙΣΤΗΡΙΩΝ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '66111200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΡΥΘΜΙΣΗΣ ΤΩΝ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΩΝ ΑΓΟΡΩΝ',
  },
  {
    label: '66111900',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΗ ΔΙΑΧΕΙΡΙΣΗ ΤΩΝ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΩΝ ΑΓΟΡΩΝ',
  },
  {
    label: '66120000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΣΥΝΑΛΛΑΓΕΣ ΣΥΜΒΑΣΕΩΝ ΧΡΕΟΓΡΑΦΩΝ ΚΑΙ ΑΓΑΘΩΝ',
  },
  {
    label: '66121000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΣΥΝΑΛΛΑΓΕΣ ΣΥΜΒΑΣΕΩΝ, ΧΡΕΟΓΡΑΦΩΝ ΚΑΙ ΑΓΑΘΩΝ',
  },
  {
    label: '66121100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΑΛΛΑΓΗΣ (ΜΕΣΙΤΕΙΑΣ) ΧΡΕΟΓΡΑΦΩΝ',
  },
  {
    label: '66121101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΤΡΑΠΕΖΙΚΩΝ ΟΜΟΛΟΓΩΝ',
  },
  {
    label: '66121102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΔΟΣΗΣ ΚΑΙ ΕΙΣΑΓΩΓΗΣ ΚΙΝΗΤΩΝ ΑΞΙΩΝ',
  },
  {
    label: '66121103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΤΥΠΗΣ Η ΗΛΕΚΤΡΟΝΙΚΗΣ ΕΝΗΜΕΡΩΣΗΣ, ΣΧΕΤΙΚΑ ΜΕ ΤΙΣ ΤΙΜΕΣ ΤΩΝ ΧΡΕΟΓΡΑΦΩΝ',
  },
  {
    label: '66121104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΕΝΤΟΚΩΝ ΓΡΑΜΜΑΤΙΩΝ',
  },
  {
    label: '66121105',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΜΕΤΟΧΩΝ',
  },
  {
    label: '66121106',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΟΜΟΛΟΓΩΝ',
  },
  {
    label: '66121107',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΡΗΜΑΤΙΣΤΗ Η ΜΕΣΙΤΗ ΧΡΗΜΑΤΙΣΤΗΡΙΟΥ ΑΞΙΩΝ',
  },
  {
    label: '66121108',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΡΗΜΑΤΙΣΤΗΡΙΑΚΗΣ ΕΤΑΙΡΕΙΑΣ',
  },
  {
    label: '66121200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΣΙΤΕΙΑΣ ΑΓΑΘΩΝ',
  },
  {
    label: '66121300',
    value: 'ΣΥΝΑΛΛΑΓΜΑΤΙΚΕΣ ΠΡΑΞΕΙΣ',
  },
  {
    label: '66121301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΛΛΑΚΤΗΡΙΩΝ ΣΥΝΑΛΛΑΓΜΑΤΟΣ',
  },
  {
    label: '66121302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΡΓΥΡΑΜΟΙΒΟΥ',
  },
  {
    label: '66190000',
    value:
      'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΥΝΑΦΕΙΣ ΠΡΟΣ ΤΙΣ ΧΡΗΜΑΤΟΠΙΣΤΩΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΙΣ ΑΣΦΑΛΙΣΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΚΑΙ ΤΑ ΣΥΝΤΑΞΙΟΔΟΤΙΚΑ ΤΑΜΕΙΑ',
  },
  {
    label: '66191000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΑΙ ΕΚΚΑΘΑΡΙΣΗΣ ΣΥΝΑΛΛΑΓΩΝ ΧΡΕΟΓΡΑΦΩΝ',
  },
  {
    label: '66192000',
    value: 'ΒΟΗΘΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΡΑΠΕΖΙΚΕΣ ΕΠΕΝΔΥΣΕΙΣ',
  },
  {
    label: '66192100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΓΧΩΝΕΥΣΕΩΝ ΚΑΙ ΕΞΑΓΟΡΩΝ',
  },
  {
    label: '66192200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΡΗΜΑΤΟΠΙΣΤΩΤΙΚΩΝ ΠΡΑΞΕΩΝ ΕΤΑΙΡΕΙΩΝ ΚΑΙ ΕΠΙΧΕΙΡΗΜΑΤΙΚΟΥ ΚΕΦΑΛΑΙΟΥ',
  },
  {
    label: '66192900',
    value: 'ΑΛΛΕΣ ΒΟΗΘΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΡΑΠΕΖΙΚΕΣ ΕΠΕΝΔΥΣΕΙΣ',
  },
  {
    label: '66193000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΠΙΣΤΕΥΤΙΚΗΣ ΔΙΑΧΕΙΡΙΣΗΣ ΚΑΙ ΠΑΡΑΚΑΤΑΘΗΚΗΣ',
  },
  {
    label: '66193100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΠΙΣΤΕΥΤΙΚΗΣ ΔΙΑΧΕΙΡΙΣΗΣ',
  },
  {
    label: '66193200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΚΑΤΑΘΗΚΗΣ',
  },
  {
    label: '66199000',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΒΟΗΘΗΤΙΚΕΣ ΤΩΝ ΧΡΗΜΑΤΟΠΙΣΤΩΤΙΚΩΝ, ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΑΣΦΑΛΙΣΤΙΚΕΣ ΚΑΙ ΤΑ ΣΥΝΤΑΞΙΟΔΟΤΙΚΑ ΤΑΜΕΙΑ',
  },
  {
    label: '66199100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΩΝ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '66199101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΤΑΙΡΕΙΩΝ ΠΑΡΟΧΗΣ ΕΠΕΝΔΥΤΙΚΩΝ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '66199200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΚΑΙ ΕΚΚΑΘΑΡΙΣΗΣ ΧΡΗΜΑΤΟΟΙΚΟΝΟΜΙΚΩΝ ΣΥΝΑΛΛΑΓΩΝ',
  },
  {
    label: '66199900',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΒΟΗΘΗΤΙΚΕΣ ΤΩΝ ΧΡΗΜΑΤΟΠΙΣΤΩΤΙΚΩΝ, Π.Δ.Κ.Α., ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΑΣΦΑΛΙΣΤΙΚΕΣ ΚΑΙ ΤΑ ΣΥΝΤΑΞΙΟΔΟΤΙΚΑ ΤΑΜΕΙΑ',
  },
  {
    label: '66199901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΗΨΗΣ ΚΑΙ ΔΙΑΒΙΒΑΣΗΣ ΧΡΗΜΑΤΙΣΤΗΡΙΑΚΩΝ ΕΝΤΟΛΩΝ',
  },
  {
    label: '66199902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΥΛΑΞΗΣ ΧΡΕΟΓΡΑΦΩΝ',
  },
  {
    label: '66199903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΗΜΕΡΩΣΗΣ ΟΦΕΙΛΕΤΩΝ ΓΙΑ ΧΡΕΗ',
  },
  {
    label: '66210000',
    value: 'ΑΞΙΟΛΟΓΗΣΗ ΚΙΝΔΥΝΩΝ ΚΑΙ ΖΗΜΙΩΝ',
  },
  {
    label: '66211000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΞΙΟΛΟΓΗΣΗΣ ΚΙΝΔΥΝΟΥ ΚΑΙ ΖΗΜΙΩΝ',
  },
  {
    label: '66220000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΑΣΦΑΛΙΣΤΙΚΩΝ ΠΡΑΚΤΟΡΩΝ ΚΑΙ ΜΕΣΙΤΩΝ',
  },
  {
    label: '66221001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΤΙΚΟΥ ΠΡΑΚΤΟΡΑ',
  },
  {
    label: '66221002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΤΙΚΟΥ ΣΥΜΒΟΥΛΟΥ, ΜΕ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΕΓΚΑΤΑΣΤΑΣΗ',
  },
  {
    label: '66221003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΦΑΛΙΣΤΙΚΟΥ ΣΥΜΒΟΥΛΟΥ, ΧΩΡΙΣ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΕΓΚΑΤΑΣΤΑΣΗ',
  },
  {
    label: '66221004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΤΙΜΗΤΗ, ΠΡΑΓΜΑΤΟΓΝΩΜΟΝΑ ΑΣΦΑΛΙΣΕΩΝ',
  },
  {
    label: '66221005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΣΙΤΗ ΑΣΦΑΛΕΙΩΝ ΓΕΝΙΚΑ, ΜΕ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΕΓΚΑΤΑΣΤΑΣΗ',
  },
  {
    label: '66221006',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΣΙΤΗ ΑΣΦΑΛΕΙΩΝ ΓΕΝΙΚΑ, ΧΩΡΙΣ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΕΓΚΑΤΑΣΤΑΣΗ',
  },
  {
    label: '66221007',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΣΕ ΑΣΦΑΛΙΣΤΙΚΑ ΚΑΙ ΣΥΝΤΑΞΙΟΔΟΤΙΚΑ ΘΕΜΑΤΑ',
  },
  {
    label: '66221008',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΟΝΙΣΤΗ ΑΣΦΑΛΙΣΤΙΚΩΝ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '66221009',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΟΝΙΣΤΗ ΠΑΡΑΓΩΓΩΝ ΑΣΦΑΛΙΣΕΩΝ ΖΩΗΣ',
  },
  {
    label: '66290000',
    value:
      'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΥΝΑΦΕΙΣ ΠΡΟΣ ΤΙΣ ΑΣΦΑΛΙΣΕΙΣ ΚΑΙ ΤΑ ΣΥΝΤΑΞΙΟΔΟΤΙΚΑ ΤΑΜΕΙΑ',
  },
  {
    label: '66291000',
    value:
      'ΑΛΛΕΣ ΒΟΗΘΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΥΝΑΦΕΙΣ ΜΕ ΤΙΣ ΑΣΦΑΛΙΣΕΙΣ ΚΑΙ ΤΑ ΣΥΝΤΑΞΙΟΔΟΤΙΚΑ ΤΑΜΕΙΑ',
  },
  {
    label: '66291100',
    value: 'ΑΝΑΛΟΓΙΣΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '66291101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΠΟΛΟΓΙΣΜΟΥ ΑΣΦΑΛΙΣΤΙΚΩΝ ΚΙΝΔΥΝΩΝ ΚΑΙ ΑΣΦΑΛΙΣΤΡΩΝ',
  },
  {
    label: '66291900',
    value:
      'ΑΛΛΕΣ ΒΟΗΘΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΥΝΑΦΕΙΣ ΜΕ ΤΙΣ ΑΣΦΑΛΙΣΕΙΣ ΚΑΙ ΤΑ ΣΥΝΤΑΞΙΟΔΟΤΙΚΑ ΤΑΜΕΙΑ Π.Δ.Κ.Α.',
  },
  {
    label: '66300000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΚΕΦΑΛΑΙΩΝ',
  },
  {
    label: '66301000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΚΕΦΑΛΑΙΩΝ',
  },
  {
    label: '66301100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΧΑΡΤΟΦΥΛΑΚΙΩΝ ΕΚΤΟΣ ΤΩΝ ΣΥΝΤΑΞΙΟΔΟΤΙΚΩΝ ΤΑΜΕΙΩΝ',
  },
  {
    label: '66301101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΑΜΟΙΒΑΙΩΝ ΚΕΦΑΛΑΙΩΝ',
  },
  {
    label: '66301200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΣΥΝΤΑΞΙΟΔΟΤΙΚΩΝ ΤΑΜΕΙΩΝ',
  },
  {
    label: '68100000',
    value: 'ΑΓΟΡΑΠΩΛΗΣΙΑ ΙΔΙΟΚΤΗΤΩΝ ΑΚΙΝΗΤΩΝ',
  },
  {
    label: '68101100',
    value: 'ΑΓΟΡΑΠΩΛΗΣΙΑ ΚΤΙΡΙΩΝ ΚΑΤΟΙΚΙΩΝ ΚΑΙ ΟΙΚΟΠΕΔΩΝ ΓΙΑ ΚΤΙΡΙΑ ΚΑΤΟΙΚΙΩΝ',
  },
  {
    label: '68101200',
    value: 'ΑΓΟΡΑΠΩΛΗΣΙΑ ΙΔΙΟΚΤΗΣΙΩΝ ΧΡΟΝΟΜΕΡΙΣΤΙΚΗΣ ΜΙΣΘΩΣΗΣ',
  },
  {
    label: '68101300',
    value:
      'ΑΓΟΡΑΠΩΛΗΣΙΑ ΕΛΕΥΘΕΡΩΝ (ΜΗ ΟΙΚΟΔΟΜΗΜΕΝΩΝ) ΟΙΚΟΠΕΔΩΝ ΓΙΑ ΚΤΙΡΙΑ ΚΑΤΟΙΚΙΩΝ',
  },
  {
    label: '68101400',
    value:
      'ΑΓΟΡΑΠΩΛΗΣΙΑ ΜΗ ΟΙΚΙΣΤΙΚΩΝ ΚΤΙΡΙΩΝ ΚΑΙ ΟΙΚΟΠΕΔΩΝ ΓΙΑ ΤΗΝ ΑΝΕΓΕΡΣΗ ΤΕΤΟΙΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '68101500',
    value:
      'ΑΓΟΡΑΠΩΛΗΣΙΑ ΕΛΕΥΘΕΡΩΝ (ΜΗ ΟΙΚΟΔΟΜΗΜΕΝΩΝ) ΟΙΚΟΠΕΔΩΝ ΠΟΥ ΔΕΝ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΤΗΝ ΑΝΕΓΕΡΣΗ ΚΤΙΡΙΩΝ ΚΑΤΟΙΚΙΩΝ',
  },
  {
    label: '68200000',
    value: 'ΕΚΜΙΣΘΩΣΗ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗ ΙΔΙΟΚΤΗΤΩΝ Η ΜΙΣΘΩΜΕΝΩΝ ΑΚΙΝΗΤΩΝ',
  },
  {
    label: '68201000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΜΙΣΘΩΣΗΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΙΔΙΟΚΤΗΤΩΝ Η ΜΙΣΘΩΜΕΝΩΝ ΑΚΙΝΗΤΩΝ',
  },
  {
    label: '68201100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΜΙΣΘΩΣΗΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΙΔΙΟΚΤΗΤΩΝ Η ΜΙΣΘΩΜΕΝΩΝ ΑΚΙΝΗΤΩΝ, ΠΟΥ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΚΑΤΟΙΚΙΑ',
  },
  {
    label: '68201101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΑΚΙΝΗΤΟΥ, ΠΟΥ ΠΡΟΟΡΙΖΕΤΑΙ ΓΙΑ ΚΑΤΟΙΚΗΣΗ',
  },
  {
    label: '68201102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΔΩΜΑΤΙΩΝ ΣΠΙΤΙΩΝ, ΜΑΚΡΑΣ ΔΙΑΡΚΕΙΑΣ',
  },
  {
    label: '68201103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΠΛΩΜΕΝΩΝ ΔΙΑΜΕΡΙΣΜΑΤΩΝ ΜΑΚΡΑΣ ΔΙΑΡΚΕΙΑΣ, ΧΩΡΙΣ ΠΑΡΟΧΗ ΥΠΗΡΕΣΙΩΝ ΠΕΡΙΠΟΙΗΣΗΣ ΠΕΛΑΤΩΝ',
  },
  {
    label: '68201104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΡΟΝΟΜΕΡΙΣΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΑΚΙΝΗΤΟΥ ΓΙΑ ΚΑΤΟΙΚΗΣΗ',
  },
  {
    label: '68201200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΜΙΣΘΩΣΗΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΙΔΙΟΚΤΗΤΩΝ Η ΜΙΣΘΩΜΕΝΩΝ ΑΚΙΝΗΤΩΝ, ΠΟΥ ΔΕΝ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΚΑΤΟΙΚΙΑ',
  },
  {
    label: '68201201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΜΙΣΘΩΣΗΣ Η ΔΙΑΧΕΙΡΙΣΗΣ ΙΔΙΟΚΤΗΤΩΝ Η ΜΙΣΘΩΜΕΝΩΝ ΑΚΙΝΗΤΩΝ, ΠΟΥ ΔΕΝ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΚΑΤΟΙΚΙΑ, ΜΕ ΥΠΑΓΩΓΗ ΣΕ Φ.Π.Α.',
  },
  {
    label: '68201202',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΜΙΣΘΩΣΗΣ Η ΔΙΑΧΕΙΡΙΣΗΣ ΙΔΙΟΚΤΗΤΩΝ Η ΜΙΣΘΩΜΕΝΩΝ ΑΚΙΝΗΤΩΝ, ΠΟΥ ΔΕΝ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΚΑΤΟΙΚΙΑ, ΧΩΡΙΣ ΥΠΑΓΩΓΗ ΣΕ Φ.Π.Α.',
  },
  {
    label: '68201203',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΑΚΙΝΗΤΩΝ, ΠΟΥ ΔΕΝ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΚΑΤΟΙΚΗΣΗ',
  },
  {
    label: '68201204',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΒΙΟΜΗΧΑΝΟΣΤΑΣΙΟΥ',
  },
  {
    label: '68201205',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΙΣΘΩΣΗΣ ΑΣΚΕΠΟΥΣ ΧΩΡΟΥ ΓΙΑ ΤΗΝ ΕΓΚΑΤΑΣΤΑΣΗ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '68201206',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΧΩΡΗΣΗΣ ΧΡΗΣΗΣ ΕΓΚΑΤΑΣΤΑΣΕΩΝ (ΓΗΠΕΔΑ ΓΚΟΛΦ, ΤΕΝΙΣ ΚΛΠ)',
  },
  {
    label: '68310000',
    value: 'ΜΕΣΙΤΙΚΑ ΓΡΑΦΕΙΑ ΑΚΙΝΗΤΩΝ',
  },
  {
    label: '68311000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΣΙΤΙΚΟΥ ΓΡΑΦΕΙΟΥ ΑΚΙΝΗΤΩΝ ΕΝΑΝΤΙ ΑΜΟΙΒΗΣ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '68311100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΚΤΙΡΙΩΝ ΚΑΤΟΙΚΙΩΝ ΚΑΙ ΓΗΣ ΓΙΑ ΑΝΕΓΕΡΣΗ ΚΤΙΡΙΩΝ ΚΑΤΟΙΚΙΩΝ, ΒΑΣΕΙ ΑΜΟΙΒΗΣ Η ΣΥΜΒΑΣΗΣ, ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΙΔΙΟΚΤΗΣΙΕΣ ΧΡΟΝΟΜΕΡΙΣΤΙΚΗΣ ΜΙΣΘΩΣΗΣ',
  },
  {
    label: '68311200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΙΔΙΟΚΤΗΣΙΩΝ ΧΡΟΝΟΜΕΡΙΣΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΕΝΑΝΤΙ ΑΜΟΙΒΗΣ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '68311300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΕΛΕΥΘΕΡΩΝ (ΜΗ ΟΙΚΟΔΟΜΗΜΕΝΩΝ) ΟΙΚΟΠΕΔΩΝ ΠΟΥ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΤΗΝ ΑΝΕΓΕΡΣΗ ΚΤΙΡΙΩΝ ΚΑΤΟΙΚΙΩΝ, ΕΝΑΝΤΙ ΑΜΟΙΒΗΣ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '68311400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΚΤΙΡΙΩΝ ΠΟΥ ΔΕΝ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΚΑΤΟΙΚΗΣΗ ΚΑΙ ΣΥΝΑΦΩΝ ΟΙΚΟΠΕΔΩΝ ΒΑΣΕΙ ΑΜΟΙΒΗΣ Η ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '68311500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΕΛΕΥΘΕΡΩΝ (ΜΗ ΟΙΚΟΔΟΜΗΜΕΝΩΝ) ΟΙΚΟΠΕΔΩΝ ΠΟΥ ΔΕΝ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΤΗΝ ΑΝΕΓΕΡΣΗ ΚΤΙΡΙΩΝ ΚΑΤΟΙΚΙΩΝ, ΕΝΑΝΤΙ ΑΜΟΙΒΗΣ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '68311600',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΤΙΜΗΣΗΣ ΑΚΙΝΗΤΩΝ ΕΝΑΝΤΙ ΑΜΟΙΒΗΣ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '68320000',
    value: 'ΔΙΑΧΕΙΡΙΣΗ ΑΚΙΝΗΤΗΣ ΠΕΡΙΟΥΣΙΑΣ, ΕΝΑΝΤΙ ΑΜΟΙΒΗΣ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '68321000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΑΚΙΝΗΤΩΝ ΕΝΑΝΤΙ ΑΜΟΙΒΗΣ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '68321100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΚΤΙΡΙΩΝ ΚΑΤΟΙΚΙΩΝ ΒΑΣΕΙ ΑΜΟΙΒΗΣ Η ΣΥΜΒΑΣΗΣ, ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΙΔΙΟΚΤΗΣΙΕΣ ΧΡΟΝΟΜΕΡΙΣΤΙΚΗΣ ΜΙΣΘΩΣΗΣ',
  },
  {
    label: '68321101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΚΤΙΡΙΩΝ ΠΟΛΥΚΑΤΟΙΚΙΩΝ',
  },
  {
    label: '68321102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΙΣΠΡΑΞΗΣ ΜΙΣΘΩΜΑΤΩΝ ΟΙΚΙΩΝ',
  },
  {
    label: '68321103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΔΟΣΗΣ ΛΟΓΑΡΙΑΣΜΩΝ ΚΟΙΝΟΧΡΗΣΤΩΝ ΠΟΛΥΚΑΤΟΙΚΙΩΝ',
  },
  {
    label: '68321200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΙΔΙΟΚΤΗΣΙΩΝ ΧΡΟΝΟΜΕΡΙΣΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΕΝΑΝΤΙ ΑΜΟΙΒΗΣ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '68321300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΑΚΙΝΗΤΩΝ ΠΟΥ ΔΕΝ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΚΑΤΟΙΚΗΣΗ, ΕΝΑΝΤΙ ΑΜΟΙΒΗΣ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '68321301',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΠΟΥ ΑΦΟΡΟΥΝ ΑΓΡΟΤΙΚΑ, ΔΑΣΙΚΑ ΚΑΙ ΠΑΡΟΜΟΙΑ ΑΚΙΝΗΤΑ',
  },
  {
    label: '69100000',
    value: 'ΝΟΜΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '69101000',
    value: 'ΝΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ (ΔΙΚΗΓΟΡΟΥ)',
  },
  {
    label: '69101100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΝΟΜΙΚΩΝ ΣΥΜΒΟΥΛΩΝ ΚΑΙ ΝΟΜΙΚΗΣ ΕΚΠΡΟΣΩΠΗΣΗΣ ΣΤΟΝ ΤΟΜΕΑ ΤΟΥ ΠΟΙΝΙΚΟΥ ΔΙΚΑΙΟΥ',
  },
  {
    label: '69101200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΝΟΜΙΚΩΝ ΣΥΜΒΟΥΛΩΝ ΚΑΙ ΝΟΜΙΚΗΣ ΕΚΠΡΟΣΩΠΗΣΗΣ ΣΕ ΔΙΚΟΝΟΜΙΚΕΣ ΔΙΑΔΙΚΑΣΙΕΣ ΕΝΩΠΙΟΝ ΤΑΚΤΙΚΩΝ ΔΙΚΑΣΤΗΡΙΩΝ ΣΧΕΤΙΚΑ ΜΕ ΤΟ ΕΠΙΧΕΙΡΗΜΑΤΙΚΟ ΚΑΙ ΤΟ ΕΜΠΟΡΙΚΟ ΔΙΚΑΙΟ',
  },
  {
    label: '69101300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΝΟΜΙΚΩΝ ΣΥΜΒΟΥΛΩΝ ΚΑΙ ΝΟΜΙΚΗΣ ΕΚΠΡΟΣΩΠΗΣΗΣ ΣΕ ΔΙΚΟΝΟΜΙΚΕΣ ΔΙΑΔΙΚΑΣΙΕΣ ΕΝΩΠΙΟΝ ΤΑΚΤΙΚΩΝ ΔΙΚΑΣΤΗΡΙΩΝ ΣΧΕΤΙΚΑ ΜΕ ΤΟ ΕΡΓΑΤΙΚΟ ΔΙΚΑΙΟ',
  },
  {
    label: '69101400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΝΟΜΙΚΩΝ ΣΥΜΒΟΥΛΩΝ ΚΑΙ ΝΟΜΙΚΗΣ ΕΚΠΡΟΣΩΠΗΣΗΣ ΣΕ ΔΙΚΟΝΟΜΙΚΕΣ ΔΙΑΔΙΚΑΣΙΕΣ ΕΝΩΠΙΟΝ ΤΑΚΤΙΚΩΝ ΔΙΚΑΣΤΗΡΙΩΝ ΣΧΕΤΙΚΑ ΜΕ ΤΟ ΑΣΤΙΚΟ ΔΙΚΑΙΟ',
  },
  {
    label: '69101500',
    value:
      'ΝΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΑ ΜΕ ΔΙΠΛΩΜΑΤΑ ΕΥΡΕΣΙΤΕΧΝΙΑΣ, ΔΙΚΑΙΩΜΑΤΑ ΠΝΕΥΜΑΤΙΚΗΣ ΙΔΙΟΚΤΗΣΙΑΣ ΚΑΙ ΑΛΛΑ ΔΙΚΑΙΩΜΑΤΑ ΔΙΑΝΟΗΤΙΚΗΣ ΙΔΙΟΚΤΗΣΙΑΣ',
  },
  {
    label: '69101501',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΡΟΕΤΟΙΜΑΣΙΑΣ, ΣΥΝΤΑΞΗΣ ΚΑΙ ΕΠΙΚΥΡΩΣΗΣ ΠΝΕΥΜΑΤΙΚΩΝ ΚΑΙ ΡΑΔΙΟΤΗΛΕΟΠΤΙΚΩΝ ΔΙΚΑΙΩΜΑΤΩΝ',
  },
  {
    label: '69101600',
    value: 'ΣΥΜΒΟΛΑΙΟΓΡΑΦΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '69101700',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΙΤΗΣΙΑΣ ΚΑΙ ΣΥΜΒΙΒΑΣΜΟΥ',
  },
  {
    label: '69101800',
    value: 'ΝΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΔΗΜΟΠΡΑΣΙΩΝ',
  },
  {
    label: '69101801',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΟΡΓΑΝΩΣΗΣ ΠΛΕΙΣΤΗΡΙΑΣΜΩΝ',
  },
  {
    label: '69101900',
    value: 'ΑΛΛΕΣ ΝΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '69101901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΚΟΥΜΕΝΟΥ ΔΙΚΗΓΟΡΟΥ',
  },
  {
    label: '69101902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΚΑΣΤΙΚΟΥ ΕΠΙΜΕΛΗΤΗ',
  },
  {
    label: '69101903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΚΟΛΑΒΟΥ',
  },
  {
    label: '69101904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΣΕΓΓΥΗΣΗΣ ΚΑΙ ΣΥΜΒΙΒΑΣΜΟΥ ΑΚΙΝΗΤΗΣ ΠΕΡΙΟΥΣΙΑΣ',
  },
  {
    label: '69200000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΛΟΓΙΣΤΙΚΗΣ, ΤΗΡΗΣΗΣ ΒΙΒΛΙΩΝ ΚΑΙ ΛΟΓΙΣΤΙΚΟΥ ΕΛΕΓΧΟΥ· ΠΑΡΟΧΗ ΦΟΡΟΛΟΓΙΚΩΝ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '69201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΙΚΟΝΟΜΙΚΟΥ ΕΛΕΓΧΟΥ',
  },
  {
    label: '69201001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΡΚΩΤΟΥ ΕΛΕΓΚΤΗ',
  },
  {
    label: '69201002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΡΚΩΤΟΥ ΛΟΓΙΣΤΗ',
  },
  {
    label: '69202000',
    value: 'ΛΟΓΙΣΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '69202100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΟΓΙΣΤΙΚΗΣ ΕΠΑΛΗΘΕΥΣΗΣ',
  },
  {
    label: '69202200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΑΞΗΣ ΟΙΚΟΝΟΜΙΚΩΝ ΚΑΤΑΣΤΑΣΕΩΝ',
  },
  {
    label: '69202201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΛΟΓΙΣΤΗ ΓΙΑ ΣΥΝΤΑΞΗ ΟΙΚΟΝΟΜΙΚΩΝ ΚΑΤΑΣΤΑΣΕΩΝ ΚΑΙ ΦΟΡΟΛΟΓΙΚΩΝ ΔΗΛΩΣΕΩΝ',
  },
  {
    label: '69202202',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΑΞΗΣ ΚΑΙ ΔΗΜΟΣΙΕΥΣΗΣ ΙΣΟΛΟΓΙΣΜΩΝ, ΚΑΤΑΣΤΑΤΙΚΩΝ, ΤΡΟΠΟΠΟΙΗΣΕΩΝ, ΑΝΑΚΟΙΝΩΣΕΩΝ ΚΛΠ',
  },
  {
    label: '69202300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΗΡΗΣΗΣ ΛΟΓΙΣΤΙΚΩΝ ΒΙΒΛΙΩΝ',
  },
  {
    label: '69202301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΡΓΑΝΩΜΕΝΩΝ ΓΡΑΦΕΙΩΝ ΤΗΡΗΣΗΣ ΛΟΓΙΣΤΙΚΩΝ ΒΙΒΛΙΩΝ',
  },
  {
    label: '69202302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΗΡΗΣΗΣ ΛΟΓΙΣΤΙΚΩΝ ΒΙΒΛΙΩΝ ΜΕ ΠΡΟΣΩΠΙΚΗ ΕΡΓΑΣΙΑ',
  },
  {
    label: '69202400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΙΣΘΟΛΟΓΙΟΥ',
  },
  {
    label: '69202900',
    value: 'ΑΛΛΕΣ ΛΟΓΙΣΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '69202901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΟΓΙΣΤΙΚΩΝ ΑΠΟΤΙΜΗΣΕΩΝ, ΑΠΟΓΡΑΦΩΝ, ΒΕΒΑΙΩΣΕΩΝ ΚΛΠ',
  },
  {
    label: '69203000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΦΟΡΟΛΟΓΙΚΩΝ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '69203100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΦΟΡΟΛΟΓΙΚΩΝ ΣΥΜΒΟΥΛΩΝ ΣΕ ΝΟΜΙΚΑ ΠΡΟΣΩΠΑ ΚΑΙ ΠΡΟΕΤΟΙΜΑΣΙΑ ΦΟΡΟΛΟΓΙΚΩΝ ΔΗΛΩΣΕΩΝ',
  },
  {
    label: '69203200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΦΟΡΟΛΟΓΙΚΩΝ ΣΥΜΒΟΥΛΩΝ ΣΕ ΦΥΣΙΚΑ ΠΡΟΣΩΠΑ ΚΑΙ ΠΡΟΕΤΟΙΜΑΣΙΑ ΦΟΡΟΛΟΓΙΚΩΝ ΔΗΛΩΣΕΩΝ',
  },
  {
    label: '69203201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΑΞΗΣ ΦΟΡΟΛΟΓΙΚΩΝ ΔΗΛΩΣΕΩΝ ΚΑΙ ΣΧΕΤΙΚΩΝ ΕΓΓΡΑΦΩΝ',
  },
  {
    label: '69204000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΦΕΡΕΓΓΥΟΤΗΤΑΣ ΚΑΙ ΕΚΚΑΘΑΡΙΣΗΣ',
  },
  {
    label: '70100000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΚΕΝΤΡΙΚΩΝ ΓΡΑΦΕΙΩΝ',
  },
  {
    label: '70101000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΕΝΤΡΙΚΩΝ ΓΡΑΦΕΙΩΝ (ΕΔΡΩΝ) ΕΤΑΙΡΕΙΩΝ',
  },
  {
    label: '70210000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΔΗΜΟΣΙΩΝ ΣΧΕΣΕΩΝ ΚΑΙ ΕΠΙΚΟΙΝΩΝΙΑΣ',
  },
  {
    label: '70211000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΗΜΟΣΙΩΝ ΣΧΕΣΕΩΝ ΚΑΙ ΕΠΙΚΟΙΝΩΝΙΑΣ',
  },
  {
    label: '70220000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΑΡΟΧΗΣ ΕΠΙΧΕΙΡΗΜΑΤΙΚΩΝ ΣΥΜΒΟΥΛΩΝ ΚΑΙ ΑΛΛΩΝ ΣΥΜΒΟΥΛΩΝ ΔΙΑΧΕΙΡΙΣΗΣ',
  },
  {
    label: '70221000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΕΠΙΧΕΙΡΗΜΑΤΙΚΩΝ ΣΥΜΒΟΥΛΩΝ ΔΙΑΧΕΙΡΙΣΗΣ',
  },
  {
    label: '70221100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΣΤΡΑΤΗΓΙΚΗΣ ΔΙΑΧΕΙΡΙΣΗΣ',
  },
  {
    label: '70221101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΔΙΚΑΣΙΩΝ ΙΔΡΥΣΗΣ ΕΠΙΧΕΙΡΗΣΗΣ',
  },
  {
    label: '70221102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΜΒΟΥΛΩΝ ΔΙΑΧΕΙΡΙΣΗΣ ΑΠΟ ΟΡΓΑΝΩΜΕΝΟ ΓΡΑΦΕΙΟ, ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΜΕΧΡΙ 30 ~ ΑΤΟΜΑ',
  },
  {
    label: '70221103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΜΒΟΥΛΩΝ ΔΙΑΧΕΙΡΙΣΗΣ ΑΠΟ ΟΡΓΑΝΩΜΕΝΟ ΓΡΑΦΕΙΟ, ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΠΑΝΩ ΑΠΟ 30 ~ ΑΤΟΜΑ',
  },
  {
    label: '70221104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΔΙΑΡΘΡΩΣΗΣ Η ΑΝΑΔΙΑΡΘΡΩΣΗΣ ΕΠΙΧΕΙΡΗΣΗΣ',
  },
  {
    label: '70221105',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΥΠΟΣΤΗΡΙΞΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ ΓΙΑ ΤΗΝ ΕΝΤΑΞΗ ΤΟΥΣ ΣΕ ΑΝΑΠΤΥΞΙΑΚΑ ΠΡΟΓΡΑΜΜΑΤΑ',
  },
  {
    label: '70221200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΣΕ ΘΕΜΑΤΑ ΟΙΚΟΝΟΜΙΚΗΣ ΔΙΑΧΕΙΡΙΣΗΣ (ΕΚΤΟΣ ΘΕΜΑΤΩΝ ΦΟΡΟΛΟΓΙΑΣ ΝΟΜΙΚΩΝ ΠΡΟΣΩΠΩΝ)',
  },
  {
    label: '70221201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΞΙΟΠΟΙΗΣΗΣ ΚΑΙ ΔΙΑΧΕΙΡΙΣΗΣ ΠΕΡΙΟΥΣΙΑΣ ΝΟΜΙΚΩΝ ΠΡΟΣΩΠΩΝ',
  },
  {
    label: '70221202',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΠΟΤΙΜΗΣΗΣ ΕΠΙΧΕΙΡΗΣΕΩΝ ΠΡΙΝ ΑΠΟ ΣΥΓΧΩΝΕΥΣΕΙΣ Η/ΚΑΙ ΕΞΑΓΟΡΕΣ',
  },
  {
    label: '70221203',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΜΕΣΟΛΑΒΗΣΗΣ ΓΙΑ ΤΗΝ ΕΞΑΓΩΓΗ ΑΓΑΘΩΝ',
  },
  {
    label: '70221204',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΠΤΩΧΕΥΤΙΚΗΣ ΠΕΡΙΟΥΣΙΑΣ ΑΠΟ ΣΥΝΔΙΚΟ ΠΤΩΧΕΥΣΗΣ',
  },
  {
    label: '70221205',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΚΑΘΑΡΙΣΤΗ ΕΤΑΙΡΕΙΑΣ',
  },
  {
    label: '70221206',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΚΑΘΑΡΙΣΤΗ ΚΛΗΡΟΝΟΜΙΑΣ',
  },
  {
    label: '70221207',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΤΕΛΕΣΤΗ ΔΙΑΘΗΚΗΣ',
  },
  {
    label: '70221208',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΤΕΛΩΝΙΣΤΗ Η ΔΙΑΣΑΦΙΣΤΗ',
  },
  {
    label: '70221209',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΗΔΕΜΟΝΑ ΣΧΟΛΑΖΟΥΣΑΣ ΚΛΗΡΟΝΟΜΙΑΣ',
  },
  {
    label: '70221210',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΛΕΤΩΝ ΟΡΓΑΝΩΣΗΣ ΚΑΙ ΕΠΙΧΕΙΡΗΣΙΑΚΗΣ ΕΡΕΥΝΑΣ',
  },
  {
    label: '70221211',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΟΙΚΟΝΟΜΙΚΩΝ ΚΑΙ ΕΜΠΟΡΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ, ΕΚΤΟΣ ΣΥΜΠΕΡΙΦΟΡΑΣ ΚΑΤΑΝΑΛΩΤΩΝ',
  },
  {
    label: '70221212',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΑΝΑΠΤΥΞΗΣ ΚΑΘΕ ΕΙΔΟΥΣ ΑΓΡΟΤΙΚΩΝ ΕΚΜΕΤΑΛΛΕΥΣΕΩΝ',
  },
  {
    label: '70221213',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΜΒΟΥΛΩΝ ΔΙΑΧΕΙΡΙΣΗΣ ΚΕΦΑΛΑΙΩΝ (ΚΕΦΑΛΑΙΑΚΗΣ ΔΙΑΡΘΡΩΣΗΣ, ΕΠΕΝΔΥΣΕΩΝ)',
  },
  {
    label: '70221214',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΜΒΟΥΛΩΝ ΔΙΑΧΕΙΡΙΣΗΣ ΚΕΦΑΛΑΙΩΝ ΚΙΝΗΣΗΣ (ΡΕΥΣΤΟΤΗΤΑΣ)',
  },
  {
    label: '70221215',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΟΡΟΛΟΓΙΚΟΥ ΑΝΤΙΠΡΟΣΩΠΟΥ Η ΕΚΠΡΟΣΩΠΟΥ',
  },
  {
    label: '70221300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΣΕ ΘΕΜΑΤΑ ΜΑΡΚΕΤΙΝΓΚ',
  },
  {
    label: '70221301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΙΑΤΡΙΚΟΥ ΕΠΙΣΚΕΠΤΗ',
  },
  {
    label: '70221302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΡΓΑΝΩΣΗΣ ΤΟΥ ΚΥΚΛΩΜΑΤΟΣ ΔΙΑΝΟΜΗΣ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '70221303',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΧΩΡΗΣΗΣ ΠΡΟΝΟΜΙΟΥ FRANCHISE ΚΑΙ ΠΑΡΟΧΗΣ ΣΧΕΤΙΚΩΝ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '70221304',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΤΗ ΑΓΑΘΩΝ',
  },
  {
    label: '70221305',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΜΒΟΥΛΟΥ ΣΕ ΘΕΜΑΤΑ ΠΡΟΩΘΗΣΗΣ ΠΩΛΗΣΕΩΝ',
  },
  {
    label: '70221400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΣΕ ΘΕΜΑΤΑ ΔΙΑΧΕΙΡΙΣΗΣ ΑΝΘΡΩΠΙΝΟΥ ΔΥΝΑΜΙΚΟΥ',
  },
  {
    label: '70221401',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΠΤΥΞΗΣ ΤΟΥ ΑΝΘΡΩΠΙΝΟΥ ΔΥΝΑΜΙΚΟΥ ΕΠΙΧΕΙΡΗΣΗΣ',
  },
  {
    label: '70221500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΣΕ ΘΕΜΑΤΑ ΟΡΓΑΝΩΣΗΣ ΠΑΡΑΓΩΓΗΣ',
  },
  {
    label: '70221501',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΛΙΕΥΤΙΚΩΝ ΜΕΛΕΤΩΝ',
  },
  {
    label: '70221502',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΕΩΡΓΙΚΩΝ ΜΕΛΕΤΩΝ (ΓΕΩΡΓΟΟΙΚΟΝΟΜΙΚΩΝ ~ ΓΕΩΡΓΟΤΕΧΝΙΚΩΝ, ΕΓΓΕΙΩΝ ΒΕΛΤΙΩΣΕΩΝ, ΓΕΩΡΓΟΚΤΗΝΟΤΡΟΦΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΙΣΜΟΥ, ΓΕΩΡΓΟΚΤΗΝΟΤΡΟΦΙΚΩΝ ΕΚΜΕΤΑΛΛΕΥΣΕΩΝ)',
  },
  {
    label: '70221503',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΑΣΟΛΟΓΙΚΩΝ ΜΕΛΕΤΩΝ (ΔΙΑΧΕΙΡΙΣΗΣ ΔΑΣΩΝ ΚΑΙ ΟΡΕΙΝΩΝ ΒΟΣΚΟΤΟΠΩΝ, ΔΑΣΟΤΕΧΝΙΚΗΣ ΔΙΕΥΘΕΤΗΣΗΣ ΟΡΕΙΝΩΝ ΛΕΚΑΝΩΝ, ΧΕΙΜΑΡΡΩΝ, ΑΝΑΔΑΣΩΣΕΩΝ, ΔΑΣΙΚΩΝ ΟΔΩΝ ΚΑΙ ΔΑΣΙΚΩΝ ΜΕΤΑΦΟΡΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ)',
  },
  {
    label: '70221504',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΟΡΓΑΝΩΣΗΣ ΤΗΣ ΜΕΘΟΔΟΥ ΕΡΓΑΣΙΑΣ',
  },
  {
    label: '70221505',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΙΣΤΟΠΟΙΗΣΗΣ ΣΥΣΤΗΜΑΤΩΝ ΔΙΑΧΕΙΡΙΣΗΣ ΠΟΙΟΤΗΤΑΣ',
  },
  {
    label: '70221506',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΓΕΩΠΟΝΟΥΣ ΚΑΙ ΑΠΟ ΑΛΛΟΥΣ ΕΙΔΙΚΟΥΣ ΣΕ ΘΕΜΑΤΑ ΑΓΡΟΤΙΚΗΣ ΟΙΚΟΝΟΜΙΑΣ',
  },
  {
    label: '70221507',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΟΙΚΟΝΟΜΟΛΟΓΟΥΣ, ΕΙΔΙΚΟΥΣ ΣΕ ΘΕΜΑΤΑ ΑΓΡΟΤΙΚΗΣ ΟΙΚΟΝΟΜΙΑΣ',
  },
  {
    label: '70221508',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΜΒΟΥΛΩΝ ΓΙΑ ΕΛΕΓΧΟ ΠΟΙΟΤΗΤΑΣ',
  },
  {
    label: '70221509',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΜΒΟΥΛΩΝ ΓΙΑ ΕΛΕΓΧΟ ΠΟΙΟΤΗΤΑΣ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '70221510',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΜΒΟΥΛΩΝ ΓΙΑ ΚΑΝΟΝΕΣ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '70221600',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΓΙΑ ΘΕΜΑΤΑ ΕΦΟΔΙΑΣΜΟΥ ΚΑΙ ΑΛΛΩΝ ΣΥΜΒΟΥΛΩΝ ΔΙΑΧΕΙΡΙΣΗΣ',
  },
  {
    label: '70221601',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΜΒΟΥΛΩΝ ΣΕ ΘΕΜΑΤΑ ΕΠΙΜΕΛΗΤΕΙΑΣ (LOGISTIC)',
  },
  {
    label: '70221700',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΕΠΙΧΕΙΡΗΜΑΤΙΚΩΝ ΔΙΑΔΙΚΑΣΙΩΝ',
  },
  {
    label: '70222000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΕΡΓΩΝ ΕΚΤΟΣ ΤΩΝ ΚΑΤΑΣΚΕΥΑΣΤΙΚΩΝ',
  },
  {
    label: '70222001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΡΤΙΣΗΣ ΠΡΟΫΠΟΛΟΓΙΣΜΟΥ ΕΠΙΧΕΙΡΗΣΗΣ',
  },
  {
    label: '70222002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΟΓΙΣΤΙΚΗΣ ΚΑΙ ΕΛΕΓΧΟΥ ΚΟΣΤΟΥΣ ΠΡΟΜΗΘΕΙΩΝ',
  },
  {
    label: '70222003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΟΝΙΣΜΟΥ ΚΑΙ ΕΠΙΘΕΩΡΗΣΗΣ ΥΠΕΡΓΟΛΑΒΩΝ',
  },
  {
    label: '70223000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΕΠΙΧΕΙΡΗΜΑΤΙΚΩΝ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '70223001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΚΟΣΜΗΤΗ ΚΑΤΑΣΤΗΜΑΤΩΝ ΚΑΙ ΑΛΛΩΝ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΧΩΡΩΝ (DECORATEUR)',
  },
  {
    label: '70223002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΔΥΜΑΤΟΛΟΓΟΥ (ΕΚΤΟΣ ΘΕΑΜΑΤΩΝ)',
  },
  {
    label: '70223003',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΣΩΤΕΡΙΚΗΣ ΔΙΑΜΟΡΦΩΣΗΣ ΚΑΙ ΔΙΑΚΟΣΜΗΣΗΣ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΧΩΡΩΝ',
  },
  {
    label: '70224000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΕΜΠΟΡΙΚΩΝ ΣΗΜΑΤΩΝ ΚΑΙ ΣΥΜΒΑΣΕΩΝ ΔΙΚΑΙΟΧΡΗΣΗΣ',
  },
  {
    label: '71110000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΑΡΧΙΤΕΚΤΟΝΩΝ',
  },
  {
    label: '71111000',
    value: 'ΠΑΡΑΓΩΓΗ ΣΧΕΔΙΩΝ ΚΑΙ ΣΚΑΡΙΦΗΜΑΤΩΝ ΓΙΑ ΑΡΧΙΤΕΚΤΟΝΙΚΟΥΣ ΣΚΟΠΟΥΣ',
  },
  {
    label: '71112000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΡΧΙΤΕΚΤΟΝΩΝ ΓΙΑ ΚΤΙΡΙΑ',
  },
  {
    label: '71112100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΡΧΙΤΕΚΤΟΝΩΝ ΓΙΑ ΕΡΓΑ ΚΑΤΑΣΚΕΥΗΣ ΚΑΤΟΙΚΙΩΝ',
  },
  {
    label: '71112200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΡΧΙΤΕΚΤΟΝΩΝ ΓΙΑ ΕΡΓΑ ΚΑΤΑΣΚΕΥΗΣ ΜΗ ΟΙΚΙΣΤΙΚΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '71112300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΡΧΙΤΕΚΤΟΝΩΝ ΙΣΤΟΡΙΚΗΣ ΑΠΟΚΑΤΑΣΤΑΣΗΣ',
  },
  {
    label: '71112301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΡΧΙΤΕΚΤΟΝΙΚΩΝ ΜΕΛΕΤΩΝ ΔΙΑΤΗΡΗΣΗΣ ΠΑΡΑΔΟΣΙΑΚΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '71112400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΑΡΧΙΤΕΚΤΟΝΙΚΩΝ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '71113000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΤΙΚΟΥ ΚΑΙ ΧΩΡΟΤΑΞΙΚΟΥ ΣΧΕΔΙΑΣΜΟΥ',
  },
  {
    label: '71113100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΛΕΟΔΟΜΙΑΣ',
  },
  {
    label: '71113101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΛΕΤΩΝ ΚΑΙ ΠΡΟΓΡΑΜΜΑΤΩΝ ΧΩΡΙΚΗΣ ΑΝΑΠΤΥΞΗΣ',
  },
  {
    label: '71113102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΛΕΤΩΝ ΠΕΡΙΒΑΛΛΟΝΤΙΚΩΝ ΕΠΙΠΤΩΣΕΩΝ ΠΟΛΕΟΔΟΜΙΚΗΣ ΠΑΡΕΜΒΑΣΗΣ',
  },
  {
    label: '71113103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΛΕΤΩΝ ΣΥΝΤΟΝΙΣΜΕΝΗΣ ΑΣΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ',
  },
  {
    label: '71113104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΛΕΟΔΟΜΙΚΩΝ ΚΑΙ ΡΥΜΟΤΟΜΙΚΩΝ ΜΕΛΕΤΩΝ',
  },
  {
    label: '71113105',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΩΡΟΤΑΞΙΚΩΝ ΚΑΙ ΡΥΘΜΙΣΤΙΚΩΝ ΜΕΛΕΤΩΝ',
  },
  {
    label: '71113200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΓΡΟΤΙΚΗΣ ΧΩΡΟΤΑΞΙΑΣ',
  },
  {
    label: '71113300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΕΝΙΚΟΥ ΣΧΕΔΙΑΣΜΟΥ ΕΡΓΟΤΑΞΙΟΥ',
  },
  {
    label: '71114000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΡΧΙΤΕΚΤΟΝΙΚΗΣ ΤΟΠΙΟΥ ΚΑΙ ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΑΡΧΙΤΕΚΤΟΝΙΚΩΝ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '71114100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΡΧΙΤΕΚΤΟΝΙΚΗΣ ΤΟΠΙΟΥ',
  },
  {
    label: '71114101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΩΝ ΑΡΧΙΤΕΚΤΟΝΙΚΩΝ ΜΕΛΕΤΩΝ (ΔΙΑΤΗΡΗΣΗΣ ΠΑΡΑΔΟΣΙΑΚΩΝ ΟΙΚΙΣΜΩΝ ΚΑΙ ΤΟΠΙΟΥ)',
  },
  {
    label: '71114102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΛΕΤΩΝ ΦΥΤΟΤΕΧΝΙΚΗΣ ΔΙΑΜΟΡΦΩΣΗΣ ΠΕΡΙΒΑΛΛΟΝΤΟΣ ΧΩΡΟΥ ΚΑΙ ΕΡΓΩΝ ΠΡΑΣΙΝΟΥ',
  },
  {
    label: '71114103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΚΑΙ ΕΠΙΒΛΕΨΗΣ ΧΩΡΩΝ ΠΡΑΣΙΝΟΥ, ΠΕΖΟΔΡΟΜΙΩΝ, ΠΕΖΟΔΡΟΜΩΝ, ΠΕΡΙΦΡΑΞΕΩΝ ΚΑΙ ΧΩΡΩΝ ΣΤΑΘΜΕΥΣΗΣ',
  },
  {
    label: '71114200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΑΡΧΙΤΕΚΤΟΝΙΚΗΣ ΤΟΠΙΟΥ',
  },
  {
    label: '71120000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΣΥΝΑΦΕΙΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΑΡΟΧΗΣ ΤΕΧΝΙΚΩΝ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '71121000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΙΚΩΝ',
  },
  {
    label: '71121100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΜΗΧΑΝΙΚΟΥ',
  },
  {
    label: '71121101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΛΕΤΩΝ ΠΕΡΙΒΑΛΛΟΝΤΙΚΩΝ ΕΠΙΠΤΩΣΕΩΝ ΤΕΧΝΙΚΩΝ ΕΡΓΩΝ',
  },
  {
    label: '71121102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΛΕΤΩΝ ΣΚΟΠΙΜΟΤΗΤΑΣ ΤΕΧΝΙΚΩΝ ΕΡΓΩΝ',
  },
  {
    label: '71121103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΙΚΟΝΟΜΟΤΕΧΝΙΚΩΝ ΜΕΛΕΤΩΝ',
  },
  {
    label: '71121104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΕΠΙΣΤΗΜΟΝΙΚΩΝ ΤΕΧΝΙΚΩΝ ΣΥΜΒΟΥΛΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '71121105',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΑΓΜΑΤΟΓΝΩΜΟΣΥΝΩΝ ΓΙΑ ΑΚΙΝΗΤΑ ΚΑΙ ΤΕΧΝΙΚΑ ΕΡΓΑ',
  },
  {
    label: '71121200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΙΚΩΝ ΓΙΑ ΟΙΚΟΔΟΜΙΚΑ ΕΡΓΑ',
  },
  {
    label: '71121201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΣΤΑΤΙΚΩΝ ΜΕΛΕΤΩΝ ΜΕΓΑΛΩΝ Η ΕΙΔΙΚΩΝ ΤΕΧΝΙΚΩΝ ΕΡΓΩΝ',
  },
  {
    label: '71121202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΣΤΑΤΙΚΩΝ ΜΕΛΕΤΩΝ ΦΕΡΟΥΣΩΝ ΚΑΤΑΣΚΕΥΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '71121203',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΤΕΧΝΙΚΩΝ ΜΕΛΕΤΩΝ ΑΚΟΥΣΤΙΚΗΣ ΚΑΙ ΔΟΝΗΣΕΩΝ',
  },
  {
    label: '71121300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΙΚΩΝ ΓΙΑ ΕΝΕΡΓΕΙΑΚΑ ΕΡΓΑ',
  },
  {
    label: '71121301',
    value:
      'ΕΡΓΑΣΙΕΣ ΣΧΕΔΙΑΣΗΣ ΣΥΣΤΗΜΑΤΩΝ ΣΩΛΗΝΩΣΕΩΝ, ΩΣΤΕ ΝΑ ΜΠΟΡΟΥΝ ΝΑ ΛΕΙΤΟΥΡΓΟΥΝ ΥΠΟ ΠΙΕΣΗ',
  },
  {
    label: '71121302',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΕΝΕΡΓΕΙΑΚΩΝ ΜΕΛΕΤΩΝ (ΘΕΡΜΟΗΛΕΚΤΡΙΚΩΝ, ΥΔΡΟΗΛΕΚΤΡΙΚΩΝ, ΠΥΡΗΝΙΚΩΝ',
  },
  {
    label: '71121303',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΗΛΕΚΤΡΟΛΟΓΙΚΩΝ ΜΕΛΕΤΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '71121304',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΜΕΛΕΤΩΝ ΚΤΙΡΙΩΝ',
  },
  {
    label: '71121305',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΗΧΑΝΟΛΟΓΙΚΩΝ ΜΕΛΕΤΩΝ ΚΤΙΡΙΩΝ (ΘΕΡΜΑΝΣΗΣ, ΚΛΙΜΑΤΙΣΜΟΥ ΚΛΠ)',
  },
  {
    label: '71121306',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΤΕΧΝΙΚΩΝ ΜΕΛΕΤΩΝ ΓΙΑ ΣΥΣΤΗΜΑΤΑ ΠΥΡΟΣΒΕΣΗΣ',
  },
  {
    label: '71121307',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΩΝ ΤΕΧΝΟΛΟΓΟΥ ΗΛΕΚΤΡΟΛΟΓΟΥ ΜΗΧΑΝΙΚΟΥ',
  },
  {
    label: '71121400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΙΚΩΝ ΓΙΑ ΕΡΓΑ ΜΕΤΑΦΟΡΩΝ',
  },
  {
    label: '71121401',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΛΕΤΩΝ ΜΕΤΑΦΟΡΙΚΩΝ ΜΕΣΩΝ (ΧΕΡΣΑΙΩΝ, ΠΛΩΤΩΝ, ΕΝΑΕΡΙΩΝ)',
  },
  {
    label: '71121402',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΛΕΤΩΝ ΣΥΓΚΟΙΝΩΝΙΑΚΩΝ ΕΡΓΩΝ (ΟΔΩΝ, ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΓΡΑΜΜΩΝ, ΓΕΦΥΡΩΝ, ΜΙΚΡΩΝ ΤΕΧΝΙΚΩΝ ΕΡΓΩΝ, ΕΡΓΩΝ ΥΠΟΔΟΜΗΣ ΑΕΡΟΛΙΜΕΝΩΝ ΚΑΙ ΚΥΚΛΟΦΟΡΙΑΚΩΝ)',
  },
  {
    label: '71121403',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΤΕΧΝΙΚΩΝ ΜΕΛΕΤΩΝ ΣΥΣΤΗΜΑΤΩΝ ΕΛΕΓΧΟΥ ΤΗΣ ΚΥΚΛΟΦΟΡΙΑΣ',
  },
  {
    label: '71121500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΙΚΩΝ ΓΙΑ ΕΡΓΑ ΔΙΑΧΕΙΡΙΣΗΣ ΑΠΟΒΛΗΤΩΝ (ΕΠΙΚΙΝΔΥΝΩΝ ΚΑΙ ΜΗ ΕΠΙΚΙΝΔΥΝΩΝ)',
  },
  {
    label: '71121501',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΤΕΧΝΙΚΩΝ ΜΕΛΕΤΩΝ ΓΙΑ ΕΓΚΑΤΑΣΤΑΣΕΙΣ ΣΤΕΡΕΩΝ ΚΑΙ ΥΓΡΩΝ ΑΠΟΒΛΗΤΩΝ',
  },
  {
    label: '71121600',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΙΚΩΝ ΓΙΑ ΕΡΓΑ ΥΔΡΕΥΣΗΣ ΚΑΙ ΕΠΕΞΕΡΓΑΣΙΑΣ ΛΥΜΑΤΩΝ ΚΑΙ ΓΙΑ ΑΠΟΣΤΡΑΓΓΙΣΤΙΚΑ ΕΡΓΑ',
  },
  {
    label: '71121601',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΛΕΤΩΝ ΥΔΡΑΥΛΙΚΩΝ ΕΡΓΩΝ (ΕΓΓΕΙΟΒΕΛΤΙΩΤΙΚΩΝ ΕΡΓΩΝ, ΑΝΤΙΠΛΗΜΜΥΡΙΚΩΝ ΕΡΓΩΝ, ΦΡΑΓΜΑΤΩΝ, ΥΔΡΕΥΣΕΩΝ ΚΑΙ ΑΠΟΧΕΤΕΥΣΕΩΝ)',
  },
  {
    label: '71121700',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΙΚΩΝ ΓΙΑ ΒΙΟΜΗΧΑΝΙΚΑ ΚΑΙ ΒΙΟΤΕΧΝΙΚΑ ΕΡΓΑ',
  },
  {
    label: '71121701',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΛΕΤΗΣ ΤΕΧΝΙΚΟΥ ΠΡΟΓΡΑΜΜΑΤΙΣΜΟΥ ~ ΣΧΕΔΙΑΣΜΟΥ ΚΑΙ ΛΕΙΤΟΥΡΓΙΑΣ ΒΙΟΜΗΧΑΝΙΩΝ',
  },
  {
    label: '71121800',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΙΚΩΝ ΓΙΑ ΕΡΓΑ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ ΚΑΙ ΕΚΠΟΜΠΗΣ',
  },
  {
    label: '71121900',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΙΚΩΝ ΓΙΑ ΑΛΛΑ ΕΡΓΑ',
  },
  {
    label: '71121901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΓΕΩΤΕΧΝΙΚΩΝ ΜΕΛΕΤΩΝ',
  },
  {
    label: '71121902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΛΕΤΩΝ ΕΚΤΙΜΗΣΗΣ ΥΔΑΤΙΝΩΝ ΠΟΡΩΝ',
  },
  {
    label: '71121903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΛΕΤΩΝ ΚΑΙ ΕΠΙΒΛΕΨΗΣ ΤΟΠΟΓΡΑΦΙΚΩΝ ΕΡΓΩΝ',
  },
  {
    label: '71121904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΛΕΤΩΝ ΛΙΜΕΝΙΚΩΝ ΕΡΓΩΝ',
  },
  {
    label: '71121905',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΤΕΧΝΙΚΩΝ ΜΕΛΕΤΩΝ ΑΝΙΧΝΕΥΣΗΣ ΚΑΙ ΕΛΕΓΧΟΥ ΤΗΣ ΔΙΑΒΡΩΣΗΣ',
  },
  {
    label: '71121906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΤΕΧΝΙΚΩΝ ΜΕΛΕΤΩΝ ΓΙΑ ΝΕΑ ΠΡΟΪΟΝΤΑ',
  },
  {
    label: '71121907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΤΕΧΝΙΚΩΝ ΜΕΛΕΤΩΝ ΣΧΕΤΙΚΩΝ ΜΕ ΤΗ ΜΟΛΥΝΣΗ',
  },
  {
    label: '71121908',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΛΕΤΩΝ ΗΛΕΚΤΡΟΛΟΓΟΥ ΜΗΧΑΝΙΚΟΥ ΓΕΝΙΚΑ',
  },
  {
    label: '71121909',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΛΕΤΩΝ ΜΗΧΑΝΟΛΟΓΟΥ ΜΗΧΑΝΙΚΟΥ ΓΕΝΙΚΑ',
  },
  {
    label: '71121910',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΛΕΤΩΝ ΧΗΜΙΚΟΥ ΜΗΧΑΝΙΚΟΥ ΓΕΝΙΚΑ',
  },
  {
    label: '71121911',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΟΥ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '71121912',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΛΕΤΩΝ ΚΑΙ ΕΠΙΒΛΕΨΕΩΝ ΝΑΥΠΗΓΟΥ ΜΗΧΑΝΙΚΟΥ',
  },
  {
    label: '71122000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΕΡΓΩΝ ΓΙΑ ΚΑΤΑΣΚΕΥΑΣΤΙΚΑ ΕΡΓΑ',
  },
  {
    label: '71123000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΕΩΛΟΓΙΚΩΝ, ΓΕΩΦΥΣΙΚΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΕΠΙΣΤΗΜΟΝΙΚΩΝ ΕΡΕΥΝΩΝ ΚΑΙ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '71123100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΓΕΩΛΟΓΙΚΩΝ ΚΑΙ ΓΕΩΦΥΣΙΚΩΝ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '71123101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΕΔΑΦΟΛΟΓΙΚΩΝ ΜΕΛΕΤΩΝ',
  },
  {
    label: '71123102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΜΕΤΑΛΛΕΥΤΙΚΩΝ ΜΕΛΕΤΩΝ ΚΑΙ ΕΡΕΥΝΩΝ',
  },
  {
    label: '71123103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΥΔΡΟΓΕΩΛΟΓΙΚΩΝ ΜΕΛΕΤΩΝ',
  },
  {
    label: '71123104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΩΚΕΑΝΟΓΡΑΦΙΚΩΝ ΜΕΛΕΤΩΝ',
  },
  {
    label: '71123200',
    value: 'ΓΕΩΦΥΣΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '71123300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΟΡΥΞΗΣ ΚΑΙ ΑΞΙΟΛΟΓΗΣΗΣ ΟΡΥΚΤΩΝ',
  },
  {
    label: '71123301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΠΟΓΕΙΑΣ ΤΟΠΟΓΡΑΦΙΚΗΣ ΑΠΟΤΥΠΩΣΗΣ',
  },
  {
    label: '71123400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΦΑΝΕΙΑΚΗΣ ΤΟΠΟΓΡΑΦΙΚΗΣ ΑΠΟΤΥΠΩΣΗΣ',
  },
  {
    label: '71123401',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΓΚΕΝΤΡΩΣΗΣ ΤΟΠΟΓΡΑΦΙΚΩΝ ΔΕΔΟΜΕΝΩΝ ΜΕ ΔΟΡΥΦΟΡΟ',
  },
  {
    label: '71123500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΑΡΤΟΓΡΑΦΗΣΗΣ',
  },
  {
    label: '71123501',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΠΕΔΟΜΕΤΡΙΚΗΣ ΧΑΡΤΟΓΡΑΦΗΣΗΣ',
  },
  {
    label: '71123502',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΤΗΜΑΤΟΛΟΓΙΚΗΣ ΧΑΡΤΟΓΡΑΦΗΣΗΣ',
  },
  {
    label: '71123503',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΙΚΗΣ ΧΑΡΤΟΓΡΑΦΗΣΗΣ',
  },
  {
    label: '71123504',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΔΡΟΓΡΑΦΙΚΗΣ ΧΑΡΤΟΓΡΑΦΗΣΗΣ',
  },
  {
    label: '71200000',
    value: 'ΤΕΧΝΙΚΕΣ ΔΟΚΙΜΕΣ ΚΑΙ ΑΝΑΛΥΣΕΙΣ',
  },
  {
    label: '71201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΩΝ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ',
  },
  {
    label: '71201100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ ΤΗΣ ΣΥΝΘΕΣΗΣ ΚΑΙ ΤΗΣ ΚΑΘΑΡΟΤΗΤΑΣ',
  },
  {
    label: '71201101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ ΒΑΚΤΗΡΙΟΛΟΓΙΑΣ, ΕΚΤΟΣ ΙΑΤΡΙΚΩΝ',
  },
  {
    label: '71201102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ ΒΙΟΛΟΓΙΚΩΝ ΙΔΙΟΤΗΤΩΝ ΤΩΝ ΥΛΙΚΩΝ',
  },
  {
    label: '71201103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ ΜΙΚΡΟΒΙΟΛΟΓΙΑΣ, ΕΚΤΟΣ ΙΑΤΡΙΚΩΝ',
  },
  {
    label: '71201104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ ΧΗΜΕΙΑΣ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '71201105',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΟΙΝΟΛΟΓΙΚΩΝ ΜΕΛΕΤΩΝ',
  },
  {
    label: '71201106',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΟΝΗΣΗΣ ΧΗΜΙΚΟΤΕΧΝΙΚΩΝ ΜΕΛΕΤΩΝ',
  },
  {
    label: '71201107',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΤΗΡΗΣΕΩΝ ΥΔΡΟΛΟΓΙΚΩΝ ΣΤΑΘΜΩΝ',
  },
  {
    label: '71201108',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΗΜΙΚΩΝ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ',
  },
  {
    label: '71201200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ ΤΩΝ ΦΥΣΙΚΩΝ ΙΔΙΟΤΗΤΩΝ',
  },
  {
    label: '71201300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ ΟΛΟΚΛΗΡΩΜΕΝΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΤΗΜΑΤΩΝ',
  },
  {
    label: '71201301',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΧΑΡΑΚΤΗΡΙΣΤΙΚΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '71201302',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΧΑΡΑΚΤΗΡΙΣΤΙΚΩΝ ΚΙΝΗΤΗΡΩΝ',
  },
  {
    label: '71201303',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΧΑΡΑΚΤΗΡΙΣΤΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '71201304',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ ΜΗΧΑΝΙΚΩΝ ΚΑΙ ΗΛΕΚΤΡΙΚΩΝ ΧΑΡΑΚΤΗΡΙΣΤΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '71201400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΟΥ ΕΛΕΓΧΟΥ ΟΧΗΜΑΤΩΝ ΟΔΙΚΩΝ ΜΕΤΑΦΟΡΩΝ',
  },
  {
    label: '71201900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΩΝ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ',
  },
  {
    label: '71201901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΛΕΓΧΟΥ ΣΥΓΚΟΛΛΗΣΕΩΝ',
  },
  {
    label: '71201902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΙΣΤΟΠΟΙΗΣΗΣ ΚΑΙ ΒΕΒΑΙΩΣΗΣ ΤΗΣ ΓΝΗΣΙΟΤΗΤΑΣ ΕΡΓΩΝ ΤΕΧΝΗΣ',
  },
  {
    label: '71201903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΙΣΤΟΠΟΙΗΣΗΣ ΠΛΟΙΩΝ, ΑΕΡΟΣΚΑΦΩΝ, ΦΡΑΓΜΑΤΩΝ ΚΛΠ',
  },
  {
    label: '71201904',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΗΜΙΚΩΝ ΤΕΧΝΙΚΩΝ ΔΟΚΙΜΩΝ ΚΑΙ ΑΝΑΛΥΣΕΩΝ ΣΕ ΒΙΟΜΗΧΑΝΙΚΕΣ ΔΙΑΔΙΚΑΣΙΕΣ',
  },
  {
    label: '71201905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΘΕΩΡΗΣΗΣ ΚΑΙ ΑΛΛΩΝ ΔΟΚΙΜΩΝ ΠΛΟΙΩΝ',
  },
  {
    label: '72110000',
    value: 'ΕΡΕΥΝΑ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗ ΑΝΑΠΤΥΞΗ ΣΤΗ ΒΙΟΤΕΧΝΟΛΟΓΙΑ',
  },
  {
    label: '72111000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΗ ΒΙΟΤΕΧΝΟΛΟΓΙΑ ΓΙΑ ΤΗΝ ΥΓΕΙΑ, ΤΟ ΠΕΡΙΒΑΛΛΟΝ, ΤΗ ΓΕΩΡΓΙΑ ΚΑΙ ΑΛΛΕΣ ΕΦΑΡΜΟΓΕΣ',
  },
  {
    label: '72111100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΗ ΒΙΟΤΕΧΝΟΛΟΓΙΑ ΤΗΣ ΥΓΕΙΑΣ',
  },
  {
    label: '72111200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΗΝ ΠΕΡΙΒΑΛΛΟΝΤΙΚΗ ΚΑΙ ΒΙΟΜΗΧΑΝΙΚΗ ΒΙΟΤΕΧΝΟΛΟΓΙΑ',
  },
  {
    label: '72111300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΗ ΓΕΩΡΓΙΚΗ ΒΙΟΤΕΧΝΟΛΟΓΙΑ',
  },
  {
    label: '72112000',
    value: 'ΕΡΕΥΝΑ ΚΑΙ ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΑΝΑΠΤΥΞΗΣ ΣΤΗ ΒΙΟΤΕΧΝΟΛΟΓΙΑ',
  },
  {
    label: '72190000',
    value:
      'ΕΡΕΥΝΑ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗ ΑΝΑΠΤΥΞΗ ΣΕ ΑΛΛΕΣ ΦΥΣΙΚΕΣ ΕΠΙΣΤΗΜΕΣ ΚΑΙ ΤΗ ΜΗΧΑΝΙΚΗ',
  },
  {
    label: '72191000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΕ ΑΛΛΕΣ ΦΥΣΙΚΕΣ ΕΠΙΣΤΗΜΕΣ',
  },
  {
    label: '72191100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΑ ΜΑΘΗΜΑΤΙΚΑ',
  },
  {
    label: '72191200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΙΣ ΕΠΙΣΤΗΜΕΣ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΛΗΡΟΦΟΡΙΩΝ',
  },
  {
    label: '72191300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΙΣ ΦΥΣΙΚΕΣ ΕΠΙΣΤΗΜΕΣ',
  },
  {
    label: '72191301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΤΗΡΗΣΕΩΝ ΑΣΤΕΡΟΣΚΟΠΕΙΟΥ',
  },
  {
    label: '72191400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΗ ΧΗΜΕΙΑ',
  },
  {
    label: '72191401',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΝΑΛΥΣΗΣ, ΣΧΕΔΙΑΣΜΟΥ ΚΑΙ ΑΝΑΠΤΥΞΗΣ ΧΗΜΙΚΩΝ ΔΙΕΡΓΑΣΙΩΝ ΚΑΙ ΣΥΣΤΗΜΑΤΩΝ',
  },
  {
    label: '72191402',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗ ΧΗΜΕΙΑ',
  },
  {
    label: '72191403',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗ ΧΗΜΕΙΑ ΤΡΟΦΙΜΩΝ',
  },
  {
    label: '72191500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΙΣ ΓΕΩΕΠΙΣΤΗΜΕΣ ΚΑΙ ΣΤΙΣ ΕΠΙΣΤΗΜΕΣ ΠΕΡΙΒΑΛΛΟΝΤΟΣ',
  },
  {
    label: '72191501',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΕΡΙΒΑΛΛΟΝΤΙΚΗΣ ΕΡΕΥΝΑΣ',
  },
  {
    label: '72191600',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΙΣ ΒΙΟΛΟΓΙΚΕΣ ΕΠΙΣΤΗΜΕΣ',
  },
  {
    label: '72191601',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗ ΒΙΟΛΟΓΙΑ',
  },
  {
    label: '72191900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΕ ΑΛΛΕΣ ΘΕΤΙΚΕΣ ΕΠΙΣΤΗΜΕΣ',
  },
  {
    label: '72191901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΔΙΕΠΙΣΤΗΜΟΝΙΚΟΥ ΧΑΡΑΚΤΗΡΑ (ΓΕΩΓΡΑΦΙΑ, ΠΑΙΔΑΓΩΓΙΚΕΣ ΣΠΟΥΔΕΣ, ΚΛΠ)',
  },
  {
    label: '72191902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗ ΜΕΤΑΛΛΕΙΟΛΟΓΙΑ',
  },
  {
    label: '72191903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗΝ ΩΚΕΑΝΟΓΡΑΦΙΑ',
  },
  {
    label: '72192000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΗ ΜΗΧΑΝΙΚΗ ΚΑΙ ΤΗΝ ΤΕΧΝΟΛΟΓΙΑ, ΕΚΤΟΣ ΤΗΣ ΒΙΟΤΕΧΝΟΛΟΓΙΑΣ',
  },
  {
    label: '72192100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΗ ΝΑΝΟΤΕΧΝΟΛΟΓΙΑ',
  },
  {
    label: '72192900',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΗ ΜΗΧΑΝΙΚΗ ΚΑΙ ΤΗΝ ΤΕΧΝΟΛΟΓΙΑ, ΕΚΤΟΣ ΤΗΣ ΒΙΟΤΕΧΝΟΛΟΓΙΑΣ',
  },
  {
    label: '72192901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΑΝΑΠΤΥΞΗΣ ΠΡΟΪΟΝΤΩΝ ΔΙΑΔΡΑΣΤΙΚΩΝ ΠΟΛΥΜΕΣΩΝ (INTERACTIVE MULTIMEDIA)',
  },
  {
    label: '72192902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗ ΜΗΧΑΝΟΛΟΓΙΑ',
  },
  {
    label: '72192903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗΝ ΝΑΥΠΗΓΙΚΗ ΚΑΙ ΑΕΡΟΝΑΥΠΗΓΙΚΗ',
  },
  {
    label: '72192904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗΝ ΠΛΗΡΟΦΟΡΙΚΗ',
  },
  {
    label: '72192905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗΝ ΤΕΧΝΟΛΟΓΙΑ ΜΕΤΑΛΛΩΝ',
  },
  {
    label: '72192906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗΝ ΤΕΧΝΟΛΟΓΙΑ ΤΟΥ ΗΛΕΚΤΡΙΣΜΟΥ',
  },
  {
    label: '72192907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗΝ ΤΕΧΝΟΛΟΓΙΑ ΤΩΝ ΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '72192908',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗΝ ΤΕΧΝΟΛΟΓΙΑ ΥΛΙΚΩΝ',
  },
  {
    label: '72192909',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΙΣ ΕΠΙΚΟΙΝΩΝΙΕΣ',
  },
  {
    label: '72193000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΙΣ ΙΑΤΡΙΚΕΣ ΕΠΙΣΤΗΜΕΣ',
  },
  {
    label: '72194000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΙΣ ΓΕΩΠΟΝΙΚΕΣ ΕΠΙΣΤΗΜΕΣ',
  },
  {
    label: '72194001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗΝ ΚΤΗΝΟΤΡΟΦΙΑ',
  },
  {
    label: '72194002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗ ΔΑΣΟΚΟΜΙΑ',
  },
  {
    label: '72194003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗΝ ΑΛΙΕΙΑ',
  },
  {
    label: '72195000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΕΡΕΥΝΑΣ ΚΑΙ ΑΝΑΠΤΥΞΗΣ ΣΤΙΣ ΘΕΤΙΚΕΣ ΕΠΙΣΤΗΜΕΣ ΚΑΙ ΤΗ ΜΗΧΑΝΙΚΗ, ΕΚΤΟΣ ΤΗΣ ΒΙΟΤΕΧΝΟΛΟΓΙΑΣ',
  },
  {
    label: '72200000',
    value:
      'ΕΡΕΥΝΑ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗ ΑΝΑΠΤΥΞΗ ΣΤΙΣ ΚΟΙΝΩΝΙΚΕΣ ΚΑΙ ΑΝΘΡΩΠΙΣΤΙΚΕΣ ΕΠΙΣΤΗΜΕΣ',
  },
  {
    label: '72201000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΙΣ ΚΟΙΝΩΝΙΚΕΣ ΕΠΙΣΤΗΜΕΣ',
  },
  {
    label: '72201100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΑ ΟΙΚΟΝΟΜΙΚΑ ΚΑΙ ΤΙΣ ΕΠΙΧΕΙΡΗΣΕΙΣ',
  },
  {
    label: '72201101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΙΚΟΝΟΜΙΚΩΝ ΕΡΕΥΝΩΝ',
  },
  {
    label: '72201200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΗ ΨΥΧΟΛΟΓΙΑ',
  },
  {
    label: '72201201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗΝ ΨΥΧΟΛΟΓΙΑ',
  },
  {
    label: '72201300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΗ ΝΟΜΙΚΗ ΕΠΙΣΤΗΜΗ',
  },
  {
    label: '72201900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΕ ΑΛΛΕΣ ΚΟΙΝΩΝΙΚΕΣ ΕΠΙΣΤΗΜΕΣ',
  },
  {
    label: '72202000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΙΣ ΑΝΘΡΩΠΙΣΤΙΚΕΣ ΕΠΙΣΤΗΜΕΣ',
  },
  {
    label: '72202100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΟΥΣ ΤΟΜΕΙΣ ΤΗΣ ΓΛΩΣΣΟΛΟΓΙΑΣ ΚΑΙ ΤΗΣ ΛΟΓΟΤΕΧΝΙΑΣ',
  },
  {
    label: '72202900',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΚΑΙ ΠΕΙΡΑΜΑΤΙΚΗΣ ΑΝΑΠΤΥΞΗΣ ΣΤΙΣ ΑΝΘΡΩΠΙΣΤΙΚΕΣ ΕΠΙΣΤΗΜΕΣ',
  },
  {
    label: '72202901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΣΤΗΝ ΚΟΙΝΩΝΙΟΛΟΓΙΑ',
  },
  {
    label: '72202902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΙΣΤΟΡΙΚΩΝ ΕΡΕΥΝΩΝ',
  },
  {
    label: '72202903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΩΝ ΕΡΕΥΝΩΝ',
  },
  {
    label: '72202904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΙΛΟΛΟΓΙΚΩΝ ΚΑΙ ΦΙΛΟΣΟΦΙΚΩΝ ΕΡΕΥΝΩΝ',
  },
  {
    label: '72203000',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΕΡΕΥΝΑΣ ΚΑΙ ΑΝΑΠΤΥΞΗΣ ΣΤΙΣ ΚΟΙΝΩΝΙΚΕΣ ΚΑΙ ΑΝΘΡΩΠΙΣΤΙΚΕΣ ΕΠΙΣΤΗΜΕΣ',
  },
  {
    label: '73110000',
    value: 'ΔΙΑΦΗΜΙΣΤΙΚΑ ΓΡΑΦΕΙΑ',
  },
  {
    label: '73111000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΔΙΑΦΗΜΙΣΤΙΚΑ ΓΡΑΦΕΙΑ',
  },
  {
    label: '73111100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΛΗΡΟΥΣ ΔΙΑΦΗΜΙΣΗΣ',
  },
  {
    label: '73111101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΙΣΤΑ ΔΙΑΦΗΜΙΣΕΩΝ',
  },
  {
    label: '73111102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΔΙΑΦΗΜΙΣΤΙΚΩΝ ΠΙΝΑΚΩΝ ΓΕΝΙΚΑ (ΠΑΝΟ) ΚΑΙ ΕΠΙΓΡΑΦΩΝ',
  },
  {
    label: '73111103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΧΩΡΙΣΗΣ ΑΓΓΕΛΙΩΝ ΚΑΙ ΔΙΑΦΗΜΙΣΕΩΝ ΣΕ ΕΦΗΜΕΡΙΔΕΣ ΚΑΙ ΠΕΡΙΟΔΙΚΑ',
  },
  {
    label: '73111104',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ (ΟΧΙ ΠΑΡΑΓΩΓΗΣ) ΔΙΑΦΗΜΙΣΤΙΚΩΝ ΑΝΤΙΚΕΙΜΕΝΩΝ Η ΤΑΙΝΙΩΝ',
  },
  {
    label: '73111105',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΔΙΑΦΗΜΙΣΤΙΚΩΝ ΑΦΙΣΩΝ',
  },
  {
    label: '73111200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΕΡΓΗΤΙΚΟΥ ΜΑΡΚΕΤΙΝΓΚ ΚΑΙ ΑΠΟΣΤΟΛΗΣ ΑΤΟΜΙΚΩΝ ΕΠΙΣΤΟΛΩΝ',
  },
  {
    label: '73111300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΣΧΕΔΙΑΣΜΟΥ ΚΑΙ ΕΝΝΟΙΟΛΟΓΙΚΗΣ ΑΝΑΠΤΥΞΗΣ',
  },
  {
    label: '73111900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΦΗΜΙΣΗΣ',
  },
  {
    label: '73111901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΦΙΣΟΚΟΛΛΗΣΕΩΝ',
  },
  {
    label: '73111902',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΤΑΡΑΤΣΩΝ ΚΑΙ ΤΟΙΧΩΝ ΚΤΙΣΜΑΤΩΝ Η ΠΕΡΙΦΡΑΞΕΩΝ ΓΙΑ ΑΝΑΡΤΗΣΗ ΔΙΑΦΗΜΙΣΤΙΚΩΝ ΠΙΝΑΚΙΔΩΝ',
  },
  {
    label: '73111903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΥΛΙΚΟΥ (ΦΕΙΓ ΒΟΛΑΝ ΚΛΠ)',
  },
  {
    label: '73111904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΝΟΜΗΣ ΔΙΑΦΗΜΙΣΤΙΚΩΝ ΔΕΙΓΜΑΤΩΝ',
  },
  {
    label: '73111905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΦΗΜΙΣΤΙΚΗΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΠΛΩΤΩΝ ΕΞΕΔΡΩΝ',
  },
  {
    label: '73111906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΒΟΛΗΣ ΑΦΙΣΩΝ ΑΠΟ ΕΝΑΕΡΙΑ ΜΕΣΑ',
  },
  {
    label: '73111907',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΡΟΩΘΗΣΗΣ ΠΡΟΪΟΝΤΩΝ ΜΕΣΑ ΣΕ ΚΑΤΑΣΤΗΜΑΤΑ (ΜΕ ΔΙΑΝΟΜΗ ΔΩΡΩΝ Η ΟΧΙ)',
  },
  {
    label: '73120000',
    value: 'ΠΑΡΟΥΣΙΑΣΗ ΣΤΑ ΜΕΣΑ ΕΝΗΜΕΡΩΣΗΣ',
  },
  {
    label: '73121000',
    value: 'ΠΩΛΗΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ Η ΧΡΟΝΟΥ ΜΕ ΑΜΟΙΒΗ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '73121100',
    value:
      'ΠΩΛΗΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ ΣΤΑ ΕΝΤΥΠΑ ΜΕΣΑ, ΜΕ ΑΜΟΙΒΗ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '73121101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΧΩΡΟΥ ΕΦΗΜΕΡΙΔΑΣ ΓΙΑ ΚΑΤΑΧΩΡΙΣΗ ΔΙΑΦΗΜΙΣΕΩΝ',
  },
  {
    label: '73121200',
    value:
      'ΠΩΛΗΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ Η ΧΡΟΝΟΥ ΣΤΗΝ ΤΗΛΕΟΡΑΣΗ ΚΑΙ ΤΟ ΡΑΔΙΟΦΩΝΟ ΜΕ ΑΜΟΙΒΗ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '73121201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΧΡΟΝΟΥ ΣΤΑ ΗΛΕΚΤΡΟΝΙΚΑ ΜΕΣΑ ΕΝΗΜΕΡΩΣΗΣ ΓΙΑ ΠΑΡΟΥΣΙΑΣΗ ΔΙΑΦΗΜΙΣΕΩΝ',
  },
  {
    label: '73121300',
    value:
      'ΠΩΛΗΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ Η ΧΡΟΝΟΥ ΣΤΟ ΔΙΑΔΙΚΤΥΟ ΜΕ ΑΜΟΙΒΗ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '73121400',
    value: 'ΠΩΛΗΣΗ ΔΙΑΦΗΜΙΣΗΣ ΣΧΕΤΙΚΑ ΜΕ ΕΚΔΗΛΩΣΕΙΣ',
  },
  {
    label: '73121900',
    value:
      'ΑΛΛΕΣ ΠΩΛΗΣΕΙΣ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ Η ΧΡΟΝΟΥ ΜΕ ΑΜΟΙΒΗ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '73121901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΧΩΡΟΥ ΚΑΤΑΣΤΗΜΑΤΟΣ ΓΙΑ ΠΡΟΒΟΛΗ ΑΓΑΘΩΝ',
  },
  {
    label: '73122000',
    value: 'ΜΕΤΑΠΩΛΗΣΗ ΔΙΑΦΗΜΙΣΤΙΚΟΥ ΧΩΡΟΥ Η ΧΡΟΝΟΥ ΜΕ ΑΜΟΙΒΗ Η ΒΑΣΕΙ ΣΥΜΒΑΣΗΣ',
  },
  {
    label: '73200000',
    value: 'ΕΡΕΥΝΑ ΑΓΟΡΑΣ ΚΑΙ ΔΗΜΟΣΚΟΠΗΣΕΙΣ',
  },
  {
    label: '73201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΑΓΟΡΑΣ ΚΑΙ ΠΑΡΟΜΟΙΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '73201100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΑΓΟΡΑΣ: ΠΟΙΟΤΙΚΕΣ ΕΡΕΥΝΕΣ',
  },
  {
    label: '73201200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΑΓΟΡΑΣ: ΣΤΑΤΙΣΤΙΚΕΣ AD HOC ΕΡΕΥΝΕΣ',
  },
  {
    label: '73201300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΑΓΟΡΑΣ: ΠΕΡΙΟΔΙΚΕΣ ΚΑΙ ΤΑΚΤΙΚΕΣ ΣΤΑΤΙΣΤΙΚΕΣ ΕΡΕΥΝΕΣ',
  },
  {
    label: '73201400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΑΓΟΡΑΣ ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΣΤΑΤΙΣΤΙΚΕΣ ΕΡΕΥΝΕΣ',
  },
  {
    label: '73201900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΑΣ ΑΓΟΡΑΣ',
  },
  {
    label: '73201901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΕΥΡΕΣΗΣ ΠΕΛΑΤΩΝ',
  },
  {
    label: '73201902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΕΥΝΗΤΗ ΕΠΙΧΕΙΡΗΣΕΩΝ',
  },
  {
    label: '73201903',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΟΙΚΟΝΟΜΙΚΩΝ ΚΑΙ ΕΜΠΟΡΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ ΣΕ ΘΕΜΑΤΑ ΣΥΜΠΕΡΙΦΟΡΑΣ ΚΑΤΑΝΑΛΩΤΩΝ',
  },
  {
    label: '73201904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΜΗΘΕΙΑΣ ΕΠΙ ΔΑΝΕΙΩΝ ΑΝΕΥΡΕΘΕΝΤΩΝ ΔΑΝΕΙΟΛΗΠΤΩΝ',
  },
  {
    label: '73202000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΗΜΟΣΚΟΠΗΣΕΩΝ',
  },
  {
    label: '74100000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΕΙΔΙΚΕΥΜΕΝΟΥ ΣΧΕΔΙΟΥ',
  },
  {
    label: '74101000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΕΣΩΤΕΡΙΚΩΝ ΧΩΡΩΝ, ΒΙΟΜΗΧΑΝΙΚΗΣ ΣΧΕΔΙΑΣΗΣ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΞΕΙΔΙΚΕΥΜΕΝΟΥ ΣΧΕΔΙΑΣΜΟΥ',
  },
  {
    label: '74101100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΕΣΩΤΕΡΙΚΩΝ ΧΩΡΩΝ',
  },
  {
    label: '74101101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΝΤΕΚΟΡΑΤΕΡ',
  },
  {
    label: '74101200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΙΟΜΗΧΑΝΙΚΟΥ ΣΧΕΔΙΑΣΜΟΥ',
  },
  {
    label: '74101900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΞΕΙΔΙΚΕΥΜΕΝΟΥ ΣΧΕΔΙΑΣΜΟΥ',
  },
  {
    label: '74101901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΙΣΘΗΤΙΚΟΥ ΣΧΕΔΙΑΣΜΟΥ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '74101902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΕΠΙΠΛΩΝ',
  },
  {
    label: '74101903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΣΥΣΚΕΥΑΣΙΩΝ',
  },
  {
    label: '74101904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '74101905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΤΗ ΚΟΣΜΗΜΑΤΩΝ ΚΑΙ ΥΠΗΡΕΣΙΕΣ ΓΕΜΜΟΛΟΓΙΑΣ',
  },
  {
    label: '74101906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΤΗ ΜΟΔΑΣ (ΜΟΝΤΕΛΙΣΤ)',
  },
  {
    label: '74102000',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΣΧΕΔΙΩΝ',
  },
  {
    label: '74200000',
    value: 'ΦΩΤΟΓΡΑΦΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '74201000',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΩΤΟΓΡΑΦΙΚΩΝ ΠΛΑΚΩΝ ΚΑΙ ΦΙΛΜ, ΕΚΤΟΣ ΤΩΝ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ, ΠΟΥ ΕΧΟΥΝ ΕΚΤΕΘΕΙ ΣΤΟ ΦΩΣ',
  },
  {
    label: '74201100',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΩΤΟΓΡΑΦΙΚΩΝ ΠΛΑΚΩΝ ΚΑΙ ΦΙΛΜ, ΠΟΥ ΕΧΟΥΝ ΕΚΤΕΘΕΙ ΣΤΟ ΦΩΣ ΑΛΛΑ ΔΕΝ ΕΧΟΥΝ',
  },
  {
    label: '74201200',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΩΤΟΓΡΑΦΙΚΩΝ ΠΛΑΚΩΝ ΚΑΙ ΦΙΛΜ, ΠΟΥ ΕΧΟΥΝ ΕΚΤΕΘΕΙ ΣΤΟ ΦΩΣ ΚΑΙ ΕΧΟΥΝ ΕΜΦΑΝΙΣΤΕΙ, ΓΙΑ ΑΝΑΠΑΡΑΓΩΓΗ OFFSET',
  },
  {
    label: '74201900',
    value:
      'ΠΑΡΑΓΩΓΗ ΑΛΛΩΝ ΦΩΤΟΓΡΑΦΙΚΩΝ ΠΛΑΚΩΝ ΚΑΙ ΦΙΛΜ ΠΟΥ ΕΧΟΥΝ ΕΚΤΕΘΕΙ ΣΤΟ ΦΩΣ ΚΑΙ ΕΧΟΥΝ',
  },
  {
    label: '74202000',
    value: 'ΕΞΕΙΔΙΚΕΥΜΕΝΕΣ ΦΩΤΟΓΡΑΦΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '74202100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΩΤΟΓΡΑΦΙΚΩΝ ΠΟΡΤΡΑΙΤΩΝ',
  },
  {
    label: '74202101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΩΤΟΓΡΑΦΙΣΗΣ ΠΟΡΤΡΑΙΤΩΝ ΕΝΤΟΣ ΚΑΙ ΕΚΤΟΣ STUDIO',
  },
  {
    label: '74202102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΦΩΤΟΓΡΑΦΙΣΗΣ ΠΟΡΤΡΑΙΤΩΝ ΜΕ ΕΚΤΥΠΩΣΗ ΑΣΠΡΟΜΑΥΡΩΝ Η/ΚΑΙ ΕΓΧΡΩΜΩΝ ΦΩΤΟΓΡΑΦΙΩΝ, ΣΕ ΕΡΓΑΣΤΗΡΙΑ ΤΡΙΤΩΝ',
  },
  {
    label: '74202200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΦΗΜΙΣΤΙΚΩΝ ΦΩΤΟΓΡΑΦΙΣΕΩΝ ΚΑΙ ΣΧΕΤΙΚΕΣ ΦΩΤΟΓΡΑΦΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '74202300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΩΤΟΓΡΑΦΙΣΗΣ ΚΑΙ ΒΙΝΤΕΟΣΚΟΠΗΣΗΣ ΕΚΔΗΛΩΣΕΩΝ',
  },
  {
    label: '74202301',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΦΩΤΟΓΡΑΦΙΣΗΣ ΚΑΙ ΒΙΝΤΕΟΣΚΟΠΗΣΗΣ ΕΚΔΗΛΩΣΕΩΝ ΕΝΤΟΣ ΚΑΙ ΕΚΤΟΣ STUDIO',
  },
  {
    label: '74202400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΕΡΟΦΩΤΟΓΡΑΦΙΩΝ',
  },
  {
    label: '74202900',
    value: 'ΑΛΛΕΣ ΕΞΕΙΔΙΚΕΥΜΕΝΕΣ ΦΩΤΟΓΡΑΦΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '74202901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΙΑΤΡΙΚΗΣ ΚΑΙ ΒΙΟΛΟΓΙΚΗΣ ΦΩΤΟΓΡΑΦΙΣΗΣ',
  },
  {
    label: '74202902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΙΚΡΟΦΩΤΟΓΡΑΦΙΣΗΣ',
  },
  {
    label: '74202903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΠΟΒΡΥΧΙΑΣ ΦΩΤΟΓΡΑΦΙΣΗΣ',
  },
  {
    label: '74203000',
    value: 'ΑΛΛΕΣ ΦΩΤΟΓΡΑΦΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '74203100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΦΩΤΟΓΡΑΦΙΩΝ',
  },
  {
    label: '74203101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΙΓΡΑΦΗΣ ΦΙΛΜ ΚΑΙ ΟΠΤΙΚΟΑΚΟΥΣΤΙΚΩΝ ΜΕΣΩΝ',
  },
  {
    label: '74203102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΡΗΓΟΡΗΣ ΕΜΦΑΝΙΣΗΣ ΦΙΛΜ ΚΑΙ ΕΚΤΥΠΩΣΗΣ ΦΩΤΟΓΡΑΦΙΩΝ',
  },
  {
    label: '74203103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΜΦΑΝΙΣΗΣ ΦΙΛΜ ΚΑΙ ΕΚΤΥΠΩΣΗΣ ΦΩΤΟΓΡΑΦΙΩΝ',
  },
  {
    label: '74203200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΚΑΤΑΣΤΑΣΗΣ ΚΑΙ ΡΕΤΟΥΣΑΡΙΣΜΑΤΟΣ ΦΩΤΟΓΡΑΦΙΩΝ',
  },
  {
    label: '74203900',
    value: 'ΑΛΛΕΣ ΦΩΤΟΓΡΑΦΙΚΕΣ ΥΠΗΡΕΣΙΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '74300000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΜΕΤΑΦΡΑΣΗΣ ΚΑΙ ΔΙΕΡΜΗΝΕΙΑΣ',
  },
  {
    label: '74301000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΡΑΣΗΣ ΚΑΙ ΔΙΕΡΜΗΝΕΙΑΣ',
  },
  {
    label: '74301100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΡΑΣΗΣ',
  },
  {
    label: '74301101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΡΑΣΗΣ ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΩΝ ΤΑΙΝΙΩΝ',
  },
  {
    label: '74301200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΕΡΜΗΝΕΙΑΣ',
  },
  {
    label: '74301201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΕΡΜΗΝΕΙΑΣ ΣΤΗ ΝΟΗΜΑΤΙΚΗ ΓΛΩΣΣΑ',
  },
  {
    label: '74900000',
    value:
      'ΑΛΛΕΣ ΕΠΑΓΓΕΛΜΑΤΙΚΕΣ, ΕΠΙΣΤΗΜΟΝΙΚΕΣ ΚΑΙ ΤΕΧΝΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '74901000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΚΑΙ ΤΕΧΝΙΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ ΚΑΙ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '74901100',
    value: 'ΠΛΗΡΟΦΟΡΙΑΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΛΕΓΧΟΥ ΛΟΓΑΡΙΑΣΜΩΝ ΚΑΙ ΤΙΜΗΣ ΝΑΥΛΩΝ',
  },
  {
    label: '74901200',
    value:
      'ΕΠΙΧΕΙΡΗΜΑΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΜΕΣΙΤΕΙΑΣ ΚΑΙ ΕΚΤΙΜΗΣΗΣ, ΕΚΤΟΣ ΑΠΟ ΤΙΣ ΣΧΕΤΙΚΕΣ ΤΑ ΑΚΙΝΗΤΑ ΚΑΙ ΤΙΣ ΑΣΦΑΛΙΣΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '74901300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΠΕΡΙΒΑΛΛΟΝΤΙΚΩΝ ΣΥΜΒΟΥΛΩΝ',
  },
  {
    label: '74901400',
    value: 'ΠΡΟΒΛΕΨΗ ΚΑΙΡΟΥ ΚΑΙ ΜΕΤΕΩΡΟΛΟΓΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '74901500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΣΕ ΘΕΜΑΤΑ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '74901900',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΕΠΙΣΤΗΜΟΝΙΚΩΝ ΚΑΙ ΤΕΧΝΙΚΩΝ ΣΥΜΒΟΥΛΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '74902000',
    value:
      'ΑΛΛΕΣ ΕΠΑΓΓΕΛΜΑΤΙΚΕΣ, ΤΕΧΝΙΚΕΣ ΚΑΙ ΕΠΙΧΕΙΡΗΜΑΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '75000000',
    value: 'ΚΤΗΝΙΑΤΡΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '75001000',
    value: 'ΚΤΗΝΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '75001100',
    value: 'ΚΤΗΝΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΖΩΑ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '75001101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΤΗΝΙΑΤΡΟΥ ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ, ΑΠΟΚΛΕΙΣΤΙΚΑ ΜΕ ΠΡΟΣΩΠΙΚΗ ΕΡΓΑΣΙΑ',
  },
  {
    label: '75001200',
    value: 'ΚΤΗΝΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΖΩΙΚΗΣ ΠΑΡΑΓΩΓΗΣ (ΑΓΡΟΚΤΗΜΑΤΩΝ)',
  },
  {
    label: '75001900',
    value: 'ΑΛΛΕΣ ΚΤΗΝΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '75001901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΤΗΝΙΑΤΡΟΥ ΖΩΩΝ ΑΛΛΩΝ ΑΠΟ ΣΥΝΤΡΟΦΙΑΣ, ΑΠΟΚΛΕΙΣΤΙΚΑ ΜΕ ΠΡΟΣΩΠΙΚΗ ΕΡΓΑΣΙΑ',
  },
  {
    label: '77110000',
    value:
      'ΕΝΟΙΚΙΑΣΗ ΚΑΙ ΕΚΜΙΣΘΩΣΗ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '77111000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΕΛΑΦΡΩΝ ΜΗΧΑΝΟΚΙΝΗΤΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '77111001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΒΑΤΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ, ΧΩΡΙΣ ΟΔΗΓΟ',
  },
  {
    label: '77120000',
    value: 'ΕΝΟΙΚΙΑΣΗ ΚΑΙ ΕΚΜΙΣΘΩΣΗ ΦΟΡΤΗΓΩΝ',
  },
  {
    label: '77121000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΦΟΡΤΗΓΩΝ',
  },
  {
    label: '77121100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΟΧΗΜΑΤΩΝ ΜΕΤΑΦΟΡΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ, ΧΩΡΙΣ ΟΔΗΓΟ',
  },
  {
    label: '77121900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΑΛΛΟΥ ΧΕΡΣΑΙΟΥ ΜΕΤΑΦΟΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ, ΧΩΡΙΣ ΟΔΗΓΟ',
  },
  {
    label: '77210000',
    value: 'ΕΝΟΙΚΙΑΣΗ ΚΑΙ ΕΚΜΙΣΘΩΣΗ ΕΙΔΩΝ ΑΝΑΨΥΧΗΣ ΚΑΙ ΑΘΛΗΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '77211000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΕΙΔΩΝ ΑΝΑΨΥΧΗΣ ΚΑΙ ΑΘΛΗΤΙΣΜΟΥ',
  },
  {
    label: '77211001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΑΕΡΟΣΤΑΤΩΝ, ΑΝΕΜΟΠΛΑΝΩΝ, ΑΙΩΡΟΠΤΕΡΩΝ ΚΑΙ ΠΗΔΑΛΙΟΥΧΩΝ ΑΕΡΟΠΛΟΙΩΝ',
  },
  {
    label: '77211002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΑΛΟΓΩΝ ΙΠΠΑΣΙΑΣ',
  },
  {
    label: '77211003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΙΔΩΝ ΚΑΤΑΣΚΗΝΩΣΗΣ',
  },
  {
    label: '77211004',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΘΑΛΑΣΣΙΩΝ ΣΠΟΡ (ΚΥΜΑΤΟΣΑΝΙΔΩΝ, ΣΚΙ, ΛΕΜΒΩΝ)',
  },
  {
    label: '77211005',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΧΙΟΝΟΔΡΟΜΙΚΩΝ ΑΘΛΗΜΑΤΩΝ (ΠΑΓΟΠΕΔΙΛΩΝ, ΜΠΟΤΩΝ ΚΛΠ)',
  },
  {
    label: '77211006',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΜΠΙΛΙΑΡΔΩΝ',
  },
  {
    label: '77211007',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΠΛΟΙΩΝ ΨΥΧΑΓΩΓΙΑΣ (ΚΟΤΕΡΩΝ, ΘΑΛΑΜΗΓΩΝ, ΒΕΝΖΙΝΑΚΑΤΩΝ ΚΛΠ), ΧΩΡΙΣ ΠΛΗΡΩΜΑ',
  },
  {
    label: '77211008',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΠΟΔΗΛΑΤΩΝ',
  },
  {
    label: '77211009',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΙΣΘΩΣΗΣ ΑΘΛΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ (ΜΠΑΣΤΟΥΝΙΩΝ ΓΚΟΛΦ, ΡΑΚΕΤΩΝ ΚΛΠ)',
  },
  {
    label: '77220000',
    value: 'ΕΝΟΙΚΙΑΣΗ ΒΙΝΤΕΟΚΑΣΕΤΩΝ ΚΑΙ ΔΙΣΚΩΝ',
  },
  {
    label: '77221000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΒΙΝΤΕΟΚΑΣΕΤΩΝ ΚΑΙ ΔΙΣΚΩΝ',
  },
  {
    label: '77221001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΒΙΝΤΕΟΚΑΣΕΤΩΝ ΚΑΙ ΟΠΤΙΚΩΝ ΔΙΣΚΩΝ (CDS, DVDS, BLU;RAYS ΚΛΠ)',
  },
  {
    label: '77221002',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΜΟΥΣΙΚΩΝ ΚΑΣΕΤΩΝ, ΔΙΣΚΩΝ ΓΡΑΜΟΦΩΝΟΥ Η ΒΙΝΥΛΙΟΥ',
  },
  {
    label: '77290000',
    value: 'ΕΝΟΙΚΙΑΣΗ ΚΑΙ ΕΚΜΙΣΘΩΣΗ ΑΛΛΩΝ ΕΙΔΩΝ ΠΡΟΣΩΠΙΚΗΣ Η ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '77291000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΑΛΛΩΝ ΠΡΟΣΩΠΙΚΩΝ ΚΑΙ ΟΙΚΙΑΚΩΝ ΑΓΑΘΩΝ',
  },
  {
    label: '77291100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΤΗΛΕΟΠΤΙΚΩΝ ΚΑΙ ΡΑΔΙΟΦΩΝΙΚΩΝ ΣΥΣΚΕΥΩΝ, ΜΑΓΝΗΤΟΣΚΟΠΙΩΝ (ΒΙΝΤΕΟ) ΚΑΙ ΣΥΝΑΦΟΥΣ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΕΞΑΡΤΗΜΑΤΩΝ',
  },
  {
    label: '77291101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΣΤΕΡΕΟΦΩΝΙΚΩΝ ΣΥΓΚΡΟΤΗΜΑΤΩΝ',
  },
  {
    label: '77291200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΕΠΙΠΛΩΝ ΚΑΙ ΑΛΛΩΝ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '77291201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΠΛΩΝ ΚΑΙ ΣΚΕΥΩΝ ΣΕ ΕΠΑΓΓΕΛΜΑΤΙΕΣ',
  },
  {
    label: '77291202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΠΛΩΝ ΚΑΙ ΣΚΕΥΩΝ ΣΕ ΙΔΙΩΤΕΣ',
  },
  {
    label: '77291203',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΘΙΣΜΑΤΩΝ ΓΙΑ ΕΚΔΗΛΩΣΕΙΣ',
  },
  {
    label: '77291300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '77291400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΛΕΥΚΩΝ ΕΙΔΩΝ (ΛΙΝΩΝ) ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '77291401',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΠΕΤΣΕΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ (ΚΟΥΡΕΙΩΝ, ΕΣΤΙΑΤΟΡΙΩΝ ΚΛΠ)',
  },
  {
    label: '77291500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΥΦΑΣΜΑΤΩΝ, ΕΙΔΩΝ ΙΜΑΤΙΣΜΟΥ (ΡΟΥΧΙΣΜΟΥ) ΚΑΙ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '77291501',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΑΠΟΚΡΙΑΤΙΚΩΝ ΣΤΟΛΩΝ',
  },
  {
    label: '77291502',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΙΔΩΝ ΙΜΑΤΙΣΜΟΥ',
  },
  {
    label: '77291503',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΝΥΦΙΚΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΑΞΕΣΟΥΑΡ',
  },
  {
    label: '77291504',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΝΥΦΙΚΩΝ, ΕΙΔΩΝ ΓΑΜΟΥ ΚΑΙ ΣΥΝΑΦΩΝ ΑΜΦΙΕΣΕΩΝ',
  },
  {
    label: '77291600',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΙΔΙΟΚΑΤΑΣΚΕΥΩΝ',
  },
  {
    label: '77291601',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΙΔΙΟΚΑΤΑΣΚΕΥΕΣ',
  },
  {
    label: '77291900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΑΛΛΩΝ ΠΡΟΣΩΠΙΚΩΝ ΚΑΙ ΟΙΚΙΑΚΩΝ ΑΓΑΘΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '77291901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '77291902',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΙΑΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ (ΠΑΤΕΡΙΤΣΩΝ ΚΛΠ) Η ΠΑΡΑΪΑΤΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '77310000',
    value: 'ΕΝΟΙΚΙΑΣΗ ΚΑΙ ΕΚΜΙΣΘΩΣΗ ΓΕΩΡΓΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '77311000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΓΕΩΡΓΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '77311001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΑΓΡΟΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ ΕΠΟΧΙΑΚΗΣ ΧΡΗΣΗΣ (ΘΕΡΙΖΟΑΛΩΝΙΣΤΙΚΩΝ, ΒΑΜΒΑΚΟΣΥΛΛΕΚΤΙΚΩΝ ΚΛΠ), ΧΩΡΙΣ ΧΕΙΡΙΣΤΗ',
  },
  {
    label: '77311002',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΜΗΧΑΝΙΚΩΝ ΜΕΣΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΕΝΙΚΑ, ΠΟΥ ΧΡΗΣΙΜΟΠΟΙΟΥΝΤΑΙ ΣΤΙΣ ΑΓΡΟΤΙΚΕΣ ΕΚΜΕΤΑΛΛΕΥΣΕΙΣ, ΧΩΡΙΣ ΧΕΙΡΙΣΤΗ',
  },
  {
    label: '77320000',
    value:
      'ΕΝΟΙΚΙΑΣΗ ΚΑΙ ΕΚΜΙΣΘΩΣΗ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΚΑΤΑΣΚΕΥΩΝ ΚΑΙ ΕΡΓΩΝ ΠΟΛΙΤΙΚΟΥ ΜΗΧΑΝΙΚΟΥ',
  },
  {
    label: '77321000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΚΑΤΑΣΚΕΥΩΝ, ΚΑΙ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΙΑ ΕΡΓΑ ΠΟΛΙΤΙΚΟΥ ΜΗΧΑΝΙΚΟΥ',
  },
  {
    label: '77321001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΑΕΡΟΣΥΜΠΙΕΣΤΩΝ ΓΙΑ ΤΕΧΝΙΚΑ ΕΡΓΑ',
  },
  {
    label: '77321002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΓΕΡΑΝΟΥ, ΧΩΡΙΣ ΧΕΙΡΙΣΤΗ',
  },
  {
    label: '77321003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΓΕΩΤΡΗΣΕΩΝ',
  },
  {
    label: '77330000',
    value:
      'ΕΝΟΙΚΙΑΣΗ ΚΑΙ ΕΚΜΙΣΘΩΣΗ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΟΥ (ΣΥΜΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ)',
  },
  {
    label: '77331000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΟΥ (ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ)',
  },
  {
    label: '77331100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΓΡΑΦΕΙΟ (ΕΚΤΟΣ ΤΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ)',
  },
  {
    label: '77331101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΓΡΑΦΟΜΗΧΑΝΩΝ',
  },
  {
    label: '77331102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΠΙΠΛΩΝ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '77331103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΦΩΤΟΤΥΠΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '77331200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ',
  },
  {
    label: '77340000',
    value: 'ΕΝΟΙΚΙΑΣΗ ΚΑΙ ΕΚΜΙΣΘΩΣΗ ΕΞΟΠΛΙΣΜΟΥ ΠΛΩΤΩΝ ΜΕΤΑΦΟΡΩΝ',
  },
  {
    label: '77341000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΥΔΑΤΙΝΟΥ ΜΕΤΑΦΟΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '77341001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΛΕΜΒΩΝ, ΧΩΡΙΣ ΠΛΗΡΩΜΑ',
  },
  {
    label: '77341002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΤΟΥΡΙΣΤΙΚΟΥ ΣΚΑΦΟΥΣ, ΧΩΡΙΣ ΠΛΗΡΩΜΑ',
  },
  {
    label: '77350000',
    value: 'ΕΝΟΙΚΙΑΣΗ ΚΑΙ ΕΚΜΙΣΘΩΣΗ ΕΞΟΠΛΙΣΜΟΥ ΑΕΡΟΠΟΡΙΚΩΝ ΜΕΤΑΦΟΡΩΝ',
  },
  {
    label: '77351000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΕΝΑΕΡΙΟΥ ΜΕΤΑΦΟΡΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '77351001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΝΑΥΛΩΣΗΣ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΕΛΙΚΟΠΤΕΡΩΝ, ΧΩΡΙΣ ΠΛΗΡΩΜΑ',
  },
  {
    label: '77390000',
    value:
      'ΕΝΟΙΚΙΑΣΗ ΚΑΙ ΕΚΜΙΣΘΩΣΗ ΑΛΛΩΝ ΜΗΧΑΝΗΜΑΤΩΝ, ΕΙΔΩΝ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΥΛΙΚΩΝ ΑΓΑΘΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '77391000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΑΛΛΩΝ ΜΗΧΑΝΩΝ, ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΥΛΙΚΩΝ ΑΓΑΘΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '77391100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΣΙΔΗΡΟΔΡΟΜΙΚΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '77391200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΕΜΠΟΡΕΥΜΑΤΟΚΙΒΩΤΙΩΝ',
  },
  {
    label: '77391300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΜΟΤΟΣΙΚΛΕΤΩΝ ΚΑΙ ΤΡΟΧΟΣΠΙΤΩΝ',
  },
  {
    label: '77391301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΜΟΤΟΠΟΔΗΛΑΤΩΝ',
  },
  {
    label: '77391302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '77391400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '77391900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΚΑΙ ΧΡΗΜΑΤΟΔΟΤΙΚΗΣ ΜΙΣΘΩΣΗΣ ΑΛΛΩΝ ΜΗΧΑΝΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΧΩΡΙΣ ΧΕΙΡΙΣΤΗ ΚΑΙ ΥΛΙΚΩΝ ΑΓΑΘΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '77391901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΑΡΔΕΥΤΙΚΩΝ, ΑΠΟΞΗΡΑΝΤΙΚΩΝ ΜΕΣΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '77391902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΒΥΘΟΚΟΡΩΝ, ΧΩΡΙΣ ΧΕΙΡΙΣΤΗ',
  },
  {
    label: '77391903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΕΚΘΕΣΕΩΝ',
  },
  {
    label: '77391904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΑΥΤΟΜΑΤΩΝ ΠΩΛΗΤΩΝ',
  },
  {
    label: '77391905',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΤΥΧΕΡΩΝ ΠΑΙΧΝΙΔΙΩΝ, ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΚΕΡΜΑΤΑ',
  },
  {
    label: '77391906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΗΣ ΠΛΩΤΩΝ ΓΕΡΑΝΩΝ ΧΩΡΙΣ ΧΕΙΡΙΣΤΗ',
  },
  {
    label: '77391907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΙΣΘΩΣΗΣ ΧΡΗΜΑΤΟΘΥΡΙΔΩΝ, ΕΚΤΟΣ ΤΡΑΠΕΖΩΝ',
  },
  {
    label: '77391908',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΧΩΡΗΣΗΣ ΧΡΗΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ Η ΠΑΙΧΝΙΔΙΩΝ ΣΕ ΛΟΥΝΑ ΠΑΡΚ ΚΑΙ ΣΧΕΤΙΚΑ ΚΑΤΑΣΤΗΜΑΤΑ',
  },
  {
    label: '77391909',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΡΗΣΙΔΑΝΕΙΣΜΟΥ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '77400000',
    value:
      'ΕΚΜΙΣΘΩΣΗ ΠΝΕΥΜΑΤΙΚΗΣ ΙΔΙΟΚΤΗΣΙΑΣ ΚΑΙ ΠΑΡΕΜΦΕΡΩΝ ΠΡΟΪΟΝΤΩΝ, ΜΕ ΕΞΑΙΡΕΣΗ ΤΑ ΕΡΓΑ ΜΕ ΔΙΚΑΙΩΜΑΤΑ ΔΗΜΙΟΥΡΓΟΥ',
  },
  {
    label: '77401000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΩΝ ΓΙΑ ΤΑ ΔΙΚΑΙΩΜΑΤΑ ΧΡΗΣΗΣ ΠΝΕΥΜΑΤΙΚΗΣ ΙΔΙΟΚΤΗΣΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΚΤΟΣ ΕΡΓΩΝ ΜΕ ΔΙΚΑΙΩΜΑΤΑ ΔΗΜΙΟΥΡΓΟΥ (ΒΙΒΛΙΑ, ΛΟΓΙΣΜΙΚΟ, ΤΑΙΝΙΕΣ ΚΛΠ)',
  },
  {
    label: '77401100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΩΝ ΓΙΑ ΤΑ ΔΙΚΑΙΩΜΑΤΑ ΧΡΗΣΗΣ ΠΡΟΪΟΝΤΩΝ ΕΡΕΥΝΑΣ ΚΑΙ ΑΝΑΠΤΥΞΗΣ',
  },
  {
    label: '77401200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΩΝ ΓΙΑ ΤΑ ΔΙΚΑΙΩΜΑΤΑ ΧΡΗΣΗΣ ΕΜΠΟΡΙΚΩΝ ΣΗΜΑΤΩΝ ΚΑΙ ΣΥΜΒΑΣΕΩΝ ΔΙΚΑΙΟΧΡΗΣΗΣ',
  },
  {
    label: '77401300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΩΝ ΓΙΑ ΤΑ ΔΙΚΑΙΩΜΑΤΑ ΧΡΗΣΗΣ ΜΕΤΑΛΛΕΥΤΙΚΩΝ ΕΡΕΥΝΩΝ ΚΑΙ',
  },
  {
    label: '77401900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΑΔΕΙΩΝ ΓΙΑ ΤΑ ΔΙΚΑΙΩΜΑΤΑ ΧΡΗΣΗΣ ΑΛΛΗΣ ΠΝΕΥΜΑΤΙΚΗΣ ΙΔΙΟΚΤΗΣΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΡΟΪΟΝΤΩΝ, ΕΚΤΟΣ ΕΡΓΩΝ ΜΕ ΔΙΚΑΙΩΜΑΤΑ ΔΗΜΙΟΥΡΓΟΥ (ΒΙΒΛΙΑ, ΛΟΓΙΣΜΙΚΟ, ΤΑΙΝΙΕΣ ΚΛΠ)',
  },
  {
    label: '78100000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΓΡΑΦΕΙΩΝ ΕΥΡΕΣΗΣ ΕΡΓΑΣΙΑΣ',
  },
  {
    label: '78101000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΕΥΡΕΣΗΣ ΑΠΑΣΧΟΛΗΣΗΣ',
  },
  {
    label: '78101100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΖΗΤΗΣΗΣ ΣΤΕΛΕΧΩΝ',
  },
  {
    label: '78101101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΥΡΕΣΗΣ ΚΑΛΛΙΤΕΧΝΩΝ ΓΙΑ ΘΕΑΜΑΤΑ',
  },
  {
    label: '78101102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΥΡΕΣΗΣ ΙΑΤΡΙΚΟΥ ΠΡΟΣΩΠΙΚΟΥ',
  },
  {
    label: '78101200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΟΝΙΜΗΣ ΤΟΠΟΘΕΤΗΣΗΣ ΠΡΟΣΩΠΙΚΟΥ, ΕΚΤΟΣ ΤΩΝ ΥΠΗΡΕΣΙΩΝ ΑΝΑΖΗΤΗΣΗΣ ΣΤΕΛΕΧΩΝ',
  },
  {
    label: '78200000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΕΥΡΕΣΗΣ ΠΡΟΣΩΡΙΝΗΣ ΑΠΑΣΧΟΛΗΣΗΣ',
  },
  {
    label: '78201100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΕΥΡΕΣΗΣ ΠΡΟΣΩΡΙΝΗΣ ΑΠΑΣΧΟΛΗΣΗΣ ΓΙΑ ΤΗΝ ΠΑΡΟΧΗ ΠΡΟΣΩΠΙΚΟΥ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '78201200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΕΥΡΕΣΗΣ ΠΡΟΣΩΡΙΝΗΣ ΑΠΑΣΧΟΛΗΣΗΣ ΓΙΑ ΤΗΝ ΠΑΡΟΧΗ ΛΟΙΠΟΥ ΠΡΟΣΩΠΙΚΟΥ ΥΠΟΣΤΗΡΙΞΗΣ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '78201300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΕΥΡΕΣΗΣ ΠΡΟΣΩΡΙΝΗΣ ΑΠΑΣΧΟΛΗΣΗΣ ΓΙΑ ΤΗΝ ΠΑΡΟΧΗ ΠΡΟΣΩΠΙΚΟΥ ΣΤΟΝ ΤΟΜΕΑ ΤΟΥ ΕΜΠΟΡΙΟΥ',
  },
  {
    label: '78201400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΕΥΡΕΣΗΣ ΠΡΟΣΩΡΙΝΗΣ ΑΠΑΣΧΟΛΗΣΗΣ ΓΙΑ ΤΗΝ ΠΑΡΟΧΗ ΠΡΟΣΩΠΙΚΟΥ ΣΤΟΝ ΤΟΜΕΑ ΤΩΝ ΜΕΤΑΦΟΡΩΝ, ΤΗΣ ΑΠΟΘΗΚΕΥΣΗΣ, ΤΟΥ ΕΦΟΔΙΑΣΜΟΥ Η ΤΗΣ ΒΙΟΜΗΧΑΝΙΑΣ',
  },
  {
    label: '78201500',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΕΥΡΕΣΗΣ ΠΡΟΣΩΡΙΝΗΣ ΑΠΑΣΧΟΛΗΣΗΣ ΓΙΑ ΤΗΝ ΠΑΡΟΧΗ ΠΡΟΣΩΠΙΚΟΥ ΣΕ ΞΕΝΟΔΟΧΕΙΑ ΚΑΙ ΕΣΤΙΑΤΟΡΙΑ',
  },
  {
    label: '78201600',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΕΥΡΕΣΗΣ ΠΡΟΣΩΡΙΝΗΣ ΑΠΑΣΧΟΛΗΣΗΣ ΓΙΑ ΤΗΝ ΠΑΡΟΧΗ ΙΑΤΡΙΚΟΥ ΠΡΟΣΩΠΙΚΟΥ',
  },
  {
    label: '78201900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΕΥΡΕΣΗΣ ΠΡΟΣΩΡΙΝΗΣ ΑΠΑΣΧΟΛΗΣΗΣ ΓΙΑ ΤΗΝ ΠΑΡΟΧΗ ΛΟΙΠΟΥ ΠΡΟΣΩΠΙΚΟΥ',
  },
  {
    label: '78300000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΝΘΡΩΠΙΝΟΥ ΔΥΝΑΜΙΚΟΥ',
  },
  {
    label: '78301100',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΝΘΡΩΠΙΝΟΥ ΔΥΝΑΜΙΚΟΥ ΓΙΑ ΕΡΓΑΣΙΕΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΤΗΛΕΠΙΚΟΙΝΩΝΙΩΝ',
  },
  {
    label: '78301200',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΝΘΡΩΠΙΝΟΥ ΔΥΝΑΜΙΚΟΥ ΓΙΑ ΕΡΓΑΣΙΕΣ ΥΠΟΣΤΗΡΙΞΗΣ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '78301300',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΝΘΡΩΠΙΝΟΥ ΔΥΝΑΜΙΚΟΥ ΓΙΑ ΕΡΓΑΣΙΕΣ ΣΤΟΝ ΤΟΜΕΑ ΤΟΥ ΕΜΠΟΡΙΟΥ',
  },
  {
    label: '78301400',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΝΘΡΩΠΙΝΟΥ ΔΥΝΑΜΙΚΟΥ ΓΙΑ ΕΡΓΑΣΙΕΣ ΜΕΤΑΦΟΡΩΝ, ΑΠΟΘΗΚΕΥΣΗΣ, ΕΦΟΔΙΑΣΜΟΥ Η ΒΙΟΜΗΧΑΝΙΑΣ',
  },
  {
    label: '78301500',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΝΘΡΩΠΙΝΟΥ ΔΥΝΑΜΙΚΟΥ ΓΙΑ ΞΕΝΟΔΟΧΕΙΑ ΚΑΙ ΕΣΤΙΑΤΟΡΙΑ',
  },
  {
    label: '78301600',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΝΘΡΩΠΙΝΟΥ ΔΥΝΑΜΙΚΟΥ ΓΙΑ ΙΑΤΡΙΚΕΣ ΕΡΓΑΣΙΕΣ',
  },
  {
    label: '78301900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΝΘΡΩΠΙΝΟΥ ΔΥΝΑΜΙΚΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '78301901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΔΙΔΑΚΤΙΚΟΥ ΠΡΟΣΩΠΙΚΟΥ',
  },
  {
    label: '79110000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΤΑΞΙΔΙΩΤΙΚΩΝ ΠΡΑΚΤΟΡΕΙΩΝ',
  },
  {
    label: '79111000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΞΙΔΙΩΤΙΚΩΝ ΠΡΑΚΤΟΡΕΙΩΝ ΓΙΑ ΚΡΑΤΗΣΕΙΣ ΜΕΤΑΦΟΡΑΣ',
  },
  {
    label: '79111100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΡΑΤΗΣΗΣ ΓΙΑ ΑΕΡΟΠΟΡΙΚΕΣ ΓΡΑΜΜΕΣ',
  },
  {
    label: '79111101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΑΕΡΟΠΟΡΙΚΩΝ ΕΙΣΙΤΗΡΙΩΝ ΜΕΤΑΦΟΡΑΣ ΠΡΟΣΩΠΩΝ ΜΕ ΠΡΟΜΗΘΕΙΑ',
  },
  {
    label: '79111200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΡΑΤΗΣΗΣ ΓΙΑ ΣΙΔΗΡΟΔΡΟΜΟΥΣ',
  },
  {
    label: '79111300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΡΑΤΗΣΗΣ ΓΙΑ ΛΕΩΦΟΡΕΙΑ',
  },
  {
    label: '79111400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΡΑΤΗΣΗΣ ΓΙΑ ΕΝΟΙΚΙΑΣΗ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '79111900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΑΞΙΔΙΩΤΙΚΩΝ ΠΡΑΚΤΟΡΕΙΩΝ ΓΙΑ ΚΡΑΤΗΣΕΙΣ ΜΕΤΑΦΟΡΑΣ',
  },
  {
    label: '79111901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΑΤΜΟΠΛΟΪΚΩΝ ΕΙΣΙΤΗΡΙΩΝ ΜΕΤΑΦΟΡΑΣ ΠΡΟΣΩΠΩΝ ΜΕ ΠΡΟΜΗΘΕΙΑ',
  },
  {
    label: '79111902',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΑΤΜΟΠΛΟΪΚΩΝ ΕΙΣΙΤΗΡΙΩΝ ΕΞΩΤΕΡΙΚΟΥ ΜΕ ΠΡΟΜΗΘΕΙΑ, ΑΠΟ ΠΡΑΚΤΟΡΕΙΟ',
  },
  {
    label: '79111903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΣΗΣ ΤΟΥΡΙΣΤΙΚΩΝ ΕΙΣΙΤΗΡΙΩΝ ΓΕΝΙΚΑ, ΜΕ ΠΡΟΜΗΘΕΙΑ',
  },
  {
    label: '79112000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΤΑΞΙΔΙΩΤΙΚΩΝ ΠΡΑΚΤΟΡΕΙΩΝ ΓΙΑ ΚΡΑΤΗΣΕΙΣ ΚΑΤΑΛΥΜΑΤΟΣ, ΚΡΟΥΑΖΙΕΡΩΝ ΚΑΙ ΟΡΓΑΝΩΜΕΝΑ ΤΑΞΙΔΙΑ (ΤΑΞΙΔΙΩΤΙΚΑ ΠΑΚΕΤΑ)',
  },
  {
    label: '79112100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΡΑΤΗΣΗΣ ΓΙΑ ΚΑΤΑΛΥΜΑ',
  },
  {
    label: '79112200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΡΑΤΗΣΗΣ ΓΙΑ ΚΡΟΥΑΖΙΕΡΕΣ',
  },
  {
    label: '79112300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΡΑΤΗΣΗΣ ΓΙΑ ΟΡΓΑΝΩΜΕΝΑ ΤΑΞΙΔΙΑ (ΤΑΞΙΔΙΩΤΙΚΑ ΠΑΚΕΤΑ)',
  },
  {
    label: '79112301',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΣΙΤΕΙΑΣ ΓΙΑ ΟΡΓΑΝΩΜΕΝΕΣ ΠΕΡΙΗΓΗΣΕΙΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ',
  },
  {
    label: '79120000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΓΡΑΦΕΙΩΝ ΟΡΓΑΝΩΜΕΝΩΝ ΤΑΞΙΔΙΩΝ',
  },
  {
    label: '79121000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΟΡΓΑΝΩΜΕΝΩΝ ΤΑΞΙΔΙΩΝ',
  },
  {
    label: '79121100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΔΙΟΡΓΑΝΩΣΗΣ ΟΡΓΑΝΩΜΕΝΩΝ ΠΕΡΙΗΓΗΣΕΩΝ (ΤΑΞΙΔΙΩΤΙΚΩΝ ΠΑΚΕΤΩΝ)',
  },
  {
    label: '79121101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΟΡΓΑΝΩΣΗΣ ΠΕΡΙΗΓΗΣΕΩΝ (ΠΡΑΚΤΟΡΕΙΟ ΤΑΞΙΔΙΩΝ) ΓΙΑ ΟΡΓΑΝΩΜΕΝΟ ΤΟΥΡΙΣΜΟ ΑΠΟ ΤΟ ΕΞΩΤΕΡΙΚΟ',
  },
  {
    label: '79121200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΤΩΝ ΠΕΡΙΗΓΗΣΕΩΝ',
  },
  {
    label: '79900000',
    value:
      'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΥΠΗΡΕΣΙΩΝ ΚΡΑΤΗΣΕΩΝ ΚΑΙ ΣΥΝΑΦΕΙΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '79901000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΥΡΙΣΤΙΚΗΣ ΠΡΟΒΟΛΗΣ ΚΑΙ ΕΝΗΜΕΡΩΣΗΣ ΕΠΙΣΚΕΠΤΩΝ',
  },
  {
    label: '79901100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΥΡΙΣΤΙΚΗΣ ΠΡΟΒΟΛΗΣ',
  },
  {
    label: '79901200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΗΜΕΡΩΣΗΣ ΕΠΙΣΚΕΠΤΩΝ',
  },
  {
    label: '79902000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΥΡΙΣΤΙΚΩΝ ΞΕΝΑΓΩΝ',
  },
  {
    label: '79903000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΡΑΤΗΣΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '79903100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΤΑΛΛΑΓΩΝ ΧΡΟΝΟΜΕΡΙΣΤΙΚΗΣ ΜΙΣΘΩΣΗΣ',
  },
  {
    label: '79903200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΡΑΤΗΣΕΩΝ ΓΙΑ ΣΥΝΕΔΡΙΑΚΑ ΚΕΝΤΡΑ ΚΑΙ ΕΚΘΕΣΙΑΚΟΥΣ ΧΩΡΟΥΣ',
  },
  {
    label: '79903900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΡΑΤΗΣΕΩΝ ΓΙΑ ΕΙΣΙΤΗΡΙΑ ΕΚΔΗΛΩΣΕΩΝ, ΥΠΗΡΕΣΙΕΣ ΨΥΧΑΓΩΓΙΑΣ ΚΑΙ ΑΝΑΨΥΧΗΣ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΡΑΤΗΣΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '80100000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΑΡΟΧΗΣ ΙΔΙΩΤΙΚΗΣ ΠΡΟΣΤΑΣΙΑΣ',
  },
  {
    label: '80101000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΙΔΙΩΤΙΚΗΣ ΠΡΟΣΤΑΣΙΑΣ',
  },
  {
    label: '80101100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΩΡΑΚΙΣΜΕΝΩΝ ΟΧΗΜΑΤΩΝ',
  },
  {
    label: '80101101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΡΗΜΑΤΑΠΟΣΤΟΛΩΝ',
  },
  {
    label: '80101200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΥΛΑΞΗΣ',
  },
  {
    label: '80101201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΩΜΑΤΟΦΥΛΑΚΩΝ',
  },
  {
    label: '80101900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΠΡΟΣΤΑΣΙΑΣ',
  },
  {
    label: '80200000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΥΠΗΡΕΣΙΩΝ ΣΥΣΤΗΜΑΤΩΝ ΠΡΟΣΤΑΣΙΑΣ',
  },
  {
    label: '80201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΣΤΗΜΑΤΩΝ ΠΡΟΣΤΑΣΙΑΣ',
  },
  {
    label: '80201001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΕΝΤΡΟΥ ΔΙΑΒΙΒΑΣΗΣ ΣΗΜΑΤΩΝ ΣΥΝΑΓΕΡΜΟΥ',
  },
  {
    label: '80201002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΚΟΛΟΥΘΗΣΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΣΥΣΤΗΜΑΤΩΝ ΣΥΝΑΓΕΡΜΟΥ',
  },
  {
    label: '80300000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΕΡΕΥΝΑΣ',
  },
  {
    label: '80301000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΕΞΑΓΩΓΗΣ ΕΡΕΥΝΩΝ (ΝΤΕΤΕΚΤΙΒ)',
  },
  {
    label: '80301001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΕΚΠΕΡΑΙΩΣΗΣ ΕΜΠΙΣΤΕΥΤΙΚΩΝ ΥΠΟΘΕΣΕΩΝ',
  },
  {
    label: '81100000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΥΝΔΥΑΣΜΟΥ ΒΟΗΘΗΤΙΚΩΝ ΥΠΗΡΕΣΙΩΝ',
  },
  {
    label: '81101000',
    value:
      'ΣΥΝΔΥΑΣΜΕΝΕΣ ΒΟΗΘΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΕ ΚΤΙΡΙΑ ΚΑΙ ΕΞΩΤΕΡΙΚΟΥΣ ΧΩΡΟΥΣ (ΚΑΘΑΡΙΣΜΟΥ, ΦΥΛΑΞΗΣ, ΥΠΟΔΟΧΗΣ ΚΛΠ)',
  },
  {
    label: '81210000',
    value: 'ΓΕΝΙΚΟΣ ΚΑΘΑΡΙΣΜΟΣ ΚΤΙΡΙΩΝ',
  },
  {
    label: '81211000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΕΝΙΚΟΥ ΚΑΘΑΡΙΣΜΟΥ ΚΤΙΡΙΩΝ',
  },
  {
    label: '81211001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΓΟΛΑΒΟΥ ΚΑΘΑΡΙΟΤΗΤΑΣ',
  },
  {
    label: '81211002',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΚΟΙΝΟΧΡΗΣΤΩΝ ΧΩΡΩΝ ΚΑΤΟΙΚΙΩΝ ΚΑΙ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΧΩΡΩΝ',
  },
  {
    label: '81211003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΤΗ ΟΙΚΙΩΝ ΚΑΙ ΑΛΛΩΝ ΧΩΡΩΝ',
  },
  {
    label: '81211004',
    value: "ΥΠΗΡΕΣΙΕΣ ΚΑΤ' ΟΙΚΟΝ ΣΤΙΛΒΩΜΑΤΟΣ ΕΠΙΠΛΩΝ",
  },
  {
    label: '81220000',
    value:
      'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΚΑΘΑΡΙΣΜΟΥ ΚΤΙΡΙΩΝ ΚΑΙ ΒΙΟΜΗΧΑΝΙΚΟΥ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '81221000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΙΟΜΗΧΑΝΙΚΟΥ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '81221100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΠΑΡΑΘΥΡΩΝ',
  },
  {
    label: '81221200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΕΙΔΙΚΕΥΜΕΝΟΥ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '81221201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΑΠΟΣΤΕΙΡΩΣΗΣ ΑΝΤΙΚΕΙΜΕΝΩΝ Η ΕΓΚΑΤΑΣΤΑΣΕΩΝ (ΧΕΙΡΟΥΡΓΕΙΩΝ ΚΛΠ)',
  },
  {
    label: '81221202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΔΕΞΑΜΕΝΩΝ (ΕΡΓΟΣΤΑΣΙΩΝ, ΠΛΟΙΩΝ ΚΛΠ)',
  },
  {
    label: '81221203',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΕΙΔΙΚΩΝ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΧΩΡΩΝ (ΝΟΣΟΚΟΜΕΙΩΝ ΚΛΠ)',
  },
  {
    label: '81221300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΚΛΙΒΑΝΩΝ ΚΑΙ ΚΑΠΝΟΔΟΧΩΝ',
  },
  {
    label: '81290000',
    value: 'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '81291000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '81291100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΛΥΜΑΝΣΗΣ ΚΑΙ ΕΞΟΛΟΘΡΕΥΣΗΣ (ΜΥΟΚΤΟΝΙΑΣ ΚΛΠ)',
  },
  {
    label: '81291101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΛΥΜΑΝΣΗΣ ΑΠΟΘΗΚΩΝ ΚΑΙ ΑΛΛΩΝ ΧΩΡΩΝ',
  },
  {
    label: '81291102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΛΥΜΑΝΣΗΣ ΟΙΚΙΩΝ',
  },
  {
    label: '81291200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΑΡΩΣΗΣ ΚΑΙ ΑΠΟΜΑΚΡΥΝΣΗΣ ΧΙΟΝΙΟΥ ΚΑΙ ΠΑΓΟΥ',
  },
  {
    label: '81291300',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΥΓΙΕΙΝΗΣ',
  },
  {
    label: '81291900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ Π.Δ.Κ.Α.',
  },
  {
    label: '81291901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΜΕΤΑΦΟΡΙΚΩΝ ΜΕΣΩΝ',
  },
  {
    label: '81291902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΠΛΟΙΩΝ',
  },
  {
    label: '81291903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΟΚΑΘΑΡΙΣΜΟΥ',
  },
  {
    label: '81300000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΥΠΗΡΕΣΙΩΝ ΤΟΠΙΟΥ',
  },
  {
    label: '81301000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΥΣΙΚΟΥ ΤΟΠΙΟΥ',
  },
  {
    label: '81301001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΜΟΡΦΩΣΗΣ ΚΑΙ ΠΕΡΙΠΟΙΗΣΗΣ ΚΗΠΩΝ (ΥΠΗΡΕΣΙΕΣ ΚΗΠΟΥΡΟΥ)',
  },
  {
    label: '82110000',
    value: 'ΣΥΝΔΥΑΣΜΕΝΕΣ ΔΙΟΙΚΗΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '82111000',
    value: 'ΣΥΝΔΥΑΣΜΕΝΕΣ ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '82190000',
    value:
      'ΑΝΑΠΑΡΑΓΩΓΗ ΦΩΤΟΤΥΠΙΩΝ, ΠΡΟΕΤΟΙΜΑΣΙΑ ΕΓΓΡΑΦΩΝ ΚΑΙ ΑΛΛΕΣ ΕΙΔΙΚΕΥΜΕΝΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΓΡΑΜΜΑΤΕΙΑΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ',
  },
  {
    label: '82191000',
    value:
      'ΠΑΡΑΓΩΓΗ ΦΩΤΟΑΝΤΙΓΡΑΦΩΝ, ΠΡΟΕΤΟΙΜΑΣΙΑ ΕΓΓΡΑΦΩΝ ΚΑΙ ΑΛΛΕΣ ΕΞΕΙΔΙΚΕΥΜΕΝΕΣ ΥΠΗΡΕΣΙΕΣ ΓΡΑΜΜΑΤΕΙΑΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '82191100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΠΑΡΑΓΩΓΗΣ ΕΓΓΡΑΦΩΝ',
  },
  {
    label: '82191101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΦΩΤΟΤΥΠΙΩΝ ΚΑΙ ΦΩΤΟΑΝΤΙΓΡΑΦΩΝ',
  },
  {
    label: '82191102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΛΥΓΡΑΦΗΣΕΩΝ ΚΑΙ ΦΩΤΟΑΝΤΙΓΡΑΦΩΝ',
  },
  {
    label: '82191200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΑΞΗΣ ΚΑΤΑΛΟΓΩΝ ΔΙΕΥΘΥΝΣΕΩΝ ΚΑΙ ΥΠΗΡΕΣΙΕΣ ΔΙΕΚΠΕΡΑΙΩΣΗΣ ΤΑΧΥΔΡΟΜΕΙΟΥ',
  },
  {
    label: '82191300',
    value:
      'ΠΡΟΕΤΟΙΜΑΣΙΑ ΕΓΓΡΑΦΩΝ ΚΑΙ ΑΛΛΕΣ ΕΞΕΙΔΙΚΕΥΜΕΝΕΣ ΥΠΗΡΕΣΙΕΣ ΓΡΑΜΜΑΤΕΙΑΚΗΣ ΥΠΟΣΤΗΡΙΞΗΣ',
  },
  {
    label: '82191301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΑΚΤΥΛΟΓΡΑΦΗΣΕΩΝ',
  },
  {
    label: '82191302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΟΡΘΩΣΗΣ ΤΥΠΟΓΡΑΦΙΚΩΝ ΔΟΚΙΜΙΩΝ',
  },
  {
    label: '82191303',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΕΞΕΡΓΑΣΙΑΣ ΕΓΓΡΑΦΩΝ',
  },
  {
    label: '82191304',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΥΠΟΣΤΗΡΙΞΗΣ ΓΡΑΦΕΙΟΥ ΕΥΡΥΤΕΡΟΥ ΔΗΜΟΣΙΟΥ ΤΟΜΕΑ, ΑΠΟ ΠΡΟΣΩΠΙΚΟ ΜΕ ΣΥΜΒΑΣΗ ΕΡΓΟΥ',
  },
  {
    label: '82200000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΤΗΛΕΦΩΝΙΚΩΝ ΚΕΝΤΡΩΝ',
  },
  {
    label: '82201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΗΛΕΦΩΝΙΚΟΥ ΚΕΝΤΡΟΥ',
  },
  {
    label: '82300000',
    value: 'ΟΡΓΑΝΩΣΗ ΣΥΝΕΔΡΙΩΝ ΚΑΙ ΕΜΠΟΡΙΚΩΝ ΕΚΘΕΣΕΩΝ',
  },
  {
    label: '82301000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΟΡΓΑΝΩΣΗΣ ΣΥΝΕΔΡΙΩΝ ΚΑΙ ΕΜΠΟΡΙΚΩΝ ΕΚΘΕΣΕΩΝ',
  },
  {
    label: '82301100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΟΡΓΑΝΩΣΗΣ ΣΥΝΕΔΡΙΩΝ',
  },
  {
    label: '82301101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΟΡΓΑΝΩΣΗΣ ΕΠΙΜΟΡΦΩΤΙΚΩΝ ΣΕΜΙΝΑΡΙΩΝ',
  },
  {
    label: '82301102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΡΓΑΝΩΣΗΣ ΕΠΙΣΤΗΜΟΝΙΚΩΝ Η ΠΟΛΙΤΙΣΤΙΚΩΝ ΕΚΔΗΛΩΣΕΩΝ',
  },
  {
    label: '82301200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΟΡΓΑΝΩΣΗΣ ΕΜΠΟΡΙΚΩΝ ΕΚΘΕΣΕΩΝ',
  },
  {
    label: '82301201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΕΚΘΕΣΙΑΚΩΝ ΧΩΡΩΝ',
  },
  {
    label: '82301202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΚΑΙ ΕΓΚΑΤΑΣΤΑΣΗΣ ΕΞΟΠΛΙΣΜΟΥ ΕΚΘΕΣΕΩΝ',
  },
  {
    label: '82910000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΓΡΑΦΕΙΩΝ ΕΙΣΠΡΑΞΗΣ ΚΑΙ ΓΡΑΦΕΙΩΝ ΟΙΚΟΝΟΜΙΚΩΝ ΚΑΙ ΕΜΠΟΡΙΚΩΝ ΠΛΗΡΟΦΟΡΙΩΝ',
  },
  {
    label: '82911000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΕΙΣΠΡΑΞΗΣ ΧΡΕΩΝ ΚΑΙ ΓΡΑΦΕΙΩΝ ΠΙΣΤΩΣΗΣ',
  },
  {
    label: '82911100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΤΙΜΗΣΗΣ ΚΑΙ ΑΝΑΦΟΡΑΣ ΣΧΕΤΙΚΑ ΜΕ ΤΗ ΦΕΡΕΓΓΥΟΤΗΤΑ ΑΤΟΜΩΝ Η ΕΠΙΧΕΙΡΗΣΕΩΝ',
  },
  {
    label: '82911101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΤΙΜΗΣΗΣ ΟΙΚΟΝΟΜΙΚΗΣ ΚΑΤΑΣΤΑΣΗΣ ΜΕΛΛΟΝΤΙΚΩΝ ΠΕΛΑΤΩΝ',
  },
  {
    label: '82911200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΕΙΣΠΡΑΞΗΣ ΧΡΕΩΝ',
  },
  {
    label: '82911201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΙΣΠΡΑΞΕΩΝ (ΑΜΟΙΒΩΝ, ΕΙΣΦΟΡΩΝ, ΔΟΣΕΩΝ, ΣΥΝΔΡΟΜΩΝ ΚΛΠ)',
  },
  {
    label: '82911202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΙΣΠΡΑΞΗΣ ΑΣΦΑΛΙΣΤΡΩΝ',
  },
  {
    label: '82911203',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΙΣΠΡΑΞΗΣ ΛΟΓΑΡΙΑΣΜΩΝ ΗΛΕΚΤΡΙΚΟΥ ΡΕΥΜΑΤΟΣ, ΤΗΛΕΦΩΝΙΑΣ, INTERNET, ΥΔΡΕΥΣΗΣ ΚΛΠ',
  },
  {
    label: '82911204',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΙΚΙΑΣΤΗ ΔΗΜΟΣΙΩΝ, ΔΗΜΟΤΙΚΩΝ, ΛΙΜΕΝΙΚΩΝ ΚΛΠ ΦΟΡΩΝ',
  },
  {
    label: '82920000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΥΣΚΕΥΑΣΙΑΣ',
  },
  {
    label: '82921000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΣΚΕΥΑΣΙΑΣ',
  },
  {
    label: '82921001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΜΦΙΑΛΩΣΗΣ ΟΙΝΟΠΝΕΥΜΑΤΟΣ',
  },
  {
    label: '82921002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΡΥΣΤΑΛΛΟΠΟΙΗΣΗΣ ΚΑΙ ΣΥΣΚΕΥΑΣΙΑΣ ΖΑΧΑΡΗΣ',
  },
  {
    label: '82921003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΣΚΕΥΑΣΙΑΣ ΑΛΛΩΝ ΑΓΡΟΤΙΚΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '82921004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΣΚΕΥΑΣΙΑΣ ΕΛΑΙΩΝ',
  },
  {
    label: '82921005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΣΚΕΥΑΣΙΑΣ ΚΑΙ ΑΠΟΣΥΣΚΕΥΑΣΙΑΣ ΕΜΠΟΡΕΥΜΑΤΩΝ',
  },
  {
    label: '82990000',
    value:
      'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΑΡΟΧΗΣ ΥΠΗΡΕΣΙΩΝ ΠΡΟΣ ΤΙΣ ΕΠΙΧΕΙΡΗΣΕΙΣ Π.Δ.Κ.Α.',
  },
  {
    label: '82991000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΥΠΟΣΤΗΡΙΞΗΣ ΠΡΟΣ ΤΙΣ ΕΠΙΧΕΙΡΗΣΕΙΣ Π.Δ.Κ.Α.',
  },
  {
    label: '82991100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΗΧΟΓΡΑΦΗΣΗΣ ΥΠΑΓΟΡΕΥΣΗΣ ΚΑΙ ΣΤΕΝΟΤΥΠΙΑΣ',
  },
  {
    label: '82991200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΠΟΣΤΗΡΙΞΗΣ ΜΕΣΩ ΤΗΛΕΦΩΝΟΥ',
  },
  {
    label: '82991900',
    value:
      'ΑΛΛΕΣ ΠΟΙΚΙΛΕΣ ΥΠΗΡΕΣΙΕΣ ΥΠΟΣΤΗΡΙΞΗΣ ΠΡΟΣ ΤΙΣ ΕΠΙΧΕΙΡΗΣΕΙΣ Π.Δ.Κ.Α.',
  },
  {
    label: '82991901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΠΑΡΚΟΚΑΡΤΩΝ, ΤΗΛΕΚΑΡΤΩΝ, ΚΑΡΤΩΝ INTERNET, ΚΙΝΗΤΗΣ ΤΗΛΕΦΩΝΙΑΣ, ΛΙΑΝΙΚΑ',
  },
  {
    label: '82991902',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΠΑΡΚΟΚΑΡΤΩΝ, ΤΗΛΕΚΑΡΤΩΝ, ΚΑΡΤΩΝ INTERNET, ΚΙΝΗΤΗΣ ΤΗΛΕΦΩΝΙΑΣ, ΧΟΝΔΡΙΚΑ',
  },
  {
    label: '82991903',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΔΙΚΑΙΩΜΑΤΩΝ ΠΝΕΥΜΑΤΙΚΗΣ ΙΔΙΟΚΤΗΣΙΑΣ ΚΑΙ ΤΩΝ ΕΣΟΔΩΝ ΤΟΥΣ (ΕΚΤΟΣ ΑΠΟ ΤΑΙΝΙΕΣ)',
  },
  {
    label: '82991904',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΧΕΙΡΙΣΗΣ ΔΙΚΑΙΩΜΑΤΩΝ, ΠΟΥ ΣΥΝΔΕΟΝΤΑΙ ΜΕ ΤΗ ΒΙΟΜΗΧΑΝΙΚΗ ΙΔΙΟΚΤΗΣΙΑ',
  },
  {
    label: '82991905',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΔΟΣΗΣ ΚΟΥΠΟΝΙΩΝ, ΠΟΥ ΔΙΝΟΥΝ ΔΙΚΑΙΩΜΑ ΣΕ ΜΕΙΩΜΕΝΗ ΤΙΜΗ ΚΑΙ ΚΟΥΠΟΝΙΩΝ ΔΩΡΩΝ',
  },
  {
    label: '82991906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΔΕΙΞΗΣ ΧΡΗΣΗΣ ΗΛΕΚΤΡΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '82991907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΖΥΓΙΣΗΣ (ΓΕΦΥΡΟΠΛΑΣΤΙΓΓΑΣ ΚΛΠ)',
  },
  {
    label: '82991908',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΒΙΒΑΣΗΣ Η ΠΑΡΑΧΩΡΗΣΗΣ ΧΡΗΣΗΣ ΑΥΛΩΝ ΑΓΑΘΩΝ (ΔΙΚΑΙΩΜΑΤΩΝ ΠΝΕΥΜΑΤΙΚΗΣ ΙΔΙΟΚΤΗΣΙΑΣ, ΔΙΠΛΩΜΑΤΩΝ ΕΥΡΕΣΙΤΕΧΝΙΑΣ, ΑΔΕΙΩΝ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΒΙΟΜΗΧΑΝΙΚΩΝ ΚΑΙ ΕΜΠΟΡΙΚΩΝ ΣΗΜΑΤΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΔΙΚΑΙΩΜΑΤΩΝ)',
  },
  {
    label: '82991909',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΧΩΡΗΣΗΣ ΤΕΧΝΙΚΩΝ ΜΕΘΟΔΩΝ',
  },
  {
    label: '82991910',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΛΕΙΣΤΗΡΙΑΣΜΩΝ, ΠΟΥ ΔΕΝ ΣΥΝΔΕΟΝΤΑΙ ΜΕ ΝΟΜΙΚΕΣ ΔΙΑΔΙΚΑΣΙΕΣ',
  },
  {
    label: '82991911',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΩΘΗΣΗΣ ΒΙΒΛΙΩΝ',
  },
  {
    label: '82991912',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΟΔΟΥ ΕΚΔΡΟΜΩΝ ΤΑΞΙΔΙΩΤΙΚΟΥ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '82991913',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΩΤΟΜΟΝΤΕΛΟΥ',
  },
  {
    label: '84110000',
    value: 'ΓΕΝΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΔΗΜΟΣΙΑΣ ΔΙΟΙΚΗΣΗΣ',
  },
  {
    label: '84111000',
    value: 'ΓΕΝΙΚΕΣ ΔΗΜΟΣΙΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '84111100',
    value: 'ΕΚΤΕΛΕΣΤΙΚΕΣ ΚΑΙ ΝΟΜΟΘΕΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '84111101',
    value: 'ΝΟΜΑΡΧΙΑΚΗ ΑΥΤΟΔΙΟΙΚΗΣΗ',
  },
  {
    label: '84111102',
    value: 'ΟΡΓΑΝΙΣΜΟΣ ΤΟΠΙΚΗΣ ΑΥΤΟΔΙΟΙΚΗΣΗΣ (Ο.Τ.Α.)',
  },
  {
    label: '84111103',
    value: 'ΠΕΡΙΦΕΡΕΙΑΚΗ ΑΥΤΟΔΙΟΙΚΗΣΗ',
  },
  {
    label: '84111200',
    value: 'ΧΡΗΜΑΤΟΠΙΣΤΩΤΙΚΕΣ ΚΑΙ ΔΗΜΟΣΙΟΝΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '84111300',
    value:
      'ΓΕΝΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΟΙΚΟΝΟΜΙΚΟΥ ΚΑΙ ΚΟΙΝΩΝΙΚΟΥ ΣΧΕΔΙΑΣΜΟΥ, ΚΑΘΩΣ ΚΑΙ ΣΤΑΤΙΣΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '84111400',
    value: 'ΚΥΒΕΡΝΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΗ ΒΑΣΙΚΗ ΕΡΕΥΝΑ',
  },
  {
    label: '84111900',
    value: 'ΑΛΛΕΣ ΓΕΝΙΚΕΣ ΔΗΜΟΣΙΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '84112000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΠΟΣΤΗΡΙΞΗΣ ΠΡΟΣ ΤΗΝ ΚΥΒΕΡΝΗΣΗ',
  },
  {
    label: '84112100',
    value: 'ΓΕΝΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΡΟΣΩΠΙΚΟΥ ΓΙΑ ΤΟ ΔΗΜΟΣΙΟ',
  },
  {
    label: '84112900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΥΠΟΣΤΗΡΙΞΗΣ ΠΡΟΣ ΤΗΝ ΚΥΒΕΡΝΗΣΗ',
  },
  {
    label: '84120000',
    value:
      'ΡΥΘΜΙΣΗ ΤΩΝ ΔΡΑΣΤΗΡΙΟΤΗΤΩΝ ΓΙΑ ΤΗΝ ΠΑΡΟΧΗ ΠΕΡΙΘΑΛΨΗΣ ΥΓΕΙΑΣ, ΕΚΠΑΙΔΕΥΣΗΣ, ΠΟΛΙΤΙΣΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΚΟΙΝΩΝΙΚΩΝ ΥΠΗΡΕΣΙΩΝ, ΕΚΤΟΣ ΑΠΟ ΤΗΝ ΚΟΙΝΩΝΙΚΗ ΑΣΦΑΛΙΣΗ',
  },
  {
    label: '84121000',
    value:
      'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗ ΡΥΘΜΙΣΗ ΤΩΝ ΥΓΕΙΟΝΟΜΙΚΩΝ, ΕΚΠΑΙΔΕΥΤΙΚΩΝ, ΠΟΛΙΤΙΣΤΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΚΟΙΝΩΝΙΚΩΝ ΥΠΗΡΕΣΙΩΝ, ΕΚΤΟΣ ΤΗΣ ΚΟΙΝΩΝΙΚΗΣ ΑΣΦΑΛΙΣΗΣ',
  },
  {
    label: '84121100',
    value: 'ΔΙΟΙΚΗΤΙΚΕΣ ΕΚΠΑΙΔΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '84121200',
    value: 'ΔΙΟΙΚΗΤΙΚΕΣ ΥΓΕΙΟΝΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '84121300',
    value:
      'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΤΕΓΑΣΗΣ ΚΑΙ ΑΝΑΒΑΘΜΙΣΗΣ ΤΩΝ ΣΥΝΘΗΚΩΝ ΔΙΑΒΙΩΣΗΣ ΤΩΝ ΠΟΛΙΤΩΝ',
  },
  {
    label: '84121400',
    value: 'ΔΙΟΙΚΗΤΙΚΕΣ ΨΥΧΑΓΩΓΙΚΕΣ, ΠΟΛΙΤΙΣΤΙΚΕΣ ΚΑΙ ΘΡΗΣΚΕΥΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '84130000',
    value:
      'ΡΥΘΜΙΣΗ ΤΩΝ ΕΠΙΧΕΙΡΗΜΑΤΙΚΩΝ ΔΡΑΣΤΗΡΙΟΤΗΤΩΝ ΚΑΙ ΣΥΜΒΟΛΗ ΣΤΗΝ ΑΠΟΤΕΛΕΣΜΑΤΙΚΟΤΕΡΗ ΛΕΙΤΟΥΡΓΙΑ ΤΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ',
  },
  {
    label: '84131000',
    value:
      'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΓΙΑ ΤΗΝ ΑΠΟΤΕΛΕΣΜΑΤΙΚΟΤΕΡΗ ΛΕΙΤΟΥΡΓΙΑ ΤΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ',
  },
  {
    label: '84131100',
    value:
      'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΤΗ ΓΕΩΡΓΙΑ, ΤΗ ΔΑΣΟΚΟΜΙΑ, ΤΗΝ ΑΛΙΕΙΑ ΚΑΙ ΤΗ ΘΗΡΑ',
  },
  {
    label: '84131200',
    value:
      'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΤΑ ΚΑΥΣΙΜΑ ΚΑΙ ΤΗΝ ΕΝΕΡΓΕΙΑ',
  },
  {
    label: '84131300',
    value:
      'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΤΑ ΟΡΥΧΕΙΑ ΚΑΙ ΤΟΝ ΟΡΥΚΤΟ ΠΛΟΥΤΟ, ΚΑΘΩΣ ΚΑΙ ΜΕ ΤΙΣ ΜΕΤΑΠΟΙΗΤΙΚΕΣ ΚΑΙ ΚΑΤΑΣΚΕΥΑΣΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '84131400',
    value:
      'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΤΙΣ ΜΕΤΑΦΟΡΕΣ ΚΑΙ ΤΙΣ ΕΠΙΚΟΙΝΩΝΙΕΣ',
  },
  {
    label: '84131500',
    value:
      'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΤΟ ΔΙΑΝΕΜΗΤΙΚΟ ΕΜΠΟΡΙΟ ΚΑΙ ΤΗΝ ΤΡΟΦΟΔΟΣΙΑ ΜΕ ΤΡΟΦΙΜΑ, ΜΕ ΤΑ ΞΕΝΟΔΟΧΕΙΑ ΚΑΙ ΤΑ ΕΣΤΙΑΤΟΡΙΑ',
  },
  {
    label: '84131600',
    value: 'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΤΟΥΡΙΣΤΙΚΑ ΘΕΜΑΤΑ',
  },
  {
    label: '84131700',
    value:
      'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΑΝΑΠΤΥΞΙΑΚΑ ΠΡΟΓΡΑΜΜΑΤΑ ΠΟΛΛΑΠΛΩΝ ΣΤΟΧΩΝ',
  },
  {
    label: '84131800',
    value:
      'ΓΕΝΙΚΕΣ ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΟΙΚΟΝΟΜΙΚΕΣ, ΕΜΠΟΡΙΚΕΣ ΚΑΙ ΕΡΓΑΤΙΚΕΣ',
  },
  {
    label: '84210000',
    value: 'ΕΞΩΤΕΡΙΚΕΣ ΥΠΟΘΕΣΕΙΣ',
  },
  {
    label: '84211000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΩΤΕΡΙΚΩΝ ΥΠΟΘΕΣΕΩΝ',
  },
  {
    label: '84211100',
    value:
      'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΕΞΩΤΕΡΙΚΕΣ ΥΠΟΘΕΣΕΙΣ, ΔΙΠΛΩΜΑΤΙΚΕΣ ΚΑΙ ΠΡΟΞΕΝΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΤΟ ΕΞΩΤΕΡΙΚΟ',
  },
  {
    label: '84211200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΘΕΜΑΤΑ ΕΞΩΤΕΡΙΚΗΣ ΟΙΚΟΝΟΜΙΚΗΣ ΒΟΗΘΕΙΑΣ',
  },
  {
    label: '84211300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΘΕΜΑΤΑ ΕΞΩΤΕΡΙΚΗΣ ΣΤΡΑΤΙΩΤΙΚΗΣ ΒΟΗΘΕΙΑΣ',
  },
  {
    label: '84220000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΑΜΥΝΑΣ',
  },
  {
    label: '84221000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΜΥΝΑΣ',
  },
  {
    label: '84221100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΡΑΤΙΩΤΙΚΗΣ ΑΜΥΝΑΣ',
  },
  {
    label: '84221200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΛΙΤΙΚΗΣ ΑΜΥΝΑΣ',
  },
  {
    label: '84230000',
    value: 'ΔΙΚΑΙΟΣΥΝΗ ΚΑΙ ΔΙΚΑΣΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '84231000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΚΑΙΟΣΥΝΗΣ',
  },
  {
    label: '84231100',
    value: 'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΤΑ ΔΙΚΑΣΤΗΡΙΑ',
  },
  {
    label: '84231200',
    value:
      'ΔΙΟΙΚΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΤΗΝ ΚΡΑΤΗΣΗ Η ΤΗΝ ΚΟΙΝΩΝΙΚΗ ΕΠΑΝΕΝΤΑΞΗ ΕΓΚΛΗΜΑΤΙΩΝ',
  },
  {
    label: '84240000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΔΗΜΟΣΙΑΣ ΤΑΞΗΣ ΚΑΙ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '84241000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΗΜΟΣΙΑΣ ΤΑΞΗΣ ΚΑΙ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '84241100',
    value: 'ΑΣΤΥΝΟΜΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '84241900',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΘΕΜΑΤΑ ΔΗΜΟΣΙΑΣ ΤΑΞΗΣ ΚΑΙ ΑΣΦΑΛΕΙΑΣ',
  },
  {
    label: '84250000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΥΡΟΣΒΕΣΤΙΚΗΣ',
  },
  {
    label: '84251000',
    value: 'ΠΥΡΟΣΒΕΣΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '84251100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΒΕΣΗΣ ΚΑΙ ΠΡΟΛΗΨΗΣ ΠΥΡΚΑΓΙΩΝ (ΠΥΡΟΠΡΟΣΤΑΣΙΑΣ)',
  },
  {
    label: '84251900',
    value: 'ΑΛΛΕΣ ΠΥΡΟΣΒΕΣΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '84251901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΣΩΣΗΣ ΑΤΟΜΩΝ (ΣΤΗ ΘΑΛΑΣΣΑ, ΣΤΑ ΒΟΥΝΑ, ΣΕ ΦΥΣΙΚΕΣ ΚΑΤΑΣΤΡΟΦΕΣ)',
  },
  {
    label: '84251902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΥΡΟΤΕΧΝΟΥΡΓΟΥ',
  },
  {
    label: '84300000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΥΠΟΧΡΕΩΤΙΚΗΣ ΚΟΙΝΩΝΙΚΗΣ ΑΣΦΑΛΙΣΗΣ',
  },
  {
    label: '84301000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΠΟΧΡΕΩΤΙΚΗΣ ΚΟΙΝΩΝΙΚΗΣ ΑΣΦΑΛΙΣΗΣ',
  },
  {
    label: '84301100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΥΠΟΧΡΕΩΤΙΚΗΣ ΚΟΙΝΩΝΙΚΗΣ ΑΣΦΑΛΙΣΗΣ ΠΟΥ ΑΦΟΡΟΥΝ ΤΑ ΕΠΙΔΟΜΑΤΑ ΑΣΘΕΝΕΙΑΣ, ΜΗΤΡΟΤΗΤΑΣ Η ΠΡΟΣΩΡΙΝΗΣ ΑΝΑΠΗΡΙΑΣ',
  },
  {
    label: '84301200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΥΠΟΧΡΕΩΤΙΚΗΣ ΚΟΙΝΩΝΙΚΗΣ ΑΣΦΑΛΙΣΗΣ ΠΟΥ ΑΦΟΡΟΥΝ ΤΑ ΣΥΝΤΑΞΙΟΔΟΤΙΚΑ ΣΥΣΤΗΜΑΤΑ ΔΗΜΟΣΙΩΝ ΥΠΑΛΛΗΛΩΝ· ΕΠΙΔΟΜΑΤΑ ΓΗΡΑΤΟΣ, ΑΝΑΠΗΡΙΑΣ Η ΕΠΙΖΩΝΤΟΣ ΣΥΖΥΓΟΥ, ΕΚΤΟΣ ΟΣΩΝ ΠΡΟΟΡΙΖΟΝΤΑΙ ΓΙΑ ΤΟΥΣ ΔΗΜΟΣΙΟΥΣ ΥΠΑΛΛΗΛΟΥΣ',
  },
  {
    label: '84301300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΥΠΟΧΡΕΩΤΙΚΗΣ ΚΟΙΝΩΝΙΚΗΣ ΑΣΦΑΛΙΣΗΣ ΠΟΥ ΑΦΟΡΟΥΝ ΤΑ ΕΠΙΔΟΜΑΤΑ ΑΝΕΡΓΙΑΣ',
  },
  {
    label: '84301400',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΥΠΟΧΡΕΩΤΙΚΗΣ ΚΟΙΝΩΝΙΚΗΣ ΑΣΦΑΛΙΣΗΣ ΠΟΥ ΑΦΟΡΟΥΝ ΤΑ ΟΙΚΟΓΕΝΕΙΑΚΑ ΕΠΙΔΟΜΑΤΑ ΚΑΙ ΕΠΙΔΟΜΑΤΑ ΤΕΚΝΩΝ',
  },
  {
    label: '85100000',
    value: 'ΠΡΟΣΧΟΛΙΚΗ ΕΚΠΑΙΔΕΥΣΗ',
  },
  {
    label: '85101000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΣΧΟΛΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85200000',
    value: 'ΠΡΩΤΟΒΑΘΜΙΑ ΕΚΠΑΙΔΕΥΣΗ',
  },
  {
    label: '85201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΩΤΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85201100',
    value: 'ΕΠΙΓΡΑΜΜΙΚΕΣ (ON LINE) ΥΠΗΡΕΣΙΕΣ ΠΡΩΤΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85201200',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΡΩΤΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85310000',
    value: 'ΓΕΝΙΚΗ ΔΕΥΤΕΡΟΒΑΘΜΙΑ ΕΚΠΑΙΔΕΥΣΗ',
  },
  {
    label: '85311000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΕΝΙΚΗΣ ΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85311100',
    value:
      'ΕΠΙΓΡΑΜΜΙΚΕΣ (ON LINE) ΥΠΗΡΕΣΙΕΣ ΚΑΤΩΤΕΡΗΣ ΓΕΝΙΚΗΣ ΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85311200',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΑΤΩΤΕΡΗΣ ΓΕΝΙΚΗΣ ΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85311300',
    value:
      'ΕΠΙΓΡΑΜΜΙΚΕΣ (ON LINE) ΥΠΗΡΕΣΙΕΣ ΑΝΩΤΕΡΗΣ ΓΕΝΙΚΗΣ ΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85311400',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΑΝΩΤΕΡΗΣ ΓΕΝΙΚΗΣ ΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85320000',
    value: 'ΤΕΧΝΙΚΗ ΚΑΙ ΕΠΑΓΓΕΛΜΑΤΙΚΗ ΔΕΥΤΕΡΟΒΑΘΜΙΑ ΕΚΠΑΙΔΕΥΣΗ',
  },
  {
    label: '85321000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΗΣ ΚΑΙ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85321100',
    value:
      'ΕΠΙΓΡΑΜΜΙΚΕΣ (ON LINE) ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΗΣ ΚΑΙ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΚΑΤΩΤΕΡΗΣ ΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85321200',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΗΣ ΚΑΙ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΚΑΤΩΤΕΡΗΣ ΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85321300',
    value:
      'ΕΠΙΓΡΑΜΜΙΚΕΣ (ON LINE) ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΗΣ ΚΑΙ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΑΝΩΤΕΡΗΣ ΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85321400',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΙΚΗΣ ΚΑΙ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΑΝΩΤΕΡΗΣ ΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85410000',
    value: 'ΜΕΤΑΔΕΥΤΕΡΟΒΑΘΜΙΑ ΜΗ ΤΡΙΤΟΒΑΘΜΙΑ ΕΚΠΑΙΔΕΥΣΗ',
  },
  {
    label: '85411000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΜΗ ΤΡΙΤΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85411100',
    value:
      'ΕΠΙΓΡΑΜΜΙΚΕΣ (ON LINE) ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΜΗ ΤΡΙΤΟΒΑΘΜΙΑΣ ΓΕΝΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85411200',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΜΗ ΤΡΙΤΟΒΑΘΜΙΑΣ ΓΕΝΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85411300',
    value:
      'ΕΠΙΓΡΑΜΜΙΚΕΣ (ON LINE) ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΜΗ ΤΡΙΤΟΒΑΘΜΙΑΣ ΤΕΧΝΙΚΗΣ ΚΑΙ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85411400',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΔΕΥΤΕΡΟΒΑΘΜΙΑΣ ΜΗ ΤΡΙΤΟΒΑΘΜΙΑΣ ΤΕΧΝΙΚΗΣ ΚΑΙ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ',
  },
  {
    label: '85420000',
    value: 'ΤΡΙΤΟΒΑΘΜΙΑ ΕΚΠΑΙΔΕΥΣΗ',
  },
  {
    label: '85421000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΡΙΤΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85421100',
    value:
      'ΕΠΙΓΡΑΜΜΙΚΕΣ (ON LINE) ΥΠΗΡΕΣΙΕΣ ΠΡΩΤΗΣ ΒΑΘΜΙΔΑΣ ΤΡΙΤΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85421200',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΡΩΤΗΣ ΒΑΘΜΙΔΑΣ ΤΡΙΤΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85421201',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΠΑΙΔΕΥΣΗΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΑΝΩΤΕΡΕΣ ΣΧΟΛΕΣ ΕΜΠΟΡΙΚΟΥ ΝΑΥΤΙΚΟΥ',
  },
  {
    label: '85421300',
    value:
      'ΕΠΙΓΡΑΜΜΙΚΕΣ (ON LINE) ΥΠΗΡΕΣΙΕΣ ΔΕΥΤΕΡΗΣ ΒΑΘΜΙΔΑΣ ΤΡΙΤΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85421400',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΔΕΥΤΕΡΗΣ ΒΑΘΜΙΔΑΣ ΤΡΙΤΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85421500',
    value:
      'ΕΠΙΓΡΑΜΜΙΚΕΣ (ON LINE) ΥΠΗΡΕΣΙΕΣ ΤΡΙΤΗΣ ΒΑΘΜΙΔΑΣ ΤΡΙΤΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85421600',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΡΙΤΗΣ ΒΑΘΜΙΔΑΣ ΤΡΙΤΟΒΑΘΜΙΑΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85510000',
    value: 'ΑΘΛΗΤΙΚΗ ΚΑΙ ΨΥΧΑΓΩΓΙΚΗ ΕΚΠΑΙΔΕΥΣΗ',
  },
  {
    label: '85511000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΘΛΗΤΙΚΗΣ ΚΑΙ ΨΥΧΑΓΩΓΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85511001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΕΡΟΒΙΚΗΣ ΓΥΜΝΑΣΤΙΚΗΣ (ΕΚΠΑΙΔΕΥΤΙΚΕΣ)',
  },
  {
    label: '85511002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΜΑΘΗΣΗΣ ΘΑΛΑΣΣΙΩΝ ΣΠΟΡ',
  },
  {
    label: '85511003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΜΑΘΗΣΗΣ ΚΑΤΑΔΥΣΕΩΝ',
  },
  {
    label: '85511004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΗΓΗΤΗ ΑΘΛΗΜΑΤΩΝ',
  },
  {
    label: '85511005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΥΝΟΤΡΟΦΕΙΩΝ',
  },
  {
    label: '85511006',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΠΟΝΗΤΗ ΑΘΛΗΤΩΝ',
  },
  {
    label: '85511007',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΗΣ ΑΘΛΗΜΑΤΩΝ',
  },
  {
    label: '85511008',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΗΣ ΙΠΠΑΣΙΑΣ',
  },
  {
    label: '85511009',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΠΑΛΗΣ, ΠΥΓΜΑΧΙΑΣ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΑΘΛΗΜΑΤΩΝ (ΚΑΡΑΤΕ, ΤΖΟΥΝΤΟ, ΤΑΕ ΚΒΟΝ ΝΤΟ, ΑΛΛΩΝ ΠΟΛΕΜΙΚΩΝ ΤΕΧΝΩΝ ΚΑΙ ΑΥΤΟΑΜΥΝΑΣ)',
  },
  {
    label: '85520000',
    value: 'ΠΟΛΙΤΙΣΤΙΚΗ ΕΚΠΑΙΔΕΥΣΗ',
  },
  {
    label: '85521000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΛΙΤΙΣΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85521100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΧΟΡΟΥ ΚΑΙ ΔΙΔΑΣΚΑΛΩΝ ΧΟΡΟΥ',
  },
  {
    label: '85521101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΧΟΡΟΥ',
  },
  {
    label: '85521102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΗΓΗΤΗ ΧΟΡΟΥ',
  },
  {
    label: '85521200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΟΥΣΙΚΩΝ ΣΧΟΛΩΝ ΚΑΙ ΔΙΔΑΣΚΑΛΩΝ ΜΟΥΣΙΚΗΣ',
  },
  {
    label: '85521201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΗΓΗΤΗ ΜΟΥΣΙΚΗΣ',
  },
  {
    label: '85521202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΩΔΕΙΟΥ',
  },
  {
    label: '85521300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΚΑΛΩΝ ΤΕΧΝΩΝ ΚΑΙ ΔΙΔΑΣΚΑΛΩΝ ΤΕΧΝΩΝ',
  },
  {
    label: '85521301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΗΓΗΤΗ ΖΩΓΡΑΦΙΚΗΣ',
  },
  {
    label: '85521900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΛΙΤΙΣΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85521901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΥΠΟΚΡΙΤΙΚΗΣ',
  },
  {
    label: '85530000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΧΟΛΩΝ ΕΡΑΣΙΤΕΧΝΩΝ ΟΔΗΓΩΝ',
  },
  {
    label: '85531000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΟΔΗΓΩΝ, ΣΧΟΛΩΝ ΠΙΛΟΤΩΝ ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΣΧΟΛΩΝ ΙΣΤΙΟΠΛΟΪΑΣ (ΕΡΑΣΙΤΕΧΝΙΚΩΝ)',
  },
  {
    label: '85531100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΕΡΑΣΙΤΕΧΝΩΝ ΟΔΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '85531101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΩΡΗΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ ΥΠΟΨΗΦΙΩΝ ΟΔΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '85531200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΕΡΑΣΙΤΕΧΝΩΝ ΟΔΗΓΩΝ (ΠΙΛΟΤΩΝ) ΑΕΡΟΣΚΑΦΩΝ ΚΑΙ ΣΧΟΛΩΝ ΕΡΑΣΙΤΕΧΝΙΚΗΣ ΙΣΤΙΟΠΛΟΪΑΣ',
  },
  {
    label: '85531201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΑΙΔΕΥΣΗΣ ΣΤΗΝ ΟΔΗΓΗΣΗ ΤΑΧΥΠΛΟΩΝ ΣΚΑΦΩΝ',
  },
  {
    label: '85531202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΕΡΑΣΙΤΕΧΝΩΝ ΠΙΛΟΤΩΝ ΑΕΡΟΣΚΑΦΩΝ',
  },
  {
    label: '85590000',
    value: 'ΑΛΛΗ ΕΚΠΑΙΔΕΥΣΗ Π.Δ.Κ.Α.',
  },
  {
    label: '85591000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΚΠΑΙΔΕΥΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '85591100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΓΛΩΣΣΩΝ',
  },
  {
    label: '85591101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΞΕΝΟΓΛΩΣΣΗΣ ΕΚΠΑΙΔΕΥΣΗΣ ΜΕΣΩ ΥΠΟΛΟΓΙΣΤΗ',
  },
  {
    label: '85591102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΡΟΝΤΙΣΤΗΡΙΟΥ ΞΕΝΩΝ ΓΛΩΣΣΩΝ',
  },
  {
    label: '85591200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΤΕΧΝΟΛΟΓΙΩΝ ΤΗΣ ΠΛΗΡΟΦΟΡΙΑΣ (IT)',
  },
  {
    label: '85591300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '85591301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΕΞΑΓΩΓΗΣ ΣΕΜΙΝΑΡΙΩΝ ΕΠΙΜΟΡΦΩΣΗΣ ΣΤΕΛΕΧΩΝ ΕΠΙΧΕΙΡΗΣΕΩΝ',
  },
  {
    label: '85591302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΑΙΔΕΥΣΗΣ ΑΣΦΑΛΕΙΟΜΕΣΙΤΩΝ',
  },
  {
    label: '85591303',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΓΑΣΤΗΡΙΟΥ ΕΛΕΥΘΕΡΩΝ ΣΠΟΥΔΩΝ, ΕΚΤΟΣ ΜΕΤΑΛΥΚΕΙΑΚΗΣ ΕΚΠΑΙΔΕΥΣΗΣ',
  },
  {
    label: '85591304',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΕΝΤΡΟΥ Η ΙΝΣΤΙΤΟΥΤΟΥ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΚΑΤΑΡΤΙΣΗΣ',
  },
  {
    label: '85591305',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΕΠΑΓΓΕΛΜΑΤΙΩΝ ΧΕΙΡΙΣΤΩΝ ΚΑΙ ΠΛΗΡΩΜΑΤΟΣ ΣΚΑΦΩΝ',
  },
  {
    label: '85591306',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΕΠΑΓΓΕΛΜΑΤΙΩΝ ΟΔΗΓΩΝ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '85591307',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΩΝ ΕΠΑΓΓΕΛΜΑΤΙΩΝ ΠΙΛΟΤΩΝ ΑΕΡΟΣΚΑΦΩΝ',
  },
  {
    label: '85591900',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΑΙΔΕΥΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '85591901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΑΣΚΑΛΟΥ',
  },
  {
    label: '85591902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΔΑΣΚΑΛΙΑΣ (ΕΙΣΗΓΗΣΕΩΝ) ΣΕ ΕΠΙΜΟΡΦΩΤΙΚΑ ΣΕΜΙΝΑΡΙΑ',
  },
  {
    label: '85591903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΥ ΠΑΙΔΑΓΩΓΟΥ',
  },
  {
    label: '85591904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΑΙΔΕΥΣΗΣ ΜΕ ΑΛΛΗΛΟΓΡΑΦΙΑ',
  },
  {
    label: '85591905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΑΙΔΕΥΣΗΣ ΜΕΣΩ ΕΠΙΜΟΡΦΩΤΙΚΩΝ ΣΕΜΙΝΑΡΙΩΝ',
  },
  {
    label: '85591906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΠΑΙΔΕΥΣΗΣ ΜΕΣΩ ΥΠΟΛΟΓΙΣΤΗ',
  },
  {
    label: '85591907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΗΓΗΤΗ',
  },
  {
    label: '85591908',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΡΤΙΣΗΣ ΜΕΣΩ ΡΑΔΙΟΤΗΛΕΟΠΤΙΚΩΝ ΕΚΠΟΜΠΩΝ',
  },
  {
    label: '85591909',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΑΪΚΗΣ ΕΠΙΜΟΡΦΩΣΗΣ',
  },
  {
    label: '85591910',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΔΟΣΗΣ ΙΔΙΑΙΤΕΡΩΝ ΜΑΘΗΜΑΤΩΝ',
  },
  {
    label: '85591911',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΡΟΝΤΙΣΤΗΡΙΟΥ ΓΕΝΙΚΑ (ΘΕΤΙΚΩΝ Η ΘΕΩΡΗΤΙΚΩΝ ΕΠΙΣΤΗΜΩΝ)',
  },
  {
    label: '85600000',
    value: 'ΕΚΠΑΙΔΕΥΤΙΚΕΣ ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '85601000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΠΡΟΣ ΤΗΝ ΕΚΠΑΙΔΕΥΣΗ',
  },
  {
    label: '85601001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΕΤΑΣΤΙΚΟΥ ΚΕΝΤΡΟΥ',
  },
  {
    label: '85601002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΔΙΑΣΜΟΥ ΚΑΙ ΠΙΣΤΟΠΟΙΗΣΗΣ ΕΚΠΑΙΔΕΥΤΙΚΩΝ ΠΡΟΓΡΑΜΜΑΤΩΝ',
  },
  {
    label: '85601003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΟΛΙΚΟΥ ΓΡΑΜΜΑΤΕΑ Η ΣΧΟΛΙΚΟΥ ΤΡΟΧΟΝΟΜΟΥ',
  },
  {
    label: '86100000',
    value: 'ΝΟΣΟΚΟΜΕΙΑΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '86101000',
    value: 'ΝΟΣΟΚΟΜΕΙΑΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '86101100',
    value: 'ΝΟΣΟΚΟΜΕΙΑΚΕΣ ΥΠΗΡΕΣΙΕΣ ΧΕΙΡΟΥΡΓΕΙΟΥ',
  },
  {
    label: '86101101',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΑΓΓΕΙΟΧΕΙΡΟΥΡΓΙΚΗΣ',
  },
  {
    label: '86101102',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΝΕΥΡΟΧΕΙΡΟΥΡΓΙΚΗΣ',
  },
  {
    label: '86101103',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΑΙΔΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86101104',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΛΑΣΤΙΚΗΣ ΧΕΙΡΟΥΡΓΙΚΗΣ',
  },
  {
    label: '86101105',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΧΕΙΡΟΥΡΓΙΚΗΣ',
  },
  {
    label: '86101106',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΧΕΙΡΟΥΡΓΙΚΗΣ ΘΩΡΑΚΑ',
  },
  {
    label: '86101107',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΧΕΙΡΟΥΡΓΙΚΗΣ ΠΑΙΔΩΝ',
  },
  {
    label: '86101200',
    value: 'ΓΥΝΑΙΚΟΛΟΓΙΚΕΣ ΚΑΙ ΜΑΙΕΥΤΙΚΕΣ ΝΟΣΟΚΟΜΕΙΑΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '86101201',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΜΑΙΕΥΤΙΚΗΣ ~ ΓΥΝΑΙΚΟΛΟΓΙΑΣ',
  },
  {
    label: '86101300',
    value: 'ΝΟΣΟΚΟΜΕΙΑΚΕΣ ΥΠΗΡΕΣΙΕΣ ΑΠΟΚΑΤΑΣΤΑΣΗΣ',
  },
  {
    label: '86101301',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΦΥΣΙΚΗΣ ΙΑΤΡΙΚΗΣ ΚΑΙ ΑΠΟΚΑΤΑΣΤΑΣΗΣ',
  },
  {
    label: '86101400',
    value: 'ΝΟΣΟΚΟΜΕΙΑΚΕΣ ΨΥΧΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '86101401',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΑΙΔΟΨΥΧΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86101402',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΨΥΧΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86101500',
    value: 'ΑΛΛΕΣ ΝΟΣΟΚΟΜΕΙΑΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΙΑΤΡΟΥΣ',
  },
  {
    label: '86101501',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΑΙΜΑΤΟΛΟΓΙΑΣ',
  },
  {
    label: '86101502',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΑΚΤΙΝΟΔΙΑΓΝΩΣΤΙΚΗΣ',
  },
  {
    label: '86101503',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΑΚΤΙΝΟΘΕΡΑΠΕΥΤΙΚΗΣ ~ ΟΓΚΟΛΟΓΙΑΣ',
  },
  {
    label: '86101504',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΑΛΛΕΡΓΙΟΛΟΓΙΑΣ',
  },
  {
    label: '86101505',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΑΝΑΙΣΘΗΣΙΟΛΟΓΙΑΣ',
  },
  {
    label: '86101506',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΓΑΣΤΡΕΝΤΕΡΟΛΟΓΙΑΣ',
  },
  {
    label: '86101507',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΓΕΝΙΚΗΣ ΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86101508',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΔΕΡΜΑΤΟΛΟΓΙΑΣ ~ ΑΦΡΟΔΙΣΙΟΛΟΓΙΑΣ',
  },
  {
    label: '86101509',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΕΝΔΟΚΡΙΝΟΛΟΓΙΑΣ',
  },
  {
    label: '86101510',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΙΑΤΡΙΚΗΣ ΒΙΟΠΑΘΟΛΟΓΙΑΣ (ΜΙΚΡΟΒΙΟΛΟΓΙΑΣ)',
  },
  {
    label: '86101511',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΚΑΡΔΙΟΛΟΓΙΑΣ',
  },
  {
    label: '86101512',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΚΥΤΤΑΡΟΛΟΓΙΑΣ',
  },
  {
    label: '86101513',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΝΕΥΡΟΛΟΓΙΑΣ',
  },
  {
    label: '86101514',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΝΕΦΡΟΛΟΓΙΑΣ',
  },
  {
    label: '86101515',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΟΡΘΟΠΕΔΙΚΗΣ',
  },
  {
    label: '86101516',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΟΥΡΟΛΟΓΙΑΣ',
  },
  {
    label: '86101517',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΟΦΘΑΛΜΟΛΟΓΙΑΣ',
  },
  {
    label: '86101518',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΑΘΟΛΟΓΙΑΣ',
  },
  {
    label: '86101519',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΑΘΟΛΟΓΙΚΗΣ ΑΝΑΤΟΜΙΚΗΣ',
  },
  {
    label: '86101520',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΑΘΟΛΟΓΙΚΗΣ ΟΓΚΟΛΟΓΙΑΣ',
  },
  {
    label: '86101521',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΝΕΥΜΟΝΟΛΟΓΙΑΣ ~ ΦΥΜΑΤΙΟΛΟΓΙΑΣ',
  },
  {
    label: '86101522',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΥΡΗΝΙΚΗΣ ΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86101523',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΡΕΥΜΑΤΟΛΟΓΙΑΣ',
  },
  {
    label: '86101524',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΩΤΟΡΙΝΟΛΑΡΥΓΓΟΛΟΓΙΑΣ',
  },
  {
    label: '86101900',
    value: 'ΑΛΛΕΣ ΝΟΣΟΚΟΜΕΙΑΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '86101901',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΙΑΤΡΙΚΗΣ ΤΗΣ ΕΡΓΑΣΙΑΣ',
  },
  {
    label: '86101902',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΙΑΤΡΟΔΙΚΑΣΤΙΚΗΣ',
  },
  {
    label: '86101903',
    value:
      'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΚΟΙΝΩΝΙΚΗΣ ΙΑΤΡΙΚΗΣ (ΔΗΜΟΣΙΑΣ ΥΓΕΙΑΣ)',
  },
  {
    label: '86101904',
    value: 'ΕΝΔΟΝΟΣΟΚΟΜΕΙΑΚΕΣ ΥΠΗΡΕΣΙΕΣ ΚΛΙΝΙΚΟΥ ΒΙΟΧΗΜΙΚΟΥ',
  },
  {
    label: '86210000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΑΣΚΗΣΗΣ ΓΕΝΙΚΩΝ ΙΑΤΡΙΚΩΝ ΕΠΑΓΓΕΛΜΑΤΩΝ',
  },
  {
    label: '86211000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΕΝΙΚΗΣ ΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86211001',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΓΕΝΙΚΗΣ ΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86211002',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΙΑΤΡΙΚΗΣ ΤΗΣ ΕΡΓΑΣΙΑΣ',
  },
  {
    label: '86211003',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΑΘΟΛΟΓΙΑΣ',
  },
  {
    label: '86211004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΙΑΤΡΩΝ ΓΕΝΙΚΑ, ΑΠΟΚΛΕΙΣΤΙΚΑ ΜΕ ΠΡΟΣΩΠΙΚΗ ΕΡΓΑΣΙΑ',
  },
  {
    label: '86211005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΙΑΤΡΩΝ ΓΕΝΙΚΑ, ΜΕ ΒΟΗΘΗΤΙΚΟ ΠΡΟΣΩΠΙΚΟ',
  },
  {
    label: '86220000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΑΣΚΗΣΗΣ ΕΙΔΙΚΩΝ ΙΑΤΡΙΚΩΝ ΕΠΑΓΓΕΛΜΑΤΩΝ',
  },
  {
    label: '86221000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΗΣ ΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86221100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΛΥΣΗΣ ΚΑΙ ΕΡΜΗΝΕΙΑΣ ΙΑΤΡΙΚΩΝ ΕΙΚΟΝΩΝ',
  },
  {
    label: '86221900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΗΣ ΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86221901',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΑΓΓΕΙΟΧΕΙΡΟΥΡΓΙΚΗΣ',
  },
  {
    label: '86221902',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΑΙΜΑΤΟΛΟΓΙΑΣ',
  },
  {
    label: '86221903',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΑΚΤΙΝΟΔΙΑΓΝΩΣΤΙΚΗΣ',
  },
  {
    label: '86221904',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΑΚΤΙΝΟΘΕΡΑΠΕΥΤΙΚΗΣ ~ ΟΓΚΟΛΟΓΙΑΣ',
  },
  {
    label: '86221905',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΑΛΛΕΡΓΙΟΛΟΓΙΑΣ',
  },
  {
    label: '86221906',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΑΝΑΙΣΘΗΣΙΟΛΟΓΙΑΣ',
  },
  {
    label: '86221907',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΓΑΣΤΡΕΝΤΕΡΟΛΟΓΙΑΣ',
  },
  {
    label: '86221908',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΔΕΡΜΑΤΟΛΟΓΙΑΣ ~ ΑΦΡΟΔΙΣΙΟΛΟΓΙΑΣ',
  },
  {
    label: '86221909',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΕΝΔΟΚΡΙΝΟΛΟΓΙΑΣ',
  },
  {
    label: '86221910',
    value:
      'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΙΑΤΡΙΚΗΣ ΒΙΟΠΑΘΟΛΟΓΙΑΣ (ΜΙΚΡΟΒΙΟΛΟΓΙΑΣ)',
  },
  {
    label: '86221911',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΙΑΤΡΟΔΙΚΑΣΤΙΚΗΣ',
  },
  {
    label: '86221912',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΚΑΡΔΙΟΛΟΓΙΑΣ',
  },
  {
    label: '86221913',
    value:
      'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΚΟΙΝΩΝΙΚΗΣ ΙΑΤΡΙΚΗΣ (ΔΗΜΟΣΙΑΣ ΥΓΕΙΑΣ)',
  },
  {
    label: '86221914',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΚΥΤΤΑΡΟΛΟΓΙΑΣ',
  },
  {
    label: '86221915',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΜΑΙΕΥΤΙΚΗΣ ~ ΓΥΝΑΙΚΟΛΟΓΙΑΣ',
  },
  {
    label: '86221916',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΝΕΥΡΟΛΟΓΙΑΣ',
  },
  {
    label: '86221917',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΝΕΥΡΟΧΕΙΡΟΥΡΓΙΚΗΣ',
  },
  {
    label: '86221918',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΝΕΦΡΟΛΟΓΙΑΣ',
  },
  {
    label: '86221919',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΟΡΘΟΠΕΔΙΚΗΣ',
  },
  {
    label: '86221920',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΟΥΡΟΛΟΓΙΑΣ',
  },
  {
    label: '86221921',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΟΦΘΑΛΜΟΛΟΓΙΑΣ',
  },
  {
    label: '86221922',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΑΘΟΛΟΓΙΚΗΣ ΑΝΑΤΟΜΙΚΗΣ',
  },
  {
    label: '86221923',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΑΘΟΛΟΓΙΚΗΣ ΟΓΚΟΛΟΓΙΑΣ',
  },
  {
    label: '86221924',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΑΙΔΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86221925',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΑΙΔΟΨΥΧΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86221926',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΛΑΣΤΙΚΗΣ ΧΕΙΡΟΥΡΓΙΚΗΣ',
  },
  {
    label: '86221927',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΝΕΥΜΟΝΟΛΟΓΙΑΣ ~ ΦΥΜΑΤΙΟΛΟΓΙΑΣ',
  },
  {
    label: '86221928',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΠΥΡΗΝΙΚΗΣ ΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86221929',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΡΕΥΜΑΤΟΛΟΓΙΑΣ',
  },
  {
    label: '86221930',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΦΥΣΙΚΗΣ ΙΑΤΡΙΚΗΣ ΚΑΙ ΑΠΟΚΑΤΑΣΤΑΣΗΣ',
  },
  {
    label: '86221931',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΧΕΙΡΟΥΡΓΙΚΗΣ',
  },
  {
    label: '86221932',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΧΕΙΡΟΥΡΓΙΚΗΣ ΘΩΡΑΚΑ',
  },
  {
    label: '86221933',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΧΕΙΡΟΥΡΓΙΚΗΣ ΠΑΙΔΩΝ',
  },
  {
    label: '86221934',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΨΥΧΙΑΤΡΙΚΗΣ',
  },
  {
    label: '86221935',
    value: 'ΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΙΔΙΚΟΤΗΤΑΣ ΩΤΟΡΙΝΟΛΑΡΥΓΓΟΛΟΓΙΑΣ',
  },
  {
    label: '86230000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΑΣΚΗΣΗΣ ΟΔΟΝΤΙΑΤΡΙΚΩΝ ΕΠΑΓΓΕΛΜΑΤΩΝ',
  },
  {
    label: '86231000',
    value: 'ΟΔΟΝΤΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '86231100',
    value: 'ΟΡΘΟΔΟΝΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '86231900',
    value: 'ΑΛΛΕΣ ΟΔΟΝΤΙΑΤΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '86231901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΟΝΤΙΑΤΡΩΝ, ΑΠΟΚΛΕΙΣΤΙΚΑ ΜΕ ΠΡΟΣΩΠΙΚΗ ΕΡΓΑΣΙΑ',
  },
  {
    label: '86231902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΟΝΤΙΑΤΡΩΝ, ΜΕ ΒΟΗΘΗΤΙΚΟ ΠΡΟΣΩΠΙΚΟ',
  },
  {
    label: '86231903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΡΓΑΝΩΜΕΝΗΣ ΜΟΝΑΔΑΣ ΟΔΟΝΤΙΑΤΡΙΚΩΝ ΥΠΗΡΕΣΙΩΝ',
  },
  {
    label: '86231904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΟΜΑΤΙΚΩΝ ΚΑΙ ΓΝΑΘΟΠΡΟΣΩΠΙΚΩΝ ΧΕΙΡΟΥΡΓΩΝ',
  },
  {
    label: '86900000',
    value: 'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΑΝΘΡΩΠΙΝΗΣ ΥΓΕΙΑΣ',
  },
  {
    label: '86901000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΑΦΟΡΟΥΝ ΤΗΝ ΑΝΘΡΩΠΙΝΗ ΥΓΕΙΑ',
  },
  {
    label: '86901100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΗΝ ΕΓΚΥΜΟΣΥΝΗ',
  },
  {
    label: '86901200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΝΟΣΟΚΟΜΟΥ',
  },
  {
    label: '86901201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΚΛΕΙΣΤΙΚΩΝ ΝΟΣΟΚΟΜΩΝ',
  },
  {
    label: '86901202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΟΗΘΟΥ ΙΑΤΡΙΚΩΝ ΚΑΙ ΒΙΟΛΟΓΙΚΩΝ ΕΡΓΑΣΤΗΡΙΩΝ',
  },
  {
    label: '86901203',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΠΤΩΝ ΝΟΣΟΚΟΜΩΝ',
  },
  {
    label: '86901204',
    value: 'ΥΠΗΡΕΣΙΕΣ ΝΟΣΗΛΕΥΤΗ',
  },
  {
    label: '86901300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΥΣΙΟΘΕΡΑΠΕΙΑΣ',
  },
  {
    label: '86901301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΙΝΗΣΙΟΘΕΡΑΠΕΙΑΣ',
  },
  {
    label: '86901302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΑΛΑΚΤΗ (ΜΑΣΕΡ)',
  },
  {
    label: '86901303',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΥΣΙΟΘΕΡΑΠΕΥΤΗ',
  },
  {
    label: '86901304',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΕΙΡΟΠΡΑΚΤΗ',
  },
  {
    label: '86901400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΣΘΕΝΟΦΟΡΩΝ',
  },
  {
    label: '86901500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΙΑΤΡΙΚΟΥ ΕΡΓΑΣΤΗΡΙΟΥ',
  },
  {
    label: '86901501',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΚΤΙΝΟΦΥΣΙΚΟΥ',
  },
  {
    label: '86901502',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΓΝΩΣΤΙΚΟΥ ΙΑΤΡΙΚΟΥ ΚΕΝΤΡΟΥ',
  },
  {
    label: '86901503',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΞΕΤΑΣΕΩΝ ΕΛΕΓΧΟΥ ΑΝΘΡΩΠΙΝΗΣ ΓΟΝΙΜΟΤΗΤΑΣ',
  },
  {
    label: '86901504',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΓΑΣΤΗΡΙΟΥ ΕΛΕΓΧΟΥ ΑΝΤΙ;ΝΤΟΠΙΝΓΚ ΑΘΛΗΤΩΝ',
  },
  {
    label: '86901505',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΛΙΝΙΚΟΥ ΒΙΟΧΗΜΙΚΟΥ',
  },
  {
    label: '86901506',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΥΤΤΑΡΟΛΟΓΙΚΟΥ ΕΡΓΑΣΤΗΡΙΟΥ',
  },
  {
    label: '86901507',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΕΙΡΙΣΤΗ ΙΑΤΡΟΔΙΑΓΝΩΣΤΙΚΩΝ ΜΗΧΑΝΗΜΑΤΩΝ',
  },
  {
    label: '86901600',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΡΑΠΕΖΩΝ ΑΙΜΑΤΟΣ, ΣΠΕΡΜΑΤΟΣ ΚΑΙ ΟΡΓΑΝΩΝ ΜΕΤΑΜΟΣΧΕΥΣΗΣ',
  },
  {
    label: '86901700',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΓΝΩΣΤΙΚΩΝ ΕΙΚΟΝΩΝ ΧΩΡΙΣ ΕΡΜΗΝΕΙΑ',
  },
  {
    label: '86901800',
    value: 'ΥΠΗΡΕΣΙΕΣ ΨΥΧΙΚΗΣ ΥΓΕΙΑΣ',
  },
  {
    label: '86901801',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΙΔΟΨΥΧΟΛΟΓΟΥ',
  },
  {
    label: '86901802',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΜΒΟΥΛΟΥ ΨΥΧΙΚΗΣ ΥΓΕΙΑΣ',
  },
  {
    label: '86901803',
    value: 'ΥΠΗΡΕΣΙΕΣ ΨΥΧΟΘΕΡΑΠΕΥΤΗ',
  },
  {
    label: '86901804',
    value: 'ΥΠΗΡΕΣΙΕΣ ΨΥΧΟΛΟΓΟΥ',
  },
  {
    label: '86901900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΑΦΟΡΟΥΝ ΤΗΝ ΑΝΘΡΩΠΙΝΗ ΥΓΕΙΑ Π.Δ.Κ.Α.',
  },
  {
    label: '86901901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΕΛΟΝΙΣΜΟΥ',
  },
  {
    label: '86901902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΟΤΑΝΟΘΕΡΑΠΕΙΑΣ ΚΑΙ ΑΡΩΜΑΤΟΘΕΡΑΠΕΙΑΣ',
  },
  {
    label: '86901903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΑΛΛΑΚΤΙΚΩΝ ΘΕΡΑΠΕΙΩΝ',
  },
  {
    label: '86901904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΓΑΣΙΟΘΕΡΑΠΕΙΑΣ',
  },
  {
    label: '86901905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΓΟΘΕΡΑΠΕΙΑΣ',
  },
  {
    label: '86901906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΡΑΠΕΥΤΗ ΚΑΛΩΝ',
  },
  {
    label: '86901907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΡΑΠΕΥΤΗ ΝΥΧΙΩΝ',
  },
  {
    label: '86901908',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΡΑΠΕΥΤΗ ΝΥΧΙΩΝ ΚΑΙ ΚΑΛΩΝ',
  },
  {
    label: '86901909',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΟΓΟΘΕΡΑΠΕΙΑΣ',
  },
  {
    label: '86901910',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΔΗΓΙΩΝ ΔΙΑΤΡΟΦΗΣ ΑΠΟ ΕΙΔΙΚΟΥΣ ΠΟΥ ΔΕΝ ΕΙΝΑΙ ΓΙΑΤΡΟΙ',
  },
  {
    label: '86901911',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΜΟΙΟΠΑΘΗΤΙΚΗΣ',
  },
  {
    label: '86901912',
    value: 'ΥΠΗΡΕΣΙΕΣ ΡΕΦΛΕΞΟΛΟΓΙΑΣ',
  },
  {
    label: '87100000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΝΟΣΟΚΟΜΕΙΑΚΗΣ ΦΡΟΝΤΙΔΑΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ',
  },
  {
    label: '87200000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΦΡΟΝΤΙΔΑΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΑΤΟΜΑ ΜΕ ΝΟΗΤΙΚΗ ΥΣΤΕΡΗΣΗ, ΨΥΧΙΚΕΣ ΔΙΑΤΑΡΑΧΕΣ ΚΑΙ ΧΡΗΣΗ ΟΥΣΙΩΝ',
  },
  {
    label: '87201000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΦΡΟΝΤΙΔΑΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ ΑΤΟΜΑ ΜΕ ΝΟΗΤΙΚΗ ΥΣΤΕΡΗΣΗ, ΨΥΧΙΚΕΣ ΔΙΑΤΑΡΑΧΕΣ ΚΑΙ ΧΡΗΣΗ ΟΥΣΙΩΝ 87201100 ~ ΥΠΗΡΕΣΙΕΣ ΦΡΟΝΤΙΔΑΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΠΑΙΔΙΑ ΠΟΥ ΠΑΣΧΟΥΝ ΑΠΟ ΝΟΗΤΙΚΗ ΥΣΤΕΡΗΣΗ, ΨΥΧΙΚΕΣ ΔΙΑΤΑΡΑΧΕΣ ΚΑΙ ΧΡΗΣΗ ΟΥΣΙΩΝ',
  },
  {
    label: '87201200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΦΡΟΝΤΙΔΑΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΕΝΗΛΙΚΕΣ ΠΟΥ ΠΑΣΧΟΥΝ ΑΠΟ ΝΟΗΤΙΚΗ ΥΣΤΕΡΗΣΗ, ΨΥΧΙΚΕΣ ΔΙΑΤΑΡΑΧΕΣ ΚΑΙ ΧΡΗΣΗ ΟΥΣΙΩΝ',
  },
  {
    label: '87300000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΦΡΟΝΤΙΔΑΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΗΛΙΚΙΩΜΕΝΟΥΣ ΚΑΙ ΑΤΟΜΑ ΜΕ ΑΝΑΠΗΡΙΑ',
  },
  {
    label: '87301000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΦΡΟΝΤΙΔΑΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΗΛΙΚΙΩΜΕΝΟΥΣ ΚΑΙ ΑΝΑΠΗΡΟΥΣ',
  },
  {
    label: '87301100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΗΣ ΜΕΡΙΜΝΑΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΜΕΣΩ ΟΙΚΟΤΡΟΦΕΙΩΝ ΣΕ ΗΛΙΚΙΩΜΕΝΟΥΣ',
  },
  {
    label: '87301101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΙΚΩΝ ΕΥΓΗΡΙΑΣ',
  },
  {
    label: '87301200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΗΣ ΜΕΡΙΜΝΑΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΜΕΣΩ ΟΙΚΟΤΡΟΦΕΙΩΝ ΣΕ ΠΑΙΔΙΑ ΚΑΙ ΝΕΟΥΣ ΜΕ ΑΝΑΠΗΡΙΕΣ',
  },
  {
    label: '87301300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΗΣ ΜΕΡΙΜΝΑΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΜΕΣΩ ΟΙΚΟΤΡΟΦΕΙΩΝ ΣΕ ΕΝΗΛΙΚΕΣ ΜΕ ΑΝΑΠΗΡΙΕΣ',
  },
  {
    label: '87900000',
    value: 'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΦΡΟΝΤΙΔΑΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ',
  },
  {
    label: '87901000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΦΡΟΝΤΙΔΑΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ',
  },
  {
    label: '87901100',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΗΣ ΜΕΡΙΜΝΑΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ ΣΕ ΠΑΙΔΙΑ ΚΑΙ ΝΕΟΥΣ',
  },
  {
    label: '87901101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΜΟΡΦΩΤΗΡΙΩΝ ΑΝΗΛΙΚΩΝ',
  },
  {
    label: '87901200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΗΣ ΜΕΡΙΜΝΑΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΚΑΚΟΠΟΙΗΜΕΝΕΣ ΓΥΝΑΙΚΕΣ',
  },
  {
    label: '87901300',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΗΣ ΜΕΡΙΜΝΑΣ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΕΝΗΛΙΚΕΣ',
  },
  {
    label: '87901301',
    value:
      'ΚΟΙΝΩΝΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΕΠΑΝΕΝΤΑΞΗΣ ΑΠΟΦΥΛΑΚΙΣΜΕΝΩΝ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ',
  },
  {
    label: '87901302',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΑΝΕΝΤΑΞΗΣ ΓΙΑ ΑΤΟΜΑ ΕΘΙΣΜΕΝΑ ΣΤΑ ΝΑΡΚΩΤΙΚΑ Η ΣΤΑ ΟΙΝΟΠΝΕΥΜΑΤΩΔΗ (ΕΚΤΟΣ ΑΠΟ ΙΑΤΡΙΚΗ ΘΕΡΑΠΕΙΑ) ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ',
  },
  {
    label: '87901303',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΗΣ ΑΡΩΓΗΣ ΣΕ ΘΥΜΑΤΑ ΘΕΟΜΗΝΙΩΝ, ΠΡΟΣΦΥΓΕΣ, ΜΕΤΑΝΑΣΤΕΣ ΚΛΠ ΜΕ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ',
  },
  {
    label: '88100000',
    value:
      'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΚΟΙΝΩΝΙΚΗΣ ΜΕΡΙΜΝΑΣ ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΗΛΙΚΙΩΜΕΝΟΥΣ ΚΑΙ ΑΤΟΜΑ ΜΕ ΑΝΑΠΗΡΙΑ',
  },
  {
    label: '88101000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΗΣ ΜΕΡΙΜΝΑΣ ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ ΓΙΑ ΗΛΙΚΙΩΜΕΝΟΥΣ ΚΑΙ ΑΤΟΜΑ ΜΕ ΑΝΑΠΗΡΙΑ',
  },
  {
    label: '88101100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΨΗΣ ΚΑΙ ΠΑΡΟΧΗΣ ΥΠΟΣΤΗΡΙΞΗΣ ΣΕ ΗΛΙΚΙΩΜΕΝΟΥΣ',
  },
  {
    label: '88101101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΨΕΩΝ ΣΕ ΗΛΙΚΙΩΜΕΝΟΥΣ',
  },
  {
    label: '88101200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΕΝΤΡΩΝ ΗΜΕΡΗΣΙΑΣ ΦΡΟΝΤΙΔΑΣ ΗΛΙΚΙΩΜΕΝΩΝ',
  },
  {
    label: '88101300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΑΠΟΚΑΤΑΣΤΑΣΗΣ ΓΙΑ ΑΤΟΜΑ ΜΕ ΑΝΑΠΗΡΙΕΣ',
  },
  {
    label: '88101400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΨΗΣ ΚΑΙ ΠΑΡΟΧΗΣ ΥΠΟΣΤΗΡΙΞΗΣ ΓΙΑ ΑΤΟΜΑ ΜΕ ΑΝΑΠΗΡΙΕΣ',
  },
  {
    label: '88101500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΕΝΤΡΩΝ ΗΜΕΡΗΣΙΑΣ ΦΡΟΝΤΙΔΑΣ ΕΝΗΛΙΚΩΝ ΜΕ ΑΝΑΠΗΡΙΕΣ',
  },
  {
    label: '88910000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΒΡΕΦΟΝΗΠΙΑΚΩΝ ΚΑΙ ΠΑΙΔΙΚΩΝ ΣΤΑΘΜΩΝ',
  },
  {
    label: '88911000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΗΜΕΡΗΣΙΑΣ ΦΡΟΝΤΙΔΑΣ ΓΙΑ ΠΑΙΔΙΑ',
  },
  {
    label: '88911100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΗΜΕΡΗΣΙΑΣ ΦΡΟΝΤΙΔΑΣ ΓΙΑ ΠΑΙΔΙΑ, ΕΚΤΟΣ ΟΣΩΝ ΑΦΟΡΟΥΝ ΠΑΙΔΙΑ ΜΕ ΑΝΑΠΗΡΙΑ',
  },
  {
    label: '88911200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΗΜΕΡΗΣΙΑΣ ΦΡΟΝΤΙΔΑΣ ΓΙΑ ΠΑΙΔΙΑ ΚΑΙ ΝΕΟΥΣ ΜΕ ΑΝΑΠΗΡΙΑ',
  },
  {
    label: '88911300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΥΛΑΞΗΣ ΜΙΚΡΩΝ ΠΑΙΔΙΩΝ',
  },
  {
    label: '88911301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΡΕΦΟΝΗΠΙΟΚΟΜΟΥ',
  },
  {
    label: '88911302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΙΔΙΚΟΥ ΚΑΙ ΒΡΕΦΟΝΗΠΙΑΚΟΥ ΣΤΑΘΜΟΥ',
  },
  {
    label: '88911303',
    value: "ΥΠΗΡΕΣΙΕΣ ΚΑΤ' ΟΙΚΟΝ ΦΥΛΑΞΗΣ ΜΙΚΡΩΝ ΠΑΙΔΙΩΝ",
  },
  {
    label: '88990000',
    value:
      'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΚΟΙΝΩΝΙΚΗΣ ΜΕΡΙΜΝΑΣ ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '88991000',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΗΣ ΜΕΡΙΜΝΑΣ ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '88991100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΑΘΟΔΗΓΗΣΗΣ ΚΑΙ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ Π.Δ.Κ.Α. ΣΧΕΤΙΚΕΣ ΜΕ ΤΑ ΠΑΙΔΙΑ',
  },
  {
    label: '88991200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΝΟΙΑΣ ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ',
  },
  {
    label: '88991201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΜΒΟΥΛΩΝ ΟΙΚΟΓΕΝΕΙΑΚΟΥ ΠΡΟΓΡΑΜΜΑΤΙΣΜΟΥ',
  },
  {
    label: '88991202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΟΡΗΓΗΣΗΣ ΣΥΣΣΙΤΙΩΝ Η ΚΟΥΠΟΝΙΩΝ ΣΙΤΙΣΗΣ',
  },
  {
    label: '88991300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΑΠΟΚΑΤΑΣΤΑΣΗΣ ΓΙΑ ΑΝΕΡΓΟΥΣ',
  },
  {
    label: '88991900',
    value: 'ΑΛΛΕΣ ΚΟΙΝΩΝΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '88991901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΟΔΗΓΗΣΗΣ ΑΤΟΜΩΝ ΜΕ ΠΡΟΒΛΗΜΑΤΑ',
  },
  {
    label: '88991902',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΗΣ ΑΡΩΓΗΣ ΣΕ ΘΥΜΑΤΑ ΘΕΟΜΗΝΙΩΝ, ΠΡΟΣΦΥΓΕΣ, ΜΕΤΑΝΑΣΤΕΣ ΚΛΠ, ΧΩΡΙΣ ΠΑΡΟΧΗ ΚΑΤΑΛΥΜΑΤΟΣ',
  },
  {
    label: '88991903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΟΥ ΛΕΙΤΟΥΡΓΟΥ',
  },
  {
    label: '88991904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΝΙΚΩΝ ΓΝΩΡΙΜΙΩΝ ΚΑΙ ΣΥΝΟΙΚΕΣΙΩΝ',
  },
  {
    label: '90010000',
    value: 'ΤΕΧΝΕΣ ΤΟΥ ΘΕΑΜΑΤΟΣ',
  },
  {
    label: '90011000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΛΛΙΤΕΧΝΩΝ ΤΟΥ ΘΕΑΜΑΤΟΣ',
  },
  {
    label: '90011001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΕΥΘΥΝΤΗ ΟΡΧΗΣΤΡΑΣ',
  },
  {
    label: '90011002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΤΕΛΕΣΤΗ ΜΟΥΣΙΚΩΝ ΕΡΓΩΝ',
  },
  {
    label: '90011003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΗΘΟΠΟΙΟΥ',
  },
  {
    label: '90011004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΛΛΙΤΕΧΝΗ ΚΕΝΤΡΩΝ ΔΙΑΣΚΕΔΑΣΗΣ',
  },
  {
    label: '90011005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΛΛΙΤΕΧΝΗ ΜΙΜΟΥ',
  },
  {
    label: '90011006',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΛΛΙΤΕΧΝΗ ΠΑΡΟΥΣΙΑΣΤΗ',
  },
  {
    label: '90011007',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΡΑΓΟΥΔΙΣΤΗ',
  },
  {
    label: '90011008',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΟΡΕΥΤΗ',
  },
  {
    label: '90011009',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΛΛΟΥ ΚΑΛΛΙΤΕΧΝΗ ΤΟΥ ΘΕΑΜΑΤΟΣ',
  },
  {
    label: '90011010',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΑΤΡΙΚΟΥ ΘΙΑΣΟΥ',
  },
  {
    label: '90011011',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΙΑΣΟΥ ΤΣΙΡΚΟΥ',
  },
  {
    label: '90011012',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΟΥΣΙΚΗΣ ΟΡΧΗΣΤΡΑΣ',
  },
  {
    label: '90011013',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΟΥΣΙΚΟΥ ΣΥΓΚΡΟΤΗΜΑΤΟΣ',
  },
  {
    label: '90011014',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΟΡΩΔΙΑΣ',
  },
  {
    label: '90011015',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΠΑΛΕΤΟΥ',
  },
  {
    label: '90011016',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΛΛΗΣ ΚΑΛΛΙΤΕΧΝΙΚΗΣ ΟΜΑΔΑΣ',
  },
  {
    label: '90020000',
    value: 'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΓΙΑ ΤΙΣ ΤΕΧΝΕΣ ΤΟΥ ΘΕΑΜΑΤΟΣ',
  },
  {
    label: '90021000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΠΟΣΤΗΡΙΞΗΣ ΚΑΛΛΙΤΕΧΝΩΝ',
  },
  {
    label: '90021100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΗΣ ΚΑΙ ΠΑΡΟΥΣΙΑΣΗΣ ΚΑΛΛΙΤΕΧΝΙΚΩΝ ΕΚΔΗΛΩΣΕΩΝ',
  },
  {
    label: '90021101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΑΤΡΙΚΩΝ ΚΑΙ ΛΟΙΠΩΝ ΔΗΜΟΣΙΩΝ ΘΕΑΜΑΤΩΝ ΓΕΝΙΚΑ',
  },
  {
    label: '90021105',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΕΙΜΕΝΟΓΡΑΦΟΥ ~ ΣΕΝΑΡΙΟΓΡΑΦΟΥ',
  },
  {
    label: '90021106',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΚΗΝΟΘΕΤΗ',
  },
  {
    label: '90021107',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΑΤΡΩΝΗ',
  },
  {
    label: '90021108',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΑΓΩΓΟΥ ΑΛΛΩΝ ΚΑΛΛΙΤΕΧΝΙΚΩΝ ΕΚΔΗΛΩΣΕΩΝ',
  },
  {
    label: '90021200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΒΟΛΗΣ ΚΑΙ ΔΙΟΡΓΑΝΩΣΗΣ ΚΑΛΛΙΤΕΧΝΙΚΩΝ ΕΚΔΗΛΩΣΕΩΝ',
  },
  {
    label: '90021201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΠΡΟΓΡΑΜΜΑΤΩΝ ΘΕΑΜΑΤΩΝ',
  },
  {
    label: '90021900',
    value: 'ΑΛΛΕΣ ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΤΩΝ ΤΕΧΝΩΝ ΤΟΥ ΘΕΑΜΑΤΟΣ',
  },
  {
    label: '90021904',
    value:
      'ΕΠΙΚΟΥΡΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΤΟΥ ΘΕΑΜΑΤΟΣ (ΣΚΗΝΙΚΩΝ, ΦΩΤΙΣΜΟΥ, ΗΧΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΛΠ)',
  },
  {
    label: '90021905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΗΧΟΛΗΨΙΑΣ',
  },
  {
    label: '90021906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΑΤΡΙΚΟΥ Η ΚΙΝΗΜΑΤΟΓΡΑΦΙΚΟΥ ΕΝΔΥΜΑΤΟΛΟΓΟΥ',
  },
  {
    label: '90021907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΑΤΡΙΚΟΥ ΦΩΤΙΣΤΗ',
  },
  {
    label: '90021908',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΑΚΙΓΙΕΡ ΘΕΑΤΡΟΥ ~ ΣΚΗΝΗΣ',
  },
  {
    label: '90021909',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΚΗΝΟΓΡΑΦΟΥ',
  },
  {
    label: '90021910',
    value: 'ΥΠΗΡΕΣΙΕΣ ΗΧΗΤΙΚΗΣ ΚΑΛΥΨΗΣ ΚΑΛΛΙΤΕΧΝΙΚΩΝ ΕΚΔΗΛΩΣΕΩΝ',
  },
  {
    label: '90030000',
    value: 'ΚΑΛΛΙΤΕΧΝΙΚΗ ΔΗΜΙΟΥΡΓΙΑ',
  },
  {
    label: '90031100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΣΥΓΓΡΑΦΕΙΣ, ΣΥΝΘΕΤΕΣ, ΓΛΥΠΤΕΣ ΚΑΙ ΑΛΛΟΥΣ ΚΑΛΛΙΤΕΧΝΕΣ, ΕΚΤΟΣ ΤΩΝ ΚΑΛΛΙΤΕΧΝΩΝ ΤΟΥ ΘΕΑΜΑΤΟΣ',
  },
  {
    label: '90031101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΓΙΟΓΡΑΦΟΥ',
  },
  {
    label: '90031102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΝΑΣΤΗΛΩΣΗΣ ΕΡΓΩΝ ΤΕΧΝΗΣ',
  },
  {
    label: '90031103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΛΥΠΤΗ',
  },
  {
    label: '90031104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΟΡΧΗΣΤΡΩΤΗ ',
  },
  {
    label: '90031105',
    value: 'ΥΠΗΡΕΣΙΕΣ ΖΩΓΡΑΦΟΥ',
  },
  {
    label: '90031107',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΟΥΣΟΥΡΓΟΥ',
  },
  {
    label: '90031108',
    value: 'ΥΠΗΡΕΣΙΕΣ ΞΥΛΟΓΛΥΠΤΗ',
  },
  {
    label: '90031110',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΚΙΤΣΟΓΡΑΦΟΥ',
  },
  {
    label: '90031111',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΙΧΟΥΡΓΟΥ',
  },
  {
    label: '90031112',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΓΓΡΑΦΕΑ',
  },
  {
    label: '90031113',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΒΙΒΛΙΑΚΟΥ ΚΑΙ ΑΡΧΕΙΑΚΟΥ ΥΛΙΚΟΥ',
  },
  {
    label: '90031114',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΣΗΣ ΕΡΓΩΝ ΤΕΧΝΗΣ',
  },
  {
    label: '90031115',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΙΧΟΓΡΑΦΙΑΣ',
  },
  {
    label: '90031116',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΑΡΑΚΤΗ',
  },
  {
    label: '90031117',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΟΡΟΓΡΑΦΟΥ',
  },
  {
    label: '90031118',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΟΡΩΔΟΥ',
  },
  {
    label: '90031200',
    value:
      'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΕΡΓΩΝ ΣΥΓΓΡΑΦΕΩΝ, ΣΥΝΘΕΤΩΝ ΚΑΙ ΑΛΛΩΝ ΚΑΛΛΙΤΕΧΝΩΝ, ΕΚΤΟΣ ΤΩΝ ΚΑΛΛΙΤΕΧΝΩΝ ΤΟΥ ΘΕΑΜΑΤΟΣ, ΤΩΝ ΖΩΓΡΑΦΩΝ, ΤΩΝ ΓΡΑΦΙΣΤΩΝ ΚΑΙ ΤΩΝ ΓΛΥΠΤΩΝ',
  },
  {
    label: '90031300',
    value: 'ΠΑΡΑΓΩΓΗ ΠΡΩΤΟΤΥΠΩΝ ΕΡΓΩΝ ΖΩΓΡΑΦΩΝ, ΓΡΑΦΙΣΤΩΝ ΚΑΙ ΓΛΥΠΤΩΝ',
  },
  {
    label: '90040000',
    value: 'ΕΚΜΕΤΑΛΛΕΥΣΗ ΑΙΘΟΥΣΩΝ ΘΕΑΜΑΤΩΝ ΚΑΙ ΣΥΝΑΦΕΙΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '90041000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΚΑΛΛΙΤΕΧΝΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ',
  },
  {
    label: '90041008',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΞΙΘΕΤΗΣΗΣ ΚΟΙΝΟΥ ΣΕ ΘΕΑΤΡΑ ΚΑΙ ΚΙΝΗΜΑΤΟΓΡΑΦΟΥΣ',
  },
  {
    label: '90041009',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΙΘΟΥΣΩΝ ΣΥΝΑΥΛΙΩΝ',
  },
  {
    label: '90041010',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΑΤΡΙΚΩΝ ΑΙΘΟΥΣΩΝ',
  },
  {
    label: '90041011',
    value: 'ΥΠΗΡΕΣΙΕΣ ΥΠΑΙΘΡΙΩΝ ΧΩΡΩΝ ΚΑΛΛΙΤΕΧΝΙΚΩΝ ΕΚΔΗΛΩΣΕΩΝ',
  },
  {
    label: '90041012',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΕΓΑΣΜΕΝΩΝ ΧΩΡΩΝ ΑΛΛΩΝ ΚΑΛΛΙΤΕΧΝΙΚΩΝ ΕΚΔΗΛΩΣΕΩΝ',
  },
  {
    label: '91010000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΒΙΒΛΙΟΘΗΚΩΝ ΚΑΙ ΑΡΧΕΙΟΦΥΛΑΚΕΙΩΝ',
  },
  {
    label: '91011000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΙΒΛΙΟΘΗΚΩΝ ΚΑΙ ΑΡΧΕΙΟΦΥΛΑΚΕΙΩΝ',
  },
  {
    label: '91011100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΙΒΛΙΟΘΗΚΩΝ',
  },
  {
    label: '91011200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΡΧΕΙΟΦΥΛΑΚΕΙΩΝ',
  },
  {
    label: '91011201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΜΙΣΘΟΥ ΥΠΟΘΗΚΟΦΥΛΑΚΑ',
  },
  {
    label: '91011202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΡΧΕΙΟΘΗΚΗΣ ΦΩΤΟΓΡΑΦΙΩΝ',
  },
  {
    label: '91011203',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΤΗΜΑΤΟΛΟΓΙΚΟΥ ΓΡΑΦΕΙΟΥ',
  },
  {
    label: '91011204',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΟΥΣΙΚΩΝ ΑΡΧΕΙΩΝ',
  },
  {
    label: '91011205',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΙΝΙΟΘΗΚΗΣ',
  },
  {
    label: '91020000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΜΟΥΣΕΙΩΝ',
  },
  {
    label: '91021000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΜΟΥΣΕΙΩΝ',
  },
  {
    label: '91022000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΥΣΙΑΣΗΣ ΣΥΛΛΟΓΩΝ ΜΟΥΣΕΙΩΝ',
  },
  {
    label: '91022001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΔΕΙΞΗΣ ΚΑΛΛΙΤΕΧΝΙΚΩΝ Η ΑΡΧΑΙΟΛΟΓΙΚΩΝ ΣΥΛΛΟΓΩΝ',
  },
  {
    label: '91030000',
    value:
      'ΛΕΙΤΟΥΡΓΙΑ ΙΣΤΟΡΙΚΩΝ ΧΩΡΩΝ ΚΑΙ ΚΤΙΡΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΠΟΛΩΝ ΕΛΞΗΣ ΕΠΙΣΚΕΠΤΩΝ',
  },
  {
    label: '91031000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΙΣΤΟΡΙΚΩΝ ΧΩΡΩΝ ΚΑΙ ΚΤΙΡΙΩΝ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΑΞΙΟΘΕΑΤΩΝ',
  },
  {
    label: '91031001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΨΗΣ ΑΡΧΑΙΟΛΟΓΙΚΩΝ ΚΑΙ ΑΛΛΩΝ ΙΣΤΟΡΙΚΩΝ ΧΩΡΩΝ ΚΑΙ ΚΤΙΡΙΩΝ',
  },
  {
    label: '91031002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΝΤΗΡΗΤΗ ΑΡΧΑΙΟΛΟΓΟΥ',
  },
  {
    label: '91040000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΒΟΤΑΝΙΚΩΝ ΚΑΙ ΖΩΟΛΟΓΙΚΩΝ ΚΗΠΩΝ ΚΑΙ ΦΥΣΙΚΩΝ ΒΙΟΤΟΠΩΝ',
  },
  {
    label: '91041000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΒΟΤΑΝΙΚΩΝ ΚΑΙ ΖΩΟΛΟΓΙΚΩΝ ΚΗΠΩΝ ΚΑΙ ΠΡΟΣΤΑΤΕΥΟΜΕΝΩΝ ΦΥΣΙΚΩΝ ΒΙΟΤΟΠΩΝ',
  },
  {
    label: '91041100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΟΤΑΝΙΚΩΝ ΚΑΙ ΖΩΟΛΟΓΙΚΩΝ ΚΗΠΩΝ',
  },
  {
    label: '91041200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΡΟΣΤΑΤΕΥΟΜΕΝΩΝ ΦΥΣΙΚΩΝ ΒΙΟΤΟΠΩΝ, ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΗΣ ΤΗΣ ΠΡΟΣΤΑΣΙΑΣ ΤΗΣ ΑΓΡΙΑΣ ΠΑΝΙΔΑΣ ΚΑΙ ΧΛΩΡΙΔΑΣ',
  },
  {
    label: '92000000',
    value: 'ΤΥΧΕΡΑ ΠΑΙΧΝΙΔΙΑ ΚΑΙ ΣΤΟΙΧΗΜΑΤΑ',
  },
  {
    label: '92001000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΥΧΕΡΩΝ ΠΑΙΧΝΙΔΙΩΝ',
  },
  {
    label: '92001100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΥΧΕΡΩΝ ΠΑΙΧΝΙΔΙΩΝ ΤΡΑΠΕΖΙΟΥ',
  },
  {
    label: '92001101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΖΙΝΟ',
  },
  {
    label: '92001102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΑΡΤΟΠΑΙΚΤΙΚΗΣ ΛΕΣΧΗΣ',
  },
  {
    label: '92001200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΥΧΕΡΩΝ ΠΑΙΧΝΙΔΙΩΝ ΜΕ ΜΗΧΑΝΗΜΑΤΑ',
  },
  {
    label: '92001201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΠΑΙΧΝΙΔΙΩΝ',
  },
  {
    label: '92001202',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΜΗΧΑΝΗΜΑΤΩΝ ΤΥΧΕΡΩΝ ΠΑΙΧΝΙΔΙΩΝ (ΜΕ ΚΕΡΜΑΤΟΔΕΚΤΗ)',
  },
  {
    label: '92001300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΑΧΕΙΩΝ, ΠΑΙΧΝΙΔΙΩΝ ΜΕ ΑΡΙΘΜΟΥΣ ΚΑΙ ΜΠΙΓΚΟ',
  },
  {
    label: '92001301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΛΑΝΟΔΙΑΣ ΔΙΑΘΕΣΗΣ ΛΑΧΕΙΩΝ',
  },
  {
    label: '92001302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΑΚΤΟΡΕΙΟΥ ΛΑΧΕΙΩΝ',
  },
  {
    label: '92001303',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΡΑΚΤΟΡΕΙΟΥ ΛΟΤΤΟ, ΚΙΝΟ, ΤΖΟΚΕΡ, ΞΥΣΤΟ, ΠΡΟΤΟ, EXTRA5 ;, SUPER3 ~ ΚΑΙ ΠΑΡΟΜΟΙΩΝ',
  },
  {
    label: '92001304',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΩΛΗΤΗ ΛΑΧΕΙΩΝ',
  },
  {
    label: '92001400',
    value: "ΥΠΗΡΕΣΙΕΣ ΤΥΧΕΡΩΝ ΠΑΙΧΝΙΔΙΩΝ ΣΕ ΑΠ' ΕΥΘΕΙΑΣ (ON;LINE) ΣΥΝΔΕΣΗ",
  },
  {
    label: '92001900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΤΥΧΕΡΩΝ ΠΑΙΧΝΙΔΙΩΝ',
  },
  {
    label: '92002000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΟΙΧΗΜΑΤΩΝ',
  },
  {
    label: '92002100',
    value: "ΥΠΗΡΕΣΙΕΣ ΣΤΟΙΧΗΜΑΤΩΝ ΣΕ ΑΠ' ΕΥΘΕΙΑΣ (ON;LINE) ΣΥΝΔΕΣΗ",
  },
  {
    label: '92002900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΣΤΟΙΧΗΜΑΤΩΝ',
  },
  {
    label: '92002901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΡΑΚΤΟΡΕΙΟΥ ΠΡΟ;ΠΟ, \\ΠΑΜΕ ΣΤΟΙΧΗΜΑ\\ ΚΑΙ ΙΠΠΟΔΡΟΜΙΑΚΟΥ ΣΤΟΙΧΗΜΑΤΟΣ',
  },
  {
    label: '93110000',
    value: 'ΕΚΜΕΤΑΛΛΕΥΣΗ ΑΘΛΗΤΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ',
  },
  {
    label: '93111000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΕΙΤΟΥΡΓΙΑΣ ΑΘΛΗΤΙΚΩΝ ΕΓΚΑΤΑΣΤΑΣΕΩΝ',
  },
  {
    label: '93111001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΗΠΕΔΩΝ (4 ;Χ4 ;,            5 ;Χ5 ~ ΚΛΠ) ΠΟΔΟΣΦΑΙΡΟΥ, ΚΑΛΑΘΟΣΦΑΙΡΙΣΗΣ, ΑΝΤΙΣΦΑΙΡΙΣΗΣ ΚΛΠ',
  },
  {
    label: '93111002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΗΠΕΔΩΝ ΓΚΟΛΦ Η ΜΙΝΙ ΓΚΟΛΦ',
  },
  {
    label: '93111003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΛΥΜΒΗΤΗΡΙΟΥ (ΠΙΣΙΝΑΣ)',
  },
  {
    label: '93111004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΙΣΤΑΣ \\ΚΑΡΤ\\',
  },
  {
    label: '93111005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΩΡΟΥ ΜΠΟΟΥΛΙΓΚ',
  },
  {
    label: '93120000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΑΘΛΗΤΙΚΩΝ ΟΜΙΛΩΝ',
  },
  {
    label: '93121000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΘΛΗΤΙΚΩΝ ΣΩΜΑΤΕΙΩΝ',
  },
  {
    label: '93121001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΡΓΑΝΩΣΗΣ ΑΓΩΝΩΝ ΡΑΛΙ ΑΥΤΟΚΙΝΗΤΩΝ ΚΑΙ ΜΟΤΟΣΙΚΛΕΤΩΝ',
  },
  {
    label: '93130000',
    value: 'ΕΓΚΑΤΑΣΤΑΣΕΙΣ ΓΥΜΝΑΣΤΙΚΗΣ',
  },
  {
    label: '93131000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΥΜΝΑΣΤΗΡΙΩΝ',
  },
  {
    label: '93131001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΓΥΜΝΑΣΤΗΡΙΟΥ ΕΙΔΙΚΩΝ ΓΥΜΝΑΣΤΙΚΩΝ (ΑΕΡΟΒΙΚΗΣ, ΠΙΛΑΤΕΣ, ΓΙΟΓΚΑ ΚΛΠ)',
  },
  {
    label: '93131002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΥΜΝΑΣΤΗΡΙΟΥ ΕΝΟΡΓΑΝΗΣ Η ΜΗ ΓΥΜΝΑΣΤΙΚΗΣ',
  },
  {
    label: '93131003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΗΓΗΤΗ ΦΥΣΙΚΗΣ ΑΓΩΓΗΣ Η ΓΥΜΝΑΣΤΗ',
  },
  {
    label: '93190000',
    value: 'ΑΛΛΕΣ ΑΘΛΗΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '93191000',
    value: 'ΑΛΛΕΣ ΑΘΛΗΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '93191100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΡΟΒΟΛΗΣ ΑΘΛΗΤΙΚΩΝ ΕΚΔΗΛΩΣΕΩΝ ΚΑΙ ΨΥΧΑΓΩΓΙΚΩΝ ΑΘΛΗΤΙΚΩΝ ΕΚΔΗΛΩΣΕΩΝ',
  },
  {
    label: '93191200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΘΛΗΤΩΝ',
  },
  {
    label: '93191201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΜΕΙΒΟΜΕΝΟΥ ΑΘΛΗΤΗ',
  },
  {
    label: '93191300',
    value:
      'ΥΠΟΣΤΗΡΙΚΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΑΘΛΗΤΙΣΜΟΥ ΚΑΙ ΨΥΧΑΓΩΓΙΑΣ',
  },
  {
    label: '93191301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΙΤΗΣΙΑΣ ΑΘΛΗΤΙΚΩΝ ΑΓΩΝΩΝ',
  },
  {
    label: '93191302',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΜΕΤΡΗΤΗ ΑΘΛΗΤΙΚΩΝ ΕΠΙΔΟΣΕΩΝ (ΧΡΟΝΟΜΕΤΡΗ ΚΛΠ)',
  },
  {
    label: '93191303',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΤΗΝ ΕΚΠΑΙΔΕΥΣΗ ΚΑΤΟΙΚΙΔΙΩΝ ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ, ΓΙΑ ΚΥΝΗΓΙ ΚΑΙ ΣΧΕΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '93191304',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΣΧΕΤΙΖΟΝΤΑΙ ΜΕ ΤΗΝ ΕΡΑΣΙΤΕΧΝΙΚΗ ΑΛΙΕΙΑ',
  },
  {
    label: '93191305',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΑΒΛΩΝ ΙΠΠΟΔΡΟΜΙΩΝ',
  },
  {
    label: '93191306',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΟ ΚΥΝΗΓΙ ΩΣ ΑΘΛΗΜΑ Η ΨΥΧΑΓΩΓΙΑ',
  },
  {
    label: '93191900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΑΘΛΗΤΙΣΜΟΥ ΚΑΙ ΑΝΑΨΥΧΗΣ',
  },
  {
    label: '93210000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΑΡΚΩΝ ΑΝΑΨΥΧΗΣ ΚΑΙ ΑΛΛΩΝ ΘΕΜΑΤΙΚΩΝ ΠΑΡΚΩΝ',
  },
  {
    label: '93211000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΚΩΝ ΨΥΧΑΓΩΓΙΑΣ ΚΑΙ ΘΕΜΑΤΙΚΩΝ ΠΑΡΚΩΝ',
  },
  {
    label: '93211001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΟΥΟΤΕΡ ΠΑΡΚ (ΝΕΡΟΤΣΟΥΛΗΘΡΩΝ ΚΛΠ)',
  },
  {
    label: '93211002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΛΟΥΝΑ ΠΑΡΚ',
  },
  {
    label: '93211003',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΑΝΗΓΥΡΙΩΝ (ΤΟΠΙΚΩΝ ΕΟΡΤΩΝ) ΚΑΙ ΕΚΘΕΣΕΩΝ ΕΜΠΟΡΙΚΟΥ ΧΑΡΑΚΤΗΡΑ',
  },
  {
    label: '93290000',
    value: 'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΔΙΑΣΚΕΔΑΣΗΣ ΚΑΙ ΨΥΧΑΓΩΓΙΑΣ',
  },
  {
    label: '93291000',
    value: 'ΑΛΛΕΣ ΨΥΧΑΓΩΓΙΚΕΣ ΥΠΗΡΕΣΙΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '93291100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΚΩΝ ΨΥΧΑΓΩΓΙΑΣ ΚΑΙ ΠΑΡΑΛΙΩΝ',
  },
  {
    label: '93291101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΠΟΔΥΤΗΡΙΩΝ ΚΑΙ ΒΕΣΤΙΑΡΙΩΝ ΠΑΡΑΛΙΩΝ (ΠΛΑΖ)',
  },
  {
    label: '93291102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΘΑΛΑΣΣΙΩΝ ΛΟΥΤΡΩΝ',
  },
  {
    label: '93291103',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΚΤΗΜΑΤΟΣ, ΓΙΑ ΔΙΕΝΕΡΓΕΙΑ ΕΚΔΗΛΩΣΕΩΝ (Π.Χ. ΓΑΜΩΝ ΚΑΙ ΣΥΝΑΦΩΝ)',
  },
  {
    label: '93291104',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΠΑΙΧΝΙΔΙΩΝ ΘΑΛΑΣΣΑΣ (ΘΑΛΑΣΣΙΩΝ ΠΟΔΗΛΑΤΩΝ, ΚΑΝΟ ΚΑΙ ΠΑΡΟΜΟΙΩΝ ΕΙΔΩΝ ΑΝΑΨΥΧΗΣ)',
  },
  {
    label: '93291105',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΙΣΘΩΣΗΣ ΟΜΠΡΕΛΩΝ Η/ΚΑΙ ΚΑΘΙΣΜΑΤΩΝ ΠΑΡΑΛΙΩΝ (ΠΛΑΖ)',
  },
  {
    label: '93291106',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΚΟΥ ΑΝΑΨΥΧΗΣ',
  },
  {
    label: '93291900',
    value: 'ΔΙΑΦΟΡΕΣ ΨΥΧΑΓΩΓΙΚΕΣ ΥΠΗΡΕΣΙΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '93291901',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΟΡΓΑΝΩΣΗΣ ΨΥΧΑΓΩΓΙΚΩΝ ΕΚΔΗΛΩΣΕΩΝ (Π.Χ. ΓΑΜΩΝ ΚΑΙ ΣΥΝΑΦΩΝ)',
  },
  {
    label: '93291902',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΟΙΚΗΜΑΤΟΣ, ΓΙΑ ΔΙΕΝΕΡΓΕΙΑ ΕΚΔΗΛΩΣΕΩΝ (Π.Χ. ΓΑΜΩΝ ΚΑΙ ΣΥΝΑΦΩΝ)',
  },
  {
    label: '93291903',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΟΥΣΙΚΗΣ ΚΑΛΥΨΗΣ ΕΚΔΗΛΩΣΕΩΝ, ΥΠΗΡΕΣΙΕΣ DISK JOCKEY (D.J.)',
  },
  {
    label: '93291904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΝΤΙΣΚΟΤΕΚ (ΧΩΡΙΣ ΠΡΟΣΦΟΡΑ ΠΟΤΟΥ Η ΦΑΓΗΤΟΥ)',
  },
  {
    label: '93291905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΙΔΟΤΟΠΟΥ',
  },
  {
    label: '93291906',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΦΑΙΡΙΣΤΗΡΙΟΥ ΚΑΙ ΣΥΝΑΦΩΝ ΨΥΧΑΓΩΓΙΚΩΝ ΠΑΙΧΝΙΔΙΩΝ (ΠΟΔΟΣΦΑΙΡΑΚΙΑ ΚΛΠ)',
  },
  {
    label: '93291907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΧΙΟΝΟΔΡΟΜΙΚΟΥ ΚΕΝΤΡΟΥ',
  },
  {
    label: '93292000',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΘΕΑΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '93292100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΑΜΑΤΩΝ ΜΕ ΠΥΡΟΤΕΧΝΗΜΑΤΑ ΚΑΙ ΘΕΑΜΑΤΩΝ \\ΗΧΟΣ ΚΑΙ ΦΩΣ\\',
  },
  {
    label: '93292101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΑΜΑΤΟΣ ΗΧΟΣ ΚΑΙ ΦΩΣ',
  },
  {
    label: '93292102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΑΜΑΤΟΣ ΘΕΑΤΡΟΥ ΣΚΙΩΝ (ΚΑΡΑΓΚΙΟΖΟΠΑΙΚΤΗ)',
  },
  {
    label: '93292103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΑΜΑΤΟΣ ΚΟΥΚΛΟΘΕΑΤΡΟΥ',
  },
  {
    label: '93292104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΑΜΑΤΟΣ ΡΟΝΤΕΟ',
  },
  {
    label: '93292200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΙΓΝΙΔΟΜΗΧΑΝΩΝ ΜΕ ΚΕΡΜΑΤΟΔΕΚΤΗ',
  },
  {
    label: '93292900',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΑΜΑΤΟΣ Π.Δ.Κ.Α.',
  },
  {
    label: '94110000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΕΠΙΧΕΙΡΗΜΑΤΙΚΩΝ ΚΑΙ ΕΡΓΟΔΟΤΙΚΩΝ ΟΡΓΑΝΩΣΕΩΝ',
  },
  {
    label: '94111000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΕΠΙΧΕΙΡΗΜΑΤΙΚΕΣ ΚΑΙ ΕΡΓΟΔΟΤΙΚΕΣ ΟΡΓΑΝΩΣΕΙΣ',
  },
  {
    label: '94120000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΕΠΑΓΓΕΛΜΑΤΙΚΩΝ ΟΡΓΑΝΩΣΕΩΝ',
  },
  {
    label: '94121000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΕΠΑΓΓΕΛΜΑΤΙΚΕΣ ΟΡΓΑΝΩΣΕΙΣ',
  },
  {
    label: '94200000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΥΝΔΙΚΑΛΙΣΤΙΚΩΝ ΟΡΓΑΝΩΣΕΩΝ',
  },
  {
    label: '94201000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΕΡΓΑΤΙΚΕΣ ΕΝΩΣΕΙΣ',
  },
  {
    label: '94910000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΘΡΗΣΚΕΥΤΙΚΩΝ ΟΡΓΑΝΩΣΕΩΝ',
  },
  {
    label: '94911000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΘΡΗΣΚΕΥΤΙΚΕΣ ΟΡΓΑΝΩΣΕΙΣ',
  },
  {
    label: '94911001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΔΟΣΗΣ ΤΗΣ ΒΙΒΛΟΥ',
  },
  {
    label: '94911002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΙΕΡΩΝ ΜΟΝΩΝ',
  },
  {
    label: '94911003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΙΕΡΩΝ ΝΑΩΝ',
  },
  {
    label: '94920000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΟΛΙΤΙΚΩΝ ΟΡΓΑΝΩΣΕΩΝ',
  },
  {
    label: '94921000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΠΟΛΙΤΙΚΕΣ ΟΡΓΑΝΩΣΕΙΣ',
  },
  {
    label: '94921001',
    value: 'ΠΑΡΟΧΗ ΥΠΗΡΕΣΙΩΝ ΑΠΟ ΠΟΛΙΤΙΚΑ ΚΟΜΜΑΤΑ',
  },
  {
    label: '94921002',
    value:
      'ΠΑΡΟΧΗ ΥΠΗΡΕΣΙΩΝ ΑΠΟ ΕΚΛΟΓΙΚΟΥΣ ΣΥΝΔΥΑΣΜΟΥΣ ΝΟΜΑΡΧΙΑΚΗΣ ΚΑΙ ΤΟΠΙΚΗΣ ΑΥΤΟΔΙΟΙΚΗΣΗΣ',
  },
  {
    label: '94990000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΑΛΛΩΝ ΟΡΓΑΝΩΣΕΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '94991000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ [ΕΚΤΟΣ ΤΗΣ ΧΟΡΗΓΗΣΗΣ ΕΝΙΣΧΥΣΕΩΝ (ΕΠΙΧΟΡΗΓΗΣΕΩΝ)            ] ΑΠΟ ΑΛΛΕΣ ΟΡΓΑΝΩΣΕΙΣ Π.Δ.Κ.Α.',
  },
  {
    label: '94991100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΟΡΓΑΝΩΣΕΙΣ ΓΙΑ ΤΑ ΑΝΘΡΩΠΙΝΑ ΔΙΚΑΙΩΜΑΤΑ',
  },
  {
    label: '94991200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΠΕΡΙΒΑΛΛΟΝΤΙΚΕΣ ΟΜΑΔΕΣ ',
  },
  {
    label: '94991201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΟΙΚΟΛΟΓΙΚΑ ΣΩΜΑΤΕΙΑ',
  },
  {
    label: '94991300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΣΤΑΣΙΑΣ ΕΙΔΙΚΩΝ ΟΜΑΔΩΝ',
  },
  {
    label: '94991400',
    value:
      'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΥΠΟΣΤΗΡΙΞΗΣ ΓΙΑ ΤΗ ΒΕΛΤΙΩΣΗ ΤΗΣ ΖΩΗΣ ΤΩΝ ΠΟΛΙΤΩΝ ΚΑΙ ΤΗΝ ΑΝΑΒΑΘΜΙΣΗ ΤΩΝ ΓΕΝΙΚΩΝ ΣΥΝΘΗΚΩΝ ΔΙΑΒΙΩΣΗΣ',
  },
  {
    label: '94991401',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΞΩΡΑΪΣΤΙΚΩΝ ΚΑΙ ΑΝΑΠΤΥΞΙΑΚΩΝ ΣΩΜΑΤΕΙΩΝ, ΕΝΩΣΕΩΝ, ΣΥΝΕΤΑΙΡΙΣΜΩΝ ΚΛΠ',
  },
  {
    label: '94991500',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΟΡΓΑΝΩΣΕΙΣ ΝΕΩΝ',
  },
  {
    label: '94991600',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΠΟΛΙΤΙΣΤΙΚΕΣ ΚΑΙ ΨΥΧΑΓΩΓΙΚΕΣ ΕΝΩΣΕΙΣ',
  },
  {
    label: '94991601',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΛΙΤΙΣΤΙΚΩΝ ΣΥΛΛΟΓΩΝ ΚΑΙ ΣΩΜΑΤΕΙΩΝ',
  },
  {
    label: '94991602',
    value: 'ΥΠΗΡΕΣΙΕΣ ΨΥΧΑΓΩΓΙΚΩΝ ΜΗ ΑΘΛΗΤΙΚΩΝ ΛΕΣΧΩΝ',
  },
  {
    label: '94991700',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΑΛΛΕΣ ΟΡΓΑΝΩΣΕΙΣ ΠΟΛΙΤΩΝ ΚΑΙ ΚΟΙΝΩΝΙΚΕΣ ΟΡΓΑΝΩΣΕΙΣ',
  },
  {
    label: '94991701',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΝΩΣΕΩΝ ΓΥΝΑΙΚΩΝ',
  },
  {
    label: '94991900',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΟΝΤΑΙ ΑΠΟ ΑΛΛΕΣ ΟΡΓΑΝΩΣΕΙΣ Π.Δ.Κ.Α.',
  },
  {
    label: '94991901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΛΛΩΝ ΜΗ ΚΥΒΕΡΝΗΤΙΚΩΝ ΟΡΓΑΝΩΣΕΩΝ',
  },
  {
    label: '94991902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΘΝΙΚΩΝ ΚΑΙ ΠΑΤΡΙΩΤΙΚΩΝ ΣΩΜΑΤΕΙΩΝ',
  },
  {
    label: '94991903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΑΝΙΚΩΝ ΕΠΙΤΡΟΠΩΝ',
  },
  {
    label: '94991904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΙΣΛΑΜΙΚΩΝ ΒΑΚΟΥΦΙΩΝ',
  },
  {
    label: '94991905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΙΝΩΦΕΛΩΝ ΙΔΡΥΜΑΤΩΝ ΚΑΙ ΣΩΜΑΤΕΙΩΝ',
  },
  {
    label: '94991906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΟΠΙΚΩΝ ΣΥΛΛΟΓΩΝ ΚΑΙ ΣΩΜΑΤΕΙΩΝ',
  },
  {
    label: '94991907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΙΛΑΝΘΡΩΠΙΚΩΝ ΣΩΜΑΤΕΙΩΝ',
  },
  {
    label: '94992000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΕΝΙΣΧΥΣΕΩΝ (ΕΠΙΧΟΡΗΓΗΣΕΩΝ) ΑΠΟ ΟΡΓΑΝΩΣΕΙΣ',
  },
  {
    label: '95110000',
    value: 'ΕΠΙΣΚΕΥΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '95111000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΥΠΟΛΟΓΙΣΤΩΝ ΚΑΙ ΠΕΡΙΦΕΡΕΙΑΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '95111001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΓΚΑΤΑΣΤΑΣΗΣ ΠΑΚΕΤΩΝ ΛΟΓΙΣΜΙΚΟΥ Η ΕΠΕΚΤΑΣΕΩΝ',
  },
  {
    label: '95120000',
    value: 'ΕΠΙΣΚΕΥΗ ΕΞΟΠΛΙΣΜΟΥ ΕΠΙΚΟΙΝΩΝΙΑΣ',
  },
  {
    label: '95121000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΕΞΟΠΛΙΣΜΟΥ ΕΠΙΚΟΙΝΩΝΙΑΣ',
  },
  {
    label: '95121001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΤΗΛΕΦΩΝΙΚΩΝ, ΤΗΛΕΟΜΟΙΟΤΥΠΙΚΩΝ ΚΑΙ ΣΥΝΑΦΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '95210000',
    value: 'ΕΠΙΣΚΕΥΗ ΗΛΕΚΤΡΟΝΙΚΩΝ ΕΙΔΩΝ ΕΥΡΕΙΑΣ ΚΑΤΑΝΑΛΩΣΗΣ',
  },
  {
    label: '95211000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΤΑΝΑΛΩΤΙΚΩΝ ΗΛΕΚΤΡΟΝΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '95211001',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΗΛΕΚΤΡΟΝΙΚΩΝ ΕΡΓΑΣΤΗΡΙΩΝ ΚΑΙ ΤΟΠΟΘΕΤΗΣΗΣ ΚΕΡΑΙΩΝ ΛΗΨΗΣ ΤΗΛΕΟΠΤΙΚΩΝ ΔΕΚΤΩΝ',
  },
  {
    label: '95220000',
    value: 'ΕΠΙΣΚΕΥΗ ΣΥΣΚΕΥΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΣΠΙΤΙΟΥ ΚΑΙ ΚΗΠΟΥ',
  },
  {
    label: '95221000',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΟΙΚΙΑΚΩΝ ΣΥΣΚΕΥΩΝ ΚΑΙ ΕΞΟΠΛΙΣΜΟΥ ΣΠΙΤΙΟΥ ΚΑΙ ΚΗΠΟΥ',
  },
  {
    label: '95221001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΨΥΚΤΙΚΩΝ ΚΑΙ ΚΛΙΜΑΤΙΣΤΙΚΩΝ ΣΥΣΚΕΥΩΝ',
  },
  {
    label: '95230000',
    value: 'ΕΠΙΔΙΟΡΘΩΣΗ ΥΠΟΔΗΜΑΤΩΝ ΚΑΙ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '95231000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΥΠΟΔΗΜΑΤΩΝ ΚΑΙ ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ',
  },
  {
    label: '95231001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΔΙΟΡΘΩΣΗΣ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '95231002',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΤΙΛΒΩΣΗΣ ΚΑΙ ΒΑΦΗΣ ΥΠΟΔΗΜΑΤΩΝ, ΔΕΡΜΑΤΙΝΩΝ ΕΙΔΩΝ ΚΛΠ',
  },
  {
    label: '95240000',
    value: 'ΕΠΙΣΚΕΥΗ ΕΠΙΠΛΩΝ ΚΑΙ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΕΠΙΠΛΩΣΗΣ',
  },
  {
    label: '95241000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΕΠΙΠΛΩΝ ΚΑΙ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΔΙΑΚΟΣΜΗΣΗΣ',
  },
  {
    label: '95250000',
    value: 'ΕΠΙΣΚΕΥΗ ΡΟΛΟΓΙΩΝ ΚΑΙ ΚΟΣΜΗΜΑΤΩΝ',
  },
  {
    label: '95251000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΡΟΛΟΓΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ ΚΑΙ ΚΟΣΜΗΜΑΤΩΝ',
  },
  {
    label: '95251100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΡΟΛΟΓΙΩΝ ΚΑΘΕ ΕΙΔΟΥΣ',
  },
  {
    label: '95251200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΟΣΜΗΜΑΤΩΝ',
  },
  {
    label: '95290000',
    value: 'ΕΠΙΣΚΕΥΗ ΑΛΛΩΝ ΕΙΔΩΝ ΠΡΟΣΩΠΙΚΗΣ ΚΑΙ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '95291000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΑΛΛΩΝ ΕΙΔΩΝ ΑΤΟΜΙΚΗΣ ΚΑΙ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '95291100',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΜΕΤΑΤΡΟΠΗΣ ΕΝΔΥΜΑΤΩΝ ΚΑΙ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '95291101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΔΙΟΡΘΩΣΗΣ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '95291102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΔΙΟΡΘΩΣΗΣ ΥΦΑΣΜΑΤΙΝΩΝ ΕΙΔΩΝ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ',
  },
  {
    label: '95291103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΓΟΥΝΑΡΙΚΩΝ',
  },
  {
    label: '95291104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΠΕΛΩΝ',
  },
  {
    label: '95291105',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΑΝΤΑΡΙΣΜΑΤΟΣ ΕΝΔΥΜΑΤΩΝ',
  },
  {
    label: '95291200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΠΟΔΗΛΑΤΩΝ',
  },
  {
    label: '95291300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '95291400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΑΙ ΣΥΝΤΗΡΗΣΗΣ ΑΘΛΗΤΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ',
  },
  {
    label: '95291401',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΑΘΛΗΤΙΚΩΝ ΕΙΔΩΝ ΚΑΙ ΕΙΔΩΝ ΚΑΤΑΣΚΗΝΩΣΗΣ',
  },
  {
    label: '95291900',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΑΛΛΩΝ ΕΙΔΩΝ ΑΤΟΜΙΚΗΣ ΚΑΙ ΟΙΚΙΑΚΗΣ ΧΡΗΣΗΣ Π.Δ.Κ.Α.',
  },
  {
    label: '95291901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΚΑΣΣΙΤΕΡΩΣΗΣ ΜΕΤΑΛΛΙΚΩΝ ΣΚΕΥΩΝ ΚΛΠ',
  },
  {
    label: '95291902',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΕΡΑΣΙΤΕΧΝΙΚΟΥ ΦΩΤΟΓΡΑΦΙΚΟΥ ΕΞΟΠΛΙΣΜΟΥ ΚΑΙ ΦΩΤΟΓΡΑΦΙΚΩΝ ΜΗΧΑΝΩΝ',
  },
  {
    label: '95291903',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΚΛΕΙΔΑΡΙΩΝ, ΠΑΡΑΒΙΑΣΗΣ ΘΥΡΩΝ ΚΑΙ ΠΑΡΑΓΩΓΗΣ ΑΝΤΙΓΡΑΦΩΝ ΚΛΕΙΔΙΩΝ',
  },
  {
    label: '95291904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΠΙΣΚΕΥΗΣ ΦΩΤΙΣΤΙΚΩΝ ΕΙΔΩΝ',
  },
  {
    label: '95291905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΣΚΕΥΗΣ ΑΝΤΙΓΡΑΦΩΝ ΚΛΕΙΔΙΩΝ',
  },
  {
    label: '95291906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΥΡΔΙΣΜΑΤΟΣ ΠΙΑΝΩΝ ΚΑΙ ΑΛΛΩΝ ΜΟΥΣΙΚΩΝ ΟΡΓΑΝΩΝ',
  },
  {
    label: '95291907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΛΑΣΤΙΚΟΠΟΙΗΣΗΣ ΤΑΥΤΟΤΗΤΩΝ',
  },
  {
    label: '96010000',
    value:
      'ΠΛΥΣΙΜΟ ΚΑΙ (ΣΤΕΓΝΟ) ΚΑΘΑΡΙΣΜΑ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΚΑΙ ΓΟΥΝΙΝΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '96011000',
    value:
      'ΠΛΥΣΙΜΟ ΚΑΙ ΣΤΕΓΝΟ ΚΑΘΑΡΙΣΜΑ ΚΛΩΣΤΟΫΦΑΝΤΟΥΡΓΙΚΩΝ ΚΑΙ ΓΟΥΝΙΝΩΝ ΠΡΟΪΟΝΤΩΝ',
  },
  {
    label: '96011100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΛΥΝΤΗΡΙΟΥ ΜΕ ΚΕΡΜΑΤΟΔΕΚΤΗ',
  },
  {
    label: '96011200',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΤΕΓΝΟΥ ΚΑΘΑΡΙΣΜΑΤΟΣ (ΠΕΡΙΛΑΜΒΑΝΟΜΕΝΩΝ ΤΩΝ ΥΠΗΡΕΣΙΩΝ ΚΑΘΑΡΙΣΜΟΥ ΓΟΥΝΩΝ)',
  },
  {
    label: '96011300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΙΔΕΡΩΤΗΡΙΩΝ',
  },
  {
    label: '96011301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΙΔΕΡΩΤΗΡΙΟΥ ΡΟΥΧΩΝ',
  },
  {
    label: '96011400',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΑΦΗΣ ΚΑΙ ΧΡΩΜΑΤΙΣΜΟΥ',
  },
  {
    label: '96011401',
    value: 'ΥΠΗΡΕΣΙΕΣ ΒΑΦΗΣ ΡΟΥΧΩΝ',
  },
  {
    label: '96011900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΥΦΑΣΜΑΤΩΝ',
  },
  {
    label: '96011901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΘΑΡΙΣΜΟΥ ΧΑΛΙΩΝ ΚΑΙ ΜΟΚΕΤΩΝ',
  },
  {
    label: '96011902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΙΚΩΝ ΠΛΥΝΤΗΡΙΩΝ',
  },
  {
    label: '96011903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΛΥΣΙΜΑΤΟΣ ΡΟΥΧΩΝ',
  },
  {
    label: '96011904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΥΛΑΞΗΣ ΧΑΛΙΩΝ ΚΑΙ ΜΟΚΕΤΩΝ',
  },
  {
    label: '96011905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΥΛΛΟΓΗΣ ΚΑΙ ΠΑΡΑΔΟΣΗΣ ΤΩΝ ΠΡΟΣ ΠΛΥΣΙΜΟ ΡΟΥΧΩΝ',
  },
  {
    label: '96020000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΚΟΜΜΩΤΗΡΙΩΝ, ΚΟΥΡΕΙΩΝ ΚΑΙ ΚΕΝΤΡΩΝ ΑΙΣΘΗΤΙΚΗΣ',
  },
  {
    label: '96021000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΜΜΩΤΗΡΙΩΝ ΚΑΙ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΑΛΛΩΠΙΣΜΟΥ',
  },
  {
    label: '96021100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΜΜΩΤΗΡΙΩΝ ΓΥΝΑΙΚΩΝ ΚΑΙ ΚΟΡΙΤΣΙΩΝ',
  },
  {
    label: '96021101',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΟΜΜΩΤΗΡΙΟΥ ΚΑΙ ΚΑΛΛΩΠΙΣΤΗΡΙΟΥ ΓΥΝΑΙΚΩΝ, ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΜΕΧΡΙ ΚΑΙ ΔΥΟ ΤΕΧΝΙΤΕΣ ΚΟΜΜΩΤΕΣ',
  },
  {
    label: '96021102',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΟΜΜΩΤΗΡΙΟΥ ΚΑΙ ΚΑΛΛΩΠΙΣΤΗΡΙΟΥ ΓΥΝΑΙΚΩΝ, ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΠΑΝΩ ΑΠΟ ΔΥΟ ΤΕΧΝΙΤΕΣ ΚΟΜΜΩΤΕΣ',
  },
  {
    label: '96021200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΜΜΩΤΗΡΙΩΝ ΚΑΙ ΚΟΥΡΕΙΩΝ ΑΝΔΡΩΝ ΚΑΙ ΑΓΟΡΙΩΝ',
  },
  {
    label: '96021201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΥΡΕΙΟΥ',
  },
  {
    label: '96021202',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΟΥΡΕΙΟΥ Η ΚΟΜΜΩΤΗΡΙΟΥ ΑΝΔΡΩΝ, ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΜΕΧΡΙ ΚΑΙ ΔΥΟ ΤΕΧΝΙΤΕΣ',
  },
  {
    label: '96021203',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΚΟΥΡΕΙΟΥ Η ΚΟΜΜΩΤΗΡΙΟΥ ΑΝΔΡΩΝ, ΠΟΥ ΑΠΑΣΧΟΛΕΙ ΠΑΝΩ ΑΠΟ ΔΥΟ ΤΕΧΝΙΤΕΣ',
  },
  {
    label: '96021300',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΙΣΘΗΤΙΚΩΝ ΚΑΙ ΥΠΗΡΕΣΙΕΣ ΠΕΡΙΠΟΙΗΣΗΣ ΤΩΝ ΝΥΧΙΩΝ',
  },
  {
    label: '96021301',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΙΣΘΗΤΙΚΟΥ ΑΡΩΜΑΤΟΘΕΡΑΠΕΙΑΣ',
  },
  {
    label: '96021302',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΕΡΓΑΣΤΗΡΙΟΥ ΑΙΣΘΗΤΙΚΗΣ ΠΡΟΣΩΠΟΥ ΚΑΙ ΣΩΜΑΤΟΣ (ΙΝΣΤΙΤΟΥΤΟΥ ΚΑΛΛΟΝΗΣ)',
  },
  {
    label: '96021303',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΑΚΙΓΙΕΡ ~ ΑΙΣΘΗΤΙΚΟΥ',
  },
  {
    label: '96021304',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΑΝΙΚΙΟΥΡ ~ ΠΕΝΤΙΚΙΟΥΡ',
  },
  {
    label: '96021305',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΔΟΛΟΓΙΑΣ ΚΑΙ ΚΑΛΛΩΠΙΣΜΟΥ ΝΥΧΙΩΝ',
  },
  {
    label: '96021900',
    value: 'ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ ΚΑΛΛΩΠΙΣΜΟΥ',
  },
  {
    label: '96021901',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΕΧΝΗΤΟΥ ΜΑΥΡΙΣΜΑΤΟΣ (ΣΟΛΑΡΙΟΥΜ)',
  },
  {
    label: '96022000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΘΕΣΗΣ ΑΝΘΡΩΠΙΝΩΝ ΜΑΛΛΙΩΝ, ΜΗ ΚΑΤΕΡΓΑΣΜΕΝΩΝ',
  },
  {
    label: '96030000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΓΡΑΦΕΙΩΝ ΚΗΔΕΙΩΝ ΚΑΙ ΣΥΝΑΦΕΙΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ',
  },
  {
    label: '96031000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΚΗΔΕΙΩΝ ΚΑΙ ΣΧΕΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '96031100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΝΕΚΡΟΤΑΦΕΙΩΝ ΚΑΙ ΑΠΟΤΕΦΡΩΣΗΣ ΝΕΚΡΩΝ',
  },
  {
    label: '96031200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΦΗΣ ΝΕΚΡΩΝ',
  },
  {
    label: '96031201',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΡΓΟΛΑΒΟΥ ΕΠΙΚΗΔΕΙΩΝ ΤΕΛΕΤΩΝ, ΜΝΗΜΟΣΥΝΩΝ, ΚΛΠ',
  },
  {
    label: '96031202',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΝΕΚΡΩΝ',
  },
  {
    label: '96031203',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΥΝΟΔΕΙΑΣ ΝΕΚΡΩΝ (ΜΕΤΑΦΟΡΑΣ ΦΕΡΕΤΡΟΥ ΚΑΙ ΣΤΕΦΑΝΩΝ ΑΝΘΕΩΝ)',
  },
  {
    label: '96031204',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΑΦΗΣ ΖΩΩΝ',
  },
  {
    label: '96040000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΣΧΕΤΙΚΕΣ ΜΕ ΤΗ ΦΥΣΙΚΗ ΕΥΕΞΙΑ',
  },
  {
    label: '96041000',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΩΜΑΤΙΚΗΣ ΕΥΕΞΙΑΣ',
  },
  {
    label: '96041001',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΙΤΟΛΟΓΙΑΣ',
  },
  {
    label: '96041002',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΑΙΤΟΛΟΓΙΚΩΝ ΜΟΝΑΔΩΝ (ΠΟΛΥΔΥΝΑΜΩΝ ΜΟΝΑΔΩΝ ΣΥΝΔΥΑΣΜΟΥ ΑΣΚΗΣΗΣ, ΑΙΣΘΗΤΙΚΗΣ ΚΑΙ ΔΙΑΙΤΑΣ)',
  },
  {
    label: '96041003',
    value: 'ΥΠΗΡΕΣΙΕΣ ΕΚΜΕΤΑΛΛΕΥΣΗΣ ΛΟΥΤΡΩΝ (ΚΑΘΑΡΙΟΤΗΤΑΣ, ΧΑΜΑΜ ΚΛΠ)',
  },
  {
    label: '96041004',
    value: 'ΥΠΗΡΕΣΙΕΣ ΘΕΡΑΠΕΥΤΙΚΩΝ ΛΟΥΤΡΩΝ ΚΑΙ ΙΑΜΑΤΙΚΩΝ ΠΗΓΩΝ',
  },
  {
    label: '96041005',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΑΣΑΖ (ΕΚΤΟΣ ΤΟΥ ΘΕΡΑΠΕΥΤΙΚΟΥ ΜΑΣΑΖ)',
  },
  {
    label: '96041006',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΠΡΟΣΩΠΙΚΗΣ ΥΓΙΕΙΝΗΣ ΚΑΙ ΦΡΟΝΤΙΔΑΣ ΣΩΜΑΤΟΣ (ΑΠΟΤΡΙΧΩΣΗΣ, ΘΕΡΑΠΕΙΑΣ ΜΕ ΥΠΕΡΙΩΔΕΙΣ ΚΑΙ ΥΠΕΡΥΘΡΕΣ ΑΚΤΙΝΕΣ)',
  },
  {
    label: '96041007',
    value: 'ΥΠΗΡΕΣΙΕΣ ΣΑΟΥΝΑΣ, SPA (ΟΧΙ ΘΕΡΑΠΕΥΤΙΚΟΥ) ΚΑΙ ΑΤΜΟΛΟΥΤΡΩΝ',
  },
  {
    label: '96090000',
    value: 'ΑΛΛΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΠΑΡΟΧΗΣ ΠΡΟΣΩΠΙΚΩΝ ΥΠΗΡΕΣΙΩΝ Π.Δ.Κ.Α.',
  },
  {
    label: '96091000',
    value: 'ΑΛΛΕΣ ΠΡΟΣΩΠΙΚΕΣ ΥΠΗΡΕΣΙΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '96091100',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΡΟΝΤΙΔΑΣ ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '96091101',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΑΤΑΦΥΓΙΟΥ ΑΔΕΣΠΟΤΩΝ ΖΩΩΝ',
  },
  {
    label: '96091102',
    value: 'ΥΠΗΡΕΣΙΕΣ ΚΟΥΡΕΜΑΤΟΣ, ΠΛΥΣΙΜΑΤΟΣ, ΚΑΛΛΩΠΙΣΜΟΥ ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '96091103',
    value: 'ΥΠΗΡΕΣΙΕΣ ΜΕΤΑΦΟΡΑΣ ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '96091104',
    value: 'ΥΠΗΡΕΣΙΕΣ ΦΙΛΟΞΕΝΙΑΣ ΖΩΩΝ ΣΥΝΤΡΟΦΙΑΣ',
  },
  {
    label: '96091200',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΑΡΟΧΗΣ ΣΥΝΟΔΟΥ',
  },
  {
    label: '96091300',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΜΗΧΑΝΗΜΑΤΩΝ ΠΟΥ ΛΕΙΤΟΥΡΓΟΥΝ ΜΕ ΚΕΡΜΑΤΟΔΕΚΤΗ Π.Δ.Κ.Α. (ΟΧΙ ΓΙΑ ΠΩΛΗΣΗ ΑΓΑΘΩΝ Η ΓΙΑ ΤΥΧΕΡΑ ΠΑΙΧΝΙΔΙΑ)',
  },
  {
    label: '96091900',
    value: 'ΔΙΑΦΟΡΕΣ ΑΛΛΕΣ ΥΠΗΡΕΣΙΕΣ Π.Δ.Κ.Α.',
  },
  {
    label: '96091901',
    value: 'ΑΣΤΡΟΛΟΓΙΚΕΣ ΚΑΙ ΠΝΕΥΜΑΤΙΣΤΙΚΕΣ ΥΠΗΡΕΣΙΕΣ',
  },
  {
    label: '96091902',
    value: 'ΥΠΗΡΕΣΙΕΣ ΑΧΘΟΦΟΡΩΝ',
  },
  {
    label: '96091903',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΕΝΕΑΛΟΓΙΚΕΣ',
  },
  {
    label: '96091904',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΕΥΣΙΓΝΩΣΙΑΣ',
  },
  {
    label: '96091905',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΚΑΡΝΤΑΡΟΜΠΑΣ',
  },
  {
    label: '96091906',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΕΙΩΝ ΓΝΩΡΙΜΙΑΣ Η ΣΥΝΟΙΚΕΣΙΩΝ',
  },
  {
    label: '96091907',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΡΑΦΟΛΟΓΟΥ',
  },
  {
    label: '96091908',
    value: 'ΥΠΗΡΕΣΙΕΣ ΓΥΑΛΙΣΜΑΤΟΣ ΥΠΟΔΗΜΑΤΩΝ',
  },
  {
    label: '96091909',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΕΡΜΑΤΟΣΤΙΞΙΑΣ (ΤΑΤΟΥΑΖ)',
  },
  {
    label: '96091910',
    value: 'ΥΠΗΡΕΣΙΕΣ ΔΙΑΚΟΣΜΗΤΗ ΚΑΤΟΙΚΙΩΝ',
  },
  {
    label: '96091911',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΔΙΕΚΠΕΡΑΙΩΣΗΣ ΘΕΜΑΤΩΝ ΥΠΟΥΡΓΕΙΟΥ ΜΕΤΑΦΟΡΩΝ (ΜΕΤΑΒΙΒΑΣΕΩΝ ΑΥΤΟΚΙΝΗΤΩΝ ΚΛΠ)',
  },
  {
    label: '96091912',
    value: 'ΥΠΗΡΕΣΙΕΣ ΙΕΡΟΔΟΥΛΟΥ',
  },
  {
    label: '96091913',
    value: 'ΥΠΗΡΕΣΙΕΣ ΟΙΚΙΑΚΟΥ ΥΠΗΡΕΤΗ',
  },
  {
    label: '96091914',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΟΡΤΙΕΡΗ ΚΑΙ ΠΑΡΚΑΔΟΡΟΥ',
  },
  {
    label: '96091915',
    value: 'ΥΠΗΡΕΣΙΕΣ ΠΡΟΣΩΠΙΚΟΥ ΟΔΗΓΟΥ ΑΥΤΟΚΙΝΗΤΩΝ',
  },
  {
    label: '96091916',
    value:
      'ΥΠΗΡΕΣΙΕΣ ΣΤΟΛΙΣΜΟΥ ΕΚΚΛΗΣΙΩΝ, ΑΙΘΟΥΣΩΝ ΚΛΠ (ΓΙΑ ΓΑΜΟΥΣ, ΒΑΠΤΙΣΕΙΣ, ΚΗΔΕΙΕΣ ΚΑΙ ΑΛΛΕΣ ΕΚΔΗΛΩΣΕΙΣ)',
  },
  {
    label: '96091917',
    value: 'ΥΠΗΡΕΣΙΕΣ ΤΡΥΠΗΜΑΤΟΣ ΔΕΡΜΑΤΟΣ ΤΟΥ ΣΩΜΑΤΟΣ (PIERCING)',
  },
  {
    label: '99000000',
    value: 'ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ ΕΞΩΧΩΡΙΩΝ ΟΡΓΑΝΙΣΜΩΝ ΚΑΙ ΦΟΡΕΩΝ',
  },
];
